// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/avatar1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MiIgaGVpZ2h0PSI1MiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTUxLjggMjVBMjkgMjkgMCAwIDAgMjYgOSAyOSAyOSAwIDAgMCAuMiAyNWEyIDIgMCAwIDAgMCAxLjhDNSAzNi40IDE0LjcgNDMgMjYgNDNhMjkgMjkgMCAwIDAgMjUuOC0xNiAyIDIgMCAwIDAgMC0xLjh6TTI2IDM3YTExIDExIDAgMSAxIDAtMjIgMTEgMTEgMCAxIDEgMCAyMnptMC0xOGMtNCAwLTcgMy03IDdzMyA3IDcgNyA3LTMgNy03LTMtNy03LTd6Ii8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

██╗██╗     ██████╗ █████╗ ██╗   ██╗████████╗██╗ ██████╗ ███╗   ██╗    ██╗██╗
██║██║    ██╔════╝██╔══██╗██║   ██║╚══██╔══╝██║██╔═══██╗████╗  ██║    ██║██║
██║██║    ██║     ███████║██║   ██║   ██║   ██║██║   ██║██╔██╗ ██║    ██║██║
╚═╝╚═╝    ██║     ██╔══██║██║   ██║   ██║   ██║██║   ██║██║╚██╗██║    ╚═╝╚═╝
██╗██╗    ╚██████╗██║  ██║╚██████╔╝   ██║   ██║╚██████╔╝██║ ╚████║    ██╗██╗
╚═╝╚═╝     ╚═════╝╚═╝  ╚═╝ ╚═════╝    ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝    ╚═╝╚═╝
                                                                            
This component is for Design Systems Engineering team use only.
Its content is unsupported for project implementation and may be withdrawn anytime.
Refer to official documentation for current guidance at https://sfdc.co/slds-plus-playbook

 */
@layer deprecated, defaults, shared, theme, component, primereact, core;
@layer defaults{
  :where(html){
    --slds-g-spacing-ratio: 1;
    --sds-g-spacing-1:var(--slds-g-spacing-1);
    --slds-g-spacing-1: calc(var(--slds-g-spacing-ratio) * 0.25rem);
    --sds-g-spacing-2:var(--slds-g-spacing-2);
    --slds-g-spacing-2: calc(var(--slds-g-spacing-ratio) * 0.5rem);
    --sds-g-spacing-3:var(--slds-g-spacing-3);
    --slds-g-spacing-3: calc(var(--slds-g-spacing-ratio) * 0.75rem);
    --sds-g-spacing-4:var(--slds-g-spacing-4);
    --slds-g-spacing-4: calc(var(--slds-g-spacing-ratio) * 1rem);
    --sds-g-spacing-5:var(--slds-g-spacing-5);
    --slds-g-spacing-5: calc(var(--slds-g-spacing-ratio) * 1.5rem);
    --sds-g-spacing-6:var(--slds-g-spacing-6);
    --slds-g-spacing-6: calc(var(--slds-g-spacing-ratio) * 2rem);
    --sds-g-spacing-7:var(--slds-g-spacing-7);
    --slds-g-spacing-7: calc(var(--slds-g-spacing-ratio) * 2.5rem);
    --sds-g-spacing-8:var(--slds-g-spacing-8);
    --slds-g-spacing-8: calc(var(--slds-g-spacing-ratio) * 3rem);
    --sds-g-spacing-9:var(--slds-g-spacing-9);
    --slds-g-spacing-9: calc(var(--slds-g-spacing-ratio) * 3.5rem);
    --sds-g-spacing-10: var(--slds-g-spacing-10);
    --slds-g-spacing-10: calc(var(--slds-g-spacing-ratio) * 4rem);
    --sds-g-spacing-11:var(--slds-g-spacing-11);
    --slds-g-spacing-11: calc(var(--slds-g-spacing-ratio) * 4.5rem);
    --sds-g-spacing-12:var(--slds-g-spacing-12);
    --slds-g-spacing-12: calc(var(--slds-g-spacing-ratio) * 5rem);
    --slds-g-sizing-border-ratio: 1;
    --sds-g-sizing-border-1:var(--slds-g-sizing-border-1);
    --slds-g-sizing-border-1: calc(var(--slds-g-sizing-border-ratio) * 1px);
    --sds-g-sizing-border-2:var(--slds-g-sizing-border-2);
    --slds-g-sizing-border-2: calc(var(--slds-g-sizing-border-ratio) * 2px);
    --sds-g-sizing-border-3:var(--slds-g-sizing-border-3);
    --slds-g-sizing-border-3: calc(var(--slds-g-sizing-border-ratio) * 3px);
    --sds-g-sizing-border-4:var(--slds-g-sizing-border-4);
    --slds-g-sizing-border-4: calc(var(--slds-g-sizing-border-ratio) * 4px);
    --sds-g-sizing-1:var(--slds-g-sizing-1);
    --slds-g-sizing-1:0.125rem;
    --sds-g-sizing-2:var(--slds-g-sizing-2);
    --slds-g-sizing-2:0.25rem;
    --sds-g-sizing-3:var(--slds-g-sizing-3);
    --slds-g-sizing-3:0.5rem;
    --sds-g-sizing-4:var(--slds-g-sizing-4);
    --slds-g-sizing-4:0.75rem;
    --sds-g-sizing-5:var(--slds-g-sizing-5);
    --slds-g-sizing-5:1rem;
    --sds-g-sizing-6:var(--slds-g-sizing-6);
    --slds-g-sizing-6:1.25rem;
    --sds-g-sizing-7:var(--slds-g-sizing-7);
    --slds-g-sizing-7:1.5rem;
    --sds-g-sizing-8:var(--slds-g-sizing-8);
    --slds-g-sizing-8:1.75rem;
    --sds-g-sizing-9:var(--slds-g-sizing-9);
    --slds-g-sizing-9:2rem;
    --sds-g-sizing-10:var(--slds-g-sizing-10);
    --slds-g-sizing-10:3rem;
    --sds-g-sizing-11:var(--slds-g-sizing-11);
    --slds-g-sizing-11:4rem;
    --sds-g-sizing-12:var(--slds-g-sizing-12);
    --slds-g-sizing-12:5rem;
    --sds-g-sizing-13:var(--slds-g-sizing-13);
    --slds-g-sizing-13:10rem;
    --sds-g-sizing-14:var(--slds-g-sizing-14);
    --slds-g-sizing-14:15rem;
    --sds-g-sizing-15:var(--slds-g-sizing-15);
    --slds-g-sizing-15:20rem;
    --sds-g-sizing-16:var(--slds-g-sizing-16);
    --slds-g-sizing-16:30rem;
    --sds-g-sizing-content-1:var(--slds-g-sizing-content-1);
    --slds-g-sizing-content-1:20ch;
    --sds-g-sizing-content-2:var(--slds-g-sizing-content-2);
    --slds-g-sizing-content-2:45ch;
    --sds-g-sizing-content-3:var(--slds-g-sizing-content-3);
    --slds-g-sizing-content-3:60ch;
    --sds-g-sizing-heading-1:var(--slds-g-sizing-heading-1);
    --slds-g-sizing-heading-1:20ch;
    --sds-g-sizing-heading-2:var(--slds-g-sizing-heading-2);
    --slds-g-sizing-heading-2:25ch;
    --sds-g-sizing-heading-3:var(--slds-g-sizing-heading-3);
    --slds-g-sizing-heading-3:35ch;
    --sds-g-shadow-1:var(--slds-g-shadow-1);
    --slds-g-shadow-1:0px 0px 1.5px 0px #00000017, 0px 1.4px 1.5px 0px #00000017, 0px -1px 1px 0px #00000009;
    --sds-g-shadow-2:var(--slds-g-shadow-2);
    --slds-g-shadow-2:0px 0px 3px 0px #00000016, 0px 2.8px 3px 0px #00000016, 0px -1px 1.2px 0px #00000009;
    --sds-g-shadow-3:var(--slds-g-shadow-3);
    --slds-g-shadow-3:0px 0px 4.5px 0px #00000014, 0px 4.2px 4.5px 0px #00000017, 0px -1px 1.44px 0px #00000008;
    --sds-g-shadow-4:var(--slds-g-shadow-4);
    --slds-g-shadow-4:0px 0px 6.75px 0px #00000012, 0px 6.3px 6.75px 0px #00000012, 0px -1px 1.7px 0px #00000007;
    --sds-g-shadow-5:var(--slds-g-shadow-5);
    --slds-g-shadow-5:var(--slds-g-shadow-4);
    --sds-g-shadow-6:var(--slds-g-shadow-6);
    --slds-g-shadow-6:var(--slds-g-shadow-4);
    --sds-g-shadow-inverse-1:var(--slds-g-shadow-inverse-1);
    --slds-g-shadow-inverse-1:0 0 3px #f3f3f3;
    --sds-g-ratio-square:var(--slds-g-ratio-square);
    --slds-g-ratio-square:1;
    --sds-g-ratio-landscape:var(--slds-g-ratio-landscape);
    --slds-g-ratio-landscape:4/3;
    --sds-g-ratio-portrait:var(--slds-g-ratio-portrait);
    --slds-g-ratio-portrait:3/4;
    --sds-g-ratio-wide:var(--slds-g-ratio-wide);
    --slds-g-ratio-wide:16/9;
    --sds-g-ratio-ultrawide:var(--slds-g-ratio-ultrawide);
    --slds-g-ratio-ultrawide:18/5;
    --slds-g-radius-border-ratio: 1;
    --sds-g-radius-border-1:var(--slds-g-radius-border-1);
    --slds-g-radius-border-1: calc(var(--slds-g-radius-border-ratio) * 0.25rem);
    --sds-g-radius-border-2:var(--slds-g-radius-border-2);
    --slds-g-radius-border-2: calc(var(--slds-g-radius-border-ratio) * 0.5rem);
    --sds-g-radius-border-3:var(--slds-g-radius-border-3);
    --slds-g-radius-border-3: calc(var(--slds-g-radius-border-ratio) * 0.75rem);
    --sds-g-radius-border-4:var(--slds-g-radius-border-4);
    --slds-g-radius-border-4: calc(var(--slds-g-radius-border-ratio) * 1.25rem);
    --sds-g-radius-border-pill:var(--slds-g-radius-border-pill);
    --slds-g-radius-border-pill:15rem;
    --sds-g-radius-border-circle:var(--slds-g-radius-border-circle);
    --slds-g-radius-border-circle:100%;
    --sds-g-color-palette-blue-10:var(--slds-g-color-palette-blue-10);
    --slds-g-color-palette-blue-10:#001639;
    --sds-g-color-palette-blue-15:var(--slds-g-color-palette-blue-15);
    --slds-g-color-palette-blue-15:#03234d;
    --sds-g-color-palette-blue-20:var(--slds-g-color-palette-blue-20);
    --slds-g-color-palette-blue-20:#032d60;
    --sds-g-color-palette-blue-30:var(--slds-g-color-palette-blue-30);
    --slds-g-color-palette-blue-30:#014486;
    --sds-g-color-palette-blue-40:var(--slds-g-color-palette-blue-40);
    --slds-g-color-palette-blue-40:#0b5cab;
    --sds-g-color-palette-blue-50:var(--slds-g-color-palette-blue-50);
    --slds-g-color-palette-blue-50:#0176d3;
    --sds-g-color-palette-blue-60:var(--slds-g-color-palette-blue-60);
    --slds-g-color-palette-blue-60:#1b96ff;
    --sds-g-color-palette-blue-65:var(--slds-g-color-palette-blue-65);
    --slds-g-color-palette-blue-65:#57a3fd;
    --sds-g-color-palette-blue-70:var(--slds-g-color-palette-blue-70);
    --slds-g-color-palette-blue-70:#78b0fd;
    --sds-g-color-palette-blue-80:var(--slds-g-color-palette-blue-80);
    --slds-g-color-palette-blue-80:#aacbff;
    --sds-g-color-palette-blue-90:var(--slds-g-color-palette-blue-90);
    --slds-g-color-palette-blue-90:#d8e6fe;
    --sds-g-color-palette-blue-95:var(--slds-g-color-palette-blue-95);
    --slds-g-color-palette-blue-95:#eef4ff;
    --sds-g-color-palette-cloud-blue-10:var(--slds-g-color-palette-cloud-blue-10);
    --slds-g-color-palette-cloud-blue-10:#001a28;
    --sds-g-color-palette-cloud-blue-15:var(--slds-g-color-palette-cloud-blue-15);
    --slds-g-color-palette-cloud-blue-15:#0a2636;
    --sds-g-color-palette-cloud-blue-20:var(--slds-g-color-palette-cloud-blue-20);
    --slds-g-color-palette-cloud-blue-20:#023248;
    --sds-g-color-palette-cloud-blue-30:var(--slds-g-color-palette-cloud-blue-30);
    --slds-g-color-palette-cloud-blue-30:#084968;
    --sds-g-color-palette-cloud-blue-40:var(--slds-g-color-palette-cloud-blue-40);
    --slds-g-color-palette-cloud-blue-40:#05628a;
    --sds-g-color-palette-cloud-blue-50:var(--slds-g-color-palette-cloud-blue-50);
    --slds-g-color-palette-cloud-blue-50:#107cad;
    --sds-g-color-palette-cloud-blue-60:var(--slds-g-color-palette-cloud-blue-60);
    --slds-g-color-palette-cloud-blue-60:#0d9dda;
    --sds-g-color-palette-cloud-blue-65:var(--slds-g-color-palette-cloud-blue-65);
    --slds-g-color-palette-cloud-blue-65:#08abed;
    --sds-g-color-palette-cloud-blue-70:var(--slds-g-color-palette-cloud-blue-70);
    --slds-g-color-palette-cloud-blue-70:#1ab9ff;
    --sds-g-color-palette-cloud-blue-80:var(--slds-g-color-palette-cloud-blue-80);
    --slds-g-color-palette-cloud-blue-80:#90d0fe;
    --sds-g-color-palette-cloud-blue-90:var(--slds-g-color-palette-cloud-blue-90);
    --slds-g-color-palette-cloud-blue-90:#cfe9fe;
    --sds-g-color-palette-cloud-blue-95:var(--slds-g-color-palette-cloud-blue-95);
    --slds-g-color-palette-cloud-blue-95:#eaf5fe;
    --sds-g-color-palette-green-10:var(--slds-g-color-palette-green-10);
    --slds-g-color-palette-green-10:#071b12;
    --sds-g-color-palette-green-15:var(--slds-g-color-palette-green-15);
    --slds-g-color-palette-green-15:#0c2912;
    --sds-g-color-palette-green-20:var(--slds-g-color-palette-green-20);
    --slds-g-color-palette-green-20:#1C3326;
    --sds-g-color-palette-green-30:var(--slds-g-color-palette-green-30);
    --slds-g-color-palette-green-30:#194e31;
    --sds-g-color-palette-green-40:var(--slds-g-color-palette-green-40);
    --slds-g-color-palette-green-40:#396547;
    --sds-g-color-palette-green-50:var(--slds-g-color-palette-green-50);
    --slds-g-color-palette-green-50:#2e844a;
    --sds-g-color-palette-green-60:var(--slds-g-color-palette-green-60);
    --slds-g-color-palette-green-60:#3ba755;
    --sds-g-color-palette-green-65:var(--slds-g-color-palette-green-65);
    --slds-g-color-palette-green-65:#41b658;
    --sds-g-color-palette-green-70:var(--slds-g-color-palette-green-70);
    --slds-g-color-palette-green-70:#45c65a;
    --sds-g-color-palette-green-80:var(--slds-g-color-palette-green-80);
    --slds-g-color-palette-green-80:#91db8b;
    --sds-g-color-palette-green-90:var(--slds-g-color-palette-green-90);
    --slds-g-color-palette-green-90:#cdefc4;
    --sds-g-color-palette-green-95:var(--slds-g-color-palette-green-95);
    --slds-g-color-palette-green-95:#ebf7e6;
    --sds-g-color-palette-hot-orange-10:var(--slds-g-color-palette-hot-orange-10);
    --slds-g-color-palette-hot-orange-10:#281202;
    --sds-g-color-palette-hot-orange-15:var(--slds-g-color-palette-hot-orange-15);
    --slds-g-color-palette-hot-orange-15:#421604;
    --sds-g-color-palette-hot-orange-20:var(--slds-g-color-palette-hot-orange-20);
    --slds-g-color-palette-hot-orange-20:#4A2413;
    --sds-g-color-palette-hot-orange-30:var(--slds-g-color-palette-hot-orange-30);
    --slds-g-color-palette-hot-orange-30:#7e2600;
    --sds-g-color-palette-hot-orange-40:var(--slds-g-color-palette-hot-orange-40);
    --slds-g-color-palette-hot-orange-40:#aa3001;
    --sds-g-color-palette-hot-orange-50:var(--slds-g-color-palette-hot-orange-50);
    --slds-g-color-palette-hot-orange-50:#d83a00;
    --sds-g-color-palette-hot-orange-60:var(--slds-g-color-palette-hot-orange-60);
    --slds-g-color-palette-hot-orange-60:#ff5d2d;
    --sds-g-color-palette-hot-orange-65:var(--slds-g-color-palette-hot-orange-65);
    --slds-g-color-palette-hot-orange-65:#ff784f;
    --sds-g-color-palette-hot-orange-70:var(--slds-g-color-palette-hot-orange-70);
    --slds-g-color-palette-hot-orange-70:#ff906e;
    --sds-g-color-palette-hot-orange-80:var(--slds-g-color-palette-hot-orange-80);
    --slds-g-color-palette-hot-orange-80:#feb9a5;
    --sds-g-color-palette-hot-orange-90:var(--slds-g-color-palette-hot-orange-90);
    --slds-g-color-palette-hot-orange-90:#ffded5;
    --sds-g-color-palette-hot-orange-95:var(--slds-g-color-palette-hot-orange-95);
    --slds-g-color-palette-hot-orange-95:#fef1ed;
    --sds-g-color-palette-indigo-10:var(--slds-g-color-palette-indigo-10);
    --slds-g-color-palette-indigo-10:#200647;
    --sds-g-color-palette-indigo-15:var(--slds-g-color-palette-indigo-15);
    --slds-g-color-palette-indigo-15:#1f0974;
    --sds-g-color-palette-indigo-20:var(--slds-g-color-palette-indigo-20);
    --slds-g-color-palette-indigo-20:#321D71;
    --sds-g-color-palette-indigo-30:var(--slds-g-color-palette-indigo-30);
    --slds-g-color-palette-indigo-30:#2f2cb7;
    --sds-g-color-palette-indigo-40:var(--slds-g-color-palette-indigo-40);
    --slds-g-color-palette-indigo-40:#3a49da;
    --sds-g-color-palette-indigo-50:var(--slds-g-color-palette-indigo-50);
    --slds-g-color-palette-indigo-50:#5867e8;
    --sds-g-color-palette-indigo-60:var(--slds-g-color-palette-indigo-60);
    --slds-g-color-palette-indigo-60:#7f8ced;
    --sds-g-color-palette-indigo-65:var(--slds-g-color-palette-indigo-65);
    --slds-g-color-palette-indigo-65:#8e9bef;
    --sds-g-color-palette-indigo-70:var(--slds-g-color-palette-indigo-70);
    --slds-g-color-palette-indigo-70:#9ea9f1;
    --sds-g-color-palette-indigo-80:var(--slds-g-color-palette-indigo-80);
    --slds-g-color-palette-indigo-80:#bec7f6;
    --sds-g-color-palette-indigo-90:var(--slds-g-color-palette-indigo-90);
    --slds-g-color-palette-indigo-90:#e0e5f8;
    --sds-g-color-palette-indigo-95:var(--slds-g-color-palette-indigo-95);
    --slds-g-color-palette-indigo-95:#f1f3fb;
    --sds-g-color-palette-orange-10:var(--slds-g-color-palette-orange-10);
    --slds-g-color-palette-orange-10:#201600;
    --sds-g-color-palette-orange-15:var(--slds-g-color-palette-orange-15);
    --slds-g-color-palette-orange-15:#371e03;
    --sds-g-color-palette-orange-20:var(--slds-g-color-palette-orange-20);
    --slds-g-color-palette-orange-20:#3e2b02;
    --sds-g-color-palette-orange-30:var(--slds-g-color-palette-orange-30);
    --slds-g-color-palette-orange-30:#5f3e02;
    --sds-g-color-palette-orange-40:var(--slds-g-color-palette-orange-40);
    --slds-g-color-palette-orange-40:#825101;
    --sds-g-color-palette-orange-50:var(--slds-g-color-palette-orange-50);
    --slds-g-color-palette-orange-50:#a96404;
    --sds-g-color-palette-orange-60:var(--slds-g-color-palette-orange-60);
    --slds-g-color-palette-orange-60:#dd7a01;
    --sds-g-color-palette-orange-65:var(--slds-g-color-palette-orange-65);
    --slds-g-color-palette-orange-65:#f38303;
    --sds-g-color-palette-orange-70:var(--slds-g-color-palette-orange-70);
    --slds-g-color-palette-orange-70:#fe9339;
    --sds-g-color-palette-orange-80:var(--slds-g-color-palette-orange-80);
    --slds-g-color-palette-orange-80:#ffba90;
    --sds-g-color-palette-orange-90:var(--slds-g-color-palette-orange-90);
    --slds-g-color-palette-orange-90:#fedfd0;
    --sds-g-color-palette-orange-95:var(--slds-g-color-palette-orange-95);
    --slds-g-color-palette-orange-95:#fff1ea;
    --sds-g-color-palette-pink-10:var(--slds-g-color-palette-pink-10);
    --slds-g-color-palette-pink-10:#370114;
    --sds-g-color-palette-pink-15:var(--slds-g-color-palette-pink-15);
    --slds-g-color-palette-pink-15:#4b0620;
    --sds-g-color-palette-pink-20:var(--slds-g-color-palette-pink-20);
    --slds-g-color-palette-pink-20:#61022a;
    --sds-g-color-palette-pink-30:var(--slds-g-color-palette-pink-30);
    --slds-g-color-palette-pink-30:#8a033e;
    --sds-g-color-palette-pink-40:var(--slds-g-color-palette-pink-40);
    --slds-g-color-palette-pink-40:#b60554;
    --sds-g-color-palette-pink-50:var(--slds-g-color-palette-pink-50);
    --slds-g-color-palette-pink-50:#e3066a;
    --sds-g-color-palette-pink-60:var(--slds-g-color-palette-pink-60);
    --slds-g-color-palette-pink-60:#ff538a;
    --sds-g-color-palette-pink-65:var(--slds-g-color-palette-pink-65);
    --slds-g-color-palette-pink-65:#fe7298;
    --sds-g-color-palette-pink-70:var(--slds-g-color-palette-pink-70);
    --slds-g-color-palette-pink-70:#fe8aa7;
    --sds-g-color-palette-pink-80:var(--slds-g-color-palette-pink-80);
    --slds-g-color-palette-pink-80:#fdb6c5;
    --sds-g-color-palette-pink-90:var(--slds-g-color-palette-pink-90);
    --slds-g-color-palette-pink-90:#fddde3;
    --sds-g-color-palette-pink-95:var(--slds-g-color-palette-pink-95);
    --slds-g-color-palette-pink-95:#fef0f3;
    --sds-g-color-palette-purple-10:var(--slds-g-color-palette-purple-10);
    --slds-g-color-palette-purple-10:#240643;
    --sds-g-color-palette-purple-15:var(--slds-g-color-palette-purple-15);
    --slds-g-color-palette-purple-15:#300b60;
    --sds-g-color-palette-purple-20:var(--slds-g-color-palette-purple-20);
    --slds-g-color-palette-purple-20:#401075;
    --sds-g-color-palette-purple-30:var(--slds-g-color-palette-purple-30);
    --slds-g-color-palette-purple-30:#5a1ba9;
    --sds-g-color-palette-purple-40:var(--slds-g-color-palette-purple-40);
    --slds-g-color-palette-purple-40:#7526e3;
    --sds-g-color-palette-purple-50:var(--slds-g-color-palette-purple-50);
    --slds-g-color-palette-purple-50:#9050e9;
    --sds-g-color-palette-purple-60:var(--slds-g-color-palette-purple-60);
    --slds-g-color-palette-purple-60:#ad7bee;
    --sds-g-color-palette-purple-65:var(--slds-g-color-palette-purple-65);
    --slds-g-color-palette-purple-65:#b78def;
    --sds-g-color-palette-purple-70:var(--slds-g-color-palette-purple-70);
    --slds-g-color-palette-purple-70:#c29ef1;
    --sds-g-color-palette-purple-80:var(--slds-g-color-palette-purple-80);
    --slds-g-color-palette-purple-80:#D7BFF2;
    --sds-g-color-palette-purple-90:var(--slds-g-color-palette-purple-90);
    --slds-g-color-palette-purple-90:#ece1f9;
    --sds-g-color-palette-purple-95:var(--slds-g-color-palette-purple-95);
    --slds-g-color-palette-purple-95:#f6f2fb;
    --sds-g-color-palette-red-10:var(--slds-g-color-palette-red-10);
    --slds-g-color-palette-red-10:#300c01;
    --sds-g-color-palette-red-15:var(--slds-g-color-palette-red-15);
    --slds-g-color-palette-red-15:#4a0c04;
    --sds-g-color-palette-red-20:var(--slds-g-color-palette-red-20);
    --slds-g-color-palette-red-20:#640103;
    --sds-g-color-palette-red-30:var(--slds-g-color-palette-red-30);
    --slds-g-color-palette-red-30:#8e030f;
    --sds-g-color-palette-red-40:var(--slds-g-color-palette-red-40);
    --slds-g-color-palette-red-40:#ba0517;
    --sds-g-color-palette-red-50:var(--slds-g-color-palette-red-50);
    --slds-g-color-palette-red-50:#ea001e;
    --sds-g-color-palette-red-60:var(--slds-g-color-palette-red-60);
    --slds-g-color-palette-red-60:#fe5c4c;
    --sds-g-color-palette-red-65:var(--slds-g-color-palette-red-65);
    --slds-g-color-palette-red-65:#fe7765;
    --sds-g-color-palette-red-70:var(--slds-g-color-palette-red-70);
    --slds-g-color-palette-red-70:#fe8f7d;
    --sds-g-color-palette-red-80:var(--slds-g-color-palette-red-80);
    --slds-g-color-palette-red-80:#feb8ab;
    --sds-g-color-palette-red-90:var(--slds-g-color-palette-red-90);
    --slds-g-color-palette-red-90:#feded8;
    --sds-g-color-palette-red-95:var(--slds-g-color-palette-red-95);
    --slds-g-color-palette-red-95:#fef1ee;
    --sds-g-color-palette-teal-10:var(--slds-g-color-palette-teal-10);
    --slds-g-color-palette-teal-10:#071b12;
    --sds-g-color-palette-teal-15:var(--slds-g-color-palette-teal-15);
    --slds-g-color-palette-teal-15:#072825;
    --sds-g-color-palette-teal-20:var(--slds-g-color-palette-teal-20);
    --slds-g-color-palette-teal-20:#023434;
    --sds-g-color-palette-teal-30:var(--slds-g-color-palette-teal-30);
    --slds-g-color-palette-teal-30:#024d4c;
    --sds-g-color-palette-teal-40:var(--slds-g-color-palette-teal-40);
    --slds-g-color-palette-teal-40:#056764;
    --sds-g-color-palette-teal-50:var(--slds-g-color-palette-teal-50);
    --slds-g-color-palette-teal-50:#0b827c;
    --sds-g-color-palette-teal-60:var(--slds-g-color-palette-teal-60);
    --slds-g-color-palette-teal-60:#06a59a;
    --sds-g-color-palette-teal-65:var(--slds-g-color-palette-teal-65);
    --slds-g-color-palette-teal-65:#03b4a7;
    --sds-g-color-palette-teal-70:var(--slds-g-color-palette-teal-70);
    --slds-g-color-palette-teal-70:#01c3b3;
    --sds-g-color-palette-teal-80:var(--slds-g-color-palette-teal-80);
    --slds-g-color-palette-teal-80:#04e1cb;
    --sds-g-color-palette-teal-90:var(--slds-g-color-palette-teal-90);
    --slds-g-color-palette-teal-90:#acf3e4;
    --sds-g-color-palette-teal-95:var(--slds-g-color-palette-teal-95);
    --slds-g-color-palette-teal-95:#def9f3;
    --sds-g-color-palette-violet-10:var(--slds-g-color-palette-violet-10);
    --slds-g-color-palette-violet-10:#2e0039;
    --sds-g-color-palette-violet-15:var(--slds-g-color-palette-violet-15);
    --slds-g-color-palette-violet-15:#3d0157;
    --sds-g-color-palette-violet-20:var(--slds-g-color-palette-violet-20);
    --slds-g-color-palette-violet-20:#481A54;
    --sds-g-color-palette-violet-30:var(--slds-g-color-palette-violet-30);
    --slds-g-color-palette-violet-30:#730394;
    --sds-g-color-palette-violet-40:var(--slds-g-color-palette-violet-40);
    --slds-g-color-palette-violet-40:#9602c7;
    --sds-g-color-palette-violet-50:var(--slds-g-color-palette-violet-50);
    --slds-g-color-palette-violet-50:#ba01ff;
    --sds-g-color-palette-violet-60:var(--slds-g-color-palette-violet-60);
    --slds-g-color-palette-violet-60:#cb65ff;
    --sds-g-color-palette-violet-65:var(--slds-g-color-palette-violet-65);
    --slds-g-color-palette-violet-65:#d17dfe;
    --sds-g-color-palette-violet-70:var(--slds-g-color-palette-violet-70);
    --slds-g-color-palette-violet-70:#d892fe;
    --sds-g-color-palette-violet-80:var(--slds-g-color-palette-violet-80);
    --slds-g-color-palette-violet-80:#e5b9fe;
    --sds-g-color-palette-violet-90:var(--slds-g-color-palette-violet-90);
    --slds-g-color-palette-violet-90:#f2defe;
    --sds-g-color-palette-violet-95:var(--slds-g-color-palette-violet-95);
    --slds-g-color-palette-violet-95:#f9f0ff;
    --sds-g-color-palette-yellow-10:var(--slds-g-color-palette-yellow-10);
    --slds-g-color-palette-yellow-10:#281202;
    --sds-g-color-palette-yellow-15:var(--slds-g-color-palette-yellow-15);
    --slds-g-color-palette-yellow-15:#2e2204;
    --sds-g-color-palette-yellow-20:var(--slds-g-color-palette-yellow-20);
    --slds-g-color-palette-yellow-20:#4f2100;
    --sds-g-color-palette-yellow-30:var(--slds-g-color-palette-yellow-30);
    --slds-g-color-palette-yellow-30:#6f3400;
    --sds-g-color-palette-yellow-40:var(--slds-g-color-palette-yellow-40);
    --slds-g-color-palette-yellow-40:#8c4b02;
    --sds-g-color-palette-yellow-50:var(--slds-g-color-palette-yellow-50);
    --slds-g-color-palette-yellow-50:#a86403;
    --sds-g-color-palette-yellow-60:var(--slds-g-color-palette-yellow-60);
    --slds-g-color-palette-yellow-60:#ca8501;
    --sds-g-color-palette-yellow-65:var(--slds-g-color-palette-yellow-65);
    --slds-g-color-palette-yellow-65:#d79304;
    --sds-g-color-palette-yellow-70:var(--slds-g-color-palette-yellow-70);
    --slds-g-color-palette-yellow-70:#e4a201;
    --sds-g-color-palette-yellow-80:var(--slds-g-color-palette-yellow-80);
    --slds-g-color-palette-yellow-80:#fcc003;
    --sds-g-color-palette-yellow-90:var(--slds-g-color-palette-yellow-90);
    --slds-g-color-palette-yellow-90:#f9e3b6;
    --sds-g-color-palette-yellow-95:var(--slds-g-color-palette-yellow-95);
    --slds-g-color-palette-yellow-95:#fbf3e0;
    --sds-g-color-palette-neutral-10:var(--slds-g-color-palette-neutral-10);
    --slds-g-color-palette-neutral-10:#181818;
    --sds-g-color-palette-neutral-15:var(--slds-g-color-palette-neutral-15);
    --slds-g-color-palette-neutral-15:#242424;
    --sds-g-color-palette-neutral-20:var(--slds-g-color-palette-neutral-20);
    --slds-g-color-palette-neutral-20:#2e2e2e;
    --sds-g-color-palette-neutral-30:var(--slds-g-color-palette-neutral-30);
    --slds-g-color-palette-neutral-30:#444444;
    --sds-g-color-palette-neutral-40:var(--slds-g-color-palette-neutral-40);
    --slds-g-color-palette-neutral-40:#5c5c5c;
    --sds-g-color-palette-neutral-50:var(--slds-g-color-palette-neutral-50);
    --slds-g-color-palette-neutral-50:#747474;
    --sds-g-color-palette-neutral-60:var(--slds-g-color-palette-neutral-60);
    --slds-g-color-palette-neutral-60:#939393;
    --sds-g-color-palette-neutral-65:var(--slds-g-color-palette-neutral-65);
    --slds-g-color-palette-neutral-65:#a0a0a0;
    --sds-g-color-palette-neutral-70:var(--slds-g-color-palette-neutral-70);
    --slds-g-color-palette-neutral-70:#aeaeae;
    --sds-g-color-palette-neutral-80:var(--slds-g-color-palette-neutral-80);
    --slds-g-color-palette-neutral-80:#c9c9c9;
    --sds-g-color-palette-neutral-90:var(--slds-g-color-palette-neutral-90);
    --slds-g-color-palette-neutral-90:#e5e5e5;
    --sds-g-color-palette-neutral-95:var(--slds-g-color-palette-neutral-95);
    --slds-g-color-palette-neutral-95:#f3f3f3;
    --sds-g-color-palette-neutral-100:var(--slds-g-color-palette-neutral-100);
    --slds-g-color-palette-neutral-100:#ffffff;
    --sds-g-font-family-base:var(--slds-g-font-family-base);
    --slds-g-font-family-base:system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    --sds-g-font-family-monospace:var(--slds-g-font-family-monospace);
    --slds-g-font-family-monospace:Consolas, Menlo, Monaco, Courier, monospace;
    --slds-g-font-weight-ratio:1;
    --sds-g-font-weight-bold:var(--slds-g-font-weight-bold);
    --slds-g-font-weight-bold:bold;
    --sds-g-font-weight-1:var(--slds-g-font-weight-1);
    --slds-g-font-weight-1: calc(var(--slds-g-font-weight-ratio) * 100);
    --sds-g-font-weight-2:var(--slds-g-font-weight-2);
    --slds-g-font-weight-2: calc(var(--slds-g-font-weight-ratio) * 200);
    --sds-g-font-weight-3:var(--slds-g-font-weight-3);
    --slds-g-font-weight-3: calc(var(--slds-g-font-weight-ratio) * 300);
    --sds-g-font-weight-4:var(--slds-g-font-weight-4);
    --slds-g-font-weight-4: calc(var(--slds-g-font-weight-ratio) * 400);
    --sds-g-font-weight-5:var(--slds-g-font-weight-5);
    --slds-g-font-weight-5: calc(var(--slds-g-font-weight-ratio) * 500);
    --sds-g-font-weight-6:var(--slds-g-font-weight-6);
    --slds-g-font-weight-6: calc(var(--slds-g-font-weight-ratio) * 600);
    --sds-g-font-weight-7:var(--slds-g-font-weight-7);
    --slds-g-font-weight-7: calc(var(--slds-g-font-weight-ratio) * 700);
    --slds-g-font-lineheight-ratio: 1;
    --sds-g-font-lineheight-base:var(--slds-g-font-lineheight-base);
    --slds-g-font-lineheight-base:1.5;
    --sds-g-font-lineheight-1:var(--slds-g-font-lineheight-1);
    --slds-g-font-lineheight-1: calc(var(--slds-g-font-lineheight-ratio) * 1);
    --sds-g-font-lineheight-2:var(--slds-g-font-lineheight-2);
    --slds-g-font-lineheight-2: calc(var(--slds-g-font-lineheight-ratio) * 1.25);
    --sds-g-font-lineheight-3:var(--slds-g-font-lineheight-3);
    --slds-g-font-lineheight-3: calc(var(--slds-g-font-lineheight-ratio) * 1.375);
    --sds-g-font-lineheight-4:var(--slds-g-font-lineheight-4);
    --slds-g-font-lineheight-4: calc(var(--slds-g-font-lineheight-ratio) * 1.5);
    --sds-g-font-lineheight-5:var(--slds-g-font-lineheight-5);
    --slds-g-font-lineheight-5: calc(var(--slds-g-font-lineheight-ratio) * 1.75);
    --sds-g-font-lineheight-6:var(--slds-g-font-lineheight-6);
    --slds-g-font-lineheight-6: calc(var(--slds-g-font-lineheight-ratio) * 2);
    --sds-g-font-scale-ratio:var(--slds-g-font-scale-ratio);
    --slds-g-font-scale-ratio:1;
    --sds-g-font-size-base:var(--slds-g-font-size-base);
    --slds-g-font-size-base: calc(var(--slds-g-font-scale-ratio) * 0.8125rem);
    --sds-g-font-scale-neg-4:var(--slds-g-font-scale-neg-4);
    --slds-g-font-scale-neg-4:var(--slds-g-font-scale-neg-3);
    --sds-g-font-scale-neg-3:var(--slds-g-font-scale-neg-3);
    --slds-g-font-scale-neg-3:var(--slds-g-font-scale-neg-2);
    --sds-g-font-scale-neg-2:var(--slds-g-font-scale-neg-2);
    --slds-g-font-scale-neg-2: calc(var(--slds-g-font-scale-ratio) * 0.625rem);
    --sds-g-font-scale-neg-1:var(--slds-g-font-scale-neg-1);
    --slds-g-font-scale-neg-1: calc(var(--slds-g-font-scale-ratio) * 0.75rem);
    --sds-g-font-scale-1:var(--slds-g-font-scale-1);
    --slds-g-font-scale-1: calc(var(--slds-g-font-scale-ratio) * 0.875rem);
    --sds-g-font-scale-2:var(--slds-g-font-scale-2);
    --slds-g-font-scale-2: calc(var(--slds-g-font-scale-ratio) * 1rem);
    --sds-g-font-scale-3:var(--slds-g-font-scale-3);
    --slds-g-font-scale-3: calc(var(--slds-g-font-scale-ratio) * 1.25rem);
    --sds-g-font-scale-4:var(--slds-g-font-scale-4);
    --slds-g-font-scale-4: calc(var(--slds-g-font-scale-ratio) * 1.5rem);
    --sds-g-font-scale-5:var(--slds-g-font-scale-5);
    --slds-g-font-scale-5: calc(var(--slds-g-font-scale-ratio) * 1.75rem);
    --sds-g-font-scale-6:var(--slds-g-font-scale-6);
    --slds-g-font-scale-6: calc(var(--slds-g-font-scale-ratio) * 2rem);
    --sds-g-font-scale-7:var(--slds-g-font-scale-7);
    --slds-g-font-scale-7: calc(var(--slds-g-font-scale-ratio) * 2.5rem);
    --sds-g-font-scale-8:var(--slds-g-font-scale-8);
    --slds-g-font-scale-8: calc(var(--slds-g-font-scale-ratio) * 3rem);
    --sds-g-font-scale-9:var(--slds-g-font-scale-9);
    --slds-g-font-scale-9:var(--slds-g-font-scale-8);
    --sds-g-font-scale-10:var(--slds-g-font-scale-10);
    --slds-g-font-scale-10:var(--slds-g-font-scale-8);
    --sds-g-color-neutral-base-100:var(--slds-g-color-neutral-base-100);
    --slds-g-color-neutral-base-100:#ffffff;
    --sds-g-color-neutral-base-95:var(--slds-g-color-neutral-base-95);
    --slds-g-color-neutral-base-95:#f3f3f3;
    --sds-g-color-neutral-base-90:var(--slds-g-color-neutral-base-90);
    --slds-g-color-neutral-base-90:#e5e5e5;
    --sds-g-color-neutral-base-80:var(--slds-g-color-neutral-base-80);
    --slds-g-color-neutral-base-80:#c9c9c9;
    --sds-g-color-neutral-base-70:var(--slds-g-color-neutral-base-70);
    --slds-g-color-neutral-base-70:#aeaeae;
    --sds-g-color-neutral-base-65:var(--slds-g-color-neutral-base-65);
    --slds-g-color-neutral-base-65:#a0a0a0;
    --sds-g-color-neutral-base-60:var(--slds-g-color-neutral-base-60);
    --slds-g-color-neutral-base-60:#939393;
    --sds-g-color-neutral-base-50:var(--slds-g-color-neutral-base-50);
    --slds-g-color-neutral-base-50:#747474;
    --sds-g-color-neutral-base-40:var(--slds-g-color-neutral-base-40);
    --slds-g-color-neutral-base-40:#5c5c5c;
    --sds-g-color-neutral-base-30:var(--slds-g-color-neutral-base-30);
    --slds-g-color-neutral-base-30:#444444;
    --sds-g-color-neutral-base-20:var(--slds-g-color-neutral-base-20);
    --slds-g-color-neutral-base-20:#2e2e2e;
    --sds-g-color-neutral-base-15:var(--slds-g-color-neutral-base-15);
    --slds-g-color-neutral-base-15:#242424;
    --sds-g-color-neutral-base-10:var(--slds-g-color-neutral-base-10);
    --slds-g-color-neutral-base-10:#181818;
    --sds-g-color-brand-base-100:var(--slds-g-color-brand-base-100);
    --slds-g-color-brand-base-100:#ffffff;
    --sds-g-color-brand-base-95:var(--slds-g-color-brand-base-95);
    --slds-g-color-brand-base-95:#edf4ff;
    --sds-g-color-brand-base-90:var(--slds-g-color-brand-base-90);
    --slds-g-color-brand-base-90:#d6e6ff;
    --sds-g-color-brand-base-80:var(--slds-g-color-brand-base-80);
    --slds-g-color-brand-base-80:#a8cbff;
    --sds-g-color-brand-base-70:var(--slds-g-color-brand-base-70);
    --slds-g-color-brand-base-70:#7cb1fe;
    --sds-g-color-brand-base-65:var(--slds-g-color-brand-base-65);
    --slds-g-color-brand-base-65:#5f9ffe;
    --sds-g-color-brand-base-60:var(--slds-g-color-brand-base-60);
    --slds-g-color-brand-base-60:#4992fe;
    --sds-g-color-brand-base-50:var(--slds-g-color-brand-base-50);
    --slds-g-color-brand-base-50:#066afe;
    --sds-g-color-brand-base-40:var(--slds-g-color-brand-base-40);
    --slds-g-color-brand-base-40:#0250d9;
    --sds-g-color-brand-base-30:var(--slds-g-color-brand-base-30);
    --slds-g-color-brand-base-30:#022ac0;
    --sds-g-color-brand-base-20:var(--slds-g-color-brand-base-20);
    --slds-g-color-brand-base-20:#002775;
    --sds-g-color-brand-base-15:var(--slds-g-color-brand-base-15);
    --slds-g-color-brand-base-15:#001e5b;
    --sds-g-color-brand-base-10:var(--slds-g-color-brand-base-10);
    --slds-g-color-brand-base-10:#001642;
    --sds-g-color-error-base-100:var(--slds-g-color-error-base-100);
    --slds-g-color-error-base-100:#ffffff;
    --sds-g-color-error-base-90:var(--slds-g-color-error-base-90);
    --slds-g-color-error-base-90:#fddde3;
    --sds-g-color-error-base-80:var(--slds-g-color-error-base-80);
    --slds-g-color-error-base-80:#fdb6c5;
    --sds-g-color-error-base-70:var(--slds-g-color-error-base-70);
    --slds-g-color-error-base-70:#fe8aa7;
    --sds-g-color-error-base-60:var(--slds-g-color-error-base-60);
    --slds-g-color-error-base-60:#ff538a;
    --sds-g-color-error-base-50:var(--slds-g-color-error-base-50);
    --slds-g-color-error-base-50:#e3066a;
    --sds-g-color-error-base-40:var(--slds-g-color-error-base-40);
    --slds-g-color-error-base-40:#b60554;
    --sds-g-color-error-base-30:var(--slds-g-color-error-base-30);
    --slds-g-color-error-base-30:#8a033e;
    --sds-g-color-error-base-20:var(--slds-g-color-error-base-20);
    --slds-g-color-error-base-20:#61022a;
    --sds-g-color-error-base-10:var(--slds-g-color-error-base-10);
    --slds-g-color-error-base-10:#370114;
    --sds-g-color-warning-base-100:var(--slds-g-color-warning-base-100);
    --slds-g-color-warning-base-100:#ffffff;
    --sds-g-color-warning-base-90:var(--slds-g-color-warning-base-90);
    --slds-g-color-warning-base-90:#f9e3b6;
    --sds-g-color-warning-base-80:var(--slds-g-color-warning-base-80);
    --slds-g-color-warning-base-80:#fcc003;
    --sds-g-color-warning-base-70:var(--slds-g-color-warning-base-70);
    --slds-g-color-warning-base-70:#e4a201;
    --sds-g-color-warning-base-60:var(--slds-g-color-warning-base-60);
    --slds-g-color-warning-base-60:#ca8501;
    --sds-g-color-warning-base-50:var(--slds-g-color-warning-base-50);
    --slds-g-color-warning-base-50:#a86403;
    --sds-g-color-warning-base-40:var(--slds-g-color-warning-base-40);
    --slds-g-color-warning-base-40:#8c4b02;
    --sds-g-color-warning-base-30:var(--slds-g-color-warning-base-30);
    --slds-g-color-warning-base-30:#6f3400;
    --sds-g-color-warning-base-20:var(--slds-g-color-warning-base-20);
    --slds-g-color-warning-base-20:#4f2100;
    --sds-g-color-warning-base-10:var(--slds-g-color-warning-base-10);
    --slds-g-color-warning-base-10:#281202;
    --sds-g-color-success-base-100:var(--slds-g-color-success-base-100);
    --slds-g-color-success-base-100:#ffffff;
    --sds-g-color-success-base-90:var(--slds-g-color-success-base-90);
    --slds-g-color-success-base-90:#acf3e4;
    --sds-g-color-success-base-80:var(--slds-g-color-success-base-80);
    --slds-g-color-success-base-80:#04e1cb;
    --sds-g-color-success-base-70:var(--slds-g-color-success-base-70);
    --slds-g-color-success-base-70:#01c3b3;
    --sds-g-color-success-base-60:var(--slds-g-color-success-base-60);
    --slds-g-color-success-base-60:#06a59a;
    --sds-g-color-success-base-50:var(--slds-g-color-success-base-50);
    --slds-g-color-success-base-50:#0b827c;
    --sds-g-color-success-base-40:var(--slds-g-color-success-base-40);
    --slds-g-color-success-base-40:#056764;
    --sds-g-color-success-base-30:var(--slds-g-color-success-base-30);
    --slds-g-color-success-base-30:#024d4c;
    --sds-g-color-success-base-20:var(--slds-g-color-success-base-20);
    --slds-g-color-success-base-20:#023434;
    --sds-g-color-success-base-10:var(--slds-g-color-success-base-10);
    --slds-g-color-success-base-10:#071b12;
    --sds-g-color-border-1:var(--slds-g-color-border-1);
    --slds-g-color-border-1:#c9c9c9;
    --sds-g-color-border-2:var(--slds-g-color-border-2);
    --slds-g-color-border-2:#5c5c5c;
    --sds-g-color-border-accent-1:var(--slds-g-color-border-accent-1);
    --slds-g-color-border-accent-1:#066afe;
    --sds-g-color-border-accent-2:var(--slds-g-color-border-accent-2);
    --slds-g-color-border-accent-2:#0250d9;
    --sds-g-color-border-accent-3:var(--slds-g-color-border-accent-3);
    --slds-g-color-border-accent-3:#022ac0;
    --sds-g-color-surface-1:var(--slds-g-color-surface-1);
    --slds-g-color-surface-1:#ffffff;
    --sds-g-color-surface-2:var(--slds-g-color-surface-2);
    --slds-g-color-surface-2:#f3f3f3;
    --sds-g-color-surface-3:var(--slds-g-color-surface-3);
    --slds-g-color-surface-3:#e5e5e5;
    --sds-g-color-surface-container-1:var(--slds-g-color-surface-container-1);
    --slds-g-color-surface-container-1:#ffffff;
    --sds-g-color-surface-container-2:var(--slds-g-color-surface-container-2);
    --slds-g-color-surface-container-2:#f3f3f3;
    --sds-g-color-surface-container-3:var(--slds-g-color-surface-container-3);
    --slds-g-color-surface-container-3:#e5e5e5;
    --sds-g-color-on-surface-1:var(--slds-g-color-on-surface-1);
    --slds-g-color-on-surface-1:#5c5c5c;
    --sds-g-color-on-surface-2:var(--slds-g-color-on-surface-2);
    --slds-g-color-on-surface-2:#2e2e2e;
    --sds-g-color-on-surface-3:var(--slds-g-color-on-surface-3);
    --slds-g-color-on-surface-3:#03234d;
    --sds-g-color-accent-1:var(--slds-g-color-accent-1);
    --slds-g-color-accent-1:#066afe;
    --sds-g-color-accent-2:var(--slds-g-color-accent-2);
    --slds-g-color-accent-2:#0250d9;
    --sds-g-color-accent-3:var(--slds-g-color-accent-3);
    --slds-g-color-accent-3:#022ac0;
    --sds-g-color-accent-container-1:var(--slds-g-color-accent-container-1);
    --slds-g-color-accent-container-1:#066afe;
    --sds-g-color-accent-container-2:var(--slds-g-color-accent-container-2);
    --slds-g-color-accent-container-2:#0250d9;
    --sds-g-color-accent-container-3:var(--slds-g-color-accent-container-3);
    --slds-g-color-accent-container-3:#022ac0;
    --sds-g-color-on-accent-1:var(--slds-g-color-on-accent-1);
    --slds-g-color-on-accent-1:#ffffff;
    --sds-g-color-error-1:var(--slds-g-color-error-1);
    --slds-g-color-error-1:#b60554;
    --sds-g-color-error-container-1:var(--slds-g-color-error-container-1);
    --slds-g-color-error-container-1:#fddde3;
    --sds-g-color-on-error-1:var(--slds-g-color-on-error-1);
    --slds-g-color-on-error-1:#b60554;
    --sds-g-color-border-error-1:var(--slds-g-color-border-error-1);
    --slds-g-color-border-error-1:#b60554;
    --sds-g-color-warning-1:var(--slds-g-color-warning-1);
    --slds-g-color-warning-1:#8c4b02;
    --sds-g-color-warning-container-1:var(--slds-g-color-warning-container-1);
    --slds-g-color-warning-container-1:#f9e3b6;
    --sds-g-color-on-warning-1:var(--slds-g-color-on-warning-1);
    --slds-g-color-on-warning-1:#8c4b02;
    --sds-g-color-border-warning-1:var(--slds-g-color-border-warning-1);
    --slds-g-color-border-warning-1:#dd7a01;
    --sds-g-color-success-1:var(--slds-g-color-success-1);
    --slds-g-color-success-1:#056764;
    --sds-g-color-success-container-1:var(--slds-g-color-success-container-1);
    --slds-g-color-success-container-1:#acf3e4;
    --sds-g-color-on-success-1:var(--slds-g-color-on-success-1);
    --slds-g-color-on-success-1:var(--slds-g-color-success-base-40);
    --sds-g-color-border-success-1:var(--slds-g-color-border-success-1);
    --slds-g-color-border-success-1:var(--slds-g-color-success-base-40);
    --sds-g-color-info-1:var(--slds-g-color-info-1);
    --slds-g-color-info-1:#0b5cab;
    --sds-g-color-info-container-1:var(--slds-g-color-info-container-1);
    --slds-g-color-info-container-1:#d8e6fe;
    --sds-g-color-on-info-1:var(--slds-g-color-on-info-1);
    --slds-g-color-on-info-1:#0b5cab;
    --sds-g-color-disabled-1:var(--slds-g-color-disabled-1);
    --slds-g-color-disabled-1:#c9c9c9;
    --sds-g-color-disabled-container-1:var(--slds-g-color-disabled-container-1);
    --slds-g-color-disabled-container-1:#ffffff;
    --sds-g-color-on-disabled-1:var(--slds-g-color-on-disabled-1);
    --slds-g-color-on-disabled-1:#c9c9c9;
    --sds-g-color-border-disabled-1:var(--slds-g-color-border-disabled-1);
    --slds-g-color-border-disabled-1:var(--slds-g-color-neutral-base-80);
    --sds-g-shadow-blockstart-1:var(--slds-g-shadow-blockstart-1);
    --slds-g-shadow-blockstart-1:0px 0px 1.5px 0px #00000017, 0px -1.4px 1.5px 0px #00000017, 0px 1px 1px 0px #00000009;
    --sds-g-shadow-inlineend-1:var(--slds-g-shadow-inlineend-1);
    --slds-g-shadow-inlineend-1:0px 0px 1.5px 0px #00000017, 1.4px 0px 1.5px 0px #00000017, -1px 0 1px 0 #00000009;
    --sds-g-shadow-blockend-1:var(--slds-g-shadow-blockend-1);
    --slds-g-shadow-blockend-1:var(--slds-g-shadow-1);
    --sds-g-shadow-inlinestart-1:var(--slds-g-shadow-inlinestart-1);
    --slds-g-shadow-inlinestart-1:0px 0px 1.5px 0px #00000017, -1.4px 0px 1.5px 0px #00000017, 1px 0px 1px 0px #00000009;
    --sds-g-shadow-blockstart-2:var(--slds-g-shadow-blockstart-2);
    --slds-g-shadow-blockstart-2:0px 0px 3px 0px #00000016, 0px -2.8px 3px 0px #00000016, 0px 1px 1.2px 0px #00000009;
    --sds-g-shadow-inlineend-2:var(--slds-g-shadow-inlineend-2);
    --slds-g-shadow-inlineend-2:0px 0px 3px 0px #00000016, 2.8px 0px 3px 0px #00000016, -1px 0px 1.2px 0px #00000009;
    --sds-g-shadow-blockend-2:var(--slds-g-shadow-blockend-2);
    --slds-g-shadow-blockend-2:var(--slds-g-shadow-2);
    --sds-g-shadow-inlinestart-2:var(--slds-g-shadow-inlinestart-2);
    --slds-g-shadow-inlinestart-2:0px 0px 3px 0px #00000016, -2.8px 0px 3px 0px #00000016, 1px 0px 1.2px 0px #00000009;
    --sds-g-shadow-blockstart-3:var(--slds-g-shadow-blockstart-3);
    --slds-g-shadow-blockstart-3:0px 0px 4.5px 0px #00000014, 0px -4.2px 4.5px 0px #00000017, 0px 1px 1.44px 0px #00000008;
    --sds-g-shadow-inlineend-3:var(--slds-g-shadow-inlineend-3);
    --slds-g-shadow-inlineend-3:0px 0px 4.5px 0px #00000014, 4.2px 0px 4.5px 0px #00000017, -1px 0px 1.44px 0px #00000008;
    --sds-g-shadow-blockend-3:var(--slds-g-shadow-blockend-3);
    --slds-g-shadow-blockend-3:var(--slds-g-shadow-3);
    --sds-g-shadow-inlinestart-3:var(--slds-g-shadow-inlinestart-3);
    --slds-g-shadow-inlinestart-3:0px 0px 4.5px 0px #00000014, -4.2px 0px 4.5px 0px #00000017, 1px 0px 1.44px 0px #00000008;
    --sds-g-shadow-blockstart-4:var(--slds-g-shadow-blockstart-4);
    --slds-g-shadow-blockstart-4:0px 0px 6.75px 0px #00000012, 0px -6.3px 6.75px 0px #00000012, 0px 1px 1.7px 0px #00000007;
    --sds-g-shadow-inlineend-4:var(--slds-g-shadow-inlineend-4);
    --slds-g-shadow-inlineend-4:0px 0px 6.75px 0px #00000012, 6.3px 0px 6.75px 0px #00000012, -1px 0px 1.7px 0px #00000007;
    --sds-g-shadow-blockend-4:var(--slds-g-shadow-blockend-4);
    --slds-g-shadow-blockend-4:var(--slds-g-shadow-4);
    --sds-g-shadow-inlinestart-4:var(--slds-g-shadow-inlinestart-4);
    --slds-g-shadow-inlinestart-4:0px 0px 6.75px 0px #00000012, -6.3px 0px 6.75px 0px #00000012, 1px 0px 1.7px 0px #00000007;
    --sds-g-shadow-outline-focus-1:var(--slds-g-shadow-outline-focus-1);
    --slds-g-shadow-outline-focus-1:0px 0px 0px 2px var(--slds-g-color-brand-base-15);
    --sds-g-shadow-outset-focus-1:var(--slds-g-shadow-outset-focus-1);
    --slds-g-shadow-outset-focus-1:0px 0px 0px 2px var(--slds-g-color-neutral-base-100), 0px 0px 0px 4px var(--slds-g-color-brand-base-15);
    --sds-g-shadow-inset-focus-1:var(--slds-g-shadow-inset-focus-1);
    --slds-g-shadow-inset-focus-1:0px 0px 0px 2px var(--slds-g-color-brand-base-15) inset;
    --sds-g-shadow-insetinverse-focus-1:var(--slds-g-shadow-insetinverse-focus-1);
    --slds-g-shadow-insetinverse-focus-1:0px 0px 0px 2px var(--slds-g-color-brand-base-15) inset, 0px 0px 0px 4px var(--slds-g-color-neutral-base-100) inset;
    --sds-g-color-palette-electric-blue-10:var(--slds-g-color-palette-electric-blue-10);
    --slds-g-color-palette-electric-blue-10:#001642;
    --sds-g-color-palette-electric-blue-15:var(--slds-g-color-palette-electric-blue-15);
    --slds-g-color-palette-electric-blue-15:#001e5b;
    --sds-g-color-palette-electric-blue-20:var(--slds-g-color-palette-electric-blue-20);
    --slds-g-color-palette-electric-blue-20:#002775;
    --sds-g-color-palette-electric-blue-30:var(--slds-g-color-palette-electric-blue-30);
    --slds-g-color-palette-electric-blue-30:#022ac0;
    --sds-g-color-palette-electric-blue-40:var(--slds-g-color-palette-electric-blue-40);
    --slds-g-color-palette-electric-blue-40:#0250d9;
    --sds-g-color-palette-electric-blue-50:var(--slds-g-color-palette-electric-blue-50);
    --slds-g-color-palette-electric-blue-50:#066afe;
    --sds-g-color-palette-electric-blue-60:var(--slds-g-color-palette-electric-blue-60);
    --slds-g-color-palette-electric-blue-60:#4992fe;
    --sds-g-color-palette-electric-blue-65:var(--slds-g-color-palette-electric-blue-65);
    --slds-g-color-palette-electric-blue-65:#5f9ffe;
    --sds-g-color-palette-electric-blue-70:var(--slds-g-color-palette-electric-blue-70);
    --slds-g-color-palette-electric-blue-70:#7cb1fe;
    --sds-g-color-palette-electric-blue-80:var(--slds-g-color-palette-electric-blue-80);
    --slds-g-color-palette-electric-blue-80:#a8cbff;
    --sds-g-color-palette-electric-blue-90:var(--slds-g-color-palette-electric-blue-90);
    --slds-g-color-palette-electric-blue-90:#d6e6ff;
    --sds-g-color-palette-electric-blue-95:var(--slds-g-color-palette-electric-blue-95);
    --slds-g-color-palette-electric-blue-95:#edf4ff;
    --sds-g-color-accent-light-1:var(--slds-g-color-accent-light-1);
    --slds-g-color-accent-light-1:#edf4ff;
    --sds-g-color-accent-light-2:var(--slds-g-color-accent-light-2);
    --slds-g-color-accent-light-2:#d6e6ff;
    --sds-g-color-accent-dark-1:var(--slds-g-color-accent-dark-1);
    --slds-g-color-accent-dark-1:#002775;
    --sds-g-color-accent-dark-2:var(--slds-g-color-accent-dark-2);
    --slds-g-color-accent-dark-2:#001642;
    --sds-g-color-disabled-container-2:var(--slds-g-color-disabled-container-2);
    --slds-g-color-disabled-container-2:#c9c9c9;
    --sds-g-color-on-disabled-2:var(--slds-g-color-on-disabled-2);
    --slds-g-color-on-disabled-2:#939393;
    --sds-g-color-error-container-2:var(--slds-g-color-error-container-2);
    --slds-g-color-error-container-2:#fdb6c5;
    --sds-g-color-on-error-2:var(--slds-g-color-on-error-2);
    --slds-g-color-on-error-2:#8a033e;
    --sds-g-color-border-error-2:var(--slds-g-color-border-error-2);
    --slds-g-color-border-error-2:#8a033e;
    --sds-g-color-success-container-2:var(--slds-g-color-success-container-2);
    --slds-g-color-success-container-2:#04e1cb;
    --sds-g-color-on-success-2:var(--slds-g-color-on-success-2);
    --slds-g-color-on-success-2:var(--slds-g-color-success-base-20);
    --sds-g-color-surface-inverse-1:var(--slds-g-color-surface-inverse-1);
    --slds-g-color-surface-inverse-1:#032d60;
    --sds-g-color-surface-inverse-2:var(--slds-g-color-surface-inverse-2);
    --slds-g-color-surface-inverse-2:#03234d;
    --sds-g-color-surface-container-inverse-1:var(--slds-g-color-surface-container-inverse-1);
    --slds-g-color-surface-container-inverse-1:#032d60;
    --sds-g-color-surface-container-inverse-2:var(--slds-g-color-surface-container-inverse-2);
    --slds-g-color-surface-container-inverse-2:#03234d;
    --sds-g-color-on-surface-inverse-1:var(--slds-g-color-on-surface-inverse-1);
    --slds-g-color-on-surface-inverse-1:#ffffff;
    --sds-g-color-on-surface-inverse-2:var(--slds-g-color-on-surface-inverse-2);
    --slds-g-color-on-surface-inverse-2:#a8cbff;
    --sds-g-color-border-inverse-1:var(--slds-g-color-border-inverse-1);
    --slds-g-color-border-inverse-1:#f3f3f3;
    --sds-g-color-border-inverse-2:var(--slds-g-color-border-inverse-2);
    --slds-g-color-border-inverse-2:#032d60;
  }
}
@layer deprecated{
  :where(html){
    --lwc-brandPrimary:var(--slds-g-color-brand-base-60) !important;
    --lwc-brandPrimaryActive:var(--slds-g-color-brand-base-50) !important;
    --lwc-brandAccessible:var(--slds-g-color-brand-base-50) !important;
    --lwc-brandAccessibleActive:var(--slds-g-color-brand-base-40) !important;
    --lwc-brandContrast:var(--slds-g-color-brand-base-100) !important;
    --lwc-brandContrastActive:var(--slds-g-color-brand-base-100) !important;
    --lwc-brandLight:var(--slds-g-color-brand-base-95) !important;
    --lwc-brandLightActive:var(--slds-g-color-brand-base-90) !important;
    --lwc-brandDark:var(--slds-g-color-brand-base-20) !important;
    --lwc-brandDarkActive:var(--slds-g-color-brand-base-10) !important;
    --lwc-brandTextLink:var(--slds-g-color-brand-base-50) !important;
    --lwc-brandTextLinkActive:var(--slds-g-color-brand-base-40) !important;

    --lwc-varSpacingXxxSmall: 0.125rem;
    --lwc-varSpacingXxSmall: 0.25rem;
    --lwc-varSpacingXSmall: 0.5rem;
    --lwc-varSpacingSmall: 0.75rem;
    --lwc-varSpacingMedium: 1rem;
    --lwc-varSpacingLarge: 1.5rem;
    --lwc-varSpacingXLarge: 2rem;
    --lwc-varSpacingXxLarge: 3rem;


    --lwc-varSpacingHorizontalXxxSmall: 0.125rem;
    --lwc-varSpacingHorizontalXxSmall: 0.25rem;
    --lwc-varSpacingHorizontalXSmall: 0.5rem;
    --lwc-varSpacingHorizontalSmall: 0.75rem;
    --lwc-varSpacingHorizontalMedium: 1rem;
    --lwc-varSpacingHorizontalLarge: 1.5rem;
    --lwc-varSpacingHorizontalXLarge: 2rem;
    --lwc-varSpacingHorizontalXxLarge: 3rem;


    
    --lwc-varSpacingVerticalXxxSmall: 0.125rem;
    --lwc-varSpacingVerticalXxSmall: 0.25rem;
    --lwc-varSpacingVerticalXSmall: 0.5rem;
    --lwc-varSpacingVerticalSmall: 0.75rem;
    --lwc-varSpacingVerticalMedium: 1rem;
    --lwc-varSpacingVerticalLarge: 1.5rem;
    --lwc-varSpacingVerticalXLarge: 2rem;
    --lwc-varSpacingVerticalXxLarge: 3rem;
  }
}
@layer shared{
  :where(html){
    --sds-s-table-color:var(--slds-s-table-color);
    --slds-s-table-color:var(--slds-g-color-on-surface-1);
    --sds-s-table-header-color-background:var(--slds-s-table-header-color-background);
    --slds-s-table-header-color-background:var(--slds-g-color-surface-container-2);
    --sds-s-table-header-color-background-hover:var(--slds-s-table-header-color-background-hover);
    --slds-s-table-header-color-background-hover:var(--slds-g-color-surface-container-3);
    --sds-s-table-header-color-background-selected:var(--slds-s-table-header-color-background-selected);
    --slds-s-table-header-color-background-selected:var(--slds-g-color-surface-container-1);
    --sds-s-table-header-color:var(--slds-s-table-header-color);
    --slds-s-table-header-color:var(--slds-g-color-on-surface-1);
    --sds-s-table-header-font-weight:var(--slds-s-table-header-font-weight);
    --slds-s-table-header-font-weight:var(--slds-g-font-weight-6);
    --sds-s-table-resize-color:var(--slds-s-table-resize-color);
    --slds-s-table-resize-color:var(--slds-g-color-border-1);
    --sds-s-table-resize-color-active:var(--slds-s-table-resize-color-active);
    --slds-s-table-resize-color-active:var(--slds-g-color-accent-3);
    --sds-s-table-row-color-background-selected:var(--slds-s-table-row-color-background-selected);
    --slds-s-table-row-color-background-selected:var(--slds-g-color-brand-base-90);
    --sds-s-table-row-color-border-selected-hover:var(--slds-s-table-row-color-border-selected-hover);
    --slds-s-table-row-color-border-selected-hover:var(--slds-g-color-border-accent-2);
    --sds-s-table-cell-shadow-selected:var(--slds-s-table-cell-shadow-selected);
    --slds-s-table-cell-shadow-selected:var(--slds-g-color-brand-base-15) 0 0 0 2px inset;
    --sds-s-pill-color-background-hover:var(--slds-s-pill-color-background-hover);
    --slds-s-pill-color-background-hover:var(--slds-g-color-brand-base-90);
    --sds-s-pageheader-color-background:var(--slds-s-pageheader-color-background);
    --slds-s-pageheader-color-background:var(--slds-g-color-surface-container-2);
    --sds-s-pageheader-row-color-background:var(--slds-s-pageheader-row-color-background);
    --slds-s-pageheader-row-color-background:var(--slds-g-color-surface-container-2);
    --sds-s-pageheader-radius-border:var(--slds-s-pageheader-radius-border);
    --slds-s-pageheader-radius-border:0;
    --sds-s-pageheader-title-font-size:var(--slds-s-pageheader-title-font-size);
    --slds-s-pageheader-title-font-size:var(--slds-g-font-scale-5);
    --sds-s-pageheader-title-font-weight:var(--slds-s-pageheader-title-font-weight);
    --slds-s-pageheader-title-font-weight:var(--slds-g-font-weight-4);
    --sds-s-pageheader-sizing-border:var(--slds-s-pageheader-sizing-border);
    --slds-s-pageheader-sizing-border:0;
    --sds-s-pageheader-shadow:var(--slds-s-pageheader-shadow);
    --slds-s-pageheader-shadow:none;
    --sds-s-pageheader-action-bottom-spacing:var(--slds-s-pageheader-action-bottom-spacing);
    --slds-s-pageheader-action-bottom-spacing:var(--slds-g-spacing-1);
    --sds-s-navigation-color-background:var(--slds-s-navigation-color-background);
    --slds-s-navigation-color-background:var(--slds-g-color-surface-container-1);
    --sds-s-navigation-color-background-active:var(--slds-s-navigation-color-background-active);
    --slds-s-navigation-color-background-active:var(--slds-g-color-surface-container-1);
    --sds-s-navigation-color-background-hover:var(--slds-s-navigation-color-background-hover);
    --slds-s-navigation-color-background-hover:var(--slds-g-color-brand-base-90);
    --sds-s-navigation-color:var(--slds-s-navigation-color);
    --slds-s-navigation-color:var(--slds-g-color-on-surface-1);
    --sds-s-navigation-color-active:var(--slds-s-navigation-color-active);
    --slds-s-navigation-color-active:var(--slds-g-color-accent-3);
    --sds-s-navigation-color-hover:var(--slds-s-navigation-color-hover);
    --slds-s-navigation-color-hover:var(--slds-g-color-brand-base-15);
    --sds-s-navigation-color-border:var(--slds-s-navigation-color-border);
    --slds-s-navigation-color-border:var(--slds-g-color-neutral-base-80);
    --sds-s-navigation-color-border-hover:var(--slds-s-navigation-color-border-hover);
    --slds-s-navigation-color-border-hover:var(--slds-g-color-brand-base-15);
    --sds-s-navigation-sizing-border-hover:var(--slds-s-navigation-sizing-border-hover);
    --slds-s-navigation-sizing-border-hover:3px;
    --sds-s-navigation-sizing-border-active:var(--slds-s-navigation-sizing-border-active);
    --slds-s-navigation-sizing-border-active:3px;
    --sds-s-navigation-font-weight:var(--slds-s-navigation-font-weight);
    --slds-s-navigation-font-weight:600;
    --sds-s-navigation-font-weight-active:var(--slds-s-navigation-font-weight-active);
    --slds-s-navigation-font-weight-active:600;
    --sds-s-navigation-sizing-height:var(--slds-s-navigation-sizing-height);
    --slds-s-navigation-sizing-height:2.5rem;
    --sds-s-navigation-font-lineheight:var(--slds-s-navigation-font-lineheight);
    --slds-s-navigation-font-lineheight:2.5rem;
    --sds-s-menu-item-color-background-active:var(--slds-s-menu-item-color-background-active);
    --slds-s-menu-item-color-background-active:var(--slds-g-color-brand-base-90);
    --sds-s-menu-item-color-active:var(--slds-s-menu-item-color-active);
    --slds-s-menu-item-color-active:var(--slds-g-color-accent-1);
    --sds-s-mark-color-foreground-checked:var(--slds-s-mark-color-foreground-checked);
    --slds-s-mark-color-foreground-checked:var(--slds-g-color-on-accent-1);
    --sds-s-mark-color-background:var(--slds-s-mark-color-background);
    --slds-s-mark-color-background:var(--slds-g-color-surface-container-1);
    --sds-s-mark-color-background-checked:var(--slds-s-mark-color-background-checked);
    --slds-s-mark-color-background-checked:var(--slds-g-color-accent-container-1);
    --sds-s-mark-color-foreground-invalid:var(--slds-s-mark-color-foreground-invalid);
    --slds-s-mark-color-foreground-invalid:var(--slds-g-color-error-base-100);
    --sds-s-mark-color-background-invalid:var(--slds-s-mark-color-background-invalid);
    --slds-s-mark-color-background-invalid:var(--slds-g-color-error-base-40);
    --sds-s-mark-shadow-focus:var(--slds-s-mark-shadow-focus);
    --slds-s-mark-shadow-focus:0 0 0 2px var(--slds-g-color-surface-1), 0 0 0 4px var(--slds-g-color-brand-base-15);
    --sds-s-mark-shadow-checked:var(--slds-s-mark-shadow-checked);
    --slds-s-mark-shadow-checked:0px 1px 0px 0px rgba(0, 0, 0, 0.08) inset, 0px 0.5px 2px 0px rgba(0, 0, 0, 0.08) inset, 2px 2px 5px 0px rgba(0, 0, 0, 0.08) inset;
    --sds-s-link-color:var(--slds-s-link-color);
    --slds-s-link-color:var(--slds-g-color-accent-2);
    --sds-s-link-color-hover:var(--slds-s-link-color-hover);
    --slds-s-link-color-hover:var(--slds-g-color-accent-3);
    --sds-s-link-color-focus:var(--slds-s-link-color-focus);
    --slds-s-link-color-focus:var(--slds-g-color-accent-3);
    --sds-s-link-color-active:var(--slds-s-link-color-active);
    --slds-s-link-color-active:var(--slds-g-color-accent-3);
    --sds-s-link-shadow-focus:var(--slds-s-link-shadow-focus);
    --slds-s-link-shadow-focus:0 0 0 2px var(--slds-g-color-surface-1), 0 0 0 4px var(--slds-g-color-brand-base-15);
    --sds-s-label-color:var(--slds-s-label-color);
    --slds-s-label-color:var(--slds-g-color-on-surface-1);
    --sds-s-label-font-size:var(--slds-s-label-font-size);
    --slds-s-label-font-size:var(--slds-g-font-size-base);
    --sds-s-label-font-weight:var(--slds-s-label-font-weight);
    --slds-s-label-font-weight:var(--slds-g-font-weight-4);
    --sds-s-label-spacing:var(--slds-s-label-spacing);
    --slds-s-label-spacing:var(--slds-g-spacing-2);
    --sds-s-label-spacing-gap:var(--slds-s-label-spacing-gap);
    --slds-s-label-spacing-gap:var(--slds-g-spacing-1);
    --sds-s-input-radius-border:var(--slds-s-input-radius-border);
    --slds-s-input-radius-border:var(--slds-g-radius-border-2);
    --sds-s-input-color-background:var(--slds-s-input-color-background);
    --slds-s-input-color-background:var(--slds-g-color-surface-container-1);
    --sds-s-input-color-background-disabled:var(--slds-s-input-color-background-disabled);
    --slds-s-input-color-background-disabled:var(--slds-g-color-disabled-container-1);
    --sds-s-input-color-background-invalid:var(--slds-s-input-color-background-invalid);
    --slds-s-input-color-background-invalid:var(--slds-g-color-palette-pink-95);
    --sds-s-input-color-border:var(--slds-s-input-color-border);
    --slds-s-input-color-border:var(--slds-g-color-border-2);
    --sds-s-input-color-border-disabled:var(--slds-s-input-color-border-disabled);
    --slds-s-input-color-border-disabled:var(--slds-g-color-border-disabled-1);
    --sds-s-input-color-border-focus:var(--slds-s-input-color-border-focus);
    --slds-s-input-color-border-focus:var(--slds-g-color-border-2);
    --sds-s-input-spacing:var(--slds-s-input-spacing);
    --slds-s-input-spacing:var(--slds-g-spacing-2);
    --sds-s-input-color:var(--slds-s-input-color);
    --slds-s-input-color:var(--slds-g-color-on-surface-2);
    --sds-s-input-color-disabled:var(--slds-s-input-color-disabled);
    --slds-s-input-color-disabled:var(--slds-g-color-on-disabled-1);
    --sds-s-input-color-invalid:var(--slds-s-input-color-invalid);
    --slds-s-input-color-invalid:var(--slds-g-color-palette-pink-40);
    --sds-s-input-shadow-focus:var(--slds-s-input-shadow-focus);
    --slds-s-input-shadow-focus:2px 2px 5px 0px rgba(0, 0, 0, 0.08) inset, 0px 0.5px 2px 0px rgba(0, 0, 0, 0.35) inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.15) inset, 0 0 0 2px var(--slds-g-color-surface-1), 0 0 0 4px var(--slds-g-color-brand-base-15);
    --sds-s-input-shadow-invalid:var(--slds-s-input-shadow-invalid);
    --slds-s-input-shadow-invalid:none;
    --sds-s-icon-color-foreground:var(--slds-s-icon-color-foreground);
    --slds-s-icon-color-foreground:var(--slds-g-color-on-surface-1);
    --sds-s-icon-radius-border:var(--slds-s-icon-radius-border);
    --slds-s-icon-radius-border:var(--slds-g-radius-border-circle);
    --sds-s-helptext-color:var(--slds-s-helptext-color);
    --slds-s-helptext-color:var(--slds-g-color-on-surface-1);
    --sds-s-helptext-font-size:var(--slds-s-helptext-font-size);
    --slds-s-helptext-font-size:var(--slds-g-font-scale-neg-1);
    --sds-s-helptext-spacing:var(--slds-s-helptext-spacing);
    --slds-s-helptext-spacing:var(--slds-g-spacing-1);
    --sds-s-header-sizing-height:var(--slds-s-header-sizing-height);
    --slds-s-header-sizing-height:3.125rem;
    --sds-s-container-color:var(--slds-s-container-color);
    --slds-s-container-color:var(--slds-g-color-on-surface-1);
    --sds-s-container-shadow:var(--slds-s-container-shadow);
    --slds-s-container-shadow:none;
    --sds-s-container-footer-sizing-border:var(--slds-s-container-footer-sizing-border);
    --slds-s-container-footer-sizing-border:var(--slds-g-sizing-border-1);
    --sds-s-container-color-border:var(--slds-s-container-color-border);
    --slds-s-container-color-border:transparent;
    --sds-s-container-sizing-border:var(--slds-s-container-sizing-border);
    --slds-s-container-sizing-border:0;
    --sds-s-container-radius-border:var(--slds-s-container-radius-border);
    --slds-s-container-radius-border:var(--slds-g-radius-border-4);
    --sds-s-container-heading-font-color:var(--slds-s-container-heading-font-color);
    --slds-s-container-heading-font-color:var(--slds-g-color-on-surface-3);
    --sds-s-container-heading-font-size:var(--slds-s-container-heading-font-size);
    --slds-s-container-heading-font-size:var(--slds-g-font-scale-3);
    --sds-s-container-heading-font-weight:var(--slds-s-container-heading-font-weight);
    --slds-s-container-heading-font-weight:var(--slds-g-font-weight-4);
    --sds-s-container-heading-font-align:var(--slds-s-container-heading-font-align);
    --slds-s-container-heading-font-align:left;
    --sds-s-container-footer-font-align:var(--slds-s-container-footer-font-align);
    --slds-s-container-footer-font-align:right;
    --sds-s-container-footer-font-color:var(--slds-s-container-footer-font-color);
    --slds-s-container-footer-font-color:var(--slds-g-color-on-surface-2);
    --sds-s-container-footer-color-background:var(--slds-s-container-footer-color-background);
    --slds-s-container-footer-color-background:var(--slds-g-color-surface-container-1);
    --sds-s-container-content-color:var(--slds-s-container-content-color);
    --slds-s-container-content-color:var(--slds-g-color-on-surface-1);
    --sds-s-button-color-background:var(--slds-s-button-color-background);
    --slds-s-button-color-background:var(--slds-g-color-surface-container-1);
    --sds-s-button-color-background-hover:var(--slds-s-button-color-background-hover);
    --slds-s-button-color-background-hover:var(--slds-g-color-brand-base-90);
    --sds-s-button-color-background-focus:var(--slds-s-button-color-background-focus);
    --slds-s-button-color-background-focus:var(--slds-g-color-surface-container-2);
    --sds-s-button-color-background-active:var(--slds-s-button-color-background-active);
    --slds-s-button-color-background-active:var(--slds-g-color-surface-container-2);
    --sds-s-button-color-border:var(--slds-s-button-color-border);
    --slds-s-button-color-border:var(--slds-g-color-border-2);
    --sds-s-button-shadow-focus:var(--slds-s-button-shadow-focus);
    --slds-s-button-shadow-focus:0 0 0 2px var(--slds-g-color-surface-1), 0 0 0 4px var(--slds-g-color-brand-base-15);
    --sds-s-button-shadow-focus-inverse:var(--slds-s-button-shadow-focus-inverse);
    --slds-s-button-shadow-focus-inverse:0 0 0 2px var(--slds-g-color-brand-base-15), 0 0 0 4px var(--slds-g-color-surface-1);
    --sds-s-button-shadow-active:var(--slds-s-button-shadow-active);
    --slds-s-button-shadow-active:2px 2px 5px 0px rgba(0, 0, 0, 0.08) inset, 0px 0.5px 2px 0px rgba(0, 0, 0, 0.35) inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.15) inset;
    --sds-s-button-radius-border:var(--slds-s-button-radius-border);
    --slds-s-button-radius-border:var(--slds-g-radius-border-pill);
    --sds-s-button-color:var(--slds-s-button-color);
    --slds-s-button-color:var(--slds-g-color-accent-2);
    --sds-s-button-color-hover:var(--slds-s-button-color-hover);
    --slds-s-button-color-hover:var(--slds-g-color-on-surface-3);
    --sds-s-button-spacing-inline:var(--slds-s-button-spacing-inline);
    --slds-s-button-spacing-inline:var(--slds-g-spacing-4);
    --sds-s-backdrop-color-background:var(--slds-s-backdrop-color-background);
    --slds-s-backdrop-color-background:rgba(92, 92, 92, 0.80);
    --sds-s-avatar-radius-border:var(--slds-s-avatar-radius-border);
    --slds-s-avatar-radius-border:var(--slds-g-radius-border-circle);
    --sds-s-alert-font-weight:var(--slds-s-alert-font-weight);
    --slds-s-alert-font-weight:var(--slds-g-font-weight-6);
    --sds-s-alert-close-button-hover:var(--slds-s-alert-close-button-hover);
    --slds-s-alert-close-button-hover:var(--slds-g-color-on-surface-3);
  }
}
@layer component{
  :where(html){
    --_slds-c-path-item-color-background-active:var(--slds-g-color-surface-container-inverse-1);
    --_slds-c-path-item-color-background-active-hover:var(--slds-g-color-surface-container-inverse-2);
    --_slds-c-path-item-color-background-incomplete:var(--slds-g-color-surface-container-3);
    --_slds-c-path-item-color-incomplete:var(--slds-g-color-on-surface-2);
    --_slds-c-path-item-color-background-incomplete-hover:var(--slds-g-color-neutral-base-70);
    --_slds-c-path-item-color-background-complete:var(--slds-g-color-success-container-1);
    --_slds-c-path-item-color-background-complete-hover:var(--slds-g-color-success-container-1);
    --_slds-c-path-item-color-background-success:var(--slds-g-color-success-container-1);
    --_slds-c-path-item-color-background-error:var(--slds-g-color-error-container-1);
    --_slds-c-path-item-sizing-border:0.0625rem;
    --_slds-c-path-item-sizing-height:1.875rem;
    --_slds-c-globalnavigation-sizing-border:0;
    --_slds-c-globalnavigation-spacing-block:var(--slds-g-spacing-1);
    --_slds-c-globalnavigation-spacing-gap:var(--slds-g-spacing-1);
    --_slds-c-globalnavigation-item-sizing-width-max:var(--slds-g-sizing-15);
    --_slds-c-globalnavigation-item-sizing-border:0;
    --_slds-c-globalnavigation-item-radius-border:var(--slds-g-radius-border-3);
    --_slds-c-globalnavigation-item-sizing-border-hover:3px;
    --_slds-c-globalnavigation-item-sizing-border-active:0;
    --_slds-c-globalnavigation-item-color-background-hover:transparent;
    --_slds-c-globalnavigation-item-color-background-active:transparent;
    --_slds-c-globalnavigation-item-color-border-success:var(--slds-g-color-on-success-1);
    --_slds-c-globalnavigation-item-color-border-error:var(--slds-g-color-on-error-1);
    --_slds-c-globalnavigation-item-color-border-warning:var(--slds-g-color-on-warning-1);
    --_slds-c-globalnavigation-item-color-border-hover:var(--slds-g-color-brand-base-15);
    --_slds-c-globalnavigation-item-color-border-active:var(--slds-g-color-accent-2);
    --_slds-c-globalnavigation-item-shadow-focus:0 0 0 2px var(--slds-g-color-brand-base-15) inset;
    --_slds-c-globalnavigation-font-decoration-focus:none;
    --_slds-c-globalnavigation-font-weight:500;
    --_slds-c-globalnavigation-app-font-weight:var(--slds-g-font-weight-4);
    --_slds-c-globalnavigation-item-color-active:var(--slds-g-color-accent-2);
    --_slds-c-globalnavigation-subtab-color-background-active:var(--slds-g-color-brand-base-90);
    --_slds-c-globalnavigation-subtab-color-background-hover:var(--slds-g-color-surface-container-2);
    --_slds-c-globalheader-color-background:#ffffff;
    --_slds-c-globalheader-color:#5c5c5c;
    --_slds-c-globalheader-color-hover:#444444;
    --_slds-c-utilitybar-sizing-border-hover:3px;
    --_slds-c-utilitybar-sizing-border-active:3px;
    --_slds-c-utilitybar-color-border-hover:var(--slds-g-color-brand-base-15);
    --_slds-c-utilitybar-color-border-active:var(--slds-g-color-accent-2);
    --_slds-c-utilitybar-color-background-hover:var(--slds-g-color-surface-1);
    --_slds-c-utilitybar-color-background-active:var(--slds-g-color-surface-1);
    --_slds-c-utilitybar-color:var(--slds-g-color-on-surface-1);
    --_slds-c-utilitybar-color-hover:var(--slds-g-color-brand-base-15);
    --_slds-c-utilitybar-color-active:var(--slds-g-color-accent-2);
    --_slds-c-utilitybar-font-weight:var(--slds-g-font-weight-6);
    --_slds-c-brandband-scrim-sizing-height:0;
    --_slds-c-brandband-sizing-height-small:0;
    --_slds-c-brandband-sizing-height-medium:0;
    --_slds-c-brandband-sizing-height-large:0;
  }
}
@layer core {
*,
*::before,
*::after{
  box-sizing:border-box;
}
html{
  font-family:var(--slds-g-font-family-base);
  font-size:100%;
  line-height:var(--slds-g-font-lineheight-base);
  background:var(--slds-g-color-surface-2);
  color:var(--slds-g-color-on-surface-3);
  -webkit-tap-highlight-color:transparent;
}
body{
  font-size:var(--slds-g-font-size-base, 0.8125rem);
  background:transparent;
}
::placeholder{
  color:var(--slds-g-color-on-surface-1);
  font-weight:var(--slds-g-font-weight-4);
  opacity:1;
}
::selection{
  background:var(--slds-g-color-brand-base-90);
  text-shadow:none;
  color:var(--slds-g-color-brand-base-15);
}
h1,
h2,
h3,
h4,
h5,
h6,
p,
ol,
ul,
dl,
fieldset{
  margin:0;
  padding:0;
}
dd,
figure{
  margin:0;
}
abbr[title]{
  text-decoration:none;
  border:0;
  cursor:help;
}
fieldset{
  border:0;
}
hr{
  border:0;
  padding:0;
  display:block;
  margin-block:var(--slds-g-spacing-6);
  margin-inline:0;
  border-block-start:1px solid var(--slds-g-color-border-1);
  height:1px;
  clear:both;
}
h1,
h2,
h3,
h4,
h5,
h6{
  font-weight:inherit;
  font-size:1em;
}
ol,
ul{
  list-style:none;
}
a{
  color:var(--slds-s-link-color);
  text-decoration:none;
  transition:color 0.1s linear;
}
a:hover,
a:focus-visible{
  text-decoration:underline;
  color:var(--slds-s-link-color-hover);
}
a:active{
  color:var(--slds-s-link-color-active);
}
a:focus-visible{
  outline-color:var(--slds-g-color-accent-2);
}
a,
button{
  cursor:pointer;
}
button{
  padding:0;
}
/* button,
input,
optgroup,
select,
textarea{
  font:inherit;
} */
b,
strong,
dfn{
  font-weight:var(--slds-g-font-weight-7);
}
mark{
  background-color:var(--slds-g-color-palette-yellow-90);
  color:var(--slds-g-color-neutral-base-10);
}
input[type='search']{
  box-sizing:border-box;
}
table{
  width:100%;
  border-collapse:collapse;
  border-spacing:0;
}
caption,
th,
td{
  text-align:left;
}
audio,
canvas,
iframe,
img,
svg,
video{
  vertical-align:middle;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary{
  display:block;
}
img{
  max-width:100%;
  height:auto;
}
.slds-icon-standard-header-discounts{
  --slds-c-icon-color-background:rgb(92, 92, 92);
}
.slds-icon-standard-contact{
  --slds-c-icon-color-background:rgb(150, 2, 199);
}
.slds-icon-standard-prep-flow{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-crypto-transaction{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-multi-select-checkbox{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-work-order{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-post{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-global-constant{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-change-request{
  --slds-c-icon-color-background:rgb(5, 103, 100);
}
.slds-icon-standard-indicator-performance-period{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-data-cloud{
  --slds-c-icon-color-background:rgb(90, 27, 169);
}
.slds-icon-standard-carousel{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-account-score{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-work-contract{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-impact-strategy-assignment{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-resource-skill{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-system-and-global-variable{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-segments{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-account-info{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-prompt-builder{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-goals{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-tour-check{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-adjust-value{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-case-wrap-up{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-investment-account{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-store{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-slider{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-output{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-medication-ingredient{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-store-group{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-all{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-service-territory-policy{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-slack-conversations{
  --slds-c-icon-color-background:rgb(72, 26, 84);
}
.slds-icon-standard-picklist-choice{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-choice{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-funding-requirement{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-your-account{
  --slds-c-icon-color-background:rgb(1, 68, 134);
}
.slds-icon-standard-app{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-default{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-case-milestone{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-operation-plan{
  --slds-c-icon-color-background:rgb(90, 27, 169);
}
.slds-icon-standard-today{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-buyer-account{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-lead-list{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-list-rate{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-work-plan-template{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-tableau{
  --slds-c-icon-color-background:rgb(15, 30, 60);
}
.slds-icon-standard-shift{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-people-score{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-product-item-transaction{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-person-language{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-apex{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-reply-text{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-answer-private{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-immunization{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-asset-downtime-period{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-opportunity-contact-role{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-retail-banking-console{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-channel-program-members{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-apps-admin{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-metric-definition{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-datadotcom{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-settings{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-network-contract{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-crypto-transaction-envelope-item{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-product-item{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-metrics{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-topic2{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-partner-fund-allocation{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-care-request-reviewer{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-indicator-definition{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-crypto-transaction-envelope-change-snapshot{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-standard-operation-plan-step-execution{
  --slds-c-icon-color-background:rgb(90, 27, 169);
}
.slds-icon-standard-approval{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-work-queue{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-iot-orchestrations{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-visualforce-page{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-person-account{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-entity{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-dynamic-highlights-panel{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-service-territory-location{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-qualifications{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-document-preview{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-tax-treatment{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-entitlement-policy{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-form{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-query-editor{
  --slds-c-icon-color-background:rgb(126, 38, 0);
}
.slds-icon-standard-visualization{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-products{
  --slds-c-icon-color-background:rgb(90, 27, 169);
}
.slds-icon-standard-prompt{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-order-item{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-read-receipts{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-javascript-button{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-maintenance-asset{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-work-plan-rule{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-loop{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-portal-roles-and-subordinates{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-work-capacity-limit{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-employee-organization{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-workforce-engagement{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-constant{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-marketing-actions{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-case-transcript{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-list-fee{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-timesheet-entry{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-key-dates{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-multi-picklist{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-facility-bed{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-product-workspace{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-visit-templates{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-restriction-policy{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-task{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-scheduling-workspace-territory{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-answer-best{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-attach{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-asset-action{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-section{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-service-request{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-orders{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-propagation-policy{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-budget{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-report-type{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-past-chat{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-crypto-transaction-envelope-change-log{
  --slds-c-icon-color-background:rgb(8, 73, 104);
}
.slds-icon-standard-feedback{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-action-list-component{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-opportunity-splits{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-location-permit{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-app-form-product-participant{
  --slds-c-icon-color-background:rgb(126, 38, 0);
}
.slds-icon-standard-messaging-user{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-filter-criteria{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-tax-policy{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-trailhead{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-entitlements{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-checkout{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-formula{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-case-log-a-call{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-shift-pattern-entry{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-thanks-loading{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-job-family{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-service-appointment-capacity-usage{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-inbox{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-channel-program-levels{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-letterhead{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-promotions-workspace{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-nft-settings{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-asset-hierarchy{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-email-chatter{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-custody-chain-entry{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-document-reference{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-announcement{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-field-sales{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-bot{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-macros{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-dashboard-ea{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-job-profile{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-steps{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-snippet-alt{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-asset-relationship{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-high-velocity-sales{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-brand{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-historical-adherence{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-visits{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-einstein-replies{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-coaching{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-record-lookup{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-product-service-campaign-item{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-scheduling-constraint{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-lightning-component{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-search{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-connected-apps{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-swarm-request{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-work-type-group{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-education{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-work-type{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-travel-mode{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-environment-hub{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-identifier{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-cms{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-call-coaching{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-salesforce-cms{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-price-sheet{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-thanks{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-service-territory-member{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-work-forecast{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-crypto-product-category-wallet-role{
  --slds-c-icon-color-background:rgb(5, 103, 100);
}
.slds-icon-standard-program-cohort-member{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-holiday-operating-hours{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-uploaded-model{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-user-role{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-observation-component{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-orchestrator{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-work-capacity-usage{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-record-create{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-campaign-members{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-retail-banking{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-product-service-campaign{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-portal-roles{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-operation-plan-step{
  --slds-c-icon-color-background:rgb(90, 27, 169);
}
.slds-icon-standard-calibration{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-answer-public{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-robot{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-display-text{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-product-consumed-state{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-budget-category-value{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-scheduling-workspace{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-unmatched{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-partners{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-email-iq{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-mulesoft{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-service-crew{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-payment-gateway{
  --slds-c-icon-color-background:rgb(5, 103, 100);
}
.slds-icon-standard-voice-call{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-cancel-checkout{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-asset-warranty{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-resource-capacity{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-repeaters{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-setup-modal{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-channel-programs{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-quip{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-quip-sheet{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-timeslot{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-live-chat{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-service-request-detail{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-med-rec-statement-recommendation{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-job-position{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-sobject-collection{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-user{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-client{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-screen{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-portal{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-partner-fund-request{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-asset-audit{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-resource-preference{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-record-consent{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-first-non-empty{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-rate-adjustment{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-impact-strategy{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-customer-360{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-employee-job{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-resource-absence{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-registered-model{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-panel-detail{
  --slds-c-icon-color-background:rgb(8, 73, 104);
}
.slds-icon-standard-text-template{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-entitlement-template{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-lightning-usage{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-volume-discounts{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-indicator-result{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-product-transfer-state{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-medication-dispense{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-entitlement{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-empty{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-text{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-delegated-account{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-fulfillment-order{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-case-email{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-account{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-coupon-codes{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-assignment{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-wealth-management-console{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-task2,
.slds-icon-standard-task-2{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-patient-medication-dosage{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-code-playground{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-social{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-endorsement{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-folder{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-service-crew-member{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-variation-attribute-setup{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-real-time{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-connect-wallet{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-flow{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-recipe{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-expense-report-entry{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-employee{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-omni-supervisor{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-capacity-plan{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-asset-object{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-product{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-crypto-transaction-envelope{
  --slds-c-icon-color-background:rgb(5, 103, 100);
}
.slds-icon-standard-topic{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-product-required{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-dynamic-record-choice{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-aggregation-policy{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-warranty-term{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-process{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-swarm-session{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-people{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-medication{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-reward{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-employee-contact{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-bundle-policy{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-performance{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-promotions{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-case-comment{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-price-book-entries{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-sales-channel{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-apex-plugin{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-party-profile{
  --slds-c-icon-color-background:rgb(90, 27, 169);
}
.slds-icon-standard-campaign{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-contact-request{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-business-hours{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-metric{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-evernote{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-variation-products{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-program-cohort{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-trailhead-alt{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-service-territory{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-customer-lifecycle-analytics{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-code-set{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-case{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-slack{
  --slds-c-icon-color-background:rgb(74, 21, 75);
}
.slds-icon-standard-currency{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-record{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-code-set-bundle{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-queue{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-schedule-objective{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-contract-line-item{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-skill-entity{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-funding-award-adjustment{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-skill{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-operating-hours{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-crypto-product{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-taxonomy{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-operation-plan-request{
  --slds-c-icon-color-background:rgb(90, 27, 169);
}
.slds-icon-standard-custom{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-related-list{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-bot-training{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-case-change-status{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-insurance-console{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-dashboard-component{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-incident{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-contract{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-policy{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-sobject{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-whatsapp{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-sales-cadence-target{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-photo{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-apps{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-timesheet{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-drafts{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-outcome{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-discounts{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-work-order-item{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-pricebook{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-scan-card{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-note{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-serialized-product-transaction{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-shift-pattern{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-buyer-group{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-price-adjustment-schedule{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-product-quantity-rules{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-medication-reconciliation{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-procedure{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-opportunity{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-news{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-sort-policy{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-display-rich-text{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-strategy{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-time-period{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-call-history{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-webcart{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-serialized-product{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-tax-rate{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-report{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-customer-workspace{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-groups{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-data-model{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-dashboard{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-generic-loading{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-number-input{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-toggle{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-address{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-price-books{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-entity-milestone{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-contract-line-outcome{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-wealth-management{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-customers{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-disclosure-and-compliance{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-workspace{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-story{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-service-appointment{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-maintenance-plan{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-contract-line-outcome-data{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-data-integration-hub{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-person-name{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-work-plan-template-entry{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-hierarchy{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-custom-component-task{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-partner-marketing-budget{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-asset-action-source{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-skill-requirement{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-filter-criteria-rule{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-no-code-model{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-location{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-promotion-tiers{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-radio-button{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-avatar-loading{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-article{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-custody-entry-verification{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-learner-program{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-invocable-action{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-device{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-app-form-participant{
  --slds-c-icon-color-background:rgb(5, 103, 100);
}
.slds-icon-standard-proposition{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-snippets{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-customer-portal-users{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-cost-model{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-path-experiment{
  --slds-c-icon-color-background:rgb(221, 122, 1);
}
.slds-icon-standard-actions-and-buttons{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-record-update{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-shift-type{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-water{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-log-a-call{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-crypto-wallet{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-crypto-wallet-group{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-quotes{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-data-governance{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-question-feed{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-attribute-based-pricing{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-walkthroughs{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-kanban{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-work-plan{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-shift-template{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-merge{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-expense{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-dataset{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-work-summary{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-shift-preference{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-product-consumed{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-canvas{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-bundles-pricing{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-forecasts{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-relationship{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-tour{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-service-resource{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-filter{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-sales-path{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-shift-scheduling-operation{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-data-graph{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-data-lake-objects{
  --slds-c-icon-color-background:rgb(90, 27, 169);
}
.slds-icon-standard-events{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-data-mapping{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-sms{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-impact-outcome{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-rtc-presence{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-avatar{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-record-delete{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-solution{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-nft-studio{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-manual-discounts{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-agent-home{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-linked{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-partner-fund-claim{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-individual{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-custom-notification{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-contract-payment{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-date-input{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-catalog{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-template{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-activation-target{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-standard-selling-model{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-shipment{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-budget-allocation{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-custody-override{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-record-signature-task{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-event{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-standard-insurance{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-live-chat-visitor{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-textarea{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-work-step{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-picklist-type{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-survey{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-operation-plan-execution{
  --slds-c-icon-color-background:rgb(90, 27, 169);
}
.slds-icon-standard-link{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-messaging-session{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-video{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-list-email{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-med-rec-recommendation{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-crypto-wallet-group-item{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-recycle-bin{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-document{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-product-transfer{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-instore-locations{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-recent{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-practitioner-role{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-password{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-datashare-target{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-expense-report{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-branch-merge{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-ai-accelerator-card{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-insights{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-standard-budget-period{
  --slds-c-icon-color-background:rgb(150, 2, 199);
}
.slds-icon-standard-market{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-dropbox{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-unified-health-score{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-bill-of-materials{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-calculated-insights{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-employee-job-position{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-file{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-outcome-activity{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-currency-input{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-data-transforms{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-variable{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-team-member{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-pricing-workspace{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-agent-session{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-guidance-center{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-crypto-category-wallet-group{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-group-loading{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-lead{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-email{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-service-contract{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-decision{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-promotion-segments{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-duration-downscale{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-snippet{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-entitlement-process{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-price-adjustment-matrix{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-contact-list{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-planogram{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-activations{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-scheduling-policy{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-channel-program-history{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-question-best{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-omni-channel{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-collection-variable{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-indicator-assignment{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-procedure-detail{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-sales-value{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-knowledge{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-standard-datashares{
  --slds-c-icon-color-background:rgb(150, 2, 199);
}
.slds-icon-standard-date-time{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-category{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-maintenance-work-rule{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-data-streams{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-textbox{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-standard-lead-insights{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-waits{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-concur{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-feed{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-sort{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-messaging-conversation{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-service-report{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-standard-iot-context{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-price-adjustment-tier{
  --slds-c-icon-color-background:rgb(3, 45, 96);
}
.slds-icon-standard-asset-state-period{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-call{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-collection{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-stage{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-sales-cadence{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-product-request-line-item{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-return-order-line-item{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-chart{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-customer{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-buyer-group-qualifier{
  --slds-c-icon-color-background:rgb(57, 101, 71);
}
.slds-icon-standard-quick-text{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-home{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-standard-sossession{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-digital-verification-config{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-aggregate{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-bundle-config{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-title-party{
  --slds-c-icon-color-background:rgb(5, 103, 100);
}
.slds-icon-standard-employee-asset{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-process-exception{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-product-warranty-term{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-standard-problem{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-stage-collection{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-product-request{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-logging{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-digital-verification-config-group{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-assigned-resource{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-return-order{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-poll{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-household{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-work-step-template{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-standard-medication-statement{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-labels{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-ad-event-action{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-ad-event-cause{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-ad-event-effect{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-ad-event-factor{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-standard-ad-event-info{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-ad-event-outcome{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-ad-event-party{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-standard-adverse-event{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-billing{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-calculated-dimension{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-calculated-measure{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-disease-definition-criteria{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-disease-investigation{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-disease-outbreak{
  --slds-c-icon-color-background:rgb(182, 5, 84);
}
.slds-icon-standard-edit-form{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-enrollee-status{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-eval-result{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-event-ext{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-life-sciences{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-map-line-item{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-medication-administration{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-member-period{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-patient-service{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-procedure-output-resolution{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-program-detail{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-program-site{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-program-status{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-prospect{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-replace{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-reset-password{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-send-log{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-study{
  --slds-c-icon-color-background:rgb(47, 44, 183);
}
.slds-icon-standard-study-candidate{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-study-related{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-sub-metric{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-summary-liable{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-summary-usage{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-table{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-transaction-usage-entitlement{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-usage-entitlement-account{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-usage-entitlement-bucket{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-standard-usage-entitlement-entry{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-standard-usage-ratable-summary{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-custom-custom110,
.slds-icon-custom-110{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom100,
.slds-icon-custom-100{
  --slds-c-icon-color-background:rgb(225, 93, 118);
}
.slds-icon-custom-custom111,
.slds-icon-custom-111{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom1,
.slds-icon-custom-1{
  --slds-c-icon-color-background:rgb(255, 123, 132);
}
.slds-icon-custom-custom101,
.slds-icon-custom-101{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom112,
.slds-icon-custom-112{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom2,
.slds-icon-custom-2{
  --slds-c-icon-color-background:rgb(207, 208, 92);
}
.slds-icon-custom-custom102,
.slds-icon-custom-102{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom113,
.slds-icon-custom-113{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom90,
.slds-icon-custom-90{
  --slds-c-icon-color-background:rgb(34, 164, 138);
}
.slds-icon-custom-custom3,
.slds-icon-custom-3{
  --slds-c-icon-color-background:rgb(236, 180, 108);
}
.slds-icon-custom-custom103,
.slds-icon-custom-103{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom80,
.slds-icon-custom-80{
  --slds-c-icon-color-background:rgb(101, 154, 213);
}
.slds-icon-custom-custom91,
.slds-icon-custom-91{
  --slds-c-icon-color-background:rgb(191, 123, 102);
}
.slds-icon-custom-custom4,
.slds-icon-custom-4{
  --slds-c-icon-color-background:rgb(225, 217, 81);
}
.slds-icon-custom-custom104,
.slds-icon-custom-104{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom70,
.slds-icon-custom-70{
  --slds-c-icon-color-background:rgb(231, 105, 180);
}
.slds-icon-custom-custom81,
.slds-icon-custom-81{
  --slds-c-icon-color-background:rgb(218, 98, 127);
}
.slds-icon-custom-custom92,
.slds-icon-custom-92{
  --slds-c-icon-color-background:rgb(81, 126, 130);
}
.slds-icon-custom-custom5,
.slds-icon-custom-5{
  --slds-c-icon-color-background:rgb(159, 219, 102);
}
.slds-icon-custom-custom105,
.slds-icon-custom-105{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom60,
.slds-icon-custom-60{
  --slds-c-icon-color-background:rgb(191, 90, 136);
}
.slds-icon-custom-custom71,
.slds-icon-custom-71{
  --slds-c-icon-color-background:rgb(227, 110, 227);
}
.slds-icon-custom-custom82,
.slds-icon-custom-82{
  --slds-c-icon-color-background:rgb(209, 91, 151);
}
.slds-icon-custom-custom93,
.slds-icon-custom-93{
  --slds-c-icon-color-background:rgb(144, 77, 76);
}
.slds-icon-custom-custom6,
.slds-icon-custom-6{
  --slds-c-icon-color-background:rgb(84, 196, 115);
}
.slds-icon-custom-custom106,
.slds-icon-custom-106{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom50,
.slds-icon-custom-50{
  --slds-c-icon-color-background:rgb(73, 188, 211);
}
.slds-icon-custom-custom61,
.slds-icon-custom-61{
  --slds-c-icon-color-background:rgb(245, 115, 118);
}
.slds-icon-custom-custom72,
.slds-icon-custom-72{
  --slds-c-icon-color-background:rgb(141, 155, 251);
}
.slds-icon-custom-custom83,
.slds-icon-custom-83{
  --slds-c-icon-color-background:rgb(231, 128, 111);
}
.slds-icon-custom-custom94,
.slds-icon-custom-94{
  --slds-c-icon-color-background:rgb(67, 156, 186);
}
.slds-icon-custom-custom7,
.slds-icon-custom-7{
  --slds-c-icon-color-background:rgb(106, 137, 229);
}
.slds-icon-custom-custom107,
.slds-icon-custom-107{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom40,
.slds-icon-custom-40{
  --slds-c-icon-color-background:rgb(131, 199, 94);
}
.slds-icon-custom-custom51,
.slds-icon-custom-51{
  --slds-c-icon-color-background:rgb(216, 199, 96);
}
.slds-icon-custom-custom62,
.slds-icon-custom-62{
  --slds-c-icon-color-background:rgb(107, 146, 220);
}
.slds-icon-custom-custom73,
.slds-icon-custom-73{
  --slds-c-icon-color-background:rgb(103, 158, 240);
}
.slds-icon-custom-custom84,
.slds-icon-custom-84{
  --slds-c-icon-color-background:rgb(246, 112, 123);
}
.slds-icon-custom-custom95,
.slds-icon-custom-95{
  --slds-c-icon-color-background:rgb(139, 207, 106);
}
.slds-icon-custom-custom8,
.slds-icon-custom-8{
  --slds-c-icon-color-background:rgb(80, 206, 185);
}
.slds-icon-custom-custom108,
.slds-icon-custom-108{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom30,
.slds-icon-custom-30{
  --slds-c-icon-color-background:rgb(245, 159, 113);
}
.slds-icon-custom-custom41,
.slds-icon-custom-41{
  --slds-c-icon-color-background:rgb(67, 181, 181);
}
.slds-icon-custom-custom52,
.slds-icon-custom-52{
  --slds-c-icon-color-background:rgb(238, 142, 111);
}
.slds-icon-custom-custom63,
.slds-icon-custom-63{
  --slds-c-icon-color-background:rgb(124, 207, 96);
}
.slds-icon-custom-custom74,
.slds-icon-custom-74{
  --slds-c-icon-color-background:rgb(65, 200, 160);
}
.slds-icon-custom-custom85,
.slds-icon-custom-85{
  --slds-c-icon-color-background:rgb(242, 104, 145);
}
.slds-icon-custom-custom96,
.slds-icon-custom-96{
  --slds-c-icon-color-background:rgb(109, 157, 227);
}
.slds-icon-custom-custom9,
.slds-icon-custom-9{
  --slds-c-icon-color-background:rgb(107, 158, 226);
}
.slds-icon-custom-custom109,
.slds-icon-custom-109{
  --slds-c-icon-color-background:rgb(242, 139, 0);
}
.slds-icon-custom-custom20,
.slds-icon-custom-20{
  --slds-c-icon-color-background:rgb(72, 199, 200);
}
.slds-icon-custom-custom31,
.slds-icon-custom-31{
  --slds-c-icon-color-background:rgb(235, 104, 127);
}
.slds-icon-custom-custom42,
.slds-icon-custom-42{
  --slds-c-icon-color-background:rgb(207, 208, 91);
}
.slds-icon-custom-custom53,
.slds-icon-custom-53{
  --slds-c-icon-color-background:rgb(243, 110, 131);
}
.slds-icon-custom-custom64,
.slds-icon-custom-64{
  --slds-c-icon-color-background:rgb(97, 143, 216);
}
.slds-icon-custom-custom75,
.slds-icon-custom-75{
  --slds-c-icon-color-background:rgb(205, 159, 101);
}
.slds-icon-custom-custom86,
.slds-icon-custom-86{
  --slds-c-icon-color-background:rgb(226, 96, 171);
}
.slds-icon-custom-custom97,
.slds-icon-custom-97{
  --slds-c-icon-color-background:rgb(221, 96, 133);
}
.slds-icon-custom-custom10,
.slds-icon-custom-10{
  --slds-c-icon-color-background:rgb(100, 136, 227);
}
.slds-icon-custom-custom21,
.slds-icon-custom-21{
  --slds-c-icon-color-background:rgb(138, 122, 237);
}
.slds-icon-custom-custom32,
.slds-icon-custom-32{
  --slds-c-icon-color-background:rgb(56, 195, 147);
}
.slds-icon-custom-custom43,
.slds-icon-custom-43{
  --slds-c-icon-color-background:rgb(127, 147, 249);
}
.slds-icon-custom-custom54,
.slds-icon-custom-54{
  --slds-c-icon-color-background:rgb(234, 112, 177);
}
.slds-icon-custom-custom65,
.slds-icon-custom-65{
  --slds-c-icon-color-background:rgb(242, 121, 171);
}
.slds-icon-custom-custom76,
.slds-icon-custom-76{
  --slds-c-icon-color-background:rgb(219, 109, 122);
}
.slds-icon-custom-custom87,
.slds-icon-custom-87{
  --slds-c-icon-color-background:rgb(216, 118, 229);
}
.slds-icon-custom-custom98,
.slds-icon-custom-98{
  --slds-c-icon-color-background:rgb(225, 190, 92);
}
.slds-icon-custom-custom11,
.slds-icon-custom-11{
  --slds-c-icon-color-background:rgb(135, 132, 234);
}
.slds-icon-custom-custom22,
.slds-icon-custom-22{
  --slds-c-icon-color-background:rgb(139, 133, 249);
}
.slds-icon-custom-custom33,
.slds-icon-custom-33{
  --slds-c-icon-color-background:rgb(151, 207, 93);
}
.slds-icon-custom-custom44,
.slds-icon-custom-44{
  --slds-c-icon-color-background:rgb(200, 202, 88);
}
.slds-icon-custom-custom55,
.slds-icon-custom-55{
  --slds-c-icon-color-background:rgb(214, 110, 224);
}
.slds-icon-custom-custom66,
.slds-icon-custom-66{
  --slds-c-icon-color-background:rgb(216, 190, 95);
}
.slds-icon-custom-custom77,
.slds-icon-custom-77{
  --slds-c-icon-color-background:rgb(181, 93, 91);
}
.slds-icon-custom-custom88,
.slds-icon-custom-88{
  --slds-c-icon-color-background:rgb(153, 111, 230);
}
.slds-icon-custom-custom99,
.slds-icon-custom-99{
  --slds-c-icon-color-background:rgb(240, 133, 110);
}
.slds-icon-custom-custom12,
.slds-icon-custom-12{
  --slds-c-icon-color-background:rgb(220, 113, 209);
}
.slds-icon-custom-custom23,
.slds-icon-custom-23{
  --slds-c-icon-color-background:rgb(176, 112, 230);
}
.slds-icon-custom-custom34,
.slds-icon-custom-34{
  --slds-c-icon-color-background:rgb(213, 138, 106);
}
.slds-icon-custom-custom45,
.slds-icon-custom-45{
  --slds-c-icon-color-background:rgb(217, 88, 121);
}
.slds-icon-custom-custom56,
.slds-icon-custom-56{
  --slds-c-icon-color-background:rgb(113, 141, 235);
}
.slds-icon-custom-custom67,
.slds-icon-custom-67{
  --slds-c-icon-color-background:rgb(248, 125, 118);
}
.slds-icon-custom-custom78,
.slds-icon-custom-78{
  --slds-c-icon-color-background:rgb(90, 149, 221);
}
.slds-icon-custom-custom89,
.slds-icon-custom-89{
  --slds-c-icon-color-background:rgb(62, 153, 190);
}
.slds-icon-custom-custom13,
.slds-icon-custom-13{
  --slds-c-icon-color-background:rgb(223, 97, 132);
}
.slds-icon-custom-custom24,
.slds-icon-custom-24{
  --slds-c-icon-color-background:rgb(229, 103, 152);
}
.slds-icon-custom-custom35,
.slds-icon-custom-35{
  --slds-c-icon-color-background:rgb(233, 99, 126);
}
.slds-icon-custom-custom46,
.slds-icon-custom-46{
  --slds-c-icon-color-background:rgb(103, 165, 231);
}
.slds-icon-custom-custom57,
.slds-icon-custom-57{
  --slds-c-icon-color-background:rgb(90, 156, 221);
}
.slds-icon-custom-custom68,
.slds-icon-custom-68{
  --slds-c-icon-color-background:rgb(242, 105, 121);
}
.slds-icon-custom-custom79,
.slds-icon-custom-79{
  --slds-c-icon-color-background:rgb(142, 211, 99);
}
.slds-icon-custom-custom14,
.slds-icon-custom-14{
  --slds-c-icon-color-background:rgb(60, 194, 179);
}
.slds-icon-custom-custom25,
.slds-icon-custom-25{
  --slds-c-icon-color-background:rgb(228, 111, 190);
}
.slds-icon-custom-custom36,
.slds-icon-custom-36{
  --slds-c-icon-color-background:rgb(212, 114, 212);
}
.slds-icon-custom-custom47,
.slds-icon-custom-47{
  --slds-c-icon-color-background:rgb(95, 204, 100);
}
.slds-icon-custom-custom58,
.slds-icon-custom-58{
  --slds-c-icon-color-background:rgb(52, 181, 157);
}
.slds-icon-custom-custom69,
.slds-icon-custom-69{
  --slds-c-icon-color-background:rgb(237, 99, 135);
}
.slds-icon-custom-custom15,
.slds-icon-custom-15{
  --slds-c-icon-color-background:rgb(247, 126, 117);
}
.slds-icon-custom-custom26,
.slds-icon-custom-26{
  --slds-c-icon-color-background:rgb(118, 152, 240);
}
.slds-icon-custom-custom37,
.slds-icon-custom-37{
  --slds-c-icon-color-background:rgb(140, 137, 242);
}
.slds-icon-custom-custom48,
.slds-icon-custom-48{
  --slds-c-icon-color-background:rgb(239, 105, 127);
}
.slds-icon-custom-custom59,
.slds-icon-custom-59{
  --slds-c-icon-color-background:rgb(227, 208, 103);
}
.slds-icon-custom-custom16,
.slds-icon-custom-16{
  --slds-c-icon-color-background:rgb(233, 175, 103);
}
.slds-icon-custom-custom27,
.slds-icon-custom-27{
  --slds-c-icon-color-background:rgb(90, 176, 210);
}
.slds-icon-custom-custom38,
.slds-icon-custom-38{
  --slds-c-icon-color-background:rgb(83, 182, 215);
}
.slds-icon-custom-custom49,
.slds-icon-custom-49{
  --slds-c-icon-color-background:rgb(226, 92, 128);
}
.slds-icon-custom-custom17,
.slds-icon-custom-17{
  --slds-c-icon-color-background:rgb(172, 211, 96);
}
.slds-icon-custom-custom28,
.slds-icon-custom-28{
  --slds-c-icon-color-background:rgb(137, 192, 89);
}
.slds-icon-custom-custom39,
.slds-icon-custom-39{
  --slds-c-icon-color-background:rgb(79, 190, 117);
}
.slds-icon-custom-custom18,
.slds-icon-custom-18{
  --slds-c-icon-color-background:rgb(77, 202, 118);
}
.slds-icon-custom-custom29,
.slds-icon-custom-29{
  --slds-c-icon-color-background:rgb(189, 210, 95);
}
.slds-icon-custom-custom19,
.slds-icon-custom-19{
  --slds-c-icon-color-background:rgb(58, 190, 177);
}
.slds-icon-action-new-custom18{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom29{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-edit-groups{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-new-custom9{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-log-a-call{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-new-custom19{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-filter{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-user-activation{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-opportunity-competitor{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-canvas{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-change-record-type{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-new-notebook{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-docusign{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-share-link{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-add-file{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-edit-relationship{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-notebook{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-lead{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom-object{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-account{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-question-post-action{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-share-file{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-action-default-custom-object{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-opportunity-team-member{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-add-photo-video{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-sort{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-call{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-concur{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-reject{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-share-poll{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-scan-enabled{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-following{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-defer{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-opportunity-line-item{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-social-post{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-share-post{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-view-relationship{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-adjust-value{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-upload{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-remove-relationship{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-freeze-user{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-new-person-account{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-bug{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-apex{
  --slds-c-icon-color-background:rgb(92, 92, 92);
}
.slds-icon-action-new-opportunity{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-fallback{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-dial-in{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-approval{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-change-owner{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-new-task{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-priority{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-remove{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-web-link{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-leave-group{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-manage-perm-sets{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-close{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-google-news{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-announcement{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-back{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-new-custom90{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-download{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-new-custom80{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom91{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-action-search{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-event{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom70{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom81{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom92{
  --slds-c-icon-color-background:rgb(5, 103, 100);
}
.slds-icon-action-refresh{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-share-thanks{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-update{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-email{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-join-group{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom60{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom71{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-action-new-custom82{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom93{
  --slds-c-icon-color-background:rgb(92, 92, 92);
}
.slds-icon-action-edit{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-quote{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-dropbox{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-description{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-map{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-user{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-reset-password{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-new-custom50{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom61{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom72{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom83{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom94{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-clone{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-script{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-delete{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom40{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom51{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom62{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom73{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom84{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom95{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-scan-disabled{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-action-share{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-new-custom30{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom41{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-new-custom52{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom63{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom74{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-new-custom85{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom96{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-log-event{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-group{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom20{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-new-custom31{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom42{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-info{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-new-custom53{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom64{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom75{
  --slds-c-icon-color-background:rgb(147, 147, 147);
}
.slds-icon-action-new-custom86{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-flow{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-new-custom97{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-submit-for-approval{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-campaign{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom10{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom21{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom32{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-new-custom43{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom54{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom65{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom76{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom87{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-action-new-custom98{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-case{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom100{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom1{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-contact{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-action-office-365{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom11{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom22{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom33{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom44{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom55{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-action-new-custom66{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom77{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom88{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-action-new-custom99{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-add-contact{
  --slds-c-icon-color-background:rgb(144, 80, 233);
}
.slds-icon-action-evernote{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom2{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-lead-convert{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom12{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-action-new-custom23{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-action-new-custom34{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom45{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom56{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom67{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-recall{
  --slds-c-icon-color-background:rgb(8, 73, 104);
}
.slds-icon-action-new-custom78{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom89{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-follow{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-record{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom3{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-note{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom13{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom24{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom35{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom46{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom57{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom68{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom79{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-child-case{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom4{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom14{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-new-custom25{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom36{
  --slds-c-icon-color-background:rgb(203, 101, 255);
}
.slds-icon-action-new-custom47{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom58{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-new-custom69{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom5{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-goal{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom15{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom26{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom37{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom48{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom59{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom6{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-log-this-event{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom16{
  --slds-c-icon-color-background:rgb(255, 93, 45);
}
.slds-icon-action-new-custom27{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom38{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom49{
  --slds-c-icon-color-background:rgb(255, 83, 138);
}
.slds-icon-action-new-custom7{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-more{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-add-relationship{
  --slds-c-icon-color-background:rgb(27, 150, 255);
}
.slds-icon-action-new-custom17{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom28{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-new-custom39{
  --slds-c-icon-color-background:rgb(59, 167, 85);
}
.slds-icon-action-password-unlock{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-check{
  --slds-c-icon-color-background:rgb(16, 124, 173);
}
.slds-icon-action-update-status{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-icon-action-preview{
  --slds-c-icon-color-background:rgb(88, 103, 232);
}
.slds-icon-action-new-custom8{
  --slds-c-icon-color-background:rgb(6, 165, 154);
}
.slds-timeline__item_expandable,.slds-timeline__item--expandable{
  position:relative;
  padding-block-end:var(--slds-g-spacing-4);
}
.slds-timeline__item_expandable .slds-media__figure,.slds-timeline__item--expandable .slds-media__figure{
  margin-inline-end:var(--slds-g-spacing-1);
  z-index:1;
}
.slds-timeline__item_expandable .slds-media__figure .slds-button_icon,.slds-timeline__item--expandable .slds-media__figure .slds-button--icon{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-timeline__item_expandable .slds-media__body,.slds-timeline__item--expandable .slds-media__body{
  padding-block:0;
  padding-inline:var(--slds-g-spacing-1);
}
.slds-timeline__item_expandable .slds-checkbox,.slds-timeline__item--expandable .slds-checkbox{
  margin-inline-end:var(--slds-g-spacing-1);
}
.slds-timeline__item_expandable .slds-timeline__actions_inline,.slds-timeline__item--expandable .slds-timeline__actions--inline{
  flex-flow:row nowrap;
  align-items:center;
  flex-shrink:0;
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-timeline__item_expandable .slds-timeline__actions_inline .slds-timeline__date,.slds-timeline__item--expandable .slds-timeline__actions--inline .slds-timeline__date{
  padding-inline-end:var(--slds-g-spacing-2);
  margin-block-end:0;
}
.slds-timeline__item_expandable .slds-timeline__item_details,.slds-timeline__item--expandable .slds-timeline__item--details{
  visibility:hidden;
  opacity:0;
  height:0;
  padding:0;
}
.slds-timeline__item_expandable.slds-is-open .slds-timeline__item_details,.slds-timeline__item--expandable.slds-is-open .slds-timeline__item--details{
  visibility:visible;
  opacity:1;
  height:auto;
  padding:var(--slds-g-spacing-4);
}
.slds-timeline__item_expandable.slds-is-open .slds-timeline__details-action-icon,.slds-timeline__item--expandable.slds-is-open .slds-timeline__details-action-icon{
  transform:rotate(0);
  transform-origin:45%;
}
.slds-timeline__item_expandable::before,.slds-timeline__item--expandable::before{
  content:'';
  background:var(--slds-g-color-border-1);
  height:100%;
  width:var(--slds-g-sizing-border-2);
  position:absolute;
  inset-inline-start:2.235rem;
  inset-block-start:0;
  inset-block-end:0;
  margin-inline-start:var(--slds-g-sizing-border-2);
}
.slds-timeline__item_call::before,.slds-timeline__item--call::before{
  background:rgb(72, 195, 204);
}
.slds-timeline__item_email::before,.slds-timeline__item--email::before{
  background:rgb(147, 147, 147);
}
.slds-timeline__item_event::before,.slds-timeline__item--event::before{
  background:rgb(203, 101, 255);
}
.slds-timeline__item_task::before,.slds-timeline__item--task::before{
  background:rgb(75, 192, 118);
}
.slds-timeline__trigger{
  padding:var(--slds-g-spacing-1);
}
.slds-timeline__trigger:hover{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-timeline__icon{
  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-surface-1);
}
.slds-timeline__actions{
  display:flex;
  flex-flow:column nowrap;
  align-items:flex-end;
}
.slds-timeline__date{
  margin-block-end:var(--slds-g-spacing-1);
  font-size:var(--slds-g-font-scale-neg-3);
  color:var(--slds-g-color-on-surface-2);
}
.slds-timeline__details-action-icon{
  transform:rotate(-90deg);
}
.slds-button-group,
.slds-button-group-list{
  display:inline-flex;
}
.slds-button-group .slds-button, .slds-button-group-list .slds-button{
  border-radius:0;
  border-width:var(--slds-g-sizing-border-1);
}
.slds-button-group .slds-button:focus, .slds-button-group-list .slds-button:focus{
  z-index:1;
}
.slds-button-group .slds-button + .slds-button,
.slds-button-group .slds-button + .slds-button_last .slds-button,
.slds-button-group .slds-button + .slds-button--last .slds-button,
.slds-button-group-list li + li .slds-button{
  margin-inline-start:calc(-1 * var(--slds-g-sizing-border-1));
}
.slds-button-group .slds-button_brand + .slds-button_last .slds-button_icon-brand,.slds-button-group .slds-button--brand + .slds-button--last .slds-button--icon-brand,
.slds-button-group-list li:last-child .slds-button_icon-brand,
.slds-button-group-list li:last-child .slds-button--icon-brand{
  box-shadow:inset 1px 0 0 var(--slds-g-color-neutral-base-100);
}
.slds-button-group-list li:first-child .slds-button,
.slds-button-group .slds-button:first-child{
  border-start-start-radius:var(--slds-s-button-radius-border);
  border-start-end-radius:0;
  border-end-start-radius:var(--slds-s-button-radius-border);
  border-end-end-radius:0;
}
.slds-button-group .slds-button:last-child,
.slds-button-group-list li:last-child .slds-button,
.slds-button-group .slds-button_last .slds-button,
.slds-button-group .slds-button--last .slds-button,
.slds-button-group .slds-button.slds-button_last,
.slds-button-group .slds-button.slds-button--last,
.slds-button-group .slds-button_last .slds-button:only-child,
.slds-button-group .slds-button--last .slds-button:only-child{
  border-start-start-radius:0;
  border-start-end-radius:var(--slds-s-button-radius-border);
  border-end-start-radius:0;
  border-end-end-radius:var(--slds-s-button-radius-border);
}
.slds-button-group .slds-button:only-child,
.slds-button-group-list li:only-child .slds-button{
  border-radius:var(--slds-s-button-radius-border);
}
.slds-button.slds-button_first.slds-button_first,.slds-button.slds-button--first.slds-button--first{
  border-inline-end:0;
  border-start-start-radius:var(--slds-s-button-radius-border);
  border-start-end-radius:0;
  border-end-start-radius:var(--slds-s-button-radius-border);
  border-end-end-radius:0;
}
.slds-button.slds-button_middle.slds-button_middle,.slds-button.slds-button--middle.slds-button--middle{
  border-radius:0;
  margin-inline-start:calc(var(--slds-g-sizing-border-1) * -1);
}
.slds-button.slds-button_last.slds-button_last,.slds-button.slds-button--last.slds-button--last{
  border-start-start-radius:0;
  border-start-end-radius:var(--slds-s-button-radius-border);
  border-end-start-radius:0;
  border-end-end-radius:var(--slds-s-button-radius-border);
  margin-inline-start:calc(
    var(--slds-g-sizing-border-1) * -1
  );
}
.slds-button-group + .slds-button-group,
.slds-button-group + .slds-button-group-list,
.slds-button-group + .slds-button,
.slds-button-group-list + .slds-button-group-list,
.slds-button-group-list + .slds-button-group,
.slds-button-group-list + .slds-button{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-button-group-row{
  display:inline-flex;
}
.slds-button-group-row .slds-button-group-item + .slds-button-group-item{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-button-group-row .slds-button-group-item .slds-button{
  margin:0;
}
.slds-button{
  position:relative;
  display:inline-flex;
  align-items:center;
  padding-block-start:var(--slds-c-button-spacing-blockstart);
  padding-inline-end:var(--slds-c-button-spacing-inlineend);
  padding-block-end:var(--slds-c-button-spacing-blockend);
  padding-inline-start:var(--slds-c-button-spacing-inlinestart);
  background:none;
  background-color:var(--slds-c-button-color-background);
  background-clip:border-box;
  border-color:var(--slds-c-button-color-border, transparent);
  border-style:solid;
  border-width:var(--slds-c-button-sizing-border, var(--slds-g-sizing-border-1));
  border-radius:var(
    --slds-c-button-radius-border,
    var(--slds-s-button-radius-border, var(--slds-g-radius-border-2))
  );
  box-shadow:var(--slds-c-button-shadow, var(--slds-s-button-shadow));
  line-height:1.875rem;
  text-decoration:none;
  color:var(--slds-c-button-text-color, var(--slds-s-button-color, var(--slds-g-color-accent-2)));
  appearance:none;
  white-space:normal;
  -webkit-user-select:none;
          user-select:none;
  font-family:inherit;
}
.slds-button:hover,
.slds-button:focus-visible,
.slds-button:active,
.slds-button:visited{
  text-decoration:none;
}
.slds-button:hover,
.slds-button:focus-visible{
  --slds-c-button-color-border:var(
    --slds-c-button-color-border-hover,
    var(--slds-s-button-color-border-hover)
  );
  --slds-c-button-color-background:var(
    --slds-c-button-color-background-hover,
    var(--slds-s-button-color-background-hover, revert)
  );

  color:var(
    --slds-c-button-text-color-hover,
    var(--slds-s-button-color-hover, var(--slds-g-color-accent-3))
  );
  box-shadow:var(--slds-s-button-shadow-hover, revert);
}
.slds-button:focus-visible{
  box-shadow:var(--slds-c-button-shadow-focus, var(--slds-s-button-shadow-focus));
  outline:0;
}
.slds-button:active{
  color:var(--slds-c-button-text-color-active, var(--slds-g-color-accent-3));
  box-shadow:var(--slds-s-button-shadow-active, revert);

  --slds-c-button-color-background:var(--slds-c-button-color-background-active, revert);
  --slds-c-button-color-border:var(--slds-c-button-color-border-active, revert);
}
.slds-button[disabled],
.slds-button:disabled{
  background-color:transparent;
  border-color:transparent;
  color:var(--slds-g-color-disabled-1);
  cursor:default;
  pointer-events:none;
}
.slds-button[disabled] *, .slds-button:disabled *{
  pointer-events:none;
}
.slds-button a{
  --slds-c-button-text-color:currentColor;
}
.slds-button:hover .slds-button__icon, .slds-button:focus-visible .slds-button__icon, .slds-button:active .slds-button__icon, .slds-button[disabled] .slds-button__icon, .slds-button:disabled .slds-button__icon{
  fill:currentColor;
  pointer-events:none;
}
.slds-button + .slds-button-group,
.slds-button + .slds-button-group-list{
  margin-inline-start:var(--slds-g-spacing-1);
}
.slds-button + .slds-button{
  margin-inline-start:var(--slds-g-spacing-1);
}
.slds-button_neutral,.slds-button--neutral{
  justify-content:center;
  --slds-c-button-color-background:var(
    --slds-c-button-neutral-color-background,
    var(--slds-g-color-surface-container-1)
  );
  --slds-c-button-color-border:var(--slds-c-button-neutral-color-border, var(--slds-g-color-border-2));
  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);
  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);
}
.slds-button_neutral:hover,.slds-button--neutral:hover,
.slds-button_neutral:focus-visible,
.slds-button--neutral:focus-visible{
  --slds-c-button-color-background-hover:var(
    --slds-c-button-neutral-color-background-hover,
    var(--slds-g-color-surface-container-2, revert)
  );
  --slds-c-button-color-border-hover:var(
    --slds-c-button-neutral-color-border-hover,
    var(--slds-g-color-border-2, revert)
  );
}
.slds-button_neutral:active,.slds-button--neutral:active{
  --slds-c-button-color-background-active:var(
    --slds-c-button-neutral-color-background-active,
    var(--slds-g-color-surface-container-2, revert)
  );
  --slds-c-button-color-border-active:var(
    --slds-c-button-neutral-color-border-active,
    var(--slds-g-color-border-2, revert)
  );
}
.slds-button_neutral[disabled],.slds-button--neutral[disabled],
.slds-button_neutral:disabled,
.slds-button--neutral:disabled{
  background-color:var(--slds-g-color-disabled-container-1);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-1);
}
.slds-button_brand,.slds-button--brand{
  justify-content:center;
  --slds-c-button-color-background:var(
    --slds-c-button-brand-color-background,
    var(--slds-g-color-accent-container-1)
  );
  --slds-c-button-color-border:var(--slds-c-button-brand-color-border, var(--slds-g-color-border-accent-1));
  --slds-c-button-text-color:var(--slds-c-button-brand-text-color, var(--slds-g-color-on-accent-1));
  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);
  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);
}
.slds-button_brand:hover,.slds-button--brand:hover,
.slds-button_brand:focus-visible,
.slds-button--brand:focus-visible{
  --slds-c-button-color-background-hover:var(
    --slds-c-button-brand-color-background-hover,
    var(--slds-g-color-accent-container-2)
  );
  --slds-c-button-color-border-hover:var(
    --slds-c-button-brand-color-border-hover,
    var(--slds-g-color-accent-container-2)
  );
  --slds-c-button-text-color-hover:var(
    --slds-c-button-brand-text-color-hover,
    var(--slds-g-color-on-accent-1)
  );
}
.slds-button_brand:active,.slds-button--brand:active{
  --slds-c-button-color-background-active:var(
    --slds-c-button-brand-color-background-active,
    var(--slds-g-color-accent-container-2)
  );
  --slds-c-button-color-border-active:var(--slds-g-color-border-accent-2);
  --slds-c-button-text-color-active:var(
    --slds-c-button-brand-text-color-active,
    var(--slds-g-color-on-accent-1)
  );
}
.slds-button_brand[disabled],.slds-button--brand[disabled],
.slds-button_brand:disabled,
.slds-button--brand:disabled{
  background-color:var(--slds-g-color-disabled-container-2);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-2);
}
.slds-button_outline-brand,.slds-button--outline-brand{
  justify-content:center;
  --slds-c-button-color-background:var(--slds-g-color-surface-container-1);
  --slds-c-button-color-border:var(--slds-g-color-border-accent-1);
  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);
  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);
}
.slds-button_outline-brand:hover,.slds-button--outline-brand:hover,
.slds-button_outline-brand:focus-visible,
.slds-button--outline-brand:focus-visible{
  --slds-c-button-color-background-hover:var(--slds-g-color-surface-container-2);
  --slds-c-button-color-border-hover:var(--slds-g-color-border-accent-1);
}
.slds-button_outline-brand:active,.slds-button--outline-brand:active{
  --slds-c-button-color-background-active:var(--slds-g-color-surface-container-2);
  --slds-c-button-color-border-active:var(--slds-g-color-border-accent-1);
}
.slds-button_outline-brand[disabled],.slds-button--outline-brand[disabled],
.slds-button_outline-brand:disabled,
.slds-button--outline-brand:disabled{
  background-color:var(--slds-g-color-disabled-container-1);
  border-color:var(--slds-g-color-border-disabled-1);
}
.slds-button_inverse,.slds-button--inverse{
  justify-content:center;
  --slds-c-button-color-background:var(--slds-c-button-inverse-color-background, transparent);
  --slds-c-button-color-border:var(
    --slds-c-button-inverse-color-border,
    var(--slds-g-color-border-inverse-1)
  );
  --slds-c-button-text-color:var(
    --slds-c-button-inverse-text-color,
    var(--slds-g-color-on-surface-inverse-1)
  );
  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);
  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);
}
.slds-button_inverse:hover,.slds-button--inverse:hover,
.slds-button_inverse:focus-visible,
.slds-button--inverse:focus-visible{
  --slds-c-button-color-background-hover:var(
    --slds-c-button-inverse-color-background-hover,
    var(--slds-g-color-surface-container-2)
  );
  --slds-c-button-color-border-hover:var(
    --slds-c-button-inverse-color-border-hover,
    var(--slds-g-color-border-inverse-1)
  );
}
.slds-button_inverse:active,.slds-button--inverse:active{
  --slds-c-button-color-background-active:var(
    --slds-c-button-inverse-color-background-active,
    var(--slds-g-color-surface-container-2)
  );
  --slds-c-button-color-border-active:var(
    --slds-c-button-inverse-color-border-active,
    var(--slds-g-color-border-inverse-2)
  );
}
.slds-button_inverse[disabled],.slds-button--inverse[disabled],
.slds-button_inverse:disabled,
.slds-button--inverse:disabled{
  background-color:transparent;
  border-color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 50%);
}
.slds-button_inverse:link,.slds-button--inverse:link,
.slds-button_inverse:visited,
.slds-button--inverse:visited,
.slds-button_icon-border-inverse:link,
.slds-button--icon-border-inverse:link,
.slds-button_icon-border-inverse:visited,
.slds-button--icon-border-inverse:visited{
  --slds-c-button-text-color:var(
    --slds-c-button-inverse-text-color,
    var(--slds-g-color-on-surface-inverse-1)
  );
}
.slds-button_inverse:hover,.slds-button--inverse:hover,
.slds-button_inverse:focus-visible,
.slds-button--inverse:focus-visible,
.slds-button_icon-border-inverse:hover,
.slds-button--icon-border-inverse:hover,
.slds-button_icon-border-inverse:focus-visible,
.slds-button--icon-border-inverse:focus-visible{
  --slds-c-button-text-color-hover:var(
    --slds-c-button-inverse-text-color-hover,
    var(--slds-g-color-accent-3)
  );
}
.slds-button_inverse:focus-visible,.slds-button--inverse:focus-visible, .slds-button_icon-border-inverse:focus-visible, .slds-button--icon-border-inverse:focus-visible{
  --slds-c-button-shadow-focus:var(--slds-s-button-shadow-focus-inverse, var(--slds-g-shadow-inverse-1));
  --slds-c-button-color-border:var(--slds-g-color-border-inverse-1);

  outline:none;
}
.slds-button_inverse:active,.slds-button--inverse:active, .slds-button_icon-border-inverse:active, .slds-button--icon-border-inverse:active{
  --slds-c-button-text-color-active:var(
    --slds-c-button-inverse-text-color-active,
    var(--slds-g-color-accent-3)
  );
}
.slds-button_inverse[disabled],.slds-button--inverse[disabled],
.slds-button_inverse:disabled,
.slds-button--inverse:disabled,
.slds-button_icon-border-inverse[disabled],
.slds-button--icon-border-inverse[disabled],
.slds-button_icon-border-inverse:disabled,
.slds-button--icon-border-inverse:disabled{
  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 50%);
}
.slds-button_destructive,.slds-button--destructive{
  justify-content:center;
  --slds-c-button-color-background:var(--slds-g-color-error-container-1);
  --slds-c-button-color-border:var(--slds-g-color-border-error-1);
  --slds-c-button-text-color:var(--slds-g-color-on-error-1);
  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);
  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);
}
.slds-button_destructive:hover,.slds-button--destructive:hover,
.slds-button_destructive:focus-visible,
.slds-button--destructive:focus-visible{
  --slds-c-button-color-background-hover:var(--slds-g-color-error-container-2);
  --slds-c-button-color-border-hover:var(--slds-g-color-border-error-2);
  --slds-c-button-text-color-hover:var(--slds-g-color-on-error-1);
}
.slds-button_destructive:active,.slds-button--destructive:active{
  --slds-c-button-color-background-active:var(--slds-g-color-error-container-2);
  --slds-c-button-color-border-active:var(--slds-g-color-border-error-2);
  --slds-c-button-text-color-active:var(--slds-g-color-on-error-1);
}
.slds-button_destructive[disabled],.slds-button--destructive[disabled],
.slds-button_destructive:disabled,
.slds-button--destructive:disabled{
  background-color:var(--slds-g-color-disabled-container-2);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-2);
}
.slds-button_text-destructive,.slds-button--text-destructive{
  justify-content:center;
  --slds-c-button-color-background:var(--slds-g-color-surface-container-1);
  --slds-c-button-color-border:var(--slds-g-color-border-error-1);
  --slds-c-button-text-color:var(--slds-g-color-error-1);
  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);
  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);
}
.slds-button_text-destructive:hover,.slds-button--text-destructive:hover,
.slds-button_text-destructive:focus-visible,
.slds-button--text-destructive:focus-visible{
  --slds-c-button-color-background-hover:var(--slds-g-color-surface-container-2);
  --slds-c-button-color-border-hover:var(--slds-g-color-border-error-2);
  --slds-c-button-text-color-hover:var(--slds-g-color-error-1);
}
.slds-button_text-destructive:active,.slds-button--text-destructive:active{
  --slds-c-button-color-background-active:var(--slds-g-color-surface-container-2);
  --slds-c-button-color-border-active:var(--slds-g-color-border-error-2);
  --slds-c-button-text-color-active:var(--slds-g-color-error-1);
}
.slds-button_text-destructive[disabled],.slds-button--text-destructive[disabled],
.slds-button_text-destructive:disabled,
.slds-button--text-destructive:disabled{
  background-color:var(--slds-g-color-disabled-container-1);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-1);
}
.slds-button_success,.slds-button--success{
  justify-content:center;
  --slds-c-button-color-background:var(--slds-g-color-success-container-1);
  --slds-c-button-color-border:var(--slds-g-color-border-success-1);
  --slds-c-button-text-color:var(--slds-g-color-on-success-1);
  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);
  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);
  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);
}
.slds-button_success:hover,.slds-button--success:hover,
.slds-button_success:focus-visible,
.slds-button--success:focus-visible{
  --slds-c-button-color-background-hover:var(--slds-g-color-success-container-2);
  --slds-c-button-color-border-hover:var(--slds-g-color-border-success-1);
  --slds-c-button-text-color-hover:var(--slds-g-color-on-success-1);
}
.slds-button_success:active,.slds-button--success:active{
  --slds-c-button-color-background-active:var(--slds-g-color-success-container-2);
  --slds-c-button-color-border-active:var(--slds-g-color-border-success-1);
  --slds-c-button-text-color-active:var(--slds-g-color-on-success-1);
}
.slds-button_success[disabled],.slds-button--success[disabled],
.slds-button_success:disabled,
.slds-button--success:disabled{
  background-color:var(--slds-g-color-disabled-container-2);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-2);
}
.slds-button__icon,
.slds-button__icon_stateful,
.slds-button__icon--stateful{
  width:0.875rem;
  height:0.875rem;
  fill:var(--slds-c-icon-color-foreground, currentColor);
}
.slds-button__icon_large,.slds-button__icon--large{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
}
.slds-button__icon_small,.slds-button__icon--small{
  width:var(--slds-g-sizing-4);
  height:var(--slds-g-sizing-4);
}
.slds-button__icon_x-small,.slds-button__icon--x-small{
  width:var(--slds-g-sizing-3);
  height:var(--slds-g-sizing-3);
}
.slds-button__icon_left,.slds-button__icon--left{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-button__icon_right,.slds-button__icon--right{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-button_reset,.slds-button--reset{
  font-size:inherit;
  color:inherit;
  line-height:inherit;
  padding:0;
  background:transparent;
  border:0;
  text-align:inherit;
}
.slds-button_stretch,.slds-button--stretch{
  justify-content:center;
  width:100%;
}
.slds-button_full-width,.slds-button--full-width{
  color:inherit;
  line-height:inherit;
  padding:0;
  background:transparent;
  border:0;
  text-align:inherit;
  width:100%;
  display:inline-flex;
  flex-grow:1;
  align-items:center;
  justify-content:space-between;
}
.slds-button_full-width:focus-visible,.slds-button--full-width:focus-visible{
  --slds-c-button-shadow:none;
}
.slds-button_icon,.slds-button--icon,
.slds-button_icon-inverse,
.slds-button--icon-inverse,
.slds-button_icon-container,
.slds-button--icon-container,
.slds-button_icon-border,
.slds-button--icon-border,
.slds-button_icon-border-filled,
.slds-button--icon-border-filled,
.slds-button_icon-border-inverse,
.slds-button--icon-border-inverse,
.slds-button_icon-more,
.slds-button--icon-more,
.slds-button_icon-error,
.slds-button--icon-error,
.slds-button_icon-warning,
.slds-button--icon-warning{
  --slds-c-button-color-background-hover:none;

  line-height:1;
  vertical-align:middle;
  justify-content:center;
  color:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));
  flex-shrink:0;
  padding:0;
}
.slds-button_icon-container,.slds-button--icon-container,
.slds-button_icon-border,
.slds-button--icon-border,
.slds-button_icon-border-filled,
.slds-button--icon-border-filled,
.slds-button_icon-border-inverse,
.slds-button--icon-border-inverse,
.slds-button_icon-brand,
.slds-button--icon-brand,
.slds-button_icon-more,
.slds-button--icon-more,
.slds-button_icon-container-more,
.slds-button--icon-container-more{
  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
}
.slds-button_icon-border-filled,.slds-button--icon-border-filled,
.slds-button_icon-border,
.slds-button--icon-border{
  line-height:1;
  vertical-align:middle;
  color:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  transition:border 0.15s linear;
}
.slds-button_icon-border-filled[disabled],.slds-button--icon-border-filled[disabled],
.slds-button_icon-border-filled:disabled,
.slds-button--icon-border-filled:disabled,
.slds-button_icon-border[disabled],
.slds-button--icon-border[disabled],
.slds-button_icon-border:disabled,
.slds-button--icon-border:disabled{
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-disabled-2);
}
.slds-button_icon-border-inverse,.slds-button--icon-border-inverse{
  background-color:transparent;
  border-color:var(--slds-g-color-border-inverse-1);
}
.slds-button_icon-border-inverse[disabled],.slds-button--icon-border-inverse[disabled],
.slds-button_icon-border-inverse:disabled,
.slds-button--icon-border-inverse:disabled{
  background-color:transparent;
  border-color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 75%);
}
.slds-button_icon-brand,.slds-button--icon-brand{
  background-color:var(--slds-g-color-accent-container-1);
  border-color:var(--slds-g-color-border-accent-1);
  color:var(--slds-g-color-on-accent-1);
}
.slds-button_icon-brand:visited,.slds-button--icon-brand:visited,
.slds-button_icon-brand:active,
.slds-button--icon-brand:active{
  color:var(--slds-g-color-on-accent-1);
}
.slds-button_icon-brand:hover,.slds-button--icon-brand:hover,
.slds-button_icon-brand:focus,
.slds-button--icon-brand:focus{
  background-color:var(--slds-g-color-accent-container-2);
  border-color:var(--slds-g-color-accent-container-2);
  color:var(--slds-g-color-on-accent-1);
}
.slds-button_icon-brand:active,.slds-button--icon-brand:active{
  background-color:var(--slds-g-color-accent-container-3);
  border-color:var(--slds-g-color-accent-container-3);
}
.slds-button_icon-brand[disabled],.slds-button--icon-brand[disabled],
.slds-button_icon-brand:disabled,
.slds-button--icon-brand:disabled{
  background:var(--slds-g-color-disabled-container-2);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-2);
}
.slds-button_icon-border-filled,.slds-button--icon-border-filled{
  --slds-c-button-color-background:var(--slds-g-color-surface-container-1);
}
.slds-button_icon-border-filled:hover,.slds-button--icon-border-filled:hover,
.slds-button_icon-border-filled:focus-visible,
.slds-button--icon-border-filled:focus-visible{
  --slds-c-button-color-background-hover:var(--slds-g-color-surface-container-2);
}
.slds-button_icon-border-filled[disabled],.slds-button--icon-border-filled[disabled],
.slds-button_icon-border-filled:disabled,
.slds-button--icon-border-filled:disabled{
  border-color:var(--slds-g-color-border-disabled-1);
  background-color:var(--slds-g-color-disabled-container-1);
}
.slds-button_icon-inverse,.slds-button--icon-inverse,
.slds-button_icon-border-inverse,
.slds-button--icon-border-inverse{
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-button_icon-inverse:hover,.slds-button--icon-inverse:hover,
.slds-button_icon-inverse:focus-visible,
.slds-button--icon-inverse:focus-visible,
.slds-button_icon-border-inverse:hover,
.slds-button--icon-border-inverse:hover,
.slds-button_icon-border-inverse:focus-visible,
.slds-button--icon-border-inverse:focus-visible{
  --slds-c-button-color-background-hover:transparent;

  color:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 25%);
}
.slds-button_icon-inverse:focus-visible,.slds-button--icon-inverse:focus-visible, .slds-button_icon-border-inverse:focus-visible, .slds-button--icon-border-inverse:focus-visible{
  outline:none;
  box-shadow:var(--slds-s-button-shadow-focus-inverse);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-inverse-1);
}
.slds-button_icon-inverse:active,.slds-button--icon-inverse:active, .slds-button_icon-border-inverse:active, .slds-button--icon-border-inverse:active{
  color:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 50%);
}
.slds-button_icon-inverse[disabled],.slds-button--icon-inverse[disabled],
.slds-button_icon-inverse:disabled,
.slds-button--icon-inverse:disabled,
.slds-button_icon-border-inverse[disabled],
.slds-button--icon-border-inverse[disabled],
.slds-button_icon-border-inverse:disabled,
.slds-button--icon-border-inverse:disabled{
  color:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 75%);
}
.slds-button_icon-error,.slds-button--icon-error{
  color:var(--slds-g-color-error-1);
}
.slds-button_icon-error:hover,.slds-button--icon-error:hover,
.slds-button_icon-error:active,
.slds-button--icon-error:active,
.slds-button_icon-error:focus-visible,
.slds-button--icon-error:focus-visible{
  color:var(--slds-g-color-error-1);
}
.slds-button_icon-warning,.slds-button--icon-warning{
  color:var(--slds-g-color-warning-1);
}
.slds-button_icon-warning:hover,.slds-button--icon-warning:hover,
.slds-button_icon-warning:active,
.slds-button--icon-warning:active,
.slds-button_icon-warning:focus-visible,
.slds-button--icon-warning:focus-visible{
  color:var(--slds-g-color-warning-1);
}
.slds-button_icon-current-color,.slds-button--icon-current-color{
  color:currentColor;
}
.slds-button_icon-large,.slds-button--icon-large{
  width:var(--slds-g-sizing-10);
  height:var(--slds-g-sizing-10);
}
.slds-button_icon-large .slds-button__icon,.slds-button--icon-large .slds-button__icon{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
}
.slds-button_icon-small,.slds-button--icon-small{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
}
.slds-button_icon-x-small,.slds-button--icon-x-small{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
  line-height:1;
}
.slds-button_icon-x-small .slds-button__icon,.slds-button--icon-x-small .slds-button__icon{
  width:var(--slds-g-sizing-4);
  height:var(--slds-g-sizing-4);
}
.slds-button_icon-xx-small,.slds-button--icon-xx-small{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  line-height:1;
}
.slds-button_icon-xx-small .slds-button__icon,.slds-button--icon-xx-small .slds-button__icon{
  width:var(--slds-g-sizing-3);
  height:var(--slds-g-sizing-3);
}
.slds-button_icon-more,.slds-button--icon-more{
  width:auto;
  line-height:1.875rem;
  padding:0 var(--slds-g-spacing-2);
  background-color:var(--slds-g-color-surface-container-1);
  border-color:var(--slds-g-color-border-2);
  color:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));
}
.slds-button_icon-more:hover .slds-button__icon,.slds-button--icon-more:hover .slds-button__icon, .slds-button_icon-more:focus .slds-button__icon, .slds-button--icon-more:focus .slds-button__icon{
  fill:var(--slds-s-button-color-hover, var(--slds-g-color-accent-2));
}
.slds-button_icon-more:active .slds-button__icon,.slds-button--icon-more:active .slds-button__icon{
  fill:var(--slds-g-color-accent-3);
}
.slds-button_icon-more[disabled],.slds-button--icon-more[disabled],
.slds-button_icon-more:disabled,
.slds-button--icon-more:disabled{
  cursor:default;
}
.slds-button_icon-more[disabled] .slds-button__icon,.slds-button--icon-more[disabled] .slds-button__icon, .slds-button_icon-more:disabled .slds-button__icon, .slds-button--icon-more:disabled .slds-button__icon{
  fill:var(--slds-g-color-disabled-1);
}
.slds-button_icon-container-more,.slds-button--icon-container-more{
  width:auto;
  line-height:1.875rem;
  padding-block:0;
  padding-inline:var(--slds-g-spacing-2);
  vertical-align:middle;
}
.slds-button__icon_hint,.slds-button__icon--hint{
  fill:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));
}
.slds-button__icon_inverse-hint,.slds-button__icon--inverse-hint{
  fill:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 50%);
}
.slds-hint-parent .slds-button_icon-border-inverse,.slds-hint-parent .slds-button--icon-border-inverse{
  border-color:color-mix(in oklab, var(--slds-g-color-border-inverse-1), transparent 50%);
}
.slds-hint-parent .slds-button_icon-border-inverse:focus,.slds-hint-parent .slds-button--icon-border-inverse:focus{
  border-color:color-mix(in oklab, var(--slds-g-color-border-inverse-1), transparent 25%);
}
.slds-hint-parent:hover .slds-button_icon-border-inverse,.slds-hint-parent:hover .slds-button--icon-border-inverse, .slds-hint-parent:focus .slds-button_icon-border-inverse, .slds-hint-parent:focus .slds-button--icon-border-inverse{
  border-color:color-mix(in oklab, var(--slds-g-color-border-inverse-1), transparent 25%);
}
.slds-hint-parent:hover .slds-button__icon_hint,.slds-hint-parent:hover .slds-button__icon--hint, .slds-hint-parent:focus .slds-button__icon_hint, .slds-hint-parent:focus .slds-button__icon--hint{
  fill:var(--slds-g-color-on-surface-2);
}
.slds-hint-parent:hover .slds-button__icon_inverse-hint,.slds-hint-parent:hover .slds-button__icon--inverse-hint, .slds-hint-parent:focus .slds-button__icon_inverse-hint, .slds-hint-parent:focus .slds-button__icon--inverse-hint{
  fill:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 25%);
}
.slds-hint-parent:hover .slds-button:disabled .slds-button__icon_hint,.slds-hint-parent:hover .slds-button:disabled .slds-button__icon--hint, .slds-hint-parent:focus .slds-button:disabled .slds-button__icon_hint, .slds-hint-parent:focus .slds-button:disabled .slds-button__icon--hint{
  fill:currentColor;
}
.slds-button_icon-container.slds-is-selected,.slds-button--icon-container.slds-is-selected,
.slds-button_icon-border.slds-is-selected,
.slds-button--icon-border.slds-is-selected,
.slds-button_icon-border-filled.slds-is-selected,
.slds-button--icon-border-filled.slds-is-selected,
.slds-button_icon-border-inverse.slds-is-selected,
.slds-button--icon-border-inverse.slds-is-selected{
  background-color:var(--slds-g-color-accent-container-1);
  border-color:var(--slds-g-color-border-accent-1);
  color:var(--slds-g-color-on-accent-1);
}
.slds-button_icon-container.slds-is-selected:hover,.slds-button--icon-container.slds-is-selected:hover,
.slds-button_icon-container.slds-is-selected:focus,
.slds-button--icon-container.slds-is-selected:focus,
.slds-button_icon-border.slds-is-selected:hover,
.slds-button--icon-border.slds-is-selected:hover,
.slds-button_icon-border.slds-is-selected:focus,
.slds-button--icon-border.slds-is-selected:focus,
.slds-button_icon-border-filled.slds-is-selected:hover,
.slds-button--icon-border-filled.slds-is-selected:hover,
.slds-button_icon-border-filled.slds-is-selected:focus,
.slds-button--icon-border-filled.slds-is-selected:focus,
.slds-button_icon-border-inverse.slds-is-selected:hover,
.slds-button--icon-border-inverse.slds-is-selected:hover,
.slds-button_icon-border-inverse.slds-is-selected:focus,
.slds-button--icon-border-inverse.slds-is-selected:focus{
  background-color:var(--slds-g-color-accent-container-2);
  border-color:var(--slds-g-color-accent-container-2);
  color:var(--slds-g-color-on-accent-1);
}
.slds-button_icon-container.slds-is-selected[disabled],.slds-button--icon-container.slds-is-selected[disabled],
.slds-button_icon-container.slds-is-selected:disabled,
.slds-button--icon-container.slds-is-selected:disabled,
.slds-button_icon-border.slds-is-selected[disabled],
.slds-button--icon-border.slds-is-selected[disabled],
.slds-button_icon-border.slds-is-selected:disabled,
.slds-button--icon-border.slds-is-selected:disabled,
.slds-button_icon-border-filled.slds-is-selected[disabled],
.slds-button--icon-border-filled.slds-is-selected[disabled],
.slds-button_icon-border-filled.slds-is-selected:disabled,
.slds-button--icon-border-filled.slds-is-selected:disabled,
.slds-button_icon-border-inverse.slds-is-selected[disabled],
.slds-button--icon-border-inverse.slds-is-selected[disabled],
.slds-button_icon-border-inverse.slds-is-selected:disabled,
.slds-button--icon-border-inverse.slds-is-selected:disabled{
  background:var(--slds-g-color-disabled-container-2);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-2);
}
.slds-button_neutral.slds-is-selected,.slds-button--neutral.slds-is-selected{
  --slds-c-button-neutral-color-background:var(
    --slds-c-button-stateful-color-background-selected,
    transparent
  );
  --slds-c-button-neutral-color-border:var(--slds-c-button-stateful-color-border-selected, transparent);
}
.slds-button_neutral.slds-is-selected:hover:not([disabled]),.slds-button--neutral.slds-is-selected:hover:not([disabled]),
.slds-button_neutral.slds-is-selected:focus:not([disabled]),
.slds-button--neutral.slds-is-selected:focus:not([disabled]){
  --slds-c-button-neutral-color-background-hover:var(
    --slds-c-button-stateful-color-background-selected-hover,
    var(--slds-g-color-surface-container-2)
  );
  --slds-c-button-neutral-color-border-hover:var(
    --slds-c-button-stateful-color-border-selected-hover,
    var(--slds-g-color-border-1)
  );
}
.slds-button_neutral.slds-is-selected:active:not([disabled]),.slds-button--neutral.slds-is-selected:active:not([disabled]){
  --slds-c-button-neutral-color-background-active:var(
    --slds-c-button-stateful-color-background-selected-active,
    var(--slds-g-color-surface-container-2)
  );
}
.slds-button_inverse.slds-is-selected,.slds-button--inverse.slds-is-selected{
  border-color:transparent;
}
.slds-button_stateful .slds-text-selected,.slds-button--stateful .slds-text-selected,
.slds-button_stateful .slds-text-selected-focus,
.slds-button--stateful .slds-text-selected-focus,
.slds-button_stateful .slds-text-not-selected,
.slds-button--stateful .slds-text-not-selected{
  align-items:center;
}
.slds-not-selected .slds-text-selected{
  display:none;
}
.slds-not-selected .slds-text-selected-focus{
  display:none;
}
.slds-not-selected .slds-text-not-selected{
  display:inline-flex;
}
.slds-is-selected-clicked .slds-text-selected, .slds-is-selected[disabled] .slds-text-selected, .slds-is-selected[disabled]:hover .slds-text-selected, .slds-is-selected[disabled]:focus .slds-text-selected{
  display:inline-flex;
}
.slds-is-selected-clicked .slds-text-selected-focus, .slds-is-selected[disabled] .slds-text-selected-focus, .slds-is-selected[disabled]:hover .slds-text-selected-focus, .slds-is-selected[disabled]:focus .slds-text-selected-focus{
  display:none;
}
.slds-is-selected-clicked .slds-text-not-selected, .slds-is-selected[disabled] .slds-text-not-selected, .slds-is-selected[disabled]:hover .slds-text-not-selected, .slds-is-selected[disabled]:focus .slds-text-not-selected{
  display:none;
}
.slds-is-selected .slds-text-not-selected{
  display:none;
}
.slds-is-selected .slds-text-selected{
  display:inline-flex;
}
.slds-is-selected .slds-text-selected-focus{
  display:none;
}
.slds-is-selected:hover .slds-text-not-selected, .slds-is-selected:focus .slds-text-not-selected{
  display:none;
}
.slds-is-selected:hover .slds-text-selected, .slds-is-selected:focus .slds-text-selected{
  display:none;
}
.slds-is-selected:hover .slds-text-selected-focus, .slds-is-selected:focus .slds-text-selected-focus{
  display:inline-flex;
}
.slds-button_dual-stateful .slds-text-not-pressed,.slds-button--dual-stateful .slds-text-not-pressed{
  display:block;
}
.slds-button_dual-stateful .slds-text-pressed,.slds-button--dual-stateful .slds-text-pressed{
  display:none;
}
.slds-button_dual-stateful.slds-is-pressed,.slds-button--dual-stateful.slds-is-pressed{
  padding-inline-start:var(--slds-c-button-brand-spacing-inlinestart, var(--slds-g-spacing-4));
  padding-inline-end:var(--slds-c-button-brand-spacing-inlineend, var(--slds-g-spacing-4));

  --slds-c-button-color-background:var(
    --slds-c-button-brand-color-background,
    var(--slds-g-color-accent-container-1)
  );

  --slds-c-button-color-border:var(--slds-c-button-brand-color-border, var(--slds-g-color-border-accent-1));
  --slds-c-button-text-color:var(--slds-c-button-brand-text-color, var(--slds-g-color-on-accent-1));

  --slds-c-button-text-color-hover:var(
    --slds-c-button-brand-text-color-hover,
    var(--slds-g-color-on-accent-1)
  );

  --slds-c-button-text-color-active:var(
    --slds-c-button-brand-text-color-active,
    var(--slds-g-color-on-accent-1)
  );
}
.slds-button_dual-stateful.slds-is-pressed:focus,.slds-button--dual-stateful.slds-is-pressed:focus,
.slds-button_dual-stateful.slds-is-pressed:hover,
.slds-button--dual-stateful.slds-is-pressed:hover{
  --slds-c-button-color-background:var(
    --slds-c-button-brand-color-background-hover,
    var(--slds-g-color-accent-container-2)
  );

  --slds-c-button-color-border:var(
    --slds-c-button-brand-color-border-hover,
    var(--slds-g-color-border-accent-2)
  );

  --slds-c-button-text-color-hover:var(
    --slds-c-button-brand-text-color-hover,
    var(--slds-g-color-on-accent-1)
  );
}
.slds-button_dual-stateful.slds-is-pressed .slds-text-not-pressed,.slds-button--dual-stateful.slds-is-pressed .slds-text-not-pressed{
  display:none;
}
.slds-button_dual-stateful.slds-is-pressed .slds-text-pressed,.slds-button--dual-stateful.slds-is-pressed .slds-text-pressed{
  display:block;
}
.slds-breadcrumb .slds-list__item,
.slds-breadcrumb .slds-breadcrumb__item{
  position:relative;
}
.slds-breadcrumb .slds-list__item::before,
.slds-breadcrumb .slds-breadcrumb__item::before{
  content:'>';
  position:absolute;
  inset-inline-start:calc(var(--slds-g-spacing-1) * -1);
}
.slds-breadcrumb .slds-list__item > a,
.slds-breadcrumb .slds-breadcrumb__item > a{
  display:block;
  padding-block-start:0;
  padding-inline-end:var(--slds-c-breadcrumbs-spacing-inlineend, var(--slds-g-spacing-2));
  padding-block-end:0;
  padding-inline-start:var(--slds-c-breadcrumbs-spacing-inlinestart, var(--slds-g-spacing-2));
}
.slds-breadcrumb .slds-list__item > a:hover,
.slds-breadcrumb .slds-breadcrumb__item > a:hover{
  text-decoration:none;
}
.slds-breadcrumb .slds-list__item:first-child > a,
.slds-breadcrumb .slds-breadcrumb__item:first-child > a{
  --slds-c-breadcrumbs-spacing-inlinestart:0;
}
.slds-breadcrumb .slds-list__item:first-child::before,
.slds-breadcrumb .slds-breadcrumb__item:first-child::before{
  content:'';
}
.slds-breadcrumb .slds-dropdown-trigger{
  margin-inline-end:var(--slds-c-breadcrumbs-spacing-inlineend, var(--slds-g-spacing-2));
}
[kx-scope='breadcrumbs-item'][kx-type='underline'] > a{
  position:relative;
  will-change:color, transform;
  transition:transform calc(calc(1 * 1) * 250ms / 1) cubic-bezier(0, 0.3, 0.15, 1);
  margin-inline-end:var(--slds-g-spacing-2);
  margin-inline-start:var(--slds-g-spacing-2);
  padding-inline-end:0;
  padding-inline-start:0;
}
[kx-scope='breadcrumbs-item'][kx-type='underline'] > a:active{
  transform:scale(0.95);
}
@media (prefers-reduced-motion: reduce){
  [kx-scope='breadcrumbs-item'][kx-type='underline'] > a:active{
    transform:none;
  }
}
[kx-scope='breadcrumbs-item'][kx-type='underline'] > a::after{
  will-change:transform-origin, transform;
  content:'';
  position:absolute;
  inset-block-start:80%;
  inset-inline-start:0%;
  height:0.0625rem;
  width:100%;
  background:var(--slds-g-color-accent-2);
  background-position:left top;
  transform:scaleX(0);
  transform-origin:var(--slds-kx-breadcrumbs-pointer-position-x, 50%) 0;
  transition:transform calc(calc(1 * 1) * 250ms / 1) cubic-bezier(0, 0.3, 0.15, 1);
}
[kx-scope='breadcrumbs-item'][kx-type='underline'] > a:hover::after{
  transform:scaleX(1);
}
[kx-scope='breadcrumbs-item'][kx-type='underline']:first-child > a{
  margin-inline-start:0;
}
.slds-builder-header_container,.slds-builder-header--container{
  position:fixed;
  width:100%;
  inset-block-start:0;
  inset-inline-start:0;
  z-index:100;
}
.slds-builder-header{
  position:relative;
  display:flex;
  height:var(--slds-s-header-sizing-height, 3.125rem);
  background:var(--slds-g-color-surface-inverse-1, var(--slds-g-color-brand-base-20));
  color:var(--slds-g-color-on-surface-inverse-1, var(--slds-g-color-neutral-base-100));
}
.slds-builder-header__item{
  display:flex;
  align-content:center;
  align-items:center;
  white-space:nowrap;
}
.slds-builder-header__item + .slds-builder-header__item{
  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-surface-inverse-2, var(--slds-g-color-brand-base-10));
}
.slds-builder-header__item-action,
.slds-builder-header__item-label{
  color:currentColor;
  padding:0 var(--slds-g-spacing-4);
  display:flex;
  align-content:center;
  align-items:center;
  flex-grow:1;
  min-width:0%;
  height:100%;
}
.slds-builder-header__item-action .slds-media__body,
.slds-builder-header__item-label .slds-media__body{
  flex-basis:auto;
}
.slds-builder-header__item-action{
  transition:all 150ms linear;
}
.slds-builder-header__item-action:hover,
.slds-builder-header__item-action:focus{
  background-color:var(--slds-g-color-surface-inverse-2, var(--slds-g-color-brand-base-10));
  color:var(--slds-g-color-on-surface-inverse-1, var(--slds-g-color-neutral-base-100));
  text-decoration:none;
  --slds-c-button-radius-border:0;
}
.slds-builder-header__item-action:focus{
  text-decoration:underline;
  box-shadow:var(--slds-g-shadow-6, 0 0 3px #0176d3);
  outline:none;
  border-radius:0;
}
.slds-builder-header__nav,
.slds-builder-header__utilities{
  align-items:stretch;
}
.slds-builder-header__nav-list{
  display:flex;
}
.slds-builder-header__utilities{
  margin-inline-start:auto;
}
.slds-builder-header__nav-item,
.slds-builder-header__utilities-item{
  display:flex;
  align-content:center;
  align-items:stretch;
}
.slds-builder-header__nav-item + .slds-builder-header__nav-item,
.slds-builder-header__nav-item + .slds-builder-header__utilities-item,
.slds-builder-header__utilities-item + .slds-builder-header__nav-item,
.slds-builder-header__utilities-item + .slds-builder-header__utilities-item{
  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-surface-inverse-2, var(--slds-g-color-brand-base-10));
}
.slds-builder-toolbar{
  display:flex;
  padding-block:var(--slds-g-sizing-3);
  padding-inline:var(--slds-g-sizing-4);
  background:var(--slds-g-color-surface-container-1, var(--slds-g-color-neutral-base-100));
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1, var(--slds-g-color-border-base-1));
}
.slds-builder-toolbar__actions{
  display:flex;
  align-items:center;
  margin-inline-start:auto;
}
.slds-builder-toolbar__item-group{
  display:flex;
  align-items:center;
}
.slds-builder-toolbar__item-group + .slds-builder-toolbar__item-group{
  margin-inline-start:var(--slds-g-sizing-2);
}
.slds-input_counter,.slds-input--counter{
  text-align:center;
  padding-block:0;
  padding-inline:var(--slds-g-spacing-8);
}
.slds-input_counter[type='number'],.slds-input--counter[type='number']{
  appearance:textfield;
}
.slds-input_counter::-webkit-inner-spin-button,.slds-input--counter::-webkit-inner-spin-button{
  appearance:none;
  margin:0;
}
.slds-input__button_decrement,.slds-input__button--decrement{
  position:absolute;
  top:50%;
  transform:translateY(-50%);
  inset-inline-start:0.75rem;
}
.slds-input__button_increment,.slds-input__button--increment{
  position:absolute;
  top:50%;
  transform:translateY(-50%);
  inset-inline-end:0.75rem;
}
.slds-icon_container,.slds-icon--container{
  padding-block-start:var(--slds-s-icon-spacing);
  padding-block-end:var(--slds-s-icon-spacing);
  padding-inline-start:var(--slds-s-icon-spacing);
  padding-inline-end:var(--slds-s-icon-spacing);
  border-radius:var(--slds-c-icon-radius-border, var(--slds-s-icon-radius-border));
  border-width:var(--slds-s-icon-sizing-border, 0);
  border-style:solid;
  border-color:var(--slds-s-icon-color-border, transparent);
  background-color:var(--slds-c-icon-color-background, var(--slds-s-icon-color-background));
  display:inline-block;
  line-height:1;
}
.slds-icon_container_circle,.slds-icon_container--circle{
  --slds-c-icon-radius-border:var(--slds-g-radius-border-circle);

  padding:var(--slds-g-spacing-2);
}
[dir='rtl'] .slds-icon_flip,[dir='rtl'] .slds-icon--flip{
  transform:scaleX(-1);
}
.slds-icon{
  display:inline-flex;
  height:var(--_slds-c-icon-sizing, var(--slds-s-icon-sizing, var(--slds-g-sizing-9)));
  width:var(--_slds-c-icon-sizing, var(--slds-s-icon-sizing, var(--slds-g-sizing-9)));
  fill:var(--slds-c-icon-color-foreground, var(--slds-g-color-neutral-base-100));
}
.slds-icon_xxx-small,.slds-icon--xxx-small{
  width:var(--slds-g-sizing-3);
  height:var(--slds-g-sizing-3);
}
.slds-icon_xx-small,.slds-icon--xx-small{
  width:calc(var(--slds-g-sizing-1) + var(--slds-g-sizing-4));
  height:calc(var(--slds-g-sizing-1) + var(--slds-g-sizing-4));
}
.slds-icon_x-small,.slds-icon--x-small{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
}
.slds-icon_small,.slds-icon--small{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
}
.slds-icon_large,.slds-icon--large{
  --_slds-c-icon-sizing:var(--slds-g-sizing-10);
}
.slds-icon-text-warning{
  --slds-c-icon-color-foreground:var(--slds-g-color-warning-1);
}
.slds-icon-text-success{
  --slds-c-icon-color-foreground:var(--slds-g-color-success-1);
}
.slds-icon-text-error{
  --slds-c-icon-color-foreground:var(--slds-g-color-error-1);
}
.slds-icon-text-light{
  --slds-c-icon-color-foreground:var(--slds-g-color-neutral-base-70);
}
.slds-icon_container[icon-name^='action'],.slds-icon--container[icon-name^='action']{
  --slds-c-icon-radius-border:var(--slds-g-radius-border-circle);

  padding-block:var(--slds-g-sizing-3);
  padding-inline:var(--slds-g-sizing-3);
}
.slds-icon_container[icon-name^='action'],.slds-icon--container[icon-name^='action'],
.slds-icon_container[class^='action'],
.slds-icon--container[class^='action'],
.slds-icon_container[icon-name^='standard'],
.slds-icon--container[icon-name^='standard'],
.slds-icon_container[class^='standard'],
.slds-icon--container[class^='standard'],
.slds-icon_container[icon-name^='custom'],
.slds-icon--container[icon-name^='custom'],
.slds-icon_container[class^='custom'],
.slds-icon--container[class^='custom']{
  --slds-c-icon-color-foreground:var(--slds-g-color-neutral-base-100);
}
.slds-icon-text-default{
  --slds-c-icon-color-foreground:var(
    --slds-c-icon-color-foreground-default,
    var(--slds-s-icon-color-foreground)
  );
}
.slds-icon-text-default.slds-is-disabled{
  fill:var(--slds-g-color-disabled-1);
}
.slds-current-color .slds-icon{
  --slds-c-icon-color-foreground:currentColor;
}
.slds-icon_disabled,.slds-icon--disabled{
  background-color:currentcolor;
}
.slds-input__icon{
  --_slds-c-icon-sizing:calc(var(--slds-g-sizing-1) + var(--slds-g-sizing-4));

  position:absolute;
  top:50%;
  margin-block-start:-0.4375rem;
  line-height:var(--slds-g-font-lineheight-1);
  border:0;
  z-index:2;
}
.slds-accordion{
  position:relative;
}
.slds-accordion__list-item{
  border-block-start-width:var(--slds-c-accordion-section-sizing-border, var(--slds-g-sizing-border-1));
  border-block-start-style:solid;
  border-block-start-color:var(--slds-c-accordion-section-color-border, var(--slds-g-color-border-1));
}
.slds-accordion__list-item:first-child{
  border-top:0;
}
.slds-accordion__summary{
  display:flex;
  margin-block-start:calc(var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4)) * -1);
  margin-inline-end:calc(var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4)) * -1);
  margin-block-end:calc(var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4)) * -1);
  margin-inline-start:calc(var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4)) * -1);
  padding-block-start:var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4));
  padding-inline-end:var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4));
  padding-block-end:var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4));
  padding-inline-start:var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4));
  background-color:var(--slds-c-accordion-summary-color-background, transparent);
}
.slds-accordion__summary-heading{
  display:flex;
  flex-grow:1;
  min-width:0;
  color:var(--slds-c-accordion-heading-color, var(--slds-g-color-on-surface-3));
  font-size:var(
    --slds-c-accordion-heading-font-size,
    var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-1))
  );
  font-weight:var(--slds-s-container-heading-font-weight, var(--slds-g-font-weight-4));
  line-height:var(--slds-g-font-lineheight-2);
}
.slds-accordion__summary-heading .slds-button:focus-visible{
  box-shadow:inset 0 0 0 2px var(--slds-g-color-brand-base-15);
  border-radius:var(--slds-g-radius-border-3);
  margin-inline-end:var(--slds-c-accordion-section-spacing-inlineend, revert);
}
.slds-accordion__summary-action{
  display:inline-flex;
  flex-grow:1;
  align-items:center;
  justify-content:flex-start;
  min-width:0;
  margin-block-start:calc(var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4)) * -1);
  margin-inline-end:calc(var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4)) * -1);
  margin-block-end:calc(var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4)) * -1);
  margin-inline-start:calc(var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4)) * -1);
  padding-block-start:var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4));
  padding-inline-end:var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4));
  padding-block-end:var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4));
  padding-inline-start:var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4));
  font-weight:inherit;
}
.slds-accordion__summary-action:hover,
.slds-accordion__summary-action:focus{
  color:var(--slds-g-color-accent-container-3);
}
.slds-accordion__summary-action:active{
  box-shadow:none;
}
.slds-accordion__summary-action-icon{
  flex-shrink:0;
  transform:rotate(-90deg);
}
.slds-accordion__summary-action-icon:dir(rtl){
  transform:rotate(90deg);
}
@media (min-width: 64em){
  .slds-accordion__summary-content{
    max-width:100%;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }
}
.slds-accordion__section{
  padding-block-start:var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4));
  padding-inline-end:var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4));
  padding-block-end:var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4));
  padding-inline-start:var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4));
}
.slds-accordion__content{
  overflow:hidden;
  visibility:hidden;
  opacity:0;
  height:0;
  color:var(--slds-g-color-on-surface-1);
}
.slds-is-open > .slds-accordion__summary{
  margin-block-end:0;
}
.slds-is-open > .slds-accordion__summary .slds-accordion__summary-action-icon{
  transform:rotate(0deg);
}
.slds-is-open > .slds-accordion__content{
  overflow:visible;
  visibility:visible;
  opacity:1;
  height:auto;
  color:var(--slds-g-color-on-surface-1);
}
.slds-icon-ellie{
  width:calc(14rem / 16);
  height:calc(14rem / 16);
  display:inline-block;
  overflow:hidden;
}
.slds-icon-ellie.slds-is-animated{
  will-change:transform;
  animation:slds-icon-ellie-pop 0.3s ease-in 2s 1 both;
}
.slds-icon-ellie.slds-is-animated svg{
  will-change:transform;
  animation:slds-icon-ellie 1.2s steps(20) 2.3s 2 alternate;
}
.slds-icon-ellie.slds-is-paused,
.slds-icon-ellie.slds-is-paused svg{
  animation-play-state:paused;
}
.slds-icon-ellie svg{
  width:17.5rem;
  vertical-align:top;
  color:var(--slds-g-color-accent-1);
}
.slds-icon-ellie circle:nth-child(2n + 1){
  fill:currentColor;
  stroke:currentColor;
  stroke-width:4px;
}
.slds-icon-ellie circle:nth-child(2n){
  fill:var(--slds-g-color-on-accent-1);
  stroke:var(--slds-g-color-on-accent-1);
  stroke-width:1px;
}
.slds-icon-ellie circle:nth-child(1),
.slds-icon-ellie circle:nth-last-child(2){
  stroke-width:4px;
}
.slds-icon-ellie circle:nth-child(2),
.slds-icon-ellie circle:nth-last-child(1){
  stroke-width:1px;
}
.slds-icon-ellie circle:nth-child(3),
.slds-icon-ellie circle:nth-last-child(4){
  stroke-width:3.95px;
}
.slds-icon-ellie circle:nth-child(4),
.slds-icon-ellie circle:nth-last-child(3){
  stroke-width:1.2px;
}
.slds-icon-ellie circle:nth-child(5),
.slds-icon-ellie circle:nth-last-child(6){
  stroke-width:3.85px;
}
.slds-icon-ellie circle:nth-child(6),
.slds-icon-ellie circle:nth-last-child(5){
  stroke-width:1.4px;
}
.slds-icon-ellie circle:nth-child(7),
.slds-icon-ellie circle:nth-last-child(8){
  stroke-width:3.6px;
}
.slds-icon-ellie circle:nth-child(8),
.slds-icon-ellie circle:nth-last-child(7){
  stroke-width:1.7px;
}
.slds-icon-ellie circle:nth-child(9),
.slds-icon-ellie circle:nth-last-child(10){
  stroke-width:3.3px;
}
.slds-icon-ellie circle:nth-child(10),
.slds-icon-ellie circle:nth-last-child(9){
  stroke-width:2px;
}
.slds-icon-ellie circle:nth-child(11),
.slds-icon-ellie circle:nth-last-child(12){
  stroke-width:3.2px;
}
.slds-icon-ellie circle:nth-child(12),
.slds-icon-ellie circle:nth-last-child(11){
  stroke-width:2.4px;
}
.slds-icon-ellie circle:nth-child(13),
.slds-icon-ellie circle:nth-last-child(14){
  stroke-width:3.15px;
}
.slds-icon-ellie circle:nth-child(14),
.slds-icon-ellie circle:nth-last-child(13){
  stroke-width:2.8px;
}
.slds-icon-ellie circle:nth-child(15),
.slds-icon-ellie circle:nth-last-child(16){
  stroke-width:3.1px;
}
.slds-icon-ellie circle:nth-child(16),
.slds-icon-ellie circle:nth-last-child(15){
  stroke-width:3.25px;
}
.slds-icon-ellie circle:nth-child(17),
.slds-icon-ellie circle:nth-last-child(18){
  stroke-width:3.05px;
}
.slds-icon-ellie circle:nth-child(18),
.slds-icon-ellie circle:nth-last-child(17){
  stroke-width:3.7px;
}
.slds-icon-ellie circle:nth-child(19),
.slds-icon-ellie circle:nth-last-child(20){
  stroke-width:3px;
}
.slds-icon-ellie circle:nth-child(20),
.slds-icon-ellie circle:nth-last-child(19){
  stroke-width:4px;
}
@keyframes slds-icon-ellie-pop{
  0%{
    transform:scale(0.2);
  }
  70%{
    transform:scale(1.1);
  }
  90%{
    transform:scale(0.7);
  }
  100%{
    transform:scale(1);
  }
}
@keyframes slds-icon-ellie{
  to{
    transform:translateX(-17.5rem);
  }
}
.slds-icon-eq{
  position:relative;
  width:calc(14rem / 16);
  height:calc(14rem / 16);
}
.slds-icon-eq.slds-is-animated .slds-icon-eq__bar{
  animation:slds-icon-eq 0.25s ease-in-out infinite alternate;
  will-change:transform;
  height:0.1875rem;
}
.slds-icon-eq.slds-is-animated .slds-icon-eq__bar:nth-of-type(2){
  animation-duration:0.65s;
}
.slds-icon-eq.slds-is-animated .slds-icon-eq__bar:nth-of-type(3){
  animation-duration:0.35s;
}
.slds-icon-eq__bar{
  position:absolute;
  bottom:0;
  left:0;
  width:calc(4rem / 16);
  height:0.5625rem;
  background:var(--slds-g-color-accent-1);
  transform:scaleY(1);
  transform-origin:bottom;
}
.slds-icon-eq__bar:nth-of-type(2){
  left:calc(5rem / 16);
  height:0.875rem;
}
.slds-icon-eq__bar:nth-of-type(3){
  left:calc(10rem / 16);
  height:0.75rem;
}
@keyframes slds-icon-eq{
  to{
    transform:scaleY(4.6666666667);
  }
}
.slds-icon-score{
  display:inline-block;
  width:0.3125rem;
  height:0.3125rem;
  position:relative;
}
.slds-icon-score__positive,
.slds-icon-score__negative{
  position:absolute;
  opacity:0;
  transition:opacity 0.4s ease-in-out;
  will-change:opacity;
  stroke-width:1.125px;
}
.slds-icon-score__positive{
  fill:var(--slds-g-color-success-1);
  stroke:var(--slds-g-color-success-1);
}
.slds-icon-score__negative{
  fill:transparent;
  stroke:var(--slds-g-color-error-1);
}
[data-slds-state='positive'] .slds-icon-score__positive,
[data-slds-state='negative'] .slds-icon-score__negative{
  opacity:1;
}
.slds-icon-strength{
  width:1.6875rem;
  height:0.4375rem;
  display:inline-block;
}
.slds-icon-strength circle{
  stroke-width:0.95px;
  fill:transparent;
  stroke:var(--slds-g-color-border-2);
  transition:fill 0.4s ease-in-out, stroke 0.4s ease-in-out;
  will-change:fill, stroke;
}
.slds-icon-strength[data-slds-strength='1'] circle:nth-child(1),
.slds-icon-strength[data-slds-strength='2'] circle:nth-child(1),
.slds-icon-strength[data-slds-strength='2'] circle:nth-child(2),
.slds-icon-strength[data-slds-strength='3'] circle:nth-child(1),
.slds-icon-strength[data-slds-strength='3'] circle:nth-child(2),
.slds-icon-strength[data-slds-strength='3'] circle:nth-child(3){
  fill:var(--slds-g-color-success-1);
  stroke:var(--slds-g-color-success-1);
}
.slds-icon-strength[data-slds-strength='-1'] circle:nth-child(1),
.slds-icon-strength[data-slds-strength='-2'] circle:nth-child(1),
.slds-icon-strength[data-slds-strength='-2'] circle:nth-child(2),
.slds-icon-strength[data-slds-strength='-3'] circle:nth-child(1),
.slds-icon-strength[data-slds-strength='-3'] circle:nth-child(2),
.slds-icon-strength[data-slds-strength='-3'] circle:nth-child(3){
  fill:var(--slds-g-color-error-container-1);
  stroke:var(--slds-g-color-error-1);
}
.slds-icon-strength.slds-is-animated circle{
  animation:slds-icon-strength-positive-load 0.4s 1s ease-in-out alternate both paused;
}
.slds-icon-strength.slds-is-animated circle:nth-child(2){
  animation-delay:1.4s;
}
.slds-icon-strength.slds-is-animated circle:nth-child(3){
  animation-delay:1.8s;
}
.slds-icon-strength.slds-is-animated[data-slds-strength^='-'] circle{
  animation-name:slds-icon-strength-negative-load;
}
.slds-icon-strength.slds-is-animated[data-slds-strength='-1'] circle:nth-child(1),
.slds-icon-strength.slds-is-animated[data-slds-strength='-2'] circle:nth-child(1),
.slds-icon-strength.slds-is-animated[data-slds-strength='-2'] circle:nth-child(2),
.slds-icon-strength.slds-is-animated[data-slds-strength='-3'] circle:nth-child(1),
.slds-icon-strength.slds-is-animated[data-slds-strength='-3'] circle:nth-child(2),
.slds-icon-strength.slds-is-animated[data-slds-strength='-3'] circle:nth-child(3),
.slds-icon-strength.slds-is-animated[data-slds-strength='1'] circle:nth-child(1),
.slds-icon-strength.slds-is-animated[data-slds-strength='2'] circle:nth-child(1),
.slds-icon-strength.slds-is-animated[data-slds-strength='2'] circle:nth-child(2),
.slds-icon-strength.slds-is-animated[data-slds-strength='3'] circle:nth-child(1),
.slds-icon-strength.slds-is-animated[data-slds-strength='3'] circle:nth-child(2),
.slds-icon-strength.slds-is-animated[data-slds-strength='3'] circle:nth-child(3){
  animation-play-state:running;
}
.slds-icon-strength.slds-is-paused circle{
  animation-play-state:paused !important;
}
@keyframes slds-icon-strength-positive-load{
  0%{
    fill:transparent;
    stroke:var(--slds-g-color-border-2);
  }
  100%{
    fill:var(--slds-g-color-success-1);
    stroke:var(--slds-g-color-success-1);
  }
}
@keyframes slds-icon-strength-negative-load{
  0%{
    fill:transparent;
    stroke:var(--slds-g-color-border-2);
  }
  100%{
    fill:var(--slds-g-color-error-container-1);
    stroke:var(--slds-g-color-error-1);
  }
}
.slds-icon-trend{
  width:1rem;
  height:1rem;
  display:inline-block;
}
.slds-icon-trend.slds-is-animated .slds-icon-trend__arrow{
  animation:slds-icon-trend-arrow 0.8s 0.4s ease-in-out both;
}
.slds-icon-trend.slds-is-animated .slds-icon-trend__circle{
  animation:slds-icon-trend-circle 0.8s ease-in-out both;
}
.slds-icon-trend.slds-is-paused .slds-icon-trend__arrow,
.slds-icon-trend.slds-is-paused .slds-icon-trend__circle{
  animation-play-state:paused;
}
.slds-icon-trend[data-slds-trend='down']{
  color:var(--slds-g-color-error-1);
  transform:rotate(45deg);
}
.slds-icon-trend[data-slds-trend='neutral']{
  color:var(--slds-g-color-on-surface-1);
}
.slds-icon-trend[data-slds-trend='up']{
  color:var(--slds-g-color-success-1);
  transform:rotate(-45deg);
}
.slds-icon-trend__arrow,
.slds-icon-trend__circle{
  stroke:currentColor;
  fill:none;
  stroke-linecap:round;
  stroke-linejoin:round;
  stroke-width:1.125px;
}
.slds-icon-trend__arrow{
  stroke-dashoffset:0.1px;
  stroke-dasharray:39.175px;
}
.slds-icon-trend__circle{
  stroke-dasharray:42.3385px, 46.3385px;
}
@keyframes slds-icon-trend-arrow{
  from{
    stroke-dashoffset:40.3px;
  }
}
@keyframes slds-icon-trend-circle{
  from{
    stroke-dasharray:0.1px, 46.3385px;
  }
}
.slds-icon-waffle_container,.slds-icon-waffle--container{
  border:0;
  outline:0;
}
.slds-icon-waffle_container:hover .slds-r1,.slds-icon-waffle--container:hover .slds-r1,
.slds-icon-waffle_container:hover .slds-r2,
.slds-icon-waffle--container:hover .slds-r2,
.slds-icon-waffle_container:hover .slds-r3,
.slds-icon-waffle--container:hover .slds-r3,
.slds-icon-waffle_container:hover .slds-r4,
.slds-icon-waffle--container:hover .slds-r4,
.slds-icon-waffle_container:hover .slds-r5,
.slds-icon-waffle--container:hover .slds-r5,
.slds-icon-waffle_container:hover .slds-r6,
.slds-icon-waffle--container:hover .slds-r6,
.slds-icon-waffle_container:hover .slds-r7,
.slds-icon-waffle--container:hover .slds-r7,
.slds-icon-waffle_container:hover .slds-r8,
.slds-icon-waffle--container:hover .slds-r8,
.slds-icon-waffle_container:hover .slds-r9,
.slds-icon-waffle--container:hover .slds-r9,
.slds-icon-waffle_container:focus .slds-r1,
.slds-icon-waffle--container:focus .slds-r1,
.slds-icon-waffle_container:focus .slds-r2,
.slds-icon-waffle--container:focus .slds-r2,
.slds-icon-waffle_container:focus .slds-r3,
.slds-icon-waffle--container:focus .slds-r3,
.slds-icon-waffle_container:focus .slds-r4,
.slds-icon-waffle--container:focus .slds-r4,
.slds-icon-waffle_container:focus .slds-r5,
.slds-icon-waffle--container:focus .slds-r5,
.slds-icon-waffle_container:focus .slds-r6,
.slds-icon-waffle--container:focus .slds-r6,
.slds-icon-waffle_container:focus .slds-r7,
.slds-icon-waffle--container:focus .slds-r7,
.slds-icon-waffle_container:focus .slds-r8,
.slds-icon-waffle--container:focus .slds-r8,
.slds-icon-waffle_container:focus .slds-r9,
.slds-icon-waffle--container:focus .slds-r9{
  animation:slds-icon-waffle-throb 2 200ms alternate;
}
.slds-icon-waffle_container:hover .slds-r1,.slds-icon-waffle--container:hover .slds-r1,
.slds-icon-waffle_container:hover .slds-r2,
.slds-icon-waffle--container:hover .slds-r2,
.slds-icon-waffle_container:hover .slds-r3,
.slds-icon-waffle--container:hover .slds-r3,
.slds-icon-waffle_container:focus .slds-r1,
.slds-icon-waffle--container:focus .slds-r1,
.slds-icon-waffle_container:focus .slds-r2,
.slds-icon-waffle--container:focus .slds-r2,
.slds-icon-waffle_container:focus .slds-r3,
.slds-icon-waffle--container:focus .slds-r3{
  background-color:var(--slds-g-color-accent-1);
}
.slds-icon-waffle_container:hover .slds-r4,.slds-icon-waffle--container:hover .slds-r4,
.slds-icon-waffle_container:hover .slds-r5,
.slds-icon-waffle--container:hover .slds-r5,
.slds-icon-waffle_container:hover .slds-r7,
.slds-icon-waffle--container:hover .slds-r7,
.slds-icon-waffle_container:focus .slds-r4,
.slds-icon-waffle--container:focus .slds-r4,
.slds-icon-waffle_container:focus .slds-r5,
.slds-icon-waffle--container:focus .slds-r5,
.slds-icon-waffle_container:focus .slds-r7,
.slds-icon-waffle--container:focus .slds-r7{
  background-color:var(--slds-g-color-warning-base-70);
}
.slds-icon-waffle_container:hover .slds-r6,.slds-icon-waffle--container:hover .slds-r6,
.slds-icon-waffle_container:hover .slds-r8,
.slds-icon-waffle--container:hover .slds-r8,
.slds-icon-waffle_container:hover .slds-r9,
.slds-icon-waffle--container:hover .slds-r9,
.slds-icon-waffle_container:focus .slds-r6,
.slds-icon-waffle--container:focus .slds-r6,
.slds-icon-waffle_container:focus .slds-r8,
.slds-icon-waffle--container:focus .slds-r8,
.slds-icon-waffle_container:focus .slds-r9,
.slds-icon-waffle--container:focus .slds-r9{
  background-color:var(--slds-g-color-palette-yellow-80);
}
.slds-icon-waffle_container:hover .slds-r2,.slds-icon-waffle--container:hover .slds-r2,
.slds-icon-waffle_container:hover .slds-r4,
.slds-icon-waffle--container:hover .slds-r4,
.slds-icon-waffle_container:focus .slds-r2,
.slds-icon-waffle--container:focus .slds-r2,
.slds-icon-waffle_container:focus .slds-r4,
.slds-icon-waffle--container:focus .slds-r4{
  transition-delay:50ms;
  animation-delay:50ms;
}
.slds-icon-waffle_container:hover .slds-r3,.slds-icon-waffle--container:hover .slds-r3,
.slds-icon-waffle_container:hover .slds-r5,
.slds-icon-waffle--container:hover .slds-r5,
.slds-icon-waffle_container:hover .slds-r7,
.slds-icon-waffle--container:hover .slds-r7,
.slds-icon-waffle_container:focus .slds-r3,
.slds-icon-waffle--container:focus .slds-r3,
.slds-icon-waffle_container:focus .slds-r5,
.slds-icon-waffle--container:focus .slds-r5,
.slds-icon-waffle_container:focus .slds-r7,
.slds-icon-waffle--container:focus .slds-r7{
  transition-delay:100ms;
  animation-delay:100ms;
}
.slds-icon-waffle_container:hover .slds-r6,.slds-icon-waffle--container:hover .slds-r6,
.slds-icon-waffle_container:hover .slds-r8,
.slds-icon-waffle--container:hover .slds-r8,
.slds-icon-waffle_container:focus .slds-r6,
.slds-icon-waffle--container:focus .slds-r6,
.slds-icon-waffle_container:focus .slds-r8,
.slds-icon-waffle--container:focus .slds-r8{
  transition-delay:150ms;
  animation-delay:150ms;
}
.slds-icon-waffle_container:hover .slds-r9,.slds-icon-waffle--container:hover .slds-r9,
.slds-icon-waffle_container:focus .slds-r9,
.slds-icon-waffle--container:focus .slds-r9{
  transition-delay:200ms;
  animation-delay:200ms;
}
.slds-icon-waffle{
  width:1.3125rem;
  height:1.3125rem;
  position:relative;
  display:block;
  cursor:pointer;
}
.slds-icon-waffle .slds-r1,
.slds-icon-waffle .slds-r2,
.slds-icon-waffle .slds-r3,
.slds-icon-waffle .slds-r4,
.slds-icon-waffle .slds-r5,
.slds-icon-waffle .slds-r6,
.slds-icon-waffle .slds-r7,
.slds-icon-waffle .slds-r8,
.slds-icon-waffle .slds-r9{
  width:0.3125rem;
  height:0.3125rem;
  background-color:var(--slds-g-color-neutral-base-50, #747474);
  display:inline-block;
  position:absolute;
  border-radius:50%;
  transition:background-color 100ms;
  transform-origin:50% 50%;
  will-change:scale, background-color;
  border:2px solid transparent;
}
.slds-icon-waffle .slds-r1{
  top:0;
  left:0;
}
.slds-icon-waffle .slds-r2{
  top:0;
  left:0.5rem;
}
.slds-icon-waffle .slds-r3{
  top:0;
  right:0;
}
.slds-icon-waffle .slds-r4{
  top:0.5rem;
  left:0;
}
.slds-icon-waffle .slds-r5{
  top:0.5rem;
  left:0.5rem;
}
.slds-icon-waffle .slds-r6{
  top:0.5rem;
  right:0;
}
.slds-icon-waffle .slds-r7{
  bottom:0;
  left:0;
}
.slds-icon-waffle .slds-r8{
  bottom:0;
  left:0.5rem;
}
.slds-icon-waffle .slds-r9{
  bottom:0;
  right:0;
}
.slds-icon-waffle .slds-r1{
  transition-delay:200ms;
}
.slds-icon-waffle .slds-r2,
.slds-icon-waffle .slds-r4{
  transition-delay:150ms;
}
.slds-icon-waffle .slds-r3,
.slds-icon-waffle .slds-r5,
.slds-icon-waffle .slds-r7{
  transition-delay:100ms;
}
.slds-icon-waffle .slds-r6,
.slds-icon-waffle .slds-r8{
  transition-delay:50ms;
}
@keyframes slds-icon-waffle-throb{
  to{
    transform:scale(1.5);
  }
}
.slds-icon-help{
  width:1.5rem;
  height:1.5rem;
  fill:var(--slds-g-color-on-surface-1);
}
.slds-icon-help:hover .slds-icon-help_hover,.slds-icon-help:hover .slds-icon-help--hover{
  opacity:1;
  transform:scale(1);
}
.slds-icon-help:focus{
  animation:slds-click-global-action 80ms cubic-bezier(1, 1.9, 0.94, 0.98);
}
.slds-icon-help:focus .slds-icon-help_focus,.slds-icon-help:focus .slds-icon-help--focus{
  opacity:1;
  transform:scale(1);
}
.slds-icon-help mask{
  mask-type:alpha;
}
.slds-icon-help_hover,.slds-icon-help--hover{
  opacity:0;
  transform:scale(0.1, 0.1);
  transform-origin:45px 47px;
  transition:all 200ms ease-out;
  fill:var(--slds-g-color-accent-3);
}
.slds-icon-help_focus,.slds-icon-help--focus{
  opacity:0;
  transform:scale(0.1, 0.1);
  transform-origin:45px 47px;
  transition:all 200ms ease-out;
  fill:var(--slds-g-color-accent-2);
}
.slds-icon-help svg{
  width:1.5rem;
  height:1.5rem;
}
.slds-icon-help g{
  mask:url('#questionMark');
}
@keyframes slds-click-global-action{
  25%{
    transform:scale(0.95, 0.95);
  }

  100%{
    transform:scale(0.98, 0.98);
  }
}
.slds-icon-typing{
  display:inline-block;
  padding:var(--slds-g-spacing-1) 0;
}
.slds-icon-typing.slds-is-animated .slds-icon-typing__dot{
  animation:slds-icon-typing__dot-first 1.2s infinite ease-in-out;
}
.slds-icon-typing.slds-is-animated .slds-icon-typing__dot:nth-child(1){
  animation-name:slds-icon-typing__dot-first;
}
.slds-icon-typing.slds-is-animated .slds-icon-typing__dot:nth-child(2){
  animation-name:slds-icon-typing__dot-second;
}
.slds-icon-typing.slds-is-animated .slds-icon-typing__dot:nth-child(3){
  animation-name:slds-icon-typing__dot-third;
}
.slds-icon-typing.slds-is-paused .slds-icon-typing__dot{
  animation-play-state:paused;
}
.slds-icon-typing__dot{
  background-color:var(--slds-g-color-neutral-base-80);
  border-radius:50%;
  display:inline-block;
  height:0.5rem;
  margin:0 0.125rem;
  width:0.5rem;
}
@keyframes slds-icon-typing__dot-first{
  0%{
    background-color:var(--slds-g-color-neutral-base-80);
  }

  16%{
    background-color:var(--slds-g-color-neutral-base-60);
  }

  33%,
  100%{
    background-color:var(--slds-g-color-neutral-base-80);
  }
}
@keyframes slds-icon-typing__dot-second{
  0%,
  33%{
    background-color:var(--slds-g-color-neutral-base-80);
  }

  50%{
    background-color:var(--slds-g-color-neutral-base-60);
  }

  67%,
  100%{
    background-color:var(--slds-g-color-neutral-base-80);
  }
}
@keyframes slds-icon-typing__dot-third{
  0%,
  67%{
    background-color:var(--slds-g-color-neutral-base-80);
  }

  83%{
    background-color:var(--slds-g-color-neutral-base-60);
  }

  100%{
    background-color:var(--slds-g-color-neutral-base-80);
  }
}
.slds-dynamic-menu .slds-popover__body{
  color:var(--slds-g-color-on-surface-2);
}
.slds-dynamic-menu .slds-popover__footer{
  background-color:transparent;
}
.slds-dynamic-menu__header{
  font-size:var(--slds-g-font-scale-1);
  font-weight:var(--slds-g-font-weight-7);
}
.slds-carousel{
  position:relative;
  color:var(--slds-g-color-on-surface-2);
}
.slds-carousel__stage{
  position:relative;
  display:flex;
  flex-direction:column;
  overflow:hidden;
}
.slds-carousel__panels{
  display:flex;
  transition:transform 250ms ease-in;
  min-height:0%;
}
.slds-carousel__panel{
  flex:0 0 100%;
  max-width:100%;
}
.slds-carousel__panel-action{
  display:block;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-s-container-radius-border);
  margin:var(--slds-g-spacing-1);
}
.slds-carousel__panel-action:focus-visible{
  outline:0;
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-carousel__image{
  border-start-start-radius:inherit;
  border-start-end-radius:inherit;
  overflow:hidden;
}
.slds-carousel__image > img{
  width:100%;
}
.slds-carousel__content{
  background:var(--slds-g-color-surface-1);
  padding:var(--slds-g-spacing-4);
  border-end-start-radius:inherit;
  border-end-end-radius:inherit;
  text-align:center;
  height:6.625rem;
  overflow-x:hidden;
  overflow-y:auto;
}
.slds-carousel__content-title{
  font-size:var(--slds-g-font-scale-2);
  font-weight:var(--slds-g-font-weight-6);
}
.slds-carousel__indicators{
  align-self:center;
  margin:var(--slds-g-spacing-2) 0;
}
.slds-carousel__indicator{
  display:inline-flex;
  margin-block:0;
  margin-inline:var(--slds-g-spacing-1);
}
.slds-carousel__indicator-action{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  background:var(--slds-g-color-surface-1);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-radius:50%;
}
.slds-carousel__indicator-action.slds-is-active,
.slds-carousel__indicator-action.slds-is-active:hover{
  background:var(--slds-g-color-accent-container-1);
  border-color:var(--slds-g-color-border-accent-1);
}
.slds-carousel__indicator-action.slds-is-active{
  box-shadow:var(--slds-s-mark-shadow-checked);
}
.slds-carousel__indicator-action:hover{
  background-color:var(--slds-g-color-surface-2);
}
.slds-carousel__indicator-action:focus-visible{
  outline:0;
  box-shadow:var(--slds-s-button-shadow-focus);
  background-color:var(--slds-g-color-accent-container-3);
  border-color:var(--slds-g-color-border-accent-3);
}
.slds-carousel__autoplay{
  position:absolute;
  inset-inline-start:0;
  inset-block-end:var(--slds-g-spacing-1);
  margin:var(--slds-g-spacing-1);
}
.slds-card{
  position:relative;
  padding-block-start:var(--slds-c-card-spacing-blockstart, 0);
  padding-inline-end:var(--slds-c-card-spacing-inlineend, 0);
  padding-block-end:var(--slds-c-card-spacing-blockend, 0);
  padding-inline-start:var(--slds-c-card-spacing-inlinestart, 0);
  background:var(--slds-c-card-color-background, var(--slds-g-color-surface-container-1));
  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(
    --slds-c-card-color-border,
    var(--slds-s-container-color-border, var(--slds-g-color-border-1))
  );
  border-radius:var(
    --slds-c-card-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  background-clip:padding-box;
  box-shadow:var(--slds-c-card-shadow, var(--slds-s-container-shadow, var(--slds-g-shadow-2)));
  color:var(--slds-c-card-text-color, var(--slds-s-container-color));
}
.slds-card + .slds-card{
  margin-block-start:var(--_slds-g-spacing-var-block-4, var(--slds-g-spacing-4));
}
.slds-card__header{
  padding-block-start:var(
    --slds-c-card-header-spacing-blockstart,
    var(--slds-c-card-header-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))
  );
  padding-inline-end:var(
    --slds-c-card-header-spacing-inlineend,
    var(--slds-c-card-header-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
  padding-block-end:var(--slds-c-card-header-spacing-blockend, var(--slds-c-card-header-spacing-block, 0));
  padding-inline-start:var(
    --slds-c-card-header-spacing-inlinestart,
    var(--slds-c-card-header-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
  margin:0;
  margin-block-end:var(
    --slds-c-card-header-spacing-blockend,
    var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3))
  );
}
.slds-card__header-title{
  display:flex;
  font-size:var(
    --slds-c-card-heading-font-size,
    var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2))
  );
  font-weight:var(
    --slds-c-card-heading-font-weight,
    var(--slds-s-container-heading-font-weight, var(--slds-g-font-weight-4))
  );
  line-height:var(--slds-g-font-lineheight-2);
  color:var(--slds-g-color-on-surface-3);
}
.slds-card__header-link{
  color:inherit;
  font-weight:var(
    --slds-c-card-heading-font-weight,
    var(--slds-s-container-heading-font-weight, var(--slds-g-font-weight-7))
  );
}
.slds-card__body{
  margin-block-start:var(
    --slds-c-card-body-spacing-blockstart,
    var(--slds-c-card-body-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))
  );
  margin-block-end:var(
    --slds-c-card-body-spacing-blockend,
    var(--slds-c-card-body-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))
  );
  padding-inline-end:var(--slds-c-card-body-spacing-inlineend, var(--slds-c-card-body-spacing-inline));
  padding-inline-start:var(
    --slds-c-card-body-spacing-inlinestart,
    var(--slds-c-card-body-spacing-inline, var(--slds-g-spacing-1))
  );
}
.slds-card__body_inner,.slds-card__body--inner{
  --slds-c-card-body-spacing-inlineend:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));
  --slds-c-card-body-spacing-inlinestart:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));

  padding-block-start:0;
  padding-block-end:0;
}
.slds-card__body:empty,
.slds-card__footer:empty{
  display:none;
}
.slds-card__footer{
  display:flex;
  justify-content:center;
  align-items:center;
  padding-block-start:var(
    --slds-c-card-footer-spacing-blockstart,
    var(--slds-c-card-footer-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))
  );
  padding-inline-end:var(
    --slds-c-card-footer-spacing-inlineend,
    var(--slds-c-card-footer-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
  padding-block-end:var(
    --slds-c-card-footer-spacing-blockend,
    var(--slds-c-card-footer-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))
  );
  padding-inline-start:var(
    --slds-c-card-footer-spacing-inlinestart,
    var(--slds-c-card-footer-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
  margin-block-start:var(
    --slds-c-card-footer-spacing-blockstart,
    var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3))
  );
  font-size:var(--slds-c-card-footer-font-size, var(--slds-g-font-size-base));
  border-top-width:var(--slds-c-card-footer-sizing-border, var(--slds-g-sizing-border-1));
  border-top-style:solid;
  border-top-color:var(--slds-c-card-footer-color-border, var(--slds-g-color-border-1));
}
.slds-card__footer-action{
  display:block;
}
.slds-card__tile{
  margin-block-start:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));
}
.slds-region__pinned-left .slds-card,
.slds-region__pinned-left .slds-card-wrapper,
.slds-region__pinned-left .slds-card_boundary,
.slds-region__pinned-left .slds-card--boundary,
.slds-region__pinned-left .slds-tabs_card,
.slds-region__pinned-left .slds-tabs--card,
.slds-region__pinned-right .slds-card,
.slds-region__pinned-right .slds-card-wrapper,
.slds-region__pinned-right .slds-card_boundary,
.slds-region__pinned-right .slds-card--boundary,
.slds-region__pinned-right .slds-tabs_card,
.slds-region__pinned-right .slds-tabs--card{
  border-radius:0;
  border:0;
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  box-shadow:none;
}
.slds-region__pinned-left .slds-card:last-child, .slds-region__pinned-left .slds-card-wrapper:last-child, .slds-region__pinned-left .slds-card_boundary:last-child, .slds-region__pinned-left .slds-card--boundary:last-child, .slds-region__pinned-left .slds-tabs_card:last-child, .slds-region__pinned-left .slds-tabs--card:last-child, .slds-region__pinned-right .slds-card:last-child, .slds-region__pinned-right .slds-card-wrapper:last-child, .slds-region__pinned-right .slds-card_boundary:last-child, .slds-region__pinned-right .slds-card--boundary:last-child, .slds-region__pinned-right .slds-tabs_card:last-child, .slds-region__pinned-right .slds-tabs--card:last-child{
  border-block-end:0;
}
.slds-card-wrapper{
  padding:var(--_slds-g-spacing-var-4, var(--slds-g-spacing-4));
  background:var(--slds-c-card-color-background, var(--slds-g-color-surface-container-1));
  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(
    --slds-c-card-color-border,
    var(--slds-s-container-color-border, var(--slds-g-color-border-1))
  );
  border-radius:var(
    --slds-c-card-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  background-clip:padding-box;
  box-shadow:var(--slds-c-card-shadow, var(--slds-s-container-shadow, var(--slds-g-shadow-2)));
}
.slds-card-wrapper .slds-card__header,
.slds-card-wrapper .slds-card__body,
.slds-card-wrapper .slds-card__footer{
  padding-inline-start:0;
  padding-inline-end:0;
}
.slds-card .slds-card,
.slds-card .slds-card-wrapper,
.slds-card-wrapper .slds-card,
.slds-card-wrapper .slds-card-wrapper,
.slds-modal .slds-card,
.slds-modal .slds-card-wrapper{
  border:0;
  box-shadow:none;
}
.slds-tabs_default .slds-card,.slds-tabs--default .slds-card,
.slds-tabs_default .slds-card-wrapper,
.slds-tabs--default .slds-card-wrapper,
.slds-tabs_card .slds-card,
.slds-tabs--card .slds-card,
.slds-tabs_card .slds-card-wrapper,
.slds-tabs--card .slds-card-wrapper,
.slds-tabs_card.slds-tabs_card .slds-card,
.slds-tabs--card.slds-tabs--card .slds-card,
.slds-tabs_card.slds-tabs_card .slds-card-wrapper,
.slds-tabs--card.slds-tabs--card .slds-card-wrapper{
  border:0;
  box-shadow:none;
}
.slds-card .slds-card_boundary,.slds-card .slds-card--boundary, .slds-modal .slds-card_boundary, .slds-modal .slds-card--boundary, .slds-tabs_default .slds-card_boundary, .slds-tabs--default .slds-card--boundary{
  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(
    --slds-c-card-color-border,
    var(--slds-s-container-color-border, var(--slds-g-color-border-1))
  );
  border-radius:var(
    --slds-c-card-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
}
.slds-tabs_card,.slds-tabs--card,
.slds-tabs_card.slds-tabs_card,
.slds-tabs--card.slds-tabs--card{
  padding-block:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));
  padding-inline:var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4));
  background:var(--slds-c-card-color-background, var(--slds-g-color-surface-container-1));
  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(
    --slds-c-card-color-border,
    var(--slds-s-container-color-border, var(--slds-g-color-border-1))
  );
  border-radius:var(
    --slds-c-card-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  box-shadow:var(--slds-c-card-shadow, var(--slds-s-container-shadow, var(--slds-g-shadow-2)));
}
.slds-tabs_card .slds-card,.slds-tabs--card .slds-card,
.slds-tabs_card .slds-card-wrapper,
.slds-tabs--card .slds-card-wrapper,
.slds-tabs_card.slds-tabs_card .slds-card,
.slds-tabs--card.slds-tabs--card .slds-card,
.slds-tabs_card.slds-tabs_card .slds-card-wrapper,
.slds-tabs--card.slds-tabs--card .slds-card-wrapper{
  padding-inline-start:0;
  padding-inline-end:0;
}
.slds-tabs_card .slds-card__header,.slds-tabs--card .slds-card__header,
.slds-tabs_card .slds-card__body,
.slds-tabs--card .slds-card__body,
.slds-tabs_card .slds-card__footer,
.slds-tabs--card .slds-card__footer,
.slds-tabs_card.slds-tabs_card .slds-card__header,
.slds-tabs--card.slds-tabs--card .slds-card__header,
.slds-tabs_card.slds-tabs_card .slds-card__body,
.slds-tabs--card.slds-tabs--card .slds-card__body,
.slds-tabs_card.slds-tabs_card .slds-card__footer,
.slds-tabs--card.slds-tabs--card .slds-card__footer{
  padding-inline-start:0;
  padding-inline-end:0;
  margin-inline-start:0;
  margin-inline-end:0;
}
.slds-tabs_card .slds-card__header,.slds-tabs--card .slds-card__header, .slds-tabs_card.slds-tabs_card .slds-card__header, .slds-tabs--card.slds-tabs--card .slds-card__header{
  padding-block-start:0;
}
.slds-tabs_card .slds-card_boundary,.slds-tabs--card .slds-card--boundary, .slds-tabs_card.slds-tabs_card .slds-card_boundary, .slds-tabs--card.slds-tabs--card .slds-card--boundary, .slds-card-wrapper .slds-card_boundary, .slds-card-wrapper .slds-card--boundary{
  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(
    --slds-c-card-color-border,
    var(--slds-s-container-color-border, var(--slds-g-color-border-1))
  );
  border-radius:var(
    --slds-c-card-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
}
.slds-tabs_card .slds-card_boundary .slds-card__header,.slds-tabs--card .slds-card--boundary .slds-card__header, .slds-tabs_card.slds-tabs_card .slds-card_boundary .slds-card__header, .slds-tabs--card.slds-tabs--card .slds-card--boundary .slds-card__header, .slds-card-wrapper .slds-card_boundary .slds-card__header, .slds-card-wrapper .slds-card--boundary .slds-card__header{
  padding-block-start:var(
    --slds-c-card-header-spacing-blockstart,
    var(--slds-c-card-header-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))
  );
  padding-inline-end:var(
    --slds-c-card-header-spacing-inlineend,
    var(--slds-c-card-header-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
  padding-block-end:var(
    --slds-c-card-header-spacing-blockend,
    var(--slds-c-card-header-spacing-block, 0)
  );
  padding-inline-start:var(
    --slds-c-card-header-spacing-inlinestart,
    var(--slds-c-card-header-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
}
.slds-tabs_card .slds-card_boundary .slds-card__body_inner,.slds-tabs--card .slds-card--boundary .slds-card__body--inner, .slds-tabs_card.slds-tabs_card .slds-card_boundary .slds-card__body_inner, .slds-tabs--card.slds-tabs--card .slds-card--boundary .slds-card__body--inner, .slds-card-wrapper .slds-card_boundary .slds-card__body_inner, .slds-card-wrapper .slds-card--boundary .slds-card__body--inner{
  padding:0;
  padding-inline-end:var(
    --slds-c-card-body-spacing-inlineend,
    var(--slds-c-card-body-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
  padding-inline-start:var(
    --slds-c-card-body-spacing-inlinestart,
    var(--slds-c-card-body-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
}
.slds-tabs_card .slds-card_boundary .slds-card__footer,.slds-tabs--card .slds-card--boundary .slds-card__footer, .slds-tabs_card.slds-tabs_card .slds-card_boundary .slds-card__footer, .slds-tabs--card.slds-tabs--card .slds-card--boundary .slds-card__footer, .slds-card-wrapper .slds-card_boundary .slds-card__footer, .slds-card-wrapper .slds-card--boundary .slds-card__footer{
  padding-block-start:var(
    --slds-c-card-footer-spacing-blockstart,
    var(--slds-c-card-footer-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))
  );
  padding-inline-end:var(
    --slds-c-card-footer-spacing-inlineend,
    var(--slds-c-card-footer-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
  padding-block-end:var(
    --slds-c-card-footer-spacing-blockend,
    var(--slds-c-card-footer-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))
  );
  padding-inline-start:var(
    --slds-c-card-footer-spacing-inlinestart,
    var(--slds-c-card-footer-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))
  );
}
.slds-card_related-list-fix,.slds-card--related-list-fix{
  border-radius:var(--slds-s-container-radius-border, var(--slds-g-radius-border-2));
}
.slds-card_related-list-fix .slds-page-header,.slds-card--related-list-fix .slds-page-header{
  background:var(--slds-g-color-surface-container-1);
  border-radius:var(--slds-s-container-radius-border);
}
.slds-accordion .slds-card_related-list-fix,.slds-accordion .slds-card--related-list-fix,
.slds-tabs_card.slds-tabs_card .slds-card_related-list-fix,
.slds-tabs--card.slds-tabs--card .slds-card--related-list-fix{
  border-color:var(--slds-g-color-border-1);
}
.slds-card_related-list-fix .slds-page-header .slds-button-group-list .slds-button_icon-border-filled,.slds-card--related-list-fix .slds-page-header .slds-button-group-list .slds-button--icon-border-filled{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
}
.slds-card_related-list-fix .slds-file-selector__dropzone,.slds-card--related-list-fix .slds-file-selector__dropzone{
  margin-block-start:0;
  margin-block-end:var(--slds-g-spacing-4);
  margin-inline-start:var(--slds-g-spacing-4);
  margin-inline-end:var(--slds-g-spacing-4);
}
.slds-chat{
  margin-block-end:var(--slds-g-spacing-3);
}
.slds-chat-list{
  padding-block:0;
  padding-inline:var(--slds-g-spacing-3);
}
.slds-chat-listitem{
  display:flex;
  margin-block-start:var(--slds-g-spacing-3);
}
.slds-chat-listitem_outbound,.slds-chat-listitem--outbound{
  justify-content:flex-end;
}
.slds-chat-listitem_inbound + .slds-chat-listitem_inbound,.slds-chat-listitem--inbound + .slds-chat-listitem--inbound,
.slds-chat-listitem_outbound + .slds-chat-listitem_outbound,
.slds-chat-listitem--outbound + .slds-chat-listitem--outbound{
  margin-block-start:var(--slds-g-spacing-1);
}
.slds-chat-listitem_bookend,.slds-chat-listitem--bookend{
  margin-block:var(--slds-g-spacing-4);
  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);
  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);
}
.slds-chat-listitem_bookend + .slds-chat-listitem_bookend,.slds-chat-listitem--bookend + .slds-chat-listitem--bookend{
  margin-block-start:var(--slds-g-spacing-8);
}
.slds-chat-listitem_event,.slds-chat-listitem--event{
  margin-block:var(--slds-g-spacing-5);
  margin-inline:0;
}
.slds-chat-icon{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-chat-message{
  display:flex;
}
.slds-chat-message_faux-avatar,.slds-chat-message--faux-avatar{
  padding-inline-start:calc(var(--slds-g-spacing-6) + var(--slds-g-spacing-2));
}
.slds-chat-avatar{
  margin-inline-end:var(--slds-g-spacing-2);
  min-width:2rem;
}
.slds-chat-message__body{
  display:flex;
  flex-direction:column;
}
.slds-chat-message__image_loading,.slds-chat-message__image--loading{
  width:var(--slds-g-sizing-14);
  height:calc((180 / 16) * 1rem);
}
.slds-chat-message__text{
  overflow-wrap:break-word;
  word-wrap:break-word;
  word-break:break-word;
  display:inline-block;
  font-size:var(--slds-g-font-size-base);
  max-width:calc((420 / 16) * 1rem);
  white-space:pre-line;
}
.slds-chat-message__text a{
  color:var(--slds-s-link-color-focus);
  text-decoration:underline;
}
.slds-chat-message__text a:hover{
  text-decoration:none;
}
.slds-chat-message__file{
  width:var(--slds-g-sizing-14);
}
.slds-chat-message__file,
.slds-chat-message__image{
  overflow:hidden;
}
.slds-chat-message__file .slds-file:hover, .slds-chat-message__image .slds-file:hover{
  box-shadow:none;
  transition:none;
}
.slds-chat-message__file:focus-within, .slds-chat-message__image:focus-within{
  box-shadow:var(--slds-g-shadow-4);
}
.slds-chat-message__text_inbound,.slds-chat-message__text--inbound,
.slds-chat-message__file_inbound,
.slds-chat-message__file--inbound,
.slds-chat-message__image_inbound,
.slds-chat-message__image--inbound,
.slds-chat-message__text_outbound,
.slds-chat-message__text--outbound,
.slds-chat-message__file_outbound,
.slds-chat-message__file--outbound,
.slds-chat-message__image_outbound,
.slds-chat-message__image--outbound,
.slds-chat-message__text_outbound-agent,
.slds-chat-message__text--outbound-agent,
.slds-chat-message__text_unsupported-type,
.slds-chat-message__text--unsupported-type,
.slds-chat-message__text_delivery-failure,
.slds-chat-message__text--delivery-failure{
  border-start-start-radius:var(--slds-g-radius-border-3);
  border-start-end-radius:var(--slds-g-radius-border-3);
  border-end-start-radius:var(--slds-g-radius-border-3);
  border-end-end-radius:0;
  color:var(--slds-g-color-on-surface-inverse-1);
  min-height:2rem;
}
.slds-chat-message__text_inbound,.slds-chat-message__text--inbound,
.slds-chat-message__text_outbound,
.slds-chat-message__text--outbound,
.slds-chat-message__text_outbound-agent,
.slds-chat-message__text--outbound-agent,
.slds-chat-message__text_unsupported-type,
.slds-chat-message__text--unsupported-type,
.slds-chat-message__text_delivery-failure,
.slds-chat-message__text--delivery-failure{
  padding:var(--slds-g-spacing-2);
}
.slds-chat-message__file_inbound,.slds-chat-message__file--inbound,
.slds-chat-message__image_inbound,
.slds-chat-message__image--inbound,
.slds-chat-message__file_outbound,
.slds-chat-message__file--outbound,
.slds-chat-message__image_outbound,
.slds-chat-message__image--outbound{
  padding:0;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-chat-message__file_inbound,.slds-chat-message__file--inbound,
.slds-chat-message__image_inbound,
.slds-chat-message__image--inbound,
.slds-chat-message__file_outbound,
.slds-chat-message__file--outbound,
.slds-chat-message__image_outbound,
.slds-chat-message__image--outbound{
  color:var(--slds-g-color-on-surface-2);
}
.slds-chat-message__text_inbound,.slds-chat-message__text--inbound{
  margin-right:auto;
  background-color:var(--slds-g-color-surface-container-2);
  border-start-start-radius:var(--slds-g-radius-border-3);
  border-start-end-radius:var(--slds-g-radius-border-3);
  border-end-start-radius:0;
  border-end-end-radius:var(--slds-g-radius-border-3);
  color:var(--slds-g-color-on-surface-2);
}
.slds-chat-message__image_inbound,.slds-chat-message__image--inbound{
  background-color:var(--slds-g-color-surface-container-2);
  border-start-start-radius:var(--slds-g-radius-border-3);
  border-start-end-radius:var(--slds-g-radius-border-3);
  border-end-start-radius:0;
  border-end-end-radius:var(--slds-g-radius-border-3);
}
.slds-chat-message__file_inbound,.slds-chat-message__file--inbound{
  border-radius:var(--slds-g-radius-border-3);
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-chat-message__text_outbound,.slds-chat-message__text--outbound{
  margin-inline-start:auto;
  background-color:var(--slds-g-color-surface-container-inverse-1);
}
.slds-chat-message__text_outbound-agent,.slds-chat-message__text--outbound-agent{
  background-color:var(--slds-g-color-neutral-base-50);
  margin-inline-start:auto;
}
.slds-chat-message__text_outbound a,.slds-chat-message__text--outbound a, .slds-chat-message__text_outbound-agent a, .slds-chat-message__text--outbound-agent a{
  color:var(--slds-g-color-neutral-base-100);
  text-decoration:underline;
}
.slds-chat-message__text_unsupported-type,.slds-chat-message__text--unsupported-type{
  background-color:var(--slds-g-color-surface-container-1);
  border-start-start-radius:var(--slds-g-radius-border-3);
  border-start-end-radius:var(--slds-g-radius-border-3);
  border-end-start-radius:0;
  border-end-end-radius:var(--slds-g-radius-border-3);
  border:var(--slds-g-color-warning-base-60) var(--slds-g-sizing-border-1) solid;
  color:var(--slds-g-color-on-surface-2);
  margin-inline-end:auto;
}
.slds-chat-message__text_delivery-failure,.slds-chat-message__text--delivery-failure{
  background-color:var(--slds-g-color-surface-container-1);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-error-1);
  color:var(--slds-g-color-on-surface-2);
  margin-inline-start:auto;
}
.slds-chat-message__text_delivery-failure .slds-chat-message__text_delivery-failure-reason,.slds-chat-message__text--delivery-failure .slds-chat-message__text--delivery-failure-reason{
  display:flex;
  padding-block:var(--slds-g-spacing-2) 0;
  padding-inline:var(--slds-g-spacing-2);
  margin-block:var(--slds-g-spacing-2) 0;
  margin-inline:calc(var(--slds-g-spacing-2) * -1);
  color:var(--slds-g-color-error-1);
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-error-1);
}
.slds-chat-message__text_sneak-peak,.slds-chat-message__text--sneak-peak,
.slds-chat-message__text_sneak-peek,
.slds-chat-message__text--sneak-peek{
  font-style:italic;
}
.slds-chat-message__text_sneak-peak .slds-icon-typing,.slds-chat-message__text--sneak-peak .slds-icon-typing, .slds-chat-message__text_sneak-peek .slds-icon-typing, .slds-chat-message__text--sneak-peek .slds-icon-typing{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-chat-message__meta{
  color:var(--slds-g-color-on-surface-2);
  font-size:var(--slds-g-font-scale-neg-2);
  margin-block:0.125rem 0;
  margin-inline:var(--slds-g-spacing-2) 0;
}
.slds-chat-message__action{
  font-size:var(--slds-g-font-scale-neg-1);
  margin-inline-start:var(--slds-g-spacing-2);
  line-height:var(--slds-g-font-lineheight-2);
}
.slds-chat-message__action .slds-chat-icon.slds-icon-utility-redo .slds-icon{
  width:var(--slds-g-sizing-4);
  height:var(--slds-g-sizing-4);
  fill:var(--slds-s-link-color);
}
.slds-chat-event{
  align-items:center;
  color:var(--slds-g-color-on-surface-2);
  display:inline-flex;
  flex-wrap:wrap;
  justify-content:center;
  font-size:var(--slds-g-font-size-base);
  text-align:center;
  width:100%;
}
.slds-chat-event.slds-has-error{
  color:var(--slds-g-color-error-1);
}
.slds-chat-event.slds-has-error svg{
  fill:var(--slds-g-color-error-1);
}
.slds-chat-event__body{
  align-items:center;
  display:flex;
  margin-block:0;
  margin-inline:var(--slds-g-spacing-2);
}
.slds-chat-event__agent-message{
  flex-grow:3;
  font-size:var(--slds-g-font-scale-neg-1);
  font-style:italic;
  margin-block-start:var(--slds-g-spacing-2);
  width:100%;
}
.slds-chat-bookend{
  align-items:center;
  border:var(--slds-g-color-border-1) 0 solid;
  border-block-end-width:var(--slds-g-sizing-border-1);
  color:var(--slds-g-color-on-surface-2);
  display:flex;
  font-size:var(--slds-g-font-size-base);
  justify-content:center;
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
  width:100%;
}
.slds-chat-bookend_stop,.slds-chat-bookend--stop{
  border-width:var(--slds-g-sizing-border-1) 0 0;
}
.slds-chat_past .slds-chat-listitem_event,.slds-chat--past .slds-chat-listitem--event{
  margin-block:var(--slds-g-spacing-4);
  margin-inline:0;
}
.slds-chat_past .slds-chat-message__meta,.slds-chat--past .slds-chat-message__meta{
  margin-block:var(--slds-g-spacing-1) 0;
  margin-inline:0;
}
.slds-chat_past .slds-chat-message__meta b,.slds-chat--past .slds-chat-message__meta b{
  color:var(--slds-g-color-on-surface-3);
}
.slds-checkbox{
  display:inline-block;
  position:relative;
}
.slds-checkbox .slds-checkbox_faux,.slds-checkbox .slds-checkbox--faux{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  display:inline-block;
  position:relative;
  flex-shrink:0;
  vertical-align:middle;
  border-radius:var(--slds-c-checkbox-radius-border, var(--slds-g-radius-border-1));
  border-width:var(--slds-s-mark-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(
    --slds-c-checkbox-color-border,
    var(--slds-s-mark-color-border, var(--slds-g-color-border-2))
  );
  background-color:var(
    --slds-c-checkbox-color-background,
    var(--slds-s-mark-color-background, var(--slds-g-color-surface-container-1))
  );
  box-shadow:var(--slds-c-checkbox-shadow);
  transition:border 0.1s linear, background-color 0.1s linear;
}
.slds-checkbox .slds-checkbox__label .slds-form-element__label{
  display:inline;
  vertical-align:middle;
  font-size:var(--slds-s-label-font-size, var(--slds-g-font-scale-neg-2));
}
.slds-checkbox [type='checkbox']{
  width:1px;
  height:1px;
  border:0;
  clip:rect(0 0 0 0);
  margin:-1px;
  overflow:hidden;
  padding:0;
  position:absolute;
  pointer-events:auto;
}
.slds-checkbox [type='checkbox']:checked + .slds-checkbox_faux,.slds-checkbox [type='checkbox']:checked + .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux{
  --slds-c-checkbox-color-background:var(
    --slds-c-checkbox-color-background-checked,
    var(--slds-s-mark-color-background-checked, var(--slds-g-color-surface-container-1))
  );
}
.slds-checkbox [type='checkbox']:checked + .slds-checkbox_faux::after,.slds-checkbox [type='checkbox']:checked + .slds-checkbox--faux::after,
.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux::after,
.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux::after,
.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux::after,
.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux::after{
  display:block;
  content:'';
  height:var(--slds-g-sizing-2);
  width:var(--slds-g-sizing-3);
  position:absolute;
  inset-block-start:50%;

  /*! @noflip */
  left:50%;
  transform:translate3d(-50%, -50%, 0) rotate(-45deg);
  border-block-end:var(--slds-g-sizing-border-2) solid var(--slds-s-mark-color-foreground-checked, var(--slds-g-color-border-accent-2));

  /*! @noflip */
  border-left:var(--slds-g-sizing-border-2) solid var(--slds-s-mark-color-foreground-checked, var(--slds-g-color-border-accent-2));
}
.slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox_faux,.slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:focus-visible ~ .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:focus-visible ~ .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox__label .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox__label .slds-checkbox--faux{
  --slds-c-checkbox-color-border:var(
    --slds-c-checkbox-color-border-focus,
    var(--slds-s-input-color-border-focus, var(--slds-g-color-border-accent-1))
  );
  --slds-c-checkbox-shadow:var(
    --slds-c-checkbox-shadow-focus,
    var(--slds-s-mark-shadow-focus, 0 0 3px var(--slds-g-color-accent-2))
  );
}
.slds-checkbox [type='checkbox']:checked > .slds-checkbox_faux,.slds-checkbox [type='checkbox']:checked > .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux{
  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-checked);
}
.slds-checkbox [type='checkbox']:focus-visible:checked > .slds-checkbox_faux,.slds-checkbox [type='checkbox']:focus-visible:checked > .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:focus-visible:checked ~ .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:focus-visible:checked ~ .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:focus-visible:checked + .slds-checkbox__label .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:focus-visible:checked + .slds-checkbox__label .slds-checkbox--faux{
  --slds-c-checkbox-color-border:var(
    --slds-c-checkbox-color-border-focus,
    var(--slds-s-input-color-border-focus, var(--slds-g-color-border-accent-1))
  );
  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-focus);
}
.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox_faux,.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:indeterminate ~ .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:indeterminate ~ .slds-checkbox--faux,
.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox__label .slds-checkbox_faux,
.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox__label .slds-checkbox--faux{
  --slds-c-checkbox-color-border:var(
    --slds-c-checkbox-color-border-checked,
    var(--slds-s-input-color-border-checked)
  );
  --slds-c-checkbox-color-background:var(
    --slds-c-checkbox-color-background-checked,
    var(--slds-s-mark-color-background-checked)
  );
}
.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox_faux::after,.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox--faux::after,
.slds-checkbox [type='checkbox']:indeterminate ~ .slds-checkbox_faux::after,
.slds-checkbox [type='checkbox']:indeterminate ~ .slds-checkbox--faux::after,
.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox__label .slds-checkbox_faux::after,
.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox__label .slds-checkbox--faux::after{
  content:'';
  display:block;
  position:absolute;
  inset-block-start:50%;

  /*! @noflip */
  left:50%;
  width:var(--slds-g-sizing-3);
  height:2px;
  border:0;
  transform:translate3d(-50%, -50%, 0);
  background-color:var(--slds-s-mark-color-foreground-checked, var(--slds-g-color-accent-container-1));
}
.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox_faux,.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox--faux,
.slds-checkbox [type='checkbox'][disabled] ~ .slds-checkbox_faux,
.slds-checkbox [type='checkbox'][disabled] ~ .slds-checkbox--faux,
.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox__label .slds-checkbox_faux,
.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox__label .slds-checkbox--faux{
  border-color:var(--slds-g-color-border-disabled-1);
  background-color:var(--slds-g-color-disabled-container-2);
}
.slds-checkbox [type='checkbox'][disabled]:checked + .slds-checkbox_faux,.slds-checkbox [type='checkbox'][disabled]:checked + .slds-checkbox--faux,
.slds-checkbox [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux,
.slds-checkbox [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux,
.slds-checkbox [type='checkbox'][disabled]:checked + .slds-checkbox__label .slds-checkbox_faux,
.slds-checkbox [type='checkbox'][disabled]:checked + .slds-checkbox__label .slds-checkbox--faux{
  border-color:var(--slds-g-color-border-disabled-1);
  background-color:var(--slds-g-color-disabled-container-2);
}
.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox_faux::after,.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox--faux::after,
.slds-checkbox [type='checkbox'][disabled] ~ .slds-checkbox_faux::after,
.slds-checkbox [type='checkbox'][disabled] ~ .slds-checkbox--faux::after,
.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox__label .slds-checkbox_faux::after,
.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox__label .slds-checkbox--faux::after{
  border-color:var(--slds-g-color-on-disabled-2);
}
.slds-has-error .slds-checkbox [type='checkbox'] + .slds-checkbox_faux,.slds-has-error .slds-checkbox [type='checkbox'] + .slds-checkbox--faux,
.slds-has-error .slds-checkbox [type='checkbox'] ~ .slds-checkbox_faux,
.slds-has-error .slds-checkbox [type='checkbox'] ~ .slds-checkbox--faux,
.slds-has-error .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox_faux,
.slds-has-error .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox--faux{
  border-color:var(--slds-g-color-border-error-1);
  border-width:var(--slds-g-sizing-border-2);
}
.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox_faux,.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox--faux,
.slds-has-error .slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux,
.slds-has-error .slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux,
.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux,
.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux{
  border-color:var(--slds-g-color-border-error-1);
  background-color:var(--slds-s-mark-color-background-invalid);
  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-checked);
}
.slds-has-error .slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox_faux,.slds-has-error .slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox--faux,
.slds-has-error .slds-checkbox [type='checkbox']:focus-visible ~ .slds-checkbox_faux,
.slds-has-error .slds-checkbox [type='checkbox']:focus-visible ~ .slds-checkbox--faux,
.slds-has-error .slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox__label .slds-checkbox_faux,
.slds-has-error .slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox__label .slds-checkbox--faux{
  border-color:var(--slds-g-color-border-error-1);
  border-width:var(--slds-g-sizing-border-2);
  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-focus);
}
.slds-has-error .slds-checkbox [type='checkbox']:focus-visible:checked + .slds-checkbox_faux,.slds-has-error .slds-checkbox [type='checkbox']:focus-visible:checked + .slds-checkbox--faux,
.slds-has-error .slds-checkbox [type='checkbox']:focus-visible:checked ~ .slds-checkbox_faux,
.slds-has-error .slds-checkbox [type='checkbox']:focus-visible:checked ~ .slds-checkbox--faux,
.slds-has-error
.slds-checkbox
[type='checkbox']:focus-visible:checked
+ .slds-checkbox__label
.slds-checkbox_faux,
.slds-has-error
.slds-checkbox
[type='checkbox']:focus-visible:checked
+ .slds-checkbox__label
.slds-checkbox--faux{
  border-color:var(--slds-g-color-border-error-1);
  border-width:var(--slds-g-sizing-border-2);
  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-focus);
}
.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox_faux::after,.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox--faux::after,
.slds-has-error .slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux::after,
.slds-has-error .slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux::after,
.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux::after,
.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux::after{
  border-color:var(--slds-s-mark-color-foreground-invalid, var(--slds-g-color-border-error-1));
}
.slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox_faux,.slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox--faux,
.slds-form-element .slds-checkbox [type='checkbox'] ~ .slds-checkbox_faux,
.slds-form-element .slds-checkbox [type='checkbox'] ~ .slds-checkbox--faux,
.slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox_faux,
.slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox--faux{
  margin-inline-end:var(--slds-g-sizing-3);
}
[dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox_faux,[dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox--faux,
[dir='rtl'] [dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] ~ .slds-checkbox_faux,
[dir='rtl'] [dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] ~ .slds-checkbox--faux,
[dir='rtl']
[dir='rtl']
.slds-form-element
.slds-checkbox
[type='checkbox']
+ .slds-checkbox__label
.slds-checkbox_faux,
[dir='rtl']
[dir='rtl']
.slds-form-element
.slds-checkbox
[type='checkbox']
+ .slds-checkbox__label
.slds-checkbox--faux,
[dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox--faux{
  /*! @noflip */
  margin-right:0;

  /*! @noflip */
  margin-left:var(--slds-g-sizing-3);
}
.slds-checkbox_standalone,.slds-checkbox--standalone{
  pointer-events:none;
}
.slds-checkbox_standalone [type='checkbox'],.slds-checkbox--standalone [type='checkbox']{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  margin:0;
  clip:auto;
  opacity:0;
}
.slds-checkbox_faux,.slds-checkbox--faux{
  display:block;
}
.slds-form-element{
  position:relative;
  min-width:0;
}
.slds-form-element__label{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:auto;
  display:inline-block;
  color:var(--slds-s-label-color, var(--slds-g-color-on-surface-2));
  font-size:var(--slds-s-label-font-size, var(--slds-g-font-scale-neg-2));
  padding-inline-end:var(--slds-g-spacing-2);
  padding-block-start:var(--slds-g-spacing-1);
  margin-block-end:var(--slds-s-label-spacing-gap, calc(var(--slds-g-spacing-1) / 2));
}
.slds-form-element__label:empty{
  margin:0;
}
.slds-form-element__control{
  clear:left;
  position:relative;
}
.slds-form-element__control .slds-radio,
.slds-form-element__control .slds-checkbox{
  display:block;
}
[dir='rtl'] .slds-form-element__label{
  /*! @noflip */
  padding-right:0;

  /*! @noflip */
  padding-left:var(--slds-g-spacing-2);
}
[dir='rtl'] .slds-form-element__control{
  /*! @noflip */
  clear:right;
}
.slds-form-element__icon{
  display:inline-block;
  position:relative;
  padding-block-start:var(--slds-g-spacing-1);
  vertical-align:top;
  line-height:var(--slds-g-font-lineheight-1);
  z-index:1;
}
.slds-form-element__icon .slds-button_icon,.slds-form-element__icon .slds-button--icon{
  position:relative;
}
.slds-form-element__help,
.slds-form-element__helper{
  font-size:var(--slds-s-helptext-font-size, var(--slds-g-font-scale-neg-2));
  margin-block-start:calc(var(--slds-g-spacing-1) / 2);
  display:block;
  color:var(--slds-s-helptext-color);
}
.slds-form-element_edit .slds-form-element__static,.slds-form-element--edit .slds-form-element__static{
  width:calc(100% - var(--slds-g-sizing-7));
}
.slds-form-element_readonly,.slds-form-element--readonly{
  flex-basis:0%;
  border-bottom:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  margin-block-end:0;
}
.slds-form-element_readonly .slds-form-element__control,.slds-form-element--readonly .slds-form-element__control{
  padding-block-start:calc(var(--slds-g-spacing-1) / 2);
  padding-block-end:calc(var(--slds-g-spacing-1) / 2);
}
.slds-form-element_readonly .slds-form-element__label,.slds-form-element--readonly .slds-form-element__label{
  margin-block-end:0;
}
.slds-form-element__legend{
  font-weight:var(--slds-g-font-weight-7);
  float:left;
}
[dir='rtl'] .slds-form-element__legend{
  /*! @noflip */
  float:right;

  /*! @noflip */
  padding-right:0;
}
.slds-form-element__addon{
  display:inline-block;
  margin:0 var(--slds-g-spacing-2);
  align-self:center;
}
.slds-form-element__static{
  overflow-wrap:break-word;
  word-wrap:break-word;
  word-break:break-word;
  display:inline-block;
  font-size:var(--slds-s-label-font-size, var(--slds-g-font-scale-neg-1));
  font-weight:var(--slds-g-font-weight-4);
  color:var(--slds-g-color-neutral-base-10);
  width:100%;
}
.slds-form-element__static.slds-text-longform *:last-child{
  margin-block-end:0;
}
.slds-form-element__static:empty{
  min-height:calc(var(--slds-g-sizing-6) + 1px);
  vertical-align:bottom;
}
.slds-form-element__static--edit{
  width:calc(100% - var(--slds-g-sizing-7));
}
.slds-required{
  color:var(--slds-g-color-error-1);
  margin:0 calc(var(--slds-g-spacing-1) / 2);
}
.slds-has-error .slds-form-element__help{
  color:var(--slds-g-color-error-1);
}
.slds-form_inline .slds-form-element,.slds-form--inline .slds-form-element,
.slds-form_inline .slds-form-element__label,
.slds-form--inline .slds-form-element__label,
.slds-form_inline .slds-form-element__control,
.slds-form--inline .slds-form-element__control{
  display:block;
}
.slds-form_inline .slds-form-element + .slds-form-element,.slds-form--inline .slds-form-element + .slds-form-element{
  margin-block-start:var(--slds-g-spacing-3);
}
@media (min-width: 30em){
  .slds-form_inline .slds-form-element,.slds-form--inline .slds-form-element{
    margin-inline-end:var(--slds-g-spacing-2);
  }

  .slds-form_inline .slds-form-element + .slds-form-element,.slds-form--inline .slds-form-element + .slds-form-element{
    margin-block-start:0;
  }

  .slds-form_inline .slds-form-element,.slds-form--inline .slds-form-element,
  .slds-form_inline .slds-form-element__label,
  .slds-form--inline .slds-form-element__label,
  .slds-form_inline .slds-form-element__control,
  .slds-form--inline .slds-form-element__control{
    display:inline-block;
    vertical-align:middle;
    margin-block-end:0;
  }
}
.slds-form-element__legend_has-tooltip,.slds-form-element__legend--has-tooltip{
  float:left;
}
.slds-form-element_address .slds-form-element__row,.slds-form-element--address .slds-form-element__row{
  align-items:flex-end;
}
.slds-form-element_stacked,.slds-form-element--stacked,
.slds-form_stacked .slds-form-element,
.slds-form--stacked .slds-form-element,
.slds-form_horizontal .slds-form-element_stacked,
.slds-form--horizontal .slds-form-element--stacked{
  display:block;
}
.slds-form-element_stacked:not(.slds-form-element_readonly),.slds-form-element--stacked:not(.slds-form-element--readonly),
.slds-form_stacked .slds-form-element:not(.slds-form-element_readonly),
.slds-form--stacked .slds-form-element:not(.slds-form-element--readonly),
.slds-form_horizontal .slds-form-element_stacked:not(.slds-form-element_readonly),
.slds-form--horizontal .slds-form-element--stacked:not(.slds-form-element--readonly){
  margin-block-end:var(--slds-g-spacing-2);
}
.slds-form-element_stacked:not(.slds-is-editing),.slds-form-element--stacked:not(.slds-is-editing),
.slds-form_stacked .slds-form-element:not(.slds-is-editing),
.slds-form--stacked .slds-form-element:not(.slds-is-editing),
.slds-form_horizontal .slds-form-element_stacked:not(.slds-is-editing),
.slds-form--horizontal .slds-form-element--stacked:not(.slds-is-editing){
  padding:0 var(--slds-g-spacing-1);
}
.slds-form-element_stacked .slds-form-element,.slds-form-element--stacked .slds-form-element,
.slds-form_stacked .slds-form-element .slds-form-element,
.slds-form--stacked .slds-form-element .slds-form-element,
.slds-form_horizontal .slds-form-element_stacked .slds-form-element,
.slds-form--horizontal .slds-form-element--stacked .slds-form-element{
  padding:0;
  margin-block-end:0;
}
.slds-form-element_stacked:not([class*='slds-size']),.slds-form-element--stacked:not([class*='slds-size']),
.slds-form_stacked .slds-form-element:not([class*='slds-size']),
.slds-form--stacked .slds-form-element:not([class*='slds-size']),
.slds-form_horizontal .slds-form-element_stacked:not([class*='slds-size']),
.slds-form--horizontal .slds-form-element--stacked:not([class*='slds-size']){
  width:100%;
  flex-basis:100%;
}
.slds-form-element_stacked .slds-checkbox,.slds-form-element--stacked .slds-checkbox,
.slds-form-element_stacked .slds-radio,
.slds-form-element--stacked .slds-radio,
.slds-form_stacked .slds-form-element .slds-checkbox,
.slds-form--stacked .slds-form-element .slds-checkbox,
.slds-form_stacked .slds-form-element .slds-radio,
.slds-form--stacked .slds-form-element .slds-radio,
.slds-form_horizontal .slds-form-element_stacked .slds-checkbox,
.slds-form--horizontal .slds-form-element--stacked .slds-checkbox,
.slds-form_horizontal .slds-form-element_stacked .slds-radio,
.slds-form--horizontal .slds-form-element--stacked .slds-radio{
  display:block;
}
.slds-form-element_stacked .slds-form-element__label,.slds-form-element--stacked .slds-form-element__label,
.slds-form-element_stacked .slds-form-element__control,
.slds-form-element--stacked .slds-form-element__control,
.slds-form_stacked .slds-form-element .slds-form-element__label,
.slds-form--stacked .slds-form-element .slds-form-element__label,
.slds-form_stacked .slds-form-element .slds-form-element__control,
.slds-form--stacked .slds-form-element .slds-form-element__control,
.slds-form_horizontal .slds-form-element_stacked .slds-form-element__label,
.slds-form--horizontal .slds-form-element--stacked .slds-form-element__label,
.slds-form_horizontal .slds-form-element_stacked .slds-form-element__control,
.slds-form--horizontal .slds-form-element--stacked .slds-form-element__control{
  border-bottom:0;
  padding-inline-start:0;
}
.slds-form-element_stacked .slds-form-element__control,.slds-form-element--stacked .slds-form-element__control,
.slds-form_stacked .slds-form-element .slds-form-element__control,
.slds-form--stacked .slds-form-element .slds-form-element__control,
.slds-form_horizontal .slds-form-element_stacked .slds-form-element__control,
.slds-form--horizontal .slds-form-element--stacked .slds-form-element__control{
  width:100%;
  flex-basis:100%;
  clear:left;
}
[dir='rtl'] .slds-form-element_stacked .slds-form-element__control,[dir='rtl'] .slds-form-element--stacked .slds-form-element__control,
[dir='rtl'] .slds-form_stacked .slds-form-element .slds-form-element__control,
[dir='rtl'] .slds-form--stacked .slds-form-element .slds-form-element__control,
[dir='rtl'] .slds-form_horizontal .slds-form-element_stacked .slds-form-element__control,
[dir='rtl'] .slds-form--horizontal .slds-form-element--stacked .slds-form-element__control{
  /*! @noflip */
  clear:right;
}
.slds-form-element_stacked .slds-form-element__icon,.slds-form-element--stacked .slds-form-element__icon,
.slds-form_stacked .slds-form-element .slds-form-element__icon,
.slds-form--stacked .slds-form-element .slds-form-element__icon,
.slds-form_horizontal .slds-form-element_stacked .slds-form-element__icon,
.slds-form--horizontal .slds-form-element--stacked .slds-form-element__icon{
  float:none;
  padding-block-start:var(--slds-g-spacing-1);
}
.slds-form-element_horizontal,.slds-form-element--horizontal,
.slds-form_horizontal .slds-form-element,
.slds-form--horizontal .slds-form-element,
.slds-form_stacked .slds-form-element_horizontal,
.slds-form--stacked .slds-form-element--horizontal{
  display:block;
}
.slds-form-element_horizontal:not(.slds-form-element_readonly),.slds-form-element--horizontal:not(.slds-form-element--readonly),
.slds-form_horizontal .slds-form-element:not(.slds-form-element_readonly),
.slds-form--horizontal .slds-form-element:not(.slds-form-element--readonly),
.slds-form_stacked .slds-form-element_horizontal:not(.slds-form-element_readonly),
.slds-form--stacked .slds-form-element--horizontal:not(.slds-form-element--readonly){
  margin-block-end:var(--slds-g-spacing-2);
}
.slds-form-element_horizontal:not([class*='slds-size']),.slds-form-element--horizontal:not([class*='slds-size']),
.slds-form_horizontal .slds-form-element:not([class*='slds-size']),
.slds-form--horizontal .slds-form-element:not([class*='slds-size']),
.slds-form_stacked .slds-form-element_horizontal:not([class*='slds-size']),
.slds-form--stacked .slds-form-element--horizontal:not([class*='slds-size']){
  width:100%;
  flex-basis:100%;
}
.slds-form-element_horizontal:not(.slds-is-editing),.slds-form-element--horizontal:not(.slds-is-editing),
.slds-form_horizontal .slds-form-element:not(.slds-is-editing),
.slds-form--horizontal .slds-form-element:not(.slds-is-editing),
.slds-form_stacked .slds-form-element_horizontal:not(.slds-is-editing),
.slds-form--stacked .slds-form-element--horizontal:not(.slds-is-editing){
  padding:var(--slds-g-spacing-1);
}
.slds-form-element_horizontal .slds-form-element,.slds-form-element--horizontal .slds-form-element,
.slds-form_horizontal .slds-form-element .slds-form-element,
.slds-form--horizontal .slds-form-element .slds-form-element,
.slds-form_stacked .slds-form-element_horizontal .slds-form-element,
.slds-form--stacked .slds-form-element--horizontal .slds-form-element{
  padding:0;
  margin-block-end:0;
}
.slds-form-element_horizontal.slds-is-edited,.slds-form-element--horizontal.slds-is-edited,
.slds-form_horizontal .slds-form-element.slds-is-edited,
.slds-form--horizontal .slds-form-element.slds-is-edited,
.slds-form_stacked .slds-form-element_horizontal.slds-is-edited,
.slds-form--stacked .slds-form-element--horizontal.slds-is-edited{
  padding-block-start:calc(var(--slds-g-spacing-4) + var(--slds-g-spacing-1));
}
@media (min-width: 48em){
  .slds-form-element_horizontal.slds-form-element_1-col .slds-form-element__label,.slds-form-element--horizontal.slds-form-element--1-col .slds-form-element__label,
  .slds-form_horizontal .slds-form-element.slds-form-element_1-col .slds-form-element__label,
  .slds-form--horizontal .slds-form-element.slds-form-element--1-col .slds-form-element__label,
  .slds-form_stacked .slds-form-element_horizontal.slds-form-element_1-col .slds-form-element__label,
  .slds-form--stacked .slds-form-element--horizontal.slds-form-element--1-col .slds-form-element__label{
    max-width:calc((50% - 33.333%) - 1.25rem);
  }

  .slds-form-element_horizontal.slds-form-element_1-col .slds-form-element__control,.slds-form-element--horizontal.slds-form-element--1-col .slds-form-element__control,
  .slds-form_horizontal .slds-form-element.slds-form-element_1-col .slds-form-element__control,
  .slds-form--horizontal .slds-form-element.slds-form-element--1-col .slds-form-element__control,
  .slds-form_stacked .slds-form-element_horizontal.slds-form-element_1-col .slds-form-element__control,
  .slds-form--stacked .slds-form-element--horizontal.slds-form-element--1-col .slds-form-element__control{
    padding-inline-start:calc((50% - 33.333%) - (0.25rem * 2));
  }
}
@media (min-width: 48em){
  .slds-form-element_horizontal .slds-form-element__label,.slds-form-element--horizontal .slds-form-element__label,
  .slds-form_horizontal .slds-form-element .slds-form-element__label,
  .slds-form--horizontal .slds-form-element .slds-form-element__label,
  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__label,
  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__label{
    float:inline-start;
    max-width:calc(33% - 1.25rem);
    flex-basis:calc(33% - 1.25rem);
    margin-block-end:0;
    position:relative;
    z-index:1;
  }

  .slds-form-element_horizontal .slds-form-element__control,.slds-form-element--horizontal .slds-form-element__control,
  .slds-form_horizontal .slds-form-element .slds-form-element__control,
  .slds-form--horizontal .slds-form-element .slds-form-element__control,
  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__control,
  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__control{
    padding-inline-start:33%;
    clear:none;
  }

  .slds-form-element_horizontal .slds-form-element__control .slds-form-element__control,.slds-form-element--horizontal .slds-form-element__control .slds-form-element__control,
  .slds-form_horizontal .slds-form-element .slds-form-element__control .slds-form-element__control,
  .slds-form--horizontal .slds-form-element .slds-form-element__control .slds-form-element__control,
  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__control .slds-form-element__control,
  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__control .slds-form-element__control{
    padding-inline-start:0;
  }

  .slds-form-element_horizontal .slds-form-element__icon,.slds-form-element--horizontal .slds-form-element__icon,
  .slds-form_horizontal .slds-form-element .slds-form-element__icon,
  .slds-form--horizontal .slds-form-element .slds-form-element__icon,
  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__icon,
  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__icon{
    float:inline-start;
    padding-block-start:var(--slds-g-spacing-1);
  }

  .slds-form-element_horizontal .slds-checkbox_standalone,.slds-form-element--horizontal .slds-checkbox--standalone,
  .slds-form_horizontal .slds-form-element .slds-checkbox_standalone,
  .slds-form--horizontal .slds-form-element .slds-checkbox--standalone,
  .slds-form_stacked .slds-form-element_horizontal .slds-checkbox_standalone,
  .slds-form--stacked .slds-form-element--horizontal .slds-checkbox--standalone{
    padding-block:var(--slds-g-spacing-1);
    padding-inline:0;
  }

  .slds-form-element_horizontal .slds-checkbox:not(.slds-checkbox_stacked) .slds-form-element__label,.slds-form-element--horizontal .slds-checkbox:not(.slds-checkbox--stacked) .slds-form-element__label,
  .slds-form-element_horizontal .slds-radio .slds-form-element__label,
  .slds-form-element--horizontal .slds-radio .slds-form-element__label,
  .slds-form_horizontal
  .slds-form-element
  .slds-checkbox:not(.slds-checkbox_stacked)
  .slds-form-element__label,
  .slds-form--horizontal
  .slds-form-element
  .slds-checkbox:not(.slds-checkbox--stacked)
  .slds-form-element__label,
  .slds-form_horizontal .slds-form-element .slds-radio .slds-form-element__label,
  .slds-form--horizontal .slds-form-element .slds-radio .slds-form-element__label,
  .slds-form_stacked
  .slds-form-element_horizontal
  .slds-checkbox:not(.slds-checkbox_stacked)
  .slds-form-element__label,
  .slds-form--stacked
  .slds-form-element--horizontal
  .slds-checkbox:not(.slds-checkbox--stacked)
  .slds-form-element__label,
  .slds-form_stacked .slds-form-element_horizontal .slds-radio .slds-form-element__label,
  .slds-form--stacked .slds-form-element--horizontal .slds-radio .slds-form-element__label{
    position:relative;
    float:none;
    max-width:100%;
    width:auto;
  }

  .slds-form-element_horizontal .slds-form-element__row .slds-form-element__label,.slds-form-element--horizontal .slds-form-element__row .slds-form-element__label,
  .slds-form-element_horizontal .slds-form-element__row .slds-form-element__control,
  .slds-form-element--horizontal .slds-form-element__row .slds-form-element__control,
  .slds-form-element_horizontal .slds-dueling-list__column .slds-form-element__label,
  .slds-form-element--horizontal .slds-dueling-list__column .slds-form-element__label,
  .slds-form_horizontal .slds-form-element .slds-form-element__row .slds-form-element__label,
  .slds-form--horizontal .slds-form-element .slds-form-element__row .slds-form-element__label,
  .slds-form_horizontal .slds-form-element .slds-form-element__row .slds-form-element__control,
  .slds-form--horizontal .slds-form-element .slds-form-element__row .slds-form-element__control,
  .slds-form_horizontal .slds-form-element .slds-dueling-list__column .slds-form-element__label,
  .slds-form--horizontal .slds-form-element .slds-dueling-list__column .slds-form-element__label,
  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__row .slds-form-element__label,
  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__row .slds-form-element__label,
  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__row .slds-form-element__control,
  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__row .slds-form-element__control,
  .slds-form_stacked .slds-form-element_horizontal .slds-dueling-list__column .slds-form-element__label,
  .slds-form--stacked .slds-form-element--horizontal .slds-dueling-list__column .slds-form-element__label{
    width:auto;
    max-width:100%;
    flex-basis:auto;
    float:none;
    position:relative;
    padding-inline-start:0;
    margin-block-end:0;
  }

  .slds-form-element_horizontal .slds-dueling-list,.slds-form-element--horizontal .slds-dueling-list,
  .slds-form_horizontal .slds-form-element .slds-dueling-list,
  .slds-form--horizontal .slds-form-element .slds-dueling-list,
  .slds-form_stacked .slds-form-element_horizontal .slds-dueling-list,
  .slds-form--stacked .slds-form-element--horizontal .slds-dueling-list{
    clear:none;
  }

  .slds-form-element_horizontal .slds-input-has-icon_left .slds-input__icon,.slds-form-element--horizontal .slds-input-has-icon--left .slds-input__icon,
  .slds-form_horizontal .slds-form-element .slds-input-has-icon_left .slds-input__icon,
  .slds-form--horizontal .slds-form-element .slds-input-has-icon--left .slds-input__icon,
  .slds-form_stacked .slds-form-element_horizontal .slds-input-has-icon_left .slds-input__icon,
  .slds-form--stacked .slds-form-element--horizontal .slds-input-has-icon--left .slds-input__icon{
    inset-inline-start:calc(33% + 0.75rem);
  }

  .slds-form-element_horizontal .slds-input-has-icon_left-right .slds-input__icon_left,.slds-form-element--horizontal .slds-input-has-icon--left-right .slds-input__icon--left,
  .slds-form_horizontal .slds-form-element .slds-input-has-icon_left-right .slds-input__icon_left,
  .slds-form--horizontal .slds-form-element .slds-input-has-icon--left-right .slds-input__icon--left,
  .slds-form_stacked .slds-form-element_horizontal .slds-input-has-icon_left-right .slds-input__icon_left,
  .slds-form--stacked .slds-form-element--horizontal .slds-input-has-icon--left-right .slds-input__icon--left{
    inset-inline-start:calc(33% + 0.75rem);
  }
}
.slds-form-element_horizontal .slds-form-element__help,.slds-form-element--horizontal .slds-form-element__help,
.slds-form_horizontal .slds-form-element .slds-form-element__help,
.slds-form--horizontal .slds-form-element .slds-form-element__help,
.slds-form_stacked .slds-form-element_horizontal .slds-form-element__help,
.slds-form--stacked .slds-form-element--horizontal .slds-form-element__help{
  margin-inline-start:33%;
}
.slds-form-element_compound .slds-form-element__row,.slds-form-element--compound .slds-form-element__row{
  display:flex;
  margin-block-end:var(--slds-g-spacing-1);
  margin-inline-start:calc(var(--slds-g-spacing-1) * -1);
  margin-inline-end:calc(var(--slds-g-spacing-1) * -1);
}
.slds-form-element_compound .slds-form-element__row .slds-form-element__label,.slds-form-element--compound .slds-form-element__row .slds-form-element__label{
  padding-block-start:0;
}
.slds-form-element_compound .slds-form-element,.slds-form-element--compound .slds-form-element{
  padding-inline-start:var(--slds-g-spacing-1);
  padding-inline-end:var(--slds-g-spacing-1);
}
.slds-form_compound,.slds-form--compound{
  width:100%;
}
.slds-form_compound > .slds-form-element,.slds-form--compound > .slds-form-element{
  margin-block-start:0;
  margin-block-end:0;
  margin-inline-start:0;
  margin-inline-end:0;
}
.slds-form_compound .slds-form-element__row,.slds-form--compound .slds-form-element__row{
  display:flex;
  margin-block-start:0;
  margin-block-end:var(--slds-g-spacing-1);
  margin-inline-start:0;
  margin-inline-end:0;
}
.slds-form_compound .slds-form-element__row + .slds-form-element__row,.slds-form--compound .slds-form-element__row + .slds-form-element__row{
  clear:both;
}
.slds-form_compound .slds-form-element__row .slds-form-element,.slds-form--compound .slds-form-element__row .slds-form-element{
  margin-block-end:0;
}
.slds-form_compound .slds-form-element__row .slds-form-element + .slds-form-element,.slds-form--compound .slds-form-element__row .slds-form-element + .slds-form-element{
  padding-inline-start:var(--slds-g-spacing-2);
  margin-block-start:0;
}
.slds-form_compound .slds-form-element__row .slds-form-element__label,.slds-form--compound .slds-form-element__row .slds-form-element__label{
  padding-block-start:0;
}
.slds-form__row{
  display:flex;
  flex-wrap:wrap;
  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);
  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);
}
.slds-form__item{
  display:flex;
  flex:1 1;
  min-width:280px;
  padding-inline-start:var(--slds-g-spacing-3);
  padding-inline-end:var(--slds-g-spacing-3);
}
.slds-is-edited{
  background:var(--slds-g-color-palette-yellow-90);
}
.slds-is-edited .slds-form-element__undo{
  inset-block-start:-1.25rem;
  inset-inline-end:var(--slds-g-spacing-1);
}
.slds-form-element__undo{
  position:absolute;
  inset-block-start:0;
  inset-inline-end:0;
}
.slds-docked-form-footer{
  display:flex;
  justify-content:center;
  padding:var(--slds-g-spacing-2) 0;
  position:fixed;
  inset-block-end:0;
  inset-inline-start:0;
  width:100%;
  background-color:var(--slds-s-container-footer-color-background, var(--slds-g-color-surface-container-2));
  box-shadow:var(--slds-g-shadow-blockstart-2, 0 -2px 2px 0 rgba(0, 0, 0, 0.16));
  z-index:8000;
}
.slds-slider{
  display:flex;
  position:relative;
}
.slds-slider__range{
  appearance:none;
  width:100%;
  background:none;
  background-color:transparent;
  border-radius:var(--slds-g-radius-border-1);
}
.slds-slider__range:focus{
  outline:0;
}
.slds-slider__range::-webkit-slider-thumb{
  appearance:none;
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  border-radius:var(--slds-c-slider-thumb-radius-border, var(--slds-g-radius-border-circle));
  background:none;
  background-color:var(--slds-c-slider-thumb-color-foreground, var(--slds-g-color-accent-container-1));
  border:0;
  box-shadow:var(
    --slds-c-slider-thumb-shadow,
    var(--slds-g-color-neutral-base-10, rgba(0, 0, 0, 0.16) 0 2px 3px)
  );
  cursor:pointer;
  -webkit-transition:background 0.15s ease-in-out;
  transition:background 0.15s ease-in-out;
}
.slds-slider__range::-webkit-slider-thumb:hover{
  background-color:var(
    --slds-c-slider-thumb-color-foreground-hover,
    var(--slds-g-color-accent-container-2)
  );
}
.slds-slider__range::-webkit-slider-thumb{

  margin-top:calc(((var(--slds-g-sizing-5) / 2) - (var(--slds-g-sizing-2) / 2)) * -1);
}
.slds-slider__range::-webkit-slider-runnable-track{
  width:100%;
  height:var(--slds-g-sizing-2);
  cursor:pointer;
  background:none;
  background-color:var(--slds-c-slider-track-color-background, var(--slds-g-color-border-1));
  border-radius:var(--slds-c-slider-track-radius-border, var(--slds-g-radius-border-1));
}
.slds-slider__range::-moz-range-thumb{
  appearance:none;
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  border-radius:var(--slds-c-slider-thumb-radius-border, var(--slds-g-radius-border-circle));
  background:none;
  background-color:var(--slds-c-slider-thumb-color-foreground, var(--slds-g-color-accent-container-1));
  border:0;
  box-shadow:var(
    --slds-c-slider-thumb-shadow,
    var(--slds-g-color-neutral-base-10, rgba(0, 0, 0, 0.16) 0 2px 3px)
  );
  cursor:pointer;
  -moz-transition:background 0.15s ease-in-out;
  transition:background 0.15s ease-in-out;
}
.slds-slider__range::-moz-range-thumb:hover{
  background-color:var(
    --slds-c-slider-thumb-color-foreground-hover,
    var(--slds-g-color-accent-container-2)
  );
}
.slds-slider__range::-moz-range-track{
  width:100%;
  height:var(--slds-g-sizing-2);
  cursor:pointer;
  background:none;
  background-color:var(--slds-c-slider-track-color-background, var(--slds-g-color-border-1));
  border-radius:var(--slds-c-slider-track-radius-border, var(--slds-g-radius-border-1));
}
.slds-slider__range::-ms-track{
  width:100%;
  height:var(--slds-g-sizing-2);
  cursor:pointer;
  background:none;
  background-color:var(
    --slds-c-slider-track-color-background,
    var(--slds-g-color-neutral-base-95, var(--slds-g-color-surface-2))
  );
  border-radius:var(--slds-c-slider-track-radius-border, var(--slds-g-radius-border-1));
  border-color:transparent;
  color:transparent;
}
.slds-slider__range::-ms-thumb{
  width:100%;
  height:var(--slds-g-sizing-2);
  cursor:pointer;
  background:none;
  background-color:var(
    --slds-c-slider-track-color-background,
    var(--slds-g-color-neutral-base-95, var(--slds-g-color-surface-2))
  );
  border-radius:var(--slds-c-slider-track-radius-border, var(--slds-g-radius-border-1));
  margin-block-start:calc(var(--slds-g-sizing-2) / 4);
}
.slds-slider__range:focus::-webkit-slider-thumb{
  background-color:var(--slds-c-slider-thumb-color-foreground-focus, var(--slds-g-color-accent-container-2));
  box-shadow:var(--slds-c-slider-thumb-shadow-focus, var(--slds-s-button-shadow-focus));
}
.slds-slider__range:active::-webkit-slider-thumb{
  background-color:var(
    --slds-c-slider-thumb-color-foreground-active,
    var(--slds-g-color-accent-container-2)
  );
}
.slds-slider__range:focus::-moz-range-thumb{
  background-color:var(--slds-c-slider-thumb-color-foreground-focus, var(--slds-g-color-accent-container-2));
  box-shadow:var(--slds-c-slider-thumb-shadow-focus, var(--slds-s-button-shadow-focus));
}
.slds-slider__range:active::-moz-range-thumb{
  background-color:var(
    --slds-c-slider-thumb-color-foreground-active,
    var(--slds-g-color-accent-container-2)
  );
}
.slds-slider__range[disabled]::-webkit-slider-thumb{
  background-color:var(--slds-g-color-on-disabled-1);
  cursor:default;
}
.slds-slider__range[disabled]::-webkit-slider-runnable-track{
  background-color:var(--slds-g-color-border-disabled-1);
  cursor:default;
}
.slds-slider__range[disabled]::-moz-range-thumb{
  background-color:var(--slds-g-color-on-disabled-1);
  cursor:default;
}
.slds-slider__range[disabled]::-moz-range-track{
  background-color:var(--slds-g-color-border-disabled-1);
}
.slds-slider__range[disabled]::-ms-thumb{
  background-color:var(--slds-g-color-on-disabled-1);
  cursor:default;
}
.slds-slider__range[disabled]::-ms-track{
  background-color:var(--slds-g-color-border-disabled-1);
  cursor:default;
}
.slds-slider__value{
  padding-block:0;
  padding-inline:var(--slds-g-spacing-2);
}
.slds-slider-label__label{
  display:block;
}
.slds-slider_vertical,.slds-slider--vertical{
  height:calc(12rem + 1.875rem);
}
.slds-slider_vertical .slds-slider__range,.slds-slider--vertical .slds-slider__range{
  width:12rem;
  height:var(--slds-g-sizing-5);
  transform:rotate(-90deg);
  transform-origin:calc(12rem * 0.5) calc(12rem * 0.5);
}
.slds-slider_vertical .slds-slider__value,.slds-slider--vertical .slds-slider__value{
  position:absolute;
  inset-inline-start:0;
  inset-block-end:0;
  padding:0;
}
.slds-modal{
  opacity:0;
  visibility:hidden;
  transition:transform 0.1s linear, opacity 0.1s linear;
  position:fixed;
  inset-block-start:0;
  inset-inline-end:0;
  inset-block-end:0;
  inset-inline-start:0;
  z-index:9001;
}
.slds-modal .slds-modal__title{
  font-weight:var(--slds-c-modal-heading-font-weight, var(--slds-s-container-heading-font-weight));
  font-size:var(
    --slds-c-modal-heading-font-size,
    var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2))
  );
  line-height:var(--slds-g-font-lineheight-2);
}
.slds-modal__container{
  position:relative;
  transform:translate(0, 0);
  transition:transform 0.1s linear, opacity 0.1s linear;
  display:flex;
  flex-direction:column;
  justify-content:center;
  margin-block:0;
  margin-inline:var(--slds-g-spacing-6);
  height:100%;
  padding-block-start:var(--slds-g-spacing-8);
  padding-inline-end:0;
  padding-block-end:var(--slds-g-spacing-12);
  padding-inline-start:0;
  border-radius:var(--slds-g-radius-border-2);
}
@media (min-width: 48em){
  .slds-modal__container{
    margin-block:0;
    margin-inline:auto;
    width:50%;
    max-width:40rem;
    min-width:20rem;
  }
}
.slds-modal__header{
  position:relative;
  border-start-end-radius:var(
    --slds-c-modal-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  border-start-start-radius:var(
    --slds-c-modal-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  border-block-end-width:var(--slds-c-modal-sizing-border, var(--slds-g-sizing-border-2));
  border-block-end-style:solid;
  border-block-end-color:var(--slds-c-modal-color-border, var(--slds-g-color-border-1));
  background-color:var(
    --slds-c-modal-header-color-background,
    var(--slds-c-modal-color-background, var(--slds-g-color-surface-container-1))
  );
  color:var(--slds-c-modal-header-text-color, var(--slds-c-modal-text-color));
  flex-shrink:0;
  padding-block-start:var(--slds-c-modal-header-spacing-blockstart, var(--slds-g-spacing-4));
  padding-inline-end:var(--slds-c-modal-header-spacing-inlineend, var(--slds-g-spacing-4));
  padding-block-end:var(--slds-c-modal-header-spacing-blockend, var(--slds-g-spacing-4));
  padding-inline-start:var(--slds-c-modal-header-spacing-inlinestart, var(--slds-g-spacing-4));
  text-align:center;
}
.slds-modal__header + .slds-modal__menu{
  border-start-end-radius:0;
  border-start-start-radius:0;
}
.slds-modal__header .slds-modal__close{
  position:absolute;
  inset-block-start:calc(var(--slds-g-spacing-6) * -1.25);
  inset-inline-end:0;
  margin-inline-start:0;
  inset-block-end:0;
}
.slds-modal__close{
  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
  margin-inline-start:auto;
  position:relative;
  inset-block-end:var(--slds-g-spacing-2);
  background-color:var(--slds-g-color-surface-container-1);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
}
.slds-modal__close:hover,
.slds-modal__close:focus-visible,
.slds-modal__close:active{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-modal__content_headless,.slds-modal__content--headless,
.slds-modal__header_empty + .slds-modal__content,
.slds-modal__header--empty + .slds-modal__content{
  border-start-end-radius:var(
    --slds-c-modal-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  border-start-start-radius:var(
    --slds-c-modal-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
}
.slds-modal__content{
  background-color:var(
    --slds-c-modal-content-color-background,
    var(--slds-c-modal-color-background, var(--slds-g-color-surface-container-1))
  );
  color:var(
    --slds-c-modal-content-text-color,
    var(--slds-c-modal-text-color, var(--slds-s-container-content-color))
  );
  overflow:hidden;
  overflow-y:auto;
}
.slds-modal__content_footless,.slds-modal__content--footless,
.slds-modal__container > .slds-modal__content:last-child,
.slds-modal__content_has-hidden-footer,
.slds-modal__content--has-hidden-footer{
  border-end-end-radius:var(
    --slds-c-modal-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  border-end-start-radius:var(
    --slds-c-modal-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  box-shadow:var(--slds-c-modal-shadow, 0 2px 3px 0 rgba(0, 0, 0, 0.16));
}
.slds-modal__footer{
  border-end-end-radius:var(
    --slds-c-modal-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  border-end-start-radius:var(
    --slds-c-modal-radius-border,
    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))
  );
  border-block-start-width:var(--slds-c-modal-sizing-border, var(--slds-g-sizing-border-2));
  border-block-start-style:solid;
  border-block-start-color:var(--slds-c-modal-color-border, var(--slds-g-color-border-1));
  background-color:var(
    --slds-c-modal-footer-color-background,
    var(
      --slds-c-modal-color-background,
      var(--slds-s-container-footer-color-background, var(--slds-g-color-surface-container-2))
    )
  );
  color:var(--slds-c-modal-footer-text-color, var(--slds-c-modal-text-color));
  flex-shrink:0;
  padding-block-start:var(--slds-c-modal-footer-spacing-blockstart, var(--slds-g-spacing-3));
  padding-inline-end:var(--slds-c-modal-footer-spacing-inlineend, var(--slds-g-spacing-4));
  padding-block-end:var(--slds-c-modal-footer-spacing-blockend, var(--slds-g-spacing-3));
  padding-inline-start:var(--slds-c-modal-footer-spacing-inlinestart, var(--slds-g-spacing-4));
  text-align:right;
  box-shadow:var(--slds-c-modal-shadow, 0 2px 3px 0 rgba(0, 0, 0, 0.16));
}
.slds-modal__footer .slds-button + .slds-button{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-modal__footer_directional .slds-button:first-child,.slds-modal__footer--directional .slds-button:first-child{
  float:inline-start;
}
@media (min-width: 48em){
  .slds-modal_small .slds-modal__container,.slds-modal--small .slds-modal__container{
    width:60%;
    max-width:52.0625rem;
    min-width:40rem;
  }
}
@media (min-width: 48em){
  .slds-modal_medium .slds-modal__container,.slds-modal--medium .slds-modal__container{
    width:70%;
    max-width:75rem;
    min-width:40rem;
  }
}
@media (min-width: 48em){
  .slds-modal_large .slds-modal__container,.slds-modal--large .slds-modal__container{
    width:90%;
    max-width:none;
    min-width:40rem;
  }
}
@media (min-width: 48em){
  .slds-modal_full .slds-modal__container,.slds-modal--full .slds-modal__container{
    width:90%;
    max-width:none;
    min-width:40rem;
  }
}
@media (max-width: 30em){
  .slds-modal_full,.slds-modal--full{
    inset-block-start:env(safe-area-inset-top, 0);
    inset-block-end:auto;
    height:calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  }

  .slds-modal_full .slds-modal__header,.slds-modal--full .slds-modal__header{
    grid-area:header;
    border-start-start-radius:0;
    border-start-end-radius:0;
  }

  .slds-modal_full .slds-modal__container,.slds-modal--full .slds-modal__container{
    width:100%;
    max-width:none;
    min-width:0;
    margin:0;
    padding-block-start:var(--slds-g-spacing-4);
    padding-inline-end:0;
    padding-block-end:0;
    padding-inline-start:0;
    background-color:var(
      --slds-c-modal-header-color-background,
      var(--slds-c-modal-color-background, var(--slds-g-color-surface-container-1))
    );
    border-radius:0;
    display:grid;
    height:100dvh;
    grid-template-rows:min-content min-content 1fr min-content;
    grid-template-areas:'close' 'header' 'content' 'footer';
    grid-template-columns:1fr;
  }

  .slds-modal_full .slds-modal__content_footless,.slds-modal--full .slds-modal__content--footless,
  .slds-modal_full .slds-modal__container > .slds-modal__content:last-child,
  .slds-modal--full .slds-modal__container > .slds-modal__content:last-child,
  .slds-modal_full .slds-modal__content_has-hidden-footer,
  .slds-modal--full .slds-modal__content--has-hidden-footer{
    border-end-end-radius:0;
    border-end-start-radius:0;
    box-shadow:none;
  }

  .slds-modal_full .slds-modal__close,.slds-modal--full .slds-modal__close{
    grid-area:close;
    inset-inline-end:var(--slds-g-spacing-4);
    color:var(--slds-g-color-on-surface-1);

    --slds-c-button-color-background:var(--slds-g-color-surface-1);
    --slds-c-button-color-background-active:var(--slds-g-color-surface-1);
  }

  .slds-modal_full .slds-modal__close:hover,.slds-modal--full .slds-modal__close:hover,
  .slds-modal_full .slds-modal__close:focus,
  .slds-modal--full .slds-modal__close:focus{
    color:var(--slds-g-color-on-surface-1);
  }

  .slds-modal_full .slds-modal__content,.slds-modal--full .slds-modal__content{
    grid-area:content;
  }

  .slds-modal_full .slds-modal__footer,.slds-modal--full .slds-modal__footer{
    grid-area:footer;
    border-end-end-radius:0;
    border-end-start-radius:0;
    box-shadow:none;
  }
}
.slds-modal_full lightning-button-icon + div,.slds-modal--full lightning-button-icon + div,
.slds-modal_full lightning-modal,
.slds-modal--full lightning-modal,
.slds-modal_full lightning-modal-header,
.slds-modal--full lightning-modal-header,
.slds-modal_full lightning-modal-body,
.slds-modal--full lightning-modal-body,
.slds-modal_full lightning-modal-footer,
.slds-modal--full lightning-modal-footer{
  display:contents;
}
.slds-backdrop{
  transition-duration:0.4s;
  width:100%;
  height:100%;
  opacity:0;
  visibility:hidden;
  position:fixed;
  inset-block-start:0;
  inset-inline-end:0;
  inset-block-end:0;
  inset-inline-start:0;
  background:var(--slds-s-backdrop-color-background);
  z-index:9000;
  backdrop-filter:blur(5px);
}
.slds-backdrop_open,.slds-backdrop--open{
  visibility:visible;
  opacity:1;
  transition:opacity 0.4s linear;
}
.slds-fade-in-open{
  opacity:1;
  visibility:visible;
  transition:opacity 0.1s linear;
}
.slds-fade-in-open .slds-modal__container-reset{
  opacity:1;
  visibility:visible;
  transform:translate(0, 0);
}
.slds-slide-up-open{
  opacity:1;
  visibility:visible;
  transform:translate(0, 0);
  transition:opacity 0.1s linear, transform 0.2s linear;
}
.slds-slide-up-open .slds-modal__container-reset{
  opacity:0;
  visibility:hidden;
  transform:translate(0, 1rem);
  transition:opacity 0.2s linear, transform 0.2s linear;
}
.slds-slide-up-saving{
  opacity:1;
  visibility:visible;
  transform:translate(0, -1rem);
}
.slds-slide-down-cancel{
  opacity:1;
  visibility:visible;
  transform:translate(0, 1rem);
}
.slds-modal__header_empty,.slds-modal__header--empty{
  --slds-c-modal-header-spacing-blockstart:0;
  --slds-c-modal-header-spacing-blockend:0;
  --slds-c-modal-header-spacing-inlinestart:0;
  --slds-c-modal-header-spacing-inlineend:0;
  --slds-c-modal-sizing-border:0;
}
.slds-modal_prompt .slds-modal__header,.slds-modal--prompt .slds-modal__header{
  border-block-end:0;
  text-align:var(--slds-s-container-heading-font-align, center);
  font-size:var(--slds-s-container-heading-font-size);
  font-weight:var(--slds-s-container-heading-font-weight);
}
.slds-modal_prompt .slds-modal__content,.slds-modal--prompt .slds-modal__content{
  padding-inline-start:var(--slds-g-spacing-6);
  padding-inline-end:var(--slds-g-spacing-6);
}
.slds-modal_prompt .slds-modal__footer,.slds-modal--prompt .slds-modal__footer{
  border-block-start-width:var(--slds-s-container-footer-sizing-border, 0);
  text-align:var(--slds-s-container-footer-font-align, center);
}
.slds-input{
  display:inline-block;
  padding-block-start:0;
  padding-inline-end:var(--slds-c-input-spacing-inlineend, var(--slds-s-input-spacing));
  padding-block-end:0;
  padding-inline-start:var(--slds-c-input-spacing-inlinestart, var(--slds-s-input-spacing));
  width:100%;
  line-height:1.875rem;
  border:1px solid var(--slds-c-input-color-border, var(--slds-s-input-color-border));
  border-radius:var(--slds-c-input-radius-border, var(--slds-s-input-radius-border));
  background-color:var(--slds-c-input-color-background, var(--slds-g-color-surface-container-1));
  color:var(--slds-c-input-text-color, var(--slds-s-input-color, var(--slds-g-color-on-surface-3)));
  box-shadow:var(--slds-c-input-shadow);
}
.slds-input:focus{
  --slds-c-input-color-border:var(
    --slds-c-input-color-border-focus,
    var(--slds-s-input-color-border-focus)
  );
  --slds-c-input-background-color:var(--slds-c-input-color-background-focus, revert);
  --slds-c-input-text-color:var(--slds-c-input-text-color-focus, revert);

  outline:0;
}
.slds-input:focus-visible{
  --slds-c-input-shadow:var(--slds-c-input-shadow-focus, var(--slds-s-input-shadow-focus));

  outline:0;
}
.slds-input:focus:valid{
  background-color:revert;
  color:revert;
}
.slds-input[disabled],
.slds-input.slds-is-disabled{
  background-color:var(--slds-s-input-color-background-disabled, var(--slds-g-color-disabled-container-1));
  border-color:var(--slds-s-input-color-border-disabled, var(--slds-g-color-border-disabled-1));
  color:var(--slds-s-input-color-disabled, var(--slds-g-color-on-disabled-2));
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
}
.slds-input[disabled]:focus,
.slds-input[disabled]:active,
.slds-input.slds-is-disabled:focus,
.slds-input.slds-is-disabled:active{
  box-shadow:none;
}
.slds-input[readonly]{
  --slds-c-input-spacing-inlinestart:0;
  --slds-c-input-color-border:transparent;
  --slds-c-input-color-background:transparent;
  --slds-c-input-shadow:none;
}
.slds-input[type='search']::-ms-clear{
  display:none;
  width:0;
  height:0;
}
.slds-input[type='search']::-webkit-search-decoration,
.slds-input[type='search']::-webkit-search-cancel-button,
.slds-input[type='search']::-webkit-search-results-button,
.slds-input[type='search']::-webkit-search-results-decoration{
  display:none;
}
.slds-input[type='url'],
.slds-input[type='tel'],
.slds-input[type='email']{
  direction:ltr;
  text-align:left;
}
.slds-input_bare,.slds-input--bare{
  --slds-c-input-color-background:transparent;
  --slds-c-input-spacing-inlineend:0;
  --slds-c-input-spacing-inlinestart:var(--slds-s-input-spacing);

  border:0;
}
.slds-input_bare:focus,.slds-input--bare:focus,
.slds-input_bare:active,
.slds-input--bare:active{
  --slds-c-input-shadow-focus:none;
}
.slds-input_height,.slds-input--height{
  min-height:calc(1.875rem + 2px);
}
.slds-input_faux,.slds-input--faux{
  padding-block-start:0;
  padding-inline-end:var(--slds-c-input-spacing-inlineend, var(--slds-s-input-spacing));
  padding-block-end:0;
  padding-inline-start:var(--slds-c-input-spacing-inlinestart, var(--slds-s-input-spacing));
  width:100%;
  line-height:1.875rem;
  border:1px solid var(--slds-c-input-color-border, var(--slds-s-input-color-border));
  border-radius:var(--slds-c-input-radius-border, var(--slds-s-input-radius-border));
  background-color:var(--slds-c-input-color-background, var(--slds-g-color-surface-container-1));
  color:var(--slds-c-input-text-color, var(--slds-s-input-color, var(--slds-g-color-on-surface-3)));
  box-shadow:var(--slds-c-input-shadow);
  display:inline-flex;
  flex:1 1 auto;
  text-align:left;
}
.slds-input_faux.slds-is-disabled,.slds-input--faux.slds-is-disabled{
  background-color:var(--slds-s-input-color-background-disabled, var(--slds-g-color-disabled-container-1));
  border-color:var(--slds-s-input-color-border-disabled, var(--slds-g-color-border-disabled-1));
  color:var(--slds-s-input-color-disabled, var(--slds-g-color-on-disabled-2));
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
}
.slds-input_faux.slds-is-disabled:focus,.slds-input--faux.slds-is-disabled:focus,
.slds-input_faux.slds-is-disabled:active,
.slds-input--faux.slds-is-disabled:active{
  box-shadow:none;
}
.slds-input_faux > span::before,.slds-input--faux > span::before{
  content:'';
  display:inline-block;
}
.slds-input_borders[readonly],.slds-input--borders[readonly]{
  --slds-c-input-spacing-inlinestart:var(--slds-s-input-spacing);
  --slds-c-input-color-border:var(--slds-s-input-color-border);
}
.slds-input-has-icon{
  position:relative;
}
.slds-input-has-icon .slds-input__icon{
  width:0.875rem;
  height:0.875rem;
  position:absolute;
  top:50%;
  margin-top:calc((0.875rem * 0.5) * -1);
  line-height:1;
  border:0;
  z-index:2;
}
.slds-input-has-icon_left .slds-input__icon,.slds-input-has-icon--left .slds-input__icon{
  left:var(--slds-g-spacing-2);
}
.slds-input-has-icon_left .slds-input,.slds-input-has-icon--left .slds-input,
.slds-input-has-icon_left .slds-input_faux,
.slds-input-has-icon--left .slds-input--faux,
.slds-input-has-icon_left .slds-input_bare,
.slds-input-has-icon--left .slds-input--bare{
  --slds-c-input-spacing-inlinestart:var(--slds-g-spacing-6);
}
.slds-input-has-icon_right .slds-input__icon,.slds-input-has-icon--right .slds-input__icon{
  inset-inline-end:var(--slds-g-spacing-2);
}
.slds-input-has-icon_right .slds-input,.slds-input-has-icon--right .slds-input,
.slds-input-has-icon_right .slds-input_faux,
.slds-input-has-icon--right .slds-input--faux,
.slds-input-has-icon_right .slds-input_bare,
.slds-input-has-icon--right .slds-input--bare{
  --slds-c-input-spacing-inlineend:var(--slds-g-spacing-6);
}
.slds-input-has-icon_left-right .slds-input__icon_left,.slds-input-has-icon--left-right .slds-input__icon--left{
  left:var(--slds-g-spacing-2);
}
.slds-input-has-icon_left-right .slds-input__icon_right,.slds-input-has-icon--left-right .slds-input__icon--right{
  inset-inline-end:var(--slds-g-spacing-2);
}
.slds-input-has-icon_left-right .slds-input,.slds-input-has-icon--left-right .slds-input,
.slds-input-has-icon_left-right .slds-input_faux,
.slds-input-has-icon--left-right .slds-input--faux,
.slds-input-has-icon_left-right .slds-input_bare,
.slds-input-has-icon--left-right .slds-input--bare{
  --slds-c-input-spacing-inlinestart:var(--slds-g-spacing-6);
  --slds-c-input-spacing-inlineend:var(--slds-g-spacing-6);
}
.slds-input-has-icon_group-right .slds-input,.slds-input-has-icon--group-right .slds-input,
.slds-input-has-icon_group-right .slds-input_faux,
.slds-input-has-icon--group-right .slds-input--faux,
.slds-input-has-icon_group-right .slds-input_bare,
.slds-input-has-icon--group-right .slds-input--bare{
  --slds-c-input-spacing-inlineend:calc(var(--slds-g-spacing-6) + var(--slds-g-spacing-2));
}
.slds-input__icon-group{
  position:absolute;
  margin-top:calc((var(--slds-g-spacing-4) * var(--slds-g-spacing-2)) * -1);
}
.slds-input__icon-group_right,.slds-input__icon-group--right{
  inset-inline-end:0;
  inset-block-start:50%;
}
.slds-input__icon-group_right .slds-input__icon_right,.slds-input__icon-group--right .slds-input__icon--right{
  inset-inline-end:var(--slds-g-spacing-2);
}
.slds-input__icon-group_right .slds-input__spinner,.slds-input__icon-group--right .slds-input__spinner{
  inset-inline-end:var(--slds-g-spacing-5);
  inset-inline-start:auto;
}
.slds-input-has-fixed-addon{
  display:flex;
}
.slds-has-error .slds-input{
  --slds-c-input-color-background:var(--slds-s-input-color-background-invalid);
  --slds-c-input-color-border:var(--slds-g-color-border-error-1);
  --slds-c-input-text-color:var(--slds-s-input-color-invalid);

  background-clip:padding-box;
}
.slds-has-error .slds-input__icon{
  fill:var(--slds-g-color-error-1);
  color:var(--slds-g-color-error-1);
}
.slds-textarea{
  min-height:var(--slds-c-textarea-sizing-height-min);
  width:100%;
  padding-block-start:var(--slds-c-textarea-spacing-blockstart, var(--slds-g-spacing-2));
  padding-inline-end:var(--slds-c-textarea-spacing-inlineend, var(--slds-g-spacing-3));
  padding-block-end:var(--slds-c-textarea-spacing-blockend, var(--slds-g-spacing-2));
  padding-inline-start:var(--slds-c-textarea-spacing-inlinestart, var(--slds-g-spacing-3));
  background-color:var(--slds-c-textarea-color-background, var(--slds-g-color-surface-container-1));
  color:var(--slds-c-textarea-text-color, var(--slds-s-input-color, var(--slds-g-color-on-surface-3)));
  border:1px solid var(--slds-c-textarea-color-border, var(--slds-s-input-color-border));
  border-radius:var(--slds-c-textarea-radius-border, var(--slds-s-input-radius-border));
  box-shadow:var(--slds-c-textarea-shadow, var(--slds-s-input-shadow));
  font:inherit;
  resize:vertical;
  transition:border 0.1s linear, background-color 0.1s linear;
}
.slds-textarea:required{
  --slds-c-textarea-shadow:none;
}
.slds-textarea:focus,
.slds-textarea:active{
  outline:0;
  --slds-c-textarea-color-border:var(--slds-s-input-color-border-focus);
  --slds-c-textarea-text-color:var(--slds-c-textarea-text-color-focus, revert);

  background-color:var(--slds-c-textarea-color-background-focus, var(--slds-g-color-surface-container-1));
}
.slds-textarea:focus-visible{
  --slds-c-textarea-shadow:var(--slds-c-textarea-shadow-focus, var(--slds-s-input-shadow-focus));

  outline:0;
}
.slds-textarea:focus:invalid{
  background-color:var(--slds-s-input-color-background-invalid);
  color:var(--slds-s-input-color-invalid);
  border-color:var(--slds-g-color-border-error-1);
}
.slds-textarea:focus:valid{
  background-color:revert;
  color:revert;
}
.slds-textarea[disabled],
.slds-textarea.slds-is-disabled{
  background-color:var(--slds-s-input-color-background-disabled, var(--slds-g-color-disabled-container-1));
  border-color:var(--slds-s-input-color-border-disabled, var(--slds-g-color-border-disabled-1));
  color:var(--slds-s-input-color-disabled, var(--slds-g-color-on-disabled-2));
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
}
.slds-textarea[disabled]:focus,
.slds-textarea[disabled]:active,
.slds-textarea.slds-is-disabled:focus,
.slds-textarea.slds-is-disabled:active{
  box-shadow:none;
}
.slds-has-error .slds-textarea{
  --slds-c-textarea-color-border:var(--slds-g-color-border-error-1);
  --slds-c-textarea-color-background:var(--slds-s-input-color-background-invalid);

  background-clip:padding-box;
}
.slds-has-error .slds-textarea:focus,
.slds-has-error .slds-textarea:active{
  --slds-c-textarea-text-color-focus:var(--slds-c-textarea-text-color-error-focus);

  --slds-c-textarea-color-background-focus:var(
    --slds-c-textarea-color-background-error-focus,
    var(--slds-g-color-surface-container-1)
  );
}
.slds-checkbox_toggle,.slds-checkbox--toggle{
  width:100%;
}
.slds-checkbox_toggle .slds-checkbox_faux,.slds-checkbox--toggle .slds-checkbox--faux{
  display:block;
  position:relative;
  width:var(--slds-g-sizing-10);
  height:var(--slds-g-sizing-7);
  border-width:var(--slds-g-sizing-border-1);
  border-style:solid;
  border-color:var(--slds-c-checkbox-toggle-color-border, var(--slds-g-color-neutral-base-60));
  padding:var(--slds-g-spacing-1);
  background-color:var(--slds-c-checkbox-toggle-color-background, var(--slds-g-color-neutral-base-60));
  border-radius:var(--slds-c-checkbox-toggle-radius-border, var(--slds-g-radius-border-pill));
  box-shadow:var(--slds-c-checkbox-toggle-shadow, var(--slds-s-mark-shadow-checked));
  transition:background-color 0.2s cubic-bezier(0.75, 0, 0.08, 1);
}
.slds-checkbox_toggle .slds-checkbox_faux:hover,.slds-checkbox--toggle .slds-checkbox--faux:hover,
.slds-checkbox_toggle .slds-checkbox_faux:focus,
.slds-checkbox--toggle .slds-checkbox--faux:focus{
  --slds-c-checkbox-toggle-color-background:var(
    --slds-c-checkbox-toggle-color-background-hover,
    var(--slds-g-color-neutral-base-50)
  );
  --slds-c-checkbox-toggle-color-border:var(--slds-c-checkbox-toggle-color-border-hover);

  cursor:pointer;
}
.slds-checkbox_toggle .slds-checkbox_faux::after,.slds-checkbox--toggle .slds-checkbox--faux::after{
  content:'';
  position:absolute;
  top:1px;
  left:1px;
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
  background-color:var(
    --slds-c-checkbox-toggle-switch-color-background,
    var(--slds-g-color-on-accent-1)
  );
  border-radius:var(--slds-c-checkbox-toggle-radius-border, var(--slds-g-radius-border-pill));
}
.slds-checkbox_toggle [type='checkbox'],.slds-checkbox--toggle [type='checkbox']{
  width:1px;
  height:1px;
  border:0;
  clip:rect(0 0 0 0);
  margin:-1px;
  overflow:hidden;
  padding:0;
  position:absolute;
}
.slds-checkbox_toggle [type='checkbox'] + .slds-checkbox_faux_container,.slds-checkbox--toggle [type='checkbox'] + .slds-checkbox--faux_container{
  font-size:var(--slds-g-font-scale-neg-2);
  color:var(--slds-g-color-on-surface-1);
}
.slds-checkbox_toggle [type='checkbox'] + .slds-checkbox_faux_container .slds-checkbox_off,.slds-checkbox--toggle [type='checkbox'] + .slds-checkbox--faux_container .slds-checkbox--off{
  display:block;
}
.slds-checkbox_toggle [type='checkbox'] + .slds-checkbox_faux_container .slds-checkbox_on,.slds-checkbox--toggle [type='checkbox'] + .slds-checkbox--faux_container .slds-checkbox--on{
  display:none;
}
.slds-checkbox_toggle [type='checkbox']:focus-visible + .slds-checkbox_faux,.slds-checkbox--toggle [type='checkbox']:focus-visible + .slds-checkbox--faux,
.slds-checkbox_toggle [type='checkbox']:focus-visible ~ .slds-checkbox_faux,
.slds-checkbox--toggle [type='checkbox']:focus-visible ~ .slds-checkbox--faux,
.slds-checkbox_toggle [type='checkbox']:focus-visible + .slds-checkbox_faux_container .slds-checkbox_faux,
.slds-checkbox--toggle [type='checkbox']:focus-visible + .slds-checkbox--faux_container .slds-checkbox--faux{
  --slds-c-checkbox-toggle-color-background:var(--slds-g-color-neutral-base-50);
  --slds-c-checkbox-toggle-shadow:var(--slds-s-mark-shadow-focus);
}
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_off,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--off{
  display:none;
}
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_on,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--on{
  display:block;
}
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux,
.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux,
.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux,
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux,
.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux{
  --slds-c-checkbox-toggle-color-border:var(--slds-g-color-border-accent-1);
  --slds-c-checkbox-toggle-color-background:var(--slds-g-color-accent-container-1);
}
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux:hover,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux:hover,
.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux:hover,
.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux:hover,
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux:hover,
.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux:hover,
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux:focus,
.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux:focus,
.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux:focus,
.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux:focus,
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux:focus,
.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux:focus{
  --slds-c-checkbox-toggle-color-background:var(--slds-g-color-accent-container-2);
}
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux::before,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux::before,
.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux::before,
.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux::before,
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux::before,
.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux::before{
  content:'';
  position:absolute;
  top:1px;
  right:1px;
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
  background-color:var(
    --slds-c-checkbox-toggle-switch-color-background-checked,
    var(--slds-c-checkbox-toggle-switch-color-background, var(--slds-g-color-on-accent-1))
  );
  border-radius:var(--slds-c-checkbox-toggle-radius-border, var(--slds-g-radius-border-pill));
  transition:transform 0.2s cubic-bezier(0.75, 0, 0.08, 1);
}
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux::after,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux::after,
.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux::after,
.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux::after,
.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux::after,
.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux::after{
  --slds-c-checkbox-toggle-switch-color-background:transparent;
  --slds-c-checkbox-toggle-radius-border:0;

  content:' ';
  position:absolute;
  top:0.25rem;
  left:0.6rem;
  height:0.7rem;
  width:0.45rem;
  border-bottom-width:var(--slds-g-sizing-border-2);
  border-bottom-style:solid;
  border-bottom-color:var(
    --slds-c-checkbox-toggle-mark-color-foreground,
    var(--slds-g-color-surface-container-1)
  );
  /*! @noflip */
  border-right-width:var(--slds-g-sizing-border-2);
  border-right-style:solid;
  border-right-color:var(
    --slds-c-checkbox-toggle-mark-color-foreground,
    var(--slds-g-color-surface-container-1)
  );
  transform:rotate(45deg);
}
.slds-checkbox_toggle [type='checkbox']:checked:focus + .slds-checkbox_faux,.slds-checkbox--toggle [type='checkbox']:checked:focus + .slds-checkbox--faux,
.slds-checkbox_toggle [type='checkbox']:checked:focus ~ .slds-checkbox_faux,
.slds-checkbox--toggle [type='checkbox']:checked:focus ~ .slds-checkbox--faux,
.slds-checkbox_toggle [type='checkbox']:checked:focus + .slds-checkbox_faux_container .slds-checkbox_faux,
.slds-checkbox--toggle [type='checkbox']:checked:focus + .slds-checkbox--faux_container .slds-checkbox--faux{
  --slds-c-checkbox-toggle-color-background:var(
    --slds-c-checkbox-toggle-color-background-checked-focus,
    var(--slds-g-color-accent-container-2)
  );
}
.slds-checkbox_toggle [type='checkbox'][disabled] + .slds-checkbox_faux,.slds-checkbox--toggle [type='checkbox'][disabled] + .slds-checkbox--faux,
.slds-checkbox_toggle [type='checkbox'][disabled] ~ .slds-checkbox_faux,
.slds-checkbox--toggle [type='checkbox'][disabled] ~ .slds-checkbox--faux,
.slds-checkbox_toggle [type='checkbox'][disabled] + .slds-checkbox_faux_container .slds-checkbox_faux,
.slds-checkbox--toggle [type='checkbox'][disabled] + .slds-checkbox--faux_container .slds-checkbox--faux{
  background-color:var(--slds-g-color-disabled-container-2);
  border-color:var(--slds-g-color-border-disabled-1);
  pointer-events:none;
}
.slds-checkbox_toggle [type='checkbox'][disabled] + .slds-checkbox_faux_container .slds-checkbox_faux::before,.slds-checkbox--toggle [type='checkbox'][disabled] + .slds-checkbox--faux_container .slds-checkbox--faux::before{
  background-color:var(--slds-g-color-on-disabled-2);
}
.slds-checkbox_toggle [type='checkbox'][disabled] + .slds-checkbox_faux_container .slds-checkbox_faux::after,.slds-checkbox--toggle [type='checkbox'][disabled] + .slds-checkbox--faux_container .slds-checkbox--faux::after{
  background-color:var(--slds-g-color-on-disabled-2);
}
.slds-checkbox_toggle [type='checkbox']:checked[disabled] + .slds-checkbox_faux_container .slds-checkbox_faux::after,.slds-checkbox--toggle [type='checkbox']:checked[disabled] + .slds-checkbox--faux_container .slds-checkbox--faux::after{
  background-color:transparent;
  border-color:var(--slds-g-color-on-disabled-2);
}
.slds-checkbox_add-button .slds-checkbox_faux,.slds-checkbox--add-button .slds-checkbox--faux{
  width:var(--slds-g-spacing-6);
  height:var(--slds-g-spacing-6);
  position:relative;
  display:inline-block;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  background-color:var(--slds-g-color-surface-container-1);
  cursor:pointer;
}
.slds-checkbox_add-button .slds-checkbox_faux::before,.slds-checkbox--add-button .slds-checkbox--faux::before,
.slds-checkbox_add-button .slds-checkbox_faux::after,
.slds-checkbox--add-button .slds-checkbox--faux::after{
  content:'';
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  height:14px;
  width:2px;
  margin:auto;
  background-color:var(--slds-s-button-color, var(--slds-g-color-accent-3));
}
.slds-checkbox_add-button .slds-checkbox_faux::after,.slds-checkbox--add-button .slds-checkbox--faux::after{
  width:14px;
  height:2px;
}
.slds-checkbox_add-button .slds-checkbox_faux:hover:not([disabled]),.slds-checkbox--add-button .slds-checkbox--faux:hover:not([disabled]),
.slds-checkbox_add-button .slds-checkbox_faux:focus:not([disabled]),
.slds-checkbox--add-button .slds-checkbox--faux:focus:not([disabled]),
.slds-checkbox_add-button .slds-checkbox_faux:active:not([disabled]),
.slds-checkbox--add-button .slds-checkbox--faux:active:not([disabled]){
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-checkbox_add-button .slds-checkbox_faux:active:not([disabled]),.slds-checkbox--add-button .slds-checkbox--faux:active:not([disabled]){
  box-shadow:var(--slds-s-button-shadow-active);
}
.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux,.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux,
.slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux,
.slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux{
  border-color:transparent;
  background-color:var(--slds-g-color-accent-container-1);
  box-shadow:var(--slds-s-mark-shadow-checked);
}
.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux::before,.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux::before,
.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux::after,
.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux::after,
.slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux::before,
.slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux::before,
.slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux::after,
.slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux::after{
  background-color:var(--slds-g-color-on-accent-1);
}
.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux::before,.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux::before, .slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux::before, .slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux::before{
  left:5px;
  width:2px;
  height:16px;
  transform:rotate(40deg);
}
.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux::after,.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux::after, .slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux::after, .slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux::after{
  top:5px;
  left:-10px;
  width:9px;
  height:2px;
  transform:rotate(40deg);
}
.slds-checkbox_add-button [type='checkbox']:checked:not([disabled]) ~ .slds-checkbox_faux:hover,.slds-checkbox--add-button [type='checkbox']:checked:not([disabled]) ~ .slds-checkbox--faux:hover,
.slds-checkbox_add-button [type='checkbox']:checked:not([disabled]) + .slds-checkbox_faux:hover,
.slds-checkbox--add-button [type='checkbox']:checked:not([disabled]) + .slds-checkbox--faux:hover{
  background-color:var(--slds-g-color-accent-container-2);
}
.slds-checkbox_add-button [type='checkbox']:focus-visible ~ .slds-checkbox_faux,.slds-checkbox--add-button [type='checkbox']:focus-visible ~ .slds-checkbox--faux,
.slds-checkbox_add-button [type='checkbox']:focus-visible + .slds-checkbox_faux,
.slds-checkbox--add-button [type='checkbox']:focus-visible + .slds-checkbox--faux{
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-checkbox_add-button [type='checkbox'][disabled] ~ .slds-checkbox_faux,.slds-checkbox--add-button [type='checkbox'][disabled] ~ .slds-checkbox--faux,
.slds-checkbox_add-button [type='checkbox'][disabled] + .slds-checkbox_faux,
.slds-checkbox--add-button [type='checkbox'][disabled] + .slds-checkbox--faux{
  background-color:var(--slds-g-color-disabled-container-1);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-1);
  cursor:default;
}
.slds-checkbox_add-button [type='checkbox'][disabled] ~ .slds-checkbox_faux::before,.slds-checkbox--add-button [type='checkbox'][disabled] ~ .slds-checkbox--faux::before,
.slds-checkbox_add-button [type='checkbox'][disabled] + .slds-checkbox_faux::before,
.slds-checkbox--add-button [type='checkbox'][disabled] + .slds-checkbox--faux::before,
.slds-checkbox_add-button [type='checkbox'][disabled] ~ .slds-checkbox_faux::after,
.slds-checkbox--add-button [type='checkbox'][disabled] ~ .slds-checkbox--faux::after,
.slds-checkbox_add-button [type='checkbox'][disabled] + .slds-checkbox_faux::after,
.slds-checkbox--add-button [type='checkbox'][disabled] + .slds-checkbox--faux::after{
  background-color:var(--slds-g-color-on-disabled-1);
}
.slds-checkbox_add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux,.slds-checkbox--add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux,
.slds-checkbox_add-button [type='checkbox'][disabled]:checked + .slds-checkbox_faux,
.slds-checkbox--add-button [type='checkbox'][disabled]:checked + .slds-checkbox--faux{
  background-color:var(--slds-g-color-disabled-container-2);
}
.slds-checkbox_add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux::before,.slds-checkbox--add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux::before,
.slds-checkbox_add-button [type='checkbox'][disabled]:checked + .slds-checkbox_faux::before,
.slds-checkbox--add-button [type='checkbox'][disabled]:checked + .slds-checkbox--faux::before,
.slds-checkbox_add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux::after,
.slds-checkbox--add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux::after,
.slds-checkbox_add-button [type='checkbox'][disabled]:checked + .slds-checkbox_faux::after,
.slds-checkbox--add-button [type='checkbox'][disabled]:checked + .slds-checkbox--faux::after{
  background-color:var(--slds-g-color-on-disabled-2);
}
.slds-checkbox-button{
  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
  display:inline-flex;
  align-items:center;
  justify-content:center;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-radius:var(--slds-s-button-radius-border);
  color:var(--slds-s-button-color);
  cursor:pointer;
}
.slds-checkbox-button .slds-icon{
  --slds-c-icon-color-foreground:currentColor;
}
.slds-checkbox-button_is-checked,.slds-checkbox-button--is-checked{
  background-color:var(--slds-g-color-accent-container-1);
  border-color:transparent;
  color:var(--slds-g-color-on-accent-1);
  box-shadow:var(--slds-s-mark-shadow-checked);
}
.slds-checkbox-button_is-disabled,.slds-checkbox-button--is-disabled{
  background-color:var(--slds-g-color-disabled-container-1);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-2);
  cursor:default;
}
.slds-checkbox-button_is-disabled.slds-checkbox-button_is-checked,.slds-checkbox-button--is-disabled.slds-checkbox-button--is-checked{
  background-color:var(--slds-g-color-disabled-container-2);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-2);
  box-shadow:var(--slds-s-mark-shadow-checked);
}
.slds-checkbox-button_is-focused,.slds-checkbox-button--is-focused{
  outline:0;
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-checkbox_button-group,.slds-checkbox--button-group{
  display:inline-flex;
  background-color:var(--slds-g-color-surface-container-1);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
}
.slds-checkbox_button,.slds-checkbox--button{
  display:flex;
  border:0;
  border-radius:0;
  background-clip:padding-box;
  padding-inline:0;
}
.slds-checkbox_button .slds-checkbox_faux,.slds-checkbox--button .slds-checkbox--faux{
  padding-inline:var(--slds-g-spacing-4);
  text-align:center;
  vertical-align:middle;
  position:relative;
  background-color:var(--slds-g-color-surface-container-1);
  transition:border 0.1s linear, background-color 0.1s linear;
}
.slds-checkbox_button .slds-checkbox_button__label .slds-checkbox_faux,.slds-checkbox--button .slds-checkbox--button__label .slds-checkbox--faux,
.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_button__label .slds-checkbox_faux,
.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--button__label .slds-checkbox--faux{
  background-color:transparent;
}
.slds-checkbox_button + .slds-checkbox_button,.slds-checkbox--button + .slds-checkbox--button{
  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-radius:0;
  margin:0;
}
.slds-checkbox_button:first-child > .slds-checkbox_faux,.slds-checkbox--button:first-child > .slds-checkbox--faux,
.slds-checkbox_button:first-child > .slds-checkbox_button__label,
.slds-checkbox--button:first-child > .slds-checkbox--button__label{
  border-start-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-start-end-radius:0;
  border-end-end-radius:0;
  border-end-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
}
.slds-checkbox_button:last-child > .slds-checkbox_faux,.slds-checkbox--button:last-child > .slds-checkbox--faux,
.slds-checkbox_button .slds-button_last > .slds-checkbox_faux,
.slds-checkbox--button .slds-button--last > .slds-checkbox--faux,
.slds-checkbox_button:last-child > .slds-checkbox_button__label,
.slds-checkbox--button:last-child > .slds-checkbox--button__label{
  border-start-start-radius:0;
  border-start-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-end-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-end-start-radius:0;
}
.slds-checkbox_button:first-child:hover,.slds-checkbox--button:first-child:hover{
  border-start-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-start-end-radius:0;
  border-end-end-radius:0;
  border-end-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
}
.slds-checkbox_button:last-child:hover,.slds-checkbox--button:last-child:hover{
  border-start-start-radius:0;
  border-start-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-end-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-end-start-radius:0;
}
.slds-checkbox_button [type='checkbox'],.slds-checkbox--button [type='checkbox']{
  width:1px;
  height:1px;
  border:0;
  clip:rect(0 0 0 0);
  margin:-1px;
  overflow:hidden;
  padding:0;
  position:absolute;
}
.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_faux,.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--faux,
.slds-checkbox_button [type='checkbox']:checked ~ .slds-checkbox_faux,
.slds-checkbox--button [type='checkbox']:checked ~ .slds-checkbox--faux,
.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_button__label,
.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--button__label{
  background-color:var(--slds-g-color-accent-container-1);
  color:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-s-button-shadow-active);
}
.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_faux:hover,.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--faux:hover,
.slds-checkbox_button [type='checkbox']:checked ~ .slds-checkbox_faux:hover,
.slds-checkbox--button [type='checkbox']:checked ~ .slds-checkbox--faux:hover,
.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_button__label:hover,
.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--button__label:hover,
.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_faux:focus,
.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--faux:focus,
.slds-checkbox_button [type='checkbox']:checked ~ .slds-checkbox_faux:focus,
.slds-checkbox--button [type='checkbox']:checked ~ .slds-checkbox--faux:focus,
.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_button__label:focus,
.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--button__label:focus{
  background-color:var(--slds-g-color-accent-container-2);
}
.slds-checkbox_button [type='checkbox']:focus-visible + .slds-checkbox_faux,.slds-checkbox--button [type='checkbox']:focus-visible + .slds-checkbox--faux,
.slds-checkbox_button [type='checkbox']:focus-visible ~ .slds-checkbox_faux,
.slds-checkbox--button [type='checkbox']:focus-visible ~ .slds-checkbox--faux,
.slds-checkbox_button [type='checkbox']:focus-visible + .slds-checkbox_button__label,
.slds-checkbox--button [type='checkbox']:focus-visible + .slds-checkbox--button__label{
  box-shadow:var(--slds-s-button-shadow-focus);
  outline:0;
  z-index:1;
}
.slds-checkbox_button [type='checkbox'][disabled] + .slds-checkbox_faux,.slds-checkbox--button [type='checkbox'][disabled] + .slds-checkbox--faux,
.slds-checkbox_button [type='checkbox'][disabled] ~ .slds-checkbox_faux,
.slds-checkbox--button [type='checkbox'][disabled] ~ .slds-checkbox--faux,
.slds-checkbox_button [type='checkbox'][disabled] + .slds-checkbox_button__label,
.slds-checkbox--button [type='checkbox'][disabled] + .slds-checkbox--button__label{
  background-color:var(--slds-g-color-disabled-container-1);
  color:var(--slds-g-color-on-disabled-2);
}
.slds-checkbox_button [type='checkbox'][disabled]:checked + .slds-checkbox_faux,.slds-checkbox--button [type='checkbox'][disabled]:checked + .slds-checkbox--faux,
.slds-checkbox_button [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux,
.slds-checkbox--button [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux,
.slds-checkbox_button [type='checkbox'][disabled]:checked + .slds-checkbox_button__label,
.slds-checkbox--button [type='checkbox'][disabled]:checked + .slds-checkbox--button__label{
  background-color:var(--slds-g-color-disabled-container-2);
  color:var(--slds-g-color-on-disabled-1);
}
.slds-checkbox_button [type='checkbox'][disabled] + .slds-checkbox_button__label:hover,.slds-checkbox--button [type='checkbox'][disabled] + .slds-checkbox--button__label:hover,
.slds-checkbox_button [type='checkbox'][disabled] + .slds-checkbox_button__label:focus,
.slds-checkbox--button [type='checkbox'][disabled] + .slds-checkbox--button__label:focus{
  cursor:default;
}
.slds-checkbox_button__label,.slds-checkbox--button__label{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-checkbox_button__label:hover,.slds-checkbox--button__label:hover,
.slds-checkbox_button__label:focus,
.slds-checkbox--button__label:focus{
  cursor:pointer;
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-drop-zone{
  position:relative;
}
.slds-drop-zone::after{
  content:'';
  position:absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
  border:var(--slds-g-sizing-border-1) dotted var(--slds-g-color-border-1);
  outline:var(--slds-g-sizing-border-1) dotted var(--slds-g-color-surface-container-1);
}
.slds-drop-zone.slds-drop-zone_drag::after,.slds-drop-zone.slds-drop-zone--drag::after{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-success-1);
  outline:0;
}
.slds-drop-zone__label{
  color:var(--slds-g-color-on-accent-1);
  background:var(--slds-g-color-border-success-1);
  border-radius:var(--slds-g-radius-border-2) var(--slds-g-radius-border-2) 0 0;
  padding:var(--slds-g-spacing-1) var(--slds-g-spacing-2);
  position:absolute;
  top:0;
  left:50%;
  transform:translate(-50%, -100%);
}
.slds-drop-zone__label.slds-drop-zone__label_container,.slds-drop-zone__label.slds-drop-zone__label--container{
  opacity:0;
  background:var(--slds-g-color-accent-container-1);
}
.slds-drop-zone__label .slds-media__body{
  flex-basis:auto;
}
.slds-drop-zone__label_button,.slds-drop-zone__label--button{
  border-radius:0;
}
.slds-drop-zone__label_button:hover,.slds-drop-zone__label--button:hover,
.slds-drop-zone__label_button:focus,
.slds-drop-zone__label--button:focus{
  text-decoration:underline;
  outline:none;
}
.slds-drop-zone_drag__slot,.slds-drop-zone--drag__slot{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-100);
  border-left-width:var(--slds-g-sizing-border-2);
  border-right-width:var(--slds-g-sizing-border-2);
  background:var(--slds-g-color-success-1);
  width:100%;
  height:var(--slds-g-sizing-2);
}
.slds-drop-zone__container{
  position:relative;
  z-index:8000;
}
.slds-drop-zone__container::after{
  content:'';
  position:absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
}
.slds-drop-zone__container.slds-is-hovered .slds-drop-zone__label_container,.slds-drop-zone__container.slds-is-hovered .slds-drop-zone__label--container,
.slds-drop-zone__container.slds-is-hovered .slds-drop-zone__actions,
.slds-drop-zone__container:hover .slds-drop-zone__label_container,
.slds-drop-zone__container:hover .slds-drop-zone__label--container,
.slds-drop-zone__container:hover .slds-drop-zone__actions{
  opacity:1;
  z-index:8000;
}
.slds-drop-zone__container.slds-is-hovered::after,
.slds-drop-zone__container:hover::after{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-accent-1);
}
.slds-drop-zone__container:active::after{
  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-surface-inverse-1);
}
.slds-drop-zone__container:active .slds-drop-zone__label{
  background-color:var(--slds-g-color-surface-inverse-1);
}
.slds-drop-zone__container:focus-within{
  outline:none;
}
.slds-drop-zone__container:focus-within .slds-drop-zone__label_container,.slds-drop-zone__container:focus-within .slds-drop-zone__label--container,
.slds-drop-zone__container:focus-within .slds-drop-zone__actions{
  opacity:1;
  z-index:8000;
}
.slds-drop-zone__container:focus-within::after{
  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-border-accent-1);
}
.slds-drop-zone__container:focus-within .slds-drop-zone__label{
  background-color:var(--slds-g-color-accent-container-3);
}
.slds-drop-zone__actions{
  opacity:0;
  background:var(--slds-g-color-accent-container-1);
  position:absolute;
  right:0;
  top:0;
}
/*! Lightning Design System 2.23.0-alpha.1 */
.slds-select{
  height:calc(1.875rem + (1px * 2));
  width:100%;
  border:var(--slds-s-input-sizing-border, var(--slds-g-sizing-border-1)) solid var(--slds-c-select-color-border, var(--slds-s-input-color-border, var(--slds-g-color-border-1)));
  border-radius:var(
    --slds-c-select-radius-border,
    var(--slds-s-input-radius-border, var(--slds-g-radius-border-2))
  );
  background-color:var(
    --slds-c-select-color-background,
    var(--slds-s-input-color-background, var(--slds-g-color-surface-container-1))
  );
  color:var(--slds-c-select-text-color, var(--slds-s-input-color));
  box-shadow:var(--slds-c-select-shadow, var(--slds-s-input-shadow));
  transition:border 0.1s linear, background-color 0.1s linear;
}
.slds-select:required{
  box-shadow:none;
}
.slds-select:focus-visible{
  outline:0;
  border-color:var(--slds-c-select-color-border-focus, var(--slds-g-color-border-2));
  background-color:var(--slds-c-select-color-background-focus, var(--slds-g-color-surface-container-1));
  color:var(--slds-s-input-color-focus, var(--slds-c-select-text-color-focus));
  box-shadow:var(--slds-s-input-shadow-focus);
}
.slds-select[disabled],
.slds-select.slds-is-disabled{
  background-color:var(--slds-g-color-disabled-container-1);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-on-1);
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
  opacity:1;
}
.slds-select[disabled]:focus,
.slds-select[disabled]:active,
.slds-select.slds-is-disabled:focus,
.slds-select.slds-is-disabled:active{
  box-shadow:none;
}
.slds-select[size],
.slds-select[multiple]{
  min-height:calc(1.875rem + (1px * 2));
  height:inherit;
}
.slds-select[size] option,
.slds-select[multiple] option{
  padding:var(--slds-g-spacing-2);
}
.slds-select_container,.slds-select--container{
  position:relative;
  color:var(--slds-c-select-text-color, var(--slds-s-input-color));
}
.slds-select_container .slds-select,.slds-select--container .slds-select{
  appearance:none;
  padding-inline-start:var(--slds-s-input-spacing, var(--slds-g-spacing-2));
  padding-inline-end:var(--slds-s-input-spacing, var(--slds-g-spacing-5));
}
.slds-select_container::before,.slds-select--container::before,
.slds-select_container::after,
.slds-select--container::after{
  position:absolute;
  content:'';
  display:block;
  inset-inline-end:var(--slds-g-spacing-2);
  width:0;
  height:0;
  border-inline-start:var(--slds-g-sizing-border-3) solid transparent;
  border-inline-end:var(--slds-g-sizing-border-3) solid transparent;
  pointer-events:none;
}
.slds-select_container::before,.slds-select--container::before{
  border-block-end:5px solid currentColor;
  inset-block-start:calc((var(--slds-g-sizing-8) / 2) - 6px);
}
.slds-select_container::after,.slds-select--container::after{
  border-block-start:5px solid currentColor;
  inset-block-end:calc((var(--slds-g-sizing-8) / 2) - 6px);
}
.slds-has-error .slds-select{
  border-color:var(--slds-s-input-color-border-invalid, var(--slds-g-color-error-1));
  box-shadow:var(--slds-s-input-shadow-invalid, var(--slds-g-color-error-1) 0 0 0 1px inset);
  background-clip:padding-box;
  background-color:var(--slds-s-input-color-background-invalid);
  color:var(--slds-s-input-color-invalid);
}
.slds-has-error .slds-select:focus-visible,
.slds-has-error .slds-select:active{
  box-shadow:var(--slds-g-color-error-1) 0 0 0 1px inset, 0 0 3px var(--slds-g-color-border-accent-2);
}
.slds-has-error .slds-select:focus-visible{
  box-shadow:var(--slds-s-input-shadow-focus);
}
.slds-radio{
  display:inline-block;
}
.slds-radio .slds-radio_faux,.slds-radio .slds-radio--faux{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  display:inline-block;
  position:relative;
  flex-shrink:0;
  vertical-align:middle;
  border-radius:var(--slds-g-radius-border-circle);
  border-width:var(--slds-s-input-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(
    --slds-c-radio-color-border,
    var(--slds-s-input-color-border, var(--slds-g-color-border-2))
  );
  background:none;
  background-color:var(--slds-c-radio-color-background, var(--slds-g-color-surface-container-1));
  box-shadow:var(--slds-c-radio-shadow, var(--slds-s-input-shadow));
  transition:border 0.1s linear, background-color 0.1s linear;
}
.slds-radio .slds-form-element__label{
  display:inline;
  vertical-align:middle;
  font-size:var(--slds-s-label-font-size, var(--slds-g-font-scale-neg-2));
}
.slds-radio [type='radio']{
  width:1px;
  height:1px;
  border:0;
  clip:rect(0 0 0 0);
  margin:-1px;
  overflow:hidden;
  padding:0;
  position:absolute;
  pointer-events:auto;
}
.slds-radio [type='radio']:checked + .slds-radio_faux,.slds-radio [type='radio']:checked + .slds-radio--faux,
.slds-radio [type='radio']:checked ~ .slds-radio_faux,
.slds-radio [type='radio']:checked ~ .slds-radio--faux,
.slds-radio [type='radio']:checked + .slds-radio__label .slds-radio_faux,
.slds-radio [type='radio']:checked + .slds-radio__label .slds-radio--faux{
  --slds-c-radio-color-background:var(
    --slds-c-radio-color-background-checked,
    var(--slds-s-mark-color-background-checked, var(--slds-g-color-surface-container-1))
  );
  --slds-c-radio-shadow:var(--slds-s-mark-shadow-checked);
}
.slds-radio [type='radio']:checked + .slds-radio_faux::after,.slds-radio [type='radio']:checked + .slds-radio--faux::after,
.slds-radio [type='radio']:checked ~ .slds-radio_faux::after,
.slds-radio [type='radio']:checked ~ .slds-radio--faux::after,
.slds-radio [type='radio']:checked + .slds-radio__label .slds-radio_faux::after,
.slds-radio [type='radio']:checked + .slds-radio__label .slds-radio--faux::after{
  width:var(--slds-g-sizing-3);
  height:var(--slds-g-sizing-3);
  content:'';
  position:absolute;
  top:50%;
  /*! @noflip */
  left:50%;
  transform:translate3d(-50%, -50%, 0);
  border-radius:var(--slds-g-radius-border-circle);
  background:none;
  background-color:var(
    --slds-c-radio-color-background-checked,
    var(--slds-s-mark-color-foreground-checked, var(--slds-g-color-border-accent-2))
  );
}
.slds-radio [type='radio']:focus-visible + .slds-radio_faux,.slds-radio [type='radio']:focus-visible + .slds-radio--faux,
.slds-radio [type='radio']:focus-visible ~ .slds-radio_faux,
.slds-radio [type='radio']:focus-visible ~ .slds-radio--faux,
.slds-radio [type='radio']:focus-visible + .slds-radio__label .slds-radio_faux,
.slds-radio [type='radio']:focus-visible + .slds-radio__label .slds-radio--faux{
  border-color:var(
    --slds-c-radio-color-border-focus,
    var(--slds-s-input-color-border-focus, var(--slds-g-color-border-accent-1))
  );
  --slds-c-radio-shadow:var(
    --slds-c-radio-shadow-focus,
    var(--slds-s-mark-shadow-focus, 0 0 3px var(--slds-g-color-accent-2))
  );
}
.slds-radio [type='radio'][disabled]{
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
}
.slds-radio [type='radio'][disabled] ~ .slds-radio_faux,.slds-radio [type='radio'][disabled] ~ .slds-radio--faux,
.slds-radio [type='radio'][disabled] + .slds-radio__label .slds-radio_faux,
.slds-radio [type='radio'][disabled] + .slds-radio__label .slds-radio--faux{
  border-color:var(--slds-g-color-border-disabled-1);
  background-color:var(--slds-g-color-disabled-container-2);
}
.slds-radio [type='radio'][disabled] ~ .slds-radio_faux::after,.slds-radio [type='radio'][disabled] ~ .slds-radio--faux::after,
.slds-radio [type='radio'][disabled] + .slds-radio__label .slds-radio_faux::after,
.slds-radio [type='radio'][disabled] + .slds-radio__label .slds-radio--faux::after{
  background-color:var(--slds-g-color-on-disabled-2);
}
.slds-radio [type='radio'][disabled]:checked + .slds-radio_faux,.slds-radio [type='radio'][disabled]:checked + .slds-radio--faux,
.slds-radio [type='radio'][disabled]:checked ~ .slds-radio_faux,
.slds-radio [type='radio'][disabled]:checked ~ .slds-radio--faux,
.slds-radio [type='radio'][disabled]:checked + .slds-radio__label .slds-radio_faux,
.slds-radio [type='radio'][disabled]:checked + .slds-radio__label .slds-radio--faux{
  border-color:var(--slds-g-color-border-disabled-1);
  background-color:var(--slds-g-color-disabled-container-2);
}
.slds-has-error .slds-radio [type='radio'] + .slds-radio_faux,.slds-has-error .slds-radio [type='radio'] + .slds-radio--faux,
.slds-has-error .slds-radio [type='radio'] ~ .slds-radio_faux,
.slds-has-error .slds-radio [type='radio'] ~ .slds-radio--faux,
.slds-has-error .slds-radio [type='radio'] + .slds-radio__label .slds-radio_faux,
.slds-has-error .slds-radio [type='radio'] + .slds-radio__label .slds-radio--faux{
  border-color:var(--slds-s-input-color-border-invalid, var(--slds-g-color-border-error-1));
  border-width:var(--slds-g-sizing-border-2);
}
.slds-has-error .slds-radio [type='radio']:checked + .slds-radio_faux,.slds-has-error .slds-radio [type='radio']:checked + .slds-radio--faux,
.slds-has-error .slds-radio [type='radio']:checked ~ .slds-radio_faux,
.slds-has-error .slds-radio [type='radio']:checked ~ .slds-radio--faux,
.slds-has-error .slds-radio [type='radio']:checked + .slds-radio__label .slds-radio_faux,
.slds-has-error .slds-radio [type='radio']:checked + .slds-radio__label .slds-radio--faux{
  border-color:var(--slds-s-input-color-border-invalid, var(--slds-g-color-border-error-1));
  background-color:var(--slds-s-mark-color-background-invalid);
  --slds-c-radio-shadow:var(--slds-s-mark-shadow-checked);
}
.slds-has-error .slds-radio [type='radio']:checked + .slds-radio_faux::after,.slds-has-error .slds-radio [type='radio']:checked + .slds-radio--faux::after,
.slds-has-error .slds-radio [type='radio']:checked ~ .slds-radio_faux::after,
.slds-has-error .slds-radio [type='radio']:checked ~ .slds-radio--faux::after,
.slds-has-error .slds-radio [type='radio']:checked + .slds-radio__label .slds-radio_faux::after,
.slds-has-error .slds-radio [type='radio']:checked + .slds-radio__label .slds-radio--faux::after{
  background-color:var(--slds-s-mark-color-foreground-invalid, var(--slds-g-color-error-1));
}
.slds-form-element .slds-radio [type='radio'] + .slds-radio_faux,.slds-form-element .slds-radio [type='radio'] + .slds-radio--faux,
.slds-form-element .slds-radio [type='radio'] ~ .slds-radio_faux,
.slds-form-element .slds-radio [type='radio'] ~ .slds-radio--faux,
.slds-radio [type='radio'] + .slds-radio__label .slds-radio_faux,
.slds-radio [type='radio'] + .slds-radio__label .slds-radio--faux{
  margin-inline-end:var(--slds-g-spacing-2);
}
[dir='rtl'] .slds-form-element .slds-radio [type='radio'] + .slds-radio_faux,[dir='rtl'] .slds-form-element .slds-radio [type='radio'] + .slds-radio--faux,
[dir='rtl'] .slds-form-element .slds-radio [type='radio'] ~ .slds-radio_faux,
[dir='rtl'] .slds-form-element .slds-radio [type='radio'] ~ .slds-radio--faux,
[dir='rtl'] .slds-radio [type='radio'] + .slds-radio__label .slds-radio_faux,
[dir='rtl'] .slds-radio [type='radio'] + .slds-radio__label .slds-radio--faux{
  /*! @noflip */
  margin-right:0;
  margin-left:var(--slds-g-spacing-2);
}
.slds-radio_button-group,.slds-radio--button-group{
  display:inline-flex;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
}
.slds-radio_button,.slds-radio--button{
  display:flex;
  border:0;
  border-radius:0;
  background-clip:padding-box;
  --slds-c-button-spacing-inline:0;
}
.slds-radio_button .slds-radio_faux,.slds-radio--button .slds-radio--faux{
  padding-inline-start:var(--slds-g-spacing-4);
  padding-inline-end:var(--slds-g-spacing-4);
  text-align:center;
  vertical-align:middle;
}
.slds-radio_button + .slds-radio_button,.slds-radio--button + .slds-radio--button{
  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  margin:0;
}
.slds-radio_button:first-child:hover,.slds-radio--button:first-child:hover,
.slds-radio_button:first-child:focus,
.slds-radio--button:first-child:focus{
  border-start-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-start-end-radius:0;
  border-end-end-radius:0;
  border-end-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
}
.slds-radio_button:last-child:hover,.slds-radio--button:last-child:hover,
.slds-radio_button:last-child:focus,
.slds-radio--button:last-child:focus{
  border-start-start-radius:0;
  border-start-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-end-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-end-start-radius:0;
}
.slds-radio_button:first-child > .slds-radio_faux,.slds-radio--button:first-child > .slds-radio--faux,
.slds-radio_button:first-child > .slds-radio_button__label,
.slds-radio--button:first-child > .slds-radio--button__label{
  border-start-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-start-end-radius:0;
  border-end-end-radius:0;
  border-end-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
}
.slds-radio_button:last-child > .slds-radio_faux,.slds-radio--button:last-child > .slds-radio--faux,
.slds-radio_button .slds-button_last > .slds-radio_faux,
.slds-radio--button .slds-button--last > .slds-radio--faux,
.slds-radio_button:last-child > .slds-radio_button__label,
.slds-radio--button:last-child > .slds-radio--button__label{
  border-start-start-radius:0;
  border-start-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-end-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));
  border-end-start-radius:0;
}
.slds-radio_button [type='radio'],.slds-radio--button [type='radio']{
  width:var(--slds-g-sizing-border-1);
  height:var(--slds-g-sizing-border-1);
  border:0;
  clip:rect(0 0 0 0);
  margin:-1px;
  overflow:hidden;
  padding:0;
  position:absolute;
}
.slds-radio_button [type='radio']:checked + .slds-radio_faux,.slds-radio--button [type='radio']:checked + .slds-radio--faux,
.slds-radio_button [type='radio']:checked ~ .slds-radio_faux,
.slds-radio--button [type='radio']:checked ~ .slds-radio--faux,
.slds-radio_button [type='radio']:checked + .slds-radio_button__label,
.slds-radio--button [type='radio']:checked + .slds-radio--button__label{
  background-color:var(--slds-g-color-accent-container-1);
  color:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-s-button-shadow-active);
}
.slds-radio_button [type='radio']:checked + .slds-radio_faux:hover,.slds-radio--button [type='radio']:checked + .slds-radio--faux:hover,
.slds-radio_button [type='radio']:checked ~ .slds-radio_faux:hover,
.slds-radio--button [type='radio']:checked ~ .slds-radio--faux:hover,
.slds-radio_button [type='radio']:checked + .slds-radio_button__label:hover,
.slds-radio--button [type='radio']:checked + .slds-radio--button__label:hover,
.slds-radio_button [type='radio']:checked + .slds-radio_faux:focus,
.slds-radio--button [type='radio']:checked + .slds-radio--faux:focus,
.slds-radio_button [type='radio']:checked ~ .slds-radio_faux:focus,
.slds-radio--button [type='radio']:checked ~ .slds-radio--faux:focus,
.slds-radio_button [type='radio']:checked + .slds-radio_button__label:focus,
.slds-radio--button [type='radio']:checked + .slds-radio--button__label:focus{
  background-color:var(--slds-g-color-accent-container-2);
}
.slds-radio_button [type='radio']:focus-visible + .slds-radio_faux,.slds-radio--button [type='radio']:focus-visible + .slds-radio--faux,
.slds-radio_button [type='radio']:focus-visible ~ .slds-radio_faux,
.slds-radio--button [type='radio']:focus-visible ~ .slds-radio--faux,
.slds-radio_button [type='radio']:focus-visible + .slds-radio_button__label,
.slds-radio--button [type='radio']:focus-visible + .slds-radio--button__label{
  outline:0;
  box-shadow:var(--slds-s-button-shadow-focus);
  z-index:1;
}
.slds-radio_button [type='radio'][disabled] + .slds-radio_faux,.slds-radio--button [type='radio'][disabled] + .slds-radio--faux,
.slds-radio_button [type='radio'][disabled] ~ .slds-radio_faux,
.slds-radio--button [type='radio'][disabled] ~ .slds-radio--faux,
.slds-radio_button [type='radio'][disabled] + .slds-radio_button__label,
.slds-radio--button [type='radio'][disabled] + .slds-radio--button__label{
  background-color:var(--slds-g-color-disabled-container-1);
  color:var(--slds-g-color-on-disabled-2);
}
.slds-radio_button [type='radio'][disabled]:checked + .slds-radio_faux,.slds-radio--button [type='radio'][disabled]:checked + .slds-radio--faux,
.slds-radio_button [type='radio'][disabled]:checked ~ .slds-radio_faux,
.slds-radio--button [type='radio'][disabled]:checked ~ .slds-radio--faux,
.slds-radio_button [type='radio'][disabled]:checked + .slds-radio_button__label,
.slds-radio--button [type='radio'][disabled]:checked + .slds-radio--button__label{
  background-color:var(--slds-g-color-disabled-container-2);
  color:var(--slds-g-color-on-disabled-2);
}
.slds-radio_button [type='radio'][disabled] + .slds-radio_button__label:hover,.slds-radio--button [type='radio'][disabled] + .slds-radio--button__label:hover,
.slds-radio_button [type='radio'][disabled] + .slds-radio_button__label:focus,
.slds-radio--button [type='radio'][disabled] + .slds-radio--button__label:focus{
  cursor:default;
}
.slds-radio_button__label,.slds-radio--button__label{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-radio_button__label:hover,.slds-radio--button__label:hover,
.slds-radio_button__label:focus,
.slds-radio--button__label:focus{
  cursor:pointer;
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-file-selector{
  display:inline-flex;
}
.slds-file-selector__dropzone{
  padding:var(--slds-g-spacing-1);
  border:var(--slds-g-sizing-border-1) dashed var(--slds-g-color-border-2);
  border-radius:var(--slds-g-radius-border-2);
}
.slds-file-selector__dropzone.slds-has-drag-over{
  outline:0;
  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-border-accent-2);
}
.slds-file-selector__input:focus-visible ~ .slds-file-selector__body > .slds-file-selector__button{
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-file-selector__input[disabled] ~ .slds-file-selector__body{
  color:var(--slds-g-color-on-surface-1);
}
.slds-file-selector__input[disabled] ~ .slds-file-selector__body > .slds-file-selector__button{
  background:var(--slds-g-color-surface-2);
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-on-disabled-1);
}
.slds-file-selector__input[disabled] ~ .slds-file-selector__body > .slds-file-selector__body-icon{
  fill:currentColor;
}
.slds-file-selector__button{
  display:inline-flex;
  align-items:center;
}
.slds-file-selector__button .slds-icon-text-default{
  --slds-c-icon-color-foreground:currentColor;
}
.slds-file-selector_files .slds-file-selector__body,.slds-file-selector--files .slds-file-selector__body{
  display:flex;
  align-items:center;
}
.slds-file-selector_files .slds-file-selector__text,.slds-file-selector--files .slds-file-selector__text{
  margin-inline-start:var(--slds-g-spacing-2);
  margin-inline-end:var(--slds-g-spacing-3);
}
.slds-file-selector_images,.slds-file-selector--images{
  display:block;
}
.slds-file-selector_images .slds-file-selector__dropzone,.slds-file-selector--images .slds-file-selector__dropzone{
  display:flex;
  justify-content:center;
  align-content:center;
  padding:var(--slds-g-spacing-4);
}
.slds-file-selector_images .slds-file-selector__body,.slds-file-selector--images .slds-file-selector__body{
  text-align:center;
}
.slds-file-selector_images .slds-file-selector__text,.slds-file-selector--images .slds-file-selector__text{
  margin-block-start:var(--slds-g-spacing-3);
}
.slds-file-selector_integrated,.slds-file-selector--integrated{
  width:100%;
  height:100%;
  position:relative;
  display:block;
}
.slds-file-selector__dropzone_integrated,.slds-file-selector__dropzone--integrated{
  display:flex;
  justify-content:center;
  align-content:center;
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  border:0;
  opacity:0;
  z-index:-1;
}
.slds-file-selector__dropzone_integrated.slds-has-drag,.slds-file-selector__dropzone--integrated.slds-has-drag{
  opacity:1;
  z-index:8000;
}
.slds-file-selector__dropzone_integrated.slds-has-drag ~ p,.slds-file-selector__dropzone--integrated.slds-has-drag ~ p{
  color:var(--slds-g-color-disabled-1);
}
.slds-file-selector__dropzone_integrated.slds-has-drag-over,.slds-file-selector__dropzone--integrated.slds-has-drag-over{
  background:var(--slds-g-color-brand-base-90, var(--slds-g-color-palette-neutral-95));
  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-border-accent-2);
}
.slds-file-selector__body_integrated,.slds-file-selector__body--integrated{
  width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));
  height:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  align-content:center;
  margin:auto;
  background:var(--slds-g-color-neutral-base-100);
  box-shadow:var(--slds-g-shadow-4);
  border:var(--slds-g-sizing-border-1) solid var(--slds-s-container-color-border);
  border-radius:var(--slds-g-radius-border-2);
}
.slds-file-selector__text_integrated,.slds-file-selector__text--integrated{
  margin-block-start:var(--slds-g-spacing-3);
}
.slds-page-header{
  --_slds-c-pageheader-spacing-block:var(--lwc-varSpacingVerticalMedium);
  --_slds-c-pageheader-spacing-inline:var(--lwc-varSpacingHorizontalMedium);

  padding-block-start:var(
    --_slds-c-pageheader-spacing-blockstart,
    var(--_slds-c-pageheader-spacing-block, var(--_slds-c-pageheader-spacing, var(--slds-g-spacing-4)))
  );
  padding-block-end:var(
    --_slds-c-pageheader-spacing-blockend,
    var(--_slds-c-pageheader-spacing-block, var(--_slds-c-pageheader-spacing, var(--slds-g-spacing-4)))
  );
  padding-inline-start:var(
    --_slds-c-pageheader-spacing-inlinestart,
    var(--_slds-c-pageheader-spacing-inline, var(--_slds-c-pageheader-spacing, var(--slds-g-spacing-4)))
  );
  padding-inline-end:var(
    --_slds-c-pageheader-spacing-inlineend,
    var(--_slds-c-pageheader-spacing-inline, var(--_slds-c-pageheader-spacing, var(--slds-g-spacing-4)))
  );
  border-radius:var(--slds-s-pageheader-radius-border, var(--slds-g-radius-border-2));
  background:var(--slds-s-pageheader-color-background, var(--slds-g-color-surface-container-2));
  background-clip:padding-box;
  box-shadow:var(--slds-s-pageheader-shadow, var(--slds-g-shadow-1));
  border:var(--slds-s-pageheader-sizing-border, var(--slds-g-sizing-border-1)) solid var(--slds-s-pageheader-color-border, var(--slds-g-color-border-1));
}
.slds-page-header .slds-media{
  align-items:center;
}
.slds-page-header__row{
  display:flex;
}
.slds-page-header__row .slds-media{
  align-items:center;
}
.slds-page-header__row_gutters,.slds-page-header__row--gutters{
  margin-inline-start:calc(var(--slds-g-spacing-4) * -1);
  margin-inline-end:calc(var(--slds-g-spacing-4) * -1);
}
.slds-page-header__col-title{
  flex:1 1;
  min-width:0;
}
.slds-page-header__icon{
  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
}
.slds-page-header__col-actions{
  align-self:center;
  flex:none;
  vertical-align:top;
}
.slds-page-header__col-meta{
  align-self:center;
  flex:1 1 auto;
  vertical-align:middle;
}
.slds-page-header__col-controls{
  flex:none;
  vertical-align:bottom;
}
.slds-page-header__col-details{
  flex:1 1 auto;
  padding-inline-start:var(--slds-g-spacing-4);
  padding-inline-end:var(--slds-g-spacing-4);
  max-width:100%;
}
.slds-page-header__name{
  display:inline-flex;
  padding-inline-end:var(--slds-g-spacing-3);
  max-width:100%;
}
.slds-page-header__name h1{
  line-height:1;
}
.slds-page-header__name-title{
  min-width:0;
  color:var(--slds-g-color-on-surface-1);
}
.slds-page-header__name-switcher{
  align-self:flex-end;
  margin-inline-start:var(--slds-g-spacing-2);
  margin-block-end:var(--slds-s-pageheader-action-bottom-spacing);
}
.slds-page-header__name-switcher .slds-button__icon{
  fill:var(--slds-g-color-on-surface-3);
}
.slds-page-header__name-meta{
  max-width:100%;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  padding-inline-end:var(--slds-g-spacing-3);
  color:var(--slds-g-color-on-surface-1);
}
.slds-page-header__meta-text{
  font-size:var(--slds-g-font-size-base);
  color:var(--slds-g-color-on-surface-1);
}
.slds-page-header__title{
  font-size:var(--slds-s-pageheader-title-font-size, var(--slds-g-font-scale-1));
  font-weight:var(--slds-s-pageheader-title-font-weight, var(--slds-g-font-weight-7));
  color:var(--slds-g-color-on-surface-3);
  line-height:var(--slds-g-font-lineheight-2);
  display:block;
}
.slds-page-header__title .slds-icon{
  fill:currentColor;
}
.slds-page-header__controls{
  display:flex;
}
.slds-page-header__control{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-page-header__detail-row{
  display:flex;
  margin-block:var(--_slds-c-pageheader-spacing-block) calc(var(--_slds-c-pageheader-spacing-block) * -1);
  margin-inline:calc(var(--_slds-c-pageheader-spacing-inline) * -1);
  padding:var(--_slds-c-pageheader-spacing-inline);
  border-start-start-radius:0;
  border-start-end-radius:0;
  border-end-end-radius:var(--slds-s-pageheader-radius-border);
  border-end-start-radius:var(--slds-s-pageheader-radius-border);
  background-color:var(--slds-s-pageheader-row-color-background);
  position:relative;
  z-index:2;
}
.slds-page-header__detail-block{
  padding-inline-end:var(--slds-g-spacing-6);
  padding-inline-start:var(--slds-g-spacing-6);
  max-width:25%;
}
.slds-page-header__detail-block:first-child{
  padding-inline-start:0;
}
.slds-page-header__detail-block:last-child{
  padding-inline-end:0;
}
.slds-page-header_vertical,.slds-page-header--vertical{
  padding:var(--slds-g-spacing-3);
  background:var(--slds-g-color-surface-container-1);
  border-radius:var(--slds-s-container-radius-border, var(--slds-g-radius-border-2));
  border-block-end:0;
}
.slds-page-header_vertical .slds-page-header__controls,.slds-page-header--vertical .slds-page-header__controls{
  display:flex;
  gap:var(--slds-g-spacing-2);
  padding-block-start:var(--slds-g-spacing-2);
  margin-block-start:var(--slds-g-spacing-2);
  border-block-start:var(--slds-s-pageheader-sizing-border, var(--slds-g-sizing-border-1)) solid var(--slds-s-pageheader-color-border, var(--slds-g-color-border-1));
}
.slds-page-header__detail-list{
  display:flex;
  flex-wrap:wrap;
}
.slds-page-header__detail-item{
  margin-block-start:var(--slds-g-spacing-2);
  width:50%;
}
.slds-page-header_joined,.slds-page-header--joined,
.slds-page-header.slds-has-bottom-magnet{
  border-radius:var(--slds-s-pageheader-radius-border) var(--slds-s-pageheader-radius-border) 0 0;
}
.slds-panel{
  background:var(--slds-g-color-surface-1);
  border-radius:var(--slds-g-radius-border-1);
  overflow-y:auto;
}
.slds-panel.slds-is-editing{
  box-shadow:0 2px 3px 0 rgba(0, 0, 0, 0.16);
}
.slds-panel .slds-panel__header-title{
  text-align:start;
  width:100%;
  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2));
}
.slds-panel__section{
  padding:var(--slds-g-spacing-4);
}
.slds-panel__actions{
  padding:var(--slds-g-spacing-3);
}
.slds-panel__header{
  display:flex;
  position:relative;
  align-items:center;
  padding:var(--slds-g-spacing-3);
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-surface-3);
}
.slds-panel__header_custom,.slds-panel__header--custom{
  padding-block:var(--slds-g-spacing-3);
  padding-inline:var(--slds-g-spacing-4);
}
.slds-panel__close:first-child{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-panel__close:last-child{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-panel__back:first-child{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-panel__back:last-child{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-panel__close,
.slds-panel__back{
  flex-shrink:0;
}
.slds-panel__header_align-center,.slds-panel__header--align-center{
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-8);
}
.slds-panel__header_align-center .slds-panel__header-title,.slds-panel__header--align-center .slds-panel__header-title{
  text-align:center;
}
.slds-panel__header_align-center .slds-panel__close,.slds-panel__header--align-center .slds-panel__close{
  position:absolute;
  inset-inline-end:var(--slds-g-spacing-3);
  inset-inline-start:auto;
  inset-block-start:50%;
  margin-block-start:calc(var(--slds-g-spacing-3) * -1);
}
.slds-panel__header_align-center .slds-panel__back,.slds-panel__header--align-center .slds-panel__back{
  position:absolute;
  inset-inline-start:var(--slds-g-spacing-3);
  inset-inline-end:auto;
  inset-block-start:50%;
  margin-block-start:calc(var(--slds-g-spacing-3) * -1);
}
.slds-panel__header-actions{
  display:flex;
  align-items:flex-end;
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-panel__header-actions .slds-panel__close{
  margin-inline-start:0;
  margin-inline-end:0;
}
.slds-panel__body{
  padding:var(--slds-g-spacing-3);
  color:var(--slds-s-container-color);
}
.slds-panel_docked,.slds-panel--docked{
  position:relative;
  min-width:var(--slds-g-sizing-14);
  height:100%;
  border-radius:0;
  display:none;
}
.slds-panel_docked.slds-is-open,.slds-panel--docked.slds-is-open{
  display:block;
}
.slds-panel_docked-left,.slds-panel--docked-left{
  box-shadow:var(--slds-g-shadow-inlineend-3, 1px 0 3px rgba(0, 0, 0, 0.25));
}
.slds-panel_docked-right,.slds-panel--docked-right{
  margin-inline-start:auto;
  box-shadow:var(--slds-g-shadow-inlinestart-3, -1px 0 3px 0 rgba(0, 0, 0, 0.25));
}
.slds-panel_animated,.slds-panel--animated{
  display:block;
  position:absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
  transform:translate3d(120%, 0, 0);
  transition:transform 300ms ease;
  z-index:9000;
}
.slds-tabs-mobile__container .slds-panel_animated,.slds-tabs-mobile__container .slds-panel--animated{
  position:fixed;
}
.slds-panel_animated.slds-is-open,.slds-panel--animated.slds-is-open{
  transform:translate3d(0, 0, 0);
}
.slds-panel_filters,.slds-panel--filters{
  margin-inline-start:var(--slds-g-spacing-4);
  box-shadow:var(--slds-g-shadow-1);
  border-radius:0;
}
.slds-publisher{
  display:flex;
}
.slds-publisher.slds-is-active{
  display:block;
}
.slds-publisher.slds-is-active .slds-publisher__toggle-visibility{
  display:inherit;
  height:auto;
  overflow:visible;
  width:auto;
}
.slds-publisher.slds-is-active .slds-publisher__input{
  line-height:var(--slds-g-font-lineheight-base);
  height:auto;
  max-height:10rem;
  resize:vertical;
  padding-block-start:var(--slds-g-spacing-3);
  padding-block-end:var(--slds-g-spacing-3);
}
.slds-publisher .slds-publisher__toggle-visibility{
  display:block;
  height:0;
  overflow:hidden;
  width:0;
  color:var(--slds-s-label-color, var(--slds-g-color-on-surface-2));
}
.slds-publisher__input{
  line-height:calc(var(--slds-g-sizing-9) - var(--slds-g-sizing-1));
  padding-block:0;
  padding-inline:var(--slds-g-spacing-4);
  resize:none;
  max-height:calc(var(--slds-g-sizing-9) - var(--slds-g-sizing-1) + 2px);
  width:100%;
  border-radius:var(--slds-g-radius-border-2);
  font-family:inherit;
}
.slds-publisher__actions > .slds-button{
  margin-inline-start:var(--slds-g-spacing-3);
}
.slds-publisher_comment,.slds-publisher--comment{
  background-color:var(--slds-g-color-surface-container-1);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-radius:var(--slds-g-radius-border-2);
  width:100%;
  position:relative;
  min-height:calc(var(--slds-g-sizing-9) - var(--slds-g-sizing-1) + 2px);
  max-height:calc(var(--slds-g-sizing-9) - var(--slds-g-sizing-1) + 2px);
}
.slds-publisher_comment.slds-is-active,.slds-publisher--comment.slds-is-active{
  min-height:calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9));
  max-height:var(--slds-g-sizing-14);
}
.slds-publisher_comment.slds-is-active .slds-publisher__actions,.slds-publisher--comment.slds-is-active .slds-publisher__actions{
  display:flex;
}
.slds-publisher_comment.slds-has-focus,.slds-publisher--comment.slds-has-focus{
  outline:0;
  border-color:var(--slds-s-input-color-border, var(--slds-g-color-border-accent-1));
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-publisher_comment.slds-has-focus .slds-publisher__input,.slds-publisher--comment.slds-has-focus .slds-publisher__input{
  line-height:var(--slds-g-font-lineheight-6);
  box-shadow:var(--slds-s-input-shadow-focus);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
}
.slds-publisher_comment .slds-publisher__actions,.slds-publisher--comment .slds-publisher__actions{
  display:none;
  padding-block:0 var(--slds-g-spacing-3);
  padding-inline:var(--slds-g-spacing-3);
}
.slds-publisher_comment .slds-attachments,.slds-publisher--comment .slds-attachments{
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
}
.slds-feed{
  position:relative;
  max-width:49rem;
  margin:auto;
}
.slds-feed__list{
  margin:0;
  padding:0;
}
.slds-feed__item{
  padding:var(--_slds-g-spacing-var-block-2, var(--slds-g-spacing-2)) 0;
}
@media (min-width: 48em){
  .slds-feed__item{
    padding:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)) 0
  }
}
.slds-feed__item-comments{
  background-color:var(--slds-g-color-surface-container-2);
  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-bottom:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-feed__item-comments .slds-comment{
  padding:var(--_slds-g-spacing-var-block-2, var(--slds-g-spacing-2)) var(--slds-g-spacing-4);
}
.slds-post{
  background-color:var(--slds-g-color-surface-container-1);
  padding:var(--slds-g-spacing-3) var(--slds-g-spacing-4);
}
@media (max-width: 48em){
  .slds-post{
    border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1)
  }
}
@media (min-width: 64em){
  .slds-post{
    padding:0 var(--slds-g-spacing-4) var(--slds-g-spacing-2)
  }
}
.slds-post__header{
  margin-block-end:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));
}
.slds-post__content{
  margin-block-end:var(--slds-g-spacing-3);
}
@media (min-width: 48em){
  .slds-post__content{
    margin-block-end:var(--slds-g-spacing-5)
  }
}
.slds-post__footer{
  display:flex;
  font-size:var(--slds-g-font-scale-neg-1);
  flex-direction:column;
}
@media (min-width: 48em){
  .slds-post__footer{
    flex-direction:row
  }
}
.slds-post__footer-actions-list{
  justify-content:space-between;
  text-align:center;
  order:1;
}
@media (max-width: 30em){
  .slds-post__footer-actions-list{
    border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
    margin:0 calc(var(--slds-g-spacing-3) * -1) calc(var(--slds-g-spacing-3) * -1);
    padding:0 var(--slds-g-spacing-4)
  }
}
@media (min-width: 48em){
  .slds-post__footer-actions-list{
    order:0
  }
}
.slds-post__footer-action{
  display:flex;
  align-items:center;
  justify-content:center;
  color:var(--slds-g-color-on-surface-3);
  padding:var(--slds-g-spacing-3) 0;
  line-height:1;
}
@media (min-width: 48em){
  .slds-post__footer-action{
    margin-inline-end:var(--slds-g-spacing-4);
    padding:0
  }
}
.slds-post__footer-action .slds-icon{
  margin-inline-end:var(--slds-g-spacing-1);
}
.slds-post__footer-action:hover,
.slds-post__footer-action:focus,
.slds-post__footer-action.slds-is-active{
  color:var(--slds-s-link-color-hover);
  text-decoration:none;
}
.slds-post__footer-action:hover .slds-icon, .slds-post__footer-action:focus .slds-icon, .slds-post__footer-action.slds-is-active .slds-icon{
  fill:currentColor;
}
.slds-post__footer-action:focus-visible{
  box-shadow:var(--slds-s-button-shadow-focus);
  border-radius:var(--slds-g-radius-border-1);
  outline:0;
}
.slds-post__footer-meta-list{
  margin-block-end:var(--slds-g-spacing-4);
}
@media (min-width: 48em){
  .slds-post__footer-meta-list{
    margin-inline-start:auto;
    margin-block-end:0
  }
}
.slds-region_narrow .slds-post,.slds-region--narrow .slds-post{
  border:0;
  padding:var(--slds-g-spacing-3) var(--slds-g-spacing-4);
}
.slds-region_narrow .slds-post__content,.slds-region--narrow .slds-post__content{
  margin-block-end:var(--slds-g-spacing-3);
}
.slds-region_narrow .slds-post__footer,.slds-region--narrow .slds-post__footer{
  flex-direction:column;
}
.slds-region_narrow .slds-post__footer-action,.slds-region--narrow .slds-post__footer-action{
  padding:var(--slds-g-spacing-3) 0;
}
.slds-region_narrow .slds-post__footer-actions-list,.slds-region--narrow .slds-post__footer-actions-list{
  order:1;
  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  margin:0 calc(var(--slds-g-spacing-3) * -1) calc(var(--slds-g-spacing-3) * -1);
  padding:0 var(--slds-g-spacing-4);
}
.slds-region_narrow .slds-post__footer-meta-list,.slds-region--narrow .slds-post__footer-meta-list{
  margin-inline-start:0;
  margin-block-end:var(--slds-g-spacing-4);
}
.slds-comment__content{
  padding:var(--_slds-g-spacing-var-block-1, var(--slds-g-spacing-1)) 0;
}
.slds-post__payload{
  padding:0 0 var(--slds-g-spacing-4);
}
.slds-post__payload:empty{
  padding:0;
  border:0;
}
.slds-dropdown-trigger{
  position:relative;
  display:inline-block;
}
.slds-dropdown-trigger .slds-dropdown{
  inset-block-start:100%;
}
.slds-dropdown-trigger .slds-dropdown_bottom,.slds-dropdown-trigger .slds-dropdown--bottom{
  inset-block-start:auto;
}
.slds-dropdown-trigger > [class*='slds-button_icon'] ~ .slds-dropdown_left[class*='slds-nubbin'],.slds-dropdown-trigger > [class*='slds-button--icon'] ~ .slds-dropdown--left[class*='slds-nubbin']{
  inset-inline-start:calc(var(--slds-g-spacing-2) * -1);
}
.slds-dropdown-trigger > [class*='slds-button_icon'] ~ .slds-dropdown_right[class*='slds-nubbin'],.slds-dropdown-trigger > [class*='slds-button--icon'] ~ .slds-dropdown--right[class*='slds-nubbin']{
  inset-inline-end:calc(var(--slds-g-spacing-2) * -1);
}
.slds-dropdown-trigger_hover .slds-dropdown,.slds-dropdown-trigger--hover .slds-dropdown{
  visibility:hidden;
  opacity:0;
  transition:opacity var(0.1s) linear, visibility var(0.1s) linear;
}
.slds-dropdown-trigger_hover:hover,.slds-dropdown-trigger--hover:hover,
.slds-dropdown-trigger_hover:focus,
.slds-dropdown-trigger--hover:focus{
  outline:0;
}
.slds-dropdown-trigger_hover:hover .slds-dropdown,.slds-dropdown-trigger--hover:hover .slds-dropdown, .slds-dropdown-trigger_hover:focus .slds-dropdown, .slds-dropdown-trigger--hover:focus .slds-dropdown{
  visibility:visible;
  opacity:1;
  transition:opacity var(0.1s) linear, visibility var(0.1s) linear;
}
.slds-dropdown-trigger_click .slds-dropdown,.slds-dropdown-trigger--click .slds-dropdown,
.slds-dropdown-trigger_click:hover .slds-dropdown,
.slds-dropdown-trigger--click:hover .slds-dropdown{
  display:none;
}
.slds-dropdown-trigger_click.slds-is-open .slds-dropdown,.slds-dropdown-trigger--click.slds-is-open .slds-dropdown{
  display:block;
  visibility:visible;
  opacity:1;
}
.slds-dropdown{
  position:absolute;
  z-index:7000;
  left:50%;
  transform:translateX(-50%);
  float:inline-start;
  min-width:calc(var(--slds-g-sizing-5) * 6);
  max-width:var(--slds-g-sizing-15);
  margin-block-start:calc(var(--slds-g-spacing-1) / 2);
  margin-block-end:calc(var(--slds-g-spacing-1)) / 2;
  border-radius:var(--slds-g-radius-border-2);
  padding-block:var(--slds-g-spacing-1);
  padding-inline:0;
  font-size:var(--slds-g-font-scale-neg-1);
  background-color:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-g-shadow-2);
  color:var(--slds-g-color-on-surface-2);
}
.slds-dropdown mark{
  font-weight:var(--slds-g-font-weight-7);
  background-color:transparent;
  color:inherit;
}
.slds-dropdown[class*='slds-nubbin_top'],.slds-dropdown[class*='slds-nubbin--top']{
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-dropdown[class*='slds-nubbin_bottom'],.slds-dropdown[class*='slds-nubbin--bottom']{
  margin-block-end:var(--slds-g-spacing-2);
}
.slds-dropdown_inverse,.slds-dropdown--inverse{
  background:var(--slds-g-color-surface-inverse-2);
  border-color:var(--slds-g-color-brand-base-10);
  color:var(--slds-g-color-surface-container-1);
}
.slds-dropdown_inverse .slds-dropdown__item > a,.slds-dropdown--inverse .slds-dropdown__item > a{
  color:var(--slds-g-color-surface-container-1);
}
.slds-dropdown_inverse .slds-dropdown__item > a:hover,.slds-dropdown--inverse .slds-dropdown__item > a:hover,
.slds-dropdown_inverse .slds-dropdown__item > a:focus,
.slds-dropdown--inverse .slds-dropdown__item > a:focus{
  color:var(--slds-g-color-on-surface-inverse-2);
  background-color:transparent;
}
.slds-dropdown_inverse .slds-dropdown__item > a:active,.slds-dropdown--inverse .slds-dropdown__item > a:active{
  color:var(--slds-g-color-neutral-base-80);
  background-color:transparent;
}
.slds-dropdown_inverse .slds-dropdown__item > a[aria-disabled='true'],.slds-dropdown--inverse .slds-dropdown__item > a[aria-disabled='true']{
  color:var(--slds-g-color-palette-blue-20);
  cursor:default;
}
.slds-dropdown_inverse .slds-dropdown__item > a[aria-disabled='true']:hover,.slds-dropdown--inverse .slds-dropdown__item > a[aria-disabled='true']:hover{
  background-color:transparent;
}
.slds-dropdown__header{
  font-size:var(--slds-g-font-scale-neg-1);
  font-weight:var(--slds-g-font-weight-6);
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
}
.slds-dropdown__item{
  line-height:var(--slds-g-font-lineheight-base);
  font-weight:var(--slds-g-font-weight-4);
}
.slds-dropdown__item > a{
  position:relative;
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
  color:var(--slds-g-color-on-surface-2);
  white-space:nowrap;
  cursor:pointer;
}
.slds-dropdown__item > a:hover,
.slds-dropdown__item > a:focus{
  outline:0;
  text-decoration:none;
  background-color:var(
    --slds-s-menu-item-color-background-active,
    var(--slds-g-color-surface-container-2)
  );
}
.slds-dropdown__item > a:focus-visible{
  box-shadow:0 0 0 2px var(--slds-g-color-surface-1) inset, 0 0 0 4px var(--slds-g-color-brand-base-15) inset;
}
.slds-dropdown__item > a:active{
  text-decoration:none;
  background-color:var(
    --slds-s-menu-item-color-background-active,
    var(--slds-g-color-surface-container-2)
  );
}
.slds-dropdown__item > a[aria-disabled='true']{
  color:var(--slds-g-color-disabled-2);
  cursor:default;
}
.slds-dropdown__item > a[aria-disabled='true']:hover{
  background-color:transparent;
}
.slds-dropdown__item > a[aria-disabled='true'] .slds-icon{
  fill:var(--slds-g-color-disabled-2);
}
.slds-dropdown__item > a.slds-has-error{
  --slds-c-icon-color-foreground:var(--slds-g-color-on-error-1);

  color:var(--slds-g-color-on-error-1);
  background:var(--slds-g-color-error-container-1);
}
.slds-dropdown__item > a.slds-has-success{
  --slds-c-icon-color-foreground:var(--slds-g-color-on-success-1);

  color:var(--slds-g-color-on-success-1);
  background:var(--slds-g-color-success-container-1);
}
.slds-dropdown__item > a.slds-has-warning{
  color:var(--slds-g-color-on-warning-1);
  background:var(--slds-g-color-warning-container-1);
}
.slds-dropdown__item > a.slds-has-warning .slds-indicator_unread,.slds-dropdown__item > a.slds-has-warning .slds-indicator--unread{
  background-color:currentColor;
}
.slds-dropdown__item > a.slds-has-warning .slds-indicator_unsaved,.slds-dropdown__item > a.slds-has-warning .slds-indicator--unsaved{
  color:currentColor;
}
.slds-dropdown__item > a.slds-has-error:hover,
.slds-dropdown__item > a.slds-has-error:focus,
.slds-dropdown__item > a.slds-has-success:hover,
.slds-dropdown__item > a.slds-has-success:focus,
.slds-dropdown__item > a.slds-has-warning:hover,
.slds-dropdown__item > a.slds-has-warning:focus{
  text-decoration:underline;
}
.slds-dropdown__item .slds-icon_selected,.slds-dropdown__item .slds-icon--selected{
  --slds-c-icon-color-foreground:var(--slds-g-color-accent-2);

  opacity:0;
  transition:opacity 0.05s ease;
}
.slds-dropdown__item.slds-is-selected .slds-icon_selected,.slds-dropdown__item.slds-is-selected .slds-icon--selected,
.slds-dropdown__item.slds-is-selected .slds-icon--selected{
  opacity:1;
}
.slds-dropdown__item.slds-has-notification .slds-indicator_unsaved,.slds-dropdown__item.slds-has-notification .slds-indicator--unsaved{
  inset-block-start:-0.375rem;
}
.slds-dropdown_left,.slds-dropdown--left{
  inset-inline-start:0;
  inset-inline-end:auto;
  transform:translateX(0);
}
.slds-dropdown_right,.slds-dropdown--right{
  inset-inline-start:auto;
  inset-inline-end:0;
  transform:translateX(0);
}
.slds-dropdown_bottom,.slds-dropdown--bottom{
  inset-block-end:100%;
}
.slds-dropdown_xx-small,.slds-dropdown--xx-small{
  min-width:calc(var(--slds-g-sizing-5) * 6);
}
.slds-dropdown_x-small,.slds-dropdown--x-small{
  min-width:calc(var(--slds-g-sizing-9) * 6);
}
.slds-dropdown_small,.slds-dropdown--small{
  min-width:var(--slds-g-sizing-14);
}
.slds-dropdown_medium,.slds-dropdown--medium{
  min-width:var(--slds-g-sizing-15);
}
.slds-dropdown_large,.slds-dropdown--large{
  min-width:calc(var(--slds-g-sizing-12) * 5);
}
.slds-dropdown_fluid,.slds-dropdown--fluid{
  min-width:calc(var(--slds-g-sizing-5) * 12);
  max-width:100%;
  width:100%;
}
.slds-dropdown_length-5,.slds-dropdown--length-5{
  max-height:calc(
    (var(--slds-g-sizing-5) * var(--slds-g-font-lineheight-base) + var(--slds-g-spacing-4)) * 5
  );
  overflow-y:auto;
}
.slds-dropdown_length-7,.slds-dropdown--length-7{
  max-height:calc(
    (var(--slds-g-sizing-5) * var(--slds-g-font-lineheight-base) + var(--slds-g-spacing-4)) * 7
  );
  overflow-y:auto;
}
.slds-dropdown_length-10,.slds-dropdown--length-10{
  max-height:calc(
    (var(--slds-g-sizing-5) * var(--slds-g-font-lineheight-base) + var(--slds-g-spacing-4)) * 10
  );
  overflow-y:auto;
}
.slds-dropdown_length-with-icon-5,.slds-dropdown--length-with-icon-5{
  max-height:calc((var(--slds-g-sizing-7) + var(--slds-g-spacing-4)) * 5);
  overflow-y:auto;
}
.slds-dropdown_length-with-icon-7,.slds-dropdown--length-with-icon-7{
  max-height:calc((var(--slds-g-sizing-7) + var(--slds-g-spacing-4)) * 7);
  overflow-y:auto;
}
.slds-dropdown_length-with-icon-10,.slds-dropdown--length-with-icon-10{
  max-height:calc((var(--slds-g-sizing-7) + var(--slds-g-spacing-4)) * 10);
  overflow-y:auto;
}
[dir='rtl'] .slds-dropdown_center,[dir='rtl'] .slds-dropdown--center{
  inset-inline-start:auto;
  inset-inline-end:auto;
  transform:translateX(calc(50% - (0.875rem / 2)));
}
.slds-has-submenu{
  position:relative;
}
.slds-has-submenu .slds-dropdown_submenu,.slds-has-submenu .slds-dropdown--submenu{
  inset-block-start:0;
  transform:none;
}
.slds-has-submenu .slds-dropdown_submenu-left,.slds-has-submenu .slds-dropdown--submenu-left{
  inset-inline-start:auto;
  inset-inline-end:100%;
  margin-inline-end:var(--slds-g-spacing-1);
}
.slds-has-submenu .slds-dropdown_submenu-right,.slds-has-submenu .slds-dropdown--submenu-right{
  inset-inline-start:100%;
  margin-inline-start:var(--slds-g-spacing-1);
}
.slds-has-submenu .slds-dropdown_submenu-bottom,.slds-has-submenu .slds-dropdown--submenu-bottom{
  inset-block-start:auto;
  inset-block-end:0;
  margin-block-end:calc(var(--slds-g-spacing-1) * -1);
}
.slds-has-submenu.slds-dropdown__item .slds-dropdown_submenu,.slds-has-submenu.slds-dropdown__item .slds-dropdown--submenu{
  display:none;
}
.slds-has-submenu [role='menuitem'][aria-expanded='true'] + .slds-dropdown_submenu,.slds-has-submenu [role='menuitem'][aria-expanded='true'] + .slds-dropdown--submenu{
  display:block;
}
.slds-dropdown_actions a,.slds-dropdown--actions a{
  color:var(--slds-g-color-neutral-base-10);
}
.slds-combobox_container,.slds-combobox--container{
  display:flex;
  flex-direction:column;
  position:relative;
}
.slds-combobox_container.slds-is-open .slds-dropdown,.slds-combobox--container.slds-is-open .slds-dropdown{
  display:block;
}
.slds-combobox_container.slds-has-selection .slds-combobox__input-value,.slds-combobox--container.slds-has-selection .slds-combobox__input-value,
.slds-combobox_container.slds-has-selection .slds-combobox__input-value:focus,
.slds-combobox--container.slds-has-selection .slds-combobox__input-value:focus{
  box-shadow:0 0 0 2px var(--slds-g-color-surface-container-1) inset, 0 0 0 3px var(--slds-g-color-border-1) inset;
}
.slds-combobox_container[invalid],.slds-combobox--container[invalid]{
  --slds-c-input-color-background:var(--slds-s-input-color-background-invalid);
  --slds-c-input-text-color:var(--slds-s-input-color-invalid);
  --slds-c-input-color-border:var(--slds-g-color-border-error-1);
  --slds-c-input-shadow:var(--slds-s-input-shadow-invalid);
}
.slds-combobox_container.slds-has-icon-only .slds-combobox__input,.slds-combobox--container.slds-has-icon-only .slds-combobox__input,
.slds-combobox_container.slds-has-icon-only .slds-combobox__input:focus,
.slds-combobox--container.slds-has-icon-only .slds-combobox__input:focus,
.slds-combobox_container.slds-has-icon-only .slds-combobox__input.slds-has-focus,
.slds-combobox--container.slds-has-icon-only .slds-combobox__input.slds-has-focus{
  width:0;
  pointer-events:auto;
}
.slds-combobox_container.slds-has-icon-only .slds-input__icon,.slds-combobox--container.slds-has-icon-only .slds-input__icon{
  z-index:2;
  pointer-events:none;
}
.slds-combobox{
  position:static;
  display:flex;
  flex-direction:column;
  flex:1 1 auto;
}
.slds-combobox__form-element{
  flex:1 1 auto;
}
[role='combobox'] input[readonly],
input[readonly][role='combobox']{
  padding-inline-start:var(--slds-g-spacing-3);
  border-color:var(--slds-g-color-border-2);
  background-color:var(--slds-g-color-surface-container-1);
  font-size:inherit;
}
[role='combobox'] input[readonly]:focus-visible,
[role='combobox'] input[readonly].slds-has-focus,
input[readonly][role='combobox']:focus-visible,
input[readonly][role='combobox'].slds-has-focus{
  border-color:var(--slds-s-input-color-border-focus);
  box-shadow:var(--slds-s-input-shadow-focus);
}
[role='combobox'] input[readonly][disabled], input[readonly][role='combobox'][disabled]{
  background-color:var(--slds-s-input-color-background-disabled);
  border-color:var(--slds-s-input-color-border-disabled);
}
.slds-listbox_inline,.slds-listbox--inline{
  display:inline-flex;
  flex-wrap:wrap;
  flex-shrink:0;
  align-items:center;
  margin-inline-start:0.125rem;
  margin-inline-end:0.125rem;
}
.slds-listbox_inline li,.slds-listbox--inline li{
  display:flex;
}
.slds-listbox_inline li + li,.slds-listbox--inline li + li{
  padding-inline-start:0.125rem;
}
.slds-listbox_horizontal,.slds-listbox--horizontal{
  display:inline-flex;
  flex-wrap:wrap;
  align-items:center;
}
.slds-listbox_horizontal li,.slds-listbox--horizontal li{
  display:flex;
}
.slds-listbox_horizontal li + li,.slds-listbox--horizontal li + li{
  padding-inline-start:0.125rem;
}
.slds-listbox__option:hover{
  cursor:pointer;
}
.slds-listbox__option:focus{
  outline:0;
}
.slds-listbox__option .slds-truncate{
  display:inline-block;
  vertical-align:middle;
}
.slds-listbox__option[aria-disabled='true']{
  color:var(--slds-g-color-disabled-1);
}
.slds-listbox__option-header{
  font-size:var(--slds-g-font-scale-neg-1);
  font-weight:var(--slds-g-font-weight-6);
}
.slds-listbox__option-icon{
  width:var(--slds-g-sizing-7);
  display:inline-flex;
  align-content:center;
  align-items:center;
  justify-content:center;
  color:var(--slds-g-color-on-surface-1);
}
.slds-listbox__option[aria-disabled='true'] .slds-listbox__option-icon{
  color:currentColor;
}
.slds-listbox_vertical .slds-listbox__option:focus,.slds-listbox--vertical .slds-listbox__option:focus,
.slds-listbox_vertical .slds-listbox__option:hover,
.slds-listbox--vertical .slds-listbox__option:hover,
.slds-listbox_vertical .slds-listbox__option.slds-has-focus,
.slds-listbox--vertical .slds-listbox__option.slds-has-focus{
  background-color:var(
    --slds-s-menu-item-color-background-active,
    var(--slds-g-color-surface-container-2)
  );
  text-decoration:none;
}
.slds-listbox_vertical .slds-listbox__option[aria-disabled='true'],.slds-listbox--vertical .slds-listbox__option[aria-disabled='true'],
.slds-listbox_vertical .slds-listbox__option[role='presentation']:hover,
.slds-listbox--vertical .slds-listbox__option[role='presentation']:hover{
  background-color:transparent;
  cursor:default;
}
.slds-listbox_vertical .slds-listbox__option_entity,.slds-listbox--vertical .slds-listbox__option--entity{
  padding-block:var(--slds-g-spacing-1);
  padding-inline:var(--slds-g-spacing-3);
}
.slds-listbox_vertical .slds-listbox__option_entity .slds-media__figure,.slds-listbox--vertical .slds-listbox__option--entity .slds-media__figure{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-listbox_vertical .slds-listbox__option_plain,.slds-listbox--vertical .slds-listbox__option--plain{
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
}
.slds-listbox_vertical .slds-listbox__option_term,.slds-listbox--vertical .slds-listbox__option--term{
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
}
.slds-listbox_vertical .slds-listbox__option_has-meta .slds-media__figure,.slds-listbox--vertical .slds-listbox__option--has-meta .slds-media__figure{
  margin-block-start:var(--slds-g-spacing-1);
}
.slds-input-has-icon_left .slds-combobox__input[value],.slds-input-has-icon--left .slds-combobox__input[value],
.slds-input-has-icon_left .slds-combobox__input.slds-combobox__input-value,
.slds-input-has-icon--left .slds-combobox__input.slds-combobox__input-value,
.slds-input-has-icon_left-right .slds-combobox__input[value],
.slds-input-has-icon--left-right .slds-combobox__input[value],
.slds-input-has-icon_left-right .slds-combobox__input.slds-combobox__input-value,
.slds-input-has-icon--left-right .slds-combobox__input.slds-combobox__input-value{
  padding-inline-start:calc(var(--slds-g-sizing-7) + var(--slds-g-spacing-3));
}
.slds-combobox__input-entity-icon{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
  position:absolute;
  top:50%;
  inset-inline-start:calc(var(--slds-g-spacing-1) + 1px);
  transform:translateY(-50%);
  z-index:2;
}
.slds-combobox__input-entity-icon .slds-icon{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
}
.slds-combobox_container__icon,.slds-combobox--container__icon{
  color:var(--slds-g-color-on-surface-3);
}
.slds-listbox__icon-selected{
  opacity:0;
  fill:var(--slds-g-color-accent-1);
}
.slds-listbox__option.slds-is-selected .slds-listbox__icon-selected{
  opacity:1;
}
.slds-listbox__option.slds-is-selected .slds-listbox__option-icon{
  color:var(--slds-s-menu-item-color-active, var(--slds-g-color-accent-1));
}
.slds-listbox__option[aria-checked='true'] .slds-icon{
  --slds-c-icon-color-foreground:var(--slds-g-color-accent-2);
}
.slds-listbox__option-text_entity,.slds-listbox__option-text--entity{
  max-width:100%;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  display:block;
  margin-block-end:0.125rem;
}
.slds-listbox__option-meta{
  display:block;
  margin-block-start:calc(var(--slds-g-spacing-1) * -1);
  color:var(--slds-g-color-on-surface-1);
}
.slds-listbox__option[aria-disabled='true'] .slds-listbox__option-meta{
  color:currentColor;
}
.slds-listbox_object-switcher,.slds-listbox--object-switcher{
  flex-shrink:0;
  padding:0.125rem;
}
.slds-combobox_object-switcher,.slds-combobox--object-switcher{
  flex-shrink:0;
}
.slds-combobox_object-switcher .slds-combobox__input,.slds-combobox--object-switcher .slds-combobox__input{
  width:7.5rem;
  transition:width 80ms linear;
  font-size:var(--slds-g-font-scale-neg-1);
  color:var(--slds-s-input-color);
}
.slds-combobox_object-switcher .slds-combobox__input:focus,.slds-combobox--object-switcher .slds-combobox__input:focus,
.slds-combobox_object-switcher .slds-combobox__input.slds-has-focus,
.slds-combobox--object-switcher .slds-combobox__input.slds-has-focus{
  width:var(--slds-g-sizing-13);
}
.slds-combobox__input:focus-visible,
.slds-combobox__input.slds-has-focus{
  border-color:var(--slds-s-input-color-border-focus);
  box-shadow:var(--slds-s-input-shadow-focus);
}
.slds-combobox-group{
  display:flex;
  flex-direction:row;
}
.slds-combobox-group .slds-combobox_container,.slds-combobox-group .slds-combobox--container{
  flex:1 1 auto;
}
.slds-combobox-group .slds-combobox__input,
.slds-combobox-group .slds-combobox_object-switcher__button,
.slds-combobox-group .slds-combobox--object-switcher__button{
  border-radius:0;
  margin-inline-start:-1px;
  margin-inline-end:-1px;
  position:relative;
}
.slds-combobox-group .slds-combobox__input:focus,
.slds-combobox-group .slds-combobox__input.slds-has-focus,
.slds-combobox-group .slds-combobox_object-switcher__button:focus,
.slds-combobox-group .slds-combobox--object-switcher__button:focus,
.slds-combobox-group .slds-combobox_object-switcher__button.slds-has-focus,
.slds-combobox-group .slds-combobox--object-switcher__button.slds-has-focus{
  z-index:1;
}
.slds-combobox-group.slds-has-selection .slds-combobox-addon_start .slds-combobox__input,.slds-combobox-group.slds-has-selection .slds-combobox-addon--start .slds-combobox__input{
  border-end-start-radius:0;
}
.slds-combobox-group.slds-has-selection .slds-combobox-addon_end .slds-combobox__input,.slds-combobox-group.slds-has-selection .slds-combobox-addon--end .slds-combobox__input{
  border-end-end-radius:0;
}
.slds-combobox-group.slds-has-selection ~ .slds-listbox_selection-group,.slds-combobox-group.slds-has-selection ~ .slds-listbox--selection-group{
  display:flex;
  position:relative;
  background:var(--slds-g-color-surface-container-1);
  border:1px solid var(--slds-s-input-color-border, var(--slds-g-color-border-1));
  border-block-start:0;
  border-end-start-radius:var(--slds-s-input-radius-border);
  border-end-end-radius:var(--slds-s-input-radius-border);
  inset-inline-start:-1px;
}
.slds-combobox-group .slds-listbox_horizontal li + li,.slds-combobox-group .slds-listbox--horizontal li + li{
  padding:0.125rem;
}
.slds-listbox_selection-group,.slds-listbox--selection-group{
  position:relative;
  padding:0;
  padding-inline-end:3.75rem;
  height:1.875rem;
  overflow:hidden;
}
.slds-listbox_selection-group.slds-is-expanded,.slds-listbox--selection-group.slds-is-expanded{
  height:auto;
  padding:0;
}
.slds-listbox_selection-group .slds-listbox,.slds-listbox--selection-group .slds-listbox{
  padding-block:0 0.125rem;
  padding-inline:0;
}
.slds-listbox_selection-group .slds-listbox-item,.slds-listbox--selection-group .slds-listbox-item{
  padding-block:0.125rem 0;
  padding-inline:0.125rem;
}
.slds-listbox_selection-group .slds-listbox-toggle,.slds-listbox--selection-group .slds-listbox-toggle{
  position:absolute;
  top:50%;
  transform:translateY(-50%);
  inset-inline-end:var(--slds-g-spacing-2);
}
.slds-listbox_selection-group .slds-listbox-toggle .slds-button,.slds-listbox--selection-group .slds-listbox-toggle .slds-button{
  line-height:1;
}
.slds-combobox-addon_start .slds-combobox__input,.slds-combobox-addon--start .slds-combobox__input{
  border-start-end-radius:0;
  border-end-end-radius:0;
  border-start-start-radius:var(--slds-s-input-radius-border);
  border-end-start-radius:var(--slds-s-input-radius-border);
}
.slds-combobox-addon_end .slds-combobox__input,.slds-combobox-addon--end .slds-combobox__input{
  border-start-end-radius:var(--slds-s-input-radius-border);
  border-end-end-radius:var(--slds-s-input-radius-border);
  border-start-start-radius:0;
  border-end-start-radius:0;
}
.slds-has-inline-listbox,
.slds-has-object-switcher{
  flex-direction:row;
  background:var(--slds-s-input-color-background);
  border:var(--slds-g-sizing-border-1) solid var(--slds-s-input-color-border);
  border-radius:var(--slds-s-input-radius-border);
}
.slds-has-inline-listbox .slds-combobox, .slds-has-object-switcher .slds-combobox{
  flex-basis:50%;
  flex-shrink:0;
}
.slds-has-inline-listbox .slds-combobox__input, .slds-has-object-switcher .slds-combobox__input{
  min-height:100%;
  line-height:calc(var(--slds-g-sizing-9) - 4px);
  border:0;
  padding-block-start:0.125rem;
  padding-block-end:0.125rem;
}
.slds-has-inline-listbox .slds-combobox__input:focus,
.slds-has-inline-listbox .slds-combobox__input:active,
.slds-has-object-switcher .slds-combobox__input:focus,
.slds-has-object-switcher .slds-combobox__input:active{
  outline:0;
  box-shadow:none;
}
.slds-has-inline-listbox .slds-listbox_object-switcher ~ .slds-listbox_inline,.slds-has-inline-listbox .slds-listbox--object-switcher ~ .slds-listbox--inline,
.slds-has-inline-listbox .slds-combobox_container__icon ~ .slds-listbox_inline,
.slds-has-inline-listbox .slds-combobox--container__icon ~ .slds-listbox--inline,
.slds-has-object-switcher .slds-listbox_object-switcher ~ .slds-listbox_inline,
.slds-has-object-switcher .slds-listbox--object-switcher ~ .slds-listbox--inline,
.slds-has-object-switcher .slds-combobox_container__icon ~ .slds-listbox_inline,
.slds-has-object-switcher .slds-combobox--container__icon ~ .slds-listbox--inline{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-has-inline-listbox.slds-has-icon_left,.slds-has-inline-listbox.slds-has-icon--left, .slds-has-object-switcher.slds-has-icon_left, .slds-has-object-switcher.slds-has-icon--left{
  padding-inline-start:calc(var(--slds-g-spacing-6) + var(--slds-g-spacing-1));
}
.slds-has-inline-listbox.slds-has-icon_left .slds-combobox_container__icon,.slds-has-inline-listbox.slds-has-icon--left .slds-combobox--container__icon, .slds-has-object-switcher.slds-has-icon_left .slds-combobox_container__icon, .slds-has-object-switcher.slds-has-icon--left .slds-combobox--container__icon{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  position:absolute;
  inset-inline-start:calc(var(--slds-g-spacing-4) + 0.125rem);
  inset-block-start:50%;
  margin-block-start:calc(var(--slds-g-spacing-2) * -1);
}
.slds-has-inline-listbox [role='listbox']{
  display:inline-flex;
  padding-block:0;
  padding-inline:0.125rem;
}
.slds-has-inline-listbox .slds-combobox__input-value{
  box-shadow:0 0 0 2px var(--slds-g-color-surface-container-1) inset, 0 0 0 3px var(--slds-g-color-border-1) inset;
}
.slds-popover{
  position:relative;
  border-radius:var(--slds-g-radius-border-2);
  width:var(--slds-g-sizing-15);
  min-height:calc(1rem * 2);
  z-index:var(--slds-c-popover-position-zindex, 6000);
  background-color:var(--slds-g-color-surface-container-1);
  display:inline-block;
  box-shadow:var(--slds-g-shadow-2);
  border:1px solid var(--slds-g-color-border-1);
}
.slds-popover__meta{
  margin-block-end:var(--slds-g-spacing-3);
}
.slds-popover__body{
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
  color:var(--slds-s-container-color);
}
.slds-popover__body .slds-popover__header{
  padding-block:0 var(--slds-g-spacing-2);
  padding-inline:0;
}
.slds-popover__body,
.slds-popover__header,
.slds-popover__footer{
  position:relative;
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
  word-wrap:break-word;
}
.slds-popover__header{
  border-block-end:0;
  color:var(--slds-s-container-heading-font-color);
  font-weight:var(--slds-s-container-heading-font-weight);
}
.slds-popover__footer{
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-90);
  background-color:var(--slds-s-container-footer-color-background, var(--slds-g-color-surface-container-2));
  border-end-start-radius:inherit;
  border-end-end-radius:inherit;
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
  color:var(--slds-s-container-footer-font-color);
}
.slds-popover__footer_form,.slds-popover__footer--form{
  text-align:center;
  background:var(--slds-g-color-surface-container-2);
  border-start-start-radius:0;
  border-start-end-radius:0;
  border-end-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:var(--slds-g-radius-border-2);
}
.slds-popover__body_small,.slds-popover__body--small{
  max-height:var(--slds-g-sizing-14);
  overflow-y:auto;
}
.slds-popover__close{
  position:relative;
  margin:var(--slds-g-spacing-1);
  z-index:6001;
}
.slds-popover_small,.slds-popover--small{
  max-width:var(--slds-g-sizing-14);
}
.slds-popover_medium,.slds-popover--medium{
  min-width:var(--slds-g-sizing-15);
}
.slds-popover_large,.slds-popover--large{
  min-width:calc(var(--slds-g-sizing-15) + var(--slds-g-sizing-12));
  max-width:512px;
}
.slds-popover[class*='theme_'],.slds-popover[class*='theme--']{
  border:0;
}
.slds-popover *:last-child{
  margin-block-end:0;
}
.slds-popover_full-width,.slds-popover--full-width{
  width:100%;
}
.slds-popover_hide,.slds-popover--hide{
  display:none;
}
.slds-popover_dark,.slds-popover--dark{
  background-color:var(--slds-g-color-surface-inverse-2);
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-popover_dark .slds-badge,.slds-popover--dark .slds-badge{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-popover_dark .slds-popover__close,.slds-popover--dark .slds-popover__close{
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-popover_dark .slds-text-title,.slds-popover--dark .slds-text-title{
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-popover_dark a,.slds-popover--dark a{
  color:var(--slds-g-color-on-surface-inverse-1);
  text-decoration:underline;
}
.slds-popover_dark a:hover,.slds-popover--dark a:hover{
  text-decoration:none;
}
.slds-popover_dark .slds-icon-text-default,.slds-popover--dark .slds-icon-text-default{
  fill:var(--slds-g-color-on-accent-1);
}
.slds-popover_dark .slds-popover__header,.slds-popover--dark .slds-popover__header{
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-popover_dark .slds-popover__body,.slds-popover--dark .slds-popover__body{
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-popover_dark .slds-popover__footer,.slds-popover--dark .slds-popover__footer{
  border-block-start-color:var(--slds-g-color-brand-base-10);
  background-color:var(--slds-g-color-surface-inverse-1);
}
.slds-popover_brand .slds-popover__footer,.slds-popover--brand .slds-popover__footer{
  background-color:transparent;
  border-color:transparent;
}
.slds-popover_brand .slds-popover__icon,.slds-popover--brand .slds-popover__icon{
  fill:var(--slds-g-color-accent-2);
}
.slds-popover_brand .slds-popover__body .slds-icon-text-default,.slds-popover--brand .slds-popover__body .slds-icon-text-default{
  --slds-c-icon-color-foreground:var(--slds-g-color-accent-2);
}
.slds-popover_brand.slds-popover_brand-dark .slds-popover__icon,.slds-popover--brand.slds-popover--brand-dark .slds-popover__icon{
  fill:var(--slds-g-color-brand-base-10);
}
.slds-popover_brand-top,.slds-popover--brand-top{
  border-block-start-width:0.25rem;
  border-block-start-color:var(--slds-g-color-border-accent-1);
}
.slds-popover_brand-top.slds-nubbin_top::before,.slds-popover--brand-top.slds-nubbin--top::before,
.slds-popover_brand-top.slds-nubbin_top-left::before,
.slds-popover--brand-top.slds-nubbin--top-left::before,
.slds-popover_brand-top.slds-nubbin_top-left-corner::before,
.slds-popover--brand-top.slds-nubbin--top-left-corner::before,
.slds-popover_brand-top.slds-nubbin_top-right::before,
.slds-popover--brand-top.slds-nubbin--top-right::before,
.slds-popover_brand-top.slds-nubbin_top-right-corner::before,
.slds-popover--brand-top.slds-nubbin--top-right-corner::before{
  margin-block-start:-0.1875rem;
  background:linear-gradient(
    -45deg,
    transparent 50%,
    var(--slds-g-color-accent-container-1) 50%,
    var(--slds-g-color-accent-container-1)
  );
}
.slds-popover_brand-top.slds-nubbin_top::after,.slds-popover--brand-top.slds-nubbin--top::after,
.slds-popover_brand-top.slds-nubbin_top-left::after,
.slds-popover--brand-top.slds-nubbin--top-left::after,
.slds-popover_brand-top.slds-nubbin_top-left-corner::after,
.slds-popover--brand-top.slds-nubbin--top-left-corner::after,
.slds-popover_brand-top.slds-nubbin_top-right::after,
.slds-popover--brand-top.slds-nubbin--top-right::after,
.slds-popover_brand-top.slds-nubbin_top-right-corner::after,
.slds-popover--brand-top.slds-nubbin--top-right-corner::after{
  margin-block-start:-0.1875rem;
  background:linear-gradient(-45deg, transparent 50%, transparent 50%, transparent);
}
.slds-popover_brand-top.slds-popover_brand-dark,.slds-popover--brand-top.slds-popover--brand-dark{
  border-block-start-color:var(--slds-g-color-brand-base-10);
}
.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top::before,.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top::before,
.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top-left::before,
.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top-left::before,
.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top-left-corner::before,
.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top-left-corner::before,
.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top-right::before,
.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top-right::before,
.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top-right-corner::before,
.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top-right-corner::before{
  margin-block-start:-0.1875rem;
  background:linear-gradient(
    -45deg,
    transparent 50%,
    var(--slds-g-color-brand-base-10) 50%,
    var(--slds-g-color-brand-base-10)
  );
}
.slds-popover_brand-left,.slds-popover--brand-left{
  border-inline-start-width:0.25rem;
  border-inline-start-color:var(--slds-g-color-border-accent-1);
}
.slds-popover_brand-left.slds-nubbin_left::before,.slds-popover--brand-left.slds-nubbin--left::before,
.slds-popover_brand-left.slds-nubbin_left-top::before,
.slds-popover--brand-left.slds-nubbin--left-top::before,
.slds-popover_brand-left.slds-nubbin_left-top-corner::before,
.slds-popover--brand-left.slds-nubbin--left-top-corner::before,
.slds-popover_brand-left.slds-nubbin_left-bottom::before,
.slds-popover--brand-left.slds-nubbin--left-bottom::before,
.slds-popover_brand-left.slds-nubbin_left-bottom-corner::before,
.slds-popover--brand-left.slds-nubbin--left-bottom-corner::before{
  margin-inline-start:-0.1875rem;
  background:linear-gradient(
    -135deg,
    transparent 50%,
    var(--slds-g-color-accent-container-1) 50%,
    var(--slds-g-color-accent-container-1)
  );
}
.slds-popover_brand-left.slds-nubbin_left::after,.slds-popover--brand-left.slds-nubbin--left::after,
.slds-popover_brand-left.slds-nubbin_left-top::after,
.slds-popover--brand-left.slds-nubbin--left-top::after,
.slds-popover_brand-left.slds-nubbin_left-top-corner::after,
.slds-popover--brand-left.slds-nubbin--left-top-corner::after,
.slds-popover_brand-left.slds-nubbin_left-bottom::after,
.slds-popover--brand-left.slds-nubbin--left-bottom::after,
.slds-popover_brand-left.slds-nubbin_left-bottom-corner::after,
.slds-popover--brand-left.slds-nubbin--left-bottom-corner::after{
  margin-inline-start:-0.1875rem;
  background:linear-gradient(-135deg, transparent 50%, transparent 50%, transparent);
}
.slds-popover_brand-left.slds-popover_brand-dark,.slds-popover--brand-left.slds-popover--brand-dark{
  border-inline-start-color:var(--slds-g-color-brand-base-10);
}
.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left::before,.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left::before,
.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left-top::before,
.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left-top::before,
.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left-top-corner::before,
.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left-top-corner::before,
.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left-bottom::before,
.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left-bottom::before,
.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left-bottom-corner::before,
.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left-bottom-corner::before{
  margin-inline-start:-0.1875rem;
  background:linear-gradient(
    -135deg,
    transparent 50%,
    var(--slds-g-color-brand-base-10) 50%,
    var(--slds-g-color-brand-base-10)
  );
}
.slds-popover_brand-bottom,.slds-popover--brand-bottom{
  border-block-end-width:0.25rem;
  border-block-end-color:var(--slds-g-color-border-accent-1);
}
.slds-popover_brand-bottom.slds-nubbin_bottom::before,.slds-popover--brand-bottom.slds-nubbin--bottom::before,
.slds-popover_brand-bottom.slds-nubbin_bottom-left::before,
.slds-popover--brand-bottom.slds-nubbin--bottom-left::before,
.slds-popover_brand-bottom.slds-nubbin_bottom-left-corner::before,
.slds-popover--brand-bottom.slds-nubbin--bottom-left-corner::before,
.slds-popover_brand-bottom.slds-nubbin_bottom-right::before,
.slds-popover--brand-bottom.slds-nubbin--bottom-right::before,
.slds-popover_brand-bottom.slds-nubbin_bottom-right-corner::before,
.slds-popover--brand-bottom.slds-nubbin--bottom-right-corner::before{
  margin-block-end:-0.1875rem;
  background:linear-gradient(
    135deg,
    transparent 50%,
    var(--slds-g-color-accent-container-1) 50%,
    var(--slds-g-color-accent-container-1)
  );
}
.slds-popover_brand-bottom.slds-nubbin_bottom::after,.slds-popover--brand-bottom.slds-nubbin--bottom::after,
.slds-popover_brand-bottom.slds-nubbin_bottom-left::after,
.slds-popover--brand-bottom.slds-nubbin--bottom-left::after,
.slds-popover_brand-bottom.slds-nubbin_bottom-left-corner::after,
.slds-popover--brand-bottom.slds-nubbin--bottom-left-corner::after,
.slds-popover_brand-bottom.slds-nubbin_bottom-right::after,
.slds-popover--brand-bottom.slds-nubbin--bottom-right::after,
.slds-popover_brand-bottom.slds-nubbin_bottom-right-corner::after,
.slds-popover--brand-bottom.slds-nubbin--bottom-right-corner::after{
  margin-block-end:-0.1875rem;
  background:linear-gradient(135deg, transparent 50%, transparent 50%, transparent);
}
.slds-popover_brand-bottom.slds-popover_brand-dark,.slds-popover--brand-bottom.slds-popover--brand-dark{
  border-block-end-color:var(--slds-g-color-brand-base-10);
}
.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom::before,.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom::before,
.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom-left::before,
.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom-left::before,
.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom-left-corner::before,
.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom-left-corner::before,
.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom-right::before,
.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom-right::before,
.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom-right-corner::before,
.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom-right-corner::before{
  margin-block-end:-0.1875rem;
  background:linear-gradient(
    135deg,
    transparent 50%,
    var(--slds-g-color-brand-base-10) 50%,
    var(--slds-g-color-brand-base-10)
  );
}
.slds-popover_brand-right,.slds-popover--brand-right{
  border-inline-end-width:0.25rem;
  border-inline-end-color:var(--slds-g-color-border-accent-1);
}
.slds-popover_brand-right.slds-nubbin_right::before,.slds-popover--brand-right.slds-nubbin--right::before,
.slds-popover_brand-right.slds-nubbin_right-top::before,
.slds-popover--brand-right.slds-nubbin--right-top::before,
.slds-popover_brand-right.slds-nubbin_right-top-corner::before,
.slds-popover--brand-right.slds-nubbin--right-top-corner::before,
.slds-popover_brand-right.slds-nubbin_right-bottom::before,
.slds-popover--brand-right.slds-nubbin--right-bottom::before,
.slds-popover_brand-right.slds-nubbin_right-bottom-corner::before,
.slds-popover--brand-right.slds-nubbin--right-bottom-corner::before{
  margin-inline-end:-0.1875rem;
  background:linear-gradient(
    45deg,
    transparent 50%,
    var(--slds-g-color-accent-container-1) 50%,
    var(--slds-g-color-accent-container-1)
  );
}
.slds-popover_brand-right.slds-nubbin_right::after,.slds-popover--brand-right.slds-nubbin--right::after,
.slds-popover_brand-right.slds-nubbin_right-top::after,
.slds-popover--brand-right.slds-nubbin--right-top::after,
.slds-popover_brand-right.slds-nubbin_right-top-corner::after,
.slds-popover--brand-right.slds-nubbin--right-top-corner::after,
.slds-popover_brand-right.slds-nubbin_right-bottom::after,
.slds-popover--brand-right.slds-nubbin--right-bottom::after,
.slds-popover_brand-right.slds-nubbin_right-bottom-corner::after,
.slds-popover--brand-right.slds-nubbin--right-bottom-corner::after{
  margin-inline-end:-0.1875rem;
  background:linear-gradient(45deg, transparent 50%, transparent 50%, transparent);
}
.slds-popover_brand-right.slds-popover_brand-dark,.slds-popover--brand-right.slds-popover--brand-dark{
  border-inline-end-color:var(--slds-g-color-brand-base-10);
}
.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right::before,.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right::before,
.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right-top::before,
.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right-top::before,
.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right-top-corner::before,
.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right-top-corner::before,
.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right-bottom::before,
.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right-bottom::before,
.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right-bottom-corner::before,
.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right-bottom-corner::before{
  margin-inline-end:-0.1875rem;
  background:linear-gradient(
    45deg,
    transparent 50%,
    var(--slds-g-color-brand-base-10) 50%,
    var(--slds-g-color-brand-base-10)
  );
}
.slds-popover_panel .slds-popover__header,.slds-popover--panel .slds-popover__header{
  background:var(--sds-g-color-surface-container-2);
  padding-block:var(--slds-g-spacing-5) var(--slds-g-spacing-3);
  padding-inline:var(--slds-g-spacing-5);
  border-start-start-radius:calc(var(--slds-g-radius-border-2) - 1px);
  border-start-end-radius:calc(var(--slds-g-radius-border-2) - 1px);
  border-block-end:0;
}
.slds-popover_panel .slds-popover__body,.slds-popover--panel .slds-popover__body{
  padding:0;
}
.slds-popover_panel .slds-popover__body-list,.slds-popover--panel .slds-popover__body-list{
  padding-block:var(--slds-g-spacing-4);
  padding-inline:var(--slds-g-spacing-5);
  border-block-start:1px solid var(--slds-g-color-neutral-base-90);
}
.slds-popover_panel.slds-nubbin_left-top::before,.slds-popover--panel.slds-nubbin--left-top::before,
.slds-popover_panel.slds-nubbin_left-top::after,
.slds-popover--panel.slds-nubbin--left-top::after,
.slds-popover_panel.slds-nubbin--left-top::before,
.slds-popover--panel.slds-nubbin--left-top::before,
.slds-popover_panel.slds-nubbin--left-top::after,
.slds-popover--panel.slds-nubbin--left-top::after,
.slds-popover_panel.slds-nubbin_right-top::before,
.slds-popover--panel.slds-nubbin--right-top::before,
.slds-popover_panel.slds-nubbin_right-top::after,
.slds-popover--panel.slds-nubbin--right-top::after,
.slds-popover_panel.slds-nubbin--right-top::before,
.slds-popover--panel.slds-nubbin--right-top::before,
.slds-popover_panel.slds-nubbin--right-top::after,
.slds-popover--panel.slds-nubbin--right-top::after,
.slds-popover_panel.slds-nubbin_top-left::before,
.slds-popover--panel.slds-nubbin--top-left::before,
.slds-popover_panel.slds-nubbin_top-left::after,
.slds-popover--panel.slds-nubbin--top-left::after,
.slds-popover_panel.slds-nubbin--top-left::before,
.slds-popover--panel.slds-nubbin--top-left::before,
.slds-popover_panel.slds-nubbin--top-left::after,
.slds-popover--panel.slds-nubbin--top-left::after,
.slds-popover_panel.slds-nubbin_top-right::before,
.slds-popover--panel.slds-nubbin--top-right::before,
.slds-popover_panel.slds-nubbin_top-right::after,
.slds-popover--panel.slds-nubbin--top-right::after,
.slds-popover_panel.slds-nubbin--top-right::before,
.slds-popover--panel.slds-nubbin--top-right::before,
.slds-popover_panel.slds-nubbin--top-right::after,
.slds-popover--panel.slds-nubbin--top-right::after{
  background:var(--slds-g-color-surface-container-2);
}
.slds-popover_panel.slds-nubbin_left-top::before,.slds-popover--panel.slds-nubbin--left-top::before,
.slds-popover_panel.slds-nubbin_left-top::after,
.slds-popover--panel.slds-nubbin--left-top::after,
.slds-popover_panel.slds-nubbin--left-top::before,
.slds-popover--panel.slds-nubbin--left-top::before,
.slds-popover_panel.slds-nubbin--left-top::after,
.slds-popover--panel.slds-nubbin--left-top::after,
.slds-popover_panel.slds-nubbin_right-top::before,
.slds-popover--panel.slds-nubbin--right-top::before,
.slds-popover_panel.slds-nubbin_right-top::after,
.slds-popover--panel.slds-nubbin--right-top::after,
.slds-popover_panel.slds-nubbin--right-top::before,
.slds-popover--panel.slds-nubbin--right-top::before,
.slds-popover_panel.slds-nubbin--right-top::after,
.slds-popover--panel.slds-nubbin--right-top::after{
  inset-block-start:var(--slds-g-spacing-7);
}
.slds-popover_panel__label,.slds-popover--panel__label{
  font-size:var(--slds-g-font-scale-1);
  font-weight:var(--slds-g-font-weight-7);
}
.slds-nubbin_top::before,.slds-nubbin--top::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-start:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_top::after,.slds-nubbin--top::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-start:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
  box-shadow:-1px -1px 0 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_top-left::before,.slds-nubbin--top-left::before,
.slds-nubbin_top-left-corner::before,
.slds-nubbin--top-left-corner::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-start:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_top-left::after,.slds-nubbin--top-left::after,
.slds-nubbin_top-left-corner::after,
.slds-nubbin--top-left-corner::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-start:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
  box-shadow:-1px -1px 0 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_top-left::before,.slds-nubbin--top-left::before,
.slds-nubbin_top-left::after,
.slds-nubbin--top-left::after,
.slds-nubbin_top-left-corner::before,
.slds-nubbin--top-left-corner::before,
.slds-nubbin_top-left-corner::after,
.slds-nubbin--top-left-corner::after{
  inset-inline-start:var(--slds-g-spacing-5);
  inset-block-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_top-right::before,.slds-nubbin--top-right::before,
.slds-nubbin_top-right-corner::before,
.slds-nubbin--top-right-corner::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-start:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_top-right::after,.slds-nubbin--top-right::after,
.slds-nubbin_top-right-corner::after,
.slds-nubbin--top-right-corner::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-start:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
  box-shadow:-1px -1px 0 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_top-right::before,.slds-nubbin--top-right::before,
.slds-nubbin_top-right::after,
.slds-nubbin--top-right::after,
.slds-nubbin_top-right-corner::before,
.slds-nubbin--top-right-corner::before,
.slds-nubbin_top-right-corner::after,
.slds-nubbin--top-right-corner::after{
  inset-inline-start:auto;
  inset-inline-end:var(--slds-g-spacing-5);
  inset-block-start:calc((1rem * 0.5) * -1);
  margin-inline-end:calc((1rem * 0.5) * -1);
}
.slds-nubbin_bottom::before,.slds-nubbin--bottom::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-end:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_bottom::after,.slds-nubbin--bottom::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-end:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
  box-shadow:2px 2px 4px 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_bottom-left::before,.slds-nubbin--bottom-left::before,
.slds-nubbin_bottom-left-corner::before,
.slds-nubbin--bottom-left-corner::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-end:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_bottom-left::after,.slds-nubbin--bottom-left::after,
.slds-nubbin_bottom-left-corner::after,
.slds-nubbin--bottom-left-corner::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-end:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
  box-shadow:2px 2px 4px 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_bottom-left::before,.slds-nubbin--bottom-left::before,
.slds-nubbin_bottom-left::after,
.slds-nubbin--bottom-left::after,
.slds-nubbin_bottom-left-corner::before,
.slds-nubbin--bottom-left-corner::before,
.slds-nubbin_bottom-left-corner::after,
.slds-nubbin--bottom-left-corner::after{
  inset-inline-start:var(--slds-g-spacing-5);
  inset-block-start:100%;
  margin-block-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_bottom-right::before,.slds-nubbin--bottom-right::before,
.slds-nubbin_bottom-right-corner::before,
.slds-nubbin--bottom-right-corner::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-end:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_bottom-right::after,.slds-nubbin--bottom-right::after,
.slds-nubbin_bottom-right-corner::after,
.slds-nubbin--bottom-right-corner::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-inline-start:50%;
  inset-block-end:calc((1rem * 0.5) * -1);
  margin-inline-start:calc((1rem * 0.5) * -1);
  box-shadow:2px 2px 4px 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_bottom-right::before,.slds-nubbin--bottom-right::before,
.slds-nubbin_bottom-right::after,
.slds-nubbin--bottom-right::after,
.slds-nubbin_bottom-right-corner::before,
.slds-nubbin--bottom-right-corner::before,
.slds-nubbin_bottom-right-corner::after,
.slds-nubbin--bottom-right-corner::after{
  inset-inline-start:auto;
  inset-inline-end:var(--slds-g-spacing-5);
  inset-block-start:100%;
  margin-block-start:calc((1rem * 0.5) * -1);
  margin-inline-end:calc((1rem * 0.5) * -1);
}
.slds-nubbin_left::before,.slds-nubbin--left::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-start:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_left::after,.slds-nubbin--left::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-start:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
  box-shadow:-1px 1px 2px 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_left-top::before,.slds-nubbin--left-top::before,
.slds-nubbin_left-top-corner::before,
.slds-nubbin--left-top-corner::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-start:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_left-top::after,.slds-nubbin--left-top::after,
.slds-nubbin_left-top-corner::after,
.slds-nubbin--left-top-corner::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-start:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
  box-shadow:-1px 1px 2px 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_left-top::before,.slds-nubbin--left-top::before,
.slds-nubbin_left-top::after,
.slds-nubbin--left-top::after,
.slds-nubbin_left-top-corner::before,
.slds-nubbin--left-top-corner::before,
.slds-nubbin_left-top-corner::after,
.slds-nubbin--left-top-corner::after{
  inset-block-start:var(--slds-g-spacing-5);
}
.slds-nubbin_left-bottom::before,.slds-nubbin--left-bottom::before,
.slds-nubbin_left-bottom-corner::before,
.slds-nubbin--left-bottom-corner::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-start:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
  margin-block-end:-1px;
}
.slds-nubbin_left-bottom::after,.slds-nubbin--left-bottom::after,
.slds-nubbin_left-bottom-corner::after,
.slds-nubbin--left-bottom-corner::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-start:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
  box-shadow:-1px 2px 3px 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_left-bottom::before,.slds-nubbin--left-bottom::before,
.slds-nubbin_left-bottom::after,
.slds-nubbin--left-bottom::after,
.slds-nubbin_left-bottom-corner::before,
.slds-nubbin--left-bottom-corner::before,
.slds-nubbin_left-bottom-corner::after,
.slds-nubbin--left-bottom-corner::after{
  inset-block-start:auto;
  inset-block-end:var(--slds-g-spacing-4);
}
.slds-nubbin_right::before,.slds-nubbin--right::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-end:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_right::after,.slds-nubbin--right::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-end:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
  box-shadow:1px -1px 2px 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_right-top::before,.slds-nubbin--right-top::before,
.slds-nubbin_right-top-corner::before,
.slds-nubbin--right-top-corner::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-end:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
}
.slds-nubbin_right-top::after,.slds-nubbin--right-top::after,
.slds-nubbin_right-top-corner::after,
.slds-nubbin--right-top-corner::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-end:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
  box-shadow:1px -1px 2px 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_right-top::before,.slds-nubbin--right-top::before,
.slds-nubbin_right-top::after,
.slds-nubbin--right-top::after,
.slds-nubbin_right-top-corner::before,
.slds-nubbin--right-top-corner::before,
.slds-nubbin_right-top-corner::after,
.slds-nubbin--right-top-corner::after{
  inset-block-start:var(--slds-g-spacing-5);
}
.slds-nubbin_right-bottom::before,.slds-nubbin--right-bottom::before,
.slds-nubbin_right-bottom-corner::before,
.slds-nubbin--right-bottom-corner::before{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-end:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
  margin-bottom:-1px;
}
.slds-nubbin_right-bottom::after,.slds-nubbin--right-bottom::after,
.slds-nubbin_right-bottom-corner::after,
.slds-nubbin--right-bottom-corner::after{
  width:1rem;
  height:1rem;
  position:absolute;
  transform:rotate(45deg);
  content:'';
  background-color:inherit;
  inset-block-start:50%;
  inset-inline-end:calc((1rem * 0.5) * -1);
  margin-block-start:calc((1rem * 0.5) * -1);
  box-shadow:2px -1px 3px 0 rgba(0, 0, 0, 0.16);
  z-index:-1;
}
.slds-nubbin_right-bottom::before,.slds-nubbin--right-bottom::before,
.slds-nubbin_right-bottom::after,
.slds-nubbin--right-bottom::after,
.slds-nubbin_right-bottom-corner::before,
.slds-nubbin--right-bottom-corner::before,
.slds-nubbin_right-bottom-corner::after,
.slds-nubbin--right-bottom-corner::after{
  inset-block-start:auto;
  inset-block-end:1rem;
}
.slds-nubbin_top-left-corner,.slds-nubbin--top-left-corner{
  border-radius:var(--slds-g-radius-border-1) var(--slds-g-radius-border-2) var(--slds-g-radius-border-2);
}
.slds-nubbin_top-left-corner::before,.slds-nubbin--top-left-corner::before,
.slds-nubbin_top-left-corner::after,
.slds-nubbin--top-left-corner::after{
  inset-inline-start:var(--slds-g-spacing-3);
}
.slds-nubbin_bottom-left-corner,.slds-nubbin--bottom-left-corner{
  border-start-start-radius:var(--slds-g-radius-border-2);
  border-start-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:var(--slds-g-radius-border-1);
  border-end-end-radius:var(--slds-g-radius-border-2);
}
.slds-nubbin_bottom-left-corner::before,.slds-nubbin--bottom-left-corner::before,
.slds-nubbin_bottom-left-corner::after,
.slds-nubbin--bottom-left-corner::after{
  inset-inline-start:var(--slds-g-spacing-3);
}
.slds-nubbin_top-right-corner,.slds-nubbin--top-right-corner{
  border-start-start-radius:var(--slds-g-radius-border-2);
  border-start-end-radius:var(--slds-g-radius-border-1);
  border-end-start-radius:var(--slds-g-radius-border-2);
  border-end-end-radius:var(--slds-g-radius-border-2);
}
.slds-nubbin_top-right-corner::before,.slds-nubbin--top-right-corner::before,
.slds-nubbin_top-right-corner::after,
.slds-nubbin--top-right-corner::after{
  inset-inline-end:var(--slds-g-spacing-3);
}
.slds-nubbin_bottom-right-corner,.slds-nubbin--bottom-right-corner{
  border-start-start-radius:var(--slds-g-radius-border-2);
  border-start-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:var(--slds-g-radius-border-2);
  border-end-end-radius:var(--slds-g-radius-border-1);
}
.slds-nubbin_bottom-right-corner::before,.slds-nubbin--bottom-right-corner::before,
.slds-nubbin_bottom-right-corner::after,
.slds-nubbin--bottom-right-corner::after{
  inset-inline-end:var(--slds-g-spacing-3);
}
.slds-nubbin_left-top-corner,.slds-nubbin--left-top-corner{
  border-start-start-radius:var(--slds-g-radius-border-1);
  border-start-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:var(--slds-g-radius-border-2);
  border-end-end-radius:var(--slds-g-radius-border-2);
}
.slds-nubbin_left-top-corner::before,.slds-nubbin--left-top-corner::before,
.slds-nubbin_left-top-corner::after,
.slds-nubbin--left-top-corner::after{
  inset-block-start:var(--slds-g-spacing-3);
}
.slds-nubbin_right-top-corner,.slds-nubbin--right-top-corner{
  border-start-start-radius:var(--slds-g-radius-border-2);
  border-start-end-radius:var(--slds-g-radius-border-1);
  border-end-start-radius:var(--slds-g-radius-border-2);
  border-end-end-radius:var(--slds-g-radius-border-2);
}
.slds-nubbin_right-top-corner::before,.slds-nubbin--right-top-corner::before,
.slds-nubbin_right-top-corner::after,
.slds-nubbin--right-top-corner::after{
  inset-block-start:var(--slds-g-spacing-3);
}
.slds-nubbin_left-bottom-corner,.slds-nubbin--left-bottom-corner{
  border-start-start-radius:var(--slds-g-radius-border-2);
  border-start-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:var(--slds-g-radius-border-1);
  border-end-end-radius:var(--slds-g-radius-border-2);
}
.slds-nubbin_left-bottom-corner::before,.slds-nubbin--left-bottom-corner::before,
.slds-nubbin_left-bottom-corner::after,
.slds-nubbin--left-bottom-corner::after{
  inset-block-end:var(--slds-g-spacing-1);
}
.slds-nubbin_right-bottom-corner,.slds-nubbin--right-bottom-corner{
  border-start-start-radius:var(--slds-g-radius-border-2);
  border-start-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:var(--slds-g-radius-border-2);
  border-end-end-radius:var(--slds-g-radius-border-1);
}
.slds-nubbin_right-bottom-corner::before,.slds-nubbin--right-bottom-corner::before,
.slds-nubbin_right-bottom-corner::after,
.slds-nubbin--right-bottom-corner::after{
  inset-block-end:var(--slds-g-spacing-1);
}
.slds-popover_error .slds-popover__header,.slds-popover--error .slds-popover__header{
  background-color:var(--slds-g-color-error-container-1);
  color:var(--slds-g-color-on-error-1);
  padding-inline-start:var(--slds-g-spacing-3);
}
.slds-popover_error .slds-popover__header .slds-icon,.slds-popover--error .slds-popover__header .slds-icon{
  fill:currentColor;
}
.slds-popover_error .slds-popover__close,.slds-popover--error .slds-popover__close{
  --slds-c-icon-color-foreground:var(--slds-g-color-on-error-1);

  color:var(--slds-g-color-on-error-1);
}
.slds-popover_error .slds-button_icon:hover,.slds-popover--error .slds-button--icon:hover,
.slds-popover_error .slds-button_icon:focus-visible,
.slds-popover--error .slds-button--icon:focus-visible{
  color:var(--slds-s-alert-close-button-hover, color-mix(in oklab, currentColor, transparent 25%));
}
.slds-popover_error .slds-popover__footer,.slds-popover--error .slds-popover__footer{
  background-color:transparent;
}
.slds-popover_error .slds-popover__footer .slds-button,.slds-popover--error .slds-popover__footer .slds-button{
  text-decoration:none;
}
.slds-popover_error .slds-popover__footer .slds-button.slds-button_neutral,.slds-popover--error .slds-popover__footer .slds-button.slds-button--neutral{
  color:var(--slds-g-color-accent-2);
}
.slds-popover_error.slds-nubbin_top::before,.slds-popover--error.slds-nubbin--top::before,
.slds-popover_error.slds-nubbin_top-left::before,
.slds-popover--error.slds-nubbin--top-left::before,
.slds-popover_error.slds-nubbin_top-right::before,
.slds-popover--error.slds-nubbin--top-right::before,
.slds-popover_error.slds-nubbin_left-top::before,
.slds-popover--error.slds-nubbin--left-top::before,
.slds-popover_error.slds-nubbin_right-top::before,
.slds-popover--error.slds-nubbin--right-top::before{
  background-color:var(--slds-g-color-error-container-1);
}
.slds-popover_error .slds-popover__body,.slds-popover--error .slds-popover__body{
  padding-inline-start:var(--slds-g-spacing-7);
}
.slds-popover_error .slds-popover__header,.slds-popover--error .slds-popover__header,
.slds-popover_warning .slds-popover__header,
.slds-popover--warning .slds-popover__header{
  border-start-start-radius:calc(var(--slds-g-radius-border-2) - 1px);
  border-start-end-radius:calc(var(--slds-g-radius-border-2) - 1px);
  border-end-start-radius:0;
  border-end-end-radius:0;
}
.slds-popover_error .slds-popover__body_scrollable,.slds-popover--error .slds-popover__body--scrollable,
.slds-popover_warning .slds-popover__body_scrollable,
.slds-popover--warning .slds-popover__body--scrollable{
  max-height:150px;
  overflow-y:auto;
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-90);
}
.slds-popover_error .slds-popover__body_scrollable + .slds-popover__footer,.slds-popover--error .slds-popover__body--scrollable + .slds-popover__footer,
.slds-popover_warning .slds-popover__body_scrollable + .slds-popover__footer,
.slds-popover--warning .slds-popover__body--scrollable + .slds-popover__footer{
  border-block-start:0;
}
.slds-popover_warning button,.slds-popover--warning button{
  color:var(--slds-g-color-neutral-base-30);
  text-decoration:underline;
}
.slds-popover_warning button:hover,.slds-popover--warning button:hover{
  color:var(--slds-g-color-neutral-base-50);
}
.slds-popover_warning button:focus,.slds-popover--warning button:focus{
  color:var(--slds-g-color-neutral-base-30);
  box-shadow:0 0 3px var(--slds-g-color-neutral-base-30);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-30);
}
.slds-popover_warning button:active,.slds-popover--warning button:active{
  color:var(--slds-g-color-neutral-base-50);
}
.slds-popover_warning .slds-popover__header,.slds-popover--warning .slds-popover__header{
  background-color:var(--slds-g-color-warning-container-1);
  color:var(--slds-g-color-on-warning-1);
}
.slds-popover_warning .slds-popover__header .slds-icon,.slds-popover--warning .slds-popover__header .slds-icon{
  fill:currentColor;
}
.slds-popover_warning .slds-button_icon,.slds-popover--warning .slds-button--icon{
  --slds-c-icon-color-foreground:var(--slds-g-color-on-warning-1);

  color:var(--slds-g-color-on-warning-1);
}
.slds-popover_warning .slds-button_icon:hover,.slds-popover--warning .slds-button--icon:hover,
.slds-popover_warning .slds-button_icon:focus-visible,
.slds-popover--warning .slds-button--icon:focus-visible{
  color:var(--slds-s-alert-close-button-hover, color-mix(in oklab, currentColor, transparent 25%));
}
.slds-popover_warning.slds-nubbin_top::before,.slds-popover--warning.slds-nubbin--top::before,
.slds-popover_warning.slds-nubbin_top-left::before,
.slds-popover--warning.slds-nubbin--top-left::before,
.slds-popover_warning.slds-nubbin_top-right::before,
.slds-popover--warning.slds-nubbin--top-right::before,
.slds-popover_warning.slds-nubbin_left-top::before,
.slds-popover--warning.slds-nubbin--left-top::before,
.slds-popover_warning.slds-nubbin_right-top::before,
.slds-popover--warning.slds-nubbin--right-top::before{
  background-color:var(--slds-g-color-warning-container-1);
}
.slds-popover_warning .slds-popover__body,.slds-popover--warning .slds-popover__body{
  padding-inline-start:var(--slds-g-spacing-7);
}
.slds-popover_warning .slds-popover__footer,.slds-popover--warning .slds-popover__footer{
  background-color:transparent;
}
.slds-popover_warning .slds-popover__footer .slds-button,.slds-popover--warning .slds-popover__footer .slds-button{
  text-decoration:none;
}
.slds-popover_warning .slds-popover__footer .slds-button.slds-button_neutral,.slds-popover--warning .slds-popover__footer .slds-button.slds-button--neutral{
  color:var(--slds-g-color-accent-2);
}
.slds-popover_prompt,.slds-popover--prompt{
  width:calc(var(--slds-g-sizing-15) + var(--slds-g-sizing-12));
}
.slds-popover_prompt .slds-popover__body,.slds-popover--prompt .slds-popover__body{
  padding:var(--slds-g-spacing-4);
}
.slds-popover_prompt .slds-popover__footer,.slds-popover--prompt .slds-popover__footer{
  border-block-start:inherit;
}
.slds-popover_prompt__heading,.slds-popover--prompt__heading{
  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2));
  line-height:var(--slds-g-font-lineheight-2);
  font-weight:var(--_slds-c-popover-prompt-heading-font-weight, var(--slds-g-font-weight-7));
}
.slds-popover_prompt__action-link,.slds-popover--prompt__action-link{
  margin-inline-end:var(--slds-g-spacing-4);
}
.slds-popover_prompt_top,.slds-popover--prompt--top,
.slds-popover_prompt_top-right,
.slds-popover--prompt--top-right,
.slds-popover_prompt_top-left,
.slds-popover--prompt--top-left,
.slds-popover_prompt_bottom,
.slds-popover--prompt--bottom,
.slds-popover_prompt_bottom-right,
.slds-popover--prompt--bottom-right,
.slds-popover_prompt_bottom-left,
.slds-popover--prompt--bottom-left{
  position:absolute;
}
.slds-popover_prompt_top,.slds-popover--prompt--top,
.slds-popover_prompt_top-right,
.slds-popover--prompt--top-right,
.slds-popover_prompt_top-left,
.slds-popover--prompt--top-left{
  inset-block-start:var(--slds-g-spacing-2);
}
.slds-popover_prompt_bottom,.slds-popover--prompt--bottom,
.slds-popover_prompt_bottom-right,
.slds-popover--prompt--bottom-right,
.slds-popover_prompt_bottom-left,
.slds-popover--prompt--bottom-left{
  inset-block-end:var(--slds-g-spacing-2);
}
.slds-popover_prompt_top,.slds-popover--prompt--top,
.slds-popover_prompt_bottom,
.slds-popover--prompt--bottom{
  inset-inline-start:50%;
  margin-inline-start:calc(((var(--slds-g-sizing-15) + var(--slds-g-sizing-12)) * 0.5) * -1);
}
.slds-popover_prompt_top-right,.slds-popover--prompt--top-right,
.slds-popover_prompt_bottom-right,
.slds-popover--prompt--bottom-right{
  inset-inline-end:var(--slds-g-spacing-2);
}
.slds-popover_prompt_top-left,.slds-popover--prompt--top-left,
.slds-popover_prompt_bottom-left,
.slds-popover--prompt--bottom-left{
  inset-inline-start:var(--slds-g-spacing-2);
}
.slds-color-picker{
  position:relative;
}
.slds-color-picker .slds-form-error{
  padding-block-start:var(--slds-g-spacing-2);
  color:var(--slds-g-color-error-base-40, var(--slds-g-color-error-1));
  font-size:var(--slds-g-font-scale-neg-1);
}
.slds-color-picker__summary-label{
  display:block;
}
.slds-color-picker__summary-button{
  vertical-align:top;
  padding-block:0.3rem;
  padding-inline:var(--slds-g-spacing-2);
  line-height:1;
  background:var(--slds-g-color-neutral-base-100, var(--slds-g-color-surface-container-1));
  margin-inline-end:var(--slds-g-spacing-1);
  border-radius:var(--slds-s-input-radius-border);
}
.slds-color-picker__summary-input{
  display:inline-block;
}
.slds-color-picker__summary-input .slds-input{
  width:6rem;
}
.slds-color-picker__selector{
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-popover__footer{
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-s-container-color-border, var(--slds-g-color-neutral-base-90));
}
.slds-color-picker__selector.slds-popover{
  width:14rem;
}
.slds-color-picker__selector .slds-tabs_default__content,.slds-color-picker__selector .slds-tabs--default__content{
  padding-block:var(--slds-g-spacing-2);
  padding-inline:0;
}
.slds-color-picker__swatches{
  font-size:0;
}
.slds-color-picker__swatches.slds-swatch{
  cursor:pointer;
}
.slds-color-picker__swatch{
  display:inline-block;
  margin:var(--slds-g-spacing-1);
}
.slds-color-picker__swatch-trigger{
  display:inline-block;
}
.slds-color-picker__swatch-trigger:focus,
.slds-color-picker__swatch-trigger:active{
  outline:none;
  box-shadow:var(--slds-s-input-shadow-focus);
  border-radius:var(--slds-g-radius-border-2);
}
.slds-color-picker__custom{
  padding-block:var(--slds-g-spacing-1);
  padding-inline:0;
}
.slds-color-picker__custom-range{
  position:relative;
  margin-block-end:var(--slds-g-spacing-1);
  height:var(--slds-g-sizing-12);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
  overflow:hidden;
}
.slds-color-picker__custom-range::before{
  content:'';
  position:absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
  background:linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.9) 1%, transparent 99%), linear-gradient(to right, rgba(255, 255, 255, 1) 1%, transparent);
}
.slds-color-picker__range-indicator{
  --_slds-c-color-picker-half-spacing:calc(0.75rem * 0.5);

  transform:translate3d(
    var(--_slds-c-color-picker-half-spacing),
    var(--_slds-c-color-picker-half-spacing),
    0
  );
  cursor:pointer;
  position:absolute;
  height:var(--slds-g-sizing-4);
  width:var(--slds-g-sizing-4);
  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-surface-container-1);
  border-radius:var(--slds-g-radius-border-circle);
  box-shadow:0 2px 4px 4px rgba(0, 0, 0, 0.16), inset 0 2px 4px 4px rgba(0, 0, 0, 0.16);
}
.slds-color-picker__range-indicator:focus{
  outline:none;
  box-shadow:var(--slds-s-input-shadow-focus);
}
.slds-color-picker__hue-and-preview{
  display:flex;
}
.slds-color-picker__hue-and-preview .slds-swatch{
  margin-inline-start:var(--slds-g-spacing-1);
  height:var(--slds-g-spacing-5);
  width:var(--slds-g-spacing-5);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-1);
}
.slds-color-picker__hue-slider{
  appearance:none;
  flex:1 1;
  padding:0;
  height:var(--slds-g-sizing-7);
  width:100%;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-1);
  background:linear-gradient(
    90deg,
    red,
    #ff1500,
    #ff2b00,
    #ff4000,
    #f50,
    #ff6a00,
    #ff8000,
    #ff9500,
    #fa0,
    #ffbf00,
    #ffd500,
    #ffea00,
    #ff0,
    #eaff00,
    #d4ff00,
    #bfff00,
    #af0,
    #95ff00,
    #80ff00,
    #6aff00,
    #5f0,
    #40ff00,
    #2bff00,
    #15ff00,
    #0f0,
    #00ff15,
    #00ff2b,
    #00ff40,
    #0f5,
    #00ff6a,
    #00ff80,
    #00ff95,
    #0fa,
    #00ffbf,
    #00ffd5,
    #00ffea,
    #0ff,
    #00eaff,
    #00d4ff,
    #00bfff,
    #0af,
    #0095ff,
    #007fff,
    #006aff,
    #05f,
    #0040ff,
    #002bff,
    #0015ff,
    #00f,
    #1500ff,
    #2a00ff,
    #4000ff,
    #50f,
    #6a00ff,
    #7f00ff,
    #9500ff,
    #a0f,
    #bf00ff,
    #d400ff,
    #ea00ff,
    #f0f,
    #ff00ea,
    #ff00d4,
    #ff00bf,
    #f0a,
    #ff0095,
    #ff0080,
    #ff006a,
    #f05,
    #ff0040,
    #ff002b,
    #ff0015
  );
  margin:0;
}
.slds-color-picker__hue-slider::-webkit-slider-thumb{
  appearance:none;
  cursor:pointer;
  height:calc(var(--slds-g-sizing-7) - (var(--slds-g-sizing-border-1) * 2));
  width:0.375rem;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-30);
  border-radius:var(--slds-g-radius-border-1);
  background:var(--slds-g-color-surface-container-1, var(--slds-g-color-neutral-base-95));
}
.slds-color-picker__hue-slider::-moz-range-thumb{
  appearance:none;
  cursor:pointer;
  height:calc(var(--slds-g-sizing-7) - (var(--slds-g-sizing-border-1) * 2));
  width:0.375rem;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-30);
  border-radius:var(--slds-g-radius-border-1);
  background:var(--slds-g-color-surface-container-1, var(--slds-g-color-neutral-base-95));
}
.slds-color-picker__hue-slider::-ms-thumb{
  appearance:none;
  cursor:pointer;
  width:0.375rem;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-30);
  border-radius:var(--slds-g-radius-border-1);
  background:var(--slds-g-color-surface-container-1, var(--slds-g-color-neutral-base-95));
  height:var(--slds-g-sizing-7);
}
.slds-color-picker__hue-slider:focus{
  outline:none;
}
.slds-color-picker__hue-slider:focus::-webkit-slider-thumb{
  border-color:var(--slds-g-color-brand-base-60, var(--slds-g-color-accent-1));
  box-shadow:var(--slds-s-input-shadow-focus);
}
.slds-color-picker__hue-slider:focus::-moz-range-thumb{
  border-color:var(--slds-g-color-brand-base-60, var(--slds-g-color-accent-1));
  box-shadow:var(--slds-s-input-shadow-focus);
}
.slds-color-picker__hue-slider:focus::-ms-thumb{
  border-color:var(--slds-g-color-brand-base-60, var(--slds-g-color-accent-1));
  box-shadow:var(--slds-s-input-shadow-focus);
}
.slds-color-picker__hue-slider::-moz-range-track{
  height:0;
}
.slds-color-picker__hue-slider::-ms-track{
  height:0;
  border:0;
  background:transparent;
  color:transparent;
}
.slds-color-picker__custom-inputs{
  display:flex;
  padding-block-start:var(--slds-g-spacing-2);
}
.slds-color-picker__custom-inputs .slds-form-element:not(:first-child){
  margin-inline-start:var(--slds-g-spacing-1);
}
.slds-color-picker__custom-inputs input{
  padding-block:0;
  padding-inline:var(--slds-g-spacing-1);
}
.slds-color-picker__custom-inputs abbr{
  cursor:text;
  text-decoration:none;
}
.slds-color-picker__custom-inputs .slds-form-element.slds-color-picker__input-custom-hex{
  flex:none;
  width:4.2rem;
}
.slds-color-picker__custom-inputs .slds-form-element.slds-color-picker__input-custom-hex input{
  font-size:var(--slds-g-spacing-3);
}
.slds-color-picker__selector-footer{
  display:flex;
}
.slds-color-picker__selector-footer .slds-button{
  flex:1 1;
}
.slds-swatch{
  display:inline-block;
  vertical-align:middle;
  height:var(--slds-g-sizing-6);
  width:var(--slds-g-sizing-6);
  border-radius:var(--slds-g-radius-border-1);
  box-shadow:var(--slds-g-color-neutral-base-10, inset 0 0 1px rgba(0, 0, 0, 0.4));
}
.slds-color-picker.slds-color-picker_swatches-only,.slds-color-picker.slds-color-picker--swatches-only{
  width:13.3rem;
  padding:var(--slds-g-spacing-2);
}
.slds-color-picker.slds-color-picker_swatches-only .slds-color-picker__selector,.slds-color-picker.slds-color-picker--swatches-only .slds-color-picker__selector{
  margin:0;
}
.slds-popover_tooltip,.slds-popover--tooltip{
  --slds-c-tooltip-sizing-width-max:var(--slds-c-tooltip-sizing-width-max);

  width:auto;
  max-width:var(--slds-c-tooltip-sizing-width-max, var(--slds-g-sizing-15));
  background-color:var(--slds-c-tooltip-color-background, var(--slds-g-color-surface-inverse-1));
  border:0;
}
.slds-popover_tooltip .slds-popover__body,.slds-popover--tooltip .slds-popover__body{
  font-size:var(--slds-c-tooltip-font-size, var(--slds-g-font-scale-neg-1));
  color:var(--slds-c-tooltip-text-color, var(--slds-g-color-on-surface-inverse-1));
}
.slds-popover_tooltip .slds-icon-text-default,.slds-popover--tooltip .slds-icon-text-default{
  --slds-c-icon-color-foreground:var(--slds-g-color-on-accent-1);
}
.slds-rise-from-ground{
  visibility:visible;
  opacity:1;
  transform:translate(0%, 0%);
  transition:opacity 0.1s linear, visibility 0.1s linear, transform 0.1s linear;
  will-change:transform;
}
.slds-fall-into-ground{
  visibility:hidden;
  opacity:0;
  transform:translate(0%, 0%);
  transition:opacity 0.1s linear, visibility 0.1s linear, transform 0.1s linear;
  will-change:transform;
}
.slds-slide-from-bottom-to-top{
  transform:translateY(10%);
  will-change:transform;
}
.slds-slide-from-top-to-bottom{
  transform:translateY(-10%);
  will-change:transform;
}
.slds-slide-from-right-to-left{
  transform:translateX(5%);
  will-change:transform;
}
.slds-slide-from-left-to-right{
  transform:translateX(-5%);
  will-change:transform;
}
a [icon-name='utility:info'] .slds-icon-text-default{
  --slds-c-icon-color-foreground-default:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));
}
a:hover [icon-name='utility:info'] .slds-icon-text-default, a:focus [icon-name='utility:info'] .slds-icon-text-default{
  --slds-c-icon-color-foreground-default:var(--slds-s-button-color-hover, var(--slds-g-color-accent-3));
}
.slds-datepicker{
  padding:0;
  font-size:var(--slds-g-font-scale-neg-1);
}
.slds-datepicker thead > tr > th,
.slds-datepicker tbody > tr > td{
  text-align:center;
}
.slds-datepicker thead > tr > th{
  padding:var(--slds-g-spacing-2);
  font-weight:var(--slds-g-font-weight-4);
  color:var(--slds-g-color-on-surface-3);
  font-size:var(--slds-g-font-scale-neg-1);
}
.slds-datepicker tbody > tr > td{
  padding:var(--slds-g-spacing-1);
  font-size:var(--slds-g-font-scale-neg-1);
}
.slds-datepicker tbody > tr > td > .slds-day{
  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
  display:block;
  position:relative;
  min-width:var(--slds-g-sizing-9);
  line-height:2rem;
  border-radius:var(--slds-g-radius-border-circle);
  margin:auto;
  color:var(--slds-g-color-on-surface-2);
}
.slds-datepicker tbody > tr > .slds-day_adjacent-month > .slds-day,.slds-datepicker tbody > tr > .slds-day--adjacent-month > .slds-day{
  color:var(--slds-g-color-on-surface-1);
}
.slds-datepicker tbody > tr > td:hover > .slds-day,
.slds-datepicker tbody > tr > td:focus > .slds-day,
.slds-datepicker tbody > tr > td.slds-is-today > .slds-day{
  cursor:pointer;
}
.slds-datepicker tbody > tr > td.slds-is-today > .slds-day{
  background-color:var(--slds-g-color-brand-base-90);
  color:var(--slds-g-color-accent-2);
}
.slds-datepicker tbody > tr > td:focus{
  outline:0;
}
.slds-datepicker tbody > tr > td:focus > .slds-day{
  box-shadow:var(--slds-s-table-cell-shadow-selected);
}
.slds-datepicker tbody > tr > td:hover > .slds-day{
  background-color:var(--slds-g-color-brand-base-90);
}
.slds-datepicker tbody > tr > td.slds-is-selected > .slds-day{
  background:var(--slds-g-color-accent-container-1);
  color:var(--slds-g-color-on-accent-1);
}
.slds-datepicker tbody > tr > td.slds-is-selected:focus > .slds-day{
  background:var(--slds-g-color-accent-container-2);
  box-shadow:var(--slds-s-table-cell-shadow-selected);
  color:var(--slds-g-color-on-accent-1);
}
.slds-datepicker .slds-has-multi-selection .slds-is-selected-multi:last-child > .slds-day::after{
  left:auto;
  right:0;
  transform:translateX(var(--slds-g-spacing-1));
}
.slds-datepicker .slds-has-multi-row-selection .slds-is-selected-multi:first-child > .slds-day::before,
.slds-datepicker .slds-has-multi-row-selection .slds-is-selected-multi:last-child > .slds-day::after{
  content:'';
  position:absolute;
  background:var(--slds-g-color-accent-container-1);
  top:0;
  left:-50%;
  height:100%;
  width:calc(var(--slds-g-sizing-9) + var(--slds-g-spacing-2));
  transform:translateX(calc(var(--slds-g-spacing-2) * -1));
  z-index:-1;
}
.slds-datepicker .slds-has-multi-row-selection .slds-is-selected-multi:first-child > .slds-day::before{
  left:0;
  transform:translateX(calc(var(--slds-g-spacing-1) * -1));
}
.slds-datepicker .slds-has-multi-row-selection .slds-is-selected-multi:last-child > .slds-day::after{
  left:auto;
  right:0;
  transform:translateX(var(--slds-g-spacing-1));
}
.slds-datepicker td.slds-is-selected-multi > .slds-day{
  overflow:visible;
}
.slds-datepicker td.slds-is-selected-multi.slds-is-today > .slds-day{
  box-shadow:var(--slds-g-color-on-accent-1) 0 0 0 1px inset;
}
.slds-datepicker td.slds-is-selected-multi + .slds-is-selected-multi > .slds-day::before{
  content:'';
  position:absolute;
  background:var(--slds-g-color-accent-container-1);
  top:0;
  left:-50%;
  height:100%;
  width:calc(var(--slds-g-sizing-9) + var(--slds-g-spacing-2));
  transform:translateX(calc(var(--slds-g-spacing-2) * -1));
  z-index:-1;
}
.slds-datepicker__filter{
  padding:var(--slds-g-spacing-1);
}
.slds-datepicker__filter .slds-select{
  min-width:var(--slds-g-sizing-11);
}
.slds-datepicker__filter_month,.slds-datepicker__filter--month{
  padding:0 var(--slds-g-spacing-1) 0 0;
  color:var(--slds-g-color-on-surface-2);
}
.slds-datepicker__month{
  font-size:var(--slds-g-font-scale-neg-1);
}
.slds-has-error .slds-datepicker__filter .slds-select{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  box-shadow:none;
}
.slds-day_adjacent-month,.slds-day--adjacent-month{
  color:var(--slds-g-color-neutral-base-50);
}
.slds-table .slds-datepicker .slds-datepicker__month tbody > tr:hover > td{
  background-color:unset;
}
.slds-utility-bar_container,.slds-utility-bar--container{
  position:relative;
}
.slds-utility-bar{
  display:flex;
  position:fixed;
  bottom:0;
  left:0;
  width:100%;
  height:2.5rem;
  background:var(--slds-g-color-surface-1);
  box-shadow:var(--slds-g-shadow-blockstart-2, 0 -2px 2px 0 rgba(0, 0, 0, 0.16));
  z-index:4;
}
.slds-utility-bar .slds-indicator_unread,.slds-utility-bar .slds-indicator--unread{
  width:8px;
  height:8px;
  top:var(--slds-g-spacing-2);
  position:absolute;
  left:var(--slds-g-spacing-2);
  display:block;
  border-radius:var(--slds-g-radius-border-circle);
  background:var(--slds-g-color-error-1);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-surface-1);
}
.slds-utility-bar__item{
  display:flex;
  margin-inline-end:1px;
}
.slds-utility-bar__item_pop-out,.slds-utility-bar__item--pop-out{
  position:relative;
}
.slds-utility-bar__item_pop-out::before,.slds-utility-bar__item--pop-out::before{
  content:'';
  position:absolute;
  top:4px;
  right:4px;
  height:4px;
  width:4px;
  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);
  border-right:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);
  z-index:1;
}
.slds-utility-bar__item_pop-out::after,.slds-utility-bar__item--pop-out::after{
  content:'';
  position:absolute;
  top:2px;
  right:6px;
  height:7px;
  width:7px;
  border-right:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);
  transform:rotate(45deg);
}
[dir='rtl'] .slds-utility-bar__item_pop-out::before,[dir='rtl'] .slds-utility-bar__item--pop-out::before{
  /*! @noflip */
  right:auto;

  /*! @noflip */
  left:4px;

  /*! @noflip */
  border-right-width:0;

  /*! @noflip */
  border-left:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);
}
[dir='rtl'] .slds-utility-bar__item_pop-out::after,[dir='rtl'] .slds-utility-bar__item--pop-out::after{
  /*! @noflip */
  right:auto;

  /*! @noflip */
  left:6px;

  /*! @noflip */
  border-right-width:0;

  /*! @noflip */
  border-left:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);
  transform:rotate(-45deg);
}
.slds-utility-bar__action{
  position:relative;
  display:inline-flex;
  gap:var(--slds-g-spacing-1);
  align-items:center;
  padding:0 var(--slds-g-spacing-3);
  border-radius:0;
  border:0;
  color:var(--_slds-c-utilitybar-color, var(--slds-g-color-on-surface-3));
  font-weight:var(--_slds-c-utilitybar-font-weight);
}
.slds-utility-bar__action .slds-icon{
  fill:currentColor;
}
.slds-utility-bar__action::after{
  content:'';
  position:absolute;
  bottom:0;
  left:0;
  right:0;
  height:0;
  background:transparent;
}
.slds-utility-bar__action:focus,
.slds-utility-bar__action:hover{
  box-shadow:none;
  background:var(--_slds-c-utilitybar-color-background-hover);
  color:var(--_slds-c-utilitybar-color-hover, inherit);
}
.slds-utility-bar__action:hover::after{
  background:var(--_slds-c-utilitybar-color-border-hover);
  height:var(--_slds-c-utilitybar-sizing-border-hover);
}
.slds-utility-bar__action:focus::after{
  background:var(--_slds-c-utilitybar-color-border-hover);
  height:var(--_slds-c-utilitybar-sizing-border-active);
}
.slds-utility-bar__action.slds-is-active{
  background:var(--_slds-c-globalnavigation-item-color-background-active);
  color:var(--_slds-c-utilitybar-color-active, inherit);
}
.slds-utility-bar__action.slds-is-active::after{
  background:var(--_slds-c-utilitybar-color-border-active);
  height:var(--_slds-c-utilitybar-sizing-border-active);
}
.slds-utility-bar__text{
  display:flex;
  flex-direction:column;
  line-height:1;
  text-align:left;
}
.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action{
  background:var(--slds-g-color-info-container-1);
  color:var(--slds-g-color-on-info-1);
}
.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action .slds-icon{
  fill:var(--slds-g-color-on-info-1);
}
.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action:hover,
.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action:focus{
  background:var(--slds-g-color-surface-container-inverse-2);
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action:hover .slds-icon, .slds-utility-bar__item.slds-has-notification .slds-utility-bar__action:focus .slds-icon{
  fill:var(--slds-g-color-on-surface-inverse-1);
}
.slds-utility-panel{
  position:fixed;
  bottom:1.875rem;
  width:21.25rem;
  height:30rem;
  border-radius:var(--slds-s-container-radius-border) var(--slds-s-container-radius-border) 0 0;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-bottom:none;
  background:var(--slds-g-color-surface-container-1);
  transform:translateY(100%);
}
.slds-utility-panel.slds-is-open{
  box-shadow:var(--slds-g-shadow-blockstart-2, 0 -2px 2px 0 rgba(0, 0, 0, 0.16));
  transform:translateY(0);
}
.slds-utility-panel__header{
  background:var(--slds-g-color-surface-container-1);
  border-bottom:var(--slds-g-sizing-border-2) solid var(--slds-g-color-accent-1);
  border-radius:var(--slds-s-container-radius-border) var(--slds-s-container-radius-border) 0 0;
  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-3);
  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-1));
  font-weight:var(--slds-s-container-heading-font-weight);
  color:var(--slds-g-color-on-surface-3);
}
.slds-utility-panel__header .slds-icon{
  fill:currentColor;
}
.slds-utility-panel__body{
  display:flex;
  flex:1 1;
  flex-direction:column;
  overflow:auto;
}
.slds-datetimepicker_has-tooltip .slds-form-element__icon,.slds-datetimepicker--has-tooltip .slds-form-element__icon{
  padding-block-start:0;
}
.slds-docked_container,.slds-docked--container{
  display:flex;
  align-items:flex-end;
  position:fixed;
  inset-block-end:0;
  inset-inline-end:0;
  padding:0 var(--slds-g-spacing-7);
  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));
  font-weight:var(--slds-s-container-heading-font-weight);
}
.slds-docked-composer{
  position:relative;
  border-radius:var(--slds-s-container-radius-border, var(--slds-g-radius-border-2)) var(--slds-s-container-radius-border, var(--slds-g-radius-border-2)) 0 0;
  width:480px;
  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));
  float:left;
  box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 -4px 5px 0 rgba(0, 0, 0, 0.09), 0 0 5px 0 rgba(0, 0, 0, 0.08);
  border:var(--slds-s-container-sizing-border, var(--slds-g-sizing-border-1)) solid var(--slds-s-container-color-border, var(--slds-g-color-border-1));
  border-bottom:none;
  font-weight:var(--slds-s-container-heading-font-weight);
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-docked-composer.slds-has-focus{
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-docked-composer.slds-is-open{
  height:480px;
}
.slds-docked-composer.slds-is-closed{
  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));
}
.slds-docked-composer.slds-is-closed .slds-docked-composer__body,
.slds-docked-composer.slds-is-closed .slds-docked-composer__footer{
  display:none;
}
.slds-docked-composer + .slds-docked-composer{
  margin-inline-start:var(--slds-g-spacing-7);
}
.slds-docked-composer__header{
  background:var(--slds-g-color-surface-container-1);
  border-bottom:var(--slds-g-sizing-border-2) solid var(--slds-g-color-accent-container-1);
  border-radius:var(--slds-s-container-radius-border) var(--slds-s-container-radius-border) 0 0;
  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-3);
  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-size-base));
  color:var(--slds-g-color-on-surface-3);
}
.slds-docked-composer__actions .slds-button{
  margin-inline-start:var(--slds-g-spacing-3);
}
.slds-docked-composer__body{
  display:flex;
  flex:1 0 auto;
  flex-direction:column;
  overflow:auto;
}
.slds-docked-composer__body_form,.slds-docked-composer__body--form{
  justify-content:flex-start;
  padding:var(--slds-g-spacing-4);
}
.slds-docked-composer__lead{
  display:flex;
  background:var(--slds-g-color-surface-container-1);
  padding:var(--slds-g-spacing-4) var(--slds-g-spacing-2);
}
.slds-docked-composer__toolbar{
  background:var(--slds-g-color-surface-container-2);
  padding:var(--slds-g-spacing-1) var(--slds-g-spacing-2);
  max-height:60px;
  overflow-y:auto;
  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-bottom:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-docked-composer__input{
  background:var(--slds-g-color-surface-container-1);
  padding:var(--slds-g-spacing-4);
  min-height:calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9));
  resize:none;
  line-height:var(--slds-g-font-lineheight-base);
  overflow:hidden;
  overflow-y:auto;
  font-family:inherit;
}
.slds-docked-composer__footer{
  display:flex;
  background:var(--slds-s-container-footer-color-background, var(--slds-g-color-surface-container-2));
  padding:var(--slds-g-spacing-3) var(--slds-g-spacing-2);
  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-docked-composer__footer .slds-button{
  justify-content:center;
}
.slds-docked-composer_overflow,.slds-docked-composer--overflow{
  width:auto;
}
.slds-docked-composer_overflow__button,.slds-docked-composer--overflow__button{
  display:flex;
  background:var(--slds-g-color-surface-container-1);
  padding:0 var(--slds-g-spacing-3);
  height:inherit;
  white-space:nowrap;
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;
}
.slds-docked-composer-modal .slds-modal__content{
  border-radius:var(--slds-s-container-radius-border, var(--slds-g-radius-border-2));
}
.slds-docked-composer-modal .slds-docked-composer{
  width:100%;
  height:100%;
  border:0;
}
.slds-email-composer{
  position:relative;
  flex:1 1 auto;
}
.slds-email-composer .slds-rich-text-editor{
  border:0;
  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:0;
}
.slds-email-composer__combobox{
  padding-inline-start:var(--slds-g-spacing-8);
  border:0;
  border-bottom:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:0;
}
.slds-email-composer__combobox .slds-form-element__label{
  position:absolute;
  inset-inline-start:var(--slds-g-spacing-3);
  inset-block-start:50%;
  transform:translateY(-50%);
}
.slds-email-composer__combobox .slds-combobox_container,.slds-email-composer__combobox .slds-combobox--container,
.slds-email-composer__combobox .slds-input[value]{
  border:0;
  box-shadow:none;
}
.slds-email-composer__recipient{
  position:absolute;
  inset-block-start:0;
  inset-inline-end:var(--slds-g-spacing-3);
}
.slds-brand-band{
  --_slds-c-brandband-color-background-dark:var(--slds-g-color-surface-2);
  --_slds-c-brandband-color-background-light:var(--slds-g-color-surface-2);
  --_slds-c-brandband-asset-default-image:none;
  --_slds-c-brandband-asset-group-image:none;
  --_slds-c-brandband-asset-user-image:none;

  display:flex;
  flex-direction:column;
  position:relative;
  height:100%;
  width:100%;
}
.slds-brand-band::before{
  content:'';
  display:block;
  position:absolute;
  z-index:-1;
  top:0;
  right:0;
  bottom:0;
  left:0;
  background-image:var(--_slds-c-brandband-asset-default-image), linear-gradient(
    to top,
    color-mix(in srgb, var(--_slds-c-brandband-color-background-dark) 0%, transparent) 0,
    var(--_slds-c-brandband-color-background-dark)
  );
  background-repeat:repeat-x;
  background-position:top left;
}
.slds-brand-band::after{
  content:none;
  display:block;
  position:absolute;
  z-index:-1;
  left:0;
  right:0;
  top:0;
  width:100%;
  height:var(--_slds-c-brandband-scrim-sizing-height, 3.125rem);
  background-image:linear-gradient(
    to bottom,
    color-mix(in srgb, var(--_slds-c-brandband-color-background-light) 0%, transparent) 60%,
    var(--_slds-c-brandband-color-background-light)
  );
}
.slds-brand-band.slds-brand-band_cover::before,.slds-brand-band.slds-brand-band--cover::before{
  background-repeat:no-repeat;
  background-size:cover;
}
.slds-brand-band.slds-brand-band_small::before,.slds-brand-band.slds-brand-band--small::before{
  height:var(--_slds-c-brandband-sizing-height-small, 6rem);
}
.slds-brand-band.slds-brand-band_small::after,.slds-brand-band.slds-brand-band--small::after{
  content:'';
  top:calc(
    var(--_slds-c-brandband-sizing-height-small, 6rem) -
    var(--_slds-c-brandband-scrim-sizing-height, 3.125rem)
  );
}
.slds-brand-band.slds-brand-band_medium::before,.slds-brand-band.slds-brand-band--medium::before{
  height:var(--_slds-c-brandband-sizing-height-medium, 12.5rem);
}
.slds-brand-band.slds-brand-band_medium::after,.slds-brand-band.slds-brand-band--medium::after{
  content:'';
  top:calc(
    var(--_slds-c-brandband-sizing-height-medium, 12.5rem) -
    var(--_slds-c-brandband-scrim-sizing-height, 3.125rem)
  );
}
.slds-brand-band.slds-brand-band_large::before,.slds-brand-band.slds-brand-band--large::before{
  height:var(--_slds-c-brandband-sizing-height-large, 18.75rem);
}
.slds-brand-band.slds-brand-band_large::after,.slds-brand-band.slds-brand-band--large::after{
  content:'';
  top:calc(
    var(--_slds-c-brandband-sizing-height-large, 18.75rem) -
    var(--_slds-c-brandband-scrim-sizing-height, 3.125rem)
  );
}
.slds-brand-band.slds-brand-band_full::before,.slds-brand-band.slds-brand-band--full::before{
  height:100%;
}
.slds-brand-band.slds-brand-band_bottom::before,.slds-brand-band.slds-brand-band--bottom::before{
  background-position:bottom;
  top:initial;
}
.slds-brand-band.slds-brand-band_none::before,.slds-brand-band.slds-brand-band--none::before{
  height:0;
}
.slds-brand-band.slds-brand-band_group::before,.slds-brand-band.slds-brand-band--group::before{
  background-image:var(--_slds-c-brandband-asset-group-image);
}
.slds-brand-band.slds-brand-band_user::before,.slds-brand-band.slds-brand-band--user::before{
  background-image:var(--_slds-c-brandband-asset-user-image);
}
.slds-brand-band .slds-brand-band_blank,.slds-brand-band .slds-brand-band--blank{
  background:var(--slds-g-color-surface-color-2);
}
.slds-brand-band .slds-brand-band_blank::before,.slds-brand-band .slds-brand-band--blank::before,
.slds-brand-band .slds-brand-band_blank::after,
.slds-brand-band .slds-brand-band--blank::after{
  background:none;
}
[class*='slds-template_'],[class*='slds-template--']{
  --_slds-c-template-sizing-gap:1rem;
  --_slds-c-template-profile-sizing-gap:8rem 0.75rem 0.75rem;
}
.slds-template__container{
  position:relative;
  height:100%;
  width:100%;
}
.slds-template_default,.slds-template--default{
  padding:var(--_slds-c-template-sizing-gap);
}
.slds-template_default.slds-brand-band::before,.slds-template--default.slds-brand-band::before{
  position:fixed;
  top:5.625rem;
}
.slds-template_default.slds-brand-band.slds-brand-band_medium::after,.slds-template--default.slds-brand-band.slds-brand-band--medium::after{
  position:fixed;
  top:15rem;
}
.slds-template_bottom-magnet,.slds-template--bottom-magnet{
  padding:var(--_slds-c-template-sizing-gap) var(--_slds-c-template-sizing-gap) 0 var(--_slds-c-template-sizing-gap);
}
.slds-template_profile,.slds-template--profile{
  padding:var(--_slds-c-template-profile-sizing-gap);
}
.slds-template__content{
  padding:var(--_slds-c-template-sizing-gap) var(--_slds-c-template-sizing-gap) 0 var(--_slds-c-template-sizing-gap);
}
.slds-template_app,.slds-template--app{
  padding:var(--_slds-c-template-sizing-gap) 0 0 var(--_slds-c-template-sizing-gap);
}
.slds-template_iframe,.slds-template--iframe{
  width:calc(100% + (var(--_slds-c-template-sizing-gap) * 2));
  height:calc(100% + (var(--_slds-c-template-sizing-gap) * 2));
  margin:calc(var(--_slds-c-template-sizing-gap) * -1);
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-nav-vertical__action_overflow,.slds-nav-vertical__action--overflow{
  color:var(--slds-g-color-on-surface-1);
}
.slds-nav-vertical__action_overflow[aria-expanded='true'] .slds-button__icon,.slds-nav-vertical__action--overflow[aria-expanded='true'] .slds-button__icon{
  transform:rotate(90deg);
}
[dir='rtl'] .slds-nav-vertical__action_overflow[aria-expanded='true'] .slds-button__icon,[dir='rtl'] .slds-nav-vertical__action--overflow[aria-expanded='true'] .slds-button__icon{
  transform:rotate(-90deg);
}
.slds-nav-vertical__action-text{
  color:var(--slds-s-link-color, var(--slds-g-color-accent-2));
}
.slds-nav-vertical__action-text:hover{
  color:var(--slds-s-link-color-hover);
}
.slds-nav-vertical{
  position:relative;
}
.slds-nav-vertical_compact .slds-nav-vertical__title,.slds-nav-vertical--compact .slds-nav-vertical__title,
.slds-nav-vertical_compact .slds-nav-vertical__action,
.slds-nav-vertical--compact .slds-nav-vertical__action{
  padding-block-start:var(--slds-g-spacing-1);
  padding-inline-end:var(--slds-g-spacing-5);
  padding-block-end:var(--slds-g-spacing-1);
  padding-inline-start:var(--slds-g-spacing-5);
}
.slds-nav-vertical_shade .slds-is-active.slds-nav-vertical__item::before,.slds-nav-vertical--shade .slds-is-active.slds-nav-vertical__item::before{
  background:var(--slds-g-color-on-surface-inverse-1);
}
.slds-nav-vertical_shade .slds-nav-vertical__item:hover::before,.slds-nav-vertical--shade .slds-nav-vertical__item:hover::before{
  background:var(--slds-g-color-on-surface-inverse-1);
}
.slds-nav-vertical_shade .slds-is-active .slds-nav-vertical__action,.slds-nav-vertical--shade .slds-is-active .slds-nav-vertical__action{
  border-color:var(--slds-g-color-neutral-base-90);
}
.slds-nav-vertical__title{
  padding-block-start:var(--slds-g-spacing-2);
  padding-inline-end:var(--slds-g-spacing-4);
  padding-block-end:var(--slds-g-spacing-2);
  padding-inline-start:var(--slds-g-spacing-5);
  font-size:var(--slds-g-font-size-base);
  font-weight:var(--slds-g-font-weight-7);
}
.slds-nav-vertical__title:not(:first-of-type){
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-nav-vertical__section:not(:first-of-type){
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-nav-vertical__item{
  position:relative;
  display:block;
  list-style:none;
}
.slds-nav-vertical__item::before{
  position:absolute;
  inset-block-start:0;
  inset-inline-end:0;
  inset-block-end:0;
  inset-inline-start:0;
  content:'';
}
.slds-nav-vertical__item:hover::before,
.slds-nav-vertical__item.slds-is-active::before{
  background:color-mix(in srgb, var(--slds-g-color-accent-1) 10%, transparent);
}
.slds-nav-vertical__item:has(:focus-visible)::before{
  box-shadow:inset 0 0 0 1px var(--slds-g-color-accent-1);
}
.slds-nav-vertical__action{
  position:relative;
  display:flex;
  align-items:center;
  width:100%;
  padding-block-start:var(--slds-g-spacing-2);
  padding-inline-end:var(--slds-g-spacing-5);
  padding-block-end:var(--slds-g-spacing-2);
  padding-inline-start:var(--slds-g-spacing-6);
  color:var(--slds-s-navigation-color, var(--slds-g-color-on-surface-3));
  border-block-start:var(--slds-g-sizing-border-1) solid transparent;
  border-block-end:var(--slds-g-sizing-border-1) solid transparent;
  border-radius:0;
  box-shadow:inset 0 0 0 var(--slds-g-color-accent-1);
  cursor:pointer;
}
.slds-nav-vertical__action:active,
.slds-nav-vertical__action:hover,
.slds-nav-vertical__action:focus{
  color:currentcolor;
}
.slds-nav-vertical__action:hover{
  text-decoration:none;
  box-shadow:inset 2px 0 0 var(--slds-g-color-accent-1);
  color:var(--slds-s-navigation-color-hover);
}
[dir='rtl'] .slds-nav-vertical__action:hover{
  box-shadow:inset -2px 0 0 var(--slds-g-color-accent-1);
}
.slds-nav-vertical__action:focus-visible{
  outline:0;
  text-decoration:underline;
}
.slds-nav-vertical__item.slds-is-active .slds-nav-vertical__action{
  font-weight:var(--slds-s-navigation-font-weight, bold);
  box-shadow:inset 4px 0 0 var(--slds-g-color-accent-1);
  color:var(--slds-s-navigation-color-active);
}
[dir='rtl'] .slds-nav-vertical__item.slds-is-active .slds-nav-vertical__action{
  box-shadow:inset -4px 0 0 var(--slds-g-color-accent-1);
}
.slds-nav-vertical__item [type='radio']{
  width:1px;
  height:1px;
  border:0;
  clip:rect(0 0 0 0);
  margin:-1px;
  overflow:hidden;
  padding:0;
  position:absolute;
}
.slds-nav-vertical__item [type='radio']:focus + .slds-nav-vertical__action,
.slds-nav-vertical__item [type='radio']:focus + .slds-nav-vertical__action .slds-nav-vertical_radio-faux,
.slds-nav-vertical__item [type='radio']:focus + .slds-nav-vertical__action .slds-nav-vertical--radio-faux{
  text-decoration:underline;
}
.slds-nav-vertical__item [type='radio']:checked + .slds-nav-vertical__action{
  font-weight:var(--slds-g-font-weight-7);
  background-color:color-mix(in srgb, var(--slds-g-color-accent-1) 10%, transparent);
  box-shadow:inset 4px 0 0 var(--slds-g-color-accent-1);
}
.slds-nav-vertical_shade .slds-nav-vertical__item [type='radio']:checked + .slds-nav-vertical__action,.slds-nav-vertical--shade .slds-nav-vertical__item [type='radio']:checked + .slds-nav-vertical__action{
  border-color:var(--slds-g-color-neutral-base-90);
  background-color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-context-bar{
  display:flex;
  height:var(--slds-s-navigation-sizing-height, 2.5rem);
  background-color:var(--slds-g-color-surface-container-1);
  border-bottom:var(--_slds-c-globalnavigation-sizing-border, 3px) solid var(--slds-g-color-accent-2);
  color:var(--slds-g-color-on-surface-3);
  position:relative;
  padding-block-start:var(--_slds-c-globalnavigation-spacing-block, 0);
  padding-block-end:var(--_slds-c-globalnavigation-spacing-block, 0);
  /* margin-block-start: var(--slds-s-header-sizing-height); */
}
.slds-context-bar .slds-context-bar__button{
  color:inherit;
}
.slds-context-bar .slds-context-bar__icon-action{
  margin-left:auto;
}
.slds-context-bar .slds-is-unsaved .slds-context-bar__label-action{
  position:relative;
  font-style:italic;
  line-height:normal;
}
.slds-context-bar .slds-is-unsaved .slds-indicator_unread,.slds-context-bar .slds-is-unsaved .slds-indicator--unread{
  margin-left:-0.35rem;
}
.slds-context-bar .slds-has-notification .slds-indicator_unread,.slds-context-bar .slds-has-notification .slds-indicator--unread{
  display:inline-block;
  flex-shrink:0;
  height:6px;
  width:6px;
  left:auto;
  position:relative;
  top:auto;
}
.slds-context-bar .slds-has-notification .slds-indicator_unsaved,.slds-context-bar .slds-has-notification .slds-indicator--unsaved{
  top:rem(-4px);
}
.slds-context-bar__primary,
.slds-context-bar__secondary,
.slds-context-bar__tertiary{
  display:flex;
  flex-shrink:0;
}
.slds-context-bar__primary{
  padding-inline-start:var(--slds-g-spacing-4);
}
.slds-context-bar__secondary{
  flex:1 1;
  min-width:0;
  gap:var(--_slds-c-globalnavigation-spacing-gap, 0);
}
.slds-context-bar__secondary .slds-grid{
  gap:inherit;
}
.slds-context-bar__vertical-divider{
  width:0;
  overflow:hidden;
  border-left:1px solid var(--slds-g-color-border-1);
}
.slds-context-bar__item{
  display:flex;
  align-content:center;
  align-items:stretch;
  white-space:nowrap;
  position:relative;
  border-radius:var(--_slds-c-globalnavigation-item-radius-border, 0);
  max-width:var(--_slds-c-globalnavigation-item-sizing-width-max, var(--slds-g-sizing-14));
  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
}
.slds-context-bar__item:not(.slds-no-hover):has(:focus-visible){
  box-shadow:var(--_slds-c-globalnavigation-item-shadow-focus);
}
.slds-context-bar__item .slds-button__icon,
.slds-context-bar__item .slds-icon{
  fill:var(--slds-g-color-on-surface-1);
}
.slds-context-bar__item:not(.slds-no-hover):hover{
  outline:0;
  background-color:var(
    --_slds-c-globalnavigation-item-color-background-hover,
    var(--slds-g-color-accent-light-1)
  ) !important;
  text-decoration:none;
  cursor:pointer;
}
.slds-context-bar__item:not(.slds-no-hover):hover::after{
  opacity:1;
}
.slds-context-bar__item::before{
  bottom:0;
  content:'';
  height:auto;
  left:0;
  position:absolute;
  right:0;
  top:0;
  transition-property:top, background-color;
}
.slds-context-bar__item::after{
  content:'';
  width:100%;
  height:var(--_slds-c-globalnavigation-item-sizing-border-hover, 3px);
  display:block;
  background:var(
    --_slds-c-globalnavigation-item-color-border-hover,
    color-mix(in oklab, var(--slds-g-color-accent-2) 80%, black)
  );
  position:absolute;
  bottom:calc(var(--_slds-c-globalnavigation-item-sizing-border-hover, 3px) * -1);
  border-radius:var(--_slds-c-globalnavigation-item-radius-border, 0);
  left:0;
  right:0;
  opacity:0;
}
.slds-context-bar__item.slds-is-active{
  background-color:var(
    --_slds-c-globalnavigation-item-color-background-active,
    var(--slds-g-color-accent-light-1)
  ) !important;
  color:var(--_slds-c-globalnavigation-item-color-active, var(--slds-g-color-on-surface-3));
  text-decoration:none;
  cursor:pointer;
  animation:bkAnim 0.135s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}
.slds-context-bar__item.slds-is-active::before{
  content:'';
  height:var(--_slds-c-globalnavigation-item-sizing-border-active, 3px);
  display:block;
  background:var(--slds-g-color-accent-2);
  position:absolute;
  top:0;
  left:0;
  right:0;
  animation:navBounceIn 0.15s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}
.slds-context-bar__item.slds-is-active::after{
  opacity:1;
  background:var(--_slds-c-globalnavigation-item-color-border-active, var(--slds-g-color-accent-2));
}
.slds-context-bar__item.slds-is-active .slds-button__icon,
.slds-context-bar__item.slds-is-active .slds-icon{
  fill:var(--_slds-c-globalnavigation-item-color-active, var(--slds-g-color-on-surface-1));
}
.slds-context-bar__item.slds-has-notification{
  background:var(--slds-g-color-accent-container-1);
}
@keyframes error-pulse{
  0%{
    background-color:var(--slds-g-color-error-container-1);
  }

  40%{
    background-color:var(--slds-g-color-error-container-2);
  }

  100%{
    background-color:var(--slds-g-color-error-container-1);
  }
}
@keyframes success-pulse{
  0%{
    background-color:var(--slds-g-color-success-container-1);
  }

  40%{
    background-color:var(--slds-g-color-success-container-2);
  }

  100%{
    background-color:var(--slds-g-color-success-container-1);
  }
}
@keyframes warning-pulse{
  0%{
    background-color:var(--slds-g-color-warning-container-1);
  }

  40%{
    background-color:var(--slds-g-color-warning-base-80);
  }

  100%{
    background-color:var(--slds-g-color-warning-container-1);
  }
}
.slds-context-bar__item.slds-has-success .slds-context-bar__label-action{
  color:var(--slds-g-color-on-success-1);
}
.slds-context-bar__item.slds-has-success .slds-button__icon,
.slds-context-bar__item.slds-has-success .slds-icon{
  fill:var(--slds-g-color-on-success-1, var(--slds-g-color-on-surface-1));
}
.slds-context-bar__item.slds-has-success::before{
  animation:none;
  animation-duration:1s;
  animation-iteration-count:3;
  animation-delay:150ms;
  animation-timing-function:cubic-bezier(0.07, 0.49, 0.5, 1);
  background-color:var(--slds-g-color-success-container-1);
  bottom:0;
  content:'';
  height:auto;
  left:0;
  position:absolute;
  right:0;
  top:0;
  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
  animation-name:success-pulse;
}
.slds-context-bar__item.slds-has-success:hover::before{
  background-color:var(--slds-g-color-success-container-2);
  height:auto;
}
.slds-context-bar__item.slds-has-success::after{
  background-color:var(--_slds-c-globalnavigation-item-color-border-success);
}
.slds-context-bar__item.slds-has-success .slds-indicator_unread,.slds-context-bar__item.slds-has-success .slds-indicator--unread{
  background-color:var(--slds-g-color-neutral-base-100);
}
.slds-context-bar__item.slds-has-success .slds-indicator_unsaved,.slds-context-bar__item.slds-has-success .slds-indicator--unsaved{
  color:var(--slds-g-color-neutral-base-100);
}
.slds-context-bar__item.slds-has-error .slds-context-bar__label-action{
  color:var(--slds-g-color-on-error-1);
}
.slds-context-bar__item.slds-has-error .slds-button__icon,
.slds-context-bar__item.slds-has-error .slds-icon{
  fill:var(--slds-g-color-on-error-1, var(--slds-g-color-on-surface-1));
}
.slds-context-bar__item.slds-has-error::before{
  animation:none;
  animation-duration:1s;
  animation-iteration-count:3;
  animation-delay:150ms;
  animation-timing-function:cubic-bezier(0.07, 0.49, 0.5, 1);
  background-color:var(--slds-g-color-error-container-1);
  bottom:0;
  content:'';
  height:auto;
  left:0;
  position:absolute;
  right:0;
  top:0;
  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
  animation-name:error-pulse;
}
.slds-context-bar__item.slds-has-error:hover::before{
  background-color:var(--slds-g-color-error-container-2);
  height:auto;
}
.slds-context-bar__item.slds-has-error::after{
  background-color:var(--_slds-c-globalnavigation-item-color-border-error);
}
.slds-context-bar__item.slds-has-error .slds-indicator_unread,.slds-context-bar__item.slds-has-error .slds-indicator--unread{
  background-color:var(--slds-g-color-neutral-base-100);
}
.slds-context-bar__item.slds-has-error .slds-indicator_unsaved,.slds-context-bar__item.slds-has-error .slds-indicator--unsaved{
  color:var(--slds-g-color-neutral-base-100);
}
.slds-context-bar__item.slds-has-warning .slds-context-bar__label-action{
  color:var(--slds-g-color-on-warning-1);
}
.slds-context-bar__item.slds-has-warning .slds-button__icon,
.slds-context-bar__item.slds-has-warning .slds-icon{
  fill:var(--slds-g-color-on-warning-1);
}
.slds-context-bar__item.slds-has-warning::before{
  animation:none;
  animation-duration:1s;
  animation-iteration-count:3;
  animation-delay:150ms;
  animation-timing-function:cubic-bezier(0.07, 0.49, 0.5, 1);
  background-color:var(--slds-g-color-warning-container-1);
  bottom:0;
  content:'';
  height:auto;
  left:0;
  position:absolute;
  right:0;
  top:0;
  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
  animation-name:warning-pulse;
}
.slds-context-bar__item.slds-has-warning:hover::before{
  background-color:var(--slds-g-color-warning-base-80);
  height:auto;
}
.slds-context-bar__item.slds-has-warning::after{
  background-color:var(--_slds-c-globalnavigation-item-color-border-warning);
}
.slds-context-bar__item.slds-has-warning .slds-indicator_unread,.slds-context-bar__item.slds-has-warning .slds-indicator--unread{
  background-color:currentColor;
}
.slds-context-bar__item.slds-has-warning .slds-indicator_unsaved,.slds-context-bar__item.slds-has-warning .slds-indicator--unsaved{
  color:currentColor;
}
.slds-context-bar__item.slds-has-success.slds-is-active::after, .slds-context-bar__item.slds-has-warning.slds-is-active::after, .slds-context-bar__item.slds-has-error.slds-is-active::after{
  content:'';
  background:var(--slds-g-color-neutral-base-30);
  position:absolute;
  height:4px;
  opacity:0.4;
  top:0;
  right:0;
  left:0;
}
.slds-context-bar__item.slds-has-success.slds-has-focus::after, .slds-context-bar__item.slds-has-warning.slds-has-focus::after, .slds-context-bar__item.slds-has-error.slds-has-focus::after{
  height:4px;
}
@keyframes bkAnim{
  50%{
    background-color:var(--slds-g-color-neutral-base-100);
  }

  100%{
    background-color:var(
      --_slds-c-globalnavigation-item-color-background-active,
      var(--slds-g-color-accent-light-1)
    );
  }
}
@keyframes navBounceIn{
  0%{
    transform:translate3d(0, 20px, 0);
    opacity:0;
  }

  20%{
    opacity:0;
  }

  90%{
    transform:translate3d(0, 1px, 0);
  }

  100%{
    transform:translate3d(0, 0, 0);
  }
}
.slds-context-bar__item_divider-left,.slds-context-bar__item--divider-left{
  border-left:1px solid var(--slds-g-color-border-1);
}
.slds-context-bar__item_divider-right,.slds-context-bar__item--divider-right{
  border-right:1px solid var(--slds-g-color-border-1);
}
.slds-context-bar__label-action{
  display:flex;
  align-content:center;
  align-items:center;
  flex-grow:1;
  padding:0 var(--slds-g-spacing-3);
  min-width:0%;
  color:inherit;
  font-weight:var(--_slds-c-globalnavigation-font-weight, normal);
  z-index:1;
}
.slds-context-bar__label-action:focus-visible,
.slds-context-bar__label-action:focus-visible:hover{
  outline:0;
  -webkit-text-decoration:var(--_slds-c-globalnavigation-font-decoration-focus, underline);
          text-decoration:var(--_slds-c-globalnavigation-font-decoration-focus, underline);
}
.slds-context-bar__label-action:hover{
  text-decoration:none;
}
.slds-context-bar__label-action:hover,
.slds-context-bar__label-action:focus{
  color:inherit;
}
.slds-context-bar__label-action:active{
  color:inherit;
  text-decoration:none;
}
.slds-context-bar__icon-action{
  display:flex;
  align-items:center;
  align-content:center;
  margin-left:calc(var(--slds-g-spacing-1) * -1);
  padding:0 var(--slds-g-spacing-2);
  color:var(--slds-g-color-on-surface-1);
  border-radius:0;
  flex-shrink:0;
}
.slds-context-bar__icon-action:focus-visible{
  outline:0;
}
.slds-context-bar__icon-action:focus-visible .slds-context-bar__button{
  outline:0;
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-context-bar__icon-action:focus-visible ~ .slds-dropdown{
  visibility:visible;
  opacity:1;
}
.slds-context-bar__icon-action:hover,
.slds-context-bar__icon-action:focus{
  color:var(--slds-g-color-on-surface-1);
}
.slds-context-bar__icon-action:active{
  color:var(--slds-g-color-on-surface-1);
}
.slds-context-bar__icon-action .slds-icon-waffle_container,.slds-context-bar__icon-action .slds-icon-waffle--container{
  width:2rem;
  height:2rem;
  margin-inline-end:var(--slds-g-spacing-1);
  margin-inline-start:calc(var(--slds-g-spacing-2) * -1);
}
.slds-context-bar__icon-action .slds-icon-waffle{
  margin-right:auto;
  margin-left:auto;
}
.slds-context-bar__dropdown-trigger .slds-dropdown{
  margin-top:3px;
}
.slds-context-bar__dropdown-trigger .slds-dropdown::before{
  content:'';
  position:absolute;
  bottom:100%;
  width:100%;
  height:3px;
}
.slds-context-bar__app-name{
  padding-block:0;
  padding-inline:0 var(--slds-g-spacing-5);
  font-size:var(--slds-g-font-scale-3);
  font-weight:var(--_slds-c-globalnavigation-app-font-weight, normal);
  line-height:var(--slds-g-font-lineheight-2);
}
.slds-context-bar__object-switcher{
  min-width:9rem;
  max-width:var(--slds-g-sizing-14);
  border-left:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-right:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:0;
}
.slds-context-bar_tabs,.slds-context-bar--tabs{
  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-context-bar_tabs .slds-context-bar__secondary,.slds-context-bar--tabs .slds-context-bar__secondary{
  gap:0;
}
.slds-context-bar__item_tab,.slds-context-bar__item--tab{
  width:12.5rem;
  border-right:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:0;
}
.slds-context-bar__item_tab .slds-context-bar__label-action,.slds-context-bar__item--tab .slds-context-bar__label-action{
  padding:0 var(--slds-g-spacing-2);
}
.slds-context-bar__item_tab .slds-icon_container,.slds-context-bar__item--tab .slds-icon--container{
  --slds-c-icon-color-background:transparent;
  --slds-c-icon-color-foreground:var(--slds-g-color-on-surface-1);
}
.slds-context-bar__item_tab.slds-is-pinned,.slds-context-bar__item--tab.slds-is-pinned{
  width:auto;
  padding-right:var(--slds-g-spacing-2);
}
.slds-context-bar__item_tab.slds-is-pinned .slds-context-bar__label-action,.slds-context-bar__item--tab.slds-is-pinned .slds-context-bar__label-action{
  padding:0 var(--slds-g-spacing-2);
}
.slds-context-bar__item_tab.slds-has-sub-tabs.slds-is-active,.slds-context-bar__item--tab.slds-has-sub-tabs.slds-is-active,
.slds-context-bar__item_tab.slds-has-sub-tabs.slds-is-active:hover,
.slds-context-bar__item--tab.slds-has-sub-tabs.slds-is-active:hover{
  animation:none;
  background-color:transparent !important;
}
.slds-context-bar__item_tab.slds-has-sub-tabs.slds-is-active .slds-context-bar__label-action::after,.slds-context-bar__item--tab.slds-has-sub-tabs.slds-is-active .slds-context-bar__label-action::after, .slds-context-bar__item_tab.slds-has-sub-tabs.slds-is-active:hover .slds-context-bar__label-action::after, .slds-context-bar__item--tab.slds-has-sub-tabs.slds-is-active:hover .slds-context-bar__label-action::after{
  content:'';
  display:block;
  position:absolute;
  left:0;
  bottom:calc(var(--_slds-c-globalnavigation-item-sizing-border-active, 3px) * -1);
  height:var(--_slds-c-globalnavigation-item-sizing-border-active, 3px);
  width:100%;
  background-color:var(--slds-g-color-surface-container-1);
  border:0;
  mix-blend-mode:unset;
}
.slds-indicator_unsaved,.slds-indicator--unsaved{
  color:var(--slds-g-color-accent-2);
  align-self:center;
  position:relative;
}
.slds-indicator-container{
  display:inline;
  margin-inline-end:var(--slds-g-spacing-1);
}
.slds-indicator-container:empty{
  margin-inline-end:0;
}
.slds-icon-waffle_container,.slds-icon-waffle--container{
  border:0;
  outline:0;
  padding:0;
}
.slds-icon-waffle_container:hover .slds-r1,.slds-icon-waffle--container:hover .slds-r1,
.slds-icon-waffle_container:hover .slds-r2,
.slds-icon-waffle--container:hover .slds-r2,
.slds-icon-waffle_container:hover .slds-r3,
.slds-icon-waffle--container:hover .slds-r3,
.slds-icon-waffle_container:hover .slds-r4,
.slds-icon-waffle--container:hover .slds-r4,
.slds-icon-waffle_container:hover .slds-r5,
.slds-icon-waffle--container:hover .slds-r5,
.slds-icon-waffle_container:hover .slds-r6,
.slds-icon-waffle--container:hover .slds-r6,
.slds-icon-waffle_container:hover .slds-r7,
.slds-icon-waffle--container:hover .slds-r7,
.slds-icon-waffle_container:hover .slds-r8,
.slds-icon-waffle--container:hover .slds-r8,
.slds-icon-waffle_container:hover .slds-r9,
.slds-icon-waffle--container:hover .slds-r9,
.slds-icon-waffle_container:focus .slds-r1,
.slds-icon-waffle--container:focus .slds-r1,
.slds-icon-waffle_container:focus .slds-r2,
.slds-icon-waffle--container:focus .slds-r2,
.slds-icon-waffle_container:focus .slds-r3,
.slds-icon-waffle--container:focus .slds-r3,
.slds-icon-waffle_container:focus .slds-r4,
.slds-icon-waffle--container:focus .slds-r4,
.slds-icon-waffle_container:focus .slds-r5,
.slds-icon-waffle--container:focus .slds-r5,
.slds-icon-waffle_container:focus .slds-r6,
.slds-icon-waffle--container:focus .slds-r6,
.slds-icon-waffle_container:focus .slds-r7,
.slds-icon-waffle--container:focus .slds-r7,
.slds-icon-waffle_container:focus .slds-r8,
.slds-icon-waffle--container:focus .slds-r8,
.slds-icon-waffle_container:focus .slds-r9,
.slds-icon-waffle--container:focus .slds-r9{
  animation:slds-icon-waffle-throb 2 200ms alternate;
}
.slds-icon-waffle_container:hover .slds-r1,.slds-icon-waffle--container:hover .slds-r1,
.slds-icon-waffle_container:hover .slds-r2,
.slds-icon-waffle--container:hover .slds-r2,
.slds-icon-waffle_container:hover .slds-r3,
.slds-icon-waffle--container:hover .slds-r3,
.slds-icon-waffle_container:focus .slds-r1,
.slds-icon-waffle--container:focus .slds-r1,
.slds-icon-waffle_container:focus .slds-r2,
.slds-icon-waffle--container:focus .slds-r2,
.slds-icon-waffle_container:focus .slds-r3,
.slds-icon-waffle--container:focus .slds-r3{
  background-color:var(--slds-g-color-brand-base-50, #418fde);
}
.slds-icon-waffle_container:hover .slds-r4,.slds-icon-waffle--container:hover .slds-r4,
.slds-icon-waffle_container:hover .slds-r5,
.slds-icon-waffle--container:hover .slds-r5,
.slds-icon-waffle_container:hover .slds-r7,
.slds-icon-waffle--container:hover .slds-r7,
.slds-icon-waffle_container:focus .slds-r4,
.slds-icon-waffle--container:focus .slds-r4,
.slds-icon-waffle_container:focus .slds-r5,
.slds-icon-waffle--container:focus .slds-r5,
.slds-icon-waffle_container:focus .slds-r7,
.slds-icon-waffle--container:focus .slds-r7{
  background-color:var(--slds-g-color-warning-base-70, #ed8b00);
}
.slds-icon-waffle_container:hover .slds-r6,.slds-icon-waffle--container:hover .slds-r6,
.slds-icon-waffle_container:hover .slds-r8,
.slds-icon-waffle--container:hover .slds-r8,
.slds-icon-waffle_container:hover .slds-r9,
.slds-icon-waffle--container:hover .slds-r9,
.slds-icon-waffle_container:focus .slds-r6,
.slds-icon-waffle--container:focus .slds-r6,
.slds-icon-waffle_container:focus .slds-r8,
.slds-icon-waffle--container:focus .slds-r8,
.slds-icon-waffle_container:focus .slds-r9,
.slds-icon-waffle--container:focus .slds-r9{
  background-color:var(--slds-g-color-palette-yellow-80, #ffb60f);
}
.slds-icon-waffle_container:hover .slds-r2,.slds-icon-waffle--container:hover .slds-r2,
.slds-icon-waffle_container:hover .slds-r4,
.slds-icon-waffle--container:hover .slds-r4,
.slds-icon-waffle_container:focus .slds-r2,
.slds-icon-waffle--container:focus .slds-r2,
.slds-icon-waffle_container:focus .slds-r4,
.slds-icon-waffle--container:focus .slds-r4{
  transition-delay:50ms;
  animation-delay:50ms;
}
.slds-icon-waffle_container:hover .slds-r3,.slds-icon-waffle--container:hover .slds-r3,
.slds-icon-waffle_container:hover .slds-r5,
.slds-icon-waffle--container:hover .slds-r5,
.slds-icon-waffle_container:hover .slds-r7,
.slds-icon-waffle--container:hover .slds-r7,
.slds-icon-waffle_container:focus .slds-r3,
.slds-icon-waffle--container:focus .slds-r3,
.slds-icon-waffle_container:focus .slds-r5,
.slds-icon-waffle--container:focus .slds-r5,
.slds-icon-waffle_container:focus .slds-r7,
.slds-icon-waffle--container:focus .slds-r7{
  transition-delay:100ms;
  animation-delay:100ms;
}
.slds-icon-waffle_container:hover .slds-r6,.slds-icon-waffle--container:hover .slds-r6,
.slds-icon-waffle_container:hover .slds-r8,
.slds-icon-waffle--container:hover .slds-r8,
.slds-icon-waffle_container:focus .slds-r6,
.slds-icon-waffle--container:focus .slds-r6,
.slds-icon-waffle_container:focus .slds-r8,
.slds-icon-waffle--container:focus .slds-r8{
  transition-delay:150ms;
  animation-delay:150ms;
}
.slds-icon-waffle_container:hover .slds-r9,.slds-icon-waffle--container:hover .slds-r9,
.slds-icon-waffle_container:focus .slds-r9,
.slds-icon-waffle--container:focus .slds-r9{
  transition-delay:200ms;
  animation-delay:200ms;
}
.slds-icon-waffle{
  width:1.3125rem;
  height:1.3125rem;
  position:relative;
  display:block;
  cursor:pointer;
}
.slds-icon-waffle .slds-r1,
.slds-icon-waffle .slds-r2,
.slds-icon-waffle .slds-r3,
.slds-icon-waffle .slds-r4,
.slds-icon-waffle .slds-r5,
.slds-icon-waffle .slds-r6,
.slds-icon-waffle .slds-r7,
.slds-icon-waffle .slds-r8,
.slds-icon-waffle .slds-r9{
  width:0.3125rem;
  height:0.3125rem;
  background-color:var(--slds-g-color-neutral-base-50, #747474);
  display:inline-block;
  position:absolute;
  border-radius:50%;
  transition:background-color 100ms;
  transform-origin:50% 50%;
  will-change:scale, background-color;
}
.slds-icon-waffle .slds-r1{
  top:0;
  left:0;
  transition-delay:200ms;
}
.slds-icon-waffle .slds-r2{
  top:0;
  left:0.5rem;
}
.slds-icon-waffle .slds-r3{
  top:0;
  right:0;
}
.slds-icon-waffle .slds-r4{
  top:0.5rem;
  left:0;
}
.slds-icon-waffle .slds-r5{
  top:0.5rem;
  left:0.5rem;
}
.slds-icon-waffle .slds-r6{
  top:0.5rem;
  right:0;
}
.slds-icon-waffle .slds-r7{
  bottom:0;
  left:0;
}
.slds-icon-waffle .slds-r8{
  bottom:0;
  left:0.5rem;
}
.slds-icon-waffle .slds-r9{
  bottom:0;
  right:0;
}
.slds-icon-waffle .slds-r2,
.slds-icon-waffle .slds-r4{
  transition-delay:150ms;
}
.slds-icon-waffle .slds-r3,
.slds-icon-waffle .slds-r5,
.slds-icon-waffle .slds-r7{
  transition-delay:100ms;
}
.slds-icon-waffle .slds-r6,
.slds-icon-waffle .slds-r8{
  transition-delay:50ms;
}
@keyframes slds-icon-waffle-throb{
  to{
    transform:scale(1.5);
  }
}
.slds-expression__options{
  width:var(--slds-g-sizing-14);
}
.slds-expression__options .slds-form-element__control{
  clear:none;
}
.slds-expression__legend{
  float:left;
  width:var(--slds-g-sizing-10);
  padding-top:calc((var(--slds-g-font-lineheight-base) * var(--slds-g-font-scale-neg-1)) + (1.875rem / 4));
  font-weight:var(--slds-g-font-weight-7);
}
.slds-expression__legend.slds-expression__legend_group,.slds-expression__legend.slds-expression__legend--group{
  margin-top:0;
}
.slds-expression__row{
  margin-top:var(--slds-g-spacing-3);
}
.slds-expression__row.slds-expression__row_group,.slds-expression__row.slds-expression__row--group{
  padding-left:var(--slds-g-spacing-8);
}
.slds-expression__row .slds-form-element__label{
  line-height:1.5;
}
.slds-expression__buttons{
  margin-top:var(--slds-g-spacing-3);
}
.slds-expression__group{
  background:var(--slds-g-color-surface-2);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
  padding:var(--slds-g-spacing-3);
  margin-top:var(--slds-g-spacing-3);
}
.slds-expression__title{
  font-size:var(--slds-g-font-scale-3);
  font-weight:bold;
  margin-bottom:var(--slds-g-spacing-2);
}
.slds-expression__custom-logic{
  margin-top:var(--slds-g-spacing-3);
}
.slds-filters{
  position:relative;
}
.slds-filters__header{
  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-3);
}
.slds-filters__body{
  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-3);
}
.slds-filters__footer{
  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-4);
}
.slds-filters__item{
  padding:var(--slds-g-spacing-3);
  background:var(--slds-g-color-surface-1);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
}
.slds-filters__item.slds-is-new{
  background:var(--slds-g-color-palette-yellow-90);
  color:var(--slds-g-color-neutral-base-10, var(--slds-g-color-on-surface-2));
}
.slds-filters__item.slds-has-error{
  border-color:var(--slds-g-color-border-error-1);
}
.slds-filters__item.slds-is-locked{
  background:var(--slds-g-color-surface-2);
}
.slds-filters__item + .slds-filters__item{
  margin-top:var(--slds-g-spacing-2);
}
.slds-filters__item:hover{
  background:var(--slds-g-color-surface-2);
}
.slds-filters__group{
  background:var(--slds-g-color-surface-2);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
  padding:var(--slds-g-spacing-3);
}
.slds-expression_formula__rte,.slds-expression--formula__rte{
  margin-block-start:var(--slds-g-spacing-3);
}
.slds-global-header_container,.slds-global-header--container{
  --_slds-c-globalheader-logo:var(--lwc-brandLogoImage, url(${___CSS_LOADER_URL_REPLACEMENT_0___}));

  /* position:fixed; */
  width:100%;
  top:0;
  left:0;
  z-index:100;
}
.slds-global-header_container .slds-assistive-text_focus,.slds-global-header--container .slds-assistive-text--focus{
  top:0;
  color:var(--slds-g-color-on-surface-1);
  background:var(--slds-g-color-surface-container-1);
}
.slds-global-header{
  background:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-g-shadow-1);
  padding:var(--slds-g-spacing-2) 0;
  height:var(--slds-s-header-sizing-height, 3.125rem);
  align-items:center;
}
.slds-global-header .slds-global-search__form-element .slds-input{
  padding-inline-start:calc(var(--slds-g-spacing-5) * 2);
}
.slds-global-header .slds-global-search__form-element .slds-input__icon_left,.slds-global-header .slds-global-search__form-element .slds-input__icon--left{
  left:calc(var(--slds-g-spacing-4) + var(--slds-g-spacing-1));
}
.slds-global-header .slds-global-search__form-element .slds-icon{
  fill:var(--slds-g-color-on-surface-1);
}
.slds-global-header__item{
  padding:0 var(--slds-g-spacing-4);
}
.slds-global-header__item_search,.slds-global-header__item--search{
  flex:0 1 33.5rem;
  min-width:27.5rem;
  padding:0;
}
.slds-global-header__item_search .slds-button,.slds-global-header__item--search .slds-button{
  width:100%;
  cursor:text;
  justify-content:flex-start;

  --slds-c-button-color-background-hover:var(--slds-g-color-surface-container-1);
  --slds-c-button-color-background-active:var(--slds-g-color-surface-container-1);
  --slds-c-button-text-color:var(--slds-g-color-neutral-base-60);
  --slds-c-button-text-color-hover:var(--slds-g-color-neutral-base-60);
  --slds-c-button-text-color-active:var(--slds-g-color-neutral-base-60);
}
.slds-global-header__item_search .slds-icon,.slds-global-header__item--search .slds-icon{
  fill:var(--_slds-c-globalheader-color);
}
.slds-global-header__logo{
  width:12.5rem;
  height:2.5rem;
  background-image:var(--_slds-c-globalheader-logo);
  background-size:contain;
  background-repeat:no-repeat;
  background-position:left center;
}
.slds-global-header__notification{
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  padding:var(--slds-g-spacing-1);
}
.slds-global-header__notification:hover{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-global-header__notification:last-child{
  border-block-end:0;
}
.slds-global-header__notification_unread,.slds-global-header__notification--unread{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-global-actions{
  display:flex;
  align-items:center;
}
.slds-global-actions__item{
  margin-inline-start:var(--slds-g-spacing-2);
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-global-actions__item .slds-button__icon{
  fill:var(--_slds-c-globalheader-color);
  color:var(--_slds-c-globalheader-color);
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
}
.slds-global-actions__item-action{
  transition:color 200ms linear;
}
.slds-global-actions__item-action .slds-icon{
  fill:var(--_slds-c-globalheader-color);
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
}
.slds-global-actions__item-action:hover:not(:disabled) .slds-icon,
.slds-global-actions__item-action:focus .slds-icon{
  fill:var(--_slds-c-globalheader-color-hover);
}
.slds-global-actions__item-action:active{
  box-shadow:none;
}
.slds-global-actions__item-action:active .slds-icon{
  animation:click-icon 120ms cubic-bezier(1, 1.9, 0.94, 0.98);
}
.slds-global-actions__item-action:active:not(:disabled) .slds-icon{
  fill:var(--_slds-c-globalheader-color-hover);
}
.slds-global-actions__item_help,.slds-global-actions__item--help,
.slds-global-actions__item_notification,
.slds-global-actions__item--notification{
  margin-inline:var(--slds-g-spacing-1);
}
.slds-global-actions__item_notification .slds-icon,.slds-global-actions__item--notification .slds-icon{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
}
@keyframes click-icon{
  25%{
    transform:scale(0.94, 0.94);
  }

  100%{
    transform:scale(0.98, 0.98);
  }
}
.slds-global-actions__avatar{
  box-shadow:var(--_slds-c-globalheader-color) 0 0 0 0;
  border-radius:var(--slds-g-radius-border-circle);
  border:0;
  margin-inline-start:var(--slds-g-spacing-2);
  padding:0;
  overflow:hidden;
  transition:transform 80ms ease-out, box-shadow 0.1s linear;
}
.slds-global-actions__avatar:hover,
.slds-global-actions__avatar:focus{
  box-shadow:var(--_slds-c-globalheader-color) 0 0 0 2px;
}
.slds-global-actions__favorites{
  display:inline-flex;
}
.slds-global-actions__favorites-action{
  border-color:var(--_slds-c-globalheader-color);
  width:auto;
  padding-inline-end:var(--slds-g-spacing-1);
  padding-inline-start:var(--slds-g-spacing-1);
}
.slds-global-actions__favorites-action:hover{
  border-color:var(--_slds-c-globalheader-color-hover);
}
.slds-global-actions__favorites-action .slds-button__icon{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  transition:transform 200ms ease-out;
}
.slds-global-actions__favorites-action:hover:not(:disabled) .slds-button__icon{
  transform:scale(1.1, 1.1);
  transform-origin:60% 40%;
}
.slds-global-actions__favorites-action.slds-is-selected{
  background-color:var(--slds-g-color-accent-container-2);
  border-color:var(--slds-g-color-accent-container-2);
}
.slds-global-actions__favorites-action.slds-is-selected:hover,
.slds-global-actions__favorites-action.slds-is-selected:focus{
  background-color:var(--slds-g-color-accent-container-3);
  border-color:var(--slds-g-color-accent-container-3);
}
.slds-global-actions__favorites-action.slds-is-selected .slds-button__icon{
  animation:click-favorites-icon 600ms cubic-bezier(0.46, 0.32, 0, 0.98);
}
.slds-global-actions__favorites-action:disabled,
.slds-global-actions__favorites-action.slds-is-disabled{
  color:var(--slds-g-color-disabled-2);
  border-color:var(--slds-g-color-border-1);
}
.slds-global-actions__favorites-more{
  width:auto;
  padding-inline-start:var(--slds-g-spacing-1);
  padding-inline-end:var(--slds-g-spacing-1);
  border-color:var(--_slds-c-globalheader-color);
}
.slds-global-actions__favorites-more .slds-icon{
  width:var(--slds-g-sizing-4);
  height:var(--slds-g-sizing-4);
}
.slds-global-actions__favorites-more:hover{
  border-color:var(--_slds-c-globalheader-color-hover);
}
@keyframes click-favorites-icon{
  25%{
    transform:scale(0.85, 0.85) rotate(15deg);
  }

  75%{
    transform:scale(1.2, 1.2) rotate(0deg);
  }

  100%{
    transform:scale(1, 1) rotate(0deg);
  }
}
.slds-global-actions__task{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
  background:var(--_slds-c-globalheader-color);
  position:relative;
  top:-1px;
}
.slds-global-actions__task:hover,
.slds-global-actions__task:active{
  background:var(--_slds-c-globalheader-color-hover);
}
.slds-global-actions__task:not(:disabled) .slds-icon,
.slds-global-actions__task:not(:disabled):hover .slds-icon,
.slds-global-actions__task:not(:disabled):active .slds-icon{
  fill:var(--slds-g-color-neutral-base-100);
}
.slds-global-actions__task .slds-button__icon,
.slds-global-actions__task .slds-icon{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
}
.slds-global-actions__notifications{
  position:relative;
}
.slds-global-actions__notifications.slds-incoming-notification{
  animation:bell 0.8s ease-in-out;
}
.slds-notification-badge{
  display:inline-flex;
  justify-content:center;
  align-content:center;
  align-items:center;
  position:absolute;
  top:calc(6px * -1);
  right:calc(4px * -1);
  background:var(--slds-g-color-palette-red-50);
  color:var(--slds-g-color-neutral-base-100);
  border-radius:var(--slds-g-radius-border-circle);
  min-width:var(--slds-g-sizing-5);
  min-height:var(--slds-g-sizing-5);
  text-align:center;
  font-size:var(--slds-g-font-scale-neg-2);
  padding:0 0.125rem;
  opacity:0;
  pointer-events:none;
}
.slds-notification-badge.slds-show-notification{
  animation:ding 0.8s ease-out;
  opacity:1;
  transition-delay:0.5s;
  transform-origin:1.1875rem 0;
}
@keyframes ding{
  75%{
    transform:scale(0.5, 0.5);
  }

  85%{
    transform:scale(1.5, 1.5);
  }

  100%{
    transform:scale(1, 1);
  }
}
@keyframes bell{
  45%{
    transform:rotate(15deg);
  }

  57%{
    transform:rotate(-15deg);
  }

  70%{
    transform:rotate(7deg);
  }

  77%{
    transform:rotate(-5deg);
  }
}
.slds-app-launcher__tile{
  display:flex;
  align-items:stretch;
  margin:var(--slds-g-spacing-2) 0;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
  cursor:move;
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-app-launcher__tile:hover,
.slds-app-launcher__tile:focus,
.slds-app-launcher__tile:active{
  outline:0;
  border-color:var(--slds-g-color-border-accent-3);
}
.slds-app-launcher__tile.slds-is-draggable .slds-app-launcher__tile-figure{
  padding-block-end:var(--slds-g-spacing-1);
}
.slds-app-launcher__tile.slds-is-grabbed{
  transform:rotate(3deg);
}
.slds-app-launcher__tile-figure{
  display:flex;
  flex-direction:column;
  flex-shrink:0;
  padding:var(--slds-g-spacing-3);
  color:var(--slds-g-color-on-surface-inverse-1);
  border-start-start-radius:var(--slds-g-radius-border-2);
  border-start-end-radius:0;
  border-end-start-radius:var(--slds-g-radius-border-2);
  border-end-end-radius:0;
  text-align:center;

  --slds-c-avatar-radius-border:var(--slds-g-radius-border-2);
}
.slds-app-launcher__tile-body{
  flex:1 1 auto;
  background:var(--slds-g-color-surface-container-2);
  padding-block:var(--slds-g-spacing-2);
  padding-inline:var(--slds-g-spacing-3);
  border-start-start-radius:0;
  border-start-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:0;
  border-end-end-radius:var(--slds-g-radius-border-2);
  color:var(--slds-g-color-on-surface-2);
}
.slds-app-launcher .slds-modal__header .slds-modal__close .slds-button__icon{
  fill:var(--slds-g-color-on-surface-1);
}
.slds-app-launcher .slds-app-launcher__header-search .slds-input-has-icon .slds-input__icon{
  fill:var(--slds-g-color-on-surface-1);
}
.slds-app-launcher .slds-app-launcher__tile-figure .slds-button__icon{
  fill:var(--slds-g-color-on-surface-1);
}
.slds-app-launcher__content{
  flex:1 1 auto;
}
.slds-app-launcher__content .slds-section__title-action{
  background:transparent;
}
.slds-progress-bar{
  appearance:none;
  display:block;
  width:100%;
  height:var(--slds-g-sizing-3);
  background-color:var(--slds-g-color-surface-container-3);
  border:0;
  position:relative;
}
.slds-progress-bar_x-small,.slds-progress-bar--x-small{
  height:var(--slds-g-sizing-1);
}
.slds-progress-bar_small,.slds-progress-bar--small{
  height:var(--slds-g-sizing-2);
}
.slds-progress-bar_medium,.slds-progress-bar--medium{
  height:var(--slds-g-sizing-3);
}
.slds-progress-bar_large,.slds-progress-bar--large{
  height:var(--slds-g-sizing-4);
}
.slds-progress-bar_circular,.slds-progress-bar--circular{
  border-radius:var(--slds-g-radius-border-pill);
}
.slds-progress-bar_circular .slds-progress-bar__value,.slds-progress-bar--circular .slds-progress-bar__value{
  border-radius:var(--slds-g-radius-border-pill);
}
.slds-progress-bar__value{
  display:block;
  background-color:var(--slds-g-color-accent-container-1);
  height:100%;
}
.slds-progress-bar__value_success,.slds-progress-bar__value--success{
  background-color:var(--slds-g-color-success-1);
}
.slds-progress-bar_vertical,.slds-progress-bar--vertical{
  height:100%;
  width:var(--slds-g-sizing-3);
}
.slds-progress-bar_vertical.slds-progress-bar_x-small,.slds-progress-bar--vertical.slds-progress-bar--x-small{
  width:var(--slds-g-sizing-1);
}
.slds-progress-bar_vertical.slds-progress-bar_small,.slds-progress-bar--vertical.slds-progress-bar--small{
  width:var(--slds-g-sizing-2);
}
.slds-progress-bar_vertical.slds-progress-bar_medium,.slds-progress-bar--vertical.slds-progress-bar--medium{
  width:var(--slds-g-sizing-3);
}
.slds-progress-bar_vertical.slds-progress-bar_large,.slds-progress-bar--vertical.slds-progress-bar--large{
  width:var(--slds-g-sizing-4);
}
.slds-progress{
  position:relative;
  max-width:70%;
  width:100%;
  flex:1 1 auto;
  margin:auto;
}
.slds-progress .slds-progress-bar{
  position:absolute;
  inset-block-start:50%;
  margin-block-start:-0.0625rem;
}
.slds-progress_shade .slds-progress__item.slds-is-completed .slds-progress__marker,.slds-progress--shade .slds-progress__item.slds-is-completed .slds-progress__marker,
.slds-progress_shade .slds-progress__item.slds-is-active .slds-progress__marker,
.slds-progress--shade .slds-progress__item.slds-is-active .slds-progress__marker{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-progress_shade .slds-progress__item.slds-is-completed .slds-progress__marker_icon,.slds-progress--shade .slds-progress__item.slds-is-completed .slds-progress__marker--icon{
  border-color:var(--slds-g-color-surface-container-2);
}
.slds-progress_shade .slds-progress__item.slds-is-active .slds-progress__marker,.slds-progress--shade .slds-progress__item.slds-is-active .slds-progress__marker{
  box-shadow:var(--slds-g-color-surface-container-2) 0 0 0 var(--slds-g-sizing-2);
}
.slds-progress_shade .slds-progress__item.slds-is-active .slds-progress__marker:focus,.slds-progress--shade .slds-progress__item.slds-is-active .slds-progress__marker:focus{
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-progress_shade .slds-progress__item.slds-has-error .slds-progress__marker,.slds-progress--shade .slds-progress__item.slds-has-error .slds-progress__marker,
.slds-progress_shade .slds-progress__item.slds-has-error .slds-progress__marker:hover,
.slds-progress--shade .slds-progress__item.slds-has-error .slds-progress__marker:hover,
.slds-progress_shade .slds-progress__item.slds-has-error .slds-progress__marker:focus,
.slds-progress--shade .slds-progress__item.slds-has-error .slds-progress__marker:focus{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-progress_shade .slds-progress__item .slds-progress__marker,.slds-progress--shade .slds-progress__item .slds-progress__marker{
  border-color:var(--slds-g-color-surface-container-2);
}
.slds-progress__list{
  display:flex;
  justify-content:space-between;
  align-items:center;
  height:100%;
  margin:auto;
  position:relative;
  z-index:1;
}
.slds-progress__item{
  display:inline-flex;
  align-self:center;
}
.slds-progress__item.slds-is-completed .slds-progress__marker,
.slds-progress__item.slds-is-active .slds-progress__marker{
  background-color:var(--slds-g-color-surface-container-1);
  border-color:var(--slds-g-color-accent-container-1);
}
.slds-progress__item.slds-is-completed .slds-progress__marker_icon,.slds-progress__item.slds-is-completed .slds-progress__marker--icon{
  border-color:var(--slds-g-color-on-accent-1);
  color:var(--slds-g-color-accent-container-1);
}
.slds-progress__item.slds-is-active .slds-progress__marker{
  box-shadow:var(--slds-g-color-surface-container-1) 0 0 0 var(--slds-g-sizing-2);
}
.slds-progress__item.slds-is-active .slds-progress__marker:hover,
.slds-progress__item.slds-is-active .slds-progress__marker:focus{
  border-color:var(--slds-g-color-border-accent-2);
}
.slds-progress__item.slds-is-active .slds-progress__marker:focus{
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-progress__item.slds-has-error .slds-progress__marker,
.slds-progress__item.slds-has-error .slds-progress__marker:hover,
.slds-progress__item.slds-has-error .slds-progress__marker:focus{
  color:var(--slds-g-color-error-1);
  background-color:var(--slds-g-color-surface-container-1);
  border-color:transparent;
  box-shadow:none;
}
.slds-progress__item.slds-has-error .slds-progress__marker:focus{
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-progress__marker{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  display:flex;
  align-items:center;
  justify-content:center;
  position:relative;
  border-radius:var(--slds-g-radius-border-circle);
  background-color:var(--slds-g-color-neutral-base-80);
  border:var(--slds-g-sizing-2) solid var(--slds-g-color-on-accent-1);
  vertical-align:middle;
}
.slds-progress__marker:focus-visible{
  outline:none;
}
.slds-progress__marker:focus{
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-progress__marker_icon,.slds-progress__marker--icon{
  width:auto;
  height:auto;
  line-height:0;
}
.slds-progress__marker_icon .slds-icon_container,.slds-progress__marker--icon .slds-icon--container{
  line-height:0;
}
.slds-progress__marker_icon .slds-icon,.slds-progress__marker--icon .slds-icon{
  fill:currentColor;
}
.slds-progress_vertical,.slds-progress--vertical{
  max-width:none;
}
.slds-progress_vertical .slds-progress__list,.slds-progress--vertical .slds-progress__list{
  display:block;
}
.slds-progress_vertical .slds-progress__item,.slds-progress--vertical .slds-progress__item{
  position:relative;
  display:flex;
  align-items:center;
  padding:0;
}
.slds-progress_vertical .slds-progress__item::before,.slds-progress--vertical .slds-progress__item::before,
.slds-progress_vertical .slds-progress__item::after,
.slds-progress--vertical .slds-progress__item::after{
  content:'';
  position:absolute;
  inset-inline-start:calc((var(--slds-g-spacing-4) / 2) - 1px);
  width:var(--slds-g-sizing-1);
  background-color:var(--slds-g-color-surface-container-3);
}
.slds-progress_vertical .slds-progress__item::before,.slds-progress--vertical .slds-progress__item::before{
  inset-block-start:0;
  inset-block-end:50%;
}
.slds-progress_vertical .slds-progress__item::after,.slds-progress--vertical .slds-progress__item::after{
  inset-block-start:50%;
  inset-block-end:0;
}
.slds-progress_vertical .slds-progress__item:first-child::before,.slds-progress--vertical .slds-progress__item:first-child::before,
.slds-progress_vertical .slds-progress__item:last-child::after,
.slds-progress--vertical .slds-progress__item:last-child::after{
  display:none;
}
.slds-progress_vertical .slds-progress__item.slds-is-completed::before,.slds-progress--vertical .slds-progress__item.slds-is-completed::before,
.slds-progress_vertical .slds-progress__item.slds-is-completed::after,
.slds-progress--vertical .slds-progress__item.slds-is-completed::after,
.slds-progress_vertical .slds-progress__item.slds-is-active::before,
.slds-progress--vertical .slds-progress__item.slds-is-active::before,
.slds-progress_vertical .slds-progress__item.slds-has-error::before,
.slds-progress--vertical .slds-progress__item.slds-has-error::before{
  background-color:var(--slds-g-color-accent-container-1);
}
.slds-progress_vertical .slds-progress__item_content,.slds-progress--vertical .slds-progress__item--content{
  flex:1 1;
  align-items:center;
  margin-block-start:var(--slds-g-spacing-3);
  padding-block-end:var(--slds-g-spacing-3);
}
.slds-progress_vertical .slds-progress__list-bordered .slds-progress__item:not(:last-child) .slds-progress__item_content,.slds-progress--vertical .slds-progress__list-bordered .slds-progress__item:not(:last-child) .slds-progress__item--content{
  border-block-end:var(--slds-g-sizing-border-1) var(--slds-g-color-border-1) solid;
}
.slds-progress_vertical .slds-progress__marker,.slds-progress--vertical .slds-progress__marker{
  display:flex;
  justify-content:center;
  margin-inline-end:var(--slds-g-spacing-4);
  min-width:var(--slds-g-sizing-5);
  z-index:5;
}
.slds-progress_vertical .slds-progress__marker_icon,.slds-progress--vertical .slds-progress__marker--icon{
  border-inline-end:0;
  border-inline-start:0;
}
.slds-progress_vertical .slds-progress__item.slds-is-completed .slds-progress__marker_icon svg,.slds-progress--vertical .slds-progress__item.slds-is-completed .slds-progress__marker--icon svg{
  fill:var(--slds-g-color-accent-1);
}
.slds-progress_vertical .slds-progress__item.slds-is-completed .slds-progress__marker_icon-success svg,.slds-progress--vertical .slds-progress__item.slds-is-completed .slds-progress__marker--icon-success svg{
  fill:var(--slds-g-color-success-1);
}
.slds-progress_vertical .slds-progress__item.slds-has-error .slds-progress__marker_icon svg,.slds-progress--vertical .slds-progress__item.slds-has-error .slds-progress__marker--icon svg{
  fill:var(--slds-g-color-error-1);
}
.slds-progress_success .slds-progress__item.slds-is-completed::before,.slds-progress--success .slds-progress__item.slds-is-completed::before,
.slds-progress_success .slds-progress__item.slds-is-completed::after,
.slds-progress--success .slds-progress__item.slds-is-completed::after,
.slds-progress_success .slds-progress__item.slds-is-active::before,
.slds-progress--success .slds-progress__item.slds-is-active::before,
.slds-progress_success .slds-progress__item.slds-has-error::before,
.slds-progress--success .slds-progress__item.slds-has-error::before{
  opacity:0.3;
  background-color:var(--slds-g-color-success-1);
}
.slds-progress-ring{
  position:relative;
  display:inline-block;
  height:var(--slds-g-sizing-7);
  width:var(--slds-g-sizing-7);
  border-radius:var(--slds-g-sizing-7);
  background-color:var(--slds-g-color-surface-container-3);
}
.slds-progress-ring .slds-icon_container,.slds-progress-ring .slds-icon--container{
  line-height:0;
}
.slds-progress-ring__progress{
  position:absolute;
  inset-block-start:0;
  inset-inline-start:0;
  height:100%;
  width:100%;
  transform:scale(-1, 1) rotate(-90deg);
}
.slds-progress-ring__progress svg{
  width:100%;
}
.slds-progress-ring__path{
  fill:var(--slds-g-color-success-1);
}
.slds-progress-ring__progress-head{
  position:absolute;
  height:calc(100% + 0.375rem);
  width:calc(100% + 0.375rem);
  inset-block-start:-0.1875rem;
  inset-inline-start:-0.1875rem;
  transform:scale(-1, 1) rotate(-90deg);
}
.slds-progress-ring__progress-head svg{
  width:100%;
}
.slds-progress-ring__content{
  position:absolute;
  inset-block-start:0.1875rem;
  inset-inline-end:0.1875rem;
  inset-block-end:0.1875rem;
  inset-inline-start:0.1875rem;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:var(--slds-g-sizing-7);
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-progress-ring__content .slds-icon{
  width:var(--slds-g-sizing-4);
}
.slds-progress-ring_warning .slds-progress-ring__content,.slds-progress-ring--warning .slds-progress-ring__content{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-progress-ring_warning .slds-icon,.slds-progress-ring--warning .slds-icon,
.slds-progress-ring_warning .slds-progress-ring__path,
.slds-progress-ring--warning .slds-progress-ring__path{
  fill:var(--slds-g-color-warning-1);
}
.slds-progress-ring_expired .slds-progress-ring__content,.slds-progress-ring--expired .slds-progress-ring__content{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-progress-ring_expired .slds-icon,.slds-progress-ring--expired .slds-icon,
.slds-progress-ring_expired .slds-progress-ring__path,
.slds-progress-ring--expired .slds-progress-ring__path{
  fill:var(--slds-g-color-error-1);
}
.slds-progress-ring_complete .slds-icon,.slds-progress-ring--complete .slds-icon{
  fill:var(--slds-g-color-surface-container-1);
}
.slds-progress-ring_complete .slds-progress-ring__path,.slds-progress-ring--complete .slds-progress-ring__path{
  fill:var(--slds-g-color-success-1);
}
.slds-progress-ring_complete .slds-progress-ring__content,.slds-progress-ring--complete .slds-progress-ring__content{
  background-color:var(--slds-g-color-success-1);
}
.slds-progress-ring_large,.slds-progress-ring--large{
  height:var(--slds-g-sizing-9);
  width:var(--slds-g-sizing-9);
}
.slds-progress-ring_large .slds-icon,.slds-progress-ring--large .slds-icon{
  width:var(--slds-g-sizing-5);
}
.slds-progress-ring_active-step .slds-progress-ring__path,.slds-progress-ring--active-step .slds-progress-ring__path{
  fill:var(--slds-g-color-accent-1);
}
.slds-visual-picker{
  display:inline-flex;
  position:relative;
  flex-direction:column;
  border:0;
  border-radius:0;
  text-align:center;
  cursor:pointer;
}
.slds-visual-picker + .slds-visual-picker{
  margin-inline-start:var(--slds-g-spacing-4);
}
.slds-visual-picker:active .slds-visual-picker__figure{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);
  box-shadow:0 0 0 1px var(--slds-g-color-accent-1) inset;
}
.slds-visual-picker:hover .slds-visual-picker__figure{
  cursor:pointer;
}
.slds-visual-picker input:not(:disabled) ~ label:hover .slds-visual-picker__figure{
  cursor:pointer;
  outline:0;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);
  box-shadow:0 0 0 1px var(--slds-g-color-accent-1) inset;
}
.slds-visual-picker input{
  width:1px;
  height:1px;
  border:0;
  clip:rect(0 0 0 0);
  margin:-1px;
  overflow:hidden;
  padding:0;
  position:absolute;
}
.slds-visual-picker input:focus-visible ~ label .slds-visual-picker__figure{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);
  box-shadow:var(--slds-s-button-shadow-focus);
  outline:0;
}
.slds-visual-picker input:checked ~ label .slds-visual-picker__figure{
  box-shadow:var(--slds-s-container-shadow);
}
.slds-visual-picker input:checked:focus-visible ~ label .slds-visual-picker__figure{
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-visual-picker input:checked ~ label .slds-is-not-selected{
  display:none;
}
.slds-visual-picker input:checked ~ label .slds-is-selected{
  display:block;
}
.slds-visual-picker input:checked ~ label .slds-visual-picker__icon{
  background-color:var(--slds-g-color-accent-1);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);
}
.slds-visual-picker input:checked ~ label .slds-visual-picker__text{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);
  box-shadow:0 0 0 1px var(--slds-g-color-accent-1) inset;
}
.slds-visual-picker input:checked ~ label .slds-visual-picker__text::after{
  content:'';
  position:absolute;
  inset-block-start:0;
  inset-inline-end:0;
  border-color:transparent;
  border-style:solid;
  border-radius:0 var(--slds-g-radius-border-2) 0 0;
  border-width:1rem;
  border-inline-end-color:var(--slds-g-color-accent-1);
  border-block-start-color:var(--slds-g-color-accent-1);
}
.slds-visual-picker input:disabled{
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
}
.slds-visual-picker input:disabled ~ label .slds-visual-picker__body,
.slds-visual-picker input:disabled ~ label .slds-visual-picker__text,
.slds-visual-picker input:disabled ~ label .slds-visual-picker__text .slds-text-title{
  color:var(--slds-g-color-on-disabled-2);
}
.slds-visual-picker input:disabled ~ label .slds-visual-picker__figure .slds-icon{
  fill:var(--slds-g-color-on-disabled-2);
}
.slds-visual-picker input:disabled ~ label .slds-visual-picker__figure{
  border-color:var(--slds-g-color-disabled-1);
  background-color:var(--slds-g-color-disabled-container-2);
  box-shadow:none;
}
.slds-visual-picker input:disabled ~ label .slds-visual-picker__figure:hover{
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
  box-shadow:none;
}
.slds-visual-picker__figure{
  display:block;
  background:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-s-container-shadow, var(--slds-g-shadow-2));
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
  text-align:center;
  font-weight:var(--slds-s-container-heading-font-weight);
}
.slds-visual-picker__figure .slds-icon-action-check{
  background-color:var(--slds-g-color-accent-1);
}
.slds-visual-picker__figure span{
  display:block;
}
.slds-visual-picker__figure .slds-is-selected{
  display:none;
}
.slds-visual-picker_medium .slds-visual-picker__figure,.slds-visual-picker--medium .slds-visual-picker__figure,
.slds-visual-picker_medium .slds-visual-picker__body,
.slds-visual-picker--medium .slds-visual-picker__body{
  width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));
}
.slds-visual-picker_medium .slds-visual-picker__figure,.slds-visual-picker--medium .slds-visual-picker__figure{
  height:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));
}
.slds-visual-picker_large .slds-visual-picker__figure,.slds-visual-picker--large .slds-visual-picker__figure,
.slds-visual-picker_large .slds-visual-picker__body,
.slds-visual-picker--large .slds-visual-picker__body{
  width:var(--slds-g-sizing-14);
}
.slds-visual-picker_large .slds-visual-picker__figure,.slds-visual-picker--large .slds-visual-picker__figure{
  height:var(--slds-g-sizing-14);
}
.slds-visual-picker_small .slds-visual-picker__figure,.slds-visual-picker--small .slds-visual-picker__figure,
.slds-visual-picker_small .slds-visual-picker__body,
.slds-visual-picker--small .slds-visual-picker__body{
  width:calc(var(--slds-g-sizing-13) - var(--slds-g-sizing-7));
}
.slds-visual-picker_small .slds-visual-picker__figure,.slds-visual-picker--small .slds-visual-picker__figure{
  height:calc(var(--slds-g-sizing-13) - var(--slds-g-sizing-7));
}
.slds-visual-picker__body{
  display:flex;
  flex-direction:column;
  background:transparent;
  padding-block:var(--slds-g-spacing-4);
  padding-inline:var(--slds-g-spacing-2);
  border:0;
  border-radius:0;
}
.slds-visual-picker__text-check{
  position:absolute;
  inset-block-start:0.1rem;
  inset-inline-end:0.625rem;
  width:var(--slds-g-sizing-3);
  height:var(--slds-g-sizing-3);
}
.slds-visual-picker input[disabled] ~ label .slds-visual-picker__text-check{
  opacity:0;
}
.slds-visual-picker_vertical,.slds-visual-picker--vertical{
  width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-14));
  display:flex;
}
.slds-visual-picker_vertical .slds-visual-picker__figure,.slds-visual-picker--vertical .slds-visual-picker__figure{
  text-align:left;
  padding:var(--slds-g-spacing-4);
  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-11));
}
.slds-visual-picker_vertical + .slds-visual-picker_vertical,.slds-visual-picker--vertical + .slds-visual-picker--vertical{
  margin-inline-start:0;
  margin-block-start:var(--slds-g-spacing-4);
}
.slds-visual-picker_vertical .slds-visual-picker__figure,.slds-visual-picker--vertical .slds-visual-picker__figure,
.slds-visual-picker_vertical .slds-visual-picker__body,
.slds-visual-picker--vertical .slds-visual-picker__body{
  width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-14));
}
.slds-rich-text-editor{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-radius:var(--slds-g-radius-border-2);
}
.slds-rich-text-editor[aria-label='disabled']{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-rich-text-editor_toolbar-only,.slds-rich-text-editor--toolbar-only{
  border:0;
  border-radius:0;
}
.slds-rich-text-editor__toolbar{
  display:flex;
  flex-wrap:wrap;
  align-items:flex-start;
  white-space:nowrap;
  position:relative;
  padding-block:var(--slds-g-spacing-2) var(--slds-g-spacing-1);
  padding-inline:var(--slds-g-spacing-2);
  border-start-start-radius:var(--slds-g-radius-border-2);
  border-start-end-radius:var(--slds-g-radius-border-2);
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-rich-text-editor__toolbar .slds-icon{
  --slds-c-icon-color-foreground:currentColor;
}
.slds-rich-text-editor__toolbar[aria-label='disabled']{
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-rich-text-editor__toolbar[aria-label='disabled'] .slds-icon{
  --slds-c-icon-color-foreground:var(--slds-g-color-on-disabled-2);
}
.slds-rich-text-editor__col{
  align-self:center;
}
.slds-rich-text-editor__col + .slds-rich-text-editor__col{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-rich-text-editor__col_grow,.slds-rich-text-editor__col--grow{
  flex-grow:1;
}
.slds-rich-text-editor__toolbar_bottom,.slds-rich-text-editor__toolbar--bottom{
  border-start-start-radius:0;
  border-start-end-radius:0;
  border-end-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:var(--slds-g-radius-border-2);
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-block-end:0;
}
.slds-rich-text-editor__toolbar_detached,.slds-rich-text-editor__toolbar--detached{
  border-radius:0;
  border-block-start:0;
  border-block-end:0;
}
.slds-rich-text-editor .slds-button-group-list{
  margin-inline-end:var(--slds-g-spacing-1);
  margin-block-end:var(--slds-g-spacing-1);
  margin-inline-start:0;
}
.slds-rich-text-editor .slds-button-group-list:last-child{
  margin-inline-end:0;
}
.slds-rich-text-editor__select{
  margin-inline-end:var(--slds-g-spacing-1);
  margin-block-end:var(--slds-g-spacing-1);
}
.slds-rich-text-editor__select_x-small,.slds-rich-text-editor__select--x-small{
  max-width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));
  width:auto;
}
.slds-rich-text-editor__select_xx-small,.slds-rich-text-editor__select--xx-small{
  max-width:calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9));
  width:auto;
}
.slds-region_narrow .slds-combobox,.slds-region--narrow .slds-combobox{
  max-width:11rem;
}
.slds-rich-text-editor.slds-has-focus{
  border-color:var(--slds-g-color-border-2);
  box-shadow:var(--slds-s-input-shadow-focus);
}
.slds-rich-text-editor.slds-has-error{
  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-border-error-1);
}
.slds-rich-text-editor.slds-has-error .slds-input{
  border-color:var(--slds-g-color-border-2);
  box-shadow:none;
}
.slds-rich-text-editor.slds-has-error .slds-form-element__help{
  background:var(--slds-g-color-surface-container-1);
  margin-block-start:0;
  border-start-start-radius:0;
  border-start-end-radius:0;
  border-end-end-radius:var(--slds-g-radius-border-1);
  border-end-start-radius:var(--slds-g-radius-border-1);
}
.slds-rich-text-editor.slds-has-error .slds-button_icon,.slds-rich-text-editor.slds-has-error .slds-button--icon{
  color:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));
}
.slds-rich-text-area__content{
  --_slds-c-richtexteditor-sizing-height-min:var(--slds-c-textarea-sizing-min-height);
  --_slds-c-richtexteditor-sizing-height-max:var(--slds-c-textarea-sizing-max-height);

  overflow-y:auto;
  min-height:var(
    --_slds-c-richtexteditor-sizing-height-min,
    calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9))
  );
  max-height:var(--_slds-c-richtexteditor-sizing-height-max, var(--slds-g-sizing-14));
  padding:var(--slds-g-spacing-4);
  background-color:var(--slds-s-input-color-background, var(--slds-g-color-surface-container-1));
}
.slds-rich-text-editor__output .slds-rich-text-area__content{
  border-start-start-radius:0;
  border-start-end-radius:0;
  border-end-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:var(--slds-g-radius-border-2);
}
.slds-picklist__label[disabled] .slds-icon{
  fill:var(--slds-g-color-on-disabled-1);
}
[contenteditable]:focus{
  outline:none;
}
.slds-rich-text-editor__textarea:last-child .slds-rich-text-area__content{
  border-start-start-radius:0;
  border-start-end-radius:0;
  border-end-end-radius:var(--slds-g-radius-border-2);
  border-end-start-radius:var(--slds-g-radius-border-2);
}
.slds-rich-text-editor__textarea:first-child .slds-rich-text-area__content{
  border-start-start-radius:var(--slds-g-radius-border-2);
  border-start-end-radius:var(--slds-g-radius-border-2);
  border-end-end-radius:0;
  border-end-start-radius:0;
}
.slds-rich-text-editor__textarea .ql-editor{
  white-space:pre-wrap;
  word-wrap:break-word;
  -webkit-user-select:text;
          user-select:text;
}
.slds-rich-text-editor__textarea .ql-editor.ql-blank::before{
  color:var(--slds-g-color-on-surface-1, #54698d);
  content:attr(data-placeholder);
  pointer-events:none;
  position:absolute;
}
.slds-rich-text-editor__textarea .ql-editor a{
  text-decoration:underline;
}
.slds-rich-text-editor__textarea .overflow-menu{
  z-index:2;
}
.slds-rich-text-editor__textarea .ql-active{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-rich-text-editor__textarea .ql-clipboard{
  position:absolute !important;
  margin:-1px !important;
  border:0 !important;
  padding:0 !important;
  width:1px !important;
  height:1px !important;
  overflow:hidden !important;
  clip:rect(0 0 0 0) !important;
}
.slds-rich-text-editor__textarea p,
.slds-rich-text-editor__textarea ol,
.slds-rich-text-editor__textarea ul,
.slds-rich-text-editor__textarea pre,
.slds-rich-text-editor__textarea blockquote,
.slds-rich-text-editor__textarea h1,
.slds-rich-text-editor__textarea h2,
.slds-rich-text-editor__textarea h3,
.slds-rich-text-editor__textarea h4,
.slds-rich-text-editor__textarea h5,
.slds-rich-text-editor__textarea h6{
  counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.slds-rich-text-editor__textarea ol,
.slds-rich-text-editor__textarea ul{
  margin:0;
  padding:0;
  padding-inline-start:1.5em;
}
.slds-rich-text-editor__textarea ol > li{
  list-style-type:none;
}
.slds-rich-text-editor__textarea ul{
}
.slds-rich-text-editor__textarea ul > li{
  list-style-type:none;
}
.slds-rich-text-editor__textarea ul > li::before{
  content:'\\2022';
  vertical-align:middle;
  display:inline-block;
  line-height:normal;
}
.slds-rich-text-editor__textarea ul[data-checked='true'],
.slds-rich-text-editor__textarea ul[data-checked='false']{
  pointer-events:none;
}
.slds-rich-text-editor__textarea ul[data-checked='true'] > li::before{
  color:var(--slds-g-color-on-surface-1);
  cursor:pointer;
  pointer-events:all;
}
.slds-rich-text-editor__textarea ul[data-checked='false'] > li::before{
  color:var(--slds-g-color-on-surface-1);
  cursor:pointer;
  pointer-events:all;
}
.slds-rich-text-editor__textarea ul[data-checked='true'] > li::before{
  content:'\\2611';
}
.slds-rich-text-editor__textarea ul[data-checked='false'] > li::before{
  content:'\\2610';
}
.slds-rich-text-editor__textarea li::before{
  display:inline-block;
  margin-inline-end:0.3em;
  text-align:right;
  white-space:nowrap;
  width:1.2em;
}
.slds-rich-text-editor__textarea li:not(.ql-direction-rtl)::before{
  margin-inline-start:-1.5em;
}
.slds-rich-text-editor__textarea ol li,
.slds-rich-text-editor__textarea ul li{
  padding-inline-start:1.5em;
}
.slds-rich-text-editor__textarea ol li{
  counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment:list-num;
}
.slds-rich-text-editor__textarea ol li::before{
  content:counter(list-num, decimal) '. ';
}
.slds-rich-text-editor__textarea ol li.ql-indent-1{
  counter-increment:list-1;
}
.slds-rich-text-editor__textarea ol li.ql-indent-1::before{
  content:counter(list-1, lower-alpha) '. ';
}
.slds-rich-text-editor__textarea ol li.ql-indent-1{

  counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.slds-rich-text-editor__textarea ol li.ql-indent-2{
  counter-increment:list-2;
}
.slds-rich-text-editor__textarea ol li.ql-indent-2::before{
  content:counter(list-2, lower-roman) '. ';
}
.slds-rich-text-editor__textarea ol li.ql-indent-2{

  counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.slds-rich-text-editor__textarea ol li.ql-indent-3{
  counter-increment:list-3;
}
.slds-rich-text-editor__textarea ol li.ql-indent-3::before{
  content:counter(list-3, decimal) '. ';
}
.slds-rich-text-editor__textarea ol li.ql-indent-3{

  counter-reset:list-4 list-5 list-6 list-7 list-8 list-9;
}
.slds-rich-text-editor__textarea ol li.ql-indent-4{
  counter-increment:list-4;
}
.slds-rich-text-editor__textarea ol li.ql-indent-4::before{
  content:counter(list-4, lower-alpha) '. ';
}
.slds-rich-text-editor__textarea ol li.ql-indent-4{

  counter-reset:list-5 list-6 list-7 list-8 list-9;
}
.slds-rich-text-editor__textarea ol li.ql-indent-5{
  counter-increment:list-5;
}
.slds-rich-text-editor__textarea ol li.ql-indent-5::before{
  content:counter(list-5, lower-roman) '. ';
}
.slds-rich-text-editor__textarea ol li.ql-indent-5{

  counter-reset:list-6 list-7 list-8 list-9;
}
.slds-rich-text-editor__textarea ol li.ql-indent-6{
  counter-increment:list-6;
}
.slds-rich-text-editor__textarea ol li.ql-indent-6::before{
  content:counter(list-6, decimal) '. ';
}
.slds-rich-text-editor__textarea ol li.ql-indent-6{

  counter-reset:list-7 list-8 list-9;
}
.slds-rich-text-editor__textarea ol li.ql-indent-7{
  counter-increment:list-7;
}
.slds-rich-text-editor__textarea ol li.ql-indent-7::before{
  content:counter(list-7, lower-alpha) '. ';
}
.slds-rich-text-editor__textarea ol li.ql-indent-7{

  counter-reset:list-8 list-9;
}
.slds-rich-text-editor__textarea ol li.ql-indent-8{
  counter-increment:list-8;
}
.slds-rich-text-editor__textarea ol li.ql-indent-8::before{
  content:counter(list-8, lower-roman) '. ';
}
.slds-rich-text-editor__textarea ol li.ql-indent-8{

  counter-reset:list-9;
}
.slds-rich-text-editor__textarea ol li.ql-indent-9{
  counter-increment:list-9;
}
.slds-rich-text-editor__textarea ol li.ql-indent-9::before{
  content:counter(list-9, decimal) '. ';
}
.slds-rich-text-editor__textarea ul li.ql-indent-1::before{
  content:'\\25e6';
}
.slds-rich-text-editor__textarea ul li.ql-indent-2::before, .slds-rich-text-editor__textarea ul li.ql-indent-3::before, .slds-rich-text-editor__textarea ul li.ql-indent-4::before, .slds-rich-text-editor__textarea ul li.ql-indent-5::before, .slds-rich-text-editor__textarea ul li.ql-indent-6::before, .slds-rich-text-editor__textarea ul li.ql-indent-7::before, .slds-rich-text-editor__textarea ul li.ql-indent-8::before{
  content:'\\25aa';
}
.slds-rich-text-editor__textarea li.ql-indent-1:not(.ql-direction-rtl){
  padding-inline-start:4.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-1.ql-direction-rtl.ql-align-right{
  padding-inline-end:4.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-2:not(.ql-direction-rtl){
  padding-inline-start:7.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-2.ql-direction-rtl.ql-align-right{
  padding-inline-end:7.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-3:not(.ql-direction-rtl){
  padding-inline-start:10.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-3.ql-direction-rtl.ql-align-right{
  padding-inline-end:10.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-4:not(.ql-direction-rtl){
  padding-inline-start:13.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-4.ql-direction-rtl.ql-align-right{
  padding-inline-end:13.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-5:not(.ql-direction-rtl){
  padding-inline-start:16.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-5.ql-direction-rtl.ql-align-right{
  padding-inline-end:16.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-6:not(.ql-direction-rtl){
  padding-inline-start:19.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-6.ql-direction-rtl.ql-align-right{
  padding-inline-end:19.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-7:not(.ql-direction-rtl){
  padding-inline-start:22.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-7.ql-direction-rtl.ql-align-right{
  padding-inline-end:22.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-8:not(.ql-direction-rtl){
  padding-inline-start:25.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-8.ql-direction-rtl.ql-align-right{
  padding-inline-end:25.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-9:not(.ql-direction-rtl){
  padding-inline-start:28.5em;
}
.slds-rich-text-editor__textarea li.ql-indent-9.ql-direction-rtl.ql-align-right{
  padding-inline-end:28.5em;
}
.slds-rich-text-editor__textarea,
.slds-rich-text-editor__output{
  line-height:var(--slds-g-font-lineheight-base);
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:manual;
}
.slds-rich-text-editor__textarea h1, .slds-rich-text-editor__output h1{
  font-size:var(--slds-g-font-scale-3);
}
.slds-rich-text-editor__textarea h2, .slds-rich-text-editor__output h2{
  font-size:var(--slds-g-font-scale-1);
  font-weight:var(--slds-g-font-weight-6);
}
.slds-rich-text-editor__textarea h3, .slds-rich-text-editor__output h3{
  font-size:var(--slds-g-font-scale-1);
}
.slds-rich-text-editor__textarea h4, .slds-rich-text-editor__output h4{
  font-size:var(--slds-g-font-scale-neg-1);
  font-weight:var(--slds-g-font-weight-6);
}
.slds-rich-text-editor__textarea h5, .slds-rich-text-editor__output h5{
  font-size:var(--slds-g-font-scale-neg-1);
}
.slds-rich-text-editor__textarea h6, .slds-rich-text-editor__output h6{
  font-size:var(--slds-g-font-scale-neg-3);
  font-weight:var(--slds-g-font-weight-6);
}
.slds-rich-text-editor__textarea h1,
.slds-rich-text-editor__textarea h2,
.slds-rich-text-editor__textarea h3,
.slds-rich-text-editor__textarea h4,
.slds-rich-text-editor__textarea h5,
.slds-rich-text-editor__textarea h6,
.slds-rich-text-editor__textarea ul,
.slds-rich-text-editor__textarea ol,
.slds-rich-text-editor__textarea dl,
.slds-rich-text-editor__textarea img,
.slds-rich-text-editor__output h1,
.slds-rich-text-editor__output h2,
.slds-rich-text-editor__output h3,
.slds-rich-text-editor__output h4,
.slds-rich-text-editor__output h5,
.slds-rich-text-editor__output h6,
.slds-rich-text-editor__output ul,
.slds-rich-text-editor__output ol,
.slds-rich-text-editor__output dl,
.slds-rich-text-editor__output img{
  margin-block-end:var(--slds-g-spacing-3);
}
.slds-rich-text-editor__textarea blockquote, .slds-rich-text-editor__output blockquote{
  margin-block:var(--slds-g-spacing-6);
  margin-inline:var(--slds-g-spacing-5);
}
.slds-rich-text-editor__textarea ins, .slds-rich-text-editor__output ins{
  color:var(--slds-g-color-success-1);
  text-decoration:underline;
}
.slds-rich-text-editor__textarea del, .slds-rich-text-editor__output del{
  color:var(--slds-g-color-error-1);
  text-decoration:line-through;
}
.slds-rich-text-editor__textarea ul, .slds-rich-text-editor__output ul{
  margin-inline-start:var(--slds-g-spacing-5);
  list-style:disc;
}
.slds-rich-text-editor__textarea ul ul, .slds-rich-text-editor__output ul ul{
  list-style:circle;
  margin-block-end:0;
}
.slds-rich-text-editor__textarea ul ul ul, .slds-rich-text-editor__output ul ul ul{
  list-style:square;
}
.slds-rich-text-editor__textarea ul ul ul ul, .slds-rich-text-editor__output ul ul ul ul{
  list-style:disc;
}
.slds-rich-text-editor__textarea ul ul ul ul ul, .slds-rich-text-editor__output ul ul ul ul ul{
  list-style:circle;
}
.slds-rich-text-editor__textarea ul ol, .slds-rich-text-editor__output ul ol{
  margin-inline-start:var(--slds-g-spacing-5);
  list-style:decimal;
  margin-block-end:0;
}
.slds-rich-text-editor__textarea ol, .slds-rich-text-editor__output ol{
  margin-inline-start:var(--slds-g-spacing-5);
  list-style:decimal;
}
.slds-rich-text-editor__textarea ol ol, .slds-rich-text-editor__output ol ol{
  list-style:lower-alpha;
  margin-block-end:0;
}
.slds-rich-text-editor__textarea ol ol ol, .slds-rich-text-editor__output ol ol ol{
  list-style:lower-roman;
}
.slds-rich-text-editor__textarea ol ol ol ol, .slds-rich-text-editor__output ol ol ol ol{
  list-style:decimal;
}
.slds-rich-text-editor__textarea ol ol ol ol ol, .slds-rich-text-editor__output ol ol ol ol ol{
  list-style:lower-alpha;
}
.slds-rich-text-editor__textarea ol ul, .slds-rich-text-editor__output ol ul{
  margin-inline-start:var(--slds-g-spacing-5);
  list-style:disc;
  margin-block-end:0;
}
.slds-rich-text-editor__textarea dd, .slds-rich-text-editor__output dd{
  margin-inline-start:2.5rem;
}
.slds-rich-text-editor__textarea abbr[title],
.slds-rich-text-editor__textarea acronym[title],
.slds-rich-text-editor__output abbr[title],
.slds-rich-text-editor__output acronym[title]{
  border-block-end:1px dotted;
  cursor:help;
}
.slds-rich-text-editor__textarea table, .slds-rich-text-editor__output table{
  overflow-wrap:normal;
  word-wrap:normal;
  word-break:normal;
  width:auto;
}
.slds-rich-text-editor__textarea table caption, .slds-rich-text-editor__output table caption{
  text-align:center;
}
.slds-rich-text-editor__textarea th,
.slds-rich-text-editor__textarea td,
.slds-rich-text-editor__output th,
.slds-rich-text-editor__output td{
  padding:var(--slds-g-spacing-2);
}
.slds-rich-text-editor__textarea .sans-serif, .slds-rich-text-editor__output .sans-serif{
  font-family:sans-serif;
}
.slds-rich-text-editor__textarea .courier, .slds-rich-text-editor__output .courier{
  font-family:courier;
}
.slds-rich-text-editor__textarea .verdana, .slds-rich-text-editor__output .verdana{
  font-family:verdana;
}
.slds-rich-text-editor__textarea .tahoma, .slds-rich-text-editor__output .tahoma{
  font-family:tahoma;
}
.slds-rich-text-editor__textarea .garamond, .slds-rich-text-editor__output .garamond{
  font-family:garamond;
}
.slds-rich-text-editor__textarea .serif, .slds-rich-text-editor__output .serif{
  font-family:serif;
}
.slds-rich-text-editor__textarea .ql-indent-1:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-1:not(.ql-direction-rtl){
  padding-inline-start:3em;
}
.slds-rich-text-editor__textarea .ql-indent-1.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-1.ql-direction-rtl.ql-align-right{
  padding-inline-end:3em;
}
.slds-rich-text-editor__textarea .ql-indent-2:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-2:not(.ql-direction-rtl){
  padding-inline-start:6em;
}
.slds-rich-text-editor__textarea .ql-indent-2.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-2.ql-direction-rtl.ql-align-right{
  padding-inline-end:6em;
}
.slds-rich-text-editor__textarea .ql-indent-3:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-3:not(.ql-direction-rtl){
  padding-inline-start:9em;
}
.slds-rich-text-editor__textarea .ql-indent-3.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-3.ql-direction-rtl.ql-align-right{
  padding-inline-end:9em;
}
.slds-rich-text-editor__textarea .ql-indent-4:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-4:not(.ql-direction-rtl){
  padding-inline-start:12em;
}
.slds-rich-text-editor__textarea .ql-indent-4.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-4.ql-direction-rtl.ql-align-right{
  padding-inline-end:12em;
}
.slds-rich-text-editor__textarea .ql-indent-5:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-5:not(.ql-direction-rtl){
  padding-inline-start:15em;
}
.slds-rich-text-editor__textarea .ql-indent-5.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-5.ql-direction-rtl.ql-align-right{
  padding-inline-end:15em;
}
.slds-rich-text-editor__textarea .ql-indent-6:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-6:not(.ql-direction-rtl){
  padding-inline-start:18em;
}
.slds-rich-text-editor__textarea .ql-indent-6.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-6.ql-direction-rtl.ql-align-right{
  padding-inline-end:18em;
}
.slds-rich-text-editor__textarea .ql-indent-7:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-7:not(.ql-direction-rtl){
  padding-inline-start:21em;
}
.slds-rich-text-editor__textarea .ql-indent-7.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-7.ql-direction-rtl.ql-align-right{
  padding-inline-end:21em;
}
.slds-rich-text-editor__textarea .ql-indent-8:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-8:not(.ql-direction-rtl){
  padding-inline-start:24em;
}
.slds-rich-text-editor__textarea .ql-indent-8.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-8.ql-direction-rtl.ql-align-right{
  padding-inline-end:24em;
}
.slds-rich-text-editor__textarea .ql-indent-9:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-9:not(.ql-direction-rtl){
  padding-inline-start:27em;
}
.slds-rich-text-editor__textarea .ql-indent-9.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-9.ql-direction-rtl.ql-align-right{
  padding-inline-end:27em;
}
.slds-path.slds-is-expanded{
  padding-block-end:var(--slds-g-sizing-4);
  border-color:var(--slds-g-color-border-2);
}
.slds-path__track{
  flex-wrap:wrap;
  align-items:flex-start;
}
@media (min-width: 64em){
  .slds-path__track{
    flex-wrap:nowrap;
    align-items:stretch
  }
}
.slds-path__track.slds-has-overflow .slds-path__scroller_inner,.slds-path__track.slds-has-overflow .slds-path__scroller--inner{
  display:flex;
  width:100%;
  overflow:hidden;
}
.slds-path__track.slds-has-overflow .slds-path__scroll-controls{
  display:inline-flex;
  flex-shrink:0;
  padding-inline-start:var(--slds-g-spacing-2);
}
@media (pointer: coarse) and (hover: none){
  .slds-path__track.slds-has-overflow .slds-path__scroll-controls{
    display:none
  }
}
.slds-path__scroller{
  flex:1 1;
  max-width:100%;
  overflow:hidden;
}
.slds-path__scroll-controls{
  display:none;
}
.slds-path__stage-name{
  display:block;
  font-weight:var(--slds-g-font-weight-7);
  margin-block:var(--slds-g-spacing-3);
  margin-inline:0;
}
@media (min-width: 48em){
  .slds-path__stage-name{
    margin:0
  }
}
@media (min-width: 64em){
  .slds-path__stage-name{
    display:none
  }
}
.slds-path__scroller-container{
  flex:1 1;
  flex-basis:100%;
  overflow:hidden;
}
@media (min-width: 64em){
  .slds-path__scroller-container{
    flex-basis:auto
  }
}
@media (min-width: 48em){
  .slds-path_has-coaching .slds-path__action,.slds-path--has-coaching .slds-path__action{
    padding-inline-start:2.75rem
  }
}
@media (min-width: 64em){
  .slds-path_has-coaching .slds-path__action,.slds-path--has-coaching .slds-path__action{
    padding-inline-start:0
  }
}
.slds-path__action{
  flex-grow:1;
  flex-basis:100%;
  margin-inline-start:0;
  align-items:center;
  flex-shrink:0;
  flex-direction:column;
}
.slds-path__action .slds-icon-text-default{
  --slds-c-icon-color-foreground:var(--slds-g-color-on-accent-1);
}
@media (min-width: 48em){
  .slds-path__action{
    justify-content:space-between;
    margin-block-start:var(--slds-g-spacing-4);
    flex-direction:row
  }
}
@media (min-width: 64em){
  .slds-path__action{
    flex-basis:auto;
    flex-grow:0;
    align-items:normal;
    margin-block-start:0;
    margin-inline-start:var(--slds-g-spacing-5)
  }
}
.slds-path__nav{
  display:flex;
  align-items:flex-start;
  overflow:hidden;
}
.slds-path__nav .slds-is-incomplete{
  background:var(--_slds-c-path-item-color-background-incomplete);
}
.slds-path__nav .slds-is-incomplete::before,
.slds-path__nav .slds-is-incomplete::after{
  background:var(--_slds-c-path-item-color-background-incomplete);
}
.slds-path__nav .slds-is-incomplete .slds-path__link{
  color:var(--_slds-c-path-item-color-incomplete);
}
.slds-path__nav .slds-is-incomplete:hover{
  background:var(--_slds-c-path-item-color-background-incomplete-hover);
}
.slds-path__nav .slds-is-incomplete:hover::before,
.slds-path__nav .slds-is-incomplete:hover::after{
  background:var(--_slds-c-path-item-color-background-incomplete-hover);
}
.slds-path__nav .slds-is-complete{
  background:var(--_slds-c-path-item-color-background-complete);
}
.slds-path__nav .slds-is-complete::before,
.slds-path__nav .slds-is-complete::after{
  background:var(--_slds-c-path-item-color-background-complete);
}
.slds-path__nav .slds-is-complete .slds-path__stage{
  transform:translate(-50%, -50%) rotateX(0deg);
}
.slds-path__nav .slds-is-complete .slds-path__stage .slds-icon-text-default{
  --slds-c-icon-color-foreground:var(--slds-g-color-on-success-1);
}
.slds-path__nav .slds-is-complete .slds-path__title{
  transform:rotateX(180deg);
}
.slds-path__nav .slds-is-complete .slds-path__link{
  --slds-c-icon-color-foreground:var(--slds-g-color-on-success-1);

  color:var(--slds-g-color-on-success-1);
}
.slds-path__nav .slds-is-complete:hover{
  background:var(--_slds-c-path-item-color-background-complete-hover);
}
.slds-path__nav .slds-is-complete:hover::before,
.slds-path__nav .slds-is-complete:hover::after{
  background:var(--_slds-c-path-item-color-background-complete-hover);
}
.slds-path__nav .slds-is-complete:hover .slds-path__stage{
  transform:translate(-50%, -50%) rotateX(-180deg);
}
.slds-path__nav .slds-is-complete:hover .slds-path__title{
  transform:rotateX(0deg);
}
.slds-path__nav .slds-is-current{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-path__nav .slds-is-current::before,
.slds-path__nav .slds-is-current::after{
  background-color:var(--slds-g-color-surface-container-1);
  background-image:linear-gradient(
    90deg,
    var(--slds-g-color-brand-base-30),
    var(--slds-g-color-brand-base-30) var(--_slds-c-path-item-sizing-border),
    transparent var(--_slds-c-path-item-sizing-border)
  ), linear-gradient(
    90deg,
    var(--slds-g-color-brand-base-30),
    var(--slds-g-color-brand-base-30) var(--_slds-c-path-item-sizing-border),
    transparent var(--_slds-c-path-item-sizing-border)
  ), linear-gradient(
    var(--slds-g-color-brand-base-30),
    var(--slds-g-color-brand-base-30) var(--_slds-c-path-item-sizing-border),
    transparent var(--_slds-c-path-item-sizing-border)
  );
  background-repeat:no-repeat;
  background-size:var(--_slds-c-path-item-sizing-border) 100%, var(--_slds-c-path-item-sizing-border) 100%, 100% var(--_slds-c-path-item-sizing-border);
}
.slds-path__nav .slds-is-current::before{
  background-position:top right, top left, top left;
}
.slds-path__nav .slds-is-current::after{
  background-position:top right, top left, bottom left;
}
.slds-path__nav .slds-is-current:first-child{
  border:var(--_slds-c-path-item-sizing-border) solid var(--slds-g-color-brand-base-30);
  border-inline-end:0;
}
.slds-path__nav .slds-is-current:first-child::before,
.slds-path__nav .slds-is-current:first-child::after{
  background-color:transparent;
  background-image:linear-gradient(
    90deg,
    var(--slds-g-color-brand-base-30),
    var(--slds-g-color-brand-base-30) var(--_slds-c-path-item-sizing-border),
    transparent var(--_slds-c-path-item-sizing-border)
  );
}
.slds-path__nav .slds-is-current:first-child::before{
  inset-block-start:calc(var(--_slds-c-path-item-sizing-border) * -1);
}
.slds-path__nav .slds-is-current:first-child::after{
  inset-block-end:calc(var(--_slds-c-path-item-sizing-border) * -1);
}
.slds-path__nav .slds-is-current:first-child:hover{
  border-color:var(--slds-g-color-brand-base-20);
}
.slds-path__nav .slds-is-current:first-child:hover::before,
.slds-path__nav .slds-is-current:first-child:hover::after{
  background-image:linear-gradient(
    90deg,
    var(--slds-g-color-brand-base-20),
    var(--slds-g-color-brand-base-20) var(--_slds-c-path-item-sizing-border),
    transparent var(--_slds-c-path-item-sizing-border)
  );
}
.slds-path__nav .slds-is-current:first-child .slds-path__link{
  height:var(--_slds-c-path-item-sizing-height);
}
.slds-path__nav .slds-is-current .slds-path__link{
  color:var(--slds-g-color-brand-base-20);
}
.slds-path__nav .slds-is-current:hover::before,
.slds-path__nav .slds-is-current:hover::after{
  background-image:linear-gradient(
    90deg,
    var(--slds-g-color-brand-base-20),
    var(--slds-g-color-brand-base-20) 0.125rem,
    transparent 0.125rem
  ), linear-gradient(
    90deg,
    var(--slds-g-color-brand-base-20),
    var(--slds-g-color-brand-base-20) 0.125rem,
    transparent 0.125rem
  ), linear-gradient(
    var(--slds-g-color-brand-base-20),
    var(--slds-g-color-brand-base-20) 0.125rem,
    transparent 0.125rem
  );
}
.slds-path__nav .slds-is-current:hover .slds-path__link{
  color:var(--slds-g-color-brand-base-20);
}
.slds-path__nav .slds-is-active{
  background:var(--_slds-c-path-item-color-background-active);
}
.slds-path__nav .slds-is-active::before,
.slds-path__nav .slds-is-active::after{
  background:var(--_slds-c-path-item-color-background-active);
}
.slds-path__nav .slds-is-active:first-child{
  border:0;
}
.slds-path__nav .slds-is-active:first-child::before,
.slds-path__nav .slds-is-active:first-child::after{
  background:var(--_slds-c-path-item-color-background-active);
}
.slds-path__nav .slds-is-active:first-child::before{
  inset-block-start:0;
}
.slds-path__nav .slds-is-active:first-child::after{
  inset-block-end:0;
}
.slds-path__nav .slds-is-active:first-child .slds-path__link{
  height:2rem;
}
.slds-path__nav .slds-is-active .slds-path__stage{
  transform:translateY(-50%) rotateX(-180deg);
}
.slds-path__nav .slds-is-active .slds-path__title{
  transform:rotateX(0deg);
}
.slds-path__nav .slds-is-active .slds-path__link{
  color:var(--slds-g-color-on-accent-1);
}
.slds-path__nav .slds-is-active:hover{
  background:var(--_slds-c-path-item-color-background-active-hover);
}
.slds-path__nav .slds-is-active:hover::before,
.slds-path__nav .slds-is-active:hover::after{
  background:var(--_slds-c-path-item-color-background-active-hover);
}
.slds-path__nav .slds-is-active:hover .slds-path__link{
  color:var(--slds-g-color-on-accent-1);
}
.slds-path__nav .slds-is-lost{
  background:var(--_slds-c-path-item-color-background-error);
}
.slds-path__nav .slds-is-lost::before,
.slds-path__nav .slds-is-lost::after,
.slds-path__nav .slds-is-lost:hover,
.slds-path__nav .slds-is-lost:hover::before,
.slds-path__nav .slds-is-lost:hover::after{
  background:var(--_slds-c-path-item-color-background-error);
}
.slds-path__nav .slds-is-lost .slds-path__link{
  color:var(--slds-g-color-on-error-1);
}
.slds-path__nav .slds-is-lost:hover .slds-path__link{
  color:var(--slds-g-color-on-error-1);
}
.slds-path__nav .slds-is-won{
  background:var(--_slds-c-path-item-color-background-success);
}
.slds-path__nav .slds-is-won::before,
.slds-path__nav .slds-is-won::after,
.slds-path__nav .slds-is-won:hover,
.slds-path__nav .slds-is-won:hover::before,
.slds-path__nav .slds-is-won:hover::after{
  background:var(--_slds-c-path-item-color-background-success);
}
.slds-path__nav .slds-is-won .slds-path__link{
  color:var(--slds-g-color-on-success-1);
}
.slds-path__nav .slds-is-won:hover .slds-path__link{
  color:var(--slds-g-color-on-success-1);
}
.slds-path.slds-is-won .slds-path__item.slds-is-current{
  background:var(--_slds-c-path-item-color-background-success);
}
.slds-path.slds-is-won .slds-path__item.slds-is-current::before,
.slds-path.slds-is-won .slds-path__item.slds-is-current::after,
.slds-path.slds-is-won .slds-path__item.slds-is-current:hover,
.slds-path.slds-is-won .slds-path__item.slds-is-current:hover::before,
.slds-path.slds-is-won .slds-path__item.slds-is-current:hover::after{
  background:var(--_slds-c-path-item-color-background-success);
}
.slds-path.slds-is-lost .slds-path__item.slds-is-current{
  background:var(--slds-g-color-error-base-50);
}
.slds-path.slds-is-lost .slds-path__item.slds-is-current::before,
.slds-path.slds-is-lost .slds-path__item.slds-is-current::after,
.slds-path.slds-is-lost .slds-path__item.slds-is-current:hover,
.slds-path.slds-is-lost .slds-path__item.slds-is-current:hover::before,
.slds-path.slds-is-lost .slds-path__item.slds-is-current:hover::after{
  background:var(--slds-g-color-error-base-50);
}
.slds-path__item{
  position:relative;
  flex:1 1;
  margin-inline-start:0.375rem;
  margin-inline-end:0.4375rem;
  min-width:5rem;
  text-align:center;
}
.slds-path__item::before,
.slds-path__item::after{
  content:'';
  position:absolute;
  inset-inline-start:-0.25rem;
  inset-inline-end:-0.3125rem;
  cursor:pointer;
}
.slds-path__item::before{
  inset-block-start:0;
  height:1.0313rem;
  transform:skew(28deg) translate3d(0, 0, 0);
}
.slds-path__item::after{
  inset-block-end:0;
  height:1rem;
  transform:skew(-30deg) translate3d(0, 0, 0);
}
.slds-path__item:first-child{
  margin-inline-start:0;
  border-start-start-radius:2rem;
  border-end-start-radius:2rem;
  padding-inline-start:0.625rem;
}
.slds-path__item:first-child::before,
.slds-path__item:first-child::after{
  inset-inline-start:1.125rem;
}
.slds-path__item:last-child{
  margin-inline-end:0;
  border-start-end-radius:2rem;
  border-end-end-radius:2rem;
  padding-inline-end:0.625rem;
}
.slds-path__item:last-child .slds-path__link{
  padding-inline-start:var(--slds-g-spacing-1);
}
.slds-path__item:last-child::before,
.slds-path__item:last-child::after{
  inset-inline-end:0.625rem;
}
[dir='rtl'] .slds-path__item::before{
  transform:skew(-30deg) translate3d(0, 0, 0);
}
[dir='rtl'] .slds-path__item::after{
  transform:skew(28deg) translate3d(0, 0, 0);
}
.slds-path__item .slds-icon_container,.slds-path__item .slds-icon--container{
  display:flex;
}
.slds-path__title{
  max-width:100%;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  transform:translate3d(0, 0, 0);
}
.slds-path__stage{
  position:absolute;
  inset-block-start:50%;
  /*! @noflip */
  left:50%;
  transform:translate(-50%, -50%) rotateX(-180deg);
}
.slds-path__link{
  position:relative;
  display:flex;
  justify-content:center;
  align-items:center;
  height:2rem;
  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-1) var(--slds-g-spacing-2) var(--slds-g-spacing-2);
  text-decoration:none;
  z-index:5;
  cursor:pointer;
}
.slds-path__link:hover{
  text-decoration:none;
}
.slds-path__link:focus{
  outline:0;
}
.slds-path__title,
.slds-path__stage{
  display:block;
  transition:transform 0.2s linear;
  backface-visibility:hidden;
}
.slds-path .slds-path__trigger{
  margin-inline-end:var(--slds-g-spacing-3);
  transition:0.4s transform ease-in-out;
  display:none;
}
@media (min-width: 48em){
  .slds-path .slds-path__trigger{
    display:block
  }
}
.slds-path__trigger_open,.slds-path__trigger--open{
  transform:rotate(90deg);
}
[dir='rtl'] .slds-path__trigger_open,[dir='rtl'] .slds-path__trigger--open{
  transform:rotate(-90deg);
}
.slds-path .slds-path__mark-complete{
  --slds-c-button-sizing-border:0;

  width:100%;
  min-width:13rem;
  margin-inline-end:0;
  justify-content:center;
}
@media (min-width: 48em){
  .slds-path .slds-path__mark-complete{
    width:auto
  }
}
.slds-path__mark-current{
  border-color:var(--slds-g-color-border-accent-2);
  background-color:var(--slds-g-color-accent-container-1);
}
.slds-path__mark-current:hover,
.slds-path__mark-current:focus{
  background-color:var(--slds-g-color-accent-container-3);
}
.slds-path__guidance{
  margin-inline-end:var(--slds-g-spacing-2);
  padding-block-end:var(--slds-g-spacing-1);
  background-color:var(--slds-g-color-surface-container-1);
}
@media (min-width: 48em){
  .slds-path__guidance{
    margin-block-start:0
  }
}
.slds-path__keys,
.slds-path__guidance{
  flex:1 1 100%;
  margin-block-start:var(--slds-g-spacing-4);
  padding-inline-start:0;
  padding-inline-end:0;
}
@media (min-width: 48em){
  .slds-path__keys,
  .slds-path__guidance{
    flex-basis:50%
  }
}
@media (min-width: 48em){
  .slds-path__keys{
    padding-inline-end:var(--slds-g-spacing-3)
  }
}
.slds-path__coach{
  flex-wrap:wrap;
  align-items:flex-start;
}
@media (min-width: 48em){
  .slds-path__coach{
    flex-wrap:nowrap;
    align-items:stretch
  }
}
.slds-path__coach-title{
  font-size:var(--slds-g-font-scale-neg-1);
  font-weight:var(--slds-g-font-weight-7);
  margin-block-end:var(--slds-g-spacing-2);
  padding-block-end:var(--slds-g-spacing-2);
  line-height:1.125;
}
.slds-path__coach-edit{
  border:0;
  padding:0;
  line-height:inherit;
}
.slds-path__guidance-content{
  padding-block-start:var(--slds-g-spacing-1);
}
.slds-path__trigger-coaching-content{
  width:100%;
  margin-block-start:var(--slds-g-spacing-3);
}
@media (min-width: 48em){
  .slds-path__trigger-coaching-content{
    display:none
  }
}
.slds-path .slds-path__trigger-coaching-content{
  margin-inline-start:0;
}
.slds-region_medium .slds-path_has-coaching .slds-path__action,.slds-region--medium .slds-path--has-coaching .slds-path__action{
  padding-inline-start:2.75rem;
}
.slds-region_medium .slds-path__scroller-container,.slds-region--medium .slds-path__scroller-container{
  flex-basis:100%;
}
.slds-region_medium .slds-path__track,.slds-region--medium .slds-path__track{
  flex-wrap:wrap;
  align-items:flex-start;
}
.slds-region_medium .slds-path__action,.slds-region--medium .slds-path__action{
  flex-grow:1;
  flex-basis:100%;
  margin-inline-start:0;
  align-items:center;
  justify-content:space-between;
  margin-block-start:var(--slds-g-spacing-4);
  flex-direction:row;
}
.slds-region_medium .slds-path__stage-name,.slds-region--medium .slds-path__stage-name,
.slds-region_medium .slds-path__trigger,
.slds-region--medium .slds-path__trigger{
  display:block;
}
.slds-region_medium .slds-path__stage-name,.slds-region--medium .slds-path__stage-name{
  margin:0;
}
.slds-region_medium .slds-path__trigger-coaching-content,.slds-region--medium .slds-path__trigger-coaching-content{
  display:none;
}
.slds-region_medium .slds-path__mark-complete,.slds-region--medium .slds-path__mark-complete{
  width:auto;
}
.slds-region_medium .slds-path__coach,.slds-region--medium .slds-path__coach{
  justify-content:space-between;
  margin-block-start:var(--slds-g-spacing-4);
  flex-direction:row;
}
.slds-region_medium .slds-path__keys,.slds-region--medium .slds-path__keys,
.slds-region_medium .slds-path__guidance,
.slds-region--medium .slds-path__guidance{
  flex-basis:50%;
}
.slds-region_medium .slds-path__keys,.slds-region--medium .slds-path__keys{
  padding-inline-end:var(--slds-g-spacing-3);
}
.slds-region_small .slds-path__scroller-container,.slds-region--small .slds-path__scroller-container{
  flex-basis:100%;
}
.slds-region_small .slds-path__track,.slds-region--small .slds-path__track,
.slds-region_small .slds-path__coach,
.slds-region--small .slds-path__coach{
  flex-wrap:wrap;
  align-items:flex-start;
}
.slds-region_small .slds-path__stage-name,.slds-region--small .slds-path__stage-name{
  display:block;
  margin:var(--slds-g-spacing-3) 0;
}
.slds-region_small .slds-path__action,.slds-region--small .slds-path__action{
  flex-grow:1;
  flex-basis:100%;
  margin-inline-start:0;
  align-items:center;
  flex-direction:column;
  margin-block-start:0;
}
.slds-region_small .slds-path_has-coaching .slds-path__action,.slds-region--small .slds-path--has-coaching .slds-path__action{
  padding-inline-start:0;
}
.slds-region_small .slds-path__mark-complete,.slds-region--small .slds-path__mark-complete{
  width:100%;
}
.slds-region_small .slds-path__keys,.slds-region--small .slds-path__keys,
.slds-region_small .slds-path__guidance,
.slds-region--small .slds-path__guidance{
  flex-basis:100%;
  padding-inline-start:0;
  padding-inline-end:0;
}
.slds-region_small .slds-path__guidance,.slds-region--small .slds-path__guidance{
  margin-block-start:var(--slds-g-spacing-3);
}
.slds-region_small .slds-path__trigger,.slds-region--small .slds-path__trigger{
  display:none;
}
.slds-region_small .slds-path__trigger-coaching-content,.slds-region--small .slds-path__trigger-coaching-content{
  display:inline-block;
}
.slds-spinner_container,.slds-spinner--container{
  position:absolute;
  inset-block-start:0;
  inset-inline-end:0;
  inset-block-end:0;
  inset-inline-start:0;
  z-index:9050;
  background-color:rgba(255, 255, 255, 0.75);
  visibility:visible;
  opacity:1;
  transition:opacity 0.2s ease, visibility 0s;
  transition-delay:0s, 0.3s;
}
.slds-spinner_container.is-hidden,.slds-spinner--container.is-hidden{
  visibility:hidden;
  opacity:0;
  transition:opacity 0.2s ease, visibility 0s;
  transition-delay:0s, 0s;
}
.slds-spinner_container.hide,.slds-spinner--container.hide{
  display:none;
}
.slds-spinner{
  position:absolute;
  inset-block-start:50%;

  /*! @noflip */
  left:50%;
  z-index:9051;
  transform:translate(-50%, -50%) rotate(90deg);
}
.slds-spinner_inline,.slds-spinner--inline{
  position:relative;
  inset-block-start:auto;
  inset-inline-start:auto;
  inset-inline-end:auto;
  inset-block-end:auto;
  transform:none;
}
.slds-spinner,
.slds-spinner__dot-a,
.slds-spinner__dot-b{
  transform-origin:50% 50%;
  will-change:transform;
}
.slds-spinner__dot-a,
.slds-spinner__dot-b{
  position:absolute;
  inset-block-start:0;
  inset-inline-start:0;
  width:100%;
}
.slds-spinner::before,
.slds-spinner::after,
.slds-spinner__dot-a::before,
.slds-spinner__dot-b::before,
.slds-spinner__dot-a::after,
.slds-spinner__dot-b::after{
  content:'';
  position:absolute;
  background:var(--slds-g-color-neutral-base-50);
  border-radius:var(--slds-g-radius-border-circle);
  animation-duration:1000ms;
  animation-iteration-count:infinite;
  transform:translate3d(0, 0, 0);
}
.slds-spinner__dot-a{
  transform:rotate(60deg);
}
.slds-spinner__dot-b{
  transform:rotate(120deg);
}
.slds-spinner::before{
  animation-delay:-83.3333ms;
}
.slds-spinner__dot-a::before{
  animation-delay:83.3333ms;
}
.slds-spinner__dot-b::before{
  animation-delay:250ms;
}
.slds-spinner::after{
  animation-delay:416.6666ms;
}
.slds-spinner__dot-a::after{
  animation-delay:583.3333ms;
}
.slds-spinner__dot-b::after{
  animation-delay:750ms;
}
.slds-spinner_delayed::before,.slds-spinner--delayed::before{
  animation-delay:216.6666ms;
}
.slds-spinner_delayed .slds-spinner__dot-a::before,.slds-spinner--delayed .slds-spinner__dot-a::before{
  animation-delay:383.3333ms;
}
.slds-spinner_delayed .slds-spinner__dot-b::before,.slds-spinner--delayed .slds-spinner__dot-b::before{
  animation-delay:550ms;
}
.slds-spinner_delayed::after,.slds-spinner--delayed::after{
  animation-delay:716.6666ms;
}
.slds-spinner_delayed .slds-spinner__dot-a::after,.slds-spinner--delayed .slds-spinner__dot-a::after{
  animation-delay:883.3333ms;
}
.slds-spinner_delayed .slds-spinner__dot-b::after,.slds-spinner--delayed .slds-spinner__dot-b::after{
  animation-delay:1050ms;
}
.slds-spinner_brand.slds-spinner::before,.slds-spinner--brand.slds-spinner::before,
.slds-spinner_brand.slds-spinner::after,
.slds-spinner--brand.slds-spinner::after,
.slds-spinner_brand .slds-spinner__dot-a::before,
.slds-spinner--brand .slds-spinner__dot-a::before,
.slds-spinner_brand .slds-spinner__dot-b::before,
.slds-spinner--brand .slds-spinner__dot-b::before,
.slds-spinner_brand .slds-spinner__dot-a::after,
.slds-spinner--brand .slds-spinner__dot-a::after,
.slds-spinner_brand .slds-spinner__dot-b::after,
.slds-spinner--brand .slds-spinner__dot-b::after{
  background-color:var(--slds-g-color-accent-1);
}
.slds-spinner_inverse.slds-spinner::before,.slds-spinner--inverse.slds-spinner::before,
.slds-spinner_inverse.slds-spinner::after,
.slds-spinner--inverse.slds-spinner::after,
.slds-spinner_inverse .slds-spinner__dot-a::before,
.slds-spinner--inverse .slds-spinner__dot-a::before,
.slds-spinner_inverse .slds-spinner__dot-b::before,
.slds-spinner--inverse .slds-spinner__dot-b::before,
.slds-spinner_inverse .slds-spinner__dot-a::after,
.slds-spinner--inverse .slds-spinner__dot-a::after,
.slds-spinner_inverse .slds-spinner__dot-b::after,
.slds-spinner--inverse .slds-spinner__dot-b::after{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-spinner_xx-small,.slds-spinner--xx-small{
  width:var(--slds-g-sizing-3);
}
.slds-spinner_xx-small.slds-spinner_inline,.slds-spinner--xx-small.slds-spinner--inline{
  height:var(--slds-g-sizing-3);
}
.slds-spinner_xx-small.slds-spinner::before,.slds-spinner--xx-small.slds-spinner::before,
.slds-spinner_xx-small.slds-spinner::after,
.slds-spinner--xx-small.slds-spinner::after,
.slds-spinner_xx-small .slds-spinner__dot-a::before,
.slds-spinner--xx-small .slds-spinner__dot-a::before,
.slds-spinner_xx-small .slds-spinner__dot-b::before,
.slds-spinner--xx-small .slds-spinner__dot-b::before,
.slds-spinner_xx-small .slds-spinner__dot-a::after,
.slds-spinner--xx-small .slds-spinner__dot-a::after,
.slds-spinner_xx-small .slds-spinner__dot-b::after,
.slds-spinner--xx-small .slds-spinner__dot-b::after{
  width:0.125rem;
  height:0.125rem;
}
.slds-spinner_xx-small.slds-spinner::before,.slds-spinner--xx-small.slds-spinner::before,
.slds-spinner_xx-small .slds-spinner__dot-a::before,
.slds-spinner--xx-small .slds-spinner__dot-a::before,
.slds-spinner_xx-small .slds-spinner__dot-b::before,
.slds-spinner--xx-small .slds-spinner__dot-b::before{
  inset-block-start:-0.0625rem;
  inset-inline-start:-0.0625rem;
  animation-name:dotsBounceBefore-extraExtraSmall;
}
.slds-spinner_xx-small.slds-spinner::after,.slds-spinner--xx-small.slds-spinner::after,
.slds-spinner_xx-small .slds-spinner__dot-a::after,
.slds-spinner--xx-small .slds-spinner__dot-a::after,
.slds-spinner_xx-small .slds-spinner__dot-b::after,
.slds-spinner--xx-small .slds-spinner__dot-b::after{
  inset-block-start:-0.0625rem;
  inset-inline-end:-0.0625rem;
  animation-name:dotsBounceAfter-extraExtraSmall;
}
@keyframes dotsBounceBefore-extraExtraSmall{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    transform:translate3d(0, 0, 0);
    animation-timing-function:cubic-bezier(0.275, 0.0425, 0.34, 0.265);
  }

  80%{
    transform:translate3d(-0.125rem, 0, 0);
    animation-timing-function:cubic-bezier(0, 0.555, 0.35, 0.715);
  }

  100%{
    transform:translate3d(0, 0, 0);
  }
}
@keyframes dotsBounceAfter-extraExtraSmall{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    animation-timing-function:cubic-bezier(0.275, 0.0425, 0.34, 0.265);
    transform:translate3d(0, 0, 0);
  }

  80%{
    animation-timing-function:cubic-bezier(0, 0.555, 0.35, 0.715);
    transform:translate3d(0.125rem, 0, 0);
  }

  100%{
    transform:translate3d(0, 0, 0);
  }
}
.slds-spinner_x-small,.slds-spinner--x-small{
  width:var(--slds-g-sizing-5);
}
.slds-spinner_x-small.slds-spinner_inline,.slds-spinner--x-small.slds-spinner--inline{
  height:var(--slds-g-sizing-5);
}
.slds-spinner_x-small.slds-spinner::before,.slds-spinner--x-small.slds-spinner::before,
.slds-spinner_x-small.slds-spinner::after,
.slds-spinner--x-small.slds-spinner::after,
.slds-spinner_x-small .slds-spinner__dot-a::before,
.slds-spinner--x-small .slds-spinner__dot-a::before,
.slds-spinner_x-small .slds-spinner__dot-b::before,
.slds-spinner--x-small .slds-spinner__dot-b::before,
.slds-spinner_x-small .slds-spinner__dot-a::after,
.slds-spinner--x-small .slds-spinner__dot-a::after,
.slds-spinner_x-small .slds-spinner__dot-b::after,
.slds-spinner--x-small .slds-spinner__dot-b::after{
  width:var(--slds-g-sizing-2);
  height:var(--slds-g-sizing-2);
}
.slds-spinner_x-small.slds-spinner::before,.slds-spinner--x-small.slds-spinner::before,
.slds-spinner_x-small .slds-spinner__dot-a::before,
.slds-spinner--x-small .slds-spinner__dot-a::before,
.slds-spinner_x-small .slds-spinner__dot-b::before,
.slds-spinner--x-small .slds-spinner__dot-b::before{
  inset-block-start:-0.125rem;
  inset-inline-start:-0.125rem;
  animation-name:dotsBounceBefore-extraSmall;
}
.slds-spinner_x-small.slds-spinner::after,.slds-spinner--x-small.slds-spinner::after,
.slds-spinner_x-small .slds-spinner__dot-a::after,
.slds-spinner--x-small .slds-spinner__dot-a::after,
.slds-spinner_x-small .slds-spinner__dot-b::after,
.slds-spinner--x-small .slds-spinner__dot-b::after{
  inset-block-start:-0.125rem;
  inset-inline-end:-0.125rem;
  animation-name:dotsBounceAfter-extraSmall;
}
@keyframes dotsBounceBefore-extraSmall{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    transform:translate3d(0, 0, 0);
    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  80%{
    transform:translate3d(-0.25rem, 0, 0);
    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);
  }

  100%{
    transform:translate3d(0, 0, 0);
  }
}
@keyframes dotsBounceAfter-extraSmall{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    transform:translate3d(0, 0, 0);
    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  80%{
    transform:translate3d(0.25rem, 0, 0);
    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);
  }

  100%{
    transform:translate3d(0, 0, 0);
  }
}
.slds-spinner_small,.slds-spinner--small{
  width:var(--slds-g-sizing-6);
}
.slds-spinner_small.slds-spinner_inline,.slds-spinner--small.slds-spinner--inline{
  height:var(--slds-g-sizing-6);
}
.slds-spinner_small.slds-spinner::before,.slds-spinner--small.slds-spinner::before,
.slds-spinner_small.slds-spinner::after,
.slds-spinner--small.slds-spinner::after,
.slds-spinner_small .slds-spinner__dot-a::before,
.slds-spinner--small .slds-spinner__dot-a::before,
.slds-spinner_small .slds-spinner__dot-b::before,
.slds-spinner--small .slds-spinner__dot-b::before,
.slds-spinner_small .slds-spinner__dot-a::after,
.slds-spinner--small .slds-spinner__dot-a::after,
.slds-spinner_small .slds-spinner__dot-b::after,
.slds-spinner--small .slds-spinner__dot-b::after{
  width:var(--slds-g-sizing-2);
  height:var(--slds-g-sizing-2);
}
.slds-spinner_small.slds-spinner::before,.slds-spinner--small.slds-spinner::before,
.slds-spinner_small .slds-spinner__dot-a::before,
.slds-spinner--small .slds-spinner__dot-a::before,
.slds-spinner_small .slds-spinner__dot-b::before,
.slds-spinner--small .slds-spinner__dot-b::before{
  inset-block-start:-0.125rem;
  inset-inline-start:-0.125rem;
  animation-name:dotsBounceBefore-small;
}
.slds-spinner_small.slds-spinner::after,.slds-spinner--small.slds-spinner::after,
.slds-spinner_small .slds-spinner__dot-a::after,
.slds-spinner--small .slds-spinner__dot-a::after,
.slds-spinner_small .slds-spinner__dot-b::after,
.slds-spinner--small .slds-spinner__dot-b::after{
  inset-block-start:-0.125rem;
  inset-inline-end:-0.125rem;
  animation-name:dotsBounceAfter-small;
}
@keyframes dotsBounceBefore-small{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    transform:translate3d(0, 0, 0);
    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  80%{
    transform:translate3d(-0.375rem, 0, 0);
    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);
  }

  100%{
    transform:translate3d(0, 0, 0);
  }
}
@keyframes dotsBounceAfter-small{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    transform:translate3d(0, 0, 0);
    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  80%{
    transform:translate3d(0.375rem, 0, 0);
    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);
  }

  100%{
    transform:translateX(0);
  }
}
.slds-spinner_medium,.slds-spinner--medium{
  width:var(--slds-g-sizing-9);
}
.slds-spinner_medium.slds-spinner_inline,.slds-spinner--medium.slds-spinner--inline{
  height:var(--slds-g-sizing-9);
}
.slds-spinner_medium.slds-spinner::before,.slds-spinner--medium.slds-spinner::before,
.slds-spinner_medium.slds-spinner::after,
.slds-spinner--medium.slds-spinner::after,
.slds-spinner_medium .slds-spinner__dot-a::before,
.slds-spinner--medium .slds-spinner__dot-a::before,
.slds-spinner_medium .slds-spinner__dot-b::before,
.slds-spinner--medium .slds-spinner__dot-b::before,
.slds-spinner_medium .slds-spinner__dot-a::after,
.slds-spinner--medium .slds-spinner__dot-a::after,
.slds-spinner_medium .slds-spinner__dot-b::after,
.slds-spinner--medium .slds-spinner__dot-b::after{
  width:var(--slds-g-sizing-3);
  height:var(--slds-g-sizing-3);
}
.slds-spinner_medium.slds-spinner::before,.slds-spinner--medium.slds-spinner::before,
.slds-spinner_medium .slds-spinner__dot-a::before,
.slds-spinner--medium .slds-spinner__dot-a::before,
.slds-spinner_medium .slds-spinner__dot-b::before,
.slds-spinner--medium .slds-spinner__dot-b::before{
  animation-name:dotsBounceBefore-medium;
  inset-block-start:-0.25rem;
  inset-inline-start:-0.25rem;
}
.slds-spinner_medium.slds-spinner::after,.slds-spinner--medium.slds-spinner::after,
.slds-spinner_medium .slds-spinner__dot-a::after,
.slds-spinner--medium .slds-spinner__dot-a::after,
.slds-spinner_medium .slds-spinner__dot-b::after,
.slds-spinner--medium .slds-spinner__dot-b::after{
  animation-name:dotsBounceAfter-medium;
  inset-block-start:-0.25rem;
  inset-inline-end:-0.25rem;
}
@keyframes dotsBounceBefore-medium{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    transform:translate3d(0, 0, 0);
    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  80%{
    transform:translate3d(-0.5rem, 0, 0);
    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);
  }

  100%{
    transform:translate3d(0, 0, 0);
  }
}
@keyframes dotsBounceAfter-medium{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    transform:translate3d(0, 0, 0);
    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  80%{
    transform:translate3d(0.5rem, 0, 0);
    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);
  }

  100%{
    transform:translateX(0);
  }
}
.slds-spinner_large,.slds-spinner--large{
  width:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-4));
}
.slds-spinner_large.slds-spinner_inline,.slds-spinner--large.slds-spinner--inline{
  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-4));
}
.slds-spinner_large.slds-spinner::before,.slds-spinner--large.slds-spinner::before,
.slds-spinner_large.slds-spinner::after,
.slds-spinner--large.slds-spinner::after,
.slds-spinner_large .slds-spinner__dot-a::before,
.slds-spinner--large .slds-spinner__dot-a::before,
.slds-spinner_large .slds-spinner__dot-b::before,
.slds-spinner--large .slds-spinner__dot-b::before,
.slds-spinner_large .slds-spinner__dot-a::after,
.slds-spinner--large .slds-spinner__dot-a::after,
.slds-spinner_large .slds-spinner__dot-b::after,
.slds-spinner--large .slds-spinner__dot-b::after{
  width:calc(var(--slds-g-sizing-3) + var(--slds-g-sizing-1));
  height:calc(var(--slds-g-sizing-3) + var(--slds-g-sizing-1));
}
.slds-spinner_large.slds-spinner::before,.slds-spinner--large.slds-spinner::before,
.slds-spinner_large .slds-spinner__dot-a::before,
.slds-spinner--large .slds-spinner__dot-a::before,
.slds-spinner_large .slds-spinner__dot-b::before,
.slds-spinner--large .slds-spinner__dot-b::before{
  animation-name:dotsBounceBefore-medium;
  inset-block-start:-0.3125rem;
  inset-inline-start:-0.3125rem;
}
.slds-spinner_large.slds-spinner::after,.slds-spinner--large.slds-spinner::after,
.slds-spinner_large .slds-spinner__dot-a::after,
.slds-spinner--large .slds-spinner__dot-a::after,
.slds-spinner_large .slds-spinner__dot-b::after,
.slds-spinner--large .slds-spinner__dot-b::after{
  animation-name:dotsBounceAfter-medium;
  inset-block-start:-0.3125rem;
  inset-inline-end:-0.3125rem;
}
@keyframes dotsBounceBefore-large{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    transform:translate3d(0, 0, 0);
    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  80%{
    transform:translate3d(-0.75rem, 0, 0);
    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);
  }

  100%{
    transform:translateX(0);
  }
}
@keyframes dotsBounceAfter-large{
  0%{
    transform:translate3d(0, 0, 0);
  }

  60%{
    transform:translate3d(0, 0, 0);
    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);
  }

  80%{
    transform:translate3d(0.75rem, 0, 0);
    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);
  }

  100%{
    transform:translateX(0);
  }
}
.slds-split-view_container,.slds-split-view--container{
  position:relative;
  display:flex;
  flex-direction:column;
  min-width:0;
  height:100%;
}
.slds-split-view_container.slds-is-closed .slds-split-view,.slds-split-view--container.slds-is-closed .slds-split-view{
  display:none;
}
.slds-split-view_container.slds-is-closed .slds-split-view__toggle-button .slds-button__icon,.slds-split-view--container.slds-is-closed .slds-split-view__toggle-button .slds-button__icon{
  transform:rotate(180deg);
}
.slds-split-view_container.slds-is-open,.slds-split-view--container.slds-is-open{
  flex:1 1 auto;
}
.slds-split-view_container.slds-is-open .slds-split-view,.slds-split-view--container.slds-is-open .slds-split-view{
  display:inherit;
}
.slds-split-view_container.slds-is-open .slds-split-view__toggle-button .slds-button__icon,.slds-split-view--container.slds-is-open .slds-split-view__toggle-button .slds-button__icon{
  transform:rotate(0);
}
.slds-split-view{
  background:var(--slds-g-color-surface-2);
  color:var(--slds-g-color-on-surface-1);
}
.slds-split-view__header{
  padding-block-start:var(--slds-g-spacing-4);
  padding-block-end:var(--slds-g-spacing-2);
  padding-inline-start:var(--slds-g-spacing-5);
  padding-inline-end:var(--slds-g-spacing-4);
}
.slds-split-view__list-header{
  font-size:var(--slds-g-font-scale-1);
  font-weight:var(--slds-g-font-weight-7);
  line-height:var(--slds-g-font-lineheight-2);
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  padding-block:var(--slds-g-spacing-2);
  padding-inline-start:var(--slds-g-spacing-5);
  padding-inline-end:var(--slds-g-spacing-4);
}
.slds-split-view__list-item{
  display:flex;
  position:relative;
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  font-size:var(--slds-g-font-scale-neg-1);
}
.slds-split-view__list-item:hover,
.slds-split-view__list-item:focus{
  background:var(--slds-g-color-surface-container-1);
}
.slds-split-view__list-item .slds-indicator_unread,.slds-split-view__list-item .slds-indicator--unread,
.slds-split-view__list-item .slds-indicator--unread{
  background:var(--slds-g-color-accent-1);
}
.slds-indicator_unread,.slds-indicator--unread{
  width:8px;
  height:8px;
  position:absolute;
  inset-block-start:var(--slds-g-spacing-4);
  inset-inline-start:var(--slds-g-spacing-2);
  display:block;
  border-radius:var(--slds-g-radius-border-circle);
  background:var(--slds-g-color-error-1);
}
.slds-split-view__list-item-action{
  color:currentColor;
  padding-block-start:var(--slds-g-spacing-3);
  padding-block-end:var(--slds-g-spacing-2);
  padding-inline-start:var(--slds-g-spacing-5);
  padding-inline-end:var(--slds-g-spacing-4);
}
.slds-split-view__list-item-action:hover,
.slds-split-view__list-item-action:focus{
  outline:none;
  background:var(--slds-g-color-surface-container-1);
  color:currentColor;
  text-decoration:none;
}
.slds-split-view__list-item-action:focus{
  box-shadow:inset 0 0 0 1px var(--slds-g-color-accent-1);
}
.slds-split-view__list-item-action[aria-current='page']{
  box-shadow:inset 4px 0 0 var(--slds-g-color-accent-1);
}
.slds-split-view__list-item-action[aria-current='page']:focus{
  box-shadow:inset 4px 0 0 var(--slds-g-color-accent-1), inset 0 0 0 1px var(--slds-g-color-accent-1);
}
.slds-split-view__toggle-button{
  position:absolute;
  inset-inline-end:calc(0.75rem * -1);
  height:100%;
  width:0.75rem;
  background:var(--slds-g-color-surface-container-1);
  border-radius:0;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-split-view__toggle-button:hover,
.slds-split-view__toggle-button:focus{
  background:var(--slds-g-color-surface-container-1);
}
.slds-split-view__toggle-button.slds-is-closed .slds-button__icon{
  transform:rotate(180deg);
}
.slds-tile + .slds-tile{
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-tile__detail{
  position:relative;
}
.slds-tile__meta{
  color:var(--slds-g-color-on-surface-3);
}
.slds-tile_board,.slds-tile--board{
  position:relative;
}
.slds-tile_board .slds-has-alert,.slds-tile--board .slds-has-alert{
  padding-inline-end:var(--slds-g-spacing-5);
}
.slds-tile_board__icon,.slds-tile--board__icon{
  width:var(--slds-g-spacing-4);
  height:var(--slds-g-spacing-4);
  position:absolute;
  inset-block-end:var(--slds-g-spacing-1);
  inset-inline-end:var(--slds-g-spacing-1);
}
.slds-tabs_default,.slds-tabs--default{
  --_slds-c-tabs-spacing-var-font-size-medium:var(--lwc-varFontSize5);
  --_slds-c-tabs-spacing-var-font-size-large:var(--lwc-varFontSize7);

  display:block;
  width:100%;
}
.slds-tabs_default .slds-tabs__item_overflow,.slds-tabs--default .slds-tabs__item--overflow{
  overflow:visible;
}
.slds-tabs_default__nav,.slds-tabs--default__nav{
  display:flex;
  align-items:flex-start;
  border-block-end-width:var(--slds-c-tabs-list-sizing-border, var(--slds-g-sizing-border-1));
  border-block-end-style:solid;
  border-block-end-color:var(
    --slds-c-tabs-list-color-border,
    var(--slds-s-navigation-color-border, var(--slds-g-color-border-1))
  );
}
.slds-tabs_default__item,.slds-tabs--default__item{
  color:var(--slds-c-tabs-item-text-color, var(--slds-s-navigation-color, var(--slds-g-color-on-surface-2)));
  position:relative;
  padding-block-start:var(--slds-c-tabs-item-spacing-blockstart, 0);
  padding-inline-end:var(--slds-c-tabs-item-spacing-inlineend, var(--slds-g-spacing-3));
  padding-block-end:var(--slds-c-tabs-item-spacing-blockend, 0);
  padding-inline-start:var(--slds-c-tabs-item-spacing-inlinestart, var(--slds-g-spacing-3));
  margin-block-end:calc(var(--slds-c-tabs-list-sizing-border, var(--slds-c-tabs-list-sizing-border)) * -1);
  font-weight:var(--slds-s-navigation-font-weight);
}
.slds-tabs_default__item::after,.slds-tabs--default__item::after{
  display:block;
  content:'';
  inset-block-end:0;
  inset-inline-start:0;
  inset-inline-end:0;
  height:0;
  position:absolute;
}
.slds-tabs_default__item.slds-is-active,.slds-tabs--default__item.slds-is-active{
  --slds-c-tabs-item-text-color:var(
    --slds-c-tabs-item-text-color-active,
    var(--slds-s-navigation-color-active, var(--slds-g-color-on-surface-3))
  );
}
.slds-tabs_default__item.slds-is-active::after,.slds-tabs--default__item.slds-is-active::after{
  background-color:var(--slds-c-tabs-item-color-border-active, var(--slds-g-color-accent-2));
  height:var(--slds-c-tabs-list-sizing-border, var(--slds-s-navigation-sizing-border-active));
}
.slds-tabs_default__item.slds-is-active .slds-tabs_default__link,.slds-tabs--default__item.slds-is-active .slds-tabs--default__link{
  font-weight:var(--slds-s-navigation-font-weight-active);
}
.slds-tabs_default__item.slds-is-active .slds-tabs_default__link:hover,.slds-tabs--default__item.slds-is-active .slds-tabs--default__link:hover{
  color:currentColor;
}
.slds-tabs_default__item:hover,.slds-tabs--default__item:hover{
  color:var(--slds-s-navigation-color-hover);
}
.slds-tabs_default__item:hover::after,.slds-tabs--default__item:hover::after{
  height:var(--slds-c-tabs-list-sizing-border, var(--slds-s-navigation-sizing-border-hover));
  background-color:var(
    --slds-c-tabs-item-color-border-hover,
    var(--slds-s-navigation-color-border-hover, var(--slds-g-color-accent-3))
  );
}
.slds-tabs_default__item:focus-visible,.slds-tabs--default__item:focus-visible{
  outline:0;
}
.slds-tabs_default__item:focus-visible::after,.slds-tabs--default__item:focus-visible::after{
  height:var(--slds-c-tabs-list-sizing-border, var(--slds-s-navigation-sizing-border-active));
  background-color:var(--slds-c-tabs-item-color-border-active, var(--slds-g-color-accent-2));
}
.slds-tabs_default__item .slds-tabs_default__link:focus-visible,.slds-tabs--default__item .slds-tabs--default__link:focus-visible{
  box-shadow:none;
}
.slds-tabs_default__item.slds-has-notification,.slds-tabs--default__item.slds-has-notification{
  background:var(--slds-g-color-surface-container-2);
}
.slds-tabs_default__item.slds-has-notification::after,.slds-tabs--default__item.slds-has-notification::after{
  background-color:var(--slds-g-color-border-1);
}
.slds-tabs_default__item.slds-has-notification:hover::after,.slds-tabs--default__item.slds-has-notification:hover::after{
  background-color:var(--slds-g-color-accent-3);
}
.slds-tabs_default__item.slds-has-notification .slds-indicator_unread,.slds-tabs--default__item.slds-has-notification .slds-indicator--unread{
  display:inline-block;
  height:0.375rem;
  width:0.375rem;
  position:relative;
  inset-block-start:auto;
  inset-inline-start:auto;
}
.slds-tabs_default__item.slds-has-notification .slds-indicator_unsaved,.slds-tabs--default__item.slds-has-notification .slds-indicator--unsaved{
  inset-block-start:calc(var(--slds-g-spacing-1) * -1);
}
.slds-tabs_default__item.slds-is-unsaved .slds-indicator_unread,.slds-tabs--default__item.slds-is-unsaved .slds-indicator--unread{
  margin-inline-start:-0.35rem;
}
.slds-tabs_default__item.slds-is-unsaved .slds-indicator_unsaved,.slds-tabs--default__item.slds-is-unsaved .slds-indicator--unsaved{
  color:var(--slds-g-color-accent-3);
}
.slds-tabs_default__link,.slds-tabs--default__link{
  max-width:100%;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  display:inline-flex;
  align-items:center;
  text-decoration:none;
  cursor:pointer;
  height:var(--slds-c-tabs-item-sizing-height, var(--slds-s-navigation-sizing-height, 2.5rem));
  line-height:var(--slds-c-tabs-item-font-lineheight, var(--slds-s-navigation-font-lineheight, 2.5rem));
  color:currentColor;
  border:0;
  text-transform:inherit;
  z-index:1;
}
.slds-tabs_default__link:focus-visible,.slds-tabs--default__link:focus-visible{
  outline:0;
}
.slds-tabs_default__link:hover,.slds-tabs--default__link:hover,
.slds-tabs_default__link:focus,
.slds-tabs--default__link:focus{
  text-decoration:none;
  box-shadow:none;
  color:currentColor;
}
.slds-tabs_default__link[tabindex='0']:focus-visible,.slds-tabs--default__link[tabindex='0']:focus-visible{
  text-decoration:underline;
}
.slds-tabs_default__overflow-button,.slds-tabs--default__overflow-button{
  display:inline-flex;
  height:var(--slds-c-tabs-item-sizing-height, var(--slds-s-navigation-sizing-height, 2.5rem));
  line-height:var(--slds-c-tabs-item-font-lineheight, var(--slds-s-navigation-font-lineheight, 2.5rem));
}
.slds-tabs_default__overflow-button .slds-button,.slds-tabs--default__overflow-button .slds-button{
  line-height:inherit;
  color:var(--slds-c-tabs-item-text-color, var(--slds-g-color-on-surface-1));
  box-shadow:none;
  --slds-c-button-color-border-active:transparent;
}
.slds-tabs_default__overflow-button .slds-button:focus-visible,.slds-tabs--default__overflow-button .slds-button:focus-visible{
  text-decoration:underline;
}
.slds-tabs_default__overflow-button.slds-has-error .slds-button,.slds-tabs--default__overflow-button.slds-has-error .slds-button, .slds-tabs_default__overflow-button.slds-has-success .slds-button, .slds-tabs--default__overflow-button.slds-has-success .slds-button{
  color:var(--slds-g-color-neutral-base-100);
}
.slds-tabs_default__content,.slds-tabs--default__content{
  position:relative;
  padding-block-start:var(
    --slds-c-tabs-panel-spacing-blockstart,
    var(--slds-c-tabs-panel-spacing-block, var(--slds-g-spacing-3))
  );
  padding-inline-end:var(--slds-c-tabs-panel-spacing-inlineend, var(--slds-c-tabs-panel-spacing-inline, 0));
  padding-block-end:var(
    --slds-c-tabs-panel-spacing-blockend,
    var(--slds-c-tabs-panel-spacing-block, var(--slds-g-spacing-3))
  );
  padding-inline-start:var(
    --slds-c-tabs-panel-spacing-inlinestart,
    var(--slds-c-tabs-panel-spacing-inline, 0)
  );
}
.slds-tabs_medium .slds-tabs_default__item,.slds-tabs--medium .slds-tabs--default__item{
  font-size:var(--_slds-c-tabs-spacing-var-font-size-medium);
}
.slds-tabs_large .slds-tabs_default__item,.slds-tabs--large .slds-tabs--default__item{
  font-size:var(--_slds-c-tabs-spacing-var-font-size-large);
}
.slds-tabs__left-icon{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-tabs__left-icon:empty{
  margin-inline-end:0;
}
.slds-tabs__right-icon{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-tabs_scoped,.slds-tabs--scoped{
  display:block;
  width:100%;
}
.slds-tabs_scoped__nav,.slds-tabs--scoped__nav{
  display:flex;
  align-items:flex-start;
  background-color:var(--slds-s-navigation-color-background);
  border:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border);
  border-start-start-radius:var(--slds-s-navigation-radius-border);
  border-start-end-radius:var(--slds-s-navigation-radius-border);
  border-end-end-radius:0;
  border-end-start-radius:0;
}
.slds-tabs_scoped__item,.slds-tabs--scoped__item{
  position:relative;
  margin-block-end:calc(var(--slds-g-sizing-border-1) * -1);
}
.slds-tabs_scoped__item + .slds-tabs_scoped__item,.slds-tabs--scoped__item + .slds-tabs--scoped__item{
  margin-inline-start:calc(var(--slds-g-sizing-border-1) * -1);
}
.slds-tabs_scoped__item:first-child .slds-tabs_scoped__link,.slds-tabs--scoped__item:first-child .slds-tabs--scoped__link{
  border-inline-start:0;
  border-start-start-radius:var(--slds-s-navigation-radius-border);
  border-start-end-radius:0;
  border-end-end-radius:0;
  border-end-start-radius:0;
}
.slds-tabs_scoped__content,.slds-tabs--scoped__content{
  background-color:var(--slds-s-navigation-color-background-active);
  border:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border, var(--slds-g-color-border-1));
  border-block-start:0;
  border-start-start-radius:0;
  border-start-end-radius:0;
  border-end-end-radius:var(--slds-s-navigation-radius-border);
  border-end-start-radius:var(--slds-s-navigation-radius-border);
  padding:var(--slds-g-spacing-4);
}
.slds-tabs_scoped__link,.slds-tabs--scoped__link{
  max-width:100%;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  display:block;
  text-decoration:none;
  cursor:pointer;
  height:var(--slds-c-tabs-item-sizing-height, var(--slds-s-navigation-sizing-height, 2.5rem));
  line-height:var(--slds-c-tabs-item-font-lineheight, var(--slds-s-navigation-font-lineheight, 2.5rem));
  padding-block:0;
  padding-inline:var(--slds-g-spacing-4);
  color:var(--slds-s-navigation-color, var(--slds-g-color-on-surface-1));
  font-weight:var(--slds-s-navigation-font-weight);
  background-clip:padding-box;
  border:0;
  border-inline-start:var(--slds-g-sizing-border-1) solid transparent;
  border-inline-end:var(--slds-g-sizing-border-1) solid transparent;
  border-block-end:var(--slds-g-sizing-border-1) solid transparent;
  border-radius:0;
}
.slds-tabs_scoped__link:hover,.slds-tabs--scoped__link:hover,
.slds-tabs_scoped__link:focus,
.slds-tabs--scoped__link:focus{
  outline:0;
  text-decoration:none;
  color:currentColor;
  background-color:var(--slds-s-navigation-color-background-hover);
  border-color:var(--slds-s-navigation-color-border, var(--slds-g-color-border-1));
}
.slds-tabs_scoped__overflow-button,.slds-tabs--scoped__overflow-button{
  display:inline-flex;
  height:var(--slds-c-tabs-item-sizing-height, var(--slds-s-navigation-sizing-height, 2.5rem));
  line-height:var(--slds-c-tabs-item-font-lineheight, var(--slds-s-navigation-font-lineheight, 2.5rem));
}
.slds-tabs_scoped__overflow-button .slds-button,.slds-tabs--scoped__overflow-button .slds-button{
  line-height:inherit;
  color:var(--slds-s-navigation-color, var(--slds-g-color-on-surface-1));
  padding-block:0;
  padding-inline:var(--slds-g-spacing-4);
  font-weight:var(--slds-s-navigation-font-weight);
  --slds-c-button-color-background-hover:transparent;
  --slds-c-button-shadow-focus:none;
  --slds-c-button-radius-border:0;
}
.slds-tabs_scoped__overflow-button .slds-button:focus-visible,.slds-tabs--scoped__overflow-button .slds-button:focus-visible{
  text-decoration:underline;
}
.slds-tabs_scoped__overflow-button .slds-button:active,.slds-tabs--scoped__overflow-button .slds-button:active{
  box-shadow:none;
}
.slds-is-active .slds-tabs_scoped__link,.slds-is-active .slds-tabs--scoped__link{
  background-color:var(--slds-s-navigation-color-background-active);
  border-color:var(--slds-s-navigation-color-border, var(--slds-g-color-border-1));
  font-weight:var(--slds-s-navigation-font-weight-active);
  color:var(--slds-s-navigation-color-active, var(--slds-g-color-on-surface-3));
  border-block-end:none;
}
.slds-is-active .slds-tabs_scoped__link:hover,.slds-is-active .slds-tabs--scoped__link:hover{
  border-bottom-color:transparent;
}
.slds-is-active .slds-tabs_scoped__link:focus-visible,.slds-is-active .slds-tabs--scoped__link:focus-visible{
  text-decoration:underline;
}
.slds-vertical-tabs{
  display:flex;
  overflow:hidden;
  border:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border);
  border-radius:var(--slds-g-radius-border-2);
}
.slds-vertical-tabs__nav{
  width:var(--slds-g-sizing-14);
  border-inline-end:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border);
  background:var(--slds-s-navigation-color-background);
}
.slds-vertical-tabs__nav-item{
  display:flex;
  align-items:center;
  overflow:hidden;
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border);
  color:var(--slds-s-navigation-color);
}
.slds-vertical-tabs__nav-item:last-child{
  margin-block-end:-1px;
}
.slds-vertical-tabs__link{
  display:flex;
  flex:1 1;
  align-items:center;
  min-width:0;
  padding:var(--slds-g-spacing-3);
  color:currentColor;
  font-weight:var(--slds-s-navigation-font-weight);
}
.slds-vertical-tabs__link:hover{
  background:var(--slds-s-navigation-color-background-hover);
  color:var(--slds-g-color-on-surface-3);
  text-decoration:none;
}
.slds-vertical-tabs__link:focus{
  outline:0;
  color:currentColor;
}
.slds-vertical-tabs__left-icon{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-vertical-tabs__left-icon:empty{
  margin-inline-end:0;
}
.slds-vertical-tabs__right-icon{
  margin-inline-start:auto;
}
.slds-vertical-tabs__content{
  flex:1 1;
  padding:var(--slds-g-spacing-3);
  background:var(--slds-s-navigation-color-background-active);
}
.slds-vertical-tabs__nav-item.slds-is-active{
  margin-inline-end:-1px;
  border-inline-end:0;
  background:var(--slds-s-navigation-color-background-active);
  color:var(--slds-s-navigation-color-active);
}
.slds-vertical-tabs__nav-item.slds-is-active .slds-vertical-tabs__link:hover{
  background:var(--slds-s-navigation-color-background-active);
  color:currentColor;
}
.slds-vertical-tabs__nav-item.slds-is-active .slds-vertical-tabs__link{
  font-weight:var(--slds-s-navigation-font-weight-active);
}
.slds-vertical-tabs__nav-item:has(:focus-visible){
  text-decoration:underline;
}
.slds-sub-tabs .slds-tabs_default__nav,.slds-sub-tabs .slds-tabs--default__nav{
  background-color:var(--slds-g-color-surface-container-1);
  border-block-end-width:var(--slds-g-sizing-border-1);
}
.slds-sub-tabs__item{
  text-transform:none;
  letter-spacing:0;
  margin-block-end:0;
  font-weight:normal;
}
.slds-sub-tabs__item.slds-active,
.slds-sub-tabs__item.slds-is-open{
  background-color:var(
    --_slds-c-globalnavigation-subtab-color-background-active,
    var(--slds-g-color-accent-light-1)
  );
  color:var(--_slds-c-globalnavigation-item-color-active, var(--slds-g-color-on-surface-1));
}
.slds-sub-tabs__item.slds-active .slds-button__icon,
.slds-sub-tabs__item.slds-active .slds-icon,
.slds-sub-tabs__item.slds-is-open .slds-button__icon,
.slds-sub-tabs__item.slds-is-open .slds-icon{
  fill:var(--_slds-c-globalnavigation-item-color-active, var(--slds-g-color-on-surface-1));
}
.slds-sub-tabs__item.slds-active:hover, .slds-sub-tabs__item.slds-is-open:hover{
  background-color:var(
    --_slds-c-globalnavigation-subtab-color-background-active,
    var(--slds-g-color-accent-light-1)
  );
}
.slds-sub-tabs__item::after{
  content:none;
}
.slds-sub-tabs__item:hover{
  background-color:var(
    --_slds-c-globalnavigation-subtab-color-background-hover,
    var(--slds-g-color-accent-light-1)
  );
}
.slds-sub-tabs__item .slds-tabs_default__link:focus-visible,.slds-sub-tabs__item .slds-tabs--default__link:focus-visible{
  text-decoration:underline;
}
.slds-sub-tabs__item + .slds-sub-tabs__item{
  margin-inline-start:0;
}
.slds-sub-tabs__item .slds-icon_container,.slds-sub-tabs__item .slds-icon--container{
  --slds-c-icon-color-background:transparent;
  --slds-c-icon-color-foreground:var(--slds-g-color-on-surface-1);
}
.slds-sub-tabs__item .slds-button__icon,
.slds-sub-tabs__item .slds-icon{
  fill:var(--slds-g-color-on-surface-1);
}
.slds-sub-tabs__item.slds-has-success{
  color:var(--slds-g-color-on-success-1);
}
.slds-sub-tabs__item.slds-has-success .slds-button__icon,
.slds-sub-tabs__item.slds-has-success .slds-icon{
  fill:var(--slds-g-color-on-success-1);
}
.slds-sub-tabs__item.slds-has-success::before{
  animation-duration:1s;
  animation-iteration-count:3;
  animation-timing-function:linear;
  background-color:var(--slds-g-color-success-container-1);
  inset-block-end:0;
  content:' ';
  inset-inline-start:0;
  position:absolute;
  inset-inline-end:0;
  inset-block-start:0;
  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
  animation-name:success-pulse;
}
.slds-sub-tabs__item.slds-has-success:hover::before{
  background-color:var(--slds-g-color-success-container-2);
}
.slds-sub-tabs__item.slds-has-success .slds-indicator_unread,.slds-sub-tabs__item.slds-has-success .slds-indicator--unread{
  background-color:currentColor;
}
.slds-sub-tabs__item.slds-has-success .slds-indicator_unsaved,.slds-sub-tabs__item.slds-has-success .slds-indicator--unsaved{
  color:currentColor;
}
.slds-sub-tabs__item.slds-has-error{
  color:var(--slds-g-color-on-error-1);
}
.slds-sub-tabs__item.slds-has-error .slds-button__icon,
.slds-sub-tabs__item.slds-has-error .slds-icon{
  fill:var(--slds-g-color-on-error-1);
}
.slds-sub-tabs__item.slds-has-error::before{
  animation-duration:1s;
  animation-iteration-count:3;
  animation-timing-function:linear;
  background-color:var(--slds-g-color-error-container-1);
  inset-block-end:0;
  content:' ';
  inset-inline-start:0;
  position:absolute;
  inset-inline-end:0;
  inset-block-start:0;
  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
  animation-name:error-pulse;
}
.slds-sub-tabs__item.slds-has-error:hover::before{
  background-color:var(--slds-g-color-error-container-2);
}
.slds-sub-tabs__item.slds-has-error .slds-indicator_unread,.slds-sub-tabs__item.slds-has-error .slds-indicator--unread{
  background-color:currentColor;
}
.slds-sub-tabs__item.slds-has-error .slds-indicator_unsaved,.slds-sub-tabs__item.slds-has-error .slds-indicator--unsaved{
  color:currentColor;
}
.slds-sub-tabs__item.slds-has-warning{
  color:var(--slds-g-color-on-warning-1);
}
.slds-sub-tabs__item.slds-has-warning .slds-button__icon,
.slds-sub-tabs__item.slds-has-warning .slds-icon{
  fill:var(--slds-g-color-on-warning-1);
}
.slds-sub-tabs__item.slds-has-warning::before{
  animation-duration:1s;
  animation-iteration-count:3;
  animation-timing-function:linear;
  background-color:var(--slds-g-color-warning-container-1);
  inset-block-end:0;
  content:' ';
  inset-inline-start:0;
  position:absolute;
  inset-inline-end:0;
  inset-block-start:0;
  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
  animation-name:warning-pulse;
}
.slds-sub-tabs__item.slds-has-warning:hover::before{
  background-color:var(--slds-g-color-warning-base-80);
}
.slds-sub-tabs__item.slds-has-warning .slds-indicator_unread,.slds-sub-tabs__item.slds-has-warning .slds-indicator--unread{
  background-color:currentColor;
}
.slds-sub-tabs__item.slds-has-warning .slds-indicator_unsaved,.slds-sub-tabs__item.slds-has-warning .slds-indicator--unsaved{
  color:currentColor;
}
.slds-has-pinned-regions .slds-sub-tabs__item.slds-active::before, .slds-has-pinned-regions .slds-sub-tabs__item.slds-is-open::before{
  content:'';
  height:3px;
  display:block;
  background:var(--slds-g-color-accent-2);
  position:absolute;
  inset-block-start:0;
  inset-inline-start:-1px;
  inset-inline-end:-1px;
}
.slds-tab__scroll-controls{
  display:none;
}
.slds-tabs-mobile__container{
  position:relative;
  overflow:hidden;
}
.slds-panel__body .slds-tabs-mobile:first-child{
  margin-block-start:calc(var(--slds-g-spacing-3) * -1);
}
.slds-panel__body .slds-tabs-mobile:first-child .slds-tabs-mobile__item:first-child{
  border-block-start:0;
}
.slds-panel__body .slds-tabs-mobile{
  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);
  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);
}
.slds-tabs-mobile{
  display:flex;
  flex-direction:column;
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-tabs-mobile__item{
  display:flex;
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-4));
  align-items:stretch;
  color:var(--slds-g-color-on-surface-3);
  font-size:var(--slds-g-font-scale-2);
  padding:0 var(--slds-g-spacing-3);
}
.slds-tabs-mobile__item:active{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-tabs-mobile__item:last-child{
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-tabs-mobile__group
.slds-tabs-mobile__container
+ .slds-tabs-mobile__container
.slds-tabs-mobile__item:first-child{
  border-block-start:0;
}
.slds-table_tree .slds-tree__item,.slds-table--tree .slds-tree__item{
  line-height:var(--slds-g-font-lineheight-4);
}
.slds-table_tree .slds-tree__item a,.slds-table--tree .slds-tree__item a{
  color:var(--slds-s-link-color);
}
.slds-table_tree .slds-tree__item a:hover,.slds-table--tree .slds-tree__item a:hover{
  text-decoration:underline;
}
.slds-table_tree .slds-button,.slds-table--tree .slds-button,
.slds-table--tree .slds-button{
  align-self:center;
}
.slds-table_tree .slds-button:not(.slds-th__action-button),.slds-table--tree .slds-button:not(.slds-th__action-button){
  margin-block-start:0;
}
[aria-level='1'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='2'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='3'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='4'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='5'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='6'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='7'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='8'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='9'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='10'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='11'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='12'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='13'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='14'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='15'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='16'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='17'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='18'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='19'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
[aria-level='20'] > .slds-tree__item{
  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));
}
.slds-tree-container,
.slds-tree_container,
.slds-tree--container{
  min-width:25rem;
  max-width:var(--slds-c-tree-sizing-max-width, 25rem);
}
.slds-tree-container > .slds-text-heading_label,.slds-tree-container > .slds-text-heading--label,
.slds-tree_container > .slds-text-heading_label,
.slds-tree--container > .slds-text-heading--label{
  margin-block-end:var(--slds-g-spacing-2);
}
.slds-tree__item{
  display:flex;
  padding-block-start:calc(var(--slds-g-spacing-1) + 2px);
  padding-block-end:calc(var(--slds-g-spacing-1) + 2px);
  padding-inline-start:var(--slds-g-spacing-4);
  padding-inline-end:0;
}
.slds-tree__item.slds-is-hovered,
.slds-tree__item:hover{
  background:var(--slds-s-table-row-color-background-selected, var(--slds-g-color-surface-container-2));
  cursor:pointer;
}
.slds-tree [role='treeitem']:focus{
  outline:0;
}
.slds-tree [role='treeitem']:focus > .slds-tree__item{
  background:var(--slds-g-color-surface-container-2);
  cursor:pointer;
  text-decoration:underline;
}
.slds-tree [role='treeitem'][aria-selected='true'] > .slds-tree__item{
  background:var(--slds-g-color-brand-base-90);
  box-shadow:var(--slds-g-color-accent-1) 4px 0 0 inset;
}
.slds-tree [role='treeitem'][aria-selected='true'] > .slds-tree__item [dir='rtl']{
  box-shadow:var(--slds-g-color-accent-1) -4px 0 0 inset;
}
.slds-tree [aria-disabled='true']{
  color:var(--slds-g-color-disabled-1);
}
.slds-tree [aria-disabled='true'] .slds-tree__item.slds-is-hovered,
.slds-tree [aria-disabled='true'] .slds-tree__item:hover{
  background-color:transparent;
  cursor:default;
}
.slds-tree [aria-disabled='true'] .slds-tree__item-meta{
  color:inherit;
}
.slds-tree [role='treeitem'] > [role='group']{
  display:none;
}
.slds-tree [role='treeitem'][aria-expanded='true'] > [role='group']{
  display:block;
}
[aria-expanded='false'] > .slds-tree__item .slds-button__icon{
  transition:0.2s transform ease-in-out;
  transform:rotate(0deg);
}
[aria-expanded='true'] > .slds-tree__item .slds-button__icon{
  transition:0.2s transform ease-in-out;
  transform:rotate(90deg);
}
[aria-expanded='true'] > .slds-tree__item .slds-button__icon [dir='rtl']{
  transform:rotate(-90deg);
}
[aria-level='1'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 1);
}
[aria-level='2'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 2);
}
[aria-level='3'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 3);
}
[aria-level='4'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 4);
}
[aria-level='5'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 5);
}
[aria-level='6'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 6);
}
[aria-level='7'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 7);
}
[aria-level='8'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 8);
}
[aria-level='9'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 9);
}
[aria-level='10'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 10);
}
[aria-level='11'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 11);
}
[aria-level='12'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 12);
}
[aria-level='13'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 13);
}
[aria-level='14'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 14);
}
[aria-level='15'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 15);
}
[aria-level='16'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 16);
}
[aria-level='17'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 17);
}
[aria-level='18'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 18);
}
[aria-level='19'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 19);
}
[aria-level='20'] > .slds-tree__item{
  padding-inline-start:calc(var(--slds-g-spacing-4) * 20);
}
.slds-tree__item-label{
  display:block;
}
.slds-tree__item-meta{
  display:block;
  color:var(--slds-g-color-on-surface-1);
}
.slds-tree__item .slds-button{
  align-self:flex-start;
  margin-block-start:2px;
}
.slds-tree__item .slds-pill{
  margin-inline-start:var(--slds-g-spacing-3);
}
.slds-tree__group-header{
  font-size:var(--slds-g-font-scale-1);
  font-weight:var(--slds-g-font-weight-7);
}
.slds-notify_alert,.slds-notify--alert{
  position:relative;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  width:100%;
  padding-block-start:var(--slds-c-alert-spacing-blockstart, var(--slds-g-spacing-2));
  padding-inline-end:var(--slds-c-alert-spacing-inlineend, var(--slds-g-spacing-6));
  padding-block-end:var(--slds-c-alert-spacing-blockend, var(--slds-g-spacing-2));
  padding-inline-start:var(--slds-c-alert-spacing-inlinestart, var(--slds-g-spacing-2));
  color:var(--slds-c-alert-text-color, var(--slds-g-color-on-info-1));
  font-weight:var(--slds-c-alert-font-weight);
  text-align:center;
  background-color:var(--slds-c-alert-color-background, var(--slds-g-color-info-container-1));
}
.slds-notify_alert .slds-icon,.slds-notify--alert .slds-icon,
.slds-notify_alert .slds-button__icon,
.slds-notify--alert .slds-button__icon{
  fill:currentColor;
}
.slds-notify_alert .slds-button_icon,.slds-notify--alert .slds-button--icon{
  color:currentColor;
}
.slds-notify_alert .slds-button_icon:hover,.slds-notify--alert .slds-button--icon:hover,
.slds-notify_alert .slds-button_icon:focus-visible,
.slds-notify--alert .slds-button--icon:focus-visible{
  color:var(--slds-s-alert-close-button-hover, color-mix(in oklab, currentColor, transparent 25%));
}
.slds-notify_alert a,.slds-notify--alert a{
  color:currentColor;
  border:var(--slds-g-sizing-border-1) solid transparent;
  border-radius:var(--slds-g-radius-border-2);
  text-decoration:underline;
}
.slds-notify_alert a:hover,.slds-notify--alert a:hover,
.slds-notify_alert a:focus,
.slds-notify--alert a:focus{
  text-decoration:none;
  outline:0;
}
.slds-notify_alert a:focus-visible,.slds-notify--alert a:focus-visible{
  box-shadow:var(--slds-c-alert-shadow, 0 0 3px var(--slds-g-color-on-info-1));
  border-width:var(--slds-c-alert-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(--slds-c-alert-color-border, var(--slds-g-color-on-info-1));
}
.slds-notify_alert a:active,.slds-notify--alert a:active{
  color:var(--slds-c-alert-text-color-active, color-mix(in oklab, currentColor, transparent 50%));
}
.slds-notify_alert a[disabled],.slds-notify--alert a[disabled]{
  color:color-mix(in oklab, currentColor, transparent 90%);
}
.slds-alert_warning,.slds-alert--warning{
  --slds-c-alert-color-background:var(--slds-g-color-warning-container-1);
  --slds-c-alert-text-color:var(--slds-g-color-on-warning-1);
}
.slds-alert_error,.slds-alert--error{
  --slds-c-alert-color-background:var(--slds-g-color-error-container-1);
  --slds-c-alert-text-color:var(--slds-g-color-on-error-1);
}
.slds-alert_offline,.slds-alert--offline{
  --slds-c-alert-color-background:var(--slds-g-color-neutral-base-50);
  --slds-c-alert-text-color:var(--slds-g-color-neutral-base-100);
}
.slds-notify__close{
  position:absolute;
  inset-inline-end:var(--slds-g-spacing-3);
  margin-inline-start:var(--slds-g-spacing-1);
  top:50%;
  transform:translateY(-50%);
}
.slds-scoped-notification{
  padding:var(--slds-g-spacing-3);
  border-radius:var(--slds-g-radius-border-2);
  font-weight:var(--slds-s-alert-font-weight);
}
.slds-scoped-notification .slds-icon_container,.slds-scoped-notification .slds-icon--container{
  display:flex;
}
.slds-scoped-notification a:focus-visible{
  box-shadow:var(--slds-s-link-shadow-focus);
  border-radius:var(--slds-g-radius-border-1);
  outline:0;
}
.slds-scoped-notification.slds-theme_warning a:focus,.slds-scoped-notification.slds-theme--warning a:focus{
  border:0;
}
.slds-scoped-notification_light,.slds-scoped-notification--light{
  background-color:var(--slds-g-color-surface-container-3);
  color:var(--slds-g-color-on-surface-1);
}
.slds-scoped-notification_light a,.slds-scoped-notification--light a{
  color:var(--slds-g-color-on-surface-1);
  text-decoration:underline;
}
.slds-scoped-notification_light a:link,.slds-scoped-notification--light a:link,
.slds-scoped-notification_light a:visited,
.slds-scoped-notification--light a:visited{
  color:var(--slds-g-color-on-surface-1);
}
.slds-scoped-notification_light a:hover,.slds-scoped-notification--light a:hover,
.slds-scoped-notification_light a:focus,
.slds-scoped-notification--light a:focus{
  text-decoration:none;
}
.slds-scoped-notification_dark,.slds-scoped-notification--dark{
  background-color:var(--slds-g-color-neutral-base-50);
  color:var(--slds-g-color-neutral-base-100);
}
.slds-scoped-notification_dark a,.slds-scoped-notification--dark a{
  color:var(--slds-g-color-neutral-base-100);
  text-decoration:underline;
}
.slds-scoped-notification_dark a:hover,.slds-scoped-notification--dark a:hover,
.slds-scoped-notification_dark a:active,
.slds-scoped-notification--dark a:active{
  text-decoration:none;
}
.slds-notify_container,.slds-notify--container{
  position:fixed;
  width:100%;
  inset-inline-start:0;
  inset-block-start:0;
  z-index:1000;
  text-align:center;
}
.slds-notify_toast,.slds-notify--toast{
  display:inline-flex;
  align-items:center;
  position:relative;
  background:none;
  background-color:var(--slds-c-toast-color-background, var(--slds-g-color-on-surface-1));
  color:var(--slds-c-toast-text-color);
  border-radius:var(--slds-c-toast-radius-border, var(--slds-g-radius-border-2));
  margin:var(--slds-g-spacing-2);
  padding-block-start:var(--slds-c-toast-spacing-blockstart, var(--slds-g-spacing-3));
  padding-inline-end:var(--slds-c-toast-spacing-inlineend, var(--slds-g-spacing-8));
  padding-block-end:var(--slds-c-toast-spacing-blockend, var(--slds-g-spacing-3));
  padding-inline-start:var(--slds-c-toast-spacing-inlinestart, var(--slds-g-spacing-5));
  min-width:var(--slds-c-toast-sizing-width-min, var(--slds-g-sizing-16));
  text-align:left;
  justify-content:flex-start;
}
.slds-notify_toast .slds-notify__content .slds-text-heading_small,.slds-notify--toast .slds-notify__content .slds-text-heading--small{
  font-weight:var(--slds-s-alert-font-weight);
}
.slds-notify_toast .slds-notify__close,.slds-notify--toast .slds-notify__close{
  float:inline-end;
  position:absolute;
  top:var(--slds-g-spacing-3);
  inset-inline-end:var(--slds-g-spacing-3);
  margin-inline-start:var(--slds-g-spacing-1);
  transform:translateY(var(--slds-g-sizing-1) * -1);
}
.slds-notify_toast .slds-button_icon,.slds-notify--toast .slds-button--icon{
  color:currentColor;
}
.slds-notify_toast .slds-button_icon:hover,.slds-notify--toast .slds-button--icon:hover,
.slds-notify_toast .slds-button_icon:focus-visible,
.slds-notify--toast .slds-button--icon:focus-visible{
  color:var(--slds-s-alert-close-button-hover, color-mix(in oklab, currentColor, transparent 25%));
}
.slds-region_narrow .slds-notify_toast,.slds-region--narrow .slds-notify--toast{
  min-width:auto;
  width:100%;
  margin-inline-start:0;
}
.slds-trial-header{
  color:var(--slds-g-color-surface-1);
  height:var(--slds-s-header-sizing-height, 3.125rem);
  background:var(--slds-g-color-surface-inverse-2);
  padding-block:0;
  padding-inline:var(--slds-g-spacing-4);
  align-items:center;
}
.slds-trial-header .slds-dropdown__item .slds-icon{
  fill:currentColor;
}
.slds-trial-header .slds-button_inverse,.slds-trial-header .slds-button--inverse{
  border:0;
}
.slds-trial-header .slds-dropdown{
  margin-block-start:var(--slds-g-spacing-4);
}
.slds-trial-header .slds-dropdown_inverse .slds-dropdown__item > a:hover,.slds-trial-header .slds-dropdown--inverse .slds-dropdown__item > a:hover,
.slds-trial-header .slds-dropdown_inverse .slds-dropdown__item > a:focus,
.slds-trial-header .slds-dropdown--inverse .slds-dropdown__item > a:focus{
  color:var(--slds-g-color-accent-3);
  background-color:var(--slds-g-color-surface-container-2);
  border-color:var(--slds-g-color-border-inverse-1);
}
.slds-avatar{
  --_slds-c-avatar-group-image-small:var(
    --lwc-groupDefaultAvatarSmall,
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
  );
  --_slds-c-avatar-group-image-medium:var(
    --lwc-groupDefaultAvatarMedium,
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
  );
  --_slds-c-avatar-group-image-large:var(
    --lwc-groupDefaultAvatarLarge,
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
  );
  --_slds-c-avatar-user-image-small:var(
    --lwc-userDefaultAvatarSmall,
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
  );
  --_slds-c-avatar-user-image-medium:var(
    --lwc-userDefaultAvatarMedium,
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
  );
  --_slds-c-avatar-user-image-large:var(
    --lwc-userDefaultAvatarLarge,
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
  );

  --slds-c-icon-color-background:var(--_slds-c-avatar-color-background);

  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
  overflow:hidden;
  display:inline-block;
  vertical-align:middle;
  border-radius:var(
    --slds-c-avatar-radius-border,
    var(--slds-s-avatar-radius-border, var(--slds-g-radius-border-2))
  );
  line-height:var(--slds-g-font-lineheight-1);
  font-size:var(--slds-g-font-scale-1);
}
.slds-avatar_group-image-small,.slds-avatar--group-image-small{
  background:var(--_slds-c-avatar-group-image-small) top left / cover no-repeat;
}
.slds-avatar_group-image-medium,.slds-avatar--group-image-medium{
  background:var(--_slds-c-avatar-group-image-medium) top left / cover no-repeat;
}
.slds-avatar_group-image-large,.slds-avatar--group-image-large{
  background:var(--_slds-c-avatar-group-image-large) top left / cover no-repeat;
}
.slds-avatar_profile-image-small,.slds-avatar--profile-image-small{
  background:var(--_slds-c-avatar-user-image-small) top left / cover no-repeat;
}
.slds-avatar_profile-image-medium,.slds-avatar--profile-image-medium{
  background:var(--_slds-c-avatar-user-image-medium) top left / cover no-repeat;
}
.slds-avatar_profile-image-large,.slds-avatar--profile-image-large{
  background:var(--_slds-c-avatar-user-image-large) top left / cover no-repeat;
}
.slds-avatar_x-small,.slds-avatar--x-small{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
  font-size:var(--slds-g-font-scale-neg-2);

  --slds-c-avatar-radius-border:var(--slds-s-avatar-radius-border, var(--slds-g-radius-border-1));
  --_slds-c-icon-sizing:var(--slds-g-sizing-6);
}
.slds-avatar_small,.slds-avatar--small{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
  font-size:var(--slds-g-font-scale-neg-2);

  --slds-c-avatar-radius-border:var(--slds-s-avatar-radius-border, var(--slds-g-radius-border-1));
  --_slds-c-icon-sizing:var(--slds-g-sizing-7);
}
.slds-avatar_medium,.slds-avatar--medium{
  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
  font-size:var(--slds-g-font-scale-1);

  --_slds-c-icon-sizing:var(--slds-g-sizing-9);
}
.slds-avatar_large,.slds-avatar--large{
  width:var(--slds-g-sizing-10);
  height:var(--slds-g-sizing-10);
  font-size:var(--slds-g-font-scale-3);
  line-height:var(--slds-g-font-lineheight-2);

  --_slds-c-icon-sizing:var(--slds-g-sizing-10);
}
.slds-avatar_circle,.slds-avatar--circle{
  border-radius:var(--slds-g-radius-border-circle);
}
.slds-avatar_empty,.slds-avatar--empty{
  border:var(--slds-g-sizing-border-1) dashed var(--slds-g-color-border-1);
}
.slds-avatar__initials{
  display:flex;
  justify-content:center;
  align-content:center;
  align-items:center;
  margin:auto;
  color:var(--slds-c-avatar-text-color, var(--slds-g-color-on-accent-1));
  height:100%;
  text-shadow:0 0 1px rgba(0, 0, 0, 80%);
  background-color:var(--_slds-c-avatar-color-background, var(--slds-g-color-accent-container-1));
}
.slds-avatar__initials[title]{
  cursor:default;
  text-decoration:none;
}
.slds-avatar__initials_inverse,.slds-avatar__initials--inverse{
  --slds-c-avatar-text-color:var(--slds-c-avatar-inverse-text-color, var(--slds-g-color-on-surface-1));

  background-color:var(--slds-g-color-surface-container-2);
  text-shadow:none;
}
.slds-avatar-group{
  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
  position:relative;
  display:inline-block;
}
.slds-avatar-grouped{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-accent-1);
  line-height:0;
  border-radius:var(--slds-s-avatar-radius-border, var(--slds-g-radius-border-circle));
  background-color:var(--slds-g-color-accent-container-1);
}
.slds-avatar-grouped_inverse,.slds-avatar-grouped--inverse{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-avatar-grouped__primary{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
  position:absolute;
  inset-inline-start:0;
  inset-block-end:0;
  z-index:1;
}
.slds-avatar-grouped__primary .slds-avatar-grouped__initials{
  transform:scale(0.5);
}
.slds-avatar-grouped__secondary{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
  position:absolute;
  inset-block-start:0;
  inset-inline-end:0;
}
.slds-avatar-grouped__secondary .slds-avatar-grouped__initials{
  transform:scale(0.4);
}
.slds-avatar-grouped__icon{
  height:100%;
  line-height:0;
}
.slds-avatar-grouped__icon .slds-icon{
  width:100%;
  height:100%;
}
.slds-avatar-group_x-small,.slds-avatar-group--x-small{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
}
.slds-avatar-group_x-small .slds-avatar-grouped__primary,.slds-avatar-group--x-small .slds-avatar-grouped__primary{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
}
.slds-avatar-group_x-small .slds-avatar-grouped__primary .slds-avatar-grouped__initials,.slds-avatar-group--x-small .slds-avatar-grouped__primary .slds-avatar-grouped__initials{
  transform:scale(0.3);
}
.slds-avatar-group_x-small .slds-avatar-grouped__secondary,.slds-avatar-group--x-small .slds-avatar-grouped__secondary{
  width:var(--slds-g-sizing-4);
  height:var(--slds-g-sizing-4);
}
.slds-avatar-group_x-small .slds-avatar-grouped__secondary .slds-avatar-grouped__initials,.slds-avatar-group--x-small .slds-avatar-grouped__secondary .slds-avatar-grouped__initials{
  transform:scale(0.18);
}
.slds-avatar-group_small,.slds-avatar-group--small{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
}
.slds-avatar-group_small .slds-avatar-grouped__primary,.slds-avatar-group--small .slds-avatar-grouped__primary{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
}
.slds-avatar-group_small .slds-avatar-grouped__primary .slds-avatar-grouped__initials,.slds-avatar-group--small .slds-avatar-grouped__primary .slds-avatar-grouped__initials{
  transform:scale(0.4);
}
.slds-avatar-group_small .slds-avatar-grouped__secondary,.slds-avatar-group--small .slds-avatar-grouped__secondary{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
}
.slds-avatar-group_small .slds-avatar-grouped__secondary .slds-avatar-grouped__initials,.slds-avatar-group--small .slds-avatar-grouped__secondary .slds-avatar-grouped__initials{
  transform:scale(0.3);
}
.slds-avatar-group_medium,.slds-avatar-group--medium{
  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
}
.slds-avatar-group_medium .slds-avatar-grouped__primary,.slds-avatar-group--medium .slds-avatar-grouped__primary{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
}
.slds-avatar-group_medium .slds-avatar-grouped__primary .slds-avatar-grouped__initials,.slds-avatar-group--medium .slds-avatar-grouped__primary .slds-avatar-grouped__initials{
  transform:scale(0.5);
}
.slds-avatar-group_medium .slds-avatar-grouped__secondary,.slds-avatar-group--medium .slds-avatar-grouped__secondary{
  width:var(--slds-g-sizing-6);
  height:var(--slds-g-sizing-6);
}
.slds-avatar-group_medium .slds-avatar-grouped__secondary .slds-avatar-grouped__initials,.slds-avatar-group--medium .slds-avatar-grouped__secondary .slds-avatar-grouped__initials{
  transform:scale(0.4);
}
.slds-avatar-group_large,.slds-avatar-group--large{
  width:var(--slds-g-sizing-10);
  height:var(--slds-g-sizing-10);
}
.slds-avatar-group_large .slds-avatar-grouped__primary,.slds-avatar-group--large .slds-avatar-grouped__primary{
  width:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));
  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));
}
.slds-avatar-group_large .slds-avatar-grouped__primary .slds-avatar-grouped__initials,.slds-avatar-group--large .slds-avatar-grouped__primary .slds-avatar-grouped__initials{
  transform:scale(0.8);
}
.slds-avatar-group_large .slds-avatar-grouped__secondary,.slds-avatar-group--large .slds-avatar-grouped__secondary{
  width:var(--slds-g-sizing-7);
  height:var(--slds-g-sizing-7);
}
.slds-avatar-group_large .slds-avatar-grouped__secondary .slds-avatar-grouped__initials,.slds-avatar-group--large .slds-avatar-grouped__secondary .slds-avatar-grouped__initials{
  transform:scale(0.5);
}
.slds-image,
.slds-file{
  display:block;
  position:relative;
}
.slds-image .slds-file__text, .slds-file .slds-file__text{
  display:block;
  color:var(--slds-g-color-on-surface-2);
}
.slds-image .slds-file__figure:hover::before,
.slds-image .slds-file__figure:hover::after,
.slds-image .slds-file__figure:focus::before,
.slds-image .slds-file__figure:focus::after,
.slds-image .slds-file__crop:hover::before,
.slds-image .slds-file__crop:hover::after,
.slds-image .slds-file__crop:focus::before,
.slds-image .slds-file__crop:focus::after,
.slds-file .slds-file__figure:hover::before,
.slds-file .slds-file__figure:hover::after,
.slds-file .slds-file__figure:focus::before,
.slds-file .slds-file__figure:focus::after,
.slds-file .slds-file__crop:hover::before,
.slds-file .slds-file__crop:hover::after,
.slds-file .slds-file__crop:focus::before,
.slds-file .slds-file__crop:focus::after{
  position:absolute;
  z-index:5;
  cursor:pointer;
  content:'';
}
.slds-image.slds-file_loading .slds-file__figure:hover::before,.slds-image.slds-file--loading .slds-file__figure:hover::before,
.slds-image.slds-file_loading .slds-file__figure:hover::after,
.slds-image.slds-file--loading .slds-file__figure:hover::after,
.slds-image.slds-file_loading .slds-file__figure:focus::before,
.slds-image.slds-file--loading .slds-file__figure:focus::before,
.slds-image.slds-file_loading .slds-file__figure:focus::after,
.slds-image.slds-file--loading .slds-file__figure:focus::after,
.slds-image.slds-file_loading .slds-file__crop:hover::before,
.slds-image.slds-file--loading .slds-file__crop:hover::before,
.slds-image.slds-file_loading .slds-file__crop:hover::after,
.slds-image.slds-file--loading .slds-file__crop:hover::after,
.slds-image.slds-file_loading .slds-file__crop:focus::before,
.slds-image.slds-file--loading .slds-file__crop:focus::before,
.slds-image.slds-file_loading .slds-file__crop:focus::after,
.slds-image.slds-file--loading .slds-file__crop:focus::after,
.slds-file.slds-file_loading .slds-file__figure:hover::before,
.slds-file.slds-file--loading .slds-file__figure:hover::before,
.slds-file.slds-file_loading .slds-file__figure:hover::after,
.slds-file.slds-file--loading .slds-file__figure:hover::after,
.slds-file.slds-file_loading .slds-file__figure:focus::before,
.slds-file.slds-file--loading .slds-file__figure:focus::before,
.slds-file.slds-file_loading .slds-file__figure:focus::after,
.slds-file.slds-file--loading .slds-file__figure:focus::after,
.slds-file.slds-file_loading .slds-file__crop:hover::before,
.slds-file.slds-file--loading .slds-file__crop:hover::before,
.slds-file.slds-file_loading .slds-file__crop:hover::after,
.slds-file.slds-file--loading .slds-file__crop:hover::after,
.slds-file.slds-file_loading .slds-file__crop:focus::before,
.slds-file.slds-file--loading .slds-file__crop:focus::before,
.slds-file.slds-file_loading .slds-file__crop:focus::after,
.slds-file.slds-file--loading .slds-file__crop:focus::after{
  display:none;
}
.slds-image .slds-file__figure:hover::before,
.slds-image .slds-file__figure:focus::before,
.slds-image .slds-file__crop:hover::before,
.slds-image .slds-file__crop:focus::before,
.slds-file .slds-file__figure:hover::before,
.slds-file .slds-file__figure:focus::before,
.slds-file .slds-file__crop:hover::before,
.slds-file .slds-file__crop:focus::before{
  inset-block-start:0;
  inset-inline-end:0;
  inset-block-end:0;
  inset-inline-start:0;
  background-color:rgba(24, 24, 24, 0.5);
}
.slds-image .slds-file__figure:hover::after,
.slds-image .slds-file__figure:focus::after,
.slds-image .slds-file__crop:hover::after,
.slds-image .slds-file__crop:focus::after,
.slds-file .slds-file__figure:hover::after,
.slds-file .slds-file__figure:focus::after,
.slds-file .slds-file__crop:hover::after,
.slds-file .slds-file__crop:focus::after{
  inset-block-start:50%;
  inset-inline-start:50%;
  width:var(--slds-g-sizing-9);
  height:var(--slds-g-sizing-9);
  background-image:url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size:contain;
  transform:translate(-50%, -50%);
}
.slds-image .slds-file__figure:hover + .slds-file__title,
.slds-image .slds-file__figure:focus + .slds-file__title,
.slds-image .slds-file__crop:hover + .slds-file__title,
.slds-image .slds-file__crop:focus + .slds-file__title,
.slds-file .slds-file__figure:hover + .slds-file__title,
.slds-file .slds-file__figure:focus + .slds-file__title,
.slds-file .slds-file__crop:hover + .slds-file__title,
.slds-file .slds-file__crop:focus + .slds-file__title{
  z-index:5;
}
.slds-image.slds-has-title .slds-file__figure:hover::after,
.slds-image.slds-has-title .slds-file__figure:focus::after,
.slds-image.slds-has-title .slds-file__crop:hover::after,
.slds-image.slds-has-title .slds-file__crop:focus::after,
.slds-file.slds-has-title .slds-file__figure:hover::after,
.slds-file.slds-has-title .slds-file__figure:focus::after,
.slds-file.slds-has-title .slds-file__crop:hover::after,
.slds-file.slds-has-title .slds-file__crop:focus::after{
  transform:translate(-50%, calc(-50% - (var(--slds-g-sizing-9) / 2)));
}
.slds-image:focus, .slds-file:focus{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-accent-1);
  box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.16);
}
.slds-image :not(:only-child) .slds-spinner, .slds-file :not(:only-child) .slds-spinner{
  inset-block-start:45%;
}
.slds-image .slds-file__figure_portrait img,.slds-image .slds-file__figure--portrait img, .slds-file .slds-file__figure_portrait img, .slds-file .slds-file__figure--portrait img{
  display:block;
  margin:0 auto;
  max-height:var(--slds-g-sizing-14);
  height:auto;
}
@media (any-hover: none){
  .slds-image .slds-file__figure:hover::before,
  .slds-image .slds-file__figure:hover::after,
  .slds-image .slds-file__figure:focus::before,
  .slds-image .slds-file__figure:focus::after,
  .slds-image .slds-file__crop:hover::before,
  .slds-image .slds-file__crop:hover::after,
  .slds-image .slds-file__crop:focus::before,
  .slds-image .slds-file__crop:focus::after,
  .slds-file .slds-file__figure:hover::before,
  .slds-file .slds-file__figure:hover::after,
  .slds-file .slds-file__figure:focus::before,
  .slds-file .slds-file__figure:focus::after,
  .slds-file .slds-file__crop:hover::before,
  .slds-file .slds-file__crop:hover::after,
  .slds-file .slds-file__crop:focus::before,
  .slds-file .slds-file__crop:focus::after{
    display:none;
  }
}
.slds-image__crop,
.slds-file__crop{
  display:block;
  position:relative;
  overflow:hidden;
  padding-block-start:56.25%;
  border-radius:var(--slds-g-radius-border-2);
}
.slds-image__crop img, .slds-file__crop img{
  position:absolute;
  top:50%;
  left:50%;
  transform:translate3d(-50%, -50%, 0);
  max-width:200%;
}
.slds-image__crop::after, .slds-file__crop::after{
  content:'';
  display:block;
}
.slds-image__crop_1-by-1,.slds-image__crop--1-by-1,
.slds-file__crop_1-by-1,
.slds-file__crop--1-by-1{
  padding-block-start:100%;
}
.slds-image__crop_16-by-9,.slds-image__crop--16-by-9,
.slds-file__crop_16-by-9,
.slds-file__crop--16-by-9{
  padding-block-start:56.25%;
}
.slds-image__crop_4-by-3,.slds-image__crop--4-by-3,
.slds-file__crop_4-by-3,
.slds-file__crop--4-by-3{
  padding-block-start:75%;
}
.slds-image__figure,
.slds-file__figure{
  display:block;
  min-width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));
  max-width:var(--slds-g-sizing-14);
  min-height:calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9));
  max-height:var(--slds-g-sizing-14);
}
.slds-image__title,
.slds-file__title{
  display:flex;
  z-index:5;
  align-items:center;
  padding:var(--slds-g-spacing-2);
  overflow:hidden;
}
.slds-image__title .slds-media, .slds-file__title .slds-media{
  overflow:hidden;
}
.slds-image-has-actions,
.slds-file-has-actions{
  padding-inline-end:var(--slds-g-spacing-8);
}
.slds-image_overlay,.slds-image--overlay,
.slds-file_overlay,
.slds-file--overlay{
  content:'';
  background:rgba(24, 24, 24, 0.5);
  color:var(--slds-g-color-on-surface-inverse-1);
  position:absolute;
  inset-block-start:0;
  inset-inline-start:0;
  inset-inline-end:0;
  inset-block-end:0;
  z-index:1;
}
.slds-image_card,.slds-image--card,
.slds-file_card,
.slds-file--card{
  background:var(--slds-g-color-surface-container-1);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
}
.slds-image__icon,
.slds-file__icon{
  position:absolute;
  top:50%;
  left:50%;
  transform:translate3d(-50%, -50%, 0);
  margin-block-start:calc((var(--slds-g-sizing-9) * 0.5) * -1);
}
.slds-image__actions-menu,
.slds-file__actions-menu{
  position:absolute;
  z-index:5;
  inset-block-end:var(--slds-g-spacing-2);
  inset-inline-end:var(--slds-g-spacing-1);
}
.slds-image__external-icon,
.slds-file__external-icon{
  position:absolute;
  inset-block-start:var(--slds-g-spacing-7);
  inset-inline-start:var(--slds-g-spacing-5);
}
.slds-image__loading-icon,
.slds-file__loading-icon{
  fill:var(--slds-g-color-on-disabled-1);
}
.slds-image_center-icon .slds-file__icon,.slds-image--center-icon .slds-file__icon, .slds-file_center-icon .slds-file__icon, .slds-file--center-icon .slds-file__icon{
  margin-block-start:0;
}
.slds-image__title_overlay,.slds-image__title--overlay,
.slds-file__title_overlay,
.slds-file__title--overlay{
  color:var(--slds-g-color-on-surface-inverse-1);
  position:absolute;
  inset-block-start:0;
  inset-inline-end:0;
  inset-block-end:0;
  inset-inline-start:0;
}
.slds-image__title_overlay .slds-media__body,.slds-image__title--overlay .slds-media__body, .slds-file__title_overlay .slds-media__body, .slds-file__title--overlay .slds-media__body{
  z-index:1;
}
.slds-image__title_overlay .slds-media__body .slds-file__text,.slds-image__title--overlay .slds-media__body .slds-file__text, .slds-file__title_overlay .slds-media__body .slds-file__text, .slds-file__title--overlay .slds-media__body .slds-file__text{
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-image__title_card,.slds-image__title--card,
.slds-file__title_card,
.slds-file__title--card{
  background:var(--slds-g-color-surface-container-2);
  position:absolute;
  inset-inline-end:0;
  inset-block-end:0;
  inset-inline-start:0;
  border-bottom-left-radius:var(--slds-g-radius-border-2);
  border-bottom-right-radius:var(--slds-g-radius-border-2);
}
.slds-image__title_scrim,.slds-image__title--scrim,
.slds-file__title_scrim,
.slds-file__title--scrim{
  background:linear-gradient(to bottom, transparent, rgba(24, 24, 24, 0.5));
  position:absolute;
  inset-inline-end:0;
  inset-block-end:0;
  inset-inline-start:0;
  padding:var(--slds-g-spacing-4);
}
.slds-badge{
  display:inline-flex;
  align-items:center;
  padding-block:var(--slds-g-spacing-1);
  padding-inline:var(--slds-g-spacing-2);
  color:var(--slds-c-badge-text-color, var(--slds-g-color-on-surface-1));
  font-size:var(--slds-c-badge-font-size, var(--slds-g-font-scale-neg-1));
  font-weight:var(--slds-g-font-weight-4);
  line-height:normal;
  white-space:nowrap;
  border-width:var(--slds-c-badge-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(--slds-c-badge-color-border, transparent);
  border-radius:var(--slds-c-badge-radius-border, var(--slds-g-radius-border-1));
  background-color:var(--slds-c-badge-color-background, var(--slds-g-color-surface-container-3));
}
.slds-badge + .slds-badge{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-badge:empty{
  padding:0;
}
.slds-badge_inverse,.slds-badge--inverse{
  --slds-c-badge-color-background:var(
    --slds-c-badge-inverse-color-background,
    var(--slds-g-color-neutral-base-50)
  );
  --slds-c-badge-text-color:var(--slds-c-badge-inverse-text-color, var(--slds-g-color-on-surface-inverse-1));
}
.slds-badge_lightest,.slds-badge--lightest{
  /*! @css-var-fallback background-color */
  --slds-c-badge-color-background:var(
    --slds-c-badge-lightest-color-background,
    var(--slds-g-color-surface-container-1)
  );
  --slds-c-badge-color-border:var(--slds-c-badge-lightest-color-border, var(--slds-g-color-border-1));
}
.slds-badge__icon{
  display:inline-flex;
  align-items:center;
  color:var(--slds-c-badge-icon-color-foreground, var(--slds-g-color-on-surface-1));
  line-height:1;
  vertical-align:middle;
}
.slds-badge__icon.slds-badge__icon_inverse,.slds-badge__icon.slds-badge__icon--inverse{
  --slds-c-badge-icon-color-foreground:var(--slds-c-badge-icon-inverse-color-foreground, currentColor);
}
.slds-badge__icon_left,.slds-badge__icon--left{
  margin-inline-end:var(--slds-g-spacing-1);
}
.slds-badge__icon_right,.slds-badge__icon--right{
  margin-inline-start:var(--slds-g-spacing-1);
}
.slds-pill{
  display:inline-flex;
  align-items:center;
  justify-content:space-between;
  line-height:var(--slds-g-font-lineheight-1);
  max-width:100%;
  padding-block-start:var(--slds-c-pill-spacing-blockstart);
  padding-inline-end:var(--slds-c-pill-spacing-inlineend);
  padding-block-end:var(--slds-c-pill-spacing-blockend);
  padding-inline-start:var(--slds-c-pill-spacing-inlinestart, var(--slds-g-spacing-2));
  border-width:var(--slds-c-pill-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(--slds-c-pill-color-border, var(--slds-g-color-border-2));
  border-radius:var(--slds-c-pill-radius-border, var(--slds-g-radius-border-pill));
  background-color:var(--slds-c-pill-color-background, var(--slds-g-color-surface-container-1));
  box-shadow:var(--slds-c-pill-shadow);
  position:relative;
  min-height:1.625rem;
}
.slds-pill + .slds-pill{
  margin-inline-start:var(--slds-g-spacing-1);
}
.slds-pill:hover{
  --slds-c-pill-color-background:var(--slds-s-pill-color-background-hover);
}
.slds-pill:has(:focus-visible){
  outline:0;
  --slds-c-pill-color-border:var(--slds-g-color-border-2);
  --slds-c-pill-shadow:var(--slds-s-button-shadow-focus);
}
.slds-pill a{
  text-decoration:none;
}
.slds-pill .slds-popover_tooltip,.slds-pill .slds-popover--tooltip{
  width:max-content;
}
.slds-pill_bare,.slds-pill--bare{
  --slds-c-pill-color-background:transparent;
  --slds-c-pill-sizing-border:0;
}
.slds-pill_container,.slds-pill--container{
  display:flex;
  min-height:calc(1.625rem + 2px);
  padding-block-start:var(--slds-c-pill-container-spacing-blockstart, var(--slds-g-spacing-1));
  padding-inline-end:var(--slds-c-pill-container-spacing-inlineend, var(--slds-g-spacing-1));
  padding-block-end:var(--slds-c-pill-container-spacing-blockend, var(--slds-g-spacing-1));
  padding-inline-start:var(--slds-c-pill-container-spacing-inlinestart, var(--slds-g-spacing-1));
  border-width:var(--slds-c-pill-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(--slds-c-pill-color-border, var(--slds-s-input-color-border));
  border-radius:var(--slds-c-pill-radius-border, var(--slds-g-radius-border-4));
  background-color:var(--slds-c-pill-container-color-background, var(--slds-g-color-surface-1));
}
.slds-pill_container .slds-listbox_inline,.slds-pill--container .slds-listbox--inline{
  margin-inline-start:0;
  margin-inline-end:0;
}
.slds-pill__label{
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.slds-pill__label:focus{
  outline:0;
  border-radius:var(--slds-g-radius-border-1);
  box-shadow:var(--slds-c-pill-label-shadow-focus, var(--slds-s-button-shadow-focus));
}
.slds-pill__icon,
.slds-pill__icon_container,
.slds-pill__icon--container{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  margin-inline-end:var(--slds-g-spacing-1);
}
.slds-pill__icon .slds-icon,
.slds-pill__icon .slds-avatar,
.slds-pill__icon_container .slds-icon,
.slds-pill__icon--container .slds-icon,
.slds-pill__icon_container .slds-avatar,
.slds-pill__icon--container .slds-avatar{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  display:block;
  font-size:var(--slds-g-font-scale-neg-2);
}
.slds-pill__icon ~ .slds-pill__action, .slds-pill__icon_container ~ .slds-pill__action, .slds-pill__icon--container ~ .slds-pill__action{
  padding-inline-start:calc(var(--slds-g-spacing-2) + var(--slds-g-sizing-5) + var(--slds-g-sizing-2));
}
.slds-pill__remove{
  width:var(--slds-g-sizing-5);
  height:var(--slds-g-sizing-5);
  display:inline-flex;
  align-items:center;
  justify-content:flex-start;
  box-sizing:content-box;
  padding:var(--slds-g-spacing-1);
}
.slds-pill__remove svg{
  width:var(--slds-g-sizing-4);
  height:var(--slds-g-sizing-4);
}
.slds-pill__remove .slds-button_icon,.slds-pill__remove .slds-button--icon{
  color:var(--slds-g-color-accent-2);
  line-height:var(--slds-g-font-lineheight-1);
  font-size:var(--slds-g-sizing-3);
}
.slds-pill_link,.slds-pill--link{
  border:0;
  padding:0;
  align-items:stretch;
}
.slds-pill_link .slds-pill__icon_container,.slds-pill--link .slds-pill__icon--container{
  display:inline-block;
  position:absolute;
  inset-block-start:50%;
  inset-inline-start:var(--slds-g-spacing-2);
  transform:translateY(-50%);
}
.slds-pill_link .slds-pill__remove,.slds-pill--link .slds-pill__remove{
  position:absolute;
  inset-block-start:50%;
  inset-inline-end:0;
  transform:translateY(-50%);
}
.slds-pill__action{
  padding-block-start:var(--slds-c-pill-spacing-blockstart, var(--slds-g-spacing-1));
  padding-inline-end:var(--slds-c-pill-spacing-inlineend, var(--slds-g-spacing-5));
  padding-block-end:var(--slds-c-pill-spacing-blockend, var(--slds-g-spacing-1));
  padding-inline-start:var(--slds-c-pill-spacing-inlinestart, var(--slds-g-spacing-2));
  border-width:var(--slds-c-pill-sizing-border, var(--slds-g-sizing-border-1));
  border-style:solid;
  border-color:var(--slds-c-pill-color-border, var(--slds-s-input-color-border));
  border-radius:var(--slds-c-pill-radius-border, var(--slds-g-radius-border-pill));
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  flex-grow:1;
  display:flex;
}
.slds-pill__action:focus-visible{
  outline:0;
  text-decoration:none;
}
.slds-pill__action .slds-pill__label{
  align-self:center;
}
.slds-has-error{
  border-color:var(--slds-c-pill-error-color-border, var(--slds-g-color-border-error-1));
}
.slds-has-error:active{
  border-color:var(--slds-c-pill-error-color-border-active, var(--slds-g-color-border-error-1));
}
.slds-has-error .slds-pill__label{
  font-weight:var(--slds-g-font-weight-4);
  color:var(--slds-c-pill-text-color-error, var(--slds-g-color-error-1));
}
.slds-has-error .slds-button_icon,.slds-has-error .slds-button--icon{
  color:var(--slds-g-color-error-1);
}
.slds-has-error:hover{
  --slds-c-pill-text-color-error:var(--slds-g-color-error-1);
  --slds-c-pill-color-background:var(--slds-g-color-surface-container-2);
}
.slds-has-error:hover .slds-pill__icon_container .slds-icon-text-error,.slds-has-error:hover .slds-pill__icon--container .slds-icon-text-error{
  --slds-c-icon-color-foreground:var(--slds-g-color-error-1);
}
.slds-notification-container{
  position:fixed;
  display:block;
  width:var(--slds-g-sizing-15);
  inset-inline-end:var(--slds-g-spacing-1);
  inset-block-start:var(--slds-g-spacing-1);
  padding-inline:var(--slds-g-spacing-1);
  padding-block-start:var(--slds-g-spacing-1);
  padding-block-end:var(--slds-g-spacing-2);
  z-index:8500;
}
.slds-notification{
  position:relative;
  width:var(--slds-g-sizing-15);
  border:var(--slds-s-container-sizing-border, 1px) solid var(--slds-s-container-color-border);
  border-radius:var(--slds-g-radius-border-2);
  box-shadow:0 0 3px 0 rgba(0, 0, 0, 0.09), 0 3px 3px 0 rgba(0, 0, 0, 0.09), 0 -1px 1px 0 rgba(0, 0, 0, 0.04);
  transition-duration:0.4s;
  transition-timing-function:ease-in-out;
  transition-property:margin, max-height, opacity, top;
}
.slds-notification .slds-media__body{
  opacity:1;
  transition-property:opacity;
  transition-duration:0.4s;
  transition-timing-function:ease-in-out;
  padding-inline-end:var(--slds-g-spacing-5);
}
.slds-notification + .slds-notification{
  margin-block-start:var(--slds-g-spacing-3);
}
.slds-notification:nth-of-type(1){
  z-index:calc(5 - 1);
}
.slds-notification:nth-of-type(2){
  z-index:calc(5 - 2);
}
.slds-notification:nth-of-type(3){
  z-index:calc(5 - 3);
}
.slds-notification:nth-of-type(4){
  z-index:calc(5 - 4);
}
.slds-notification:nth-of-type(n + 3){
  overflow:hidden;
}
.slds-notification:nth-of-type(n + 4){
  margin-block-start:0;
  transform:scaleX(0.95) translateY(-90%);
}
.slds-notification:nth-of-type(n + 4) .slds-media__body,
.slds-notification:nth-of-type(n + 5){
  opacity:0;
}
.slds-notification:nth-of-type(n + 6){
  display:none;
}
.slds-notification__target{
  padding:var(--slds-g-spacing-3);
  border-radius:var(--slds-g-radius-border-2);
  background-color:var(--slds-g-color-surface-container-2);
  color:var(--slds-g-color-on-surface-2);
}
.slds-notification__target:hover,
.slds-notification__target:focus{
  background-color:var(--slds-g-color-surface-container-1);
  text-decoration:none;
  color:var(--slds-g-color-on-surface-2);
}
.slds-notification__target:focus-visible{
  box-shadow:var(--slds-s-button-shadow-focus);
  outline:0;
}
.slds-notification__footer{
  padding-inline:var(--slds-g-spacing-3);
  padding-block-start:var(--slds-g-spacing-3);
  padding-block-end:var(--slds-g-spacing-4);
}
.slds-notification__close{
  position:absolute;
  inset-block-start:2px;
  inset-inline-end:2px;
}
.slds-notification__close .slds-button_icon,.slds-notification__close .slds-button--icon{
  color:var(--slds-g-color-on-surface-3);
}
.slds-table{
  background-color:var(--slds-g-color-surface-container-1);
  font-size:inherit;
  color:var(--slds-s-table-color);
}
.slds-table th,
.slds-table td{
  padding:var(--slds-g-spacing-2);
  white-space:nowrap;
  position:relative;
}
.slds-table th{
  font-weight:var(--slds-g-font-weight-5);
}
.slds-table th:focus{
  outline:0;
}
.slds-table thead th{
  background-color:var(--slds-s-table-header-color-background);
  color:var(--slds-s-table-header-color);
  padding:var(--slds-g-spacing-2);
  font-weight:var(--slds-s-table-header-font-weight);
  line-height:normal;
}
.slds-table:not(.slds-no-row-hover) tbody tr:hover,
.slds-table:not(.slds-no-row-hover) tbody tr:focus{
  outline:0;
}
.slds-table:not(.slds-no-row-hover) tbody tr:hover > td,
.slds-table:not(.slds-no-row-hover) tbody tr:hover > th,
.slds-table:not(.slds-no-row-hover) tbody tr:focus > td,
.slds-table:not(.slds-no-row-hover) tbody tr:focus > th{
  background-color:var(
    --slds-s-table-row-color-background-selected,
    var(--slds-g-color-surface-container-2)
  );
}
.slds-table tbody tr.slds-is-selected > td,
.slds-table tbody tr.slds-is-selected > th{
  background-color:var(--slds-s-table-row-color-background-selected);
}
.slds-table tbody tr.slds-is-selected a{
  color:var(--slds-g-color-accent-2);
}
.slds-table .slds-cell-wrap{
  white-space:pre-line;
  overflow-wrap:break-word;
  word-wrap:break-word;
}
.slds-table .slds-cell-shrink{
  width:1%;
}
.slds-table .slds-cell-buffer_left,.slds-table .slds-cell-buffer--left{
  padding-inline-start:var(--slds-g-spacing-5);
}
.slds-table .slds-cell-buffer_right,.slds-table .slds-cell-buffer--right{
  padding-inline-end:var(--slds-g-spacing-5);
}
.slds-table tbody tr{
  counter-increment:row-number;
}
.slds-table .slds-row-number::after{
  content:counter(row-number);
}
.slds-table th:focus,
.slds-table [role='gridcell']:focus{
  outline:0;
}
.slds-table th:focus,
.slds-table th.slds-has-focus,
.slds-table [role='gridcell']:focus,
.slds-table [role='gridcell'].slds-has-focus{
  box-shadow:var(--slds-s-table-cell-shadow-selected);
}
.slds-table th:focus.slds-cell_action-mode,.slds-table th:focus.slds-cell--action-mode, .slds-table th.slds-has-focus.slds-cell_action-mode, .slds-table th.slds-has-focus.slds-cell--action-mode, .slds-table [role='gridcell']:focus.slds-cell_action-mode, .slds-table [role='gridcell']:focus.slds-cell--action-mode, .slds-table [role='gridcell'].slds-has-focus.slds-cell_action-mode, .slds-table [role='gridcell'].slds-has-focus.slds-cell--action-mode{
  border-block-end:3px solid var(--slds-g-color-border-accent-1);
}
.slds-table th:active,
.slds-table [role='gridcell']:active{
  box-shadow:none;
}
.slds-table .slds-radio [type='radio'] + .slds-radio__label .slds-radio_faux,.slds-table .slds-radio [type='radio'] + .slds-radio__label .slds-radio--faux{
  margin-inline-end:0;
}
.slds-table_cell-buffer tr > th:first-child,.slds-table--cell-buffer tr > th:first-child,
.slds-table_cell-buffer tr > td:first-child,
.slds-table--cell-buffer tr > td:first-child{
  padding-inline-start:var(--slds-g-spacing-5);
}
.slds-table_cell-buffer tr > th:last-child,.slds-table--cell-buffer tr > th:last-child,
.slds-table_cell-buffer tr > td:last-child,
.slds-table--cell-buffer tr > td:last-child{
  padding-inline-end:var(--slds-g-spacing-5);
}
.slds-table_bordered,.slds-table--bordered{
  border-collapse:collapse;
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-table_bordered thead > tr + tr > th,.slds-table--bordered thead > tr + tr > th{
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-table_bordered tbody td,.slds-table--bordered tbody td,
.slds-table_bordered tbody th,
.slds-table--bordered tbody th{
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-table_bordered:not(.slds-no-row-hover) tbody tr:hover > td:not(.slds-has-focus),.slds-table--bordered:not(.slds-no-row-hover) tbody tr:hover > td:not(.slds-has-focus),
.slds-table_bordered:not(.slds-no-row-hover) tbody tr:hover > th:not(.slds-has-focus),
.slds-table--bordered:not(.slds-no-row-hover) tbody tr:hover > th:not(.slds-has-focus),
.slds-table_bordered:not(.slds-no-row-hover) tbody tr:focus > td:not(.slds-has-focus),
.slds-table--bordered:not(.slds-no-row-hover) tbody tr:focus > td:not(.slds-has-focus),
.slds-table_bordered:not(.slds-no-row-hover) tbody tr:focus > th:not(.slds-has-focus),
.slds-table--bordered:not(.slds-no-row-hover) tbody tr:focus > th:not(.slds-has-focus){
  box-shadow:var(--slds-g-color-border-1) 0 calc(var(--slds-g-sizing-border-1) * -1) 0 inset, var(--slds-g-color-border-1) 0 var(--slds-g-sizing-border-1) 0 inset;
}
.slds-table_bordered:not(.slds-no-row-hover) tr.slds-is-selected:hover > td:not(.slds-has-focus),.slds-table--bordered:not(.slds-no-row-hover) tr.slds-is-selected:hover > td:not(.slds-has-focus),
.slds-table_bordered:not(.slds-no-row-hover) tr.slds-is-selected:hover > th:not(.slds-has-focus),
.slds-table--bordered:not(.slds-no-row-hover) tr.slds-is-selected:hover > th:not(.slds-has-focus){
  background-color:var(--slds-s-table-row-color-background-selected);
  box-shadow:var(--slds-s-table-row-color-border-selected-hover) 0 calc(var(--slds-g-sizing-border-1) * -1) 0 inset, var(--slds-s-table-row-color-border-selected-hover) 0 var(--slds-g-sizing-border-1) 0 inset;
}
.slds-table_col-bordered td + td,.slds-table--col-bordered td + td,
.slds-table_col-bordered th + th,
.slds-table--col-bordered th + th,
.slds-table_col-bordered th + td,
.slds-table--col-bordered th + td,
.slds-table_col-bordered td + th,
.slds-table--col-bordered td + th{
  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-table_striped tbody tr:nth-of-type(even) > td,.slds-table--striped tbody tr:nth-of-type(even) > td,
.slds-table_striped tbody tr:nth-of-type(even) > th,
.slds-table--striped tbody tr:nth-of-type(even) > th{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-table_fixed-layout,.slds-table--fixed-layout{
  table-layout:fixed;
  width:100%;
  white-space:nowrap;
}
.slds-table_fixed-layout thead,.slds-table--fixed-layout thead{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-table_fixed-layout tbody,.slds-table--fixed-layout tbody{
  transform:translateZ(0);
}
.slds-table_fixed-layout .slds-cell-shrink,.slds-table--fixed-layout .slds-cell-shrink{
  width:var(--slds-g-sizing-3);
}
.slds-table_fixed-layout .slds-cell-shrink:nth-child(n),.slds-table--fixed-layout .slds-cell-shrink:nth-child(n){
  padding-inline-start:0;
  padding-inline-end:0;
}
.slds-table_fixed-layout .slds-cell-shrink:first-child,.slds-table--fixed-layout .slds-cell-shrink:first-child{
  text-align:right;
  padding-inline-end:var(--slds-g-spacing-2);
}
.slds-table_fixed-layout .slds-cell-shrink:last-child,.slds-table--fixed-layout .slds-cell-shrink:last-child{
  text-align:left;
  padding-inline-start:var(--slds-g-spacing-2);
}
.slds-is-sortable .slds-th__action:hover,
.slds-is-sortable .slds-th__action:focus,
.slds-is-sortable.slds-has-focus .slds-th__action,
.slds-is-sortable.slds-has-focus .slds-th__action:hover,
.slds-is-sortable.slds-has-focus .slds-th__action:focus{
  background-color:var(--slds-s-table-header-color-background-hover);
  color:currentColor;
}
.slds-is-sortable .slds-th__action:hover .slds-is-sortable__icon, .slds-is-sortable .slds-th__action:focus .slds-is-sortable__icon, .slds-is-sortable.slds-has-focus .slds-th__action .slds-is-sortable__icon, .slds-is-sortable.slds-has-focus .slds-th__action:hover .slds-is-sortable__icon, .slds-is-sortable.slds-has-focus .slds-th__action:focus .slds-is-sortable__icon{
  display:inline-block;
  fill:var(--slds-g-color-accent-2);
}
.slds-th__action{
  display:flex;
  padding:var(--slds-g-spacing-2);
  height:2rem;
  align-items:center;
  color:currentColor;
}
.slds-th__action:focus,
.slds-th__action:hover{
  outline:0;
  background-color:var(--slds-s-table-header-color-background-hover);
}
.slds-th__action_form,.slds-th__action--form{
  display:inline-flex;
}
.slds-th__action-button{
  position:absolute;
  transform:translateY(-50%);
  top:50%;
  inset-inline-end:var(--slds-g-spacing-1);
}
.slds-th__action-button > .slds-button{
  color:var(--slds-g-color-on-surface-3);
}
.slds-th__action-button > .slds-button:hover{
  background:transparent;
}
.slds-has-button-menu .slds-th__action{
  padding-inline-end:var(--slds-g-spacing-6);
}
.slds-has-button-menu .slds-th__action-button{
  inset-inline-end:var(--slds-g-spacing-3);
}
.slds-is-sortable__icon{
  width:0.75rem;
  height:0.75rem;
  margin-inline-start:var(--slds-g-spacing-1);
  display:none;
}
.slds-is-sorted .slds-is-sortable__icon{
  display:inline-block;
}
.slds-is-sorted_asc .slds-is-sortable__icon,.slds-is-sorted--asc .slds-is-sortable__icon{
  transform:rotate(180deg);
}
.slds-table_column-1-wrap tbody tr > *:nth-child(1) .slds-truncate,.slds-table--column-1-wrap tbody tr > *:nth-child(1) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-2-wrap tbody tr > *:nth-child(2) .slds-truncate,.slds-table--column-2-wrap tbody tr > *:nth-child(2) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-3-wrap tbody tr > *:nth-child(3) .slds-truncate,.slds-table--column-3-wrap tbody tr > *:nth-child(3) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-4-wrap tbody tr > *:nth-child(4) .slds-truncate,.slds-table--column-4-wrap tbody tr > *:nth-child(4) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-5-wrap tbody tr > *:nth-child(5) .slds-truncate,.slds-table--column-5-wrap tbody tr > *:nth-child(5) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-6-wrap tbody tr > *:nth-child(6) .slds-truncate,.slds-table--column-6-wrap tbody tr > *:nth-child(6) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-7-wrap tbody tr > *:nth-child(7) .slds-truncate,.slds-table--column-7-wrap tbody tr > *:nth-child(7) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-8-wrap tbody tr > *:nth-child(8) .slds-truncate,.slds-table--column-8-wrap tbody tr > *:nth-child(8) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-9-wrap tbody tr > *:nth-child(9) .slds-truncate,.slds-table--column-9-wrap tbody tr > *:nth-child(9) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-10-wrap tbody tr > *:nth-child(10) .slds-truncate,.slds-table--column-10-wrap tbody tr > *:nth-child(10) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-11-wrap tbody tr > *:nth-child(11) .slds-truncate,.slds-table--column-11-wrap tbody tr > *:nth-child(11) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-12-wrap tbody tr > *:nth-child(12) .slds-truncate,.slds-table--column-12-wrap tbody tr > *:nth-child(12) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-13-wrap tbody tr > *:nth-child(13) .slds-truncate,.slds-table--column-13-wrap tbody tr > *:nth-child(13) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-14-wrap tbody tr > *:nth-child(14) .slds-truncate,.slds-table--column-14-wrap tbody tr > *:nth-child(14) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
.slds-table_column-15-wrap tbody tr > *:nth-child(15) .slds-truncate,.slds-table--column-15-wrap tbody tr > *:nth-child(15) .slds-truncate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:none;
  white-space:normal;
}
[class*='slds-table_column-'] tr td .slds-truncate,[class*='slds-table--column-'] tr td .slds-truncate{
  overflow:hidden;
  position:relative;
  max-height:3.25rem;
}
[class*='slds-table_column-'] tr td .slds-truncate::after,[class*='slds-table--column-'] tr td .slds-truncate::after{
  content:'';
  position:absolute;
  top:2.25rem;
  bottom:0;
  right:0;
  width:50%;
  background:linear-gradient(
    to right,
    transparent 0%,
    var(--slds-g-color-neutral-base-100, rgba(255, 255, 255, 1)) 69%
  );
}
[class*='slds-table_column-'] tr:hover td .slds-truncate::after,[class*='slds-table--column-'] tr:hover td .slds-truncate::after{
  background:linear-gradient(to right, rgba(250, 250, 249, 0) 0%, rgba(250, 250, 249, 1) 69%);
}
.slds-table_resizable-cols thead th,.slds-table--resizable-cols thead th{
  padding:0;
}
.slds-table_resizable-cols thead th:last-of-type .slds-resizable__handle,.slds-table--resizable-cols thead th:last-of-type .slds-resizable__handle{
  width:var(--slds-g-sizing-2);
  inset-inline-end:0;
}
.slds-table_resizable-cols thead th:last-of-type .slds-resizable__handle .slds-resizable__divider::before,.slds-table--resizable-cols thead th:last-of-type .slds-resizable__handle .slds-resizable__divider::before,
.slds-table_resizable-cols thead th:last-of-type .slds-resizable__handle .slds-resizable__divider::after,
.slds-table--resizable-cols thead th:last-of-type .slds-resizable__handle .slds-resizable__divider::after{
  inset-inline-end:0;
}
.slds-resizable{
  max-width:100%;
}
.slds-resizable__handle{
  width:var(--slds-g-sizing-7);
  height:100%;
  position:absolute;
  top:0;
  inset-inline-end:calc(var(--slds-g-spacing-3) * -1);
}
.slds-resizable__divider{
  position:absolute;
  right:0;
  top:0;
  width:100%;
  height:100%;
  display:block;
  cursor:col-resize;
  z-index:5000;
}
.slds-resizable__divider::before,
.slds-resizable__divider::after{
  height:100%;
  content:' ';
  display:block;
  position:absolute;
  top:0;
  inset-inline-end:var(--slds-g-spacing-3);
}
.slds-resizable__divider::before{
  background-color:var(--slds-s-table-resize-color);
  height:100%;
  width:1px;
}
.slds-resizable__divider::after{
  background-color:var(--slds-s-table-resize-color-active);
  width:1px;
  height:100vh;
  opacity:0;
}
.slds-resizable__divider:hover::before, .slds-resizable__divider:focus::before, .slds-resizable__divider:active::before{
  background-color:var(--slds-s-table-resize-color-active);
  width:var(--slds-g-sizing-2);
}
.slds-resizable__divider:hover::after, .slds-resizable__divider:focus::after, .slds-resizable__divider:active::after{
  opacity:1;
}
.slds-resizable__input:focus ~ .slds-resizable__handle .slds-resizable__divider::before{
  background-color:var(--slds-s-table-resize-color-active);
  width:var(--slds-g-sizing-2);
}
.slds-resizable__input:focus ~ .slds-resizable__handle .slds-resizable__divider::after{
  opacity:1;
}
.slds-table_header-hidden,.slds-table--header-hidden{
  border-block-start:0;
}
.slds-table_header-fixed_container,.slds-table--header-fixed_container{
  position:relative;
  padding-block-start:2rem;
  background-color:var(--slds-s-table-header-color-background);
  overflow:hidden;
}
.slds-table_header-fixed_container::before,.slds-table--header-fixed_container::before{
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
  content:'';
  display:block;
  position:relative;
  width:100%;
}
.slds-cell-fixed{
  background-color:var(--slds-s-table-header-color-background);
  position:absolute;
  inset-block-start:0;
  height:2rem;
}
.slds-table_header-fixed,.slds-table--header-fixed{
  border-block-start:0;
}
.slds-table_header-fixed thead th,.slds-table--header-fixed thead th{
  position:static;
  padding:0;
  border-block-start:0;
}
.slds-table_header-fixed tbody tr:first-child td,.slds-table--header-fixed tbody tr:first-child td,
.slds-table_header-fixed tbody tr:first-child th,
.slds-table--header-fixed tbody tr:first-child th{
  border-block-start:0;
}
.slds-table_edit_container:focus,.slds-table--edit_container:focus{
  outline:none;
}
.slds-table_edit_container:focus::before,.slds-table--edit_container:focus::before{
  content:' ';
  position:absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
  z-index:1;
  background-color:var(--slds-g-color-surface-container-2);
  box-shadow:0 0 0 4px var(--slds-g-color-accent-2) inset;
}
.slds-table_edit_container:focus .slds-table_edit_container-message,.slds-table--edit_container:focus .slds-table--edit--container-message{
  display:block;
  position:absolute;
  top:50%;
  left:50%;
  width:var(--slds-g-sizing-15);
  margin-top:-2.25rem;
  margin-inline-start:calc((var(--slds-g-sizing-15) * 0.5) * -1);
  background-color:var(--slds-g-color-surface-container-1);
  text-align:center;
  z-index:1;
}
.slds-table_edit_container-message,.slds-table--edit_container-message{
  display:none;
}
.slds-table_edit thead th,.slds-table--edit thead th{
  padding:0;
}
.slds-table_edit .slds-cell-error,.slds-table--edit .slds-cell-error{
  padding-inline-start:0;
}
.slds-table_edit:not(.slds-no-cell-focus) tbody tr:hover > .slds-cell-edit.slds-has-focus,.slds-table--edit:not(.slds-no-cell-focus) tbody tr:hover > .slds-cell-edit.slds-has-focus{
  background-color:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;
}
.slds-table_edit.slds-table tbody tr:hover > .slds-cell-edit:hover,.slds-table--edit.slds-table tbody tr:hover > .slds-cell-edit:hover{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-table_edit.slds-table tbody tr:hover > .slds-cell-edit.slds-is-edited,.slds-table--edit.slds-table tbody tr:hover > .slds-cell-edit.slds-is-edited{
  background-color:var(--slds-g-color-palette-yellow-90);
}
.slds-table_edit.slds-table tbody tr:hover > .slds-cell-edit.slds-has-error,.slds-table--edit.slds-table tbody tr:hover > .slds-cell-edit.slds-has-error{
  background-color:var(--slds-g-color-palette-yellow-90);
  box-shadow:var(--slds-g-color-error-1) 0 0 0 var(--slds-g-sizing-border-2) inset;
}
.slds-table_edit .slds-button__icon_edit:focus,.slds-table--edit .slds-button__icon--edit:focus{
  fill:var(--slds-g-color-accent-2);
}
.slds-has-focus .slds-th__action{
  background-color:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-s-table-cell-shadow-selected);
}
.slds-has-focus.slds-is-resizable .slds-th__action,
.slds-has-focus.slds-is-resizable .slds-th__action:focus,
.slds-has-focus.slds-is-resizable .slds-th__action:hover,
.slds-has-focus.slds-is-resizable .slds-th__action:focus:hover,
.slds-is-resizable .slds-th__action:focus,
.slds-is-resizable .slds-th__action:focus:hover{
  background-color:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-s-table-cell-shadow-selected), var(--slds-g-color-accent-2) -0.25rem 0 0 inset;
}
.slds-table .slds-cell-edit{
  outline:0;
}
.slds-table .slds-cell-edit.slds-has-focus{
  background-color:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;
}
.slds-table .slds-cell-edit.slds-has-focus .slds-button__icon_edit,.slds-table .slds-cell-edit.slds-has-focus .slds-button__icon--edit,
.slds-table .slds-cell-edit.slds-has-focus .slds-button__icon_lock,
.slds-table .slds-cell-edit.slds-has-focus .slds-button__icon--lock{
  opacity:1;
}
.slds-table .slds-cell-edit.slds-has-focus:hover{
  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;
}
.slds-table .slds-cell-edit.slds-has-focus a:focus{
  text-decoration:underline;
  outline:none;
}
.slds-table .slds-cell-edit.slds-is-edited,
.slds-table .slds-cell-edit.slds-is-edited:hover{
  font-weight:600;
  background-color:var(--slds-g-color-palette-yellow-90);
}
.slds-table .slds-cell-edit.slds-has-error,
.slds-table .slds-cell-edit.slds-has-error:hover{
  font-weight:600;
  background-color:var(--slds-g-color-palette-yellow-90);
  box-shadow:var(--slds-g-color-error-1) 0 0 0 var(--slds-g-sizing-border-2) inset;
}
.slds-table .slds-cell-edit.slds-has-error a{
  color:currentColor;
}
.slds-cell-edit__button{
  width:1.25rem;
  height:1.25rem;
  flex-shrink:0;
}
.slds-cell-edit__button:focus .slds-button__icon_edit,.slds-cell-edit__button:focus .slds-button__icon--edit{
  opacity:1;
}
.slds-cell-edit__button[disabled],
.slds-cell-edit__button:disabled{
  color:var(--slds-g-color-disabled-1);
}
.slds-no-cell-focus .slds-has-focus{
  background:var(--slds-g-color-surface-container-2);
  box-shadow:none;
}
.slds-no-cell-focus .slds-has-focus .slds-th__action,
.slds-no-cell-focus .slds-has-focus .slds-th__action:hover,
.slds-no-cell-focus .slds-has-focus .slds-th__action:focus,
.slds-no-cell-focus .slds-has-focus .slds-th__action:focus:hover{
  color:inherit;
  background-color:var(--slds-g-color-surface-container-1);
  box-shadow:none;
}
.slds-no-cell-focus .slds-has-focus .slds-button__icon_edit,.slds-no-cell-focus .slds-has-focus .slds-button__icon--edit{
  opacity:1;
}
.slds-no-cell-focus .slds-has-focus.slds-is-resizable:hover .slds-th__action{
  background-color:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-g-color-border-1) -0.25rem 0 0 inset;
}
.slds-no-cell-focus .slds-is-sortable.slds-has-focus .slds-is-sortable__icon{
  display:none;
}
.slds-no-cell-focus .slds-is-sorted.slds-has-focus .slds-is-sortable__icon{
  display:inline-block;
  fill:var(--slds-g-color-on-surface-1);
}
.slds-no-cell-focus .slds-is-edited,
.slds-no-cell-focus .slds-is-edited:hover{
  background-color:var(--slds-g-color-palette-yellow-90);
  color:var(--slds-g-color-on-warning-1);
}
.slds-no-cell-focus .slds-has-error,
.slds-no-cell-focus .slds-has-error:hover{
  background-color:var(--slds-g-color-palette-yellow-90);
  box-shadow:var(--slds-g-color-error-1) 0 0 0 var(--slds-g-sizing-border-2) inset;
}
.slds-no-cell-focus thead .slds-has-focus:hover{
  color:var(--slds-s-link-color);
}
.slds-no-cell-focus thead .slds-has-focus:hover .slds-is-sortable__icon{
  display:inline-block;
  fill:var(--slds-s-link-color);
}
.slds-hint-parent .slds-cell-edit .slds-button__icon_edit,.slds-hint-parent .slds-cell-edit .slds-button__icon--edit,
.slds-hint-parent .slds-cell-edit .slds-button__icon_lock,
.slds-hint-parent .slds-cell-edit .slds-button__icon--lock{
  opacity:0;
}
.slds-hint-parent .slds-cell-edit:hover .slds-button__icon_edit,.slds-hint-parent .slds-cell-edit:hover .slds-button__icon--edit, .slds-hint-parent .slds-cell-edit:focus .slds-button__icon_edit, .slds-hint-parent .slds-cell-edit:focus .slds-button__icon--edit{
  opacity:1;
  fill:var(--slds-g-color-accent-2);
}
.slds-hint-parent .slds-cell-edit:hover .slds-button__icon_edit:hover,.slds-hint-parent .slds-cell-edit:hover .slds-button__icon--edit:hover,
.slds-hint-parent .slds-cell-edit:hover .slds-button__icon_edit:focus,
.slds-hint-parent .slds-cell-edit:hover .slds-button__icon--edit:focus,
.slds-hint-parent .slds-cell-edit:focus .slds-button__icon_edit:hover,
.slds-hint-parent .slds-cell-edit:focus .slds-button__icon--edit:hover,
.slds-hint-parent .slds-cell-edit:focus .slds-button__icon_edit:focus,
.slds-hint-parent .slds-cell-edit:focus .slds-button__icon--edit:focus{
  fill:var(--slds-g-color-accent-2);
  opacity:1;
}
.slds-hint-parent .slds-cell-edit:hover .slds-button__icon_lock,.slds-hint-parent .slds-cell-edit:hover .slds-button__icon--lock, .slds-hint-parent .slds-cell-edit:focus .slds-button__icon_lock, .slds-hint-parent .slds-cell-edit:focus .slds-button__icon--lock{
  opacity:1;
}
.slds-hint-parent .slds-cell-edit:hover .slds-button_icon:hover .slds-button__icon_edit,.slds-hint-parent .slds-cell-edit:hover .slds-button--icon:hover .slds-button__icon--edit, .slds-hint-parent .slds-cell-edit:hover .slds-button_icon:focus .slds-button__icon_edit, .slds-hint-parent .slds-cell-edit:hover .slds-button--icon:focus .slds-button__icon--edit, .slds-hint-parent .slds-cell-edit:focus .slds-button_icon:hover .slds-button__icon_edit, .slds-hint-parent .slds-cell-edit:focus .slds-button--icon:hover .slds-button__icon--edit, .slds-hint-parent .slds-cell-edit:focus .slds-button_icon:focus .slds-button__icon_edit, .slds-hint-parent .slds-cell-edit:focus .slds-button--icon:focus .slds-button__icon--edit{
  fill:var(--slds-g-color-on-surface-3);
}
.slds-hint-parent .slds-cell-edit.slds-has-focus .slds-button__icon_edit,.slds-hint-parent .slds-cell-edit.slds-has-focus .slds-button__icon--edit{
  fill:var(--slds-g-color-on-surface-3);
  opacity:1;
}
.slds-form-element__label_edit,.slds-form-element__label--edit{
  margin-block:0;
  margin-inline:0.125rem;
}
.slds-popover_edit,.slds-popover--edit{
  border-block-start:0;
  border-start-start-radius:0;
  border-start-end-radius:0;
}
.slds-popover_edit .slds-popover__body,.slds-popover--edit .slds-popover__body{
  padding:var(--slds-g-spacing-1);
  padding-inline-start:0;
}
.slds-popover_edit .slds-form-element__help,.slds-popover--edit .slds-form-element__help{
  width:100%;
  padding-inline-start:var(--slds-g-spacing-2);
}
.slds-table_joined table,.slds-table--joined table,
.slds-table.slds-has-top-magnet table{
  border-radius:0 0 var(--slds-g-radius-border-2) var(--slds-g-radius-border-2);
  box-shadow:var(--slds-s-container-shadow, var(--slds-g-shadow-1));
}
.slds-table_joined-wrapper,.slds-table--joined-wrapper{
  padding:var(--slds-g-spacing-4) var(--slds-g-spacing-4) 0 var(--slds-g-spacing-4);
  border-radius:var(--slds-g-radius-border-2);
  background-clip:padding-box;
}
.slds-table_joined-wrapper .slds-table,.slds-table--joined-wrapper .slds-table{
  border-radius:0 0 var(--slds-g-radius-border-2) var(--slds-g-radius-border-2);
  box-shadow:var(--slds-s-container-shadow, var(--slds-g-shadow-1));
}
.slds-section{
  margin-block:var(--slds-g-spacing-2);
}
.slds-section.slds-is-open .slds-section__title-action-icon{
  transform:rotate(0deg);
  transform-origin:45%;
}
.slds-section.slds-is-open .slds-section__content{
  padding-top:var(--slds-g-spacing-2);
  overflow:visible;
  visibility:visible;
  opacity:1;
  height:auto;
  color:var(--slds-g-color-on-surface-1);
}
.slds-section__title{
  display:flex;
  align-items:center;
  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2));
  line-height:1.875rem;
  border:var(--slds-g-sizing-border-1) solid transparent;
  border-radius:var(--slds-g-radius-border-2);
}
.slds-section__title .slds-button{
  --slds-c-button-radius-border:var(--slds-g-radius-border-2);
}
.slds-section__title-action{
  display:flex;
  align-items:center;
  background-color:var(--slds-g-color-surface-container-2);
  cursor:pointer;
  width:100%;
  text-align:left;
  color:var(--slds-g-color-on-surface-3);
  font-size:inherit;
  font-weight:var(--slds-s-container-heading-font-weight);
  padding:0 var(--slds-g-spacing-2);
}
.slds-section__title-action:hover,
.slds-section__title-action:focus,
.slds-section__title-action:active{
  background-color:var(--slds-g-color-surface-container-2);
  color:inherit;
}
.slds-section__content{
  overflow:hidden;
  visibility:hidden;
  opacity:0;
  height:0;
}
.slds-section__title-action-icon{
  transform:rotate(-90deg);
}
.slds-section-title_divider,.slds-section-title--divider{
  font-size:var(--slds-g-font-scale-neg-1);
  line-height:var(--slds-g-font-lineheight-2);
  color:var(--slds-g-color-neutral-base-30);
  text-transform:uppercase;
  letter-spacing:0.0625rem;
  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-4);
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-illustration{
  text-align:center;
}
.slds-illustration.slds-illustration_small .slds-illustration__svg,.slds-illustration.slds-illustration--small .slds-illustration__svg{
  width:100%;
  max-width:300px;
  max-height:200px;
  margin-block-end:var(--slds-g-spacing-4);
}
.slds-illustration.slds-illustration_large .slds-illustration__svg,.slds-illustration.slds-illustration--large .slds-illustration__svg{
  width:100%;
  max-width:600px;
  max-height:400px;
  margin-block-end:var(--slds-g-spacing-8);
}
.slds-illustration.slds-illustration_large .slds-illustration__header,.slds-illustration.slds-illustration--large .slds-illustration__header{
  margin-block-end:var(--slds-g-spacing-5);
}
.slds-illustration.slds-illustration_large p,.slds-illustration.slds-illustration--large p{
  margin-block-end:var(--slds-g-spacing-8);
}
.slds-illustration .slds-illustration__stroke-primary{
  stroke:var(--slds-g-color-palette-cloud-blue-80);
}
.slds-illustration .slds-illustration__stroke-secondary{
  stroke:var(--slds-g-color-palette-cloud-blue-90);
}
.slds-illustration .slds-illustration__fill-primary{
  fill:var(--slds-g-color-palette-cloud-blue-80);
}
.slds-illustration .slds-illustration__fill-secondary{
  fill:var(--slds-g-color-palette-cloud-blue-90);
}
.slds-region{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-region__pinned-top{
  background-color:var(--slds-g-color-surface-container-1);
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-region__pinned-left{
  background-color:var(--slds-g-color-surface-container-1);
  border-inline-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-region__pinned-right{
  background-color:var(--slds-g-color-surface-container-1);
  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-map_container,.slds-map--container{
  flex:3 1 auto;
}
.slds-map{
  position:relative;
  min-width:23.75rem;
  width:100%;
  max-height:100%;
}
.slds-map::before{
  content:'';
  display:block;
  height:0;
  width:100%;
  padding-block-start:56.25%;
}
.slds-map iframe{
  position:absolute;
  inset-block-start:0;
  inset-inline-start:0;
  inset-inline-end:0;
  height:100%;
  width:100%;
  border:0;
}
.slds-has-coordinates{
  display:flex;
  flex-wrap:wrap;
  overflow:auto;
  max-height:41.25rem;
  background:var(--slds-g-color-surface-container-1);
}
.slds-has-coordinates .slds-map::before{
  padding-block-start:75%;
}
.slds-coordinates{
  overflow:auto;
  flex:1 1 auto;
}
.slds-coordinates__header{
  padding:var(--slds-g-spacing-4);
}
.slds-coordinates__title{
  font-size:var(--slds-g-font-scale-2);
  font-weight:var(--slds-g-font-weight-6);
}
.slds-coordinates__item-action{
  padding-inline:var(--slds-g-spacing-4);
  padding-block:var(--slds-g-spacing-2);
  width:100%;
}
.slds-coordinates__item-action.slds-media{
  align-items:center;
}
.slds-coordinates__item-action .slds-text-link{
  display:block;
}
.slds-coordinates__item-action:hover,
.slds-coordinates__item-action:focus{
  background-color:var(--slds-s-menu-item-color-background-active);
  outline:0;
}
.slds-coordinates__item-action:hover .slds-text-link, .slds-coordinates__item-action:focus .slds-text-link{
  text-decoration:underline;
}
.slds-coordinates__item-action:focus-visible{
  box-shadow:0 0 0 2px var(--slds-g-color-brand-base-15) inset, 0 0 0 4px var(--slds-g-color-surface-1) inset;
}
.slds-coordinates__item-action:active{
  background-color:var(--slds-s-menu-item-color-background-active);
}
.slds-coordinates__item-action[aria-pressed='true']{
  background-color:var(--slds-s-menu-item-color-background-active);
}
.slds-welcome-mat{
  --_slds-c-welcomemat-image-background:var(
    --lwc-welcomeMatBackgroundImageInfo
  );
  position:relative;
}
.slds-welcome-mat__content{
  min-height:25rem;
  max-height:37.5rem;
}
.slds-welcome-mat__content .slds-progress-bar{
  display:inline-block;
  width:12.5rem;
  background:var(--slds-g-color-surface-1);
}
.slds-welcome-mat__content .slds-progress-bar__value{
  background:var(--slds-g-color-success-1);
}
.slds-welcome-mat__info{
  display:flex;
  overflow:auto;
  padding-block:var(--slds-g-spacing-4) 7.75rem;
  padding-inline:var(--slds-g-spacing-8);
  color:var(--slds-g-color-brand-base-20);
  background-image:var(--_slds-c-welcomemat-image-background);
  background-position:bottom center;
  background-repeat:no-repeat;
  background-size:contain;
  background-color:var(--sds-g-color-palette-cloud-blue-90);
  align-items:center;
}
.slds-welcome-mat__info-content{
  margin:auto;
  text-align:center;
}
.slds-welcome-mat__info-title{
  margin-block-end:var(--slds-g-spacing-5);
  font-size:var(--slds-g-font-scale-7);
  font-weight:var(--slds-g-font-weight-7);
  line-height:var(--slds-g-font-lineheight-2);
}
.slds-welcome-mat__info-description{
  margin-block-end:var(--slds-g-spacing-5);
}
.slds-welcome-mat__info-progress{
  margin-block-end:var(--slds-g-spacing-4);
}
.slds-welcome-mat__tiles{
  background:var(--slds-g-color-surface-container-2);
  overflow:auto;
  padding:var(--slds-g-spacing-4);
}
.slds-welcome-mat__tile{
  margin-block:var(--slds-g-spacing-4);
  margin-inline:0;
  box-shadow:var(--slds-g-shadow-2);
  border-radius:var(--slds-g-radius-border-2);
  background:var(--slds-g-color-neutral-base-100);
}
.slds-welcome-mat__tile:hover{
  box-shadow:0 0 0 1px var(--slds-g-color-border-accent-1) inset, var(--slds-g-shadow-2);
}
.slds-welcome-mat__tile .slds-media{
  padding:var(--slds-g-spacing-3);
}
.slds-welcome-mat__tile .slds-icon-action-check{
  display:none;
}
.slds-welcome-mat__tile:first-child{
  margin-block-start:0;
}
.slds-welcome-mat__tile:last-child{
  margin-block-end:0;
}
.slds-welcome-mat__tile.slds-welcome-mat__tile_complete,.slds-welcome-mat__tile.slds-welcome-mat__tile--complete,
.slds-welcome-mat__tile.slds-welcome-mat__tile_info-only,
.slds-welcome-mat__tile.slds-welcome-mat__tile--info-only{
  box-shadow:none;
}
.slds-welcome-mat__tile-figure{
  margin-inline-start:var(--slds-g-spacing-1);
}
.slds-welcome-mat__tile-title{
  font-weight:var(--slds-g-font-weight-7);
}
.slds-welcome-mat__tile-body{
  padding:var(--slds-g-spacing-3);
  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-welcome-mat__tile-description{
  color:var(--slds-g-color-on-surface-3);
  font-size:var(--slds-g-font-scale-neg-1);
  line-height:var(--slds-g-font-lineheight-3);
}
.slds-welcome-mat__tile-icon-container{
  position:relative;
}
.slds-welcome-mat__tile_complete,.slds-welcome-mat__tile--complete{
  background:transparent;
}
.slds-welcome-mat__tile_complete .slds-icon,.slds-welcome-mat__tile--complete .slds-icon{
  fill:var(--slds-g-color-neutral-base-80);
}
.slds-welcome-mat__tile_complete .slds-icon-action-check,.slds-welcome-mat__tile--complete .slds-icon-action-check{
  position:absolute;
  inset-block-end:calc(var(--slds-g-sizing-6) * 0.5 * -1);
  inset-inline-end:calc(var(--slds-g-sizing-6) * 0.5 * -1);
  height:var(--slds-g-sizing-6);
  width:var(--slds-g-sizing-6);
  display:flex;
  align-items:center;
  justify-content:center;
  padding:0.25rem;
  border:var(--slds-g-sizing-borde-2) solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-sizing-6);
  line-height:0;
  background:var(--slds-g-color-success-1);
}
.slds-welcome-mat__tile_complete .slds-icon-action-check .slds-icon,.slds-welcome-mat__tile--complete .slds-icon-action-check .slds-icon{
  fill:var(--slds-g-color-neutral-base-100);
}
.slds-welcome-mat_info-only .slds-welcome-mat__content,.slds-welcome-mat--info-only .slds-welcome-mat__content{
  height:37.5rem;
}
.slds-welcome-mat_info-only .slds-welcome-mat__info-title,.slds-welcome-mat--info-only .slds-welcome-mat__info-title{
  font-size:var(--slds-g-font-scale-7);
}
.slds-welcome-mat__tiles_info-only,.slds-welcome-mat__tiles--info-only{
  background-color:var(--slds-g-color-surface-container-1);
}
.slds-welcome-mat__tile_info-only .slds-welcome-mat__tile-body,.slds-welcome-mat__tile--info-only .slds-welcome-mat__tile-body{
  border-inline-start:0;
}
.slds-welcome-mat_splash .slds-welcome-mat__content,.slds-welcome-mat--splash .slds-welcome-mat__content{
  height:37.5rem;
}
.slds-welcome-mat_splash .slds-welcome-mat__info-content,.slds-welcome-mat--splash .slds-welcome-mat__info-content{
  max-width:37.5rem;
}
.slds-welcome-mat_splash .slds-welcome-mat__info-title,.slds-welcome-mat--splash .slds-welcome-mat__info-title{
  font-size:var(--slds-g-font-scale-7);
}
.slds-welcome-mat__info-badge-container{
  display:inline-block;
  position:relative;
}
.slds-welcome-mat__info-badge-container .slds-icon-action-check{
  border-width:0;
  top:50%;
  right:0%;
  transform:translate3d(50%, -50%, 0);
  display:none;
}
.slds-welcome-mat__info-badge{
  margin-block-end:var(--slds-g-spacing-3);
}
.slds-welcome-mat__info-progress_complete .slds-icon-action-check,.slds-welcome-mat__info-progress--complete .slds-icon-action-check{
  display:flex;
}
.slds-summary-detail{
  display:flex;
  align-items:flex-start;
}
.slds-summary-detail .slds-summary-detail__action-icon{
  transform:rotate(-90deg);
}
.slds-summary-detail .slds-summary-detail__content{
  overflow:hidden;
  visibility:hidden;
  opacity:0;
  height:0;
}
[dir='rtl'] .slds-summary-detail .slds-summary-detail__action-icon{
  transform:rotate(90deg);
}
.slds-summary-detail.slds-is-open .slds-summary-detail__action-icon{
  transform:rotate(0deg);
  transform-origin:45%;
}
.slds-summary-detail.slds-is-open .slds-summary-detail__content{
  padding-block-start:var(--slds-g-spacing-3);
  overflow:visible;
  visibility:visible;
  opacity:1;
  height:auto;
}
.slds-setup-assistant{
  padding:var(--slds-g-spacing-4);
}
.slds-setup-assistant__item{
  border-block-end:1px var(--slds-g-color-disabled-1) solid;
  padding-block:var(--slds-g-spacing-6);
  padding-inline:0;
}
.slds-setup-assistant__item:first-child{
  padding-block-start:0;
}
.slds-setup-assistant__item:last-child{
  padding-block-end:0;
  border-bottom:0;
}
.slds-setup-assistant__step-summary .slds-progress-ring_large,.slds-setup-assistant__step-summary .slds-progress-ring--large{
  top:1px;
}
[dir='rtl'] .slds-setup-assistant__step-summary .slds-media__figure{
  margin-inline-start:var(--slds-g-spacing-3);
}
.slds-setup-assistant__step-summary-content{
  margin-inline-end:var(--slds-g-spacing-8);
}
[dir='rtl'] .slds-setup-assistant__step-summary-content{
  margin-inline-end:0;
}
.slds-setup-assistant__step-summary-title{
  padding-block-end:var(--slds-g-spacing-2);
  font-weight:var(--slds-g-font-weight-7);
}
.slds-setup-assistant__step-detail{
  padding-inline-start:2.75rem;
}
[dir='rtl'] .slds-setup-assistant__step-detail{
  padding-inline-end:var(--slds-g-spacing-5);
  padding-inline-start:var(--slds-g-spacing-4);
}
[dir='rtl'] .slds-setup-assistant__step-detail .slds-media_center,[dir='rtl'] .slds-setup-assistant__step-detail .slds-media--center{
  margin-inline-end:var(--slds-g-spacing-4);
}
[dir='rtl'] .slds-setup-assistant__step-detail .slds-media__figure{
  margin-inline-start:var(--slds-g-spacing-3);
}
.slds-grid{
  display:flex;
}
.slds-grid_frame,.slds-grid--frame{
  min-width:100vw;
  min-height:100vh;
  overflow:hidden;
}
.slds-grid_vertical,.slds-grid--vertical{
  flex-direction:column;
}
.slds-grid_vertical-reverse,.slds-grid--vertical-reverse{
  flex-direction:column-reverse;
}
.slds-grid_reverse,.slds-grid--reverse{
  flex-direction:row-reverse;
}
.slds-wrap{
  flex-wrap:wrap;
  align-items:flex-start;
}
.slds-nowrap{
  flex:1 1 auto;
  flex-wrap:nowrap;
  align-items:stretch;
}
@media (min-width: 30em){
  .slds-nowrap_small,.slds-nowrap--small{
    flex:1 1 auto;
    flex-wrap:nowrap;
    align-items:stretch;
  }
}
@media (min-width: 48em){
  .slds-nowrap_medium,.slds-nowrap--medium{
    flex:1 1 auto;
    flex-wrap:nowrap;
    align-items:stretch;
  }
}
@media (min-width: 64em){
  .slds-nowrap_large,.slds-nowrap--large{
    flex:1 1 auto;
    flex-wrap:nowrap;
    align-items:stretch;
  }
}
.slds-gutters{
  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);
}
.slds-gutters .slds-col{
  padding-inline-end:var(--slds-g-spacing-3);
  padding-inline-start:var(--slds-g-spacing-3);
}
.slds-gutters_xxx-small,.slds-gutters--xxx-small{
  margin-inline-end:calc(0.125rem * -1);
  margin-inline-start:calc(0.125rem * -1);
}
.slds-gutters_xxx-small .slds-col,.slds-gutters--xxx-small .slds-col{
  padding-inline-end:0.125rem;
  padding-inline-start:0.125rem;
}
.slds-gutters_xx-small,.slds-gutters--xx-small{
  margin-inline-end:calc(var(--slds-g-spacing-1) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-1) * -1);
}
.slds-gutters_xx-small .slds-col,.slds-gutters--xx-small .slds-col{
  padding-inline-end:var(--slds-g-spacing-1);
  padding-inline-start:var(--slds-g-spacing-1);
}
.slds-gutters_x-small,.slds-gutters--x-small{
  margin-inline-end:calc(var(--slds-g-spacing-2) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-2) * -1);
}
.slds-gutters_x-small .slds-col,.slds-gutters--x-small .slds-col{
  padding-inline-end:var(--slds-g-spacing-2);
  padding-inline-start:var(--slds-g-spacing-2);
}
.slds-gutters_small,.slds-gutters--small{
  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);
}
.slds-gutters_small .slds-col,.slds-gutters--small .slds-col{
  padding-inline-end:var(--slds-g-spacing-3);
  padding-inline-start:var(--slds-g-spacing-3);
}
.slds-gutters_medium,.slds-gutters--medium{
  margin-inline-end:calc(var(--slds-g-spacing-4) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-4) * -1);
}
.slds-gutters_medium .slds-col,.slds-gutters--medium .slds-col{
  padding-inline-end:var(--slds-g-spacing-4);
  padding-inline-start:var(--slds-g-spacing-4);
}
.slds-gutters_large,.slds-gutters--large{
  margin-inline-end:calc(var(--slds-g-spacing-5) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-5) * -1);
}
.slds-gutters_large .slds-col,.slds-gutters--large .slds-col{
  padding-inline-end:var(--slds-g-spacing-5);
  padding-inline-start:var(--slds-g-spacing-5);
}
.slds-gutters_x-large,.slds-gutters--x-large{
  margin-inline-end:calc(var(--slds-g-spacing-6) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-6) * -1);
}
.slds-gutters_x-large .slds-col,.slds-gutters--x-large .slds-col{
  padding-inline-end:var(--slds-g-spacing-6);
  padding-inline-start:var(--slds-g-spacing-6);
}
.slds-gutters_xx-large,.slds-gutters--xx-large{
  margin-inline-end:calc(var(--slds-g-spacing-8) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-8) * -1);
}
.slds-gutters_xx-large .slds-col,.slds-gutters--xx-large .slds-col{
  padding-inline-end:var(--slds-g-spacing-8);
  padding-inline-start:var(--slds-g-spacing-8);
}
.slds-gutters_direct,.slds-gutters--direct{
  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);
}
.slds-gutters_direct > .slds-col,.slds-gutters--direct > .slds-col{
  padding-inline-end:var(--slds-g-spacing-3);
  padding-inline-start:var(--slds-g-spacing-3);
}
.slds-gutters_direct-xxx-small,.slds-gutters--direct-xxx-small{
  margin-inline-end:calc(0.125rem * -1);
  margin-inline-start:calc(0.125rem * -1);
}
.slds-gutters_direct-xxx-small > .slds-col,.slds-gutters--direct-xxx-small > .slds-col{
  padding-inline-end:0.125rem;
  padding-inline-start:0.125rem;
}
.slds-gutters_direct-xx-small,.slds-gutters--direct-xx-small{
  margin-inline-end:calc(var(--slds-g-spacing-1) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-1) * -1);
}
.slds-gutters_direct-xx-small > .slds-col,.slds-gutters--direct-xx-small > .slds-col{
  padding-inline-end:var(--slds-g-spacing-1);
  padding-inline-start:var(--slds-g-spacing-1);
}
.slds-gutters_direct-x-small,.slds-gutters--direct-x-small{
  margin-inline-end:calc(var(--slds-g-spacing-2) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-2) * -1);
}
.slds-gutters_direct-x-small > .slds-col,.slds-gutters--direct-x-small > .slds-col{
  padding-inline-end:var(--slds-g-spacing-2);
  padding-inline-start:var(--slds-g-spacing-2);
}
.slds-gutters_direct-small,.slds-gutters--direct-small{
  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);
}
.slds-gutters_direct-small > .slds-col,.slds-gutters--direct-small > .slds-col{
  padding-inline-end:var(--slds-g-spacing-3);
  padding-inline-start:var(--slds-g-spacing-3);
}
.slds-gutters_direct-medium,.slds-gutters--direct-medium{
  margin-inline-end:calc(var(--slds-g-spacing-4) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-4) * -1);
}
.slds-gutters_direct-medium > .slds-col,.slds-gutters--direct-medium > .slds-col{
  padding-inline-end:var(--slds-g-spacing-4);
  padding-inline-start:var(--slds-g-spacing-4);
}
.slds-gutters_direct-large,.slds-gutters--direct-large{
  margin-inline-end:calc(var(--slds-g-spacing-5) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-5) * -1);
}
.slds-gutters_direct-large > .slds-col,.slds-gutters--direct-large > .slds-col{
  padding-inline-end:var(--slds-g-spacing-5);
  padding-inline-start:var(--slds-g-spacing-5);
}
.slds-gutters_direct-x-large,.slds-gutters--direct-x-large{
  margin-inline-end:calc(var(--slds-g-spacing-6) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-6) * -1);
}
.slds-gutters_direct-x-large > .slds-col,.slds-gutters--direct-x-large > .slds-col{
  padding-inline-end:var(--slds-g-spacing-6);
  padding-inline-start:var(--slds-g-spacing-6);
}
.slds-gutters_direct-xx-large,.slds-gutters--direct-xx-large{
  margin-inline-end:calc(var(--slds-g-spacing-8) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-8) * -1);
}
.slds-gutters_direct-xx-large > .slds-col,.slds-gutters--direct-xx-large > .slds-col{
  padding-inline-end:var(--slds-g-spacing-8);
  padding-inline-start:var(--slds-g-spacing-8);
}
.slds-grid_pull-padded,.slds-grid--pull-padded{
  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);
}
.slds-grid_pull-padded-xxx-small,.slds-grid--pull-padded-xxx-small{
  margin-inline-end:calc(0.125rem * -1);
  margin-inline-start:calc(0.125rem * -1);
}
.slds-grid_pull-padded-xx-small,.slds-grid--pull-padded-xx-small{
  margin-inline-end:calc(var(--slds-g-spacing-1) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-1) * -1);
}
.slds-grid_pull-padded-x-small,.slds-grid--pull-padded-x-small{
  margin-inline-end:calc(var(--slds-g-spacing-2) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-2) * -1);
}
.slds-grid_pull-padded-small,.slds-grid--pull-padded-small{
  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);
}
.slds-grid_pull-padded-medium,.slds-grid--pull-padded-medium{
  margin-inline-end:calc(var(--slds-g-spacing-4) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-4) * -1);
}
.slds-grid_pull-padded-large,.slds-grid--pull-padded-large{
  margin-inline-end:calc(var(--slds-g-spacing-5) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-5) * -1);
}
.slds-grid_pull-padded-x-large,.slds-grid--pull-padded-x-large{
  margin-inline-end:calc(var(--slds-g-spacing-6) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-6) * -1);
}
.slds-grid_pull-padded-xx-large,.slds-grid--pull-padded-xx-large{
  margin-inline-end:calc(var(--slds-g-spacing-8) * -1);
  margin-inline-start:calc(var(--slds-g-spacing-8) * -1);
}
.slds-col,
.slds-col_padded-around-medium,
.slds-col--padded-around-medium,
.slds-col_padded-medium,
.slds-col--padded-medium,
.slds-col_padded-around-large,
.slds-col--padded-around-large,
.slds-col_padded-large,
.slds-col--padded-large,
.slds-col_padded-around,
.slds-col--padded-around,
.slds-col_padded,
.slds-col--padded{
  flex:1 1 auto;
}
.slds-col{
  flex:1 1 auto;
}
@media (min-width: 64em){
  .slds-col_rule-top,.slds-col--rule-top{
    border-inline-start:1px solid var(--slds-g-color-border-1);
  }
}
@media (min-width: 64em){
  .slds-col_rule-right,.slds-col--rule-right{
    border-inline-end:1px solid var(--slds-g-color-border-1);
  }
}
@media (min-width: 64em){
  .slds-col_rule-bottom,.slds-col--rule-bottom{
    border-block-end:1px solid var(--slds-g-color-border-1);
  }
}
@media (min-width: 64em){
  .slds-col_rule-left,.slds-col--rule-left{
    border-inline-start:1px solid var(--slds-g-color-border-1);
  }
}
.slds-has-flexi-truncate{
  flex:1 1;
  min-width:0;
}
.slds-no-flex{
  flex:none;
}
.slds-no-space{
  min-width:0;
}
.slds-grow{
  flex-grow:1;
}
.slds-grow-none{
  flex-grow:0;
}
.slds-shrink{
  flex-shrink:1;
}
.slds-shrink-none{
  flex-shrink:0;
}
.slds-text-longform ul.slds-grid{
  margin-inline-start:0;
  list-style:none;
}
.slds-grid_align-center,.slds-grid--align-center{
  justify-content:center;
}
.slds-grid_align-center .slds-col,.slds-grid--align-center .slds-col,
.slds-grid_align-center .slds-col_padded-around-medium,
.slds-grid--align-center .slds-col--padded-around-medium,
.slds-grid_align-center .slds-col_padded-medium,
.slds-grid--align-center .slds-col--padded-medium,
.slds-grid_align-center .slds-col_padded-around-large,
.slds-grid--align-center .slds-col--padded-around-large,
.slds-grid_align-center .slds-col_padded-large,
.slds-grid--align-center .slds-col--padded-large,
.slds-grid_align-center .slds-col_padded-around,
.slds-grid--align-center .slds-col--padded-around,
.slds-grid_align-center .slds-col_padded,
.slds-grid--align-center .slds-col--padded{
  flex-grow:0;
}
.slds-grid_align-space,.slds-grid--align-space{
  justify-content:space-around;
}
.slds-grid_align-space .slds-col,.slds-grid--align-space .slds-col,
.slds-grid_align-space .slds-col_padded-around-medium,
.slds-grid--align-space .slds-col--padded-around-medium,
.slds-grid_align-space .slds-col_padded-medium,
.slds-grid--align-space .slds-col--padded-medium,
.slds-grid_align-space .slds-col_padded-around-large,
.slds-grid--align-space .slds-col--padded-around-large,
.slds-grid_align-space .slds-col_padded-large,
.slds-grid--align-space .slds-col--padded-large,
.slds-grid_align-space .slds-col_padded-around,
.slds-grid--align-space .slds-col--padded-around,
.slds-grid_align-space .slds-col_padded,
.slds-grid--align-space .slds-col--padded{
  flex-grow:0;
}
.slds-grid_align-spread,.slds-grid--align-spread{
  justify-content:space-between;
}
.slds-grid_align-spread .slds-col,.slds-grid--align-spread .slds-col,
.slds-grid_align-spread .slds-col_padded-around-medium,
.slds-grid--align-spread .slds-col--padded-around-medium,
.slds-grid_align-spread .slds-col_padded-medium,
.slds-grid--align-spread .slds-col--padded-medium,
.slds-grid_align-spread .slds-col_padded-around-large,
.slds-grid--align-spread .slds-col--padded-around-large,
.slds-grid_align-spread .slds-col_padded-large,
.slds-grid--align-spread .slds-col--padded-large,
.slds-grid_align-spread .slds-col_padded-around,
.slds-grid--align-spread .slds-col--padded-around,
.slds-grid_align-spread .slds-col_padded,
.slds-grid--align-spread .slds-col--padded{
  flex-grow:0;
}
.slds-grid_align-end,.slds-grid--align-end{
  justify-content:flex-end;
}
.slds-grid_align-end .slds-col,.slds-grid--align-end .slds-col,
.slds-grid_align-end .slds-col_padded-around-medium,
.slds-grid--align-end .slds-col--padded-around-medium,
.slds-grid_align-end .slds-col_padded-medium,
.slds-grid--align-end .slds-col--padded-medium,
.slds-grid_align-end .slds-col_padded-around-large,
.slds-grid--align-end .slds-col--padded-around-large,
.slds-grid_align-end .slds-col_padded-large,
.slds-grid--align-end .slds-col--padded-large,
.slds-grid_align-end .slds-col_padded-around,
.slds-grid--align-end .slds-col--padded-around,
.slds-grid_align-end .slds-col_padded,
.slds-grid--align-end .slds-col--padded{
  flex-grow:0;
}
.slds-grid_vertical-align-start,.slds-grid--vertical-align-start{
  align-items:flex-start;
  align-content:flex-start;
}
.slds-grid_vertical-align-center,.slds-grid--vertical-align-center{
  align-items:center;
  align-content:center;
}
.slds-grid_vertical-align-end,.slds-grid--vertical-align-end{
  align-items:flex-end;
  align-content:flex-end;
}
.slds-align-top{
  vertical-align:top;
  align-self:flex-start;
}
.slds-align-middle{
  vertical-align:middle;
  align-self:center;
}
.slds-align-bottom{
  vertical-align:bottom;
  align-self:flex-end;
}
.slds-col_bump-top,.slds-col--bump-top{
  margin-block-start:auto;
}
.slds-col_bump-right,.slds-col--bump-right{
  margin-inline-end:auto;
}
.slds-col_bump-bottom,.slds-col--bump-bottom{
  margin-block-end:auto;
}
.slds-col_bump-left,.slds-col--bump-left{
  margin-inline-start:auto;
}
.slds-grid_vertical-stretch,.slds-grid--vertical-stretch{
  align-items:stretch;
  align-content:stretch;
}
.slds-container_small,.slds-container--small{
  max-width:30rem;
}
.slds-container_medium,.slds-container--medium{
  max-width:48rem;
}
.slds-container_large,.slds-container--large{
  max-width:64rem;
}
.slds-container_x-large,.slds-container--x-large{
  max-width:80rem;
}
.slds-container_fluid,.slds-container--fluid{
  width:100%;
}
.slds-container_center,.slds-container--center{
  margin-inline-start:auto;
  margin-inline-end:auto;
}
.slds-container_left,.slds-container--left{
  margin-inline-end:auto;
}
.slds-container_right,.slds-container--right{
  margin-inline-start:auto;
}
.slds-grid_overflow,.slds-grid--overflow{
  flex-flow:row nowrap;
}
.slds-grid_overflow .slds-col,.slds-grid--overflow .slds-col{
  min-width:11.25em;
  max-width:22.5em;
}
.slds-col_padded,.slds-col--padded{
  padding-inline:var(--slds-g-spacing-3);
}
.slds-col_padded-medium,.slds-col--padded-medium{
  padding-inline:var(--slds-g-spacing-4);
}
.slds-col_padded-large,.slds-col--padded-large{
  padding-inline:var(--slds-g-spacing-5);
}
.slds-col_padded-around,.slds-col--padded-around{
  padding:var(--slds-g-spacing-3);
}
.slds-col_padded-around-medium,.slds-col--padded-around-medium{
  padding:var(--slds-g-spacing-4);
}
.slds-col_padded-around-large,.slds-col--padded-around-large{
  padding:var(--slds-g-spacing-5);
}
.slds-align_absolute-center,.slds-align--absolute-center{
  display:flex;
  justify-content:center;
  align-content:center;
  align-items:center;
  margin:auto;
}
.slds-media{
  display:flex;
  align-items:flex-start;
}
.slds-media__figure{
  flex-shrink:0;
  margin-inline-end:var(--slds-g-spacing-3);
}
.slds-media__figure_fixed-width,.slds-media__figure--fixed-width{
  min-width:var(--slds-g-sizing-10);
}
.slds-media__body{
  flex:1 1;
  min-width:0;
}
.slds-media__body,
.slds-media__body > :last-child{
  margin-block-end:0;
}
.slds-media-body-iefix{
  flex-shrink:0;
  flex-basis:auto;
}
.slds-media_small .slds-media__figure,.slds-media--small .slds-media__figure,
.slds-media--small .slds-media__figure{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-media_small .slds-media__figure_reverse,.slds-media--small .slds-media__figure--reverse,
.slds-media--small .slds-media__figure--reverse{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-media_large .slds-media__figure,.slds-media--large .slds-media__figure,
.slds-media--large .slds-media__figure{
  margin-inline-end:var(--slds-g-spacing-5);
}
.slds-media_large .slds-media__figure_reverse,.slds-media--large .slds-media__figure--reverse,
.slds-media--large .slds-media__figure--reverse{
  margin-inline-start:var(--slds-g-spacing-5);
}
.slds-media_inline .slds-media__body,.slds-media--inline .slds-media__body{
  flex:0 1 auto;
}
.slds-media_center,.slds-media--center,
.slds-media--center{
  align-items:center;
}
.slds-media__figure_reverse,.slds-media__figure--reverse,
.slds-media__figure--reverse{
  margin:0;
  margin-inline-start:var(--slds-g-spacing-3);
}
[class*='slds-var-m-']{
  --_slds-g-spacing-var-block-1:var(--lwc-varSpacingVerticalXxSmall);
  --_slds-g-spacing-var-block-2:var(--lwc-varSpacingVerticalXSmall);
  --_slds-g-spacing-var-block-3:var(--lwc-varSpacingVerticalSmall);
  --_slds-g-spacing-var-block-4:var(--lwc-varSpacingVerticalMedium);
  --_slds-g-spacing-var-block-5:var(--lwc-varSpacingVerticalLarge);
  --_slds-g-spacing-var-block-6:var(--lwc-varSpacingVerticalXLarge);
  --_slds-g-spacing-var-block-7:var(--lwc-varSpacingVerticalXxLarge);
  --_slds-g-spacing-var-inline-1:var(--lwc-varSpacingHorizontalXxSmall);
  --_slds-g-spacing-var-inline-2:var(--lwc-varSpacingHorizontalXSmall);
  --_slds-g-spacing-var-inline-3:var(--lwc-varSpacingHorizontalSmall);
  --_slds-g-spacing-var-inline-4:var(--lwc-varSpacingHorizontalMedium);
  --_slds-g-spacing-var-inline-5:var(--lwc-varSpacingHorizontalLarge);
  --_slds-g-spacing-var-inline-6:var(--lwc-varSpacingHorizontalXLarge);
  --_slds-g-spacing-var-inline-7:var(--lwc-varSpacingHorizontalXxLarge);
  --_slds-g-spacing-var-1:var(--lwc-varSpacingXxSmall);
  --_slds-g-spacing-var-2:var(--lwc-varSpacingXSmall);
  --_slds-g-spacing-var-3:var(--lwc-varSpacingSmall);
  --_slds-g-spacing-var-4:var(--lwc-varSpacingMedium);
  --_slds-g-spacing-var-5:var(--lwc-varSpacingLarge);
  --_slds-g-spacing-var-6:var(--lwc-varSpacingXLarge);
  --_slds-g-spacing-var-7:var(--lwc-varSpacingXxLarge);
}
.slds-m-top_none,.slds-m-top--none{
  margin-block-start:0 !important;
}
.slds-m-top_xxx-small,.slds-m-top--xxx-small{
  margin-block-start:0.125rem;
}
.slds-m-top_xx-small,.slds-m-top--xx-small{
  margin-block-start:var(--slds-g-spacing-1);
}
.slds-m-top_x-small,.slds-m-top--x-small{
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-m-top_small,.slds-m-top--small{
  margin-block-start:var(--slds-g-spacing-3);
}
.slds-m-top_medium,.slds-m-top--medium{
  margin-block-start:var(--slds-g-spacing-4);
}
.slds-m-top_large,.slds-m-top--large{
  margin-block-start:var(--slds-g-spacing-5);
}
.slds-m-top_x-large,.slds-m-top--x-large{
  margin-block-start:var(--slds-g-spacing-6);
}
.slds-m-top_xx-large,.slds-m-top--xx-large{
  margin-block-start:var(--slds-g-spacing-8);
}
.slds-var-m-top_xxx-small,.slds-var-m-top--xxx-small{
  margin-block-start:var(--lwc-varSpacingVerticalXxxSmall);
}
.slds-var-m-top_xx-small,.slds-var-m-top--xx-small{
  margin-block-start:var(--_slds-g-spacing-var-block-1);
}
.slds-var-m-top_x-small,.slds-var-m-top--x-small{
  margin-block-start:var(--_slds-g-spacing-var-block-2);
}
.slds-var-m-top_small,.slds-var-m-top--small{
  margin-block-start:var(--_slds-g-spacing-var-block-3);
}
.slds-var-m-top_medium,.slds-var-m-top--medium{
  margin-block-start:var(--_slds-g-spacing-var-block-4);
}
.slds-var-m-top_large,.slds-var-m-top--large{
  margin-block-start:var(--_slds-g-spacing-var-block-5);
}
.slds-var-m-top_x-large,.slds-var-m-top--x-large{
  margin-block-start:var(--_slds-g-spacing-var-block-6);
}
.slds-var-m-top_xx-large,.slds-var-m-top--xx-large{
  margin-block-start:var(--_slds-g-spacing-var-block-7);
}
.slds-m-right_none,.slds-m-right--none{
  margin-inline-end:0 !important;
}
.slds-m-right_xxx-small,.slds-m-right--xxx-small{
  margin-inline-end:0.125rem;
}
.slds-m-right_xx-small,.slds-m-right--xx-small{
  margin-inline-end:var(--slds-g-spacing-1);
}
.slds-m-right_x-small,.slds-m-right--x-small{
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-m-right_small,.slds-m-right--small{
  margin-inline-end:var(--slds-g-spacing-3);
}
.slds-m-right_medium,.slds-m-right--medium{
  margin-inline-end:var(--slds-g-spacing-4);
}
.slds-m-right_large,.slds-m-right--large{
  margin-inline-end:var(--slds-g-spacing-5);
}
.slds-m-right_x-large,.slds-m-right--x-large{
  margin-inline-end:var(--slds-g-spacing-6);
}
.slds-m-right_xx-large,.slds-m-right--xx-large{
  margin-inline-end:var(--slds-g-spacing-8);
}
.slds-var-m-right_xxx-small,.slds-var-m-right--xxx-small{
  margin-inline-end:var(--lwc-varSpacingHorizontalXxxSmall);
}
.slds-var-m-right_xx-small,.slds-var-m-right--xx-small{
  margin-inline-end:var(--_slds-g-spacing-var-inline-1);
}
.slds-var-m-right_x-small,.slds-var-m-right--x-small{
  margin-inline-end:var(--_slds-g-spacing-var-inline-2);
}
.slds-var-m-right_small,.slds-var-m-right--small{
  margin-inline-end:var(--_slds-g-spacing-var-inline-3);
}
.slds-var-m-right_medium,.slds-var-m-right--medium{
  margin-inline-end:var(--_slds-g-spacing-var-inline-4);
}
.slds-var-m-right_large,.slds-var-m-right--large{
  margin-inline-end:var(--_slds-g-spacing-var-inline-5);
}
.slds-var-m-right_x-large,.slds-var-m-right--x-large{
  margin-inline-end:var(--_slds-g-spacing-var-inline-6);
}
.slds-var-m-right_xx-large,.slds-var-m-right--xx-large{
  margin-inline-end:var(--_slds-g-spacing-var-inline-7);
}
.slds-m-bottom_none,.slds-m-bottom--none{
  margin-block-end:0 !important;
}
.slds-m-bottom_xxx-small,.slds-m-bottom--xxx-small{
  margin-block-end:0.125rem;
}
.slds-m-bottom_xx-small,.slds-m-bottom--xx-small{
  margin-block-end:var(--slds-g-spacing-1);
}
.slds-m-bottom_x-small,.slds-m-bottom--x-small{
  margin-block-end:var(--slds-g-spacing-2);
}
.slds-m-bottom_small,.slds-m-bottom--small{
  margin-block-end:var(--slds-g-spacing-3);
}
.slds-m-bottom_medium,.slds-m-bottom--medium{
  margin-block-end:var(--slds-g-spacing-4);
}
.slds-m-bottom_large,.slds-m-bottom--large{
  margin-block-end:var(--slds-g-spacing-5);
}
.slds-m-bottom_x-large,.slds-m-bottom--x-large{
  margin-block-end:var(--slds-g-spacing-6);
}
.slds-m-bottom_xx-large,.slds-m-bottom--xx-large{
  margin-block-end:var(--slds-g-spacing-8);
}
.slds-var-m-bottom_xxx-small,.slds-var-m-bottom--xxx-small{
  margin-block-end:var(--lwc-varSpacingVerticalXxxSmall);
}
.slds-var-m-bottom_xx-small,.slds-var-m-bottom--xx-small{
  margin-block-end:var(--_slds-g-spacing-var-block-1);
}
.slds-var-m-bottom_x-small,.slds-var-m-bottom--x-small{
  margin-block-end:var(--_slds-g-spacing-var-block-2);
}
.slds-var-m-bottom_small,.slds-var-m-bottom--small{
  margin-block-end:var(--_slds-g-spacing-var-block-3);
}
.slds-var-m-bottom_medium,.slds-var-m-bottom--medium{
  margin-block-end:var(--_slds-g-spacing-var-block-5);
}
.slds-var-m-bottom_large,.slds-var-m-bottom--large{
  margin-block-end:var(--_slds-g-spacing-var-block-6);
}
.slds-var-m-bottom_x-large,.slds-var-m-bottom--x-large{
  margin-block-end:var(--_slds-g-spacing-var-block-6);
}
.slds-var-m-bottom_xx-large,.slds-var-m-bottom--xx-large{
  margin-block-end:var(--_slds-g-spacing-var-block-7);
}
.slds-m-left_none,.slds-m-left--none{
  margin-inline-start:0 !important;
}
.slds-m-left_xxx-small,.slds-m-left--xxx-small{
  margin-inline-start:0.125rem;
}
.slds-m-left_xx-small,.slds-m-left--xx-small{
  margin-inline-start:var(--slds-g-spacing-1);
}
.slds-m-left_x-small,.slds-m-left--x-small{
  margin-inline-start:var(--slds-g-spacing-2);
}
.slds-m-left_small,.slds-m-left--small{
  margin-inline-start:var(--slds-g-spacing-3);
}
.slds-m-left_medium,.slds-m-left--medium{
  margin-inline-start:var(--slds-g-spacing-4);
}
.slds-m-left_large,.slds-m-left--large{
  margin-inline-start:var(--slds-g-spacing-5);
}
.slds-m-left_x-large,.slds-m-left--x-large{
  margin-inline-start:var(--slds-g-spacing-6);
}
.slds-m-left_xx-large,.slds-m-left--xx-large{
  margin-inline-start:var(--slds-g-spacing-8);
}
.slds-var-m-left_xxx-small,.slds-var-m-left--xxx-small{
  margin-inline-start:var(--lwc-varSpacingHorizontalXxxSmall);
}
.slds-var-m-left_xx-small,.slds-var-m-left--xx-small{
  margin-inline-start:var(--_slds-g-spacing-var-inline-1);
}
.slds-var-m-left_x-small,.slds-var-m-left--x-small{
  margin-inline-start:var(--_slds-g-spacing-var-inline-2);
}
.slds-var-m-left_small,.slds-var-m-left--small{
  margin-inline-start:var(--_slds-g-spacing-var-inline-3);
}
.slds-var-m-left_medium,.slds-var-m-left--medium{
  margin-inline-start:var(--_slds-g-spacing-var-inline-4);
}
.slds-var-m-left_large,.slds-var-m-left--large{
  margin-inline-start:var(--_slds-g-spacing-var-inline-5);
}
.slds-var-m-left_x-large,.slds-var-m-left--x-large{
  margin-inline-start:var(--_slds-g-spacing-var-inline-6);
}
.slds-var-m-left_xx-large,.slds-var-m-left--xx-large{
  margin-inline-start:var(--_slds-g-spacing-var-inline-7);
}
.slds-m-horizontal_none,.slds-m-horizontal--none{
  margin-inline-start:0 !important;
  margin-inline-end:0 !important;
}
.slds-m-horizontal_xxx-small,.slds-m-horizontal--xxx-small{
  margin-inline-start:0.125rem;
  margin-inline-end:0.125rem;
}
.slds-m-horizontal_xx-small,.slds-m-horizontal--xx-small{
  margin-inline-start:var(--slds-g-spacing-1);
  margin-inline-end:var(--slds-g-spacing-1);
}
.slds-m-horizontal_x-small,.slds-m-horizontal--x-small{
  margin-inline-start:var(--slds-g-spacing-2);
  margin-inline-end:var(--slds-g-spacing-2);
}
.slds-m-horizontal_small,.slds-m-horizontal--small{
  margin-inline-start:var(--slds-g-spacing-3);
  margin-inline-end:var(--slds-g-spacing-3);
}
.slds-m-horizontal_medium,.slds-m-horizontal--medium{
  margin-inline-start:var(--slds-g-spacing-4);
  margin-inline-end:var(--slds-g-spacing-4);
}
.slds-m-horizontal_large,.slds-m-horizontal--large{
  margin-inline-start:var(--slds-g-spacing-5);
  margin-inline-end:var(--slds-g-spacing-5);
}
.slds-m-horizontal_x-large,.slds-m-horizontal--x-large{
  margin-inline-start:var(--slds-g-spacing-6);
  margin-inline-end:var(--slds-g-spacing-6);
}
.slds-m-horizontal_xx-large,.slds-m-horizontal--xx-large{
  margin-inline-start:var(--slds-g-spacing-8);
  margin-inline-end:var(--slds-g-spacing-8);
}
.slds-var-m-horizontal_xxx-small,.slds-var-m-horizontal--xxx-small{
  margin-inline-start:var(--lwc-varSpacingHorizontalXxxSmall);
  margin-inline-end:var(--lwc-varSpacingHorizontalXxxSmall);
}
.slds-var-m-horizontal_xx-small,.slds-var-m-horizontal--xx-small{
  margin-inline-start:var(--_slds-g-spacing-var-inline-1);
  margin-inline-end:var(--_slds-g-spacing-var-inline-1);
}
.slds-var-m-horizontal_x-small,.slds-var-m-horizontal--x-small{
  margin-inline-start:var(--_slds-g-spacing-var-inline-2);
  margin-inline-end:var(--_slds-g-spacing-var-inline-2);
}
.slds-var-m-horizontal_small,.slds-var-m-horizontal--small{
  margin-inline-start:var(--_slds-g-spacing-var-inline-3);
  margin-inline-end:var(--_slds-g-spacing-var-inline-3);
}
.slds-var-m-horizontal_medium,.slds-var-m-horizontal--medium{
  margin-inline-start:var(--_slds-g-spacing-var-inline-4);
  margin-inline-end:var(--_slds-g-spacing-var-inline-4);
}
.slds-var-m-horizontal_large,.slds-var-m-horizontal--large{
  margin-inline-start:var(--_slds-g-spacing-var-inline-5);
  margin-inline-end:var(--_slds-g-spacing-var-inline-5);
}
.slds-var-m-horizontal_x-large,.slds-var-m-horizontal--x-large{
  margin-inline-start:var(--_slds-g-spacing-var-inline-6);
  margin-inline-end:var(--_slds-g-spacing-var-inline-6);
}
.slds-var-m-horizontal_xx-large,.slds-var-m-horizontal--xx-large{
  margin-inline-start:var(--_slds-g-spacing-var-inline-7);
  margin-inline-end:var(--_slds-g-spacing-var-inline-7);
}
.slds-m-vertical_none,.slds-m-vertical--none{
  margin-block-start:0 !important;
  margin-block-end:0 !important;
}
.slds-m-vertical_xxx-small,.slds-m-vertical--xxx-small{
  margin-block-start:0.125rem;
  margin-block-end:0.125rem;
}
.slds-m-vertical_xx-small,.slds-m-vertical--xx-small{
  margin-block-start:var(--slds-g-spacing-1);
  margin-block-end:var(--slds-g-spacing-1);
}
.slds-m-vertical_x-small,.slds-m-vertical--x-small{
  margin-block-start:var(--slds-g-spacing-2);
  margin-block-end:var(--slds-g-spacing-2);
}
.slds-m-vertical_small,.slds-m-vertical--small{
  margin-block-start:var(--slds-g-spacing-3);
  margin-block-end:var(--slds-g-spacing-3);
}
.slds-m-vertical_medium,.slds-m-vertical--medium{
  margin-block-start:var(--slds-g-spacing-4);
  margin-block-end:var(--slds-g-spacing-4);
}
.slds-m-vertical_large,.slds-m-vertical--large{
  margin-block-start:var(--slds-g-spacing-5);
  margin-block-end:var(--slds-g-spacing-5);
}
.slds-m-vertical_x-large,.slds-m-vertical--x-large{
  margin-block-start:var(--slds-g-spacing-6);
  margin-block-end:var(--slds-g-spacing-6);
}
.slds-m-vertical_xx-large,.slds-m-vertical--xx-large{
  margin-block-start:var(--slds-g-spacing-8);
  margin-block-end:var(--slds-g-spacing-8);
}
.slds-var-m-vertical_xxx-small,.slds-var-m-vertical--xxx-small{
  margin-block-start:var(--lwc-varSpacingVerticalXxxSmall);
  margin-block-end:var(--lwc-varSpacingVerticalXxxSmall);
}
.slds-var-m-vertical_xx-small,.slds-var-m-vertical--xx-small{
  margin-block-start:var(--_slds-g-spacing-var-block-1);
  margin-block-end:var(--_slds-g-spacing-var-block-1);
}
.slds-var-m-vertical_x-small,.slds-var-m-vertical--x-small{
  margin-block-start:var(--_slds-g-spacing-var-block-2);
  margin-block-end:var(--_slds-g-spacing-var-block-2);
}
.slds-var-m-vertical_small,.slds-var-m-vertical--small{
  margin-block-start:var(--_slds-g-spacing-var-block-3);
  margin-block-end:var(--_slds-g-spacing-var-block-3);
}
.slds-var-m-vertical_medium,.slds-var-m-vertical--medium{
  margin-block-start:var(--_slds-g-spacing-var-block-4);
  margin-block-end:var(--_slds-g-spacing-var-block-4);
}
.slds-var-m-vertical_large,.slds-var-m-vertical--large{
  margin-block-start:var(--_slds-g-spacing-var-block-5);
  margin-block-end:var(--_slds-g-spacing-var-block-5);
}
.slds-var-m-vertical_x-large,.slds-var-m-vertical--x-large{
  margin-block-start:var(--_slds-g-spacing-var-block-6);
  margin-block-end:var(--_slds-g-spacing-var-block-6);
}
.slds-var-m-vertical_xx-large,.slds-var-m-vertical--xx-large{
  margin-block-start:var(--_slds-g-spacing-var-block-7);
  margin-block-end:var(--_slds-g-spacing-var-block-7);
}
.slds-m-around_none,.slds-m-around--none{
  margin:0 !important;
}
.slds-m-around_xxx-small,.slds-m-around--xxx-small{
  margin:0.125rem;
}
.slds-m-around_xx-small,.slds-m-around--xx-small{
  margin:var(--slds-g-spacing-1);
}
.slds-m-around_x-small,.slds-m-around--x-small{
  margin:var(--slds-g-spacing-2);
}
.slds-m-around_small,.slds-m-around--small{
  margin:var(--slds-g-spacing-3);
}
.slds-m-around_medium,.slds-m-around--medium{
  margin:var(--slds-g-spacing-4);
}
.slds-m-around_large,.slds-m-around--large{
  margin:var(--slds-g-spacing-5);
}
.slds-m-around_x-large,.slds-m-around--x-large{
  margin:var(--slds-g-spacing-6);
}
.slds-m-around_xx-large,.slds-m-around--xx-large{
  margin:var(--slds-g-spacing-8);
}
.slds-var-m-around_xxx-small,.slds-var-m-around--xxx-small{
  margin:var(--lwc-varSpacingXxxSmall);
}
.slds-var-m-around_xx-small,.slds-var-m-around--xx-small{
  margin:var(--_slds-g-spacing-var-1);
}
.slds-var-m-around_x-small,.slds-var-m-around--x-small{
  margin:var(--_slds-g-spacing-var-2);
}
.slds-var-m-around_small,.slds-var-m-around--small{
  margin:var(--_slds-g-spacing-var-3);
}
.slds-var-m-around_medium,.slds-var-m-around--medium{
  margin:var(--_slds-g-spacing-var-4);
}
.slds-var-m-around_large,.slds-var-m-around--large{
  margin:var(--_slds-g-spacing-var-5);
}
.slds-var-m-around_x-large,.slds-var-m-around--x-large{
  margin:var(--_slds-g-spacing-var-6);
}
.slds-var-m-around_xx-large,.slds-var-m-around--xx-large{
  margin:var(--_slds-g-spacing-var-7);
}
[class*='slds-var-p-']{
  --_slds-g-spacing-var-block-1:var(--lwc-varSpacingVerticalXxSmall);
  --_slds-g-spacing-var-block-2:var(--lwc-varSpacingVerticalXSmall);
  --_slds-g-spacing-var-block-3:var(--lwc-varSpacingVerticalSmall);
  --_slds-g-spacing-var-block-4:var(--lwc-varSpacingVerticalMedium);
  --_slds-g-spacing-var-block-5:var(--lwc-varSpacingVerticalLarge);
  --_slds-g-spacing-var-block-6:var(--lwc-varSpacingVerticalXLarge);
  --_slds-g-spacing-var-block-7:var(--lwc-varSpacingVerticalXxLarge);
  --_slds-g-spacing-var-inline-1:var(--lwc-varSpacingHorizontalXxSmall);
  --_slds-g-spacing-var-inline-2:var(--lwc-varSpacingHorizontalXSmall);
  --_slds-g-spacing-var-inline-3:var(--lwc-varSpacingHorizontalSmall);
  --_slds-g-spacing-var-inline-4:var(--lwc-varSpacingHorizontalMedium);
  --_slds-g-spacing-var-inline-5:var(--lwc-varSpacingHorizontalLarge);
  --_slds-g-spacing-var-inline-6:var(--lwc-varSpacingHorizontalXLarge);
  --_slds-g-spacing-var-inline-7:var(--lwc-varSpacingHorizontalXxLarge);
  --_slds-g-spacing-var-1:var(--lwc-varSpacingXxSmall);
  --_slds-g-spacing-var-2:var(--lwc-varSpacingXSmall);
  --_slds-g-spacing-var-3:var(--lwc-varSpacingSmall);
  --_slds-g-spacing-var-4:var(--lwc-varSpacingMedium);
  --_slds-g-spacing-var-5:var(--lwc-varSpacingLarge);
  --_slds-g-spacing-var-6:var(--lwc-varSpacingXLarge);
  --_slds-g-spacing-var-7:var(--lwc-varSpacingXxLarge);
}
.slds-p-top_none,.slds-p-top--none{
  padding-block-start:0 !important;
}
.slds-p-top_xxx-small,.slds-p-top--xxx-small{
  padding-block-start:0.125rem;
}
.slds-p-top_xx-small,.slds-p-top--xx-small{
  padding-block-start:var(--slds-g-spacing-1);
}
.slds-p-top_x-small,.slds-p-top--x-small{
  padding-block-start:var(--slds-g-spacing-2);
}
.slds-p-top_small,.slds-p-top--small{
  padding-block-start:var(--slds-g-spacing-3);
}
.slds-p-top_medium,.slds-p-top--medium{
  padding-block-start:var(--slds-g-spacing-4);
}
.slds-p-top_large,.slds-p-top--large{
  padding-block-start:var(--slds-g-spacing-5);
}
.slds-p-top_x-large,.slds-p-top--x-large{
  padding-block-start:var(--slds-g-spacing-6);
}
.slds-p-top_xx-large,.slds-p-top--xx-large{
  padding-block-start:var(--slds-g-spacing-8);
}
.slds-var-p-top_xxx-small,.slds-var-p-top--xxx-small{
  padding-block-start:var(--lwc-varSpacingVerticalXxxSmall);
}
.slds-var-p-top_xx-small,.slds-var-p-top--xx-small{
  padding-block-start:var(--_slds-g-spacing-var-block-1);
}
.slds-var-p-top_x-small,.slds-var-p-top--x-small{
  padding-block-start:var(--_slds-g-spacing-var-block-2);
}
.slds-var-p-top_small,.slds-var-p-top--small{
  padding-block-start:var(--_slds-g-spacing-var-block-3);
}
.slds-var-p-top_medium,.slds-var-p-top--medium{
  padding-block-start:var(--_slds-g-spacing-var-block-4);
}
.slds-var-p-top_large,.slds-var-p-top--large{
  padding-block-start:var(--_slds-g-spacing-var-block-5);
}
.slds-var-p-top_x-large,.slds-var-p-top--x-large{
  padding-block-start:var(--_slds-g-spacing-var-block-6);
}
.slds-var-p-top_xx-large,.slds-var-p-top--xx-large{
  padding-block-start:var(--_slds-g-spacing-var-block-7);
}
.slds-p-right_none,.slds-p-right--none{
  padding-inline-end:0 !important;
}
.slds-p-right_xxx-small,.slds-p-right--xxx-small{
  padding-inline-end:0.125rem;
}
.slds-p-right_xx-small,.slds-p-right--xx-small{
  padding-inline-end:var(--slds-g-spacing-1);
}
.slds-p-right_x-small,.slds-p-right--x-small{
  padding-inline-end:var(--slds-g-spacing-2);
}
.slds-p-right_small,.slds-p-right--small{
  padding-inline-end:var(--slds-g-spacing-3);
}
.slds-p-right_medium,.slds-p-right--medium{
  padding-inline-end:var(--slds-g-spacing-4);
}
.slds-p-right_large,.slds-p-right--large{
  padding-inline-end:var(--slds-g-spacing-5);
}
.slds-p-right_x-large,.slds-p-right--x-large{
  padding-inline-end:var(--slds-g-spacing-6);
}
.slds-p-right_xx-large,.slds-p-right--xx-large{
  padding-inline-end:var(--slds-g-spacing-8);
}
.slds-var-p-right_xxx-small,.slds-var-p-right--xxx-small{
  padding-inline-end:var(--lwc-varSpacingHorizontalXxxSmall);
}
.slds-var-p-right_xx-small,.slds-var-p-right--xx-small{
  padding-inline-end:var(--_slds-g-spacing-var-inline-1);
}
.slds-var-p-right_x-small,.slds-var-p-right--x-small{
  padding-inline-end:var(--_slds-g-spacing-var-inline-2);
}
.slds-var-p-right_small,.slds-var-p-right--small{
  padding-inline-end:var(--_slds-g-spacing-var-inline-3);
}
.slds-var-p-right_medium,.slds-var-p-right--medium{
  padding-inline-end:var(--_slds-g-spacing-var-inline-4);
}
.slds-var-p-right_large,.slds-var-p-right--large{
  padding-inline-end:var(--_slds-g-spacing-var-inline-5);
}
.slds-var-p-right_x-large,.slds-var-p-right--x-large{
  padding-inline-end:var(--_slds-g-spacing-var-inline-6);
}
.slds-var-p-right_xx-large,.slds-var-p-right--xx-large{
  padding-inline-end:var(--_slds-g-spacing-var-inline-7);
}
.slds-p-bottom_none,.slds-p-bottom--none{
  padding-block-end:0 !important;
}
.slds-p-bottom_xxx-small,.slds-p-bottom--xxx-small{
  padding-block-end:0.125rem;
}
.slds-p-bottom_xx-small,.slds-p-bottom--xx-small{
  padding-block-end:var(--slds-g-spacing-1);
}
.slds-p-bottom_x-small,.slds-p-bottom--x-small{
  padding-block-end:var(--slds-g-spacing-2);
}
.slds-p-bottom_small,.slds-p-bottom--small{
  padding-block-end:var(--slds-g-spacing-3);
}
.slds-p-bottom_medium,.slds-p-bottom--medium{
  padding-block-end:var(--slds-g-spacing-4);
}
.slds-p-bottom_large,.slds-p-bottom--large{
  padding-block-end:var(--slds-g-spacing-5);
}
.slds-p-bottom_x-large,.slds-p-bottom--x-large{
  padding-block-end:var(--slds-g-spacing-6);
}
.slds-p-bottom_xx-large,.slds-p-bottom--xx-large{
  padding-block-end:var(--slds-g-spacing-8);
}
.slds-var-p-bottom_xxx-small,.slds-var-p-bottom--xxx-small{
  padding-block-end:var(--lwc-varSpacingVerticalXxxSmall);
}
.slds-var-p-bottom_xx-small,.slds-var-p-bottom--xx-small{
  padding-block-end:var(--_slds-g-spacing-var-block-1);
}
.slds-var-p-bottom_x-small,.slds-var-p-bottom--x-small{
  padding-block-end:var(--_slds-g-spacing-var-block-2);
}
.slds-var-p-bottom_small,.slds-var-p-bottom--small{
  padding-block-end:var(--_slds-g-spacing-var-block-3);
}
.slds-var-p-bottom_medium,.slds-var-p-bottom--medium{
  padding-block-end:var(--_slds-g-spacing-var-block-5);
}
.slds-var-p-bottom_large,.slds-var-p-bottom--large{
  padding-block-end:var(--_slds-g-spacing-var-block-6);
}
.slds-var-p-bottom_x-large,.slds-var-p-bottom--x-large{
  padding-block-end:var(--_slds-g-spacing-var-block-6);
}
.slds-var-p-bottom_xx-large,.slds-var-p-bottom--xx-large{
  padding-block-end:var(--_slds-g-spacing-var-block-7);
}
.slds-p-left_none,.slds-p-left--none{
  padding-inline-start:0 !important;
}
.slds-p-left_xxx-small,.slds-p-left--xxx-small{
  padding-inline-start:0.125rem;
}
.slds-p-left_xx-small,.slds-p-left--xx-small{
  padding-inline-start:var(--slds-g-spacing-1);
}
.slds-p-left_x-small,.slds-p-left--x-small{
  padding-inline-start:var(--slds-g-spacing-2);
}
.slds-p-left_small,.slds-p-left--small{
  padding-inline-start:var(--slds-g-spacing-3);
}
.slds-p-left_medium,.slds-p-left--medium{
  padding-inline-start:var(--slds-g-spacing-4);
}
.slds-p-left_large,.slds-p-left--large{
  padding-inline-start:var(--slds-g-spacing-5);
}
.slds-p-left_x-large,.slds-p-left--x-large{
  padding-inline-start:var(--slds-g-spacing-6);
}
.slds-p-left_xx-large,.slds-p-left--xx-large{
  padding-inline-start:var(--slds-g-spacing-8);
}
.slds-var-p-left_xxx-small,.slds-var-p-left--xxx-small{
  padding-inline-start:var(--lwc-varSpacingHorizontalXxxSmall);
}
.slds-var-p-left_xx-small,.slds-var-p-left--xx-small{
  padding-inline-start:var(--_slds-g-spacing-var-inline-1);
}
.slds-var-p-left_x-small,.slds-var-p-left--x-small{
  padding-inline-start:var(--_slds-g-spacing-var-inline-2);
}
.slds-var-p-left_small,.slds-var-p-left--small{
  padding-inline-start:var(--_slds-g-spacing-var-inline-3);
}
.slds-var-p-left_medium,.slds-var-p-left--medium{
  padding-inline-start:var(--_slds-g-spacing-var-inline-4);
}
.slds-var-p-left_large,.slds-var-p-left--large{
  padding-inline-start:var(--_slds-g-spacing-var-inline-5);
}
.slds-var-p-left_x-large,.slds-var-p-left--x-large{
  padding-inline-start:var(--_slds-g-spacing-var-inline-6);
}
.slds-var-p-left_xx-large,.slds-var-p-left--xx-large{
  padding-inline-start:var(--_slds-g-spacing-var-inline-7);
}
.slds-p-horizontal_none,.slds-p-horizontal--none{
  padding-inline-start:0 !important;
  padding-inline-end:0 !important;
}
.slds-p-horizontal_xxx-small,.slds-p-horizontal--xxx-small{
  padding-inline-start:0.125rem;
  padding-inline-end:0.125rem;
}
.slds-p-horizontal_xx-small,.slds-p-horizontal--xx-small{
  padding-inline-start:var(--slds-g-spacing-1);
  padding-inline-end:var(--slds-g-spacing-1);
}
.slds-p-horizontal_x-small,.slds-p-horizontal--x-small{
  padding-inline-start:var(--slds-g-spacing-2);
  padding-inline-end:var(--slds-g-spacing-2);
}
.slds-p-horizontal_small,.slds-p-horizontal--small{
  padding-inline-start:var(--slds-g-spacing-3);
  padding-inline-end:var(--slds-g-spacing-3);
}
.slds-p-horizontal_medium,.slds-p-horizontal--medium{
  padding-inline-start:var(--slds-g-spacing-4);
  padding-inline-end:var(--slds-g-spacing-4);
}
.slds-p-horizontal_large,.slds-p-horizontal--large{
  padding-inline-start:var(--slds-g-spacing-5);
  padding-inline-end:var(--slds-g-spacing-5);
}
.slds-p-horizontal_x-large,.slds-p-horizontal--x-large{
  padding-inline-start:var(--slds-g-spacing-6);
  padding-inline-end:var(--slds-g-spacing-6);
}
.slds-p-horizontal_xx-large,.slds-p-horizontal--xx-large{
  padding-inline-start:var(--slds-g-spacing-8);
  padding-inline-end:var(--slds-g-spacing-8);
}
.slds-var-p-horizontal_xxx-small,.slds-var-p-horizontal--xxx-small{
  padding-inline-start:var(--lwc-varSpacingHorizontalXxxSmall);
  padding-inline-end:var(--lwc-varSpacingHorizontalXxxSmall);
}
.slds-var-p-horizontal_xx-small,.slds-var-p-horizontal--xx-small{
  padding-inline-start:var(--_slds-g-spacing-var-inline-1);
  padding-inline-end:var(--_slds-g-spacing-var-inline-1);
}
.slds-var-p-horizontal_x-small,.slds-var-p-horizontal--x-small{
  padding-inline-start:var(--_slds-g-spacing-var-inline-2);
  padding-inline-end:var(--_slds-g-spacing-var-inline-2);
}
.slds-var-p-horizontal_small,.slds-var-p-horizontal--small{
  padding-inline-start:var(--_slds-g-spacing-var-inline-3);
  padding-inline-end:var(--_slds-g-spacing-var-inline-3);
}
.slds-var-p-horizontal_medium,.slds-var-p-horizontal--medium{
  padding-inline-start:var(--_slds-g-spacing-var-inline-4);
  padding-inline-end:var(--_slds-g-spacing-var-inline-4);
}
.slds-var-p-horizontal_large,.slds-var-p-horizontal--large{
  padding-inline-start:var(--_slds-g-spacing-var-inline-5);
  padding-inline-end:var(--_slds-g-spacing-var-inline-5);
}
.slds-var-p-horizontal_x-large,.slds-var-p-horizontal--x-large{
  padding-inline-start:var(--_slds-g-spacing-var-inline-6);
  padding-inline-end:var(--_slds-g-spacing-var-inline-6);
}
.slds-var-p-horizontal_xx-large,.slds-var-p-horizontal--xx-large{
  padding-inline-start:var(--_slds-g-spacing-var-inline-7);
  padding-inline-end:var(--_slds-g-spacing-var-inline-7);
}
.slds-p-vertical_none,.slds-p-vertical--none{
  padding-block-start:0 !important;
  padding-block-end:0 !important;
}
.slds-p-vertical_xxx-small,.slds-p-vertical--xxx-small{
  padding-block-start:0.125rem;
  padding-block-end:0.125rem;
}
.slds-p-vertical_xx-small,.slds-p-vertical--xx-small{
  padding-block-start:var(--slds-g-spacing-1);
  padding-block-end:var(--slds-g-spacing-1);
}
.slds-p-vertical_x-small,.slds-p-vertical--x-small{
  padding-block-start:var(--slds-g-spacing-2);
  padding-block-end:var(--slds-g-spacing-2);
}
.slds-p-vertical_small,.slds-p-vertical--small{
  padding-block-start:var(--slds-g-spacing-3);
  padding-block-end:var(--slds-g-spacing-3);
}
.slds-p-vertical_medium,.slds-p-vertical--medium{
  padding-block-start:var(--slds-g-spacing-4);
  padding-block-end:var(--slds-g-spacing-4);
}
.slds-p-vertical_large,.slds-p-vertical--large{
  padding-block-start:var(--slds-g-spacing-5);
  padding-block-end:var(--slds-g-spacing-5);
}
.slds-p-vertical_x-large,.slds-p-vertical--x-large{
  padding-block-start:var(--slds-g-spacing-6);
  padding-block-end:var(--slds-g-spacing-6);
}
.slds-p-vertical_xx-large,.slds-p-vertical--xx-large{
  padding-block-start:var(--slds-g-spacing-8);
  padding-block-end:var(--slds-g-spacing-8);
}
.slds-var-p-vertical_xxx-small,.slds-var-p-vertical--xxx-small{
  padding-block-start:var(--lwc-varSpacingVerticalXxxSmall);
  padding-block-end:var(--lwc-varSpacingVerticalXxxSmall);
}
.slds-var-p-vertical_xx-small,.slds-var-p-vertical--xx-small{
  padding-block-start:var(--_slds-g-spacing-var-block-1);
  padding-block-end:var(--_slds-g-spacing-var-block-1);
}
.slds-var-p-vertical_x-small,.slds-var-p-vertical--x-small{
  padding-block-start:var(--_slds-g-spacing-var-block-2);
  padding-block-end:var(--_slds-g-spacing-var-block-2);
}
.slds-var-p-vertical_small,.slds-var-p-vertical--small{
  padding-block-start:var(--_slds-g-spacing-var-block-3);
  padding-block-end:var(--_slds-g-spacing-var-block-3);
}
.slds-var-p-vertical_medium,.slds-var-p-vertical--medium{
  padding-block-start:var(--_slds-g-spacing-var-block-4);
  padding-block-end:var(--_slds-g-spacing-var-block-4);
}
.slds-var-p-vertical_large,.slds-var-p-vertical--large{
  padding-block-start:var(--_slds-g-spacing-var-block-5);
  padding-block-end:var(--_slds-g-spacing-var-block-5);
}
.slds-var-p-vertical_x-large,.slds-var-p-vertical--x-large{
  padding-block-start:var(--_slds-g-spacing-var-block-6);
  padding-block-end:var(--_slds-g-spacing-var-block-6);
}
.slds-var-p-vertical_xx-large,.slds-var-p-vertical--xx-large{
  padding-block-start:var(--_slds-g-spacing-var-block-7);
  padding-block-end:var(--_slds-g-spacing-var-block-7);
}
.slds-p-around_none,.slds-p-around--none{
  padding:0 !important;
}
.slds-p-around_xxx-small,.slds-p-around--xxx-small{
  padding:0.125rem;
}
.slds-p-around_xx-small,.slds-p-around--xx-small{
  padding:var(--slds-g-spacing-1);
}
.slds-p-around_x-small,.slds-p-around--x-small{
  padding:var(--slds-g-spacing-2);
}
.slds-p-around_small,.slds-p-around--small{
  padding:var(--slds-g-spacing-3);
}
.slds-p-around_medium,.slds-p-around--medium{
  padding:var(--slds-g-spacing-4);
}
.slds-p-around_large,.slds-p-around--large{
  padding:var(--slds-g-spacing-5);
}
.slds-p-around_x-large,.slds-p-around--x-large{
  padding:var(--slds-g-spacing-6);
}
.slds-p-around_xx-large,.slds-p-around--xx-large{
  padding:var(--slds-g-spacing-8);
}
.slds-var-p-around_xxx-small,.slds-var-p-around--xxx-small{
  padding:var(--lwc-varSpacingXxxSmall);
}
.slds-var-p-around_xx-small,.slds-var-p-around--xx-small{
  padding:var(--_slds-g-spacing-var-1);
}
.slds-var-p-around_x-small,.slds-var-p-around--x-small{
  padding:var(--_slds-g-spacing-var-2);
}
.slds-var-p-around_small,.slds-var-p-around--small{
  padding:var(--_slds-g-spacing-var-3);
}
.slds-var-p-around_medium,.slds-var-p-around--medium{
  padding:var(--_slds-g-spacing-var-4);
}
.slds-var-p-around_large,.slds-var-p-around--large{
  padding:var(--_slds-g-spacing-var-5);
}
.slds-var-p-around_x-large,.slds-var-p-around--x-large{
  padding:var(--_slds-g-spacing-var-6);
}
.slds-var-p-around_xx-large,.slds-var-p-around--xx-large{
  padding:var(--_slds-g-spacing-var-7);
}
.slds-has-cushion{
  padding:var(--slds-g-spacing-4);
}
.slds-clearfix::after{
  content:'';
  display:table;
  clear:both;
}
.slds-clear{
  clear:both;
}
.slds-float_left,.slds-float--left{
  float:inline-start;
}
.slds-float_none,.slds-float--none{
  float:none;
}
.slds-float_right,.slds-float--right{
  float:inline-end;
}
.slds-border_bottom,.slds-border--bottom{
  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-border_left,.slds-border--left{
  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-border_right,.slds-border--right{
  border-inline-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-border_top,.slds-border--top{
  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-text-link_reset,.slds-text-link--reset{
  cursor:pointer;
  line-height:inherit;
  font-size:inherit;
}
.slds-text-link_reset:active,.slds-text-link--reset:active{
  outline:none;
}
.slds-text-link_reset,.slds-text-link--reset,
.slds-text-link_reset:active,
.slds-text-link--reset:active,
.slds-text-link_reset:focus,
.slds-text-link--reset:focus,
.slds-text-link_reset:hover,
.slds-text-link--reset:hover{
  color:inherit;
  text-decoration:inherit;
}
.slds-text-link{
  color:var(--slds-g-color-accent-2);
  text-decoration:none;
  transition:color 0.1s linear;
}
.slds-text-link:hover,
.slds-text-link:focus{
  text-decoration:underline;
  color:var(--slds-g-color-accent-3);
}
.slds-text-link:active{
  color:var(--slds-g-color-accent-3);
}
.slds-text-link_faux,.slds-text-link--faux,
.slds-type-focus{
  border-block-end:var(--slds-g-sizing-border-1) solid transparent;
  border-radius:0;
  color:currentColor;
  cursor:pointer;
}
.slds-text-link_faux:hover,.slds-text-link--faux:hover,
.slds-text-link_faux:focus,
.slds-text-link--faux:focus,
.slds-type-focus:hover,
.slds-type-focus:focus{
  color:currentColor;
  border-block-end-color:currentColor;
}
.slds-has-blur-focus{
  color:currentColor;
}
.slds-has-blur-focus:hover,
.slds-has-blur-focus:focus,
.slds-has-blur-focus:active{
  color:currentColor;
  text-decoration:none;
}
.slds-has-blur-focus:focus{
  outline:0;
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-has-input-focus{
  outline:0;
  border-color:var(--slds-g-color-border-accent-1);
  background-color:var(--slds-g-color-surface-container-1);
  box-shadow:var(--slds-s-button-shadow-focus);
}
.slds-list_vertical.slds-has-dividers > .slds-list__item,.slds-list--vertical.slds-has-dividers > .slds-list__item{
  padding:var(--slds-g-spacing-2);
  border-block-end:1px solid var(--slds-g-color-border-1);
}
.slds-list_vertical.slds-has-dividers > .slds-list__item:hover,.slds-list--vertical.slds-has-dividers > .slds-list__item:hover{
  background-color:var(--slds-g-color-surface-container-2);
  border-color:var(--slds-g-color-border-1);
  cursor:pointer;
}
.slds-list_vertical.slds-has-dividers > .slds-list__item:active,.slds-list--vertical.slds-has-dividers > .slds-list__item:active{
  background-color:var(--slds-g-color-surface-container-2);
  box-shadow:var(--slds-g-color-border-1) 0 -1px 0 inset;
}
.slds-list_vertical.slds-has-dividers > .slds-list__item.slds-is-selected,.slds-list--vertical.slds-has-dividers > .slds-list__item.slds-is-selected{
  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-list_vertical.slds-has-dividers > .slds-list__item.slds-is-selected:hover,.slds-list--vertical.slds-has-dividers > .slds-list__item.slds-is-selected:hover,
.slds-list_vertical.slds-has-dividers > .slds-list__item.slds-is-selected:focus,
.slds-list--vertical.slds-has-dividers > .slds-list__item.slds-is-selected:focus{
  box-shadow:var(--slds-g-color-accent-1) 0 -2px 0 inset, var(--slds-g-color-accent-1) 0 0 0 1px inset;
}
.slds-has-cards > .slds-list__item{
  border:1px solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
  background-clip:padding-box;
}
.slds-has-cards > .slds-list__item + .slds-list__item{
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-has-cards_space > .slds-list__item,.slds-has-cards--space > .slds-list__item{
  border:1px solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
  background-clip:padding-box;
  padding:var(--slds-g-spacing-3);
}
@media (min-width: 30em){
  .slds-has-cards_space > .slds-list__item,.slds-has-cards--space > .slds-list__item{
    padding:var(--slds-g-spacing-2);
  }
}
.slds-has-cards_space > .slds-list__item + .slds-list__item,.slds-has-cards--space > .slds-list__item + .slds-list__item{
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-has-divider{
  margin-block-start:var(--slds-g-spacing-2);
  padding-block-start:var(--slds-g-spacing-2);
  border-block-start:1px solid var(--slds-g-color-border-1);
}
.slds-has-block-links a{
  display:block;
  text-decoration:none;
}
.slds-has-block-links .slds-is-nested{
  margin-inline-start:var(--slds-g-spacing-4);
}
.slds-has-block-links_space .slds-list__item,.slds-has-block-links--space .slds-list__item,
.slds-has-block-links_space .slds-item,
.slds-has-block-links--space .slds-item{
  padding:0;
}
.slds-has-block-links_space a,.slds-has-block-links--space a{
  display:block;
  text-decoration:none;
  padding:var(--slds-g-spacing-3);
}
@media (min-width: 48em){
  .slds-has-block-links_space a,.slds-has-block-links--space a{
    padding:var(--slds-g-spacing-2);
  }
}
.slds-has-inline-block-links a{
  display:inline-block;
  text-decoration:none;
}
.slds-has-inline-block-links_space a,.slds-has-inline-block-links--space a{
  display:inline-block;
  text-decoration:none;
  padding:var(--slds-g-spacing-3);
}
@media (min-width: 48em){
  .slds-has-inline-block-links_space a,.slds-has-inline-block-links--space a{
    padding:var(--slds-g-spacing-2);
  }
}
.slds-list_vertical-space .slds-list__item + .slds-list__item,.slds-list--vertical-space .slds-list__item + .slds-list__item,
.slds-list_vertical-space .slds-item + .slds-item,
.slds-list--vertical-space .slds-item + .slds-item{
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-list_vertical-space-medium .slds-list__item + .slds-list__item,.slds-list--vertical-space-medium .slds-list__item + .slds-list__item,
.slds-list_vertical-space-medium .slds-item + .slds-item,
.slds-list--vertical-space-medium .slds-item + .slds-item{
  margin-block-start:var(--slds-g-spacing-4);
}
.slds-is-nested{
  margin-inline-start:var(--slds-g-spacing-4);
}
.slds-list_dotted,.slds-list--dotted{
  margin-inline-start:var(--slds-g-spacing-5);
  list-style:disc;
}
.slds-list_ordered,.slds-list--ordered{
  margin-inline-start:var(--slds-g-spacing-5);
  list-style:decimal;
}
.slds-has-dividers_top > .slds-list__item,.slds-has-dividers--top > .slds-list__item,
.slds-has-dividers_top > .slds-item,
.slds-has-dividers--top > .slds-item{
  border-block-start:1px solid var(--slds-g-color-border-1);
}
.slds-has-dividers_top-space > .slds-list__item,.slds-has-dividers--top-space > .slds-list__item,
.slds-has-dividers_top-space > .slds-item,
.slds-has-dividers--top-space > .slds-item{
  border-block-start:1px solid var(--slds-g-color-border-1);
  padding:var(--slds-g-spacing-3);
}
@media (min-width: 30em){
  .slds-has-dividers_top-space > .slds-list__item,.slds-has-dividers--top-space > .slds-list__item,
  .slds-has-dividers_top-space > .slds-item,
  .slds-has-dividers--top-space > .slds-item{
    padding:var(--slds-g-spacing-2);
  }
}
.slds-has-dividers_bottom > .slds-list__item,.slds-has-dividers--bottom > .slds-list__item,
.slds-has-dividers_bottom > .slds-item,
.slds-has-dividers--bottom > .slds-item{
  border-block-end:1px solid var(--slds-g-color-border-1);
}
.slds-has-dividers_bottom-space > .slds-list__item,.slds-has-dividers--bottom-space > .slds-list__item,
.slds-has-dividers_bottom-space > .slds-item,
.slds-has-dividers--bottom-space > .slds-item{
  border-block-end:1px solid var(--slds-g-color-border-1);
  padding:var(--slds-g-spacing-3);
}
@media (min-width: 30em){
  .slds-has-dividers_bottom-space > .slds-list__item,.slds-has-dividers--bottom-space > .slds-list__item,
  .slds-has-dividers_bottom-space > .slds-item,
  .slds-has-dividers--bottom-space > .slds-item{
    padding:var(--slds-g-spacing-2);
  }
}
.slds-has-dividers_around > .slds-item,.slds-has-dividers--around > .slds-item{
  border:1px solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
  background-clip:padding-box;
}
.slds-has-dividers_around > .slds-item + .slds-item,.slds-has-dividers--around > .slds-item + .slds-item{
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-has-dividers_around-space > .slds-item,.slds-has-dividers--around-space > .slds-item{
  border:1px solid var(--slds-g-color-border-1);
  border-radius:var(--slds-g-radius-border-2);
  background-clip:padding-box;
  padding:var(--slds-g-spacing-3);
}
@media (min-width: 30em){
  .slds-has-dividers_around-space > .slds-item,.slds-has-dividers--around-space > .slds-item{
    padding:var(--slds-g-spacing-2);
  }
}
.slds-has-dividers_around-space > .slds-item + .slds-item,.slds-has-dividers--around-space > .slds-item + .slds-item{
  margin-block-start:var(--slds-g-spacing-2);
}
.slds-has-list-interactions > .slds-list__item:hover,
.slds-has-list-interactions > .slds-item:hover{
  background-color:var(--slds-g-color-surface-container-2);
  border-color:var(--slds-g-color-border-1);
  cursor:pointer;
}
.slds-has-list-interactions > .slds-list__item:active,
.slds-has-list-interactions > .slds-item:active{
  background-color:var(--slds-g-color-surface-container-2);
  box-shadow:var(--slds-g-color-border-1) 0 -1px 0 inset;
}
.slds-has-list-interactions > .slds-list__item.slds-is-selected,
.slds-has-list-interactions > .slds-item.slds-is-selected{
  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-has-list-interactions > .slds-list__item.slds-is-selected:hover,
.slds-has-list-interactions > .slds-list__item.slds-is-selected:focus,
.slds-has-list-interactions > .slds-item.slds-is-selected:hover,
.slds-has-list-interactions > .slds-item.slds-is-selected:focus{
  box-shadow:var(--slds-g-color-accent-1) 0 -2px 0 inset, var(--slds-g-color-accent-1) 0 0 0 1px inset;
}
.slds-has-divider_top,.slds-has-divider--top{
  border-block-start:1px solid var(--slds-g-color-border-1);
}
.slds-has-divider_top-space,.slds-has-divider--top-space{
  border-block-start:1px solid var(--slds-g-color-border-1);
  margin-block-start:var(--slds-g-spacing-2);
  padding-block-start:var(--slds-g-spacing-2);
}
.slds-has-divider_right,.slds-has-divider--right{
  position:relative;
  display:flex;
  align-items:center;
}
.slds-has-divider_right::after,.slds-has-divider--right::after{
  height:2px;
  content:'';
  margin-inline-start:var(--slds-g-spacing-2);
  margin-inline-end:var(--slds-g-spacing-2);
  border-radius:50%;
  background-color:currentColor;
}
.slds-has-divider_right:last-child,.slds-has-divider--right:last-child{
  margin-inline-end:0;
  padding-inline-end:0;
}
.slds-has-divider_right:last-child::after,.slds-has-divider--right:last-child::after{
  content:none;
}
.slds-has-divider_bottom,.slds-has-divider--bottom{
  border-block-end:1px solid var(--slds-g-color-border-1);
}
.slds-has-divider_bottom-space,.slds-has-divider--bottom-space{
  border-block-end:1px solid var(--slds-g-color-border-1);
  margin-block-end:var(--slds-g-spacing-2);
  padding-block-end:var(--slds-g-spacing-2);
}
.slds-has-divider_left,.slds-has-divider--left{
  position:relative;
  display:flex;
  align-items:center;
}
.slds-has-divider_left::before,.slds-has-divider--left::before{
  width:2px;
  height:2px;
  content:'';
  display:inline-block;
  vertical-align:middle;
  margin-inline-start:var(--slds-g-spacing-2);
  margin-inline-end:var(--slds-g-spacing-2);
  border-radius:50%;
  background-color:currentColor;
}
.slds-has-divider_left:first-child,.slds-has-divider--left:first-child{
  margin-inline-end:0;
  padding-inline-end:0;
}
.slds-has-divider_left:first-child::before,.slds-has-divider--left:first-child::before{
  content:none;
}
.slds-list_horizontal.slds-has-dividers > .slds-list__item,.slds-list--horizontal.slds-has-dividers > .slds-list__item{
  position:relative;
  display:flex;
  align-items:center;
}
.slds-list_horizontal.slds-has-dividers > .slds-list__item::after,.slds-list--horizontal.slds-has-dividers > .slds-list__item::after{
  width:2px;
  height:2px;
  content:'';
  margin-inline-start:var(--slds-g-spacing-2);
  margin-inline-end:var(--slds-g-spacing-2);
  border-radius:50%;
  background-color:currentColor;
}
.slds-list_horizontal.slds-has-dividers > .slds-list__item:last-child,.slds-list--horizontal.slds-has-dividers > .slds-list__item:last-child{
  margin-inline-end:0;
  padding-inline-end:0;
}
.slds-list_horizontal.slds-has-dividers > .slds-list__item:last-child::after,.slds-list--horizontal.slds-has-dividers > .slds-list__item:last-child::after{
  content:none;
}
.slds-list_horizontal,.slds-list--horizontal{
  display:flex;
}
.slds-list_horizontal > .slds-list__item,.slds-list--horizontal > .slds-list__item{
  align-self:center;
}
.slds-list_horizontal-large > .slds-list__item > a,.slds-list--horizontal-large > .slds-list__item > a,
.slds-list_horizontal-large > .slds-item > a,
.slds-list--horizontal-large > .slds-item > a{
  padding-block:var(--slds-g-spacing-3);
  padding-inline:var(--slds-g-spacing-4);
}
.slds-has-dividers_left > .slds-list__item,.slds-has-dividers--left > .slds-list__item,
.slds-has-dividers_left > .slds-item,
.slds-has-dividers--left > .slds-item{
  position:relative;
  display:flex;
  align-items:center;
}
.slds-has-dividers_left > .slds-list__item::before,.slds-has-dividers--left > .slds-list__item::before,
.slds-has-dividers_left > .slds-item::before,
.slds-has-dividers--left > .slds-item::before{
  width:2px;
  height:2px;
  content:'';
  display:inline-block;
  vertical-align:middle;
  margin-inline-start:var(--slds-g-spacing-2);
  margin-inline-end:var(--slds-g-spacing-2);
  border-radius:50%;
  background-color:currentColor;
}
.slds-has-dividers_left > .slds-list__item:first-child,.slds-has-dividers--left > .slds-list__item:first-child,
.slds-has-dividers_left > .slds-item:first-child,
.slds-has-dividers--left > .slds-item:first-child{
  margin-inline-end:0;
  padding-inline-end:0;
}
.slds-has-dividers_left > .slds-list__item:first-child::before,.slds-has-dividers--left > .slds-list__item:first-child::before,
.slds-has-dividers_left > .slds-item:first-child::before,
.slds-has-dividers--left > .slds-item:first-child::before{
  content:none;
}
.slds-has-dividers_right > .slds-list__item,.slds-has-dividers--right > .slds-list__item,
.slds-has-dividers_right > .slds-item,
.slds-has-dividers--right > .slds-item{
  position:relative;
  display:flex;
  align-items:center;
}
.slds-has-dividers_right > .slds-list__item::after,.slds-has-dividers--right > .slds-list__item::after,
.slds-has-dividers_right > .slds-item::after,
.slds-has-dividers--right > .slds-item::after{
  width:2px;
  height:2px;
  content:'';
  margin-inline-start:var(--slds-g-spacing-2);
  margin-inline-end:var(--slds-g-spacing-2);
  border-radius:50%;
  background-color:currentColor;
}
.slds-has-dividers_right > .slds-list__item:last-child,.slds-has-dividers--right > .slds-list__item:last-child,
.slds-has-dividers_right > .slds-item:last-child,
.slds-has-dividers--right > .slds-item:last-child{
  margin-inline-end:0;
  padding-inline-end:0;
}
.slds-has-dividers_right > .slds-list__item:last-child::after,.slds-has-dividers--right > .slds-list__item:last-child::after,
.slds-has-dividers_right > .slds-item:last-child::after,
.slds-has-dividers--right > .slds-item:last-child::after{
  content:none;
}
.slds-dl_inline::after,.slds-dl--inline::after{
  content:'';
  display:table;
  clear:both;
}
@media (min-width: 30em){
  .slds-dl_inline__label,.slds-dl--inline__label{
    float:inline-start;
    clear:inline-start;
  }
  .slds-dl_inline__detail,.slds-dl--inline__detail{
    float:inline-start;
    padding-inline-start:var(--slds-g-spacing-1);
  }
}
.slds-region_narrow .slds-dl_inline__label,.slds-region--narrow .slds-dl--inline__label,
.slds-region_narrow .slds-dl_inline__detail,
.slds-region--narrow .slds-dl--inline__detail{
  float:inline-start;
}
.slds-region_narrow .slds-dl_inline__label,.slds-region--narrow .slds-dl--inline__label{
  clear:inline-start;
}
.slds-region_narrow .slds-dl_inline__detail,.slds-region--narrow .slds-dl--inline__detail{
  padding-inline-start:var(--slds-g-spacing-1);
}
.slds-region_narrow .slds-dl_horizontal,.slds-region--narrow .slds-dl--horizontal{
  display:flex;
  flex-wrap:wrap;
}
.slds-region_narrow .slds-dl_horizontal .slds-dl_horizontal__label,.slds-region--narrow .slds-dl--horizontal .slds-dl--horizontal__label{
  width:30%;
  padding-inline-end:var(--slds-g-spacing-3);
}
.slds-region_narrow .slds-dl_horizontal .slds-dl_horizontal__detail,.slds-region--narrow .slds-dl--horizontal .slds-dl--horizontal__detail{
  width:70%;
}
@media (min-width: 30em){
  .slds-dl_horizontal,.slds-dl--horizontal{
    display:flex;
    flex-wrap:wrap;
  }
  .slds-dl_horizontal__label,.slds-dl--horizontal__label{
    width:30%;
    padding-inline-end:var(--slds-g-spacing-3);
  }
  .slds-dl_horizontal__detail,.slds-dl--horizontal__detail{
    width:70%;
  }
}
.slds-list_horizontal .slds-item_label,.slds-list--horizontal .slds-item--label{
  width:30%;
  padding-inline-end:var(--slds-g-spacing-3);
}
.slds-list_horizontal .slds-item_detail,.slds-list--horizontal .slds-item--detail{
  width:70%;
}
.slds-list_vertical .slds-item_label,.slds-list--vertical .slds-item--label,
.slds-list_vertical .slds-item_detail,
.slds-list--vertical .slds-item--detail{
  display:block;
}
.slds-list_inline,.slds-list--inline{
  display:inline-flex;
  max-width:100%;
}
.slds-list_inline .slds-item_label,.slds-list--inline .slds-item--label{
  max-width:180px;
  padding-inline-end:var(--slds-g-spacing-3);
  flex-shrink:0;
}
.slds-list_inline .slds-item_label ~ .slds-item_label,.slds-list--inline .slds-item--label ~ .slds-item--label{
  padding-inline-start:var(--slds-g-spacing-4);
}
.slds-list_inline .slds-item_detail,.slds-list--inline .slds-item--detail{
  min-width:0;
}
.slds-truncate{
  max-width:100%;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.slds-truncate_container_25,.slds-truncate_container--25{
  max-width:25%;
}
.slds-truncate_container_50,.slds-truncate_container--50{
  max-width:50%;
}
.slds-truncate_container_75,.slds-truncate_container--75{
  max-width:75%;
}
.slds-truncate_container_33,.slds-truncate_container--33{
  max-width:33%;
}
.slds-truncate_container_66,.slds-truncate_container--66{
  max-width:66%;
}
.slds-hyphenate{
  overflow-wrap:break-word;
  word-wrap:break-word;
  hyphens:auto;
}
.slds-box{
  padding:var(--slds-g-spacing-4);
  border-radius:var(--slds-g-radius-border-2);
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);
}
.slds-box_xx-small,.slds-box--xx-small{
  padding:var(--slds-g-spacing-1);
}
.slds-box_x-small,.slds-box--x-small{
  padding:var(--slds-g-spacing-2);
}
.slds-box_small,.slds-box--small{
  padding:var(--slds-g-spacing-3);
}
.slds-box_link,.slds-box--link,
.slds-box_link:active,
.slds-box--link:active,
.slds-box_link:focus,
.slds-box--link:focus,
.slds-box_link:hover,
.slds-box--link:hover{
  color:inherit;
  text-decoration:inherit;
}
.slds-box_link:hover,.slds-box--link:hover,
.slds-box_link:focus,
.slds-box--link:focus{
  cursor:pointer;
  outline:0;
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-accent-2);
  box-shadow:0 0 0 1px var(--slds-g-color-accent-1) inset;
}
.slds-theme_default,.slds-theme--default{
  background-color:var(--slds-g-color-surface-container-1);
  color:var(--slds-g-color-on-surface-3);
}
.slds-theme_shade,.slds-theme--shade{
  background-color:var(--slds-g-color-surface-container-2);
}
.slds-theme_inverse,.slds-theme--inverse{
  color:var(--slds-g-color-neutral-base-100);
  background-color:var(--slds-g-color-brand-base-10);
  border-color:var(--slds-g-color-brand-base-10);
}
.slds-theme_inverse a:not(.slds-button_neutral),.slds-theme--inverse a:not(.slds-button--neutral){
  color:var(--slds-g-color-neutral-base-100);
  text-decoration:underline;
}
.slds-theme_inverse a:not(.slds-button_neutral):link,.slds-theme--inverse a:not(.slds-button--neutral):link,
.slds-theme_inverse a:not(.slds-button_neutral):visited,
.slds-theme--inverse a:not(.slds-button--neutral):visited{
  color:var(--slds-g-color-neutral-base-100);
}
.slds-theme_inverse a:not(.slds-button_neutral):hover,.slds-theme--inverse a:not(.slds-button--neutral):hover,
.slds-theme_inverse a:not(.slds-button_neutral):focus,
.slds-theme--inverse a:not(.slds-button--neutral):focus{
  text-decoration:none;
}
.slds-theme_inverse a:not(.slds-button_neutral):active,.slds-theme--inverse a:not(.slds-button--neutral):active{
  color:rgba(255, 255, 255, 0.5);
}
.slds-theme_inverse a:not(.slds-button_neutral)[disabled],.slds-theme--inverse a:not(.slds-button--neutral)[disabled]{
  color:rgba(255, 255, 255, 0.15);
}
.slds-theme_alt-inverse,.slds-theme--alt-inverse{
  color:var(--slds-g-color-neutral-base-100);
  background-color:var(--slds-g-color-brand-base-20);
  border-color:var(--slds-g-color-brand-base-20);
}
.slds-theme_alt-inverse a:not(.slds-button_neutral),.slds-theme--alt-inverse a:not(.slds-button--neutral){
  color:var(--slds-g-color-neutral-base-100);
  text-decoration:underline;
}
.slds-theme_alt-inverse a:not(.slds-button_neutral):link,.slds-theme--alt-inverse a:not(.slds-button--neutral):link,
.slds-theme_alt-inverse a:not(.slds-button_neutral):visited,
.slds-theme--alt-inverse a:not(.slds-button--neutral):visited{
  color:var(--slds-g-color-neutral-base-100);
}
.slds-theme_alt-inverse a:not(.slds-button_neutral):hover,.slds-theme--alt-inverse a:not(.slds-button--neutral):hover,
.slds-theme_alt-inverse a:not(.slds-button_neutral):focus,
.slds-theme--alt-inverse a:not(.slds-button--neutral):focus{
  text-decoration:none;
}
.slds-theme_alt-inverse a:not(.slds-button_neutral):active,.slds-theme--alt-inverse a:not(.slds-button--neutral):active{
  color:rgba(255, 255, 255, 0.5);
}
.slds-theme_alt-inverse a:not(.slds-button_neutral)[disabled],.slds-theme--alt-inverse a:not(.slds-button--neutral)[disabled]{
  color:rgba(255, 255, 255, 0.15);
}
.slds-theme_success,.slds-theme--success{
  color:var(--slds-g-color-on-success-1);
  background-color:var(--slds-g-color-success-container-1);
}
.slds-theme_success a:not(.slds-button_neutral),.slds-theme--success a:not(.slds-button--neutral){
  color:var(--slds-g-color-on-success-1);
  text-decoration:underline;
}
.slds-theme_success a:not(.slds-button_neutral):link,.slds-theme--success a:not(.slds-button--neutral):link,
.slds-theme_success a:not(.slds-button_neutral):visited,
.slds-theme--success a:not(.slds-button--neutral):visited{
  color:var(--slds-g-color-on-success-1);
}
.slds-theme_success a:not(.slds-button_neutral):hover,.slds-theme--success a:not(.slds-button--neutral):hover,
.slds-theme_success a:not(.slds-button_neutral):focus,
.slds-theme--success a:not(.slds-button--neutral):focus{
  text-decoration:none;
}
.slds-theme_success a:not(.slds-button_neutral):active,.slds-theme--success a:not(.slds-button--neutral):active{
  color:var(--slds-g-color-on-success-1);
}
.slds-theme_success a:not(.slds-button_neutral)[disabled],.slds-theme--success a:not(.slds-button--neutral)[disabled]{
  color:rgba(255, 255, 255, 0.15);
}
.slds-theme_success .slds-icon,.slds-theme--success .slds-icon,
.slds-theme_success .slds-button__icon,
.slds-theme--success .slds-button__icon{
  fill:var(--slds-g-color-on-success-1);
}
.slds-theme_info,.slds-theme--info{
  color:var(--slds-g-color-on-info-1);
  background-color:var(--slds-g-color-info-container-1);
}
.slds-theme_info a:not(.slds-button_neutral),.slds-theme--info a:not(.slds-button--neutral){
  color:var(--slds-g-color-on-info-1);
  text-decoration:underline;
}
.slds-theme_info a:not(.slds-button_neutral):link,.slds-theme--info a:not(.slds-button--neutral):link,
.slds-theme_info a:not(.slds-button_neutral):visited,
.slds-theme--info a:not(.slds-button--neutral):visited{
  color:var(--slds-g-color-on-info-1);
}
.slds-theme_info a:not(.slds-button_neutral):hover,.slds-theme--info a:not(.slds-button--neutral):hover,
.slds-theme_info a:not(.slds-button_neutral):focus,
.slds-theme--info a:not(.slds-button--neutral):focus{
  text-decoration:none;
}
.slds-theme_info a:not(.slds-button_neutral):active,.slds-theme--info a:not(.slds-button--neutral):active{
  color:var(--slds-g-color-on-info-1);
}
.slds-theme_info a:not(.slds-button_neutral)[disabled],.slds-theme--info a:not(.slds-button--neutral)[disabled]{
  color:rgba(255, 255, 255, 0.15);
}
.slds-theme_info .slds-icon,.slds-theme--info .slds-icon,
.slds-theme_info .slds-button__icon,
.slds-theme--info .slds-button__icon{
  fill:var(--slds-g-color-on-info-1);
}
.slds-theme_warning,.slds-theme--warning{
  background-color:var(--slds-g-color-warning-container-1);
  color:var(--slds-g-color-on-warning-1);
}
.slds-theme_warning a,.slds-theme--warning a{
  color:var(--slds-g-color-on-warning-1);
  text-decoration:underline;
}
.slds-theme_warning a:link,.slds-theme--warning a:link,
.slds-theme_warning a:visited,
.slds-theme--warning a:visited{
  color:var(--slds-g-color-on-warning-1);
}
.slds-theme_warning a:hover,.slds-theme--warning a:hover,
.slds-theme_warning a:focus,
.slds-theme--warning a:focus{
  text-decoration:none;
}
.slds-theme_warning a:focus-visible,.slds-theme--warning a:focus-visible{
  box-shadow:var(--slds-s-link-shadow-focus);
  outline:0;
}
.slds-theme_warning a:active,.slds-theme--warning a:active{
  color:var(--slds-g-color-on-warning-1);
}
.slds-theme_warning a[disabled],.slds-theme--warning a[disabled]{
  color:var(--slds-g-color-neutral-base-30, #514f4d);
}
.slds-theme_warning button,.slds-theme--warning button{
  color:var(--slds-g-color-neutral-base-30, #514f4d);
  text-decoration:underline;
}
.slds-theme_warning button:hover,.slds-theme--warning button:hover{
  color:var(--slds-g-color-neutral-base-50, #706e6b);
}
.slds-theme_warning button:focus,.slds-theme--warning button:focus{
  color:var(--slds-g-color-neutral-base-30, #514f4d);
  box-shadow:0 0 3px var(--slds-g-color-neutral-base-30, #514f4d);
  border:1px solid var(--slds-g-color-neutral-base-30, #514f4d);
}
.slds-theme_warning button:active,.slds-theme--warning button:active{
  color:var(--slds-g-color-neutral-base-50, #706e6b);
}
.slds-theme_warning .slds-icon,.slds-theme--warning .slds-icon,
.slds-theme_warning .slds-button__icon,
.slds-theme--warning .slds-button__icon{
  fill:var(--slds-g-color-on-warning-1);
}
.slds-theme_error,.slds-theme--error{
  color:var(--slds-g-color-on-error-1);
  background-color:var(--slds-g-color-error-container-1);
}
.slds-theme_error a:not(.slds-button_neutral),.slds-theme--error a:not(.slds-button--neutral){
  color:var(--slds-g-color-on-error-1);
  text-decoration:underline;
}
.slds-theme_error a:not(.slds-button_neutral):link,.slds-theme--error a:not(.slds-button--neutral):link,
.slds-theme_error a:not(.slds-button_neutral):visited,
.slds-theme--error a:not(.slds-button--neutral):visited{
  color:var(--slds-g-color-on-error-1);
}
.slds-theme_error a:not(.slds-button_neutral):hover,.slds-theme--error a:not(.slds-button--neutral):hover,
.slds-theme_error a:not(.slds-button_neutral):focus,
.slds-theme--error a:not(.slds-button--neutral):focus{
  text-decoration:none;
}
.slds-theme_error a:not(.slds-button_neutral):active,.slds-theme--error a:not(.slds-button--neutral):active{
  color:var(--slds-g-color-on-error-1);
}
.slds-theme_error a:not(.slds-button_neutral)[disabled],.slds-theme--error a:not(.slds-button--neutral)[disabled]{
  color:rgba(255, 255, 255, 0.15);
}
.slds-theme_error .slds-icon,.slds-theme--error .slds-icon,
.slds-theme_error .slds-button__icon,
.slds-theme--error .slds-button__icon{
  fill:var(--slds-g-color-on-error-1);
}
.slds-theme_offline,.slds-theme--offline{
  color:var(--slds-g-color-neutral-base-100);
  background-color:var(--slds-g-color-neutral-base-30);
}
.slds-theme_offline a:not(.slds-button_neutral),.slds-theme--offline a:not(.slds-button--neutral){
  color:var(--slds-g-color-neutral-base-100);
  text-decoration:underline;
}
.slds-theme_offline a:not(.slds-button_neutral):link,.slds-theme--offline a:not(.slds-button--neutral):link,
.slds-theme_offline a:not(.slds-button_neutral):visited,
.slds-theme--offline a:not(.slds-button--neutral):visited{
  color:var(--slds-g-color-neutral-base-100);
}
.slds-theme_offline a:not(.slds-button_neutral):hover,.slds-theme--offline a:not(.slds-button--neutral):hover,
.slds-theme_offline a:not(.slds-button_neutral):focus,
.slds-theme--offline a:not(.slds-button--neutral):focus{
  text-decoration:none;
}
.slds-theme_offline a:not(.slds-button_neutral):active,.slds-theme--offline a:not(.slds-button--neutral):active{
  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 50%);
}
.slds-theme_offline a:not(.slds-button_neutral)[disabled],.slds-theme--offline a:not(.slds-button--neutral)[disabled]{
  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 10%);
}
.slds-theme_inverse-text,.slds-theme--inverse-text{
  color:var(--slds-g-color-neutral-base-100);
}
.slds-theme_inverse-text a:not(.slds-button_neutral),.slds-theme--inverse-text a:not(.slds-button--neutral){
  color:var(--slds-g-color-neutral-base-100);
  text-decoration:underline;
}
.slds-theme_inverse-text a:not(.slds-button_neutral):link,.slds-theme--inverse-text a:not(.slds-button--neutral):link,
.slds-theme_inverse-text a:not(.slds-button_neutral):visited,
.slds-theme--inverse-text a:not(.slds-button--neutral):visited{
  color:var(--slds-g-color-neutral-base-100);
}
.slds-theme_inverse-text a:not(.slds-button_neutral):hover,.slds-theme--inverse-text a:not(.slds-button--neutral):hover,
.slds-theme_inverse-text a:not(.slds-button_neutral):focus,
.slds-theme--inverse-text a:not(.slds-button--neutral):focus{
  text-decoration:none;
}
.slds-theme_inverse-text a:not(.slds-button_neutral):active,.slds-theme--inverse-text a:not(.slds-button--neutral):active{
  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 50%);
}
.slds-theme_inverse-text a:not(.slds-button_neutral)[disabled],.slds-theme--inverse-text a:not(.slds-button--neutral)[disabled]{
  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 15%);
}
.slds-dueling-list{
  display:flex;
  clear:left;
}
.slds-dueling-list__column{
  display:inline-flex;
  flex-direction:column;
}
.slds-dueling-list__column .slds-button{
  margin:var(--slds-g-spacing-1);
}
.slds-dueling-list__column .slds-button:first-of-type{
  margin-top:var(--slds-g-spacing-5);
}
.slds-dueling-list__column_responsive,.slds-dueling-list__column--responsive{
  flex:1 1 var(--slds-g-sizing-14);
  flex-wrap:wrap;
  overflow:hidden;
  min-width:6rem;
}
.slds-dueling-list__column_responsive .slds-dueling-list__options,.slds-dueling-list__column--responsive .slds-dueling-list__options{
  width:auto;
  max-width:100%;
}
.slds-dueling-list__options,
.slds-picklist__options{
  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);
  border-radius:var(--slds-g-radius-border-2);
  padding:var(--slds-g-spacing-1) 0;
  width:var(--slds-g-sizing-14);
  height:var(--slds-g-sizing-14);
  background-color:var(--slds-g-color-surface-container-1);
  overflow:auto;
}
.slds-dueling-list__options .slds-is-grabbed,
.slds-picklist__options .slds-is-grabbed{
  transform:rotate(3deg);
}
.slds-dueling-list__options [aria-selected='true'],
.slds-picklist__options [aria-selected='true']{
  background-color:var(--slds-g-color-accent-container-1);
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-dueling-list__options [aria-selected='true']:hover,
.slds-picklist__options [aria-selected='true']:hover,
.slds-dueling-list__options [aria-selected='true']:focus,
.slds-picklist__options [aria-selected='true']:focus{
  background:var(--slds-g-color-accent-container-3);
  color:var(--slds-g-color-on-surface-inverse-1);
}
.slds-dueling-list__options.slds-is-disabled,
.slds-picklist__options.slds-is-disabled{
  background-color:var(--slds-g-color-disabled-container-1, var(--slds-g-color-neutral-base-95));
  border-color:var(--slds-g-color-border-disabled-1);
  color:var(--slds-g-color-disabled-2);
}
.slds-dueling-list__options.slds-is-disabled:hover,
.slds-picklist__options.slds-is-disabled:hover{
  cursor:not-allowed;
}
.slds-dueling-list__options.slds-is-disabled .slds-listbox__option:hover,
.slds-picklist__options.slds-is-disabled .slds-listbox__option:hover{
  cursor:not-allowed;
  background-color:transparent;
}
.slds-dueling-list__options.slds-is-disabled .slds-listbox__option:focus,
.slds-picklist__options.slds-is-disabled .slds-listbox__option:focus{
  background-color:transparent;
}
.slds-text-body_regular,.slds-text-body--regular{
  font-size:var(--slds-g-font-size-base);
}
.slds-text-body_small,.slds-text-body--small{
  font-size:var(--slds-g-font-scale-neg-1);
}
.slds-text-heading_large,.slds-text-heading--large{
  font-size:var(--slds-g-font-scale-6);
  line-height:var(--slds-g-font-lineheight-2);
}
.slds-text-heading_medium,.slds-text-heading--medium{
  font-size:var(--slds-g-font-scale-4);
  line-height:var(--slds-g-font-lineheight-2);
}
.slds-text-heading_small,.slds-text-heading--small{
  font-size:var(--slds-g-font-scale-2);
  line-height:var(--slds-g-font-lineheight-2);
}
.slds-text-title{
  font-size:var(--slds-g-font-scale-neg-1);
  line-height:var(--slds-g-font-lineheight-2);
  color:var(--slds-g-color-on-surface-1);
}
.slds-text-title_caps,.slds-text-title--caps{
  font-size:var(--slds-g-font-scale-neg-1);
  color:var(--slds-g-color-on-surface-1);
  font-weight:var(--slds-g-font-weight-4);
  text-transform:uppercase;
  letter-spacing:0.0625rem;
}
.slds-text-title_bold,.slds-text-title--bold{
  font-size:var(--slds-g-font-scale-neg-1);
  font-weight:var(--slds-g-font-weight-7);
}
.slds-line-height_reset,.slds-line-height--reset{
  line-height:1;
}
.slds-text-color_default,.slds-text-color--default{
  color:var(--slds-g-color-on-surface-3);
}
.slds-text-color_weak,.slds-text-color--weak{
  color:var(--slds-g-color-on-surface-1);
}
.slds-text-color_error,.slds-text-color--error{
  color:var(--slds-g-color-error-1);
}
.slds-text-color_destructive,.slds-text-color--destructive{
  color:var(--slds-g-color-error-1);
}
.slds-text-color_success,.slds-text-color--success{
  color:var(--slds-g-color-success-1);
}
.slds-text-color_inverse,.slds-text-color--inverse{
  color:var(--slds-g-color-neutral-base-100);
}
.slds-text-color_inverse-weak,.slds-text-color--inverse-weak{
  color:var(--slds-g-color-neutral-base-70);
}
.slds-text-align_left,.slds-text-align--left{
  text-align:start;
}
.slds-text-align_center,.slds-text-align--center{
  text-align:center;
}
.slds-text-align_right,.slds-text-align--right{
  text-align:end;
}
.slds-text-longform h1,
.slds-text-longform h2,
.slds-text-longform h3,
.slds-text-longform p,
.slds-text-longform ul,
.slds-text-longform ol,
.slds-text-longform dl,
.slds-text-longform img{
  margin-block-end:var(--slds-g-spacing-4);
}
.slds-text-longform ul{
  margin-inline-start:var(--slds-g-spacing-5);
  list-style:disc;
}
.slds-text-longform ul ul{
  list-style:circle;
}
.slds-text-longform ul ul ul{
  list-style:square;
}
.slds-text-longform ol{
  margin-inline-start:var(--slds-g-spacing-5);
  list-style:decimal;
}
.slds-text-longform ol ol{
  list-style:lower-alpha;
}
.slds-text-longform ol ol ol{
  list-style:lower-roman;
}
.slds-text-longform .slds-video{
  display:block;
  max-width:100%;
}
.slds-text-longform .slds-video.slds-video_center,.slds-text-longform .slds-video.slds-video--center{
  margin:0 auto;
}
.slds-text-longform .slds-video.slds-video_right,.slds-text-longform .slds-video.slds-video--right{
  margin:0 0 0 auto;
}
.slds-text-font_monospace,.slds-text-font--monospace{
  font-family:var(--slds-g-font-family-monospace);
}
.slds-color__text_gray-1,.slds-color__text--gray-1{
  color:var(--slds-g-color-neutral-base-100) !important;
}
.slds-color__text_gray-2,.slds-color__text--gray-2{
  color:var(--slds-g-color-neutral-base-95) !important;
}
.slds-color__text_gray-3,.slds-color__text--gray-3{
  color:var(--slds-g-color-neutral-base-95) !important;
}
.slds-color__text_gray-4,.slds-color__text--gray-4{
  color:var(--slds-g-color-neutral-base-90) !important;
}
.slds-color__text_gray-5,.slds-color__text--gray-5{
  color:var(--slds-g-color-neutral-base-90) !important;
}
.slds-color__text_gray-6,.slds-color__text--gray-6{
  color:var(--slds-g-color-neutral-base-80) !important;
}
.slds-color__text_gray-7,.slds-color__text--gray-7{
  color:var(--slds-g-color-neutral-base-70) !important;
}
.slds-color__text_gray-8,.slds-color__text--gray-8{
  color:var(--slds-g-color-neutral-base-60) !important;
}
.slds-color__text_gray-9,.slds-color__text--gray-9{
  color:var(--slds-g-color-neutral-base-50) !important;
}
.slds-color__text_gray-10,.slds-color__text--gray-10{
  color:var(--slds-g-color-neutral-base-30) !important;
}
.slds-color__text_gray-11,.slds-color__text--gray-11{
  color:var(--slds-g-color-neutral-base-30) !important;
}
.slds-color__text_gray-12,.slds-color__text--gray-12{
  color:var(--slds-g-color-neutral-base-20) !important;
}
.slds-color__background_gray-1,.slds-color__background--gray-1{
  background-color:var(--slds-g-color-neutral-base-100) !important;
}
.slds-color__background_gray-2,.slds-color__background--gray-2{
  background-color:var(--slds-g-color-neutral-base-95) !important;
}
.slds-color__background_gray-3,.slds-color__background--gray-3{
  background-color:var(--slds-g-color-neutral-base-95) !important;
}
.slds-color__background_gray-4,.slds-color__background--gray-4{
  background-color:var(--slds-g-color-neutral-base-90) !important;
}
.slds-color__background_gray-5,.slds-color__background--gray-5{
  background-color:var(--slds-g-color-neutral-base-90) !important;
}
.slds-color__background_gray-6,.slds-color__background--gray-6{
  background-color:var(--slds-g-color-neutral-base-80) !important;
}
.slds-color__background_gray-7,.slds-color__background--gray-7{
  background-color:var(--slds-g-color-neutral-base-70) !important;
}
.slds-color__background_gray-8,.slds-color__background--gray-8{
  background-color:var(--slds-g-color-neutral-base-60) !important;
}
.slds-color__background_gray-9,.slds-color__background--gray-9{
  background-color:var(--slds-g-color-neutral-base-50) !important;
}
.slds-color__background_gray-10,.slds-color__background--gray-10{
  background-color:var(--slds-g-color-neutral-base-30) !important;
}
.slds-color__background_gray-11,.slds-color__background--gray-11{
  background-color:var(--slds-g-color-neutral-base-30) !important;
}
.slds-color__background_gray-12,.slds-color__background--gray-12{
  background-color:var(--slds-g-color-neutral-base-20) !important;
}
.slds-color__border_gray-1,.slds-color__border--gray-1{
  border-color:var(--slds-g-color-neutral-base-100) !important;
}
.slds-color__border_gray-2,.slds-color__border--gray-2{
  border-color:var(--slds-g-color-neutral-base-95) !important;
}
.slds-color__border_gray-3,.slds-color__border--gray-3{
  border-color:var(--slds-g-color-neutral-base-95) !important;
}
.slds-color__border_gray-4,.slds-color__border--gray-4{
  border-color:var(--slds-g-color-neutral-base-90) !important;
}
.slds-color__border_gray-5,.slds-color__border--gray-5{
  border-color:var(--slds-g-color-neutral-base-90) !important;
}
.slds-color__border_gray-6,.slds-color__border--gray-6{
  border-color:var(--slds-g-color-neutral-base-80) !important;
}
.slds-color__border_gray-7,.slds-color__border--gray-7{
  border-color:var(--slds-g-color-neutral-base-70) !important;
}
.slds-color__border_gray-8,.slds-color__border--gray-8{
  border-color:var(--slds-g-color-neutral-base-60) !important;
}
.slds-color__border_gray-9,.slds-color__border--gray-9{
  border-color:var(--slds-g-color-neutral-base-50) !important;
}
.slds-color__border_gray-10,.slds-color__border--gray-10{
  border-color:var(--slds-g-color-neutral-base-30) !important;
}
.slds-color__border_gray-11,.slds-color__border--gray-11{
  border-color:var(--slds-g-color-neutral-base-30) !important;
}
.slds-color__border_gray-12,.slds-color__border--gray-12{
  border-color:var(--slds-g-color-neutral-base-20) !important;
}
.slds-color__fill_gray-1,.slds-color__fill--gray-1{
  fill:var(--slds-g-color-neutral-base-100) !important;
}
.slds-color__fill_gray-2,.slds-color__fill--gray-2{
  fill:var(--slds-g-color-neutral-base-95) !important;
}
.slds-color__fill_gray-3,.slds-color__fill--gray-3{
  fill:var(--slds-g-color-neutral-base-95) !important;
}
.slds-color__fill_gray-4,.slds-color__fill--gray-4{
  fill:var(--slds-g-color-neutral-base-90) !important;
}
.slds-color__fill_gray-5,.slds-color__fill--gray-5{
  fill:var(--slds-g-color-neutral-base-90) !important;
}
.slds-color__fill_gray-6,.slds-color__fill--gray-6{
  fill:var(--slds-g-color-neutral-base-80) !important;
}
.slds-color__fill_gray-7,.slds-color__fill--gray-7{
  fill:var(--slds-g-color-neutral-base-70) !important;
}
.slds-color__fill_gray-8,.slds-color__fill--gray-8{
  fill:var(--slds-g-color-neutral-base-60) !important;
}
.slds-color__fill_gray-9,.slds-color__fill--gray-9{
  fill:var(--slds-g-color-neutral-base-50) !important;
}
.slds-color__fill_gray-10,.slds-color__fill--gray-10{
  fill:var(--slds-g-color-neutral-base-30) !important;
}
.slds-color__fill_gray-11,.slds-color__fill--gray-11{
  fill:var(--slds-g-color-neutral-base-30) !important;
}
.slds-color__fill_gray-12,.slds-color__fill--gray-12{
  fill:var(--slds-g-color-neutral-base-20) !important;
}
.slds-scrollable{
  -webkit-overflow-scrolling:touch;
  overflow:auto;
}
.slds-scrollable_none,.slds-scrollable--none{
  overflow:hidden;
}
.slds-scrollable_y,.slds-scrollable--y{
  -webkit-overflow-scrolling:touch;
  max-height:100%;
  overflow:hidden;
  overflow-y:auto;
}
.slds-scrollable_x,.slds-scrollable--x{
  -webkit-overflow-scrolling:touch;
  max-width:100%;
  overflow:hidden;
  overflow-x:auto;
}
.slds-size_xxx-small,.slds-size--xxx-small{
  width:3rem;
}
.slds-size_xx-small,.slds-size--xx-small{
  width:6rem;
}
.slds-size_x-small,.slds-size--x-small{
  width:12rem;
}
.slds-size_small,.slds-size--small{
  width:15rem;
}
.slds-size_medium,.slds-size--medium{
  width:20rem;
}
.slds-size_large,.slds-size--large{
  width:25rem;
}
.slds-size_x-large,.slds-size--x-large{
  width:40rem;
}
.slds-size_xx-large,.slds-size--xx-large{
  width:60rem;
}
.slds-size_full,.slds-size--full{
  width:100%;
}
.slds-size_1-of-1,.slds-size--1-of-1{
  width:100%;
}
.slds-size_1-of-2,.slds-size--1-of-2{
  width:50%;
}
.slds-size_2-of-2,.slds-size--2-of-2{
  width:100%;
}
.slds-size_1-of-3,.slds-size--1-of-3{
  width:33.333%;
}
.slds-size_2-of-3,.slds-size--2-of-3{
  width:66.6667%;
}
.slds-size_3-of-3,.slds-size--3-of-3{
  width:100%;
}
.slds-size_1-of-4,.slds-size--1-of-4{
  width:25%;
}
.slds-size_2-of-4,.slds-size--2-of-4{
  width:50%;
}
.slds-size_3-of-4,.slds-size--3-of-4{
  width:75%;
}
.slds-size_4-of-4,.slds-size--4-of-4{
  width:100%;
}
.slds-size_1-of-5,.slds-size--1-of-5{
  width:20%;
}
.slds-size_2-of-5,.slds-size--2-of-5{
  width:40%;
}
.slds-size_3-of-5,.slds-size--3-of-5{
  width:60%;
}
.slds-size_4-of-5,.slds-size--4-of-5{
  width:80%;
}
.slds-size_5-of-5,.slds-size--5-of-5{
  width:100%;
}
.slds-size_1-of-6,.slds-size--1-of-6{
  width:16.6667%;
}
.slds-size_2-of-6,.slds-size--2-of-6{
  width:33.333%;
}
.slds-size_3-of-6,.slds-size--3-of-6{
  width:50%;
}
.slds-size_4-of-6,.slds-size--4-of-6{
  width:66.6667%;
}
.slds-size_5-of-6,.slds-size--5-of-6{
  width:83.3333%;
}
.slds-size_6-of-6,.slds-size--6-of-6{
  width:100%;
}
.slds-size_1-of-7,.slds-size--1-of-7{
  width:14.2857%;
}
.slds-size_2-of-7,.slds-size--2-of-7{
  width:28.5714%;
}
.slds-size_3-of-7,.slds-size--3-of-7{
  width:42.8571%;
}
.slds-size_4-of-7,.slds-size--4-of-7{
  width:57.1429%;
}
.slds-size_5-of-7,.slds-size--5-of-7{
  width:71.4286%;
}
.slds-size_6-of-7,.slds-size--6-of-7{
  width:85.7143%;
}
.slds-size_7-of-7,.slds-size--7-of-7{
  width:100%;
}
.slds-size_1-of-8,.slds-size--1-of-8{
  width:12.5%;
}
.slds-size_2-of-8,.slds-size--2-of-8{
  width:25%;
}
.slds-size_3-of-8,.slds-size--3-of-8{
  width:37.5%;
}
.slds-size_4-of-8,.slds-size--4-of-8{
  width:50%;
}
.slds-size_5-of-8,.slds-size--5-of-8{
  width:62.5%;
}
.slds-size_6-of-8,.slds-size--6-of-8{
  width:75%;
}
.slds-size_7-of-8,.slds-size--7-of-8{
  width:87.5%;
}
.slds-size_8-of-8,.slds-size--8-of-8{
  width:100%;
}
.slds-size_1-of-12,.slds-size--1-of-12{
  width:8.3333%;
}
.slds-size_2-of-12,.slds-size--2-of-12{
  width:16.6667%;
}
.slds-size_3-of-12,.slds-size--3-of-12{
  width:25%;
}
.slds-size_4-of-12,.slds-size--4-of-12{
  width:33.333%;
}
.slds-size_5-of-12,.slds-size--5-of-12{
  width:41.6667%;
}
.slds-size_6-of-12,.slds-size--6-of-12{
  width:50%;
}
.slds-size_7-of-12,.slds-size--7-of-12{
  width:58.3333%;
}
.slds-size_8-of-12,.slds-size--8-of-12{
  width:66.6667%;
}
.slds-size_9-of-12,.slds-size--9-of-12{
  width:75%;
}
.slds-size_10-of-12,.slds-size--10-of-12{
  width:83.3333%;
}
.slds-size_11-of-12,.slds-size--11-of-12{
  width:91.6667%;
}
.slds-size_12-of-12,.slds-size--12-of-12{
  width:100%;
}
.slds-order_1,.slds-order--1{
  order:1;
}
.slds-order_2,.slds-order--2{
  order:2;
}
.slds-order_3,.slds-order--3{
  order:3;
}
.slds-order_4,.slds-order--4{
  order:4;
}
.slds-order_5,.slds-order--5{
  order:5;
}
.slds-order_6,.slds-order--6{
  order:6;
}
.slds-order_7,.slds-order--7{
  order:7;
}
.slds-order_8,.slds-order--8{
  order:8;
}
.slds-order_9,.slds-order--9{
  order:9;
}
.slds-order_10,.slds-order--10{
  order:10;
}
.slds-order_11,.slds-order--11{
  order:11;
}
.slds-order_12,.slds-order--12{
  order:12;
}
@media (min-width: 20em){
  .slds-x-small-size_xxx-small,.slds-x-small-size--xxx-small,
  .slds-x-small-size_xx-small,
  .slds-x-small-size--xx-small,
  .slds-x-small-size_x-small,
  .slds-x-small-size--x-small,
  .slds-x-small-size_small,
  .slds-x-small-size--small,
  .slds-x-small-size_medium,
  .slds-x-small-size--medium,
  .slds-x-small-size_large,
  .slds-x-small-size--large,
  .slds-x-small-size_x-large,
  .slds-x-small-size--x-large,
  .slds-x-small-size_xx-large,
  .slds-x-small-size--xx-large,
  .slds-x-small-size_1-of-1,
  .slds-x-small-size--1-of-1,
  .slds-x-small-size_1-of-2,
  .slds-x-small-size--1-of-2,
  .slds-x-small-size_2-of-2,
  .slds-x-small-size--2-of-2,
  .slds-x-small-size_1-of-3,
  .slds-x-small-size--1-of-3,
  .slds-x-small-size_2-of-3,
  .slds-x-small-size--2-of-3,
  .slds-x-small-size_3-of-3,
  .slds-x-small-size--3-of-3,
  .slds-x-small-size_1-of-4,
  .slds-x-small-size--1-of-4,
  .slds-x-small-size_2-of-4,
  .slds-x-small-size--2-of-4,
  .slds-x-small-size_3-of-4,
  .slds-x-small-size--3-of-4,
  .slds-x-small-size_4-of-4,
  .slds-x-small-size--4-of-4,
  .slds-x-small-size_1-of-5,
  .slds-x-small-size--1-of-5,
  .slds-x-small-size_2-of-5,
  .slds-x-small-size--2-of-5,
  .slds-x-small-size_3-of-5,
  .slds-x-small-size--3-of-5,
  .slds-x-small-size_4-of-5,
  .slds-x-small-size--4-of-5,
  .slds-x-small-size_5-of-5,
  .slds-x-small-size--5-of-5,
  .slds-x-small-size_1-of-6,
  .slds-x-small-size--1-of-6,
  .slds-x-small-size_2-of-6,
  .slds-x-small-size--2-of-6,
  .slds-x-small-size_3-of-6,
  .slds-x-small-size--3-of-6,
  .slds-x-small-size_4-of-6,
  .slds-x-small-size--4-of-6,
  .slds-x-small-size_5-of-6,
  .slds-x-small-size--5-of-6,
  .slds-x-small-size_6-of-6,
  .slds-x-small-size--6-of-6,
  .slds-x-small-size_1-of-7,
  .slds-x-small-size--1-of-7,
  .slds-x-small-size_2-of-7,
  .slds-x-small-size--2-of-7,
  .slds-x-small-size_3-of-7,
  .slds-x-small-size--3-of-7,
  .slds-x-small-size_4-of-7,
  .slds-x-small-size--4-of-7,
  .slds-x-small-size_5-of-7,
  .slds-x-small-size--5-of-7,
  .slds-x-small-size_6-of-7,
  .slds-x-small-size--6-of-7,
  .slds-x-small-size_7-of-7,
  .slds-x-small-size--7-of-7,
  .slds-x-small-size_1-of-8,
  .slds-x-small-size--1-of-8,
  .slds-x-small-size_2-of-8,
  .slds-x-small-size--2-of-8,
  .slds-x-small-size_3-of-8,
  .slds-x-small-size--3-of-8,
  .slds-x-small-size_4-of-8,
  .slds-x-small-size--4-of-8,
  .slds-x-small-size_5-of-8,
  .slds-x-small-size--5-of-8,
  .slds-x-small-size_6-of-8,
  .slds-x-small-size--6-of-8,
  .slds-x-small-size_7-of-8,
  .slds-x-small-size--7-of-8,
  .slds-x-small-size_8-of-8,
  .slds-x-small-size--8-of-8,
  .slds-x-small-size_1-of-12,
  .slds-x-small-size--1-of-12,
  .slds-x-small-size_2-of-12,
  .slds-x-small-size--2-of-12,
  .slds-x-small-size_3-of-12,
  .slds-x-small-size--3-of-12,
  .slds-x-small-size_4-of-12,
  .slds-x-small-size--4-of-12,
  .slds-x-small-size_5-of-12,
  .slds-x-small-size--5-of-12,
  .slds-x-small-size_6-of-12,
  .slds-x-small-size--6-of-12,
  .slds-x-small-size_7-of-12,
  .slds-x-small-size--7-of-12,
  .slds-x-small-size_8-of-12,
  .slds-x-small-size--8-of-12,
  .slds-x-small-size_9-of-12,
  .slds-x-small-size--9-of-12,
  .slds-x-small-size_10-of-12,
  .slds-x-small-size--10-of-12,
  .slds-x-small-size_11-of-12,
  .slds-x-small-size--11-of-12,
  .slds-x-small-size_12-of-12,
  .slds-x-small-size--12-of-12{
    flex:none;
  }

  .slds-x-small-size_xxx-small,.slds-x-small-size--xxx-small{
    width:3rem;
  }

  .slds-x-small-size_xx-small,.slds-x-small-size--xx-small{
    width:6rem;
  }

  .slds-x-small-size_x-small,.slds-x-small-size--x-small{
    width:12rem;
  }

  .slds-x-small-size_small,.slds-x-small-size--small{
    width:15rem;
  }

  .slds-x-small-size_medium,.slds-x-small-size--medium{
    width:20rem;
  }

  .slds-x-small-size_large,.slds-x-small-size--large{
    width:25rem;
  }

  .slds-x-small-size_x-large,.slds-x-small-size--x-large{
    width:40rem;
  }

  .slds-x-small-size_xx-large,.slds-x-small-size--xx-large{
    width:60rem;
  }

  .slds-x-small-size_1-of-1,.slds-x-small-size--1-of-1{
    width:100%;
  }

  .slds-x-small-size_1-of-2,.slds-x-small-size--1-of-2{
    width:50%;
  }

  .slds-x-small-size_2-of-2,.slds-x-small-size--2-of-2{
    width:100%;
  }

  .slds-x-small-size_1-of-3,.slds-x-small-size--1-of-3{
    width:33.333%;
  }

  .slds-x-small-size_2-of-3,.slds-x-small-size--2-of-3{
    width:66.6667%;
  }

  .slds-x-small-size_3-of-3,.slds-x-small-size--3-of-3{
    width:100%;
  }

  .slds-x-small-size_1-of-4,.slds-x-small-size--1-of-4{
    width:25%;
  }

  .slds-x-small-size_2-of-4,.slds-x-small-size--2-of-4{
    width:50%;
  }

  .slds-x-small-size_3-of-4,.slds-x-small-size--3-of-4{
    width:75%;
  }

  .slds-x-small-size_4-of-4,.slds-x-small-size--4-of-4{
    width:100%;
  }

  .slds-x-small-size_1-of-5,.slds-x-small-size--1-of-5{
    width:20%;
  }

  .slds-x-small-size_2-of-5,.slds-x-small-size--2-of-5{
    width:40%;
  }

  .slds-x-small-size_3-of-5,.slds-x-small-size--3-of-5{
    width:60%;
  }

  .slds-x-small-size_4-of-5,.slds-x-small-size--4-of-5{
    width:80%;
  }

  .slds-x-small-size_5-of-5,.slds-x-small-size--5-of-5{
    width:100%;
  }

  .slds-x-small-size_1-of-6,.slds-x-small-size--1-of-6{
    width:16.6667%;
  }

  .slds-x-small-size_2-of-6,.slds-x-small-size--2-of-6{
    width:33.333%;
  }

  .slds-x-small-size_3-of-6,.slds-x-small-size--3-of-6{
    width:50%;
  }

  .slds-x-small-size_4-of-6,.slds-x-small-size--4-of-6{
    width:66.6667%;
  }

  .slds-x-small-size_5-of-6,.slds-x-small-size--5-of-6{
    width:83.3333%;
  }

  .slds-x-small-size_6-of-6,.slds-x-small-size--6-of-6{
    width:100%;
  }

  .slds-x-small-size_1-of-7,.slds-x-small-size--1-of-7{
    width:14.2857%;
  }

  .slds-x-small-size_2-of-7,.slds-x-small-size--2-of-7{
    width:28.5714%;
  }

  .slds-x-small-size_3-of-7,.slds-x-small-size--3-of-7{
    width:42.8571%;
  }

  .slds-x-small-size_4-of-7,.slds-x-small-size--4-of-7{
    width:57.1429%;
  }

  .slds-x-small-size_5-of-7,.slds-x-small-size--5-of-7{
    width:71.4286%;
  }

  .slds-x-small-size_6-of-7,.slds-x-small-size--6-of-7{
    width:85.7143%;
  }

  .slds-x-small-size_7-of-7,.slds-x-small-size--7-of-7{
    width:100%;
  }

  .slds-x-small-size_1-of-8,.slds-x-small-size--1-of-8{
    width:12.5%;
  }

  .slds-x-small-size_2-of-8,.slds-x-small-size--2-of-8{
    width:25%;
  }

  .slds-x-small-size_3-of-8,.slds-x-small-size--3-of-8{
    width:37.5%;
  }

  .slds-x-small-size_4-of-8,.slds-x-small-size--4-of-8{
    width:50%;
  }

  .slds-x-small-size_5-of-8,.slds-x-small-size--5-of-8{
    width:62.5%;
  }

  .slds-x-small-size_6-of-8,.slds-x-small-size--6-of-8{
    width:75%;
  }

  .slds-x-small-size_7-of-8,.slds-x-small-size--7-of-8{
    width:87.5%;
  }

  .slds-x-small-size_8-of-8,.slds-x-small-size--8-of-8{
    width:100%;
  }

  .slds-x-small-size_1-of-12,.slds-x-small-size--1-of-12{
    width:8.3333%;
  }

  .slds-x-small-size_2-of-12,.slds-x-small-size--2-of-12{
    width:16.6667%;
  }

  .slds-x-small-size_3-of-12,.slds-x-small-size--3-of-12{
    width:25%;
  }

  .slds-x-small-size_4-of-12,.slds-x-small-size--4-of-12{
    width:33.333%;
  }

  .slds-x-small-size_5-of-12,.slds-x-small-size--5-of-12{
    width:41.6667%;
  }

  .slds-x-small-size_6-of-12,.slds-x-small-size--6-of-12{
    width:50%;
  }

  .slds-x-small-size_7-of-12,.slds-x-small-size--7-of-12{
    width:58.3333%;
  }

  .slds-x-small-size_8-of-12,.slds-x-small-size--8-of-12{
    width:66.6667%;
  }

  .slds-x-small-size_9-of-12,.slds-x-small-size--9-of-12{
    width:75%;
  }

  .slds-x-small-size_10-of-12,.slds-x-small-size--10-of-12{
    width:83.3333%;
  }

  .slds-x-small-size_11-of-12,.slds-x-small-size--11-of-12{
    width:91.6667%;
  }

  .slds-x-small-size_12-of-12,.slds-x-small-size--12-of-12{
    width:100%;
  }

  .slds-x-small-order_1,.slds-x-small-order--1{
    order:1;
  }

  .slds-x-small-order_2,.slds-x-small-order--2{
    order:2;
  }

  .slds-x-small-order_3,.slds-x-small-order--3{
    order:3;
  }

  .slds-x-small-order_4,.slds-x-small-order--4{
    order:4;
  }

  .slds-x-small-order_5,.slds-x-small-order--5{
    order:5;
  }

  .slds-x-small-order_6,.slds-x-small-order--6{
    order:6;
  }

  .slds-x-small-order_7,.slds-x-small-order--7{
    order:7;
  }

  .slds-x-small-order_8,.slds-x-small-order--8{
    order:8;
  }

  .slds-x-small-order_9,.slds-x-small-order--9{
    order:9;
  }

  .slds-x-small-order_10,.slds-x-small-order--10{
    order:10;
  }

  .slds-x-small-order_11,.slds-x-small-order--11{
    order:11;
  }

  .slds-x-small-order_12,.slds-x-small-order--12{
    order:12;
  }
}
@media (max-width: 20em){
  .slds-max-x-small-size_xxx-small,.slds-max-x-small-size--xxx-small,
  .slds-max-x-small-size_xx-small,
  .slds-max-x-small-size--xx-small,
  .slds-max-x-small-size_x-small,
  .slds-max-x-small-size--x-small,
  .slds-max-x-small-size_small,
  .slds-max-x-small-size--small,
  .slds-max-x-small-size_medium,
  .slds-max-x-small-size--medium,
  .slds-max-x-small-size_large,
  .slds-max-x-small-size--large,
  .slds-max-x-small-size_x-large,
  .slds-max-x-small-size--x-large,
  .slds-max-x-small-size_xx-large,
  .slds-max-x-small-size--xx-large{
    flex:none;
  }

  .slds-max-x-small-size_xxx-small,.slds-max-x-small-size--xxx-small{
    width:3rem;
  }

  .slds-max-x-small-size_xx-small,.slds-max-x-small-size--xx-small{
    width:6rem;
  }

  .slds-max-x-small-size_x-small,.slds-max-x-small-size--x-small{
    width:12rem;
  }

  .slds-max-x-small-size_small,.slds-max-x-small-size--small{
    width:15rem;
  }

  .slds-max-x-small-size_medium,.slds-max-x-small-size--medium{
    width:20rem;
  }

  .slds-max-x-small-size_large,.slds-max-x-small-size--large{
    width:25rem;
  }

  .slds-max-x-small-size_x-large,.slds-max-x-small-size--x-large{
    width:40rem;
  }

  .slds-max-x-small-size_xx-large,.slds-max-x-small-size--xx-large{
    width:60rem;
  }

  .slds-max-x-small-size_1-of-1,.slds-max-x-small-size--1-of-1{
    width:100%;
  }

  .slds-max-x-small-size_1-of-2,.slds-max-x-small-size--1-of-2{
    width:50%;
  }

  .slds-max-x-small-size_2-of-2,.slds-max-x-small-size--2-of-2{
    width:100%;
  }

  .slds-max-x-small-size_1-of-3,.slds-max-x-small-size--1-of-3{
    width:33.333%;
  }

  .slds-max-x-small-size_2-of-3,.slds-max-x-small-size--2-of-3{
    width:66.6667%;
  }

  .slds-max-x-small-size_3-of-3,.slds-max-x-small-size--3-of-3{
    width:100%;
  }

  .slds-max-x-small-size_1-of-4,.slds-max-x-small-size--1-of-4{
    width:25%;
  }

  .slds-max-x-small-size_2-of-4,.slds-max-x-small-size--2-of-4{
    width:50%;
  }

  .slds-max-x-small-size_3-of-4,.slds-max-x-small-size--3-of-4{
    width:75%;
  }

  .slds-max-x-small-size_4-of-4,.slds-max-x-small-size--4-of-4{
    width:100%;
  }

  .slds-max-x-small-size_1-of-5,.slds-max-x-small-size--1-of-5{
    width:20%;
  }

  .slds-max-x-small-size_2-of-5,.slds-max-x-small-size--2-of-5{
    width:40%;
  }

  .slds-max-x-small-size_3-of-5,.slds-max-x-small-size--3-of-5{
    width:60%;
  }

  .slds-max-x-small-size_4-of-5,.slds-max-x-small-size--4-of-5{
    width:80%;
  }

  .slds-max-x-small-size_5-of-5,.slds-max-x-small-size--5-of-5{
    width:100%;
  }

  .slds-max-x-small-size_1-of-6,.slds-max-x-small-size--1-of-6{
    width:16.6667%;
  }

  .slds-max-x-small-size_2-of-6,.slds-max-x-small-size--2-of-6{
    width:33.333%;
  }

  .slds-max-x-small-size_3-of-6,.slds-max-x-small-size--3-of-6{
    width:50%;
  }

  .slds-max-x-small-size_4-of-6,.slds-max-x-small-size--4-of-6{
    width:66.6667%;
  }

  .slds-max-x-small-size_5-of-6,.slds-max-x-small-size--5-of-6{
    width:83.3333%;
  }

  .slds-max-x-small-size_6-of-6,.slds-max-x-small-size--6-of-6{
    width:100%;
  }

  .slds-max-x-small-size_1-of-7,.slds-max-x-small-size--1-of-7{
    width:14.2857%;
  }

  .slds-max-x-small-size_2-of-7,.slds-max-x-small-size--2-of-7{
    width:28.5714%;
  }

  .slds-max-x-small-size_3-of-7,.slds-max-x-small-size--3-of-7{
    width:42.8571%;
  }

  .slds-max-x-small-size_4-of-7,.slds-max-x-small-size--4-of-7{
    width:57.1429%;
  }

  .slds-max-x-small-size_5-of-7,.slds-max-x-small-size--5-of-7{
    width:71.4286%;
  }

  .slds-max-x-small-size_6-of-7,.slds-max-x-small-size--6-of-7{
    width:85.7143%;
  }

  .slds-max-x-small-size_7-of-7,.slds-max-x-small-size--7-of-7{
    width:100%;
  }

  .slds-max-x-small-size_1-of-8,.slds-max-x-small-size--1-of-8{
    width:12.5%;
  }

  .slds-max-x-small-size_2-of-8,.slds-max-x-small-size--2-of-8{
    width:25%;
  }

  .slds-max-x-small-size_3-of-8,.slds-max-x-small-size--3-of-8{
    width:37.5%;
  }

  .slds-max-x-small-size_4-of-8,.slds-max-x-small-size--4-of-8{
    width:50%;
  }

  .slds-max-x-small-size_5-of-8,.slds-max-x-small-size--5-of-8{
    width:62.5%;
  }

  .slds-max-x-small-size_6-of-8,.slds-max-x-small-size--6-of-8{
    width:75%;
  }

  .slds-max-x-small-size_7-of-8,.slds-max-x-small-size--7-of-8{
    width:87.5%;
  }

  .slds-max-x-small-size_8-of-8,.slds-max-x-small-size--8-of-8{
    width:100%;
  }

  .slds-max-x-small-size_1-of-12,.slds-max-x-small-size--1-of-12{
    width:8.3333%;
  }

  .slds-max-x-small-size_2-of-12,.slds-max-x-small-size--2-of-12{
    width:16.6667%;
  }

  .slds-max-x-small-size_3-of-12,.slds-max-x-small-size--3-of-12{
    width:25%;
  }

  .slds-max-x-small-size_4-of-12,.slds-max-x-small-size--4-of-12{
    width:33.333%;
  }

  .slds-max-x-small-size_5-of-12,.slds-max-x-small-size--5-of-12{
    width:41.6667%;
  }

  .slds-max-x-small-size_6-of-12,.slds-max-x-small-size--6-of-12{
    width:50%;
  }

  .slds-max-x-small-size_7-of-12,.slds-max-x-small-size--7-of-12{
    width:58.3333%;
  }

  .slds-max-x-small-size_8-of-12,.slds-max-x-small-size--8-of-12{
    width:66.6667%;
  }

  .slds-max-x-small-size_9-of-12,.slds-max-x-small-size--9-of-12{
    width:75%;
  }

  .slds-max-x-small-size_10-of-12,.slds-max-x-small-size--10-of-12{
    width:83.3333%;
  }

  .slds-max-x-small-size_11-of-12,.slds-max-x-small-size--11-of-12{
    width:91.6667%;
  }

  .slds-max-x-small-size_12-of-12,.slds-max-x-small-size--12-of-12{
    width:100%;
  }

  .slds-max-x-small-order_1,.slds-max-x-small-order--1{
    order:1;
  }

  .slds-max-x-small-order_2,.slds-max-x-small-order--2{
    order:2;
  }

  .slds-max-x-small-order_3,.slds-max-x-small-order--3{
    order:3;
  }

  .slds-max-x-small-order_4,.slds-max-x-small-order--4{
    order:4;
  }

  .slds-max-x-small-order_5,.slds-max-x-small-order--5{
    order:5;
  }

  .slds-max-x-small-order_6,.slds-max-x-small-order--6{
    order:6;
  }

  .slds-max-x-small-order_7,.slds-max-x-small-order--7{
    order:7;
  }

  .slds-max-x-small-order_8,.slds-max-x-small-order--8{
    order:8;
  }

  .slds-max-x-small-order_9,.slds-max-x-small-order--9{
    order:9;
  }

  .slds-max-x-small-order_10,.slds-max-x-small-order--10{
    order:10;
  }

  .slds-max-x-small-order_11,.slds-max-x-small-order--11{
    order:11;
  }

  .slds-max-x-small-order_12,.slds-max-x-small-order--12{
    order:12;
  }
}
@media (min-width: 30em){
  .slds-small-size_xxx-small,.slds-small-size--xxx-small,
  .slds-small-size_xx-small,
  .slds-small-size--xx-small,
  .slds-small-size_x-small,
  .slds-small-size--x-small,
  .slds-small-size_small,
  .slds-small-size--small,
  .slds-small-size_medium,
  .slds-small-size--medium,
  .slds-small-size_large,
  .slds-small-size--large,
  .slds-small-size_x-large,
  .slds-small-size--x-large,
  .slds-small-size_xx-large,
  .slds-small-size--xx-large,
  .slds-small-size_1-of-1,
  .slds-small-size--1-of-1,
  .slds-small-size_1-of-2,
  .slds-small-size--1-of-2,
  .slds-small-size_2-of-2,
  .slds-small-size--2-of-2,
  .slds-small-size_1-of-3,
  .slds-small-size--1-of-3,
  .slds-small-size_2-of-3,
  .slds-small-size--2-of-3,
  .slds-small-size_3-of-3,
  .slds-small-size--3-of-3,
  .slds-small-size_1-of-4,
  .slds-small-size--1-of-4,
  .slds-small-size_2-of-4,
  .slds-small-size--2-of-4,
  .slds-small-size_3-of-4,
  .slds-small-size--3-of-4,
  .slds-small-size_4-of-4,
  .slds-small-size--4-of-4,
  .slds-small-size_1-of-5,
  .slds-small-size--1-of-5,
  .slds-small-size_2-of-5,
  .slds-small-size--2-of-5,
  .slds-small-size_3-of-5,
  .slds-small-size--3-of-5,
  .slds-small-size_4-of-5,
  .slds-small-size--4-of-5,
  .slds-small-size_5-of-5,
  .slds-small-size--5-of-5,
  .slds-small-size_1-of-6,
  .slds-small-size--1-of-6,
  .slds-small-size_2-of-6,
  .slds-small-size--2-of-6,
  .slds-small-size_3-of-6,
  .slds-small-size--3-of-6,
  .slds-small-size_4-of-6,
  .slds-small-size--4-of-6,
  .slds-small-size_5-of-6,
  .slds-small-size--5-of-6,
  .slds-small-size_6-of-6,
  .slds-small-size--6-of-6,
  .slds-small-size_1-of-7,
  .slds-small-size--1-of-7,
  .slds-small-size_2-of-7,
  .slds-small-size--2-of-7,
  .slds-small-size_3-of-7,
  .slds-small-size--3-of-7,
  .slds-small-size_4-of-7,
  .slds-small-size--4-of-7,
  .slds-small-size_5-of-7,
  .slds-small-size--5-of-7,
  .slds-small-size_6-of-7,
  .slds-small-size--6-of-7,
  .slds-small-size_7-of-7,
  .slds-small-size--7-of-7,
  .slds-small-size_1-of-8,
  .slds-small-size--1-of-8,
  .slds-small-size_2-of-8,
  .slds-small-size--2-of-8,
  .slds-small-size_3-of-8,
  .slds-small-size--3-of-8,
  .slds-small-size_4-of-8,
  .slds-small-size--4-of-8,
  .slds-small-size_5-of-8,
  .slds-small-size--5-of-8,
  .slds-small-size_6-of-8,
  .slds-small-size--6-of-8,
  .slds-small-size_7-of-8,
  .slds-small-size--7-of-8,
  .slds-small-size_8-of-8,
  .slds-small-size--8-of-8,
  .slds-small-size_1-of-12,
  .slds-small-size--1-of-12,
  .slds-small-size_2-of-12,
  .slds-small-size--2-of-12,
  .slds-small-size_3-of-12,
  .slds-small-size--3-of-12,
  .slds-small-size_4-of-12,
  .slds-small-size--4-of-12,
  .slds-small-size_5-of-12,
  .slds-small-size--5-of-12,
  .slds-small-size_6-of-12,
  .slds-small-size--6-of-12,
  .slds-small-size_7-of-12,
  .slds-small-size--7-of-12,
  .slds-small-size_8-of-12,
  .slds-small-size--8-of-12,
  .slds-small-size_9-of-12,
  .slds-small-size--9-of-12,
  .slds-small-size_10-of-12,
  .slds-small-size--10-of-12,
  .slds-small-size_11-of-12,
  .slds-small-size--11-of-12,
  .slds-small-size_12-of-12,
  .slds-small-size--12-of-12{
    flex:none;
  }

  .slds-small-size_xxx-small,.slds-small-size--xxx-small{
    width:3rem;
  }

  .slds-small-size_xx-small,.slds-small-size--xx-small{
    width:6rem;
  }

  .slds-small-size_x-small,.slds-small-size--x-small{
    width:12rem;
  }

  .slds-small-size_small,.slds-small-size--small{
    width:15rem;
  }

  .slds-small-size_medium,.slds-small-size--medium{
    width:20rem;
  }

  .slds-small-size_large,.slds-small-size--large{
    width:25rem;
  }

  .slds-small-size_x-large,.slds-small-size--x-large{
    width:40rem;
  }

  .slds-small-size_xx-large,.slds-small-size--xx-large{
    width:60rem;
  }

  .slds-small-size_1-of-1,.slds-small-size--1-of-1{
    width:100%;
  }

  .slds-small-size_1-of-2,.slds-small-size--1-of-2{
    width:50%;
  }

  .slds-small-size_2-of-2,.slds-small-size--2-of-2{
    width:100%;
  }

  .slds-small-size_1-of-3,.slds-small-size--1-of-3{
    width:33.333%;
  }

  .slds-small-size_2-of-3,.slds-small-size--2-of-3{
    width:66.6667%;
  }

  .slds-small-size_3-of-3,.slds-small-size--3-of-3{
    width:100%;
  }

  .slds-small-size_1-of-4,.slds-small-size--1-of-4{
    width:25%;
  }

  .slds-small-size_2-of-4,.slds-small-size--2-of-4{
    width:50%;
  }

  .slds-small-size_3-of-4,.slds-small-size--3-of-4{
    width:75%;
  }

  .slds-small-size_4-of-4,.slds-small-size--4-of-4{
    width:100%;
  }

  .slds-small-size_1-of-5,.slds-small-size--1-of-5{
    width:20%;
  }

  .slds-small-size_2-of-5,.slds-small-size--2-of-5{
    width:40%;
  }

  .slds-small-size_3-of-5,.slds-small-size--3-of-5{
    width:60%;
  }

  .slds-small-size_4-of-5,.slds-small-size--4-of-5{
    width:80%;
  }

  .slds-small-size_5-of-5,.slds-small-size--5-of-5{
    width:100%;
  }

  .slds-small-size_1-of-6,.slds-small-size--1-of-6{
    width:16.6667%;
  }

  .slds-small-size_2-of-6,.slds-small-size--2-of-6{
    width:33.333%;
  }

  .slds-small-size_3-of-6,.slds-small-size--3-of-6{
    width:50%;
  }

  .slds-small-size_4-of-6,.slds-small-size--4-of-6{
    width:66.6667%;
  }

  .slds-small-size_5-of-6,.slds-small-size--5-of-6{
    width:83.3333%;
  }

  .slds-small-size_6-of-6,.slds-small-size--6-of-6{
    width:100%;
  }

  .slds-small-size_1-of-7,.slds-small-size--1-of-7{
    width:14.2857%;
  }

  .slds-small-size_2-of-7,.slds-small-size--2-of-7{
    width:28.5714%;
  }

  .slds-small-size_3-of-7,.slds-small-size--3-of-7{
    width:42.8571%;
  }

  .slds-small-size_4-of-7,.slds-small-size--4-of-7{
    width:57.1429%;
  }

  .slds-small-size_5-of-7,.slds-small-size--5-of-7{
    width:71.4286%;
  }

  .slds-small-size_6-of-7,.slds-small-size--6-of-7{
    width:85.7143%;
  }

  .slds-small-size_7-of-7,.slds-small-size--7-of-7{
    width:100%;
  }

  .slds-small-size_1-of-8,.slds-small-size--1-of-8{
    width:12.5%;
  }

  .slds-small-size_2-of-8,.slds-small-size--2-of-8{
    width:25%;
  }

  .slds-small-size_3-of-8,.slds-small-size--3-of-8{
    width:37.5%;
  }

  .slds-small-size_4-of-8,.slds-small-size--4-of-8{
    width:50%;
  }

  .slds-small-size_5-of-8,.slds-small-size--5-of-8{
    width:62.5%;
  }

  .slds-small-size_6-of-8,.slds-small-size--6-of-8{
    width:75%;
  }

  .slds-small-size_7-of-8,.slds-small-size--7-of-8{
    width:87.5%;
  }

  .slds-small-size_8-of-8,.slds-small-size--8-of-8{
    width:100%;
  }

  .slds-small-size_1-of-12,.slds-small-size--1-of-12{
    width:8.3333%;
  }

  .slds-small-size_2-of-12,.slds-small-size--2-of-12{
    width:16.6667%;
  }

  .slds-small-size_3-of-12,.slds-small-size--3-of-12{
    width:25%;
  }

  .slds-small-size_4-of-12,.slds-small-size--4-of-12{
    width:33.333%;
  }

  .slds-small-size_5-of-12,.slds-small-size--5-of-12{
    width:41.6667%;
  }

  .slds-small-size_6-of-12,.slds-small-size--6-of-12{
    width:50%;
  }

  .slds-small-size_7-of-12,.slds-small-size--7-of-12{
    width:58.3333%;
  }

  .slds-small-size_8-of-12,.slds-small-size--8-of-12{
    width:66.6667%;
  }

  .slds-small-size_9-of-12,.slds-small-size--9-of-12{
    width:75%;
  }

  .slds-small-size_10-of-12,.slds-small-size--10-of-12{
    width:83.3333%;
  }

  .slds-small-size_11-of-12,.slds-small-size--11-of-12{
    width:91.6667%;
  }

  .slds-small-size_12-of-12,.slds-small-size--12-of-12{
    width:100%;
  }

  .slds-small-order_1,.slds-small-order--1{
    order:1;
  }

  .slds-small-order_2,.slds-small-order--2{
    order:2;
  }

  .slds-small-order_3,.slds-small-order--3{
    order:3;
  }

  .slds-small-order_4,.slds-small-order--4{
    order:4;
  }

  .slds-small-order_5,.slds-small-order--5{
    order:5;
  }

  .slds-small-order_6,.slds-small-order--6{
    order:6;
  }

  .slds-small-order_7,.slds-small-order--7{
    order:7;
  }

  .slds-small-order_8,.slds-small-order--8{
    order:8;
  }

  .slds-small-order_9,.slds-small-order--9{
    order:9;
  }

  .slds-small-order_10,.slds-small-order--10{
    order:10;
  }

  .slds-small-order_11,.slds-small-order--11{
    order:11;
  }

  .slds-small-order_12,.slds-small-order--12{
    order:12;
  }
}
@media (max-width: 30em){
  .slds-max-small-size_xxx-small,.slds-max-small-size--xxx-small,
  .slds-max-small-size_xx-small,
  .slds-max-small-size--xx-small,
  .slds-max-small-size_x-small,
  .slds-max-small-size--x-small,
  .slds-max-small-size_small,
  .slds-max-small-size--small,
  .slds-max-small-size_medium,
  .slds-max-small-size--medium,
  .slds-max-small-size_large,
  .slds-max-small-size--large,
  .slds-max-small-size_x-large,
  .slds-max-small-size--x-large,
  .slds-max-small-size_xx-large,
  .slds-max-small-size--xx-large{
    flex:none;
  }

  .slds-max-small-size_xxx-small,.slds-max-small-size--xxx-small{
    width:3rem;
  }

  .slds-max-small-size_xx-small,.slds-max-small-size--xx-small{
    width:6rem;
  }

  .slds-max-small-size_x-small,.slds-max-small-size--x-small{
    width:12rem;
  }

  .slds-max-small-size_small,.slds-max-small-size--small{
    width:15rem;
  }

  .slds-max-small-size_medium,.slds-max-small-size--medium{
    width:20rem;
  }

  .slds-max-small-size_large,.slds-max-small-size--large{
    width:25rem;
  }

  .slds-max-small-size_x-large,.slds-max-small-size--x-large{
    width:40rem;
  }

  .slds-max-small-size_xx-large,.slds-max-small-size--xx-large{
    width:60rem;
  }

  .slds-max-small-size_1-of-1,.slds-max-small-size--1-of-1{
    width:100%;
  }

  .slds-max-small-size_1-of-2,.slds-max-small-size--1-of-2{
    width:50%;
  }

  .slds-max-small-size_2-of-2,.slds-max-small-size--2-of-2{
    width:100%;
  }

  .slds-max-small-size_1-of-3,.slds-max-small-size--1-of-3{
    width:33.333%;
  }

  .slds-max-small-size_2-of-3,.slds-max-small-size--2-of-3{
    width:66.6667%;
  }

  .slds-max-small-size_3-of-3,.slds-max-small-size--3-of-3{
    width:100%;
  }

  .slds-max-small-size_1-of-4,.slds-max-small-size--1-of-4{
    width:25%;
  }

  .slds-max-small-size_2-of-4,.slds-max-small-size--2-of-4{
    width:50%;
  }

  .slds-max-small-size_3-of-4,.slds-max-small-size--3-of-4{
    width:75%;
  }

  .slds-max-small-size_4-of-4,.slds-max-small-size--4-of-4{
    width:100%;
  }

  .slds-max-small-size_1-of-5,.slds-max-small-size--1-of-5{
    width:20%;
  }

  .slds-max-small-size_2-of-5,.slds-max-small-size--2-of-5{
    width:40%;
  }

  .slds-max-small-size_3-of-5,.slds-max-small-size--3-of-5{
    width:60%;
  }

  .slds-max-small-size_4-of-5,.slds-max-small-size--4-of-5{
    width:80%;
  }

  .slds-max-small-size_5-of-5,.slds-max-small-size--5-of-5{
    width:100%;
  }

  .slds-max-small-size_1-of-6,.slds-max-small-size--1-of-6{
    width:16.6667%;
  }

  .slds-max-small-size_2-of-6,.slds-max-small-size--2-of-6{
    width:33.333%;
  }

  .slds-max-small-size_3-of-6,.slds-max-small-size--3-of-6{
    width:50%;
  }

  .slds-max-small-size_4-of-6,.slds-max-small-size--4-of-6{
    width:66.6667%;
  }

  .slds-max-small-size_5-of-6,.slds-max-small-size--5-of-6{
    width:83.3333%;
  }

  .slds-max-small-size_6-of-6,.slds-max-small-size--6-of-6{
    width:100%;
  }

  .slds-max-small-size_1-of-7,.slds-max-small-size--1-of-7{
    width:14.2857%;
  }

  .slds-max-small-size_2-of-7,.slds-max-small-size--2-of-7{
    width:28.5714%;
  }

  .slds-max-small-size_3-of-7,.slds-max-small-size--3-of-7{
    width:42.8571%;
  }

  .slds-max-small-size_4-of-7,.slds-max-small-size--4-of-7{
    width:57.1429%;
  }

  .slds-max-small-size_5-of-7,.slds-max-small-size--5-of-7{
    width:71.4286%;
  }

  .slds-max-small-size_6-of-7,.slds-max-small-size--6-of-7{
    width:85.7143%;
  }

  .slds-max-small-size_7-of-7,.slds-max-small-size--7-of-7{
    width:100%;
  }

  .slds-max-small-size_1-of-8,.slds-max-small-size--1-of-8{
    width:12.5%;
  }

  .slds-max-small-size_2-of-8,.slds-max-small-size--2-of-8{
    width:25%;
  }

  .slds-max-small-size_3-of-8,.slds-max-small-size--3-of-8{
    width:37.5%;
  }

  .slds-max-small-size_4-of-8,.slds-max-small-size--4-of-8{
    width:50%;
  }

  .slds-max-small-size_5-of-8,.slds-max-small-size--5-of-8{
    width:62.5%;
  }

  .slds-max-small-size_6-of-8,.slds-max-small-size--6-of-8{
    width:75%;
  }

  .slds-max-small-size_7-of-8,.slds-max-small-size--7-of-8{
    width:87.5%;
  }

  .slds-max-small-size_8-of-8,.slds-max-small-size--8-of-8{
    width:100%;
  }

  .slds-max-small-size_1-of-12,.slds-max-small-size--1-of-12{
    width:8.3333%;
  }

  .slds-max-small-size_2-of-12,.slds-max-small-size--2-of-12{
    width:16.6667%;
  }

  .slds-max-small-size_3-of-12,.slds-max-small-size--3-of-12{
    width:25%;
  }

  .slds-max-small-size_4-of-12,.slds-max-small-size--4-of-12{
    width:33.333%;
  }

  .slds-max-small-size_5-of-12,.slds-max-small-size--5-of-12{
    width:41.6667%;
  }

  .slds-max-small-size_6-of-12,.slds-max-small-size--6-of-12{
    width:50%;
  }

  .slds-max-small-size_7-of-12,.slds-max-small-size--7-of-12{
    width:58.3333%;
  }

  .slds-max-small-size_8-of-12,.slds-max-small-size--8-of-12{
    width:66.6667%;
  }

  .slds-max-small-size_9-of-12,.slds-max-small-size--9-of-12{
    width:75%;
  }

  .slds-max-small-size_10-of-12,.slds-max-small-size--10-of-12{
    width:83.3333%;
  }

  .slds-max-small-size_11-of-12,.slds-max-small-size--11-of-12{
    width:91.6667%;
  }

  .slds-max-small-size_12-of-12,.slds-max-small-size--12-of-12{
    width:100%;
  }

  .slds-max-small-order_1,.slds-max-small-order--1{
    order:1;
  }

  .slds-max-small-order_2,.slds-max-small-order--2{
    order:2;
  }

  .slds-max-small-order_3,.slds-max-small-order--3{
    order:3;
  }

  .slds-max-small-order_4,.slds-max-small-order--4{
    order:4;
  }

  .slds-max-small-order_5,.slds-max-small-order--5{
    order:5;
  }

  .slds-max-small-order_6,.slds-max-small-order--6{
    order:6;
  }

  .slds-max-small-order_7,.slds-max-small-order--7{
    order:7;
  }

  .slds-max-small-order_8,.slds-max-small-order--8{
    order:8;
  }

  .slds-max-small-order_9,.slds-max-small-order--9{
    order:9;
  }

  .slds-max-small-order_10,.slds-max-small-order--10{
    order:10;
  }

  .slds-max-small-order_11,.slds-max-small-order--11{
    order:11;
  }

  .slds-max-small-order_12,.slds-max-small-order--12{
    order:12;
  }
}
@media (min-width: 48em){
  .slds-medium-size_xxx-small,.slds-medium-size--xxx-small,
  .slds-medium-size_xx-small,
  .slds-medium-size--xx-small,
  .slds-medium-size_x-small,
  .slds-medium-size--x-small,
  .slds-medium-size_small,
  .slds-medium-size--small,
  .slds-medium-size_medium,
  .slds-medium-size--medium,
  .slds-medium-size_large,
  .slds-medium-size--large,
  .slds-medium-size_x-large,
  .slds-medium-size--x-large,
  .slds-medium-size_xx-large,
  .slds-medium-size--xx-large,
  .slds-medium-size_1-of-1,
  .slds-medium-size--1-of-1,
  .slds-medium-size_1-of-2,
  .slds-medium-size--1-of-2,
  .slds-medium-size_2-of-2,
  .slds-medium-size--2-of-2,
  .slds-medium-size_1-of-3,
  .slds-medium-size--1-of-3,
  .slds-medium-size_2-of-3,
  .slds-medium-size--2-of-3,
  .slds-medium-size_3-of-3,
  .slds-medium-size--3-of-3,
  .slds-medium-size_1-of-4,
  .slds-medium-size--1-of-4,
  .slds-medium-size_2-of-4,
  .slds-medium-size--2-of-4,
  .slds-medium-size_3-of-4,
  .slds-medium-size--3-of-4,
  .slds-medium-size_4-of-4,
  .slds-medium-size--4-of-4,
  .slds-medium-size_1-of-5,
  .slds-medium-size--1-of-5,
  .slds-medium-size_2-of-5,
  .slds-medium-size--2-of-5,
  .slds-medium-size_3-of-5,
  .slds-medium-size--3-of-5,
  .slds-medium-size_4-of-5,
  .slds-medium-size--4-of-5,
  .slds-medium-size_5-of-5,
  .slds-medium-size--5-of-5,
  .slds-medium-size_1-of-6,
  .slds-medium-size--1-of-6,
  .slds-medium-size_2-of-6,
  .slds-medium-size--2-of-6,
  .slds-medium-size_3-of-6,
  .slds-medium-size--3-of-6,
  .slds-medium-size_4-of-6,
  .slds-medium-size--4-of-6,
  .slds-medium-size_5-of-6,
  .slds-medium-size--5-of-6,
  .slds-medium-size_6-of-6,
  .slds-medium-size--6-of-6,
  .slds-medium-size_1-of-7,
  .slds-medium-size--1-of-7,
  .slds-medium-size_2-of-7,
  .slds-medium-size--2-of-7,
  .slds-medium-size_3-of-7,
  .slds-medium-size--3-of-7,
  .slds-medium-size_4-of-7,
  .slds-medium-size--4-of-7,
  .slds-medium-size_5-of-7,
  .slds-medium-size--5-of-7,
  .slds-medium-size_6-of-7,
  .slds-medium-size--6-of-7,
  .slds-medium-size_7-of-7,
  .slds-medium-size--7-of-7,
  .slds-medium-size_1-of-8,
  .slds-medium-size--1-of-8,
  .slds-medium-size_2-of-8,
  .slds-medium-size--2-of-8,
  .slds-medium-size_3-of-8,
  .slds-medium-size--3-of-8,
  .slds-medium-size_4-of-8,
  .slds-medium-size--4-of-8,
  .slds-medium-size_5-of-8,
  .slds-medium-size--5-of-8,
  .slds-medium-size_6-of-8,
  .slds-medium-size--6-of-8,
  .slds-medium-size_7-of-8,
  .slds-medium-size--7-of-8,
  .slds-medium-size_8-of-8,
  .slds-medium-size--8-of-8,
  .slds-medium-size_1-of-12,
  .slds-medium-size--1-of-12,
  .slds-medium-size_2-of-12,
  .slds-medium-size--2-of-12,
  .slds-medium-size_3-of-12,
  .slds-medium-size--3-of-12,
  .slds-medium-size_4-of-12,
  .slds-medium-size--4-of-12,
  .slds-medium-size_5-of-12,
  .slds-medium-size--5-of-12,
  .slds-medium-size_6-of-12,
  .slds-medium-size--6-of-12,
  .slds-medium-size_7-of-12,
  .slds-medium-size--7-of-12,
  .slds-medium-size_8-of-12,
  .slds-medium-size--8-of-12,
  .slds-medium-size_9-of-12,
  .slds-medium-size--9-of-12,
  .slds-medium-size_10-of-12,
  .slds-medium-size--10-of-12,
  .slds-medium-size_11-of-12,
  .slds-medium-size--11-of-12,
  .slds-medium-size_12-of-12,
  .slds-medium-size--12-of-12{
    flex:none;
  }

  .slds-medium-size_xxx-small,.slds-medium-size--xxx-small{
    width:3rem;
  }

  .slds-medium-size_xx-small,.slds-medium-size--xx-small{
    width:6rem;
  }

  .slds-medium-size_x-small,.slds-medium-size--x-small{
    width:12rem;
  }

  .slds-medium-size_small,.slds-medium-size--small{
    width:15rem;
  }

  .slds-medium-size_medium,.slds-medium-size--medium{
    width:20rem;
  }

  .slds-medium-size_large,.slds-medium-size--large{
    width:25rem;
  }

  .slds-medium-size_x-large,.slds-medium-size--x-large{
    width:40rem;
  }

  .slds-medium-size_xx-large,.slds-medium-size--xx-large{
    width:60rem;
  }

  .slds-medium-size_1-of-1,.slds-medium-size--1-of-1{
    width:100%;
  }

  .slds-medium-size_1-of-2,.slds-medium-size--1-of-2{
    width:50%;
  }

  .slds-medium-size_2-of-2,.slds-medium-size--2-of-2{
    width:100%;
  }

  .slds-medium-size_1-of-3,.slds-medium-size--1-of-3{
    width:33.333%;
  }

  .slds-medium-size_2-of-3,.slds-medium-size--2-of-3{
    width:66.6667%;
  }

  .slds-medium-size_3-of-3,.slds-medium-size--3-of-3{
    width:100%;
  }

  .slds-medium-size_1-of-4,.slds-medium-size--1-of-4{
    width:25%;
  }

  .slds-medium-size_2-of-4,.slds-medium-size--2-of-4{
    width:50%;
  }

  .slds-medium-size_3-of-4,.slds-medium-size--3-of-4{
    width:75%;
  }

  .slds-medium-size_4-of-4,.slds-medium-size--4-of-4{
    width:100%;
  }

  .slds-medium-size_1-of-5,.slds-medium-size--1-of-5{
    width:20%;
  }

  .slds-medium-size_2-of-5,.slds-medium-size--2-of-5{
    width:40%;
  }

  .slds-medium-size_3-of-5,.slds-medium-size--3-of-5{
    width:60%;
  }

  .slds-medium-size_4-of-5,.slds-medium-size--4-of-5{
    width:80%;
  }

  .slds-medium-size_5-of-5,.slds-medium-size--5-of-5{
    width:100%;
  }

  .slds-medium-size_1-of-6,.slds-medium-size--1-of-6{
    width:16.6667%;
  }

  .slds-medium-size_2-of-6,.slds-medium-size--2-of-6{
    width:33.333%;
  }

  .slds-medium-size_3-of-6,.slds-medium-size--3-of-6{
    width:50%;
  }

  .slds-medium-size_4-of-6,.slds-medium-size--4-of-6{
    width:66.6667%;
  }

  .slds-medium-size_5-of-6,.slds-medium-size--5-of-6{
    width:83.3333%;
  }

  .slds-medium-size_6-of-6,.slds-medium-size--6-of-6{
    width:100%;
  }

  .slds-medium-size_1-of-7,.slds-medium-size--1-of-7{
    width:14.2857%;
  }

  .slds-medium-size_2-of-7,.slds-medium-size--2-of-7{
    width:28.5714%;
  }

  .slds-medium-size_3-of-7,.slds-medium-size--3-of-7{
    width:42.8571%;
  }

  .slds-medium-size_4-of-7,.slds-medium-size--4-of-7{
    width:57.1429%;
  }

  .slds-medium-size_5-of-7,.slds-medium-size--5-of-7{
    width:71.4286%;
  }

  .slds-medium-size_6-of-7,.slds-medium-size--6-of-7{
    width:85.7143%;
  }

  .slds-medium-size_7-of-7,.slds-medium-size--7-of-7{
    width:100%;
  }

  .slds-medium-size_1-of-8,.slds-medium-size--1-of-8{
    width:12.5%;
  }

  .slds-medium-size_2-of-8,.slds-medium-size--2-of-8{
    width:25%;
  }

  .slds-medium-size_3-of-8,.slds-medium-size--3-of-8{
    width:37.5%;
  }

  .slds-medium-size_4-of-8,.slds-medium-size--4-of-8{
    width:50%;
  }

  .slds-medium-size_5-of-8,.slds-medium-size--5-of-8{
    width:62.5%;
  }

  .slds-medium-size_6-of-8,.slds-medium-size--6-of-8{
    width:75%;
  }

  .slds-medium-size_7-of-8,.slds-medium-size--7-of-8{
    width:87.5%;
  }

  .slds-medium-size_8-of-8,.slds-medium-size--8-of-8{
    width:100%;
  }

  .slds-medium-size_1-of-12,.slds-medium-size--1-of-12{
    width:8.3333%;
  }

  .slds-medium-size_2-of-12,.slds-medium-size--2-of-12{
    width:16.6667%;
  }

  .slds-medium-size_3-of-12,.slds-medium-size--3-of-12{
    width:25%;
  }

  .slds-medium-size_4-of-12,.slds-medium-size--4-of-12{
    width:33.333%;
  }

  .slds-medium-size_5-of-12,.slds-medium-size--5-of-12{
    width:41.6667%;
  }

  .slds-medium-size_6-of-12,.slds-medium-size--6-of-12{
    width:50%;
  }

  .slds-medium-size_7-of-12,.slds-medium-size--7-of-12{
    width:58.3333%;
  }

  .slds-medium-size_8-of-12,.slds-medium-size--8-of-12{
    width:66.6667%;
  }

  .slds-medium-size_9-of-12,.slds-medium-size--9-of-12{
    width:75%;
  }

  .slds-medium-size_10-of-12,.slds-medium-size--10-of-12{
    width:83.3333%;
  }

  .slds-medium-size_11-of-12,.slds-medium-size--11-of-12{
    width:91.6667%;
  }

  .slds-medium-size_12-of-12,.slds-medium-size--12-of-12{
    width:100%;
  }

  .slds-medium-order_1,.slds-medium-order--1{
    order:1;
  }

  .slds-medium-order_2,.slds-medium-order--2{
    order:2;
  }

  .slds-medium-order_3,.slds-medium-order--3{
    order:3;
  }

  .slds-medium-order_4,.slds-medium-order--4{
    order:4;
  }

  .slds-medium-order_5,.slds-medium-order--5{
    order:5;
  }

  .slds-medium-order_6,.slds-medium-order--6{
    order:6;
  }

  .slds-medium-order_7,.slds-medium-order--7{
    order:7;
  }

  .slds-medium-order_8,.slds-medium-order--8{
    order:8;
  }

  .slds-medium-order_9,.slds-medium-order--9{
    order:9;
  }

  .slds-medium-order_10,.slds-medium-order--10{
    order:10;
  }

  .slds-medium-order_11,.slds-medium-order--11{
    order:11;
  }

  .slds-medium-order_12,.slds-medium-order--12{
    order:12;
  }
}
@media (max-width: 48em){
  .slds-max-medium-size_xxx-small,.slds-max-medium-size--xxx-small,
  .slds-max-medium-size_xx-small,
  .slds-max-medium-size--xx-small,
  .slds-max-medium-size_x-small,
  .slds-max-medium-size--x-small,
  .slds-max-medium-size_small,
  .slds-max-medium-size--small,
  .slds-max-medium-size_medium,
  .slds-max-medium-size--medium,
  .slds-max-medium-size_large,
  .slds-max-medium-size--large,
  .slds-max-medium-size_x-large,
  .slds-max-medium-size--x-large,
  .slds-max-medium-size_xx-large,
  .slds-max-medium-size--xx-large{
    flex:none;
  }

  .slds-max-medium-size_xxx-small,.slds-max-medium-size--xxx-small{
    width:3rem;
  }

  .slds-max-medium-size_xx-small,.slds-max-medium-size--xx-small{
    width:6rem;
  }

  .slds-max-medium-size_x-small,.slds-max-medium-size--x-small{
    width:12rem;
  }

  .slds-max-medium-size_small,.slds-max-medium-size--small{
    width:15rem;
  }

  .slds-max-medium-size_medium,.slds-max-medium-size--medium{
    width:20rem;
  }

  .slds-max-medium-size_large,.slds-max-medium-size--large{
    width:25rem;
  }

  .slds-max-medium-size_x-large,.slds-max-medium-size--x-large{
    width:40rem;
  }

  .slds-max-medium-size_xx-large,.slds-max-medium-size--xx-large{
    width:60rem;
  }

  .slds-max-medium-size_1-of-1,.slds-max-medium-size--1-of-1{
    width:100%;
  }

  .slds-max-medium-size_1-of-2,.slds-max-medium-size--1-of-2{
    width:50%;
  }

  .slds-max-medium-size_2-of-2,.slds-max-medium-size--2-of-2{
    width:100%;
  }

  .slds-max-medium-size_1-of-3,.slds-max-medium-size--1-of-3{
    width:33.333%;
  }

  .slds-max-medium-size_2-of-3,.slds-max-medium-size--2-of-3{
    width:66.6667%;
  }

  .slds-max-medium-size_3-of-3,.slds-max-medium-size--3-of-3{
    width:100%;
  }

  .slds-max-medium-size_1-of-4,.slds-max-medium-size--1-of-4{
    width:25%;
  }

  .slds-max-medium-size_2-of-4,.slds-max-medium-size--2-of-4{
    width:50%;
  }

  .slds-max-medium-size_3-of-4,.slds-max-medium-size--3-of-4{
    width:75%;
  }

  .slds-max-medium-size_4-of-4,.slds-max-medium-size--4-of-4{
    width:100%;
  }

  .slds-max-medium-size_1-of-5,.slds-max-medium-size--1-of-5{
    width:20%;
  }

  .slds-max-medium-size_2-of-5,.slds-max-medium-size--2-of-5{
    width:40%;
  }

  .slds-max-medium-size_3-of-5,.slds-max-medium-size--3-of-5{
    width:60%;
  }

  .slds-max-medium-size_4-of-5,.slds-max-medium-size--4-of-5{
    width:80%;
  }

  .slds-max-medium-size_5-of-5,.slds-max-medium-size--5-of-5{
    width:100%;
  }

  .slds-max-medium-size_1-of-6,.slds-max-medium-size--1-of-6{
    width:16.6667%;
  }

  .slds-max-medium-size_2-of-6,.slds-max-medium-size--2-of-6{
    width:33.333%;
  }

  .slds-max-medium-size_3-of-6,.slds-max-medium-size--3-of-6{
    width:50%;
  }

  .slds-max-medium-size_4-of-6,.slds-max-medium-size--4-of-6{
    width:66.6667%;
  }

  .slds-max-medium-size_5-of-6,.slds-max-medium-size--5-of-6{
    width:83.3333%;
  }

  .slds-max-medium-size_6-of-6,.slds-max-medium-size--6-of-6{
    width:100%;
  }

  .slds-max-medium-size_1-of-7,.slds-max-medium-size--1-of-7{
    width:14.2857%;
  }

  .slds-max-medium-size_2-of-7,.slds-max-medium-size--2-of-7{
    width:28.5714%;
  }

  .slds-max-medium-size_3-of-7,.slds-max-medium-size--3-of-7{
    width:42.8571%;
  }

  .slds-max-medium-size_4-of-7,.slds-max-medium-size--4-of-7{
    width:57.1429%;
  }

  .slds-max-medium-size_5-of-7,.slds-max-medium-size--5-of-7{
    width:71.4286%;
  }

  .slds-max-medium-size_6-of-7,.slds-max-medium-size--6-of-7{
    width:85.7143%;
  }

  .slds-max-medium-size_7-of-7,.slds-max-medium-size--7-of-7{
    width:100%;
  }

  .slds-max-medium-size_1-of-8,.slds-max-medium-size--1-of-8{
    width:12.5%;
  }

  .slds-max-medium-size_2-of-8,.slds-max-medium-size--2-of-8{
    width:25%;
  }

  .slds-max-medium-size_3-of-8,.slds-max-medium-size--3-of-8{
    width:37.5%;
  }

  .slds-max-medium-size_4-of-8,.slds-max-medium-size--4-of-8{
    width:50%;
  }

  .slds-max-medium-size_5-of-8,.slds-max-medium-size--5-of-8{
    width:62.5%;
  }

  .slds-max-medium-size_6-of-8,.slds-max-medium-size--6-of-8{
    width:75%;
  }

  .slds-max-medium-size_7-of-8,.slds-max-medium-size--7-of-8{
    width:87.5%;
  }

  .slds-max-medium-size_8-of-8,.slds-max-medium-size--8-of-8{
    width:100%;
  }

  .slds-max-medium-size_1-of-12,.slds-max-medium-size--1-of-12{
    width:8.3333%;
  }

  .slds-max-medium-size_2-of-12,.slds-max-medium-size--2-of-12{
    width:16.6667%;
  }

  .slds-max-medium-size_3-of-12,.slds-max-medium-size--3-of-12{
    width:25%;
  }

  .slds-max-medium-size_4-of-12,.slds-max-medium-size--4-of-12{
    width:33.333%;
  }

  .slds-max-medium-size_5-of-12,.slds-max-medium-size--5-of-12{
    width:41.6667%;
  }

  .slds-max-medium-size_6-of-12,.slds-max-medium-size--6-of-12{
    width:50%;
  }

  .slds-max-medium-size_7-of-12,.slds-max-medium-size--7-of-12{
    width:58.3333%;
  }

  .slds-max-medium-size_8-of-12,.slds-max-medium-size--8-of-12{
    width:66.6667%;
  }

  .slds-max-medium-size_9-of-12,.slds-max-medium-size--9-of-12{
    width:75%;
  }

  .slds-max-medium-size_10-of-12,.slds-max-medium-size--10-of-12{
    width:83.3333%;
  }

  .slds-max-medium-size_11-of-12,.slds-max-medium-size--11-of-12{
    width:91.6667%;
  }

  .slds-max-medium-size_12-of-12,.slds-max-medium-size--12-of-12{
    width:100%;
  }

  .slds-max-medium-order_1,.slds-max-medium-order--1{
    order:1;
  }

  .slds-max-medium-order_2,.slds-max-medium-order--2{
    order:2;
  }

  .slds-max-medium-order_3,.slds-max-medium-order--3{
    order:3;
  }

  .slds-max-medium-order_4,.slds-max-medium-order--4{
    order:4;
  }

  .slds-max-medium-order_5,.slds-max-medium-order--5{
    order:5;
  }

  .slds-max-medium-order_6,.slds-max-medium-order--6{
    order:6;
  }

  .slds-max-medium-order_7,.slds-max-medium-order--7{
    order:7;
  }

  .slds-max-medium-order_8,.slds-max-medium-order--8{
    order:8;
  }

  .slds-max-medium-order_9,.slds-max-medium-order--9{
    order:9;
  }

  .slds-max-medium-order_10,.slds-max-medium-order--10{
    order:10;
  }

  .slds-max-medium-order_11,.slds-max-medium-order--11{
    order:11;
  }

  .slds-max-medium-order_12,.slds-max-medium-order--12{
    order:12;
  }
}
@media (min-width: 64em){
  .slds-large-size_xxx-small,.slds-large-size--xxx-small,
  .slds-large-size_xx-small,
  .slds-large-size--xx-small,
  .slds-large-size_x-small,
  .slds-large-size--x-small,
  .slds-large-size_small,
  .slds-large-size--small,
  .slds-large-size_medium,
  .slds-large-size--medium,
  .slds-large-size_large,
  .slds-large-size--large,
  .slds-large-size_x-large,
  .slds-large-size--x-large,
  .slds-large-size_xx-large,
  .slds-large-size--xx-large,
  .slds-large-size_1-of-1,
  .slds-large-size--1-of-1,
  .slds-large-size_1-of-2,
  .slds-large-size--1-of-2,
  .slds-large-size_2-of-2,
  .slds-large-size--2-of-2,
  .slds-large-size_1-of-3,
  .slds-large-size--1-of-3,
  .slds-large-size_2-of-3,
  .slds-large-size--2-of-3,
  .slds-large-size_3-of-3,
  .slds-large-size--3-of-3,
  .slds-large-size_1-of-4,
  .slds-large-size--1-of-4,
  .slds-large-size_2-of-4,
  .slds-large-size--2-of-4,
  .slds-large-size_3-of-4,
  .slds-large-size--3-of-4,
  .slds-large-size_4-of-4,
  .slds-large-size--4-of-4,
  .slds-large-size_1-of-5,
  .slds-large-size--1-of-5,
  .slds-large-size_2-of-5,
  .slds-large-size--2-of-5,
  .slds-large-size_3-of-5,
  .slds-large-size--3-of-5,
  .slds-large-size_4-of-5,
  .slds-large-size--4-of-5,
  .slds-large-size_5-of-5,
  .slds-large-size--5-of-5,
  .slds-large-size_1-of-6,
  .slds-large-size--1-of-6,
  .slds-large-size_2-of-6,
  .slds-large-size--2-of-6,
  .slds-large-size_3-of-6,
  .slds-large-size--3-of-6,
  .slds-large-size_4-of-6,
  .slds-large-size--4-of-6,
  .slds-large-size_5-of-6,
  .slds-large-size--5-of-6,
  .slds-large-size_6-of-6,
  .slds-large-size--6-of-6,
  .slds-large-size_1-of-7,
  .slds-large-size--1-of-7,
  .slds-large-size_2-of-7,
  .slds-large-size--2-of-7,
  .slds-large-size_3-of-7,
  .slds-large-size--3-of-7,
  .slds-large-size_4-of-7,
  .slds-large-size--4-of-7,
  .slds-large-size_5-of-7,
  .slds-large-size--5-of-7,
  .slds-large-size_6-of-7,
  .slds-large-size--6-of-7,
  .slds-large-size_7-of-7,
  .slds-large-size--7-of-7,
  .slds-large-size_1-of-8,
  .slds-large-size--1-of-8,
  .slds-large-size_2-of-8,
  .slds-large-size--2-of-8,
  .slds-large-size_3-of-8,
  .slds-large-size--3-of-8,
  .slds-large-size_4-of-8,
  .slds-large-size--4-of-8,
  .slds-large-size_5-of-8,
  .slds-large-size--5-of-8,
  .slds-large-size_6-of-8,
  .slds-large-size--6-of-8,
  .slds-large-size_7-of-8,
  .slds-large-size--7-of-8,
  .slds-large-size_8-of-8,
  .slds-large-size--8-of-8,
  .slds-large-size_1-of-12,
  .slds-large-size--1-of-12,
  .slds-large-size_2-of-12,
  .slds-large-size--2-of-12,
  .slds-large-size_3-of-12,
  .slds-large-size--3-of-12,
  .slds-large-size_4-of-12,
  .slds-large-size--4-of-12,
  .slds-large-size_5-of-12,
  .slds-large-size--5-of-12,
  .slds-large-size_6-of-12,
  .slds-large-size--6-of-12,
  .slds-large-size_7-of-12,
  .slds-large-size--7-of-12,
  .slds-large-size_8-of-12,
  .slds-large-size--8-of-12,
  .slds-large-size_9-of-12,
  .slds-large-size--9-of-12,
  .slds-large-size_10-of-12,
  .slds-large-size--10-of-12,
  .slds-large-size_11-of-12,
  .slds-large-size--11-of-12,
  .slds-large-size_12-of-12,
  .slds-large-size--12-of-12{
    flex:none;
  }

  .slds-large-size_xxx-small,.slds-large-size--xxx-small{
    width:3rem;
  }

  .slds-large-size_xx-small,.slds-large-size--xx-small{
    width:6rem;
  }

  .slds-large-size_x-small,.slds-large-size--x-small{
    width:12rem;
  }

  .slds-large-size_small,.slds-large-size--small{
    width:15rem;
  }

  .slds-large-size_medium,.slds-large-size--medium{
    width:20rem;
  }

  .slds-large-size_large,.slds-large-size--large{
    width:25rem;
  }

  .slds-large-size_x-large,.slds-large-size--x-large{
    width:40rem;
  }

  .slds-large-size_xx-large,.slds-large-size--xx-large{
    width:60rem;
  }

  .slds-large-size_1-of-1,.slds-large-size--1-of-1{
    width:100%;
  }

  .slds-large-size_1-of-2,.slds-large-size--1-of-2{
    width:50%;
  }

  .slds-large-size_2-of-2,.slds-large-size--2-of-2{
    width:100%;
  }

  .slds-large-size_1-of-3,.slds-large-size--1-of-3{
    width:33.333%;
  }

  .slds-large-size_2-of-3,.slds-large-size--2-of-3{
    width:66.6667%;
  }

  .slds-large-size_3-of-3,.slds-large-size--3-of-3{
    width:100%;
  }

  .slds-large-size_1-of-4,.slds-large-size--1-of-4{
    width:25%;
  }

  .slds-large-size_2-of-4,.slds-large-size--2-of-4{
    width:50%;
  }

  .slds-large-size_3-of-4,.slds-large-size--3-of-4{
    width:75%;
  }

  .slds-large-size_4-of-4,.slds-large-size--4-of-4{
    width:100%;
  }

  .slds-large-size_1-of-5,.slds-large-size--1-of-5{
    width:20%;
  }

  .slds-large-size_2-of-5,.slds-large-size--2-of-5{
    width:40%;
  }

  .slds-large-size_3-of-5,.slds-large-size--3-of-5{
    width:60%;
  }

  .slds-large-size_4-of-5,.slds-large-size--4-of-5{
    width:80%;
  }

  .slds-large-size_5-of-5,.slds-large-size--5-of-5{
    width:100%;
  }

  .slds-large-size_1-of-6,.slds-large-size--1-of-6{
    width:16.6667%;
  }

  .slds-large-size_2-of-6,.slds-large-size--2-of-6{
    width:33.333%;
  }

  .slds-large-size_3-of-6,.slds-large-size--3-of-6{
    width:50%;
  }

  .slds-large-size_4-of-6,.slds-large-size--4-of-6{
    width:66.6667%;
  }

  .slds-large-size_5-of-6,.slds-large-size--5-of-6{
    width:83.3333%;
  }

  .slds-large-size_6-of-6,.slds-large-size--6-of-6{
    width:100%;
  }

  .slds-large-size_1-of-7,.slds-large-size--1-of-7{
    width:14.2857%;
  }

  .slds-large-size_2-of-7,.slds-large-size--2-of-7{
    width:28.5714%;
  }

  .slds-large-size_3-of-7,.slds-large-size--3-of-7{
    width:42.8571%;
  }

  .slds-large-size_4-of-7,.slds-large-size--4-of-7{
    width:57.1429%;
  }

  .slds-large-size_5-of-7,.slds-large-size--5-of-7{
    width:71.4286%;
  }

  .slds-large-size_6-of-7,.slds-large-size--6-of-7{
    width:85.7143%;
  }

  .slds-large-size_7-of-7,.slds-large-size--7-of-7{
    width:100%;
  }

  .slds-large-size_1-of-8,.slds-large-size--1-of-8{
    width:12.5%;
  }

  .slds-large-size_2-of-8,.slds-large-size--2-of-8{
    width:25%;
  }

  .slds-large-size_3-of-8,.slds-large-size--3-of-8{
    width:37.5%;
  }

  .slds-large-size_4-of-8,.slds-large-size--4-of-8{
    width:50%;
  }

  .slds-large-size_5-of-8,.slds-large-size--5-of-8{
    width:62.5%;
  }

  .slds-large-size_6-of-8,.slds-large-size--6-of-8{
    width:75%;
  }

  .slds-large-size_7-of-8,.slds-large-size--7-of-8{
    width:87.5%;
  }

  .slds-large-size_8-of-8,.slds-large-size--8-of-8{
    width:100%;
  }

  .slds-large-size_1-of-12,.slds-large-size--1-of-12{
    width:8.3333%;
  }

  .slds-large-size_2-of-12,.slds-large-size--2-of-12{
    width:16.6667%;
  }

  .slds-large-size_3-of-12,.slds-large-size--3-of-12{
    width:25%;
  }

  .slds-large-size_4-of-12,.slds-large-size--4-of-12{
    width:33.333%;
  }

  .slds-large-size_5-of-12,.slds-large-size--5-of-12{
    width:41.6667%;
  }

  .slds-large-size_6-of-12,.slds-large-size--6-of-12{
    width:50%;
  }

  .slds-large-size_7-of-12,.slds-large-size--7-of-12{
    width:58.3333%;
  }

  .slds-large-size_8-of-12,.slds-large-size--8-of-12{
    width:66.6667%;
  }

  .slds-large-size_9-of-12,.slds-large-size--9-of-12{
    width:75%;
  }

  .slds-large-size_10-of-12,.slds-large-size--10-of-12{
    width:83.3333%;
  }

  .slds-large-size_11-of-12,.slds-large-size--11-of-12{
    width:91.6667%;
  }

  .slds-large-size_12-of-12,.slds-large-size--12-of-12{
    width:100%;
  }

  .slds-large-order_1,.slds-large-order--1{
    order:1;
  }

  .slds-large-order_2,.slds-large-order--2{
    order:2;
  }

  .slds-large-order_3,.slds-large-order--3{
    order:3;
  }

  .slds-large-order_4,.slds-large-order--4{
    order:4;
  }

  .slds-large-order_5,.slds-large-order--5{
    order:5;
  }

  .slds-large-order_6,.slds-large-order--6{
    order:6;
  }

  .slds-large-order_7,.slds-large-order--7{
    order:7;
  }

  .slds-large-order_8,.slds-large-order--8{
    order:8;
  }

  .slds-large-order_9,.slds-large-order--9{
    order:9;
  }

  .slds-large-order_10,.slds-large-order--10{
    order:10;
  }

  .slds-large-order_11,.slds-large-order--11{
    order:11;
  }

  .slds-large-order_12,.slds-large-order--12{
    order:12;
  }
}
@media (max-width: 64em){
  .slds-max-large-size_xxx-small,.slds-max-large-size--xxx-small,
  .slds-max-large-size_xx-small,
  .slds-max-large-size--xx-small,
  .slds-max-large-size_x-small,
  .slds-max-large-size--x-small,
  .slds-max-large-size_small,
  .slds-max-large-size--small,
  .slds-max-large-size_medium,
  .slds-max-large-size--medium,
  .slds-max-large-size_large,
  .slds-max-large-size--large,
  .slds-max-large-size_x-large,
  .slds-max-large-size--x-large,
  .slds-max-large-size_xx-large,
  .slds-max-large-size--xx-large{
    flex:none;
  }

  .slds-max-large-size_xxx-small,.slds-max-large-size--xxx-small{
    width:3rem;
  }

  .slds-max-large-size_xx-small,.slds-max-large-size--xx-small{
    width:6rem;
  }

  .slds-max-large-size_x-small,.slds-max-large-size--x-small{
    width:12rem;
  }

  .slds-max-large-size_small,.slds-max-large-size--small{
    width:15rem;
  }

  .slds-max-large-size_medium,.slds-max-large-size--medium{
    width:20rem;
  }

  .slds-max-large-size_large,.slds-max-large-size--large{
    width:25rem;
  }

  .slds-max-large-size_x-large,.slds-max-large-size--x-large{
    width:40rem;
  }

  .slds-max-large-size_xx-large,.slds-max-large-size--xx-large{
    width:60rem;
  }

  .slds-max-large-size_1-of-1,.slds-max-large-size--1-of-1{
    width:100%;
  }

  .slds-max-large-size_1-of-2,.slds-max-large-size--1-of-2{
    width:50%;
  }

  .slds-max-large-size_2-of-2,.slds-max-large-size--2-of-2{
    width:100%;
  }

  .slds-max-large-size_1-of-3,.slds-max-large-size--1-of-3{
    width:33.333%;
  }

  .slds-max-large-size_2-of-3,.slds-max-large-size--2-of-3{
    width:66.6667%;
  }

  .slds-max-large-size_3-of-3,.slds-max-large-size--3-of-3{
    width:100%;
  }

  .slds-max-large-size_1-of-4,.slds-max-large-size--1-of-4{
    width:25%;
  }

  .slds-max-large-size_2-of-4,.slds-max-large-size--2-of-4{
    width:50%;
  }

  .slds-max-large-size_3-of-4,.slds-max-large-size--3-of-4{
    width:75%;
  }

  .slds-max-large-size_4-of-4,.slds-max-large-size--4-of-4{
    width:100%;
  }

  .slds-max-large-size_1-of-5,.slds-max-large-size--1-of-5{
    width:20%;
  }

  .slds-max-large-size_2-of-5,.slds-max-large-size--2-of-5{
    width:40%;
  }

  .slds-max-large-size_3-of-5,.slds-max-large-size--3-of-5{
    width:60%;
  }

  .slds-max-large-size_4-of-5,.slds-max-large-size--4-of-5{
    width:80%;
  }

  .slds-max-large-size_5-of-5,.slds-max-large-size--5-of-5{
    width:100%;
  }

  .slds-max-large-size_1-of-6,.slds-max-large-size--1-of-6{
    width:16.6667%;
  }

  .slds-max-large-size_2-of-6,.slds-max-large-size--2-of-6{
    width:33.333%;
  }

  .slds-max-large-size_3-of-6,.slds-max-large-size--3-of-6{
    width:50%;
  }

  .slds-max-large-size_4-of-6,.slds-max-large-size--4-of-6{
    width:66.6667%;
  }

  .slds-max-large-size_5-of-6,.slds-max-large-size--5-of-6{
    width:83.3333%;
  }

  .slds-max-large-size_6-of-6,.slds-max-large-size--6-of-6{
    width:100%;
  }

  .slds-max-large-size_1-of-7,.slds-max-large-size--1-of-7{
    width:14.2857%;
  }

  .slds-max-large-size_2-of-7,.slds-max-large-size--2-of-7{
    width:28.5714%;
  }

  .slds-max-large-size_3-of-7,.slds-max-large-size--3-of-7{
    width:42.8571%;
  }

  .slds-max-large-size_4-of-7,.slds-max-large-size--4-of-7{
    width:57.1429%;
  }

  .slds-max-large-size_5-of-7,.slds-max-large-size--5-of-7{
    width:71.4286%;
  }

  .slds-max-large-size_6-of-7,.slds-max-large-size--6-of-7{
    width:85.7143%;
  }

  .slds-max-large-size_7-of-7,.slds-max-large-size--7-of-7{
    width:100%;
  }

  .slds-max-large-size_1-of-8,.slds-max-large-size--1-of-8{
    width:12.5%;
  }

  .slds-max-large-size_2-of-8,.slds-max-large-size--2-of-8{
    width:25%;
  }

  .slds-max-large-size_3-of-8,.slds-max-large-size--3-of-8{
    width:37.5%;
  }

  .slds-max-large-size_4-of-8,.slds-max-large-size--4-of-8{
    width:50%;
  }

  .slds-max-large-size_5-of-8,.slds-max-large-size--5-of-8{
    width:62.5%;
  }

  .slds-max-large-size_6-of-8,.slds-max-large-size--6-of-8{
    width:75%;
  }

  .slds-max-large-size_7-of-8,.slds-max-large-size--7-of-8{
    width:87.5%;
  }

  .slds-max-large-size_8-of-8,.slds-max-large-size--8-of-8{
    width:100%;
  }

  .slds-max-large-size_1-of-12,.slds-max-large-size--1-of-12{
    width:8.3333%;
  }

  .slds-max-large-size_2-of-12,.slds-max-large-size--2-of-12{
    width:16.6667%;
  }

  .slds-max-large-size_3-of-12,.slds-max-large-size--3-of-12{
    width:25%;
  }

  .slds-max-large-size_4-of-12,.slds-max-large-size--4-of-12{
    width:33.333%;
  }

  .slds-max-large-size_5-of-12,.slds-max-large-size--5-of-12{
    width:41.6667%;
  }

  .slds-max-large-size_6-of-12,.slds-max-large-size--6-of-12{
    width:50%;
  }

  .slds-max-large-size_7-of-12,.slds-max-large-size--7-of-12{
    width:58.3333%;
  }

  .slds-max-large-size_8-of-12,.slds-max-large-size--8-of-12{
    width:66.6667%;
  }

  .slds-max-large-size_9-of-12,.slds-max-large-size--9-of-12{
    width:75%;
  }

  .slds-max-large-size_10-of-12,.slds-max-large-size--10-of-12{
    width:83.3333%;
  }

  .slds-max-large-size_11-of-12,.slds-max-large-size--11-of-12{
    width:91.6667%;
  }

  .slds-max-large-size_12-of-12,.slds-max-large-size--12-of-12{
    width:100%;
  }

  .slds-max-large-order_1,.slds-max-large-order--1{
    order:1;
  }

  .slds-max-large-order_2,.slds-max-large-order--2{
    order:2;
  }

  .slds-max-large-order_3,.slds-max-large-order--3{
    order:3;
  }

  .slds-max-large-order_4,.slds-max-large-order--4{
    order:4;
  }

  .slds-max-large-order_5,.slds-max-large-order--5{
    order:5;
  }

  .slds-max-large-order_6,.slds-max-large-order--6{
    order:6;
  }

  .slds-max-large-order_7,.slds-max-large-order--7{
    order:7;
  }

  .slds-max-large-order_8,.slds-max-large-order--8{
    order:8;
  }

  .slds-max-large-order_9,.slds-max-large-order--9{
    order:9;
  }

  .slds-max-large-order_10,.slds-max-large-order--10{
    order:10;
  }

  .slds-max-large-order_11,.slds-max-large-order--11{
    order:11;
  }

  .slds-max-large-order_12,.slds-max-large-order--12{
    order:12;
  }
}
.slds-size_xxx-small,.slds-size--xxx-small,
.slds-size_xx-small,
.slds-size--xx-small,
.slds-size_x-small,
.slds-size--x-small,
.slds-size_small,
.slds-size--small,
.slds-size_medium,
.slds-size--medium,
.slds-size_large,
.slds-size--large,
.slds-size_x-large,
.slds-size--x-large,
.slds-size_xx-large,
.slds-size--xx-large,
.slds-size_1-of-1,
.slds-size--1-of-1,
.slds-size_1-of-2,
.slds-size--1-of-2,
.slds-size_2-of-2,
.slds-size--2-of-2,
.slds-size_1-of-3,
.slds-size--1-of-3,
.slds-size_2-of-3,
.slds-size--2-of-3,
.slds-size_3-of-3,
.slds-size--3-of-3,
.slds-size_1-of-4,
.slds-size--1-of-4,
.slds-size_2-of-4,
.slds-size--2-of-4,
.slds-size_3-of-4,
.slds-size--3-of-4,
.slds-size_4-of-4,
.slds-size--4-of-4,
.slds-size_1-of-5,
.slds-size--1-of-5,
.slds-size_2-of-5,
.slds-size--2-of-5,
.slds-size_3-of-5,
.slds-size--3-of-5,
.slds-size_4-of-5,
.slds-size--4-of-5,
.slds-size_5-of-5,
.slds-size--5-of-5,
.slds-size_1-of-6,
.slds-size--1-of-6,
.slds-size_2-of-6,
.slds-size--2-of-6,
.slds-size_3-of-6,
.slds-size--3-of-6,
.slds-size_4-of-6,
.slds-size--4-of-6,
.slds-size_5-of-6,
.slds-size--5-of-6,
.slds-size_6-of-6,
.slds-size--6-of-6,
.slds-size_1-of-7,
.slds-size--1-of-7,
.slds-size_2-of-7,
.slds-size--2-of-7,
.slds-size_3-of-7,
.slds-size--3-of-7,
.slds-size_4-of-7,
.slds-size--4-of-7,
.slds-size_5-of-7,
.slds-size--5-of-7,
.slds-size_6-of-7,
.slds-size--6-of-7,
.slds-size_7-of-7,
.slds-size--7-of-7,
.slds-size_1-of-8,
.slds-size--1-of-8,
.slds-size_2-of-8,
.slds-size--2-of-8,
.slds-size_3-of-8,
.slds-size--3-of-8,
.slds-size_4-of-8,
.slds-size--4-of-8,
.slds-size_5-of-8,
.slds-size--5-of-8,
.slds-size_6-of-8,
.slds-size--6-of-8,
.slds-size_7-of-8,
.slds-size--7-of-8,
.slds-size_8-of-8,
.slds-size--8-of-8,
.slds-size_1-of-12,
.slds-size--1-of-12,
.slds-size_2-of-12,
.slds-size--2-of-12,
.slds-size_3-of-12,
.slds-size--3-of-12,
.slds-size_4-of-12,
.slds-size--4-of-12,
.slds-size_5-of-12,
.slds-size--5-of-12,
.slds-size_6-of-12,
.slds-size--6-of-12,
.slds-size_7-of-12,
.slds-size--7-of-12,
.slds-size_8-of-12,
.slds-size--8-of-12,
.slds-size_9-of-12,
.slds-size--9-of-12,
.slds-size_10-of-12,
.slds-size--10-of-12,
.slds-size_11-of-12,
.slds-size--11-of-12,
.slds-size_12-of-12,
.slds-size--12-of-12{
  flex:none;
}
.slds-has-buffer{
  margin:var(--slds-g-spacing-3);
}
.slds-has-full-bleed{
  margin:0;
}
.slds-has-bottom-magnet{
  margin-block-end:0 !important;
  border-end-start-radius:0 !important;
  border-end-end-radius:0 !important;
}
.slds-has-top-magnet{
  margin-block-start:0 !important;
  border-start-start-radius:0 !important;
  border-start-end-radius:0 !important;
}
.slds-has-top-magnet.slds-has-buffer{
  margin-block-end:0;
  border-radius:0;
  border-block-start:0;
  box-shadow:none;
}
.slds-is-static{
  position:static;
}
.slds-is-relative{
  position:relative;
}
.slds-is-fixed{
  position:fixed;
}
.slds-is-absolute{
  position:absolute;
}
@media print{
  .slds-no-print{
    display:none;
  }
}
.slds-assistive-text{
  position:absolute !important;
  margin:-1px !important;
  border:0 !important;
  padding:0 !important;
  width:1px !important;
  height:1px !important;
  overflow:hidden !important;
  clip:rect(0 0 0 0) !important;
  text-transform:none !important;
  white-space:nowrap !important;
}
.slds-assistive-text_focus:focus,.slds-assistive-text--focus:focus{
  margin:inherit !important;
  border:inherit !important;
  padding:inherit !important;
  width:auto !important;
  height:auto !important;
  overflow:visible !important;
  clip:auto !important;
}
.slds-is-collapsed{
  height:0;
  overflow:hidden;
}
.slds-is-expanded{
  height:auto;
  overflow:visible;
}
.slds-hidden{
  visibility:hidden !important;
}
.slds-visible{
  visibility:visible;
}
.slds-hide{
  display:none !important;
}
.slds-show{
  display:block;
}
.slds-show_inline-block,.slds-show--inline-block{
  display:inline-block;
}
.slds-show_inline,.slds-show--inline{
  display:inline;
}
.slds-transition-hide{
  opacity:0;
}
.slds-transition-show{
  opacity:1;
}
.slds-x-small-show{
  display:none;
}
@media (min-width: 320px){
  .slds-x-small-show{
    display:block;
  }
  .slds-x-small-show_inline-block,.slds-x-small-show--inline-block{
    display:inline-block;
  }
  .slds-x-small-show_inline,.slds-x-small-show--inline{
    display:inline;
  }
}
.slds-x-small-show-only{
  display:none;
}
@media (min-width: 320px) and (max-width: 479px){
  .slds-x-small-show-only{
    display:block;
  }
  .slds-x-small-show-only_inline-block,.slds-x-small-show-only--inline-block{
    display:inline-block;
  }
  .slds-x-small-show-only_inline,.slds-x-small-show-only--inline{
    display:inline;
  }
}
@media (max-width: 479px){
  .slds-max-x-small-hide{
    display:none;
  }
}
.slds-small-show{
  display:none;
}
@media (min-width: 480px){
  .slds-small-show{
    display:block;
  }
  .slds-small-show_inline-block,.slds-small-show--inline-block{
    display:inline-block;
  }
  .slds-small-show_inline,.slds-small-show--inline{
    display:inline;
  }
}
.slds-small-show-only{
  display:none;
}
@media (min-width: 480px) and (max-width: 767px){
  .slds-small-show-only{
    display:block;
  }
  .slds-small-show-only_inline-block,.slds-small-show-only--inline-block{
    display:inline-block;
  }
  .slds-small-show-only_inline,.slds-small-show-only--inline{
    display:inline;
  }
}
@media (max-width: 767px){
  .slds-max-small-hide{
    display:none;
  }
}
.slds-medium-show{
  display:none;
}
@media (min-width: 768px){
  .slds-medium-show{
    display:block;
  }
  .slds-medium-show_inline-block,.slds-medium-show--inline-block{
    display:inline-block;
  }
  .slds-medium-show_inline,.slds-medium-show--inline{
    display:inline;
  }
}
.slds-medium-show-only{
  display:none;
}
@media (min-width: 768px) and (max-width: 1023px){
  .slds-medium-show-only{
    display:block;
  }
  .slds-medium-show-only_inline-block,.slds-medium-show-only--inline-block{
    display:inline-block;
  }
  .slds-medium-show-only_inline,.slds-medium-show-only--inline{
    display:inline;
  }
}
@media (max-width: 1023px){
  .slds-max-medium-hide{
    display:none;
  }
}
.slds-large-show{
  display:none;
}
@media (min-width: 1024px){
  .slds-large-show{
    display:block;
  }
  .slds-large-show_inline-block,.slds-large-show--inline-block{
    display:inline-block;
  }
  .slds-large-show_inline,.slds-large-show--inline{
    display:inline;
  }
}
@media (min-width: 320px){
  .slds-hide_x-small,.slds-hide--x-small{
    display:none !important;
  }
}
@media (max-width: 319px){
  .slds-show_x-small,.slds-show--x-small{
    display:none !important;
  }
}
@media (min-width: 480px){
  .slds-hide_small,.slds-hide--small{
    display:none !important;
  }
}
@media (max-width: 479px){
  .slds-show_small,.slds-show--small{
    display:none !important;
  }
}
@media (min-width: 768px){
  .slds-hide_medium,.slds-hide--medium{
    display:none !important;
  }
}
@media (max-width: 767px){
  .slds-show_medium,.slds-show--medium{
    display:none !important;
  }
}
@media (min-width: 1024px){
  .slds-hide_large,.slds-hide--large{
    display:none !important;
  }
}
@media (max-width: 1023px){
  .slds-show_large,.slds-show--large{
    display:none !important;
  }
}
@media (min-width: 1280px){
  .slds-hide_x-large,.slds-hide--x-large{
    display:none !important;
  }
}
@media (max-width: 1279px){
  .slds-show_x-large,.slds-show--x-large{
    display:none !important;
  }
}
.slds-is-visually-empty{
  visibility:hidden !important;
  width:0;
}
.slds-line-clamp{
  overflow:hidden;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:3;
  text-overflow:ellipsis;
  white-space:pre-line;
}
.slds-line-clamp_x-small,.slds-line-clamp--x-small{
  overflow:hidden;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2;
  text-overflow:ellipsis;
  white-space:pre-line;
}
.slds-line-clamp_small,.slds-line-clamp--small{
  overflow:hidden;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:3;
  text-overflow:ellipsis;
  white-space:pre-line;
}
.slds-line-clamp_medium,.slds-line-clamp--medium{
  overflow:hidden;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:5;
  text-overflow:ellipsis;
  white-space:pre-line;
}
.slds-line-clamp_large,.slds-line-clamp--large{
  overflow:hidden;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:7;
  text-overflow:ellipsis;
  white-space:pre-line;
}
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;EAaE;AACF,uEAAuE;AACvE;EACE;IACE,yBAAyB;IACzB,yCAAyC;IACzC,+DAA+D;IAC/D,yCAAyC;IACzC,8DAA8D;IAC9D,yCAAyC;IACzC,+DAA+D;IAC/D,yCAAyC;IACzC,4DAA4D;IAC5D,yCAAyC;IACzC,8DAA8D;IAC9D,yCAAyC;IACzC,4DAA4D;IAC5D,yCAAyC;IACzC,8DAA8D;IAC9D,yCAAyC;IACzC,4DAA4D;IAC5D,yCAAyC;IACzC,8DAA8D;IAC9D,4CAA4C;IAC5C,6DAA6D;IAC7D,2CAA2C;IAC3C,+DAA+D;IAC/D,2CAA2C;IAC3C,6DAA6D;IAC7D,+BAA+B;IAC/B,qDAAqD;IACrD,uEAAuE;IACvE,qDAAqD;IACrD,uEAAuE;IACvE,qDAAqD;IACrD,uEAAuE;IACvE,qDAAqD;IACrD,uEAAuE;IACvE,uCAAuC;IACvC,0BAA0B;IAC1B,uCAAuC;IACvC,yBAAyB;IACzB,uCAAuC;IACvC,wBAAwB;IACxB,uCAAuC;IACvC,yBAAyB;IACzB,uCAAuC;IACvC,sBAAsB;IACtB,uCAAuC;IACvC,yBAAyB;IACzB,uCAAuC;IACvC,wBAAwB;IACxB,uCAAuC;IACvC,yBAAyB;IACzB,uCAAuC;IACvC,sBAAsB;IACtB,yCAAyC;IACzC,uBAAuB;IACvB,yCAAyC;IACzC,uBAAuB;IACvB,yCAAyC;IACzC,uBAAuB;IACvB,yCAAyC;IACzC,wBAAwB;IACxB,yCAAyC;IACzC,wBAAwB;IACxB,yCAAyC;IACzC,wBAAwB;IACxB,yCAAyC;IACzC,wBAAwB;IACxB,uDAAuD;IACvD,8BAA8B;IAC9B,uDAAuD;IACvD,8BAA8B;IAC9B,uDAAuD;IACvD,8BAA8B;IAC9B,uDAAuD;IACvD,8BAA8B;IAC9B,uDAAuD;IACvD,8BAA8B;IAC9B,uDAAuD;IACvD,8BAA8B;IAC9B,uCAAuC;IACvC,wGAAwG;IACxG,uCAAuC;IACvC,sGAAsG;IACtG,uCAAuC;IACvC,2GAA2G;IAC3G,uCAAuC;IACvC,4GAA4G;IAC5G,uCAAuC;IACvC,wCAAwC;IACxC,uCAAuC;IACvC,wCAAwC;IACxC,uDAAuD;IACvD,yCAAyC;IACzC,+CAA+C;IAC/C,uBAAuB;IACvB,qDAAqD;IACrD,4BAA4B;IAC5B,mDAAmD;IACnD,2BAA2B;IAC3B,2CAA2C;IAC3C,wBAAwB;IACxB,qDAAqD;IACrD,6BAA6B;IAC7B,+BAA+B;IAC/B,qDAAqD;IACrD,2EAA2E;IAC3E,qDAAqD;IACrD,0EAA0E;IAC1E,qDAAqD;IACrD,2EAA2E;IAC3E,qDAAqD;IACrD,2EAA2E;IAC3E,2DAA2D;IAC3D,iCAAiC;IACjC,+DAA+D;IAC/D,kCAAkC;IAClC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;IACvC,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,6EAA6E;IAC7E,4CAA4C;IAC5C,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,yEAAyE;IACzE,0CAA0C;IAC1C,uDAAuD;IACvD,uLAAuL;IACvL,iEAAiE;IACjE,0EAA0E;IAC1E,4BAA4B;IAC5B,uDAAuD;IACvD,8BAA8B;IAC9B,iDAAiD;IACjD,mEAAmE;IACnE,iDAAiD;IACjD,mEAAmE;IACnE,iDAAiD;IACjD,mEAAmE;IACnE,iDAAiD;IACjD,mEAAmE;IACnE,iDAAiD;IACjD,mEAAmE;IACnE,iDAAiD;IACjD,mEAAmE;IACnE,iDAAiD;IACjD,mEAAmE;IACnE,iCAAiC;IACjC,+DAA+D;IAC/D,iCAAiC;IACjC,yDAAyD;IACzD,yEAAyE;IACzE,yDAAyD;IACzD,4EAA4E;IAC5E,yDAAyD;IACzD,6EAA6E;IAC7E,yDAAyD;IACzD,2EAA2E;IAC3E,yDAAyD;IACzD,4EAA4E;IAC5E,yDAAyD;IACzD,yEAAyE;IACzE,uDAAuD;IACvD,2BAA2B;IAC3B,mDAAmD;IACnD,yEAAyE;IACzE,uDAAuD;IACvD,wDAAwD;IACxD,uDAAuD;IACvD,wDAAwD;IACxD,uDAAuD;IACvD,0EAA0E;IAC1E,uDAAuD;IACvD,yEAAyE;IACzE,+CAA+C;IAC/C,sEAAsE;IACtE,+CAA+C;IAC/C,kEAAkE;IAClE,+CAA+C;IAC/C,qEAAqE;IACrE,+CAA+C;IAC/C,oEAAoE;IACpE,+CAA+C;IAC/C,qEAAqE;IACrE,+CAA+C;IAC/C,kEAAkE;IAClE,+CAA+C;IAC/C,oEAAoE;IACpE,+CAA+C;IAC/C,kEAAkE;IAClE,+CAA+C;IAC/C,gDAAgD;IAChD,iDAAiD;IACjD,iDAAiD;IACjD,mEAAmE;IACnE,uCAAuC;IACvC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,+DAA+D;IAC/D,qCAAqC;IACrC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,+DAA+D;IAC/D,qCAAqC;IACrC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,mEAAmE;IACnE,uCAAuC;IACvC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,mEAAmE;IACnE,uCAAuC;IACvC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,mDAAmD;IACnD,+BAA+B;IAC/B,mDAAmD;IACnD,+BAA+B;IAC/B,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,iEAAiE;IACjE,sCAAsC;IACtC,qDAAqD;IACrD,gCAAgC;IAChC,qDAAqD;IACrD,gCAAgC;IAChC,qDAAqD;IACrD,gCAAgC;IAChC,yEAAyE;IACzE,0CAA0C;IAC1C,yEAAyE;IACzE,0CAA0C;IAC1C,yEAAyE;IACzE,0CAA0C;IAC1C,2DAA2D;IAC3D,mCAAmC;IACnC,2DAA2D;IAC3D,mCAAmC;IACnC,2DAA2D;IAC3D,mCAAmC;IACnC,mDAAmD;IACnD,+BAA+B;IAC/B,mDAAmD;IACnD,+BAA+B;IAC/B,mDAAmD;IACnD,+BAA+B;IAC/B,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,uEAAuE;IACvE,yCAAyC;IACzC,yDAAyD;IACzD,kCAAkC;IAClC,iDAAiD;IACjD,8BAA8B;IAC9B,qEAAqE;IACrE,wCAAwC;IACxC,uDAAuD;IACvD,iCAAiC;IACjC,+DAA+D;IAC/D,qCAAqC;IACrC,qDAAqD;IACrD,gCAAgC;IAChC,yEAAyE;IACzE,0CAA0C;IAC1C,2DAA2D;IAC3D,mCAAmC;IACnC,mEAAmE;IACnE,uCAAuC;IACvC,qDAAqD;IACrD,gCAAgC;IAChC,yEAAyE;IACzE,0CAA0C;IAC1C,2DAA2D;IAC3D,+DAA+D;IAC/D,mEAAmE;IACnE,mEAAmE;IACnE,+CAA+C;IAC/C,6BAA6B;IAC7B,mEAAmE;IACnE,uCAAuC;IACvC,qDAAqD;IACrD,gCAAgC;IAChC,uDAAuD;IACvD,iCAAiC;IACjC,2EAA2E;IAC3E,2CAA2C;IAC3C,6DAA6D;IAC7D,oCAAoC;IACpC,qEAAqE;IACrE,oEAAoE;IACpE,6DAA6D;IAC7D,mHAAmH;IACnH,2DAA2D;IAC3D,8GAA8G;IAC9G,yDAAyD;IACzD,iDAAiD;IACjD,+DAA+D;IAC/D,oHAAoH;IACpH,6DAA6D;IAC7D,iHAAiH;IACjH,2DAA2D;IAC3D,gHAAgH;IAChH,yDAAyD;IACzD,iDAAiD;IACjD,+DAA+D;IAC/D,kHAAkH;IAClH,6DAA6D;IAC7D,sHAAsH;IACtH,2DAA2D;IAC3D,qHAAqH;IACrH,yDAAyD;IACzD,iDAAiD;IACjD,+DAA+D;IAC/D,uHAAuH;IACvH,6DAA6D;IAC7D,uHAAuH;IACvH,2DAA2D;IAC3D,sHAAsH;IACtH,yDAAyD;IACzD,iDAAiD;IACjD,+DAA+D;IAC/D,wHAAwH;IACxH,mEAAmE;IACnE,iFAAiF;IACjF,iEAAiE;IACjE,sIAAsI;IACtI,+DAA+D;IAC/D,qFAAqF;IACrF,6EAA6E;IAC7E,wJAAwJ;IACxJ,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,mFAAmF;IACnF,+CAA+C;IAC/C,+DAA+D;IAC/D,qCAAqC;IACrC,+DAA+D;IAC/D,qCAAqC;IACrC,6DAA6D;IAC7D,oCAAoC;IACpC,6DAA6D;IAC7D,oCAAoC;IACpC,2EAA2E;IAC3E,2CAA2C;IAC3C,6DAA6D;IAC7D,oCAAoC;IACpC,qEAAqE;IACrE,wCAAwC;IACxC,uDAAuD;IACvD,iCAAiC;IACjC,+DAA+D;IAC/D,qCAAqC;IACrC,yEAAyE;IACzE,0CAA0C;IAC1C,2DAA2D;IAC3D,+DAA+D;IAC/D,qEAAqE;IACrE,wCAAwC;IACxC,qEAAqE;IACrE,wCAAwC;IACxC,yFAAyF;IACzF,kDAAkD;IAClD,yFAAyF;IACzF,kDAAkD;IAClD,2EAA2E;IAC3E,2CAA2C;IAC3C,2EAA2E;IAC3E,2CAA2C;IAC3C,mEAAmE;IACnE,uCAAuC;IACvC,mEAAmE;IACnE,uCAAuC;EACzC;AACF;AACA;EACE;IACE,+DAA+D;IAC/D,qEAAqE;IACrE,kEAAkE;IAClE,wEAAwE;IACxE,iEAAiE;IACjE,uEAAuE;IACvE,6DAA6D;IAC7D,mEAAmE;IACnE,4DAA4D;IAC5D,kEAAkE;IAClE,gEAAgE;IAChE,sEAAsE;;IAEtE,kCAAkC;IAClC,gCAAgC;IAChC,8BAA8B;IAC9B,8BAA8B;IAC9B,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;;;IAG7B,4CAA4C;IAC5C,0CAA0C;IAC1C,wCAAwC;IACxC,wCAAwC;IACxC,sCAAsC;IACtC,uCAAuC;IACvC,sCAAsC;IACtC,uCAAuC;;;;IAIvC,0CAA0C;IAC1C,wCAAwC;IACxC,sCAAsC;IACtC,sCAAsC;IACtC,oCAAoC;IACpC,qCAAqC;IACrC,oCAAoC;IACpC,qCAAqC;EACvC;AACF;AACA;EACE;IACE,6CAA6C;IAC7C,qDAAqD;IACrD,iFAAiF;IACjF,8EAA8E;IAC9E,6FAA6F;IAC7F,oFAAoF;IACpF,mGAAmG;IACnG,uFAAuF;IACvF,2DAA2D;IAC3D,4DAA4D;IAC5D,uEAAuE;IACvE,6DAA6D;IAC7D,2DAA2D;IAC3D,wDAAwD;IACxD,yEAAyE;IACzE,+DAA+D;IAC/D,6FAA6F;IAC7F,8EAA8E;IAC9E,iGAAiG;IACjG,kFAAkF;IAClF,2EAA2E;IAC3E,qFAAqF;IACrF,6EAA6E;IAC7E,sEAAsE;IACtE,6EAA6E;IAC7E,4EAA4E;IAC5E,qFAAqF;IACrF,gFAAgF;IAChF,uEAAuE;IACvE,mCAAmC;IACnC,2EAA2E;IAC3E,8DAA8D;IAC9D,+EAA+E;IAC/E,iEAAiE;IACjE,uEAAuE;IACvE,mCAAmC;IACnC,yDAAyD;IACzD,+BAA+B;IAC/B,uFAAuF;IACvF,iEAAiE;IACjE,6EAA6E;IAC7E,4EAA4E;IAC5E,2FAA2F;IAC3F,mFAAmF;IACnF,yFAAyF;IACzF,4EAA4E;IAC5E,uDAAuD;IACvD,0DAA0D;IAC1D,qEAAqE;IACrE,6DAA6D;IAC7D,mEAAmE;IACnE,iEAAiE;IACjE,qEAAqE;IACrE,oEAAoE;IACpE,iFAAiF;IACjF,wEAAwE;IACxE,mFAAmF;IACnF,2CAA2C;IAC3C,qFAAqF;IACrF,4CAA4C;IAC5C,mEAAmE;IACnE,mCAAmC;IACnC,iFAAiF;IACjF,0CAA0C;IAC1C,uEAAuE;IACvE,wCAAwC;IACxC,2EAA2E;IAC3E,0CAA0C;IAC1C,yFAAyF;IACzF,4EAA4E;IAC5E,mEAAmE;IACnE,4DAA4D;IAC5D,iFAAiF;IACjF,sEAAsE;IACtE,iEAAiE;IACjE,sEAAsE;IACtE,iFAAiF;IACjF,6EAA6E;IAC7E,iFAAiF;IACjF,yEAAyE;IACzE,iFAAiF;IACjF,wEAAwE;IACxE,yDAAyD;IACzD,+GAA+G;IAC/G,6DAA6D;IAC7D,8JAA8J;IAC9J,2CAA2C;IAC3C,gDAAgD;IAChD,uDAAuD;IACvD,sDAAsD;IACtD,uDAAuD;IACvD,sDAAsD;IACtD,yDAAyD;IACzD,uDAAuD;IACvD,yDAAyD;IACzD,+GAA+G;IAC/G,6CAA6C;IAC7C,qDAAqD;IACrD,qDAAqD;IACrD,qDAAqD;IACrD,yDAAyD;IACzD,sDAAsD;IACtD,iDAAiD;IACjD,8CAA8C;IAC9C,yDAAyD;IACzD,kDAAkD;IAClD,6DAA6D;IAC7D,0DAA0D;IAC1D,mEAAmE;IACnE,uEAAuE;IACvE,qFAAqF;IACrF,iFAAiF;IACjF,mFAAmF;IACnF,2EAA2E;IAC3E,2DAA2D;IAC3D,wDAAwD;IACxD,6EAA6E;IAC7E,0EAA0E;IAC1E,uEAAuE;IACvE,8DAA8D;IAC9D,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,qDAAqD;IACrD,+DAA+D;IAC/D,+DAA+D;IAC/D,6DAA6D;IAC7D,gEAAgE;IAChE,2DAA2D;IAC3D,mPAAmP;IACnP,+DAA+D;IAC/D,kCAAkC;IAClC,iEAAiE;IACjE,+DAA+D;IAC/D,2DAA2D;IAC3D,8DAA8D;IAC9D,mDAAmD;IACnD,wDAAwD;IACxD,2DAA2D;IAC3D,0DAA0D;IAC1D,uDAAuD;IACvD,iDAAiD;IACjD,+DAA+D;IAC/D,sCAAsC;IACtC,qDAAqD;IACrD,yDAAyD;IACzD,uDAAuD;IACvD,8BAA8B;IAC9B,mFAAmF;IACnF,qEAAqE;IACrE,mEAAmE;IACnE,2CAA2C;IAC3C,qEAAqE;IACrE,kCAAkC;IAClC,qEAAqE;IACrE,8DAA8D;IAC9D,+EAA+E;IAC/E,sEAAsE;IACtE,6EAA6E;IAC7E,+DAA+D;IAC/D,iFAAiF;IACjF,kEAAkE;IAClE,+EAA+E;IAC/E,0CAA0C;IAC1C,6EAA6E;IAC7E,0CAA0C;IAC1C,6EAA6E;IAC7E,qEAAqE;IACrE,yFAAyF;IACzF,kFAAkF;IAClF,qEAAqE;IACrE,iEAAiE;IACjE,qEAAqE;IACrE,wEAAwE;IACxE,iFAAiF;IACjF,wEAAwE;IACxE,iFAAiF;IACjF,8EAA8E;IAC9E,mFAAmF;IACnF,+EAA+E;IAC/E,6DAA6D;IAC7D,yDAAyD;IACzD,6DAA6D;IAC7D,iHAAiH;IACjH,6EAA6E;IAC7E,yHAAyH;IACzH,+DAA+D;IAC/D,+JAA+J;IAC/J,+DAA+D;IAC/D,8DAA8D;IAC9D,+CAA+C;IAC/C,kDAAkD;IAClD,2DAA2D;IAC3D,4DAA4D;IAC5D,iEAAiE;IACjE,sDAAsD;IACtD,yEAAyE;IACzE,yDAAyD;IACzD,+DAA+D;IAC/D,gEAAgE;IAChE,yDAAyD;IACzD,sDAAsD;IACtD,uEAAuE;IACvE,kEAAkE;EACpE;AACF;AACA;EACE;IACE,2FAA2F;IAC3F,iGAAiG;IACjG,uFAAuF;IACvF,qEAAqE;IACrE,yFAAyF;IACzF,qFAAqF;IACrF,2FAA2F;IAC3F,oFAAoF;IACpF,gFAAgF;IAChF,2CAA2C;IAC3C,0CAA0C;IAC1C,0CAA0C;IAC1C,gEAAgE;IAChE,8DAA8D;IAC9D,wEAAwE;IACxE,+CAA+C;IAC/C,2EAA2E;IAC3E,uDAAuD;IACvD,sDAAsD;IACtD,kEAAkE;IAClE,mEAAmE;IACnE,qFAAqF;IACrF,iFAAiF;IACjF,qFAAqF;IACrF,oFAAoF;IACpF,gFAAgF;IAChF,8FAA8F;IAC9F,qDAAqD;IACrD,0CAA0C;IAC1C,sEAAsE;IACtE,yEAAyE;IACzE,2FAA2F;IAC3F,gGAAgG;IAChG,+CAA+C;IAC/C,oCAAoC;IACpC,0CAA0C;IAC1C,4CAA4C;IAC5C,6CAA6C;IAC7C,yEAAyE;IACzE,qEAAqE;IACrE,yEAAyE;IACzE,0EAA0E;IAC1E,2DAA2D;IAC3D,kEAAkE;IAClE,8DAA8D;IAC9D,4DAA4D;IAC5D,yCAAyC;IACzC,yCAAyC;IACzC,0CAA0C;IAC1C,yCAAyC;EAC3C;AACF;AACA;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,0CAA0C;EAC1C,cAAc;EACd,8CAA8C;EAC9C,wCAAwC;EACxC,sCAAsC;EACtC,uCAAuC;AACzC;AACA;EACE,iDAAiD;EACjD,sBAAsB;AACxB;AACA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,SAAS;AACX;AACA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,uCAAuC;AACzC;AACA;;;;;;;;;;;EAWE,QAAQ;EACR,SAAS;AACX;AACA;;EAEE,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,eAAe;EACf,yDAAyD;EACzD,UAAU;EACV,UAAU;AACZ;AACA;;;;;;EAME,mBAAmB;EACnB,aAAa;AACf;AACA;;EAEE,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,0CAA0C;AAC5C;AACA;;EAEE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;;;;;;GAMG;AACH;;;EAGE,uCAAuC;AACzC;AACA;EACE,sDAAsD;EACtD,yCAAyC;AAC3C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;;EAGE,eAAe;AACjB;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;;;;;;;;;;;EAaE,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;;EAEE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,iDAAiD;AACnD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,yCAAyC;EACzC,SAAS;AACX;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,2CAA2C;AAC7C;AACA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,uCAAuC;EACvC,WAAW;EACX,mCAAmC;EACnC,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,iDAAiD;AACnD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,SAAS;AACX;AACA;;;;EAIE,4DAA4D;AAC9D;AACA;;;EAGE,6DAA6D;AAC/D;AACA;;EAEE,4DAA4D;EAC5D,yBAAyB;EACzB,0DAA0D;EAC1D,uBAAuB;AACzB;AACA;;;;;;;;EAQE,2BAA2B;EAC3B,0DAA0D;EAC1D,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;;EAEE,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,yBAAyB;EACzB,0DAA0D;EAC1D,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,4DAA4D;AAC9D;AACA;EACE,2BAA2B;EAC3B,0DAA0D;EAC1D,yBAAyB;EACzB,wDAAwD;EACxD;;GAEC;AACH;AACA;;;;;;EAME,2CAA2C;AAC7C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2DAA2D;EAC3D,yDAAyD;EACzD,uDAAuD;EACvD,6DAA6D;EAC7D,eAAe;EACf,sDAAsD;EACtD,0BAA0B;EAC1B,2DAA2D;EAC3D,kBAAkB;EAClB,8EAA8E;EAC9E;;;GAGC;EACD,mEAAmE;EACnE,oBAAoB;EACpB,oBAAoB;EACpB,+FAA+F;EAC/F,eAAe;EACf,kBAAkB;EAClB,wBAAgB;UAAhB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;EAIE,oBAAoB;AACtB;AACA;;EAEE;;;GAGC;EACD;;;GAGC;;EAED;;;GAGC;EACD,oDAAoD;AACtD;AACA;EACE,+EAA+E;EAC/E,SAAS;AACX;AACA;EACE,0EAA0E;EAC1E,qDAAqD;;EAErD,qFAAqF;EACrF,6EAA6E;AAC/E;AACA;;EAEE,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB;;;GAGC;EACD,oGAAoG;EACpG,qEAAqE;EACrE,mEAAmE;EACnE,uEAAuE;EACvE,qEAAqE;AACvE;AACA;;;EAGE;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE;;;GAGC;EACD;;;GAGC;AACH;AACA;;;EAGE,yDAAyD;EACzD,kDAAkD;EAClD,uCAAuC;AACzC;AACA;EACE,sBAAsB;EACtB;;;GAGC;EACD,yGAAyG;EACzG,iGAAiG;EACjG,qEAAqE;EACrE,mEAAmE;EACnE,uEAAuE;EACvE,qEAAqE;AACvE;AACA;;;EAGE;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE;;;GAGC;EACD,uEAAuE;EACvE;;;GAGC;AACH;AACA;;;EAGE,yDAAyD;EACzD,kDAAkD;EAClD,uCAAuC;AACzC;AACA;EACE,sBAAsB;EACtB,wEAAwE;EACxE,gEAAgE;EAChE,qEAAqE;EACrE,mEAAmE;EACnE,uEAAuE;EACvE,qEAAqE;AACvE;AACA;;;EAGE,8EAA8E;EAC9E,sEAAsE;AACxE;AACA;EACE,+EAA+E;EAC/E,uEAAuE;AACzE;AACA;;;EAGE,yDAAyD;EACzD,kDAAkD;AACpD;AACA;EACE,sBAAsB;EACtB,2FAA2F;EAC3F;;;GAGC;EACD;;;GAGC;EACD,qEAAqE;EACrE,mEAAmE;EACnE,uEAAuE;EACvE,qEAAqE;AACvE;AACA;;;EAGE;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE;;;GAGC;EACD;;;GAGC;AACH;AACA;;;EAGE,4BAA4B;EAC5B,uFAAuF;AACzF;AACA;;;;;;;EAOE;;;GAGC;AACH;AACA;;;;;;;EAOE;;;GAGC;AACH;AACA;EACE,sGAAsG;EACtG,iEAAiE;;EAEjE,YAAY;AACd;AACA;EACE;;;GAGC;AACH;AACA;;;;;;;EAOE,gFAAgF;AAClF;AACA;EACE,sBAAsB;EACtB,sEAAsE;EACtE,+DAA+D;EAC/D,yDAAyD;EACzD,qEAAqE;EACrE,mEAAmE;EACnE,uEAAuE;EACvE,qEAAqE;AACvE;AACA;;;EAGE,4EAA4E;EAC5E,qEAAqE;EACrE,+DAA+D;AACjE;AACA;EACE,6EAA6E;EAC7E,sEAAsE;EACtE,gEAAgE;AAClE;AACA;;;EAGE,yDAAyD;EACzD,kDAAkD;EAClD,uCAAuC;AACzC;AACA;EACE,sBAAsB;EACtB,wEAAwE;EACxE,+DAA+D;EAC/D,sDAAsD;EACtD,qEAAqE;EACrE,mEAAmE;EACnE,uEAAuE;EACvE,qEAAqE;AACvE;AACA;;;EAGE,8EAA8E;EAC9E,qEAAqE;EACrE,4DAA4D;AAC9D;AACA;EACE,+EAA+E;EAC/E,sEAAsE;EACtE,6DAA6D;AAC/D;AACA;;;EAGE,yDAAyD;EACzD,kDAAkD;EAClD,uCAAuC;AACzC;AACA;EACE,sBAAsB;EACtB,wEAAwE;EACxE,iEAAiE;EACjE,2DAA2D;EAC3D,qEAAqE;EACrE,mEAAmE;EACnE,uEAAuE;EACvE,qEAAqE;AACvE;AACA;;;EAGE,8EAA8E;EAC9E,uEAAuE;EACvE,iEAAiE;AACnE;AACA;EACE,+EAA+E;EAC/E,wEAAwE;EACxE,kEAAkE;AACpE;AACA;;;EAGE,yDAAyD;EACzD,kDAAkD;EAClD,uCAAuC;AACzC;AACA;;;EAGE,cAAc;EACd,eAAe;EACf,sDAAsD;AACxD;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;;;;;;;;;;;;;;;;;EAiBE,2CAA2C;;EAE3C,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,kEAAkE;EAClE,aAAa;EACb,SAAS;AACX;AACA;;;;;;;;;;;;;EAaE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,kEAAkE;EAClE,uEAAuE;EACvE,8BAA8B;AAChC;AACA;;;;;;;EAOE,kDAAkD;EAClD,oCAAoC;AACtC;AACA;EACE,4BAA4B;EAC5B,iDAAiD;AACnD;AACA;;;EAGE,4BAA4B;EAC5B,uFAAuF;AACzF;AACA;EACE,uDAAuD;EACvD,gDAAgD;EAChD,qCAAqC;AACvC;AACA;;;EAGE,qCAAqC;AACvC;AACA;;;EAGE,uDAAuD;EACvD,mDAAmD;EACnD,qCAAqC;AACvC;AACA;EACE,uDAAuD;EACvD,mDAAmD;AACrD;AACA;;;EAGE,mDAAmD;EACnD,kDAAkD;EAClD,uCAAuC;AACzC;AACA;EACE,wEAAwE;AAC1E;AACA;;;EAGE,8EAA8E;AAChF;AACA;;;EAGE,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;;;EAGE,8CAA8C;AAChD;AACA;;;;;;;EAOE,kDAAkD;;EAElD,oFAAoF;AACtF;AACA;EACE,YAAY;EACZ,oDAAoD;EACpD,+EAA+E;AACjF;AACA;EACE,oFAAoF;AACtF;AACA;;;;;;;EAOE,oFAAoF;AACtF;AACA;EACE,iCAAiC;AACnC;AACA;;;;;EAKE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;;;;;EAKE,mCAAmC;AACrC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,iCAAiC;EACjC,wDAAwD;EACxD,yCAAyC;EACzC,kEAAkE;AACpE;AACA;EACE,mEAAmE;AACrE;AACA;EACE,iCAAiC;AACnC;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,sCAAsC;EACtC,qBAAqB;AACvB;AACA;EACE,iEAAiE;AACnE;AACA;EACE,mFAAmF;AACrF;AACA;EACE,uFAAuF;AACzF;AACA;EACE,uFAAuF;AACzF;AACA;EACE,uFAAuF;AACzF;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mFAAmF;AACrF;AACA;EACE,iBAAiB;AACnB;AACA;;;;;;;EAOE,uDAAuD;EACvD,gDAAgD;EAChD,qCAAqC;AACvC;AACA;;;;;;;;;;;;;;;EAeE,uDAAuD;EACvD,mDAAmD;EACnD,qCAAqC;AACvC;AACA;;;;;;;;;;;;;;;EAeE,mDAAmD;EACnD,kDAAkD;EAClD,uCAAuC;AACzC;AACA;EACE;;;GAGC;EACD,qGAAqG;AACvG;AACA;;;EAGE;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE;;;GAGC;AACH;AACA;EACE,wBAAwB;AAC1B;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,4FAA4F;EAC5F,wFAAwF;;EAExF;;;GAGC;;EAED,yGAAyG;EACzG,iGAAiG;;EAEjG;;;GAGC;;EAED;;;GAGC;AACH;AACA;;;EAGE;;;GAGC;;EAED;;;GAGC;;EAED;;;GAGC;AACH;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,iBAAiB;EACjB,qDAAqD;AACvD;AACA;;EAEE,aAAa;EACb,qBAAqB;EACrB,uFAAuF;EACvF,mBAAmB;EACnB,2FAA2F;AAC7F;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,UAAU;AACZ;AACA;EACE,sFAAsF;AACxF;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gFAAgF;EAChF,yCAAyC;EACzC,2CAA2C;EAC3C,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,uCAAuC;EACvC,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,4BAA4B;EAC5B,mBAAmB;EACnB,qEAAqE;EACrE,gFAAgF;AAClF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,mDAAmD;EACnD,mFAAmF;EACnF,oFAAoF;AACtF;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gIAAgI;AAClI;AACA;;EAEE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,yFAAyF;EACzF,oFAAoF;EACpF,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;;;EAIE,gIAAgI;AAClI;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,qCAAqC;EACrC,wFAAwF;EACxF,oHAAoH;AACtH;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,OAAO;EACP,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,OAAO;EACP,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,8CAA8C;EAC9C,4CAA4C;EAC5C,+CAA+C;EAC/C,6CAA6C;EAC7C,gFAAgF;EAChF,gDAAgD;EAChD,kBAAkB;EAClB,yDAAyD;EACzD,yFAAyF;EACzF,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,8DAA8D;;EAE9D,+BAA+B;AACjC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oFAAoF;EACpF,mFAAmF;EACnF,8EAA8E;AAChF;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,2DAA2D;EAC3D,4DAA4D;AAC9D;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,kEAAkE;AACpE;AACA;EACE,8DAA8D;;EAE9D,oCAAoC;EACpC,qCAAqC;AACvC;AACA;;;;;;;;;;;EAWE,mEAAmE;AACrE;AACA;EACE;;;GAGC;AACH;AACA;EACE,mCAAmC;AACrC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2EAA2E;;EAE3E,iBAAiB;EACjB,OAAO;EACP,6BAA6B;EAC7B,2CAA2C;EAC3C,QAAQ;EACR,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qGAAqG;EACrG,8BAA8B;EAC9B,mGAAmG;AACrG;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,wGAAwG;EACxG,sGAAsG;EACtG,oGAAoG;EACpG,0GAA0G;EAC1G,8FAA8F;EAC9F,4FAA4F;EAC5F,0FAA0F;EAC1F,gGAAgG;EAChG,8EAA8E;AAChF;AACA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,6EAA6E;EAC7E;;;GAGC;EACD,oFAAoF;EACpF,2CAA2C;AAC7C;AACA;EACE,4DAA4D;EAC5D,2CAA2C;EAC3C,2EAA2E;AAC7E;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,wGAAwG;EACxG,sGAAsG;EACtG,oGAAoG;EACpG,0GAA0G;EAC1G,8FAA8F;EAC9F,4FAA4F;EAC5F,0FAA0F;EAC1F,gGAAgG;EAChG,mBAAmB;AACrB;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB;EACF;AACF;AACA;EACE,8FAA8F;EAC9F,4FAA4F;EAC5F,0FAA0F;EAC1F,gGAAgG;AAClG;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,QAAQ;EACR,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,oDAAoD;AACtD;AACA;EACE,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,2DAA2D;EAC3D,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,QAAQ;EACR,MAAM;EACN,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,SAAS;EACT,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;AACA;;EAEE,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,yDAAyD;EACzD,wBAAwB;AAC1B;AACA;;;;;;EAME,kCAAkC;EAClC,oCAAoC;AACtC;AACA;;;;;;EAME,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,oFAAoF;AACtF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,+CAA+C;AACjD;AACA;;;;;;;;;;;;EAYE,4BAA4B;AAC9B;AACA;EACE,sCAAsC;AACxC;AACA;EACE;IACE,gBAAgB;IAChB,mCAAmC;EACrC;EACA;IACE,kCAAkC;IAClC,oCAAoC;EACtC;AACF;AACA;EACE;IACE,gBAAgB;IAChB,mCAAmC;EACrC;EACA;IACE,0CAA0C;IAC1C,kCAAkC;EACpC;AACF;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,sDAAsD;AACxD;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;;EAEE,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,qCAAqC;AACvC;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,iCAAiC;EACnC;AACF;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmCE,kDAAkD;AACpD;AACA;;;;;;;;;;;EAWE,6CAA6C;AAC/C;AACA;;;;;;;;;;;EAWE,oDAAoD;AACtD;AACA;;;;;;;;;;;EAWE,sDAAsD;AACxD;AACA;;;;;;;EAOE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;;;;;;;;;;;EAWE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;;;;;;EAOE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;;EAGE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;;;;;;;;;EASE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,KAAK;EACL,MAAM;AACR;AACA;EACE,KAAK;EACL,WAAW;AACb;AACA;EACE,KAAK;EACL,OAAO;AACT;AACA;EACE,UAAU;EACV,MAAM;AACR;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,OAAO;AACT;AACA;EACE,QAAQ;EACR,MAAM;AACR;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,QAAQ;EACR,OAAO;AACT;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;AACxB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,+DAA+D;AACjE;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oDAAoD;EACpD,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;AACA;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;;IAEE,oDAAoD;EACtD;AACF;AACA;EACE;;IAEE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;;IAEE,oDAAoD;EACtD;AACF;AACA;EACE;;IAEE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;AACF;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kCAAkC;EAClC,aAAa;AACf;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,uEAAuE;EACvE,mDAAmD;EACnD,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;EACxC,uEAAuE;EACvE,iBAAiB;AACnB;AACA;;EAEE,iDAAiD;EACjD,gDAAgD;AAClD;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,8CAA8C;AAChD;AACA;EACE,SAAS;EACT,4CAA4C;EAC5C,uDAAuD;EACvD,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,uCAAuC;EACvC,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,4DAA4D;EAC5D,0DAA0D;EAC1D,wDAAwD;EACxD,8DAA8D;EAC9D,uFAAuF;EACvF,4EAA4E;EAC5E,kBAAkB;EAClB;;;GAGC;EACD;;;GAGC;EACD,2BAA2B;EAC3B,4FAA4F;EAC5F,kEAAkE;AACpE;AACA;EACE,8EAA8E;AAChF;AACA;EACE;;;GAGC;EACD;;;GAGC;EACD,wGAAwG;EACxG;;;GAGC;EACD,QAAQ;EACR;;;GAGC;AACH;AACA;EACE,YAAY;EACZ;;;GAGC;EACD;;;GAGC;EACD,2CAA2C;EAC3C,sCAAsC;AACxC;AACA;EACE,aAAa;EACb;;;GAGC;AACH;AACA;EACE;;;GAGC;EACD;;;GAGC;EACD,oGAAoG;EACpG;;;GAGC;AACH;AACA;EACE,gGAAgG;EAChG,kGAAkG;;EAElG,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;EAEE,YAAY;AACd;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD,2EAA2E;EAC3E,uFAAuF;EACvF,sBAAsB;EACtB,qFAAqF;AACvF;AACA;EACE,aAAa;AACf;AACA;EACE,8EAA8E;AAChF;AACA;;;;;;;;;;;;EAYE,eAAe;EACf,QAAQ;EACR,iFAAiF;EACjF,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6DAA6D;EAC7D,uFAAuF;EACvF,4EAA4E;EAC5E,kBAAkB;EAClB;;;GAGC;EACD;;;GAGC;EACD,2BAA2B;EAC3B,4FAA4F;AAC9F;AACA;;;EAGE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;;;;;;EAME,QAAQ;EACR,eAAe;AACjB;AACA;;;;;;;;;;;EAWE,QAAQ;EACR,eAAe;AACjB;AACA;EACE,4EAA4E;EAC5E,kBAAkB;EAClB;;;GAGC;EACD;;;GAGC;AACH;AACA;;;EAGE,yEAAyE;EACzE,2EAA2E;EAC3E,uFAAuF;EACvF,4EAA4E;EAC5E,kBAAkB;EAClB;;;GAGC;EACD;;;GAGC;EACD,4FAA4F;AAC9F;AACA;;;;;;;EAOE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;;;;;;;;;;;EAWE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4EAA4E;EAC5E,kBAAkB;EAClB;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE,SAAS;EACT;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kDAAkD;EAClD,mDAAmD;AACrD;AACA;;;EAGE,yCAAyC;AAC3C;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,wCAAwC;EACxC,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,wBAAwB;AAC1B;AACA;;;EAGE,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;AACd;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,sCAAsC;EACtC,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;;;;;;;;;;;;;;;;;EAiBE,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;EACrD,uBAAuB;EACvB,8CAA8C;EAC9C,eAAe;AACjB;AACA;;;;;;;;;EASE,+BAA+B;AACjC;AACA;;;;;;;EAOE,SAAS;EACT,uEAAuE;AACzE;AACA;;;;;;;EAOE,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,wDAAwD;EACxD,uDAAuD;EACvD,qDAAqD;EACrD,yBAAyB;EACzB,mDAAmD;EACnD,sCAAsC;AACxC;AACA;EACE,wDAAwD;EACxD,uDAAuD;EACvD,qDAAqD;EACrD,yBAAyB;EACzB,mDAAmD;AACrD;AACA;EACE,2CAA2C;EAC3C,wDAAwD;AAC1D;AACA;EACE,wBAAwB;EACxB,gEAAgE;AAClE;AACA;EACE,oDAAoD;EACpD,wBAAwB;AAC1B;AACA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;EACE,wDAAwD;EACxD,uDAAuD;EACvD,qDAAqD;EACrD,yBAAyB;EACzB,mDAAmD;EACnD,8EAA8E;EAC9E,sCAAsC;EACtC,sBAAsB;AACxB;AACA;EACE,wDAAwD;EACxD,6EAA6E;EAC7E,sCAAsC;EACtC,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,uCAAuC;EACvC,sCAAsC;EACtC,sCAAsC;EACtC,gDAAgD;EAChD,iCAAiC;EACjC,yFAAyF;AAC3F;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,uBAAuB;EACvB,uCAAuC;AACzC;AACA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,iBAAiB;EACjB,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,oDAAoD;EACpD,sCAAsC;EACtC,YAAY;EACZ,sCAAsC;EACtC,sBAAsB;EACtB,qCAAqC;EACrC,sCAAsC;EACtC,UAAU;AACZ;AACA;EACE,8CAA8C;AAChD;AACA;EACE,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,iFAAiF;EACjF,4EAA4E;EAC5E,kBAAkB;EAClB;;;GAGC;EACD;;;GAGC;EACD,wCAAwC;EACxC,2DAA2D;AAC7D;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uEAAuE;AACzE;AACA;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;;;;EAKE;;;GAGC;AACH;AACA;;;;;EAKE,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,4BAA4B;EAC5B,iBAAiB;EACjB,qBAAqB;;EAErB,aAAa;EACb,QAAQ;EACR,mDAAmD;EACnD,qIAAqI;;EAErI,aAAa;EACb,gIAAgI;AAClI;AACA;;;;;EAKE;;;GAGC;EACD;;;GAGC;AACH;AACA;;;;;EAKE,0DAA0D;AAC5D;AACA;;;;;EAKE;;;GAGC;EACD,wDAAwD;AAC1D;AACA;;;;;EAKE;;;GAGC;EACD;;;GAGC;AACH;AACA;;;;;EAKE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,qBAAqB;;EAErB,aAAa;EACb,QAAQ;EACR,4BAA4B;EAC5B,UAAU;EACV,QAAQ;EACR,oCAAoC;EACpC,oGAAoG;AACtG;AACA;;;;;EAKE,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;;;;;EAKE,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;;;;;EAKE,8CAA8C;AAChD;AACA;;;;;EAKE,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;;;;;EAKE,+CAA+C;EAC/C,4DAA4D;EAC5D,0DAA0D;AAC5D;AACA;;;;;EAKE,+CAA+C;EAC/C,0CAA0C;EAC1C,wDAAwD;AAC1D;AACA;;;;;;;;;;;;;EAaE,+CAA+C;EAC/C,0CAA0C;EAC1C,wDAAwD;AAC1D;AACA;;;;;EAKE,4FAA4F;AAC9F;AACA;;;;;EAKE,wCAAwC;AAC1C;AACA;;;;;;;;;;;;;;;;;;EAkBE,aAAa;EACb,cAAc;;EAEd,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,QAAQ;EACR,SAAS;EACT,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,iEAAiE;EACjE,uEAAuE;EACvE,0CAA0C;EAC1C,2CAA2C;EAC3C,mFAAmF;AACrF;AACA;EACE,QAAQ;AACV;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;;EAEf,aAAa;EACb,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;EAC3C,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,0EAA0E;EAC1E,oDAAoD;EACpD,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,8EAA8E;EAC9E,kBAAkB;AACpB;AACA;EACE,qDAAqD;EACrD,mDAAmD;AACrD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,UAAU;AACZ;AACA;EACE,aAAa;EACb,WAAW;;EAEX,aAAa;EACb,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,uEAAuE;EACvE,uCAAuC;EACvC,yCAAyC;EACzC,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;AACA;EACE,iCAAiC;AACnC;AACA;;;;;EAKE,aAAa;AACf;AACA;EACE,0CAA0C;AAC5C;AACA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;;;IAKE,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;;;;;EAKE,aAAa;AACf;AACA;;;;;EAKE,wCAAwC;AAC1C;AACA;;;;;EAKE,iCAAiC;AACnC;AACA;;;;;EAKE,SAAS;EACT,kBAAkB;AACpB;AACA;;;;;EAKE,UAAU;EACV,eAAe;AACjB;AACA;;;;;;;;;;;EAWE,aAAa;AACf;AACA;;;;;;;;;;;EAWE,eAAe;EACf,sBAAsB;AACxB;AACA;;;;;EAKE,UAAU;EACV,eAAe;EACf,UAAU;AACZ;AACA;;;;;EAKE,aAAa;EACb,WAAW;AACb;AACA;;;;;EAKE,UAAU;EACV,2CAA2C;AAC7C;AACA;;;;;EAKE,aAAa;AACf;AACA;;;;;EAKE,wCAAwC;AAC1C;AACA;;;;;EAKE,UAAU;EACV,eAAe;AACjB;AACA;;;;;EAKE,+BAA+B;AACjC;AACA;;;;;EAKE,SAAS;EACT,kBAAkB;AACpB;AACA;;;;;EAKE,2EAA2E;AAC7E;AACA;EACE;;;;;IAKE,yCAAyC;EAC3C;;EAEA;;;;;IAKE,0DAA0D;EAC5D;AACF;AACA;EACE;;;;;IAKE,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;EACX;;EAEA;;;;;IAKE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;;;;;IAKE,sBAAsB;EACxB;;EAEA;;;;;IAKE,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;;;;;IAKE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;;;;;;;;;;;;;;;;;;;;;;;IAuBE,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,UAAU;EACZ;;EAEA;;;;;;;;;;;;;;;;;IAiBE,UAAU;IACV,cAAc;IACd,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;;;;;IAKE,UAAU;EACZ;;EAEA;;;;;IAKE,sCAAsC;EACxC;;EAEA;;;;;IAKE,sCAAsC;EACxC;AACF;AACA;;;;;EAKE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,wCAAwC;EACxC,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4CAA4C;EAC5C,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,cAAc;EACd,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,QAAW;EACX,eAAe;EACf,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;EACV,yGAAyG;EACzG,8EAA8E;EAC9E,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,UAAU;EACV,eAAe;EACf,4BAA4B;EAC5B,2CAA2C;AAC7C;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,0FAA0F;EAC1F,eAAe;EACf,oGAAoG;EACpG,QAAQ;EACR;;;GAGC;EACD,cAAc;EACd,+CAAuC;EAAvC,uCAAuC;AACzC;AACA;EACE;;;GAGC;AACH;AACA;;EAEE,mFAAmF;AACrF;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,0FAA0F;EAC1F,qFAAqF;AACvF;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,0FAA0F;EAC1F,eAAe;EACf,oGAAoG;EACpG,QAAQ;EACR;;;GAGC;EACD,cAAc;EACd,4CAAuC;EAAvC,uCAAuC;AACzC;AACA;EACE;;;GAGC;AACH;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,0FAA0F;EAC1F,qFAAqF;AACvF;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf;;;GAGC;EACD,qFAAqF;EACrF,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf;;;GAGC;EACD,qFAAqF;EACrF,mDAAmD;AACrD;AACA;EACE,0GAA0G;EAC1G,qFAAqF;AACvF;AACA;EACE;;;GAGC;AACH;AACA;EACE,0GAA0G;EAC1G,qFAAqF;AACvF;AACA;EACE;;;GAGC;AACH;AACA;EACE,kDAAkD;EAClD,cAAc;AAChB;AACA;EACE,sDAAsD;EACtD,cAAc;AAChB;AACA;EACE,kDAAkD;EAClD,cAAc;AAChB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,kDAAkD;EAClD,cAAc;AAChB;AACA;EACE,sDAAsD;EACtD,cAAc;AAChB;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,wBAAwB;EACxB,oDAAoD;AACtD;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,qDAAqD;EACrD,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,gGAAgG;EAChG;;;GAGC;EACD,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qDAAqD;EACrD,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,qCAAqC;EACrC,WAAW;EACX,2CAA2C;EAC3C,oBAAoB;EACpB,0CAA0C;EAC1C,sBAAsB;EACtB,2CAA2C;AAC7C;AACA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;EACjB;;;GAGC;EACD;;;GAGC;EACD,uFAAuF;EACvF,4BAA4B;EAC5B,qFAAqF;EACrF;;;GAGC;EACD,2EAA2E;EAC3E,aAAa;EACb,0FAA0F;EAC1F,wFAAwF;EACxF,sFAAsF;EACtF,4FAA4F;EAC5F,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,uDAAuD;EACvD,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,uCAAuC;EACvC,wDAAwD;EACxD,uEAAuE;AACzE;AACA;;;EAGE,wDAAwD;AAC1D;AACA;;;EAGE;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE;;;GAGC;EACD;;;GAGC;EACD,eAAe;EACf,eAAe;AACjB;AACA;;;;EAIE;;;GAGC;EACD;;;GAGC;EACD,sEAAsE;AACxE;AACA;EACE;;;GAGC;EACD;;;GAGC;EACD,yFAAyF;EACzF,8BAA8B;EAC9B,uFAAuF;EACvF;;;;;;GAMC;EACD,2EAA2E;EAC3E,aAAa;EACb,0FAA0F;EAC1F,wFAAwF;EACxF,sFAAsF;EACtF,4FAA4F;EAC5F,gBAAgB;EAChB,sEAAsE;AACxE;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,SAAS;IACT,oBAAoB;IACpB,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;IACf,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,6CAA6C;IAC7C,oBAAoB;IACpB,4EAA4E;EAC9E;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,cAAc;IACd,WAAW;IACX,QAAQ;IACR,2CAA2C;IAC3C,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB;;;KAGC;IACD,eAAe;IACf,YAAY;IACZ,aAAa;IACb,0DAA0D;IAC1D,uDAAuD;IACvD,yBAAyB;EAC3B;;EAEA;;;;;IAKE,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,wCAAwC;IACxC,sCAAsC;;IAEtC,8DAA8D;IAC9D,qEAAqE;EACvE;;EAEA;;;IAGE,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;EACjB;AACF;AACA;;;;;;;;;EASE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kDAAkD;EAClD,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;AACvD;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,qDAAqD;AACvD;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,2CAA2C;EAC3C,yCAAyC;EACzC,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,mDAAmD;EACnD,uDAAuD;AACzD;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,wEAAwE;EACxE,4DAA4D;AAC9D;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,qFAAqF;EACrF,mBAAmB;EACnB,yFAAyF;EACzF,UAAU;EACV,oBAAoB;EACpB,mFAAmF;EACnF,kFAAkF;EAClF,8FAA8F;EAC9F,iGAAiG;EACjG,qCAAqC;AACvC;AACA;EACE;;;GAGC;EACD,kFAAkF;EAClF,sEAAsE;;EAEtE,SAAS;AACX;AACA;EACE,wFAAwF;;EAExF,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;;EAEE,wGAAwG;EACxG,6FAA6F;EAC7F,2EAA2E;EAC3E,kBAAkB;EAClB,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;;;;EAIE,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,2CAA2C;EAC3C,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,OAAO;EACP,QAAQ;AACV;AACA;;;;EAIE,YAAY;AACd;AACA;;;EAGE,aAAa;EACb,eAAe;AACjB;AACA;EACE,2CAA2C;EAC3C,kCAAkC;EAClC,8DAA8D;;EAE9D,QAAQ;AACV;AACA;;;EAGE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,qFAAqF;EACrF,mBAAmB;EACnB,yFAAyF;EACzF,UAAU;EACV,oBAAoB;EACpB,mFAAmF;EACnF,kFAAkF;EAClF,8FAA8F;EAC9F,iGAAiG;EACjG,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,wGAAwG;EACxG,6FAA6F;EAC7F,2EAA2E;EAC3E,kBAAkB;EAClB,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,8DAA8D;EAC9D,4DAA4D;AAC9D;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,OAAO;EACP,sCAAsC;EACtC,aAAa;EACb,QAAQ;EACR,SAAS;AACX;AACA;EACE,4BAA4B;AAC9B;AACA;;;;;EAKE,0DAA0D;AAC5D;AACA;EACE,wCAAwC;AAC1C;AACA;;;;;EAKE,wDAAwD;AAC1D;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wCAAwC;AAC1C;AACA;;;;;EAKE,0DAA0D;EAC1D,wDAAwD;AAC1D;AACA;;;;;EAKE,wFAAwF;AAC1F;AACA;EACE,iBAAiB;EACjB,yEAAyE;AAC3E;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,4EAA4E;EAC5E,8DAA8D;EAC9D,2DAA2D;;EAE3D,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;AACA;EACE,mDAAmD;EACnD,UAAU;EACV,sFAAsF;EACtF,oFAAoF;EACpF,kFAAkF;EAClF,wFAAwF;EACxF,iGAAiG;EACjG,oGAAoG;EACpG,sFAAsF;EACtF,qFAAqF;EACrF,oEAAoE;EACpE,YAAY;EACZ,eAAe;EACf,2DAA2D;AAC7D;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,SAAS;EACT,qEAAqE;EACrE,4EAA4E;;EAE5E,uGAAuG;AACzG;AACA;EACE,8FAA8F;;EAE9F,SAAS;AACX;AACA;EACE,6DAA6D;EAC7D,uCAAuC;EACvC,+CAA+C;AACjD;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;;EAEE,wGAAwG;EACxG,6FAA6F;EAC7F,2EAA2E;EAC3E,kBAAkB;EAClB,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;;;;EAIE,eAAe;AACjB;AACA;EACE,iEAAiE;EACjE,+EAA+E;;EAE/E,2BAA2B;AAC7B;AACA;;EAEE,gFAAgF;;EAEhF;;;GAGC;AACH;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;EAClB,4FAA4F;EAC5F,+BAA+B;EAC/B,oGAAoG;EACpG,2FAA2F;EAC3F,kFAAkF;EAClF,+DAA+D;AACjE;AACA;;;EAGE;;;GAGC;EACD,sFAAsF;;EAEtF,cAAc;AAChB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,6BAA6B;EAC7B;;;GAGC;EACD,2FAA2F;AAC7F;AACA;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;;;;;EAKE,6EAA6E;EAC7E,+DAA+D;AACjE;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;;;;EAKE,yEAAyE;EACzE,gFAAgF;AAClF;AACA;;;;;;;;;;;EAWE,gFAAgF;AAClF;AACA;;;;;EAKE,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;EAC7B;;;GAGC;EACD,2FAA2F;EAC3F,wDAAwD;AAC1D;AACA;;;;;EAKE,4DAA4D;EAC5D,wCAAwC;;EAExC,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,aAAa;EACb,aAAa;EACb,iDAAiD;EACjD,yBAAyB;EACzB;;;GAGC;EACD,aAAa;EACb,gDAAgD;EAChD,wBAAwB;EACxB;;;GAGC;EACD,uBAAuB;AACzB;AACA;;;;;EAKE;;;GAGC;AACH;AACA;;;;;EAKE,yDAAyD;EACzD,kDAAkD;EAClD,mBAAmB;AACrB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,uEAAuE;EACvE,+EAA+E;EAC/E,wDAAwD;EACxD,cAAc;AAChB;AACA;;;EAGE,UAAU;EACV,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,SAAS;EACT,WAAW;EACX,yEAAyE;AAC3E;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;;;;;EAKE,wDAAwD;AAC1D;AACA;EACE,6CAA6C;AAC/C;AACA;;;EAGE,wBAAwB;EACxB,uDAAuD;EACvD,4CAA4C;AAC9C;AACA;;;;;;;EAOE,gDAAgD;AAClD;AACA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,OAAO;EACP,UAAU;EACV,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;AACA;;;EAGE,uDAAuD;AACzD;AACA;;;EAGE,4CAA4C;AAC9C;AACA;;;EAGE,yDAAyD;EACzD,kDAAkD;EAClD,uCAAuC;EACvC,cAAc;AAChB;AACA;;;;;;;EAOE,kDAAkD;AACpD;AACA;;;EAGE,yDAAyD;AAC3D;AACA;;;;;;;EAOE,kDAAkD;AACpD;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uEAAuE;EACvE,gDAAgD;EAChD,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uDAAuD;EACvD,wBAAwB;EACxB,qCAAqC;EACrC,4CAA4C;AAC9C;AACA;EACE,yDAAyD;EACzD,kDAAkD;EAClD,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,yDAAyD;EACzD,kDAAkD;EAClD,uCAAuC;EACvC,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,wDAAwD;EACxD,uEAAuE;EACvE,+EAA+E;AACjF;AACA;EACE,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,wDAAwD;EACxD,2DAA2D;AAC7D;AACA;;;EAGE,4BAA4B;AAC9B;AACA;EACE,oFAAoF;EACpF,eAAe;EACf,QAAQ;AACV;AACA;;;EAGE,2FAA2F;EAC3F,yBAAyB;EACzB,uBAAuB;EACvB,yFAAyF;AAC3F;AACA;;;;;EAKE,2BAA2B;EAC3B,yFAAyF;EACzF,uFAAuF;EACvF,yBAAyB;AAC3B;AACA;EACE,2FAA2F;EAC3F,yBAAyB;EACzB,uBAAuB;EACvB,yFAAyF;AAC3F;AACA;EACE,2BAA2B;EAC3B,yFAAyF;EACzF,uFAAuF;EACvF,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;;;;;EAKE,uDAAuD;EACvD,6CAA6C;EAC7C,6CAA6C;AAC/C;AACA;;;;;;;;;;;EAWE,uDAAuD;AACzD;AACA;;;;;EAKE,4CAA4C;EAC5C,SAAS;EACT,SAAS;AACX;AACA;;;;;EAKE,yDAAyD;EACzD,uCAAuC;AACzC;AACA;;;;;EAKE,yDAAyD;EACzD,uCAAuC;AACzC;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,wDAAwD;AAC1D;AACA;;;EAGE,cAAc;EACd,wDAAwD;AAC1D;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,QAAQ;EACR,OAAO;EACP,wEAAwE;EACxE,oFAAoF;AACtF;AACA;EACE,+EAA+E;EAC/E,SAAS;AACX;AACA;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,6EAA6E;EAC7E,uDAAuD;EACvD,iBAAiB;EACjB,KAAK;EACL,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,iDAAiD;AACnD;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,+EAA+E;EAC/E,+CAA+C;EAC/C,gDAAgD;EAChD,wCAAwC;EACxC,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,QAAQ;EACR,OAAO;AACT;AACA;;;;;EAKE,SAAS;EACT,YAAY;AACd;AACA;;EAEE,8EAA8E;AAChF;AACA;EACE,gFAAgF;AAClF;AACA;EACE,sDAAsD;AACxD;AACA;EACE,YAAY;AACd;AACA;;EAEE,SAAS;EACT,YAAY;AACd;AACA;EACE,8EAA8E;AAChF;AACA;EACE,uDAAuD;AACzD;AACA;EACE,SAAS;EACT,iDAAiD;EACjD,iBAAiB;EACjB,OAAO;EACP,KAAK;AACP;AACA,4CAA4C;AAC5C;EACE,iCAAiC;EACjC,UAAU;EACV,+KAA+K;EAC/K;;;GAGC;EACD;;;GAGC;EACD,gEAAgE;EAChE,kEAAkE;EAClE,2DAA2D;AAC7D;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,kFAAkF;EAClF,qGAAqG;EACrG,4EAA4E;EAC5E,2CAA2C;AAC7C;AACA;;EAEE,yDAAyD;EACzD,kDAAkD;EAClD,0CAA0C;EAC1C,kBAAkB;EAClB,wBAAgB;UAAhB,gBAAgB;EAChB,SAAS;AACX;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,gEAAgE;AAClE;AACA;EACE,eAAe;EACf,yEAAyE;EACzE,uEAAuE;AACzE;AACA;;;EAGE,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,wCAAwC;EACxC,OAAO;EACP,QAAQ;EACR,mEAAmE;EACnE,iEAAiE;EACjE,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,0DAA0D;AAC5D;AACA;EACE,yCAAyC;EACzC,wDAAwD;AAC1D;AACA;EACE,kFAAkF;EAClF,0FAA0F;EAC1F,2BAA2B;EAC3B,6DAA6D;EAC7D,uCAAuC;AACzC;AACA;;EAEE,mGAAmG;AACrG;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,gDAAgD;EAChD,6EAA6E;EAC7E,kBAAkB;EAClB;;;GAGC;EACD,eAAe;EACf,8FAA8F;EAC9F,iEAAiE;EACjE,2DAA2D;AAC7D;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uEAAuE;AACzE;AACA;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;;;;EAKE;;;GAGC;EACD,uDAAuD;AACzD;AACA;;;;;EAKE,4BAA4B;EAC5B,6BAA6B;EAC7B,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP,aAAa;EACb,QAAQ;EACR,oCAAoC;EACpC,gDAAgD;EAChD,eAAe;EACf;;;GAGC;AACH;AACA;;;;;EAKE;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE,kBAAkB;EAClB,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;;;EAGE,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;;;EAGE,kDAAkD;AACpD;AACA;;;;;EAKE,kDAAkD;EAClD,yDAAyD;AAC3D;AACA;;;;;EAKE,yFAAyF;EACzF,0CAA0C;AAC5C;AACA;;;;;EAKE,yFAAyF;EACzF,4DAA4D;EAC5D,uDAAuD;AACzD;AACA;;;;;EAKE,yFAAyF;AAC3F;AACA;;;;;EAKE,yCAAyC;AAC3C;AACA;;;;;EAKE,aAAa;EACb,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,uEAAuE;EACvE,+EAA+E;AACjF;AACA;EACE,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,oFAAoF;EACpF,QAAQ;AACV;AACA;;;EAGE,2FAA2F;EAC3F,yBAAyB;EACzB,uBAAuB;EACvB,yFAAyF;AAC3F;AACA;;;EAGE,2BAA2B;EAC3B,yFAAyF;EACzF,uFAAuF;EACvF,yBAAyB;AAC3B;AACA;;;EAGE,2FAA2F;EAC3F,yBAAyB;EACzB,uBAAuB;EACvB,yFAAyF;AAC3F;AACA;;;;;EAKE,2BAA2B;EAC3B,yFAAyF;EACzF,uFAAuF;EACvF,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;;;;;EAKE,uDAAuD;EACvD,6CAA6C;EAC7C,6CAA6C;AAC/C;AACA;;;;;;;;;;;EAWE,uDAAuD;AACzD;AACA;;;;;EAKE,SAAS;EACT,4CAA4C;EAC5C,SAAS;AACX;AACA;;;;;EAKE,yDAAyD;EACzD,uCAAuC;AACzC;AACA;;;;;EAKE,yDAAyD;EACzD,uCAAuC;AACzC;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,wDAAwD;AAC1D;AACA;;;EAGE,cAAc;EACd,wDAAwD;AAC1D;AACA;EACE,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,wEAAwE;EACxE,2CAA2C;AAC7C;AACA;EACE,SAAS;EACT,8EAA8E;AAChF;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,wCAAwC;EACxC,kDAAkD;EAClD,uCAAuC;AACzC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oFAAoF;EACpF,8EAA8E;AAChF;AACA;EACE,4DAA4D;EAC5D,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,+CAA+C;EAC/C,iCAAiC;EACjC,+EAA+E;EAC/E,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,sEAAsE;EACtE,yEAAyE;;EAEzE;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD,mFAAmF;EACnF,6FAA6F;EAC7F,2BAA2B;EAC3B,kEAAkE;EAClE,sJAAsJ;AACxJ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,QAAW;EACX,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,+DAA+D;AACjE;AACA;EACE,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,8EAA8E;EAC9E,mFAAmF;EACnF,sCAAsC;EACtC,2CAA2C;EAC3C,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,uGAAuG;EACvG,iEAAiE;EACjE,gDAAgD;EAChD,2BAA2B;EAC3B,yBAAyB;EACzB,4DAA4D;EAC5D,8DAA8D;EAC9D,8DAA8D;EAC9D,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,kDAAkD;EAClD,kFAAkF;EAClF,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,2CAA2C;EAC3C,0CAA0C;EAC1C,kKAAkK;AACpK;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,SAAS;AACX;AACA;;EAEE,+FAA+F;AACjG;AACA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,+EAA+E;AACjF;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,kFAAkF;AACpF;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;;EAEE,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,uBAAuB;EACvB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,qBAAqB;EACrB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,wBAAwB;EACxB,+EAA+E;AACjF;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,QAAQ;EACR,OAAO;EACP,iCAAiC;EACjC,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,OAAO;EACP,iEAAiE;AACnE;AACA;EACE,iEAAiE;EACjE,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,sEAAsE;EACtE,UAAU;EACV,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,wDAAwD;EACxD,uEAAuE;EACvE,2CAA2C;EAC3C,UAAU;EACV,iBAAiB;EACjB,sEAAsE;EACtE,sEAAsE;AACxE;AACA;EACE,iEAAiE;EACjE,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,kFAAkF;EAClF,wDAAwD;AAC1D;AACA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,uEAAuE;AACzE;AACA;EACE,YAAY;EACZ,uCAAuC;EACvC,sCAAsC;AACxC;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,qEAAqE;AACvE;AACA;EACE;IACE;EACF;AACF;AACA;EACE,wDAAwD;EACxD,2EAA2E;EAC3E,8EAA8E;AAChF;AACA;EACE,2FAA2F;AAC7F;AACA;EACE,wDAAwD;EACxD,uDAAuD;AACzD;AACA;EACE;IACE;EACF;AACF;AACA;EACE;IACE;EACF;AACF;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,wCAAwC;AAC1C;AACA;EACE;IACE;EACF;AACF;AACA;EACE,YAAY;EACZ,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE;IACE;EACF;AACF;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,OAAO;AACT;AACA;EACE;IACE,2EAA2E;IAC3E,8EAA8E;IAC9E;EACF;AACF;AACA;EACE;IACE;EACF;AACF;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;EACtC,iCAAiC;EACjC,aAAa;AACf;AACA;EACE;IACE,yCAAyC;IACzC;EACF;AACF;AACA;EACE,yCAAyC;AAC3C;AACA;;;EAGE,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,SAAS;AACX;AACA;EACE,wCAAwC;AAC1C;AACA;EACE;IACE,wBAAwB;IACxB;EACF;AACF;AACA;EACE,QAAQ;EACR,uDAAuD;AACzD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,OAAO;EACP,2EAA2E;EAC3E,8EAA8E;EAC9E,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,qEAAqE;AACvE;AACA;EACE,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,gEAAgE;AAClE;AACA;;;EAGE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,gEAAgE;AAClE;AACA;;;EAGE,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,QAAQ;EACR,0BAA0B;EAC1B,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;EACjC,oDAAoD;EACpD,kDAAkD;EAClD,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB;EAChB,wCAAwC;EACxC,wDAAwD;EACxD,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;;;EAGE,8CAA8C;EAC9C,4BAA4B;AAC9B;AACA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;AACA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,8CAA8C;EAC9C,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,SAAS;EACT,oBAAoB;EACpB;;;GAGC;AACH;AACA;EACE,2GAA2G;AAC7G;AACA;EACE,oBAAoB;EACpB;;;GAGC;AACH;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6DAA6D;;EAE7D,oCAAoC;EACpC,gDAAgD;AAClD;AACA;EACE,+DAA+D;;EAE/D,sCAAsC;EACtC,kDAAkD;AACpD;AACA;EACE,sCAAsC;EACtC,kDAAkD;AACpD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;EACE,2DAA2D;;EAE3D,SAAS;EACT,6BAA6B;AAC/B;AACA;;EAEE,SAAS;AACX;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,cAAc;EACd,UAAU;AACZ;AACA;EACE;;GAEC;EACD,eAAe;AACjB;AACA;EACE;;GAEC;EACD,eAAe;AACjB;AACA;EACE;;GAEC;EACD,eAAe;AACjB;AACA;EACE,uEAAuE;EACvE,eAAe;AACjB;AACA;EACE,uEAAuE;EACvE,eAAe;AACjB;AACA;EACE,wEAAwE;EACxE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gDAAgD;AAClD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mDAAmD;AACrD;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;;;EAGE,gHAAgH;AAClH;AACA;EACE,4EAA4E;EAC5E,2DAA2D;EAC3D,8DAA8D;EAC9D,wDAAwD;AAC1D;AACA;;;;;EAKE,OAAO;EACP,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,4CAA4C;EAC5C,yCAAyC;EACzC,wDAAwD;EACxD,iBAAiB;AACnB;AACA;;;;EAIE,mDAAmD;EACnD,2CAA2C;AAC7C;AACA;EACE,8DAA8D;EAC9D,sDAAsD;AACxD;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,uCAAuC;AACzC;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;;;;;EAKE;;;GAGC;EACD,oBAAoB;AACtB;AACA;;;EAGE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,0CAA0C;AAC5C;AACA;;;;;;;EAOE,2EAA2E;AAC7E;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,OAAO;EACP,sDAAsD;EACtD,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,iCAAiC;AACnC;AACA;EACE,SAAS;AACX;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,qDAAqD;EACrD,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;EACxC,+BAA+B;AACjC;AACA;;;EAGE,6BAA6B;AAC/B;AACA;;EAEE,mDAAmD;EACnD,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;;;EAGE,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;;;;;;EAME,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kDAAkD;EAClD,+EAA+E;EAC/E,oBAAoB;EACpB,yDAAyD;EACzD,uDAAuD;EACvD,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,OAAO;EACP,0BAA0B;EAC1B,wCAAwC;AAC1C;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,2DAA2D;EAC3D,yDAAyD;AAC3D;AACA;EACE,yDAAyD;EACzD,uDAAuD;EACvD,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,+CAA+C;EAC/C,2EAA2E;EAC3E,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,8CAA8C;EAC9C,QAAQ;EACR,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;;;;EAIE,SAAS;EACT,eAAe;AACjB;AACA;;;;;;;EAOE,2CAA2C;AAC7C;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,2DAA2D;EAC3D,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gHAAgH;AAClH;AACA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,6BAA6B;EAC7B,yBAAyB;EACzB,mDAAmD;EACnD,wDAAwD;EACxD,oBAAoB;EACpB,iCAAiC;EACjC,6CAA6C;AAC/C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;AACA;;;EAGE,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;EACtC,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,uDAAuD;AACzD;AACA;EACE,0FAA0F;EAC1F,yGAAyG;EACzG,+BAA+B;EAC/B,6BAA6B;EAC7B,qCAAqC;EACrC,sCAAsC;EACtC,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,2BAA2B;EAC3B,yBAAyB;EACzB,mDAAmD;EACnD,qDAAqD;AACvD;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iEAAiE;EACjE,eAAe;AACjB;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,sDAAsD;EACtD,8CAA8C;AAChD;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,0DAA0D;EAC1D,sDAAsD;AACxD;AACA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,sCAAsC;AACxC;AACA;EACE,gCAAgC;EAChC,4DAA4D;AAC9D;AACA;;;;;;;;;EASE,6BAA6B;EAC7B;;;;;GAKC;AACH;AACA;;;;;;;;;EASE,6BAA6B;EAC7B,iFAAiF;AACnF;AACA;EACE,0DAA0D;AAC5D;AACA;;;;;;;;;EASE,6BAA6B;EAC7B;;;;;GAKC;AACH;AACA;EACE,iCAAiC;EACjC,6DAA6D;AAC/D;AACA;;;;;;;;;EASE,8BAA8B;EAC9B;;;;;GAKC;AACH;AACA;;;;;;;;;EASE,8BAA8B;EAC9B,kFAAkF;AACpF;AACA;EACE,2DAA2D;AAC7D;AACA;;;;;;;;;EASE,8BAA8B;EAC9B;;;;;GAKC;AACH;AACA;EACE,8BAA8B;EAC9B,0DAA0D;AAC5D;AACA;;;;;;;;;EASE,2BAA2B;EAC3B;;;;;GAKC;AACH;AACA;;;;;;;;;EASE,2BAA2B;EAC3B,iFAAiF;AACnF;AACA;EACE,wDAAwD;AAC1D;AACA;;;;;;;;;EASE,2BAA2B;EAC3B;;;;;GAKC;AACH;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;;;;;;;;;EASE,4BAA4B;EAC5B;;;;;GAKC;AACH;AACA;;;;;;;;;EASE,4BAA4B;EAC5B,gFAAgF;AAClF;AACA;EACE,yDAAyD;AAC3D;AACA;;;;;;;;;EASE,4BAA4B;EAC5B;;;;;GAKC;AACH;AACA;EACE,iDAAiD;EACjD,6DAA6D;EAC7D,sCAAsC;EACtC,mEAAmE;EACnE,iEAAiE;EACjE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gEAAgE;AAClE;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+BE,kDAAkD;AACpD;AACA;;;;;;;;;;;;;;;EAeE,yCAAyC;AAC3C;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;EAC5C,UAAU;AACZ;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;EAC5C,UAAU;AACZ;AACA;;;;;;;EAOE,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,yCAAyC;EACzC,2CAA2C;EAC3C,4CAA4C;EAC5C,UAAU;AACZ;AACA;;;;;;;EAOE,uBAAuB;EACvB,wCAAwC;EACxC,yCAAyC;EACzC,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,uCAAuC;EACvC,2CAA2C;EAC3C,4CAA4C;EAC5C,UAAU;AACZ;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,uCAAuC;EACvC,2CAA2C;EAC3C,4CAA4C;EAC5C,UAAU;AACZ;AACA;;;;;;;EAOE,0CAA0C;EAC1C,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,uCAAuC;EACvC,2CAA2C;EAC3C,4CAA4C;EAC5C,UAAU;AACZ;AACA;;;;;;;EAOE,uBAAuB;EACvB,wCAAwC;EACxC,sBAAsB;EACtB,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;EAC1C,6CAA6C;EAC7C,UAAU;AACZ;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;AAC5C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;EAC1C,6CAA6C;EAC7C,UAAU;AACZ;AACA;;;;;;;EAOE,yCAAyC;AAC3C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;EAC1C,qBAAqB;AACvB;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;EAC1C,6CAA6C;EAC7C,UAAU;AACZ;AACA;;;;;;;EAOE,sBAAsB;EACtB,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;EACxC,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;EACxC,0CAA0C;EAC1C,6CAA6C;EAC7C,UAAU;AACZ;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;EACxC,0CAA0C;AAC5C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;EACxC,0CAA0C;EAC1C,6CAA6C;EAC7C,UAAU;AACZ;AACA;;;;;;;EAOE,yCAAyC;AAC3C;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;EACxC,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;;;EAGE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;EACxC,0CAA0C;EAC1C,6CAA6C;EAC7C,UAAU;AACZ;AACA;;;;;;;EAOE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,uGAAuG;AACzG;AACA;;;EAGE,0CAA0C;AAC5C;AACA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;EACrD,mDAAmD;AACrD;AACA;;;EAGE,0CAA0C;AAC5C;AACA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;EACrD,mDAAmD;AACrD;AACA;;;EAGE,wCAAwC;AAC1C;AACA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;EACrD,mDAAmD;AACrD;AACA;;;EAGE,wCAAwC;AAC1C;AACA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;EACrD,mDAAmD;AACrD;AACA;;;EAGE,yCAAyC;AAC3C;AACA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;EACrD,mDAAmD;AACrD;AACA;;;EAGE,yCAAyC;AAC3C;AACA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;EACrD,mDAAmD;AACrD;AACA;;;EAGE,uCAAuC;AACzC;AACA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,qDAAqD;EACrD,mDAAmD;AACrD;AACA;;;EAGE,uCAAuC;AACzC;AACA;EACE,sDAAsD;EACtD,oCAAoC;EACpC,4CAA4C;AAC9C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6DAA6D;;EAE7D,oCAAoC;AACtC;AACA;;;EAGE,gGAAgG;AAClG;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kCAAkC;AACpC;AACA;;;;;;;;;EASE,sDAAsD;AACxD;AACA;EACE,4CAA4C;AAC9C;AACA;;;EAGE,mEAAmE;EACnE,iEAAiE;EACjE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,wFAAwF;AAC1F;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;EACzC,sDAAsD;EACtD,8EAA8E;AAChF;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wDAAwD;EACxD,sCAAsC;AACxC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+DAA+D;;EAE/D,sCAAsC;AACxC;AACA;;;EAGE,gGAAgG;AAClG;AACA;;;;;;;;;EASE,wDAAwD;AAC1D;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,+EAA+E;EAC/E,2CAA2C;EAC3C,0FAA0F;AAC5F;AACA;EACE,yCAAyC;AAC3C;AACA;;;;;;;;;;;EAWE,iBAAiB;AACnB;AACA;;;;;EAKE,yCAAyC;AAC3C;AACA;;;;;EAKE,uCAAuC;AACzC;AACA;;;EAGE,sBAAsB;EACtB,0FAA0F;AAC5F;AACA;;;EAGE,wCAAwC;AAC1C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2CAA2C;EAC3C,oEAAoE;EACpE,wCAAwC;AAC1C;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,wFAAwF;EACxF,yCAAyC;EACzC,+CAA+C;AACjD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,gIAAgI;AAClI;AACA;EACE,WAAW;AACb;AACA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,YAAY;EACZ,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,8BAA8B;EAC9B,uEAAuE;EACvE,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,KAAK;EACL,OAAO;EACP,QAAQ;EACR,MAAM;EACN,+JAA+J;AACjK;AACA;EACE,uDAAuD;;EAEvD;;;;GAIC;EACD,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;EAC5B,kFAAkF;EAClF,gDAAgD;EAChD,qFAAqF;AACvF;AACA;EACE,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,YAAY;AACd;AACA;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,6BAA6B;EAC7B,uEAAuE;EACvE,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,QAAM;EACN,SAAS;EACT,6BAA6B;EAC7B,UAAU;EACV,uEAAuE;EACvE,2CAA2C;EAC3C;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0EC;EACD,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,yEAAyE;EACzE,cAAc;EACd,8EAA8E;EAC9E,2CAA2C;EAC3C,uFAAuF;AACzF;AACA;EACE,eAAe;EACf,cAAc;EACd,yEAAyE;EACzE,cAAc;EACd,8EAA8E;EAC9E,2CAA2C;EAC3C,uFAAuF;AACzF;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,8EAA8E;EAC9E,2CAA2C;EAC3C,uFAAuF;EACvF,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,4EAA4E;EAC5E,2CAA2C;AAC7C;AACA;EACE,4EAA4E;EAC5E,2CAA2C;AAC7C;AACA;EACE,4EAA4E;EAC5E,2CAA2C;AAC7C;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;EACR,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,iCAAiC;AACnC;AACA;EACE,YAAY;AACd;AACA;EACE,QAAM;AACR;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,4BAA4B;EAC5B,2CAA2C;EAC3C,gFAAgF;AAClF;AACA;EACE,aAAa;EACb,+BAA+B;AACjC;AACA;EACE,QAAQ;AACV;AACA;EACE,wEAAwE;;EAExE,UAAU;EACV,yEAAyE;EACzE,8FAA8F;EAC9F,QAAQ;AACV;AACA;EACE,yEAAyE;EACzE,gFAAgF;AAClF;AACA;EACE,8DAA8D;AAChE;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,6EAA6E;EAC7E,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,2BAA2B;EAC3B,6EAA6E;EAC7E,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mGAAmG;AACrG;AACA;EACE,qGAAqG;AACvG;AACA;EACE,SAAS;EACT,wCAAwC;AAC1C;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,sCAAsC;EACtC,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gDAAgD;EAChD,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,kDAAkD;EAClD,kCAAkC;AACpC;AACA;EACE,SAAS;AACX;AACA;EACE,mDAAmD;AACrD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,iDAAiD;EACjD,qCAAqC;AACvC;AACA;EACE,iDAAiD;EACjD,mDAAmD;EACnD,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,OAAO;EACP,6CAA6C;AAC/C;AACA;;EAEE,UAAU;EACV,iBAAiB;EACjB,iDAAiD;EACjD,KAAK;EACL,SAAS;EACT,WAAW;EACX,4DAA4D;EAC5D,wDAAwD;EACxD,UAAU;AACZ;AACA;EACE,MAAM;EACN,wDAAwD;AAC1D;AACA;EACE,SAAS;EACT,OAAO;EACP,6CAA6C;AAC/C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,iDAAiD;EACjD,KAAK;EACL,SAAS;EACT,WAAW;EACX,4DAA4D;EAC5D,wDAAwD;EACxD,UAAU;AACZ;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,uEAAuE;EACvE,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,MAAM;EACN,UAAU;EACV,aAAa;EACb,wCAAwC;EACxC,8EAA8E;EAC9E,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,gDAAgD;EAChD,sCAAsC;EACtC,wEAAwE;AAC1E;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP,SAAS;EACT,UAAU;EACV,SAAS;EACT,+EAA+E;EAC/E,iFAAiF;EACjF,SAAS;AACX;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP,SAAS;EACT,UAAU;EACV,SAAS;EACT,iFAAiF;EACjF,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,UAAU;;EAEV,aAAa;EACb,QAAQ;;EAER,aAAa;EACb,oBAAoB;;EAEpB,aAAa;EACb,gFAAgF;AAClF;AACA;EACE,aAAa;EACb,UAAU;;EAEV,aAAa;EACb,QAAQ;;EAER,aAAa;EACb,oBAAoB;;EAEpB,aAAa;EACb,gFAAgF;EAChF,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,QAAQ;EACR,uEAAuE;EACvE,iDAAiD;AACnD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,QAAQ;EACR,MAAM;EACN,OAAO;EACP,QAAQ;EACR,sBAAsB;AACxB;AACA;;EAEE,eAAe;EACf,2DAA2D;EAC3D,oDAAoD;AACtD;AACA;EACE,uDAAuD;EACvD,oDAAoD;AACtD;AACA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;AACA;EACE,uEAAuE;EACvE,qDAAqD;AACvD;AACA;EACE,wDAAwD;EACxD,qDAAqD;AACvD;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,0DAA0D;EAC1D,8CAA8C;AAChD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;EACZ,6FAA6F;EAC7F,uEAAuE;EACvE,kBAAkB;EAClB,kDAAkD;EAClD,0BAA0B;AAC5B;AACA;EACE,8EAA8E;EAC9E,uBAAuB;AACzB;AACA;EACE,kDAAkD;EAClD,8EAA8E;EAC9E,6FAA6F;EAC7F,uDAAuD;EACvD,+EAA+E;EAC/E,uDAAuD;EACvD,sCAAsC;AACxC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,QAAW;EACX,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,4DAA4D;EAC5D,uDAAuD;AACzD;AACA;EACE,iBAAiB;EACjB,2JAA2J;EAC3J,WAAW;EACX,4DAA4D;EAC5D,UAAU;EACV,2GAA2G;EAC3G,oJAAoJ;EACpJ,kBAAkB;EAClB,uDAAuD;EACvD,wDAAwD;AAC1D;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,YAAY;AACd;AACA;EACE,4DAA4D;AAC9D;AACA;;EAEE,YAAY;AACd;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,kDAAkD;EAClD,wFAAwF;EACxF,6FAA6F;EAC7F,uDAAuD;EACvD,iFAAiF;EACjF,sCAAsC;AACxC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,kDAAkD;EAClD,uDAAuD;AACzD;AACA;EACE,kDAAkD;EAClD,uDAAuD;EACvD,eAAe;EACf,eAAe;EACf,2EAA2E;EAC3E,8EAA8E;AAChF;AACA;EACE,kDAAkD;EAClD,+BAA+B;EAC/B,iEAAiE;EACjE,WAAW;EACX,8CAA8C;EAC9C,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mGAAmG;EACnG,uDAAuD;EACvD,2EAA2E;AAC7E;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kDAAkD;EAClD,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,kFAAkF;AACpF;AACA;EACE,UAAU;EACV,WAAW;EACX,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,QAAQ;EACR,2EAA2E;EAC3E,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,QAAQ;EACR,8EAA8E;EAC9E,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;;EAEE,QAAQ;EACR,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,uEAAuE;EACvE,wEAAwE;EACxE,4CAA4C;EAC5C,0CAA0C;EAC1C,yCAAyC;;EAEzC,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,KAAK;EACL,OAAO;EACP,QAAQ;EACR,MAAM;EACN;;;;GAIC;EACD,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,MAAM;EACN,OAAO;EACP,KAAK;EACL,UAAU;EACV,6DAA6D;EAC7D;;;;GAIC;AACH;AACA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,UAAU;EACV;;;GAGC;AACH;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,UAAU;EACV;;;GAGC;AACH;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,UAAU;EACV;;;GAGC;AACH;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,QAAQ;AACV;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,8CAA8C;AAChD;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,0DAA0D;AAC5D;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;AACZ;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,kHAAkH;AACpH;AACA;EACE,kDAAkD;AACpD;AACA;EACE,kHAAkH;AACpH;AACA;EACE,iFAAiF;AACnF;AACA;EACE,2DAA2D;EAC3D,4DAA4D;EAC5D,oDAAoD;EACpD,wDAAwD;AAC1D;AACA;EACE,sCAAsC;AACxC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;EACzC,4CAA4C;AAC9C;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;EACzC,4CAA4C;EAC5C,sCAAsC;EACtC,uCAAuC;AACzC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;AACA;;EAEE,4EAA4E;AAC9E;AACA;EACE,uDAAuD;AACzD;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;EACzC,4CAA4C;EAC5C,sEAAsE;EACtE,kEAAkE;EAClE,gEAAgE;EAChE,eAAe;EACf,mDAAmD;EACnD,cAAc;AAChB;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,0CAA0C;AAC5C;AACA;EACE,sDAAsD;AACxD;AACA;EACE,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,sDAAsD;EACtD,qDAAqD;EACrD,2CAA2C;AAC7C;AACA;EACE,sDAAsD;AACxD;AACA;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,uCAAuC;EACvC,kFAAkF;EAClF,qDAAqD;AACvD;AACA;EACE,gDAAgD;EAChD,yDAAyD;AAC3D;AACA;EACE,YAAY;EACZ,qDAAqD;EACrD,wDAAwD;EACxD,mGAAmG;EACnG,sCAAsC;EACtC,iBAAiB;EACjB,oEAAoE;EACpE,kEAAkE;EAClE,4DAA4D;AAC9D;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,UAAU;EACV,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;;;EAGE,YAAY;EACZ,aAAa;AACf;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,QAAW;EACX,WAAW;EACX,kDAAkD;AACpD;AACA;EACE,WAAW;AACb;AACA;EACE,OAAO;EACP,eAAe;EACf,kDAAkD;AACpD;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mEAAmE;EACnE,wFAAwF;EACxF,qEAAqE;AACvE;AACA;EACE,4DAA4D;AAC9D;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,SAAS;EACT;;;cAGY;EACZ,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,MAAM;EACN,iBAAiB;EACjB,OAAO;EACP,KAAK;EACL,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,UAAU;EACV,oEAAoE;EACpE,aAAa;EACb;;;GAGC;EACD,iBAAiB;EACjB,+EAA+E;EAC/E,mEAAmE;EACnE,MAAM;EACN,OAAO;EACP,SAAS;AACX;AACA;EACE;;;cAGY;EACZ,yFAAyF;EACzF,oBAAoB;EACpB,cAAc;EACd,gEAAgE;AAClE;AACA;EACE,UAAU;EACV,qEAAqE;EACrE,aAAa;EACb,uCAAuC;EACvC,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,OAAO;EACP,oEAAoE;AACtE;AACA;EACE,SAAS;EACT,iGAAiG;AACnG;AACA;;EAEE,wFAAwF;AAC1F;AACA;EACE,iDAAiD;AACnD;AACA;EACE;IACE,sDAAsD;EACxD;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,sDAAsD;EACxD;AACF;AACA;EACE;IACE,wDAAwD;EAC1D;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,wDAAwD;EAC1D;AACF;AACA;EACE;IACE,wDAAwD;EAC1D;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,wDAAwD;EAC1D;AACF;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,uEAAuE;AACzE;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,0DAA0D;EAC1D,wDAAwD;EACxD,QAAQ;EACR,UAAU;EACV,WAAW;EACX,MAAM;EACN,iBAAiB;EACjB,OAAO;EACP,KAAK;EACL,qEAAqE;EACrE,4BAA4B;AAC9B;AACA;EACE,wDAAwD;EACxD,WAAW;AACb;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,qDAAqD;AACvD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,qEAAqE;AACvE;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,0DAA0D;EAC1D,sDAAsD;EACtD,QAAQ;EACR,UAAU;EACV,WAAW;EACX,MAAM;EACN,iBAAiB;EACjB,OAAO;EACP,KAAK;EACL,qEAAqE;EACrE,0BAA0B;AAC5B;AACA;EACE,sDAAsD;EACtD,WAAW;AACb;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,qDAAqD;AACvD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,0DAA0D;EAC1D,wDAAwD;EACxD,QAAQ;EACR,UAAU;EACV,WAAW;EACX,MAAM;EACN,iBAAiB;EACjB,OAAO;EACP,KAAK;EACL,qEAAqE;EACrE,4BAA4B;AAC9B;AACA;EACE,oDAAoD;EACpD,WAAW;AACb;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,8CAA8C;EAC9C,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,KAAK;EACL,OAAO;EACP,MAAM;AACR;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,qDAAqD;EACvD;;EAEA;IACE;;;KAGC;EACH;AACF;AACA;EACE;IACE,iCAAiC;IACjC,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA;EACE,kDAAkD;AACpD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,+DAA+D;EAC/D,SAAS;AACX;AACA;;EAEE,SAAS;EACT,wFAAgF;UAAhF,gFAAgF;AAClF;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,8CAA8C;EAC9C,iCAAiC;EACjC,sCAAsC;EACtC,eAAe;EACf,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;;EAEE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,UAAU;EACV,WAAW;EACX,yCAAyC;EACzC,sDAAsD;AACxD;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;AACA;EACE,eAAe;EACf,wCAAwC;EACxC,oCAAoC;EACpC,mEAAmE;EACnE,2CAA2C;AAC7C;AACA;EACE,cAAc;EACd,iCAAiC;EACjC,4EAA4E;EAC5E,6EAA6E;EAC7E,eAAe;AACjB;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,KAAK;AACP;AACA;EACE,aAAa;EACb,6EAA6E;EAC7E,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,0CAA0C;EAC1C,+DAA+D;AACjE;AACA;EACE,UAAU;EACV,qCAAqC;AACvC;AACA;EACE,iCAAiC;AACnC;AACA;;;EAGE,cAAc;EACd,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,MAAM;EACN,gFAAgF;EAChF,qEAAqE;EACrE,UAAU;EACV,wDAAwD;EACxD,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,SAAS;EACT,SAAS;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmCE,kDAAkD;AACpD;AACA;;;;;;;;;;;EAWE,2DAA2D;AAC7D;AACA;;;;;;;;;;;EAWE,6DAA6D;AAC/D;AACA;;;;;;;;;;;EAWE,+DAA+D;AACjE;AACA;;;;;;;EAOE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;;;;;;;;;;;EAWE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;;;;;;EAOE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;;EAGE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;;;;;;;;;EASE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;AACrC;AACA;EACE,KAAK;EACL,MAAM;EACN,sBAAsB;AACxB;AACA;EACE,KAAK;EACL,WAAW;AACb;AACA;EACE,KAAK;EACL,OAAO;AACT;AACA;EACE,UAAU;EACV,MAAM;AACR;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,OAAO;AACT;AACA;EACE,QAAQ;EACR,MAAM;AACR;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,QAAQ;EACR,OAAO;AACT;AACA;;EAEE,sBAAsB;AACxB;AACA;;;EAGE,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,wGAAwG;EACxG,uCAAuC;AACzC;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,wCAAwC;EACxC,uEAAuE;EACvE,2CAA2C;EAC3C,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,uEAAuE;EACvE,2CAA2C;AAC7C;AACA;EACE,gDAAgD;EAChD,2EAA2E;AAC7E;AACA;EACE,+CAA+C;AACjD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;EACxC,uEAAuE;EACvE,2CAA2C;EAC3C,+BAA+B;AACjC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,8FAAqF;;EAErF,oBAAoB;EACpB,UAAU;EACV,KAAK;EACL,MAAM;EACN,WAAW;AACb;AACA;EACE,KAAK;EACL,sCAAsC;EACtC,kDAAkD;AACpD;AACA;EACE,kDAAkD;EAClD,iCAAiC;EACjC,iCAAiC;EACjC,mDAAmD;EACnD,kBAAkB;AACpB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;;EAE1B,8EAA8E;EAC9E,+EAA+E;EAC/E,8DAA8D;EAC9D,oEAAoE;EACpE,qEAAqE;AACvE;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,aAAa;EACb,iDAAiD;EACjD,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,iFAAiF;EACjF,+BAA+B;AACjC;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,eAAe;AACjB;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,4CAA4C;AAC9C;AACA;;;EAGE,qCAAqC;AACvC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,oDAAoD;EACpD,gDAAgD;EAChD,QAAQ;EACR,2CAA2C;EAC3C,SAAS;EACT,eAAe;EACf,0DAA0D;AAC5D;AACA;;EAEE,sDAAsD;AACxD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8CAA8C;EAC9C,UAAU;EACV,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,mCAAmC;AACrC;AACA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,uDAAuD;EACvD,mDAAmD;AACrD;AACA;;EAEE,uDAAuD;EACvD,mDAAmD;AACrD;AACA;EACE,sEAAsE;AACxE;AACA;;EAEE,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,4CAA4C;EAC5C,0CAA0C;EAC1C,8CAA8C;AAChD;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oDAAoD;AACtD;AACA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,kCAAkC;EACpC;AACF;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,4CAA4C;EAC5C,iBAAiB;EACjB,QAAQ;AACV;AACA;;EAEE,kDAAkD;AACpD;AACA;;;EAGE,yCAAyC;AAC3C;AACA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,6CAA6C;EAC7C,0CAA0C;EAC1C,gDAAgD;EAChD,gCAAgC;EAChC,iCAAiC;EACjC,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,SAAS;EACT,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,uEAAuE;EACvE,2CAA2C;EAC3C,WAAW;EACX,wDAAwD;AAC1D;AACA;;;EAGE,SAAS;EACT,gDAAgD;AAClD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,+BAA+B;EAC/B,8CAA8C;EAC9C,uDAAuD;EACvD,yBAAyB;EACzB,qDAAqD;EACrD,uBAAuB;EACvB,iBAAiB;;EAEjB,2DAA2D;AAC7D;AACA;EACE,aAAa;EACb,kDAAkD;EAClD,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,qDAAqD;EACrD,yBAAyB;EACzB,mDAAmD;EACnD,sCAAsC;AACxC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,wDAAwD;EACxD,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,uDAAuD;EACvD,WAAW;AACb;AACA;EACE,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,aAAa;EACb,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;;;EAGE,wDAAwD;AAC1D;AACA;EACE,oDAAoD;AACtD;AACA;EACE,+EAA+E;AACjF;AACA;EACE,4CAA4C;AAC9C;AACA;;;;;EAKE,wDAAwD;AAC1D;AACA;EACE,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,wDAAwD;EACxD,mDAAmD;AACrD;AACA;EACE,4CAA4C;EAC5C,4CAA4C;AAC9C;AACA;EACE,+EAA+E;AACjF;AACA;;EAEE,gDAAgD;AAClD;AACA;EACE,4CAA4C;AAC9C;AACA;;;EAGE,iCAAiC;EACjC,wDAAwD;EACxD,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gDAAgD;EAChD,oDAAoD;EACpD,mEAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;AACA;;;EAGE,UAAU;EACV,iBAAiB;EACjB,4DAA4D;EAC5D,4BAA4B;EAC5B,wDAAwD;AAC1D;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;;EAGE,YAAY;AACd;AACA;;;;;;;EAOE,uDAAuD;AACzD;AACA;EACE,QAAM;EACN,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,iFAAiF;AACnF;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,yCAAyC;EACzC,gCAAgC;EAChC,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;;;;;;;EAOE,WAAW;EACX,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;EACpC,wDAAwD;AAC1D;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,qCAAqC;AACvC;AACA;EACE,UAAU;AACZ;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,wDAAwD;AAC1D;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wDAAwD;AAC1D;AACA;;;EAGE,kCAAkC;AACpC;AACA;EACE,wDAAwD;AAC1D;AACA;;;EAGE,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uEAAuE;EACvE,uDAAuD;AACzD;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,SAAS;EACT,uEAAuE;EACvE,uDAAuD;AACzD;AACA;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,uEAAuE;EACvE,4CAA4C;EAC5C,SAAS;AACX;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,6CAA6C;EAC7C,uEAAuE;AACzE;AACA;EACE,uEAAuE;EACvE,uDAAuD;AACzD;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,iDAAiD;EACjD,iBAAiB;EACjB,oDAAoD;EACpD,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;;;EAGE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,2CAA2C;EAC3C,yDAAyD;EACzD,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAgB;UAAhB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,kDAAkD;EAClD,iEAAiE;EACjE,uEAAuE;EACvE,2CAA2C;EAC3C,iBAAiB;EACjB,uDAAuD;AACzD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;;;EAGE,4DAA4D;AAC9D;AACA;EACE,6DAA6D;AAC/D;AACA;;;EAGE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;;;EAGE,4DAA4D;AAC9D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,qCAAqC;EACrC,sCAAsC;EACtC,QAAQ;EACR,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,SAAS;AACX;AACA;EACE,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,6DAA6D;AAC/D;AACA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;;;EAGE,6DAA6D;AAC/D;AACA;EACE,uEAAuE;EACvE,2CAA2C;AAC7C;AACA;EACE,uEAAuE;AACzE;AACA;EACE,QAAQ;EACR,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,6DAA6D;EAC7D,sCAAsC;EACtC,uDAAuD;EACvD,qDAAqD;EACrD,iFAAiF;EACjF,wDAAwD;AAC1D;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,iFAAiF;AACnF;AACA;EACE,gEAAgE;AAClE;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mDAAmD;EACnD,qDAAqD;EACrD,mFAAmF;EACnF,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,gEAAgE;EAChE,UAAU;AACZ;AACA;EACE,gEAAgE;EAChE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,kDAAkD;EAClD,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;EACzB,mDAAmD;EACnD,qDAAqD;AACvD;AACA;EACE,kEAAkE;AACpE;AACA;EACE,mFAAmF;EACnF,mFAAmF;;EAEnF,eAAe;EACf;;;GAGC;EACD,mFAAmF;EACnF,+BAA+B;EAC/B,8FAA8F;AAChG;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mDAAmD;EACnD,qDAAqD;AACvD;AACA;EACE,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mDAAmD;EACnD,qDAAqD;AACvD;AACA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,wBAAgB;UAAhB,gBAAgB;AAClB;AACA;EACE,+CAA+C;EAC/C,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;;;;;;;;;;EAWE,4EAA4E;AAC9E;AACA;;EAEE,QAAQ;EACR,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,oBAAoB;AACtB;AACA;AACA;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,4EAA4E;EAC5E,0BAA0B;AAC5B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,qEAAqE;AACvE;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,8DAA8D;AAChE;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qCAAqC;AACvC;AACA;;EAEE,uDAAuD;AACzD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,gDAAgD;AAClD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,yCAAyC;AAC3C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qCAAqC;AACvC;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,8CAA8C;EAC9C,wBAAwB;EACxB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,uCAAuC;AACzC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;EACxC,uCAAuC;AACzC;AACA;;;;;;;;;;;;;;;;;;;;EAoBE,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;;;;EAIE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;;;;EAIE,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE;IACE,gBAAgB;IAChB;EACF;AACF;AACA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE;IACE;EACF;AACF;AACA;EACE,QAAM;EACN,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE;IACE;EACF;AACF;AACA;EACE;IACE;EACF;AACF;AACA;EACE,QAAM;EACN,eAAe;EACf,eAAe;AACjB;AACA;EACE;IACE;EACF;AACF;AACA;EACE;IACE;EACF;AACF;AACA;EACE;IACE;EACF;AACF;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,8DAA8D;AAChE;AACA;EACE;IACE,6BAA6B;IAC7B,0CAA0C;IAC1C;EACF;AACF;AACA;EACE;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB;EACF;AACF;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,+DAA+D;AACjE;AACA;;EAEE,+DAA+D;AACjE;AACA;EACE,+CAA+C;AACjD;AACA;EACE,qEAAqE;AACvE;AACA;;EAEE,qEAAqE;AACvE;AACA;EACE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,+DAA+D;AACjE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+DAA+D;;EAE/D,sCAAsC;AACxC;AACA;EACE,mEAAmE;AACrE;AACA;;EAEE,mEAAmE;AACrE;AACA;EACE,gDAAgD;AAClD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wDAAwD;AAC1D;AACA;;EAEE,wDAAwD;EACxD;;;;;;;;;;;;;;GAcC;EACD,2BAA2B;EAC3B,qJAAqJ;AACvJ;AACA;EACE,iDAAiD;AACnD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,qFAAqF;EACrF,mBAAmB;AACrB;AACA;;EAEE,4BAA4B;EAC5B;;;;;GAKC;AACH;AACA;EACE,mEAAmE;AACrE;AACA;EACE,iEAAiE;AACnE;AACA;EACE,8CAA8C;AAChD;AACA;;EAEE;;;;;GAKC;AACH;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,uCAAuC;AACzC;AACA;;EAEE;;;;;;;;;;;;;;GAcC;AACH;AACA;EACE,uCAAuC;AACzC;AACA;EACE,2DAA2D;AAC7D;AACA;;EAEE,2DAA2D;AAC7D;AACA;EACE,QAAQ;AACV;AACA;;EAEE,2DAA2D;AAC7D;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iEAAiE;AACnE;AACA;;EAEE,iEAAiE;AACnE;AACA;EACE,qCAAqC;AACvC;AACA;EACE,0DAA0D;AAC5D;AACA;;;;;EAKE,0DAA0D;AAC5D;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,4DAA4D;AAC9D;AACA;;;;;EAKE,4DAA4D;AAC9D;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4DAA4D;AAC9D;AACA;;;;;EAKE,4DAA4D;AAC9D;AACA;EACE,4CAA4C;AAC9C;AACA;;;;;EAKE,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,QAAM;EACN,4BAA4B;EAC5B,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,UAAU;EACV,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,4CAA4C;AAC9C;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,uGAAuG;EACvG,oBAAoB;EACpB,SAAS;EACT,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;AACA;;EAEE,aAAa;EACb,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,YAAY;AACd;AACA;EACE;IACE;EACF;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,+BAA+B;;EAE/B,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE;IACE;EACF;AACF;AACA;EACE,gDAAgD;EAChD,uDAAuD;AACzD;AACA;;EAEE,uDAAuD;AACzD;AACA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,wDAAwD;AAC1D;AACA;EACE;IACE;EACF;AACF;AACA;;EAEE,aAAa;EACb,0CAA0C;EAC1C,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE;;IAEE;EACF;AACF;AACA;EACE;IACE;EACF;AACF;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE;IACE,gBAAgB;IAChB;EACF;AACF;AACA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,wCAAwC;EACxC,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,0CAA0C;AAC5C;AACA;EACE;IACE;EACF;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,2CAA2C;EAC3C,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,qBAAqB;;EAErB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;AACA;;;EAGE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;AACA;;;;;;EAME,UAAU;EACV,iBAAiB;EACjB,8CAA8C;EAC9C,gDAAgD;EAChD,yBAAyB;EACzB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;;;;;;;;;;;EAWE,6CAA6C;AAC/C;AACA;;;;;;;;;;;EAWE,wDAAwD;AAC1D;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;;;;;;;;;;;EAWE,cAAc;EACd,eAAe;AACjB;AACA;;;;;EAKE,4BAA4B;EAC5B,6BAA6B;EAC7B,+CAA+C;AACjD;AACA;;;;;EAKE,4BAA4B;EAC5B,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,kEAAkE;EACpE;;EAEA;IACE,sCAAsC;IACtC,6DAA6D;EAC/D;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,kEAAkE;IAClE,8BAA8B;EAChC;;EAEA;IACE,6DAA6D;IAC7D,qCAAqC;EACvC;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;;;;;;;;;;;EAWE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;;;;;EAKE,2BAA2B;EAC3B,4BAA4B;EAC5B,0CAA0C;AAC5C;AACA;;;;;EAKE,2BAA2B;EAC3B,0BAA0B;EAC1B,yCAAyC;AAC3C;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,+DAA+D;EACjE;;EAEA;IACE,qCAAqC;IACrC,0DAA0D;EAC5D;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,+DAA+D;EACjE;;EAEA;IACE,oCAAoC;IACpC,0DAA0D;EAC5D;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;;;;;;;;;;;EAWE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;;;;;EAKE,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;AACvC;AACA;;;;;EAKE,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,+DAA+D;EACjE;;EAEA;IACE,sCAAsC;IACtC,0DAA0D;EAC5D;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,+DAA+D;EACjE;;EAEA;IACE,qCAAqC;IACrC,0DAA0D;EAC5D;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;;;;;;;;;;;EAWE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;;;;;EAKE,sCAAsC;EACtC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;;;;;EAKE,qCAAqC;EACrC,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,+DAA+D;EACjE;;EAEA;IACE,oCAAoC;IACpC,0DAA0D;EAC5D;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,+DAA+D;EACjE;;EAEA;IACE,mCAAmC;IACnC,0DAA0D;EAC5D;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,4DAA4D;AAC9D;AACA;;;;;;;;;;;EAWE,2DAA2D;EAC3D,4DAA4D;AAC9D;AACA;;;;;EAKE,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;;;;;EAKE,qCAAqC;EACrC,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,+DAA+D;EACjE;;EAEA;IACE,qCAAqC;IACrC,0DAA0D;EAC5D;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,+DAA+D;EACjE;;EAEA;IACE,oCAAoC;IACpC,0DAA0D;EAC5D;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;AACA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,2CAA2C;EAC3C,mFAAmF;EACnF,iFAAiF;EACjF,qCAAqC;EACrC,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iFAAiF;EACjF,wCAAwC;AAC1C;AACA;;EAEE,kDAAkD;AACpD;AACA;;EAEE,uCAAuC;AACzC;AACA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,yCAAyC;EACzC,0CAA0C;EAC1C,aAAa;EACb,gDAAgD;EAChD,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,yCAAyC;EACzC,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;;EAEE,YAAY;EACZ,kDAAkD;EAClD,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,mGAAmG;AACrG;AACA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,kDAAkD;EAClD,eAAe;EACf,uEAAuE;AACzE;AACA;;EAEE,kDAAkD;AACpD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,iBAAiB;EACjB,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,mEAAmE;EACnE,kEAAkE;;EAElE,aAAa;EACb,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,2FAA2F;EAC3F,4BAA4B;EAC5B;;;GAGC;AACH;AACA;EACE,0GAA0G;EAC1G,iBAAiB;EACjB,iEAAiE;EACjE,qFAAqF;EACrF,6DAA6D;EAC7D,yFAAyF;EACzF,wGAAwG;EACxG,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE;;;GAGC;AACH;AACA;EACE,0FAA0F;EAC1F,2FAA2F;AAC7F;AACA;EACE,uDAAuD;AACzD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0FAA0F;EAC1F;;;GAGC;AACH;AACA;EACE,SAAS;AACX;AACA;EACE,2FAA2F;EAC3F,0FAA0F;AAC5F;AACA;EACE,eAAe;AACjB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,4FAA4F;EAC5F,qGAAqG;EACrG,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;;;EAGE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,4FAA4F;EAC5F,qGAAqG;AACvG;AACA;EACE,mBAAmB;EACnB,0EAA0E;EAC1E,eAAe;EACf,+CAA+C;AACjD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB;;;GAGC;EACD,yGAAyG;EACzG;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,0DAA0D;EAC1D,gFAAgF;EAChF,gEAAgE;EAChE,8DAA8D;EAC9D,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,yDAAyD;AAC3D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,qBAAqB;EACrB,gEAAgE;EAChE,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,iEAAiE;EACjE,8GAA8G;EAC9G,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;EACzB,4DAA4D;EAC5D,8DAA8D;EAC9D,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,4FAA4F;EAC5F,qGAAqG;EACrG,eAAe;EACf,sCAAsC;EACtC,sEAAsE;EACtE,gDAAgD;EAChD,2BAA2B;EAC3B,QAAQ;EACR,mEAAmE;EACnE,iEAAiE;EACjE,gEAAgE;EAChE,eAAe;AACjB;AACA;;;EAGE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gEAAgE;EAChE,gFAAgF;AAClF;AACA;EACE,mBAAmB;EACnB,4FAA4F;EAC5F,qGAAqG;AACvG;AACA;EACE,mBAAmB;EACnB,sEAAsE;EACtE,eAAe;EACf,sCAAsC;EACtC,gDAAgD;EAChD,kDAAkD;EAClD,iCAAiC;EACjC,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,iEAAiE;EACjE,gFAAgF;EAChF,uDAAuD;EACvD,6EAA6E;EAC7E,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,gFAAgF;EAChF,2CAA2C;AAC7C;AACA;EACE,6BAA6B;EAC7B,2FAA2F;EAC3F,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0FAA0F;EAC1F,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,QAAW;EACX,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,0DAA0D;EAC1D,sCAAsC;EACtC,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,QAAM;EACN,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,2DAA2D;EAC3D,2CAA2C;AAC7C;AACA;EACE,2DAA2D;EAC3D,kBAAkB;AACpB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wDAAwD;EACxD,oDAAoD;AACtD;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE;;;GAGC;EACD,yFAAyF;AAC3F;AACA;;;;EAIE,wFAAwF;AAC1F;AACA;EACE;;;GAGC;AACH;AACA;EACE,YAAY;AACd;AACA;EACE;;;GAGC;AACH;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0CAA0C;EAC1C,+DAA+D;AACjE;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,gCAAgC;EAChC,wDAAwD;EACxD,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qEAAqE;EACrE,4BAA4B;AAC9B;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,mCAAmC;AACrC;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,gCAAgC;EAChC,sDAAsD;EACtD,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qEAAqE;EACrE,0BAA0B;AAC5B;AACA;EACE,sDAAsD;AACxD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,gCAAgC;EAChC,wDAAwD;EACxD,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qEAAqE;EACrE,4BAA4B;AAC9B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,UAAU;EACV,aAAa;EACb,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,mFAAmF;EACnF,4DAA4D;EAC5D,mBAAmB;EACnB,sCAAsC;EACtC,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,iFAAiF;AACnF;AACA;;;;EAIE,oBAAoB;AACtB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,kFAAkF;AACpF;AACA;;;EAGE,eAAe;EACf,oDAAoD;AACtD;AACA;;;EAGE,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,uDAAuD;EACvD,qDAAqD;EACrD,4CAA4C;EAC5C,oBAAoB;AACtB;AACA;;EAEE,qGAAqG;EACrG,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,kDAAkD;EAClD,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,4CAA4C;EAC5C,qDAAqD;AACvD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;AACA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,mFAAmF;EACnF,iFAAiF;EACjF,+EAA+E;EAC/E,qFAAqF;EACrF,mEAAmE;EACnE,2CAA2C;EAC3C,iBAAiB;EACjB,2FAA2F;AAC7F;AACA;;;EAGE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,gGAAgG;AAClG;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;;;EAGE,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,4EAA4E;EAC5E,6EAA6E;EAC7E,kBAAkB;EAClB,4EAA4E;AAC9E;AACA;EACE,+FAA+F;AACjG;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,uEAAuE;EACvE,0DAA0D;AAC5D;AACA;EACE,qEAAqE;EACrE,wDAAwD;AAC1D;AACA;EACE,mEAAmE;EACnE,8DAA8D;AAChE;AACA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,2CAA2C;EAC3C,OAAO;EACP,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;EACE,YAAY;AACd;AACA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,wDAAwD;EACxD,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;;;EAGE,sCAAsC;AACxC;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,oDAAoD;EACpD,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uFAAuF;EACvF,oCAAoC;EACpC,8EAA8E;EAC9E,8BAA8B;EAC9B,mFAAmF;EACnF,iFAAiF;EACjF,+EAA+E;EAC/E,qFAAqF;EACrF,uEAAuE;EACvE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,wCAAwC;EACxC,2CAA2C;EAC3C,iDAAiD;AACnD;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,gGAAgG;AAClG;AACA;EACE,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,mDAAmD;EACnD,gDAAgD;EAChD,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,QAAQ;AACV;AACA;EACE,0CAA0C;AAC5C;AACA;;;EAGE,kCAAkC;EAClC,wDAAwD;EACxD,iDAAiD;AACnD;AACA;EACE;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;;EAED,qEAAqE;;EAErE,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB;;;GAGC;EACD,2CAA2C;EAC3C,oCAAoC;AACtC;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,8EAA8E;AAChF;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;;EAExC,+FAA+F;EAC/F,4CAA4C;AAC9C;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;;EAExC,+FAA+F;EAC/F,4CAA4C;AAC9C;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;;EAEpC,4CAA4C;AAC9C;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,oCAAoC;EACpC,2CAA2C;;EAE3C,6CAA6C;AAC/C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,sEAAsE;EACtE,WAAW;EACX,sCAAsC;EACtC,+FAA+F;AACjG;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,oGAAoG;;EAEpG,wDAAwD;EACxD,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,0EAA0E;EAC1E,aAAa;EACb,oFAAoF;EACpF,uDAAuD;AACzD;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,2DAA2D;EAC3D,4DAA4D;AAC9D;AACA;EACE,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;AACA;;;;;;;;;;;;;;;;EAgBE,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,UAAU;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+BE,YAAY;AACd;AACA;;;;;;;;EAQE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;AACxC;AACA;;;;;;;;EAQE,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,wDAAwb;EACxb,uBAAuB;EACvB,+BAA+B;AACjC;AACA;;;;;;;;EAQE,SAAS;AACX;AACA;;;;;;;;EAQE,oEAAoE;AACtE;AACA;EACE,8EAA8E;EAC9E,0CAA0C;AAC5C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;AACA;EACE;;;;;;;;;;;;;;;;IAgBE,YAAY;EACd;AACF;AACA;;EAEE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;;;EAGE,wBAAwB;AAC1B;AACA;;;EAGE,0BAA0B;AAC5B;AACA;;;EAGE,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,gEAAgE;EAChE,iCAAiC;EACjC,iEAAiE;EACjE,kCAAkC;AACpC;AACA;;EAEE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,0CAA0C;AAC5C;AACA;;;EAGE,UAAU;EACV,gCAAgC;EAChC,8CAA8C;EAC9C,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;AACA;;;EAGE,kDAAkD;EAClD,uEAAuE;EACvE,2CAA2C;AAC7C;AACA;;EAEE,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,oCAAoC;EACpC,4DAA4D;AAC9D;AACA;;EAEE,iBAAiB;EACjB,SAAS;EACT,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;;EAEE,iBAAiB;EACjB,yCAAyC;EACzC,0CAA0C;AAC5C;AACA;;EAEE,sCAAsC;AACxC;AACA;EACE,oBAAoB;AACtB;AACA;;;EAGE,8CAA8C;EAC9C,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;AACA;EACE,8CAA8C;AAChD;AACA;;;EAGE,kDAAkD;EAClD,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,uDAAuD;EACvD,wDAAwD;AAC1D;AACA;;;EAGE,yEAAyE;EACzE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,sEAAsE;EACtE,uEAAuE;EACvE,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,6EAA6E;EAC7E,kBAAkB;EAClB,0DAA0D;EAC1D,8EAA8E;EAC9E,8FAA8F;AAChG;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,SAAS;AACX;AACA;EACE;;;GAGC;EACD,0GAA0G;AAC5G;AACA;EACE,wCAAwC;EACxC;;;GAGC;EACD,mGAAmG;AACrG;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iFAAiF;EACjF,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,oGAAoG;AACtG;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,2CAA2C;EAC3C,cAAc;EACd,yDAAyD;EACzD,uDAAuD;EACvD,qDAAqD;EACrD,oFAAoF;EACpF,4EAA4E;EAC5E,kBAAkB;EAClB,0EAA0E;EAC1E,gFAAgF;EAChF,6FAA6F;EAC7F,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,SAAS;EACT,uDAAuD;EACvD,sDAAsD;AACxD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,4FAA4F;EAC5F,0FAA0F;EAC1F,wFAAwF;EACxF,8FAA8F;EAC9F,4EAA4E;EAC5E,kBAAkB;EAClB,8EAA8E;EAC9E,6EAA6E;EAC7E,6FAA6F;AAC/F;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,2CAA2C;EAC3C,mFAAmF;AACrF;AACA;;;EAGE,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;;;;;;EAME,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,oGAAoG;AACtG;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,gCAAgC;AAClC;AACA;EACE,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,0CAA0C;EAC1C,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,kFAAkF;EAClF,gFAAgF;EAChF,8EAA8E;EAC9E,oFAAoF;EACpF,4EAA4E;EAC5E,kBAAkB;EAClB,8EAA8E;EAC9E,gFAAgF;EAChF,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sFAAsF;AACxF;AACA;EACE,6FAA6F;AAC/F;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE,iCAAiC;AACnC;AACA;EACE,0DAA0D;EAC1D,sEAAsE;AACxE;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,wCAAwC;EACxC,yCAAyC;EACzC,sCAAsC;EACtC,2CAA2C;EAC3C,yCAAyC;EACzC,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,4FAA4F;EAC5F,2CAA2C;EAC3C,2GAA2G;EAC3G,wBAAwB;EACxB,sCAAsC;EACtC,oDAAoD;AACtD;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,wBAAwB;EACxB,sCAAsC;EACtC,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,uCAAuC;AACzC;AACA;;EAEE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,wDAAwD;EACxD,sCAAsC;AACxC;AACA;;EAEE,wDAAwD;EACxD,oBAAoB;EACpB,sCAAsC;AACxC;AACA;EACE,4CAA4C;EAC5C,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,wDAAwD;EACxD,iBAAiB;EACjB,+BAA+B;AACjC;AACA;;EAEE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,SAAS;AACX;AACA;EACE,4DAA4D;EAC5D,sCAAsC;EACtC,+BAA+B;EAC/B,kDAAkD;EAClD,kBAAkB;AACpB;AACA;;EAEE,SAAS;AACX;AACA;;;;EAIE;;;GAGC;AACH;AACA;;EAEE,kEAAkE;AACpE;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,QAAQ;AACV;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,SAAS;AACX;AACA;;;;EAIE,mDAAmD;AACrD;AACA;EACE,8DAA8D;AAChE;AACA;;EAEE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,4CAA4C;AAC9C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;EACE,wBAAwB;EACxB,mFAAmF;EACnF,iFAAiF;AACnF;AACA;EACE,mFAAmF;AACrF;AACA;;;EAGE,mFAAmF;AACrF;AACA;;;;;;;EAOE,gKAAgK;AAClK;AACA;;;EAGE,kEAAkE;EAClE,8MAA8M;AAChN;AACA;;;;;;;EAOE,oFAAoF;AACtF;AACA;;;EAGE,wDAAwD;AAC1D;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,4CAA4C;AAC9C;AACA;;;;;EAKE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,SAAS;EACT,kEAAkE;AACpE;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,OAAO;EACP,wCAAwC;AAC1C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,cAAc;EACd,2CAA2C;EAC3C,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,SAAS;EACT;;;;GAIC;AACH;AACA;EACE,2FAA2F;AAC7F;AACA;EACE,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,KAAK;EACL,mDAAmD;AACrD;AACA;EACE,iBAAiB;EACjB,OAAO;EACP,KAAK;EACL,UAAU;EACV,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,WAAW;EACX,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,KAAK;EACL,wCAAwC;AAC1C;AACA;EACE,iDAAiD;EACjD,WAAW;EACX,SAAS;AACX;AACA;EACE,wDAAwD;EACxD,SAAS;EACT,YAAY;EACZ,SAAS;AACX;AACA;EACE,wDAAwD;EACxD,4BAA4B;AAC9B;AACA;EACE,SAAS;AACX;AACA;EACE,wDAAwD;EACxD,4BAA4B;AAC9B;AACA;EACE,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,4DAA4D;EAC5D,eAAe;AACjB;AACA;EACE,iFAAiF;EACjF,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,4DAA4D;EAC5D,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,SAAS;EACT,oBAAoB;AACtB;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,KAAK;EACL,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,wDAAwD;EACxD,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,mBAAmB;EACnB,8DAA8D;EAC9D,wDAAwD;EACxD,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wDAAwD;EACxD,uDAAuD;AACzD;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;EACtD,gFAAgF;AAClF;AACA;EACE,iCAAiC;AACnC;AACA;EACE,wDAAwD;EACxD,mDAAmD;AACrD;AACA;;;;;;EAME,wDAAwD;EACxD,oGAAoG;AACtG;AACA;EACE,SAAS;AACX;AACA;EACE,wDAAwD;EACxD,uDAAuD;AACzD;AACA;;;EAGE,SAAS;AACX;AACA;EACE,uDAAuD;AACzD;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,eAAe;EACf,sDAAsD;AACxD;AACA;;EAEE,eAAe;EACf,sDAAsD;EACtD,gFAAgF;AAClF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,cAAc;EACd,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,kDAAkD;EAClD,eAAe;AACjB;AACA;;;;EAIE,aAAa;EACb,wDAAwD;EACxD,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,wDAAwD;EACxD,0DAA0D;AAC5D;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;AACA;;EAEE,sDAAsD;EACtD,sCAAsC;AACxC;AACA;;EAEE,sDAAsD;EACtD,gFAAgF;AAClF;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;;;EAGE,SAAS;AACX;AACA;EACE,SAAS;EACT,iCAAiC;AACnC;AACA;;;;;;;EAOE,iCAAiC;EACjC,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,4CAA4C;AAC9C;AACA;;EAEE,6EAA6E;EAC7E,iEAAiE;AACnE;AACA;EACE,iFAAiF;EACjF,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE,6EAA6E;EAC7E,iEAAiE;AACnE;AACA;EACE,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,+EAA+E;EAC/E,oBAAoB;EACpB,sDAAsD;EACtD,2CAA2C;AAC7C;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,wDAAwD;EACxD,cAAc;EACd,UAAU;EACV,eAAe;EACf,sCAAsC;EACtC,iBAAiB;EACjB,uDAAuD;EACvD,iCAAiC;AACnC;AACA;;;EAGE,wDAAwD;EACxD,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,QAAQ;AACV;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,yCAAyC;EACzC,wBAAwB;EACxB,wBAAwB;EACxB,uDAAuD;EACvD,wDAAwD;AAC1D;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;EACxD,iFAAiF;AACnF;AACA;EACE,wDAAwD;EACxD,kFAAkF;AACpF;AACA;EACE,wDAAwD;EACxD,oFAAoF;AACtF;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE,UAAU;EACV,aAAa;EACb,QAAQ;EACR,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;AACV;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kDAAkD;AACpD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;;EAEE,gEAAgE;EAChE,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2GAA2G;AAC7G;AACA;EACE,gEAAgE;AAClE;AACA;EACE,gEAAgE;AAClE;AACA;EACE;;GAEC;EACD,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,aAAa;EACb,6CAA6C;EAC7C,sCAAsC;EACtC,uCAAuC;EACvC,2DAA2D;EAC3D,iCAAiC;EACjC,2BAA2B;EAC3B,uBAAuB;EACvB,yDAAyD;EACzD,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kDAAkD;EAClD,aAAa;EACb,+BAA+B;AACjC;AACA;EACE,oCAAoC;EACpC,eAAe;EACf,iCAAiC;EACjC,2CAA2C;EAC3C,+CAA+C;AACjD;AACA;EACE,sFAAsF;AACxF;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,+BAA+B;EAC/B,oFAAoF;AACtF;AACA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,2CAA2C;AAC7C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,uDAAuD;EACvD,wDAAwD;EACxD,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,sEAAsE;EACtE,oCAAoC;EACpC,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,OAAO;EACP,QAAQ;EACR,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,QAAQ;AACV;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yDAAyD;EACzD,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,OAAO;AACT;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;EACE,oDAAoD;EACpD,sDAAsD;AACxD;AACA;;;;;;;;;;;;;EAaE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,0DAA0D;EAC5D;AACF;AACA;EACE;IACE,wDAAwD;EAC1D;AACF;AACA;EACE;IACE,uDAAuD;EACzD;AACF;AACA;EACE;IACE,0DAA0D;EAC5D;AACF;AACA;EACE,QAAW;EACX,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;EAaE,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;AACA;;;;;;;;;;;;;EAaE,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;;;;;;;;;;;;;EAaE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;;;;;;;;;;;;;EAaE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,iCAAiC;AACnC;AACA;EACE,QAAM;EACN,WAAW;AACb;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,2CAA2C;AAC7C;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,2CAA2C;AAC7C;AACA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,QAAQ;EACR,2CAA2C;AAC7C;AACA;EACE,kEAAkE;EAClE,iEAAiE;EACjE,gEAAgE;EAChE,iEAAiE;EACjE,gEAAgE;EAChE,iEAAiE;EACjE,kEAAkE;EAClE,qEAAqE;EACrE,oEAAoE;EACpE,mEAAmE;EACnE,oEAAoE;EACpE,mEAAmE;EACnE,oEAAoE;EACpE,qEAAqE;EACrE,oDAAoD;EACpD,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,oDAAoD;AACtD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,sDAAsD;AACxD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2DAA2D;EAC3D,yDAAyD;AAC3D;AACA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;AACA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;AACA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;AACA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;AACA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;AACA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;AACA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;AACA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;EACE,qDAAqD;EACrD,mDAAmD;AACrD;AACA;EACE,qDAAqD;EACrD,mDAAmD;AACrD;AACA;EACE,qDAAqD;EACrD,mDAAmD;AACrD;AACA;EACE,qDAAqD;EACrD,mDAAmD;AACrD;AACA;EACE,qDAAqD;EACrD,mDAAmD;AACrD;AACA;EACE,qDAAqD;EACrD,mDAAmD;AACrD;AACA;EACE,qDAAqD;EACrD,mDAAmD;AACrD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kEAAkE;EAClE,iEAAiE;EACjE,gEAAgE;EAChE,iEAAiE;EACjE,gEAAgE;EAChE,iEAAiE;EACjE,kEAAkE;EAClE,qEAAqE;EACrE,oEAAoE;EACpE,mEAAmE;EACnE,oEAAoE;EACpE,mEAAmE;EACnE,oEAAoE;EACpE,qEAAqE;EACrE,oDAAoD;EACpD,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,oDAAoD;AACtD;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,uDAAuD;AACzD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,4DAA4D;EAC5D,0DAA0D;AAC5D;AACA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,yDAAyD;EACzD,uDAAuD;AACzD;AACA;EACE,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,sDAAsD;EACtD,oDAAoD;AACtD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,aAAa;EACb,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iFAAiF;AACnF;AACA;EACE,oFAAoF;AACtF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,mFAAmF;AACrF;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;;;;;;;EAOE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,gEAAgE;EAChE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;;;;;EAKE,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,gDAAgD;EAChD,wDAAwD;EACxD,4CAA4C;AAC9C;AACA;EACE,+BAA+B;EAC/B,uDAAuD;AACzD;AACA;EACE,wDAAwD;EACxD,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;EACE,uDAAuD;EACvD,wDAAwD;AAC1D;AACA;;;EAGE,oGAAoG;AACtG;AACA;EACE,6CAA6C;EAC7C,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,6CAA6C;EAC7C,2CAA2C;EAC3C,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,2CAA2C;AAC7C;AACA;;;EAGE,SAAS;AACX;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;;;EAGE,yDAAyD;AAC3D;AACA;;;EAGE,yDAAyD;EACzD,+BAA+B;AACjC;AACA;EACE;;;IAGE,+BAA+B;EACjC;AACF;AACA;;;EAGE,uDAAuD;AACzD;AACA;;;EAGE,uDAAuD;EACvD,+BAA+B;AACjC;AACA;EACE;;;IAGE,+BAA+B;EACjC;AACF;AACA;EACE,6CAA6C;EAC7C,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,6CAA6C;EAC7C,2CAA2C;EAC3C,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE;IACE,+BAA+B;EACjC;AACF;AACA;EACE,0CAA0C;AAC5C;AACA;;EAEE,wDAAwD;EACxD,yCAAyC;EACzC,cAAc;AAChB;AACA;;EAEE,wDAAwD;EACxD,sDAAsD;AACxD;AACA;;EAEE,uDAAuD;EACvD,wDAAwD;AAC1D;AACA;;;;EAIE,oGAAoG;AACtG;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,yDAAyD;EACzD,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,UAAU;EACV,2CAA2C;EAC3C,yCAAyC;EACzC,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;EACvD,wCAAwC;EACxC,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,2CAA2C;EAC3C,yCAAyC;EACzC,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,UAAU;EACV,2CAA2C;EAC3C,yCAAyC;EACzC,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;;;EAGE,SAAS;EACT,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,2CAA2C;EAC3C,yCAAyC;EACzC,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;;;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;EAGE,YAAY;AACd;AACA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;;;EAGE,SAAS;EACT,UAAU;EACV,UAAU;EACV,2CAA2C;EAC3C,yCAAyC;EACzC,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;;;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;EAGE,YAAY;AACd;AACA;EACE,UAAU;EACV,aAAa;EACb,UAAU;AACZ;AACA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,4CAA4C;EAC9C;AACF;AACA;;;EAGE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,SAAS;EACT,0CAA0C;AAC5C;AACA;EACE,SAAS;AACX;AACA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,SAAS;IACT,0CAA0C;EAC5C;EACA;IACE,SAAS;EACX;AACF;AACA;EACE,SAAS;EACT,0CAA0C;AAC5C;AACA;EACE,SAAS;AACX;AACA;;;EAGE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,0CAA0C;EAC1C,aAAa;AACf;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,uEAAuE;AACzE;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;;;;;;;EAOE,aAAa;EACb,uBAAuB;AACzB;AACA;;;EAGE,cAAc;EACd,SAAS;EACT,8EAA8E;EAC9E,uDAAuD;AACzD;AACA;EACE,wDAAwD;EACxD,sCAAsC;AACxC;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,0CAA0C;EAC1C,kDAAkD;EAClD,8CAA8C;AAChD;AACA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0CAA0C;EAC1C,kDAAkD;EAClD,8CAA8C;AAChD;AACA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,sCAAsC;EACtC,wDAAwD;AAC1D;AACA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;;;EAGE,sCAAsC;AACxC;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,+BAA+B;AACjC;AACA;;;EAGE,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,qDAAqD;AACvD;AACA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;;;EAGE,mCAAmC;AACrC;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;AACA;;;EAGE,kCAAkC;AACpC;AACA;EACE,wDAAwD;EACxD,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;;;EAGE,sCAAsC;AACxC;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,0CAA0C;EAC1C,SAAS;AACX;AACA;EACE,sCAAsC;AACxC;AACA;EACE,kDAAkD;AACpD;AACA;EACE,kDAAkD;EAClD,yBAAyB;AAC3B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,kDAAkD;EAClD,+DAA+D;EAC/D,6DAA6D;AAC/D;AACA;EACE,kDAAkD;AACpD;AACA;;;EAGE,qCAAqC;AACvC;AACA;EACE,oCAAoC;EACpC,sDAAsD;AACxD;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;;EAGE,oCAAoC;AACtC;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,+BAA+B;AACjC;AACA;;;EAGE,mCAAmC;AACrC;AACA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD;AACA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,gFAAgF;AAClF;AACA;EACE,gFAAgF;AAClF;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,gFAAgF;AAClF;AACA;EACE,gFAAgF;AAClF;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;;EAEE,uEAAuE;EACvE,2CAA2C;EAC3C,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,wDAAwD;EACxD,aAAa;AACf;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,uDAAuD;EACvD,8CAA8C;AAChD;AACA;;;;EAIE,iDAAiD;EACjD,8CAA8C;AAChD;AACA;;EAEE,8FAA8F;EAC9F,kDAAkD;EAClD,oCAAoC;AACtC;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;AACA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;AACA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;AACA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,sCAAsC;AACxC;AACA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,uCAAuC;EACvC,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,wCAAwC;EACxC,uCAAuC;AACzC;AACA;EACE,aAAa;AACf;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;;;;;;;;EAQE,wCAAwC;AAC1C;AACA;EACE,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,gEAAgE;AAClE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,+DAA+D;AACjE;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,oDAAoD;AACtD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EAGE,OAAO;AACT;AACA;EAGE,OAAO;AACT;AACA;EAGE,OAAO;AACT;AACA;EAGE,OAAO;AACT;AACA;EAGE,OAAO;AACT;AACA;EAGE,OAAO;AACT;AACA;EAGE,OAAO;AACT;AACA;EAGE,OAAO;AACT;AACA;EAGE,OAAO;AACT;AACA;EAGE,QAAQ;AACV;AACA;EAGE,QAAQ;AACV;AACA;EAGE,QAAQ;AACV;AACA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA+GE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;AACA;EACE;;;;;;;;;;;;;;;IAeE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;AACA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA+GE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;AACA;EACE;;;;;;;;;;;;;;;IAeE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;AACA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA+GE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;AACA;EACE;;;;;;;;;;;;;;;IAeE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;AACA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA+GE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;AACA;EACE;;;;;;;;;;;;;;;IAeE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+GE,SAAS;AACX;AACA;EACE,8BAA8B;AAChC;AACA;EACE,QAAQ;AACV;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,sCAAsC;EACtC,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,4BAA4B;EAC5B,OAAO;AACT;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA","sourcesContent":["/*\n\n██╗██╗     ██████╗ █████╗ ██╗   ██╗████████╗██╗ ██████╗ ███╗   ██╗    ██╗██╗\n██║██║    ██╔════╝██╔══██╗██║   ██║╚══██╔══╝██║██╔═══██╗████╗  ██║    ██║██║\n██║██║    ██║     ███████║██║   ██║   ██║   ██║██║   ██║██╔██╗ ██║    ██║██║\n╚═╝╚═╝    ██║     ██╔══██║██║   ██║   ██║   ██║██║   ██║██║╚██╗██║    ╚═╝╚═╝\n██╗██╗    ╚██████╗██║  ██║╚██████╔╝   ██║   ██║╚██████╔╝██║ ╚████║    ██╗██╗\n╚═╝╚═╝     ╚═════╝╚═╝  ╚═╝ ╚═════╝    ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝    ╚═╝╚═╝\n                                                                            \nThis component is for Design Systems Engineering team use only.\nIts content is unsupported for project implementation and may be withdrawn anytime.\nRefer to official documentation for current guidance at https://sfdc.co/slds-plus-playbook\n\n */\n@layer deprecated, defaults, shared, theme, component, primereact, core;\n@layer defaults{\n  :where(html){\n    --slds-g-spacing-ratio: 1;\n    --sds-g-spacing-1:var(--slds-g-spacing-1);\n    --slds-g-spacing-1: calc(var(--slds-g-spacing-ratio) * 0.25rem);\n    --sds-g-spacing-2:var(--slds-g-spacing-2);\n    --slds-g-spacing-2: calc(var(--slds-g-spacing-ratio) * 0.5rem);\n    --sds-g-spacing-3:var(--slds-g-spacing-3);\n    --slds-g-spacing-3: calc(var(--slds-g-spacing-ratio) * 0.75rem);\n    --sds-g-spacing-4:var(--slds-g-spacing-4);\n    --slds-g-spacing-4: calc(var(--slds-g-spacing-ratio) * 1rem);\n    --sds-g-spacing-5:var(--slds-g-spacing-5);\n    --slds-g-spacing-5: calc(var(--slds-g-spacing-ratio) * 1.5rem);\n    --sds-g-spacing-6:var(--slds-g-spacing-6);\n    --slds-g-spacing-6: calc(var(--slds-g-spacing-ratio) * 2rem);\n    --sds-g-spacing-7:var(--slds-g-spacing-7);\n    --slds-g-spacing-7: calc(var(--slds-g-spacing-ratio) * 2.5rem);\n    --sds-g-spacing-8:var(--slds-g-spacing-8);\n    --slds-g-spacing-8: calc(var(--slds-g-spacing-ratio) * 3rem);\n    --sds-g-spacing-9:var(--slds-g-spacing-9);\n    --slds-g-spacing-9: calc(var(--slds-g-spacing-ratio) * 3.5rem);\n    --sds-g-spacing-10: var(--slds-g-spacing-10);\n    --slds-g-spacing-10: calc(var(--slds-g-spacing-ratio) * 4rem);\n    --sds-g-spacing-11:var(--slds-g-spacing-11);\n    --slds-g-spacing-11: calc(var(--slds-g-spacing-ratio) * 4.5rem);\n    --sds-g-spacing-12:var(--slds-g-spacing-12);\n    --slds-g-spacing-12: calc(var(--slds-g-spacing-ratio) * 5rem);\n    --slds-g-sizing-border-ratio: 1;\n    --sds-g-sizing-border-1:var(--slds-g-sizing-border-1);\n    --slds-g-sizing-border-1: calc(var(--slds-g-sizing-border-ratio) * 1px);\n    --sds-g-sizing-border-2:var(--slds-g-sizing-border-2);\n    --slds-g-sizing-border-2: calc(var(--slds-g-sizing-border-ratio) * 2px);\n    --sds-g-sizing-border-3:var(--slds-g-sizing-border-3);\n    --slds-g-sizing-border-3: calc(var(--slds-g-sizing-border-ratio) * 3px);\n    --sds-g-sizing-border-4:var(--slds-g-sizing-border-4);\n    --slds-g-sizing-border-4: calc(var(--slds-g-sizing-border-ratio) * 4px);\n    --sds-g-sizing-1:var(--slds-g-sizing-1);\n    --slds-g-sizing-1:0.125rem;\n    --sds-g-sizing-2:var(--slds-g-sizing-2);\n    --slds-g-sizing-2:0.25rem;\n    --sds-g-sizing-3:var(--slds-g-sizing-3);\n    --slds-g-sizing-3:0.5rem;\n    --sds-g-sizing-4:var(--slds-g-sizing-4);\n    --slds-g-sizing-4:0.75rem;\n    --sds-g-sizing-5:var(--slds-g-sizing-5);\n    --slds-g-sizing-5:1rem;\n    --sds-g-sizing-6:var(--slds-g-sizing-6);\n    --slds-g-sizing-6:1.25rem;\n    --sds-g-sizing-7:var(--slds-g-sizing-7);\n    --slds-g-sizing-7:1.5rem;\n    --sds-g-sizing-8:var(--slds-g-sizing-8);\n    --slds-g-sizing-8:1.75rem;\n    --sds-g-sizing-9:var(--slds-g-sizing-9);\n    --slds-g-sizing-9:2rem;\n    --sds-g-sizing-10:var(--slds-g-sizing-10);\n    --slds-g-sizing-10:3rem;\n    --sds-g-sizing-11:var(--slds-g-sizing-11);\n    --slds-g-sizing-11:4rem;\n    --sds-g-sizing-12:var(--slds-g-sizing-12);\n    --slds-g-sizing-12:5rem;\n    --sds-g-sizing-13:var(--slds-g-sizing-13);\n    --slds-g-sizing-13:10rem;\n    --sds-g-sizing-14:var(--slds-g-sizing-14);\n    --slds-g-sizing-14:15rem;\n    --sds-g-sizing-15:var(--slds-g-sizing-15);\n    --slds-g-sizing-15:20rem;\n    --sds-g-sizing-16:var(--slds-g-sizing-16);\n    --slds-g-sizing-16:30rem;\n    --sds-g-sizing-content-1:var(--slds-g-sizing-content-1);\n    --slds-g-sizing-content-1:20ch;\n    --sds-g-sizing-content-2:var(--slds-g-sizing-content-2);\n    --slds-g-sizing-content-2:45ch;\n    --sds-g-sizing-content-3:var(--slds-g-sizing-content-3);\n    --slds-g-sizing-content-3:60ch;\n    --sds-g-sizing-heading-1:var(--slds-g-sizing-heading-1);\n    --slds-g-sizing-heading-1:20ch;\n    --sds-g-sizing-heading-2:var(--slds-g-sizing-heading-2);\n    --slds-g-sizing-heading-2:25ch;\n    --sds-g-sizing-heading-3:var(--slds-g-sizing-heading-3);\n    --slds-g-sizing-heading-3:35ch;\n    --sds-g-shadow-1:var(--slds-g-shadow-1);\n    --slds-g-shadow-1:0px 0px 1.5px 0px #00000017, 0px 1.4px 1.5px 0px #00000017, 0px -1px 1px 0px #00000009;\n    --sds-g-shadow-2:var(--slds-g-shadow-2);\n    --slds-g-shadow-2:0px 0px 3px 0px #00000016, 0px 2.8px 3px 0px #00000016, 0px -1px 1.2px 0px #00000009;\n    --sds-g-shadow-3:var(--slds-g-shadow-3);\n    --slds-g-shadow-3:0px 0px 4.5px 0px #00000014, 0px 4.2px 4.5px 0px #00000017, 0px -1px 1.44px 0px #00000008;\n    --sds-g-shadow-4:var(--slds-g-shadow-4);\n    --slds-g-shadow-4:0px 0px 6.75px 0px #00000012, 0px 6.3px 6.75px 0px #00000012, 0px -1px 1.7px 0px #00000007;\n    --sds-g-shadow-5:var(--slds-g-shadow-5);\n    --slds-g-shadow-5:var(--slds-g-shadow-4);\n    --sds-g-shadow-6:var(--slds-g-shadow-6);\n    --slds-g-shadow-6:var(--slds-g-shadow-4);\n    --sds-g-shadow-inverse-1:var(--slds-g-shadow-inverse-1);\n    --slds-g-shadow-inverse-1:0 0 3px #f3f3f3;\n    --sds-g-ratio-square:var(--slds-g-ratio-square);\n    --slds-g-ratio-square:1;\n    --sds-g-ratio-landscape:var(--slds-g-ratio-landscape);\n    --slds-g-ratio-landscape:4/3;\n    --sds-g-ratio-portrait:var(--slds-g-ratio-portrait);\n    --slds-g-ratio-portrait:3/4;\n    --sds-g-ratio-wide:var(--slds-g-ratio-wide);\n    --slds-g-ratio-wide:16/9;\n    --sds-g-ratio-ultrawide:var(--slds-g-ratio-ultrawide);\n    --slds-g-ratio-ultrawide:18/5;\n    --slds-g-radius-border-ratio: 1;\n    --sds-g-radius-border-1:var(--slds-g-radius-border-1);\n    --slds-g-radius-border-1: calc(var(--slds-g-radius-border-ratio) * 0.25rem);\n    --sds-g-radius-border-2:var(--slds-g-radius-border-2);\n    --slds-g-radius-border-2: calc(var(--slds-g-radius-border-ratio) * 0.5rem);\n    --sds-g-radius-border-3:var(--slds-g-radius-border-3);\n    --slds-g-radius-border-3: calc(var(--slds-g-radius-border-ratio) * 0.75rem);\n    --sds-g-radius-border-4:var(--slds-g-radius-border-4);\n    --slds-g-radius-border-4: calc(var(--slds-g-radius-border-ratio) * 1.25rem);\n    --sds-g-radius-border-pill:var(--slds-g-radius-border-pill);\n    --slds-g-radius-border-pill:15rem;\n    --sds-g-radius-border-circle:var(--slds-g-radius-border-circle);\n    --slds-g-radius-border-circle:100%;\n    --sds-g-color-palette-blue-10:var(--slds-g-color-palette-blue-10);\n    --slds-g-color-palette-blue-10:#001639;\n    --sds-g-color-palette-blue-15:var(--slds-g-color-palette-blue-15);\n    --slds-g-color-palette-blue-15:#03234d;\n    --sds-g-color-palette-blue-20:var(--slds-g-color-palette-blue-20);\n    --slds-g-color-palette-blue-20:#032d60;\n    --sds-g-color-palette-blue-30:var(--slds-g-color-palette-blue-30);\n    --slds-g-color-palette-blue-30:#014486;\n    --sds-g-color-palette-blue-40:var(--slds-g-color-palette-blue-40);\n    --slds-g-color-palette-blue-40:#0b5cab;\n    --sds-g-color-palette-blue-50:var(--slds-g-color-palette-blue-50);\n    --slds-g-color-palette-blue-50:#0176d3;\n    --sds-g-color-palette-blue-60:var(--slds-g-color-palette-blue-60);\n    --slds-g-color-palette-blue-60:#1b96ff;\n    --sds-g-color-palette-blue-65:var(--slds-g-color-palette-blue-65);\n    --slds-g-color-palette-blue-65:#57a3fd;\n    --sds-g-color-palette-blue-70:var(--slds-g-color-palette-blue-70);\n    --slds-g-color-palette-blue-70:#78b0fd;\n    --sds-g-color-palette-blue-80:var(--slds-g-color-palette-blue-80);\n    --slds-g-color-palette-blue-80:#aacbff;\n    --sds-g-color-palette-blue-90:var(--slds-g-color-palette-blue-90);\n    --slds-g-color-palette-blue-90:#d8e6fe;\n    --sds-g-color-palette-blue-95:var(--slds-g-color-palette-blue-95);\n    --slds-g-color-palette-blue-95:#eef4ff;\n    --sds-g-color-palette-cloud-blue-10:var(--slds-g-color-palette-cloud-blue-10);\n    --slds-g-color-palette-cloud-blue-10:#001a28;\n    --sds-g-color-palette-cloud-blue-15:var(--slds-g-color-palette-cloud-blue-15);\n    --slds-g-color-palette-cloud-blue-15:#0a2636;\n    --sds-g-color-palette-cloud-blue-20:var(--slds-g-color-palette-cloud-blue-20);\n    --slds-g-color-palette-cloud-blue-20:#023248;\n    --sds-g-color-palette-cloud-blue-30:var(--slds-g-color-palette-cloud-blue-30);\n    --slds-g-color-palette-cloud-blue-30:#084968;\n    --sds-g-color-palette-cloud-blue-40:var(--slds-g-color-palette-cloud-blue-40);\n    --slds-g-color-palette-cloud-blue-40:#05628a;\n    --sds-g-color-palette-cloud-blue-50:var(--slds-g-color-palette-cloud-blue-50);\n    --slds-g-color-palette-cloud-blue-50:#107cad;\n    --sds-g-color-palette-cloud-blue-60:var(--slds-g-color-palette-cloud-blue-60);\n    --slds-g-color-palette-cloud-blue-60:#0d9dda;\n    --sds-g-color-palette-cloud-blue-65:var(--slds-g-color-palette-cloud-blue-65);\n    --slds-g-color-palette-cloud-blue-65:#08abed;\n    --sds-g-color-palette-cloud-blue-70:var(--slds-g-color-palette-cloud-blue-70);\n    --slds-g-color-palette-cloud-blue-70:#1ab9ff;\n    --sds-g-color-palette-cloud-blue-80:var(--slds-g-color-palette-cloud-blue-80);\n    --slds-g-color-palette-cloud-blue-80:#90d0fe;\n    --sds-g-color-palette-cloud-blue-90:var(--slds-g-color-palette-cloud-blue-90);\n    --slds-g-color-palette-cloud-blue-90:#cfe9fe;\n    --sds-g-color-palette-cloud-blue-95:var(--slds-g-color-palette-cloud-blue-95);\n    --slds-g-color-palette-cloud-blue-95:#eaf5fe;\n    --sds-g-color-palette-green-10:var(--slds-g-color-palette-green-10);\n    --slds-g-color-palette-green-10:#071b12;\n    --sds-g-color-palette-green-15:var(--slds-g-color-palette-green-15);\n    --slds-g-color-palette-green-15:#0c2912;\n    --sds-g-color-palette-green-20:var(--slds-g-color-palette-green-20);\n    --slds-g-color-palette-green-20:#1C3326;\n    --sds-g-color-palette-green-30:var(--slds-g-color-palette-green-30);\n    --slds-g-color-palette-green-30:#194e31;\n    --sds-g-color-palette-green-40:var(--slds-g-color-palette-green-40);\n    --slds-g-color-palette-green-40:#396547;\n    --sds-g-color-palette-green-50:var(--slds-g-color-palette-green-50);\n    --slds-g-color-palette-green-50:#2e844a;\n    --sds-g-color-palette-green-60:var(--slds-g-color-palette-green-60);\n    --slds-g-color-palette-green-60:#3ba755;\n    --sds-g-color-palette-green-65:var(--slds-g-color-palette-green-65);\n    --slds-g-color-palette-green-65:#41b658;\n    --sds-g-color-palette-green-70:var(--slds-g-color-palette-green-70);\n    --slds-g-color-palette-green-70:#45c65a;\n    --sds-g-color-palette-green-80:var(--slds-g-color-palette-green-80);\n    --slds-g-color-palette-green-80:#91db8b;\n    --sds-g-color-palette-green-90:var(--slds-g-color-palette-green-90);\n    --slds-g-color-palette-green-90:#cdefc4;\n    --sds-g-color-palette-green-95:var(--slds-g-color-palette-green-95);\n    --slds-g-color-palette-green-95:#ebf7e6;\n    --sds-g-color-palette-hot-orange-10:var(--slds-g-color-palette-hot-orange-10);\n    --slds-g-color-palette-hot-orange-10:#281202;\n    --sds-g-color-palette-hot-orange-15:var(--slds-g-color-palette-hot-orange-15);\n    --slds-g-color-palette-hot-orange-15:#421604;\n    --sds-g-color-palette-hot-orange-20:var(--slds-g-color-palette-hot-orange-20);\n    --slds-g-color-palette-hot-orange-20:#4A2413;\n    --sds-g-color-palette-hot-orange-30:var(--slds-g-color-palette-hot-orange-30);\n    --slds-g-color-palette-hot-orange-30:#7e2600;\n    --sds-g-color-palette-hot-orange-40:var(--slds-g-color-palette-hot-orange-40);\n    --slds-g-color-palette-hot-orange-40:#aa3001;\n    --sds-g-color-palette-hot-orange-50:var(--slds-g-color-palette-hot-orange-50);\n    --slds-g-color-palette-hot-orange-50:#d83a00;\n    --sds-g-color-palette-hot-orange-60:var(--slds-g-color-palette-hot-orange-60);\n    --slds-g-color-palette-hot-orange-60:#ff5d2d;\n    --sds-g-color-palette-hot-orange-65:var(--slds-g-color-palette-hot-orange-65);\n    --slds-g-color-palette-hot-orange-65:#ff784f;\n    --sds-g-color-palette-hot-orange-70:var(--slds-g-color-palette-hot-orange-70);\n    --slds-g-color-palette-hot-orange-70:#ff906e;\n    --sds-g-color-palette-hot-orange-80:var(--slds-g-color-palette-hot-orange-80);\n    --slds-g-color-palette-hot-orange-80:#feb9a5;\n    --sds-g-color-palette-hot-orange-90:var(--slds-g-color-palette-hot-orange-90);\n    --slds-g-color-palette-hot-orange-90:#ffded5;\n    --sds-g-color-palette-hot-orange-95:var(--slds-g-color-palette-hot-orange-95);\n    --slds-g-color-palette-hot-orange-95:#fef1ed;\n    --sds-g-color-palette-indigo-10:var(--slds-g-color-palette-indigo-10);\n    --slds-g-color-palette-indigo-10:#200647;\n    --sds-g-color-palette-indigo-15:var(--slds-g-color-palette-indigo-15);\n    --slds-g-color-palette-indigo-15:#1f0974;\n    --sds-g-color-palette-indigo-20:var(--slds-g-color-palette-indigo-20);\n    --slds-g-color-palette-indigo-20:#321D71;\n    --sds-g-color-palette-indigo-30:var(--slds-g-color-palette-indigo-30);\n    --slds-g-color-palette-indigo-30:#2f2cb7;\n    --sds-g-color-palette-indigo-40:var(--slds-g-color-palette-indigo-40);\n    --slds-g-color-palette-indigo-40:#3a49da;\n    --sds-g-color-palette-indigo-50:var(--slds-g-color-palette-indigo-50);\n    --slds-g-color-palette-indigo-50:#5867e8;\n    --sds-g-color-palette-indigo-60:var(--slds-g-color-palette-indigo-60);\n    --slds-g-color-palette-indigo-60:#7f8ced;\n    --sds-g-color-palette-indigo-65:var(--slds-g-color-palette-indigo-65);\n    --slds-g-color-palette-indigo-65:#8e9bef;\n    --sds-g-color-palette-indigo-70:var(--slds-g-color-palette-indigo-70);\n    --slds-g-color-palette-indigo-70:#9ea9f1;\n    --sds-g-color-palette-indigo-80:var(--slds-g-color-palette-indigo-80);\n    --slds-g-color-palette-indigo-80:#bec7f6;\n    --sds-g-color-palette-indigo-90:var(--slds-g-color-palette-indigo-90);\n    --slds-g-color-palette-indigo-90:#e0e5f8;\n    --sds-g-color-palette-indigo-95:var(--slds-g-color-palette-indigo-95);\n    --slds-g-color-palette-indigo-95:#f1f3fb;\n    --sds-g-color-palette-orange-10:var(--slds-g-color-palette-orange-10);\n    --slds-g-color-palette-orange-10:#201600;\n    --sds-g-color-palette-orange-15:var(--slds-g-color-palette-orange-15);\n    --slds-g-color-palette-orange-15:#371e03;\n    --sds-g-color-palette-orange-20:var(--slds-g-color-palette-orange-20);\n    --slds-g-color-palette-orange-20:#3e2b02;\n    --sds-g-color-palette-orange-30:var(--slds-g-color-palette-orange-30);\n    --slds-g-color-palette-orange-30:#5f3e02;\n    --sds-g-color-palette-orange-40:var(--slds-g-color-palette-orange-40);\n    --slds-g-color-palette-orange-40:#825101;\n    --sds-g-color-palette-orange-50:var(--slds-g-color-palette-orange-50);\n    --slds-g-color-palette-orange-50:#a96404;\n    --sds-g-color-palette-orange-60:var(--slds-g-color-palette-orange-60);\n    --slds-g-color-palette-orange-60:#dd7a01;\n    --sds-g-color-palette-orange-65:var(--slds-g-color-palette-orange-65);\n    --slds-g-color-palette-orange-65:#f38303;\n    --sds-g-color-palette-orange-70:var(--slds-g-color-palette-orange-70);\n    --slds-g-color-palette-orange-70:#fe9339;\n    --sds-g-color-palette-orange-80:var(--slds-g-color-palette-orange-80);\n    --slds-g-color-palette-orange-80:#ffba90;\n    --sds-g-color-palette-orange-90:var(--slds-g-color-palette-orange-90);\n    --slds-g-color-palette-orange-90:#fedfd0;\n    --sds-g-color-palette-orange-95:var(--slds-g-color-palette-orange-95);\n    --slds-g-color-palette-orange-95:#fff1ea;\n    --sds-g-color-palette-pink-10:var(--slds-g-color-palette-pink-10);\n    --slds-g-color-palette-pink-10:#370114;\n    --sds-g-color-palette-pink-15:var(--slds-g-color-palette-pink-15);\n    --slds-g-color-palette-pink-15:#4b0620;\n    --sds-g-color-palette-pink-20:var(--slds-g-color-palette-pink-20);\n    --slds-g-color-palette-pink-20:#61022a;\n    --sds-g-color-palette-pink-30:var(--slds-g-color-palette-pink-30);\n    --slds-g-color-palette-pink-30:#8a033e;\n    --sds-g-color-palette-pink-40:var(--slds-g-color-palette-pink-40);\n    --slds-g-color-palette-pink-40:#b60554;\n    --sds-g-color-palette-pink-50:var(--slds-g-color-palette-pink-50);\n    --slds-g-color-palette-pink-50:#e3066a;\n    --sds-g-color-palette-pink-60:var(--slds-g-color-palette-pink-60);\n    --slds-g-color-palette-pink-60:#ff538a;\n    --sds-g-color-palette-pink-65:var(--slds-g-color-palette-pink-65);\n    --slds-g-color-palette-pink-65:#fe7298;\n    --sds-g-color-palette-pink-70:var(--slds-g-color-palette-pink-70);\n    --slds-g-color-palette-pink-70:#fe8aa7;\n    --sds-g-color-palette-pink-80:var(--slds-g-color-palette-pink-80);\n    --slds-g-color-palette-pink-80:#fdb6c5;\n    --sds-g-color-palette-pink-90:var(--slds-g-color-palette-pink-90);\n    --slds-g-color-palette-pink-90:#fddde3;\n    --sds-g-color-palette-pink-95:var(--slds-g-color-palette-pink-95);\n    --slds-g-color-palette-pink-95:#fef0f3;\n    --sds-g-color-palette-purple-10:var(--slds-g-color-palette-purple-10);\n    --slds-g-color-palette-purple-10:#240643;\n    --sds-g-color-palette-purple-15:var(--slds-g-color-palette-purple-15);\n    --slds-g-color-palette-purple-15:#300b60;\n    --sds-g-color-palette-purple-20:var(--slds-g-color-palette-purple-20);\n    --slds-g-color-palette-purple-20:#401075;\n    --sds-g-color-palette-purple-30:var(--slds-g-color-palette-purple-30);\n    --slds-g-color-palette-purple-30:#5a1ba9;\n    --sds-g-color-palette-purple-40:var(--slds-g-color-palette-purple-40);\n    --slds-g-color-palette-purple-40:#7526e3;\n    --sds-g-color-palette-purple-50:var(--slds-g-color-palette-purple-50);\n    --slds-g-color-palette-purple-50:#9050e9;\n    --sds-g-color-palette-purple-60:var(--slds-g-color-palette-purple-60);\n    --slds-g-color-palette-purple-60:#ad7bee;\n    --sds-g-color-palette-purple-65:var(--slds-g-color-palette-purple-65);\n    --slds-g-color-palette-purple-65:#b78def;\n    --sds-g-color-palette-purple-70:var(--slds-g-color-palette-purple-70);\n    --slds-g-color-palette-purple-70:#c29ef1;\n    --sds-g-color-palette-purple-80:var(--slds-g-color-palette-purple-80);\n    --slds-g-color-palette-purple-80:#D7BFF2;\n    --sds-g-color-palette-purple-90:var(--slds-g-color-palette-purple-90);\n    --slds-g-color-palette-purple-90:#ece1f9;\n    --sds-g-color-palette-purple-95:var(--slds-g-color-palette-purple-95);\n    --slds-g-color-palette-purple-95:#f6f2fb;\n    --sds-g-color-palette-red-10:var(--slds-g-color-palette-red-10);\n    --slds-g-color-palette-red-10:#300c01;\n    --sds-g-color-palette-red-15:var(--slds-g-color-palette-red-15);\n    --slds-g-color-palette-red-15:#4a0c04;\n    --sds-g-color-palette-red-20:var(--slds-g-color-palette-red-20);\n    --slds-g-color-palette-red-20:#640103;\n    --sds-g-color-palette-red-30:var(--slds-g-color-palette-red-30);\n    --slds-g-color-palette-red-30:#8e030f;\n    --sds-g-color-palette-red-40:var(--slds-g-color-palette-red-40);\n    --slds-g-color-palette-red-40:#ba0517;\n    --sds-g-color-palette-red-50:var(--slds-g-color-palette-red-50);\n    --slds-g-color-palette-red-50:#ea001e;\n    --sds-g-color-palette-red-60:var(--slds-g-color-palette-red-60);\n    --slds-g-color-palette-red-60:#fe5c4c;\n    --sds-g-color-palette-red-65:var(--slds-g-color-palette-red-65);\n    --slds-g-color-palette-red-65:#fe7765;\n    --sds-g-color-palette-red-70:var(--slds-g-color-palette-red-70);\n    --slds-g-color-palette-red-70:#fe8f7d;\n    --sds-g-color-palette-red-80:var(--slds-g-color-palette-red-80);\n    --slds-g-color-palette-red-80:#feb8ab;\n    --sds-g-color-palette-red-90:var(--slds-g-color-palette-red-90);\n    --slds-g-color-palette-red-90:#feded8;\n    --sds-g-color-palette-red-95:var(--slds-g-color-palette-red-95);\n    --slds-g-color-palette-red-95:#fef1ee;\n    --sds-g-color-palette-teal-10:var(--slds-g-color-palette-teal-10);\n    --slds-g-color-palette-teal-10:#071b12;\n    --sds-g-color-palette-teal-15:var(--slds-g-color-palette-teal-15);\n    --slds-g-color-palette-teal-15:#072825;\n    --sds-g-color-palette-teal-20:var(--slds-g-color-palette-teal-20);\n    --slds-g-color-palette-teal-20:#023434;\n    --sds-g-color-palette-teal-30:var(--slds-g-color-palette-teal-30);\n    --slds-g-color-palette-teal-30:#024d4c;\n    --sds-g-color-palette-teal-40:var(--slds-g-color-palette-teal-40);\n    --slds-g-color-palette-teal-40:#056764;\n    --sds-g-color-palette-teal-50:var(--slds-g-color-palette-teal-50);\n    --slds-g-color-palette-teal-50:#0b827c;\n    --sds-g-color-palette-teal-60:var(--slds-g-color-palette-teal-60);\n    --slds-g-color-palette-teal-60:#06a59a;\n    --sds-g-color-palette-teal-65:var(--slds-g-color-palette-teal-65);\n    --slds-g-color-palette-teal-65:#03b4a7;\n    --sds-g-color-palette-teal-70:var(--slds-g-color-palette-teal-70);\n    --slds-g-color-palette-teal-70:#01c3b3;\n    --sds-g-color-palette-teal-80:var(--slds-g-color-palette-teal-80);\n    --slds-g-color-palette-teal-80:#04e1cb;\n    --sds-g-color-palette-teal-90:var(--slds-g-color-palette-teal-90);\n    --slds-g-color-palette-teal-90:#acf3e4;\n    --sds-g-color-palette-teal-95:var(--slds-g-color-palette-teal-95);\n    --slds-g-color-palette-teal-95:#def9f3;\n    --sds-g-color-palette-violet-10:var(--slds-g-color-palette-violet-10);\n    --slds-g-color-palette-violet-10:#2e0039;\n    --sds-g-color-palette-violet-15:var(--slds-g-color-palette-violet-15);\n    --slds-g-color-palette-violet-15:#3d0157;\n    --sds-g-color-palette-violet-20:var(--slds-g-color-palette-violet-20);\n    --slds-g-color-palette-violet-20:#481A54;\n    --sds-g-color-palette-violet-30:var(--slds-g-color-palette-violet-30);\n    --slds-g-color-palette-violet-30:#730394;\n    --sds-g-color-palette-violet-40:var(--slds-g-color-palette-violet-40);\n    --slds-g-color-palette-violet-40:#9602c7;\n    --sds-g-color-palette-violet-50:var(--slds-g-color-palette-violet-50);\n    --slds-g-color-palette-violet-50:#ba01ff;\n    --sds-g-color-palette-violet-60:var(--slds-g-color-palette-violet-60);\n    --slds-g-color-palette-violet-60:#cb65ff;\n    --sds-g-color-palette-violet-65:var(--slds-g-color-palette-violet-65);\n    --slds-g-color-palette-violet-65:#d17dfe;\n    --sds-g-color-palette-violet-70:var(--slds-g-color-palette-violet-70);\n    --slds-g-color-palette-violet-70:#d892fe;\n    --sds-g-color-palette-violet-80:var(--slds-g-color-palette-violet-80);\n    --slds-g-color-palette-violet-80:#e5b9fe;\n    --sds-g-color-palette-violet-90:var(--slds-g-color-palette-violet-90);\n    --slds-g-color-palette-violet-90:#f2defe;\n    --sds-g-color-palette-violet-95:var(--slds-g-color-palette-violet-95);\n    --slds-g-color-palette-violet-95:#f9f0ff;\n    --sds-g-color-palette-yellow-10:var(--slds-g-color-palette-yellow-10);\n    --slds-g-color-palette-yellow-10:#281202;\n    --sds-g-color-palette-yellow-15:var(--slds-g-color-palette-yellow-15);\n    --slds-g-color-palette-yellow-15:#2e2204;\n    --sds-g-color-palette-yellow-20:var(--slds-g-color-palette-yellow-20);\n    --slds-g-color-palette-yellow-20:#4f2100;\n    --sds-g-color-palette-yellow-30:var(--slds-g-color-palette-yellow-30);\n    --slds-g-color-palette-yellow-30:#6f3400;\n    --sds-g-color-palette-yellow-40:var(--slds-g-color-palette-yellow-40);\n    --slds-g-color-palette-yellow-40:#8c4b02;\n    --sds-g-color-palette-yellow-50:var(--slds-g-color-palette-yellow-50);\n    --slds-g-color-palette-yellow-50:#a86403;\n    --sds-g-color-palette-yellow-60:var(--slds-g-color-palette-yellow-60);\n    --slds-g-color-palette-yellow-60:#ca8501;\n    --sds-g-color-palette-yellow-65:var(--slds-g-color-palette-yellow-65);\n    --slds-g-color-palette-yellow-65:#d79304;\n    --sds-g-color-palette-yellow-70:var(--slds-g-color-palette-yellow-70);\n    --slds-g-color-palette-yellow-70:#e4a201;\n    --sds-g-color-palette-yellow-80:var(--slds-g-color-palette-yellow-80);\n    --slds-g-color-palette-yellow-80:#fcc003;\n    --sds-g-color-palette-yellow-90:var(--slds-g-color-palette-yellow-90);\n    --slds-g-color-palette-yellow-90:#f9e3b6;\n    --sds-g-color-palette-yellow-95:var(--slds-g-color-palette-yellow-95);\n    --slds-g-color-palette-yellow-95:#fbf3e0;\n    --sds-g-color-palette-neutral-10:var(--slds-g-color-palette-neutral-10);\n    --slds-g-color-palette-neutral-10:#181818;\n    --sds-g-color-palette-neutral-15:var(--slds-g-color-palette-neutral-15);\n    --slds-g-color-palette-neutral-15:#242424;\n    --sds-g-color-palette-neutral-20:var(--slds-g-color-palette-neutral-20);\n    --slds-g-color-palette-neutral-20:#2e2e2e;\n    --sds-g-color-palette-neutral-30:var(--slds-g-color-palette-neutral-30);\n    --slds-g-color-palette-neutral-30:#444444;\n    --sds-g-color-palette-neutral-40:var(--slds-g-color-palette-neutral-40);\n    --slds-g-color-palette-neutral-40:#5c5c5c;\n    --sds-g-color-palette-neutral-50:var(--slds-g-color-palette-neutral-50);\n    --slds-g-color-palette-neutral-50:#747474;\n    --sds-g-color-palette-neutral-60:var(--slds-g-color-palette-neutral-60);\n    --slds-g-color-palette-neutral-60:#939393;\n    --sds-g-color-palette-neutral-65:var(--slds-g-color-palette-neutral-65);\n    --slds-g-color-palette-neutral-65:#a0a0a0;\n    --sds-g-color-palette-neutral-70:var(--slds-g-color-palette-neutral-70);\n    --slds-g-color-palette-neutral-70:#aeaeae;\n    --sds-g-color-palette-neutral-80:var(--slds-g-color-palette-neutral-80);\n    --slds-g-color-palette-neutral-80:#c9c9c9;\n    --sds-g-color-palette-neutral-90:var(--slds-g-color-palette-neutral-90);\n    --slds-g-color-palette-neutral-90:#e5e5e5;\n    --sds-g-color-palette-neutral-95:var(--slds-g-color-palette-neutral-95);\n    --slds-g-color-palette-neutral-95:#f3f3f3;\n    --sds-g-color-palette-neutral-100:var(--slds-g-color-palette-neutral-100);\n    --slds-g-color-palette-neutral-100:#ffffff;\n    --sds-g-font-family-base:var(--slds-g-font-family-base);\n    --slds-g-font-family-base:system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';\n    --sds-g-font-family-monospace:var(--slds-g-font-family-monospace);\n    --slds-g-font-family-monospace:Consolas, Menlo, Monaco, Courier, monospace;\n    --slds-g-font-weight-ratio:1;\n    --sds-g-font-weight-bold:var(--slds-g-font-weight-bold);\n    --slds-g-font-weight-bold:bold;\n    --sds-g-font-weight-1:var(--slds-g-font-weight-1);\n    --slds-g-font-weight-1: calc(var(--slds-g-font-weight-ratio) * 100);\n    --sds-g-font-weight-2:var(--slds-g-font-weight-2);\n    --slds-g-font-weight-2: calc(var(--slds-g-font-weight-ratio) * 200);\n    --sds-g-font-weight-3:var(--slds-g-font-weight-3);\n    --slds-g-font-weight-3: calc(var(--slds-g-font-weight-ratio) * 300);\n    --sds-g-font-weight-4:var(--slds-g-font-weight-4);\n    --slds-g-font-weight-4: calc(var(--slds-g-font-weight-ratio) * 400);\n    --sds-g-font-weight-5:var(--slds-g-font-weight-5);\n    --slds-g-font-weight-5: calc(var(--slds-g-font-weight-ratio) * 500);\n    --sds-g-font-weight-6:var(--slds-g-font-weight-6);\n    --slds-g-font-weight-6: calc(var(--slds-g-font-weight-ratio) * 600);\n    --sds-g-font-weight-7:var(--slds-g-font-weight-7);\n    --slds-g-font-weight-7: calc(var(--slds-g-font-weight-ratio) * 700);\n    --slds-g-font-lineheight-ratio: 1;\n    --sds-g-font-lineheight-base:var(--slds-g-font-lineheight-base);\n    --slds-g-font-lineheight-base:1.5;\n    --sds-g-font-lineheight-1:var(--slds-g-font-lineheight-1);\n    --slds-g-font-lineheight-1: calc(var(--slds-g-font-lineheight-ratio) * 1);\n    --sds-g-font-lineheight-2:var(--slds-g-font-lineheight-2);\n    --slds-g-font-lineheight-2: calc(var(--slds-g-font-lineheight-ratio) * 1.25);\n    --sds-g-font-lineheight-3:var(--slds-g-font-lineheight-3);\n    --slds-g-font-lineheight-3: calc(var(--slds-g-font-lineheight-ratio) * 1.375);\n    --sds-g-font-lineheight-4:var(--slds-g-font-lineheight-4);\n    --slds-g-font-lineheight-4: calc(var(--slds-g-font-lineheight-ratio) * 1.5);\n    --sds-g-font-lineheight-5:var(--slds-g-font-lineheight-5);\n    --slds-g-font-lineheight-5: calc(var(--slds-g-font-lineheight-ratio) * 1.75);\n    --sds-g-font-lineheight-6:var(--slds-g-font-lineheight-6);\n    --slds-g-font-lineheight-6: calc(var(--slds-g-font-lineheight-ratio) * 2);\n    --sds-g-font-scale-ratio:var(--slds-g-font-scale-ratio);\n    --slds-g-font-scale-ratio:1;\n    --sds-g-font-size-base:var(--slds-g-font-size-base);\n    --slds-g-font-size-base: calc(var(--slds-g-font-scale-ratio) * 0.8125rem);\n    --sds-g-font-scale-neg-4:var(--slds-g-font-scale-neg-4);\n    --slds-g-font-scale-neg-4:var(--slds-g-font-scale-neg-3);\n    --sds-g-font-scale-neg-3:var(--slds-g-font-scale-neg-3);\n    --slds-g-font-scale-neg-3:var(--slds-g-font-scale-neg-2);\n    --sds-g-font-scale-neg-2:var(--slds-g-font-scale-neg-2);\n    --slds-g-font-scale-neg-2: calc(var(--slds-g-font-scale-ratio) * 0.625rem);\n    --sds-g-font-scale-neg-1:var(--slds-g-font-scale-neg-1);\n    --slds-g-font-scale-neg-1: calc(var(--slds-g-font-scale-ratio) * 0.75rem);\n    --sds-g-font-scale-1:var(--slds-g-font-scale-1);\n    --slds-g-font-scale-1: calc(var(--slds-g-font-scale-ratio) * 0.875rem);\n    --sds-g-font-scale-2:var(--slds-g-font-scale-2);\n    --slds-g-font-scale-2: calc(var(--slds-g-font-scale-ratio) * 1rem);\n    --sds-g-font-scale-3:var(--slds-g-font-scale-3);\n    --slds-g-font-scale-3: calc(var(--slds-g-font-scale-ratio) * 1.25rem);\n    --sds-g-font-scale-4:var(--slds-g-font-scale-4);\n    --slds-g-font-scale-4: calc(var(--slds-g-font-scale-ratio) * 1.5rem);\n    --sds-g-font-scale-5:var(--slds-g-font-scale-5);\n    --slds-g-font-scale-5: calc(var(--slds-g-font-scale-ratio) * 1.75rem);\n    --sds-g-font-scale-6:var(--slds-g-font-scale-6);\n    --slds-g-font-scale-6: calc(var(--slds-g-font-scale-ratio) * 2rem);\n    --sds-g-font-scale-7:var(--slds-g-font-scale-7);\n    --slds-g-font-scale-7: calc(var(--slds-g-font-scale-ratio) * 2.5rem);\n    --sds-g-font-scale-8:var(--slds-g-font-scale-8);\n    --slds-g-font-scale-8: calc(var(--slds-g-font-scale-ratio) * 3rem);\n    --sds-g-font-scale-9:var(--slds-g-font-scale-9);\n    --slds-g-font-scale-9:var(--slds-g-font-scale-8);\n    --sds-g-font-scale-10:var(--slds-g-font-scale-10);\n    --slds-g-font-scale-10:var(--slds-g-font-scale-8);\n    --sds-g-color-neutral-base-100:var(--slds-g-color-neutral-base-100);\n    --slds-g-color-neutral-base-100:#ffffff;\n    --sds-g-color-neutral-base-95:var(--slds-g-color-neutral-base-95);\n    --slds-g-color-neutral-base-95:#f3f3f3;\n    --sds-g-color-neutral-base-90:var(--slds-g-color-neutral-base-90);\n    --slds-g-color-neutral-base-90:#e5e5e5;\n    --sds-g-color-neutral-base-80:var(--slds-g-color-neutral-base-80);\n    --slds-g-color-neutral-base-80:#c9c9c9;\n    --sds-g-color-neutral-base-70:var(--slds-g-color-neutral-base-70);\n    --slds-g-color-neutral-base-70:#aeaeae;\n    --sds-g-color-neutral-base-65:var(--slds-g-color-neutral-base-65);\n    --slds-g-color-neutral-base-65:#a0a0a0;\n    --sds-g-color-neutral-base-60:var(--slds-g-color-neutral-base-60);\n    --slds-g-color-neutral-base-60:#939393;\n    --sds-g-color-neutral-base-50:var(--slds-g-color-neutral-base-50);\n    --slds-g-color-neutral-base-50:#747474;\n    --sds-g-color-neutral-base-40:var(--slds-g-color-neutral-base-40);\n    --slds-g-color-neutral-base-40:#5c5c5c;\n    --sds-g-color-neutral-base-30:var(--slds-g-color-neutral-base-30);\n    --slds-g-color-neutral-base-30:#444444;\n    --sds-g-color-neutral-base-20:var(--slds-g-color-neutral-base-20);\n    --slds-g-color-neutral-base-20:#2e2e2e;\n    --sds-g-color-neutral-base-15:var(--slds-g-color-neutral-base-15);\n    --slds-g-color-neutral-base-15:#242424;\n    --sds-g-color-neutral-base-10:var(--slds-g-color-neutral-base-10);\n    --slds-g-color-neutral-base-10:#181818;\n    --sds-g-color-brand-base-100:var(--slds-g-color-brand-base-100);\n    --slds-g-color-brand-base-100:#ffffff;\n    --sds-g-color-brand-base-95:var(--slds-g-color-brand-base-95);\n    --slds-g-color-brand-base-95:#edf4ff;\n    --sds-g-color-brand-base-90:var(--slds-g-color-brand-base-90);\n    --slds-g-color-brand-base-90:#d6e6ff;\n    --sds-g-color-brand-base-80:var(--slds-g-color-brand-base-80);\n    --slds-g-color-brand-base-80:#a8cbff;\n    --sds-g-color-brand-base-70:var(--slds-g-color-brand-base-70);\n    --slds-g-color-brand-base-70:#7cb1fe;\n    --sds-g-color-brand-base-65:var(--slds-g-color-brand-base-65);\n    --slds-g-color-brand-base-65:#5f9ffe;\n    --sds-g-color-brand-base-60:var(--slds-g-color-brand-base-60);\n    --slds-g-color-brand-base-60:#4992fe;\n    --sds-g-color-brand-base-50:var(--slds-g-color-brand-base-50);\n    --slds-g-color-brand-base-50:#066afe;\n    --sds-g-color-brand-base-40:var(--slds-g-color-brand-base-40);\n    --slds-g-color-brand-base-40:#0250d9;\n    --sds-g-color-brand-base-30:var(--slds-g-color-brand-base-30);\n    --slds-g-color-brand-base-30:#022ac0;\n    --sds-g-color-brand-base-20:var(--slds-g-color-brand-base-20);\n    --slds-g-color-brand-base-20:#002775;\n    --sds-g-color-brand-base-15:var(--slds-g-color-brand-base-15);\n    --slds-g-color-brand-base-15:#001e5b;\n    --sds-g-color-brand-base-10:var(--slds-g-color-brand-base-10);\n    --slds-g-color-brand-base-10:#001642;\n    --sds-g-color-error-base-100:var(--slds-g-color-error-base-100);\n    --slds-g-color-error-base-100:#ffffff;\n    --sds-g-color-error-base-90:var(--slds-g-color-error-base-90);\n    --slds-g-color-error-base-90:#fddde3;\n    --sds-g-color-error-base-80:var(--slds-g-color-error-base-80);\n    --slds-g-color-error-base-80:#fdb6c5;\n    --sds-g-color-error-base-70:var(--slds-g-color-error-base-70);\n    --slds-g-color-error-base-70:#fe8aa7;\n    --sds-g-color-error-base-60:var(--slds-g-color-error-base-60);\n    --slds-g-color-error-base-60:#ff538a;\n    --sds-g-color-error-base-50:var(--slds-g-color-error-base-50);\n    --slds-g-color-error-base-50:#e3066a;\n    --sds-g-color-error-base-40:var(--slds-g-color-error-base-40);\n    --slds-g-color-error-base-40:#b60554;\n    --sds-g-color-error-base-30:var(--slds-g-color-error-base-30);\n    --slds-g-color-error-base-30:#8a033e;\n    --sds-g-color-error-base-20:var(--slds-g-color-error-base-20);\n    --slds-g-color-error-base-20:#61022a;\n    --sds-g-color-error-base-10:var(--slds-g-color-error-base-10);\n    --slds-g-color-error-base-10:#370114;\n    --sds-g-color-warning-base-100:var(--slds-g-color-warning-base-100);\n    --slds-g-color-warning-base-100:#ffffff;\n    --sds-g-color-warning-base-90:var(--slds-g-color-warning-base-90);\n    --slds-g-color-warning-base-90:#f9e3b6;\n    --sds-g-color-warning-base-80:var(--slds-g-color-warning-base-80);\n    --slds-g-color-warning-base-80:#fcc003;\n    --sds-g-color-warning-base-70:var(--slds-g-color-warning-base-70);\n    --slds-g-color-warning-base-70:#e4a201;\n    --sds-g-color-warning-base-60:var(--slds-g-color-warning-base-60);\n    --slds-g-color-warning-base-60:#ca8501;\n    --sds-g-color-warning-base-50:var(--slds-g-color-warning-base-50);\n    --slds-g-color-warning-base-50:#a86403;\n    --sds-g-color-warning-base-40:var(--slds-g-color-warning-base-40);\n    --slds-g-color-warning-base-40:#8c4b02;\n    --sds-g-color-warning-base-30:var(--slds-g-color-warning-base-30);\n    --slds-g-color-warning-base-30:#6f3400;\n    --sds-g-color-warning-base-20:var(--slds-g-color-warning-base-20);\n    --slds-g-color-warning-base-20:#4f2100;\n    --sds-g-color-warning-base-10:var(--slds-g-color-warning-base-10);\n    --slds-g-color-warning-base-10:#281202;\n    --sds-g-color-success-base-100:var(--slds-g-color-success-base-100);\n    --slds-g-color-success-base-100:#ffffff;\n    --sds-g-color-success-base-90:var(--slds-g-color-success-base-90);\n    --slds-g-color-success-base-90:#acf3e4;\n    --sds-g-color-success-base-80:var(--slds-g-color-success-base-80);\n    --slds-g-color-success-base-80:#04e1cb;\n    --sds-g-color-success-base-70:var(--slds-g-color-success-base-70);\n    --slds-g-color-success-base-70:#01c3b3;\n    --sds-g-color-success-base-60:var(--slds-g-color-success-base-60);\n    --slds-g-color-success-base-60:#06a59a;\n    --sds-g-color-success-base-50:var(--slds-g-color-success-base-50);\n    --slds-g-color-success-base-50:#0b827c;\n    --sds-g-color-success-base-40:var(--slds-g-color-success-base-40);\n    --slds-g-color-success-base-40:#056764;\n    --sds-g-color-success-base-30:var(--slds-g-color-success-base-30);\n    --slds-g-color-success-base-30:#024d4c;\n    --sds-g-color-success-base-20:var(--slds-g-color-success-base-20);\n    --slds-g-color-success-base-20:#023434;\n    --sds-g-color-success-base-10:var(--slds-g-color-success-base-10);\n    --slds-g-color-success-base-10:#071b12;\n    --sds-g-color-border-1:var(--slds-g-color-border-1);\n    --slds-g-color-border-1:#c9c9c9;\n    --sds-g-color-border-2:var(--slds-g-color-border-2);\n    --slds-g-color-border-2:#5c5c5c;\n    --sds-g-color-border-accent-1:var(--slds-g-color-border-accent-1);\n    --slds-g-color-border-accent-1:#066afe;\n    --sds-g-color-border-accent-2:var(--slds-g-color-border-accent-2);\n    --slds-g-color-border-accent-2:#0250d9;\n    --sds-g-color-border-accent-3:var(--slds-g-color-border-accent-3);\n    --slds-g-color-border-accent-3:#022ac0;\n    --sds-g-color-surface-1:var(--slds-g-color-surface-1);\n    --slds-g-color-surface-1:#ffffff;\n    --sds-g-color-surface-2:var(--slds-g-color-surface-2);\n    --slds-g-color-surface-2:#f3f3f3;\n    --sds-g-color-surface-3:var(--slds-g-color-surface-3);\n    --slds-g-color-surface-3:#e5e5e5;\n    --sds-g-color-surface-container-1:var(--slds-g-color-surface-container-1);\n    --slds-g-color-surface-container-1:#ffffff;\n    --sds-g-color-surface-container-2:var(--slds-g-color-surface-container-2);\n    --slds-g-color-surface-container-2:#f3f3f3;\n    --sds-g-color-surface-container-3:var(--slds-g-color-surface-container-3);\n    --slds-g-color-surface-container-3:#e5e5e5;\n    --sds-g-color-on-surface-1:var(--slds-g-color-on-surface-1);\n    --slds-g-color-on-surface-1:#5c5c5c;\n    --sds-g-color-on-surface-2:var(--slds-g-color-on-surface-2);\n    --slds-g-color-on-surface-2:#2e2e2e;\n    --sds-g-color-on-surface-3:var(--slds-g-color-on-surface-3);\n    --slds-g-color-on-surface-3:#03234d;\n    --sds-g-color-accent-1:var(--slds-g-color-accent-1);\n    --slds-g-color-accent-1:#066afe;\n    --sds-g-color-accent-2:var(--slds-g-color-accent-2);\n    --slds-g-color-accent-2:#0250d9;\n    --sds-g-color-accent-3:var(--slds-g-color-accent-3);\n    --slds-g-color-accent-3:#022ac0;\n    --sds-g-color-accent-container-1:var(--slds-g-color-accent-container-1);\n    --slds-g-color-accent-container-1:#066afe;\n    --sds-g-color-accent-container-2:var(--slds-g-color-accent-container-2);\n    --slds-g-color-accent-container-2:#0250d9;\n    --sds-g-color-accent-container-3:var(--slds-g-color-accent-container-3);\n    --slds-g-color-accent-container-3:#022ac0;\n    --sds-g-color-on-accent-1:var(--slds-g-color-on-accent-1);\n    --slds-g-color-on-accent-1:#ffffff;\n    --sds-g-color-error-1:var(--slds-g-color-error-1);\n    --slds-g-color-error-1:#b60554;\n    --sds-g-color-error-container-1:var(--slds-g-color-error-container-1);\n    --slds-g-color-error-container-1:#fddde3;\n    --sds-g-color-on-error-1:var(--slds-g-color-on-error-1);\n    --slds-g-color-on-error-1:#b60554;\n    --sds-g-color-border-error-1:var(--slds-g-color-border-error-1);\n    --slds-g-color-border-error-1:#b60554;\n    --sds-g-color-warning-1:var(--slds-g-color-warning-1);\n    --slds-g-color-warning-1:#8c4b02;\n    --sds-g-color-warning-container-1:var(--slds-g-color-warning-container-1);\n    --slds-g-color-warning-container-1:#f9e3b6;\n    --sds-g-color-on-warning-1:var(--slds-g-color-on-warning-1);\n    --slds-g-color-on-warning-1:#8c4b02;\n    --sds-g-color-border-warning-1:var(--slds-g-color-border-warning-1);\n    --slds-g-color-border-warning-1:#dd7a01;\n    --sds-g-color-success-1:var(--slds-g-color-success-1);\n    --slds-g-color-success-1:#056764;\n    --sds-g-color-success-container-1:var(--slds-g-color-success-container-1);\n    --slds-g-color-success-container-1:#acf3e4;\n    --sds-g-color-on-success-1:var(--slds-g-color-on-success-1);\n    --slds-g-color-on-success-1:var(--slds-g-color-success-base-40);\n    --sds-g-color-border-success-1:var(--slds-g-color-border-success-1);\n    --slds-g-color-border-success-1:var(--slds-g-color-success-base-40);\n    --sds-g-color-info-1:var(--slds-g-color-info-1);\n    --slds-g-color-info-1:#0b5cab;\n    --sds-g-color-info-container-1:var(--slds-g-color-info-container-1);\n    --slds-g-color-info-container-1:#d8e6fe;\n    --sds-g-color-on-info-1:var(--slds-g-color-on-info-1);\n    --slds-g-color-on-info-1:#0b5cab;\n    --sds-g-color-disabled-1:var(--slds-g-color-disabled-1);\n    --slds-g-color-disabled-1:#c9c9c9;\n    --sds-g-color-disabled-container-1:var(--slds-g-color-disabled-container-1);\n    --slds-g-color-disabled-container-1:#ffffff;\n    --sds-g-color-on-disabled-1:var(--slds-g-color-on-disabled-1);\n    --slds-g-color-on-disabled-1:#c9c9c9;\n    --sds-g-color-border-disabled-1:var(--slds-g-color-border-disabled-1);\n    --slds-g-color-border-disabled-1:var(--slds-g-color-neutral-base-80);\n    --sds-g-shadow-blockstart-1:var(--slds-g-shadow-blockstart-1);\n    --slds-g-shadow-blockstart-1:0px 0px 1.5px 0px #00000017, 0px -1.4px 1.5px 0px #00000017, 0px 1px 1px 0px #00000009;\n    --sds-g-shadow-inlineend-1:var(--slds-g-shadow-inlineend-1);\n    --slds-g-shadow-inlineend-1:0px 0px 1.5px 0px #00000017, 1.4px 0px 1.5px 0px #00000017, -1px 0 1px 0 #00000009;\n    --sds-g-shadow-blockend-1:var(--slds-g-shadow-blockend-1);\n    --slds-g-shadow-blockend-1:var(--slds-g-shadow-1);\n    --sds-g-shadow-inlinestart-1:var(--slds-g-shadow-inlinestart-1);\n    --slds-g-shadow-inlinestart-1:0px 0px 1.5px 0px #00000017, -1.4px 0px 1.5px 0px #00000017, 1px 0px 1px 0px #00000009;\n    --sds-g-shadow-blockstart-2:var(--slds-g-shadow-blockstart-2);\n    --slds-g-shadow-blockstart-2:0px 0px 3px 0px #00000016, 0px -2.8px 3px 0px #00000016, 0px 1px 1.2px 0px #00000009;\n    --sds-g-shadow-inlineend-2:var(--slds-g-shadow-inlineend-2);\n    --slds-g-shadow-inlineend-2:0px 0px 3px 0px #00000016, 2.8px 0px 3px 0px #00000016, -1px 0px 1.2px 0px #00000009;\n    --sds-g-shadow-blockend-2:var(--slds-g-shadow-blockend-2);\n    --slds-g-shadow-blockend-2:var(--slds-g-shadow-2);\n    --sds-g-shadow-inlinestart-2:var(--slds-g-shadow-inlinestart-2);\n    --slds-g-shadow-inlinestart-2:0px 0px 3px 0px #00000016, -2.8px 0px 3px 0px #00000016, 1px 0px 1.2px 0px #00000009;\n    --sds-g-shadow-blockstart-3:var(--slds-g-shadow-blockstart-3);\n    --slds-g-shadow-blockstart-3:0px 0px 4.5px 0px #00000014, 0px -4.2px 4.5px 0px #00000017, 0px 1px 1.44px 0px #00000008;\n    --sds-g-shadow-inlineend-3:var(--slds-g-shadow-inlineend-3);\n    --slds-g-shadow-inlineend-3:0px 0px 4.5px 0px #00000014, 4.2px 0px 4.5px 0px #00000017, -1px 0px 1.44px 0px #00000008;\n    --sds-g-shadow-blockend-3:var(--slds-g-shadow-blockend-3);\n    --slds-g-shadow-blockend-3:var(--slds-g-shadow-3);\n    --sds-g-shadow-inlinestart-3:var(--slds-g-shadow-inlinestart-3);\n    --slds-g-shadow-inlinestart-3:0px 0px 4.5px 0px #00000014, -4.2px 0px 4.5px 0px #00000017, 1px 0px 1.44px 0px #00000008;\n    --sds-g-shadow-blockstart-4:var(--slds-g-shadow-blockstart-4);\n    --slds-g-shadow-blockstart-4:0px 0px 6.75px 0px #00000012, 0px -6.3px 6.75px 0px #00000012, 0px 1px 1.7px 0px #00000007;\n    --sds-g-shadow-inlineend-4:var(--slds-g-shadow-inlineend-4);\n    --slds-g-shadow-inlineend-4:0px 0px 6.75px 0px #00000012, 6.3px 0px 6.75px 0px #00000012, -1px 0px 1.7px 0px #00000007;\n    --sds-g-shadow-blockend-4:var(--slds-g-shadow-blockend-4);\n    --slds-g-shadow-blockend-4:var(--slds-g-shadow-4);\n    --sds-g-shadow-inlinestart-4:var(--slds-g-shadow-inlinestart-4);\n    --slds-g-shadow-inlinestart-4:0px 0px 6.75px 0px #00000012, -6.3px 0px 6.75px 0px #00000012, 1px 0px 1.7px 0px #00000007;\n    --sds-g-shadow-outline-focus-1:var(--slds-g-shadow-outline-focus-1);\n    --slds-g-shadow-outline-focus-1:0px 0px 0px 2px var(--slds-g-color-brand-base-15);\n    --sds-g-shadow-outset-focus-1:var(--slds-g-shadow-outset-focus-1);\n    --slds-g-shadow-outset-focus-1:0px 0px 0px 2px var(--slds-g-color-neutral-base-100), 0px 0px 0px 4px var(--slds-g-color-brand-base-15);\n    --sds-g-shadow-inset-focus-1:var(--slds-g-shadow-inset-focus-1);\n    --slds-g-shadow-inset-focus-1:0px 0px 0px 2px var(--slds-g-color-brand-base-15) inset;\n    --sds-g-shadow-insetinverse-focus-1:var(--slds-g-shadow-insetinverse-focus-1);\n    --slds-g-shadow-insetinverse-focus-1:0px 0px 0px 2px var(--slds-g-color-brand-base-15) inset, 0px 0px 0px 4px var(--slds-g-color-neutral-base-100) inset;\n    --sds-g-color-palette-electric-blue-10:var(--slds-g-color-palette-electric-blue-10);\n    --slds-g-color-palette-electric-blue-10:#001642;\n    --sds-g-color-palette-electric-blue-15:var(--slds-g-color-palette-electric-blue-15);\n    --slds-g-color-palette-electric-blue-15:#001e5b;\n    --sds-g-color-palette-electric-blue-20:var(--slds-g-color-palette-electric-blue-20);\n    --slds-g-color-palette-electric-blue-20:#002775;\n    --sds-g-color-palette-electric-blue-30:var(--slds-g-color-palette-electric-blue-30);\n    --slds-g-color-palette-electric-blue-30:#022ac0;\n    --sds-g-color-palette-electric-blue-40:var(--slds-g-color-palette-electric-blue-40);\n    --slds-g-color-palette-electric-blue-40:#0250d9;\n    --sds-g-color-palette-electric-blue-50:var(--slds-g-color-palette-electric-blue-50);\n    --slds-g-color-palette-electric-blue-50:#066afe;\n    --sds-g-color-palette-electric-blue-60:var(--slds-g-color-palette-electric-blue-60);\n    --slds-g-color-palette-electric-blue-60:#4992fe;\n    --sds-g-color-palette-electric-blue-65:var(--slds-g-color-palette-electric-blue-65);\n    --slds-g-color-palette-electric-blue-65:#5f9ffe;\n    --sds-g-color-palette-electric-blue-70:var(--slds-g-color-palette-electric-blue-70);\n    --slds-g-color-palette-electric-blue-70:#7cb1fe;\n    --sds-g-color-palette-electric-blue-80:var(--slds-g-color-palette-electric-blue-80);\n    --slds-g-color-palette-electric-blue-80:#a8cbff;\n    --sds-g-color-palette-electric-blue-90:var(--slds-g-color-palette-electric-blue-90);\n    --slds-g-color-palette-electric-blue-90:#d6e6ff;\n    --sds-g-color-palette-electric-blue-95:var(--slds-g-color-palette-electric-blue-95);\n    --slds-g-color-palette-electric-blue-95:#edf4ff;\n    --sds-g-color-accent-light-1:var(--slds-g-color-accent-light-1);\n    --slds-g-color-accent-light-1:#edf4ff;\n    --sds-g-color-accent-light-2:var(--slds-g-color-accent-light-2);\n    --slds-g-color-accent-light-2:#d6e6ff;\n    --sds-g-color-accent-dark-1:var(--slds-g-color-accent-dark-1);\n    --slds-g-color-accent-dark-1:#002775;\n    --sds-g-color-accent-dark-2:var(--slds-g-color-accent-dark-2);\n    --slds-g-color-accent-dark-2:#001642;\n    --sds-g-color-disabled-container-2:var(--slds-g-color-disabled-container-2);\n    --slds-g-color-disabled-container-2:#c9c9c9;\n    --sds-g-color-on-disabled-2:var(--slds-g-color-on-disabled-2);\n    --slds-g-color-on-disabled-2:#939393;\n    --sds-g-color-error-container-2:var(--slds-g-color-error-container-2);\n    --slds-g-color-error-container-2:#fdb6c5;\n    --sds-g-color-on-error-2:var(--slds-g-color-on-error-2);\n    --slds-g-color-on-error-2:#8a033e;\n    --sds-g-color-border-error-2:var(--slds-g-color-border-error-2);\n    --slds-g-color-border-error-2:#8a033e;\n    --sds-g-color-success-container-2:var(--slds-g-color-success-container-2);\n    --slds-g-color-success-container-2:#04e1cb;\n    --sds-g-color-on-success-2:var(--slds-g-color-on-success-2);\n    --slds-g-color-on-success-2:var(--slds-g-color-success-base-20);\n    --sds-g-color-surface-inverse-1:var(--slds-g-color-surface-inverse-1);\n    --slds-g-color-surface-inverse-1:#032d60;\n    --sds-g-color-surface-inverse-2:var(--slds-g-color-surface-inverse-2);\n    --slds-g-color-surface-inverse-2:#03234d;\n    --sds-g-color-surface-container-inverse-1:var(--slds-g-color-surface-container-inverse-1);\n    --slds-g-color-surface-container-inverse-1:#032d60;\n    --sds-g-color-surface-container-inverse-2:var(--slds-g-color-surface-container-inverse-2);\n    --slds-g-color-surface-container-inverse-2:#03234d;\n    --sds-g-color-on-surface-inverse-1:var(--slds-g-color-on-surface-inverse-1);\n    --slds-g-color-on-surface-inverse-1:#ffffff;\n    --sds-g-color-on-surface-inverse-2:var(--slds-g-color-on-surface-inverse-2);\n    --slds-g-color-on-surface-inverse-2:#a8cbff;\n    --sds-g-color-border-inverse-1:var(--slds-g-color-border-inverse-1);\n    --slds-g-color-border-inverse-1:#f3f3f3;\n    --sds-g-color-border-inverse-2:var(--slds-g-color-border-inverse-2);\n    --slds-g-color-border-inverse-2:#032d60;\n  }\n}\n@layer deprecated{\n  :where(html){\n    --lwc-brandPrimary:var(--slds-g-color-brand-base-60) !important;\n    --lwc-brandPrimaryActive:var(--slds-g-color-brand-base-50) !important;\n    --lwc-brandAccessible:var(--slds-g-color-brand-base-50) !important;\n    --lwc-brandAccessibleActive:var(--slds-g-color-brand-base-40) !important;\n    --lwc-brandContrast:var(--slds-g-color-brand-base-100) !important;\n    --lwc-brandContrastActive:var(--slds-g-color-brand-base-100) !important;\n    --lwc-brandLight:var(--slds-g-color-brand-base-95) !important;\n    --lwc-brandLightActive:var(--slds-g-color-brand-base-90) !important;\n    --lwc-brandDark:var(--slds-g-color-brand-base-20) !important;\n    --lwc-brandDarkActive:var(--slds-g-color-brand-base-10) !important;\n    --lwc-brandTextLink:var(--slds-g-color-brand-base-50) !important;\n    --lwc-brandTextLinkActive:var(--slds-g-color-brand-base-40) !important;\n\n    --lwc-varSpacingXxxSmall: 0.125rem;\n    --lwc-varSpacingXxSmall: 0.25rem;\n    --lwc-varSpacingXSmall: 0.5rem;\n    --lwc-varSpacingSmall: 0.75rem;\n    --lwc-varSpacingMedium: 1rem;\n    --lwc-varSpacingLarge: 1.5rem;\n    --lwc-varSpacingXLarge: 2rem;\n    --lwc-varSpacingXxLarge: 3rem;\n\n\n    --lwc-varSpacingHorizontalXxxSmall: 0.125rem;\n    --lwc-varSpacingHorizontalXxSmall: 0.25rem;\n    --lwc-varSpacingHorizontalXSmall: 0.5rem;\n    --lwc-varSpacingHorizontalSmall: 0.75rem;\n    --lwc-varSpacingHorizontalMedium: 1rem;\n    --lwc-varSpacingHorizontalLarge: 1.5rem;\n    --lwc-varSpacingHorizontalXLarge: 2rem;\n    --lwc-varSpacingHorizontalXxLarge: 3rem;\n\n\n    \n    --lwc-varSpacingVerticalXxxSmall: 0.125rem;\n    --lwc-varSpacingVerticalXxSmall: 0.25rem;\n    --lwc-varSpacingVerticalXSmall: 0.5rem;\n    --lwc-varSpacingVerticalSmall: 0.75rem;\n    --lwc-varSpacingVerticalMedium: 1rem;\n    --lwc-varSpacingVerticalLarge: 1.5rem;\n    --lwc-varSpacingVerticalXLarge: 2rem;\n    --lwc-varSpacingVerticalXxLarge: 3rem;\n  }\n}\n@layer shared{\n  :where(html){\n    --sds-s-table-color:var(--slds-s-table-color);\n    --slds-s-table-color:var(--slds-g-color-on-surface-1);\n    --sds-s-table-header-color-background:var(--slds-s-table-header-color-background);\n    --slds-s-table-header-color-background:var(--slds-g-color-surface-container-2);\n    --sds-s-table-header-color-background-hover:var(--slds-s-table-header-color-background-hover);\n    --slds-s-table-header-color-background-hover:var(--slds-g-color-surface-container-3);\n    --sds-s-table-header-color-background-selected:var(--slds-s-table-header-color-background-selected);\n    --slds-s-table-header-color-background-selected:var(--slds-g-color-surface-container-1);\n    --sds-s-table-header-color:var(--slds-s-table-header-color);\n    --slds-s-table-header-color:var(--slds-g-color-on-surface-1);\n    --sds-s-table-header-font-weight:var(--slds-s-table-header-font-weight);\n    --slds-s-table-header-font-weight:var(--slds-g-font-weight-6);\n    --sds-s-table-resize-color:var(--slds-s-table-resize-color);\n    --slds-s-table-resize-color:var(--slds-g-color-border-1);\n    --sds-s-table-resize-color-active:var(--slds-s-table-resize-color-active);\n    --slds-s-table-resize-color-active:var(--slds-g-color-accent-3);\n    --sds-s-table-row-color-background-selected:var(--slds-s-table-row-color-background-selected);\n    --slds-s-table-row-color-background-selected:var(--slds-g-color-brand-base-90);\n    --sds-s-table-row-color-border-selected-hover:var(--slds-s-table-row-color-border-selected-hover);\n    --slds-s-table-row-color-border-selected-hover:var(--slds-g-color-border-accent-2);\n    --sds-s-table-cell-shadow-selected:var(--slds-s-table-cell-shadow-selected);\n    --slds-s-table-cell-shadow-selected:var(--slds-g-color-brand-base-15) 0 0 0 2px inset;\n    --sds-s-pill-color-background-hover:var(--slds-s-pill-color-background-hover);\n    --slds-s-pill-color-background-hover:var(--slds-g-color-brand-base-90);\n    --sds-s-pageheader-color-background:var(--slds-s-pageheader-color-background);\n    --slds-s-pageheader-color-background:var(--slds-g-color-surface-container-2);\n    --sds-s-pageheader-row-color-background:var(--slds-s-pageheader-row-color-background);\n    --slds-s-pageheader-row-color-background:var(--slds-g-color-surface-container-2);\n    --sds-s-pageheader-radius-border:var(--slds-s-pageheader-radius-border);\n    --slds-s-pageheader-radius-border:0;\n    --sds-s-pageheader-title-font-size:var(--slds-s-pageheader-title-font-size);\n    --slds-s-pageheader-title-font-size:var(--slds-g-font-scale-5);\n    --sds-s-pageheader-title-font-weight:var(--slds-s-pageheader-title-font-weight);\n    --slds-s-pageheader-title-font-weight:var(--slds-g-font-weight-4);\n    --sds-s-pageheader-sizing-border:var(--slds-s-pageheader-sizing-border);\n    --slds-s-pageheader-sizing-border:0;\n    --sds-s-pageheader-shadow:var(--slds-s-pageheader-shadow);\n    --slds-s-pageheader-shadow:none;\n    --sds-s-pageheader-action-bottom-spacing:var(--slds-s-pageheader-action-bottom-spacing);\n    --slds-s-pageheader-action-bottom-spacing:var(--slds-g-spacing-1);\n    --sds-s-navigation-color-background:var(--slds-s-navigation-color-background);\n    --slds-s-navigation-color-background:var(--slds-g-color-surface-container-1);\n    --sds-s-navigation-color-background-active:var(--slds-s-navigation-color-background-active);\n    --slds-s-navigation-color-background-active:var(--slds-g-color-surface-container-1);\n    --sds-s-navigation-color-background-hover:var(--slds-s-navigation-color-background-hover);\n    --slds-s-navigation-color-background-hover:var(--slds-g-color-brand-base-90);\n    --sds-s-navigation-color:var(--slds-s-navigation-color);\n    --slds-s-navigation-color:var(--slds-g-color-on-surface-1);\n    --sds-s-navigation-color-active:var(--slds-s-navigation-color-active);\n    --slds-s-navigation-color-active:var(--slds-g-color-accent-3);\n    --sds-s-navigation-color-hover:var(--slds-s-navigation-color-hover);\n    --slds-s-navigation-color-hover:var(--slds-g-color-brand-base-15);\n    --sds-s-navigation-color-border:var(--slds-s-navigation-color-border);\n    --slds-s-navigation-color-border:var(--slds-g-color-neutral-base-80);\n    --sds-s-navigation-color-border-hover:var(--slds-s-navigation-color-border-hover);\n    --slds-s-navigation-color-border-hover:var(--slds-g-color-brand-base-15);\n    --sds-s-navigation-sizing-border-hover:var(--slds-s-navigation-sizing-border-hover);\n    --slds-s-navigation-sizing-border-hover:3px;\n    --sds-s-navigation-sizing-border-active:var(--slds-s-navigation-sizing-border-active);\n    --slds-s-navigation-sizing-border-active:3px;\n    --sds-s-navigation-font-weight:var(--slds-s-navigation-font-weight);\n    --slds-s-navigation-font-weight:600;\n    --sds-s-navigation-font-weight-active:var(--slds-s-navigation-font-weight-active);\n    --slds-s-navigation-font-weight-active:600;\n    --sds-s-navigation-sizing-height:var(--slds-s-navigation-sizing-height);\n    --slds-s-navigation-sizing-height:2.5rem;\n    --sds-s-navigation-font-lineheight:var(--slds-s-navigation-font-lineheight);\n    --slds-s-navigation-font-lineheight:2.5rem;\n    --sds-s-menu-item-color-background-active:var(--slds-s-menu-item-color-background-active);\n    --slds-s-menu-item-color-background-active:var(--slds-g-color-brand-base-90);\n    --sds-s-menu-item-color-active:var(--slds-s-menu-item-color-active);\n    --slds-s-menu-item-color-active:var(--slds-g-color-accent-1);\n    --sds-s-mark-color-foreground-checked:var(--slds-s-mark-color-foreground-checked);\n    --slds-s-mark-color-foreground-checked:var(--slds-g-color-on-accent-1);\n    --sds-s-mark-color-background:var(--slds-s-mark-color-background);\n    --slds-s-mark-color-background:var(--slds-g-color-surface-container-1);\n    --sds-s-mark-color-background-checked:var(--slds-s-mark-color-background-checked);\n    --slds-s-mark-color-background-checked:var(--slds-g-color-accent-container-1);\n    --sds-s-mark-color-foreground-invalid:var(--slds-s-mark-color-foreground-invalid);\n    --slds-s-mark-color-foreground-invalid:var(--slds-g-color-error-base-100);\n    --sds-s-mark-color-background-invalid:var(--slds-s-mark-color-background-invalid);\n    --slds-s-mark-color-background-invalid:var(--slds-g-color-error-base-40);\n    --sds-s-mark-shadow-focus:var(--slds-s-mark-shadow-focus);\n    --slds-s-mark-shadow-focus:0 0 0 2px var(--slds-g-color-surface-1), 0 0 0 4px var(--slds-g-color-brand-base-15);\n    --sds-s-mark-shadow-checked:var(--slds-s-mark-shadow-checked);\n    --slds-s-mark-shadow-checked:0px 1px 0px 0px rgba(0, 0, 0, 0.08) inset, 0px 0.5px 2px 0px rgba(0, 0, 0, 0.08) inset, 2px 2px 5px 0px rgba(0, 0, 0, 0.08) inset;\n    --sds-s-link-color:var(--slds-s-link-color);\n    --slds-s-link-color:var(--slds-g-color-accent-2);\n    --sds-s-link-color-hover:var(--slds-s-link-color-hover);\n    --slds-s-link-color-hover:var(--slds-g-color-accent-3);\n    --sds-s-link-color-focus:var(--slds-s-link-color-focus);\n    --slds-s-link-color-focus:var(--slds-g-color-accent-3);\n    --sds-s-link-color-active:var(--slds-s-link-color-active);\n    --slds-s-link-color-active:var(--slds-g-color-accent-3);\n    --sds-s-link-shadow-focus:var(--slds-s-link-shadow-focus);\n    --slds-s-link-shadow-focus:0 0 0 2px var(--slds-g-color-surface-1), 0 0 0 4px var(--slds-g-color-brand-base-15);\n    --sds-s-label-color:var(--slds-s-label-color);\n    --slds-s-label-color:var(--slds-g-color-on-surface-1);\n    --sds-s-label-font-size:var(--slds-s-label-font-size);\n    --slds-s-label-font-size:var(--slds-g-font-size-base);\n    --sds-s-label-font-weight:var(--slds-s-label-font-weight);\n    --slds-s-label-font-weight:var(--slds-g-font-weight-4);\n    --sds-s-label-spacing:var(--slds-s-label-spacing);\n    --slds-s-label-spacing:var(--slds-g-spacing-2);\n    --sds-s-label-spacing-gap:var(--slds-s-label-spacing-gap);\n    --slds-s-label-spacing-gap:var(--slds-g-spacing-1);\n    --sds-s-input-radius-border:var(--slds-s-input-radius-border);\n    --slds-s-input-radius-border:var(--slds-g-radius-border-2);\n    --sds-s-input-color-background:var(--slds-s-input-color-background);\n    --slds-s-input-color-background:var(--slds-g-color-surface-container-1);\n    --sds-s-input-color-background-disabled:var(--slds-s-input-color-background-disabled);\n    --slds-s-input-color-background-disabled:var(--slds-g-color-disabled-container-1);\n    --sds-s-input-color-background-invalid:var(--slds-s-input-color-background-invalid);\n    --slds-s-input-color-background-invalid:var(--slds-g-color-palette-pink-95);\n    --sds-s-input-color-border:var(--slds-s-input-color-border);\n    --slds-s-input-color-border:var(--slds-g-color-border-2);\n    --sds-s-input-color-border-disabled:var(--slds-s-input-color-border-disabled);\n    --slds-s-input-color-border-disabled:var(--slds-g-color-border-disabled-1);\n    --sds-s-input-color-border-focus:var(--slds-s-input-color-border-focus);\n    --slds-s-input-color-border-focus:var(--slds-g-color-border-2);\n    --sds-s-input-spacing:var(--slds-s-input-spacing);\n    --slds-s-input-spacing:var(--slds-g-spacing-2);\n    --sds-s-input-color:var(--slds-s-input-color);\n    --slds-s-input-color:var(--slds-g-color-on-surface-2);\n    --sds-s-input-color-disabled:var(--slds-s-input-color-disabled);\n    --slds-s-input-color-disabled:var(--slds-g-color-on-disabled-1);\n    --sds-s-input-color-invalid:var(--slds-s-input-color-invalid);\n    --slds-s-input-color-invalid:var(--slds-g-color-palette-pink-40);\n    --sds-s-input-shadow-focus:var(--slds-s-input-shadow-focus);\n    --slds-s-input-shadow-focus:2px 2px 5px 0px rgba(0, 0, 0, 0.08) inset, 0px 0.5px 2px 0px rgba(0, 0, 0, 0.35) inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.15) inset, 0 0 0 2px var(--slds-g-color-surface-1), 0 0 0 4px var(--slds-g-color-brand-base-15);\n    --sds-s-input-shadow-invalid:var(--slds-s-input-shadow-invalid);\n    --slds-s-input-shadow-invalid:none;\n    --sds-s-icon-color-foreground:var(--slds-s-icon-color-foreground);\n    --slds-s-icon-color-foreground:var(--slds-g-color-on-surface-1);\n    --sds-s-icon-radius-border:var(--slds-s-icon-radius-border);\n    --slds-s-icon-radius-border:var(--slds-g-radius-border-circle);\n    --sds-s-helptext-color:var(--slds-s-helptext-color);\n    --slds-s-helptext-color:var(--slds-g-color-on-surface-1);\n    --sds-s-helptext-font-size:var(--slds-s-helptext-font-size);\n    --slds-s-helptext-font-size:var(--slds-g-font-scale-neg-1);\n    --sds-s-helptext-spacing:var(--slds-s-helptext-spacing);\n    --slds-s-helptext-spacing:var(--slds-g-spacing-1);\n    --sds-s-header-sizing-height:var(--slds-s-header-sizing-height);\n    --slds-s-header-sizing-height:3.125rem;\n    --sds-s-container-color:var(--slds-s-container-color);\n    --slds-s-container-color:var(--slds-g-color-on-surface-1);\n    --sds-s-container-shadow:var(--slds-s-container-shadow);\n    --slds-s-container-shadow:none;\n    --sds-s-container-footer-sizing-border:var(--slds-s-container-footer-sizing-border);\n    --slds-s-container-footer-sizing-border:var(--slds-g-sizing-border-1);\n    --sds-s-container-color-border:var(--slds-s-container-color-border);\n    --slds-s-container-color-border:transparent;\n    --sds-s-container-sizing-border:var(--slds-s-container-sizing-border);\n    --slds-s-container-sizing-border:0;\n    --sds-s-container-radius-border:var(--slds-s-container-radius-border);\n    --slds-s-container-radius-border:var(--slds-g-radius-border-4);\n    --sds-s-container-heading-font-color:var(--slds-s-container-heading-font-color);\n    --slds-s-container-heading-font-color:var(--slds-g-color-on-surface-3);\n    --sds-s-container-heading-font-size:var(--slds-s-container-heading-font-size);\n    --slds-s-container-heading-font-size:var(--slds-g-font-scale-3);\n    --sds-s-container-heading-font-weight:var(--slds-s-container-heading-font-weight);\n    --slds-s-container-heading-font-weight:var(--slds-g-font-weight-4);\n    --sds-s-container-heading-font-align:var(--slds-s-container-heading-font-align);\n    --slds-s-container-heading-font-align:left;\n    --sds-s-container-footer-font-align:var(--slds-s-container-footer-font-align);\n    --slds-s-container-footer-font-align:right;\n    --sds-s-container-footer-font-color:var(--slds-s-container-footer-font-color);\n    --slds-s-container-footer-font-color:var(--slds-g-color-on-surface-2);\n    --sds-s-container-footer-color-background:var(--slds-s-container-footer-color-background);\n    --slds-s-container-footer-color-background:var(--slds-g-color-surface-container-1);\n    --sds-s-container-content-color:var(--slds-s-container-content-color);\n    --slds-s-container-content-color:var(--slds-g-color-on-surface-1);\n    --sds-s-button-color-background:var(--slds-s-button-color-background);\n    --slds-s-button-color-background:var(--slds-g-color-surface-container-1);\n    --sds-s-button-color-background-hover:var(--slds-s-button-color-background-hover);\n    --slds-s-button-color-background-hover:var(--slds-g-color-brand-base-90);\n    --sds-s-button-color-background-focus:var(--slds-s-button-color-background-focus);\n    --slds-s-button-color-background-focus:var(--slds-g-color-surface-container-2);\n    --sds-s-button-color-background-active:var(--slds-s-button-color-background-active);\n    --slds-s-button-color-background-active:var(--slds-g-color-surface-container-2);\n    --sds-s-button-color-border:var(--slds-s-button-color-border);\n    --slds-s-button-color-border:var(--slds-g-color-border-2);\n    --sds-s-button-shadow-focus:var(--slds-s-button-shadow-focus);\n    --slds-s-button-shadow-focus:0 0 0 2px var(--slds-g-color-surface-1), 0 0 0 4px var(--slds-g-color-brand-base-15);\n    --sds-s-button-shadow-focus-inverse:var(--slds-s-button-shadow-focus-inverse);\n    --slds-s-button-shadow-focus-inverse:0 0 0 2px var(--slds-g-color-brand-base-15), 0 0 0 4px var(--slds-g-color-surface-1);\n    --sds-s-button-shadow-active:var(--slds-s-button-shadow-active);\n    --slds-s-button-shadow-active:2px 2px 5px 0px rgba(0, 0, 0, 0.08) inset, 0px 0.5px 2px 0px rgba(0, 0, 0, 0.35) inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.15) inset;\n    --sds-s-button-radius-border:var(--slds-s-button-radius-border);\n    --slds-s-button-radius-border:var(--slds-g-radius-border-pill);\n    --sds-s-button-color:var(--slds-s-button-color);\n    --slds-s-button-color:var(--slds-g-color-accent-2);\n    --sds-s-button-color-hover:var(--slds-s-button-color-hover);\n    --slds-s-button-color-hover:var(--slds-g-color-on-surface-3);\n    --sds-s-button-spacing-inline:var(--slds-s-button-spacing-inline);\n    --slds-s-button-spacing-inline:var(--slds-g-spacing-4);\n    --sds-s-backdrop-color-background:var(--slds-s-backdrop-color-background);\n    --slds-s-backdrop-color-background:rgba(92, 92, 92, 0.80);\n    --sds-s-avatar-radius-border:var(--slds-s-avatar-radius-border);\n    --slds-s-avatar-radius-border:var(--slds-g-radius-border-circle);\n    --sds-s-alert-font-weight:var(--slds-s-alert-font-weight);\n    --slds-s-alert-font-weight:var(--slds-g-font-weight-6);\n    --sds-s-alert-close-button-hover:var(--slds-s-alert-close-button-hover);\n    --slds-s-alert-close-button-hover:var(--slds-g-color-on-surface-3);\n  }\n}\n@layer component{\n  :where(html){\n    --_slds-c-path-item-color-background-active:var(--slds-g-color-surface-container-inverse-1);\n    --_slds-c-path-item-color-background-active-hover:var(--slds-g-color-surface-container-inverse-2);\n    --_slds-c-path-item-color-background-incomplete:var(--slds-g-color-surface-container-3);\n    --_slds-c-path-item-color-incomplete:var(--slds-g-color-on-surface-2);\n    --_slds-c-path-item-color-background-incomplete-hover:var(--slds-g-color-neutral-base-70);\n    --_slds-c-path-item-color-background-complete:var(--slds-g-color-success-container-1);\n    --_slds-c-path-item-color-background-complete-hover:var(--slds-g-color-success-container-1);\n    --_slds-c-path-item-color-background-success:var(--slds-g-color-success-container-1);\n    --_slds-c-path-item-color-background-error:var(--slds-g-color-error-container-1);\n    --_slds-c-path-item-sizing-border:0.0625rem;\n    --_slds-c-path-item-sizing-height:1.875rem;\n    --_slds-c-globalnavigation-sizing-border:0;\n    --_slds-c-globalnavigation-spacing-block:var(--slds-g-spacing-1);\n    --_slds-c-globalnavigation-spacing-gap:var(--slds-g-spacing-1);\n    --_slds-c-globalnavigation-item-sizing-width-max:var(--slds-g-sizing-15);\n    --_slds-c-globalnavigation-item-sizing-border:0;\n    --_slds-c-globalnavigation-item-radius-border:var(--slds-g-radius-border-3);\n    --_slds-c-globalnavigation-item-sizing-border-hover:3px;\n    --_slds-c-globalnavigation-item-sizing-border-active:0;\n    --_slds-c-globalnavigation-item-color-background-hover:transparent;\n    --_slds-c-globalnavigation-item-color-background-active:transparent;\n    --_slds-c-globalnavigation-item-color-border-success:var(--slds-g-color-on-success-1);\n    --_slds-c-globalnavigation-item-color-border-error:var(--slds-g-color-on-error-1);\n    --_slds-c-globalnavigation-item-color-border-warning:var(--slds-g-color-on-warning-1);\n    --_slds-c-globalnavigation-item-color-border-hover:var(--slds-g-color-brand-base-15);\n    --_slds-c-globalnavigation-item-color-border-active:var(--slds-g-color-accent-2);\n    --_slds-c-globalnavigation-item-shadow-focus:0 0 0 2px var(--slds-g-color-brand-base-15) inset;\n    --_slds-c-globalnavigation-font-decoration-focus:none;\n    --_slds-c-globalnavigation-font-weight:500;\n    --_slds-c-globalnavigation-app-font-weight:var(--slds-g-font-weight-4);\n    --_slds-c-globalnavigation-item-color-active:var(--slds-g-color-accent-2);\n    --_slds-c-globalnavigation-subtab-color-background-active:var(--slds-g-color-brand-base-90);\n    --_slds-c-globalnavigation-subtab-color-background-hover:var(--slds-g-color-surface-container-2);\n    --_slds-c-globalheader-color-background:#ffffff;\n    --_slds-c-globalheader-color:#5c5c5c;\n    --_slds-c-globalheader-color-hover:#444444;\n    --_slds-c-utilitybar-sizing-border-hover:3px;\n    --_slds-c-utilitybar-sizing-border-active:3px;\n    --_slds-c-utilitybar-color-border-hover:var(--slds-g-color-brand-base-15);\n    --_slds-c-utilitybar-color-border-active:var(--slds-g-color-accent-2);\n    --_slds-c-utilitybar-color-background-hover:var(--slds-g-color-surface-1);\n    --_slds-c-utilitybar-color-background-active:var(--slds-g-color-surface-1);\n    --_slds-c-utilitybar-color:var(--slds-g-color-on-surface-1);\n    --_slds-c-utilitybar-color-hover:var(--slds-g-color-brand-base-15);\n    --_slds-c-utilitybar-color-active:var(--slds-g-color-accent-2);\n    --_slds-c-utilitybar-font-weight:var(--slds-g-font-weight-6);\n    --_slds-c-brandband-scrim-sizing-height:0;\n    --_slds-c-brandband-sizing-height-small:0;\n    --_slds-c-brandband-sizing-height-medium:0;\n    --_slds-c-brandband-sizing-height-large:0;\n  }\n}\n@layer core {\n*,\n*::before,\n*::after{\n  box-sizing:border-box;\n}\nhtml{\n  font-family:var(--slds-g-font-family-base);\n  font-size:100%;\n  line-height:var(--slds-g-font-lineheight-base);\n  background:var(--slds-g-color-surface-2);\n  color:var(--slds-g-color-on-surface-3);\n  -webkit-tap-highlight-color:transparent;\n}\nbody{\n  font-size:var(--slds-g-font-size-base, 0.8125rem);\n  background:transparent;\n}\n::placeholder{\n  color:var(--slds-g-color-on-surface-1);\n  font-weight:var(--slds-g-font-weight-4);\n  opacity:1;\n}\n::selection{\n  background:var(--slds-g-color-brand-base-90);\n  text-shadow:none;\n  color:var(--slds-g-color-brand-base-15);\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nol,\nul,\ndl,\nfieldset{\n  margin:0;\n  padding:0;\n}\ndd,\nfigure{\n  margin:0;\n}\nabbr[title]{\n  text-decoration:none;\n  border:0;\n  cursor:help;\n}\nfieldset{\n  border:0;\n}\nhr{\n  border:0;\n  padding:0;\n  display:block;\n  margin-block:var(--slds-g-spacing-6);\n  margin-inline:0;\n  border-block-start:1px solid var(--slds-g-color-border-1);\n  height:1px;\n  clear:both;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6{\n  font-weight:inherit;\n  font-size:1em;\n}\nol,\nul{\n  list-style:none;\n}\na{\n  color:var(--slds-s-link-color);\n  text-decoration:none;\n  transition:color 0.1s linear;\n}\na:hover,\na:focus-visible{\n  text-decoration:underline;\n  color:var(--slds-s-link-color-hover);\n}\na:active{\n  color:var(--slds-s-link-color-active);\n}\na:focus-visible{\n  outline-color:var(--slds-g-color-accent-2);\n}\na,\nbutton{\n  cursor:pointer;\n}\nbutton{\n  padding:0;\n}\n/* button,\ninput,\noptgroup,\nselect,\ntextarea{\n  font:inherit;\n} */\nb,\nstrong,\ndfn{\n  font-weight:var(--slds-g-font-weight-7);\n}\nmark{\n  background-color:var(--slds-g-color-palette-yellow-90);\n  color:var(--slds-g-color-neutral-base-10);\n}\ninput[type='search']{\n  box-sizing:border-box;\n}\ntable{\n  width:100%;\n  border-collapse:collapse;\n  border-spacing:0;\n}\ncaption,\nth,\ntd{\n  text-align:left;\n}\naudio,\ncanvas,\niframe,\nimg,\nsvg,\nvideo{\n  vertical-align:middle;\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary{\n  display:block;\n}\nimg{\n  max-width:100%;\n  height:auto;\n}\n.slds-icon-standard-header-discounts{\n  --slds-c-icon-color-background:rgb(92, 92, 92);\n}\n.slds-icon-standard-contact{\n  --slds-c-icon-color-background:rgb(150, 2, 199);\n}\n.slds-icon-standard-prep-flow{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-crypto-transaction{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-multi-select-checkbox{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-work-order{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-post{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-global-constant{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-change-request{\n  --slds-c-icon-color-background:rgb(5, 103, 100);\n}\n.slds-icon-standard-indicator-performance-period{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-data-cloud{\n  --slds-c-icon-color-background:rgb(90, 27, 169);\n}\n.slds-icon-standard-carousel{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-account-score{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-work-contract{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-impact-strategy-assignment{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-resource-skill{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-system-and-global-variable{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-segments{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-account-info{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-prompt-builder{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-goals{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-tour-check{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-adjust-value{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-case-wrap-up{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-investment-account{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-store{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-slider{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-output{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-medication-ingredient{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-store-group{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-all{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-service-territory-policy{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-slack-conversations{\n  --slds-c-icon-color-background:rgb(72, 26, 84);\n}\n.slds-icon-standard-picklist-choice{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-choice{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-funding-requirement{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-your-account{\n  --slds-c-icon-color-background:rgb(1, 68, 134);\n}\n.slds-icon-standard-app{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-default{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-case-milestone{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-operation-plan{\n  --slds-c-icon-color-background:rgb(90, 27, 169);\n}\n.slds-icon-standard-today{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-buyer-account{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-lead-list{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-list-rate{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-work-plan-template{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-tableau{\n  --slds-c-icon-color-background:rgb(15, 30, 60);\n}\n.slds-icon-standard-shift{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-people-score{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-product-item-transaction{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-person-language{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-apex{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-reply-text{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-answer-private{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-immunization{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-asset-downtime-period{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-opportunity-contact-role{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-retail-banking-console{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-channel-program-members{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-apps-admin{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-metric-definition{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-datadotcom{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-settings{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-network-contract{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-crypto-transaction-envelope-item{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-product-item{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-metrics{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-topic2{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-partner-fund-allocation{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-care-request-reviewer{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-indicator-definition{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-crypto-transaction-envelope-change-snapshot{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-standard-operation-plan-step-execution{\n  --slds-c-icon-color-background:rgb(90, 27, 169);\n}\n.slds-icon-standard-approval{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-work-queue{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-iot-orchestrations{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-visualforce-page{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-person-account{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-entity{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-dynamic-highlights-panel{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-service-territory-location{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-qualifications{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-document-preview{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-tax-treatment{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-entitlement-policy{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-form{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-query-editor{\n  --slds-c-icon-color-background:rgb(126, 38, 0);\n}\n.slds-icon-standard-visualization{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-products{\n  --slds-c-icon-color-background:rgb(90, 27, 169);\n}\n.slds-icon-standard-prompt{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-order-item{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-read-receipts{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-javascript-button{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-maintenance-asset{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-work-plan-rule{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-loop{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-portal-roles-and-subordinates{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-work-capacity-limit{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-employee-organization{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-workforce-engagement{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-constant{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-marketing-actions{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-case-transcript{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-list-fee{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-timesheet-entry{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-key-dates{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-multi-picklist{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-facility-bed{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-product-workspace{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-visit-templates{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-restriction-policy{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-task{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-scheduling-workspace-territory{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-answer-best{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-attach{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-asset-action{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-section{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-service-request{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-orders{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-propagation-policy{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-budget{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-report-type{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-past-chat{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-crypto-transaction-envelope-change-log{\n  --slds-c-icon-color-background:rgb(8, 73, 104);\n}\n.slds-icon-standard-feedback{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-action-list-component{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-opportunity-splits{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-location-permit{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-app-form-product-participant{\n  --slds-c-icon-color-background:rgb(126, 38, 0);\n}\n.slds-icon-standard-messaging-user{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-filter-criteria{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-tax-policy{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-trailhead{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-entitlements{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-checkout{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-formula{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-case-log-a-call{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-shift-pattern-entry{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-thanks-loading{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-job-family{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-service-appointment-capacity-usage{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-inbox{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-channel-program-levels{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-letterhead{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-promotions-workspace{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-nft-settings{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-asset-hierarchy{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-email-chatter{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-custody-chain-entry{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-document-reference{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-announcement{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-field-sales{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-bot{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-macros{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-dashboard-ea{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-job-profile{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-steps{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-snippet-alt{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-asset-relationship{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-high-velocity-sales{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-brand{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-historical-adherence{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-visits{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-einstein-replies{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-coaching{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-record-lookup{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-product-service-campaign-item{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-scheduling-constraint{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-lightning-component{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-search{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-connected-apps{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-swarm-request{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-work-type-group{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-education{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-work-type{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-travel-mode{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-environment-hub{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-identifier{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-cms{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-call-coaching{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-salesforce-cms{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-price-sheet{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-thanks{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-service-territory-member{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-work-forecast{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-crypto-product-category-wallet-role{\n  --slds-c-icon-color-background:rgb(5, 103, 100);\n}\n.slds-icon-standard-program-cohort-member{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-holiday-operating-hours{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-uploaded-model{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-user-role{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-observation-component{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-orchestrator{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-work-capacity-usage{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-record-create{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-campaign-members{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-retail-banking{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-product-service-campaign{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-portal-roles{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-operation-plan-step{\n  --slds-c-icon-color-background:rgb(90, 27, 169);\n}\n.slds-icon-standard-calibration{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-answer-public{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-robot{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-display-text{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-product-consumed-state{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-budget-category-value{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-scheduling-workspace{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-unmatched{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-partners{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-email-iq{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-mulesoft{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-service-crew{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-payment-gateway{\n  --slds-c-icon-color-background:rgb(5, 103, 100);\n}\n.slds-icon-standard-voice-call{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-cancel-checkout{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-asset-warranty{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-resource-capacity{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-repeaters{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-setup-modal{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-channel-programs{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-quip{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-quip-sheet{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-timeslot{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-live-chat{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-service-request-detail{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-med-rec-statement-recommendation{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-job-position{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-sobject-collection{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-user{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-client{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-screen{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-portal{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-partner-fund-request{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-asset-audit{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-resource-preference{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-record-consent{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-first-non-empty{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-rate-adjustment{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-impact-strategy{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-customer-360{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-employee-job{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-resource-absence{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-registered-model{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-panel-detail{\n  --slds-c-icon-color-background:rgb(8, 73, 104);\n}\n.slds-icon-standard-text-template{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-entitlement-template{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-lightning-usage{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-volume-discounts{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-indicator-result{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-product-transfer-state{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-medication-dispense{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-entitlement{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-empty{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-text{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-delegated-account{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-fulfillment-order{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-case-email{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-account{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-coupon-codes{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-assignment{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-wealth-management-console{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-task2,\n.slds-icon-standard-task-2{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-patient-medication-dosage{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-code-playground{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-social{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-endorsement{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-folder{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-service-crew-member{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-variation-attribute-setup{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-real-time{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-connect-wallet{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-flow{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-recipe{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-expense-report-entry{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-employee{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-omni-supervisor{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-capacity-plan{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-asset-object{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-product{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-crypto-transaction-envelope{\n  --slds-c-icon-color-background:rgb(5, 103, 100);\n}\n.slds-icon-standard-topic{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-product-required{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-dynamic-record-choice{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-aggregation-policy{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-warranty-term{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-process{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-swarm-session{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-people{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-medication{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-reward{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-employee-contact{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-bundle-policy{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-performance{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-promotions{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-case-comment{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-price-book-entries{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-sales-channel{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-apex-plugin{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-party-profile{\n  --slds-c-icon-color-background:rgb(90, 27, 169);\n}\n.slds-icon-standard-campaign{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-contact-request{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-business-hours{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-metric{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-evernote{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-variation-products{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-program-cohort{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-trailhead-alt{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-service-territory{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-customer-lifecycle-analytics{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-code-set{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-case{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-slack{\n  --slds-c-icon-color-background:rgb(74, 21, 75);\n}\n.slds-icon-standard-currency{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-record{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-code-set-bundle{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-queue{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-schedule-objective{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-contract-line-item{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-skill-entity{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-funding-award-adjustment{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-skill{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-operating-hours{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-crypto-product{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-taxonomy{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-operation-plan-request{\n  --slds-c-icon-color-background:rgb(90, 27, 169);\n}\n.slds-icon-standard-custom{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-related-list{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-bot-training{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-case-change-status{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-insurance-console{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-dashboard-component{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-incident{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-contract{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-policy{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-sobject{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-whatsapp{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-sales-cadence-target{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-photo{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-apps{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-timesheet{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-drafts{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-outcome{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-discounts{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-work-order-item{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-pricebook{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-scan-card{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-note{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-serialized-product-transaction{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-shift-pattern{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-buyer-group{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-price-adjustment-schedule{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-product-quantity-rules{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-medication-reconciliation{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-procedure{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-opportunity{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-news{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-sort-policy{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-display-rich-text{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-strategy{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-time-period{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-call-history{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-webcart{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-serialized-product{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-tax-rate{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-report{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-customer-workspace{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-groups{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-data-model{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-dashboard{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-generic-loading{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-number-input{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-toggle{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-address{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-price-books{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-entity-milestone{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-contract-line-outcome{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-wealth-management{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-customers{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-disclosure-and-compliance{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-workspace{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-story{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-service-appointment{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-maintenance-plan{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-contract-line-outcome-data{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-data-integration-hub{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-person-name{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-work-plan-template-entry{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-hierarchy{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-custom-component-task{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-partner-marketing-budget{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-asset-action-source{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-skill-requirement{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-filter-criteria-rule{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-no-code-model{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-location{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-promotion-tiers{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-radio-button{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-avatar-loading{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-article{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-custody-entry-verification{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-learner-program{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-invocable-action{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-device{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-app-form-participant{\n  --slds-c-icon-color-background:rgb(5, 103, 100);\n}\n.slds-icon-standard-proposition{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-snippets{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-customer-portal-users{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-cost-model{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-path-experiment{\n  --slds-c-icon-color-background:rgb(221, 122, 1);\n}\n.slds-icon-standard-actions-and-buttons{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-record-update{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-shift-type{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-water{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-log-a-call{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-crypto-wallet{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-crypto-wallet-group{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-quotes{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-data-governance{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-question-feed{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-attribute-based-pricing{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-walkthroughs{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-kanban{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-work-plan{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-shift-template{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-merge{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-expense{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-dataset{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-work-summary{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-shift-preference{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-product-consumed{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-canvas{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-bundles-pricing{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-forecasts{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-relationship{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-tour{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-service-resource{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-filter{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-sales-path{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-shift-scheduling-operation{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-data-graph{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-data-lake-objects{\n  --slds-c-icon-color-background:rgb(90, 27, 169);\n}\n.slds-icon-standard-events{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-data-mapping{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-sms{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-impact-outcome{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-rtc-presence{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-avatar{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-record-delete{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-solution{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-nft-studio{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-manual-discounts{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-agent-home{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-linked{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-partner-fund-claim{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-individual{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-custom-notification{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-contract-payment{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-date-input{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-catalog{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-template{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-activation-target{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-standard-selling-model{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-shipment{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-budget-allocation{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-custody-override{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-record-signature-task{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-event{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-standard-insurance{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-live-chat-visitor{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-textarea{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-work-step{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-picklist-type{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-survey{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-operation-plan-execution{\n  --slds-c-icon-color-background:rgb(90, 27, 169);\n}\n.slds-icon-standard-link{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-messaging-session{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-video{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-list-email{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-med-rec-recommendation{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-crypto-wallet-group-item{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-recycle-bin{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-document{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-product-transfer{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-instore-locations{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-recent{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-practitioner-role{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-password{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-datashare-target{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-expense-report{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-branch-merge{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-ai-accelerator-card{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-insights{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-standard-budget-period{\n  --slds-c-icon-color-background:rgb(150, 2, 199);\n}\n.slds-icon-standard-market{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-dropbox{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-unified-health-score{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-bill-of-materials{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-calculated-insights{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-employee-job-position{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-file{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-outcome-activity{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-currency-input{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-data-transforms{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-variable{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-team-member{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-pricing-workspace{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-agent-session{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-guidance-center{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-crypto-category-wallet-group{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-group-loading{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-lead{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-email{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-service-contract{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-decision{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-promotion-segments{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-duration-downscale{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-snippet{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-entitlement-process{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-price-adjustment-matrix{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-contact-list{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-planogram{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-activations{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-scheduling-policy{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-channel-program-history{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-question-best{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-omni-channel{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-collection-variable{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-indicator-assignment{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-procedure-detail{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-sales-value{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-knowledge{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-standard-datashares{\n  --slds-c-icon-color-background:rgb(150, 2, 199);\n}\n.slds-icon-standard-date-time{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-category{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-maintenance-work-rule{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-data-streams{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-textbox{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-standard-lead-insights{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-waits{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-concur{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-feed{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-sort{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-messaging-conversation{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-service-report{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-standard-iot-context{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-price-adjustment-tier{\n  --slds-c-icon-color-background:rgb(3, 45, 96);\n}\n.slds-icon-standard-asset-state-period{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-call{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-collection{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-stage{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-sales-cadence{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-product-request-line-item{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-return-order-line-item{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-chart{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-customer{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-buyer-group-qualifier{\n  --slds-c-icon-color-background:rgb(57, 101, 71);\n}\n.slds-icon-standard-quick-text{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-home{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-standard-sossession{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-digital-verification-config{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-aggregate{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-bundle-config{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-title-party{\n  --slds-c-icon-color-background:rgb(5, 103, 100);\n}\n.slds-icon-standard-employee-asset{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-process-exception{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-product-warranty-term{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-standard-problem{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-stage-collection{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-product-request{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-logging{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-digital-verification-config-group{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-assigned-resource{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-return-order{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-poll{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-household{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-work-step-template{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-standard-medication-statement{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-labels{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-ad-event-action{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-ad-event-cause{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-ad-event-effect{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-ad-event-factor{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-standard-ad-event-info{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-ad-event-outcome{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-ad-event-party{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-standard-adverse-event{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-billing{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-calculated-dimension{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-calculated-measure{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-disease-definition-criteria{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-disease-investigation{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-disease-outbreak{\n  --slds-c-icon-color-background:rgb(182, 5, 84);\n}\n.slds-icon-standard-edit-form{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-enrollee-status{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-eval-result{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-event-ext{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-life-sciences{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-map-line-item{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-medication-administration{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-member-period{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-patient-service{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-procedure-output-resolution{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-program-detail{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-program-site{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-program-status{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-prospect{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-replace{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-reset-password{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-send-log{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-study{\n  --slds-c-icon-color-background:rgb(47, 44, 183);\n}\n.slds-icon-standard-study-candidate{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-study-related{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-sub-metric{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-summary-liable{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-summary-usage{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-table{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-transaction-usage-entitlement{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-usage-entitlement-account{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-usage-entitlement-bucket{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-standard-usage-entitlement-entry{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-standard-usage-ratable-summary{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-custom-custom110,\n.slds-icon-custom-110{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom100,\n.slds-icon-custom-100{\n  --slds-c-icon-color-background:rgb(225, 93, 118);\n}\n.slds-icon-custom-custom111,\n.slds-icon-custom-111{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom1,\n.slds-icon-custom-1{\n  --slds-c-icon-color-background:rgb(255, 123, 132);\n}\n.slds-icon-custom-custom101,\n.slds-icon-custom-101{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom112,\n.slds-icon-custom-112{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom2,\n.slds-icon-custom-2{\n  --slds-c-icon-color-background:rgb(207, 208, 92);\n}\n.slds-icon-custom-custom102,\n.slds-icon-custom-102{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom113,\n.slds-icon-custom-113{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom90,\n.slds-icon-custom-90{\n  --slds-c-icon-color-background:rgb(34, 164, 138);\n}\n.slds-icon-custom-custom3,\n.slds-icon-custom-3{\n  --slds-c-icon-color-background:rgb(236, 180, 108);\n}\n.slds-icon-custom-custom103,\n.slds-icon-custom-103{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom80,\n.slds-icon-custom-80{\n  --slds-c-icon-color-background:rgb(101, 154, 213);\n}\n.slds-icon-custom-custom91,\n.slds-icon-custom-91{\n  --slds-c-icon-color-background:rgb(191, 123, 102);\n}\n.slds-icon-custom-custom4,\n.slds-icon-custom-4{\n  --slds-c-icon-color-background:rgb(225, 217, 81);\n}\n.slds-icon-custom-custom104,\n.slds-icon-custom-104{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom70,\n.slds-icon-custom-70{\n  --slds-c-icon-color-background:rgb(231, 105, 180);\n}\n.slds-icon-custom-custom81,\n.slds-icon-custom-81{\n  --slds-c-icon-color-background:rgb(218, 98, 127);\n}\n.slds-icon-custom-custom92,\n.slds-icon-custom-92{\n  --slds-c-icon-color-background:rgb(81, 126, 130);\n}\n.slds-icon-custom-custom5,\n.slds-icon-custom-5{\n  --slds-c-icon-color-background:rgb(159, 219, 102);\n}\n.slds-icon-custom-custom105,\n.slds-icon-custom-105{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom60,\n.slds-icon-custom-60{\n  --slds-c-icon-color-background:rgb(191, 90, 136);\n}\n.slds-icon-custom-custom71,\n.slds-icon-custom-71{\n  --slds-c-icon-color-background:rgb(227, 110, 227);\n}\n.slds-icon-custom-custom82,\n.slds-icon-custom-82{\n  --slds-c-icon-color-background:rgb(209, 91, 151);\n}\n.slds-icon-custom-custom93,\n.slds-icon-custom-93{\n  --slds-c-icon-color-background:rgb(144, 77, 76);\n}\n.slds-icon-custom-custom6,\n.slds-icon-custom-6{\n  --slds-c-icon-color-background:rgb(84, 196, 115);\n}\n.slds-icon-custom-custom106,\n.slds-icon-custom-106{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom50,\n.slds-icon-custom-50{\n  --slds-c-icon-color-background:rgb(73, 188, 211);\n}\n.slds-icon-custom-custom61,\n.slds-icon-custom-61{\n  --slds-c-icon-color-background:rgb(245, 115, 118);\n}\n.slds-icon-custom-custom72,\n.slds-icon-custom-72{\n  --slds-c-icon-color-background:rgb(141, 155, 251);\n}\n.slds-icon-custom-custom83,\n.slds-icon-custom-83{\n  --slds-c-icon-color-background:rgb(231, 128, 111);\n}\n.slds-icon-custom-custom94,\n.slds-icon-custom-94{\n  --slds-c-icon-color-background:rgb(67, 156, 186);\n}\n.slds-icon-custom-custom7,\n.slds-icon-custom-7{\n  --slds-c-icon-color-background:rgb(106, 137, 229);\n}\n.slds-icon-custom-custom107,\n.slds-icon-custom-107{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom40,\n.slds-icon-custom-40{\n  --slds-c-icon-color-background:rgb(131, 199, 94);\n}\n.slds-icon-custom-custom51,\n.slds-icon-custom-51{\n  --slds-c-icon-color-background:rgb(216, 199, 96);\n}\n.slds-icon-custom-custom62,\n.slds-icon-custom-62{\n  --slds-c-icon-color-background:rgb(107, 146, 220);\n}\n.slds-icon-custom-custom73,\n.slds-icon-custom-73{\n  --slds-c-icon-color-background:rgb(103, 158, 240);\n}\n.slds-icon-custom-custom84,\n.slds-icon-custom-84{\n  --slds-c-icon-color-background:rgb(246, 112, 123);\n}\n.slds-icon-custom-custom95,\n.slds-icon-custom-95{\n  --slds-c-icon-color-background:rgb(139, 207, 106);\n}\n.slds-icon-custom-custom8,\n.slds-icon-custom-8{\n  --slds-c-icon-color-background:rgb(80, 206, 185);\n}\n.slds-icon-custom-custom108,\n.slds-icon-custom-108{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom30,\n.slds-icon-custom-30{\n  --slds-c-icon-color-background:rgb(245, 159, 113);\n}\n.slds-icon-custom-custom41,\n.slds-icon-custom-41{\n  --slds-c-icon-color-background:rgb(67, 181, 181);\n}\n.slds-icon-custom-custom52,\n.slds-icon-custom-52{\n  --slds-c-icon-color-background:rgb(238, 142, 111);\n}\n.slds-icon-custom-custom63,\n.slds-icon-custom-63{\n  --slds-c-icon-color-background:rgb(124, 207, 96);\n}\n.slds-icon-custom-custom74,\n.slds-icon-custom-74{\n  --slds-c-icon-color-background:rgb(65, 200, 160);\n}\n.slds-icon-custom-custom85,\n.slds-icon-custom-85{\n  --slds-c-icon-color-background:rgb(242, 104, 145);\n}\n.slds-icon-custom-custom96,\n.slds-icon-custom-96{\n  --slds-c-icon-color-background:rgb(109, 157, 227);\n}\n.slds-icon-custom-custom9,\n.slds-icon-custom-9{\n  --slds-c-icon-color-background:rgb(107, 158, 226);\n}\n.slds-icon-custom-custom109,\n.slds-icon-custom-109{\n  --slds-c-icon-color-background:rgb(242, 139, 0);\n}\n.slds-icon-custom-custom20,\n.slds-icon-custom-20{\n  --slds-c-icon-color-background:rgb(72, 199, 200);\n}\n.slds-icon-custom-custom31,\n.slds-icon-custom-31{\n  --slds-c-icon-color-background:rgb(235, 104, 127);\n}\n.slds-icon-custom-custom42,\n.slds-icon-custom-42{\n  --slds-c-icon-color-background:rgb(207, 208, 91);\n}\n.slds-icon-custom-custom53,\n.slds-icon-custom-53{\n  --slds-c-icon-color-background:rgb(243, 110, 131);\n}\n.slds-icon-custom-custom64,\n.slds-icon-custom-64{\n  --slds-c-icon-color-background:rgb(97, 143, 216);\n}\n.slds-icon-custom-custom75,\n.slds-icon-custom-75{\n  --slds-c-icon-color-background:rgb(205, 159, 101);\n}\n.slds-icon-custom-custom86,\n.slds-icon-custom-86{\n  --slds-c-icon-color-background:rgb(226, 96, 171);\n}\n.slds-icon-custom-custom97,\n.slds-icon-custom-97{\n  --slds-c-icon-color-background:rgb(221, 96, 133);\n}\n.slds-icon-custom-custom10,\n.slds-icon-custom-10{\n  --slds-c-icon-color-background:rgb(100, 136, 227);\n}\n.slds-icon-custom-custom21,\n.slds-icon-custom-21{\n  --slds-c-icon-color-background:rgb(138, 122, 237);\n}\n.slds-icon-custom-custom32,\n.slds-icon-custom-32{\n  --slds-c-icon-color-background:rgb(56, 195, 147);\n}\n.slds-icon-custom-custom43,\n.slds-icon-custom-43{\n  --slds-c-icon-color-background:rgb(127, 147, 249);\n}\n.slds-icon-custom-custom54,\n.slds-icon-custom-54{\n  --slds-c-icon-color-background:rgb(234, 112, 177);\n}\n.slds-icon-custom-custom65,\n.slds-icon-custom-65{\n  --slds-c-icon-color-background:rgb(242, 121, 171);\n}\n.slds-icon-custom-custom76,\n.slds-icon-custom-76{\n  --slds-c-icon-color-background:rgb(219, 109, 122);\n}\n.slds-icon-custom-custom87,\n.slds-icon-custom-87{\n  --slds-c-icon-color-background:rgb(216, 118, 229);\n}\n.slds-icon-custom-custom98,\n.slds-icon-custom-98{\n  --slds-c-icon-color-background:rgb(225, 190, 92);\n}\n.slds-icon-custom-custom11,\n.slds-icon-custom-11{\n  --slds-c-icon-color-background:rgb(135, 132, 234);\n}\n.slds-icon-custom-custom22,\n.slds-icon-custom-22{\n  --slds-c-icon-color-background:rgb(139, 133, 249);\n}\n.slds-icon-custom-custom33,\n.slds-icon-custom-33{\n  --slds-c-icon-color-background:rgb(151, 207, 93);\n}\n.slds-icon-custom-custom44,\n.slds-icon-custom-44{\n  --slds-c-icon-color-background:rgb(200, 202, 88);\n}\n.slds-icon-custom-custom55,\n.slds-icon-custom-55{\n  --slds-c-icon-color-background:rgb(214, 110, 224);\n}\n.slds-icon-custom-custom66,\n.slds-icon-custom-66{\n  --slds-c-icon-color-background:rgb(216, 190, 95);\n}\n.slds-icon-custom-custom77,\n.slds-icon-custom-77{\n  --slds-c-icon-color-background:rgb(181, 93, 91);\n}\n.slds-icon-custom-custom88,\n.slds-icon-custom-88{\n  --slds-c-icon-color-background:rgb(153, 111, 230);\n}\n.slds-icon-custom-custom99,\n.slds-icon-custom-99{\n  --slds-c-icon-color-background:rgb(240, 133, 110);\n}\n.slds-icon-custom-custom12,\n.slds-icon-custom-12{\n  --slds-c-icon-color-background:rgb(220, 113, 209);\n}\n.slds-icon-custom-custom23,\n.slds-icon-custom-23{\n  --slds-c-icon-color-background:rgb(176, 112, 230);\n}\n.slds-icon-custom-custom34,\n.slds-icon-custom-34{\n  --slds-c-icon-color-background:rgb(213, 138, 106);\n}\n.slds-icon-custom-custom45,\n.slds-icon-custom-45{\n  --slds-c-icon-color-background:rgb(217, 88, 121);\n}\n.slds-icon-custom-custom56,\n.slds-icon-custom-56{\n  --slds-c-icon-color-background:rgb(113, 141, 235);\n}\n.slds-icon-custom-custom67,\n.slds-icon-custom-67{\n  --slds-c-icon-color-background:rgb(248, 125, 118);\n}\n.slds-icon-custom-custom78,\n.slds-icon-custom-78{\n  --slds-c-icon-color-background:rgb(90, 149, 221);\n}\n.slds-icon-custom-custom89,\n.slds-icon-custom-89{\n  --slds-c-icon-color-background:rgb(62, 153, 190);\n}\n.slds-icon-custom-custom13,\n.slds-icon-custom-13{\n  --slds-c-icon-color-background:rgb(223, 97, 132);\n}\n.slds-icon-custom-custom24,\n.slds-icon-custom-24{\n  --slds-c-icon-color-background:rgb(229, 103, 152);\n}\n.slds-icon-custom-custom35,\n.slds-icon-custom-35{\n  --slds-c-icon-color-background:rgb(233, 99, 126);\n}\n.slds-icon-custom-custom46,\n.slds-icon-custom-46{\n  --slds-c-icon-color-background:rgb(103, 165, 231);\n}\n.slds-icon-custom-custom57,\n.slds-icon-custom-57{\n  --slds-c-icon-color-background:rgb(90, 156, 221);\n}\n.slds-icon-custom-custom68,\n.slds-icon-custom-68{\n  --slds-c-icon-color-background:rgb(242, 105, 121);\n}\n.slds-icon-custom-custom79,\n.slds-icon-custom-79{\n  --slds-c-icon-color-background:rgb(142, 211, 99);\n}\n.slds-icon-custom-custom14,\n.slds-icon-custom-14{\n  --slds-c-icon-color-background:rgb(60, 194, 179);\n}\n.slds-icon-custom-custom25,\n.slds-icon-custom-25{\n  --slds-c-icon-color-background:rgb(228, 111, 190);\n}\n.slds-icon-custom-custom36,\n.slds-icon-custom-36{\n  --slds-c-icon-color-background:rgb(212, 114, 212);\n}\n.slds-icon-custom-custom47,\n.slds-icon-custom-47{\n  --slds-c-icon-color-background:rgb(95, 204, 100);\n}\n.slds-icon-custom-custom58,\n.slds-icon-custom-58{\n  --slds-c-icon-color-background:rgb(52, 181, 157);\n}\n.slds-icon-custom-custom69,\n.slds-icon-custom-69{\n  --slds-c-icon-color-background:rgb(237, 99, 135);\n}\n.slds-icon-custom-custom15,\n.slds-icon-custom-15{\n  --slds-c-icon-color-background:rgb(247, 126, 117);\n}\n.slds-icon-custom-custom26,\n.slds-icon-custom-26{\n  --slds-c-icon-color-background:rgb(118, 152, 240);\n}\n.slds-icon-custom-custom37,\n.slds-icon-custom-37{\n  --slds-c-icon-color-background:rgb(140, 137, 242);\n}\n.slds-icon-custom-custom48,\n.slds-icon-custom-48{\n  --slds-c-icon-color-background:rgb(239, 105, 127);\n}\n.slds-icon-custom-custom59,\n.slds-icon-custom-59{\n  --slds-c-icon-color-background:rgb(227, 208, 103);\n}\n.slds-icon-custom-custom16,\n.slds-icon-custom-16{\n  --slds-c-icon-color-background:rgb(233, 175, 103);\n}\n.slds-icon-custom-custom27,\n.slds-icon-custom-27{\n  --slds-c-icon-color-background:rgb(90, 176, 210);\n}\n.slds-icon-custom-custom38,\n.slds-icon-custom-38{\n  --slds-c-icon-color-background:rgb(83, 182, 215);\n}\n.slds-icon-custom-custom49,\n.slds-icon-custom-49{\n  --slds-c-icon-color-background:rgb(226, 92, 128);\n}\n.slds-icon-custom-custom17,\n.slds-icon-custom-17{\n  --slds-c-icon-color-background:rgb(172, 211, 96);\n}\n.slds-icon-custom-custom28,\n.slds-icon-custom-28{\n  --slds-c-icon-color-background:rgb(137, 192, 89);\n}\n.slds-icon-custom-custom39,\n.slds-icon-custom-39{\n  --slds-c-icon-color-background:rgb(79, 190, 117);\n}\n.slds-icon-custom-custom18,\n.slds-icon-custom-18{\n  --slds-c-icon-color-background:rgb(77, 202, 118);\n}\n.slds-icon-custom-custom29,\n.slds-icon-custom-29{\n  --slds-c-icon-color-background:rgb(189, 210, 95);\n}\n.slds-icon-custom-custom19,\n.slds-icon-custom-19{\n  --slds-c-icon-color-background:rgb(58, 190, 177);\n}\n.slds-icon-action-new-custom18{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom29{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-edit-groups{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-new-custom9{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-log-a-call{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-new-custom19{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-filter{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-user-activation{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-opportunity-competitor{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-canvas{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-change-record-type{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-new-notebook{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-docusign{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-share-link{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-add-file{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-edit-relationship{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-notebook{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-lead{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom-object{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-account{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-question-post-action{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-share-file{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-action-default-custom-object{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-opportunity-team-member{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-add-photo-video{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-sort{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-call{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-concur{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-reject{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-share-poll{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-scan-enabled{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-following{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-defer{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-opportunity-line-item{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-social-post{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-share-post{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-view-relationship{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-adjust-value{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-upload{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-remove-relationship{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-freeze-user{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-new-person-account{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-bug{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-apex{\n  --slds-c-icon-color-background:rgb(92, 92, 92);\n}\n.slds-icon-action-new-opportunity{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-fallback{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-dial-in{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-approval{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-change-owner{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-new-task{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-priority{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-remove{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-web-link{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-leave-group{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-manage-perm-sets{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-close{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-google-news{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-announcement{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-back{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-new-custom90{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-download{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-new-custom80{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom91{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-action-search{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-event{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom70{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom81{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom92{\n  --slds-c-icon-color-background:rgb(5, 103, 100);\n}\n.slds-icon-action-refresh{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-share-thanks{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-update{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-email{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-join-group{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom60{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom71{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-action-new-custom82{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom93{\n  --slds-c-icon-color-background:rgb(92, 92, 92);\n}\n.slds-icon-action-edit{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-quote{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-dropbox{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-description{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-map{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-user{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-reset-password{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-new-custom50{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom61{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom72{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom83{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom94{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-clone{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-script{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-delete{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom40{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom51{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom62{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom73{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom84{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom95{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-scan-disabled{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-action-share{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-new-custom30{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom41{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-new-custom52{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom63{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom74{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-new-custom85{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom96{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-log-event{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-group{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom20{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-new-custom31{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom42{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-info{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-new-custom53{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom64{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom75{\n  --slds-c-icon-color-background:rgb(147, 147, 147);\n}\n.slds-icon-action-new-custom86{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-flow{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-new-custom97{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-submit-for-approval{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-campaign{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom10{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom21{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom32{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-new-custom43{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom54{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom65{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom76{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom87{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-action-new-custom98{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-case{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom100{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom1{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-contact{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-action-office-365{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom11{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom22{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom33{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom44{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom55{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-action-new-custom66{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom77{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom88{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-action-new-custom99{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-add-contact{\n  --slds-c-icon-color-background:rgb(144, 80, 233);\n}\n.slds-icon-action-evernote{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom2{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-lead-convert{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom12{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-action-new-custom23{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-action-new-custom34{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom45{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom56{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom67{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-recall{\n  --slds-c-icon-color-background:rgb(8, 73, 104);\n}\n.slds-icon-action-new-custom78{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom89{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-follow{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-record{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom3{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-note{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom13{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom24{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom35{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom46{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom57{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom68{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom79{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-child-case{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom4{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom14{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-new-custom25{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom36{\n  --slds-c-icon-color-background:rgb(203, 101, 255);\n}\n.slds-icon-action-new-custom47{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom58{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-new-custom69{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom5{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-goal{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom15{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom26{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom37{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom48{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom59{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom6{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-log-this-event{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom16{\n  --slds-c-icon-color-background:rgb(255, 93, 45);\n}\n.slds-icon-action-new-custom27{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom38{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom49{\n  --slds-c-icon-color-background:rgb(255, 83, 138);\n}\n.slds-icon-action-new-custom7{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-more{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-add-relationship{\n  --slds-c-icon-color-background:rgb(27, 150, 255);\n}\n.slds-icon-action-new-custom17{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom28{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-new-custom39{\n  --slds-c-icon-color-background:rgb(59, 167, 85);\n}\n.slds-icon-action-password-unlock{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-check{\n  --slds-c-icon-color-background:rgb(16, 124, 173);\n}\n.slds-icon-action-update-status{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-icon-action-preview{\n  --slds-c-icon-color-background:rgb(88, 103, 232);\n}\n.slds-icon-action-new-custom8{\n  --slds-c-icon-color-background:rgb(6, 165, 154);\n}\n.slds-timeline__item_expandable,.slds-timeline__item--expandable{\n  position:relative;\n  padding-block-end:var(--slds-g-spacing-4);\n}\n.slds-timeline__item_expandable .slds-media__figure,.slds-timeline__item--expandable .slds-media__figure{\n  margin-inline-end:var(--slds-g-spacing-1);\n  z-index:1;\n}\n.slds-timeline__item_expandable .slds-media__figure .slds-button_icon,.slds-timeline__item--expandable .slds-media__figure .slds-button--icon{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-timeline__item_expandable .slds-media__body,.slds-timeline__item--expandable .slds-media__body{\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-1);\n}\n.slds-timeline__item_expandable .slds-checkbox,.slds-timeline__item--expandable .slds-checkbox{\n  margin-inline-end:var(--slds-g-spacing-1);\n}\n.slds-timeline__item_expandable .slds-timeline__actions_inline,.slds-timeline__item--expandable .slds-timeline__actions--inline{\n  flex-flow:row nowrap;\n  align-items:center;\n  flex-shrink:0;\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-timeline__item_expandable .slds-timeline__actions_inline .slds-timeline__date,.slds-timeline__item--expandable .slds-timeline__actions--inline .slds-timeline__date{\n  padding-inline-end:var(--slds-g-spacing-2);\n  margin-block-end:0;\n}\n.slds-timeline__item_expandable .slds-timeline__item_details,.slds-timeline__item--expandable .slds-timeline__item--details{\n  visibility:hidden;\n  opacity:0;\n  height:0;\n  padding:0;\n}\n.slds-timeline__item_expandable.slds-is-open .slds-timeline__item_details,.slds-timeline__item--expandable.slds-is-open .slds-timeline__item--details{\n  visibility:visible;\n  opacity:1;\n  height:auto;\n  padding:var(--slds-g-spacing-4);\n}\n.slds-timeline__item_expandable.slds-is-open .slds-timeline__details-action-icon,.slds-timeline__item--expandable.slds-is-open .slds-timeline__details-action-icon{\n  transform:rotate(0);\n  transform-origin:45%;\n}\n.slds-timeline__item_expandable::before,.slds-timeline__item--expandable::before{\n  content:'';\n  background:var(--slds-g-color-border-1);\n  height:100%;\n  width:var(--slds-g-sizing-border-2);\n  position:absolute;\n  inset-inline-start:2.235rem;\n  inset-block-start:0;\n  inset-block-end:0;\n  margin-inline-start:var(--slds-g-sizing-border-2);\n}\n.slds-timeline__item_call::before,.slds-timeline__item--call::before{\n  background:rgb(72, 195, 204);\n}\n.slds-timeline__item_email::before,.slds-timeline__item--email::before{\n  background:rgb(147, 147, 147);\n}\n.slds-timeline__item_event::before,.slds-timeline__item--event::before{\n  background:rgb(203, 101, 255);\n}\n.slds-timeline__item_task::before,.slds-timeline__item--task::before{\n  background:rgb(75, 192, 118);\n}\n.slds-timeline__trigger{\n  padding:var(--slds-g-spacing-1);\n}\n.slds-timeline__trigger:hover{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-timeline__icon{\n  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-surface-1);\n}\n.slds-timeline__actions{\n  display:flex;\n  flex-flow:column nowrap;\n  align-items:flex-end;\n}\n.slds-timeline__date{\n  margin-block-end:var(--slds-g-spacing-1);\n  font-size:var(--slds-g-font-scale-neg-3);\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-timeline__details-action-icon{\n  transform:rotate(-90deg);\n}\n.slds-button-group,\n.slds-button-group-list{\n  display:inline-flex;\n}\n.slds-button-group .slds-button, .slds-button-group-list .slds-button{\n  border-radius:0;\n  border-width:var(--slds-g-sizing-border-1);\n}\n.slds-button-group .slds-button:focus, .slds-button-group-list .slds-button:focus{\n  z-index:1;\n}\n.slds-button-group .slds-button + .slds-button,\n.slds-button-group .slds-button + .slds-button_last .slds-button,\n.slds-button-group .slds-button + .slds-button--last .slds-button,\n.slds-button-group-list li + li .slds-button{\n  margin-inline-start:calc(-1 * var(--slds-g-sizing-border-1));\n}\n.slds-button-group .slds-button_brand + .slds-button_last .slds-button_icon-brand,.slds-button-group .slds-button--brand + .slds-button--last .slds-button--icon-brand,\n.slds-button-group-list li:last-child .slds-button_icon-brand,\n.slds-button-group-list li:last-child .slds-button--icon-brand{\n  box-shadow:inset 1px 0 0 var(--slds-g-color-neutral-base-100);\n}\n.slds-button-group-list li:first-child .slds-button,\n.slds-button-group .slds-button:first-child{\n  border-start-start-radius:var(--slds-s-button-radius-border);\n  border-start-end-radius:0;\n  border-end-start-radius:var(--slds-s-button-radius-border);\n  border-end-end-radius:0;\n}\n.slds-button-group .slds-button:last-child,\n.slds-button-group-list li:last-child .slds-button,\n.slds-button-group .slds-button_last .slds-button,\n.slds-button-group .slds-button--last .slds-button,\n.slds-button-group .slds-button.slds-button_last,\n.slds-button-group .slds-button.slds-button--last,\n.slds-button-group .slds-button_last .slds-button:only-child,\n.slds-button-group .slds-button--last .slds-button:only-child{\n  border-start-start-radius:0;\n  border-start-end-radius:var(--slds-s-button-radius-border);\n  border-end-start-radius:0;\n  border-end-end-radius:var(--slds-s-button-radius-border);\n}\n.slds-button-group .slds-button:only-child,\n.slds-button-group-list li:only-child .slds-button{\n  border-radius:var(--slds-s-button-radius-border);\n}\n.slds-button.slds-button_first.slds-button_first,.slds-button.slds-button--first.slds-button--first{\n  border-inline-end:0;\n  border-start-start-radius:var(--slds-s-button-radius-border);\n  border-start-end-radius:0;\n  border-end-start-radius:var(--slds-s-button-radius-border);\n  border-end-end-radius:0;\n}\n.slds-button.slds-button_middle.slds-button_middle,.slds-button.slds-button--middle.slds-button--middle{\n  border-radius:0;\n  margin-inline-start:calc(var(--slds-g-sizing-border-1) * -1);\n}\n.slds-button.slds-button_last.slds-button_last,.slds-button.slds-button--last.slds-button--last{\n  border-start-start-radius:0;\n  border-start-end-radius:var(--slds-s-button-radius-border);\n  border-end-start-radius:0;\n  border-end-end-radius:var(--slds-s-button-radius-border);\n  margin-inline-start:calc(\n    var(--slds-g-sizing-border-1) * -1\n  );\n}\n.slds-button-group + .slds-button-group,\n.slds-button-group + .slds-button-group-list,\n.slds-button-group + .slds-button,\n.slds-button-group-list + .slds-button-group-list,\n.slds-button-group-list + .slds-button-group,\n.slds-button-group-list + .slds-button{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-button-group-row{\n  display:inline-flex;\n}\n.slds-button-group-row .slds-button-group-item + .slds-button-group-item{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-button-group-row .slds-button-group-item .slds-button{\n  margin:0;\n}\n.slds-button{\n  position:relative;\n  display:inline-flex;\n  align-items:center;\n  padding-block-start:var(--slds-c-button-spacing-blockstart);\n  padding-inline-end:var(--slds-c-button-spacing-inlineend);\n  padding-block-end:var(--slds-c-button-spacing-blockend);\n  padding-inline-start:var(--slds-c-button-spacing-inlinestart);\n  background:none;\n  background-color:var(--slds-c-button-color-background);\n  background-clip:border-box;\n  border-color:var(--slds-c-button-color-border, transparent);\n  border-style:solid;\n  border-width:var(--slds-c-button-sizing-border, var(--slds-g-sizing-border-1));\n  border-radius:var(\n    --slds-c-button-radius-border,\n    var(--slds-s-button-radius-border, var(--slds-g-radius-border-2))\n  );\n  box-shadow:var(--slds-c-button-shadow, var(--slds-s-button-shadow));\n  line-height:1.875rem;\n  text-decoration:none;\n  color:var(--slds-c-button-text-color, var(--slds-s-button-color, var(--slds-g-color-accent-2)));\n  appearance:none;\n  white-space:normal;\n  user-select:none;\n  font-family:inherit;\n}\n.slds-button:hover,\n.slds-button:focus-visible,\n.slds-button:active,\n.slds-button:visited{\n  text-decoration:none;\n}\n.slds-button:hover,\n.slds-button:focus-visible{\n  --slds-c-button-color-border:var(\n    --slds-c-button-color-border-hover,\n    var(--slds-s-button-color-border-hover)\n  );\n  --slds-c-button-color-background:var(\n    --slds-c-button-color-background-hover,\n    var(--slds-s-button-color-background-hover, revert)\n  );\n\n  color:var(\n    --slds-c-button-text-color-hover,\n    var(--slds-s-button-color-hover, var(--slds-g-color-accent-3))\n  );\n  box-shadow:var(--slds-s-button-shadow-hover, revert);\n}\n.slds-button:focus-visible{\n  box-shadow:var(--slds-c-button-shadow-focus, var(--slds-s-button-shadow-focus));\n  outline:0;\n}\n.slds-button:active{\n  color:var(--slds-c-button-text-color-active, var(--slds-g-color-accent-3));\n  box-shadow:var(--slds-s-button-shadow-active, revert);\n\n  --slds-c-button-color-background:var(--slds-c-button-color-background-active, revert);\n  --slds-c-button-color-border:var(--slds-c-button-color-border-active, revert);\n}\n.slds-button[disabled],\n.slds-button:disabled{\n  background-color:transparent;\n  border-color:transparent;\n  color:var(--slds-g-color-disabled-1);\n  cursor:default;\n  pointer-events:none;\n}\n.slds-button[disabled] *, .slds-button:disabled *{\n  pointer-events:none;\n}\n.slds-button a{\n  --slds-c-button-text-color:currentColor;\n}\n.slds-button:hover .slds-button__icon, .slds-button:focus-visible .slds-button__icon, .slds-button:active .slds-button__icon, .slds-button[disabled] .slds-button__icon, .slds-button:disabled .slds-button__icon{\n  fill:currentColor;\n  pointer-events:none;\n}\n.slds-button + .slds-button-group,\n.slds-button + .slds-button-group-list{\n  margin-inline-start:var(--slds-g-spacing-1);\n}\n.slds-button + .slds-button{\n  margin-inline-start:var(--slds-g-spacing-1);\n}\n.slds-button_neutral,.slds-button--neutral{\n  justify-content:center;\n  --slds-c-button-color-background:var(\n    --slds-c-button-neutral-color-background,\n    var(--slds-g-color-surface-container-1)\n  );\n  --slds-c-button-color-border:var(--slds-c-button-neutral-color-border, var(--slds-g-color-border-2));\n  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);\n  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);\n}\n.slds-button_neutral:hover,.slds-button--neutral:hover,\n.slds-button_neutral:focus-visible,\n.slds-button--neutral:focus-visible{\n  --slds-c-button-color-background-hover:var(\n    --slds-c-button-neutral-color-background-hover,\n    var(--slds-g-color-surface-container-2, revert)\n  );\n  --slds-c-button-color-border-hover:var(\n    --slds-c-button-neutral-color-border-hover,\n    var(--slds-g-color-border-2, revert)\n  );\n}\n.slds-button_neutral:active,.slds-button--neutral:active{\n  --slds-c-button-color-background-active:var(\n    --slds-c-button-neutral-color-background-active,\n    var(--slds-g-color-surface-container-2, revert)\n  );\n  --slds-c-button-color-border-active:var(\n    --slds-c-button-neutral-color-border-active,\n    var(--slds-g-color-border-2, revert)\n  );\n}\n.slds-button_neutral[disabled],.slds-button--neutral[disabled],\n.slds-button_neutral:disabled,\n.slds-button--neutral:disabled{\n  background-color:var(--slds-g-color-disabled-container-1);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-1);\n}\n.slds-button_brand,.slds-button--brand{\n  justify-content:center;\n  --slds-c-button-color-background:var(\n    --slds-c-button-brand-color-background,\n    var(--slds-g-color-accent-container-1)\n  );\n  --slds-c-button-color-border:var(--slds-c-button-brand-color-border, var(--slds-g-color-border-accent-1));\n  --slds-c-button-text-color:var(--slds-c-button-brand-text-color, var(--slds-g-color-on-accent-1));\n  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);\n  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);\n}\n.slds-button_brand:hover,.slds-button--brand:hover,\n.slds-button_brand:focus-visible,\n.slds-button--brand:focus-visible{\n  --slds-c-button-color-background-hover:var(\n    --slds-c-button-brand-color-background-hover,\n    var(--slds-g-color-accent-container-2)\n  );\n  --slds-c-button-color-border-hover:var(\n    --slds-c-button-brand-color-border-hover,\n    var(--slds-g-color-accent-container-2)\n  );\n  --slds-c-button-text-color-hover:var(\n    --slds-c-button-brand-text-color-hover,\n    var(--slds-g-color-on-accent-1)\n  );\n}\n.slds-button_brand:active,.slds-button--brand:active{\n  --slds-c-button-color-background-active:var(\n    --slds-c-button-brand-color-background-active,\n    var(--slds-g-color-accent-container-2)\n  );\n  --slds-c-button-color-border-active:var(--slds-g-color-border-accent-2);\n  --slds-c-button-text-color-active:var(\n    --slds-c-button-brand-text-color-active,\n    var(--slds-g-color-on-accent-1)\n  );\n}\n.slds-button_brand[disabled],.slds-button--brand[disabled],\n.slds-button_brand:disabled,\n.slds-button--brand:disabled{\n  background-color:var(--slds-g-color-disabled-container-2);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-2);\n}\n.slds-button_outline-brand,.slds-button--outline-brand{\n  justify-content:center;\n  --slds-c-button-color-background:var(--slds-g-color-surface-container-1);\n  --slds-c-button-color-border:var(--slds-g-color-border-accent-1);\n  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);\n  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);\n}\n.slds-button_outline-brand:hover,.slds-button--outline-brand:hover,\n.slds-button_outline-brand:focus-visible,\n.slds-button--outline-brand:focus-visible{\n  --slds-c-button-color-background-hover:var(--slds-g-color-surface-container-2);\n  --slds-c-button-color-border-hover:var(--slds-g-color-border-accent-1);\n}\n.slds-button_outline-brand:active,.slds-button--outline-brand:active{\n  --slds-c-button-color-background-active:var(--slds-g-color-surface-container-2);\n  --slds-c-button-color-border-active:var(--slds-g-color-border-accent-1);\n}\n.slds-button_outline-brand[disabled],.slds-button--outline-brand[disabled],\n.slds-button_outline-brand:disabled,\n.slds-button--outline-brand:disabled{\n  background-color:var(--slds-g-color-disabled-container-1);\n  border-color:var(--slds-g-color-border-disabled-1);\n}\n.slds-button_inverse,.slds-button--inverse{\n  justify-content:center;\n  --slds-c-button-color-background:var(--slds-c-button-inverse-color-background, transparent);\n  --slds-c-button-color-border:var(\n    --slds-c-button-inverse-color-border,\n    var(--slds-g-color-border-inverse-1)\n  );\n  --slds-c-button-text-color:var(\n    --slds-c-button-inverse-text-color,\n    var(--slds-g-color-on-surface-inverse-1)\n  );\n  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);\n  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);\n}\n.slds-button_inverse:hover,.slds-button--inverse:hover,\n.slds-button_inverse:focus-visible,\n.slds-button--inverse:focus-visible{\n  --slds-c-button-color-background-hover:var(\n    --slds-c-button-inverse-color-background-hover,\n    var(--slds-g-color-surface-container-2)\n  );\n  --slds-c-button-color-border-hover:var(\n    --slds-c-button-inverse-color-border-hover,\n    var(--slds-g-color-border-inverse-1)\n  );\n}\n.slds-button_inverse:active,.slds-button--inverse:active{\n  --slds-c-button-color-background-active:var(\n    --slds-c-button-inverse-color-background-active,\n    var(--slds-g-color-surface-container-2)\n  );\n  --slds-c-button-color-border-active:var(\n    --slds-c-button-inverse-color-border-active,\n    var(--slds-g-color-border-inverse-2)\n  );\n}\n.slds-button_inverse[disabled],.slds-button--inverse[disabled],\n.slds-button_inverse:disabled,\n.slds-button--inverse:disabled{\n  background-color:transparent;\n  border-color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 50%);\n}\n.slds-button_inverse:link,.slds-button--inverse:link,\n.slds-button_inverse:visited,\n.slds-button--inverse:visited,\n.slds-button_icon-border-inverse:link,\n.slds-button--icon-border-inverse:link,\n.slds-button_icon-border-inverse:visited,\n.slds-button--icon-border-inverse:visited{\n  --slds-c-button-text-color:var(\n    --slds-c-button-inverse-text-color,\n    var(--slds-g-color-on-surface-inverse-1)\n  );\n}\n.slds-button_inverse:hover,.slds-button--inverse:hover,\n.slds-button_inverse:focus-visible,\n.slds-button--inverse:focus-visible,\n.slds-button_icon-border-inverse:hover,\n.slds-button--icon-border-inverse:hover,\n.slds-button_icon-border-inverse:focus-visible,\n.slds-button--icon-border-inverse:focus-visible{\n  --slds-c-button-text-color-hover:var(\n    --slds-c-button-inverse-text-color-hover,\n    var(--slds-g-color-accent-3)\n  );\n}\n.slds-button_inverse:focus-visible,.slds-button--inverse:focus-visible, .slds-button_icon-border-inverse:focus-visible, .slds-button--icon-border-inverse:focus-visible{\n  --slds-c-button-shadow-focus:var(--slds-s-button-shadow-focus-inverse, var(--slds-g-shadow-inverse-1));\n  --slds-c-button-color-border:var(--slds-g-color-border-inverse-1);\n\n  outline:none;\n}\n.slds-button_inverse:active,.slds-button--inverse:active, .slds-button_icon-border-inverse:active, .slds-button--icon-border-inverse:active{\n  --slds-c-button-text-color-active:var(\n    --slds-c-button-inverse-text-color-active,\n    var(--slds-g-color-accent-3)\n  );\n}\n.slds-button_inverse[disabled],.slds-button--inverse[disabled],\n.slds-button_inverse:disabled,\n.slds-button--inverse:disabled,\n.slds-button_icon-border-inverse[disabled],\n.slds-button--icon-border-inverse[disabled],\n.slds-button_icon-border-inverse:disabled,\n.slds-button--icon-border-inverse:disabled{\n  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 50%);\n}\n.slds-button_destructive,.slds-button--destructive{\n  justify-content:center;\n  --slds-c-button-color-background:var(--slds-g-color-error-container-1);\n  --slds-c-button-color-border:var(--slds-g-color-border-error-1);\n  --slds-c-button-text-color:var(--slds-g-color-on-error-1);\n  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);\n  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);\n}\n.slds-button_destructive:hover,.slds-button--destructive:hover,\n.slds-button_destructive:focus-visible,\n.slds-button--destructive:focus-visible{\n  --slds-c-button-color-background-hover:var(--slds-g-color-error-container-2);\n  --slds-c-button-color-border-hover:var(--slds-g-color-border-error-2);\n  --slds-c-button-text-color-hover:var(--slds-g-color-on-error-1);\n}\n.slds-button_destructive:active,.slds-button--destructive:active{\n  --slds-c-button-color-background-active:var(--slds-g-color-error-container-2);\n  --slds-c-button-color-border-active:var(--slds-g-color-border-error-2);\n  --slds-c-button-text-color-active:var(--slds-g-color-on-error-1);\n}\n.slds-button_destructive[disabled],.slds-button--destructive[disabled],\n.slds-button_destructive:disabled,\n.slds-button--destructive:disabled{\n  background-color:var(--slds-g-color-disabled-container-2);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-2);\n}\n.slds-button_text-destructive,.slds-button--text-destructive{\n  justify-content:center;\n  --slds-c-button-color-background:var(--slds-g-color-surface-container-1);\n  --slds-c-button-color-border:var(--slds-g-color-border-error-1);\n  --slds-c-button-text-color:var(--slds-g-color-error-1);\n  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);\n  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);\n}\n.slds-button_text-destructive:hover,.slds-button--text-destructive:hover,\n.slds-button_text-destructive:focus-visible,\n.slds-button--text-destructive:focus-visible{\n  --slds-c-button-color-background-hover:var(--slds-g-color-surface-container-2);\n  --slds-c-button-color-border-hover:var(--slds-g-color-border-error-2);\n  --slds-c-button-text-color-hover:var(--slds-g-color-error-1);\n}\n.slds-button_text-destructive:active,.slds-button--text-destructive:active{\n  --slds-c-button-color-background-active:var(--slds-g-color-surface-container-2);\n  --slds-c-button-color-border-active:var(--slds-g-color-border-error-2);\n  --slds-c-button-text-color-active:var(--slds-g-color-error-1);\n}\n.slds-button_text-destructive[disabled],.slds-button--text-destructive[disabled],\n.slds-button_text-destructive:disabled,\n.slds-button--text-destructive:disabled{\n  background-color:var(--slds-g-color-disabled-container-1);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-1);\n}\n.slds-button_success,.slds-button--success{\n  justify-content:center;\n  --slds-c-button-color-background:var(--slds-g-color-success-container-1);\n  --slds-c-button-color-border:var(--slds-g-color-border-success-1);\n  --slds-c-button-text-color:var(--slds-g-color-on-success-1);\n  --slds-c-button-spacing-blockstart:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-blockend:var(--slds-s-button-spacing-block);\n  --slds-c-button-spacing-inlinestart:var(--slds-s-button-spacing-inline);\n  --slds-c-button-spacing-inlineend:var(--slds-s-button-spacing-inline);\n}\n.slds-button_success:hover,.slds-button--success:hover,\n.slds-button_success:focus-visible,\n.slds-button--success:focus-visible{\n  --slds-c-button-color-background-hover:var(--slds-g-color-success-container-2);\n  --slds-c-button-color-border-hover:var(--slds-g-color-border-success-1);\n  --slds-c-button-text-color-hover:var(--slds-g-color-on-success-1);\n}\n.slds-button_success:active,.slds-button--success:active{\n  --slds-c-button-color-background-active:var(--slds-g-color-success-container-2);\n  --slds-c-button-color-border-active:var(--slds-g-color-border-success-1);\n  --slds-c-button-text-color-active:var(--slds-g-color-on-success-1);\n}\n.slds-button_success[disabled],.slds-button--success[disabled],\n.slds-button_success:disabled,\n.slds-button--success:disabled{\n  background-color:var(--slds-g-color-disabled-container-2);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-2);\n}\n.slds-button__icon,\n.slds-button__icon_stateful,\n.slds-button__icon--stateful{\n  width:0.875rem;\n  height:0.875rem;\n  fill:var(--slds-c-icon-color-foreground, currentColor);\n}\n.slds-button__icon_large,.slds-button__icon--large{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n}\n.slds-button__icon_small,.slds-button__icon--small{\n  width:var(--slds-g-sizing-4);\n  height:var(--slds-g-sizing-4);\n}\n.slds-button__icon_x-small,.slds-button__icon--x-small{\n  width:var(--slds-g-sizing-3);\n  height:var(--slds-g-sizing-3);\n}\n.slds-button__icon_left,.slds-button__icon--left{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-button__icon_right,.slds-button__icon--right{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-button_reset,.slds-button--reset{\n  font-size:inherit;\n  color:inherit;\n  line-height:inherit;\n  padding:0;\n  background:transparent;\n  border:0;\n  text-align:inherit;\n}\n.slds-button_stretch,.slds-button--stretch{\n  justify-content:center;\n  width:100%;\n}\n.slds-button_full-width,.slds-button--full-width{\n  color:inherit;\n  line-height:inherit;\n  padding:0;\n  background:transparent;\n  border:0;\n  text-align:inherit;\n  width:100%;\n  display:inline-flex;\n  flex-grow:1;\n  align-items:center;\n  justify-content:space-between;\n}\n.slds-button_full-width:focus-visible,.slds-button--full-width:focus-visible{\n  --slds-c-button-shadow:none;\n}\n.slds-button_icon,.slds-button--icon,\n.slds-button_icon-inverse,\n.slds-button--icon-inverse,\n.slds-button_icon-container,\n.slds-button--icon-container,\n.slds-button_icon-border,\n.slds-button--icon-border,\n.slds-button_icon-border-filled,\n.slds-button--icon-border-filled,\n.slds-button_icon-border-inverse,\n.slds-button--icon-border-inverse,\n.slds-button_icon-more,\n.slds-button--icon-more,\n.slds-button_icon-error,\n.slds-button--icon-error,\n.slds-button_icon-warning,\n.slds-button--icon-warning{\n  --slds-c-button-color-background-hover:none;\n\n  line-height:1;\n  vertical-align:middle;\n  justify-content:center;\n  color:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));\n  flex-shrink:0;\n  padding:0;\n}\n.slds-button_icon-container,.slds-button--icon-container,\n.slds-button_icon-border,\n.slds-button--icon-border,\n.slds-button_icon-border-filled,\n.slds-button--icon-border-filled,\n.slds-button_icon-border-inverse,\n.slds-button--icon-border-inverse,\n.slds-button_icon-brand,\n.slds-button--icon-brand,\n.slds-button_icon-more,\n.slds-button--icon-more,\n.slds-button_icon-container-more,\n.slds-button--icon-container-more{\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n}\n.slds-button_icon-border-filled,.slds-button--icon-border-filled,\n.slds-button_icon-border,\n.slds-button--icon-border{\n  line-height:1;\n  vertical-align:middle;\n  color:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  transition:border 0.15s linear;\n}\n.slds-button_icon-border-filled[disabled],.slds-button--icon-border-filled[disabled],\n.slds-button_icon-border-filled:disabled,\n.slds-button--icon-border-filled:disabled,\n.slds-button_icon-border[disabled],\n.slds-button--icon-border[disabled],\n.slds-button_icon-border:disabled,\n.slds-button--icon-border:disabled{\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-disabled-2);\n}\n.slds-button_icon-border-inverse,.slds-button--icon-border-inverse{\n  background-color:transparent;\n  border-color:var(--slds-g-color-border-inverse-1);\n}\n.slds-button_icon-border-inverse[disabled],.slds-button--icon-border-inverse[disabled],\n.slds-button_icon-border-inverse:disabled,\n.slds-button--icon-border-inverse:disabled{\n  background-color:transparent;\n  border-color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 75%);\n}\n.slds-button_icon-brand,.slds-button--icon-brand{\n  background-color:var(--slds-g-color-accent-container-1);\n  border-color:var(--slds-g-color-border-accent-1);\n  color:var(--slds-g-color-on-accent-1);\n}\n.slds-button_icon-brand:visited,.slds-button--icon-brand:visited,\n.slds-button_icon-brand:active,\n.slds-button--icon-brand:active{\n  color:var(--slds-g-color-on-accent-1);\n}\n.slds-button_icon-brand:hover,.slds-button--icon-brand:hover,\n.slds-button_icon-brand:focus,\n.slds-button--icon-brand:focus{\n  background-color:var(--slds-g-color-accent-container-2);\n  border-color:var(--slds-g-color-accent-container-2);\n  color:var(--slds-g-color-on-accent-1);\n}\n.slds-button_icon-brand:active,.slds-button--icon-brand:active{\n  background-color:var(--slds-g-color-accent-container-3);\n  border-color:var(--slds-g-color-accent-container-3);\n}\n.slds-button_icon-brand[disabled],.slds-button--icon-brand[disabled],\n.slds-button_icon-brand:disabled,\n.slds-button--icon-brand:disabled{\n  background:var(--slds-g-color-disabled-container-2);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-2);\n}\n.slds-button_icon-border-filled,.slds-button--icon-border-filled{\n  --slds-c-button-color-background:var(--slds-g-color-surface-container-1);\n}\n.slds-button_icon-border-filled:hover,.slds-button--icon-border-filled:hover,\n.slds-button_icon-border-filled:focus-visible,\n.slds-button--icon-border-filled:focus-visible{\n  --slds-c-button-color-background-hover:var(--slds-g-color-surface-container-2);\n}\n.slds-button_icon-border-filled[disabled],.slds-button--icon-border-filled[disabled],\n.slds-button_icon-border-filled:disabled,\n.slds-button--icon-border-filled:disabled{\n  border-color:var(--slds-g-color-border-disabled-1);\n  background-color:var(--slds-g-color-disabled-container-1);\n}\n.slds-button_icon-inverse,.slds-button--icon-inverse,\n.slds-button_icon-border-inverse,\n.slds-button--icon-border-inverse{\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-button_icon-inverse:hover,.slds-button--icon-inverse:hover,\n.slds-button_icon-inverse:focus-visible,\n.slds-button--icon-inverse:focus-visible,\n.slds-button_icon-border-inverse:hover,\n.slds-button--icon-border-inverse:hover,\n.slds-button_icon-border-inverse:focus-visible,\n.slds-button--icon-border-inverse:focus-visible{\n  --slds-c-button-color-background-hover:transparent;\n\n  color:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 25%);\n}\n.slds-button_icon-inverse:focus-visible,.slds-button--icon-inverse:focus-visible, .slds-button_icon-border-inverse:focus-visible, .slds-button--icon-border-inverse:focus-visible{\n  outline:none;\n  box-shadow:var(--slds-s-button-shadow-focus-inverse);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-inverse-1);\n}\n.slds-button_icon-inverse:active,.slds-button--icon-inverse:active, .slds-button_icon-border-inverse:active, .slds-button--icon-border-inverse:active{\n  color:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 50%);\n}\n.slds-button_icon-inverse[disabled],.slds-button--icon-inverse[disabled],\n.slds-button_icon-inverse:disabled,\n.slds-button--icon-inverse:disabled,\n.slds-button_icon-border-inverse[disabled],\n.slds-button--icon-border-inverse[disabled],\n.slds-button_icon-border-inverse:disabled,\n.slds-button--icon-border-inverse:disabled{\n  color:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 75%);\n}\n.slds-button_icon-error,.slds-button--icon-error{\n  color:var(--slds-g-color-error-1);\n}\n.slds-button_icon-error:hover,.slds-button--icon-error:hover,\n.slds-button_icon-error:active,\n.slds-button--icon-error:active,\n.slds-button_icon-error:focus-visible,\n.slds-button--icon-error:focus-visible{\n  color:var(--slds-g-color-error-1);\n}\n.slds-button_icon-warning,.slds-button--icon-warning{\n  color:var(--slds-g-color-warning-1);\n}\n.slds-button_icon-warning:hover,.slds-button--icon-warning:hover,\n.slds-button_icon-warning:active,\n.slds-button--icon-warning:active,\n.slds-button_icon-warning:focus-visible,\n.slds-button--icon-warning:focus-visible{\n  color:var(--slds-g-color-warning-1);\n}\n.slds-button_icon-current-color,.slds-button--icon-current-color{\n  color:currentColor;\n}\n.slds-button_icon-large,.slds-button--icon-large{\n  width:var(--slds-g-sizing-10);\n  height:var(--slds-g-sizing-10);\n}\n.slds-button_icon-large .slds-button__icon,.slds-button--icon-large .slds-button__icon{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n}\n.slds-button_icon-small,.slds-button--icon-small{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n}\n.slds-button_icon-x-small,.slds-button--icon-x-small{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n  line-height:1;\n}\n.slds-button_icon-x-small .slds-button__icon,.slds-button--icon-x-small .slds-button__icon{\n  width:var(--slds-g-sizing-4);\n  height:var(--slds-g-sizing-4);\n}\n.slds-button_icon-xx-small,.slds-button--icon-xx-small{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  line-height:1;\n}\n.slds-button_icon-xx-small .slds-button__icon,.slds-button--icon-xx-small .slds-button__icon{\n  width:var(--slds-g-sizing-3);\n  height:var(--slds-g-sizing-3);\n}\n.slds-button_icon-more,.slds-button--icon-more{\n  width:auto;\n  line-height:1.875rem;\n  padding:0 var(--slds-g-spacing-2);\n  background-color:var(--slds-g-color-surface-container-1);\n  border-color:var(--slds-g-color-border-2);\n  color:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));\n}\n.slds-button_icon-more:hover .slds-button__icon,.slds-button--icon-more:hover .slds-button__icon, .slds-button_icon-more:focus .slds-button__icon, .slds-button--icon-more:focus .slds-button__icon{\n  fill:var(--slds-s-button-color-hover, var(--slds-g-color-accent-2));\n}\n.slds-button_icon-more:active .slds-button__icon,.slds-button--icon-more:active .slds-button__icon{\n  fill:var(--slds-g-color-accent-3);\n}\n.slds-button_icon-more[disabled],.slds-button--icon-more[disabled],\n.slds-button_icon-more:disabled,\n.slds-button--icon-more:disabled{\n  cursor:default;\n}\n.slds-button_icon-more[disabled] .slds-button__icon,.slds-button--icon-more[disabled] .slds-button__icon, .slds-button_icon-more:disabled .slds-button__icon, .slds-button--icon-more:disabled .slds-button__icon{\n  fill:var(--slds-g-color-disabled-1);\n}\n.slds-button_icon-container-more,.slds-button--icon-container-more{\n  width:auto;\n  line-height:1.875rem;\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-2);\n  vertical-align:middle;\n}\n.slds-button__icon_hint,.slds-button__icon--hint{\n  fill:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));\n}\n.slds-button__icon_inverse-hint,.slds-button__icon--inverse-hint{\n  fill:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 50%);\n}\n.slds-hint-parent .slds-button_icon-border-inverse,.slds-hint-parent .slds-button--icon-border-inverse{\n  border-color:color-mix(in oklab, var(--slds-g-color-border-inverse-1), transparent 50%);\n}\n.slds-hint-parent .slds-button_icon-border-inverse:focus,.slds-hint-parent .slds-button--icon-border-inverse:focus{\n  border-color:color-mix(in oklab, var(--slds-g-color-border-inverse-1), transparent 25%);\n}\n.slds-hint-parent:hover .slds-button_icon-border-inverse,.slds-hint-parent:hover .slds-button--icon-border-inverse, .slds-hint-parent:focus .slds-button_icon-border-inverse, .slds-hint-parent:focus .slds-button--icon-border-inverse{\n  border-color:color-mix(in oklab, var(--slds-g-color-border-inverse-1), transparent 25%);\n}\n.slds-hint-parent:hover .slds-button__icon_hint,.slds-hint-parent:hover .slds-button__icon--hint, .slds-hint-parent:focus .slds-button__icon_hint, .slds-hint-parent:focus .slds-button__icon--hint{\n  fill:var(--slds-g-color-on-surface-2);\n}\n.slds-hint-parent:hover .slds-button__icon_inverse-hint,.slds-hint-parent:hover .slds-button__icon--inverse-hint, .slds-hint-parent:focus .slds-button__icon_inverse-hint, .slds-hint-parent:focus .slds-button__icon--inverse-hint{\n  fill:color-mix(in oklab, var(--slds-g-color-on-surface-inverse-1), transparent 25%);\n}\n.slds-hint-parent:hover .slds-button:disabled .slds-button__icon_hint,.slds-hint-parent:hover .slds-button:disabled .slds-button__icon--hint, .slds-hint-parent:focus .slds-button:disabled .slds-button__icon_hint, .slds-hint-parent:focus .slds-button:disabled .slds-button__icon--hint{\n  fill:currentColor;\n}\n.slds-button_icon-container.slds-is-selected,.slds-button--icon-container.slds-is-selected,\n.slds-button_icon-border.slds-is-selected,\n.slds-button--icon-border.slds-is-selected,\n.slds-button_icon-border-filled.slds-is-selected,\n.slds-button--icon-border-filled.slds-is-selected,\n.slds-button_icon-border-inverse.slds-is-selected,\n.slds-button--icon-border-inverse.slds-is-selected{\n  background-color:var(--slds-g-color-accent-container-1);\n  border-color:var(--slds-g-color-border-accent-1);\n  color:var(--slds-g-color-on-accent-1);\n}\n.slds-button_icon-container.slds-is-selected:hover,.slds-button--icon-container.slds-is-selected:hover,\n.slds-button_icon-container.slds-is-selected:focus,\n.slds-button--icon-container.slds-is-selected:focus,\n.slds-button_icon-border.slds-is-selected:hover,\n.slds-button--icon-border.slds-is-selected:hover,\n.slds-button_icon-border.slds-is-selected:focus,\n.slds-button--icon-border.slds-is-selected:focus,\n.slds-button_icon-border-filled.slds-is-selected:hover,\n.slds-button--icon-border-filled.slds-is-selected:hover,\n.slds-button_icon-border-filled.slds-is-selected:focus,\n.slds-button--icon-border-filled.slds-is-selected:focus,\n.slds-button_icon-border-inverse.slds-is-selected:hover,\n.slds-button--icon-border-inverse.slds-is-selected:hover,\n.slds-button_icon-border-inverse.slds-is-selected:focus,\n.slds-button--icon-border-inverse.slds-is-selected:focus{\n  background-color:var(--slds-g-color-accent-container-2);\n  border-color:var(--slds-g-color-accent-container-2);\n  color:var(--slds-g-color-on-accent-1);\n}\n.slds-button_icon-container.slds-is-selected[disabled],.slds-button--icon-container.slds-is-selected[disabled],\n.slds-button_icon-container.slds-is-selected:disabled,\n.slds-button--icon-container.slds-is-selected:disabled,\n.slds-button_icon-border.slds-is-selected[disabled],\n.slds-button--icon-border.slds-is-selected[disabled],\n.slds-button_icon-border.slds-is-selected:disabled,\n.slds-button--icon-border.slds-is-selected:disabled,\n.slds-button_icon-border-filled.slds-is-selected[disabled],\n.slds-button--icon-border-filled.slds-is-selected[disabled],\n.slds-button_icon-border-filled.slds-is-selected:disabled,\n.slds-button--icon-border-filled.slds-is-selected:disabled,\n.slds-button_icon-border-inverse.slds-is-selected[disabled],\n.slds-button--icon-border-inverse.slds-is-selected[disabled],\n.slds-button_icon-border-inverse.slds-is-selected:disabled,\n.slds-button--icon-border-inverse.slds-is-selected:disabled{\n  background:var(--slds-g-color-disabled-container-2);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-2);\n}\n.slds-button_neutral.slds-is-selected,.slds-button--neutral.slds-is-selected{\n  --slds-c-button-neutral-color-background:var(\n    --slds-c-button-stateful-color-background-selected,\n    transparent\n  );\n  --slds-c-button-neutral-color-border:var(--slds-c-button-stateful-color-border-selected, transparent);\n}\n.slds-button_neutral.slds-is-selected:hover:not([disabled]),.slds-button--neutral.slds-is-selected:hover:not([disabled]),\n.slds-button_neutral.slds-is-selected:focus:not([disabled]),\n.slds-button--neutral.slds-is-selected:focus:not([disabled]){\n  --slds-c-button-neutral-color-background-hover:var(\n    --slds-c-button-stateful-color-background-selected-hover,\n    var(--slds-g-color-surface-container-2)\n  );\n  --slds-c-button-neutral-color-border-hover:var(\n    --slds-c-button-stateful-color-border-selected-hover,\n    var(--slds-g-color-border-1)\n  );\n}\n.slds-button_neutral.slds-is-selected:active:not([disabled]),.slds-button--neutral.slds-is-selected:active:not([disabled]){\n  --slds-c-button-neutral-color-background-active:var(\n    --slds-c-button-stateful-color-background-selected-active,\n    var(--slds-g-color-surface-container-2)\n  );\n}\n.slds-button_inverse.slds-is-selected,.slds-button--inverse.slds-is-selected{\n  border-color:transparent;\n}\n.slds-button_stateful .slds-text-selected,.slds-button--stateful .slds-text-selected,\n.slds-button_stateful .slds-text-selected-focus,\n.slds-button--stateful .slds-text-selected-focus,\n.slds-button_stateful .slds-text-not-selected,\n.slds-button--stateful .slds-text-not-selected{\n  align-items:center;\n}\n.slds-not-selected .slds-text-selected{\n  display:none;\n}\n.slds-not-selected .slds-text-selected-focus{\n  display:none;\n}\n.slds-not-selected .slds-text-not-selected{\n  display:inline-flex;\n}\n.slds-is-selected-clicked .slds-text-selected, .slds-is-selected[disabled] .slds-text-selected, .slds-is-selected[disabled]:hover .slds-text-selected, .slds-is-selected[disabled]:focus .slds-text-selected{\n  display:inline-flex;\n}\n.slds-is-selected-clicked .slds-text-selected-focus, .slds-is-selected[disabled] .slds-text-selected-focus, .slds-is-selected[disabled]:hover .slds-text-selected-focus, .slds-is-selected[disabled]:focus .slds-text-selected-focus{\n  display:none;\n}\n.slds-is-selected-clicked .slds-text-not-selected, .slds-is-selected[disabled] .slds-text-not-selected, .slds-is-selected[disabled]:hover .slds-text-not-selected, .slds-is-selected[disabled]:focus .slds-text-not-selected{\n  display:none;\n}\n.slds-is-selected .slds-text-not-selected{\n  display:none;\n}\n.slds-is-selected .slds-text-selected{\n  display:inline-flex;\n}\n.slds-is-selected .slds-text-selected-focus{\n  display:none;\n}\n.slds-is-selected:hover .slds-text-not-selected, .slds-is-selected:focus .slds-text-not-selected{\n  display:none;\n}\n.slds-is-selected:hover .slds-text-selected, .slds-is-selected:focus .slds-text-selected{\n  display:none;\n}\n.slds-is-selected:hover .slds-text-selected-focus, .slds-is-selected:focus .slds-text-selected-focus{\n  display:inline-flex;\n}\n.slds-button_dual-stateful .slds-text-not-pressed,.slds-button--dual-stateful .slds-text-not-pressed{\n  display:block;\n}\n.slds-button_dual-stateful .slds-text-pressed,.slds-button--dual-stateful .slds-text-pressed{\n  display:none;\n}\n.slds-button_dual-stateful.slds-is-pressed,.slds-button--dual-stateful.slds-is-pressed{\n  padding-inline-start:var(--slds-c-button-brand-spacing-inlinestart, var(--slds-g-spacing-4));\n  padding-inline-end:var(--slds-c-button-brand-spacing-inlineend, var(--slds-g-spacing-4));\n\n  --slds-c-button-color-background:var(\n    --slds-c-button-brand-color-background,\n    var(--slds-g-color-accent-container-1)\n  );\n\n  --slds-c-button-color-border:var(--slds-c-button-brand-color-border, var(--slds-g-color-border-accent-1));\n  --slds-c-button-text-color:var(--slds-c-button-brand-text-color, var(--slds-g-color-on-accent-1));\n\n  --slds-c-button-text-color-hover:var(\n    --slds-c-button-brand-text-color-hover,\n    var(--slds-g-color-on-accent-1)\n  );\n\n  --slds-c-button-text-color-active:var(\n    --slds-c-button-brand-text-color-active,\n    var(--slds-g-color-on-accent-1)\n  );\n}\n.slds-button_dual-stateful.slds-is-pressed:focus,.slds-button--dual-stateful.slds-is-pressed:focus,\n.slds-button_dual-stateful.slds-is-pressed:hover,\n.slds-button--dual-stateful.slds-is-pressed:hover{\n  --slds-c-button-color-background:var(\n    --slds-c-button-brand-color-background-hover,\n    var(--slds-g-color-accent-container-2)\n  );\n\n  --slds-c-button-color-border:var(\n    --slds-c-button-brand-color-border-hover,\n    var(--slds-g-color-border-accent-2)\n  );\n\n  --slds-c-button-text-color-hover:var(\n    --slds-c-button-brand-text-color-hover,\n    var(--slds-g-color-on-accent-1)\n  );\n}\n.slds-button_dual-stateful.slds-is-pressed .slds-text-not-pressed,.slds-button--dual-stateful.slds-is-pressed .slds-text-not-pressed{\n  display:none;\n}\n.slds-button_dual-stateful.slds-is-pressed .slds-text-pressed,.slds-button--dual-stateful.slds-is-pressed .slds-text-pressed{\n  display:block;\n}\n.slds-breadcrumb .slds-list__item,\n.slds-breadcrumb .slds-breadcrumb__item{\n  position:relative;\n}\n.slds-breadcrumb .slds-list__item::before,\n.slds-breadcrumb .slds-breadcrumb__item::before{\n  content:'>';\n  position:absolute;\n  inset-inline-start:calc(var(--slds-g-spacing-1) * -1);\n}\n.slds-breadcrumb .slds-list__item > a,\n.slds-breadcrumb .slds-breadcrumb__item > a{\n  display:block;\n  padding-block-start:0;\n  padding-inline-end:var(--slds-c-breadcrumbs-spacing-inlineend, var(--slds-g-spacing-2));\n  padding-block-end:0;\n  padding-inline-start:var(--slds-c-breadcrumbs-spacing-inlinestart, var(--slds-g-spacing-2));\n}\n.slds-breadcrumb .slds-list__item > a:hover,\n.slds-breadcrumb .slds-breadcrumb__item > a:hover{\n  text-decoration:none;\n}\n.slds-breadcrumb .slds-list__item:first-child > a,\n.slds-breadcrumb .slds-breadcrumb__item:first-child > a{\n  --slds-c-breadcrumbs-spacing-inlinestart:0;\n}\n.slds-breadcrumb .slds-list__item:first-child::before,\n.slds-breadcrumb .slds-breadcrumb__item:first-child::before{\n  content:'';\n}\n.slds-breadcrumb .slds-dropdown-trigger{\n  margin-inline-end:var(--slds-c-breadcrumbs-spacing-inlineend, var(--slds-g-spacing-2));\n}\n[kx-scope='breadcrumbs-item'][kx-type='underline'] > a{\n  position:relative;\n  will-change:color, transform;\n  transition:transform calc(calc(1 * 1) * 250ms / 1) cubic-bezier(0, 0.3, 0.15, 1);\n  margin-inline-end:var(--slds-g-spacing-2);\n  margin-inline-start:var(--slds-g-spacing-2);\n  padding-inline-end:0;\n  padding-inline-start:0;\n}\n[kx-scope='breadcrumbs-item'][kx-type='underline'] > a:active{\n  transform:scale(0.95);\n}\n@media (prefers-reduced-motion: reduce){\n  [kx-scope='breadcrumbs-item'][kx-type='underline'] > a:active{\n    transform:none;\n  }\n}\n[kx-scope='breadcrumbs-item'][kx-type='underline'] > a::after{\n  will-change:transform-origin, transform;\n  content:'';\n  position:absolute;\n  inset-block-start:80%;\n  inset-inline-start:0%;\n  height:0.0625rem;\n  width:100%;\n  background:var(--slds-g-color-accent-2);\n  background-position:left top;\n  transform:scaleX(0);\n  transform-origin:var(--slds-kx-breadcrumbs-pointer-position-x, 50%) 0;\n  transition:transform calc(calc(1 * 1) * 250ms / 1) cubic-bezier(0, 0.3, 0.15, 1);\n}\n[kx-scope='breadcrumbs-item'][kx-type='underline'] > a:hover::after{\n  transform:scaleX(1);\n}\n[kx-scope='breadcrumbs-item'][kx-type='underline']:first-child > a{\n  margin-inline-start:0;\n}\n.slds-builder-header_container,.slds-builder-header--container{\n  position:fixed;\n  width:100%;\n  inset-block-start:0;\n  inset-inline-start:0;\n  z-index:100;\n}\n.slds-builder-header{\n  position:relative;\n  display:flex;\n  height:var(--slds-s-header-sizing-height, 3.125rem);\n  background:var(--slds-g-color-surface-inverse-1, var(--slds-g-color-brand-base-20));\n  color:var(--slds-g-color-on-surface-inverse-1, var(--slds-g-color-neutral-base-100));\n}\n.slds-builder-header__item{\n  display:flex;\n  align-content:center;\n  align-items:center;\n  white-space:nowrap;\n}\n.slds-builder-header__item + .slds-builder-header__item{\n  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-surface-inverse-2, var(--slds-g-color-brand-base-10));\n}\n.slds-builder-header__item-action,\n.slds-builder-header__item-label{\n  color:currentColor;\n  padding:0 var(--slds-g-spacing-4);\n  display:flex;\n  align-content:center;\n  align-items:center;\n  flex-grow:1;\n  min-width:0%;\n  height:100%;\n}\n.slds-builder-header__item-action .slds-media__body,\n.slds-builder-header__item-label .slds-media__body{\n  flex-basis:auto;\n}\n.slds-builder-header__item-action{\n  transition:all 150ms linear;\n}\n.slds-builder-header__item-action:hover,\n.slds-builder-header__item-action:focus{\n  background-color:var(--slds-g-color-surface-inverse-2, var(--slds-g-color-brand-base-10));\n  color:var(--slds-g-color-on-surface-inverse-1, var(--slds-g-color-neutral-base-100));\n  text-decoration:none;\n  --slds-c-button-radius-border:0;\n}\n.slds-builder-header__item-action:focus{\n  text-decoration:underline;\n  box-shadow:var(--slds-g-shadow-6, 0 0 3px #0176d3);\n  outline:none;\n  border-radius:0;\n}\n.slds-builder-header__nav,\n.slds-builder-header__utilities{\n  align-items:stretch;\n}\n.slds-builder-header__nav-list{\n  display:flex;\n}\n.slds-builder-header__utilities{\n  margin-inline-start:auto;\n}\n.slds-builder-header__nav-item,\n.slds-builder-header__utilities-item{\n  display:flex;\n  align-content:center;\n  align-items:stretch;\n}\n.slds-builder-header__nav-item + .slds-builder-header__nav-item,\n.slds-builder-header__nav-item + .slds-builder-header__utilities-item,\n.slds-builder-header__utilities-item + .slds-builder-header__nav-item,\n.slds-builder-header__utilities-item + .slds-builder-header__utilities-item{\n  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-surface-inverse-2, var(--slds-g-color-brand-base-10));\n}\n.slds-builder-toolbar{\n  display:flex;\n  padding-block:var(--slds-g-sizing-3);\n  padding-inline:var(--slds-g-sizing-4);\n  background:var(--slds-g-color-surface-container-1, var(--slds-g-color-neutral-base-100));\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1, var(--slds-g-color-border-base-1));\n}\n.slds-builder-toolbar__actions{\n  display:flex;\n  align-items:center;\n  margin-inline-start:auto;\n}\n.slds-builder-toolbar__item-group{\n  display:flex;\n  align-items:center;\n}\n.slds-builder-toolbar__item-group + .slds-builder-toolbar__item-group{\n  margin-inline-start:var(--slds-g-sizing-2);\n}\n.slds-input_counter,.slds-input--counter{\n  text-align:center;\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-8);\n}\n.slds-input_counter[type='number'],.slds-input--counter[type='number']{\n  appearance:textfield;\n}\n.slds-input_counter::-webkit-inner-spin-button,.slds-input--counter::-webkit-inner-spin-button{\n  appearance:none;\n  margin:0;\n}\n.slds-input__button_decrement,.slds-input__button--decrement{\n  position:absolute;\n  top:50%;\n  transform:translateY(-50%);\n  inset-inline-start:0.75rem;\n}\n.slds-input__button_increment,.slds-input__button--increment{\n  position:absolute;\n  top:50%;\n  transform:translateY(-50%);\n  inset-inline-end:0.75rem;\n}\n.slds-icon_container,.slds-icon--container{\n  padding-block-start:var(--slds-s-icon-spacing);\n  padding-block-end:var(--slds-s-icon-spacing);\n  padding-inline-start:var(--slds-s-icon-spacing);\n  padding-inline-end:var(--slds-s-icon-spacing);\n  border-radius:var(--slds-c-icon-radius-border, var(--slds-s-icon-radius-border));\n  border-width:var(--slds-s-icon-sizing-border, 0);\n  border-style:solid;\n  border-color:var(--slds-s-icon-color-border, transparent);\n  background-color:var(--slds-c-icon-color-background, var(--slds-s-icon-color-background));\n  display:inline-block;\n  line-height:1;\n}\n.slds-icon_container_circle,.slds-icon_container--circle{\n  --slds-c-icon-radius-border:var(--slds-g-radius-border-circle);\n\n  padding:var(--slds-g-spacing-2);\n}\n[dir='rtl'] .slds-icon_flip,[dir='rtl'] .slds-icon--flip{\n  transform:scaleX(-1);\n}\n.slds-icon{\n  display:inline-flex;\n  height:var(--_slds-c-icon-sizing, var(--slds-s-icon-sizing, var(--slds-g-sizing-9)));\n  width:var(--_slds-c-icon-sizing, var(--slds-s-icon-sizing, var(--slds-g-sizing-9)));\n  fill:var(--slds-c-icon-color-foreground, var(--slds-g-color-neutral-base-100));\n}\n.slds-icon_xxx-small,.slds-icon--xxx-small{\n  width:var(--slds-g-sizing-3);\n  height:var(--slds-g-sizing-3);\n}\n.slds-icon_xx-small,.slds-icon--xx-small{\n  width:calc(var(--slds-g-sizing-1) + var(--slds-g-sizing-4));\n  height:calc(var(--slds-g-sizing-1) + var(--slds-g-sizing-4));\n}\n.slds-icon_x-small,.slds-icon--x-small{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n}\n.slds-icon_small,.slds-icon--small{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n}\n.slds-icon_large,.slds-icon--large{\n  --_slds-c-icon-sizing:var(--slds-g-sizing-10);\n}\n.slds-icon-text-warning{\n  --slds-c-icon-color-foreground:var(--slds-g-color-warning-1);\n}\n.slds-icon-text-success{\n  --slds-c-icon-color-foreground:var(--slds-g-color-success-1);\n}\n.slds-icon-text-error{\n  --slds-c-icon-color-foreground:var(--slds-g-color-error-1);\n}\n.slds-icon-text-light{\n  --slds-c-icon-color-foreground:var(--slds-g-color-neutral-base-70);\n}\n.slds-icon_container[icon-name^='action'],.slds-icon--container[icon-name^='action']{\n  --slds-c-icon-radius-border:var(--slds-g-radius-border-circle);\n\n  padding-block:var(--slds-g-sizing-3);\n  padding-inline:var(--slds-g-sizing-3);\n}\n.slds-icon_container[icon-name^='action'],.slds-icon--container[icon-name^='action'],\n.slds-icon_container[class^='action'],\n.slds-icon--container[class^='action'],\n.slds-icon_container[icon-name^='standard'],\n.slds-icon--container[icon-name^='standard'],\n.slds-icon_container[class^='standard'],\n.slds-icon--container[class^='standard'],\n.slds-icon_container[icon-name^='custom'],\n.slds-icon--container[icon-name^='custom'],\n.slds-icon_container[class^='custom'],\n.slds-icon--container[class^='custom']{\n  --slds-c-icon-color-foreground:var(--slds-g-color-neutral-base-100);\n}\n.slds-icon-text-default{\n  --slds-c-icon-color-foreground:var(\n    --slds-c-icon-color-foreground-default,\n    var(--slds-s-icon-color-foreground)\n  );\n}\n.slds-icon-text-default.slds-is-disabled{\n  fill:var(--slds-g-color-disabled-1);\n}\n.slds-current-color .slds-icon{\n  --slds-c-icon-color-foreground:currentColor;\n}\n.slds-icon_disabled,.slds-icon--disabled{\n  background-color:currentcolor;\n}\n.slds-input__icon{\n  --_slds-c-icon-sizing:calc(var(--slds-g-sizing-1) + var(--slds-g-sizing-4));\n\n  position:absolute;\n  top:50%;\n  margin-block-start:-0.4375rem;\n  line-height:var(--slds-g-font-lineheight-1);\n  border:0;\n  z-index:2;\n}\n.slds-accordion{\n  position:relative;\n}\n.slds-accordion__list-item{\n  border-block-start-width:var(--slds-c-accordion-section-sizing-border, var(--slds-g-sizing-border-1));\n  border-block-start-style:solid;\n  border-block-start-color:var(--slds-c-accordion-section-color-border, var(--slds-g-color-border-1));\n}\n.slds-accordion__list-item:first-child{\n  border-top:0;\n}\n.slds-accordion__summary{\n  display:flex;\n  margin-block-start:calc(var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4)) * -1);\n  margin-inline-end:calc(var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4)) * -1);\n  margin-block-end:calc(var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4)) * -1);\n  margin-inline-start:calc(var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4)) * -1);\n  padding-block-start:var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4));\n  padding-inline-end:var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4));\n  padding-block-end:var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4));\n  padding-inline-start:var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4));\n  background-color:var(--slds-c-accordion-summary-color-background, transparent);\n}\n.slds-accordion__summary-heading{\n  display:flex;\n  flex-grow:1;\n  min-width:0;\n  color:var(--slds-c-accordion-heading-color, var(--slds-g-color-on-surface-3));\n  font-size:var(\n    --slds-c-accordion-heading-font-size,\n    var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-1))\n  );\n  font-weight:var(--slds-s-container-heading-font-weight, var(--slds-g-font-weight-4));\n  line-height:var(--slds-g-font-lineheight-2);\n}\n.slds-accordion__summary-heading .slds-button:focus-visible{\n  box-shadow:inset 0 0 0 2px var(--slds-g-color-brand-base-15);\n  border-radius:var(--slds-g-radius-border-3);\n  margin-inline-end:var(--slds-c-accordion-section-spacing-inlineend, revert);\n}\n.slds-accordion__summary-action{\n  display:inline-flex;\n  flex-grow:1;\n  align-items:center;\n  justify-content:flex-start;\n  min-width:0;\n  margin-block-start:calc(var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4)) * -1);\n  margin-inline-end:calc(var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4)) * -1);\n  margin-block-end:calc(var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4)) * -1);\n  margin-inline-start:calc(var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4)) * -1);\n  padding-block-start:var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4));\n  padding-inline-end:var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4));\n  padding-block-end:var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4));\n  padding-inline-start:var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4));\n  font-weight:inherit;\n}\n.slds-accordion__summary-action:hover,\n.slds-accordion__summary-action:focus{\n  color:var(--slds-g-color-accent-container-3);\n}\n.slds-accordion__summary-action:active{\n  box-shadow:none;\n}\n.slds-accordion__summary-action-icon{\n  flex-shrink:0;\n  transform:rotate(-90deg);\n}\n.slds-accordion__summary-action-icon:dir(rtl){\n  transform:rotate(90deg);\n}\n@media (min-width: 64em){\n  .slds-accordion__summary-content{\n    max-width:100%;\n    overflow:hidden;\n    text-overflow:ellipsis;\n    white-space:nowrap\n  }\n}\n.slds-accordion__section{\n  padding-block-start:var(--slds-c-accordion-section-spacing-blockstart, var(--slds-g-sizing-4));\n  padding-inline-end:var(--slds-c-accordion-section-spacing-inlineend, var(--slds-g-sizing-4));\n  padding-block-end:var(--slds-c-accordion-section-spacing-blockend, var(--slds-g-sizing-4));\n  padding-inline-start:var(--slds-c-accordion-section-spacing-inlinestart, var(--slds-g-sizing-4));\n}\n.slds-accordion__content{\n  overflow:hidden;\n  visibility:hidden;\n  opacity:0;\n  height:0;\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-is-open > .slds-accordion__summary{\n  margin-block-end:0;\n}\n.slds-is-open > .slds-accordion__summary .slds-accordion__summary-action-icon{\n  transform:rotate(0deg);\n}\n.slds-is-open > .slds-accordion__content{\n  overflow:visible;\n  visibility:visible;\n  opacity:1;\n  height:auto;\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-icon-ellie{\n  width:calc(14rem / 16);\n  height:calc(14rem / 16);\n  display:inline-block;\n  overflow:hidden;\n}\n.slds-icon-ellie.slds-is-animated{\n  will-change:transform;\n  animation:slds-icon-ellie-pop 0.3s ease-in 2s 1 both;\n}\n.slds-icon-ellie.slds-is-animated svg{\n  will-change:transform;\n  animation:slds-icon-ellie 1.2s steps(20) 2.3s 2 alternate;\n}\n.slds-icon-ellie.slds-is-paused,\n.slds-icon-ellie.slds-is-paused svg{\n  animation-play-state:paused;\n}\n.slds-icon-ellie svg{\n  width:17.5rem;\n  vertical-align:top;\n  color:var(--slds-g-color-accent-1);\n}\n.slds-icon-ellie circle:nth-child(2n + 1){\n  fill:currentColor;\n  stroke:currentColor;\n  stroke-width:4px;\n}\n.slds-icon-ellie circle:nth-child(2n){\n  fill:var(--slds-g-color-on-accent-1);\n  stroke:var(--slds-g-color-on-accent-1);\n  stroke-width:1px;\n}\n.slds-icon-ellie circle:nth-child(1),\n.slds-icon-ellie circle:nth-last-child(2){\n  stroke-width:4px;\n}\n.slds-icon-ellie circle:nth-child(2),\n.slds-icon-ellie circle:nth-last-child(1){\n  stroke-width:1px;\n}\n.slds-icon-ellie circle:nth-child(3),\n.slds-icon-ellie circle:nth-last-child(4){\n  stroke-width:3.95px;\n}\n.slds-icon-ellie circle:nth-child(4),\n.slds-icon-ellie circle:nth-last-child(3){\n  stroke-width:1.2px;\n}\n.slds-icon-ellie circle:nth-child(5),\n.slds-icon-ellie circle:nth-last-child(6){\n  stroke-width:3.85px;\n}\n.slds-icon-ellie circle:nth-child(6),\n.slds-icon-ellie circle:nth-last-child(5){\n  stroke-width:1.4px;\n}\n.slds-icon-ellie circle:nth-child(7),\n.slds-icon-ellie circle:nth-last-child(8){\n  stroke-width:3.6px;\n}\n.slds-icon-ellie circle:nth-child(8),\n.slds-icon-ellie circle:nth-last-child(7){\n  stroke-width:1.7px;\n}\n.slds-icon-ellie circle:nth-child(9),\n.slds-icon-ellie circle:nth-last-child(10){\n  stroke-width:3.3px;\n}\n.slds-icon-ellie circle:nth-child(10),\n.slds-icon-ellie circle:nth-last-child(9){\n  stroke-width:2px;\n}\n.slds-icon-ellie circle:nth-child(11),\n.slds-icon-ellie circle:nth-last-child(12){\n  stroke-width:3.2px;\n}\n.slds-icon-ellie circle:nth-child(12),\n.slds-icon-ellie circle:nth-last-child(11){\n  stroke-width:2.4px;\n}\n.slds-icon-ellie circle:nth-child(13),\n.slds-icon-ellie circle:nth-last-child(14){\n  stroke-width:3.15px;\n}\n.slds-icon-ellie circle:nth-child(14),\n.slds-icon-ellie circle:nth-last-child(13){\n  stroke-width:2.8px;\n}\n.slds-icon-ellie circle:nth-child(15),\n.slds-icon-ellie circle:nth-last-child(16){\n  stroke-width:3.1px;\n}\n.slds-icon-ellie circle:nth-child(16),\n.slds-icon-ellie circle:nth-last-child(15){\n  stroke-width:3.25px;\n}\n.slds-icon-ellie circle:nth-child(17),\n.slds-icon-ellie circle:nth-last-child(18){\n  stroke-width:3.05px;\n}\n.slds-icon-ellie circle:nth-child(18),\n.slds-icon-ellie circle:nth-last-child(17){\n  stroke-width:3.7px;\n}\n.slds-icon-ellie circle:nth-child(19),\n.slds-icon-ellie circle:nth-last-child(20){\n  stroke-width:3px;\n}\n.slds-icon-ellie circle:nth-child(20),\n.slds-icon-ellie circle:nth-last-child(19){\n  stroke-width:4px;\n}\n@keyframes slds-icon-ellie-pop{\n  0%{\n    transform:scale(0.2);\n  }\n  70%{\n    transform:scale(1.1);\n  }\n  90%{\n    transform:scale(0.7);\n  }\n  100%{\n    transform:scale(1);\n  }\n}\n@keyframes slds-icon-ellie{\n  to{\n    transform:translateX(-17.5rem);\n  }\n}\n.slds-icon-eq{\n  position:relative;\n  width:calc(14rem / 16);\n  height:calc(14rem / 16);\n}\n.slds-icon-eq.slds-is-animated .slds-icon-eq__bar{\n  animation:slds-icon-eq 0.25s ease-in-out infinite alternate;\n  will-change:transform;\n  height:0.1875rem;\n}\n.slds-icon-eq.slds-is-animated .slds-icon-eq__bar:nth-of-type(2){\n  animation-duration:0.65s;\n}\n.slds-icon-eq.slds-is-animated .slds-icon-eq__bar:nth-of-type(3){\n  animation-duration:0.35s;\n}\n.slds-icon-eq__bar{\n  position:absolute;\n  bottom:0;\n  left:0;\n  width:calc(4rem / 16);\n  height:0.5625rem;\n  background:var(--slds-g-color-accent-1);\n  transform:scaleY(1);\n  transform-origin:bottom;\n}\n.slds-icon-eq__bar:nth-of-type(2){\n  left:calc(5rem / 16);\n  height:0.875rem;\n}\n.slds-icon-eq__bar:nth-of-type(3){\n  left:calc(10rem / 16);\n  height:0.75rem;\n}\n@keyframes slds-icon-eq{\n  to{\n    transform:scaleY(4.6666666667);\n  }\n}\n.slds-icon-score{\n  display:inline-block;\n  width:0.3125rem;\n  height:0.3125rem;\n  position:relative;\n}\n.slds-icon-score__positive,\n.slds-icon-score__negative{\n  position:absolute;\n  opacity:0;\n  transition:opacity 0.4s ease-in-out;\n  will-change:opacity;\n  stroke-width:1.125px;\n}\n.slds-icon-score__positive{\n  fill:var(--slds-g-color-success-1);\n  stroke:var(--slds-g-color-success-1);\n}\n.slds-icon-score__negative{\n  fill:transparent;\n  stroke:var(--slds-g-color-error-1);\n}\n[data-slds-state='positive'] .slds-icon-score__positive,\n[data-slds-state='negative'] .slds-icon-score__negative{\n  opacity:1;\n}\n.slds-icon-strength{\n  width:1.6875rem;\n  height:0.4375rem;\n  display:inline-block;\n}\n.slds-icon-strength circle{\n  stroke-width:0.95px;\n  fill:transparent;\n  stroke:var(--slds-g-color-border-2);\n  transition:fill 0.4s ease-in-out, stroke 0.4s ease-in-out;\n  will-change:fill, stroke;\n}\n.slds-icon-strength[data-slds-strength='1'] circle:nth-child(1),\n.slds-icon-strength[data-slds-strength='2'] circle:nth-child(1),\n.slds-icon-strength[data-slds-strength='2'] circle:nth-child(2),\n.slds-icon-strength[data-slds-strength='3'] circle:nth-child(1),\n.slds-icon-strength[data-slds-strength='3'] circle:nth-child(2),\n.slds-icon-strength[data-slds-strength='3'] circle:nth-child(3){\n  fill:var(--slds-g-color-success-1);\n  stroke:var(--slds-g-color-success-1);\n}\n.slds-icon-strength[data-slds-strength='-1'] circle:nth-child(1),\n.slds-icon-strength[data-slds-strength='-2'] circle:nth-child(1),\n.slds-icon-strength[data-slds-strength='-2'] circle:nth-child(2),\n.slds-icon-strength[data-slds-strength='-3'] circle:nth-child(1),\n.slds-icon-strength[data-slds-strength='-3'] circle:nth-child(2),\n.slds-icon-strength[data-slds-strength='-3'] circle:nth-child(3){\n  fill:var(--slds-g-color-error-container-1);\n  stroke:var(--slds-g-color-error-1);\n}\n.slds-icon-strength.slds-is-animated circle{\n  animation:slds-icon-strength-positive-load 0.4s 1s ease-in-out alternate both paused;\n}\n.slds-icon-strength.slds-is-animated circle:nth-child(2){\n  animation-delay:1.4s;\n}\n.slds-icon-strength.slds-is-animated circle:nth-child(3){\n  animation-delay:1.8s;\n}\n.slds-icon-strength.slds-is-animated[data-slds-strength^='-'] circle{\n  animation-name:slds-icon-strength-negative-load;\n}\n.slds-icon-strength.slds-is-animated[data-slds-strength='-1'] circle:nth-child(1),\n.slds-icon-strength.slds-is-animated[data-slds-strength='-2'] circle:nth-child(1),\n.slds-icon-strength.slds-is-animated[data-slds-strength='-2'] circle:nth-child(2),\n.slds-icon-strength.slds-is-animated[data-slds-strength='-3'] circle:nth-child(1),\n.slds-icon-strength.slds-is-animated[data-slds-strength='-3'] circle:nth-child(2),\n.slds-icon-strength.slds-is-animated[data-slds-strength='-3'] circle:nth-child(3),\n.slds-icon-strength.slds-is-animated[data-slds-strength='1'] circle:nth-child(1),\n.slds-icon-strength.slds-is-animated[data-slds-strength='2'] circle:nth-child(1),\n.slds-icon-strength.slds-is-animated[data-slds-strength='2'] circle:nth-child(2),\n.slds-icon-strength.slds-is-animated[data-slds-strength='3'] circle:nth-child(1),\n.slds-icon-strength.slds-is-animated[data-slds-strength='3'] circle:nth-child(2),\n.slds-icon-strength.slds-is-animated[data-slds-strength='3'] circle:nth-child(3){\n  animation-play-state:running;\n}\n.slds-icon-strength.slds-is-paused circle{\n  animation-play-state:paused !important;\n}\n@keyframes slds-icon-strength-positive-load{\n  0%{\n    fill:transparent;\n    stroke:var(--slds-g-color-border-2);\n  }\n  100%{\n    fill:var(--slds-g-color-success-1);\n    stroke:var(--slds-g-color-success-1);\n  }\n}\n@keyframes slds-icon-strength-negative-load{\n  0%{\n    fill:transparent;\n    stroke:var(--slds-g-color-border-2);\n  }\n  100%{\n    fill:var(--slds-g-color-error-container-1);\n    stroke:var(--slds-g-color-error-1);\n  }\n}\n.slds-icon-trend{\n  width:1rem;\n  height:1rem;\n  display:inline-block;\n}\n.slds-icon-trend.slds-is-animated .slds-icon-trend__arrow{\n  animation:slds-icon-trend-arrow 0.8s 0.4s ease-in-out both;\n}\n.slds-icon-trend.slds-is-animated .slds-icon-trend__circle{\n  animation:slds-icon-trend-circle 0.8s ease-in-out both;\n}\n.slds-icon-trend.slds-is-paused .slds-icon-trend__arrow,\n.slds-icon-trend.slds-is-paused .slds-icon-trend__circle{\n  animation-play-state:paused;\n}\n.slds-icon-trend[data-slds-trend='down']{\n  color:var(--slds-g-color-error-1);\n  transform:rotate(45deg);\n}\n.slds-icon-trend[data-slds-trend='neutral']{\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-icon-trend[data-slds-trend='up']{\n  color:var(--slds-g-color-success-1);\n  transform:rotate(-45deg);\n}\n.slds-icon-trend__arrow,\n.slds-icon-trend__circle{\n  stroke:currentColor;\n  fill:none;\n  stroke-linecap:round;\n  stroke-linejoin:round;\n  stroke-width:1.125px;\n}\n.slds-icon-trend__arrow{\n  stroke-dashoffset:0.1px;\n  stroke-dasharray:39.175px;\n}\n.slds-icon-trend__circle{\n  stroke-dasharray:42.3385px, 46.3385px;\n}\n@keyframes slds-icon-trend-arrow{\n  from{\n    stroke-dashoffset:40.3px;\n  }\n}\n@keyframes slds-icon-trend-circle{\n  from{\n    stroke-dasharray:0.1px, 46.3385px;\n  }\n}\n.slds-icon-waffle_container,.slds-icon-waffle--container{\n  border:0;\n  outline:0;\n}\n.slds-icon-waffle_container:hover .slds-r1,.slds-icon-waffle--container:hover .slds-r1,\n.slds-icon-waffle_container:hover .slds-r2,\n.slds-icon-waffle--container:hover .slds-r2,\n.slds-icon-waffle_container:hover .slds-r3,\n.slds-icon-waffle--container:hover .slds-r3,\n.slds-icon-waffle_container:hover .slds-r4,\n.slds-icon-waffle--container:hover .slds-r4,\n.slds-icon-waffle_container:hover .slds-r5,\n.slds-icon-waffle--container:hover .slds-r5,\n.slds-icon-waffle_container:hover .slds-r6,\n.slds-icon-waffle--container:hover .slds-r6,\n.slds-icon-waffle_container:hover .slds-r7,\n.slds-icon-waffle--container:hover .slds-r7,\n.slds-icon-waffle_container:hover .slds-r8,\n.slds-icon-waffle--container:hover .slds-r8,\n.slds-icon-waffle_container:hover .slds-r9,\n.slds-icon-waffle--container:hover .slds-r9,\n.slds-icon-waffle_container:focus .slds-r1,\n.slds-icon-waffle--container:focus .slds-r1,\n.slds-icon-waffle_container:focus .slds-r2,\n.slds-icon-waffle--container:focus .slds-r2,\n.slds-icon-waffle_container:focus .slds-r3,\n.slds-icon-waffle--container:focus .slds-r3,\n.slds-icon-waffle_container:focus .slds-r4,\n.slds-icon-waffle--container:focus .slds-r4,\n.slds-icon-waffle_container:focus .slds-r5,\n.slds-icon-waffle--container:focus .slds-r5,\n.slds-icon-waffle_container:focus .slds-r6,\n.slds-icon-waffle--container:focus .slds-r6,\n.slds-icon-waffle_container:focus .slds-r7,\n.slds-icon-waffle--container:focus .slds-r7,\n.slds-icon-waffle_container:focus .slds-r8,\n.slds-icon-waffle--container:focus .slds-r8,\n.slds-icon-waffle_container:focus .slds-r9,\n.slds-icon-waffle--container:focus .slds-r9{\n  animation:slds-icon-waffle-throb 2 200ms alternate;\n}\n.slds-icon-waffle_container:hover .slds-r1,.slds-icon-waffle--container:hover .slds-r1,\n.slds-icon-waffle_container:hover .slds-r2,\n.slds-icon-waffle--container:hover .slds-r2,\n.slds-icon-waffle_container:hover .slds-r3,\n.slds-icon-waffle--container:hover .slds-r3,\n.slds-icon-waffle_container:focus .slds-r1,\n.slds-icon-waffle--container:focus .slds-r1,\n.slds-icon-waffle_container:focus .slds-r2,\n.slds-icon-waffle--container:focus .slds-r2,\n.slds-icon-waffle_container:focus .slds-r3,\n.slds-icon-waffle--container:focus .slds-r3{\n  background-color:var(--slds-g-color-accent-1);\n}\n.slds-icon-waffle_container:hover .slds-r4,.slds-icon-waffle--container:hover .slds-r4,\n.slds-icon-waffle_container:hover .slds-r5,\n.slds-icon-waffle--container:hover .slds-r5,\n.slds-icon-waffle_container:hover .slds-r7,\n.slds-icon-waffle--container:hover .slds-r7,\n.slds-icon-waffle_container:focus .slds-r4,\n.slds-icon-waffle--container:focus .slds-r4,\n.slds-icon-waffle_container:focus .slds-r5,\n.slds-icon-waffle--container:focus .slds-r5,\n.slds-icon-waffle_container:focus .slds-r7,\n.slds-icon-waffle--container:focus .slds-r7{\n  background-color:var(--slds-g-color-warning-base-70);\n}\n.slds-icon-waffle_container:hover .slds-r6,.slds-icon-waffle--container:hover .slds-r6,\n.slds-icon-waffle_container:hover .slds-r8,\n.slds-icon-waffle--container:hover .slds-r8,\n.slds-icon-waffle_container:hover .slds-r9,\n.slds-icon-waffle--container:hover .slds-r9,\n.slds-icon-waffle_container:focus .slds-r6,\n.slds-icon-waffle--container:focus .slds-r6,\n.slds-icon-waffle_container:focus .slds-r8,\n.slds-icon-waffle--container:focus .slds-r8,\n.slds-icon-waffle_container:focus .slds-r9,\n.slds-icon-waffle--container:focus .slds-r9{\n  background-color:var(--slds-g-color-palette-yellow-80);\n}\n.slds-icon-waffle_container:hover .slds-r2,.slds-icon-waffle--container:hover .slds-r2,\n.slds-icon-waffle_container:hover .slds-r4,\n.slds-icon-waffle--container:hover .slds-r4,\n.slds-icon-waffle_container:focus .slds-r2,\n.slds-icon-waffle--container:focus .slds-r2,\n.slds-icon-waffle_container:focus .slds-r4,\n.slds-icon-waffle--container:focus .slds-r4{\n  transition-delay:50ms;\n  animation-delay:50ms;\n}\n.slds-icon-waffle_container:hover .slds-r3,.slds-icon-waffle--container:hover .slds-r3,\n.slds-icon-waffle_container:hover .slds-r5,\n.slds-icon-waffle--container:hover .slds-r5,\n.slds-icon-waffle_container:hover .slds-r7,\n.slds-icon-waffle--container:hover .slds-r7,\n.slds-icon-waffle_container:focus .slds-r3,\n.slds-icon-waffle--container:focus .slds-r3,\n.slds-icon-waffle_container:focus .slds-r5,\n.slds-icon-waffle--container:focus .slds-r5,\n.slds-icon-waffle_container:focus .slds-r7,\n.slds-icon-waffle--container:focus .slds-r7{\n  transition-delay:100ms;\n  animation-delay:100ms;\n}\n.slds-icon-waffle_container:hover .slds-r6,.slds-icon-waffle--container:hover .slds-r6,\n.slds-icon-waffle_container:hover .slds-r8,\n.slds-icon-waffle--container:hover .slds-r8,\n.slds-icon-waffle_container:focus .slds-r6,\n.slds-icon-waffle--container:focus .slds-r6,\n.slds-icon-waffle_container:focus .slds-r8,\n.slds-icon-waffle--container:focus .slds-r8{\n  transition-delay:150ms;\n  animation-delay:150ms;\n}\n.slds-icon-waffle_container:hover .slds-r9,.slds-icon-waffle--container:hover .slds-r9,\n.slds-icon-waffle_container:focus .slds-r9,\n.slds-icon-waffle--container:focus .slds-r9{\n  transition-delay:200ms;\n  animation-delay:200ms;\n}\n.slds-icon-waffle{\n  width:1.3125rem;\n  height:1.3125rem;\n  position:relative;\n  display:block;\n  cursor:pointer;\n}\n.slds-icon-waffle .slds-r1,\n.slds-icon-waffle .slds-r2,\n.slds-icon-waffle .slds-r3,\n.slds-icon-waffle .slds-r4,\n.slds-icon-waffle .slds-r5,\n.slds-icon-waffle .slds-r6,\n.slds-icon-waffle .slds-r7,\n.slds-icon-waffle .slds-r8,\n.slds-icon-waffle .slds-r9{\n  width:0.3125rem;\n  height:0.3125rem;\n  background-color:var(--slds-g-color-neutral-base-50, #747474);\n  display:inline-block;\n  position:absolute;\n  border-radius:50%;\n  transition:background-color 100ms;\n  transform-origin:50% 50%;\n  will-change:scale, background-color;\n  border:2px solid transparent;\n}\n.slds-icon-waffle .slds-r1{\n  top:0;\n  left:0;\n}\n.slds-icon-waffle .slds-r2{\n  top:0;\n  left:0.5rem;\n}\n.slds-icon-waffle .slds-r3{\n  top:0;\n  right:0;\n}\n.slds-icon-waffle .slds-r4{\n  top:0.5rem;\n  left:0;\n}\n.slds-icon-waffle .slds-r5{\n  top:0.5rem;\n  left:0.5rem;\n}\n.slds-icon-waffle .slds-r6{\n  top:0.5rem;\n  right:0;\n}\n.slds-icon-waffle .slds-r7{\n  bottom:0;\n  left:0;\n}\n.slds-icon-waffle .slds-r8{\n  bottom:0;\n  left:0.5rem;\n}\n.slds-icon-waffle .slds-r9{\n  bottom:0;\n  right:0;\n}\n.slds-icon-waffle .slds-r1{\n  transition-delay:200ms;\n}\n.slds-icon-waffle .slds-r2,\n.slds-icon-waffle .slds-r4{\n  transition-delay:150ms;\n}\n.slds-icon-waffle .slds-r3,\n.slds-icon-waffle .slds-r5,\n.slds-icon-waffle .slds-r7{\n  transition-delay:100ms;\n}\n.slds-icon-waffle .slds-r6,\n.slds-icon-waffle .slds-r8{\n  transition-delay:50ms;\n}\n@keyframes slds-icon-waffle-throb{\n  to{\n    transform:scale(1.5);\n  }\n}\n.slds-icon-help{\n  width:1.5rem;\n  height:1.5rem;\n  fill:var(--slds-g-color-on-surface-1);\n}\n.slds-icon-help:hover .slds-icon-help_hover,.slds-icon-help:hover .slds-icon-help--hover{\n  opacity:1;\n  transform:scale(1);\n}\n.slds-icon-help:focus{\n  animation:slds-click-global-action 80ms cubic-bezier(1, 1.9, 0.94, 0.98);\n}\n.slds-icon-help:focus .slds-icon-help_focus,.slds-icon-help:focus .slds-icon-help--focus{\n  opacity:1;\n  transform:scale(1);\n}\n.slds-icon-help mask{\n  mask-type:alpha;\n}\n.slds-icon-help_hover,.slds-icon-help--hover{\n  opacity:0;\n  transform:scale(0.1, 0.1);\n  transform-origin:45px 47px;\n  transition:all 200ms ease-out;\n  fill:var(--slds-g-color-accent-3);\n}\n.slds-icon-help_focus,.slds-icon-help--focus{\n  opacity:0;\n  transform:scale(0.1, 0.1);\n  transform-origin:45px 47px;\n  transition:all 200ms ease-out;\n  fill:var(--slds-g-color-accent-2);\n}\n.slds-icon-help svg{\n  width:1.5rem;\n  height:1.5rem;\n}\n.slds-icon-help g{\n  mask:url('#questionMark');\n}\n@keyframes slds-click-global-action{\n  25%{\n    transform:scale(0.95, 0.95);\n  }\n\n  100%{\n    transform:scale(0.98, 0.98);\n  }\n}\n.slds-icon-typing{\n  display:inline-block;\n  padding:var(--slds-g-spacing-1) 0;\n}\n.slds-icon-typing.slds-is-animated .slds-icon-typing__dot{\n  animation:slds-icon-typing__dot-first 1.2s infinite ease-in-out;\n}\n.slds-icon-typing.slds-is-animated .slds-icon-typing__dot:nth-child(1){\n  animation-name:slds-icon-typing__dot-first;\n}\n.slds-icon-typing.slds-is-animated .slds-icon-typing__dot:nth-child(2){\n  animation-name:slds-icon-typing__dot-second;\n}\n.slds-icon-typing.slds-is-animated .slds-icon-typing__dot:nth-child(3){\n  animation-name:slds-icon-typing__dot-third;\n}\n.slds-icon-typing.slds-is-paused .slds-icon-typing__dot{\n  animation-play-state:paused;\n}\n.slds-icon-typing__dot{\n  background-color:var(--slds-g-color-neutral-base-80);\n  border-radius:50%;\n  display:inline-block;\n  height:0.5rem;\n  margin:0 0.125rem;\n  width:0.5rem;\n}\n@keyframes slds-icon-typing__dot-first{\n  0%{\n    background-color:var(--slds-g-color-neutral-base-80);\n  }\n\n  16%{\n    background-color:var(--slds-g-color-neutral-base-60);\n  }\n\n  33%,\n  100%{\n    background-color:var(--slds-g-color-neutral-base-80);\n  }\n}\n@keyframes slds-icon-typing__dot-second{\n  0%,\n  33%{\n    background-color:var(--slds-g-color-neutral-base-80);\n  }\n\n  50%{\n    background-color:var(--slds-g-color-neutral-base-60);\n  }\n\n  67%,\n  100%{\n    background-color:var(--slds-g-color-neutral-base-80);\n  }\n}\n@keyframes slds-icon-typing__dot-third{\n  0%,\n  67%{\n    background-color:var(--slds-g-color-neutral-base-80);\n  }\n\n  83%{\n    background-color:var(--slds-g-color-neutral-base-60);\n  }\n\n  100%{\n    background-color:var(--slds-g-color-neutral-base-80);\n  }\n}\n.slds-dynamic-menu .slds-popover__body{\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-dynamic-menu .slds-popover__footer{\n  background-color:transparent;\n}\n.slds-dynamic-menu__header{\n  font-size:var(--slds-g-font-scale-1);\n  font-weight:var(--slds-g-font-weight-7);\n}\n.slds-carousel{\n  position:relative;\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-carousel__stage{\n  position:relative;\n  display:flex;\n  flex-direction:column;\n  overflow:hidden;\n}\n.slds-carousel__panels{\n  display:flex;\n  transition:transform 250ms ease-in;\n  min-height:0%;\n}\n.slds-carousel__panel{\n  flex:0 0 100%;\n  max-width:100%;\n}\n.slds-carousel__panel-action{\n  display:block;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-s-container-radius-border);\n  margin:var(--slds-g-spacing-1);\n}\n.slds-carousel__panel-action:focus-visible{\n  outline:0;\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-carousel__image{\n  border-start-start-radius:inherit;\n  border-start-end-radius:inherit;\n  overflow:hidden;\n}\n.slds-carousel__image > img{\n  width:100%;\n}\n.slds-carousel__content{\n  background:var(--slds-g-color-surface-1);\n  padding:var(--slds-g-spacing-4);\n  border-end-start-radius:inherit;\n  border-end-end-radius:inherit;\n  text-align:center;\n  height:6.625rem;\n  overflow-x:hidden;\n  overflow-y:auto;\n}\n.slds-carousel__content-title{\n  font-size:var(--slds-g-font-scale-2);\n  font-weight:var(--slds-g-font-weight-6);\n}\n.slds-carousel__indicators{\n  align-self:center;\n  margin:var(--slds-g-spacing-2) 0;\n}\n.slds-carousel__indicator{\n  display:inline-flex;\n  margin-block:0;\n  margin-inline:var(--slds-g-spacing-1);\n}\n.slds-carousel__indicator-action{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  background:var(--slds-g-color-surface-1);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-radius:50%;\n}\n.slds-carousel__indicator-action.slds-is-active,\n.slds-carousel__indicator-action.slds-is-active:hover{\n  background:var(--slds-g-color-accent-container-1);\n  border-color:var(--slds-g-color-border-accent-1);\n}\n.slds-carousel__indicator-action.slds-is-active{\n  box-shadow:var(--slds-s-mark-shadow-checked);\n}\n.slds-carousel__indicator-action:hover{\n  background-color:var(--slds-g-color-surface-2);\n}\n.slds-carousel__indicator-action:focus-visible{\n  outline:0;\n  box-shadow:var(--slds-s-button-shadow-focus);\n  background-color:var(--slds-g-color-accent-container-3);\n  border-color:var(--slds-g-color-border-accent-3);\n}\n.slds-carousel__autoplay{\n  position:absolute;\n  inset-inline-start:0;\n  inset-block-end:var(--slds-g-spacing-1);\n  margin:var(--slds-g-spacing-1);\n}\n.slds-card{\n  position:relative;\n  padding-block-start:var(--slds-c-card-spacing-blockstart, 0);\n  padding-inline-end:var(--slds-c-card-spacing-inlineend, 0);\n  padding-block-end:var(--slds-c-card-spacing-blockend, 0);\n  padding-inline-start:var(--slds-c-card-spacing-inlinestart, 0);\n  background:var(--slds-c-card-color-background, var(--slds-g-color-surface-container-1));\n  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(\n    --slds-c-card-color-border,\n    var(--slds-s-container-color-border, var(--slds-g-color-border-1))\n  );\n  border-radius:var(\n    --slds-c-card-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  background-clip:padding-box;\n  box-shadow:var(--slds-c-card-shadow, var(--slds-s-container-shadow, var(--slds-g-shadow-2)));\n  color:var(--slds-c-card-text-color, var(--slds-s-container-color));\n}\n.slds-card + .slds-card{\n  margin-block-start:var(--_slds-g-spacing-var-block-4, var(--slds-g-spacing-4));\n}\n.slds-card__header{\n  padding-block-start:var(\n    --slds-c-card-header-spacing-blockstart,\n    var(--slds-c-card-header-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))\n  );\n  padding-inline-end:var(\n    --slds-c-card-header-spacing-inlineend,\n    var(--slds-c-card-header-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n  padding-block-end:var(--slds-c-card-header-spacing-blockend, var(--slds-c-card-header-spacing-block, 0));\n  padding-inline-start:var(\n    --slds-c-card-header-spacing-inlinestart,\n    var(--slds-c-card-header-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n  margin:0;\n  margin-block-end:var(\n    --slds-c-card-header-spacing-blockend,\n    var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3))\n  );\n}\n.slds-card__header-title{\n  display:flex;\n  font-size:var(\n    --slds-c-card-heading-font-size,\n    var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2))\n  );\n  font-weight:var(\n    --slds-c-card-heading-font-weight,\n    var(--slds-s-container-heading-font-weight, var(--slds-g-font-weight-4))\n  );\n  line-height:var(--slds-g-font-lineheight-2);\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-card__header-link{\n  color:inherit;\n  font-weight:var(\n    --slds-c-card-heading-font-weight,\n    var(--slds-s-container-heading-font-weight, var(--slds-g-font-weight-7))\n  );\n}\n.slds-card__body{\n  margin-block-start:var(\n    --slds-c-card-body-spacing-blockstart,\n    var(--slds-c-card-body-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))\n  );\n  margin-block-end:var(\n    --slds-c-card-body-spacing-blockend,\n    var(--slds-c-card-body-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))\n  );\n  padding-inline-end:var(--slds-c-card-body-spacing-inlineend, var(--slds-c-card-body-spacing-inline));\n  padding-inline-start:var(\n    --slds-c-card-body-spacing-inlinestart,\n    var(--slds-c-card-body-spacing-inline, var(--slds-g-spacing-1))\n  );\n}\n.slds-card__body_inner,.slds-card__body--inner{\n  --slds-c-card-body-spacing-inlineend:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));\n  --slds-c-card-body-spacing-inlinestart:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));\n\n  padding-block-start:0;\n  padding-block-end:0;\n}\n.slds-card__body:empty,\n.slds-card__footer:empty{\n  display:none;\n}\n.slds-card__footer{\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  padding-block-start:var(\n    --slds-c-card-footer-spacing-blockstart,\n    var(--slds-c-card-footer-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))\n  );\n  padding-inline-end:var(\n    --slds-c-card-footer-spacing-inlineend,\n    var(--slds-c-card-footer-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n  padding-block-end:var(\n    --slds-c-card-footer-spacing-blockend,\n    var(--slds-c-card-footer-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))\n  );\n  padding-inline-start:var(\n    --slds-c-card-footer-spacing-inlinestart,\n    var(--slds-c-card-footer-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n  margin-block-start:var(\n    --slds-c-card-footer-spacing-blockstart,\n    var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3))\n  );\n  font-size:var(--slds-c-card-footer-font-size, var(--slds-g-font-size-base));\n  border-top-width:var(--slds-c-card-footer-sizing-border, var(--slds-g-sizing-border-1));\n  border-top-style:solid;\n  border-top-color:var(--slds-c-card-footer-color-border, var(--slds-g-color-border-1));\n}\n.slds-card__footer-action{\n  display:block;\n}\n.slds-card__tile{\n  margin-block-start:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));\n}\n.slds-region__pinned-left .slds-card,\n.slds-region__pinned-left .slds-card-wrapper,\n.slds-region__pinned-left .slds-card_boundary,\n.slds-region__pinned-left .slds-card--boundary,\n.slds-region__pinned-left .slds-tabs_card,\n.slds-region__pinned-left .slds-tabs--card,\n.slds-region__pinned-right .slds-card,\n.slds-region__pinned-right .slds-card-wrapper,\n.slds-region__pinned-right .slds-card_boundary,\n.slds-region__pinned-right .slds-card--boundary,\n.slds-region__pinned-right .slds-tabs_card,\n.slds-region__pinned-right .slds-tabs--card{\n  border-radius:0;\n  border:0;\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  box-shadow:none;\n}\n.slds-region__pinned-left .slds-card:last-child, .slds-region__pinned-left .slds-card-wrapper:last-child, .slds-region__pinned-left .slds-card_boundary:last-child, .slds-region__pinned-left .slds-card--boundary:last-child, .slds-region__pinned-left .slds-tabs_card:last-child, .slds-region__pinned-left .slds-tabs--card:last-child, .slds-region__pinned-right .slds-card:last-child, .slds-region__pinned-right .slds-card-wrapper:last-child, .slds-region__pinned-right .slds-card_boundary:last-child, .slds-region__pinned-right .slds-card--boundary:last-child, .slds-region__pinned-right .slds-tabs_card:last-child, .slds-region__pinned-right .slds-tabs--card:last-child{\n  border-block-end:0;\n}\n.slds-card-wrapper{\n  padding:var(--_slds-g-spacing-var-4, var(--slds-g-spacing-4));\n  background:var(--slds-c-card-color-background, var(--slds-g-color-surface-container-1));\n  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(\n    --slds-c-card-color-border,\n    var(--slds-s-container-color-border, var(--slds-g-color-border-1))\n  );\n  border-radius:var(\n    --slds-c-card-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  background-clip:padding-box;\n  box-shadow:var(--slds-c-card-shadow, var(--slds-s-container-shadow, var(--slds-g-shadow-2)));\n}\n.slds-card-wrapper .slds-card__header,\n.slds-card-wrapper .slds-card__body,\n.slds-card-wrapper .slds-card__footer{\n  padding-inline-start:0;\n  padding-inline-end:0;\n}\n.slds-card .slds-card,\n.slds-card .slds-card-wrapper,\n.slds-card-wrapper .slds-card,\n.slds-card-wrapper .slds-card-wrapper,\n.slds-modal .slds-card,\n.slds-modal .slds-card-wrapper{\n  border:0;\n  box-shadow:none;\n}\n.slds-tabs_default .slds-card,.slds-tabs--default .slds-card,\n.slds-tabs_default .slds-card-wrapper,\n.slds-tabs--default .slds-card-wrapper,\n.slds-tabs_card .slds-card,\n.slds-tabs--card .slds-card,\n.slds-tabs_card .slds-card-wrapper,\n.slds-tabs--card .slds-card-wrapper,\n.slds-tabs_card.slds-tabs_card .slds-card,\n.slds-tabs--card.slds-tabs--card .slds-card,\n.slds-tabs_card.slds-tabs_card .slds-card-wrapper,\n.slds-tabs--card.slds-tabs--card .slds-card-wrapper{\n  border:0;\n  box-shadow:none;\n}\n.slds-card .slds-card_boundary,.slds-card .slds-card--boundary, .slds-modal .slds-card_boundary, .slds-modal .slds-card--boundary, .slds-tabs_default .slds-card_boundary, .slds-tabs--default .slds-card--boundary{\n  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(\n    --slds-c-card-color-border,\n    var(--slds-s-container-color-border, var(--slds-g-color-border-1))\n  );\n  border-radius:var(\n    --slds-c-card-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n}\n.slds-tabs_card,.slds-tabs--card,\n.slds-tabs_card.slds-tabs_card,\n.slds-tabs--card.slds-tabs--card{\n  padding-block:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));\n  padding-inline:var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4));\n  background:var(--slds-c-card-color-background, var(--slds-g-color-surface-container-1));\n  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(\n    --slds-c-card-color-border,\n    var(--slds-s-container-color-border, var(--slds-g-color-border-1))\n  );\n  border-radius:var(\n    --slds-c-card-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  box-shadow:var(--slds-c-card-shadow, var(--slds-s-container-shadow, var(--slds-g-shadow-2)));\n}\n.slds-tabs_card .slds-card,.slds-tabs--card .slds-card,\n.slds-tabs_card .slds-card-wrapper,\n.slds-tabs--card .slds-card-wrapper,\n.slds-tabs_card.slds-tabs_card .slds-card,\n.slds-tabs--card.slds-tabs--card .slds-card,\n.slds-tabs_card.slds-tabs_card .slds-card-wrapper,\n.slds-tabs--card.slds-tabs--card .slds-card-wrapper{\n  padding-inline-start:0;\n  padding-inline-end:0;\n}\n.slds-tabs_card .slds-card__header,.slds-tabs--card .slds-card__header,\n.slds-tabs_card .slds-card__body,\n.slds-tabs--card .slds-card__body,\n.slds-tabs_card .slds-card__footer,\n.slds-tabs--card .slds-card__footer,\n.slds-tabs_card.slds-tabs_card .slds-card__header,\n.slds-tabs--card.slds-tabs--card .slds-card__header,\n.slds-tabs_card.slds-tabs_card .slds-card__body,\n.slds-tabs--card.slds-tabs--card .slds-card__body,\n.slds-tabs_card.slds-tabs_card .slds-card__footer,\n.slds-tabs--card.slds-tabs--card .slds-card__footer{\n  padding-inline-start:0;\n  padding-inline-end:0;\n  margin-inline-start:0;\n  margin-inline-end:0;\n}\n.slds-tabs_card .slds-card__header,.slds-tabs--card .slds-card__header, .slds-tabs_card.slds-tabs_card .slds-card__header, .slds-tabs--card.slds-tabs--card .slds-card__header{\n  padding-block-start:0;\n}\n.slds-tabs_card .slds-card_boundary,.slds-tabs--card .slds-card--boundary, .slds-tabs_card.slds-tabs_card .slds-card_boundary, .slds-tabs--card.slds-tabs--card .slds-card--boundary, .slds-card-wrapper .slds-card_boundary, .slds-card-wrapper .slds-card--boundary{\n  border-width:var(--slds-c-card-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(\n    --slds-c-card-color-border,\n    var(--slds-s-container-color-border, var(--slds-g-color-border-1))\n  );\n  border-radius:var(\n    --slds-c-card-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n}\n.slds-tabs_card .slds-card_boundary .slds-card__header,.slds-tabs--card .slds-card--boundary .slds-card__header, .slds-tabs_card.slds-tabs_card .slds-card_boundary .slds-card__header, .slds-tabs--card.slds-tabs--card .slds-card--boundary .slds-card__header, .slds-card-wrapper .slds-card_boundary .slds-card__header, .slds-card-wrapper .slds-card--boundary .slds-card__header{\n  padding-block-start:var(\n    --slds-c-card-header-spacing-blockstart,\n    var(--slds-c-card-header-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))\n  );\n  padding-inline-end:var(\n    --slds-c-card-header-spacing-inlineend,\n    var(--slds-c-card-header-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n  padding-block-end:var(\n    --slds-c-card-header-spacing-blockend,\n    var(--slds-c-card-header-spacing-block, 0)\n  );\n  padding-inline-start:var(\n    --slds-c-card-header-spacing-inlinestart,\n    var(--slds-c-card-header-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n}\n.slds-tabs_card .slds-card_boundary .slds-card__body_inner,.slds-tabs--card .slds-card--boundary .slds-card__body--inner, .slds-tabs_card.slds-tabs_card .slds-card_boundary .slds-card__body_inner, .slds-tabs--card.slds-tabs--card .slds-card--boundary .slds-card__body--inner, .slds-card-wrapper .slds-card_boundary .slds-card__body_inner, .slds-card-wrapper .slds-card--boundary .slds-card__body--inner{\n  padding:0;\n  padding-inline-end:var(\n    --slds-c-card-body-spacing-inlineend,\n    var(--slds-c-card-body-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n  padding-inline-start:var(\n    --slds-c-card-body-spacing-inlinestart,\n    var(--slds-c-card-body-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n}\n.slds-tabs_card .slds-card_boundary .slds-card__footer,.slds-tabs--card .slds-card--boundary .slds-card__footer, .slds-tabs_card.slds-tabs_card .slds-card_boundary .slds-card__footer, .slds-tabs--card.slds-tabs--card .slds-card--boundary .slds-card__footer, .slds-card-wrapper .slds-card_boundary .slds-card__footer, .slds-card-wrapper .slds-card--boundary .slds-card__footer{\n  padding-block-start:var(\n    --slds-c-card-footer-spacing-blockstart,\n    var(--slds-c-card-footer-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))\n  );\n  padding-inline-end:var(\n    --slds-c-card-footer-spacing-inlineend,\n    var(--slds-c-card-footer-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n  padding-block-end:var(\n    --slds-c-card-footer-spacing-blockend,\n    var(--slds-c-card-footer-spacing-block, var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)))\n  );\n  padding-inline-start:var(\n    --slds-c-card-footer-spacing-inlinestart,\n    var(--slds-c-card-footer-spacing-inline, var(--_slds-g-spacing-var-inline-4, var(--slds-g-spacing-4)))\n  );\n}\n.slds-card_related-list-fix,.slds-card--related-list-fix{\n  border-radius:var(--slds-s-container-radius-border, var(--slds-g-radius-border-2));\n}\n.slds-card_related-list-fix .slds-page-header,.slds-card--related-list-fix .slds-page-header{\n  background:var(--slds-g-color-surface-container-1);\n  border-radius:var(--slds-s-container-radius-border);\n}\n.slds-accordion .slds-card_related-list-fix,.slds-accordion .slds-card--related-list-fix,\n.slds-tabs_card.slds-tabs_card .slds-card_related-list-fix,\n.slds-tabs--card.slds-tabs--card .slds-card--related-list-fix{\n  border-color:var(--slds-g-color-border-1);\n}\n.slds-card_related-list-fix .slds-page-header .slds-button-group-list .slds-button_icon-border-filled,.slds-card--related-list-fix .slds-page-header .slds-button-group-list .slds-button--icon-border-filled{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n}\n.slds-card_related-list-fix .slds-file-selector__dropzone,.slds-card--related-list-fix .slds-file-selector__dropzone{\n  margin-block-start:0;\n  margin-block-end:var(--slds-g-spacing-4);\n  margin-inline-start:var(--slds-g-spacing-4);\n  margin-inline-end:var(--slds-g-spacing-4);\n}\n.slds-chat{\n  margin-block-end:var(--slds-g-spacing-3);\n}\n.slds-chat-list{\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-3);\n}\n.slds-chat-listitem{\n  display:flex;\n  margin-block-start:var(--slds-g-spacing-3);\n}\n.slds-chat-listitem_outbound,.slds-chat-listitem--outbound{\n  justify-content:flex-end;\n}\n.slds-chat-listitem_inbound + .slds-chat-listitem_inbound,.slds-chat-listitem--inbound + .slds-chat-listitem--inbound,\n.slds-chat-listitem_outbound + .slds-chat-listitem_outbound,\n.slds-chat-listitem--outbound + .slds-chat-listitem--outbound{\n  margin-block-start:var(--slds-g-spacing-1);\n}\n.slds-chat-listitem_bookend,.slds-chat-listitem--bookend{\n  margin-block:var(--slds-g-spacing-4);\n  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);\n  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-chat-listitem_bookend + .slds-chat-listitem_bookend,.slds-chat-listitem--bookend + .slds-chat-listitem--bookend{\n  margin-block-start:var(--slds-g-spacing-8);\n}\n.slds-chat-listitem_event,.slds-chat-listitem--event{\n  margin-block:var(--slds-g-spacing-5);\n  margin-inline:0;\n}\n.slds-chat-icon{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-chat-message{\n  display:flex;\n}\n.slds-chat-message_faux-avatar,.slds-chat-message--faux-avatar{\n  padding-inline-start:calc(var(--slds-g-spacing-6) + var(--slds-g-spacing-2));\n}\n.slds-chat-avatar{\n  margin-inline-end:var(--slds-g-spacing-2);\n  min-width:2rem;\n}\n.slds-chat-message__body{\n  display:flex;\n  flex-direction:column;\n}\n.slds-chat-message__image_loading,.slds-chat-message__image--loading{\n  width:var(--slds-g-sizing-14);\n  height:calc((180 / 16) * 1rem);\n}\n.slds-chat-message__text{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  word-break:break-word;\n  display:inline-block;\n  font-size:var(--slds-g-font-size-base);\n  max-width:calc((420 / 16) * 1rem);\n  white-space:pre-line;\n}\n.slds-chat-message__text a{\n  color:var(--slds-s-link-color-focus);\n  text-decoration:underline;\n}\n.slds-chat-message__text a:hover{\n  text-decoration:none;\n}\n.slds-chat-message__file{\n  width:var(--slds-g-sizing-14);\n}\n.slds-chat-message__file,\n.slds-chat-message__image{\n  overflow:hidden;\n}\n.slds-chat-message__file .slds-file:hover, .slds-chat-message__image .slds-file:hover{\n  box-shadow:none;\n  transition:none;\n}\n.slds-chat-message__file:focus-within, .slds-chat-message__image:focus-within{\n  box-shadow:var(--slds-g-shadow-4);\n}\n.slds-chat-message__text_inbound,.slds-chat-message__text--inbound,\n.slds-chat-message__file_inbound,\n.slds-chat-message__file--inbound,\n.slds-chat-message__image_inbound,\n.slds-chat-message__image--inbound,\n.slds-chat-message__text_outbound,\n.slds-chat-message__text--outbound,\n.slds-chat-message__file_outbound,\n.slds-chat-message__file--outbound,\n.slds-chat-message__image_outbound,\n.slds-chat-message__image--outbound,\n.slds-chat-message__text_outbound-agent,\n.slds-chat-message__text--outbound-agent,\n.slds-chat-message__text_unsupported-type,\n.slds-chat-message__text--unsupported-type,\n.slds-chat-message__text_delivery-failure,\n.slds-chat-message__text--delivery-failure{\n  border-start-start-radius:var(--slds-g-radius-border-3);\n  border-start-end-radius:var(--slds-g-radius-border-3);\n  border-end-start-radius:var(--slds-g-radius-border-3);\n  border-end-end-radius:0;\n  color:var(--slds-g-color-on-surface-inverse-1);\n  min-height:2rem;\n}\n.slds-chat-message__text_inbound,.slds-chat-message__text--inbound,\n.slds-chat-message__text_outbound,\n.slds-chat-message__text--outbound,\n.slds-chat-message__text_outbound-agent,\n.slds-chat-message__text--outbound-agent,\n.slds-chat-message__text_unsupported-type,\n.slds-chat-message__text--unsupported-type,\n.slds-chat-message__text_delivery-failure,\n.slds-chat-message__text--delivery-failure{\n  padding:var(--slds-g-spacing-2);\n}\n.slds-chat-message__file_inbound,.slds-chat-message__file--inbound,\n.slds-chat-message__image_inbound,\n.slds-chat-message__image--inbound,\n.slds-chat-message__file_outbound,\n.slds-chat-message__file--outbound,\n.slds-chat-message__image_outbound,\n.slds-chat-message__image--outbound{\n  padding:0;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-chat-message__file_inbound,.slds-chat-message__file--inbound,\n.slds-chat-message__image_inbound,\n.slds-chat-message__image--inbound,\n.slds-chat-message__file_outbound,\n.slds-chat-message__file--outbound,\n.slds-chat-message__image_outbound,\n.slds-chat-message__image--outbound{\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-chat-message__text_inbound,.slds-chat-message__text--inbound{\n  margin-right:auto;\n  background-color:var(--slds-g-color-surface-container-2);\n  border-start-start-radius:var(--slds-g-radius-border-3);\n  border-start-end-radius:var(--slds-g-radius-border-3);\n  border-end-start-radius:0;\n  border-end-end-radius:var(--slds-g-radius-border-3);\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-chat-message__image_inbound,.slds-chat-message__image--inbound{\n  background-color:var(--slds-g-color-surface-container-2);\n  border-start-start-radius:var(--slds-g-radius-border-3);\n  border-start-end-radius:var(--slds-g-radius-border-3);\n  border-end-start-radius:0;\n  border-end-end-radius:var(--slds-g-radius-border-3);\n}\n.slds-chat-message__file_inbound,.slds-chat-message__file--inbound{\n  border-radius:var(--slds-g-radius-border-3);\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-chat-message__text_outbound,.slds-chat-message__text--outbound{\n  margin-inline-start:auto;\n  background-color:var(--slds-g-color-surface-container-inverse-1);\n}\n.slds-chat-message__text_outbound-agent,.slds-chat-message__text--outbound-agent{\n  background-color:var(--slds-g-color-neutral-base-50);\n  margin-inline-start:auto;\n}\n.slds-chat-message__text_outbound a,.slds-chat-message__text--outbound a, .slds-chat-message__text_outbound-agent a, .slds-chat-message__text--outbound-agent a{\n  color:var(--slds-g-color-neutral-base-100);\n  text-decoration:underline;\n}\n.slds-chat-message__text_unsupported-type,.slds-chat-message__text--unsupported-type{\n  background-color:var(--slds-g-color-surface-container-1);\n  border-start-start-radius:var(--slds-g-radius-border-3);\n  border-start-end-radius:var(--slds-g-radius-border-3);\n  border-end-start-radius:0;\n  border-end-end-radius:var(--slds-g-radius-border-3);\n  border:var(--slds-g-color-warning-base-60) var(--slds-g-sizing-border-1) solid;\n  color:var(--slds-g-color-on-surface-2);\n  margin-inline-end:auto;\n}\n.slds-chat-message__text_delivery-failure,.slds-chat-message__text--delivery-failure{\n  background-color:var(--slds-g-color-surface-container-1);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-error-1);\n  color:var(--slds-g-color-on-surface-2);\n  margin-inline-start:auto;\n}\n.slds-chat-message__text_delivery-failure .slds-chat-message__text_delivery-failure-reason,.slds-chat-message__text--delivery-failure .slds-chat-message__text--delivery-failure-reason{\n  display:flex;\n  padding-block:var(--slds-g-spacing-2) 0;\n  padding-inline:var(--slds-g-spacing-2);\n  margin-block:var(--slds-g-spacing-2) 0;\n  margin-inline:calc(var(--slds-g-spacing-2) * -1);\n  color:var(--slds-g-color-error-1);\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-error-1);\n}\n.slds-chat-message__text_sneak-peak,.slds-chat-message__text--sneak-peak,\n.slds-chat-message__text_sneak-peek,\n.slds-chat-message__text--sneak-peek{\n  font-style:italic;\n}\n.slds-chat-message__text_sneak-peak .slds-icon-typing,.slds-chat-message__text--sneak-peak .slds-icon-typing, .slds-chat-message__text_sneak-peek .slds-icon-typing, .slds-chat-message__text--sneak-peek .slds-icon-typing{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-chat-message__meta{\n  color:var(--slds-g-color-on-surface-2);\n  font-size:var(--slds-g-font-scale-neg-2);\n  margin-block:0.125rem 0;\n  margin-inline:var(--slds-g-spacing-2) 0;\n}\n.slds-chat-message__action{\n  font-size:var(--slds-g-font-scale-neg-1);\n  margin-inline-start:var(--slds-g-spacing-2);\n  line-height:var(--slds-g-font-lineheight-2);\n}\n.slds-chat-message__action .slds-chat-icon.slds-icon-utility-redo .slds-icon{\n  width:var(--slds-g-sizing-4);\n  height:var(--slds-g-sizing-4);\n  fill:var(--slds-s-link-color);\n}\n.slds-chat-event{\n  align-items:center;\n  color:var(--slds-g-color-on-surface-2);\n  display:inline-flex;\n  flex-wrap:wrap;\n  justify-content:center;\n  font-size:var(--slds-g-font-size-base);\n  text-align:center;\n  width:100%;\n}\n.slds-chat-event.slds-has-error{\n  color:var(--slds-g-color-error-1);\n}\n.slds-chat-event.slds-has-error svg{\n  fill:var(--slds-g-color-error-1);\n}\n.slds-chat-event__body{\n  align-items:center;\n  display:flex;\n  margin-block:0;\n  margin-inline:var(--slds-g-spacing-2);\n}\n.slds-chat-event__agent-message{\n  flex-grow:3;\n  font-size:var(--slds-g-font-scale-neg-1);\n  font-style:italic;\n  margin-block-start:var(--slds-g-spacing-2);\n  width:100%;\n}\n.slds-chat-bookend{\n  align-items:center;\n  border:var(--slds-g-color-border-1) 0 solid;\n  border-block-end-width:var(--slds-g-sizing-border-1);\n  color:var(--slds-g-color-on-surface-2);\n  display:flex;\n  font-size:var(--slds-g-font-size-base);\n  justify-content:center;\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n  width:100%;\n}\n.slds-chat-bookend_stop,.slds-chat-bookend--stop{\n  border-width:var(--slds-g-sizing-border-1) 0 0;\n}\n.slds-chat_past .slds-chat-listitem_event,.slds-chat--past .slds-chat-listitem--event{\n  margin-block:var(--slds-g-spacing-4);\n  margin-inline:0;\n}\n.slds-chat_past .slds-chat-message__meta,.slds-chat--past .slds-chat-message__meta{\n  margin-block:var(--slds-g-spacing-1) 0;\n  margin-inline:0;\n}\n.slds-chat_past .slds-chat-message__meta b,.slds-chat--past .slds-chat-message__meta b{\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-checkbox{\n  display:inline-block;\n  position:relative;\n}\n.slds-checkbox .slds-checkbox_faux,.slds-checkbox .slds-checkbox--faux{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  display:inline-block;\n  position:relative;\n  flex-shrink:0;\n  vertical-align:middle;\n  border-radius:var(--slds-c-checkbox-radius-border, var(--slds-g-radius-border-1));\n  border-width:var(--slds-s-mark-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(\n    --slds-c-checkbox-color-border,\n    var(--slds-s-mark-color-border, var(--slds-g-color-border-2))\n  );\n  background-color:var(\n    --slds-c-checkbox-color-background,\n    var(--slds-s-mark-color-background, var(--slds-g-color-surface-container-1))\n  );\n  box-shadow:var(--slds-c-checkbox-shadow);\n  transition:border 0.1s linear, background-color 0.1s linear;\n}\n.slds-checkbox .slds-checkbox__label .slds-form-element__label{\n  display:inline;\n  vertical-align:middle;\n  font-size:var(--slds-s-label-font-size, var(--slds-g-font-scale-neg-2));\n}\n.slds-checkbox [type='checkbox']{\n  width:1px;\n  height:1px;\n  border:0;\n  clip:rect(0 0 0 0);\n  margin:-1px;\n  overflow:hidden;\n  padding:0;\n  position:absolute;\n  pointer-events:auto;\n}\n.slds-checkbox [type='checkbox']:checked + .slds-checkbox_faux,.slds-checkbox [type='checkbox']:checked + .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux{\n  --slds-c-checkbox-color-background:var(\n    --slds-c-checkbox-color-background-checked,\n    var(--slds-s-mark-color-background-checked, var(--slds-g-color-surface-container-1))\n  );\n}\n.slds-checkbox [type='checkbox']:checked + .slds-checkbox_faux::after,.slds-checkbox [type='checkbox']:checked + .slds-checkbox--faux::after,\n.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux::after,\n.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux::after,\n.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux::after,\n.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux::after{\n  display:block;\n  content:'';\n  height:var(--slds-g-sizing-2);\n  width:var(--slds-g-sizing-3);\n  position:absolute;\n  inset-block-start:50%;\n\n  /*! @noflip */\n  left:50%;\n  transform:translate3d(-50%, -50%, 0) rotate(-45deg);\n  border-block-end:var(--slds-g-sizing-border-2) solid var(--slds-s-mark-color-foreground-checked, var(--slds-g-color-border-accent-2));\n\n  /*! @noflip */\n  border-left:var(--slds-g-sizing-border-2) solid var(--slds-s-mark-color-foreground-checked, var(--slds-g-color-border-accent-2));\n}\n.slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox_faux,.slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:focus-visible ~ .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:focus-visible ~ .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox__label .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox__label .slds-checkbox--faux{\n  --slds-c-checkbox-color-border:var(\n    --slds-c-checkbox-color-border-focus,\n    var(--slds-s-input-color-border-focus, var(--slds-g-color-border-accent-1))\n  );\n  --slds-c-checkbox-shadow:var(\n    --slds-c-checkbox-shadow-focus,\n    var(--slds-s-mark-shadow-focus, 0 0 3px var(--slds-g-color-accent-2))\n  );\n}\n.slds-checkbox [type='checkbox']:checked > .slds-checkbox_faux,.slds-checkbox [type='checkbox']:checked > .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux{\n  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-checked);\n}\n.slds-checkbox [type='checkbox']:focus-visible:checked > .slds-checkbox_faux,.slds-checkbox [type='checkbox']:focus-visible:checked > .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:focus-visible:checked ~ .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:focus-visible:checked ~ .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:focus-visible:checked + .slds-checkbox__label .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:focus-visible:checked + .slds-checkbox__label .slds-checkbox--faux{\n  --slds-c-checkbox-color-border:var(\n    --slds-c-checkbox-color-border-focus,\n    var(--slds-s-input-color-border-focus, var(--slds-g-color-border-accent-1))\n  );\n  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-focus);\n}\n.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox_faux,.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:indeterminate ~ .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:indeterminate ~ .slds-checkbox--faux,\n.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox__label .slds-checkbox_faux,\n.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox__label .slds-checkbox--faux{\n  --slds-c-checkbox-color-border:var(\n    --slds-c-checkbox-color-border-checked,\n    var(--slds-s-input-color-border-checked)\n  );\n  --slds-c-checkbox-color-background:var(\n    --slds-c-checkbox-color-background-checked,\n    var(--slds-s-mark-color-background-checked)\n  );\n}\n.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox_faux::after,.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox--faux::after,\n.slds-checkbox [type='checkbox']:indeterminate ~ .slds-checkbox_faux::after,\n.slds-checkbox [type='checkbox']:indeterminate ~ .slds-checkbox--faux::after,\n.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox__label .slds-checkbox_faux::after,\n.slds-checkbox [type='checkbox']:indeterminate + .slds-checkbox__label .slds-checkbox--faux::after{\n  content:'';\n  display:block;\n  position:absolute;\n  inset-block-start:50%;\n\n  /*! @noflip */\n  left:50%;\n  width:var(--slds-g-sizing-3);\n  height:2px;\n  border:0;\n  transform:translate3d(-50%, -50%, 0);\n  background-color:var(--slds-s-mark-color-foreground-checked, var(--slds-g-color-accent-container-1));\n}\n.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox_faux,.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox--faux,\n.slds-checkbox [type='checkbox'][disabled] ~ .slds-checkbox_faux,\n.slds-checkbox [type='checkbox'][disabled] ~ .slds-checkbox--faux,\n.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox__label .slds-checkbox_faux,\n.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox__label .slds-checkbox--faux{\n  border-color:var(--slds-g-color-border-disabled-1);\n  background-color:var(--slds-g-color-disabled-container-2);\n}\n.slds-checkbox [type='checkbox'][disabled]:checked + .slds-checkbox_faux,.slds-checkbox [type='checkbox'][disabled]:checked + .slds-checkbox--faux,\n.slds-checkbox [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux,\n.slds-checkbox [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux,\n.slds-checkbox [type='checkbox'][disabled]:checked + .slds-checkbox__label .slds-checkbox_faux,\n.slds-checkbox [type='checkbox'][disabled]:checked + .slds-checkbox__label .slds-checkbox--faux{\n  border-color:var(--slds-g-color-border-disabled-1);\n  background-color:var(--slds-g-color-disabled-container-2);\n}\n.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox_faux::after,.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox--faux::after,\n.slds-checkbox [type='checkbox'][disabled] ~ .slds-checkbox_faux::after,\n.slds-checkbox [type='checkbox'][disabled] ~ .slds-checkbox--faux::after,\n.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox__label .slds-checkbox_faux::after,\n.slds-checkbox [type='checkbox'][disabled] + .slds-checkbox__label .slds-checkbox--faux::after{\n  border-color:var(--slds-g-color-on-disabled-2);\n}\n.slds-has-error .slds-checkbox [type='checkbox'] + .slds-checkbox_faux,.slds-has-error .slds-checkbox [type='checkbox'] + .slds-checkbox--faux,\n.slds-has-error .slds-checkbox [type='checkbox'] ~ .slds-checkbox_faux,\n.slds-has-error .slds-checkbox [type='checkbox'] ~ .slds-checkbox--faux,\n.slds-has-error .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox_faux,\n.slds-has-error .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox--faux{\n  border-color:var(--slds-g-color-border-error-1);\n  border-width:var(--slds-g-sizing-border-2);\n}\n.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox_faux,.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox--faux,\n.slds-has-error .slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux,\n.slds-has-error .slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux,\n.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux,\n.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux{\n  border-color:var(--slds-g-color-border-error-1);\n  background-color:var(--slds-s-mark-color-background-invalid);\n  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-checked);\n}\n.slds-has-error .slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox_faux,.slds-has-error .slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox--faux,\n.slds-has-error .slds-checkbox [type='checkbox']:focus-visible ~ .slds-checkbox_faux,\n.slds-has-error .slds-checkbox [type='checkbox']:focus-visible ~ .slds-checkbox--faux,\n.slds-has-error .slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox__label .slds-checkbox_faux,\n.slds-has-error .slds-checkbox [type='checkbox']:focus-visible + .slds-checkbox__label .slds-checkbox--faux{\n  border-color:var(--slds-g-color-border-error-1);\n  border-width:var(--slds-g-sizing-border-2);\n  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-focus);\n}\n.slds-has-error .slds-checkbox [type='checkbox']:focus-visible:checked + .slds-checkbox_faux,.slds-has-error .slds-checkbox [type='checkbox']:focus-visible:checked + .slds-checkbox--faux,\n.slds-has-error .slds-checkbox [type='checkbox']:focus-visible:checked ~ .slds-checkbox_faux,\n.slds-has-error .slds-checkbox [type='checkbox']:focus-visible:checked ~ .slds-checkbox--faux,\n.slds-has-error\n.slds-checkbox\n[type='checkbox']:focus-visible:checked\n+ .slds-checkbox__label\n.slds-checkbox_faux,\n.slds-has-error\n.slds-checkbox\n[type='checkbox']:focus-visible:checked\n+ .slds-checkbox__label\n.slds-checkbox--faux{\n  border-color:var(--slds-g-color-border-error-1);\n  border-width:var(--slds-g-sizing-border-2);\n  --slds-c-checkbox-shadow:var(--slds-s-mark-shadow-focus);\n}\n.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox_faux::after,.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox--faux::after,\n.slds-has-error .slds-checkbox [type='checkbox']:checked ~ .slds-checkbox_faux::after,\n.slds-has-error .slds-checkbox [type='checkbox']:checked ~ .slds-checkbox--faux::after,\n.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox_faux::after,\n.slds-has-error .slds-checkbox [type='checkbox']:checked + .slds-checkbox__label .slds-checkbox--faux::after{\n  border-color:var(--slds-s-mark-color-foreground-invalid, var(--slds-g-color-border-error-1));\n}\n.slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox_faux,.slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox--faux,\n.slds-form-element .slds-checkbox [type='checkbox'] ~ .slds-checkbox_faux,\n.slds-form-element .slds-checkbox [type='checkbox'] ~ .slds-checkbox--faux,\n.slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox_faux,\n.slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox--faux{\n  margin-inline-end:var(--slds-g-sizing-3);\n}\n[dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox_faux,[dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox--faux,\n[dir='rtl'] [dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] ~ .slds-checkbox_faux,\n[dir='rtl'] [dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] ~ .slds-checkbox--faux,\n[dir='rtl']\n[dir='rtl']\n.slds-form-element\n.slds-checkbox\n[type='checkbox']\n+ .slds-checkbox__label\n.slds-checkbox_faux,\n[dir='rtl']\n[dir='rtl']\n.slds-form-element\n.slds-checkbox\n[type='checkbox']\n+ .slds-checkbox__label\n.slds-checkbox--faux,\n[dir='rtl'] .slds-form-element .slds-checkbox [type='checkbox'] + .slds-checkbox__label .slds-checkbox--faux{\n  /*! @noflip */\n  margin-right:0;\n\n  /*! @noflip */\n  margin-left:var(--slds-g-sizing-3);\n}\n.slds-checkbox_standalone,.slds-checkbox--standalone{\n  pointer-events:none;\n}\n.slds-checkbox_standalone [type='checkbox'],.slds-checkbox--standalone [type='checkbox']{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  margin:0;\n  clip:auto;\n  opacity:0;\n}\n.slds-checkbox_faux,.slds-checkbox--faux{\n  display:block;\n}\n.slds-form-element{\n  position:relative;\n  min-width:0;\n}\n.slds-form-element__label{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:auto;\n  display:inline-block;\n  color:var(--slds-s-label-color, var(--slds-g-color-on-surface-2));\n  font-size:var(--slds-s-label-font-size, var(--slds-g-font-scale-neg-2));\n  padding-inline-end:var(--slds-g-spacing-2);\n  padding-block-start:var(--slds-g-spacing-1);\n  margin-block-end:var(--slds-s-label-spacing-gap, calc(var(--slds-g-spacing-1) / 2));\n}\n.slds-form-element__label:empty{\n  margin:0;\n}\n.slds-form-element__control{\n  clear:left;\n  position:relative;\n}\n.slds-form-element__control .slds-radio,\n.slds-form-element__control .slds-checkbox{\n  display:block;\n}\n[dir='rtl'] .slds-form-element__label{\n  /*! @noflip */\n  padding-right:0;\n\n  /*! @noflip */\n  padding-left:var(--slds-g-spacing-2);\n}\n[dir='rtl'] .slds-form-element__control{\n  /*! @noflip */\n  clear:right;\n}\n.slds-form-element__icon{\n  display:inline-block;\n  position:relative;\n  padding-block-start:var(--slds-g-spacing-1);\n  vertical-align:top;\n  line-height:var(--slds-g-font-lineheight-1);\n  z-index:1;\n}\n.slds-form-element__icon .slds-button_icon,.slds-form-element__icon .slds-button--icon{\n  position:relative;\n}\n.slds-form-element__help,\n.slds-form-element__helper{\n  font-size:var(--slds-s-helptext-font-size, var(--slds-g-font-scale-neg-2));\n  margin-block-start:calc(var(--slds-g-spacing-1) / 2);\n  display:block;\n  color:var(--slds-s-helptext-color);\n}\n.slds-form-element_edit .slds-form-element__static,.slds-form-element--edit .slds-form-element__static{\n  width:calc(100% - var(--slds-g-sizing-7));\n}\n.slds-form-element_readonly,.slds-form-element--readonly{\n  flex-basis:0%;\n  border-bottom:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  margin-block-end:0;\n}\n.slds-form-element_readonly .slds-form-element__control,.slds-form-element--readonly .slds-form-element__control{\n  padding-block-start:calc(var(--slds-g-spacing-1) / 2);\n  padding-block-end:calc(var(--slds-g-spacing-1) / 2);\n}\n.slds-form-element_readonly .slds-form-element__label,.slds-form-element--readonly .slds-form-element__label{\n  margin-block-end:0;\n}\n.slds-form-element__legend{\n  font-weight:var(--slds-g-font-weight-7);\n  float:left;\n}\n[dir='rtl'] .slds-form-element__legend{\n  /*! @noflip */\n  float:right;\n\n  /*! @noflip */\n  padding-right:0;\n}\n.slds-form-element__addon{\n  display:inline-block;\n  margin:0 var(--slds-g-spacing-2);\n  align-self:center;\n}\n.slds-form-element__static{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  word-break:break-word;\n  display:inline-block;\n  font-size:var(--slds-s-label-font-size, var(--slds-g-font-scale-neg-1));\n  font-weight:var(--slds-g-font-weight-4);\n  color:var(--slds-g-color-neutral-base-10);\n  width:100%;\n}\n.slds-form-element__static.slds-text-longform *:last-child{\n  margin-block-end:0;\n}\n.slds-form-element__static:empty{\n  min-height:calc(var(--slds-g-sizing-6) + 1px);\n  vertical-align:bottom;\n}\n.slds-form-element__static--edit{\n  width:calc(100% - var(--slds-g-sizing-7));\n}\n.slds-required{\n  color:var(--slds-g-color-error-1);\n  margin:0 calc(var(--slds-g-spacing-1) / 2);\n}\n.slds-has-error .slds-form-element__help{\n  color:var(--slds-g-color-error-1);\n}\n.slds-form_inline .slds-form-element,.slds-form--inline .slds-form-element,\n.slds-form_inline .slds-form-element__label,\n.slds-form--inline .slds-form-element__label,\n.slds-form_inline .slds-form-element__control,\n.slds-form--inline .slds-form-element__control{\n  display:block;\n}\n.slds-form_inline .slds-form-element + .slds-form-element,.slds-form--inline .slds-form-element + .slds-form-element{\n  margin-block-start:var(--slds-g-spacing-3);\n}\n@media (min-width: 30em){\n  .slds-form_inline .slds-form-element,.slds-form--inline .slds-form-element{\n    margin-inline-end:var(--slds-g-spacing-2);\n  }\n\n  .slds-form_inline .slds-form-element + .slds-form-element,.slds-form--inline .slds-form-element + .slds-form-element{\n    margin-block-start:0;\n  }\n\n  .slds-form_inline .slds-form-element,.slds-form--inline .slds-form-element,\n  .slds-form_inline .slds-form-element__label,\n  .slds-form--inline .slds-form-element__label,\n  .slds-form_inline .slds-form-element__control,\n  .slds-form--inline .slds-form-element__control{\n    display:inline-block;\n    vertical-align:middle;\n    margin-block-end:0;\n  }\n}\n.slds-form-element__legend_has-tooltip,.slds-form-element__legend--has-tooltip{\n  float:left;\n}\n.slds-form-element_address .slds-form-element__row,.slds-form-element--address .slds-form-element__row{\n  align-items:flex-end;\n}\n.slds-form-element_stacked,.slds-form-element--stacked,\n.slds-form_stacked .slds-form-element,\n.slds-form--stacked .slds-form-element,\n.slds-form_horizontal .slds-form-element_stacked,\n.slds-form--horizontal .slds-form-element--stacked{\n  display:block;\n}\n.slds-form-element_stacked:not(.slds-form-element_readonly),.slds-form-element--stacked:not(.slds-form-element--readonly),\n.slds-form_stacked .slds-form-element:not(.slds-form-element_readonly),\n.slds-form--stacked .slds-form-element:not(.slds-form-element--readonly),\n.slds-form_horizontal .slds-form-element_stacked:not(.slds-form-element_readonly),\n.slds-form--horizontal .slds-form-element--stacked:not(.slds-form-element--readonly){\n  margin-block-end:var(--slds-g-spacing-2);\n}\n.slds-form-element_stacked:not(.slds-is-editing),.slds-form-element--stacked:not(.slds-is-editing),\n.slds-form_stacked .slds-form-element:not(.slds-is-editing),\n.slds-form--stacked .slds-form-element:not(.slds-is-editing),\n.slds-form_horizontal .slds-form-element_stacked:not(.slds-is-editing),\n.slds-form--horizontal .slds-form-element--stacked:not(.slds-is-editing){\n  padding:0 var(--slds-g-spacing-1);\n}\n.slds-form-element_stacked .slds-form-element,.slds-form-element--stacked .slds-form-element,\n.slds-form_stacked .slds-form-element .slds-form-element,\n.slds-form--stacked .slds-form-element .slds-form-element,\n.slds-form_horizontal .slds-form-element_stacked .slds-form-element,\n.slds-form--horizontal .slds-form-element--stacked .slds-form-element{\n  padding:0;\n  margin-block-end:0;\n}\n.slds-form-element_stacked:not([class*='slds-size']),.slds-form-element--stacked:not([class*='slds-size']),\n.slds-form_stacked .slds-form-element:not([class*='slds-size']),\n.slds-form--stacked .slds-form-element:not([class*='slds-size']),\n.slds-form_horizontal .slds-form-element_stacked:not([class*='slds-size']),\n.slds-form--horizontal .slds-form-element--stacked:not([class*='slds-size']){\n  width:100%;\n  flex-basis:100%;\n}\n.slds-form-element_stacked .slds-checkbox,.slds-form-element--stacked .slds-checkbox,\n.slds-form-element_stacked .slds-radio,\n.slds-form-element--stacked .slds-radio,\n.slds-form_stacked .slds-form-element .slds-checkbox,\n.slds-form--stacked .slds-form-element .slds-checkbox,\n.slds-form_stacked .slds-form-element .slds-radio,\n.slds-form--stacked .slds-form-element .slds-radio,\n.slds-form_horizontal .slds-form-element_stacked .slds-checkbox,\n.slds-form--horizontal .slds-form-element--stacked .slds-checkbox,\n.slds-form_horizontal .slds-form-element_stacked .slds-radio,\n.slds-form--horizontal .slds-form-element--stacked .slds-radio{\n  display:block;\n}\n.slds-form-element_stacked .slds-form-element__label,.slds-form-element--stacked .slds-form-element__label,\n.slds-form-element_stacked .slds-form-element__control,\n.slds-form-element--stacked .slds-form-element__control,\n.slds-form_stacked .slds-form-element .slds-form-element__label,\n.slds-form--stacked .slds-form-element .slds-form-element__label,\n.slds-form_stacked .slds-form-element .slds-form-element__control,\n.slds-form--stacked .slds-form-element .slds-form-element__control,\n.slds-form_horizontal .slds-form-element_stacked .slds-form-element__label,\n.slds-form--horizontal .slds-form-element--stacked .slds-form-element__label,\n.slds-form_horizontal .slds-form-element_stacked .slds-form-element__control,\n.slds-form--horizontal .slds-form-element--stacked .slds-form-element__control{\n  border-bottom:0;\n  padding-inline-start:0;\n}\n.slds-form-element_stacked .slds-form-element__control,.slds-form-element--stacked .slds-form-element__control,\n.slds-form_stacked .slds-form-element .slds-form-element__control,\n.slds-form--stacked .slds-form-element .slds-form-element__control,\n.slds-form_horizontal .slds-form-element_stacked .slds-form-element__control,\n.slds-form--horizontal .slds-form-element--stacked .slds-form-element__control{\n  width:100%;\n  flex-basis:100%;\n  clear:left;\n}\n[dir='rtl'] .slds-form-element_stacked .slds-form-element__control,[dir='rtl'] .slds-form-element--stacked .slds-form-element__control,\n[dir='rtl'] .slds-form_stacked .slds-form-element .slds-form-element__control,\n[dir='rtl'] .slds-form--stacked .slds-form-element .slds-form-element__control,\n[dir='rtl'] .slds-form_horizontal .slds-form-element_stacked .slds-form-element__control,\n[dir='rtl'] .slds-form--horizontal .slds-form-element--stacked .slds-form-element__control{\n  /*! @noflip */\n  clear:right;\n}\n.slds-form-element_stacked .slds-form-element__icon,.slds-form-element--stacked .slds-form-element__icon,\n.slds-form_stacked .slds-form-element .slds-form-element__icon,\n.slds-form--stacked .slds-form-element .slds-form-element__icon,\n.slds-form_horizontal .slds-form-element_stacked .slds-form-element__icon,\n.slds-form--horizontal .slds-form-element--stacked .slds-form-element__icon{\n  float:none;\n  padding-block-start:var(--slds-g-spacing-1);\n}\n.slds-form-element_horizontal,.slds-form-element--horizontal,\n.slds-form_horizontal .slds-form-element,\n.slds-form--horizontal .slds-form-element,\n.slds-form_stacked .slds-form-element_horizontal,\n.slds-form--stacked .slds-form-element--horizontal{\n  display:block;\n}\n.slds-form-element_horizontal:not(.slds-form-element_readonly),.slds-form-element--horizontal:not(.slds-form-element--readonly),\n.slds-form_horizontal .slds-form-element:not(.slds-form-element_readonly),\n.slds-form--horizontal .slds-form-element:not(.slds-form-element--readonly),\n.slds-form_stacked .slds-form-element_horizontal:not(.slds-form-element_readonly),\n.slds-form--stacked .slds-form-element--horizontal:not(.slds-form-element--readonly){\n  margin-block-end:var(--slds-g-spacing-2);\n}\n.slds-form-element_horizontal:not([class*='slds-size']),.slds-form-element--horizontal:not([class*='slds-size']),\n.slds-form_horizontal .slds-form-element:not([class*='slds-size']),\n.slds-form--horizontal .slds-form-element:not([class*='slds-size']),\n.slds-form_stacked .slds-form-element_horizontal:not([class*='slds-size']),\n.slds-form--stacked .slds-form-element--horizontal:not([class*='slds-size']){\n  width:100%;\n  flex-basis:100%;\n}\n.slds-form-element_horizontal:not(.slds-is-editing),.slds-form-element--horizontal:not(.slds-is-editing),\n.slds-form_horizontal .slds-form-element:not(.slds-is-editing),\n.slds-form--horizontal .slds-form-element:not(.slds-is-editing),\n.slds-form_stacked .slds-form-element_horizontal:not(.slds-is-editing),\n.slds-form--stacked .slds-form-element--horizontal:not(.slds-is-editing){\n  padding:var(--slds-g-spacing-1);\n}\n.slds-form-element_horizontal .slds-form-element,.slds-form-element--horizontal .slds-form-element,\n.slds-form_horizontal .slds-form-element .slds-form-element,\n.slds-form--horizontal .slds-form-element .slds-form-element,\n.slds-form_stacked .slds-form-element_horizontal .slds-form-element,\n.slds-form--stacked .slds-form-element--horizontal .slds-form-element{\n  padding:0;\n  margin-block-end:0;\n}\n.slds-form-element_horizontal.slds-is-edited,.slds-form-element--horizontal.slds-is-edited,\n.slds-form_horizontal .slds-form-element.slds-is-edited,\n.slds-form--horizontal .slds-form-element.slds-is-edited,\n.slds-form_stacked .slds-form-element_horizontal.slds-is-edited,\n.slds-form--stacked .slds-form-element--horizontal.slds-is-edited{\n  padding-block-start:calc(var(--slds-g-spacing-4) + var(--slds-g-spacing-1));\n}\n@media (min-width: 48em){\n  .slds-form-element_horizontal.slds-form-element_1-col .slds-form-element__label,.slds-form-element--horizontal.slds-form-element--1-col .slds-form-element__label,\n  .slds-form_horizontal .slds-form-element.slds-form-element_1-col .slds-form-element__label,\n  .slds-form--horizontal .slds-form-element.slds-form-element--1-col .slds-form-element__label,\n  .slds-form_stacked .slds-form-element_horizontal.slds-form-element_1-col .slds-form-element__label,\n  .slds-form--stacked .slds-form-element--horizontal.slds-form-element--1-col .slds-form-element__label{\n    max-width:calc((50% - 33.333%) - 1.25rem);\n  }\n\n  .slds-form-element_horizontal.slds-form-element_1-col .slds-form-element__control,.slds-form-element--horizontal.slds-form-element--1-col .slds-form-element__control,\n  .slds-form_horizontal .slds-form-element.slds-form-element_1-col .slds-form-element__control,\n  .slds-form--horizontal .slds-form-element.slds-form-element--1-col .slds-form-element__control,\n  .slds-form_stacked .slds-form-element_horizontal.slds-form-element_1-col .slds-form-element__control,\n  .slds-form--stacked .slds-form-element--horizontal.slds-form-element--1-col .slds-form-element__control{\n    padding-inline-start:calc((50% - 33.333%) - (0.25rem * 2));\n  }\n}\n@media (min-width: 48em){\n  .slds-form-element_horizontal .slds-form-element__label,.slds-form-element--horizontal .slds-form-element__label,\n  .slds-form_horizontal .slds-form-element .slds-form-element__label,\n  .slds-form--horizontal .slds-form-element .slds-form-element__label,\n  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__label,\n  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__label{\n    float:inline-start;\n    max-width:calc(33% - 1.25rem);\n    flex-basis:calc(33% - 1.25rem);\n    margin-block-end:0;\n    position:relative;\n    z-index:1;\n  }\n\n  .slds-form-element_horizontal .slds-form-element__control,.slds-form-element--horizontal .slds-form-element__control,\n  .slds-form_horizontal .slds-form-element .slds-form-element__control,\n  .slds-form--horizontal .slds-form-element .slds-form-element__control,\n  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__control,\n  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__control{\n    padding-inline-start:33%;\n    clear:none;\n  }\n\n  .slds-form-element_horizontal .slds-form-element__control .slds-form-element__control,.slds-form-element--horizontal .slds-form-element__control .slds-form-element__control,\n  .slds-form_horizontal .slds-form-element .slds-form-element__control .slds-form-element__control,\n  .slds-form--horizontal .slds-form-element .slds-form-element__control .slds-form-element__control,\n  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__control .slds-form-element__control,\n  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__control .slds-form-element__control{\n    padding-inline-start:0;\n  }\n\n  .slds-form-element_horizontal .slds-form-element__icon,.slds-form-element--horizontal .slds-form-element__icon,\n  .slds-form_horizontal .slds-form-element .slds-form-element__icon,\n  .slds-form--horizontal .slds-form-element .slds-form-element__icon,\n  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__icon,\n  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__icon{\n    float:inline-start;\n    padding-block-start:var(--slds-g-spacing-1);\n  }\n\n  .slds-form-element_horizontal .slds-checkbox_standalone,.slds-form-element--horizontal .slds-checkbox--standalone,\n  .slds-form_horizontal .slds-form-element .slds-checkbox_standalone,\n  .slds-form--horizontal .slds-form-element .slds-checkbox--standalone,\n  .slds-form_stacked .slds-form-element_horizontal .slds-checkbox_standalone,\n  .slds-form--stacked .slds-form-element--horizontal .slds-checkbox--standalone{\n    padding-block:var(--slds-g-spacing-1);\n    padding-inline:0;\n  }\n\n  .slds-form-element_horizontal .slds-checkbox:not(.slds-checkbox_stacked) .slds-form-element__label,.slds-form-element--horizontal .slds-checkbox:not(.slds-checkbox--stacked) .slds-form-element__label,\n  .slds-form-element_horizontal .slds-radio .slds-form-element__label,\n  .slds-form-element--horizontal .slds-radio .slds-form-element__label,\n  .slds-form_horizontal\n  .slds-form-element\n  .slds-checkbox:not(.slds-checkbox_stacked)\n  .slds-form-element__label,\n  .slds-form--horizontal\n  .slds-form-element\n  .slds-checkbox:not(.slds-checkbox--stacked)\n  .slds-form-element__label,\n  .slds-form_horizontal .slds-form-element .slds-radio .slds-form-element__label,\n  .slds-form--horizontal .slds-form-element .slds-radio .slds-form-element__label,\n  .slds-form_stacked\n  .slds-form-element_horizontal\n  .slds-checkbox:not(.slds-checkbox_stacked)\n  .slds-form-element__label,\n  .slds-form--stacked\n  .slds-form-element--horizontal\n  .slds-checkbox:not(.slds-checkbox--stacked)\n  .slds-form-element__label,\n  .slds-form_stacked .slds-form-element_horizontal .slds-radio .slds-form-element__label,\n  .slds-form--stacked .slds-form-element--horizontal .slds-radio .slds-form-element__label{\n    position:relative;\n    float:none;\n    max-width:100%;\n    width:auto;\n  }\n\n  .slds-form-element_horizontal .slds-form-element__row .slds-form-element__label,.slds-form-element--horizontal .slds-form-element__row .slds-form-element__label,\n  .slds-form-element_horizontal .slds-form-element__row .slds-form-element__control,\n  .slds-form-element--horizontal .slds-form-element__row .slds-form-element__control,\n  .slds-form-element_horizontal .slds-dueling-list__column .slds-form-element__label,\n  .slds-form-element--horizontal .slds-dueling-list__column .slds-form-element__label,\n  .slds-form_horizontal .slds-form-element .slds-form-element__row .slds-form-element__label,\n  .slds-form--horizontal .slds-form-element .slds-form-element__row .slds-form-element__label,\n  .slds-form_horizontal .slds-form-element .slds-form-element__row .slds-form-element__control,\n  .slds-form--horizontal .slds-form-element .slds-form-element__row .slds-form-element__control,\n  .slds-form_horizontal .slds-form-element .slds-dueling-list__column .slds-form-element__label,\n  .slds-form--horizontal .slds-form-element .slds-dueling-list__column .slds-form-element__label,\n  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__row .slds-form-element__label,\n  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__row .slds-form-element__label,\n  .slds-form_stacked .slds-form-element_horizontal .slds-form-element__row .slds-form-element__control,\n  .slds-form--stacked .slds-form-element--horizontal .slds-form-element__row .slds-form-element__control,\n  .slds-form_stacked .slds-form-element_horizontal .slds-dueling-list__column .slds-form-element__label,\n  .slds-form--stacked .slds-form-element--horizontal .slds-dueling-list__column .slds-form-element__label{\n    width:auto;\n    max-width:100%;\n    flex-basis:auto;\n    float:none;\n    position:relative;\n    padding-inline-start:0;\n    margin-block-end:0;\n  }\n\n  .slds-form-element_horizontal .slds-dueling-list,.slds-form-element--horizontal .slds-dueling-list,\n  .slds-form_horizontal .slds-form-element .slds-dueling-list,\n  .slds-form--horizontal .slds-form-element .slds-dueling-list,\n  .slds-form_stacked .slds-form-element_horizontal .slds-dueling-list,\n  .slds-form--stacked .slds-form-element--horizontal .slds-dueling-list{\n    clear:none;\n  }\n\n  .slds-form-element_horizontal .slds-input-has-icon_left .slds-input__icon,.slds-form-element--horizontal .slds-input-has-icon--left .slds-input__icon,\n  .slds-form_horizontal .slds-form-element .slds-input-has-icon_left .slds-input__icon,\n  .slds-form--horizontal .slds-form-element .slds-input-has-icon--left .slds-input__icon,\n  .slds-form_stacked .slds-form-element_horizontal .slds-input-has-icon_left .slds-input__icon,\n  .slds-form--stacked .slds-form-element--horizontal .slds-input-has-icon--left .slds-input__icon{\n    inset-inline-start:calc(33% + 0.75rem);\n  }\n\n  .slds-form-element_horizontal .slds-input-has-icon_left-right .slds-input__icon_left,.slds-form-element--horizontal .slds-input-has-icon--left-right .slds-input__icon--left,\n  .slds-form_horizontal .slds-form-element .slds-input-has-icon_left-right .slds-input__icon_left,\n  .slds-form--horizontal .slds-form-element .slds-input-has-icon--left-right .slds-input__icon--left,\n  .slds-form_stacked .slds-form-element_horizontal .slds-input-has-icon_left-right .slds-input__icon_left,\n  .slds-form--stacked .slds-form-element--horizontal .slds-input-has-icon--left-right .slds-input__icon--left{\n    inset-inline-start:calc(33% + 0.75rem);\n  }\n}\n.slds-form-element_horizontal .slds-form-element__help,.slds-form-element--horizontal .slds-form-element__help,\n.slds-form_horizontal .slds-form-element .slds-form-element__help,\n.slds-form--horizontal .slds-form-element .slds-form-element__help,\n.slds-form_stacked .slds-form-element_horizontal .slds-form-element__help,\n.slds-form--stacked .slds-form-element--horizontal .slds-form-element__help{\n  margin-inline-start:33%;\n}\n.slds-form-element_compound .slds-form-element__row,.slds-form-element--compound .slds-form-element__row{\n  display:flex;\n  margin-block-end:var(--slds-g-spacing-1);\n  margin-inline-start:calc(var(--slds-g-spacing-1) * -1);\n  margin-inline-end:calc(var(--slds-g-spacing-1) * -1);\n}\n.slds-form-element_compound .slds-form-element__row .slds-form-element__label,.slds-form-element--compound .slds-form-element__row .slds-form-element__label{\n  padding-block-start:0;\n}\n.slds-form-element_compound .slds-form-element,.slds-form-element--compound .slds-form-element{\n  padding-inline-start:var(--slds-g-spacing-1);\n  padding-inline-end:var(--slds-g-spacing-1);\n}\n.slds-form_compound,.slds-form--compound{\n  width:100%;\n}\n.slds-form_compound > .slds-form-element,.slds-form--compound > .slds-form-element{\n  margin-block-start:0;\n  margin-block-end:0;\n  margin-inline-start:0;\n  margin-inline-end:0;\n}\n.slds-form_compound .slds-form-element__row,.slds-form--compound .slds-form-element__row{\n  display:flex;\n  margin-block-start:0;\n  margin-block-end:var(--slds-g-spacing-1);\n  margin-inline-start:0;\n  margin-inline-end:0;\n}\n.slds-form_compound .slds-form-element__row + .slds-form-element__row,.slds-form--compound .slds-form-element__row + .slds-form-element__row{\n  clear:both;\n}\n.slds-form_compound .slds-form-element__row .slds-form-element,.slds-form--compound .slds-form-element__row .slds-form-element{\n  margin-block-end:0;\n}\n.slds-form_compound .slds-form-element__row .slds-form-element + .slds-form-element,.slds-form--compound .slds-form-element__row .slds-form-element + .slds-form-element{\n  padding-inline-start:var(--slds-g-spacing-2);\n  margin-block-start:0;\n}\n.slds-form_compound .slds-form-element__row .slds-form-element__label,.slds-form--compound .slds-form-element__row .slds-form-element__label{\n  padding-block-start:0;\n}\n.slds-form__row{\n  display:flex;\n  flex-wrap:wrap;\n  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);\n  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-form__item{\n  display:flex;\n  flex:1 1 0%;\n  min-width:280px;\n  padding-inline-start:var(--slds-g-spacing-3);\n  padding-inline-end:var(--slds-g-spacing-3);\n}\n.slds-is-edited{\n  background:var(--slds-g-color-palette-yellow-90);\n}\n.slds-is-edited .slds-form-element__undo{\n  inset-block-start:-1.25rem;\n  inset-inline-end:var(--slds-g-spacing-1);\n}\n.slds-form-element__undo{\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-end:0;\n}\n.slds-docked-form-footer{\n  display:flex;\n  justify-content:center;\n  padding:var(--slds-g-spacing-2) 0;\n  position:fixed;\n  inset-block-end:0;\n  inset-inline-start:0;\n  width:100%;\n  background-color:var(--slds-s-container-footer-color-background, var(--slds-g-color-surface-container-2));\n  box-shadow:var(--slds-g-shadow-blockstart-2, 0 -2px 2px 0 rgba(0, 0, 0, 0.16));\n  z-index:8000;\n}\n.slds-slider{\n  display:flex;\n  position:relative;\n}\n.slds-slider__range{\n  appearance:none;\n  width:100%;\n  background:none;\n  background-color:transparent;\n  border-radius:var(--slds-g-radius-border-1);\n}\n.slds-slider__range:focus{\n  outline:0;\n}\n.slds-slider__range::-webkit-slider-thumb{\n  appearance:none;\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  border-radius:var(--slds-c-slider-thumb-radius-border, var(--slds-g-radius-border-circle));\n  background:none;\n  background-color:var(--slds-c-slider-thumb-color-foreground, var(--slds-g-color-accent-container-1));\n  border:0;\n  box-shadow:var(\n    --slds-c-slider-thumb-shadow,\n    var(--slds-g-color-neutral-base-10, rgba(0, 0, 0, 0.16) 0 2px 3px)\n  );\n  cursor:pointer;\n  transition:background 0.15s ease-in-out;\n}\n.slds-slider__range::-webkit-slider-thumb:hover{\n  background-color:var(\n    --slds-c-slider-thumb-color-foreground-hover,\n    var(--slds-g-color-accent-container-2)\n  );\n}\n.slds-slider__range::-webkit-slider-thumb{\n\n  margin-top:calc(((var(--slds-g-sizing-5) / 2) - (var(--slds-g-sizing-2) / 2)) * -1);\n}\n.slds-slider__range::-webkit-slider-runnable-track{\n  width:100%;\n  height:var(--slds-g-sizing-2);\n  cursor:pointer;\n  background:none;\n  background-color:var(--slds-c-slider-track-color-background, var(--slds-g-color-border-1));\n  border-radius:var(--slds-c-slider-track-radius-border, var(--slds-g-radius-border-1));\n}\n.slds-slider__range::-moz-range-thumb{\n  appearance:none;\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  border-radius:var(--slds-c-slider-thumb-radius-border, var(--slds-g-radius-border-circle));\n  background:none;\n  background-color:var(--slds-c-slider-thumb-color-foreground, var(--slds-g-color-accent-container-1));\n  border:0;\n  box-shadow:var(\n    --slds-c-slider-thumb-shadow,\n    var(--slds-g-color-neutral-base-10, rgba(0, 0, 0, 0.16) 0 2px 3px)\n  );\n  cursor:pointer;\n  transition:background 0.15s ease-in-out;\n}\n.slds-slider__range::-moz-range-thumb:hover{\n  background-color:var(\n    --slds-c-slider-thumb-color-foreground-hover,\n    var(--slds-g-color-accent-container-2)\n  );\n}\n.slds-slider__range::-moz-range-track{\n  width:100%;\n  height:var(--slds-g-sizing-2);\n  cursor:pointer;\n  background:none;\n  background-color:var(--slds-c-slider-track-color-background, var(--slds-g-color-border-1));\n  border-radius:var(--slds-c-slider-track-radius-border, var(--slds-g-radius-border-1));\n}\n.slds-slider__range::-ms-track{\n  width:100%;\n  height:var(--slds-g-sizing-2);\n  cursor:pointer;\n  background:none;\n  background-color:var(\n    --slds-c-slider-track-color-background,\n    var(--slds-g-color-neutral-base-95, var(--slds-g-color-surface-2))\n  );\n  border-radius:var(--slds-c-slider-track-radius-border, var(--slds-g-radius-border-1));\n  border-color:transparent;\n  color:transparent;\n}\n.slds-slider__range::-ms-thumb{\n  width:100%;\n  height:var(--slds-g-sizing-2);\n  cursor:pointer;\n  background:none;\n  background-color:var(\n    --slds-c-slider-track-color-background,\n    var(--slds-g-color-neutral-base-95, var(--slds-g-color-surface-2))\n  );\n  border-radius:var(--slds-c-slider-track-radius-border, var(--slds-g-radius-border-1));\n  margin-block-start:calc(var(--slds-g-sizing-2) / 4);\n}\n.slds-slider__range:focus::-webkit-slider-thumb{\n  background-color:var(--slds-c-slider-thumb-color-foreground-focus, var(--slds-g-color-accent-container-2));\n  box-shadow:var(--slds-c-slider-thumb-shadow-focus, var(--slds-s-button-shadow-focus));\n}\n.slds-slider__range:active::-webkit-slider-thumb{\n  background-color:var(\n    --slds-c-slider-thumb-color-foreground-active,\n    var(--slds-g-color-accent-container-2)\n  );\n}\n.slds-slider__range:focus::-moz-range-thumb{\n  background-color:var(--slds-c-slider-thumb-color-foreground-focus, var(--slds-g-color-accent-container-2));\n  box-shadow:var(--slds-c-slider-thumb-shadow-focus, var(--slds-s-button-shadow-focus));\n}\n.slds-slider__range:active::-moz-range-thumb{\n  background-color:var(\n    --slds-c-slider-thumb-color-foreground-active,\n    var(--slds-g-color-accent-container-2)\n  );\n}\n.slds-slider__range[disabled]::-webkit-slider-thumb{\n  background-color:var(--slds-g-color-on-disabled-1);\n  cursor:default;\n}\n.slds-slider__range[disabled]::-webkit-slider-runnable-track{\n  background-color:var(--slds-g-color-border-disabled-1);\n  cursor:default;\n}\n.slds-slider__range[disabled]::-moz-range-thumb{\n  background-color:var(--slds-g-color-on-disabled-1);\n  cursor:default;\n}\n.slds-slider__range[disabled]::-moz-range-track{\n  background-color:var(--slds-g-color-border-disabled-1);\n}\n.slds-slider__range[disabled]::-ms-thumb{\n  background-color:var(--slds-g-color-on-disabled-1);\n  cursor:default;\n}\n.slds-slider__range[disabled]::-ms-track{\n  background-color:var(--slds-g-color-border-disabled-1);\n  cursor:default;\n}\n.slds-slider__value{\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-2);\n}\n.slds-slider-label__label{\n  display:block;\n}\n.slds-slider_vertical,.slds-slider--vertical{\n  height:calc(12rem + 1.875rem);\n}\n.slds-slider_vertical .slds-slider__range,.slds-slider--vertical .slds-slider__range{\n  width:12rem;\n  height:var(--slds-g-sizing-5);\n  transform:rotate(-90deg);\n  transform-origin:calc(12rem * 0.5) calc(12rem * 0.5);\n}\n.slds-slider_vertical .slds-slider__value,.slds-slider--vertical .slds-slider__value{\n  position:absolute;\n  inset-inline-start:0;\n  inset-block-end:0;\n  padding:0;\n}\n.slds-modal{\n  opacity:0;\n  visibility:hidden;\n  transition:transform 0.1s linear, opacity 0.1s linear;\n  position:fixed;\n  inset-block-start:0;\n  inset-inline-end:0;\n  inset-block-end:0;\n  inset-inline-start:0;\n  z-index:9001;\n}\n.slds-modal .slds-modal__title{\n  font-weight:var(--slds-c-modal-heading-font-weight, var(--slds-s-container-heading-font-weight));\n  font-size:var(\n    --slds-c-modal-heading-font-size,\n    var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2))\n  );\n  line-height:var(--slds-g-font-lineheight-2);\n}\n.slds-modal__container{\n  position:relative;\n  transform:translate(0, 0);\n  transition:transform 0.1s linear, opacity 0.1s linear;\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  margin-block:0;\n  margin-inline:var(--slds-g-spacing-6);\n  height:100%;\n  padding-block-start:var(--slds-g-spacing-8);\n  padding-inline-end:0;\n  padding-block-end:var(--slds-g-spacing-12);\n  padding-inline-start:0;\n  border-radius:var(--slds-g-radius-border-2);\n}\n@media (min-width: 48em){\n  .slds-modal__container{\n    margin-block:0;\n    margin-inline:auto;\n    width:50%;\n    max-width:40rem;\n    min-width:20rem;\n  }\n}\n.slds-modal__header{\n  position:relative;\n  border-start-end-radius:var(\n    --slds-c-modal-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  border-start-start-radius:var(\n    --slds-c-modal-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  border-block-end-width:var(--slds-c-modal-sizing-border, var(--slds-g-sizing-border-2));\n  border-block-end-style:solid;\n  border-block-end-color:var(--slds-c-modal-color-border, var(--slds-g-color-border-1));\n  background-color:var(\n    --slds-c-modal-header-color-background,\n    var(--slds-c-modal-color-background, var(--slds-g-color-surface-container-1))\n  );\n  color:var(--slds-c-modal-header-text-color, var(--slds-c-modal-text-color));\n  flex-shrink:0;\n  padding-block-start:var(--slds-c-modal-header-spacing-blockstart, var(--slds-g-spacing-4));\n  padding-inline-end:var(--slds-c-modal-header-spacing-inlineend, var(--slds-g-spacing-4));\n  padding-block-end:var(--slds-c-modal-header-spacing-blockend, var(--slds-g-spacing-4));\n  padding-inline-start:var(--slds-c-modal-header-spacing-inlinestart, var(--slds-g-spacing-4));\n  text-align:center;\n}\n.slds-modal__header + .slds-modal__menu{\n  border-start-end-radius:0;\n  border-start-start-radius:0;\n}\n.slds-modal__header .slds-modal__close{\n  position:absolute;\n  inset-block-start:calc(var(--slds-g-spacing-6) * -1.25);\n  inset-inline-end:0;\n  margin-inline-start:0;\n  inset-block-end:0;\n}\n.slds-modal__close{\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n  margin-inline-start:auto;\n  position:relative;\n  inset-block-end:var(--slds-g-spacing-2);\n  background-color:var(--slds-g-color-surface-container-1);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n}\n.slds-modal__close:hover,\n.slds-modal__close:focus-visible,\n.slds-modal__close:active{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-modal__content_headless,.slds-modal__content--headless,\n.slds-modal__header_empty + .slds-modal__content,\n.slds-modal__header--empty + .slds-modal__content{\n  border-start-end-radius:var(\n    --slds-c-modal-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  border-start-start-radius:var(\n    --slds-c-modal-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n}\n.slds-modal__content{\n  background-color:var(\n    --slds-c-modal-content-color-background,\n    var(--slds-c-modal-color-background, var(--slds-g-color-surface-container-1))\n  );\n  color:var(\n    --slds-c-modal-content-text-color,\n    var(--slds-c-modal-text-color, var(--slds-s-container-content-color))\n  );\n  overflow:hidden;\n  overflow-y:auto;\n}\n.slds-modal__content_footless,.slds-modal__content--footless,\n.slds-modal__container > .slds-modal__content:last-child,\n.slds-modal__content_has-hidden-footer,\n.slds-modal__content--has-hidden-footer{\n  border-end-end-radius:var(\n    --slds-c-modal-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  border-end-start-radius:var(\n    --slds-c-modal-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  box-shadow:var(--slds-c-modal-shadow, 0 2px 3px 0 rgba(0, 0, 0, 0.16));\n}\n.slds-modal__footer{\n  border-end-end-radius:var(\n    --slds-c-modal-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  border-end-start-radius:var(\n    --slds-c-modal-radius-border,\n    var(--slds-s-container-radius-border, var(--slds-g-radius-border-2))\n  );\n  border-block-start-width:var(--slds-c-modal-sizing-border, var(--slds-g-sizing-border-2));\n  border-block-start-style:solid;\n  border-block-start-color:var(--slds-c-modal-color-border, var(--slds-g-color-border-1));\n  background-color:var(\n    --slds-c-modal-footer-color-background,\n    var(\n      --slds-c-modal-color-background,\n      var(--slds-s-container-footer-color-background, var(--slds-g-color-surface-container-2))\n    )\n  );\n  color:var(--slds-c-modal-footer-text-color, var(--slds-c-modal-text-color));\n  flex-shrink:0;\n  padding-block-start:var(--slds-c-modal-footer-spacing-blockstart, var(--slds-g-spacing-3));\n  padding-inline-end:var(--slds-c-modal-footer-spacing-inlineend, var(--slds-g-spacing-4));\n  padding-block-end:var(--slds-c-modal-footer-spacing-blockend, var(--slds-g-spacing-3));\n  padding-inline-start:var(--slds-c-modal-footer-spacing-inlinestart, var(--slds-g-spacing-4));\n  text-align:right;\n  box-shadow:var(--slds-c-modal-shadow, 0 2px 3px 0 rgba(0, 0, 0, 0.16));\n}\n.slds-modal__footer .slds-button + .slds-button{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-modal__footer_directional .slds-button:first-child,.slds-modal__footer--directional .slds-button:first-child{\n  float:inline-start;\n}\n@media (min-width: 48em){\n  .slds-modal_small .slds-modal__container,.slds-modal--small .slds-modal__container{\n    width:60%;\n    max-width:52.0625rem;\n    min-width:40rem;\n  }\n}\n@media (min-width: 48em){\n  .slds-modal_medium .slds-modal__container,.slds-modal--medium .slds-modal__container{\n    width:70%;\n    max-width:75rem;\n    min-width:40rem;\n  }\n}\n@media (min-width: 48em){\n  .slds-modal_large .slds-modal__container,.slds-modal--large .slds-modal__container{\n    width:90%;\n    max-width:none;\n    min-width:40rem;\n  }\n}\n@media (min-width: 48em){\n  .slds-modal_full .slds-modal__container,.slds-modal--full .slds-modal__container{\n    width:90%;\n    max-width:none;\n    min-width:40rem;\n  }\n}\n@media (max-width: 30em){\n  .slds-modal_full,.slds-modal--full{\n    inset-block-start:env(safe-area-inset-top, 0);\n    inset-block-end:auto;\n    height:calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom));\n  }\n\n  .slds-modal_full .slds-modal__header,.slds-modal--full .slds-modal__header{\n    grid-area:header;\n    border-start-start-radius:0;\n    border-start-end-radius:0;\n  }\n\n  .slds-modal_full .slds-modal__container,.slds-modal--full .slds-modal__container{\n    width:100%;\n    max-width:none;\n    min-width:0;\n    margin:0;\n    padding-block-start:var(--slds-g-spacing-4);\n    padding-inline-end:0;\n    padding-block-end:0;\n    padding-inline-start:0;\n    background-color:var(\n      --slds-c-modal-header-color-background,\n      var(--slds-c-modal-color-background, var(--slds-g-color-surface-container-1))\n    );\n    border-radius:0;\n    display:grid;\n    height:100dvh;\n    grid-template-rows:min-content min-content 1fr min-content;\n    grid-template-areas:'close' 'header' 'content' 'footer';\n    grid-template-columns:1fr;\n  }\n\n  .slds-modal_full .slds-modal__content_footless,.slds-modal--full .slds-modal__content--footless,\n  .slds-modal_full .slds-modal__container > .slds-modal__content:last-child,\n  .slds-modal--full .slds-modal__container > .slds-modal__content:last-child,\n  .slds-modal_full .slds-modal__content_has-hidden-footer,\n  .slds-modal--full .slds-modal__content--has-hidden-footer{\n    border-end-end-radius:0;\n    border-end-start-radius:0;\n    box-shadow:none;\n  }\n\n  .slds-modal_full .slds-modal__close,.slds-modal--full .slds-modal__close{\n    grid-area:close;\n    inset-inline-end:var(--slds-g-spacing-4);\n    color:var(--slds-g-color-on-surface-1);\n\n    --slds-c-button-color-background:var(--slds-g-color-surface-1);\n    --slds-c-button-color-background-active:var(--slds-g-color-surface-1);\n  }\n\n  .slds-modal_full .slds-modal__close:hover,.slds-modal--full .slds-modal__close:hover,\n  .slds-modal_full .slds-modal__close:focus,\n  .slds-modal--full .slds-modal__close:focus{\n    color:var(--slds-g-color-on-surface-1);\n  }\n\n  .slds-modal_full .slds-modal__content,.slds-modal--full .slds-modal__content{\n    grid-area:content;\n  }\n\n  .slds-modal_full .slds-modal__footer,.slds-modal--full .slds-modal__footer{\n    grid-area:footer;\n    border-end-end-radius:0;\n    border-end-start-radius:0;\n    box-shadow:none;\n  }\n}\n.slds-modal_full lightning-button-icon + div,.slds-modal--full lightning-button-icon + div,\n.slds-modal_full lightning-modal,\n.slds-modal--full lightning-modal,\n.slds-modal_full lightning-modal-header,\n.slds-modal--full lightning-modal-header,\n.slds-modal_full lightning-modal-body,\n.slds-modal--full lightning-modal-body,\n.slds-modal_full lightning-modal-footer,\n.slds-modal--full lightning-modal-footer{\n  display:contents;\n}\n.slds-backdrop{\n  transition-duration:0.4s;\n  width:100%;\n  height:100%;\n  opacity:0;\n  visibility:hidden;\n  position:fixed;\n  inset-block-start:0;\n  inset-inline-end:0;\n  inset-block-end:0;\n  inset-inline-start:0;\n  background:var(--slds-s-backdrop-color-background);\n  z-index:9000;\n  backdrop-filter:blur(5px);\n}\n.slds-backdrop_open,.slds-backdrop--open{\n  visibility:visible;\n  opacity:1;\n  transition:opacity 0.4s linear;\n}\n.slds-fade-in-open{\n  opacity:1;\n  visibility:visible;\n  transition:opacity 0.1s linear;\n}\n.slds-fade-in-open .slds-modal__container-reset{\n  opacity:1;\n  visibility:visible;\n  transform:translate(0, 0);\n}\n.slds-slide-up-open{\n  opacity:1;\n  visibility:visible;\n  transform:translate(0, 0);\n  transition:opacity 0.1s linear, transform 0.2s linear;\n}\n.slds-slide-up-open .slds-modal__container-reset{\n  opacity:0;\n  visibility:hidden;\n  transform:translate(0, 1rem);\n  transition:opacity 0.2s linear, transform 0.2s linear;\n}\n.slds-slide-up-saving{\n  opacity:1;\n  visibility:visible;\n  transform:translate(0, -1rem);\n}\n.slds-slide-down-cancel{\n  opacity:1;\n  visibility:visible;\n  transform:translate(0, 1rem);\n}\n.slds-modal__header_empty,.slds-modal__header--empty{\n  --slds-c-modal-header-spacing-blockstart:0;\n  --slds-c-modal-header-spacing-blockend:0;\n  --slds-c-modal-header-spacing-inlinestart:0;\n  --slds-c-modal-header-spacing-inlineend:0;\n  --slds-c-modal-sizing-border:0;\n}\n.slds-modal_prompt .slds-modal__header,.slds-modal--prompt .slds-modal__header{\n  border-block-end:0;\n  text-align:var(--slds-s-container-heading-font-align, center);\n  font-size:var(--slds-s-container-heading-font-size);\n  font-weight:var(--slds-s-container-heading-font-weight);\n}\n.slds-modal_prompt .slds-modal__content,.slds-modal--prompt .slds-modal__content{\n  padding-inline-start:var(--slds-g-spacing-6);\n  padding-inline-end:var(--slds-g-spacing-6);\n}\n.slds-modal_prompt .slds-modal__footer,.slds-modal--prompt .slds-modal__footer{\n  border-block-start-width:var(--slds-s-container-footer-sizing-border, 0);\n  text-align:var(--slds-s-container-footer-font-align, center);\n}\n.slds-input{\n  display:inline-block;\n  padding-block-start:0;\n  padding-inline-end:var(--slds-c-input-spacing-inlineend, var(--slds-s-input-spacing));\n  padding-block-end:0;\n  padding-inline-start:var(--slds-c-input-spacing-inlinestart, var(--slds-s-input-spacing));\n  width:100%;\n  line-height:1.875rem;\n  border:1px solid var(--slds-c-input-color-border, var(--slds-s-input-color-border));\n  border-radius:var(--slds-c-input-radius-border, var(--slds-s-input-radius-border));\n  background-color:var(--slds-c-input-color-background, var(--slds-g-color-surface-container-1));\n  color:var(--slds-c-input-text-color, var(--slds-s-input-color, var(--slds-g-color-on-surface-3)));\n  box-shadow:var(--slds-c-input-shadow);\n}\n.slds-input:focus{\n  --slds-c-input-color-border:var(\n    --slds-c-input-color-border-focus,\n    var(--slds-s-input-color-border-focus)\n  );\n  --slds-c-input-background-color:var(--slds-c-input-color-background-focus, revert);\n  --slds-c-input-text-color:var(--slds-c-input-text-color-focus, revert);\n\n  outline:0;\n}\n.slds-input:focus-visible{\n  --slds-c-input-shadow:var(--slds-c-input-shadow-focus, var(--slds-s-input-shadow-focus));\n\n  outline:0;\n}\n.slds-input:focus:valid{\n  background-color:revert;\n  color:revert;\n}\n.slds-input[disabled],\n.slds-input.slds-is-disabled{\n  background-color:var(--slds-s-input-color-background-disabled, var(--slds-g-color-disabled-container-1));\n  border-color:var(--slds-s-input-color-border-disabled, var(--slds-g-color-border-disabled-1));\n  color:var(--slds-s-input-color-disabled, var(--slds-g-color-on-disabled-2));\n  cursor:not-allowed;\n  user-select:none;\n}\n.slds-input[disabled]:focus,\n.slds-input[disabled]:active,\n.slds-input.slds-is-disabled:focus,\n.slds-input.slds-is-disabled:active{\n  box-shadow:none;\n}\n.slds-input[readonly]{\n  --slds-c-input-spacing-inlinestart:0;\n  --slds-c-input-color-border:transparent;\n  --slds-c-input-color-background:transparent;\n  --slds-c-input-shadow:none;\n}\n.slds-input[type='search']::-ms-clear{\n  display:none;\n  width:0;\n  height:0;\n}\n.slds-input[type='search']::-webkit-search-decoration,\n.slds-input[type='search']::-webkit-search-cancel-button,\n.slds-input[type='search']::-webkit-search-results-button,\n.slds-input[type='search']::-webkit-search-results-decoration{\n  display:none;\n}\n.slds-input[type='url'],\n.slds-input[type='tel'],\n.slds-input[type='email']{\n  direction:ltr;\n  text-align:left;\n}\n.slds-input_bare,.slds-input--bare{\n  --slds-c-input-color-background:transparent;\n  --slds-c-input-spacing-inlineend:0;\n  --slds-c-input-spacing-inlinestart:var(--slds-s-input-spacing);\n\n  border:0;\n}\n.slds-input_bare:focus,.slds-input--bare:focus,\n.slds-input_bare:active,\n.slds-input--bare:active{\n  --slds-c-input-shadow-focus:none;\n}\n.slds-input_height,.slds-input--height{\n  min-height:calc(1.875rem + 2px);\n}\n.slds-input_faux,.slds-input--faux{\n  padding-block-start:0;\n  padding-inline-end:var(--slds-c-input-spacing-inlineend, var(--slds-s-input-spacing));\n  padding-block-end:0;\n  padding-inline-start:var(--slds-c-input-spacing-inlinestart, var(--slds-s-input-spacing));\n  width:100%;\n  line-height:1.875rem;\n  border:1px solid var(--slds-c-input-color-border, var(--slds-s-input-color-border));\n  border-radius:var(--slds-c-input-radius-border, var(--slds-s-input-radius-border));\n  background-color:var(--slds-c-input-color-background, var(--slds-g-color-surface-container-1));\n  color:var(--slds-c-input-text-color, var(--slds-s-input-color, var(--slds-g-color-on-surface-3)));\n  box-shadow:var(--slds-c-input-shadow);\n  display:inline-flex;\n  flex:1 1 auto;\n  text-align:left;\n}\n.slds-input_faux.slds-is-disabled,.slds-input--faux.slds-is-disabled{\n  background-color:var(--slds-s-input-color-background-disabled, var(--slds-g-color-disabled-container-1));\n  border-color:var(--slds-s-input-color-border-disabled, var(--slds-g-color-border-disabled-1));\n  color:var(--slds-s-input-color-disabled, var(--slds-g-color-on-disabled-2));\n  cursor:not-allowed;\n  user-select:none;\n}\n.slds-input_faux.slds-is-disabled:focus,.slds-input--faux.slds-is-disabled:focus,\n.slds-input_faux.slds-is-disabled:active,\n.slds-input--faux.slds-is-disabled:active{\n  box-shadow:none;\n}\n.slds-input_faux > span::before,.slds-input--faux > span::before{\n  content:'';\n  display:inline-block;\n}\n.slds-input_borders[readonly],.slds-input--borders[readonly]{\n  --slds-c-input-spacing-inlinestart:var(--slds-s-input-spacing);\n  --slds-c-input-color-border:var(--slds-s-input-color-border);\n}\n.slds-input-has-icon{\n  position:relative;\n}\n.slds-input-has-icon .slds-input__icon{\n  width:0.875rem;\n  height:0.875rem;\n  position:absolute;\n  top:50%;\n  margin-top:calc((0.875rem * 0.5) * -1);\n  line-height:1;\n  border:0;\n  z-index:2;\n}\n.slds-input-has-icon_left .slds-input__icon,.slds-input-has-icon--left .slds-input__icon{\n  left:var(--slds-g-spacing-2);\n}\n.slds-input-has-icon_left .slds-input,.slds-input-has-icon--left .slds-input,\n.slds-input-has-icon_left .slds-input_faux,\n.slds-input-has-icon--left .slds-input--faux,\n.slds-input-has-icon_left .slds-input_bare,\n.slds-input-has-icon--left .slds-input--bare{\n  --slds-c-input-spacing-inlinestart:var(--slds-g-spacing-6);\n}\n.slds-input-has-icon_right .slds-input__icon,.slds-input-has-icon--right .slds-input__icon{\n  inset-inline-end:var(--slds-g-spacing-2);\n}\n.slds-input-has-icon_right .slds-input,.slds-input-has-icon--right .slds-input,\n.slds-input-has-icon_right .slds-input_faux,\n.slds-input-has-icon--right .slds-input--faux,\n.slds-input-has-icon_right .slds-input_bare,\n.slds-input-has-icon--right .slds-input--bare{\n  --slds-c-input-spacing-inlineend:var(--slds-g-spacing-6);\n}\n.slds-input-has-icon_left-right .slds-input__icon_left,.slds-input-has-icon--left-right .slds-input__icon--left{\n  left:var(--slds-g-spacing-2);\n}\n.slds-input-has-icon_left-right .slds-input__icon_right,.slds-input-has-icon--left-right .slds-input__icon--right{\n  inset-inline-end:var(--slds-g-spacing-2);\n}\n.slds-input-has-icon_left-right .slds-input,.slds-input-has-icon--left-right .slds-input,\n.slds-input-has-icon_left-right .slds-input_faux,\n.slds-input-has-icon--left-right .slds-input--faux,\n.slds-input-has-icon_left-right .slds-input_bare,\n.slds-input-has-icon--left-right .slds-input--bare{\n  --slds-c-input-spacing-inlinestart:var(--slds-g-spacing-6);\n  --slds-c-input-spacing-inlineend:var(--slds-g-spacing-6);\n}\n.slds-input-has-icon_group-right .slds-input,.slds-input-has-icon--group-right .slds-input,\n.slds-input-has-icon_group-right .slds-input_faux,\n.slds-input-has-icon--group-right .slds-input--faux,\n.slds-input-has-icon_group-right .slds-input_bare,\n.slds-input-has-icon--group-right .slds-input--bare{\n  --slds-c-input-spacing-inlineend:calc(var(--slds-g-spacing-6) + var(--slds-g-spacing-2));\n}\n.slds-input__icon-group{\n  position:absolute;\n  margin-top:calc((var(--slds-g-spacing-4) * var(--slds-g-spacing-2)) * -1);\n}\n.slds-input__icon-group_right,.slds-input__icon-group--right{\n  inset-inline-end:0;\n  inset-block-start:50%;\n}\n.slds-input__icon-group_right .slds-input__icon_right,.slds-input__icon-group--right .slds-input__icon--right{\n  inset-inline-end:var(--slds-g-spacing-2);\n}\n.slds-input__icon-group_right .slds-input__spinner,.slds-input__icon-group--right .slds-input__spinner{\n  inset-inline-end:var(--slds-g-spacing-5);\n  inset-inline-start:auto;\n}\n.slds-input-has-fixed-addon{\n  display:flex;\n}\n.slds-has-error .slds-input{\n  --slds-c-input-color-background:var(--slds-s-input-color-background-invalid);\n  --slds-c-input-color-border:var(--slds-g-color-border-error-1);\n  --slds-c-input-text-color:var(--slds-s-input-color-invalid);\n\n  background-clip:padding-box;\n}\n.slds-has-error .slds-input__icon{\n  fill:var(--slds-g-color-error-1);\n  color:var(--slds-g-color-error-1);\n}\n.slds-textarea{\n  min-height:var(--slds-c-textarea-sizing-height-min);\n  width:100%;\n  padding-block-start:var(--slds-c-textarea-spacing-blockstart, var(--slds-g-spacing-2));\n  padding-inline-end:var(--slds-c-textarea-spacing-inlineend, var(--slds-g-spacing-3));\n  padding-block-end:var(--slds-c-textarea-spacing-blockend, var(--slds-g-spacing-2));\n  padding-inline-start:var(--slds-c-textarea-spacing-inlinestart, var(--slds-g-spacing-3));\n  background-color:var(--slds-c-textarea-color-background, var(--slds-g-color-surface-container-1));\n  color:var(--slds-c-textarea-text-color, var(--slds-s-input-color, var(--slds-g-color-on-surface-3)));\n  border:1px solid var(--slds-c-textarea-color-border, var(--slds-s-input-color-border));\n  border-radius:var(--slds-c-textarea-radius-border, var(--slds-s-input-radius-border));\n  box-shadow:var(--slds-c-textarea-shadow, var(--slds-s-input-shadow));\n  font:inherit;\n  resize:vertical;\n  transition:border 0.1s linear, background-color 0.1s linear;\n}\n.slds-textarea:required{\n  --slds-c-textarea-shadow:none;\n}\n.slds-textarea:focus,\n.slds-textarea:active{\n  outline:0;\n  --slds-c-textarea-color-border:var(--slds-s-input-color-border-focus);\n  --slds-c-textarea-text-color:var(--slds-c-textarea-text-color-focus, revert);\n\n  background-color:var(--slds-c-textarea-color-background-focus, var(--slds-g-color-surface-container-1));\n}\n.slds-textarea:focus-visible{\n  --slds-c-textarea-shadow:var(--slds-c-textarea-shadow-focus, var(--slds-s-input-shadow-focus));\n\n  outline:0;\n}\n.slds-textarea:focus:invalid{\n  background-color:var(--slds-s-input-color-background-invalid);\n  color:var(--slds-s-input-color-invalid);\n  border-color:var(--slds-g-color-border-error-1);\n}\n.slds-textarea:focus:valid{\n  background-color:revert;\n  color:revert;\n}\n.slds-textarea[disabled],\n.slds-textarea.slds-is-disabled{\n  background-color:var(--slds-s-input-color-background-disabled, var(--slds-g-color-disabled-container-1));\n  border-color:var(--slds-s-input-color-border-disabled, var(--slds-g-color-border-disabled-1));\n  color:var(--slds-s-input-color-disabled, var(--slds-g-color-on-disabled-2));\n  cursor:not-allowed;\n  user-select:none;\n}\n.slds-textarea[disabled]:focus,\n.slds-textarea[disabled]:active,\n.slds-textarea.slds-is-disabled:focus,\n.slds-textarea.slds-is-disabled:active{\n  box-shadow:none;\n}\n.slds-has-error .slds-textarea{\n  --slds-c-textarea-color-border:var(--slds-g-color-border-error-1);\n  --slds-c-textarea-color-background:var(--slds-s-input-color-background-invalid);\n\n  background-clip:padding-box;\n}\n.slds-has-error .slds-textarea:focus,\n.slds-has-error .slds-textarea:active{\n  --slds-c-textarea-text-color-focus:var(--slds-c-textarea-text-color-error-focus);\n\n  --slds-c-textarea-color-background-focus:var(\n    --slds-c-textarea-color-background-error-focus,\n    var(--slds-g-color-surface-container-1)\n  );\n}\n.slds-checkbox_toggle,.slds-checkbox--toggle{\n  width:100%;\n}\n.slds-checkbox_toggle .slds-checkbox_faux,.slds-checkbox--toggle .slds-checkbox--faux{\n  display:block;\n  position:relative;\n  width:var(--slds-g-sizing-10);\n  height:var(--slds-g-sizing-7);\n  border-width:var(--slds-g-sizing-border-1);\n  border-style:solid;\n  border-color:var(--slds-c-checkbox-toggle-color-border, var(--slds-g-color-neutral-base-60));\n  padding:var(--slds-g-spacing-1);\n  background-color:var(--slds-c-checkbox-toggle-color-background, var(--slds-g-color-neutral-base-60));\n  border-radius:var(--slds-c-checkbox-toggle-radius-border, var(--slds-g-radius-border-pill));\n  box-shadow:var(--slds-c-checkbox-toggle-shadow, var(--slds-s-mark-shadow-checked));\n  transition:background-color 0.2s cubic-bezier(0.75, 0, 0.08, 1);\n}\n.slds-checkbox_toggle .slds-checkbox_faux:hover,.slds-checkbox--toggle .slds-checkbox--faux:hover,\n.slds-checkbox_toggle .slds-checkbox_faux:focus,\n.slds-checkbox--toggle .slds-checkbox--faux:focus{\n  --slds-c-checkbox-toggle-color-background:var(\n    --slds-c-checkbox-toggle-color-background-hover,\n    var(--slds-g-color-neutral-base-50)\n  );\n  --slds-c-checkbox-toggle-color-border:var(--slds-c-checkbox-toggle-color-border-hover);\n\n  cursor:pointer;\n}\n.slds-checkbox_toggle .slds-checkbox_faux::after,.slds-checkbox--toggle .slds-checkbox--faux::after{\n  content:'';\n  position:absolute;\n  top:1px;\n  left:1px;\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n  background-color:var(\n    --slds-c-checkbox-toggle-switch-color-background,\n    var(--slds-g-color-on-accent-1)\n  );\n  border-radius:var(--slds-c-checkbox-toggle-radius-border, var(--slds-g-radius-border-pill));\n}\n.slds-checkbox_toggle [type='checkbox'],.slds-checkbox--toggle [type='checkbox']{\n  width:1px;\n  height:1px;\n  border:0;\n  clip:rect(0 0 0 0);\n  margin:-1px;\n  overflow:hidden;\n  padding:0;\n  position:absolute;\n}\n.slds-checkbox_toggle [type='checkbox'] + .slds-checkbox_faux_container,.slds-checkbox--toggle [type='checkbox'] + .slds-checkbox--faux_container{\n  font-size:var(--slds-g-font-scale-neg-2);\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-checkbox_toggle [type='checkbox'] + .slds-checkbox_faux_container .slds-checkbox_off,.slds-checkbox--toggle [type='checkbox'] + .slds-checkbox--faux_container .slds-checkbox--off{\n  display:block;\n}\n.slds-checkbox_toggle [type='checkbox'] + .slds-checkbox_faux_container .slds-checkbox_on,.slds-checkbox--toggle [type='checkbox'] + .slds-checkbox--faux_container .slds-checkbox--on{\n  display:none;\n}\n.slds-checkbox_toggle [type='checkbox']:focus-visible + .slds-checkbox_faux,.slds-checkbox--toggle [type='checkbox']:focus-visible + .slds-checkbox--faux,\n.slds-checkbox_toggle [type='checkbox']:focus-visible ~ .slds-checkbox_faux,\n.slds-checkbox--toggle [type='checkbox']:focus-visible ~ .slds-checkbox--faux,\n.slds-checkbox_toggle [type='checkbox']:focus-visible + .slds-checkbox_faux_container .slds-checkbox_faux,\n.slds-checkbox--toggle [type='checkbox']:focus-visible + .slds-checkbox--faux_container .slds-checkbox--faux{\n  --slds-c-checkbox-toggle-color-background:var(--slds-g-color-neutral-base-50);\n  --slds-c-checkbox-toggle-shadow:var(--slds-s-mark-shadow-focus);\n}\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_off,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--off{\n  display:none;\n}\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_on,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--on{\n  display:block;\n}\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux,\n.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux,\n.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux,\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux,\n.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux{\n  --slds-c-checkbox-toggle-color-border:var(--slds-g-color-border-accent-1);\n  --slds-c-checkbox-toggle-color-background:var(--slds-g-color-accent-container-1);\n}\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux:hover,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux:hover,\n.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux:hover,\n.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux:hover,\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux:hover,\n.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux:hover,\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux:focus,\n.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux:focus,\n.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux:focus,\n.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux:focus,\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux:focus,\n.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux:focus{\n  --slds-c-checkbox-toggle-color-background:var(--slds-g-color-accent-container-2);\n}\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux::before,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux::before,\n.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux::before,\n.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux::before,\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux::before,\n.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux::before{\n  content:'';\n  position:absolute;\n  top:1px;\n  right:1px;\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n  background-color:var(\n    --slds-c-checkbox-toggle-switch-color-background-checked,\n    var(--slds-c-checkbox-toggle-switch-color-background, var(--slds-g-color-on-accent-1))\n  );\n  border-radius:var(--slds-c-checkbox-toggle-radius-border, var(--slds-g-radius-border-pill));\n  transition:transform 0.2s cubic-bezier(0.75, 0, 0.08, 1);\n}\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux::after,.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux::after,\n.slds-checkbox_toggle [type='checkbox']:checked ~ .slds-checkbox_faux::after,\n.slds-checkbox--toggle [type='checkbox']:checked ~ .slds-checkbox--faux::after,\n.slds-checkbox_toggle [type='checkbox']:checked + .slds-checkbox_faux_container .slds-checkbox_faux::after,\n.slds-checkbox--toggle [type='checkbox']:checked + .slds-checkbox--faux_container .slds-checkbox--faux::after{\n  --slds-c-checkbox-toggle-switch-color-background:transparent;\n  --slds-c-checkbox-toggle-radius-border:0;\n\n  content:' ';\n  position:absolute;\n  top:0.25rem;\n  left:0.6rem;\n  height:0.7rem;\n  width:0.45rem;\n  border-bottom-width:var(--slds-g-sizing-border-2);\n  border-bottom-style:solid;\n  border-bottom-color:var(\n    --slds-c-checkbox-toggle-mark-color-foreground,\n    var(--slds-g-color-surface-container-1)\n  );\n  /*! @noflip */\n  border-right-width:var(--slds-g-sizing-border-2);\n  border-right-style:solid;\n  border-right-color:var(\n    --slds-c-checkbox-toggle-mark-color-foreground,\n    var(--slds-g-color-surface-container-1)\n  );\n  transform:rotate(45deg);\n}\n.slds-checkbox_toggle [type='checkbox']:checked:focus + .slds-checkbox_faux,.slds-checkbox--toggle [type='checkbox']:checked:focus + .slds-checkbox--faux,\n.slds-checkbox_toggle [type='checkbox']:checked:focus ~ .slds-checkbox_faux,\n.slds-checkbox--toggle [type='checkbox']:checked:focus ~ .slds-checkbox--faux,\n.slds-checkbox_toggle [type='checkbox']:checked:focus + .slds-checkbox_faux_container .slds-checkbox_faux,\n.slds-checkbox--toggle [type='checkbox']:checked:focus + .slds-checkbox--faux_container .slds-checkbox--faux{\n  --slds-c-checkbox-toggle-color-background:var(\n    --slds-c-checkbox-toggle-color-background-checked-focus,\n    var(--slds-g-color-accent-container-2)\n  );\n}\n.slds-checkbox_toggle [type='checkbox'][disabled] + .slds-checkbox_faux,.slds-checkbox--toggle [type='checkbox'][disabled] + .slds-checkbox--faux,\n.slds-checkbox_toggle [type='checkbox'][disabled] ~ .slds-checkbox_faux,\n.slds-checkbox--toggle [type='checkbox'][disabled] ~ .slds-checkbox--faux,\n.slds-checkbox_toggle [type='checkbox'][disabled] + .slds-checkbox_faux_container .slds-checkbox_faux,\n.slds-checkbox--toggle [type='checkbox'][disabled] + .slds-checkbox--faux_container .slds-checkbox--faux{\n  background-color:var(--slds-g-color-disabled-container-2);\n  border-color:var(--slds-g-color-border-disabled-1);\n  pointer-events:none;\n}\n.slds-checkbox_toggle [type='checkbox'][disabled] + .slds-checkbox_faux_container .slds-checkbox_faux::before,.slds-checkbox--toggle [type='checkbox'][disabled] + .slds-checkbox--faux_container .slds-checkbox--faux::before{\n  background-color:var(--slds-g-color-on-disabled-2);\n}\n.slds-checkbox_toggle [type='checkbox'][disabled] + .slds-checkbox_faux_container .slds-checkbox_faux::after,.slds-checkbox--toggle [type='checkbox'][disabled] + .slds-checkbox--faux_container .slds-checkbox--faux::after{\n  background-color:var(--slds-g-color-on-disabled-2);\n}\n.slds-checkbox_toggle [type='checkbox']:checked[disabled] + .slds-checkbox_faux_container .slds-checkbox_faux::after,.slds-checkbox--toggle [type='checkbox']:checked[disabled] + .slds-checkbox--faux_container .slds-checkbox--faux::after{\n  background-color:transparent;\n  border-color:var(--slds-g-color-on-disabled-2);\n}\n.slds-checkbox_add-button .slds-checkbox_faux,.slds-checkbox--add-button .slds-checkbox--faux{\n  width:var(--slds-g-spacing-6);\n  height:var(--slds-g-spacing-6);\n  position:relative;\n  display:inline-block;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  background-color:var(--slds-g-color-surface-container-1);\n  cursor:pointer;\n}\n.slds-checkbox_add-button .slds-checkbox_faux::before,.slds-checkbox--add-button .slds-checkbox--faux::before,\n.slds-checkbox_add-button .slds-checkbox_faux::after,\n.slds-checkbox--add-button .slds-checkbox--faux::after{\n  content:'';\n  position:absolute;\n  top:0;\n  left:0;\n  right:0;\n  bottom:0;\n  height:14px;\n  width:2px;\n  margin:auto;\n  background-color:var(--slds-s-button-color, var(--slds-g-color-accent-3));\n}\n.slds-checkbox_add-button .slds-checkbox_faux::after,.slds-checkbox--add-button .slds-checkbox--faux::after{\n  width:14px;\n  height:2px;\n}\n.slds-checkbox_add-button .slds-checkbox_faux:hover:not([disabled]),.slds-checkbox--add-button .slds-checkbox--faux:hover:not([disabled]),\n.slds-checkbox_add-button .slds-checkbox_faux:focus:not([disabled]),\n.slds-checkbox--add-button .slds-checkbox--faux:focus:not([disabled]),\n.slds-checkbox_add-button .slds-checkbox_faux:active:not([disabled]),\n.slds-checkbox--add-button .slds-checkbox--faux:active:not([disabled]){\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-checkbox_add-button .slds-checkbox_faux:active:not([disabled]),.slds-checkbox--add-button .slds-checkbox--faux:active:not([disabled]){\n  box-shadow:var(--slds-s-button-shadow-active);\n}\n.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux,.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux,\n.slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux,\n.slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux{\n  border-color:transparent;\n  background-color:var(--slds-g-color-accent-container-1);\n  box-shadow:var(--slds-s-mark-shadow-checked);\n}\n.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux::before,.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux::before,\n.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux::after,\n.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux::after,\n.slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux::before,\n.slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux::before,\n.slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux::after,\n.slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux::after{\n  background-color:var(--slds-g-color-on-accent-1);\n}\n.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux::before,.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux::before, .slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux::before, .slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux::before{\n  left:5px;\n  width:2px;\n  height:16px;\n  transform:rotate(40deg);\n}\n.slds-checkbox_add-button [type='checkbox']:checked ~ .slds-checkbox_faux::after,.slds-checkbox--add-button [type='checkbox']:checked ~ .slds-checkbox--faux::after, .slds-checkbox_add-button [type='checkbox']:checked + .slds-checkbox_faux::after, .slds-checkbox--add-button [type='checkbox']:checked + .slds-checkbox--faux::after{\n  top:5px;\n  left:-10px;\n  width:9px;\n  height:2px;\n  transform:rotate(40deg);\n}\n.slds-checkbox_add-button [type='checkbox']:checked:not([disabled]) ~ .slds-checkbox_faux:hover,.slds-checkbox--add-button [type='checkbox']:checked:not([disabled]) ~ .slds-checkbox--faux:hover,\n.slds-checkbox_add-button [type='checkbox']:checked:not([disabled]) + .slds-checkbox_faux:hover,\n.slds-checkbox--add-button [type='checkbox']:checked:not([disabled]) + .slds-checkbox--faux:hover{\n  background-color:var(--slds-g-color-accent-container-2);\n}\n.slds-checkbox_add-button [type='checkbox']:focus-visible ~ .slds-checkbox_faux,.slds-checkbox--add-button [type='checkbox']:focus-visible ~ .slds-checkbox--faux,\n.slds-checkbox_add-button [type='checkbox']:focus-visible + .slds-checkbox_faux,\n.slds-checkbox--add-button [type='checkbox']:focus-visible + .slds-checkbox--faux{\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-checkbox_add-button [type='checkbox'][disabled] ~ .slds-checkbox_faux,.slds-checkbox--add-button [type='checkbox'][disabled] ~ .slds-checkbox--faux,\n.slds-checkbox_add-button [type='checkbox'][disabled] + .slds-checkbox_faux,\n.slds-checkbox--add-button [type='checkbox'][disabled] + .slds-checkbox--faux{\n  background-color:var(--slds-g-color-disabled-container-1);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-1);\n  cursor:default;\n}\n.slds-checkbox_add-button [type='checkbox'][disabled] ~ .slds-checkbox_faux::before,.slds-checkbox--add-button [type='checkbox'][disabled] ~ .slds-checkbox--faux::before,\n.slds-checkbox_add-button [type='checkbox'][disabled] + .slds-checkbox_faux::before,\n.slds-checkbox--add-button [type='checkbox'][disabled] + .slds-checkbox--faux::before,\n.slds-checkbox_add-button [type='checkbox'][disabled] ~ .slds-checkbox_faux::after,\n.slds-checkbox--add-button [type='checkbox'][disabled] ~ .slds-checkbox--faux::after,\n.slds-checkbox_add-button [type='checkbox'][disabled] + .slds-checkbox_faux::after,\n.slds-checkbox--add-button [type='checkbox'][disabled] + .slds-checkbox--faux::after{\n  background-color:var(--slds-g-color-on-disabled-1);\n}\n.slds-checkbox_add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux,.slds-checkbox--add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux,\n.slds-checkbox_add-button [type='checkbox'][disabled]:checked + .slds-checkbox_faux,\n.slds-checkbox--add-button [type='checkbox'][disabled]:checked + .slds-checkbox--faux{\n  background-color:var(--slds-g-color-disabled-container-2);\n}\n.slds-checkbox_add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux::before,.slds-checkbox--add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux::before,\n.slds-checkbox_add-button [type='checkbox'][disabled]:checked + .slds-checkbox_faux::before,\n.slds-checkbox--add-button [type='checkbox'][disabled]:checked + .slds-checkbox--faux::before,\n.slds-checkbox_add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux::after,\n.slds-checkbox--add-button [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux::after,\n.slds-checkbox_add-button [type='checkbox'][disabled]:checked + .slds-checkbox_faux::after,\n.slds-checkbox--add-button [type='checkbox'][disabled]:checked + .slds-checkbox--faux::after{\n  background-color:var(--slds-g-color-on-disabled-2);\n}\n.slds-checkbox-button{\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n  display:inline-flex;\n  align-items:center;\n  justify-content:center;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-radius:var(--slds-s-button-radius-border);\n  color:var(--slds-s-button-color);\n  cursor:pointer;\n}\n.slds-checkbox-button .slds-icon{\n  --slds-c-icon-color-foreground:currentColor;\n}\n.slds-checkbox-button_is-checked,.slds-checkbox-button--is-checked{\n  background-color:var(--slds-g-color-accent-container-1);\n  border-color:transparent;\n  color:var(--slds-g-color-on-accent-1);\n  box-shadow:var(--slds-s-mark-shadow-checked);\n}\n.slds-checkbox-button_is-disabled,.slds-checkbox-button--is-disabled{\n  background-color:var(--slds-g-color-disabled-container-1);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-2);\n  cursor:default;\n}\n.slds-checkbox-button_is-disabled.slds-checkbox-button_is-checked,.slds-checkbox-button--is-disabled.slds-checkbox-button--is-checked{\n  background-color:var(--slds-g-color-disabled-container-2);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-2);\n  box-shadow:var(--slds-s-mark-shadow-checked);\n}\n.slds-checkbox-button_is-focused,.slds-checkbox-button--is-focused{\n  outline:0;\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-checkbox_button-group,.slds-checkbox--button-group{\n  display:inline-flex;\n  background-color:var(--slds-g-color-surface-container-1);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n}\n.slds-checkbox_button,.slds-checkbox--button{\n  display:flex;\n  border:0;\n  border-radius:0;\n  background-clip:padding-box;\n  padding-inline:0;\n}\n.slds-checkbox_button .slds-checkbox_faux,.slds-checkbox--button .slds-checkbox--faux{\n  padding-inline:var(--slds-g-spacing-4);\n  text-align:center;\n  vertical-align:middle;\n  position:relative;\n  background-color:var(--slds-g-color-surface-container-1);\n  transition:border 0.1s linear, background-color 0.1s linear;\n}\n.slds-checkbox_button .slds-checkbox_button__label .slds-checkbox_faux,.slds-checkbox--button .slds-checkbox--button__label .slds-checkbox--faux,\n.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_button__label .slds-checkbox_faux,\n.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--button__label .slds-checkbox--faux{\n  background-color:transparent;\n}\n.slds-checkbox_button + .slds-checkbox_button,.slds-checkbox--button + .slds-checkbox--button{\n  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-radius:0;\n  margin:0;\n}\n.slds-checkbox_button:first-child > .slds-checkbox_faux,.slds-checkbox--button:first-child > .slds-checkbox--faux,\n.slds-checkbox_button:first-child > .slds-checkbox_button__label,\n.slds-checkbox--button:first-child > .slds-checkbox--button__label{\n  border-start-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-start-end-radius:0;\n  border-end-end-radius:0;\n  border-end-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n}\n.slds-checkbox_button:last-child > .slds-checkbox_faux,.slds-checkbox--button:last-child > .slds-checkbox--faux,\n.slds-checkbox_button .slds-button_last > .slds-checkbox_faux,\n.slds-checkbox--button .slds-button--last > .slds-checkbox--faux,\n.slds-checkbox_button:last-child > .slds-checkbox_button__label,\n.slds-checkbox--button:last-child > .slds-checkbox--button__label{\n  border-start-start-radius:0;\n  border-start-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-end-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-end-start-radius:0;\n}\n.slds-checkbox_button:first-child:hover,.slds-checkbox--button:first-child:hover{\n  border-start-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-start-end-radius:0;\n  border-end-end-radius:0;\n  border-end-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n}\n.slds-checkbox_button:last-child:hover,.slds-checkbox--button:last-child:hover{\n  border-start-start-radius:0;\n  border-start-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-end-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-end-start-radius:0;\n}\n.slds-checkbox_button [type='checkbox'],.slds-checkbox--button [type='checkbox']{\n  width:1px;\n  height:1px;\n  border:0;\n  clip:rect(0 0 0 0);\n  margin:-1px;\n  overflow:hidden;\n  padding:0;\n  position:absolute;\n}\n.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_faux,.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--faux,\n.slds-checkbox_button [type='checkbox']:checked ~ .slds-checkbox_faux,\n.slds-checkbox--button [type='checkbox']:checked ~ .slds-checkbox--faux,\n.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_button__label,\n.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--button__label{\n  background-color:var(--slds-g-color-accent-container-1);\n  color:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-s-button-shadow-active);\n}\n.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_faux:hover,.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--faux:hover,\n.slds-checkbox_button [type='checkbox']:checked ~ .slds-checkbox_faux:hover,\n.slds-checkbox--button [type='checkbox']:checked ~ .slds-checkbox--faux:hover,\n.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_button__label:hover,\n.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--button__label:hover,\n.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_faux:focus,\n.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--faux:focus,\n.slds-checkbox_button [type='checkbox']:checked ~ .slds-checkbox_faux:focus,\n.slds-checkbox--button [type='checkbox']:checked ~ .slds-checkbox--faux:focus,\n.slds-checkbox_button [type='checkbox']:checked + .slds-checkbox_button__label:focus,\n.slds-checkbox--button [type='checkbox']:checked + .slds-checkbox--button__label:focus{\n  background-color:var(--slds-g-color-accent-container-2);\n}\n.slds-checkbox_button [type='checkbox']:focus-visible + .slds-checkbox_faux,.slds-checkbox--button [type='checkbox']:focus-visible + .slds-checkbox--faux,\n.slds-checkbox_button [type='checkbox']:focus-visible ~ .slds-checkbox_faux,\n.slds-checkbox--button [type='checkbox']:focus-visible ~ .slds-checkbox--faux,\n.slds-checkbox_button [type='checkbox']:focus-visible + .slds-checkbox_button__label,\n.slds-checkbox--button [type='checkbox']:focus-visible + .slds-checkbox--button__label{\n  box-shadow:var(--slds-s-button-shadow-focus);\n  outline:0;\n  z-index:1;\n}\n.slds-checkbox_button [type='checkbox'][disabled] + .slds-checkbox_faux,.slds-checkbox--button [type='checkbox'][disabled] + .slds-checkbox--faux,\n.slds-checkbox_button [type='checkbox'][disabled] ~ .slds-checkbox_faux,\n.slds-checkbox--button [type='checkbox'][disabled] ~ .slds-checkbox--faux,\n.slds-checkbox_button [type='checkbox'][disabled] + .slds-checkbox_button__label,\n.slds-checkbox--button [type='checkbox'][disabled] + .slds-checkbox--button__label{\n  background-color:var(--slds-g-color-disabled-container-1);\n  color:var(--slds-g-color-on-disabled-2);\n}\n.slds-checkbox_button [type='checkbox'][disabled]:checked + .slds-checkbox_faux,.slds-checkbox--button [type='checkbox'][disabled]:checked + .slds-checkbox--faux,\n.slds-checkbox_button [type='checkbox'][disabled]:checked ~ .slds-checkbox_faux,\n.slds-checkbox--button [type='checkbox'][disabled]:checked ~ .slds-checkbox--faux,\n.slds-checkbox_button [type='checkbox'][disabled]:checked + .slds-checkbox_button__label,\n.slds-checkbox--button [type='checkbox'][disabled]:checked + .slds-checkbox--button__label{\n  background-color:var(--slds-g-color-disabled-container-2);\n  color:var(--slds-g-color-on-disabled-1);\n}\n.slds-checkbox_button [type='checkbox'][disabled] + .slds-checkbox_button__label:hover,.slds-checkbox--button [type='checkbox'][disabled] + .slds-checkbox--button__label:hover,\n.slds-checkbox_button [type='checkbox'][disabled] + .slds-checkbox_button__label:focus,\n.slds-checkbox--button [type='checkbox'][disabled] + .slds-checkbox--button__label:focus{\n  cursor:default;\n}\n.slds-checkbox_button__label,.slds-checkbox--button__label{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-checkbox_button__label:hover,.slds-checkbox--button__label:hover,\n.slds-checkbox_button__label:focus,\n.slds-checkbox--button__label:focus{\n  cursor:pointer;\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-drop-zone{\n  position:relative;\n}\n.slds-drop-zone::after{\n  content:'';\n  position:absolute;\n  top:0;\n  left:0;\n  bottom:0;\n  right:0;\n  border:var(--slds-g-sizing-border-1) dotted var(--slds-g-color-border-1);\n  outline:var(--slds-g-sizing-border-1) dotted var(--slds-g-color-surface-container-1);\n}\n.slds-drop-zone.slds-drop-zone_drag::after,.slds-drop-zone.slds-drop-zone--drag::after{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-success-1);\n  outline:0;\n}\n.slds-drop-zone__label{\n  color:var(--slds-g-color-on-accent-1);\n  background:var(--slds-g-color-border-success-1);\n  border-radius:var(--slds-g-radius-border-2) var(--slds-g-radius-border-2) 0 0;\n  padding:var(--slds-g-spacing-1) var(--slds-g-spacing-2);\n  position:absolute;\n  top:0;\n  left:50%;\n  transform:translate(-50%, -100%);\n}\n.slds-drop-zone__label.slds-drop-zone__label_container,.slds-drop-zone__label.slds-drop-zone__label--container{\n  opacity:0;\n  background:var(--slds-g-color-accent-container-1);\n}\n.slds-drop-zone__label .slds-media__body{\n  flex-basis:auto;\n}\n.slds-drop-zone__label_button,.slds-drop-zone__label--button{\n  border-radius:0;\n}\n.slds-drop-zone__label_button:hover,.slds-drop-zone__label--button:hover,\n.slds-drop-zone__label_button:focus,\n.slds-drop-zone__label--button:focus{\n  text-decoration:underline;\n  outline:none;\n}\n.slds-drop-zone_drag__slot,.slds-drop-zone--drag__slot{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-100);\n  border-left-width:var(--slds-g-sizing-border-2);\n  border-right-width:var(--slds-g-sizing-border-2);\n  background:var(--slds-g-color-success-1);\n  width:100%;\n  height:var(--slds-g-sizing-2);\n}\n.slds-drop-zone__container{\n  position:relative;\n  z-index:8000;\n}\n.slds-drop-zone__container::after{\n  content:'';\n  position:absolute;\n  top:0;\n  left:0;\n  bottom:0;\n  right:0;\n}\n.slds-drop-zone__container.slds-is-hovered .slds-drop-zone__label_container,.slds-drop-zone__container.slds-is-hovered .slds-drop-zone__label--container,\n.slds-drop-zone__container.slds-is-hovered .slds-drop-zone__actions,\n.slds-drop-zone__container:hover .slds-drop-zone__label_container,\n.slds-drop-zone__container:hover .slds-drop-zone__label--container,\n.slds-drop-zone__container:hover .slds-drop-zone__actions{\n  opacity:1;\n  z-index:8000;\n}\n.slds-drop-zone__container.slds-is-hovered::after,\n.slds-drop-zone__container:hover::after{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-accent-1);\n}\n.slds-drop-zone__container:active::after{\n  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-surface-inverse-1);\n}\n.slds-drop-zone__container:active .slds-drop-zone__label{\n  background-color:var(--slds-g-color-surface-inverse-1);\n}\n.slds-drop-zone__container:focus-within{\n  outline:none;\n}\n.slds-drop-zone__container:focus-within .slds-drop-zone__label_container,.slds-drop-zone__container:focus-within .slds-drop-zone__label--container,\n.slds-drop-zone__container:focus-within .slds-drop-zone__actions{\n  opacity:1;\n  z-index:8000;\n}\n.slds-drop-zone__container:focus-within::after{\n  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-border-accent-1);\n}\n.slds-drop-zone__container:focus-within .slds-drop-zone__label{\n  background-color:var(--slds-g-color-accent-container-3);\n}\n.slds-drop-zone__actions{\n  opacity:0;\n  background:var(--slds-g-color-accent-container-1);\n  position:absolute;\n  right:0;\n  top:0;\n}\n/*! Lightning Design System 2.23.0-alpha.1 */\n.slds-select{\n  height:calc(1.875rem + (1px * 2));\n  width:100%;\n  border:var(--slds-s-input-sizing-border, var(--slds-g-sizing-border-1)) solid var(--slds-c-select-color-border, var(--slds-s-input-color-border, var(--slds-g-color-border-1)));\n  border-radius:var(\n    --slds-c-select-radius-border,\n    var(--slds-s-input-radius-border, var(--slds-g-radius-border-2))\n  );\n  background-color:var(\n    --slds-c-select-color-background,\n    var(--slds-s-input-color-background, var(--slds-g-color-surface-container-1))\n  );\n  color:var(--slds-c-select-text-color, var(--slds-s-input-color));\n  box-shadow:var(--slds-c-select-shadow, var(--slds-s-input-shadow));\n  transition:border 0.1s linear, background-color 0.1s linear;\n}\n.slds-select:required{\n  box-shadow:none;\n}\n.slds-select:focus-visible{\n  outline:0;\n  border-color:var(--slds-c-select-color-border-focus, var(--slds-g-color-border-2));\n  background-color:var(--slds-c-select-color-background-focus, var(--slds-g-color-surface-container-1));\n  color:var(--slds-s-input-color-focus, var(--slds-c-select-text-color-focus));\n  box-shadow:var(--slds-s-input-shadow-focus);\n}\n.slds-select[disabled],\n.slds-select.slds-is-disabled{\n  background-color:var(--slds-g-color-disabled-container-1);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-on-1);\n  cursor:not-allowed;\n  user-select:none;\n  opacity:1;\n}\n.slds-select[disabled]:focus,\n.slds-select[disabled]:active,\n.slds-select.slds-is-disabled:focus,\n.slds-select.slds-is-disabled:active{\n  box-shadow:none;\n}\n.slds-select[size],\n.slds-select[multiple]{\n  min-height:calc(1.875rem + (1px * 2));\n  height:inherit;\n}\n.slds-select[size] option,\n.slds-select[multiple] option{\n  padding:var(--slds-g-spacing-2);\n}\n.slds-select_container,.slds-select--container{\n  position:relative;\n  color:var(--slds-c-select-text-color, var(--slds-s-input-color));\n}\n.slds-select_container .slds-select,.slds-select--container .slds-select{\n  appearance:none;\n  padding-inline-start:var(--slds-s-input-spacing, var(--slds-g-spacing-2));\n  padding-inline-end:var(--slds-s-input-spacing, var(--slds-g-spacing-5));\n}\n.slds-select_container::before,.slds-select--container::before,\n.slds-select_container::after,\n.slds-select--container::after{\n  position:absolute;\n  content:'';\n  display:block;\n  inset-inline-end:var(--slds-g-spacing-2);\n  width:0;\n  height:0;\n  border-inline-start:var(--slds-g-sizing-border-3) solid transparent;\n  border-inline-end:var(--slds-g-sizing-border-3) solid transparent;\n  pointer-events:none;\n}\n.slds-select_container::before,.slds-select--container::before{\n  border-block-end:5px solid currentColor;\n  inset-block-start:calc((var(--slds-g-sizing-8) / 2) - 6px);\n}\n.slds-select_container::after,.slds-select--container::after{\n  border-block-start:5px solid currentColor;\n  inset-block-end:calc((var(--slds-g-sizing-8) / 2) - 6px);\n}\n.slds-has-error .slds-select{\n  border-color:var(--slds-s-input-color-border-invalid, var(--slds-g-color-error-1));\n  box-shadow:var(--slds-s-input-shadow-invalid, var(--slds-g-color-error-1) 0 0 0 1px inset);\n  background-clip:padding-box;\n  background-color:var(--slds-s-input-color-background-invalid);\n  color:var(--slds-s-input-color-invalid);\n}\n.slds-has-error .slds-select:focus-visible,\n.slds-has-error .slds-select:active{\n  box-shadow:var(--slds-g-color-error-1) 0 0 0 1px inset, 0 0 3px var(--slds-g-color-border-accent-2);\n}\n.slds-has-error .slds-select:focus-visible{\n  box-shadow:var(--slds-s-input-shadow-focus);\n}\n.slds-radio{\n  display:inline-block;\n}\n.slds-radio .slds-radio_faux,.slds-radio .slds-radio--faux{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  display:inline-block;\n  position:relative;\n  flex-shrink:0;\n  vertical-align:middle;\n  border-radius:var(--slds-g-radius-border-circle);\n  border-width:var(--slds-s-input-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(\n    --slds-c-radio-color-border,\n    var(--slds-s-input-color-border, var(--slds-g-color-border-2))\n  );\n  background:none;\n  background-color:var(--slds-c-radio-color-background, var(--slds-g-color-surface-container-1));\n  box-shadow:var(--slds-c-radio-shadow, var(--slds-s-input-shadow));\n  transition:border 0.1s linear, background-color 0.1s linear;\n}\n.slds-radio .slds-form-element__label{\n  display:inline;\n  vertical-align:middle;\n  font-size:var(--slds-s-label-font-size, var(--slds-g-font-scale-neg-2));\n}\n.slds-radio [type='radio']{\n  width:1px;\n  height:1px;\n  border:0;\n  clip:rect(0 0 0 0);\n  margin:-1px;\n  overflow:hidden;\n  padding:0;\n  position:absolute;\n  pointer-events:auto;\n}\n.slds-radio [type='radio']:checked + .slds-radio_faux,.slds-radio [type='radio']:checked + .slds-radio--faux,\n.slds-radio [type='radio']:checked ~ .slds-radio_faux,\n.slds-radio [type='radio']:checked ~ .slds-radio--faux,\n.slds-radio [type='radio']:checked + .slds-radio__label .slds-radio_faux,\n.slds-radio [type='radio']:checked + .slds-radio__label .slds-radio--faux{\n  --slds-c-radio-color-background:var(\n    --slds-c-radio-color-background-checked,\n    var(--slds-s-mark-color-background-checked, var(--slds-g-color-surface-container-1))\n  );\n  --slds-c-radio-shadow:var(--slds-s-mark-shadow-checked);\n}\n.slds-radio [type='radio']:checked + .slds-radio_faux::after,.slds-radio [type='radio']:checked + .slds-radio--faux::after,\n.slds-radio [type='radio']:checked ~ .slds-radio_faux::after,\n.slds-radio [type='radio']:checked ~ .slds-radio--faux::after,\n.slds-radio [type='radio']:checked + .slds-radio__label .slds-radio_faux::after,\n.slds-radio [type='radio']:checked + .slds-radio__label .slds-radio--faux::after{\n  width:var(--slds-g-sizing-3);\n  height:var(--slds-g-sizing-3);\n  content:'';\n  position:absolute;\n  top:50%;\n  /*! @noflip */\n  left:50%;\n  transform:translate3d(-50%, -50%, 0);\n  border-radius:var(--slds-g-radius-border-circle);\n  background:none;\n  background-color:var(\n    --slds-c-radio-color-background-checked,\n    var(--slds-s-mark-color-foreground-checked, var(--slds-g-color-border-accent-2))\n  );\n}\n.slds-radio [type='radio']:focus-visible + .slds-radio_faux,.slds-radio [type='radio']:focus-visible + .slds-radio--faux,\n.slds-radio [type='radio']:focus-visible ~ .slds-radio_faux,\n.slds-radio [type='radio']:focus-visible ~ .slds-radio--faux,\n.slds-radio [type='radio']:focus-visible + .slds-radio__label .slds-radio_faux,\n.slds-radio [type='radio']:focus-visible + .slds-radio__label .slds-radio--faux{\n  border-color:var(\n    --slds-c-radio-color-border-focus,\n    var(--slds-s-input-color-border-focus, var(--slds-g-color-border-accent-1))\n  );\n  --slds-c-radio-shadow:var(\n    --slds-c-radio-shadow-focus,\n    var(--slds-s-mark-shadow-focus, 0 0 3px var(--slds-g-color-accent-2))\n  );\n}\n.slds-radio [type='radio'][disabled]{\n  cursor:not-allowed;\n  user-select:none;\n}\n.slds-radio [type='radio'][disabled] ~ .slds-radio_faux,.slds-radio [type='radio'][disabled] ~ .slds-radio--faux,\n.slds-radio [type='radio'][disabled] + .slds-radio__label .slds-radio_faux,\n.slds-radio [type='radio'][disabled] + .slds-radio__label .slds-radio--faux{\n  border-color:var(--slds-g-color-border-disabled-1);\n  background-color:var(--slds-g-color-disabled-container-2);\n}\n.slds-radio [type='radio'][disabled] ~ .slds-radio_faux::after,.slds-radio [type='radio'][disabled] ~ .slds-radio--faux::after,\n.slds-radio [type='radio'][disabled] + .slds-radio__label .slds-radio_faux::after,\n.slds-radio [type='radio'][disabled] + .slds-radio__label .slds-radio--faux::after{\n  background-color:var(--slds-g-color-on-disabled-2);\n}\n.slds-radio [type='radio'][disabled]:checked + .slds-radio_faux,.slds-radio [type='radio'][disabled]:checked + .slds-radio--faux,\n.slds-radio [type='radio'][disabled]:checked ~ .slds-radio_faux,\n.slds-radio [type='radio'][disabled]:checked ~ .slds-radio--faux,\n.slds-radio [type='radio'][disabled]:checked + .slds-radio__label .slds-radio_faux,\n.slds-radio [type='radio'][disabled]:checked + .slds-radio__label .slds-radio--faux{\n  border-color:var(--slds-g-color-border-disabled-1);\n  background-color:var(--slds-g-color-disabled-container-2);\n}\n.slds-has-error .slds-radio [type='radio'] + .slds-radio_faux,.slds-has-error .slds-radio [type='radio'] + .slds-radio--faux,\n.slds-has-error .slds-radio [type='radio'] ~ .slds-radio_faux,\n.slds-has-error .slds-radio [type='radio'] ~ .slds-radio--faux,\n.slds-has-error .slds-radio [type='radio'] + .slds-radio__label .slds-radio_faux,\n.slds-has-error .slds-radio [type='radio'] + .slds-radio__label .slds-radio--faux{\n  border-color:var(--slds-s-input-color-border-invalid, var(--slds-g-color-border-error-1));\n  border-width:var(--slds-g-sizing-border-2);\n}\n.slds-has-error .slds-radio [type='radio']:checked + .slds-radio_faux,.slds-has-error .slds-radio [type='radio']:checked + .slds-radio--faux,\n.slds-has-error .slds-radio [type='radio']:checked ~ .slds-radio_faux,\n.slds-has-error .slds-radio [type='radio']:checked ~ .slds-radio--faux,\n.slds-has-error .slds-radio [type='radio']:checked + .slds-radio__label .slds-radio_faux,\n.slds-has-error .slds-radio [type='radio']:checked + .slds-radio__label .slds-radio--faux{\n  border-color:var(--slds-s-input-color-border-invalid, var(--slds-g-color-border-error-1));\n  background-color:var(--slds-s-mark-color-background-invalid);\n  --slds-c-radio-shadow:var(--slds-s-mark-shadow-checked);\n}\n.slds-has-error .slds-radio [type='radio']:checked + .slds-radio_faux::after,.slds-has-error .slds-radio [type='radio']:checked + .slds-radio--faux::after,\n.slds-has-error .slds-radio [type='radio']:checked ~ .slds-radio_faux::after,\n.slds-has-error .slds-radio [type='radio']:checked ~ .slds-radio--faux::after,\n.slds-has-error .slds-radio [type='radio']:checked + .slds-radio__label .slds-radio_faux::after,\n.slds-has-error .slds-radio [type='radio']:checked + .slds-radio__label .slds-radio--faux::after{\n  background-color:var(--slds-s-mark-color-foreground-invalid, var(--slds-g-color-error-1));\n}\n.slds-form-element .slds-radio [type='radio'] + .slds-radio_faux,.slds-form-element .slds-radio [type='radio'] + .slds-radio--faux,\n.slds-form-element .slds-radio [type='radio'] ~ .slds-radio_faux,\n.slds-form-element .slds-radio [type='radio'] ~ .slds-radio--faux,\n.slds-radio [type='radio'] + .slds-radio__label .slds-radio_faux,\n.slds-radio [type='radio'] + .slds-radio__label .slds-radio--faux{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n[dir='rtl'] .slds-form-element .slds-radio [type='radio'] + .slds-radio_faux,[dir='rtl'] .slds-form-element .slds-radio [type='radio'] + .slds-radio--faux,\n[dir='rtl'] .slds-form-element .slds-radio [type='radio'] ~ .slds-radio_faux,\n[dir='rtl'] .slds-form-element .slds-radio [type='radio'] ~ .slds-radio--faux,\n[dir='rtl'] .slds-radio [type='radio'] + .slds-radio__label .slds-radio_faux,\n[dir='rtl'] .slds-radio [type='radio'] + .slds-radio__label .slds-radio--faux{\n  /*! @noflip */\n  margin-right:0;\n  margin-left:var(--slds-g-spacing-2);\n}\n.slds-radio_button-group,.slds-radio--button-group{\n  display:inline-flex;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n}\n.slds-radio_button,.slds-radio--button{\n  display:flex;\n  border:0;\n  border-radius:0;\n  background-clip:padding-box;\n  --slds-c-button-spacing-inline:0;\n}\n.slds-radio_button .slds-radio_faux,.slds-radio--button .slds-radio--faux{\n  padding-inline-start:var(--slds-g-spacing-4);\n  padding-inline-end:var(--slds-g-spacing-4);\n  text-align:center;\n  vertical-align:middle;\n}\n.slds-radio_button + .slds-radio_button,.slds-radio--button + .slds-radio--button{\n  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  margin:0;\n}\n.slds-radio_button:first-child:hover,.slds-radio--button:first-child:hover,\n.slds-radio_button:first-child:focus,\n.slds-radio--button:first-child:focus{\n  border-start-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-start-end-radius:0;\n  border-end-end-radius:0;\n  border-end-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n}\n.slds-radio_button:last-child:hover,.slds-radio--button:last-child:hover,\n.slds-radio_button:last-child:focus,\n.slds-radio--button:last-child:focus{\n  border-start-start-radius:0;\n  border-start-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-end-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-end-start-radius:0;\n}\n.slds-radio_button:first-child > .slds-radio_faux,.slds-radio--button:first-child > .slds-radio--faux,\n.slds-radio_button:first-child > .slds-radio_button__label,\n.slds-radio--button:first-child > .slds-radio--button__label{\n  border-start-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-start-end-radius:0;\n  border-end-end-radius:0;\n  border-end-start-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n}\n.slds-radio_button:last-child > .slds-radio_faux,.slds-radio--button:last-child > .slds-radio--faux,\n.slds-radio_button .slds-button_last > .slds-radio_faux,\n.slds-radio--button .slds-button--last > .slds-radio--faux,\n.slds-radio_button:last-child > .slds-radio_button__label,\n.slds-radio--button:last-child > .slds-radio--button__label{\n  border-start-start-radius:0;\n  border-start-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-end-end-radius:var(--slds-s-button-radius-border, var(--slds-g-radius-border-2));\n  border-end-start-radius:0;\n}\n.slds-radio_button [type='radio'],.slds-radio--button [type='radio']{\n  width:var(--slds-g-sizing-border-1);\n  height:var(--slds-g-sizing-border-1);\n  border:0;\n  clip:rect(0 0 0 0);\n  margin:-1px;\n  overflow:hidden;\n  padding:0;\n  position:absolute;\n}\n.slds-radio_button [type='radio']:checked + .slds-radio_faux,.slds-radio--button [type='radio']:checked + .slds-radio--faux,\n.slds-radio_button [type='radio']:checked ~ .slds-radio_faux,\n.slds-radio--button [type='radio']:checked ~ .slds-radio--faux,\n.slds-radio_button [type='radio']:checked + .slds-radio_button__label,\n.slds-radio--button [type='radio']:checked + .slds-radio--button__label{\n  background-color:var(--slds-g-color-accent-container-1);\n  color:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-s-button-shadow-active);\n}\n.slds-radio_button [type='radio']:checked + .slds-radio_faux:hover,.slds-radio--button [type='radio']:checked + .slds-radio--faux:hover,\n.slds-radio_button [type='radio']:checked ~ .slds-radio_faux:hover,\n.slds-radio--button [type='radio']:checked ~ .slds-radio--faux:hover,\n.slds-radio_button [type='radio']:checked + .slds-radio_button__label:hover,\n.slds-radio--button [type='radio']:checked + .slds-radio--button__label:hover,\n.slds-radio_button [type='radio']:checked + .slds-radio_faux:focus,\n.slds-radio--button [type='radio']:checked + .slds-radio--faux:focus,\n.slds-radio_button [type='radio']:checked ~ .slds-radio_faux:focus,\n.slds-radio--button [type='radio']:checked ~ .slds-radio--faux:focus,\n.slds-radio_button [type='radio']:checked + .slds-radio_button__label:focus,\n.slds-radio--button [type='radio']:checked + .slds-radio--button__label:focus{\n  background-color:var(--slds-g-color-accent-container-2);\n}\n.slds-radio_button [type='radio']:focus-visible + .slds-radio_faux,.slds-radio--button [type='radio']:focus-visible + .slds-radio--faux,\n.slds-radio_button [type='radio']:focus-visible ~ .slds-radio_faux,\n.slds-radio--button [type='radio']:focus-visible ~ .slds-radio--faux,\n.slds-radio_button [type='radio']:focus-visible + .slds-radio_button__label,\n.slds-radio--button [type='radio']:focus-visible + .slds-radio--button__label{\n  outline:0;\n  box-shadow:var(--slds-s-button-shadow-focus);\n  z-index:1;\n}\n.slds-radio_button [type='radio'][disabled] + .slds-radio_faux,.slds-radio--button [type='radio'][disabled] + .slds-radio--faux,\n.slds-radio_button [type='radio'][disabled] ~ .slds-radio_faux,\n.slds-radio--button [type='radio'][disabled] ~ .slds-radio--faux,\n.slds-radio_button [type='radio'][disabled] + .slds-radio_button__label,\n.slds-radio--button [type='radio'][disabled] + .slds-radio--button__label{\n  background-color:var(--slds-g-color-disabled-container-1);\n  color:var(--slds-g-color-on-disabled-2);\n}\n.slds-radio_button [type='radio'][disabled]:checked + .slds-radio_faux,.slds-radio--button [type='radio'][disabled]:checked + .slds-radio--faux,\n.slds-radio_button [type='radio'][disabled]:checked ~ .slds-radio_faux,\n.slds-radio--button [type='radio'][disabled]:checked ~ .slds-radio--faux,\n.slds-radio_button [type='radio'][disabled]:checked + .slds-radio_button__label,\n.slds-radio--button [type='radio'][disabled]:checked + .slds-radio--button__label{\n  background-color:var(--slds-g-color-disabled-container-2);\n  color:var(--slds-g-color-on-disabled-2);\n}\n.slds-radio_button [type='radio'][disabled] + .slds-radio_button__label:hover,.slds-radio--button [type='radio'][disabled] + .slds-radio--button__label:hover,\n.slds-radio_button [type='radio'][disabled] + .slds-radio_button__label:focus,\n.slds-radio--button [type='radio'][disabled] + .slds-radio--button__label:focus{\n  cursor:default;\n}\n.slds-radio_button__label,.slds-radio--button__label{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-radio_button__label:hover,.slds-radio--button__label:hover,\n.slds-radio_button__label:focus,\n.slds-radio--button__label:focus{\n  cursor:pointer;\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-file-selector{\n  display:inline-flex;\n}\n.slds-file-selector__dropzone{\n  padding:var(--slds-g-spacing-1);\n  border:var(--slds-g-sizing-border-1) dashed var(--slds-g-color-border-2);\n  border-radius:var(--slds-g-radius-border-2);\n}\n.slds-file-selector__dropzone.slds-has-drag-over{\n  outline:0;\n  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-border-accent-2);\n}\n.slds-file-selector__input:focus-visible ~ .slds-file-selector__body > .slds-file-selector__button{\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-file-selector__input[disabled] ~ .slds-file-selector__body{\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-file-selector__input[disabled] ~ .slds-file-selector__body > .slds-file-selector__button{\n  background:var(--slds-g-color-surface-2);\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-on-disabled-1);\n}\n.slds-file-selector__input[disabled] ~ .slds-file-selector__body > .slds-file-selector__body-icon{\n  fill:currentColor;\n}\n.slds-file-selector__button{\n  display:inline-flex;\n  align-items:center;\n}\n.slds-file-selector__button .slds-icon-text-default{\n  --slds-c-icon-color-foreground:currentColor;\n}\n.slds-file-selector_files .slds-file-selector__body,.slds-file-selector--files .slds-file-selector__body{\n  display:flex;\n  align-items:center;\n}\n.slds-file-selector_files .slds-file-selector__text,.slds-file-selector--files .slds-file-selector__text{\n  margin-inline-start:var(--slds-g-spacing-2);\n  margin-inline-end:var(--slds-g-spacing-3);\n}\n.slds-file-selector_images,.slds-file-selector--images{\n  display:block;\n}\n.slds-file-selector_images .slds-file-selector__dropzone,.slds-file-selector--images .slds-file-selector__dropzone{\n  display:flex;\n  justify-content:center;\n  align-content:center;\n  padding:var(--slds-g-spacing-4);\n}\n.slds-file-selector_images .slds-file-selector__body,.slds-file-selector--images .slds-file-selector__body{\n  text-align:center;\n}\n.slds-file-selector_images .slds-file-selector__text,.slds-file-selector--images .slds-file-selector__text{\n  margin-block-start:var(--slds-g-spacing-3);\n}\n.slds-file-selector_integrated,.slds-file-selector--integrated{\n  width:100%;\n  height:100%;\n  position:relative;\n  display:block;\n}\n.slds-file-selector__dropzone_integrated,.slds-file-selector__dropzone--integrated{\n  display:flex;\n  justify-content:center;\n  align-content:center;\n  position:absolute;\n  top:0;\n  left:0;\n  right:0;\n  bottom:0;\n  border:0;\n  opacity:0;\n  z-index:-1;\n}\n.slds-file-selector__dropzone_integrated.slds-has-drag,.slds-file-selector__dropzone--integrated.slds-has-drag{\n  opacity:1;\n  z-index:8000;\n}\n.slds-file-selector__dropzone_integrated.slds-has-drag ~ p,.slds-file-selector__dropzone--integrated.slds-has-drag ~ p{\n  color:var(--slds-g-color-disabled-1);\n}\n.slds-file-selector__dropzone_integrated.slds-has-drag-over,.slds-file-selector__dropzone--integrated.slds-has-drag-over{\n  background:var(--slds-g-color-brand-base-90, var(--slds-g-color-palette-neutral-95));\n  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-border-accent-2);\n}\n.slds-file-selector__body_integrated,.slds-file-selector__body--integrated{\n  width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));\n  height:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  align-items:center;\n  align-content:center;\n  margin:auto;\n  background:var(--slds-g-color-neutral-base-100);\n  box-shadow:var(--slds-g-shadow-4);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-s-container-color-border);\n  border-radius:var(--slds-g-radius-border-2);\n}\n.slds-file-selector__text_integrated,.slds-file-selector__text--integrated{\n  margin-block-start:var(--slds-g-spacing-3);\n}\n.slds-page-header{\n  --_slds-c-pageheader-spacing-block:var(--lwc-varSpacingVerticalMedium);\n  --_slds-c-pageheader-spacing-inline:var(--lwc-varSpacingHorizontalMedium);\n\n  padding-block-start:var(\n    --_slds-c-pageheader-spacing-blockstart,\n    var(--_slds-c-pageheader-spacing-block, var(--_slds-c-pageheader-spacing, var(--slds-g-spacing-4)))\n  );\n  padding-block-end:var(\n    --_slds-c-pageheader-spacing-blockend,\n    var(--_slds-c-pageheader-spacing-block, var(--_slds-c-pageheader-spacing, var(--slds-g-spacing-4)))\n  );\n  padding-inline-start:var(\n    --_slds-c-pageheader-spacing-inlinestart,\n    var(--_slds-c-pageheader-spacing-inline, var(--_slds-c-pageheader-spacing, var(--slds-g-spacing-4)))\n  );\n  padding-inline-end:var(\n    --_slds-c-pageheader-spacing-inlineend,\n    var(--_slds-c-pageheader-spacing-inline, var(--_slds-c-pageheader-spacing, var(--slds-g-spacing-4)))\n  );\n  border-radius:var(--slds-s-pageheader-radius-border, var(--slds-g-radius-border-2));\n  background:var(--slds-s-pageheader-color-background, var(--slds-g-color-surface-container-2));\n  background-clip:padding-box;\n  box-shadow:var(--slds-s-pageheader-shadow, var(--slds-g-shadow-1));\n  border:var(--slds-s-pageheader-sizing-border, var(--slds-g-sizing-border-1)) solid var(--slds-s-pageheader-color-border, var(--slds-g-color-border-1));\n}\n.slds-page-header .slds-media{\n  align-items:center;\n}\n.slds-page-header__row{\n  display:flex;\n}\n.slds-page-header__row .slds-media{\n  align-items:center;\n}\n.slds-page-header__row_gutters,.slds-page-header__row--gutters{\n  margin-inline-start:calc(var(--slds-g-spacing-4) * -1);\n  margin-inline-end:calc(var(--slds-g-spacing-4) * -1);\n}\n.slds-page-header__col-title{\n  flex:1 1 0%;\n  min-width:0;\n}\n.slds-page-header__icon{\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n}\n.slds-page-header__col-actions{\n  align-self:center;\n  flex:none;\n  vertical-align:top;\n}\n.slds-page-header__col-meta{\n  align-self:center;\n  flex:1 1 auto;\n  vertical-align:middle;\n}\n.slds-page-header__col-controls{\n  flex:none;\n  vertical-align:bottom;\n}\n.slds-page-header__col-details{\n  flex:1 1 auto;\n  padding-inline-start:var(--slds-g-spacing-4);\n  padding-inline-end:var(--slds-g-spacing-4);\n  max-width:100%;\n}\n.slds-page-header__name{\n  display:inline-flex;\n  padding-inline-end:var(--slds-g-spacing-3);\n  max-width:100%;\n}\n.slds-page-header__name h1{\n  line-height:1;\n}\n.slds-page-header__name-title{\n  min-width:0;\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-page-header__name-switcher{\n  align-self:flex-end;\n  margin-inline-start:var(--slds-g-spacing-2);\n  margin-block-end:var(--slds-s-pageheader-action-bottom-spacing);\n}\n.slds-page-header__name-switcher .slds-button__icon{\n  fill:var(--slds-g-color-on-surface-3);\n}\n.slds-page-header__name-meta{\n  max-width:100%;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n  padding-inline-end:var(--slds-g-spacing-3);\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-page-header__meta-text{\n  font-size:var(--slds-g-font-size-base);\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-page-header__title{\n  font-size:var(--slds-s-pageheader-title-font-size, var(--slds-g-font-scale-1));\n  font-weight:var(--slds-s-pageheader-title-font-weight, var(--slds-g-font-weight-7));\n  color:var(--slds-g-color-on-surface-3);\n  line-height:var(--slds-g-font-lineheight-2);\n  display:block;\n}\n.slds-page-header__title .slds-icon{\n  fill:currentColor;\n}\n.slds-page-header__controls{\n  display:flex;\n}\n.slds-page-header__control{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-page-header__detail-row{\n  display:flex;\n  margin-block:var(--_slds-c-pageheader-spacing-block) calc(var(--_slds-c-pageheader-spacing-block) * -1);\n  margin-inline:calc(var(--_slds-c-pageheader-spacing-inline) * -1);\n  padding:var(--_slds-c-pageheader-spacing-inline);\n  border-start-start-radius:0;\n  border-start-end-radius:0;\n  border-end-end-radius:var(--slds-s-pageheader-radius-border);\n  border-end-start-radius:var(--slds-s-pageheader-radius-border);\n  background-color:var(--slds-s-pageheader-row-color-background);\n  position:relative;\n  z-index:2;\n}\n.slds-page-header__detail-block{\n  padding-inline-end:var(--slds-g-spacing-6);\n  padding-inline-start:var(--slds-g-spacing-6);\n  max-width:25%;\n}\n.slds-page-header__detail-block:first-child{\n  padding-inline-start:0;\n}\n.slds-page-header__detail-block:last-child{\n  padding-inline-end:0;\n}\n.slds-page-header_vertical,.slds-page-header--vertical{\n  padding:var(--slds-g-spacing-3);\n  background:var(--slds-g-color-surface-container-1);\n  border-radius:var(--slds-s-container-radius-border, var(--slds-g-radius-border-2));\n  border-block-end:0;\n}\n.slds-page-header_vertical .slds-page-header__controls,.slds-page-header--vertical .slds-page-header__controls{\n  display:flex;\n  gap:var(--slds-g-spacing-2);\n  padding-block-start:var(--slds-g-spacing-2);\n  margin-block-start:var(--slds-g-spacing-2);\n  border-block-start:var(--slds-s-pageheader-sizing-border, var(--slds-g-sizing-border-1)) solid var(--slds-s-pageheader-color-border, var(--slds-g-color-border-1));\n}\n.slds-page-header__detail-list{\n  display:flex;\n  flex-wrap:wrap;\n}\n.slds-page-header__detail-item{\n  margin-block-start:var(--slds-g-spacing-2);\n  width:50%;\n}\n.slds-page-header_joined,.slds-page-header--joined,\n.slds-page-header.slds-has-bottom-magnet{\n  border-radius:var(--slds-s-pageheader-radius-border) var(--slds-s-pageheader-radius-border) 0 0;\n}\n.slds-panel{\n  background:var(--slds-g-color-surface-1);\n  border-radius:var(--slds-g-radius-border-1);\n  overflow-y:auto;\n}\n.slds-panel.slds-is-editing{\n  box-shadow:0 2px 3px 0 rgba(0, 0, 0, 0.16);\n}\n.slds-panel .slds-panel__header-title{\n  text-align:start;\n  width:100%;\n  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2));\n}\n.slds-panel__section{\n  padding:var(--slds-g-spacing-4);\n}\n.slds-panel__actions{\n  padding:var(--slds-g-spacing-3);\n}\n.slds-panel__header{\n  display:flex;\n  position:relative;\n  align-items:center;\n  padding:var(--slds-g-spacing-3);\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-surface-3);\n}\n.slds-panel__header_custom,.slds-panel__header--custom{\n  padding-block:var(--slds-g-spacing-3);\n  padding-inline:var(--slds-g-spacing-4);\n}\n.slds-panel__close:first-child{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-panel__close:last-child{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-panel__back:first-child{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-panel__back:last-child{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-panel__close,\n.slds-panel__back{\n  flex-shrink:0;\n}\n.slds-panel__header_align-center,.slds-panel__header--align-center{\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-8);\n}\n.slds-panel__header_align-center .slds-panel__header-title,.slds-panel__header--align-center .slds-panel__header-title{\n  text-align:center;\n}\n.slds-panel__header_align-center .slds-panel__close,.slds-panel__header--align-center .slds-panel__close{\n  position:absolute;\n  inset-inline-end:var(--slds-g-spacing-3);\n  inset-inline-start:auto;\n  inset-block-start:50%;\n  margin-block-start:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-panel__header_align-center .slds-panel__back,.slds-panel__header--align-center .slds-panel__back{\n  position:absolute;\n  inset-inline-start:var(--slds-g-spacing-3);\n  inset-inline-end:auto;\n  inset-block-start:50%;\n  margin-block-start:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-panel__header-actions{\n  display:flex;\n  align-items:flex-end;\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-panel__header-actions .slds-panel__close{\n  margin-inline-start:0;\n  margin-inline-end:0;\n}\n.slds-panel__body{\n  padding:var(--slds-g-spacing-3);\n  color:var(--slds-s-container-color);\n}\n.slds-panel_docked,.slds-panel--docked{\n  position:relative;\n  min-width:var(--slds-g-sizing-14);\n  height:100%;\n  border-radius:0;\n  display:none;\n}\n.slds-panel_docked.slds-is-open,.slds-panel--docked.slds-is-open{\n  display:block;\n}\n.slds-panel_docked-left,.slds-panel--docked-left{\n  box-shadow:var(--slds-g-shadow-inlineend-3, 1px 0 3px rgba(0, 0, 0, 0.25));\n}\n.slds-panel_docked-right,.slds-panel--docked-right{\n  margin-inline-start:auto;\n  box-shadow:var(--slds-g-shadow-inlinestart-3, -1px 0 3px 0 rgba(0, 0, 0, 0.25));\n}\n.slds-panel_animated,.slds-panel--animated{\n  display:block;\n  position:absolute;\n  top:0;\n  left:0;\n  bottom:0;\n  right:0;\n  transform:translate3d(120%, 0, 0);\n  transition:transform 300ms ease;\n  z-index:9000;\n}\n.slds-tabs-mobile__container .slds-panel_animated,.slds-tabs-mobile__container .slds-panel--animated{\n  position:fixed;\n}\n.slds-panel_animated.slds-is-open,.slds-panel--animated.slds-is-open{\n  transform:translate3d(0, 0, 0);\n}\n.slds-panel_filters,.slds-panel--filters{\n  margin-inline-start:var(--slds-g-spacing-4);\n  box-shadow:var(--slds-g-shadow-1);\n  border-radius:0;\n}\n.slds-publisher{\n  display:flex;\n}\n.slds-publisher.slds-is-active{\n  display:block;\n}\n.slds-publisher.slds-is-active .slds-publisher__toggle-visibility{\n  display:inherit;\n  height:auto;\n  overflow:visible;\n  width:auto;\n}\n.slds-publisher.slds-is-active .slds-publisher__input{\n  line-height:var(--slds-g-font-lineheight-base);\n  height:auto;\n  max-height:10rem;\n  resize:vertical;\n  padding-block-start:var(--slds-g-spacing-3);\n  padding-block-end:var(--slds-g-spacing-3);\n}\n.slds-publisher .slds-publisher__toggle-visibility{\n  display:block;\n  height:0;\n  overflow:hidden;\n  width:0;\n  color:var(--slds-s-label-color, var(--slds-g-color-on-surface-2));\n}\n.slds-publisher__input{\n  line-height:calc(var(--slds-g-sizing-9) - var(--slds-g-sizing-1));\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-4);\n  resize:none;\n  max-height:calc(var(--slds-g-sizing-9) - var(--slds-g-sizing-1) + 2px);\n  width:100%;\n  border-radius:var(--slds-g-radius-border-2);\n  font-family:inherit;\n}\n.slds-publisher__actions > .slds-button{\n  margin-inline-start:var(--slds-g-spacing-3);\n}\n.slds-publisher_comment,.slds-publisher--comment{\n  background-color:var(--slds-g-color-surface-container-1);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-radius:var(--slds-g-radius-border-2);\n  width:100%;\n  position:relative;\n  min-height:calc(var(--slds-g-sizing-9) - var(--slds-g-sizing-1) + 2px);\n  max-height:calc(var(--slds-g-sizing-9) - var(--slds-g-sizing-1) + 2px);\n}\n.slds-publisher_comment.slds-is-active,.slds-publisher--comment.slds-is-active{\n  min-height:calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9));\n  max-height:var(--slds-g-sizing-14);\n}\n.slds-publisher_comment.slds-is-active .slds-publisher__actions,.slds-publisher--comment.slds-is-active .slds-publisher__actions{\n  display:flex;\n}\n.slds-publisher_comment.slds-has-focus,.slds-publisher--comment.slds-has-focus{\n  outline:0;\n  border-color:var(--slds-s-input-color-border, var(--slds-g-color-border-accent-1));\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-publisher_comment.slds-has-focus .slds-publisher__input,.slds-publisher--comment.slds-has-focus .slds-publisher__input{\n  line-height:var(--slds-g-font-lineheight-6);\n  box-shadow:var(--slds-s-input-shadow-focus);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n}\n.slds-publisher_comment .slds-publisher__actions,.slds-publisher--comment .slds-publisher__actions{\n  display:none;\n  padding-block:0 var(--slds-g-spacing-3);\n  padding-inline:var(--slds-g-spacing-3);\n}\n.slds-publisher_comment .slds-attachments,.slds-publisher--comment .slds-attachments{\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n}\n.slds-feed{\n  position:relative;\n  max-width:49rem;\n  margin:auto;\n}\n.slds-feed__list{\n  margin:0;\n  padding:0;\n}\n.slds-feed__item{\n  padding:var(--_slds-g-spacing-var-block-2, var(--slds-g-spacing-2)) 0;\n}\n@media (min-width: 48em){\n  .slds-feed__item{\n    padding:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3)) 0\n  }\n}\n.slds-feed__item-comments{\n  background-color:var(--slds-g-color-surface-container-2);\n  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-bottom:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-feed__item-comments .slds-comment{\n  padding:var(--_slds-g-spacing-var-block-2, var(--slds-g-spacing-2)) var(--slds-g-spacing-4);\n}\n.slds-post{\n  background-color:var(--slds-g-color-surface-container-1);\n  padding:var(--slds-g-spacing-3) var(--slds-g-spacing-4);\n}\n@media (max-width: 48em){\n  .slds-post{\n    border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1)\n  }\n}\n@media (min-width: 64em){\n  .slds-post{\n    padding:0 var(--slds-g-spacing-4) var(--slds-g-spacing-2)\n  }\n}\n.slds-post__header{\n  margin-block-end:var(--_slds-g-spacing-var-block-3, var(--slds-g-spacing-3));\n}\n.slds-post__content{\n  margin-block-end:var(--slds-g-spacing-3);\n}\n@media (min-width: 48em){\n  .slds-post__content{\n    margin-block-end:var(--slds-g-spacing-5)\n  }\n}\n.slds-post__footer{\n  display:flex;\n  font-size:var(--slds-g-font-scale-neg-1);\n  flex-direction:column;\n}\n@media (min-width: 48em){\n  .slds-post__footer{\n    flex-direction:row\n  }\n}\n.slds-post__footer-actions-list{\n  justify-content:space-between;\n  text-align:center;\n  order:1;\n}\n@media (max-width: 30em){\n  .slds-post__footer-actions-list{\n    border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n    margin:0 calc(var(--slds-g-spacing-3) * -1) calc(var(--slds-g-spacing-3) * -1);\n    padding:0 var(--slds-g-spacing-4)\n  }\n}\n@media (min-width: 48em){\n  .slds-post__footer-actions-list{\n    order:0\n  }\n}\n.slds-post__footer-action{\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  color:var(--slds-g-color-on-surface-3);\n  padding:var(--slds-g-spacing-3) 0;\n  line-height:1;\n}\n@media (min-width: 48em){\n  .slds-post__footer-action{\n    margin-inline-end:var(--slds-g-spacing-4);\n    padding:0\n  }\n}\n.slds-post__footer-action .slds-icon{\n  margin-inline-end:var(--slds-g-spacing-1);\n}\n.slds-post__footer-action:hover,\n.slds-post__footer-action:focus,\n.slds-post__footer-action.slds-is-active{\n  color:var(--slds-s-link-color-hover);\n  text-decoration:none;\n}\n.slds-post__footer-action:hover .slds-icon, .slds-post__footer-action:focus .slds-icon, .slds-post__footer-action.slds-is-active .slds-icon{\n  fill:currentColor;\n}\n.slds-post__footer-action:focus-visible{\n  box-shadow:var(--slds-s-button-shadow-focus);\n  border-radius:var(--slds-g-radius-border-1);\n  outline:0;\n}\n.slds-post__footer-meta-list{\n  margin-block-end:var(--slds-g-spacing-4);\n}\n@media (min-width: 48em){\n  .slds-post__footer-meta-list{\n    margin-inline-start:auto;\n    margin-block-end:0\n  }\n}\n.slds-region_narrow .slds-post,.slds-region--narrow .slds-post{\n  border:0;\n  padding:var(--slds-g-spacing-3) var(--slds-g-spacing-4);\n}\n.slds-region_narrow .slds-post__content,.slds-region--narrow .slds-post__content{\n  margin-block-end:var(--slds-g-spacing-3);\n}\n.slds-region_narrow .slds-post__footer,.slds-region--narrow .slds-post__footer{\n  flex-direction:column;\n}\n.slds-region_narrow .slds-post__footer-action,.slds-region--narrow .slds-post__footer-action{\n  padding:var(--slds-g-spacing-3) 0;\n}\n.slds-region_narrow .slds-post__footer-actions-list,.slds-region--narrow .slds-post__footer-actions-list{\n  order:1;\n  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  margin:0 calc(var(--slds-g-spacing-3) * -1) calc(var(--slds-g-spacing-3) * -1);\n  padding:0 var(--slds-g-spacing-4);\n}\n.slds-region_narrow .slds-post__footer-meta-list,.slds-region--narrow .slds-post__footer-meta-list{\n  margin-inline-start:0;\n  margin-block-end:var(--slds-g-spacing-4);\n}\n.slds-comment__content{\n  padding:var(--_slds-g-spacing-var-block-1, var(--slds-g-spacing-1)) 0;\n}\n.slds-post__payload{\n  padding:0 0 var(--slds-g-spacing-4);\n}\n.slds-post__payload:empty{\n  padding:0;\n  border:0;\n}\n.slds-dropdown-trigger{\n  position:relative;\n  display:inline-block;\n}\n.slds-dropdown-trigger .slds-dropdown{\n  inset-block-start:100%;\n}\n.slds-dropdown-trigger .slds-dropdown_bottom,.slds-dropdown-trigger .slds-dropdown--bottom{\n  inset-block-start:auto;\n}\n.slds-dropdown-trigger > [class*='slds-button_icon'] ~ .slds-dropdown_left[class*='slds-nubbin'],.slds-dropdown-trigger > [class*='slds-button--icon'] ~ .slds-dropdown--left[class*='slds-nubbin']{\n  inset-inline-start:calc(var(--slds-g-spacing-2) * -1);\n}\n.slds-dropdown-trigger > [class*='slds-button_icon'] ~ .slds-dropdown_right[class*='slds-nubbin'],.slds-dropdown-trigger > [class*='slds-button--icon'] ~ .slds-dropdown--right[class*='slds-nubbin']{\n  inset-inline-end:calc(var(--slds-g-spacing-2) * -1);\n}\n.slds-dropdown-trigger_hover .slds-dropdown,.slds-dropdown-trigger--hover .slds-dropdown{\n  visibility:hidden;\n  opacity:0;\n  transition:opacity var(0.1s) linear, visibility var(0.1s) linear;\n}\n.slds-dropdown-trigger_hover:hover,.slds-dropdown-trigger--hover:hover,\n.slds-dropdown-trigger_hover:focus,\n.slds-dropdown-trigger--hover:focus{\n  outline:0;\n}\n.slds-dropdown-trigger_hover:hover .slds-dropdown,.slds-dropdown-trigger--hover:hover .slds-dropdown, .slds-dropdown-trigger_hover:focus .slds-dropdown, .slds-dropdown-trigger--hover:focus .slds-dropdown{\n  visibility:visible;\n  opacity:1;\n  transition:opacity var(0.1s) linear, visibility var(0.1s) linear;\n}\n.slds-dropdown-trigger_click .slds-dropdown,.slds-dropdown-trigger--click .slds-dropdown,\n.slds-dropdown-trigger_click:hover .slds-dropdown,\n.slds-dropdown-trigger--click:hover .slds-dropdown{\n  display:none;\n}\n.slds-dropdown-trigger_click.slds-is-open .slds-dropdown,.slds-dropdown-trigger--click.slds-is-open .slds-dropdown{\n  display:block;\n  visibility:visible;\n  opacity:1;\n}\n.slds-dropdown{\n  position:absolute;\n  z-index:7000;\n  left:50%;\n  transform:translateX(-50%);\n  float:inline-start;\n  min-width:calc(var(--slds-g-sizing-5) * 6);\n  max-width:var(--slds-g-sizing-15);\n  margin-block-start:calc(var(--slds-g-spacing-1) / 2);\n  margin-block-end:calc(var(--slds-g-spacing-1)) / 2;\n  border-radius:var(--slds-g-radius-border-2);\n  padding-block:var(--slds-g-spacing-1);\n  padding-inline:0;\n  font-size:var(--slds-g-font-scale-neg-1);\n  background-color:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-g-shadow-2);\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-dropdown mark{\n  font-weight:var(--slds-g-font-weight-7);\n  background-color:transparent;\n  color:inherit;\n}\n.slds-dropdown[class*='slds-nubbin_top'],.slds-dropdown[class*='slds-nubbin--top']{\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-dropdown[class*='slds-nubbin_bottom'],.slds-dropdown[class*='slds-nubbin--bottom']{\n  margin-block-end:var(--slds-g-spacing-2);\n}\n.slds-dropdown_inverse,.slds-dropdown--inverse{\n  background:var(--slds-g-color-surface-inverse-2);\n  border-color:var(--slds-g-color-brand-base-10);\n  color:var(--slds-g-color-surface-container-1);\n}\n.slds-dropdown_inverse .slds-dropdown__item > a,.slds-dropdown--inverse .slds-dropdown__item > a{\n  color:var(--slds-g-color-surface-container-1);\n}\n.slds-dropdown_inverse .slds-dropdown__item > a:hover,.slds-dropdown--inverse .slds-dropdown__item > a:hover,\n.slds-dropdown_inverse .slds-dropdown__item > a:focus,\n.slds-dropdown--inverse .slds-dropdown__item > a:focus{\n  color:var(--slds-g-color-on-surface-inverse-2);\n  background-color:transparent;\n}\n.slds-dropdown_inverse .slds-dropdown__item > a:active,.slds-dropdown--inverse .slds-dropdown__item > a:active{\n  color:var(--slds-g-color-neutral-base-80);\n  background-color:transparent;\n}\n.slds-dropdown_inverse .slds-dropdown__item > a[aria-disabled='true'],.slds-dropdown--inverse .slds-dropdown__item > a[aria-disabled='true']{\n  color:var(--slds-g-color-palette-blue-20);\n  cursor:default;\n}\n.slds-dropdown_inverse .slds-dropdown__item > a[aria-disabled='true']:hover,.slds-dropdown--inverse .slds-dropdown__item > a[aria-disabled='true']:hover{\n  background-color:transparent;\n}\n.slds-dropdown__header{\n  font-size:var(--slds-g-font-scale-neg-1);\n  font-weight:var(--slds-g-font-weight-6);\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n}\n.slds-dropdown__item{\n  line-height:var(--slds-g-font-lineheight-base);\n  font-weight:var(--slds-g-font-weight-4);\n}\n.slds-dropdown__item > a{\n  position:relative;\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n  color:var(--slds-g-color-on-surface-2);\n  white-space:nowrap;\n  cursor:pointer;\n}\n.slds-dropdown__item > a:hover,\n.slds-dropdown__item > a:focus{\n  outline:0;\n  text-decoration:none;\n  background-color:var(\n    --slds-s-menu-item-color-background-active,\n    var(--slds-g-color-surface-container-2)\n  );\n}\n.slds-dropdown__item > a:focus-visible{\n  box-shadow:0 0 0 2px var(--slds-g-color-surface-1) inset, 0 0 0 4px var(--slds-g-color-brand-base-15) inset;\n}\n.slds-dropdown__item > a:active{\n  text-decoration:none;\n  background-color:var(\n    --slds-s-menu-item-color-background-active,\n    var(--slds-g-color-surface-container-2)\n  );\n}\n.slds-dropdown__item > a[aria-disabled='true']{\n  color:var(--slds-g-color-disabled-2);\n  cursor:default;\n}\n.slds-dropdown__item > a[aria-disabled='true']:hover{\n  background-color:transparent;\n}\n.slds-dropdown__item > a[aria-disabled='true'] .slds-icon{\n  fill:var(--slds-g-color-disabled-2);\n}\n.slds-dropdown__item > a.slds-has-error{\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-error-1);\n\n  color:var(--slds-g-color-on-error-1);\n  background:var(--slds-g-color-error-container-1);\n}\n.slds-dropdown__item > a.slds-has-success{\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-success-1);\n\n  color:var(--slds-g-color-on-success-1);\n  background:var(--slds-g-color-success-container-1);\n}\n.slds-dropdown__item > a.slds-has-warning{\n  color:var(--slds-g-color-on-warning-1);\n  background:var(--slds-g-color-warning-container-1);\n}\n.slds-dropdown__item > a.slds-has-warning .slds-indicator_unread,.slds-dropdown__item > a.slds-has-warning .slds-indicator--unread{\n  background-color:currentColor;\n}\n.slds-dropdown__item > a.slds-has-warning .slds-indicator_unsaved,.slds-dropdown__item > a.slds-has-warning .slds-indicator--unsaved{\n  color:currentColor;\n}\n.slds-dropdown__item > a.slds-has-error:hover,\n.slds-dropdown__item > a.slds-has-error:focus,\n.slds-dropdown__item > a.slds-has-success:hover,\n.slds-dropdown__item > a.slds-has-success:focus,\n.slds-dropdown__item > a.slds-has-warning:hover,\n.slds-dropdown__item > a.slds-has-warning:focus{\n  text-decoration:underline;\n}\n.slds-dropdown__item .slds-icon_selected,.slds-dropdown__item .slds-icon--selected{\n  --slds-c-icon-color-foreground:var(--slds-g-color-accent-2);\n\n  opacity:0;\n  transition:opacity 0.05s ease;\n}\n.slds-dropdown__item.slds-is-selected .slds-icon_selected,.slds-dropdown__item.slds-is-selected .slds-icon--selected,\n.slds-dropdown__item.slds-is-selected .slds-icon--selected{\n  opacity:1;\n}\n.slds-dropdown__item.slds-has-notification .slds-indicator_unsaved,.slds-dropdown__item.slds-has-notification .slds-indicator--unsaved{\n  inset-block-start:-0.375rem;\n}\n.slds-dropdown_left,.slds-dropdown--left{\n  inset-inline-start:0;\n  inset-inline-end:auto;\n  transform:translateX(0);\n}\n.slds-dropdown_right,.slds-dropdown--right{\n  inset-inline-start:auto;\n  inset-inline-end:0;\n  transform:translateX(0);\n}\n.slds-dropdown_bottom,.slds-dropdown--bottom{\n  inset-block-end:100%;\n}\n.slds-dropdown_xx-small,.slds-dropdown--xx-small{\n  min-width:calc(var(--slds-g-sizing-5) * 6);\n}\n.slds-dropdown_x-small,.slds-dropdown--x-small{\n  min-width:calc(var(--slds-g-sizing-9) * 6);\n}\n.slds-dropdown_small,.slds-dropdown--small{\n  min-width:var(--slds-g-sizing-14);\n}\n.slds-dropdown_medium,.slds-dropdown--medium{\n  min-width:var(--slds-g-sizing-15);\n}\n.slds-dropdown_large,.slds-dropdown--large{\n  min-width:calc(var(--slds-g-sizing-12) * 5);\n}\n.slds-dropdown_fluid,.slds-dropdown--fluid{\n  min-width:calc(var(--slds-g-sizing-5) * 12);\n  max-width:100%;\n  width:100%;\n}\n.slds-dropdown_length-5,.slds-dropdown--length-5{\n  max-height:calc(\n    (var(--slds-g-sizing-5) * var(--slds-g-font-lineheight-base) + var(--slds-g-spacing-4)) * 5\n  );\n  overflow-y:auto;\n}\n.slds-dropdown_length-7,.slds-dropdown--length-7{\n  max-height:calc(\n    (var(--slds-g-sizing-5) * var(--slds-g-font-lineheight-base) + var(--slds-g-spacing-4)) * 7\n  );\n  overflow-y:auto;\n}\n.slds-dropdown_length-10,.slds-dropdown--length-10{\n  max-height:calc(\n    (var(--slds-g-sizing-5) * var(--slds-g-font-lineheight-base) + var(--slds-g-spacing-4)) * 10\n  );\n  overflow-y:auto;\n}\n.slds-dropdown_length-with-icon-5,.slds-dropdown--length-with-icon-5{\n  max-height:calc((var(--slds-g-sizing-7) + var(--slds-g-spacing-4)) * 5);\n  overflow-y:auto;\n}\n.slds-dropdown_length-with-icon-7,.slds-dropdown--length-with-icon-7{\n  max-height:calc((var(--slds-g-sizing-7) + var(--slds-g-spacing-4)) * 7);\n  overflow-y:auto;\n}\n.slds-dropdown_length-with-icon-10,.slds-dropdown--length-with-icon-10{\n  max-height:calc((var(--slds-g-sizing-7) + var(--slds-g-spacing-4)) * 10);\n  overflow-y:auto;\n}\n[dir='rtl'] .slds-dropdown_center,[dir='rtl'] .slds-dropdown--center{\n  inset-inline-start:auto;\n  inset-inline-end:auto;\n  transform:translateX(calc(50% - (0.875rem / 2)));\n}\n.slds-has-submenu{\n  position:relative;\n}\n.slds-has-submenu .slds-dropdown_submenu,.slds-has-submenu .slds-dropdown--submenu{\n  inset-block-start:0;\n  transform:none;\n}\n.slds-has-submenu .slds-dropdown_submenu-left,.slds-has-submenu .slds-dropdown--submenu-left{\n  inset-inline-start:auto;\n  inset-inline-end:100%;\n  margin-inline-end:var(--slds-g-spacing-1);\n}\n.slds-has-submenu .slds-dropdown_submenu-right,.slds-has-submenu .slds-dropdown--submenu-right{\n  inset-inline-start:100%;\n  margin-inline-start:var(--slds-g-spacing-1);\n}\n.slds-has-submenu .slds-dropdown_submenu-bottom,.slds-has-submenu .slds-dropdown--submenu-bottom{\n  inset-block-start:auto;\n  inset-block-end:0;\n  margin-block-end:calc(var(--slds-g-spacing-1) * -1);\n}\n.slds-has-submenu.slds-dropdown__item .slds-dropdown_submenu,.slds-has-submenu.slds-dropdown__item .slds-dropdown--submenu{\n  display:none;\n}\n.slds-has-submenu [role='menuitem'][aria-expanded='true'] + .slds-dropdown_submenu,.slds-has-submenu [role='menuitem'][aria-expanded='true'] + .slds-dropdown--submenu{\n  display:block;\n}\n.slds-dropdown_actions a,.slds-dropdown--actions a{\n  color:var(--slds-g-color-neutral-base-10);\n}\n.slds-combobox_container,.slds-combobox--container{\n  display:flex;\n  flex-direction:column;\n  position:relative;\n}\n.slds-combobox_container.slds-is-open .slds-dropdown,.slds-combobox--container.slds-is-open .slds-dropdown{\n  display:block;\n}\n.slds-combobox_container.slds-has-selection .slds-combobox__input-value,.slds-combobox--container.slds-has-selection .slds-combobox__input-value,\n.slds-combobox_container.slds-has-selection .slds-combobox__input-value:focus,\n.slds-combobox--container.slds-has-selection .slds-combobox__input-value:focus{\n  box-shadow:0 0 0 2px var(--slds-g-color-surface-container-1) inset, 0 0 0 3px var(--slds-g-color-border-1) inset;\n}\n.slds-combobox_container[invalid],.slds-combobox--container[invalid]{\n  --slds-c-input-color-background:var(--slds-s-input-color-background-invalid);\n  --slds-c-input-text-color:var(--slds-s-input-color-invalid);\n  --slds-c-input-color-border:var(--slds-g-color-border-error-1);\n  --slds-c-input-shadow:var(--slds-s-input-shadow-invalid);\n}\n.slds-combobox_container.slds-has-icon-only .slds-combobox__input,.slds-combobox--container.slds-has-icon-only .slds-combobox__input,\n.slds-combobox_container.slds-has-icon-only .slds-combobox__input:focus,\n.slds-combobox--container.slds-has-icon-only .slds-combobox__input:focus,\n.slds-combobox_container.slds-has-icon-only .slds-combobox__input.slds-has-focus,\n.slds-combobox--container.slds-has-icon-only .slds-combobox__input.slds-has-focus{\n  width:0;\n  pointer-events:auto;\n}\n.slds-combobox_container.slds-has-icon-only .slds-input__icon,.slds-combobox--container.slds-has-icon-only .slds-input__icon{\n  z-index:2;\n  pointer-events:none;\n}\n.slds-combobox{\n  position:static;\n  display:flex;\n  flex-direction:column;\n  flex:1 1 auto;\n}\n.slds-combobox__form-element{\n  flex:1 1 auto;\n}\n[role='combobox'] input[readonly],\ninput[readonly][role='combobox']{\n  padding-inline-start:var(--slds-g-spacing-3);\n  border-color:var(--slds-g-color-border-2);\n  background-color:var(--slds-g-color-surface-container-1);\n  font-size:inherit;\n}\n[role='combobox'] input[readonly]:focus-visible,\n[role='combobox'] input[readonly].slds-has-focus,\ninput[readonly][role='combobox']:focus-visible,\ninput[readonly][role='combobox'].slds-has-focus{\n  border-color:var(--slds-s-input-color-border-focus);\n  box-shadow:var(--slds-s-input-shadow-focus);\n}\n[role='combobox'] input[readonly][disabled], input[readonly][role='combobox'][disabled]{\n  background-color:var(--slds-s-input-color-background-disabled);\n  border-color:var(--slds-s-input-color-border-disabled);\n}\n.slds-listbox_inline,.slds-listbox--inline{\n  display:inline-flex;\n  flex-wrap:wrap;\n  flex-shrink:0;\n  align-items:center;\n  margin-inline-start:0.125rem;\n  margin-inline-end:0.125rem;\n}\n.slds-listbox_inline li,.slds-listbox--inline li{\n  display:flex;\n}\n.slds-listbox_inline li + li,.slds-listbox--inline li + li{\n  padding-inline-start:0.125rem;\n}\n.slds-listbox_horizontal,.slds-listbox--horizontal{\n  display:inline-flex;\n  flex-wrap:wrap;\n  align-items:center;\n}\n.slds-listbox_horizontal li,.slds-listbox--horizontal li{\n  display:flex;\n}\n.slds-listbox_horizontal li + li,.slds-listbox--horizontal li + li{\n  padding-inline-start:0.125rem;\n}\n.slds-listbox__option:hover{\n  cursor:pointer;\n}\n.slds-listbox__option:focus{\n  outline:0;\n}\n.slds-listbox__option .slds-truncate{\n  display:inline-block;\n  vertical-align:middle;\n}\n.slds-listbox__option[aria-disabled='true']{\n  color:var(--slds-g-color-disabled-1);\n}\n.slds-listbox__option-header{\n  font-size:var(--slds-g-font-scale-neg-1);\n  font-weight:var(--slds-g-font-weight-6);\n}\n.slds-listbox__option-icon{\n  width:var(--slds-g-sizing-7);\n  display:inline-flex;\n  align-content:center;\n  align-items:center;\n  justify-content:center;\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-listbox__option[aria-disabled='true'] .slds-listbox__option-icon{\n  color:currentColor;\n}\n.slds-listbox_vertical .slds-listbox__option:focus,.slds-listbox--vertical .slds-listbox__option:focus,\n.slds-listbox_vertical .slds-listbox__option:hover,\n.slds-listbox--vertical .slds-listbox__option:hover,\n.slds-listbox_vertical .slds-listbox__option.slds-has-focus,\n.slds-listbox--vertical .slds-listbox__option.slds-has-focus{\n  background-color:var(\n    --slds-s-menu-item-color-background-active,\n    var(--slds-g-color-surface-container-2)\n  );\n  text-decoration:none;\n}\n.slds-listbox_vertical .slds-listbox__option[aria-disabled='true'],.slds-listbox--vertical .slds-listbox__option[aria-disabled='true'],\n.slds-listbox_vertical .slds-listbox__option[role='presentation']:hover,\n.slds-listbox--vertical .slds-listbox__option[role='presentation']:hover{\n  background-color:transparent;\n  cursor:default;\n}\n.slds-listbox_vertical .slds-listbox__option_entity,.slds-listbox--vertical .slds-listbox__option--entity{\n  padding-block:var(--slds-g-spacing-1);\n  padding-inline:var(--slds-g-spacing-3);\n}\n.slds-listbox_vertical .slds-listbox__option_entity .slds-media__figure,.slds-listbox--vertical .slds-listbox__option--entity .slds-media__figure{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-listbox_vertical .slds-listbox__option_plain,.slds-listbox--vertical .slds-listbox__option--plain{\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n}\n.slds-listbox_vertical .slds-listbox__option_term,.slds-listbox--vertical .slds-listbox__option--term{\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n}\n.slds-listbox_vertical .slds-listbox__option_has-meta .slds-media__figure,.slds-listbox--vertical .slds-listbox__option--has-meta .slds-media__figure{\n  margin-block-start:var(--slds-g-spacing-1);\n}\n.slds-input-has-icon_left .slds-combobox__input[value],.slds-input-has-icon--left .slds-combobox__input[value],\n.slds-input-has-icon_left .slds-combobox__input.slds-combobox__input-value,\n.slds-input-has-icon--left .slds-combobox__input.slds-combobox__input-value,\n.slds-input-has-icon_left-right .slds-combobox__input[value],\n.slds-input-has-icon--left-right .slds-combobox__input[value],\n.slds-input-has-icon_left-right .slds-combobox__input.slds-combobox__input-value,\n.slds-input-has-icon--left-right .slds-combobox__input.slds-combobox__input-value{\n  padding-inline-start:calc(var(--slds-g-sizing-7) + var(--slds-g-spacing-3));\n}\n.slds-combobox__input-entity-icon{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n  position:absolute;\n  top:50%;\n  inset-inline-start:calc(var(--slds-g-spacing-1) + 1px);\n  transform:translateY(-50%);\n  z-index:2;\n}\n.slds-combobox__input-entity-icon .slds-icon{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n}\n.slds-combobox_container__icon,.slds-combobox--container__icon{\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-listbox__icon-selected{\n  opacity:0;\n  fill:var(--slds-g-color-accent-1);\n}\n.slds-listbox__option.slds-is-selected .slds-listbox__icon-selected{\n  opacity:1;\n}\n.slds-listbox__option.slds-is-selected .slds-listbox__option-icon{\n  color:var(--slds-s-menu-item-color-active, var(--slds-g-color-accent-1));\n}\n.slds-listbox__option[aria-checked='true'] .slds-icon{\n  --slds-c-icon-color-foreground:var(--slds-g-color-accent-2);\n}\n.slds-listbox__option-text_entity,.slds-listbox__option-text--entity{\n  max-width:100%;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n  display:block;\n  margin-block-end:0.125rem;\n}\n.slds-listbox__option-meta{\n  display:block;\n  margin-block-start:calc(var(--slds-g-spacing-1) * -1);\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-listbox__option[aria-disabled='true'] .slds-listbox__option-meta{\n  color:currentColor;\n}\n.slds-listbox_object-switcher,.slds-listbox--object-switcher{\n  flex-shrink:0;\n  padding:0.125rem;\n}\n.slds-combobox_object-switcher,.slds-combobox--object-switcher{\n  flex-shrink:0;\n}\n.slds-combobox_object-switcher .slds-combobox__input,.slds-combobox--object-switcher .slds-combobox__input{\n  width:7.5rem;\n  transition:width 80ms linear;\n  font-size:var(--slds-g-font-scale-neg-1);\n  color:var(--slds-s-input-color);\n}\n.slds-combobox_object-switcher .slds-combobox__input:focus,.slds-combobox--object-switcher .slds-combobox__input:focus,\n.slds-combobox_object-switcher .slds-combobox__input.slds-has-focus,\n.slds-combobox--object-switcher .slds-combobox__input.slds-has-focus{\n  width:var(--slds-g-sizing-13);\n}\n.slds-combobox__input:focus-visible,\n.slds-combobox__input.slds-has-focus{\n  border-color:var(--slds-s-input-color-border-focus);\n  box-shadow:var(--slds-s-input-shadow-focus);\n}\n.slds-combobox-group{\n  display:flex;\n  flex-direction:row;\n}\n.slds-combobox-group .slds-combobox_container,.slds-combobox-group .slds-combobox--container{\n  flex:1 1 auto;\n}\n.slds-combobox-group .slds-combobox__input,\n.slds-combobox-group .slds-combobox_object-switcher__button,\n.slds-combobox-group .slds-combobox--object-switcher__button{\n  border-radius:0;\n  margin-inline-start:-1px;\n  margin-inline-end:-1px;\n  position:relative;\n}\n.slds-combobox-group .slds-combobox__input:focus,\n.slds-combobox-group .slds-combobox__input.slds-has-focus,\n.slds-combobox-group .slds-combobox_object-switcher__button:focus,\n.slds-combobox-group .slds-combobox--object-switcher__button:focus,\n.slds-combobox-group .slds-combobox_object-switcher__button.slds-has-focus,\n.slds-combobox-group .slds-combobox--object-switcher__button.slds-has-focus{\n  z-index:1;\n}\n.slds-combobox-group.slds-has-selection .slds-combobox-addon_start .slds-combobox__input,.slds-combobox-group.slds-has-selection .slds-combobox-addon--start .slds-combobox__input{\n  border-end-start-radius:0;\n}\n.slds-combobox-group.slds-has-selection .slds-combobox-addon_end .slds-combobox__input,.slds-combobox-group.slds-has-selection .slds-combobox-addon--end .slds-combobox__input{\n  border-end-end-radius:0;\n}\n.slds-combobox-group.slds-has-selection ~ .slds-listbox_selection-group,.slds-combobox-group.slds-has-selection ~ .slds-listbox--selection-group{\n  display:flex;\n  position:relative;\n  background:var(--slds-g-color-surface-container-1);\n  border:1px solid var(--slds-s-input-color-border, var(--slds-g-color-border-1));\n  border-block-start:0;\n  border-end-start-radius:var(--slds-s-input-radius-border);\n  border-end-end-radius:var(--slds-s-input-radius-border);\n  inset-inline-start:-1px;\n}\n.slds-combobox-group .slds-listbox_horizontal li + li,.slds-combobox-group .slds-listbox--horizontal li + li{\n  padding:0.125rem;\n}\n.slds-listbox_selection-group,.slds-listbox--selection-group{\n  position:relative;\n  padding:0;\n  padding-inline-end:3.75rem;\n  height:1.875rem;\n  overflow:hidden;\n}\n.slds-listbox_selection-group.slds-is-expanded,.slds-listbox--selection-group.slds-is-expanded{\n  height:auto;\n  padding:0;\n}\n.slds-listbox_selection-group .slds-listbox,.slds-listbox--selection-group .slds-listbox{\n  padding-block:0 0.125rem;\n  padding-inline:0;\n}\n.slds-listbox_selection-group .slds-listbox-item,.slds-listbox--selection-group .slds-listbox-item{\n  padding-block:0.125rem 0;\n  padding-inline:0.125rem;\n}\n.slds-listbox_selection-group .slds-listbox-toggle,.slds-listbox--selection-group .slds-listbox-toggle{\n  position:absolute;\n  top:50%;\n  transform:translateY(-50%);\n  inset-inline-end:var(--slds-g-spacing-2);\n}\n.slds-listbox_selection-group .slds-listbox-toggle .slds-button,.slds-listbox--selection-group .slds-listbox-toggle .slds-button{\n  line-height:1;\n}\n.slds-combobox-addon_start .slds-combobox__input,.slds-combobox-addon--start .slds-combobox__input{\n  border-start-end-radius:0;\n  border-end-end-radius:0;\n  border-start-start-radius:var(--slds-s-input-radius-border);\n  border-end-start-radius:var(--slds-s-input-radius-border);\n}\n.slds-combobox-addon_end .slds-combobox__input,.slds-combobox-addon--end .slds-combobox__input{\n  border-start-end-radius:var(--slds-s-input-radius-border);\n  border-end-end-radius:var(--slds-s-input-radius-border);\n  border-start-start-radius:0;\n  border-end-start-radius:0;\n}\n.slds-has-inline-listbox,\n.slds-has-object-switcher{\n  flex-direction:row;\n  background:var(--slds-s-input-color-background);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-s-input-color-border);\n  border-radius:var(--slds-s-input-radius-border);\n}\n.slds-has-inline-listbox .slds-combobox, .slds-has-object-switcher .slds-combobox{\n  flex-basis:50%;\n  flex-shrink:0;\n}\n.slds-has-inline-listbox .slds-combobox__input, .slds-has-object-switcher .slds-combobox__input{\n  min-height:100%;\n  line-height:calc(var(--slds-g-sizing-9) - 4px);\n  border:0;\n  padding-block-start:0.125rem;\n  padding-block-end:0.125rem;\n}\n.slds-has-inline-listbox .slds-combobox__input:focus,\n.slds-has-inline-listbox .slds-combobox__input:active,\n.slds-has-object-switcher .slds-combobox__input:focus,\n.slds-has-object-switcher .slds-combobox__input:active{\n  outline:0;\n  box-shadow:none;\n}\n.slds-has-inline-listbox .slds-listbox_object-switcher ~ .slds-listbox_inline,.slds-has-inline-listbox .slds-listbox--object-switcher ~ .slds-listbox--inline,\n.slds-has-inline-listbox .slds-combobox_container__icon ~ .slds-listbox_inline,\n.slds-has-inline-listbox .slds-combobox--container__icon ~ .slds-listbox--inline,\n.slds-has-object-switcher .slds-listbox_object-switcher ~ .slds-listbox_inline,\n.slds-has-object-switcher .slds-listbox--object-switcher ~ .slds-listbox--inline,\n.slds-has-object-switcher .slds-combobox_container__icon ~ .slds-listbox_inline,\n.slds-has-object-switcher .slds-combobox--container__icon ~ .slds-listbox--inline{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-has-inline-listbox.slds-has-icon_left,.slds-has-inline-listbox.slds-has-icon--left, .slds-has-object-switcher.slds-has-icon_left, .slds-has-object-switcher.slds-has-icon--left{\n  padding-inline-start:calc(var(--slds-g-spacing-6) + var(--slds-g-spacing-1));\n}\n.slds-has-inline-listbox.slds-has-icon_left .slds-combobox_container__icon,.slds-has-inline-listbox.slds-has-icon--left .slds-combobox--container__icon, .slds-has-object-switcher.slds-has-icon_left .slds-combobox_container__icon, .slds-has-object-switcher.slds-has-icon--left .slds-combobox--container__icon{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  position:absolute;\n  inset-inline-start:calc(var(--slds-g-spacing-4) + 0.125rem);\n  inset-block-start:50%;\n  margin-block-start:calc(var(--slds-g-spacing-2) * -1);\n}\n.slds-has-inline-listbox [role='listbox']{\n  display:inline-flex;\n  padding-block:0;\n  padding-inline:0.125rem;\n}\n.slds-has-inline-listbox .slds-combobox__input-value{\n  box-shadow:0 0 0 2px var(--slds-g-color-surface-container-1) inset, 0 0 0 3px var(--slds-g-color-border-1) inset;\n}\n.slds-popover{\n  position:relative;\n  border-radius:var(--slds-g-radius-border-2);\n  width:var(--slds-g-sizing-15);\n  min-height:calc(1rem * 2);\n  z-index:var(--slds-c-popover-position-zindex, 6000);\n  background-color:var(--slds-g-color-surface-container-1);\n  display:inline-block;\n  box-shadow:var(--slds-g-shadow-2);\n  border:1px solid var(--slds-g-color-border-1);\n}\n.slds-popover__meta{\n  margin-block-end:var(--slds-g-spacing-3);\n}\n.slds-popover__body{\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n  color:var(--slds-s-container-color);\n}\n.slds-popover__body .slds-popover__header{\n  padding-block:0 var(--slds-g-spacing-2);\n  padding-inline:0;\n}\n.slds-popover__body,\n.slds-popover__header,\n.slds-popover__footer{\n  position:relative;\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n  word-wrap:break-word;\n}\n.slds-popover__header{\n  border-block-end:0;\n  color:var(--slds-s-container-heading-font-color);\n  font-weight:var(--slds-s-container-heading-font-weight);\n}\n.slds-popover__footer{\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-90);\n  background-color:var(--slds-s-container-footer-color-background, var(--slds-g-color-surface-container-2));\n  border-end-start-radius:inherit;\n  border-end-end-radius:inherit;\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n  color:var(--slds-s-container-footer-font-color);\n}\n.slds-popover__footer_form,.slds-popover__footer--form{\n  text-align:center;\n  background:var(--slds-g-color-surface-container-2);\n  border-start-start-radius:0;\n  border-start-end-radius:0;\n  border-end-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:var(--slds-g-radius-border-2);\n}\n.slds-popover__body_small,.slds-popover__body--small{\n  max-height:var(--slds-g-sizing-14);\n  overflow-y:auto;\n}\n.slds-popover__close{\n  position:relative;\n  margin:var(--slds-g-spacing-1);\n  z-index:6001;\n}\n.slds-popover_small,.slds-popover--small{\n  max-width:var(--slds-g-sizing-14);\n}\n.slds-popover_medium,.slds-popover--medium{\n  min-width:var(--slds-g-sizing-15);\n}\n.slds-popover_large,.slds-popover--large{\n  min-width:calc(var(--slds-g-sizing-15) + var(--slds-g-sizing-12));\n  max-width:512px;\n}\n.slds-popover[class*='theme_'],.slds-popover[class*='theme--']{\n  border:0;\n}\n.slds-popover *:last-child{\n  margin-block-end:0;\n}\n.slds-popover_full-width,.slds-popover--full-width{\n  width:100%;\n}\n.slds-popover_hide,.slds-popover--hide{\n  display:none;\n}\n.slds-popover_dark,.slds-popover--dark{\n  background-color:var(--slds-g-color-surface-inverse-2);\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-popover_dark .slds-badge,.slds-popover--dark .slds-badge{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-popover_dark .slds-popover__close,.slds-popover--dark .slds-popover__close{\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-popover_dark .slds-text-title,.slds-popover--dark .slds-text-title{\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-popover_dark a,.slds-popover--dark a{\n  color:var(--slds-g-color-on-surface-inverse-1);\n  text-decoration:underline;\n}\n.slds-popover_dark a:hover,.slds-popover--dark a:hover{\n  text-decoration:none;\n}\n.slds-popover_dark .slds-icon-text-default,.slds-popover--dark .slds-icon-text-default{\n  fill:var(--slds-g-color-on-accent-1);\n}\n.slds-popover_dark .slds-popover__header,.slds-popover--dark .slds-popover__header{\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-popover_dark .slds-popover__body,.slds-popover--dark .slds-popover__body{\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-popover_dark .slds-popover__footer,.slds-popover--dark .slds-popover__footer{\n  border-block-start-color:var(--slds-g-color-brand-base-10);\n  background-color:var(--slds-g-color-surface-inverse-1);\n}\n.slds-popover_brand .slds-popover__footer,.slds-popover--brand .slds-popover__footer{\n  background-color:transparent;\n  border-color:transparent;\n}\n.slds-popover_brand .slds-popover__icon,.slds-popover--brand .slds-popover__icon{\n  fill:var(--slds-g-color-accent-2);\n}\n.slds-popover_brand .slds-popover__body .slds-icon-text-default,.slds-popover--brand .slds-popover__body .slds-icon-text-default{\n  --slds-c-icon-color-foreground:var(--slds-g-color-accent-2);\n}\n.slds-popover_brand.slds-popover_brand-dark .slds-popover__icon,.slds-popover--brand.slds-popover--brand-dark .slds-popover__icon{\n  fill:var(--slds-g-color-brand-base-10);\n}\n.slds-popover_brand-top,.slds-popover--brand-top{\n  border-block-start-width:0.25rem;\n  border-block-start-color:var(--slds-g-color-border-accent-1);\n}\n.slds-popover_brand-top.slds-nubbin_top::before,.slds-popover--brand-top.slds-nubbin--top::before,\n.slds-popover_brand-top.slds-nubbin_top-left::before,\n.slds-popover--brand-top.slds-nubbin--top-left::before,\n.slds-popover_brand-top.slds-nubbin_top-left-corner::before,\n.slds-popover--brand-top.slds-nubbin--top-left-corner::before,\n.slds-popover_brand-top.slds-nubbin_top-right::before,\n.slds-popover--brand-top.slds-nubbin--top-right::before,\n.slds-popover_brand-top.slds-nubbin_top-right-corner::before,\n.slds-popover--brand-top.slds-nubbin--top-right-corner::before{\n  margin-block-start:-0.1875rem;\n  background:linear-gradient(\n    -45deg,\n    transparent 50%,\n    var(--slds-g-color-accent-container-1) 50%,\n    var(--slds-g-color-accent-container-1)\n  );\n}\n.slds-popover_brand-top.slds-nubbin_top::after,.slds-popover--brand-top.slds-nubbin--top::after,\n.slds-popover_brand-top.slds-nubbin_top-left::after,\n.slds-popover--brand-top.slds-nubbin--top-left::after,\n.slds-popover_brand-top.slds-nubbin_top-left-corner::after,\n.slds-popover--brand-top.slds-nubbin--top-left-corner::after,\n.slds-popover_brand-top.slds-nubbin_top-right::after,\n.slds-popover--brand-top.slds-nubbin--top-right::after,\n.slds-popover_brand-top.slds-nubbin_top-right-corner::after,\n.slds-popover--brand-top.slds-nubbin--top-right-corner::after{\n  margin-block-start:-0.1875rem;\n  background:linear-gradient(-45deg, transparent 50%, transparent 50%, transparent);\n}\n.slds-popover_brand-top.slds-popover_brand-dark,.slds-popover--brand-top.slds-popover--brand-dark{\n  border-block-start-color:var(--slds-g-color-brand-base-10);\n}\n.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top::before,.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top::before,\n.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top-left::before,\n.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top-left::before,\n.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top-left-corner::before,\n.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top-left-corner::before,\n.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top-right::before,\n.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top-right::before,\n.slds-popover_brand-top.slds-popover_brand-dark.slds-nubbin_top-right-corner::before,\n.slds-popover--brand-top.slds-popover--brand-dark.slds-nubbin--top-right-corner::before{\n  margin-block-start:-0.1875rem;\n  background:linear-gradient(\n    -45deg,\n    transparent 50%,\n    var(--slds-g-color-brand-base-10) 50%,\n    var(--slds-g-color-brand-base-10)\n  );\n}\n.slds-popover_brand-left,.slds-popover--brand-left{\n  border-inline-start-width:0.25rem;\n  border-inline-start-color:var(--slds-g-color-border-accent-1);\n}\n.slds-popover_brand-left.slds-nubbin_left::before,.slds-popover--brand-left.slds-nubbin--left::before,\n.slds-popover_brand-left.slds-nubbin_left-top::before,\n.slds-popover--brand-left.slds-nubbin--left-top::before,\n.slds-popover_brand-left.slds-nubbin_left-top-corner::before,\n.slds-popover--brand-left.slds-nubbin--left-top-corner::before,\n.slds-popover_brand-left.slds-nubbin_left-bottom::before,\n.slds-popover--brand-left.slds-nubbin--left-bottom::before,\n.slds-popover_brand-left.slds-nubbin_left-bottom-corner::before,\n.slds-popover--brand-left.slds-nubbin--left-bottom-corner::before{\n  margin-inline-start:-0.1875rem;\n  background:linear-gradient(\n    -135deg,\n    transparent 50%,\n    var(--slds-g-color-accent-container-1) 50%,\n    var(--slds-g-color-accent-container-1)\n  );\n}\n.slds-popover_brand-left.slds-nubbin_left::after,.slds-popover--brand-left.slds-nubbin--left::after,\n.slds-popover_brand-left.slds-nubbin_left-top::after,\n.slds-popover--brand-left.slds-nubbin--left-top::after,\n.slds-popover_brand-left.slds-nubbin_left-top-corner::after,\n.slds-popover--brand-left.slds-nubbin--left-top-corner::after,\n.slds-popover_brand-left.slds-nubbin_left-bottom::after,\n.slds-popover--brand-left.slds-nubbin--left-bottom::after,\n.slds-popover_brand-left.slds-nubbin_left-bottom-corner::after,\n.slds-popover--brand-left.slds-nubbin--left-bottom-corner::after{\n  margin-inline-start:-0.1875rem;\n  background:linear-gradient(-135deg, transparent 50%, transparent 50%, transparent);\n}\n.slds-popover_brand-left.slds-popover_brand-dark,.slds-popover--brand-left.slds-popover--brand-dark{\n  border-inline-start-color:var(--slds-g-color-brand-base-10);\n}\n.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left::before,.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left::before,\n.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left-top::before,\n.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left-top::before,\n.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left-top-corner::before,\n.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left-top-corner::before,\n.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left-bottom::before,\n.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left-bottom::before,\n.slds-popover_brand-left.slds-popover_brand-dark.slds-nubbin_left-bottom-corner::before,\n.slds-popover--brand-left.slds-popover--brand-dark.slds-nubbin--left-bottom-corner::before{\n  margin-inline-start:-0.1875rem;\n  background:linear-gradient(\n    -135deg,\n    transparent 50%,\n    var(--slds-g-color-brand-base-10) 50%,\n    var(--slds-g-color-brand-base-10)\n  );\n}\n.slds-popover_brand-bottom,.slds-popover--brand-bottom{\n  border-block-end-width:0.25rem;\n  border-block-end-color:var(--slds-g-color-border-accent-1);\n}\n.slds-popover_brand-bottom.slds-nubbin_bottom::before,.slds-popover--brand-bottom.slds-nubbin--bottom::before,\n.slds-popover_brand-bottom.slds-nubbin_bottom-left::before,\n.slds-popover--brand-bottom.slds-nubbin--bottom-left::before,\n.slds-popover_brand-bottom.slds-nubbin_bottom-left-corner::before,\n.slds-popover--brand-bottom.slds-nubbin--bottom-left-corner::before,\n.slds-popover_brand-bottom.slds-nubbin_bottom-right::before,\n.slds-popover--brand-bottom.slds-nubbin--bottom-right::before,\n.slds-popover_brand-bottom.slds-nubbin_bottom-right-corner::before,\n.slds-popover--brand-bottom.slds-nubbin--bottom-right-corner::before{\n  margin-block-end:-0.1875rem;\n  background:linear-gradient(\n    135deg,\n    transparent 50%,\n    var(--slds-g-color-accent-container-1) 50%,\n    var(--slds-g-color-accent-container-1)\n  );\n}\n.slds-popover_brand-bottom.slds-nubbin_bottom::after,.slds-popover--brand-bottom.slds-nubbin--bottom::after,\n.slds-popover_brand-bottom.slds-nubbin_bottom-left::after,\n.slds-popover--brand-bottom.slds-nubbin--bottom-left::after,\n.slds-popover_brand-bottom.slds-nubbin_bottom-left-corner::after,\n.slds-popover--brand-bottom.slds-nubbin--bottom-left-corner::after,\n.slds-popover_brand-bottom.slds-nubbin_bottom-right::after,\n.slds-popover--brand-bottom.slds-nubbin--bottom-right::after,\n.slds-popover_brand-bottom.slds-nubbin_bottom-right-corner::after,\n.slds-popover--brand-bottom.slds-nubbin--bottom-right-corner::after{\n  margin-block-end:-0.1875rem;\n  background:linear-gradient(135deg, transparent 50%, transparent 50%, transparent);\n}\n.slds-popover_brand-bottom.slds-popover_brand-dark,.slds-popover--brand-bottom.slds-popover--brand-dark{\n  border-block-end-color:var(--slds-g-color-brand-base-10);\n}\n.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom::before,.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom::before,\n.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom-left::before,\n.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom-left::before,\n.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom-left-corner::before,\n.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom-left-corner::before,\n.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom-right::before,\n.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom-right::before,\n.slds-popover_brand-bottom.slds-popover_brand-dark.slds-nubbin_bottom-right-corner::before,\n.slds-popover--brand-bottom.slds-popover--brand-dark.slds-nubbin--bottom-right-corner::before{\n  margin-block-end:-0.1875rem;\n  background:linear-gradient(\n    135deg,\n    transparent 50%,\n    var(--slds-g-color-brand-base-10) 50%,\n    var(--slds-g-color-brand-base-10)\n  );\n}\n.slds-popover_brand-right,.slds-popover--brand-right{\n  border-inline-end-width:0.25rem;\n  border-inline-end-color:var(--slds-g-color-border-accent-1);\n}\n.slds-popover_brand-right.slds-nubbin_right::before,.slds-popover--brand-right.slds-nubbin--right::before,\n.slds-popover_brand-right.slds-nubbin_right-top::before,\n.slds-popover--brand-right.slds-nubbin--right-top::before,\n.slds-popover_brand-right.slds-nubbin_right-top-corner::before,\n.slds-popover--brand-right.slds-nubbin--right-top-corner::before,\n.slds-popover_brand-right.slds-nubbin_right-bottom::before,\n.slds-popover--brand-right.slds-nubbin--right-bottom::before,\n.slds-popover_brand-right.slds-nubbin_right-bottom-corner::before,\n.slds-popover--brand-right.slds-nubbin--right-bottom-corner::before{\n  margin-inline-end:-0.1875rem;\n  background:linear-gradient(\n    45deg,\n    transparent 50%,\n    var(--slds-g-color-accent-container-1) 50%,\n    var(--slds-g-color-accent-container-1)\n  );\n}\n.slds-popover_brand-right.slds-nubbin_right::after,.slds-popover--brand-right.slds-nubbin--right::after,\n.slds-popover_brand-right.slds-nubbin_right-top::after,\n.slds-popover--brand-right.slds-nubbin--right-top::after,\n.slds-popover_brand-right.slds-nubbin_right-top-corner::after,\n.slds-popover--brand-right.slds-nubbin--right-top-corner::after,\n.slds-popover_brand-right.slds-nubbin_right-bottom::after,\n.slds-popover--brand-right.slds-nubbin--right-bottom::after,\n.slds-popover_brand-right.slds-nubbin_right-bottom-corner::after,\n.slds-popover--brand-right.slds-nubbin--right-bottom-corner::after{\n  margin-inline-end:-0.1875rem;\n  background:linear-gradient(45deg, transparent 50%, transparent 50%, transparent);\n}\n.slds-popover_brand-right.slds-popover_brand-dark,.slds-popover--brand-right.slds-popover--brand-dark{\n  border-inline-end-color:var(--slds-g-color-brand-base-10);\n}\n.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right::before,.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right::before,\n.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right-top::before,\n.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right-top::before,\n.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right-top-corner::before,\n.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right-top-corner::before,\n.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right-bottom::before,\n.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right-bottom::before,\n.slds-popover_brand-right.slds-popover_brand-dark.slds-nubbin_right-bottom-corner::before,\n.slds-popover--brand-right.slds-popover--brand-dark.slds-nubbin--right-bottom-corner::before{\n  margin-inline-end:-0.1875rem;\n  background:linear-gradient(\n    45deg,\n    transparent 50%,\n    var(--slds-g-color-brand-base-10) 50%,\n    var(--slds-g-color-brand-base-10)\n  );\n}\n.slds-popover_panel .slds-popover__header,.slds-popover--panel .slds-popover__header{\n  background:var(--sds-g-color-surface-container-2);\n  padding-block:var(--slds-g-spacing-5) var(--slds-g-spacing-3);\n  padding-inline:var(--slds-g-spacing-5);\n  border-start-start-radius:calc(var(--slds-g-radius-border-2) - 1px);\n  border-start-end-radius:calc(var(--slds-g-radius-border-2) - 1px);\n  border-block-end:0;\n}\n.slds-popover_panel .slds-popover__body,.slds-popover--panel .slds-popover__body{\n  padding:0;\n}\n.slds-popover_panel .slds-popover__body-list,.slds-popover--panel .slds-popover__body-list{\n  padding-block:var(--slds-g-spacing-4);\n  padding-inline:var(--slds-g-spacing-5);\n  border-block-start:1px solid var(--slds-g-color-neutral-base-90);\n}\n.slds-popover_panel.slds-nubbin_left-top::before,.slds-popover--panel.slds-nubbin--left-top::before,\n.slds-popover_panel.slds-nubbin_left-top::after,\n.slds-popover--panel.slds-nubbin--left-top::after,\n.slds-popover_panel.slds-nubbin--left-top::before,\n.slds-popover--panel.slds-nubbin--left-top::before,\n.slds-popover_panel.slds-nubbin--left-top::after,\n.slds-popover--panel.slds-nubbin--left-top::after,\n.slds-popover_panel.slds-nubbin_right-top::before,\n.slds-popover--panel.slds-nubbin--right-top::before,\n.slds-popover_panel.slds-nubbin_right-top::after,\n.slds-popover--panel.slds-nubbin--right-top::after,\n.slds-popover_panel.slds-nubbin--right-top::before,\n.slds-popover--panel.slds-nubbin--right-top::before,\n.slds-popover_panel.slds-nubbin--right-top::after,\n.slds-popover--panel.slds-nubbin--right-top::after,\n.slds-popover_panel.slds-nubbin_top-left::before,\n.slds-popover--panel.slds-nubbin--top-left::before,\n.slds-popover_panel.slds-nubbin_top-left::after,\n.slds-popover--panel.slds-nubbin--top-left::after,\n.slds-popover_panel.slds-nubbin--top-left::before,\n.slds-popover--panel.slds-nubbin--top-left::before,\n.slds-popover_panel.slds-nubbin--top-left::after,\n.slds-popover--panel.slds-nubbin--top-left::after,\n.slds-popover_panel.slds-nubbin_top-right::before,\n.slds-popover--panel.slds-nubbin--top-right::before,\n.slds-popover_panel.slds-nubbin_top-right::after,\n.slds-popover--panel.slds-nubbin--top-right::after,\n.slds-popover_panel.slds-nubbin--top-right::before,\n.slds-popover--panel.slds-nubbin--top-right::before,\n.slds-popover_panel.slds-nubbin--top-right::after,\n.slds-popover--panel.slds-nubbin--top-right::after{\n  background:var(--slds-g-color-surface-container-2);\n}\n.slds-popover_panel.slds-nubbin_left-top::before,.slds-popover--panel.slds-nubbin--left-top::before,\n.slds-popover_panel.slds-nubbin_left-top::after,\n.slds-popover--panel.slds-nubbin--left-top::after,\n.slds-popover_panel.slds-nubbin--left-top::before,\n.slds-popover--panel.slds-nubbin--left-top::before,\n.slds-popover_panel.slds-nubbin--left-top::after,\n.slds-popover--panel.slds-nubbin--left-top::after,\n.slds-popover_panel.slds-nubbin_right-top::before,\n.slds-popover--panel.slds-nubbin--right-top::before,\n.slds-popover_panel.slds-nubbin_right-top::after,\n.slds-popover--panel.slds-nubbin--right-top::after,\n.slds-popover_panel.slds-nubbin--right-top::before,\n.slds-popover--panel.slds-nubbin--right-top::before,\n.slds-popover_panel.slds-nubbin--right-top::after,\n.slds-popover--panel.slds-nubbin--right-top::after{\n  inset-block-start:var(--slds-g-spacing-7);\n}\n.slds-popover_panel__label,.slds-popover--panel__label{\n  font-size:var(--slds-g-font-scale-1);\n  font-weight:var(--slds-g-font-weight-7);\n}\n.slds-nubbin_top::before,.slds-nubbin--top::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-start:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_top::after,.slds-nubbin--top::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-start:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n  box-shadow:-1px -1px 0 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_top-left::before,.slds-nubbin--top-left::before,\n.slds-nubbin_top-left-corner::before,\n.slds-nubbin--top-left-corner::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-start:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_top-left::after,.slds-nubbin--top-left::after,\n.slds-nubbin_top-left-corner::after,\n.slds-nubbin--top-left-corner::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-start:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n  box-shadow:-1px -1px 0 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_top-left::before,.slds-nubbin--top-left::before,\n.slds-nubbin_top-left::after,\n.slds-nubbin--top-left::after,\n.slds-nubbin_top-left-corner::before,\n.slds-nubbin--top-left-corner::before,\n.slds-nubbin_top-left-corner::after,\n.slds-nubbin--top-left-corner::after{\n  inset-inline-start:var(--slds-g-spacing-5);\n  inset-block-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_top-right::before,.slds-nubbin--top-right::before,\n.slds-nubbin_top-right-corner::before,\n.slds-nubbin--top-right-corner::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-start:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_top-right::after,.slds-nubbin--top-right::after,\n.slds-nubbin_top-right-corner::after,\n.slds-nubbin--top-right-corner::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-start:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n  box-shadow:-1px -1px 0 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_top-right::before,.slds-nubbin--top-right::before,\n.slds-nubbin_top-right::after,\n.slds-nubbin--top-right::after,\n.slds-nubbin_top-right-corner::before,\n.slds-nubbin--top-right-corner::before,\n.slds-nubbin_top-right-corner::after,\n.slds-nubbin--top-right-corner::after{\n  inset-inline-start:auto;\n  inset-inline-end:var(--slds-g-spacing-5);\n  inset-block-start:calc((1rem * 0.5) * -1);\n  margin-inline-end:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_bottom::before,.slds-nubbin--bottom::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-end:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_bottom::after,.slds-nubbin--bottom::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-end:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n  box-shadow:2px 2px 4px 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_bottom-left::before,.slds-nubbin--bottom-left::before,\n.slds-nubbin_bottom-left-corner::before,\n.slds-nubbin--bottom-left-corner::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-end:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_bottom-left::after,.slds-nubbin--bottom-left::after,\n.slds-nubbin_bottom-left-corner::after,\n.slds-nubbin--bottom-left-corner::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-end:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n  box-shadow:2px 2px 4px 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_bottom-left::before,.slds-nubbin--bottom-left::before,\n.slds-nubbin_bottom-left::after,\n.slds-nubbin--bottom-left::after,\n.slds-nubbin_bottom-left-corner::before,\n.slds-nubbin--bottom-left-corner::before,\n.slds-nubbin_bottom-left-corner::after,\n.slds-nubbin--bottom-left-corner::after{\n  inset-inline-start:var(--slds-g-spacing-5);\n  inset-block-start:100%;\n  margin-block-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_bottom-right::before,.slds-nubbin--bottom-right::before,\n.slds-nubbin_bottom-right-corner::before,\n.slds-nubbin--bottom-right-corner::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-end:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_bottom-right::after,.slds-nubbin--bottom-right::after,\n.slds-nubbin_bottom-right-corner::after,\n.slds-nubbin--bottom-right-corner::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-inline-start:50%;\n  inset-block-end:calc((1rem * 0.5) * -1);\n  margin-inline-start:calc((1rem * 0.5) * -1);\n  box-shadow:2px 2px 4px 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_bottom-right::before,.slds-nubbin--bottom-right::before,\n.slds-nubbin_bottom-right::after,\n.slds-nubbin--bottom-right::after,\n.slds-nubbin_bottom-right-corner::before,\n.slds-nubbin--bottom-right-corner::before,\n.slds-nubbin_bottom-right-corner::after,\n.slds-nubbin--bottom-right-corner::after{\n  inset-inline-start:auto;\n  inset-inline-end:var(--slds-g-spacing-5);\n  inset-block-start:100%;\n  margin-block-start:calc((1rem * 0.5) * -1);\n  margin-inline-end:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_left::before,.slds-nubbin--left::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-start:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_left::after,.slds-nubbin--left::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-start:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n  box-shadow:-1px 1px 2px 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_left-top::before,.slds-nubbin--left-top::before,\n.slds-nubbin_left-top-corner::before,\n.slds-nubbin--left-top-corner::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-start:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_left-top::after,.slds-nubbin--left-top::after,\n.slds-nubbin_left-top-corner::after,\n.slds-nubbin--left-top-corner::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-start:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n  box-shadow:-1px 1px 2px 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_left-top::before,.slds-nubbin--left-top::before,\n.slds-nubbin_left-top::after,\n.slds-nubbin--left-top::after,\n.slds-nubbin_left-top-corner::before,\n.slds-nubbin--left-top-corner::before,\n.slds-nubbin_left-top-corner::after,\n.slds-nubbin--left-top-corner::after{\n  inset-block-start:var(--slds-g-spacing-5);\n}\n.slds-nubbin_left-bottom::before,.slds-nubbin--left-bottom::before,\n.slds-nubbin_left-bottom-corner::before,\n.slds-nubbin--left-bottom-corner::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-start:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n  margin-block-end:-1px;\n}\n.slds-nubbin_left-bottom::after,.slds-nubbin--left-bottom::after,\n.slds-nubbin_left-bottom-corner::after,\n.slds-nubbin--left-bottom-corner::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-start:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n  box-shadow:-1px 2px 3px 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_left-bottom::before,.slds-nubbin--left-bottom::before,\n.slds-nubbin_left-bottom::after,\n.slds-nubbin--left-bottom::after,\n.slds-nubbin_left-bottom-corner::before,\n.slds-nubbin--left-bottom-corner::before,\n.slds-nubbin_left-bottom-corner::after,\n.slds-nubbin--left-bottom-corner::after{\n  inset-block-start:auto;\n  inset-block-end:var(--slds-g-spacing-4);\n}\n.slds-nubbin_right::before,.slds-nubbin--right::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-end:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_right::after,.slds-nubbin--right::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-end:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n  box-shadow:1px -1px 2px 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_right-top::before,.slds-nubbin--right-top::before,\n.slds-nubbin_right-top-corner::before,\n.slds-nubbin--right-top-corner::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-end:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n}\n.slds-nubbin_right-top::after,.slds-nubbin--right-top::after,\n.slds-nubbin_right-top-corner::after,\n.slds-nubbin--right-top-corner::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-end:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n  box-shadow:1px -1px 2px 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_right-top::before,.slds-nubbin--right-top::before,\n.slds-nubbin_right-top::after,\n.slds-nubbin--right-top::after,\n.slds-nubbin_right-top-corner::before,\n.slds-nubbin--right-top-corner::before,\n.slds-nubbin_right-top-corner::after,\n.slds-nubbin--right-top-corner::after{\n  inset-block-start:var(--slds-g-spacing-5);\n}\n.slds-nubbin_right-bottom::before,.slds-nubbin--right-bottom::before,\n.slds-nubbin_right-bottom-corner::before,\n.slds-nubbin--right-bottom-corner::before{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-end:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n  margin-bottom:-1px;\n}\n.slds-nubbin_right-bottom::after,.slds-nubbin--right-bottom::after,\n.slds-nubbin_right-bottom-corner::after,\n.slds-nubbin--right-bottom-corner::after{\n  width:1rem;\n  height:1rem;\n  position:absolute;\n  transform:rotate(45deg);\n  content:'';\n  background-color:inherit;\n  inset-block-start:50%;\n  inset-inline-end:calc((1rem * 0.5) * -1);\n  margin-block-start:calc((1rem * 0.5) * -1);\n  box-shadow:2px -1px 3px 0 rgba(0, 0, 0, 0.16);\n  z-index:-1;\n}\n.slds-nubbin_right-bottom::before,.slds-nubbin--right-bottom::before,\n.slds-nubbin_right-bottom::after,\n.slds-nubbin--right-bottom::after,\n.slds-nubbin_right-bottom-corner::before,\n.slds-nubbin--right-bottom-corner::before,\n.slds-nubbin_right-bottom-corner::after,\n.slds-nubbin--right-bottom-corner::after{\n  inset-block-start:auto;\n  inset-block-end:1rem;\n}\n.slds-nubbin_top-left-corner,.slds-nubbin--top-left-corner{\n  border-radius:var(--slds-g-radius-border-1) var(--slds-g-radius-border-2) var(--slds-g-radius-border-2);\n}\n.slds-nubbin_top-left-corner::before,.slds-nubbin--top-left-corner::before,\n.slds-nubbin_top-left-corner::after,\n.slds-nubbin--top-left-corner::after{\n  inset-inline-start:var(--slds-g-spacing-3);\n}\n.slds-nubbin_bottom-left-corner,.slds-nubbin--bottom-left-corner{\n  border-start-start-radius:var(--slds-g-radius-border-2);\n  border-start-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:var(--slds-g-radius-border-1);\n  border-end-end-radius:var(--slds-g-radius-border-2);\n}\n.slds-nubbin_bottom-left-corner::before,.slds-nubbin--bottom-left-corner::before,\n.slds-nubbin_bottom-left-corner::after,\n.slds-nubbin--bottom-left-corner::after{\n  inset-inline-start:var(--slds-g-spacing-3);\n}\n.slds-nubbin_top-right-corner,.slds-nubbin--top-right-corner{\n  border-start-start-radius:var(--slds-g-radius-border-2);\n  border-start-end-radius:var(--slds-g-radius-border-1);\n  border-end-start-radius:var(--slds-g-radius-border-2);\n  border-end-end-radius:var(--slds-g-radius-border-2);\n}\n.slds-nubbin_top-right-corner::before,.slds-nubbin--top-right-corner::before,\n.slds-nubbin_top-right-corner::after,\n.slds-nubbin--top-right-corner::after{\n  inset-inline-end:var(--slds-g-spacing-3);\n}\n.slds-nubbin_bottom-right-corner,.slds-nubbin--bottom-right-corner{\n  border-start-start-radius:var(--slds-g-radius-border-2);\n  border-start-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:var(--slds-g-radius-border-2);\n  border-end-end-radius:var(--slds-g-radius-border-1);\n}\n.slds-nubbin_bottom-right-corner::before,.slds-nubbin--bottom-right-corner::before,\n.slds-nubbin_bottom-right-corner::after,\n.slds-nubbin--bottom-right-corner::after{\n  inset-inline-end:var(--slds-g-spacing-3);\n}\n.slds-nubbin_left-top-corner,.slds-nubbin--left-top-corner{\n  border-start-start-radius:var(--slds-g-radius-border-1);\n  border-start-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:var(--slds-g-radius-border-2);\n  border-end-end-radius:var(--slds-g-radius-border-2);\n}\n.slds-nubbin_left-top-corner::before,.slds-nubbin--left-top-corner::before,\n.slds-nubbin_left-top-corner::after,\n.slds-nubbin--left-top-corner::after{\n  inset-block-start:var(--slds-g-spacing-3);\n}\n.slds-nubbin_right-top-corner,.slds-nubbin--right-top-corner{\n  border-start-start-radius:var(--slds-g-radius-border-2);\n  border-start-end-radius:var(--slds-g-radius-border-1);\n  border-end-start-radius:var(--slds-g-radius-border-2);\n  border-end-end-radius:var(--slds-g-radius-border-2);\n}\n.slds-nubbin_right-top-corner::before,.slds-nubbin--right-top-corner::before,\n.slds-nubbin_right-top-corner::after,\n.slds-nubbin--right-top-corner::after{\n  inset-block-start:var(--slds-g-spacing-3);\n}\n.slds-nubbin_left-bottom-corner,.slds-nubbin--left-bottom-corner{\n  border-start-start-radius:var(--slds-g-radius-border-2);\n  border-start-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:var(--slds-g-radius-border-1);\n  border-end-end-radius:var(--slds-g-radius-border-2);\n}\n.slds-nubbin_left-bottom-corner::before,.slds-nubbin--left-bottom-corner::before,\n.slds-nubbin_left-bottom-corner::after,\n.slds-nubbin--left-bottom-corner::after{\n  inset-block-end:var(--slds-g-spacing-1);\n}\n.slds-nubbin_right-bottom-corner,.slds-nubbin--right-bottom-corner{\n  border-start-start-radius:var(--slds-g-radius-border-2);\n  border-start-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:var(--slds-g-radius-border-2);\n  border-end-end-radius:var(--slds-g-radius-border-1);\n}\n.slds-nubbin_right-bottom-corner::before,.slds-nubbin--right-bottom-corner::before,\n.slds-nubbin_right-bottom-corner::after,\n.slds-nubbin--right-bottom-corner::after{\n  inset-block-end:var(--slds-g-spacing-1);\n}\n.slds-popover_error .slds-popover__header,.slds-popover--error .slds-popover__header{\n  background-color:var(--slds-g-color-error-container-1);\n  color:var(--slds-g-color-on-error-1);\n  padding-inline-start:var(--slds-g-spacing-3);\n}\n.slds-popover_error .slds-popover__header .slds-icon,.slds-popover--error .slds-popover__header .slds-icon{\n  fill:currentColor;\n}\n.slds-popover_error .slds-popover__close,.slds-popover--error .slds-popover__close{\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-error-1);\n\n  color:var(--slds-g-color-on-error-1);\n}\n.slds-popover_error .slds-button_icon:hover,.slds-popover--error .slds-button--icon:hover,\n.slds-popover_error .slds-button_icon:focus-visible,\n.slds-popover--error .slds-button--icon:focus-visible{\n  color:var(--slds-s-alert-close-button-hover, color-mix(in oklab, currentColor, transparent 25%));\n}\n.slds-popover_error .slds-popover__footer,.slds-popover--error .slds-popover__footer{\n  background-color:transparent;\n}\n.slds-popover_error .slds-popover__footer .slds-button,.slds-popover--error .slds-popover__footer .slds-button{\n  text-decoration:none;\n}\n.slds-popover_error .slds-popover__footer .slds-button.slds-button_neutral,.slds-popover--error .slds-popover__footer .slds-button.slds-button--neutral{\n  color:var(--slds-g-color-accent-2);\n}\n.slds-popover_error.slds-nubbin_top::before,.slds-popover--error.slds-nubbin--top::before,\n.slds-popover_error.slds-nubbin_top-left::before,\n.slds-popover--error.slds-nubbin--top-left::before,\n.slds-popover_error.slds-nubbin_top-right::before,\n.slds-popover--error.slds-nubbin--top-right::before,\n.slds-popover_error.slds-nubbin_left-top::before,\n.slds-popover--error.slds-nubbin--left-top::before,\n.slds-popover_error.slds-nubbin_right-top::before,\n.slds-popover--error.slds-nubbin--right-top::before{\n  background-color:var(--slds-g-color-error-container-1);\n}\n.slds-popover_error .slds-popover__body,.slds-popover--error .slds-popover__body{\n  padding-inline-start:var(--slds-g-spacing-7);\n}\n.slds-popover_error .slds-popover__header,.slds-popover--error .slds-popover__header,\n.slds-popover_warning .slds-popover__header,\n.slds-popover--warning .slds-popover__header{\n  border-start-start-radius:calc(var(--slds-g-radius-border-2) - 1px);\n  border-start-end-radius:calc(var(--slds-g-radius-border-2) - 1px);\n  border-end-start-radius:0;\n  border-end-end-radius:0;\n}\n.slds-popover_error .slds-popover__body_scrollable,.slds-popover--error .slds-popover__body--scrollable,\n.slds-popover_warning .slds-popover__body_scrollable,\n.slds-popover--warning .slds-popover__body--scrollable{\n  max-height:150px;\n  overflow-y:auto;\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-90);\n}\n.slds-popover_error .slds-popover__body_scrollable + .slds-popover__footer,.slds-popover--error .slds-popover__body--scrollable + .slds-popover__footer,\n.slds-popover_warning .slds-popover__body_scrollable + .slds-popover__footer,\n.slds-popover--warning .slds-popover__body--scrollable + .slds-popover__footer{\n  border-block-start:0;\n}\n.slds-popover_warning button,.slds-popover--warning button{\n  color:var(--slds-g-color-neutral-base-30);\n  text-decoration:underline;\n}\n.slds-popover_warning button:hover,.slds-popover--warning button:hover{\n  color:var(--slds-g-color-neutral-base-50);\n}\n.slds-popover_warning button:focus,.slds-popover--warning button:focus{\n  color:var(--slds-g-color-neutral-base-30);\n  box-shadow:0 0 3px var(--slds-g-color-neutral-base-30);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-30);\n}\n.slds-popover_warning button:active,.slds-popover--warning button:active{\n  color:var(--slds-g-color-neutral-base-50);\n}\n.slds-popover_warning .slds-popover__header,.slds-popover--warning .slds-popover__header{\n  background-color:var(--slds-g-color-warning-container-1);\n  color:var(--slds-g-color-on-warning-1);\n}\n.slds-popover_warning .slds-popover__header .slds-icon,.slds-popover--warning .slds-popover__header .slds-icon{\n  fill:currentColor;\n}\n.slds-popover_warning .slds-button_icon,.slds-popover--warning .slds-button--icon{\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-warning-1);\n\n  color:var(--slds-g-color-on-warning-1);\n}\n.slds-popover_warning .slds-button_icon:hover,.slds-popover--warning .slds-button--icon:hover,\n.slds-popover_warning .slds-button_icon:focus-visible,\n.slds-popover--warning .slds-button--icon:focus-visible{\n  color:var(--slds-s-alert-close-button-hover, color-mix(in oklab, currentColor, transparent 25%));\n}\n.slds-popover_warning.slds-nubbin_top::before,.slds-popover--warning.slds-nubbin--top::before,\n.slds-popover_warning.slds-nubbin_top-left::before,\n.slds-popover--warning.slds-nubbin--top-left::before,\n.slds-popover_warning.slds-nubbin_top-right::before,\n.slds-popover--warning.slds-nubbin--top-right::before,\n.slds-popover_warning.slds-nubbin_left-top::before,\n.slds-popover--warning.slds-nubbin--left-top::before,\n.slds-popover_warning.slds-nubbin_right-top::before,\n.slds-popover--warning.slds-nubbin--right-top::before{\n  background-color:var(--slds-g-color-warning-container-1);\n}\n.slds-popover_warning .slds-popover__body,.slds-popover--warning .slds-popover__body{\n  padding-inline-start:var(--slds-g-spacing-7);\n}\n.slds-popover_warning .slds-popover__footer,.slds-popover--warning .slds-popover__footer{\n  background-color:transparent;\n}\n.slds-popover_warning .slds-popover__footer .slds-button,.slds-popover--warning .slds-popover__footer .slds-button{\n  text-decoration:none;\n}\n.slds-popover_warning .slds-popover__footer .slds-button.slds-button_neutral,.slds-popover--warning .slds-popover__footer .slds-button.slds-button--neutral{\n  color:var(--slds-g-color-accent-2);\n}\n.slds-popover_prompt,.slds-popover--prompt{\n  width:calc(var(--slds-g-sizing-15) + var(--slds-g-sizing-12));\n}\n.slds-popover_prompt .slds-popover__body,.slds-popover--prompt .slds-popover__body{\n  padding:var(--slds-g-spacing-4);\n}\n.slds-popover_prompt .slds-popover__footer,.slds-popover--prompt .slds-popover__footer{\n  border-block-start:inherit;\n}\n.slds-popover_prompt__heading,.slds-popover--prompt__heading{\n  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2));\n  line-height:var(--slds-g-font-lineheight-2);\n  font-weight:var(--_slds-c-popover-prompt-heading-font-weight, var(--slds-g-font-weight-7));\n}\n.slds-popover_prompt__action-link,.slds-popover--prompt__action-link{\n  margin-inline-end:var(--slds-g-spacing-4);\n}\n.slds-popover_prompt_top,.slds-popover--prompt--top,\n.slds-popover_prompt_top-right,\n.slds-popover--prompt--top-right,\n.slds-popover_prompt_top-left,\n.slds-popover--prompt--top-left,\n.slds-popover_prompt_bottom,\n.slds-popover--prompt--bottom,\n.slds-popover_prompt_bottom-right,\n.slds-popover--prompt--bottom-right,\n.slds-popover_prompt_bottom-left,\n.slds-popover--prompt--bottom-left{\n  position:absolute;\n}\n.slds-popover_prompt_top,.slds-popover--prompt--top,\n.slds-popover_prompt_top-right,\n.slds-popover--prompt--top-right,\n.slds-popover_prompt_top-left,\n.slds-popover--prompt--top-left{\n  inset-block-start:var(--slds-g-spacing-2);\n}\n.slds-popover_prompt_bottom,.slds-popover--prompt--bottom,\n.slds-popover_prompt_bottom-right,\n.slds-popover--prompt--bottom-right,\n.slds-popover_prompt_bottom-left,\n.slds-popover--prompt--bottom-left{\n  inset-block-end:var(--slds-g-spacing-2);\n}\n.slds-popover_prompt_top,.slds-popover--prompt--top,\n.slds-popover_prompt_bottom,\n.slds-popover--prompt--bottom{\n  inset-inline-start:50%;\n  margin-inline-start:calc(((var(--slds-g-sizing-15) + var(--slds-g-sizing-12)) * 0.5) * -1);\n}\n.slds-popover_prompt_top-right,.slds-popover--prompt--top-right,\n.slds-popover_prompt_bottom-right,\n.slds-popover--prompt--bottom-right{\n  inset-inline-end:var(--slds-g-spacing-2);\n}\n.slds-popover_prompt_top-left,.slds-popover--prompt--top-left,\n.slds-popover_prompt_bottom-left,\n.slds-popover--prompt--bottom-left{\n  inset-inline-start:var(--slds-g-spacing-2);\n}\n.slds-color-picker{\n  position:relative;\n}\n.slds-color-picker .slds-form-error{\n  padding-block-start:var(--slds-g-spacing-2);\n  color:var(--slds-g-color-error-base-40, var(--slds-g-color-error-1));\n  font-size:var(--slds-g-font-scale-neg-1);\n}\n.slds-color-picker__summary-label{\n  display:block;\n}\n.slds-color-picker__summary-button{\n  vertical-align:top;\n  padding-block:0.3rem;\n  padding-inline:var(--slds-g-spacing-2);\n  line-height:1;\n  background:var(--slds-g-color-neutral-base-100, var(--slds-g-color-surface-container-1));\n  margin-inline-end:var(--slds-g-spacing-1);\n  border-radius:var(--slds-s-input-radius-border);\n}\n.slds-color-picker__summary-input{\n  display:inline-block;\n}\n.slds-color-picker__summary-input .slds-input{\n  width:6rem;\n}\n.slds-color-picker__selector{\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-popover__footer{\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-s-container-color-border, var(--slds-g-color-neutral-base-90));\n}\n.slds-color-picker__selector.slds-popover{\n  width:14rem;\n}\n.slds-color-picker__selector .slds-tabs_default__content,.slds-color-picker__selector .slds-tabs--default__content{\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:0;\n}\n.slds-color-picker__swatches{\n  font-size:0;\n}\n.slds-color-picker__swatches.slds-swatch{\n  cursor:pointer;\n}\n.slds-color-picker__swatch{\n  display:inline-block;\n  margin:var(--slds-g-spacing-1);\n}\n.slds-color-picker__swatch-trigger{\n  display:inline-block;\n}\n.slds-color-picker__swatch-trigger:focus,\n.slds-color-picker__swatch-trigger:active{\n  outline:none;\n  box-shadow:var(--slds-s-input-shadow-focus);\n  border-radius:var(--slds-g-radius-border-2);\n}\n.slds-color-picker__custom{\n  padding-block:var(--slds-g-spacing-1);\n  padding-inline:0;\n}\n.slds-color-picker__custom-range{\n  position:relative;\n  margin-block-end:var(--slds-g-spacing-1);\n  height:var(--slds-g-sizing-12);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n  overflow:hidden;\n}\n.slds-color-picker__custom-range::before{\n  content:'';\n  position:absolute;\n  top:0;\n  right:0;\n  bottom:0;\n  left:0;\n  background:linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.9) 1%, transparent 99%), linear-gradient(to right, rgba(255, 255, 255, 1) 1%, transparent);\n}\n.slds-color-picker__range-indicator{\n  --_slds-c-color-picker-half-spacing:calc(0.75rem * 0.5);\n\n  transform:translate3d(\n    var(--_slds-c-color-picker-half-spacing),\n    var(--_slds-c-color-picker-half-spacing),\n    0\n  );\n  cursor:pointer;\n  position:absolute;\n  height:var(--slds-g-sizing-4);\n  width:var(--slds-g-sizing-4);\n  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-surface-container-1);\n  border-radius:var(--slds-g-radius-border-circle);\n  box-shadow:0 2px 4px 4px rgba(0, 0, 0, 0.16), inset 0 2px 4px 4px rgba(0, 0, 0, 0.16);\n}\n.slds-color-picker__range-indicator:focus{\n  outline:none;\n  box-shadow:var(--slds-s-input-shadow-focus);\n}\n.slds-color-picker__hue-and-preview{\n  display:flex;\n}\n.slds-color-picker__hue-and-preview .slds-swatch{\n  margin-inline-start:var(--slds-g-spacing-1);\n  height:var(--slds-g-spacing-5);\n  width:var(--slds-g-spacing-5);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-1);\n}\n.slds-color-picker__hue-slider{\n  appearance:none;\n  flex:1;\n  padding:0;\n  height:var(--slds-g-sizing-7);\n  width:100%;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-1);\n  background:linear-gradient(\n    90deg,\n    red,\n    #ff1500,\n    #ff2b00,\n    #ff4000,\n    #f50,\n    #ff6a00,\n    #ff8000,\n    #ff9500,\n    #fa0,\n    #ffbf00,\n    #ffd500,\n    #ffea00,\n    #ff0,\n    #eaff00,\n    #d4ff00,\n    #bfff00,\n    #af0,\n    #95ff00,\n    #80ff00,\n    #6aff00,\n    #5f0,\n    #40ff00,\n    #2bff00,\n    #15ff00,\n    #0f0,\n    #00ff15,\n    #00ff2b,\n    #00ff40,\n    #0f5,\n    #00ff6a,\n    #00ff80,\n    #00ff95,\n    #0fa,\n    #00ffbf,\n    #00ffd5,\n    #00ffea,\n    #0ff,\n    #00eaff,\n    #00d4ff,\n    #00bfff,\n    #0af,\n    #0095ff,\n    #007fff,\n    #006aff,\n    #05f,\n    #0040ff,\n    #002bff,\n    #0015ff,\n    #00f,\n    #1500ff,\n    #2a00ff,\n    #4000ff,\n    #50f,\n    #6a00ff,\n    #7f00ff,\n    #9500ff,\n    #a0f,\n    #bf00ff,\n    #d400ff,\n    #ea00ff,\n    #f0f,\n    #ff00ea,\n    #ff00d4,\n    #ff00bf,\n    #f0a,\n    #ff0095,\n    #ff0080,\n    #ff006a,\n    #f05,\n    #ff0040,\n    #ff002b,\n    #ff0015\n  );\n  margin:0;\n}\n.slds-color-picker__hue-slider::-webkit-slider-thumb{\n  appearance:none;\n  cursor:pointer;\n  height:calc(var(--slds-g-sizing-7) - (var(--slds-g-sizing-border-1) * 2));\n  width:0.375rem;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-30);\n  border-radius:var(--slds-g-radius-border-1);\n  background:var(--slds-g-color-surface-container-1, var(--slds-g-color-neutral-base-95));\n}\n.slds-color-picker__hue-slider::-moz-range-thumb{\n  appearance:none;\n  cursor:pointer;\n  height:calc(var(--slds-g-sizing-7) - (var(--slds-g-sizing-border-1) * 2));\n  width:0.375rem;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-30);\n  border-radius:var(--slds-g-radius-border-1);\n  background:var(--slds-g-color-surface-container-1, var(--slds-g-color-neutral-base-95));\n}\n.slds-color-picker__hue-slider::-ms-thumb{\n  appearance:none;\n  cursor:pointer;\n  width:0.375rem;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-neutral-base-30);\n  border-radius:var(--slds-g-radius-border-1);\n  background:var(--slds-g-color-surface-container-1, var(--slds-g-color-neutral-base-95));\n  height:var(--slds-g-sizing-7);\n}\n.slds-color-picker__hue-slider:focus{\n  outline:none;\n}\n.slds-color-picker__hue-slider:focus::-webkit-slider-thumb{\n  border-color:var(--slds-g-color-brand-base-60, var(--slds-g-color-accent-1));\n  box-shadow:var(--slds-s-input-shadow-focus);\n}\n.slds-color-picker__hue-slider:focus::-moz-range-thumb{\n  border-color:var(--slds-g-color-brand-base-60, var(--slds-g-color-accent-1));\n  box-shadow:var(--slds-s-input-shadow-focus);\n}\n.slds-color-picker__hue-slider:focus::-ms-thumb{\n  border-color:var(--slds-g-color-brand-base-60, var(--slds-g-color-accent-1));\n  box-shadow:var(--slds-s-input-shadow-focus);\n}\n.slds-color-picker__hue-slider::-moz-range-track{\n  height:0;\n}\n.slds-color-picker__hue-slider::-ms-track{\n  height:0;\n  border:0;\n  background:transparent;\n  color:transparent;\n}\n.slds-color-picker__custom-inputs{\n  display:flex;\n  padding-block-start:var(--slds-g-spacing-2);\n}\n.slds-color-picker__custom-inputs .slds-form-element:not(:first-child){\n  margin-inline-start:var(--slds-g-spacing-1);\n}\n.slds-color-picker__custom-inputs input{\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-1);\n}\n.slds-color-picker__custom-inputs abbr{\n  cursor:text;\n  text-decoration:none;\n}\n.slds-color-picker__custom-inputs .slds-form-element.slds-color-picker__input-custom-hex{\n  flex:none;\n  width:4.2rem;\n}\n.slds-color-picker__custom-inputs .slds-form-element.slds-color-picker__input-custom-hex input{\n  font-size:var(--slds-g-spacing-3);\n}\n.slds-color-picker__selector-footer{\n  display:flex;\n}\n.slds-color-picker__selector-footer .slds-button{\n  flex:1;\n}\n.slds-swatch{\n  display:inline-block;\n  vertical-align:middle;\n  height:var(--slds-g-sizing-6);\n  width:var(--slds-g-sizing-6);\n  border-radius:var(--slds-g-radius-border-1);\n  box-shadow:var(--slds-g-color-neutral-base-10, inset 0 0 1px rgba(0, 0, 0, 0.4));\n}\n.slds-color-picker.slds-color-picker_swatches-only,.slds-color-picker.slds-color-picker--swatches-only{\n  width:13.3rem;\n  padding:var(--slds-g-spacing-2);\n}\n.slds-color-picker.slds-color-picker_swatches-only .slds-color-picker__selector,.slds-color-picker.slds-color-picker--swatches-only .slds-color-picker__selector{\n  margin:0;\n}\n.slds-popover_tooltip,.slds-popover--tooltip{\n  --slds-c-tooltip-sizing-width-max:var(--slds-c-tooltip-sizing-width-max);\n\n  width:auto;\n  max-width:var(--slds-c-tooltip-sizing-width-max, var(--slds-g-sizing-15));\n  background-color:var(--slds-c-tooltip-color-background, var(--slds-g-color-surface-inverse-1));\n  border:0;\n}\n.slds-popover_tooltip .slds-popover__body,.slds-popover--tooltip .slds-popover__body{\n  font-size:var(--slds-c-tooltip-font-size, var(--slds-g-font-scale-neg-1));\n  color:var(--slds-c-tooltip-text-color, var(--slds-g-color-on-surface-inverse-1));\n}\n.slds-popover_tooltip .slds-icon-text-default,.slds-popover--tooltip .slds-icon-text-default{\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-accent-1);\n}\n.slds-rise-from-ground{\n  visibility:visible;\n  opacity:1;\n  transform:translate(0%, 0%);\n  transition:opacity 0.1s linear, visibility 0.1s linear, transform 0.1s linear;\n  will-change:transform;\n}\n.slds-fall-into-ground{\n  visibility:hidden;\n  opacity:0;\n  transform:translate(0%, 0%);\n  transition:opacity 0.1s linear, visibility 0.1s linear, transform 0.1s linear;\n  will-change:transform;\n}\n.slds-slide-from-bottom-to-top{\n  transform:translateY(10%);\n  will-change:transform;\n}\n.slds-slide-from-top-to-bottom{\n  transform:translateY(-10%);\n  will-change:transform;\n}\n.slds-slide-from-right-to-left{\n  transform:translateX(5%);\n  will-change:transform;\n}\n.slds-slide-from-left-to-right{\n  transform:translateX(-5%);\n  will-change:transform;\n}\na [icon-name='utility:info'] .slds-icon-text-default{\n  --slds-c-icon-color-foreground-default:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));\n}\na:hover [icon-name='utility:info'] .slds-icon-text-default, a:focus [icon-name='utility:info'] .slds-icon-text-default{\n  --slds-c-icon-color-foreground-default:var(--slds-s-button-color-hover, var(--slds-g-color-accent-3));\n}\n.slds-datepicker{\n  padding:0;\n  font-size:var(--slds-g-font-scale-neg-1);\n}\n.slds-datepicker thead > tr > th,\n.slds-datepicker tbody > tr > td{\n  text-align:center;\n}\n.slds-datepicker thead > tr > th{\n  padding:var(--slds-g-spacing-2);\n  font-weight:var(--slds-g-font-weight-4);\n  color:var(--slds-g-color-on-surface-3);\n  font-size:var(--slds-g-font-scale-neg-1);\n}\n.slds-datepicker tbody > tr > td{\n  padding:var(--slds-g-spacing-1);\n  font-size:var(--slds-g-font-scale-neg-1);\n}\n.slds-datepicker tbody > tr > td > .slds-day{\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n  display:block;\n  position:relative;\n  min-width:var(--slds-g-sizing-9);\n  line-height:2rem;\n  border-radius:var(--slds-g-radius-border-circle);\n  margin:auto;\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-datepicker tbody > tr > .slds-day_adjacent-month > .slds-day,.slds-datepicker tbody > tr > .slds-day--adjacent-month > .slds-day{\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-datepicker tbody > tr > td:hover > .slds-day,\n.slds-datepicker tbody > tr > td:focus > .slds-day,\n.slds-datepicker tbody > tr > td.slds-is-today > .slds-day{\n  cursor:pointer;\n}\n.slds-datepicker tbody > tr > td.slds-is-today > .slds-day{\n  background-color:var(--slds-g-color-brand-base-90);\n  color:var(--slds-g-color-accent-2);\n}\n.slds-datepicker tbody > tr > td:focus{\n  outline:0;\n}\n.slds-datepicker tbody > tr > td:focus > .slds-day{\n  box-shadow:var(--slds-s-table-cell-shadow-selected);\n}\n.slds-datepicker tbody > tr > td:hover > .slds-day{\n  background-color:var(--slds-g-color-brand-base-90);\n}\n.slds-datepicker tbody > tr > td.slds-is-selected > .slds-day{\n  background:var(--slds-g-color-accent-container-1);\n  color:var(--slds-g-color-on-accent-1);\n}\n.slds-datepicker tbody > tr > td.slds-is-selected:focus > .slds-day{\n  background:var(--slds-g-color-accent-container-2);\n  box-shadow:var(--slds-s-table-cell-shadow-selected);\n  color:var(--slds-g-color-on-accent-1);\n}\n.slds-datepicker .slds-has-multi-selection .slds-is-selected-multi:last-child > .slds-day::after{\n  left:auto;\n  right:0;\n  transform:translateX(var(--slds-g-spacing-1));\n}\n.slds-datepicker .slds-has-multi-row-selection .slds-is-selected-multi:first-child > .slds-day::before,\n.slds-datepicker .slds-has-multi-row-selection .slds-is-selected-multi:last-child > .slds-day::after{\n  content:'';\n  position:absolute;\n  background:var(--slds-g-color-accent-container-1);\n  top:0;\n  left:-50%;\n  height:100%;\n  width:calc(var(--slds-g-sizing-9) + var(--slds-g-spacing-2));\n  transform:translateX(calc(var(--slds-g-spacing-2) * -1));\n  z-index:-1;\n}\n.slds-datepicker .slds-has-multi-row-selection .slds-is-selected-multi:first-child > .slds-day::before{\n  left:0;\n  transform:translateX(calc(var(--slds-g-spacing-1) * -1));\n}\n.slds-datepicker .slds-has-multi-row-selection .slds-is-selected-multi:last-child > .slds-day::after{\n  left:auto;\n  right:0;\n  transform:translateX(var(--slds-g-spacing-1));\n}\n.slds-datepicker td.slds-is-selected-multi > .slds-day{\n  overflow:visible;\n}\n.slds-datepicker td.slds-is-selected-multi.slds-is-today > .slds-day{\n  box-shadow:var(--slds-g-color-on-accent-1) 0 0 0 1px inset;\n}\n.slds-datepicker td.slds-is-selected-multi + .slds-is-selected-multi > .slds-day::before{\n  content:'';\n  position:absolute;\n  background:var(--slds-g-color-accent-container-1);\n  top:0;\n  left:-50%;\n  height:100%;\n  width:calc(var(--slds-g-sizing-9) + var(--slds-g-spacing-2));\n  transform:translateX(calc(var(--slds-g-spacing-2) * -1));\n  z-index:-1;\n}\n.slds-datepicker__filter{\n  padding:var(--slds-g-spacing-1);\n}\n.slds-datepicker__filter .slds-select{\n  min-width:var(--slds-g-sizing-11);\n}\n.slds-datepicker__filter_month,.slds-datepicker__filter--month{\n  padding:0 var(--slds-g-spacing-1) 0 0;\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-datepicker__month{\n  font-size:var(--slds-g-font-scale-neg-1);\n}\n.slds-has-error .slds-datepicker__filter .slds-select{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  box-shadow:none;\n}\n.slds-day_adjacent-month,.slds-day--adjacent-month{\n  color:var(--slds-g-color-neutral-base-50);\n}\n.slds-table .slds-datepicker .slds-datepicker__month tbody > tr:hover > td{\n  background-color:unset;\n}\n.slds-utility-bar_container,.slds-utility-bar--container{\n  position:relative;\n}\n.slds-utility-bar{\n  display:flex;\n  position:fixed;\n  bottom:0;\n  left:0;\n  width:100%;\n  height:2.5rem;\n  background:var(--slds-g-color-surface-1);\n  box-shadow:var(--slds-g-shadow-blockstart-2, 0 -2px 2px 0 rgba(0, 0, 0, 0.16));\n  z-index:4;\n}\n.slds-utility-bar .slds-indicator_unread,.slds-utility-bar .slds-indicator--unread{\n  width:8px;\n  height:8px;\n  top:var(--slds-g-spacing-2);\n  position:absolute;\n  left:var(--slds-g-spacing-2);\n  display:block;\n  border-radius:var(--slds-g-radius-border-circle);\n  background:var(--slds-g-color-error-1);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-surface-1);\n}\n.slds-utility-bar__item{\n  display:flex;\n  margin-inline-end:1px;\n}\n.slds-utility-bar__item_pop-out,.slds-utility-bar__item--pop-out{\n  position:relative;\n}\n.slds-utility-bar__item_pop-out::before,.slds-utility-bar__item--pop-out::before{\n  content:'';\n  position:absolute;\n  top:4px;\n  right:4px;\n  height:4px;\n  width:4px;\n  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);\n  border-right:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);\n  z-index:1;\n}\n.slds-utility-bar__item_pop-out::after,.slds-utility-bar__item--pop-out::after{\n  content:'';\n  position:absolute;\n  top:2px;\n  right:6px;\n  height:7px;\n  width:7px;\n  border-right:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);\n  transform:rotate(45deg);\n}\n[dir='rtl'] .slds-utility-bar__item_pop-out::before,[dir='rtl'] .slds-utility-bar__item--pop-out::before{\n  /*! @noflip */\n  right:auto;\n\n  /*! @noflip */\n  left:4px;\n\n  /*! @noflip */\n  border-right-width:0;\n\n  /*! @noflip */\n  border-left:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);\n}\n[dir='rtl'] .slds-utility-bar__item_pop-out::after,[dir='rtl'] .slds-utility-bar__item--pop-out::after{\n  /*! @noflip */\n  right:auto;\n\n  /*! @noflip */\n  left:6px;\n\n  /*! @noflip */\n  border-right-width:0;\n\n  /*! @noflip */\n  border-left:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-surface-3);\n  transform:rotate(-45deg);\n}\n.slds-utility-bar__action{\n  position:relative;\n  display:inline-flex;\n  gap:var(--slds-g-spacing-1);\n  align-items:center;\n  padding:0 var(--slds-g-spacing-3);\n  border-radius:0;\n  border:0;\n  color:var(--_slds-c-utilitybar-color, var(--slds-g-color-on-surface-3));\n  font-weight:var(--_slds-c-utilitybar-font-weight);\n}\n.slds-utility-bar__action .slds-icon{\n  fill:currentColor;\n}\n.slds-utility-bar__action::after{\n  content:'';\n  position:absolute;\n  bottom:0;\n  left:0;\n  right:0;\n  height:0;\n  background:transparent;\n}\n.slds-utility-bar__action:focus,\n.slds-utility-bar__action:hover{\n  box-shadow:none;\n  background:var(--_slds-c-utilitybar-color-background-hover);\n  color:var(--_slds-c-utilitybar-color-hover, inherit);\n}\n.slds-utility-bar__action:hover::after{\n  background:var(--_slds-c-utilitybar-color-border-hover);\n  height:var(--_slds-c-utilitybar-sizing-border-hover);\n}\n.slds-utility-bar__action:focus::after{\n  background:var(--_slds-c-utilitybar-color-border-hover);\n  height:var(--_slds-c-utilitybar-sizing-border-active);\n}\n.slds-utility-bar__action.slds-is-active{\n  background:var(--_slds-c-globalnavigation-item-color-background-active);\n  color:var(--_slds-c-utilitybar-color-active, inherit);\n}\n.slds-utility-bar__action.slds-is-active::after{\n  background:var(--_slds-c-utilitybar-color-border-active);\n  height:var(--_slds-c-utilitybar-sizing-border-active);\n}\n.slds-utility-bar__text{\n  display:flex;\n  flex-direction:column;\n  line-height:1;\n  text-align:left;\n}\n.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action{\n  background:var(--slds-g-color-info-container-1);\n  color:var(--slds-g-color-on-info-1);\n}\n.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action .slds-icon{\n  fill:var(--slds-g-color-on-info-1);\n}\n.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action:hover,\n.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action:focus{\n  background:var(--slds-g-color-surface-container-inverse-2);\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-utility-bar__item.slds-has-notification .slds-utility-bar__action:hover .slds-icon, .slds-utility-bar__item.slds-has-notification .slds-utility-bar__action:focus .slds-icon{\n  fill:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-utility-panel{\n  position:fixed;\n  bottom:1.875rem;\n  width:21.25rem;\n  height:30rem;\n  border-radius:var(--slds-s-container-radius-border) var(--slds-s-container-radius-border) 0 0;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-bottom:none;\n  background:var(--slds-g-color-surface-container-1);\n  transform:translateY(100%);\n}\n.slds-utility-panel.slds-is-open{\n  box-shadow:var(--slds-g-shadow-blockstart-2, 0 -2px 2px 0 rgba(0, 0, 0, 0.16));\n  transform:translateY(0);\n}\n.slds-utility-panel__header{\n  background:var(--slds-g-color-surface-container-1);\n  border-bottom:var(--slds-g-sizing-border-2) solid var(--slds-g-color-accent-1);\n  border-radius:var(--slds-s-container-radius-border) var(--slds-s-container-radius-border) 0 0;\n  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-3);\n  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-1));\n  font-weight:var(--slds-s-container-heading-font-weight);\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-utility-panel__header .slds-icon{\n  fill:currentColor;\n}\n.slds-utility-panel__body{\n  display:flex;\n  flex:1 1 0%;\n  flex-direction:column;\n  overflow:auto;\n}\n.slds-datetimepicker_has-tooltip .slds-form-element__icon,.slds-datetimepicker--has-tooltip .slds-form-element__icon{\n  padding-block-start:0;\n}\n.slds-docked_container,.slds-docked--container{\n  display:flex;\n  align-items:flex-end;\n  position:fixed;\n  inset-block-end:0;\n  inset-inline-end:0;\n  padding:0 var(--slds-g-spacing-7);\n  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));\n  font-weight:var(--slds-s-container-heading-font-weight);\n}\n.slds-docked-composer{\n  position:relative;\n  border-radius:var(--slds-s-container-radius-border, var(--slds-g-radius-border-2)) var(--slds-s-container-radius-border, var(--slds-g-radius-border-2)) 0 0;\n  width:480px;\n  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));\n  float:left;\n  box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 -4px 5px 0 rgba(0, 0, 0, 0.09), 0 0 5px 0 rgba(0, 0, 0, 0.08);\n  border:var(--slds-s-container-sizing-border, var(--slds-g-sizing-border-1)) solid var(--slds-s-container-color-border, var(--slds-g-color-border-1));\n  border-bottom:none;\n  font-weight:var(--slds-s-container-heading-font-weight);\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-docked-composer.slds-has-focus{\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-docked-composer.slds-is-open{\n  height:480px;\n}\n.slds-docked-composer.slds-is-closed{\n  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));\n}\n.slds-docked-composer.slds-is-closed .slds-docked-composer__body,\n.slds-docked-composer.slds-is-closed .slds-docked-composer__footer{\n  display:none;\n}\n.slds-docked-composer + .slds-docked-composer{\n  margin-inline-start:var(--slds-g-spacing-7);\n}\n.slds-docked-composer__header{\n  background:var(--slds-g-color-surface-container-1);\n  border-bottom:var(--slds-g-sizing-border-2) solid var(--slds-g-color-accent-container-1);\n  border-radius:var(--slds-s-container-radius-border) var(--slds-s-container-radius-border) 0 0;\n  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-3);\n  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-size-base));\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-docked-composer__actions .slds-button{\n  margin-inline-start:var(--slds-g-spacing-3);\n}\n.slds-docked-composer__body{\n  display:flex;\n  flex:1 0 auto;\n  flex-direction:column;\n  overflow:auto;\n}\n.slds-docked-composer__body_form,.slds-docked-composer__body--form{\n  justify-content:flex-start;\n  padding:var(--slds-g-spacing-4);\n}\n.slds-docked-composer__lead{\n  display:flex;\n  background:var(--slds-g-color-surface-container-1);\n  padding:var(--slds-g-spacing-4) var(--slds-g-spacing-2);\n}\n.slds-docked-composer__toolbar{\n  background:var(--slds-g-color-surface-container-2);\n  padding:var(--slds-g-spacing-1) var(--slds-g-spacing-2);\n  max-height:60px;\n  overflow-y:auto;\n  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-bottom:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-docked-composer__input{\n  background:var(--slds-g-color-surface-container-1);\n  padding:var(--slds-g-spacing-4);\n  min-height:calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9));\n  resize:none;\n  line-height:var(--slds-g-font-lineheight-base);\n  overflow:hidden;\n  overflow-y:auto;\n  font-family:inherit;\n}\n.slds-docked-composer__footer{\n  display:flex;\n  background:var(--slds-s-container-footer-color-background, var(--slds-g-color-surface-container-2));\n  padding:var(--slds-g-spacing-3) var(--slds-g-spacing-2);\n  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-docked-composer__footer .slds-button{\n  justify-content:center;\n}\n.slds-docked-composer_overflow,.slds-docked-composer--overflow{\n  width:auto;\n}\n.slds-docked-composer_overflow__button,.slds-docked-composer--overflow__button{\n  display:flex;\n  background:var(--slds-g-color-surface-container-1);\n  padding:0 var(--slds-g-spacing-3);\n  height:inherit;\n  white-space:nowrap;\n  border-bottom-left-radius:0;\n  border-bottom-right-radius:0;\n}\n.slds-docked-composer-modal .slds-modal__content{\n  border-radius:var(--slds-s-container-radius-border, var(--slds-g-radius-border-2));\n}\n.slds-docked-composer-modal .slds-docked-composer{\n  width:100%;\n  height:100%;\n  border:0;\n}\n.slds-email-composer{\n  position:relative;\n  flex:1 1 auto;\n}\n.slds-email-composer .slds-rich-text-editor{\n  border:0;\n  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:0;\n}\n.slds-email-composer__combobox{\n  padding-inline-start:var(--slds-g-spacing-8);\n  border:0;\n  border-bottom:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:0;\n}\n.slds-email-composer__combobox .slds-form-element__label{\n  position:absolute;\n  inset-inline-start:var(--slds-g-spacing-3);\n  inset-block-start:50%;\n  transform:translateY(-50%);\n}\n.slds-email-composer__combobox .slds-combobox_container,.slds-email-composer__combobox .slds-combobox--container,\n.slds-email-composer__combobox .slds-input[value]{\n  border:0;\n  box-shadow:none;\n}\n.slds-email-composer__recipient{\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-end:var(--slds-g-spacing-3);\n}\n.slds-brand-band{\n  --_slds-c-brandband-color-background-dark:var(--slds-g-color-surface-2);\n  --_slds-c-brandband-color-background-light:var(--slds-g-color-surface-2);\n  --_slds-c-brandband-asset-default-image:none;\n  --_slds-c-brandband-asset-group-image:none;\n  --_slds-c-brandband-asset-user-image:none;\n\n  display:flex;\n  flex-direction:column;\n  position:relative;\n  height:100%;\n  width:100%;\n}\n.slds-brand-band::before{\n  content:'';\n  display:block;\n  position:absolute;\n  z-index:-1;\n  top:0;\n  right:0;\n  bottom:0;\n  left:0;\n  background-image:var(--_slds-c-brandband-asset-default-image), linear-gradient(\n    to top,\n    color-mix(in srgb, var(--_slds-c-brandband-color-background-dark) 0%, transparent) 0,\n    var(--_slds-c-brandband-color-background-dark)\n  );\n  background-repeat:repeat-x;\n  background-position:top left;\n}\n.slds-brand-band::after{\n  content:none;\n  display:block;\n  position:absolute;\n  z-index:-1;\n  left:0;\n  right:0;\n  top:0;\n  width:100%;\n  height:var(--_slds-c-brandband-scrim-sizing-height, 3.125rem);\n  background-image:linear-gradient(\n    to bottom,\n    color-mix(in srgb, var(--_slds-c-brandband-color-background-light) 0%, transparent) 60%,\n    var(--_slds-c-brandband-color-background-light)\n  );\n}\n.slds-brand-band.slds-brand-band_cover::before,.slds-brand-band.slds-brand-band--cover::before{\n  background-repeat:no-repeat;\n  background-size:cover;\n}\n.slds-brand-band.slds-brand-band_small::before,.slds-brand-band.slds-brand-band--small::before{\n  height:var(--_slds-c-brandband-sizing-height-small, 6rem);\n}\n.slds-brand-band.slds-brand-band_small::after,.slds-brand-band.slds-brand-band--small::after{\n  content:'';\n  top:calc(\n    var(--_slds-c-brandband-sizing-height-small, 6rem) -\n    var(--_slds-c-brandband-scrim-sizing-height, 3.125rem)\n  );\n}\n.slds-brand-band.slds-brand-band_medium::before,.slds-brand-band.slds-brand-band--medium::before{\n  height:var(--_slds-c-brandband-sizing-height-medium, 12.5rem);\n}\n.slds-brand-band.slds-brand-band_medium::after,.slds-brand-band.slds-brand-band--medium::after{\n  content:'';\n  top:calc(\n    var(--_slds-c-brandband-sizing-height-medium, 12.5rem) -\n    var(--_slds-c-brandband-scrim-sizing-height, 3.125rem)\n  );\n}\n.slds-brand-band.slds-brand-band_large::before,.slds-brand-band.slds-brand-band--large::before{\n  height:var(--_slds-c-brandband-sizing-height-large, 18.75rem);\n}\n.slds-brand-band.slds-brand-band_large::after,.slds-brand-band.slds-brand-band--large::after{\n  content:'';\n  top:calc(\n    var(--_slds-c-brandband-sizing-height-large, 18.75rem) -\n    var(--_slds-c-brandband-scrim-sizing-height, 3.125rem)\n  );\n}\n.slds-brand-band.slds-brand-band_full::before,.slds-brand-band.slds-brand-band--full::before{\n  height:100%;\n}\n.slds-brand-band.slds-brand-band_bottom::before,.slds-brand-band.slds-brand-band--bottom::before{\n  background-position:bottom;\n  top:initial;\n}\n.slds-brand-band.slds-brand-band_none::before,.slds-brand-band.slds-brand-band--none::before{\n  height:0;\n}\n.slds-brand-band.slds-brand-band_group::before,.slds-brand-band.slds-brand-band--group::before{\n  background-image:var(--_slds-c-brandband-asset-group-image);\n}\n.slds-brand-band.slds-brand-band_user::before,.slds-brand-band.slds-brand-band--user::before{\n  background-image:var(--_slds-c-brandband-asset-user-image);\n}\n.slds-brand-band .slds-brand-band_blank,.slds-brand-band .slds-brand-band--blank{\n  background:var(--slds-g-color-surface-color-2);\n}\n.slds-brand-band .slds-brand-band_blank::before,.slds-brand-band .slds-brand-band--blank::before,\n.slds-brand-band .slds-brand-band_blank::after,\n.slds-brand-band .slds-brand-band--blank::after{\n  background:none;\n}\n[class*='slds-template_'],[class*='slds-template--']{\n  --_slds-c-template-sizing-gap:1rem;\n  --_slds-c-template-profile-sizing-gap:8rem 0.75rem 0.75rem;\n}\n.slds-template__container{\n  position:relative;\n  height:100%;\n  width:100%;\n}\n.slds-template_default,.slds-template--default{\n  padding:var(--_slds-c-template-sizing-gap);\n}\n.slds-template_default.slds-brand-band::before,.slds-template--default.slds-brand-band::before{\n  position:fixed;\n  top:5.625rem;\n}\n.slds-template_default.slds-brand-band.slds-brand-band_medium::after,.slds-template--default.slds-brand-band.slds-brand-band--medium::after{\n  position:fixed;\n  top:15rem;\n}\n.slds-template_bottom-magnet,.slds-template--bottom-magnet{\n  padding:var(--_slds-c-template-sizing-gap) var(--_slds-c-template-sizing-gap) 0 var(--_slds-c-template-sizing-gap);\n}\n.slds-template_profile,.slds-template--profile{\n  padding:var(--_slds-c-template-profile-sizing-gap);\n}\n.slds-template__content{\n  padding:var(--_slds-c-template-sizing-gap) var(--_slds-c-template-sizing-gap) 0 var(--_slds-c-template-sizing-gap);\n}\n.slds-template_app,.slds-template--app{\n  padding:var(--_slds-c-template-sizing-gap) 0 0 var(--_slds-c-template-sizing-gap);\n}\n.slds-template_iframe,.slds-template--iframe{\n  width:calc(100% + (var(--_slds-c-template-sizing-gap) * 2));\n  height:calc(100% + (var(--_slds-c-template-sizing-gap) * 2));\n  margin:calc(var(--_slds-c-template-sizing-gap) * -1);\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-nav-vertical__action_overflow,.slds-nav-vertical__action--overflow{\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-nav-vertical__action_overflow[aria-expanded='true'] .slds-button__icon,.slds-nav-vertical__action--overflow[aria-expanded='true'] .slds-button__icon{\n  transform:rotate(90deg);\n}\n[dir='rtl'] .slds-nav-vertical__action_overflow[aria-expanded='true'] .slds-button__icon,[dir='rtl'] .slds-nav-vertical__action--overflow[aria-expanded='true'] .slds-button__icon{\n  transform:rotate(-90deg);\n}\n.slds-nav-vertical__action-text{\n  color:var(--slds-s-link-color, var(--slds-g-color-accent-2));\n}\n.slds-nav-vertical__action-text:hover{\n  color:var(--slds-s-link-color-hover);\n}\n.slds-nav-vertical{\n  position:relative;\n}\n.slds-nav-vertical_compact .slds-nav-vertical__title,.slds-nav-vertical--compact .slds-nav-vertical__title,\n.slds-nav-vertical_compact .slds-nav-vertical__action,\n.slds-nav-vertical--compact .slds-nav-vertical__action{\n  padding-block-start:var(--slds-g-spacing-1);\n  padding-inline-end:var(--slds-g-spacing-5);\n  padding-block-end:var(--slds-g-spacing-1);\n  padding-inline-start:var(--slds-g-spacing-5);\n}\n.slds-nav-vertical_shade .slds-is-active.slds-nav-vertical__item::before,.slds-nav-vertical--shade .slds-is-active.slds-nav-vertical__item::before{\n  background:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-nav-vertical_shade .slds-nav-vertical__item:hover::before,.slds-nav-vertical--shade .slds-nav-vertical__item:hover::before{\n  background:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-nav-vertical_shade .slds-is-active .slds-nav-vertical__action,.slds-nav-vertical--shade .slds-is-active .slds-nav-vertical__action{\n  border-color:var(--slds-g-color-neutral-base-90);\n}\n.slds-nav-vertical__title{\n  padding-block-start:var(--slds-g-spacing-2);\n  padding-inline-end:var(--slds-g-spacing-4);\n  padding-block-end:var(--slds-g-spacing-2);\n  padding-inline-start:var(--slds-g-spacing-5);\n  font-size:var(--slds-g-font-size-base);\n  font-weight:var(--slds-g-font-weight-7);\n}\n.slds-nav-vertical__title:not(:first-of-type){\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-nav-vertical__section:not(:first-of-type){\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-nav-vertical__item{\n  position:relative;\n  display:block;\n  list-style:none;\n}\n.slds-nav-vertical__item::before{\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-end:0;\n  inset-block-end:0;\n  inset-inline-start:0;\n  content:'';\n}\n.slds-nav-vertical__item:hover::before,\n.slds-nav-vertical__item.slds-is-active::before{\n  background:color-mix(in srgb, var(--slds-g-color-accent-1) 10%, transparent);\n}\n.slds-nav-vertical__item:has(:focus-visible)::before{\n  box-shadow:inset 0 0 0 1px var(--slds-g-color-accent-1);\n}\n.slds-nav-vertical__action{\n  position:relative;\n  display:flex;\n  align-items:center;\n  width:100%;\n  padding-block-start:var(--slds-g-spacing-2);\n  padding-inline-end:var(--slds-g-spacing-5);\n  padding-block-end:var(--slds-g-spacing-2);\n  padding-inline-start:var(--slds-g-spacing-6);\n  color:var(--slds-s-navigation-color, var(--slds-g-color-on-surface-3));\n  border-block-start:var(--slds-g-sizing-border-1) solid transparent;\n  border-block-end:var(--slds-g-sizing-border-1) solid transparent;\n  border-radius:0;\n  box-shadow:inset 0 0 0 var(--slds-g-color-accent-1);\n  cursor:pointer;\n}\n.slds-nav-vertical__action:active,\n.slds-nav-vertical__action:hover,\n.slds-nav-vertical__action:focus{\n  color:currentcolor;\n}\n.slds-nav-vertical__action:hover{\n  text-decoration:none;\n  box-shadow:inset 2px 0 0 var(--slds-g-color-accent-1);\n  color:var(--slds-s-navigation-color-hover);\n}\n[dir='rtl'] .slds-nav-vertical__action:hover{\n  box-shadow:inset -2px 0 0 var(--slds-g-color-accent-1);\n}\n.slds-nav-vertical__action:focus-visible{\n  outline:0;\n  text-decoration:underline;\n}\n.slds-nav-vertical__item.slds-is-active .slds-nav-vertical__action{\n  font-weight:var(--slds-s-navigation-font-weight, bold);\n  box-shadow:inset 4px 0 0 var(--slds-g-color-accent-1);\n  color:var(--slds-s-navigation-color-active);\n}\n[dir='rtl'] .slds-nav-vertical__item.slds-is-active .slds-nav-vertical__action{\n  box-shadow:inset -4px 0 0 var(--slds-g-color-accent-1);\n}\n.slds-nav-vertical__item [type='radio']{\n  width:1px;\n  height:1px;\n  border:0;\n  clip:rect(0 0 0 0);\n  margin:-1px;\n  overflow:hidden;\n  padding:0;\n  position:absolute;\n}\n.slds-nav-vertical__item [type='radio']:focus + .slds-nav-vertical__action,\n.slds-nav-vertical__item [type='radio']:focus + .slds-nav-vertical__action .slds-nav-vertical_radio-faux,\n.slds-nav-vertical__item [type='radio']:focus + .slds-nav-vertical__action .slds-nav-vertical--radio-faux{\n  text-decoration:underline;\n}\n.slds-nav-vertical__item [type='radio']:checked + .slds-nav-vertical__action{\n  font-weight:var(--slds-g-font-weight-7);\n  background-color:color-mix(in srgb, var(--slds-g-color-accent-1) 10%, transparent);\n  box-shadow:inset 4px 0 0 var(--slds-g-color-accent-1);\n}\n.slds-nav-vertical_shade .slds-nav-vertical__item [type='radio']:checked + .slds-nav-vertical__action,.slds-nav-vertical--shade .slds-nav-vertical__item [type='radio']:checked + .slds-nav-vertical__action{\n  border-color:var(--slds-g-color-neutral-base-90);\n  background-color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-context-bar{\n  display:flex;\n  height:var(--slds-s-navigation-sizing-height, 2.5rem);\n  background-color:var(--slds-g-color-surface-container-1);\n  border-bottom:var(--_slds-c-globalnavigation-sizing-border, 3px) solid var(--slds-g-color-accent-2);\n  color:var(--slds-g-color-on-surface-3);\n  position:relative;\n  padding-block-start:var(--_slds-c-globalnavigation-spacing-block, 0);\n  padding-block-end:var(--_slds-c-globalnavigation-spacing-block, 0);\n  /* margin-block-start: var(--slds-s-header-sizing-height); */\n}\n.slds-context-bar .slds-context-bar__button{\n  color:inherit;\n}\n.slds-context-bar .slds-context-bar__icon-action{\n  margin-left:auto;\n}\n.slds-context-bar .slds-is-unsaved .slds-context-bar__label-action{\n  position:relative;\n  font-style:italic;\n  line-height:normal;\n}\n.slds-context-bar .slds-is-unsaved .slds-indicator_unread,.slds-context-bar .slds-is-unsaved .slds-indicator--unread{\n  margin-left:-0.35rem;\n}\n.slds-context-bar .slds-has-notification .slds-indicator_unread,.slds-context-bar .slds-has-notification .slds-indicator--unread{\n  display:inline-block;\n  flex-shrink:0;\n  height:6px;\n  width:6px;\n  left:auto;\n  position:relative;\n  top:auto;\n}\n.slds-context-bar .slds-has-notification .slds-indicator_unsaved,.slds-context-bar .slds-has-notification .slds-indicator--unsaved{\n  top:rem(-4px);\n}\n.slds-context-bar__primary,\n.slds-context-bar__secondary,\n.slds-context-bar__tertiary{\n  display:flex;\n  flex-shrink:0;\n}\n.slds-context-bar__primary{\n  padding-inline-start:var(--slds-g-spacing-4);\n}\n.slds-context-bar__secondary{\n  flex:1 1 0%;\n  min-width:0;\n  gap:var(--_slds-c-globalnavigation-spacing-gap, 0);\n}\n.slds-context-bar__secondary .slds-grid{\n  gap:inherit;\n}\n.slds-context-bar__vertical-divider{\n  width:0;\n  overflow:hidden;\n  border-left:1px solid var(--slds-g-color-border-1);\n}\n.slds-context-bar__item{\n  display:flex;\n  align-content:center;\n  align-items:stretch;\n  white-space:nowrap;\n  position:relative;\n  border-radius:var(--_slds-c-globalnavigation-item-radius-border, 0);\n  max-width:var(--_slds-c-globalnavigation-item-sizing-width-max, var(--slds-g-sizing-14));\n  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);\n}\n.slds-context-bar__item:not(.slds-no-hover):has(:focus-visible){\n  box-shadow:var(--_slds-c-globalnavigation-item-shadow-focus);\n}\n.slds-context-bar__item .slds-button__icon,\n.slds-context-bar__item .slds-icon{\n  fill:var(--slds-g-color-on-surface-1);\n}\n.slds-context-bar__item:not(.slds-no-hover):hover{\n  outline:0;\n  background-color:var(\n    --_slds-c-globalnavigation-item-color-background-hover,\n    var(--slds-g-color-accent-light-1)\n  ) !important;\n  text-decoration:none;\n  cursor:pointer;\n}\n.slds-context-bar__item:not(.slds-no-hover):hover::after{\n  opacity:1;\n}\n.slds-context-bar__item::before{\n  bottom:0;\n  content:'';\n  height:auto;\n  left:0;\n  position:absolute;\n  right:0;\n  top:0;\n  transition-property:top, background-color;\n}\n.slds-context-bar__item::after{\n  content:'';\n  width:100%;\n  height:var(--_slds-c-globalnavigation-item-sizing-border-hover, 3px);\n  display:block;\n  background:var(\n    --_slds-c-globalnavigation-item-color-border-hover,\n    color-mix(in oklab, var(--slds-g-color-accent-2) 80%, black)\n  );\n  position:absolute;\n  bottom:calc(var(--_slds-c-globalnavigation-item-sizing-border-hover, 3px) * -1);\n  border-radius:var(--_slds-c-globalnavigation-item-radius-border, 0);\n  left:0;\n  right:0;\n  opacity:0;\n}\n.slds-context-bar__item.slds-is-active{\n  background-color:var(\n    --_slds-c-globalnavigation-item-color-background-active,\n    var(--slds-g-color-accent-light-1)\n  ) !important;\n  color:var(--_slds-c-globalnavigation-item-color-active, var(--slds-g-color-on-surface-3));\n  text-decoration:none;\n  cursor:pointer;\n  animation:bkAnim 0.135s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n.slds-context-bar__item.slds-is-active::before{\n  content:'';\n  height:var(--_slds-c-globalnavigation-item-sizing-border-active, 3px);\n  display:block;\n  background:var(--slds-g-color-accent-2);\n  position:absolute;\n  top:0;\n  left:0;\n  right:0;\n  animation:navBounceIn 0.15s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n.slds-context-bar__item.slds-is-active::after{\n  opacity:1;\n  background:var(--_slds-c-globalnavigation-item-color-border-active, var(--slds-g-color-accent-2));\n}\n.slds-context-bar__item.slds-is-active .slds-button__icon,\n.slds-context-bar__item.slds-is-active .slds-icon{\n  fill:var(--_slds-c-globalnavigation-item-color-active, var(--slds-g-color-on-surface-1));\n}\n.slds-context-bar__item.slds-has-notification{\n  background:var(--slds-g-color-accent-container-1);\n}\n@keyframes error-pulse{\n  0%{\n    background-color:var(--slds-g-color-error-container-1);\n  }\n\n  40%{\n    background-color:var(--slds-g-color-error-container-2);\n  }\n\n  100%{\n    background-color:var(--slds-g-color-error-container-1);\n  }\n}\n@keyframes success-pulse{\n  0%{\n    background-color:var(--slds-g-color-success-container-1);\n  }\n\n  40%{\n    background-color:var(--slds-g-color-success-container-2);\n  }\n\n  100%{\n    background-color:var(--slds-g-color-success-container-1);\n  }\n}\n@keyframes warning-pulse{\n  0%{\n    background-color:var(--slds-g-color-warning-container-1);\n  }\n\n  40%{\n    background-color:var(--slds-g-color-warning-base-80);\n  }\n\n  100%{\n    background-color:var(--slds-g-color-warning-container-1);\n  }\n}\n.slds-context-bar__item.slds-has-success .slds-context-bar__label-action{\n  color:var(--slds-g-color-on-success-1);\n}\n.slds-context-bar__item.slds-has-success .slds-button__icon,\n.slds-context-bar__item.slds-has-success .slds-icon{\n  fill:var(--slds-g-color-on-success-1, var(--slds-g-color-on-surface-1));\n}\n.slds-context-bar__item.slds-has-success::before{\n  animation:none;\n  animation-duration:1s;\n  animation-iteration-count:3;\n  animation-delay:150ms;\n  animation-timing-function:cubic-bezier(0.07, 0.49, 0.5, 1);\n  background-color:var(--slds-g-color-success-container-1);\n  bottom:0;\n  content:'';\n  height:auto;\n  left:0;\n  position:absolute;\n  right:0;\n  top:0;\n  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);\n  animation-name:success-pulse;\n}\n.slds-context-bar__item.slds-has-success:hover::before{\n  background-color:var(--slds-g-color-success-container-2);\n  height:auto;\n}\n.slds-context-bar__item.slds-has-success::after{\n  background-color:var(--_slds-c-globalnavigation-item-color-border-success);\n}\n.slds-context-bar__item.slds-has-success .slds-indicator_unread,.slds-context-bar__item.slds-has-success .slds-indicator--unread{\n  background-color:var(--slds-g-color-neutral-base-100);\n}\n.slds-context-bar__item.slds-has-success .slds-indicator_unsaved,.slds-context-bar__item.slds-has-success .slds-indicator--unsaved{\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-context-bar__item.slds-has-error .slds-context-bar__label-action{\n  color:var(--slds-g-color-on-error-1);\n}\n.slds-context-bar__item.slds-has-error .slds-button__icon,\n.slds-context-bar__item.slds-has-error .slds-icon{\n  fill:var(--slds-g-color-on-error-1, var(--slds-g-color-on-surface-1));\n}\n.slds-context-bar__item.slds-has-error::before{\n  animation:none;\n  animation-duration:1s;\n  animation-iteration-count:3;\n  animation-delay:150ms;\n  animation-timing-function:cubic-bezier(0.07, 0.49, 0.5, 1);\n  background-color:var(--slds-g-color-error-container-1);\n  bottom:0;\n  content:'';\n  height:auto;\n  left:0;\n  position:absolute;\n  right:0;\n  top:0;\n  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);\n  animation-name:error-pulse;\n}\n.slds-context-bar__item.slds-has-error:hover::before{\n  background-color:var(--slds-g-color-error-container-2);\n  height:auto;\n}\n.slds-context-bar__item.slds-has-error::after{\n  background-color:var(--_slds-c-globalnavigation-item-color-border-error);\n}\n.slds-context-bar__item.slds-has-error .slds-indicator_unread,.slds-context-bar__item.slds-has-error .slds-indicator--unread{\n  background-color:var(--slds-g-color-neutral-base-100);\n}\n.slds-context-bar__item.slds-has-error .slds-indicator_unsaved,.slds-context-bar__item.slds-has-error .slds-indicator--unsaved{\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-context-bar__item.slds-has-warning .slds-context-bar__label-action{\n  color:var(--slds-g-color-on-warning-1);\n}\n.slds-context-bar__item.slds-has-warning .slds-button__icon,\n.slds-context-bar__item.slds-has-warning .slds-icon{\n  fill:var(--slds-g-color-on-warning-1);\n}\n.slds-context-bar__item.slds-has-warning::before{\n  animation:none;\n  animation-duration:1s;\n  animation-iteration-count:3;\n  animation-delay:150ms;\n  animation-timing-function:cubic-bezier(0.07, 0.49, 0.5, 1);\n  background-color:var(--slds-g-color-warning-container-1);\n  bottom:0;\n  content:'';\n  height:auto;\n  left:0;\n  position:absolute;\n  right:0;\n  top:0;\n  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);\n  animation-name:warning-pulse;\n}\n.slds-context-bar__item.slds-has-warning:hover::before{\n  background-color:var(--slds-g-color-warning-base-80);\n  height:auto;\n}\n.slds-context-bar__item.slds-has-warning::after{\n  background-color:var(--_slds-c-globalnavigation-item-color-border-warning);\n}\n.slds-context-bar__item.slds-has-warning .slds-indicator_unread,.slds-context-bar__item.slds-has-warning .slds-indicator--unread{\n  background-color:currentColor;\n}\n.slds-context-bar__item.slds-has-warning .slds-indicator_unsaved,.slds-context-bar__item.slds-has-warning .slds-indicator--unsaved{\n  color:currentColor;\n}\n.slds-context-bar__item.slds-has-success.slds-is-active::after, .slds-context-bar__item.slds-has-warning.slds-is-active::after, .slds-context-bar__item.slds-has-error.slds-is-active::after{\n  content:'';\n  background:var(--slds-g-color-neutral-base-30);\n  position:absolute;\n  height:4px;\n  opacity:0.4;\n  top:0;\n  right:0;\n  left:0;\n}\n.slds-context-bar__item.slds-has-success.slds-has-focus::after, .slds-context-bar__item.slds-has-warning.slds-has-focus::after, .slds-context-bar__item.slds-has-error.slds-has-focus::after{\n  height:4px;\n}\n@keyframes bkAnim{\n  50%{\n    background-color:var(--slds-g-color-neutral-base-100);\n  }\n\n  100%{\n    background-color:var(\n      --_slds-c-globalnavigation-item-color-background-active,\n      var(--slds-g-color-accent-light-1)\n    );\n  }\n}\n@keyframes navBounceIn{\n  0%{\n    transform:translate3d(0, 20px, 0);\n    opacity:0;\n  }\n\n  20%{\n    opacity:0;\n  }\n\n  90%{\n    transform:translate3d(0, 1px, 0);\n  }\n\n  100%{\n    transform:translate3d(0, 0, 0);\n  }\n}\n.slds-context-bar__item_divider-left,.slds-context-bar__item--divider-left{\n  border-left:1px solid var(--slds-g-color-border-1);\n}\n.slds-context-bar__item_divider-right,.slds-context-bar__item--divider-right{\n  border-right:1px solid var(--slds-g-color-border-1);\n}\n.slds-context-bar__label-action{\n  display:flex;\n  align-content:center;\n  align-items:center;\n  flex-grow:1;\n  padding:0 var(--slds-g-spacing-3);\n  min-width:0%;\n  color:inherit;\n  font-weight:var(--_slds-c-globalnavigation-font-weight, normal);\n  z-index:1;\n}\n.slds-context-bar__label-action:focus-visible,\n.slds-context-bar__label-action:focus-visible:hover{\n  outline:0;\n  text-decoration:var(--_slds-c-globalnavigation-font-decoration-focus, underline);\n}\n.slds-context-bar__label-action:hover{\n  text-decoration:none;\n}\n.slds-context-bar__label-action:hover,\n.slds-context-bar__label-action:focus{\n  color:inherit;\n}\n.slds-context-bar__label-action:active{\n  color:inherit;\n  text-decoration:none;\n}\n.slds-context-bar__icon-action{\n  display:flex;\n  align-items:center;\n  align-content:center;\n  margin-left:calc(var(--slds-g-spacing-1) * -1);\n  padding:0 var(--slds-g-spacing-2);\n  color:var(--slds-g-color-on-surface-1);\n  border-radius:0;\n  flex-shrink:0;\n}\n.slds-context-bar__icon-action:focus-visible{\n  outline:0;\n}\n.slds-context-bar__icon-action:focus-visible .slds-context-bar__button{\n  outline:0;\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-context-bar__icon-action:focus-visible ~ .slds-dropdown{\n  visibility:visible;\n  opacity:1;\n}\n.slds-context-bar__icon-action:hover,\n.slds-context-bar__icon-action:focus{\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-context-bar__icon-action:active{\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-context-bar__icon-action .slds-icon-waffle_container,.slds-context-bar__icon-action .slds-icon-waffle--container{\n  width:2rem;\n  height:2rem;\n  margin-inline-end:var(--slds-g-spacing-1);\n  margin-inline-start:calc(var(--slds-g-spacing-2) * -1);\n}\n.slds-context-bar__icon-action .slds-icon-waffle{\n  margin-right:auto;\n  margin-left:auto;\n}\n.slds-context-bar__dropdown-trigger .slds-dropdown{\n  margin-top:3px;\n}\n.slds-context-bar__dropdown-trigger .slds-dropdown::before{\n  content:'';\n  position:absolute;\n  bottom:100%;\n  width:100%;\n  height:3px;\n}\n.slds-context-bar__app-name{\n  padding-block:0;\n  padding-inline:0 var(--slds-g-spacing-5);\n  font-size:var(--slds-g-font-scale-3);\n  font-weight:var(--_slds-c-globalnavigation-app-font-weight, normal);\n  line-height:var(--slds-g-font-lineheight-2);\n}\n.slds-context-bar__object-switcher{\n  min-width:9rem;\n  max-width:var(--slds-g-sizing-14);\n  border-left:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-right:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:0;\n}\n.slds-context-bar_tabs,.slds-context-bar--tabs{\n  border-top:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-context-bar_tabs .slds-context-bar__secondary,.slds-context-bar--tabs .slds-context-bar__secondary{\n  gap:0;\n}\n.slds-context-bar__item_tab,.slds-context-bar__item--tab{\n  width:12.5rem;\n  border-right:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:0;\n}\n.slds-context-bar__item_tab .slds-context-bar__label-action,.slds-context-bar__item--tab .slds-context-bar__label-action{\n  padding:0 var(--slds-g-spacing-2);\n}\n.slds-context-bar__item_tab .slds-icon_container,.slds-context-bar__item--tab .slds-icon--container{\n  --slds-c-icon-color-background:transparent;\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-surface-1);\n}\n.slds-context-bar__item_tab.slds-is-pinned,.slds-context-bar__item--tab.slds-is-pinned{\n  width:auto;\n  padding-right:var(--slds-g-spacing-2);\n}\n.slds-context-bar__item_tab.slds-is-pinned .slds-context-bar__label-action,.slds-context-bar__item--tab.slds-is-pinned .slds-context-bar__label-action{\n  padding:0 var(--slds-g-spacing-2);\n}\n.slds-context-bar__item_tab.slds-has-sub-tabs.slds-is-active,.slds-context-bar__item--tab.slds-has-sub-tabs.slds-is-active,\n.slds-context-bar__item_tab.slds-has-sub-tabs.slds-is-active:hover,\n.slds-context-bar__item--tab.slds-has-sub-tabs.slds-is-active:hover{\n  animation:none;\n  background-color:transparent !important;\n}\n.slds-context-bar__item_tab.slds-has-sub-tabs.slds-is-active .slds-context-bar__label-action::after,.slds-context-bar__item--tab.slds-has-sub-tabs.slds-is-active .slds-context-bar__label-action::after, .slds-context-bar__item_tab.slds-has-sub-tabs.slds-is-active:hover .slds-context-bar__label-action::after, .slds-context-bar__item--tab.slds-has-sub-tabs.slds-is-active:hover .slds-context-bar__label-action::after{\n  content:'';\n  display:block;\n  position:absolute;\n  left:0;\n  bottom:calc(var(--_slds-c-globalnavigation-item-sizing-border-active, 3px) * -1);\n  height:var(--_slds-c-globalnavigation-item-sizing-border-active, 3px);\n  width:100%;\n  background-color:var(--slds-g-color-surface-container-1);\n  border:0;\n  mix-blend-mode:unset;\n}\n.slds-indicator_unsaved,.slds-indicator--unsaved{\n  color:var(--slds-g-color-accent-2);\n  align-self:center;\n  position:relative;\n}\n.slds-indicator-container{\n  display:inline;\n  margin-inline-end:var(--slds-g-spacing-1);\n}\n.slds-indicator-container:empty{\n  margin-inline-end:0;\n}\n.slds-icon-waffle_container,.slds-icon-waffle--container{\n  border:0;\n  outline:0;\n  padding:0;\n}\n.slds-icon-waffle_container:hover .slds-r1,.slds-icon-waffle--container:hover .slds-r1,\n.slds-icon-waffle_container:hover .slds-r2,\n.slds-icon-waffle--container:hover .slds-r2,\n.slds-icon-waffle_container:hover .slds-r3,\n.slds-icon-waffle--container:hover .slds-r3,\n.slds-icon-waffle_container:hover .slds-r4,\n.slds-icon-waffle--container:hover .slds-r4,\n.slds-icon-waffle_container:hover .slds-r5,\n.slds-icon-waffle--container:hover .slds-r5,\n.slds-icon-waffle_container:hover .slds-r6,\n.slds-icon-waffle--container:hover .slds-r6,\n.slds-icon-waffle_container:hover .slds-r7,\n.slds-icon-waffle--container:hover .slds-r7,\n.slds-icon-waffle_container:hover .slds-r8,\n.slds-icon-waffle--container:hover .slds-r8,\n.slds-icon-waffle_container:hover .slds-r9,\n.slds-icon-waffle--container:hover .slds-r9,\n.slds-icon-waffle_container:focus .slds-r1,\n.slds-icon-waffle--container:focus .slds-r1,\n.slds-icon-waffle_container:focus .slds-r2,\n.slds-icon-waffle--container:focus .slds-r2,\n.slds-icon-waffle_container:focus .slds-r3,\n.slds-icon-waffle--container:focus .slds-r3,\n.slds-icon-waffle_container:focus .slds-r4,\n.slds-icon-waffle--container:focus .slds-r4,\n.slds-icon-waffle_container:focus .slds-r5,\n.slds-icon-waffle--container:focus .slds-r5,\n.slds-icon-waffle_container:focus .slds-r6,\n.slds-icon-waffle--container:focus .slds-r6,\n.slds-icon-waffle_container:focus .slds-r7,\n.slds-icon-waffle--container:focus .slds-r7,\n.slds-icon-waffle_container:focus .slds-r8,\n.slds-icon-waffle--container:focus .slds-r8,\n.slds-icon-waffle_container:focus .slds-r9,\n.slds-icon-waffle--container:focus .slds-r9{\n  animation:slds-icon-waffle-throb 2 200ms alternate;\n}\n.slds-icon-waffle_container:hover .slds-r1,.slds-icon-waffle--container:hover .slds-r1,\n.slds-icon-waffle_container:hover .slds-r2,\n.slds-icon-waffle--container:hover .slds-r2,\n.slds-icon-waffle_container:hover .slds-r3,\n.slds-icon-waffle--container:hover .slds-r3,\n.slds-icon-waffle_container:focus .slds-r1,\n.slds-icon-waffle--container:focus .slds-r1,\n.slds-icon-waffle_container:focus .slds-r2,\n.slds-icon-waffle--container:focus .slds-r2,\n.slds-icon-waffle_container:focus .slds-r3,\n.slds-icon-waffle--container:focus .slds-r3{\n  background-color:var(--slds-g-color-brand-base-50, #418fde);\n}\n.slds-icon-waffle_container:hover .slds-r4,.slds-icon-waffle--container:hover .slds-r4,\n.slds-icon-waffle_container:hover .slds-r5,\n.slds-icon-waffle--container:hover .slds-r5,\n.slds-icon-waffle_container:hover .slds-r7,\n.slds-icon-waffle--container:hover .slds-r7,\n.slds-icon-waffle_container:focus .slds-r4,\n.slds-icon-waffle--container:focus .slds-r4,\n.slds-icon-waffle_container:focus .slds-r5,\n.slds-icon-waffle--container:focus .slds-r5,\n.slds-icon-waffle_container:focus .slds-r7,\n.slds-icon-waffle--container:focus .slds-r7{\n  background-color:var(--slds-g-color-warning-base-70, #ed8b00);\n}\n.slds-icon-waffle_container:hover .slds-r6,.slds-icon-waffle--container:hover .slds-r6,\n.slds-icon-waffle_container:hover .slds-r8,\n.slds-icon-waffle--container:hover .slds-r8,\n.slds-icon-waffle_container:hover .slds-r9,\n.slds-icon-waffle--container:hover .slds-r9,\n.slds-icon-waffle_container:focus .slds-r6,\n.slds-icon-waffle--container:focus .slds-r6,\n.slds-icon-waffle_container:focus .slds-r8,\n.slds-icon-waffle--container:focus .slds-r8,\n.slds-icon-waffle_container:focus .slds-r9,\n.slds-icon-waffle--container:focus .slds-r9{\n  background-color:var(--slds-g-color-palette-yellow-80, #ffb60f);\n}\n.slds-icon-waffle_container:hover .slds-r2,.slds-icon-waffle--container:hover .slds-r2,\n.slds-icon-waffle_container:hover .slds-r4,\n.slds-icon-waffle--container:hover .slds-r4,\n.slds-icon-waffle_container:focus .slds-r2,\n.slds-icon-waffle--container:focus .slds-r2,\n.slds-icon-waffle_container:focus .slds-r4,\n.slds-icon-waffle--container:focus .slds-r4{\n  transition-delay:50ms;\n  animation-delay:50ms;\n}\n.slds-icon-waffle_container:hover .slds-r3,.slds-icon-waffle--container:hover .slds-r3,\n.slds-icon-waffle_container:hover .slds-r5,\n.slds-icon-waffle--container:hover .slds-r5,\n.slds-icon-waffle_container:hover .slds-r7,\n.slds-icon-waffle--container:hover .slds-r7,\n.slds-icon-waffle_container:focus .slds-r3,\n.slds-icon-waffle--container:focus .slds-r3,\n.slds-icon-waffle_container:focus .slds-r5,\n.slds-icon-waffle--container:focus .slds-r5,\n.slds-icon-waffle_container:focus .slds-r7,\n.slds-icon-waffle--container:focus .slds-r7{\n  transition-delay:100ms;\n  animation-delay:100ms;\n}\n.slds-icon-waffle_container:hover .slds-r6,.slds-icon-waffle--container:hover .slds-r6,\n.slds-icon-waffle_container:hover .slds-r8,\n.slds-icon-waffle--container:hover .slds-r8,\n.slds-icon-waffle_container:focus .slds-r6,\n.slds-icon-waffle--container:focus .slds-r6,\n.slds-icon-waffle_container:focus .slds-r8,\n.slds-icon-waffle--container:focus .slds-r8{\n  transition-delay:150ms;\n  animation-delay:150ms;\n}\n.slds-icon-waffle_container:hover .slds-r9,.slds-icon-waffle--container:hover .slds-r9,\n.slds-icon-waffle_container:focus .slds-r9,\n.slds-icon-waffle--container:focus .slds-r9{\n  transition-delay:200ms;\n  animation-delay:200ms;\n}\n.slds-icon-waffle{\n  width:1.3125rem;\n  height:1.3125rem;\n  position:relative;\n  display:block;\n  cursor:pointer;\n}\n.slds-icon-waffle .slds-r1,\n.slds-icon-waffle .slds-r2,\n.slds-icon-waffle .slds-r3,\n.slds-icon-waffle .slds-r4,\n.slds-icon-waffle .slds-r5,\n.slds-icon-waffle .slds-r6,\n.slds-icon-waffle .slds-r7,\n.slds-icon-waffle .slds-r8,\n.slds-icon-waffle .slds-r9{\n  width:0.3125rem;\n  height:0.3125rem;\n  background-color:var(--slds-g-color-neutral-base-50, #747474);\n  display:inline-block;\n  position:absolute;\n  border-radius:50%;\n  transition:background-color 100ms;\n  transform-origin:50% 50%;\n  will-change:scale, background-color;\n}\n.slds-icon-waffle .slds-r1{\n  top:0;\n  left:0;\n  transition-delay:200ms;\n}\n.slds-icon-waffle .slds-r2{\n  top:0;\n  left:0.5rem;\n}\n.slds-icon-waffle .slds-r3{\n  top:0;\n  right:0;\n}\n.slds-icon-waffle .slds-r4{\n  top:0.5rem;\n  left:0;\n}\n.slds-icon-waffle .slds-r5{\n  top:0.5rem;\n  left:0.5rem;\n}\n.slds-icon-waffle .slds-r6{\n  top:0.5rem;\n  right:0;\n}\n.slds-icon-waffle .slds-r7{\n  bottom:0;\n  left:0;\n}\n.slds-icon-waffle .slds-r8{\n  bottom:0;\n  left:0.5rem;\n}\n.slds-icon-waffle .slds-r9{\n  bottom:0;\n  right:0;\n}\n.slds-icon-waffle .slds-r2,\n.slds-icon-waffle .slds-r4{\n  transition-delay:150ms;\n}\n.slds-icon-waffle .slds-r3,\n.slds-icon-waffle .slds-r5,\n.slds-icon-waffle .slds-r7{\n  transition-delay:100ms;\n}\n.slds-icon-waffle .slds-r6,\n.slds-icon-waffle .slds-r8{\n  transition-delay:50ms;\n}\n@keyframes slds-icon-waffle-throb{\n  to{\n    transform:scale(1.5);\n  }\n}\n.slds-expression__options{\n  width:var(--slds-g-sizing-14);\n}\n.slds-expression__options .slds-form-element__control{\n  clear:none;\n}\n.slds-expression__legend{\n  float:left;\n  width:var(--slds-g-sizing-10);\n  padding-top:calc((var(--slds-g-font-lineheight-base) * var(--slds-g-font-scale-neg-1)) + (1.875rem / 4));\n  font-weight:var(--slds-g-font-weight-7);\n}\n.slds-expression__legend.slds-expression__legend_group,.slds-expression__legend.slds-expression__legend--group{\n  margin-top:0;\n}\n.slds-expression__row{\n  margin-top:var(--slds-g-spacing-3);\n}\n.slds-expression__row.slds-expression__row_group,.slds-expression__row.slds-expression__row--group{\n  padding-left:var(--slds-g-spacing-8);\n}\n.slds-expression__row .slds-form-element__label{\n  line-height:1.5;\n}\n.slds-expression__buttons{\n  margin-top:var(--slds-g-spacing-3);\n}\n.slds-expression__group{\n  background:var(--slds-g-color-surface-2);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n  padding:var(--slds-g-spacing-3);\n  margin-top:var(--slds-g-spacing-3);\n}\n.slds-expression__title{\n  font-size:var(--slds-g-font-scale-3);\n  font-weight:bold;\n  margin-bottom:var(--slds-g-spacing-2);\n}\n.slds-expression__custom-logic{\n  margin-top:var(--slds-g-spacing-3);\n}\n.slds-filters{\n  position:relative;\n}\n.slds-filters__header{\n  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-3);\n}\n.slds-filters__body{\n  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-3);\n}\n.slds-filters__footer{\n  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-4);\n}\n.slds-filters__item{\n  padding:var(--slds-g-spacing-3);\n  background:var(--slds-g-color-surface-1);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n}\n.slds-filters__item.slds-is-new{\n  background:var(--slds-g-color-palette-yellow-90);\n  color:var(--slds-g-color-neutral-base-10, var(--slds-g-color-on-surface-2));\n}\n.slds-filters__item.slds-has-error{\n  border-color:var(--slds-g-color-border-error-1);\n}\n.slds-filters__item.slds-is-locked{\n  background:var(--slds-g-color-surface-2);\n}\n.slds-filters__item + .slds-filters__item{\n  margin-top:var(--slds-g-spacing-2);\n}\n.slds-filters__item:hover{\n  background:var(--slds-g-color-surface-2);\n}\n.slds-filters__group{\n  background:var(--slds-g-color-surface-2);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n  padding:var(--slds-g-spacing-3);\n}\n.slds-expression_formula__rte,.slds-expression--formula__rte{\n  margin-block-start:var(--slds-g-spacing-3);\n}\n.slds-global-header_container,.slds-global-header--container{\n  --_slds-c-globalheader-logo:var(--lwc-brandLogoImage, url(../public/images/logo.svg));\n\n  /* position:fixed; */\n  width:100%;\n  top:0;\n  left:0;\n  z-index:100;\n}\n.slds-global-header_container .slds-assistive-text_focus,.slds-global-header--container .slds-assistive-text--focus{\n  top:0;\n  color:var(--slds-g-color-on-surface-1);\n  background:var(--slds-g-color-surface-container-1);\n}\n.slds-global-header{\n  background:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-g-shadow-1);\n  padding:var(--slds-g-spacing-2) 0;\n  height:var(--slds-s-header-sizing-height, 3.125rem);\n  align-items:center;\n}\n.slds-global-header .slds-global-search__form-element .slds-input{\n  padding-inline-start:calc(var(--slds-g-spacing-5) * 2);\n}\n.slds-global-header .slds-global-search__form-element .slds-input__icon_left,.slds-global-header .slds-global-search__form-element .slds-input__icon--left{\n  left:calc(var(--slds-g-spacing-4) + var(--slds-g-spacing-1));\n}\n.slds-global-header .slds-global-search__form-element .slds-icon{\n  fill:var(--slds-g-color-on-surface-1);\n}\n.slds-global-header__item{\n  padding:0 var(--slds-g-spacing-4);\n}\n.slds-global-header__item_search,.slds-global-header__item--search{\n  flex:0 1 33.5rem;\n  min-width:27.5rem;\n  padding:0;\n}\n.slds-global-header__item_search .slds-button,.slds-global-header__item--search .slds-button{\n  width:100%;\n  cursor:text;\n  justify-content:flex-start;\n\n  --slds-c-button-color-background-hover:var(--slds-g-color-surface-container-1);\n  --slds-c-button-color-background-active:var(--slds-g-color-surface-container-1);\n  --slds-c-button-text-color:var(--slds-g-color-neutral-base-60);\n  --slds-c-button-text-color-hover:var(--slds-g-color-neutral-base-60);\n  --slds-c-button-text-color-active:var(--slds-g-color-neutral-base-60);\n}\n.slds-global-header__item_search .slds-icon,.slds-global-header__item--search .slds-icon{\n  fill:var(--_slds-c-globalheader-color);\n}\n.slds-global-header__logo{\n  width:12.5rem;\n  height:2.5rem;\n  background-image:var(--_slds-c-globalheader-logo);\n  background-size:contain;\n  background-repeat:no-repeat;\n  background-position:left center;\n}\n.slds-global-header__notification{\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  padding:var(--slds-g-spacing-1);\n}\n.slds-global-header__notification:hover{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-global-header__notification:last-child{\n  border-block-end:0;\n}\n.slds-global-header__notification_unread,.slds-global-header__notification--unread{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-global-actions{\n  display:flex;\n  align-items:center;\n}\n.slds-global-actions__item{\n  margin-inline-start:var(--slds-g-spacing-2);\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-global-actions__item .slds-button__icon{\n  fill:var(--_slds-c-globalheader-color);\n  color:var(--_slds-c-globalheader-color);\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n}\n.slds-global-actions__item-action{\n  transition:color 200ms linear;\n}\n.slds-global-actions__item-action .slds-icon{\n  fill:var(--_slds-c-globalheader-color);\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n}\n.slds-global-actions__item-action:hover:not(:disabled) .slds-icon,\n.slds-global-actions__item-action:focus .slds-icon{\n  fill:var(--_slds-c-globalheader-color-hover);\n}\n.slds-global-actions__item-action:active{\n  box-shadow:none;\n}\n.slds-global-actions__item-action:active .slds-icon{\n  animation:click-icon 120ms cubic-bezier(1, 1.9, 0.94, 0.98);\n}\n.slds-global-actions__item-action:active:not(:disabled) .slds-icon{\n  fill:var(--_slds-c-globalheader-color-hover);\n}\n.slds-global-actions__item_help,.slds-global-actions__item--help,\n.slds-global-actions__item_notification,\n.slds-global-actions__item--notification{\n  margin-inline:var(--slds-g-spacing-1);\n}\n.slds-global-actions__item_notification .slds-icon,.slds-global-actions__item--notification .slds-icon{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n}\n@keyframes click-icon{\n  25%{\n    transform:scale(0.94, 0.94);\n  }\n\n  100%{\n    transform:scale(0.98, 0.98);\n  }\n}\n.slds-global-actions__avatar{\n  box-shadow:var(--_slds-c-globalheader-color) 0 0 0 0;\n  border-radius:var(--slds-g-radius-border-circle);\n  border:0;\n  margin-inline-start:var(--slds-g-spacing-2);\n  padding:0;\n  overflow:hidden;\n  transition:transform 80ms ease-out, box-shadow 0.1s linear;\n}\n.slds-global-actions__avatar:hover,\n.slds-global-actions__avatar:focus{\n  box-shadow:var(--_slds-c-globalheader-color) 0 0 0 2px;\n}\n.slds-global-actions__favorites{\n  display:inline-flex;\n}\n.slds-global-actions__favorites-action{\n  border-color:var(--_slds-c-globalheader-color);\n  width:auto;\n  padding-inline-end:var(--slds-g-spacing-1);\n  padding-inline-start:var(--slds-g-spacing-1);\n}\n.slds-global-actions__favorites-action:hover{\n  border-color:var(--_slds-c-globalheader-color-hover);\n}\n.slds-global-actions__favorites-action .slds-button__icon{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  transition:transform 200ms ease-out;\n}\n.slds-global-actions__favorites-action:hover:not(:disabled) .slds-button__icon{\n  transform:scale(1.1, 1.1);\n  transform-origin:60% 40%;\n}\n.slds-global-actions__favorites-action.slds-is-selected{\n  background-color:var(--slds-g-color-accent-container-2);\n  border-color:var(--slds-g-color-accent-container-2);\n}\n.slds-global-actions__favorites-action.slds-is-selected:hover,\n.slds-global-actions__favorites-action.slds-is-selected:focus{\n  background-color:var(--slds-g-color-accent-container-3);\n  border-color:var(--slds-g-color-accent-container-3);\n}\n.slds-global-actions__favorites-action.slds-is-selected .slds-button__icon{\n  animation:click-favorites-icon 600ms cubic-bezier(0.46, 0.32, 0, 0.98);\n}\n.slds-global-actions__favorites-action:disabled,\n.slds-global-actions__favorites-action.slds-is-disabled{\n  color:var(--slds-g-color-disabled-2);\n  border-color:var(--slds-g-color-border-1);\n}\n.slds-global-actions__favorites-more{\n  width:auto;\n  padding-inline-start:var(--slds-g-spacing-1);\n  padding-inline-end:var(--slds-g-spacing-1);\n  border-color:var(--_slds-c-globalheader-color);\n}\n.slds-global-actions__favorites-more .slds-icon{\n  width:var(--slds-g-sizing-4);\n  height:var(--slds-g-sizing-4);\n}\n.slds-global-actions__favorites-more:hover{\n  border-color:var(--_slds-c-globalheader-color-hover);\n}\n@keyframes click-favorites-icon{\n  25%{\n    transform:scale(0.85, 0.85) rotate(15deg);\n  }\n\n  75%{\n    transform:scale(1.2, 1.2) rotate(0deg);\n  }\n\n  100%{\n    transform:scale(1, 1) rotate(0deg);\n  }\n}\n.slds-global-actions__task{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n  background:var(--_slds-c-globalheader-color);\n  position:relative;\n  top:-1px;\n}\n.slds-global-actions__task:hover,\n.slds-global-actions__task:active{\n  background:var(--_slds-c-globalheader-color-hover);\n}\n.slds-global-actions__task:not(:disabled) .slds-icon,\n.slds-global-actions__task:not(:disabled):hover .slds-icon,\n.slds-global-actions__task:not(:disabled):active .slds-icon{\n  fill:var(--slds-g-color-neutral-base-100);\n}\n.slds-global-actions__task .slds-button__icon,\n.slds-global-actions__task .slds-icon{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n}\n.slds-global-actions__notifications{\n  position:relative;\n}\n.slds-global-actions__notifications.slds-incoming-notification{\n  animation:bell 0.8s ease-in-out;\n}\n.slds-notification-badge{\n  display:inline-flex;\n  justify-content:center;\n  align-content:center;\n  align-items:center;\n  position:absolute;\n  top:calc(6px * -1);\n  right:calc(4px * -1);\n  background:var(--slds-g-color-palette-red-50);\n  color:var(--slds-g-color-neutral-base-100);\n  border-radius:var(--slds-g-radius-border-circle);\n  min-width:var(--slds-g-sizing-5);\n  min-height:var(--slds-g-sizing-5);\n  text-align:center;\n  font-size:var(--slds-g-font-scale-neg-2);\n  padding:0 0.125rem;\n  opacity:0;\n  pointer-events:none;\n}\n.slds-notification-badge.slds-show-notification{\n  animation:ding 0.8s ease-out;\n  opacity:1;\n  transition-delay:0.5s;\n  transform-origin:1.1875rem 0;\n}\n@keyframes ding{\n  75%{\n    transform:scale(0.5, 0.5);\n  }\n\n  85%{\n    transform:scale(1.5, 1.5);\n  }\n\n  100%{\n    transform:scale(1, 1);\n  }\n}\n@keyframes bell{\n  45%{\n    transform:rotate(15deg);\n  }\n\n  57%{\n    transform:rotate(-15deg);\n  }\n\n  70%{\n    transform:rotate(7deg);\n  }\n\n  77%{\n    transform:rotate(-5deg);\n  }\n}\n.slds-app-launcher__tile{\n  display:flex;\n  align-items:stretch;\n  margin:var(--slds-g-spacing-2) 0;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n  cursor:move;\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-app-launcher__tile:hover,\n.slds-app-launcher__tile:focus,\n.slds-app-launcher__tile:active{\n  outline:0;\n  border-color:var(--slds-g-color-border-accent-3);\n}\n.slds-app-launcher__tile.slds-is-draggable .slds-app-launcher__tile-figure{\n  padding-block-end:var(--slds-g-spacing-1);\n}\n.slds-app-launcher__tile.slds-is-grabbed{\n  transform:rotate(3deg);\n}\n.slds-app-launcher__tile-figure{\n  display:flex;\n  flex-direction:column;\n  flex-shrink:0;\n  padding:var(--slds-g-spacing-3);\n  color:var(--slds-g-color-on-surface-inverse-1);\n  border-start-start-radius:var(--slds-g-radius-border-2);\n  border-start-end-radius:0;\n  border-end-start-radius:var(--slds-g-radius-border-2);\n  border-end-end-radius:0;\n  text-align:center;\n\n  --slds-c-avatar-radius-border:var(--slds-g-radius-border-2);\n}\n.slds-app-launcher__tile-body{\n  flex:1 1 auto;\n  background:var(--slds-g-color-surface-container-2);\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline:var(--slds-g-spacing-3);\n  border-start-start-radius:0;\n  border-start-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:0;\n  border-end-end-radius:var(--slds-g-radius-border-2);\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-app-launcher .slds-modal__header .slds-modal__close .slds-button__icon{\n  fill:var(--slds-g-color-on-surface-1);\n}\n.slds-app-launcher .slds-app-launcher__header-search .slds-input-has-icon .slds-input__icon{\n  fill:var(--slds-g-color-on-surface-1);\n}\n.slds-app-launcher .slds-app-launcher__tile-figure .slds-button__icon{\n  fill:var(--slds-g-color-on-surface-1);\n}\n.slds-app-launcher__content{\n  flex:1 1 auto;\n}\n.slds-app-launcher__content .slds-section__title-action{\n  background:transparent;\n}\n.slds-progress-bar{\n  appearance:none;\n  display:block;\n  width:100%;\n  height:var(--slds-g-sizing-3);\n  background-color:var(--slds-g-color-surface-container-3);\n  border:0;\n  position:relative;\n}\n.slds-progress-bar_x-small,.slds-progress-bar--x-small{\n  height:var(--slds-g-sizing-1);\n}\n.slds-progress-bar_small,.slds-progress-bar--small{\n  height:var(--slds-g-sizing-2);\n}\n.slds-progress-bar_medium,.slds-progress-bar--medium{\n  height:var(--slds-g-sizing-3);\n}\n.slds-progress-bar_large,.slds-progress-bar--large{\n  height:var(--slds-g-sizing-4);\n}\n.slds-progress-bar_circular,.slds-progress-bar--circular{\n  border-radius:var(--slds-g-radius-border-pill);\n}\n.slds-progress-bar_circular .slds-progress-bar__value,.slds-progress-bar--circular .slds-progress-bar__value{\n  border-radius:var(--slds-g-radius-border-pill);\n}\n.slds-progress-bar__value{\n  display:block;\n  background-color:var(--slds-g-color-accent-container-1);\n  height:100%;\n}\n.slds-progress-bar__value_success,.slds-progress-bar__value--success{\n  background-color:var(--slds-g-color-success-1);\n}\n.slds-progress-bar_vertical,.slds-progress-bar--vertical{\n  height:100%;\n  width:var(--slds-g-sizing-3);\n}\n.slds-progress-bar_vertical.slds-progress-bar_x-small,.slds-progress-bar--vertical.slds-progress-bar--x-small{\n  width:var(--slds-g-sizing-1);\n}\n.slds-progress-bar_vertical.slds-progress-bar_small,.slds-progress-bar--vertical.slds-progress-bar--small{\n  width:var(--slds-g-sizing-2);\n}\n.slds-progress-bar_vertical.slds-progress-bar_medium,.slds-progress-bar--vertical.slds-progress-bar--medium{\n  width:var(--slds-g-sizing-3);\n}\n.slds-progress-bar_vertical.slds-progress-bar_large,.slds-progress-bar--vertical.slds-progress-bar--large{\n  width:var(--slds-g-sizing-4);\n}\n.slds-progress{\n  position:relative;\n  max-width:70%;\n  width:100%;\n  flex:1 1 auto;\n  margin:auto;\n}\n.slds-progress .slds-progress-bar{\n  position:absolute;\n  inset-block-start:50%;\n  margin-block-start:-0.0625rem;\n}\n.slds-progress_shade .slds-progress__item.slds-is-completed .slds-progress__marker,.slds-progress--shade .slds-progress__item.slds-is-completed .slds-progress__marker,\n.slds-progress_shade .slds-progress__item.slds-is-active .slds-progress__marker,\n.slds-progress--shade .slds-progress__item.slds-is-active .slds-progress__marker{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-progress_shade .slds-progress__item.slds-is-completed .slds-progress__marker_icon,.slds-progress--shade .slds-progress__item.slds-is-completed .slds-progress__marker--icon{\n  border-color:var(--slds-g-color-surface-container-2);\n}\n.slds-progress_shade .slds-progress__item.slds-is-active .slds-progress__marker,.slds-progress--shade .slds-progress__item.slds-is-active .slds-progress__marker{\n  box-shadow:var(--slds-g-color-surface-container-2) 0 0 0 var(--slds-g-sizing-2);\n}\n.slds-progress_shade .slds-progress__item.slds-is-active .slds-progress__marker:focus,.slds-progress--shade .slds-progress__item.slds-is-active .slds-progress__marker:focus{\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-progress_shade .slds-progress__item.slds-has-error .slds-progress__marker,.slds-progress--shade .slds-progress__item.slds-has-error .slds-progress__marker,\n.slds-progress_shade .slds-progress__item.slds-has-error .slds-progress__marker:hover,\n.slds-progress--shade .slds-progress__item.slds-has-error .slds-progress__marker:hover,\n.slds-progress_shade .slds-progress__item.slds-has-error .slds-progress__marker:focus,\n.slds-progress--shade .slds-progress__item.slds-has-error .slds-progress__marker:focus{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-progress_shade .slds-progress__item .slds-progress__marker,.slds-progress--shade .slds-progress__item .slds-progress__marker{\n  border-color:var(--slds-g-color-surface-container-2);\n}\n.slds-progress__list{\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  height:100%;\n  margin:auto;\n  position:relative;\n  z-index:1;\n}\n.slds-progress__item{\n  display:inline-flex;\n  align-self:center;\n}\n.slds-progress__item.slds-is-completed .slds-progress__marker,\n.slds-progress__item.slds-is-active .slds-progress__marker{\n  background-color:var(--slds-g-color-surface-container-1);\n  border-color:var(--slds-g-color-accent-container-1);\n}\n.slds-progress__item.slds-is-completed .slds-progress__marker_icon,.slds-progress__item.slds-is-completed .slds-progress__marker--icon{\n  border-color:var(--slds-g-color-on-accent-1);\n  color:var(--slds-g-color-accent-container-1);\n}\n.slds-progress__item.slds-is-active .slds-progress__marker{\n  box-shadow:var(--slds-g-color-surface-container-1) 0 0 0 var(--slds-g-sizing-2);\n}\n.slds-progress__item.slds-is-active .slds-progress__marker:hover,\n.slds-progress__item.slds-is-active .slds-progress__marker:focus{\n  border-color:var(--slds-g-color-border-accent-2);\n}\n.slds-progress__item.slds-is-active .slds-progress__marker:focus{\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-progress__item.slds-has-error .slds-progress__marker,\n.slds-progress__item.slds-has-error .slds-progress__marker:hover,\n.slds-progress__item.slds-has-error .slds-progress__marker:focus{\n  color:var(--slds-g-color-error-1);\n  background-color:var(--slds-g-color-surface-container-1);\n  border-color:transparent;\n  box-shadow:none;\n}\n.slds-progress__item.slds-has-error .slds-progress__marker:focus{\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-progress__marker{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  position:relative;\n  border-radius:var(--slds-g-radius-border-circle);\n  background-color:var(--slds-g-color-neutral-base-80);\n  border:var(--slds-g-sizing-2) solid var(--slds-g-color-on-accent-1);\n  vertical-align:middle;\n}\n.slds-progress__marker:focus-visible{\n  outline:none;\n}\n.slds-progress__marker:focus{\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-progress__marker_icon,.slds-progress__marker--icon{\n  width:auto;\n  height:auto;\n  line-height:0;\n}\n.slds-progress__marker_icon .slds-icon_container,.slds-progress__marker--icon .slds-icon--container{\n  line-height:0;\n}\n.slds-progress__marker_icon .slds-icon,.slds-progress__marker--icon .slds-icon{\n  fill:currentColor;\n}\n.slds-progress_vertical,.slds-progress--vertical{\n  max-width:none;\n}\n.slds-progress_vertical .slds-progress__list,.slds-progress--vertical .slds-progress__list{\n  display:block;\n}\n.slds-progress_vertical .slds-progress__item,.slds-progress--vertical .slds-progress__item{\n  position:relative;\n  display:flex;\n  align-items:center;\n  padding:0;\n}\n.slds-progress_vertical .slds-progress__item::before,.slds-progress--vertical .slds-progress__item::before,\n.slds-progress_vertical .slds-progress__item::after,\n.slds-progress--vertical .slds-progress__item::after{\n  content:'';\n  position:absolute;\n  inset-inline-start:calc((var(--slds-g-spacing-4) / 2) - 1px);\n  width:var(--slds-g-sizing-1);\n  background-color:var(--slds-g-color-surface-container-3);\n}\n.slds-progress_vertical .slds-progress__item::before,.slds-progress--vertical .slds-progress__item::before{\n  inset-block-start:0;\n  inset-block-end:50%;\n}\n.slds-progress_vertical .slds-progress__item::after,.slds-progress--vertical .slds-progress__item::after{\n  inset-block-start:50%;\n  inset-block-end:0;\n}\n.slds-progress_vertical .slds-progress__item:first-child::before,.slds-progress--vertical .slds-progress__item:first-child::before,\n.slds-progress_vertical .slds-progress__item:last-child::after,\n.slds-progress--vertical .slds-progress__item:last-child::after{\n  display:none;\n}\n.slds-progress_vertical .slds-progress__item.slds-is-completed::before,.slds-progress--vertical .slds-progress__item.slds-is-completed::before,\n.slds-progress_vertical .slds-progress__item.slds-is-completed::after,\n.slds-progress--vertical .slds-progress__item.slds-is-completed::after,\n.slds-progress_vertical .slds-progress__item.slds-is-active::before,\n.slds-progress--vertical .slds-progress__item.slds-is-active::before,\n.slds-progress_vertical .slds-progress__item.slds-has-error::before,\n.slds-progress--vertical .slds-progress__item.slds-has-error::before{\n  background-color:var(--slds-g-color-accent-container-1);\n}\n.slds-progress_vertical .slds-progress__item_content,.slds-progress--vertical .slds-progress__item--content{\n  flex:1;\n  align-items:center;\n  margin-block-start:var(--slds-g-spacing-3);\n  padding-block-end:var(--slds-g-spacing-3);\n}\n.slds-progress_vertical .slds-progress__list-bordered .slds-progress__item:not(:last-child) .slds-progress__item_content,.slds-progress--vertical .slds-progress__list-bordered .slds-progress__item:not(:last-child) .slds-progress__item--content{\n  border-block-end:var(--slds-g-sizing-border-1) var(--slds-g-color-border-1) solid;\n}\n.slds-progress_vertical .slds-progress__marker,.slds-progress--vertical .slds-progress__marker{\n  display:flex;\n  justify-content:center;\n  margin-inline-end:var(--slds-g-spacing-4);\n  min-width:var(--slds-g-sizing-5);\n  z-index:5;\n}\n.slds-progress_vertical .slds-progress__marker_icon,.slds-progress--vertical .slds-progress__marker--icon{\n  border-inline-end:0;\n  border-inline-start:0;\n}\n.slds-progress_vertical .slds-progress__item.slds-is-completed .slds-progress__marker_icon svg,.slds-progress--vertical .slds-progress__item.slds-is-completed .slds-progress__marker--icon svg{\n  fill:var(--slds-g-color-accent-1);\n}\n.slds-progress_vertical .slds-progress__item.slds-is-completed .slds-progress__marker_icon-success svg,.slds-progress--vertical .slds-progress__item.slds-is-completed .slds-progress__marker--icon-success svg{\n  fill:var(--slds-g-color-success-1);\n}\n.slds-progress_vertical .slds-progress__item.slds-has-error .slds-progress__marker_icon svg,.slds-progress--vertical .slds-progress__item.slds-has-error .slds-progress__marker--icon svg{\n  fill:var(--slds-g-color-error-1);\n}\n.slds-progress_success .slds-progress__item.slds-is-completed::before,.slds-progress--success .slds-progress__item.slds-is-completed::before,\n.slds-progress_success .slds-progress__item.slds-is-completed::after,\n.slds-progress--success .slds-progress__item.slds-is-completed::after,\n.slds-progress_success .slds-progress__item.slds-is-active::before,\n.slds-progress--success .slds-progress__item.slds-is-active::before,\n.slds-progress_success .slds-progress__item.slds-has-error::before,\n.slds-progress--success .slds-progress__item.slds-has-error::before{\n  opacity:0.3;\n  background-color:var(--slds-g-color-success-1);\n}\n.slds-progress-ring{\n  position:relative;\n  display:inline-block;\n  height:var(--slds-g-sizing-7);\n  width:var(--slds-g-sizing-7);\n  border-radius:var(--slds-g-sizing-7);\n  background-color:var(--slds-g-color-surface-container-3);\n}\n.slds-progress-ring .slds-icon_container,.slds-progress-ring .slds-icon--container{\n  line-height:0;\n}\n.slds-progress-ring__progress{\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-start:0;\n  height:100%;\n  width:100%;\n  transform:scale(-1, 1) rotate(-90deg);\n}\n.slds-progress-ring__progress svg{\n  width:100%;\n}\n.slds-progress-ring__path{\n  fill:var(--slds-g-color-success-1);\n}\n.slds-progress-ring__progress-head{\n  position:absolute;\n  height:calc(100% + 0.375rem);\n  width:calc(100% + 0.375rem);\n  inset-block-start:-0.1875rem;\n  inset-inline-start:-0.1875rem;\n  transform:scale(-1, 1) rotate(-90deg);\n}\n.slds-progress-ring__progress-head svg{\n  width:100%;\n}\n.slds-progress-ring__content{\n  position:absolute;\n  inset-block-start:0.1875rem;\n  inset-inline-end:0.1875rem;\n  inset-block-end:0.1875rem;\n  inset-inline-start:0.1875rem;\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  border-radius:var(--slds-g-sizing-7);\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-progress-ring__content .slds-icon{\n  width:var(--slds-g-sizing-4);\n}\n.slds-progress-ring_warning .slds-progress-ring__content,.slds-progress-ring--warning .slds-progress-ring__content{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-progress-ring_warning .slds-icon,.slds-progress-ring--warning .slds-icon,\n.slds-progress-ring_warning .slds-progress-ring__path,\n.slds-progress-ring--warning .slds-progress-ring__path{\n  fill:var(--slds-g-color-warning-1);\n}\n.slds-progress-ring_expired .slds-progress-ring__content,.slds-progress-ring--expired .slds-progress-ring__content{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-progress-ring_expired .slds-icon,.slds-progress-ring--expired .slds-icon,\n.slds-progress-ring_expired .slds-progress-ring__path,\n.slds-progress-ring--expired .slds-progress-ring__path{\n  fill:var(--slds-g-color-error-1);\n}\n.slds-progress-ring_complete .slds-icon,.slds-progress-ring--complete .slds-icon{\n  fill:var(--slds-g-color-surface-container-1);\n}\n.slds-progress-ring_complete .slds-progress-ring__path,.slds-progress-ring--complete .slds-progress-ring__path{\n  fill:var(--slds-g-color-success-1);\n}\n.slds-progress-ring_complete .slds-progress-ring__content,.slds-progress-ring--complete .slds-progress-ring__content{\n  background-color:var(--slds-g-color-success-1);\n}\n.slds-progress-ring_large,.slds-progress-ring--large{\n  height:var(--slds-g-sizing-9);\n  width:var(--slds-g-sizing-9);\n}\n.slds-progress-ring_large .slds-icon,.slds-progress-ring--large .slds-icon{\n  width:var(--slds-g-sizing-5);\n}\n.slds-progress-ring_active-step .slds-progress-ring__path,.slds-progress-ring--active-step .slds-progress-ring__path{\n  fill:var(--slds-g-color-accent-1);\n}\n.slds-visual-picker{\n  display:inline-flex;\n  position:relative;\n  flex-direction:column;\n  border:0;\n  border-radius:0;\n  text-align:center;\n  cursor:pointer;\n}\n.slds-visual-picker + .slds-visual-picker{\n  margin-inline-start:var(--slds-g-spacing-4);\n}\n.slds-visual-picker:active .slds-visual-picker__figure{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);\n  box-shadow:0 0 0 1px var(--slds-g-color-accent-1) inset;\n}\n.slds-visual-picker:hover .slds-visual-picker__figure{\n  cursor:pointer;\n}\n.slds-visual-picker input:not(:disabled) ~ label:hover .slds-visual-picker__figure{\n  cursor:pointer;\n  outline:0;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);\n  box-shadow:0 0 0 1px var(--slds-g-color-accent-1) inset;\n}\n.slds-visual-picker input{\n  width:1px;\n  height:1px;\n  border:0;\n  clip:rect(0 0 0 0);\n  margin:-1px;\n  overflow:hidden;\n  padding:0;\n  position:absolute;\n}\n.slds-visual-picker input:focus-visible ~ label .slds-visual-picker__figure{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);\n  box-shadow:var(--slds-s-button-shadow-focus);\n  outline:0;\n}\n.slds-visual-picker input:checked ~ label .slds-visual-picker__figure{\n  box-shadow:var(--slds-s-container-shadow);\n}\n.slds-visual-picker input:checked:focus-visible ~ label .slds-visual-picker__figure{\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-visual-picker input:checked ~ label .slds-is-not-selected{\n  display:none;\n}\n.slds-visual-picker input:checked ~ label .slds-is-selected{\n  display:block;\n}\n.slds-visual-picker input:checked ~ label .slds-visual-picker__icon{\n  background-color:var(--slds-g-color-accent-1);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);\n}\n.slds-visual-picker input:checked ~ label .slds-visual-picker__text{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-accent-1);\n  box-shadow:0 0 0 1px var(--slds-g-color-accent-1) inset;\n}\n.slds-visual-picker input:checked ~ label .slds-visual-picker__text::after{\n  content:'';\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-end:0;\n  border-color:transparent;\n  border-style:solid;\n  border-radius:0 var(--slds-g-radius-border-2) 0 0;\n  border-width:1rem;\n  border-inline-end-color:var(--slds-g-color-accent-1);\n  border-block-start-color:var(--slds-g-color-accent-1);\n}\n.slds-visual-picker input:disabled{\n  cursor:not-allowed;\n  user-select:none;\n}\n.slds-visual-picker input:disabled ~ label .slds-visual-picker__body,\n.slds-visual-picker input:disabled ~ label .slds-visual-picker__text,\n.slds-visual-picker input:disabled ~ label .slds-visual-picker__text .slds-text-title{\n  color:var(--slds-g-color-on-disabled-2);\n}\n.slds-visual-picker input:disabled ~ label .slds-visual-picker__figure .slds-icon{\n  fill:var(--slds-g-color-on-disabled-2);\n}\n.slds-visual-picker input:disabled ~ label .slds-visual-picker__figure{\n  border-color:var(--slds-g-color-disabled-1);\n  background-color:var(--slds-g-color-disabled-container-2);\n  box-shadow:none;\n}\n.slds-visual-picker input:disabled ~ label .slds-visual-picker__figure:hover{\n  cursor:not-allowed;\n  user-select:none;\n  box-shadow:none;\n}\n.slds-visual-picker__figure{\n  display:block;\n  background:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-s-container-shadow, var(--slds-g-shadow-2));\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n  text-align:center;\n  font-weight:var(--slds-s-container-heading-font-weight);\n}\n.slds-visual-picker__figure .slds-icon-action-check{\n  background-color:var(--slds-g-color-accent-1);\n}\n.slds-visual-picker__figure span{\n  display:block;\n}\n.slds-visual-picker__figure .slds-is-selected{\n  display:none;\n}\n.slds-visual-picker_medium .slds-visual-picker__figure,.slds-visual-picker--medium .slds-visual-picker__figure,\n.slds-visual-picker_medium .slds-visual-picker__body,\n.slds-visual-picker--medium .slds-visual-picker__body{\n  width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));\n}\n.slds-visual-picker_medium .slds-visual-picker__figure,.slds-visual-picker--medium .slds-visual-picker__figure{\n  height:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));\n}\n.slds-visual-picker_large .slds-visual-picker__figure,.slds-visual-picker--large .slds-visual-picker__figure,\n.slds-visual-picker_large .slds-visual-picker__body,\n.slds-visual-picker--large .slds-visual-picker__body{\n  width:var(--slds-g-sizing-14);\n}\n.slds-visual-picker_large .slds-visual-picker__figure,.slds-visual-picker--large .slds-visual-picker__figure{\n  height:var(--slds-g-sizing-14);\n}\n.slds-visual-picker_small .slds-visual-picker__figure,.slds-visual-picker--small .slds-visual-picker__figure,\n.slds-visual-picker_small .slds-visual-picker__body,\n.slds-visual-picker--small .slds-visual-picker__body{\n  width:calc(var(--slds-g-sizing-13) - var(--slds-g-sizing-7));\n}\n.slds-visual-picker_small .slds-visual-picker__figure,.slds-visual-picker--small .slds-visual-picker__figure{\n  height:calc(var(--slds-g-sizing-13) - var(--slds-g-sizing-7));\n}\n.slds-visual-picker__body{\n  display:flex;\n  flex-direction:column;\n  background:transparent;\n  padding-block:var(--slds-g-spacing-4);\n  padding-inline:var(--slds-g-spacing-2);\n  border:0;\n  border-radius:0;\n}\n.slds-visual-picker__text-check{\n  position:absolute;\n  inset-block-start:0.1rem;\n  inset-inline-end:0.625rem;\n  width:var(--slds-g-sizing-3);\n  height:var(--slds-g-sizing-3);\n}\n.slds-visual-picker input[disabled] ~ label .slds-visual-picker__text-check{\n  opacity:0;\n}\n.slds-visual-picker_vertical,.slds-visual-picker--vertical{\n  width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-14));\n  display:flex;\n}\n.slds-visual-picker_vertical .slds-visual-picker__figure,.slds-visual-picker--vertical .slds-visual-picker__figure{\n  text-align:left;\n  padding:var(--slds-g-spacing-4);\n  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-11));\n}\n.slds-visual-picker_vertical + .slds-visual-picker_vertical,.slds-visual-picker--vertical + .slds-visual-picker--vertical{\n  margin-inline-start:0;\n  margin-block-start:var(--slds-g-spacing-4);\n}\n.slds-visual-picker_vertical .slds-visual-picker__figure,.slds-visual-picker--vertical .slds-visual-picker__figure,\n.slds-visual-picker_vertical .slds-visual-picker__body,\n.slds-visual-picker--vertical .slds-visual-picker__body{\n  width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-14));\n}\n.slds-rich-text-editor{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-radius:var(--slds-g-radius-border-2);\n}\n.slds-rich-text-editor[aria-label='disabled']{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-rich-text-editor_toolbar-only,.slds-rich-text-editor--toolbar-only{\n  border:0;\n  border-radius:0;\n}\n.slds-rich-text-editor__toolbar{\n  display:flex;\n  flex-wrap:wrap;\n  align-items:flex-start;\n  white-space:nowrap;\n  position:relative;\n  padding-block:var(--slds-g-spacing-2) var(--slds-g-spacing-1);\n  padding-inline:var(--slds-g-spacing-2);\n  border-start-start-radius:var(--slds-g-radius-border-2);\n  border-start-end-radius:var(--slds-g-radius-border-2);\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-rich-text-editor__toolbar .slds-icon{\n  --slds-c-icon-color-foreground:currentColor;\n}\n.slds-rich-text-editor__toolbar[aria-label='disabled']{\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-rich-text-editor__toolbar[aria-label='disabled'] .slds-icon{\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-disabled-2);\n}\n.slds-rich-text-editor__col{\n  align-self:center;\n}\n.slds-rich-text-editor__col + .slds-rich-text-editor__col{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-rich-text-editor__col_grow,.slds-rich-text-editor__col--grow{\n  flex-grow:1;\n}\n.slds-rich-text-editor__toolbar_bottom,.slds-rich-text-editor__toolbar--bottom{\n  border-start-start-radius:0;\n  border-start-end-radius:0;\n  border-end-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:var(--slds-g-radius-border-2);\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-block-end:0;\n}\n.slds-rich-text-editor__toolbar_detached,.slds-rich-text-editor__toolbar--detached{\n  border-radius:0;\n  border-block-start:0;\n  border-block-end:0;\n}\n.slds-rich-text-editor .slds-button-group-list{\n  margin-inline-end:var(--slds-g-spacing-1);\n  margin-block-end:var(--slds-g-spacing-1);\n  margin-inline-start:0;\n}\n.slds-rich-text-editor .slds-button-group-list:last-child{\n  margin-inline-end:0;\n}\n.slds-rich-text-editor__select{\n  margin-inline-end:var(--slds-g-spacing-1);\n  margin-block-end:var(--slds-g-spacing-1);\n}\n.slds-rich-text-editor__select_x-small,.slds-rich-text-editor__select--x-small{\n  max-width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));\n  width:auto;\n}\n.slds-rich-text-editor__select_xx-small,.slds-rich-text-editor__select--xx-small{\n  max-width:calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9));\n  width:auto;\n}\n.slds-region_narrow .slds-combobox,.slds-region--narrow .slds-combobox{\n  max-width:11rem;\n}\n.slds-rich-text-editor.slds-has-focus{\n  border-color:var(--slds-g-color-border-2);\n  box-shadow:var(--slds-s-input-shadow-focus);\n}\n.slds-rich-text-editor.slds-has-error{\n  border:var(--slds-g-sizing-border-2) solid var(--slds-g-color-border-error-1);\n}\n.slds-rich-text-editor.slds-has-error .slds-input{\n  border-color:var(--slds-g-color-border-2);\n  box-shadow:none;\n}\n.slds-rich-text-editor.slds-has-error .slds-form-element__help{\n  background:var(--slds-g-color-surface-container-1);\n  margin-block-start:0;\n  border-start-start-radius:0;\n  border-start-end-radius:0;\n  border-end-end-radius:var(--slds-g-radius-border-1);\n  border-end-start-radius:var(--slds-g-radius-border-1);\n}\n.slds-rich-text-editor.slds-has-error .slds-button_icon,.slds-rich-text-editor.slds-has-error .slds-button--icon{\n  color:var(--slds-s-button-color, var(--slds-g-color-on-surface-1));\n}\n.slds-rich-text-area__content{\n  --_slds-c-richtexteditor-sizing-height-min:var(--slds-c-textarea-sizing-min-height);\n  --_slds-c-richtexteditor-sizing-height-max:var(--slds-c-textarea-sizing-max-height);\n\n  overflow-y:auto;\n  min-height:var(\n    --_slds-c-richtexteditor-sizing-height-min,\n    calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9))\n  );\n  max-height:var(--_slds-c-richtexteditor-sizing-height-max, var(--slds-g-sizing-14));\n  padding:var(--slds-g-spacing-4);\n  background-color:var(--slds-s-input-color-background, var(--slds-g-color-surface-container-1));\n}\n.slds-rich-text-editor__output .slds-rich-text-area__content{\n  border-start-start-radius:0;\n  border-start-end-radius:0;\n  border-end-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:var(--slds-g-radius-border-2);\n}\n.slds-picklist__label[disabled] .slds-icon{\n  fill:var(--slds-g-color-on-disabled-1);\n}\n[contenteditable]:focus{\n  outline:none;\n}\n.slds-rich-text-editor__textarea:last-child .slds-rich-text-area__content{\n  border-start-start-radius:0;\n  border-start-end-radius:0;\n  border-end-end-radius:var(--slds-g-radius-border-2);\n  border-end-start-radius:var(--slds-g-radius-border-2);\n}\n.slds-rich-text-editor__textarea:first-child .slds-rich-text-area__content{\n  border-start-start-radius:var(--slds-g-radius-border-2);\n  border-start-end-radius:var(--slds-g-radius-border-2);\n  border-end-end-radius:0;\n  border-end-start-radius:0;\n}\n.slds-rich-text-editor__textarea .ql-editor{\n  white-space:pre-wrap;\n  word-wrap:break-word;\n  user-select:text;\n}\n.slds-rich-text-editor__textarea .ql-editor.ql-blank::before{\n  color:var(--slds-g-color-on-surface-1, #54698d);\n  content:attr(data-placeholder);\n  pointer-events:none;\n  position:absolute;\n}\n.slds-rich-text-editor__textarea .ql-editor a{\n  text-decoration:underline;\n}\n.slds-rich-text-editor__textarea .overflow-menu{\n  z-index:2;\n}\n.slds-rich-text-editor__textarea .ql-active{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-rich-text-editor__textarea .ql-clipboard{\n  position:absolute !important;\n  margin:-1px !important;\n  border:0 !important;\n  padding:0 !important;\n  width:1px !important;\n  height:1px !important;\n  overflow:hidden !important;\n  clip:rect(0 0 0 0) !important;\n}\n.slds-rich-text-editor__textarea p,\n.slds-rich-text-editor__textarea ol,\n.slds-rich-text-editor__textarea ul,\n.slds-rich-text-editor__textarea pre,\n.slds-rich-text-editor__textarea blockquote,\n.slds-rich-text-editor__textarea h1,\n.slds-rich-text-editor__textarea h2,\n.slds-rich-text-editor__textarea h3,\n.slds-rich-text-editor__textarea h4,\n.slds-rich-text-editor__textarea h5,\n.slds-rich-text-editor__textarea h6{\n  counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.slds-rich-text-editor__textarea ol,\n.slds-rich-text-editor__textarea ul{\n  margin:0;\n  padding:0;\n  padding-inline-start:1.5em;\n}\n.slds-rich-text-editor__textarea ol > li{\n  list-style-type:none;\n}\n.slds-rich-text-editor__textarea ul{\n}\n.slds-rich-text-editor__textarea ul > li{\n  list-style-type:none;\n}\n.slds-rich-text-editor__textarea ul > li::before{\n  content:'\\2022';\n  vertical-align:middle;\n  display:inline-block;\n  line-height:normal;\n}\n.slds-rich-text-editor__textarea ul[data-checked='true'],\n.slds-rich-text-editor__textarea ul[data-checked='false']{\n  pointer-events:none;\n}\n.slds-rich-text-editor__textarea ul[data-checked='true'] > li::before{\n  color:var(--slds-g-color-on-surface-1);\n  cursor:pointer;\n  pointer-events:all;\n}\n.slds-rich-text-editor__textarea ul[data-checked='false'] > li::before{\n  color:var(--slds-g-color-on-surface-1);\n  cursor:pointer;\n  pointer-events:all;\n}\n.slds-rich-text-editor__textarea ul[data-checked='true'] > li::before{\n  content:'\\2611';\n}\n.slds-rich-text-editor__textarea ul[data-checked='false'] > li::before{\n  content:'\\2610';\n}\n.slds-rich-text-editor__textarea li::before{\n  display:inline-block;\n  margin-inline-end:0.3em;\n  text-align:right;\n  white-space:nowrap;\n  width:1.2em;\n}\n.slds-rich-text-editor__textarea li:not(.ql-direction-rtl)::before{\n  margin-inline-start:-1.5em;\n}\n.slds-rich-text-editor__textarea ol li,\n.slds-rich-text-editor__textarea ul li{\n  padding-inline-start:1.5em;\n}\n.slds-rich-text-editor__textarea ol li{\n  counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment:list-num;\n}\n.slds-rich-text-editor__textarea ol li::before{\n  content:counter(list-num, decimal) '. ';\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-1{\n  counter-increment:list-1;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-1::before{\n  content:counter(list-1, lower-alpha) '. ';\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-1{\n\n  counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-2{\n  counter-increment:list-2;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-2::before{\n  content:counter(list-2, lower-roman) '. ';\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-2{\n\n  counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-3{\n  counter-increment:list-3;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-3::before{\n  content:counter(list-3, decimal) '. ';\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-3{\n\n  counter-reset:list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-4{\n  counter-increment:list-4;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-4::before{\n  content:counter(list-4, lower-alpha) '. ';\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-4{\n\n  counter-reset:list-5 list-6 list-7 list-8 list-9;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-5{\n  counter-increment:list-5;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-5::before{\n  content:counter(list-5, lower-roman) '. ';\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-5{\n\n  counter-reset:list-6 list-7 list-8 list-9;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-6{\n  counter-increment:list-6;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-6::before{\n  content:counter(list-6, decimal) '. ';\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-6{\n\n  counter-reset:list-7 list-8 list-9;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-7{\n  counter-increment:list-7;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-7::before{\n  content:counter(list-7, lower-alpha) '. ';\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-7{\n\n  counter-reset:list-8 list-9;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-8{\n  counter-increment:list-8;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-8::before{\n  content:counter(list-8, lower-roman) '. ';\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-8{\n\n  counter-reset:list-9;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-9{\n  counter-increment:list-9;\n}\n.slds-rich-text-editor__textarea ol li.ql-indent-9::before{\n  content:counter(list-9, decimal) '. ';\n}\n.slds-rich-text-editor__textarea ul li.ql-indent-1::before{\n  content:'\\25e6';\n}\n.slds-rich-text-editor__textarea ul li.ql-indent-2::before, .slds-rich-text-editor__textarea ul li.ql-indent-3::before, .slds-rich-text-editor__textarea ul li.ql-indent-4::before, .slds-rich-text-editor__textarea ul li.ql-indent-5::before, .slds-rich-text-editor__textarea ul li.ql-indent-6::before, .slds-rich-text-editor__textarea ul li.ql-indent-7::before, .slds-rich-text-editor__textarea ul li.ql-indent-8::before{\n  content:'\\25aa';\n}\n.slds-rich-text-editor__textarea li.ql-indent-1:not(.ql-direction-rtl){\n  padding-inline-start:4.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-1.ql-direction-rtl.ql-align-right{\n  padding-inline-end:4.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-2:not(.ql-direction-rtl){\n  padding-inline-start:7.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-2.ql-direction-rtl.ql-align-right{\n  padding-inline-end:7.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-3:not(.ql-direction-rtl){\n  padding-inline-start:10.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-3.ql-direction-rtl.ql-align-right{\n  padding-inline-end:10.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-4:not(.ql-direction-rtl){\n  padding-inline-start:13.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-4.ql-direction-rtl.ql-align-right{\n  padding-inline-end:13.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-5:not(.ql-direction-rtl){\n  padding-inline-start:16.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-5.ql-direction-rtl.ql-align-right{\n  padding-inline-end:16.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-6:not(.ql-direction-rtl){\n  padding-inline-start:19.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-6.ql-direction-rtl.ql-align-right{\n  padding-inline-end:19.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-7:not(.ql-direction-rtl){\n  padding-inline-start:22.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-7.ql-direction-rtl.ql-align-right{\n  padding-inline-end:22.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-8:not(.ql-direction-rtl){\n  padding-inline-start:25.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-8.ql-direction-rtl.ql-align-right{\n  padding-inline-end:25.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-9:not(.ql-direction-rtl){\n  padding-inline-start:28.5em;\n}\n.slds-rich-text-editor__textarea li.ql-indent-9.ql-direction-rtl.ql-align-right{\n  padding-inline-end:28.5em;\n}\n.slds-rich-text-editor__textarea,\n.slds-rich-text-editor__output{\n  line-height:var(--slds-g-font-lineheight-base);\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:manual;\n}\n.slds-rich-text-editor__textarea h1, .slds-rich-text-editor__output h1{\n  font-size:var(--slds-g-font-scale-3);\n}\n.slds-rich-text-editor__textarea h2, .slds-rich-text-editor__output h2{\n  font-size:var(--slds-g-font-scale-1);\n  font-weight:var(--slds-g-font-weight-6);\n}\n.slds-rich-text-editor__textarea h3, .slds-rich-text-editor__output h3{\n  font-size:var(--slds-g-font-scale-1);\n}\n.slds-rich-text-editor__textarea h4, .slds-rich-text-editor__output h4{\n  font-size:var(--slds-g-font-scale-neg-1);\n  font-weight:var(--slds-g-font-weight-6);\n}\n.slds-rich-text-editor__textarea h5, .slds-rich-text-editor__output h5{\n  font-size:var(--slds-g-font-scale-neg-1);\n}\n.slds-rich-text-editor__textarea h6, .slds-rich-text-editor__output h6{\n  font-size:var(--slds-g-font-scale-neg-3);\n  font-weight:var(--slds-g-font-weight-6);\n}\n.slds-rich-text-editor__textarea h1,\n.slds-rich-text-editor__textarea h2,\n.slds-rich-text-editor__textarea h3,\n.slds-rich-text-editor__textarea h4,\n.slds-rich-text-editor__textarea h5,\n.slds-rich-text-editor__textarea h6,\n.slds-rich-text-editor__textarea ul,\n.slds-rich-text-editor__textarea ol,\n.slds-rich-text-editor__textarea dl,\n.slds-rich-text-editor__textarea img,\n.slds-rich-text-editor__output h1,\n.slds-rich-text-editor__output h2,\n.slds-rich-text-editor__output h3,\n.slds-rich-text-editor__output h4,\n.slds-rich-text-editor__output h5,\n.slds-rich-text-editor__output h6,\n.slds-rich-text-editor__output ul,\n.slds-rich-text-editor__output ol,\n.slds-rich-text-editor__output dl,\n.slds-rich-text-editor__output img{\n  margin-block-end:var(--slds-g-spacing-3);\n}\n.slds-rich-text-editor__textarea blockquote, .slds-rich-text-editor__output blockquote{\n  margin-block:var(--slds-g-spacing-6);\n  margin-inline:var(--slds-g-spacing-5);\n}\n.slds-rich-text-editor__textarea ins, .slds-rich-text-editor__output ins{\n  color:var(--slds-g-color-success-1);\n  text-decoration:underline;\n}\n.slds-rich-text-editor__textarea del, .slds-rich-text-editor__output del{\n  color:var(--slds-g-color-error-1);\n  text-decoration:line-through;\n}\n.slds-rich-text-editor__textarea ul, .slds-rich-text-editor__output ul{\n  margin-inline-start:var(--slds-g-spacing-5);\n  list-style:disc;\n}\n.slds-rich-text-editor__textarea ul ul, .slds-rich-text-editor__output ul ul{\n  list-style:circle;\n  margin-block-end:0;\n}\n.slds-rich-text-editor__textarea ul ul ul, .slds-rich-text-editor__output ul ul ul{\n  list-style:square;\n}\n.slds-rich-text-editor__textarea ul ul ul ul, .slds-rich-text-editor__output ul ul ul ul{\n  list-style:disc;\n}\n.slds-rich-text-editor__textarea ul ul ul ul ul, .slds-rich-text-editor__output ul ul ul ul ul{\n  list-style:circle;\n}\n.slds-rich-text-editor__textarea ul ol, .slds-rich-text-editor__output ul ol{\n  margin-inline-start:var(--slds-g-spacing-5);\n  list-style:decimal;\n  margin-block-end:0;\n}\n.slds-rich-text-editor__textarea ol, .slds-rich-text-editor__output ol{\n  margin-inline-start:var(--slds-g-spacing-5);\n  list-style:decimal;\n}\n.slds-rich-text-editor__textarea ol ol, .slds-rich-text-editor__output ol ol{\n  list-style:lower-alpha;\n  margin-block-end:0;\n}\n.slds-rich-text-editor__textarea ol ol ol, .slds-rich-text-editor__output ol ol ol{\n  list-style:lower-roman;\n}\n.slds-rich-text-editor__textarea ol ol ol ol, .slds-rich-text-editor__output ol ol ol ol{\n  list-style:decimal;\n}\n.slds-rich-text-editor__textarea ol ol ol ol ol, .slds-rich-text-editor__output ol ol ol ol ol{\n  list-style:lower-alpha;\n}\n.slds-rich-text-editor__textarea ol ul, .slds-rich-text-editor__output ol ul{\n  margin-inline-start:var(--slds-g-spacing-5);\n  list-style:disc;\n  margin-block-end:0;\n}\n.slds-rich-text-editor__textarea dd, .slds-rich-text-editor__output dd{\n  margin-inline-start:2.5rem;\n}\n.slds-rich-text-editor__textarea abbr[title],\n.slds-rich-text-editor__textarea acronym[title],\n.slds-rich-text-editor__output abbr[title],\n.slds-rich-text-editor__output acronym[title]{\n  border-block-end:1px dotted;\n  cursor:help;\n}\n.slds-rich-text-editor__textarea table, .slds-rich-text-editor__output table{\n  overflow-wrap:normal;\n  word-wrap:normal;\n  word-break:normal;\n  width:auto;\n}\n.slds-rich-text-editor__textarea table caption, .slds-rich-text-editor__output table caption{\n  text-align:center;\n}\n.slds-rich-text-editor__textarea th,\n.slds-rich-text-editor__textarea td,\n.slds-rich-text-editor__output th,\n.slds-rich-text-editor__output td{\n  padding:var(--slds-g-spacing-2);\n}\n.slds-rich-text-editor__textarea .sans-serif, .slds-rich-text-editor__output .sans-serif{\n  font-family:sans-serif;\n}\n.slds-rich-text-editor__textarea .courier, .slds-rich-text-editor__output .courier{\n  font-family:courier;\n}\n.slds-rich-text-editor__textarea .verdana, .slds-rich-text-editor__output .verdana{\n  font-family:verdana;\n}\n.slds-rich-text-editor__textarea .tahoma, .slds-rich-text-editor__output .tahoma{\n  font-family:tahoma;\n}\n.slds-rich-text-editor__textarea .garamond, .slds-rich-text-editor__output .garamond{\n  font-family:garamond;\n}\n.slds-rich-text-editor__textarea .serif, .slds-rich-text-editor__output .serif{\n  font-family:serif;\n}\n.slds-rich-text-editor__textarea .ql-indent-1:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-1:not(.ql-direction-rtl){\n  padding-inline-start:3em;\n}\n.slds-rich-text-editor__textarea .ql-indent-1.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-1.ql-direction-rtl.ql-align-right{\n  padding-inline-end:3em;\n}\n.slds-rich-text-editor__textarea .ql-indent-2:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-2:not(.ql-direction-rtl){\n  padding-inline-start:6em;\n}\n.slds-rich-text-editor__textarea .ql-indent-2.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-2.ql-direction-rtl.ql-align-right{\n  padding-inline-end:6em;\n}\n.slds-rich-text-editor__textarea .ql-indent-3:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-3:not(.ql-direction-rtl){\n  padding-inline-start:9em;\n}\n.slds-rich-text-editor__textarea .ql-indent-3.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-3.ql-direction-rtl.ql-align-right{\n  padding-inline-end:9em;\n}\n.slds-rich-text-editor__textarea .ql-indent-4:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-4:not(.ql-direction-rtl){\n  padding-inline-start:12em;\n}\n.slds-rich-text-editor__textarea .ql-indent-4.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-4.ql-direction-rtl.ql-align-right{\n  padding-inline-end:12em;\n}\n.slds-rich-text-editor__textarea .ql-indent-5:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-5:not(.ql-direction-rtl){\n  padding-inline-start:15em;\n}\n.slds-rich-text-editor__textarea .ql-indent-5.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-5.ql-direction-rtl.ql-align-right{\n  padding-inline-end:15em;\n}\n.slds-rich-text-editor__textarea .ql-indent-6:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-6:not(.ql-direction-rtl){\n  padding-inline-start:18em;\n}\n.slds-rich-text-editor__textarea .ql-indent-6.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-6.ql-direction-rtl.ql-align-right{\n  padding-inline-end:18em;\n}\n.slds-rich-text-editor__textarea .ql-indent-7:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-7:not(.ql-direction-rtl){\n  padding-inline-start:21em;\n}\n.slds-rich-text-editor__textarea .ql-indent-7.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-7.ql-direction-rtl.ql-align-right{\n  padding-inline-end:21em;\n}\n.slds-rich-text-editor__textarea .ql-indent-8:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-8:not(.ql-direction-rtl){\n  padding-inline-start:24em;\n}\n.slds-rich-text-editor__textarea .ql-indent-8.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-8.ql-direction-rtl.ql-align-right{\n  padding-inline-end:24em;\n}\n.slds-rich-text-editor__textarea .ql-indent-9:not(.ql-direction-rtl), .slds-rich-text-editor__output .ql-indent-9:not(.ql-direction-rtl){\n  padding-inline-start:27em;\n}\n.slds-rich-text-editor__textarea .ql-indent-9.ql-direction-rtl.ql-align-right, .slds-rich-text-editor__output .ql-indent-9.ql-direction-rtl.ql-align-right{\n  padding-inline-end:27em;\n}\n.slds-path.slds-is-expanded{\n  padding-block-end:var(--slds-g-sizing-4);\n  border-color:var(--slds-g-color-border-2);\n}\n.slds-path__track{\n  flex-wrap:wrap;\n  align-items:flex-start;\n}\n@media (min-width: 64em){\n  .slds-path__track{\n    flex-wrap:nowrap;\n    align-items:stretch\n  }\n}\n.slds-path__track.slds-has-overflow .slds-path__scroller_inner,.slds-path__track.slds-has-overflow .slds-path__scroller--inner{\n  display:flex;\n  width:100%;\n  overflow:hidden;\n}\n.slds-path__track.slds-has-overflow .slds-path__scroll-controls{\n  display:inline-flex;\n  flex-shrink:0;\n  padding-inline-start:var(--slds-g-spacing-2);\n}\n@media (pointer: coarse) and (hover: none){\n  .slds-path__track.slds-has-overflow .slds-path__scroll-controls{\n    display:none\n  }\n}\n.slds-path__scroller{\n  flex:1;\n  max-width:100%;\n  overflow:hidden;\n}\n.slds-path__scroll-controls{\n  display:none;\n}\n.slds-path__stage-name{\n  display:block;\n  font-weight:var(--slds-g-font-weight-7);\n  margin-block:var(--slds-g-spacing-3);\n  margin-inline:0;\n}\n@media (min-width: 48em){\n  .slds-path__stage-name{\n    margin:0\n  }\n}\n@media (min-width: 64em){\n  .slds-path__stage-name{\n    display:none\n  }\n}\n.slds-path__scroller-container{\n  flex:1;\n  flex-basis:100%;\n  overflow:hidden;\n}\n@media (min-width: 64em){\n  .slds-path__scroller-container{\n    flex-basis:auto\n  }\n}\n@media (min-width: 48em){\n  .slds-path_has-coaching .slds-path__action,.slds-path--has-coaching .slds-path__action{\n    padding-inline-start:2.75rem\n  }\n}\n@media (min-width: 64em){\n  .slds-path_has-coaching .slds-path__action,.slds-path--has-coaching .slds-path__action{\n    padding-inline-start:0\n  }\n}\n.slds-path__action{\n  flex-grow:1;\n  flex-basis:100%;\n  margin-inline-start:0;\n  align-items:center;\n  flex-shrink:0;\n  flex-direction:column;\n}\n.slds-path__action .slds-icon-text-default{\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-accent-1);\n}\n@media (min-width: 48em){\n  .slds-path__action{\n    justify-content:space-between;\n    margin-block-start:var(--slds-g-spacing-4);\n    flex-direction:row\n  }\n}\n@media (min-width: 64em){\n  .slds-path__action{\n    flex-basis:auto;\n    flex-grow:0;\n    align-items:normal;\n    margin-block-start:0;\n    margin-inline-start:var(--slds-g-spacing-5)\n  }\n}\n.slds-path__nav{\n  display:flex;\n  align-items:flex-start;\n  overflow:hidden;\n}\n.slds-path__nav .slds-is-incomplete{\n  background:var(--_slds-c-path-item-color-background-incomplete);\n}\n.slds-path__nav .slds-is-incomplete::before,\n.slds-path__nav .slds-is-incomplete::after{\n  background:var(--_slds-c-path-item-color-background-incomplete);\n}\n.slds-path__nav .slds-is-incomplete .slds-path__link{\n  color:var(--_slds-c-path-item-color-incomplete);\n}\n.slds-path__nav .slds-is-incomplete:hover{\n  background:var(--_slds-c-path-item-color-background-incomplete-hover);\n}\n.slds-path__nav .slds-is-incomplete:hover::before,\n.slds-path__nav .slds-is-incomplete:hover::after{\n  background:var(--_slds-c-path-item-color-background-incomplete-hover);\n}\n.slds-path__nav .slds-is-complete{\n  background:var(--_slds-c-path-item-color-background-complete);\n}\n.slds-path__nav .slds-is-complete::before,\n.slds-path__nav .slds-is-complete::after{\n  background:var(--_slds-c-path-item-color-background-complete);\n}\n.slds-path__nav .slds-is-complete .slds-path__stage{\n  transform:translate(-50%, -50%) rotateX(0deg);\n}\n.slds-path__nav .slds-is-complete .slds-path__stage .slds-icon-text-default{\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-success-1);\n}\n.slds-path__nav .slds-is-complete .slds-path__title{\n  transform:rotateX(180deg);\n}\n.slds-path__nav .slds-is-complete .slds-path__link{\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-success-1);\n\n  color:var(--slds-g-color-on-success-1);\n}\n.slds-path__nav .slds-is-complete:hover{\n  background:var(--_slds-c-path-item-color-background-complete-hover);\n}\n.slds-path__nav .slds-is-complete:hover::before,\n.slds-path__nav .slds-is-complete:hover::after{\n  background:var(--_slds-c-path-item-color-background-complete-hover);\n}\n.slds-path__nav .slds-is-complete:hover .slds-path__stage{\n  transform:translate(-50%, -50%) rotateX(-180deg);\n}\n.slds-path__nav .slds-is-complete:hover .slds-path__title{\n  transform:rotateX(0deg);\n}\n.slds-path__nav .slds-is-current{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-path__nav .slds-is-current::before,\n.slds-path__nav .slds-is-current::after{\n  background-color:var(--slds-g-color-surface-container-1);\n  background-image:linear-gradient(\n    90deg,\n    var(--slds-g-color-brand-base-30),\n    var(--slds-g-color-brand-base-30) var(--_slds-c-path-item-sizing-border),\n    transparent var(--_slds-c-path-item-sizing-border)\n  ), linear-gradient(\n    90deg,\n    var(--slds-g-color-brand-base-30),\n    var(--slds-g-color-brand-base-30) var(--_slds-c-path-item-sizing-border),\n    transparent var(--_slds-c-path-item-sizing-border)\n  ), linear-gradient(\n    var(--slds-g-color-brand-base-30),\n    var(--slds-g-color-brand-base-30) var(--_slds-c-path-item-sizing-border),\n    transparent var(--_slds-c-path-item-sizing-border)\n  );\n  background-repeat:no-repeat;\n  background-size:var(--_slds-c-path-item-sizing-border) 100%, var(--_slds-c-path-item-sizing-border) 100%, 100% var(--_slds-c-path-item-sizing-border);\n}\n.slds-path__nav .slds-is-current::before{\n  background-position:top right, top left, top left;\n}\n.slds-path__nav .slds-is-current::after{\n  background-position:top right, top left, bottom left;\n}\n.slds-path__nav .slds-is-current:first-child{\n  border:var(--_slds-c-path-item-sizing-border) solid var(--slds-g-color-brand-base-30);\n  border-inline-end:0;\n}\n.slds-path__nav .slds-is-current:first-child::before,\n.slds-path__nav .slds-is-current:first-child::after{\n  background-color:transparent;\n  background-image:linear-gradient(\n    90deg,\n    var(--slds-g-color-brand-base-30),\n    var(--slds-g-color-brand-base-30) var(--_slds-c-path-item-sizing-border),\n    transparent var(--_slds-c-path-item-sizing-border)\n  );\n}\n.slds-path__nav .slds-is-current:first-child::before{\n  inset-block-start:calc(var(--_slds-c-path-item-sizing-border) * -1);\n}\n.slds-path__nav .slds-is-current:first-child::after{\n  inset-block-end:calc(var(--_slds-c-path-item-sizing-border) * -1);\n}\n.slds-path__nav .slds-is-current:first-child:hover{\n  border-color:var(--slds-g-color-brand-base-20);\n}\n.slds-path__nav .slds-is-current:first-child:hover::before,\n.slds-path__nav .slds-is-current:first-child:hover::after{\n  background-image:linear-gradient(\n    90deg,\n    var(--slds-g-color-brand-base-20),\n    var(--slds-g-color-brand-base-20) var(--_slds-c-path-item-sizing-border),\n    transparent var(--_slds-c-path-item-sizing-border)\n  );\n}\n.slds-path__nav .slds-is-current:first-child .slds-path__link{\n  height:var(--_slds-c-path-item-sizing-height);\n}\n.slds-path__nav .slds-is-current .slds-path__link{\n  color:var(--slds-g-color-brand-base-20);\n}\n.slds-path__nav .slds-is-current:hover::before,\n.slds-path__nav .slds-is-current:hover::after{\n  background-image:linear-gradient(\n    90deg,\n    var(--slds-g-color-brand-base-20),\n    var(--slds-g-color-brand-base-20) 0.125rem,\n    transparent 0.125rem\n  ), linear-gradient(\n    90deg,\n    var(--slds-g-color-brand-base-20),\n    var(--slds-g-color-brand-base-20) 0.125rem,\n    transparent 0.125rem\n  ), linear-gradient(\n    var(--slds-g-color-brand-base-20),\n    var(--slds-g-color-brand-base-20) 0.125rem,\n    transparent 0.125rem\n  );\n}\n.slds-path__nav .slds-is-current:hover .slds-path__link{\n  color:var(--slds-g-color-brand-base-20);\n}\n.slds-path__nav .slds-is-active{\n  background:var(--_slds-c-path-item-color-background-active);\n}\n.slds-path__nav .slds-is-active::before,\n.slds-path__nav .slds-is-active::after{\n  background:var(--_slds-c-path-item-color-background-active);\n}\n.slds-path__nav .slds-is-active:first-child{\n  border:0;\n}\n.slds-path__nav .slds-is-active:first-child::before,\n.slds-path__nav .slds-is-active:first-child::after{\n  background:var(--_slds-c-path-item-color-background-active);\n}\n.slds-path__nav .slds-is-active:first-child::before{\n  inset-block-start:0;\n}\n.slds-path__nav .slds-is-active:first-child::after{\n  inset-block-end:0;\n}\n.slds-path__nav .slds-is-active:first-child .slds-path__link{\n  height:2rem;\n}\n.slds-path__nav .slds-is-active .slds-path__stage{\n  transform:translateY(-50%) rotateX(-180deg);\n}\n.slds-path__nav .slds-is-active .slds-path__title{\n  transform:rotateX(0deg);\n}\n.slds-path__nav .slds-is-active .slds-path__link{\n  color:var(--slds-g-color-on-accent-1);\n}\n.slds-path__nav .slds-is-active:hover{\n  background:var(--_slds-c-path-item-color-background-active-hover);\n}\n.slds-path__nav .slds-is-active:hover::before,\n.slds-path__nav .slds-is-active:hover::after{\n  background:var(--_slds-c-path-item-color-background-active-hover);\n}\n.slds-path__nav .slds-is-active:hover .slds-path__link{\n  color:var(--slds-g-color-on-accent-1);\n}\n.slds-path__nav .slds-is-lost{\n  background:var(--_slds-c-path-item-color-background-error);\n}\n.slds-path__nav .slds-is-lost::before,\n.slds-path__nav .slds-is-lost::after,\n.slds-path__nav .slds-is-lost:hover,\n.slds-path__nav .slds-is-lost:hover::before,\n.slds-path__nav .slds-is-lost:hover::after{\n  background:var(--_slds-c-path-item-color-background-error);\n}\n.slds-path__nav .slds-is-lost .slds-path__link{\n  color:var(--slds-g-color-on-error-1);\n}\n.slds-path__nav .slds-is-lost:hover .slds-path__link{\n  color:var(--slds-g-color-on-error-1);\n}\n.slds-path__nav .slds-is-won{\n  background:var(--_slds-c-path-item-color-background-success);\n}\n.slds-path__nav .slds-is-won::before,\n.slds-path__nav .slds-is-won::after,\n.slds-path__nav .slds-is-won:hover,\n.slds-path__nav .slds-is-won:hover::before,\n.slds-path__nav .slds-is-won:hover::after{\n  background:var(--_slds-c-path-item-color-background-success);\n}\n.slds-path__nav .slds-is-won .slds-path__link{\n  color:var(--slds-g-color-on-success-1);\n}\n.slds-path__nav .slds-is-won:hover .slds-path__link{\n  color:var(--slds-g-color-on-success-1);\n}\n.slds-path.slds-is-won .slds-path__item.slds-is-current{\n  background:var(--_slds-c-path-item-color-background-success);\n}\n.slds-path.slds-is-won .slds-path__item.slds-is-current::before,\n.slds-path.slds-is-won .slds-path__item.slds-is-current::after,\n.slds-path.slds-is-won .slds-path__item.slds-is-current:hover,\n.slds-path.slds-is-won .slds-path__item.slds-is-current:hover::before,\n.slds-path.slds-is-won .slds-path__item.slds-is-current:hover::after{\n  background:var(--_slds-c-path-item-color-background-success);\n}\n.slds-path.slds-is-lost .slds-path__item.slds-is-current{\n  background:var(--slds-g-color-error-base-50);\n}\n.slds-path.slds-is-lost .slds-path__item.slds-is-current::before,\n.slds-path.slds-is-lost .slds-path__item.slds-is-current::after,\n.slds-path.slds-is-lost .slds-path__item.slds-is-current:hover,\n.slds-path.slds-is-lost .slds-path__item.slds-is-current:hover::before,\n.slds-path.slds-is-lost .slds-path__item.slds-is-current:hover::after{\n  background:var(--slds-g-color-error-base-50);\n}\n.slds-path__item{\n  position:relative;\n  flex:1;\n  margin-inline-start:0.375rem;\n  margin-inline-end:0.4375rem;\n  min-width:5rem;\n  text-align:center;\n}\n.slds-path__item::before,\n.slds-path__item::after{\n  content:'';\n  position:absolute;\n  inset-inline-start:-0.25rem;\n  inset-inline-end:-0.3125rem;\n  cursor:pointer;\n}\n.slds-path__item::before{\n  inset-block-start:0;\n  height:1.0313rem;\n  transform:skew(28deg) translate3d(0, 0, 0);\n}\n.slds-path__item::after{\n  inset-block-end:0;\n  height:1rem;\n  transform:skew(-30deg) translate3d(0, 0, 0);\n}\n.slds-path__item:first-child{\n  margin-inline-start:0;\n  border-start-start-radius:2rem;\n  border-end-start-radius:2rem;\n  padding-inline-start:0.625rem;\n}\n.slds-path__item:first-child::before,\n.slds-path__item:first-child::after{\n  inset-inline-start:1.125rem;\n}\n.slds-path__item:last-child{\n  margin-inline-end:0;\n  border-start-end-radius:2rem;\n  border-end-end-radius:2rem;\n  padding-inline-end:0.625rem;\n}\n.slds-path__item:last-child .slds-path__link{\n  padding-inline-start:var(--slds-g-spacing-1);\n}\n.slds-path__item:last-child::before,\n.slds-path__item:last-child::after{\n  inset-inline-end:0.625rem;\n}\n[dir='rtl'] .slds-path__item::before{\n  transform:skew(-30deg) translate3d(0, 0, 0);\n}\n[dir='rtl'] .slds-path__item::after{\n  transform:skew(28deg) translate3d(0, 0, 0);\n}\n.slds-path__item .slds-icon_container,.slds-path__item .slds-icon--container{\n  display:flex;\n}\n.slds-path__title{\n  max-width:100%;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n  transform:translate3d(0, 0, 0);\n}\n.slds-path__stage{\n  position:absolute;\n  inset-block-start:50%;\n  /*! @noflip */\n  left:50%;\n  transform:translate(-50%, -50%) rotateX(-180deg);\n}\n.slds-path__link{\n  position:relative;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  height:2rem;\n  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-1) var(--slds-g-spacing-2) var(--slds-g-spacing-2);\n  text-decoration:none;\n  z-index:5;\n  cursor:pointer;\n}\n.slds-path__link:hover{\n  text-decoration:none;\n}\n.slds-path__link:focus{\n  outline:0;\n}\n.slds-path__title,\n.slds-path__stage{\n  display:block;\n  transition:transform 0.2s linear;\n  backface-visibility:hidden;\n}\n.slds-path .slds-path__trigger{\n  margin-inline-end:var(--slds-g-spacing-3);\n  transition:0.4s transform ease-in-out;\n  display:none;\n}\n@media (min-width: 48em){\n  .slds-path .slds-path__trigger{\n    display:block\n  }\n}\n.slds-path__trigger_open,.slds-path__trigger--open{\n  transform:rotate(90deg);\n}\n[dir='rtl'] .slds-path__trigger_open,[dir='rtl'] .slds-path__trigger--open{\n  transform:rotate(-90deg);\n}\n.slds-path .slds-path__mark-complete{\n  --slds-c-button-sizing-border:0;\n\n  width:100%;\n  min-width:13rem;\n  margin-inline-end:0;\n  justify-content:center;\n}\n@media (min-width: 48em){\n  .slds-path .slds-path__mark-complete{\n    width:auto\n  }\n}\n.slds-path__mark-current{\n  border-color:var(--slds-g-color-border-accent-2);\n  background-color:var(--slds-g-color-accent-container-1);\n}\n.slds-path__mark-current:hover,\n.slds-path__mark-current:focus{\n  background-color:var(--slds-g-color-accent-container-3);\n}\n.slds-path__guidance{\n  margin-inline-end:var(--slds-g-spacing-2);\n  padding-block-end:var(--slds-g-spacing-1);\n  background-color:var(--slds-g-color-surface-container-1);\n}\n@media (min-width: 48em){\n  .slds-path__guidance{\n    margin-block-start:0\n  }\n}\n.slds-path__keys,\n.slds-path__guidance{\n  flex:1 1 100%;\n  margin-block-start:var(--slds-g-spacing-4);\n  padding-inline-start:0;\n  padding-inline-end:0;\n}\n@media (min-width: 48em){\n  .slds-path__keys,\n  .slds-path__guidance{\n    flex-basis:50%\n  }\n}\n@media (min-width: 48em){\n  .slds-path__keys{\n    padding-inline-end:var(--slds-g-spacing-3)\n  }\n}\n.slds-path__coach{\n  flex-wrap:wrap;\n  align-items:flex-start;\n}\n@media (min-width: 48em){\n  .slds-path__coach{\n    flex-wrap:nowrap;\n    align-items:stretch\n  }\n}\n.slds-path__coach-title{\n  font-size:var(--slds-g-font-scale-neg-1);\n  font-weight:var(--slds-g-font-weight-7);\n  margin-block-end:var(--slds-g-spacing-2);\n  padding-block-end:var(--slds-g-spacing-2);\n  line-height:1.125;\n}\n.slds-path__coach-edit{\n  border:0;\n  padding:0;\n  line-height:inherit;\n}\n.slds-path__guidance-content{\n  padding-block-start:var(--slds-g-spacing-1);\n}\n.slds-path__trigger-coaching-content{\n  width:100%;\n  margin-block-start:var(--slds-g-spacing-3);\n}\n@media (min-width: 48em){\n  .slds-path__trigger-coaching-content{\n    display:none\n  }\n}\n.slds-path .slds-path__trigger-coaching-content{\n  margin-inline-start:0;\n}\n.slds-region_medium .slds-path_has-coaching .slds-path__action,.slds-region--medium .slds-path--has-coaching .slds-path__action{\n  padding-inline-start:2.75rem;\n}\n.slds-region_medium .slds-path__scroller-container,.slds-region--medium .slds-path__scroller-container{\n  flex-basis:100%;\n}\n.slds-region_medium .slds-path__track,.slds-region--medium .slds-path__track{\n  flex-wrap:wrap;\n  align-items:flex-start;\n}\n.slds-region_medium .slds-path__action,.slds-region--medium .slds-path__action{\n  flex-grow:1;\n  flex-basis:100%;\n  margin-inline-start:0;\n  align-items:center;\n  justify-content:space-between;\n  margin-block-start:var(--slds-g-spacing-4);\n  flex-direction:row;\n}\n.slds-region_medium .slds-path__stage-name,.slds-region--medium .slds-path__stage-name,\n.slds-region_medium .slds-path__trigger,\n.slds-region--medium .slds-path__trigger{\n  display:block;\n}\n.slds-region_medium .slds-path__stage-name,.slds-region--medium .slds-path__stage-name{\n  margin:0;\n}\n.slds-region_medium .slds-path__trigger-coaching-content,.slds-region--medium .slds-path__trigger-coaching-content{\n  display:none;\n}\n.slds-region_medium .slds-path__mark-complete,.slds-region--medium .slds-path__mark-complete{\n  width:auto;\n}\n.slds-region_medium .slds-path__coach,.slds-region--medium .slds-path__coach{\n  justify-content:space-between;\n  margin-block-start:var(--slds-g-spacing-4);\n  flex-direction:row;\n}\n.slds-region_medium .slds-path__keys,.slds-region--medium .slds-path__keys,\n.slds-region_medium .slds-path__guidance,\n.slds-region--medium .slds-path__guidance{\n  flex-basis:50%;\n}\n.slds-region_medium .slds-path__keys,.slds-region--medium .slds-path__keys{\n  padding-inline-end:var(--slds-g-spacing-3);\n}\n.slds-region_small .slds-path__scroller-container,.slds-region--small .slds-path__scroller-container{\n  flex-basis:100%;\n}\n.slds-region_small .slds-path__track,.slds-region--small .slds-path__track,\n.slds-region_small .slds-path__coach,\n.slds-region--small .slds-path__coach{\n  flex-wrap:wrap;\n  align-items:flex-start;\n}\n.slds-region_small .slds-path__stage-name,.slds-region--small .slds-path__stage-name{\n  display:block;\n  margin:var(--slds-g-spacing-3) 0;\n}\n.slds-region_small .slds-path__action,.slds-region--small .slds-path__action{\n  flex-grow:1;\n  flex-basis:100%;\n  margin-inline-start:0;\n  align-items:center;\n  flex-direction:column;\n  margin-block-start:0;\n}\n.slds-region_small .slds-path_has-coaching .slds-path__action,.slds-region--small .slds-path--has-coaching .slds-path__action{\n  padding-inline-start:0;\n}\n.slds-region_small .slds-path__mark-complete,.slds-region--small .slds-path__mark-complete{\n  width:100%;\n}\n.slds-region_small .slds-path__keys,.slds-region--small .slds-path__keys,\n.slds-region_small .slds-path__guidance,\n.slds-region--small .slds-path__guidance{\n  flex-basis:100%;\n  padding-inline-start:0;\n  padding-inline-end:0;\n}\n.slds-region_small .slds-path__guidance,.slds-region--small .slds-path__guidance{\n  margin-block-start:var(--slds-g-spacing-3);\n}\n.slds-region_small .slds-path__trigger,.slds-region--small .slds-path__trigger{\n  display:none;\n}\n.slds-region_small .slds-path__trigger-coaching-content,.slds-region--small .slds-path__trigger-coaching-content{\n  display:inline-block;\n}\n.slds-spinner_container,.slds-spinner--container{\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-end:0;\n  inset-block-end:0;\n  inset-inline-start:0;\n  z-index:9050;\n  background-color:rgba(255, 255, 255, 0.75);\n  visibility:visible;\n  opacity:1;\n  transition:opacity 0.2s ease, visibility 0s;\n  transition-delay:0s, 0.3s;\n}\n.slds-spinner_container.is-hidden,.slds-spinner--container.is-hidden{\n  visibility:hidden;\n  opacity:0;\n  transition:opacity 0.2s ease, visibility 0s;\n  transition-delay:0s, 0s;\n}\n.slds-spinner_container.hide,.slds-spinner--container.hide{\n  display:none;\n}\n.slds-spinner{\n  position:absolute;\n  inset-block-start:50%;\n\n  /*! @noflip */\n  left:50%;\n  z-index:9051;\n  transform:translate(-50%, -50%) rotate(90deg);\n}\n.slds-spinner_inline,.slds-spinner--inline{\n  position:relative;\n  inset-block-start:auto;\n  inset-inline-start:auto;\n  inset-inline-end:auto;\n  inset-block-end:auto;\n  transform:none;\n}\n.slds-spinner,\n.slds-spinner__dot-a,\n.slds-spinner__dot-b{\n  transform-origin:50% 50%;\n  will-change:transform;\n}\n.slds-spinner__dot-a,\n.slds-spinner__dot-b{\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-start:0;\n  width:100%;\n}\n.slds-spinner::before,\n.slds-spinner::after,\n.slds-spinner__dot-a::before,\n.slds-spinner__dot-b::before,\n.slds-spinner__dot-a::after,\n.slds-spinner__dot-b::after{\n  content:'';\n  position:absolute;\n  background:var(--slds-g-color-neutral-base-50);\n  border-radius:var(--slds-g-radius-border-circle);\n  animation-duration:1000ms;\n  animation-iteration-count:infinite;\n  transform:translate3d(0, 0, 0);\n}\n.slds-spinner__dot-a{\n  transform:rotate(60deg);\n}\n.slds-spinner__dot-b{\n  transform:rotate(120deg);\n}\n.slds-spinner::before{\n  animation-delay:-83.3333ms;\n}\n.slds-spinner__dot-a::before{\n  animation-delay:83.3333ms;\n}\n.slds-spinner__dot-b::before{\n  animation-delay:250ms;\n}\n.slds-spinner::after{\n  animation-delay:416.6666ms;\n}\n.slds-spinner__dot-a::after{\n  animation-delay:583.3333ms;\n}\n.slds-spinner__dot-b::after{\n  animation-delay:750ms;\n}\n.slds-spinner_delayed::before,.slds-spinner--delayed::before{\n  animation-delay:216.6666ms;\n}\n.slds-spinner_delayed .slds-spinner__dot-a::before,.slds-spinner--delayed .slds-spinner__dot-a::before{\n  animation-delay:383.3333ms;\n}\n.slds-spinner_delayed .slds-spinner__dot-b::before,.slds-spinner--delayed .slds-spinner__dot-b::before{\n  animation-delay:550ms;\n}\n.slds-spinner_delayed::after,.slds-spinner--delayed::after{\n  animation-delay:716.6666ms;\n}\n.slds-spinner_delayed .slds-spinner__dot-a::after,.slds-spinner--delayed .slds-spinner__dot-a::after{\n  animation-delay:883.3333ms;\n}\n.slds-spinner_delayed .slds-spinner__dot-b::after,.slds-spinner--delayed .slds-spinner__dot-b::after{\n  animation-delay:1050ms;\n}\n.slds-spinner_brand.slds-spinner::before,.slds-spinner--brand.slds-spinner::before,\n.slds-spinner_brand.slds-spinner::after,\n.slds-spinner--brand.slds-spinner::after,\n.slds-spinner_brand .slds-spinner__dot-a::before,\n.slds-spinner--brand .slds-spinner__dot-a::before,\n.slds-spinner_brand .slds-spinner__dot-b::before,\n.slds-spinner--brand .slds-spinner__dot-b::before,\n.slds-spinner_brand .slds-spinner__dot-a::after,\n.slds-spinner--brand .slds-spinner__dot-a::after,\n.slds-spinner_brand .slds-spinner__dot-b::after,\n.slds-spinner--brand .slds-spinner__dot-b::after{\n  background-color:var(--slds-g-color-accent-1);\n}\n.slds-spinner_inverse.slds-spinner::before,.slds-spinner--inverse.slds-spinner::before,\n.slds-spinner_inverse.slds-spinner::after,\n.slds-spinner--inverse.slds-spinner::after,\n.slds-spinner_inverse .slds-spinner__dot-a::before,\n.slds-spinner--inverse .slds-spinner__dot-a::before,\n.slds-spinner_inverse .slds-spinner__dot-b::before,\n.slds-spinner--inverse .slds-spinner__dot-b::before,\n.slds-spinner_inverse .slds-spinner__dot-a::after,\n.slds-spinner--inverse .slds-spinner__dot-a::after,\n.slds-spinner_inverse .slds-spinner__dot-b::after,\n.slds-spinner--inverse .slds-spinner__dot-b::after{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-spinner_xx-small,.slds-spinner--xx-small{\n  width:var(--slds-g-sizing-3);\n}\n.slds-spinner_xx-small.slds-spinner_inline,.slds-spinner--xx-small.slds-spinner--inline{\n  height:var(--slds-g-sizing-3);\n}\n.slds-spinner_xx-small.slds-spinner::before,.slds-spinner--xx-small.slds-spinner::before,\n.slds-spinner_xx-small.slds-spinner::after,\n.slds-spinner--xx-small.slds-spinner::after,\n.slds-spinner_xx-small .slds-spinner__dot-a::before,\n.slds-spinner--xx-small .slds-spinner__dot-a::before,\n.slds-spinner_xx-small .slds-spinner__dot-b::before,\n.slds-spinner--xx-small .slds-spinner__dot-b::before,\n.slds-spinner_xx-small .slds-spinner__dot-a::after,\n.slds-spinner--xx-small .slds-spinner__dot-a::after,\n.slds-spinner_xx-small .slds-spinner__dot-b::after,\n.slds-spinner--xx-small .slds-spinner__dot-b::after{\n  width:0.125rem;\n  height:0.125rem;\n}\n.slds-spinner_xx-small.slds-spinner::before,.slds-spinner--xx-small.slds-spinner::before,\n.slds-spinner_xx-small .slds-spinner__dot-a::before,\n.slds-spinner--xx-small .slds-spinner__dot-a::before,\n.slds-spinner_xx-small .slds-spinner__dot-b::before,\n.slds-spinner--xx-small .slds-spinner__dot-b::before{\n  inset-block-start:-0.0625rem;\n  inset-inline-start:-0.0625rem;\n  animation-name:dotsBounceBefore-extraExtraSmall;\n}\n.slds-spinner_xx-small.slds-spinner::after,.slds-spinner--xx-small.slds-spinner::after,\n.slds-spinner_xx-small .slds-spinner__dot-a::after,\n.slds-spinner--xx-small .slds-spinner__dot-a::after,\n.slds-spinner_xx-small .slds-spinner__dot-b::after,\n.slds-spinner--xx-small .slds-spinner__dot-b::after{\n  inset-block-start:-0.0625rem;\n  inset-inline-end:-0.0625rem;\n  animation-name:dotsBounceAfter-extraExtraSmall;\n}\n@keyframes dotsBounceBefore-extraExtraSmall{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    transform:translate3d(0, 0, 0);\n    animation-timing-function:cubic-bezier(0.275, 0.0425, 0.34, 0.265);\n  }\n\n  80%{\n    transform:translate3d(-0.125rem, 0, 0);\n    animation-timing-function:cubic-bezier(0, 0.555, 0.35, 0.715);\n  }\n\n  100%{\n    transform:translate3d(0, 0, 0);\n  }\n}\n@keyframes dotsBounceAfter-extraExtraSmall{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    animation-timing-function:cubic-bezier(0.275, 0.0425, 0.34, 0.265);\n    transform:translate3d(0, 0, 0);\n  }\n\n  80%{\n    animation-timing-function:cubic-bezier(0, 0.555, 0.35, 0.715);\n    transform:translate3d(0.125rem, 0, 0);\n  }\n\n  100%{\n    transform:translate3d(0, 0, 0);\n  }\n}\n.slds-spinner_x-small,.slds-spinner--x-small{\n  width:var(--slds-g-sizing-5);\n}\n.slds-spinner_x-small.slds-spinner_inline,.slds-spinner--x-small.slds-spinner--inline{\n  height:var(--slds-g-sizing-5);\n}\n.slds-spinner_x-small.slds-spinner::before,.slds-spinner--x-small.slds-spinner::before,\n.slds-spinner_x-small.slds-spinner::after,\n.slds-spinner--x-small.slds-spinner::after,\n.slds-spinner_x-small .slds-spinner__dot-a::before,\n.slds-spinner--x-small .slds-spinner__dot-a::before,\n.slds-spinner_x-small .slds-spinner__dot-b::before,\n.slds-spinner--x-small .slds-spinner__dot-b::before,\n.slds-spinner_x-small .slds-spinner__dot-a::after,\n.slds-spinner--x-small .slds-spinner__dot-a::after,\n.slds-spinner_x-small .slds-spinner__dot-b::after,\n.slds-spinner--x-small .slds-spinner__dot-b::after{\n  width:var(--slds-g-sizing-2);\n  height:var(--slds-g-sizing-2);\n}\n.slds-spinner_x-small.slds-spinner::before,.slds-spinner--x-small.slds-spinner::before,\n.slds-spinner_x-small .slds-spinner__dot-a::before,\n.slds-spinner--x-small .slds-spinner__dot-a::before,\n.slds-spinner_x-small .slds-spinner__dot-b::before,\n.slds-spinner--x-small .slds-spinner__dot-b::before{\n  inset-block-start:-0.125rem;\n  inset-inline-start:-0.125rem;\n  animation-name:dotsBounceBefore-extraSmall;\n}\n.slds-spinner_x-small.slds-spinner::after,.slds-spinner--x-small.slds-spinner::after,\n.slds-spinner_x-small .slds-spinner__dot-a::after,\n.slds-spinner--x-small .slds-spinner__dot-a::after,\n.slds-spinner_x-small .slds-spinner__dot-b::after,\n.slds-spinner--x-small .slds-spinner__dot-b::after{\n  inset-block-start:-0.125rem;\n  inset-inline-end:-0.125rem;\n  animation-name:dotsBounceAfter-extraSmall;\n}\n@keyframes dotsBounceBefore-extraSmall{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    transform:translate3d(0, 0, 0);\n    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  }\n\n  80%{\n    transform:translate3d(-0.25rem, 0, 0);\n    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);\n  }\n\n  100%{\n    transform:translate3d(0, 0, 0);\n  }\n}\n@keyframes dotsBounceAfter-extraSmall{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    transform:translate3d(0, 0, 0);\n    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  }\n\n  80%{\n    transform:translate3d(0.25rem, 0, 0);\n    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);\n  }\n\n  100%{\n    transform:translate3d(0, 0, 0);\n  }\n}\n.slds-spinner_small,.slds-spinner--small{\n  width:var(--slds-g-sizing-6);\n}\n.slds-spinner_small.slds-spinner_inline,.slds-spinner--small.slds-spinner--inline{\n  height:var(--slds-g-sizing-6);\n}\n.slds-spinner_small.slds-spinner::before,.slds-spinner--small.slds-spinner::before,\n.slds-spinner_small.slds-spinner::after,\n.slds-spinner--small.slds-spinner::after,\n.slds-spinner_small .slds-spinner__dot-a::before,\n.slds-spinner--small .slds-spinner__dot-a::before,\n.slds-spinner_small .slds-spinner__dot-b::before,\n.slds-spinner--small .slds-spinner__dot-b::before,\n.slds-spinner_small .slds-spinner__dot-a::after,\n.slds-spinner--small .slds-spinner__dot-a::after,\n.slds-spinner_small .slds-spinner__dot-b::after,\n.slds-spinner--small .slds-spinner__dot-b::after{\n  width:var(--slds-g-sizing-2);\n  height:var(--slds-g-sizing-2);\n}\n.slds-spinner_small.slds-spinner::before,.slds-spinner--small.slds-spinner::before,\n.slds-spinner_small .slds-spinner__dot-a::before,\n.slds-spinner--small .slds-spinner__dot-a::before,\n.slds-spinner_small .slds-spinner__dot-b::before,\n.slds-spinner--small .slds-spinner__dot-b::before{\n  inset-block-start:-0.125rem;\n  inset-inline-start:-0.125rem;\n  animation-name:dotsBounceBefore-small;\n}\n.slds-spinner_small.slds-spinner::after,.slds-spinner--small.slds-spinner::after,\n.slds-spinner_small .slds-spinner__dot-a::after,\n.slds-spinner--small .slds-spinner__dot-a::after,\n.slds-spinner_small .slds-spinner__dot-b::after,\n.slds-spinner--small .slds-spinner__dot-b::after{\n  inset-block-start:-0.125rem;\n  inset-inline-end:-0.125rem;\n  animation-name:dotsBounceAfter-small;\n}\n@keyframes dotsBounceBefore-small{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    transform:translate3d(0, 0, 0);\n    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  }\n\n  80%{\n    transform:translate3d(-0.375rem, 0, 0);\n    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);\n  }\n\n  100%{\n    transform:translate3d(0, 0, 0);\n  }\n}\n@keyframes dotsBounceAfter-small{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    transform:translate3d(0, 0, 0);\n    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  }\n\n  80%{\n    transform:translate3d(0.375rem, 0, 0);\n    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);\n  }\n\n  100%{\n    transform:translateX(0);\n  }\n}\n.slds-spinner_medium,.slds-spinner--medium{\n  width:var(--slds-g-sizing-9);\n}\n.slds-spinner_medium.slds-spinner_inline,.slds-spinner--medium.slds-spinner--inline{\n  height:var(--slds-g-sizing-9);\n}\n.slds-spinner_medium.slds-spinner::before,.slds-spinner--medium.slds-spinner::before,\n.slds-spinner_medium.slds-spinner::after,\n.slds-spinner--medium.slds-spinner::after,\n.slds-spinner_medium .slds-spinner__dot-a::before,\n.slds-spinner--medium .slds-spinner__dot-a::before,\n.slds-spinner_medium .slds-spinner__dot-b::before,\n.slds-spinner--medium .slds-spinner__dot-b::before,\n.slds-spinner_medium .slds-spinner__dot-a::after,\n.slds-spinner--medium .slds-spinner__dot-a::after,\n.slds-spinner_medium .slds-spinner__dot-b::after,\n.slds-spinner--medium .slds-spinner__dot-b::after{\n  width:var(--slds-g-sizing-3);\n  height:var(--slds-g-sizing-3);\n}\n.slds-spinner_medium.slds-spinner::before,.slds-spinner--medium.slds-spinner::before,\n.slds-spinner_medium .slds-spinner__dot-a::before,\n.slds-spinner--medium .slds-spinner__dot-a::before,\n.slds-spinner_medium .slds-spinner__dot-b::before,\n.slds-spinner--medium .slds-spinner__dot-b::before{\n  animation-name:dotsBounceBefore-medium;\n  inset-block-start:-0.25rem;\n  inset-inline-start:-0.25rem;\n}\n.slds-spinner_medium.slds-spinner::after,.slds-spinner--medium.slds-spinner::after,\n.slds-spinner_medium .slds-spinner__dot-a::after,\n.slds-spinner--medium .slds-spinner__dot-a::after,\n.slds-spinner_medium .slds-spinner__dot-b::after,\n.slds-spinner--medium .slds-spinner__dot-b::after{\n  animation-name:dotsBounceAfter-medium;\n  inset-block-start:-0.25rem;\n  inset-inline-end:-0.25rem;\n}\n@keyframes dotsBounceBefore-medium{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    transform:translate3d(0, 0, 0);\n    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  }\n\n  80%{\n    transform:translate3d(-0.5rem, 0, 0);\n    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);\n  }\n\n  100%{\n    transform:translate3d(0, 0, 0);\n  }\n}\n@keyframes dotsBounceAfter-medium{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    transform:translate3d(0, 0, 0);\n    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  }\n\n  80%{\n    transform:translate3d(0.5rem, 0, 0);\n    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);\n  }\n\n  100%{\n    transform:translateX(0);\n  }\n}\n.slds-spinner_large,.slds-spinner--large{\n  width:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-4));\n}\n.slds-spinner_large.slds-spinner_inline,.slds-spinner--large.slds-spinner--inline{\n  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-4));\n}\n.slds-spinner_large.slds-spinner::before,.slds-spinner--large.slds-spinner::before,\n.slds-spinner_large.slds-spinner::after,\n.slds-spinner--large.slds-spinner::after,\n.slds-spinner_large .slds-spinner__dot-a::before,\n.slds-spinner--large .slds-spinner__dot-a::before,\n.slds-spinner_large .slds-spinner__dot-b::before,\n.slds-spinner--large .slds-spinner__dot-b::before,\n.slds-spinner_large .slds-spinner__dot-a::after,\n.slds-spinner--large .slds-spinner__dot-a::after,\n.slds-spinner_large .slds-spinner__dot-b::after,\n.slds-spinner--large .slds-spinner__dot-b::after{\n  width:calc(var(--slds-g-sizing-3) + var(--slds-g-sizing-1));\n  height:calc(var(--slds-g-sizing-3) + var(--slds-g-sizing-1));\n}\n.slds-spinner_large.slds-spinner::before,.slds-spinner--large.slds-spinner::before,\n.slds-spinner_large .slds-spinner__dot-a::before,\n.slds-spinner--large .slds-spinner__dot-a::before,\n.slds-spinner_large .slds-spinner__dot-b::before,\n.slds-spinner--large .slds-spinner__dot-b::before{\n  animation-name:dotsBounceBefore-medium;\n  inset-block-start:-0.3125rem;\n  inset-inline-start:-0.3125rem;\n}\n.slds-spinner_large.slds-spinner::after,.slds-spinner--large.slds-spinner::after,\n.slds-spinner_large .slds-spinner__dot-a::after,\n.slds-spinner--large .slds-spinner__dot-a::after,\n.slds-spinner_large .slds-spinner__dot-b::after,\n.slds-spinner--large .slds-spinner__dot-b::after{\n  animation-name:dotsBounceAfter-medium;\n  inset-block-start:-0.3125rem;\n  inset-inline-end:-0.3125rem;\n}\n@keyframes dotsBounceBefore-large{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    transform:translate3d(0, 0, 0);\n    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  }\n\n  80%{\n    transform:translate3d(-0.75rem, 0, 0);\n    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);\n  }\n\n  100%{\n    transform:translateX(0);\n  }\n}\n@keyframes dotsBounceAfter-large{\n  0%{\n    transform:translate3d(0, 0, 0);\n  }\n\n  60%{\n    transform:translate3d(0, 0, 0);\n    animation-timing-function:cubic-bezier(0.55, 0.085, 0.68, 0.53);\n  }\n\n  80%{\n    transform:translate3d(0.75rem, 0, 0);\n    animation-timing-function:cubic-bezier(0, 1.11, 0.7, 1.43);\n  }\n\n  100%{\n    transform:translateX(0);\n  }\n}\n.slds-split-view_container,.slds-split-view--container{\n  position:relative;\n  display:flex;\n  flex-direction:column;\n  min-width:0;\n  height:100%;\n}\n.slds-split-view_container.slds-is-closed .slds-split-view,.slds-split-view--container.slds-is-closed .slds-split-view{\n  display:none;\n}\n.slds-split-view_container.slds-is-closed .slds-split-view__toggle-button .slds-button__icon,.slds-split-view--container.slds-is-closed .slds-split-view__toggle-button .slds-button__icon{\n  transform:rotate(180deg);\n}\n.slds-split-view_container.slds-is-open,.slds-split-view--container.slds-is-open{\n  flex:1 1 auto;\n}\n.slds-split-view_container.slds-is-open .slds-split-view,.slds-split-view--container.slds-is-open .slds-split-view{\n  display:inherit;\n}\n.slds-split-view_container.slds-is-open .slds-split-view__toggle-button .slds-button__icon,.slds-split-view--container.slds-is-open .slds-split-view__toggle-button .slds-button__icon{\n  transform:rotate(0);\n}\n.slds-split-view{\n  background:var(--slds-g-color-surface-2);\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-split-view__header{\n  padding-block-start:var(--slds-g-spacing-4);\n  padding-block-end:var(--slds-g-spacing-2);\n  padding-inline-start:var(--slds-g-spacing-5);\n  padding-inline-end:var(--slds-g-spacing-4);\n}\n.slds-split-view__list-header{\n  font-size:var(--slds-g-font-scale-1);\n  font-weight:var(--slds-g-font-weight-7);\n  line-height:var(--slds-g-font-lineheight-2);\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  padding-block:var(--slds-g-spacing-2);\n  padding-inline-start:var(--slds-g-spacing-5);\n  padding-inline-end:var(--slds-g-spacing-4);\n}\n.slds-split-view__list-item{\n  display:flex;\n  position:relative;\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  font-size:var(--slds-g-font-scale-neg-1);\n}\n.slds-split-view__list-item:hover,\n.slds-split-view__list-item:focus{\n  background:var(--slds-g-color-surface-container-1);\n}\n.slds-split-view__list-item .slds-indicator_unread,.slds-split-view__list-item .slds-indicator--unread,\n.slds-split-view__list-item .slds-indicator--unread{\n  background:var(--slds-g-color-accent-1);\n}\n.slds-indicator_unread,.slds-indicator--unread{\n  width:8px;\n  height:8px;\n  position:absolute;\n  inset-block-start:var(--slds-g-spacing-4);\n  inset-inline-start:var(--slds-g-spacing-2);\n  display:block;\n  border-radius:var(--slds-g-radius-border-circle);\n  background:var(--slds-g-color-error-1);\n}\n.slds-split-view__list-item-action{\n  color:currentColor;\n  padding-block-start:var(--slds-g-spacing-3);\n  padding-block-end:var(--slds-g-spacing-2);\n  padding-inline-start:var(--slds-g-spacing-5);\n  padding-inline-end:var(--slds-g-spacing-4);\n}\n.slds-split-view__list-item-action:hover,\n.slds-split-view__list-item-action:focus{\n  outline:none;\n  background:var(--slds-g-color-surface-container-1);\n  color:currentColor;\n  text-decoration:none;\n}\n.slds-split-view__list-item-action:focus{\n  box-shadow:inset 0 0 0 1px var(--slds-g-color-accent-1);\n}\n.slds-split-view__list-item-action[aria-current='page']{\n  box-shadow:inset 4px 0 0 var(--slds-g-color-accent-1);\n}\n.slds-split-view__list-item-action[aria-current='page']:focus{\n  box-shadow:inset 4px 0 0 var(--slds-g-color-accent-1), inset 0 0 0 1px var(--slds-g-color-accent-1);\n}\n.slds-split-view__toggle-button{\n  position:absolute;\n  inset-inline-end:calc(0.75rem * -1);\n  height:100%;\n  width:0.75rem;\n  background:var(--slds-g-color-surface-container-1);\n  border-radius:0;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-split-view__toggle-button:hover,\n.slds-split-view__toggle-button:focus{\n  background:var(--slds-g-color-surface-container-1);\n}\n.slds-split-view__toggle-button.slds-is-closed .slds-button__icon{\n  transform:rotate(180deg);\n}\n.slds-tile + .slds-tile{\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-tile__detail{\n  position:relative;\n}\n.slds-tile__meta{\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-tile_board,.slds-tile--board{\n  position:relative;\n}\n.slds-tile_board .slds-has-alert,.slds-tile--board .slds-has-alert{\n  padding-inline-end:var(--slds-g-spacing-5);\n}\n.slds-tile_board__icon,.slds-tile--board__icon{\n  width:var(--slds-g-spacing-4);\n  height:var(--slds-g-spacing-4);\n  position:absolute;\n  inset-block-end:var(--slds-g-spacing-1);\n  inset-inline-end:var(--slds-g-spacing-1);\n}\n.slds-tabs_default,.slds-tabs--default{\n  --_slds-c-tabs-spacing-var-font-size-medium:var(--lwc-varFontSize5);\n  --_slds-c-tabs-spacing-var-font-size-large:var(--lwc-varFontSize7);\n\n  display:block;\n  width:100%;\n}\n.slds-tabs_default .slds-tabs__item_overflow,.slds-tabs--default .slds-tabs__item--overflow{\n  overflow:visible;\n}\n.slds-tabs_default__nav,.slds-tabs--default__nav{\n  display:flex;\n  align-items:flex-start;\n  border-block-end-width:var(--slds-c-tabs-list-sizing-border, var(--slds-g-sizing-border-1));\n  border-block-end-style:solid;\n  border-block-end-color:var(\n    --slds-c-tabs-list-color-border,\n    var(--slds-s-navigation-color-border, var(--slds-g-color-border-1))\n  );\n}\n.slds-tabs_default__item,.slds-tabs--default__item{\n  color:var(--slds-c-tabs-item-text-color, var(--slds-s-navigation-color, var(--slds-g-color-on-surface-2)));\n  position:relative;\n  padding-block-start:var(--slds-c-tabs-item-spacing-blockstart, 0);\n  padding-inline-end:var(--slds-c-tabs-item-spacing-inlineend, var(--slds-g-spacing-3));\n  padding-block-end:var(--slds-c-tabs-item-spacing-blockend, 0);\n  padding-inline-start:var(--slds-c-tabs-item-spacing-inlinestart, var(--slds-g-spacing-3));\n  margin-block-end:calc(var(--slds-c-tabs-list-sizing-border, var(--slds-c-tabs-list-sizing-border)) * -1);\n  font-weight:var(--slds-s-navigation-font-weight);\n}\n.slds-tabs_default__item::after,.slds-tabs--default__item::after{\n  display:block;\n  content:'';\n  inset-block-end:0;\n  inset-inline-start:0;\n  inset-inline-end:0;\n  height:0;\n  position:absolute;\n}\n.slds-tabs_default__item.slds-is-active,.slds-tabs--default__item.slds-is-active{\n  --slds-c-tabs-item-text-color:var(\n    --slds-c-tabs-item-text-color-active,\n    var(--slds-s-navigation-color-active, var(--slds-g-color-on-surface-3))\n  );\n}\n.slds-tabs_default__item.slds-is-active::after,.slds-tabs--default__item.slds-is-active::after{\n  background-color:var(--slds-c-tabs-item-color-border-active, var(--slds-g-color-accent-2));\n  height:var(--slds-c-tabs-list-sizing-border, var(--slds-s-navigation-sizing-border-active));\n}\n.slds-tabs_default__item.slds-is-active .slds-tabs_default__link,.slds-tabs--default__item.slds-is-active .slds-tabs--default__link{\n  font-weight:var(--slds-s-navigation-font-weight-active);\n}\n.slds-tabs_default__item.slds-is-active .slds-tabs_default__link:hover,.slds-tabs--default__item.slds-is-active .slds-tabs--default__link:hover{\n  color:currentColor;\n}\n.slds-tabs_default__item:hover,.slds-tabs--default__item:hover{\n  color:var(--slds-s-navigation-color-hover);\n}\n.slds-tabs_default__item:hover::after,.slds-tabs--default__item:hover::after{\n  height:var(--slds-c-tabs-list-sizing-border, var(--slds-s-navigation-sizing-border-hover));\n  background-color:var(\n    --slds-c-tabs-item-color-border-hover,\n    var(--slds-s-navigation-color-border-hover, var(--slds-g-color-accent-3))\n  );\n}\n.slds-tabs_default__item:focus-visible,.slds-tabs--default__item:focus-visible{\n  outline:0;\n}\n.slds-tabs_default__item:focus-visible::after,.slds-tabs--default__item:focus-visible::after{\n  height:var(--slds-c-tabs-list-sizing-border, var(--slds-s-navigation-sizing-border-active));\n  background-color:var(--slds-c-tabs-item-color-border-active, var(--slds-g-color-accent-2));\n}\n.slds-tabs_default__item .slds-tabs_default__link:focus-visible,.slds-tabs--default__item .slds-tabs--default__link:focus-visible{\n  box-shadow:none;\n}\n.slds-tabs_default__item.slds-has-notification,.slds-tabs--default__item.slds-has-notification{\n  background:var(--slds-g-color-surface-container-2);\n}\n.slds-tabs_default__item.slds-has-notification::after,.slds-tabs--default__item.slds-has-notification::after{\n  background-color:var(--slds-g-color-border-1);\n}\n.slds-tabs_default__item.slds-has-notification:hover::after,.slds-tabs--default__item.slds-has-notification:hover::after{\n  background-color:var(--slds-g-color-accent-3);\n}\n.slds-tabs_default__item.slds-has-notification .slds-indicator_unread,.slds-tabs--default__item.slds-has-notification .slds-indicator--unread{\n  display:inline-block;\n  height:0.375rem;\n  width:0.375rem;\n  position:relative;\n  inset-block-start:auto;\n  inset-inline-start:auto;\n}\n.slds-tabs_default__item.slds-has-notification .slds-indicator_unsaved,.slds-tabs--default__item.slds-has-notification .slds-indicator--unsaved{\n  inset-block-start:calc(var(--slds-g-spacing-1) * -1);\n}\n.slds-tabs_default__item.slds-is-unsaved .slds-indicator_unread,.slds-tabs--default__item.slds-is-unsaved .slds-indicator--unread{\n  margin-inline-start:-0.35rem;\n}\n.slds-tabs_default__item.slds-is-unsaved .slds-indicator_unsaved,.slds-tabs--default__item.slds-is-unsaved .slds-indicator--unsaved{\n  color:var(--slds-g-color-accent-3);\n}\n.slds-tabs_default__link,.slds-tabs--default__link{\n  max-width:100%;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n  display:inline-flex;\n  align-items:center;\n  text-decoration:none;\n  cursor:pointer;\n  height:var(--slds-c-tabs-item-sizing-height, var(--slds-s-navigation-sizing-height, 2.5rem));\n  line-height:var(--slds-c-tabs-item-font-lineheight, var(--slds-s-navigation-font-lineheight, 2.5rem));\n  color:currentColor;\n  border:0;\n  text-transform:inherit;\n  z-index:1;\n}\n.slds-tabs_default__link:focus-visible,.slds-tabs--default__link:focus-visible{\n  outline:0;\n}\n.slds-tabs_default__link:hover,.slds-tabs--default__link:hover,\n.slds-tabs_default__link:focus,\n.slds-tabs--default__link:focus{\n  text-decoration:none;\n  box-shadow:none;\n  color:currentColor;\n}\n.slds-tabs_default__link[tabindex='0']:focus-visible,.slds-tabs--default__link[tabindex='0']:focus-visible{\n  text-decoration:underline;\n}\n.slds-tabs_default__overflow-button,.slds-tabs--default__overflow-button{\n  display:inline-flex;\n  height:var(--slds-c-tabs-item-sizing-height, var(--slds-s-navigation-sizing-height, 2.5rem));\n  line-height:var(--slds-c-tabs-item-font-lineheight, var(--slds-s-navigation-font-lineheight, 2.5rem));\n}\n.slds-tabs_default__overflow-button .slds-button,.slds-tabs--default__overflow-button .slds-button{\n  line-height:inherit;\n  color:var(--slds-c-tabs-item-text-color, var(--slds-g-color-on-surface-1));\n  box-shadow:none;\n  --slds-c-button-color-border-active:transparent;\n}\n.slds-tabs_default__overflow-button .slds-button:focus-visible,.slds-tabs--default__overflow-button .slds-button:focus-visible{\n  text-decoration:underline;\n}\n.slds-tabs_default__overflow-button.slds-has-error .slds-button,.slds-tabs--default__overflow-button.slds-has-error .slds-button, .slds-tabs_default__overflow-button.slds-has-success .slds-button, .slds-tabs--default__overflow-button.slds-has-success .slds-button{\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-tabs_default__content,.slds-tabs--default__content{\n  position:relative;\n  padding-block-start:var(\n    --slds-c-tabs-panel-spacing-blockstart,\n    var(--slds-c-tabs-panel-spacing-block, var(--slds-g-spacing-3))\n  );\n  padding-inline-end:var(--slds-c-tabs-panel-spacing-inlineend, var(--slds-c-tabs-panel-spacing-inline, 0));\n  padding-block-end:var(\n    --slds-c-tabs-panel-spacing-blockend,\n    var(--slds-c-tabs-panel-spacing-block, var(--slds-g-spacing-3))\n  );\n  padding-inline-start:var(\n    --slds-c-tabs-panel-spacing-inlinestart,\n    var(--slds-c-tabs-panel-spacing-inline, 0)\n  );\n}\n.slds-tabs_medium .slds-tabs_default__item,.slds-tabs--medium .slds-tabs--default__item{\n  font-size:var(--_slds-c-tabs-spacing-var-font-size-medium);\n}\n.slds-tabs_large .slds-tabs_default__item,.slds-tabs--large .slds-tabs--default__item{\n  font-size:var(--_slds-c-tabs-spacing-var-font-size-large);\n}\n.slds-tabs__left-icon{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-tabs__left-icon:empty{\n  margin-inline-end:0;\n}\n.slds-tabs__right-icon{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-tabs_scoped,.slds-tabs--scoped{\n  display:block;\n  width:100%;\n}\n.slds-tabs_scoped__nav,.slds-tabs--scoped__nav{\n  display:flex;\n  align-items:flex-start;\n  background-color:var(--slds-s-navigation-color-background);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border);\n  border-start-start-radius:var(--slds-s-navigation-radius-border);\n  border-start-end-radius:var(--slds-s-navigation-radius-border);\n  border-end-end-radius:0;\n  border-end-start-radius:0;\n}\n.slds-tabs_scoped__item,.slds-tabs--scoped__item{\n  position:relative;\n  margin-block-end:calc(var(--slds-g-sizing-border-1) * -1);\n}\n.slds-tabs_scoped__item + .slds-tabs_scoped__item,.slds-tabs--scoped__item + .slds-tabs--scoped__item{\n  margin-inline-start:calc(var(--slds-g-sizing-border-1) * -1);\n}\n.slds-tabs_scoped__item:first-child .slds-tabs_scoped__link,.slds-tabs--scoped__item:first-child .slds-tabs--scoped__link{\n  border-inline-start:0;\n  border-start-start-radius:var(--slds-s-navigation-radius-border);\n  border-start-end-radius:0;\n  border-end-end-radius:0;\n  border-end-start-radius:0;\n}\n.slds-tabs_scoped__content,.slds-tabs--scoped__content{\n  background-color:var(--slds-s-navigation-color-background-active);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border, var(--slds-g-color-border-1));\n  border-block-start:0;\n  border-start-start-radius:0;\n  border-start-end-radius:0;\n  border-end-end-radius:var(--slds-s-navigation-radius-border);\n  border-end-start-radius:var(--slds-s-navigation-radius-border);\n  padding:var(--slds-g-spacing-4);\n}\n.slds-tabs_scoped__link,.slds-tabs--scoped__link{\n  max-width:100%;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n  display:block;\n  text-decoration:none;\n  cursor:pointer;\n  height:var(--slds-c-tabs-item-sizing-height, var(--slds-s-navigation-sizing-height, 2.5rem));\n  line-height:var(--slds-c-tabs-item-font-lineheight, var(--slds-s-navigation-font-lineheight, 2.5rem));\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-4);\n  color:var(--slds-s-navigation-color, var(--slds-g-color-on-surface-1));\n  font-weight:var(--slds-s-navigation-font-weight);\n  background-clip:padding-box;\n  border:0;\n  border-inline-start:var(--slds-g-sizing-border-1) solid transparent;\n  border-inline-end:var(--slds-g-sizing-border-1) solid transparent;\n  border-block-end:var(--slds-g-sizing-border-1) solid transparent;\n  border-radius:0;\n}\n.slds-tabs_scoped__link:hover,.slds-tabs--scoped__link:hover,\n.slds-tabs_scoped__link:focus,\n.slds-tabs--scoped__link:focus{\n  outline:0;\n  text-decoration:none;\n  color:currentColor;\n  background-color:var(--slds-s-navigation-color-background-hover);\n  border-color:var(--slds-s-navigation-color-border, var(--slds-g-color-border-1));\n}\n.slds-tabs_scoped__overflow-button,.slds-tabs--scoped__overflow-button{\n  display:inline-flex;\n  height:var(--slds-c-tabs-item-sizing-height, var(--slds-s-navigation-sizing-height, 2.5rem));\n  line-height:var(--slds-c-tabs-item-font-lineheight, var(--slds-s-navigation-font-lineheight, 2.5rem));\n}\n.slds-tabs_scoped__overflow-button .slds-button,.slds-tabs--scoped__overflow-button .slds-button{\n  line-height:inherit;\n  color:var(--slds-s-navigation-color, var(--slds-g-color-on-surface-1));\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-4);\n  font-weight:var(--slds-s-navigation-font-weight);\n  --slds-c-button-color-background-hover:transparent;\n  --slds-c-button-shadow-focus:none;\n  --slds-c-button-radius-border:0;\n}\n.slds-tabs_scoped__overflow-button .slds-button:focus-visible,.slds-tabs--scoped__overflow-button .slds-button:focus-visible{\n  text-decoration:underline;\n}\n.slds-tabs_scoped__overflow-button .slds-button:active,.slds-tabs--scoped__overflow-button .slds-button:active{\n  box-shadow:none;\n}\n.slds-is-active .slds-tabs_scoped__link,.slds-is-active .slds-tabs--scoped__link{\n  background-color:var(--slds-s-navigation-color-background-active);\n  border-color:var(--slds-s-navigation-color-border, var(--slds-g-color-border-1));\n  font-weight:var(--slds-s-navigation-font-weight-active);\n  color:var(--slds-s-navigation-color-active, var(--slds-g-color-on-surface-3));\n  border-block-end:none;\n}\n.slds-is-active .slds-tabs_scoped__link:hover,.slds-is-active .slds-tabs--scoped__link:hover{\n  border-bottom-color:transparent;\n}\n.slds-is-active .slds-tabs_scoped__link:focus-visible,.slds-is-active .slds-tabs--scoped__link:focus-visible{\n  text-decoration:underline;\n}\n.slds-vertical-tabs{\n  display:flex;\n  overflow:hidden;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border);\n  border-radius:var(--slds-g-radius-border-2);\n}\n.slds-vertical-tabs__nav{\n  width:var(--slds-g-sizing-14);\n  border-inline-end:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border);\n  background:var(--slds-s-navigation-color-background);\n}\n.slds-vertical-tabs__nav-item{\n  display:flex;\n  align-items:center;\n  overflow:hidden;\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-s-navigation-color-border);\n  color:var(--slds-s-navigation-color);\n}\n.slds-vertical-tabs__nav-item:last-child{\n  margin-block-end:-1px;\n}\n.slds-vertical-tabs__link{\n  display:flex;\n  flex:1 1 0%;\n  align-items:center;\n  min-width:0;\n  padding:var(--slds-g-spacing-3);\n  color:currentColor;\n  font-weight:var(--slds-s-navigation-font-weight);\n}\n.slds-vertical-tabs__link:hover{\n  background:var(--slds-s-navigation-color-background-hover);\n  color:var(--slds-g-color-on-surface-3);\n  text-decoration:none;\n}\n.slds-vertical-tabs__link:focus{\n  outline:0;\n  color:currentColor;\n}\n.slds-vertical-tabs__left-icon{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-vertical-tabs__left-icon:empty{\n  margin-inline-end:0;\n}\n.slds-vertical-tabs__right-icon{\n  margin-inline-start:auto;\n}\n.slds-vertical-tabs__content{\n  flex:1;\n  padding:var(--slds-g-spacing-3);\n  background:var(--slds-s-navigation-color-background-active);\n}\n.slds-vertical-tabs__nav-item.slds-is-active{\n  margin-inline-end:-1px;\n  border-inline-end:0;\n  background:var(--slds-s-navigation-color-background-active);\n  color:var(--slds-s-navigation-color-active);\n}\n.slds-vertical-tabs__nav-item.slds-is-active .slds-vertical-tabs__link:hover{\n  background:var(--slds-s-navigation-color-background-active);\n  color:currentColor;\n}\n.slds-vertical-tabs__nav-item.slds-is-active .slds-vertical-tabs__link{\n  font-weight:var(--slds-s-navigation-font-weight-active);\n}\n.slds-vertical-tabs__nav-item:has(:focus-visible){\n  text-decoration:underline;\n}\n.slds-sub-tabs .slds-tabs_default__nav,.slds-sub-tabs .slds-tabs--default__nav{\n  background-color:var(--slds-g-color-surface-container-1);\n  border-block-end-width:var(--slds-g-sizing-border-1);\n}\n.slds-sub-tabs__item{\n  text-transform:none;\n  letter-spacing:0;\n  margin-block-end:0;\n  font-weight:normal;\n}\n.slds-sub-tabs__item.slds-active,\n.slds-sub-tabs__item.slds-is-open{\n  background-color:var(\n    --_slds-c-globalnavigation-subtab-color-background-active,\n    var(--slds-g-color-accent-light-1)\n  );\n  color:var(--_slds-c-globalnavigation-item-color-active, var(--slds-g-color-on-surface-1));\n}\n.slds-sub-tabs__item.slds-active .slds-button__icon,\n.slds-sub-tabs__item.slds-active .slds-icon,\n.slds-sub-tabs__item.slds-is-open .slds-button__icon,\n.slds-sub-tabs__item.slds-is-open .slds-icon{\n  fill:var(--_slds-c-globalnavigation-item-color-active, var(--slds-g-color-on-surface-1));\n}\n.slds-sub-tabs__item.slds-active:hover, .slds-sub-tabs__item.slds-is-open:hover{\n  background-color:var(\n    --_slds-c-globalnavigation-subtab-color-background-active,\n    var(--slds-g-color-accent-light-1)\n  );\n}\n.slds-sub-tabs__item::after{\n  content:none;\n}\n.slds-sub-tabs__item:hover{\n  background-color:var(\n    --_slds-c-globalnavigation-subtab-color-background-hover,\n    var(--slds-g-color-accent-light-1)\n  );\n}\n.slds-sub-tabs__item .slds-tabs_default__link:focus-visible,.slds-sub-tabs__item .slds-tabs--default__link:focus-visible{\n  text-decoration:underline;\n}\n.slds-sub-tabs__item + .slds-sub-tabs__item{\n  margin-inline-start:0;\n}\n.slds-sub-tabs__item .slds-icon_container,.slds-sub-tabs__item .slds-icon--container{\n  --slds-c-icon-color-background:transparent;\n  --slds-c-icon-color-foreground:var(--slds-g-color-on-surface-1);\n}\n.slds-sub-tabs__item .slds-button__icon,\n.slds-sub-tabs__item .slds-icon{\n  fill:var(--slds-g-color-on-surface-1);\n}\n.slds-sub-tabs__item.slds-has-success{\n  color:var(--slds-g-color-on-success-1);\n}\n.slds-sub-tabs__item.slds-has-success .slds-button__icon,\n.slds-sub-tabs__item.slds-has-success .slds-icon{\n  fill:var(--slds-g-color-on-success-1);\n}\n.slds-sub-tabs__item.slds-has-success::before{\n  animation-duration:1s;\n  animation-iteration-count:3;\n  animation-timing-function:linear;\n  background-color:var(--slds-g-color-success-container-1);\n  inset-block-end:0;\n  content:' ';\n  inset-inline-start:0;\n  position:absolute;\n  inset-inline-end:0;\n  inset-block-start:0;\n  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);\n  animation-name:success-pulse;\n}\n.slds-sub-tabs__item.slds-has-success:hover::before{\n  background-color:var(--slds-g-color-success-container-2);\n}\n.slds-sub-tabs__item.slds-has-success .slds-indicator_unread,.slds-sub-tabs__item.slds-has-success .slds-indicator--unread{\n  background-color:currentColor;\n}\n.slds-sub-tabs__item.slds-has-success .slds-indicator_unsaved,.slds-sub-tabs__item.slds-has-success .slds-indicator--unsaved{\n  color:currentColor;\n}\n.slds-sub-tabs__item.slds-has-error{\n  color:var(--slds-g-color-on-error-1);\n}\n.slds-sub-tabs__item.slds-has-error .slds-button__icon,\n.slds-sub-tabs__item.slds-has-error .slds-icon{\n  fill:var(--slds-g-color-on-error-1);\n}\n.slds-sub-tabs__item.slds-has-error::before{\n  animation-duration:1s;\n  animation-iteration-count:3;\n  animation-timing-function:linear;\n  background-color:var(--slds-g-color-error-container-1);\n  inset-block-end:0;\n  content:' ';\n  inset-inline-start:0;\n  position:absolute;\n  inset-inline-end:0;\n  inset-block-start:0;\n  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);\n  animation-name:error-pulse;\n}\n.slds-sub-tabs__item.slds-has-error:hover::before{\n  background-color:var(--slds-g-color-error-container-2);\n}\n.slds-sub-tabs__item.slds-has-error .slds-indicator_unread,.slds-sub-tabs__item.slds-has-error .slds-indicator--unread{\n  background-color:currentColor;\n}\n.slds-sub-tabs__item.slds-has-error .slds-indicator_unsaved,.slds-sub-tabs__item.slds-has-error .slds-indicator--unsaved{\n  color:currentColor;\n}\n.slds-sub-tabs__item.slds-has-warning{\n  color:var(--slds-g-color-on-warning-1);\n}\n.slds-sub-tabs__item.slds-has-warning .slds-button__icon,\n.slds-sub-tabs__item.slds-has-warning .slds-icon{\n  fill:var(--slds-g-color-on-warning-1);\n}\n.slds-sub-tabs__item.slds-has-warning::before{\n  animation-duration:1s;\n  animation-iteration-count:3;\n  animation-timing-function:linear;\n  background-color:var(--slds-g-color-warning-container-1);\n  inset-block-end:0;\n  content:' ';\n  inset-inline-start:0;\n  position:absolute;\n  inset-inline-end:0;\n  inset-block-start:0;\n  transition:background-color 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);\n  animation-name:warning-pulse;\n}\n.slds-sub-tabs__item.slds-has-warning:hover::before{\n  background-color:var(--slds-g-color-warning-base-80);\n}\n.slds-sub-tabs__item.slds-has-warning .slds-indicator_unread,.slds-sub-tabs__item.slds-has-warning .slds-indicator--unread{\n  background-color:currentColor;\n}\n.slds-sub-tabs__item.slds-has-warning .slds-indicator_unsaved,.slds-sub-tabs__item.slds-has-warning .slds-indicator--unsaved{\n  color:currentColor;\n}\n.slds-has-pinned-regions .slds-sub-tabs__item.slds-active::before, .slds-has-pinned-regions .slds-sub-tabs__item.slds-is-open::before{\n  content:'';\n  height:3px;\n  display:block;\n  background:var(--slds-g-color-accent-2);\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-start:-1px;\n  inset-inline-end:-1px;\n}\n.slds-tab__scroll-controls{\n  display:none;\n}\n.slds-tabs-mobile__container{\n  position:relative;\n  overflow:hidden;\n}\n.slds-panel__body .slds-tabs-mobile:first-child{\n  margin-block-start:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-panel__body .slds-tabs-mobile:first-child .slds-tabs-mobile__item:first-child{\n  border-block-start:0;\n}\n.slds-panel__body .slds-tabs-mobile{\n  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);\n  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-tabs-mobile{\n  display:flex;\n  flex-direction:column;\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-tabs-mobile__item{\n  display:flex;\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-4));\n  align-items:stretch;\n  color:var(--slds-g-color-on-surface-3);\n  font-size:var(--slds-g-font-scale-2);\n  padding:0 var(--slds-g-spacing-3);\n}\n.slds-tabs-mobile__item:active{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-tabs-mobile__item:last-child{\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-tabs-mobile__group\n.slds-tabs-mobile__container\n+ .slds-tabs-mobile__container\n.slds-tabs-mobile__item:first-child{\n  border-block-start:0;\n}\n.slds-table_tree .slds-tree__item,.slds-table--tree .slds-tree__item{\n  line-height:var(--slds-g-font-lineheight-4);\n}\n.slds-table_tree .slds-tree__item a,.slds-table--tree .slds-tree__item a{\n  color:var(--slds-s-link-color);\n}\n.slds-table_tree .slds-tree__item a:hover,.slds-table--tree .slds-tree__item a:hover{\n  text-decoration:underline;\n}\n.slds-table_tree .slds-button,.slds-table--tree .slds-button,\n.slds-table--tree .slds-button{\n  align-self:center;\n}\n.slds-table_tree .slds-button:not(.slds-th__action-button),.slds-table--tree .slds-button:not(.slds-th__action-button){\n  margin-block-start:0;\n}\n[aria-level='1'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='2'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='3'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='4'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='5'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='6'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='7'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='8'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='9'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='10'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='11'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='12'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='13'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='14'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='15'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='16'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='17'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='18'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='19'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n[aria-level='20'] > .slds-tree__item{\n  padding-inline-start:calc((var(--slds-g-spacing-4) * 1) + var(--slds-g-spacing-2));\n}\n.slds-tree-container,\n.slds-tree_container,\n.slds-tree--container{\n  min-width:25rem;\n  max-width:var(--slds-c-tree-sizing-max-width, 25rem);\n}\n.slds-tree-container > .slds-text-heading_label,.slds-tree-container > .slds-text-heading--label,\n.slds-tree_container > .slds-text-heading_label,\n.slds-tree--container > .slds-text-heading--label{\n  margin-block-end:var(--slds-g-spacing-2);\n}\n.slds-tree__item{\n  display:flex;\n  padding-block-start:calc(var(--slds-g-spacing-1) + 2px);\n  padding-block-end:calc(var(--slds-g-spacing-1) + 2px);\n  padding-inline-start:var(--slds-g-spacing-4);\n  padding-inline-end:0;\n}\n.slds-tree__item.slds-is-hovered,\n.slds-tree__item:hover{\n  background:var(--slds-s-table-row-color-background-selected, var(--slds-g-color-surface-container-2));\n  cursor:pointer;\n}\n.slds-tree [role='treeitem']:focus{\n  outline:0;\n}\n.slds-tree [role='treeitem']:focus > .slds-tree__item{\n  background:var(--slds-g-color-surface-container-2);\n  cursor:pointer;\n  text-decoration:underline;\n}\n.slds-tree [role='treeitem'][aria-selected='true'] > .slds-tree__item{\n  background:var(--slds-g-color-brand-base-90);\n  box-shadow:var(--slds-g-color-accent-1) 4px 0 0 inset;\n}\n.slds-tree [role='treeitem'][aria-selected='true'] > .slds-tree__item [dir='rtl']{\n  box-shadow:var(--slds-g-color-accent-1) -4px 0 0 inset;\n}\n.slds-tree [aria-disabled='true']{\n  color:var(--slds-g-color-disabled-1);\n}\n.slds-tree [aria-disabled='true'] .slds-tree__item.slds-is-hovered,\n.slds-tree [aria-disabled='true'] .slds-tree__item:hover{\n  background-color:transparent;\n  cursor:default;\n}\n.slds-tree [aria-disabled='true'] .slds-tree__item-meta{\n  color:inherit;\n}\n.slds-tree [role='treeitem'] > [role='group']{\n  display:none;\n}\n.slds-tree [role='treeitem'][aria-expanded='true'] > [role='group']{\n  display:block;\n}\n[aria-expanded='false'] > .slds-tree__item .slds-button__icon{\n  transition:0.2s transform ease-in-out;\n  transform:rotate(0deg);\n}\n[aria-expanded='true'] > .slds-tree__item .slds-button__icon{\n  transition:0.2s transform ease-in-out;\n  transform:rotate(90deg);\n}\n[aria-expanded='true'] > .slds-tree__item .slds-button__icon [dir='rtl']{\n  transform:rotate(-90deg);\n}\n[aria-level='1'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 1);\n}\n[aria-level='2'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 2);\n}\n[aria-level='3'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 3);\n}\n[aria-level='4'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 4);\n}\n[aria-level='5'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 5);\n}\n[aria-level='6'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 6);\n}\n[aria-level='7'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 7);\n}\n[aria-level='8'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 8);\n}\n[aria-level='9'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 9);\n}\n[aria-level='10'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 10);\n}\n[aria-level='11'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 11);\n}\n[aria-level='12'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 12);\n}\n[aria-level='13'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 13);\n}\n[aria-level='14'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 14);\n}\n[aria-level='15'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 15);\n}\n[aria-level='16'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 16);\n}\n[aria-level='17'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 17);\n}\n[aria-level='18'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 18);\n}\n[aria-level='19'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 19);\n}\n[aria-level='20'] > .slds-tree__item{\n  padding-inline-start:calc(var(--slds-g-spacing-4) * 20);\n}\n.slds-tree__item-label{\n  display:block;\n}\n.slds-tree__item-meta{\n  display:block;\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-tree__item .slds-button{\n  align-self:flex-start;\n  margin-block-start:2px;\n}\n.slds-tree__item .slds-pill{\n  margin-inline-start:var(--slds-g-spacing-3);\n}\n.slds-tree__group-header{\n  font-size:var(--slds-g-font-scale-1);\n  font-weight:var(--slds-g-font-weight-7);\n}\n.slds-notify_alert,.slds-notify--alert{\n  position:relative;\n  display:inline-flex;\n  align-items:center;\n  justify-content:center;\n  width:100%;\n  padding-block-start:var(--slds-c-alert-spacing-blockstart, var(--slds-g-spacing-2));\n  padding-inline-end:var(--slds-c-alert-spacing-inlineend, var(--slds-g-spacing-6));\n  padding-block-end:var(--slds-c-alert-spacing-blockend, var(--slds-g-spacing-2));\n  padding-inline-start:var(--slds-c-alert-spacing-inlinestart, var(--slds-g-spacing-2));\n  color:var(--slds-c-alert-text-color, var(--slds-g-color-on-info-1));\n  font-weight:var(--slds-c-alert-font-weight);\n  text-align:center;\n  background-color:var(--slds-c-alert-color-background, var(--slds-g-color-info-container-1));\n}\n.slds-notify_alert .slds-icon,.slds-notify--alert .slds-icon,\n.slds-notify_alert .slds-button__icon,\n.slds-notify--alert .slds-button__icon{\n  fill:currentColor;\n}\n.slds-notify_alert .slds-button_icon,.slds-notify--alert .slds-button--icon{\n  color:currentColor;\n}\n.slds-notify_alert .slds-button_icon:hover,.slds-notify--alert .slds-button--icon:hover,\n.slds-notify_alert .slds-button_icon:focus-visible,\n.slds-notify--alert .slds-button--icon:focus-visible{\n  color:var(--slds-s-alert-close-button-hover, color-mix(in oklab, currentColor, transparent 25%));\n}\n.slds-notify_alert a,.slds-notify--alert a{\n  color:currentColor;\n  border:var(--slds-g-sizing-border-1) solid transparent;\n  border-radius:var(--slds-g-radius-border-2);\n  text-decoration:underline;\n}\n.slds-notify_alert a:hover,.slds-notify--alert a:hover,\n.slds-notify_alert a:focus,\n.slds-notify--alert a:focus{\n  text-decoration:none;\n  outline:0;\n}\n.slds-notify_alert a:focus-visible,.slds-notify--alert a:focus-visible{\n  box-shadow:var(--slds-c-alert-shadow, 0 0 3px var(--slds-g-color-on-info-1));\n  border-width:var(--slds-c-alert-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(--slds-c-alert-color-border, var(--slds-g-color-on-info-1));\n}\n.slds-notify_alert a:active,.slds-notify--alert a:active{\n  color:var(--slds-c-alert-text-color-active, color-mix(in oklab, currentColor, transparent 50%));\n}\n.slds-notify_alert a[disabled],.slds-notify--alert a[disabled]{\n  color:color-mix(in oklab, currentColor, transparent 90%);\n}\n.slds-alert_warning,.slds-alert--warning{\n  --slds-c-alert-color-background:var(--slds-g-color-warning-container-1);\n  --slds-c-alert-text-color:var(--slds-g-color-on-warning-1);\n}\n.slds-alert_error,.slds-alert--error{\n  --slds-c-alert-color-background:var(--slds-g-color-error-container-1);\n  --slds-c-alert-text-color:var(--slds-g-color-on-error-1);\n}\n.slds-alert_offline,.slds-alert--offline{\n  --slds-c-alert-color-background:var(--slds-g-color-neutral-base-50);\n  --slds-c-alert-text-color:var(--slds-g-color-neutral-base-100);\n}\n.slds-notify__close{\n  position:absolute;\n  inset-inline-end:var(--slds-g-spacing-3);\n  margin-inline-start:var(--slds-g-spacing-1);\n  top:50%;\n  transform:translateY(-50%);\n}\n.slds-scoped-notification{\n  padding:var(--slds-g-spacing-3);\n  border-radius:var(--slds-g-radius-border-2);\n  font-weight:var(--slds-s-alert-font-weight);\n}\n.slds-scoped-notification .slds-icon_container,.slds-scoped-notification .slds-icon--container{\n  display:flex;\n}\n.slds-scoped-notification a:focus-visible{\n  box-shadow:var(--slds-s-link-shadow-focus);\n  border-radius:var(--slds-g-radius-border-1);\n  outline:0;\n}\n.slds-scoped-notification.slds-theme_warning a:focus,.slds-scoped-notification.slds-theme--warning a:focus{\n  border:0;\n}\n.slds-scoped-notification_light,.slds-scoped-notification--light{\n  background-color:var(--slds-g-color-surface-container-3);\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-scoped-notification_light a,.slds-scoped-notification--light a{\n  color:var(--slds-g-color-on-surface-1);\n  text-decoration:underline;\n}\n.slds-scoped-notification_light a:link,.slds-scoped-notification--light a:link,\n.slds-scoped-notification_light a:visited,\n.slds-scoped-notification--light a:visited{\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-scoped-notification_light a:hover,.slds-scoped-notification--light a:hover,\n.slds-scoped-notification_light a:focus,\n.slds-scoped-notification--light a:focus{\n  text-decoration:none;\n}\n.slds-scoped-notification_dark,.slds-scoped-notification--dark{\n  background-color:var(--slds-g-color-neutral-base-50);\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-scoped-notification_dark a,.slds-scoped-notification--dark a{\n  color:var(--slds-g-color-neutral-base-100);\n  text-decoration:underline;\n}\n.slds-scoped-notification_dark a:hover,.slds-scoped-notification--dark a:hover,\n.slds-scoped-notification_dark a:active,\n.slds-scoped-notification--dark a:active{\n  text-decoration:none;\n}\n.slds-notify_container,.slds-notify--container{\n  position:fixed;\n  width:100%;\n  inset-inline-start:0;\n  inset-block-start:0;\n  z-index:1000;\n  text-align:center;\n}\n.slds-notify_toast,.slds-notify--toast{\n  display:inline-flex;\n  align-items:center;\n  position:relative;\n  background:none;\n  background-color:var(--slds-c-toast-color-background, var(--slds-g-color-on-surface-1));\n  color:var(--slds-c-toast-text-color);\n  border-radius:var(--slds-c-toast-radius-border, var(--slds-g-radius-border-2));\n  margin:var(--slds-g-spacing-2);\n  padding-block-start:var(--slds-c-toast-spacing-blockstart, var(--slds-g-spacing-3));\n  padding-inline-end:var(--slds-c-toast-spacing-inlineend, var(--slds-g-spacing-8));\n  padding-block-end:var(--slds-c-toast-spacing-blockend, var(--slds-g-spacing-3));\n  padding-inline-start:var(--slds-c-toast-spacing-inlinestart, var(--slds-g-spacing-5));\n  min-width:var(--slds-c-toast-sizing-width-min, var(--slds-g-sizing-16));\n  text-align:left;\n  justify-content:flex-start;\n}\n.slds-notify_toast .slds-notify__content .slds-text-heading_small,.slds-notify--toast .slds-notify__content .slds-text-heading--small{\n  font-weight:var(--slds-s-alert-font-weight);\n}\n.slds-notify_toast .slds-notify__close,.slds-notify--toast .slds-notify__close{\n  float:inline-end;\n  position:absolute;\n  top:var(--slds-g-spacing-3);\n  inset-inline-end:var(--slds-g-spacing-3);\n  margin-inline-start:var(--slds-g-spacing-1);\n  transform:translateY(var(--slds-g-sizing-1) * -1);\n}\n.slds-notify_toast .slds-button_icon,.slds-notify--toast .slds-button--icon{\n  color:currentColor;\n}\n.slds-notify_toast .slds-button_icon:hover,.slds-notify--toast .slds-button--icon:hover,\n.slds-notify_toast .slds-button_icon:focus-visible,\n.slds-notify--toast .slds-button--icon:focus-visible{\n  color:var(--slds-s-alert-close-button-hover, color-mix(in oklab, currentColor, transparent 25%));\n}\n.slds-region_narrow .slds-notify_toast,.slds-region--narrow .slds-notify--toast{\n  min-width:auto;\n  width:100%;\n  margin-inline-start:0;\n}\n.slds-trial-header{\n  color:var(--slds-g-color-surface-1);\n  height:var(--slds-s-header-sizing-height, 3.125rem);\n  background:var(--slds-g-color-surface-inverse-2);\n  padding-block:0;\n  padding-inline:var(--slds-g-spacing-4);\n  align-items:center;\n}\n.slds-trial-header .slds-dropdown__item .slds-icon{\n  fill:currentColor;\n}\n.slds-trial-header .slds-button_inverse,.slds-trial-header .slds-button--inverse{\n  border:0;\n}\n.slds-trial-header .slds-dropdown{\n  margin-block-start:var(--slds-g-spacing-4);\n}\n.slds-trial-header .slds-dropdown_inverse .slds-dropdown__item > a:hover,.slds-trial-header .slds-dropdown--inverse .slds-dropdown__item > a:hover,\n.slds-trial-header .slds-dropdown_inverse .slds-dropdown__item > a:focus,\n.slds-trial-header .slds-dropdown--inverse .slds-dropdown__item > a:focus{\n  color:var(--slds-g-color-accent-3);\n  background-color:var(--slds-g-color-surface-container-2);\n  border-color:var(--slds-g-color-border-inverse-1);\n}\n.slds-avatar{\n  --_slds-c-avatar-group-image-small:var(\n    --lwc-groupDefaultAvatarSmall,\n    url('../public/images/avatar1.jpg')\n  );\n  --_slds-c-avatar-group-image-medium:var(\n    --lwc-groupDefaultAvatarMedium,\n    url('../public/images/avatar1.jpg')\n  );\n  --_slds-c-avatar-group-image-large:var(\n    --lwc-groupDefaultAvatarLarge,\n    url('../public/images/avatar1.jpg')\n  );\n  --_slds-c-avatar-user-image-small:var(\n    --lwc-userDefaultAvatarSmall,\n    url('../public/images/avatar1.jpg')\n  );\n  --_slds-c-avatar-user-image-medium:var(\n    --lwc-userDefaultAvatarMedium,\n    url('../public/images/avatar1.jpg')\n  );\n  --_slds-c-avatar-user-image-large:var(\n    --lwc-userDefaultAvatarLarge,\n    url('../public/images/avatar1.jpg')\n  );\n\n  --slds-c-icon-color-background:var(--_slds-c-avatar-color-background);\n\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n  overflow:hidden;\n  display:inline-block;\n  vertical-align:middle;\n  border-radius:var(\n    --slds-c-avatar-radius-border,\n    var(--slds-s-avatar-radius-border, var(--slds-g-radius-border-2))\n  );\n  line-height:var(--slds-g-font-lineheight-1);\n  font-size:var(--slds-g-font-scale-1);\n}\n.slds-avatar_group-image-small,.slds-avatar--group-image-small{\n  background:var(--_slds-c-avatar-group-image-small) top left / cover no-repeat;\n}\n.slds-avatar_group-image-medium,.slds-avatar--group-image-medium{\n  background:var(--_slds-c-avatar-group-image-medium) top left / cover no-repeat;\n}\n.slds-avatar_group-image-large,.slds-avatar--group-image-large{\n  background:var(--_slds-c-avatar-group-image-large) top left / cover no-repeat;\n}\n.slds-avatar_profile-image-small,.slds-avatar--profile-image-small{\n  background:var(--_slds-c-avatar-user-image-small) top left / cover no-repeat;\n}\n.slds-avatar_profile-image-medium,.slds-avatar--profile-image-medium{\n  background:var(--_slds-c-avatar-user-image-medium) top left / cover no-repeat;\n}\n.slds-avatar_profile-image-large,.slds-avatar--profile-image-large{\n  background:var(--_slds-c-avatar-user-image-large) top left / cover no-repeat;\n}\n.slds-avatar_x-small,.slds-avatar--x-small{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n  font-size:var(--slds-g-font-scale-neg-2);\n\n  --slds-c-avatar-radius-border:var(--slds-s-avatar-radius-border, var(--slds-g-radius-border-1));\n  --_slds-c-icon-sizing:var(--slds-g-sizing-6);\n}\n.slds-avatar_small,.slds-avatar--small{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n  font-size:var(--slds-g-font-scale-neg-2);\n\n  --slds-c-avatar-radius-border:var(--slds-s-avatar-radius-border, var(--slds-g-radius-border-1));\n  --_slds-c-icon-sizing:var(--slds-g-sizing-7);\n}\n.slds-avatar_medium,.slds-avatar--medium{\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n  font-size:var(--slds-g-font-scale-1);\n\n  --_slds-c-icon-sizing:var(--slds-g-sizing-9);\n}\n.slds-avatar_large,.slds-avatar--large{\n  width:var(--slds-g-sizing-10);\n  height:var(--slds-g-sizing-10);\n  font-size:var(--slds-g-font-scale-3);\n  line-height:var(--slds-g-font-lineheight-2);\n\n  --_slds-c-icon-sizing:var(--slds-g-sizing-10);\n}\n.slds-avatar_circle,.slds-avatar--circle{\n  border-radius:var(--slds-g-radius-border-circle);\n}\n.slds-avatar_empty,.slds-avatar--empty{\n  border:var(--slds-g-sizing-border-1) dashed var(--slds-g-color-border-1);\n}\n.slds-avatar__initials{\n  display:flex;\n  justify-content:center;\n  align-content:center;\n  align-items:center;\n  margin:auto;\n  color:var(--slds-c-avatar-text-color, var(--slds-g-color-on-accent-1));\n  height:100%;\n  text-shadow:0 0 1px rgba(0, 0, 0, 80%);\n  background-color:var(--_slds-c-avatar-color-background, var(--slds-g-color-accent-container-1));\n}\n.slds-avatar__initials[title]{\n  cursor:default;\n  text-decoration:none;\n}\n.slds-avatar__initials_inverse,.slds-avatar__initials--inverse{\n  --slds-c-avatar-text-color:var(--slds-c-avatar-inverse-text-color, var(--slds-g-color-on-surface-1));\n\n  background-color:var(--slds-g-color-surface-container-2);\n  text-shadow:none;\n}\n.slds-avatar-group{\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n  position:relative;\n  display:inline-block;\n}\n.slds-avatar-grouped{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-on-accent-1);\n  line-height:0;\n  border-radius:var(--slds-s-avatar-radius-border, var(--slds-g-radius-border-circle));\n  background-color:var(--slds-g-color-accent-container-1);\n}\n.slds-avatar-grouped_inverse,.slds-avatar-grouped--inverse{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-avatar-grouped__primary{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n  position:absolute;\n  inset-inline-start:0;\n  inset-block-end:0;\n  z-index:1;\n}\n.slds-avatar-grouped__primary .slds-avatar-grouped__initials{\n  transform:scale(0.5);\n}\n.slds-avatar-grouped__secondary{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-end:0;\n}\n.slds-avatar-grouped__secondary .slds-avatar-grouped__initials{\n  transform:scale(0.4);\n}\n.slds-avatar-grouped__icon{\n  height:100%;\n  line-height:0;\n}\n.slds-avatar-grouped__icon .slds-icon{\n  width:100%;\n  height:100%;\n}\n.slds-avatar-group_x-small,.slds-avatar-group--x-small{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n}\n.slds-avatar-group_x-small .slds-avatar-grouped__primary,.slds-avatar-group--x-small .slds-avatar-grouped__primary{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n}\n.slds-avatar-group_x-small .slds-avatar-grouped__primary .slds-avatar-grouped__initials,.slds-avatar-group--x-small .slds-avatar-grouped__primary .slds-avatar-grouped__initials{\n  transform:scale(0.3);\n}\n.slds-avatar-group_x-small .slds-avatar-grouped__secondary,.slds-avatar-group--x-small .slds-avatar-grouped__secondary{\n  width:var(--slds-g-sizing-4);\n  height:var(--slds-g-sizing-4);\n}\n.slds-avatar-group_x-small .slds-avatar-grouped__secondary .slds-avatar-grouped__initials,.slds-avatar-group--x-small .slds-avatar-grouped__secondary .slds-avatar-grouped__initials{\n  transform:scale(0.18);\n}\n.slds-avatar-group_small,.slds-avatar-group--small{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n}\n.slds-avatar-group_small .slds-avatar-grouped__primary,.slds-avatar-group--small .slds-avatar-grouped__primary{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n}\n.slds-avatar-group_small .slds-avatar-grouped__primary .slds-avatar-grouped__initials,.slds-avatar-group--small .slds-avatar-grouped__primary .slds-avatar-grouped__initials{\n  transform:scale(0.4);\n}\n.slds-avatar-group_small .slds-avatar-grouped__secondary,.slds-avatar-group--small .slds-avatar-grouped__secondary{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n}\n.slds-avatar-group_small .slds-avatar-grouped__secondary .slds-avatar-grouped__initials,.slds-avatar-group--small .slds-avatar-grouped__secondary .slds-avatar-grouped__initials{\n  transform:scale(0.3);\n}\n.slds-avatar-group_medium,.slds-avatar-group--medium{\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n}\n.slds-avatar-group_medium .slds-avatar-grouped__primary,.slds-avatar-group--medium .slds-avatar-grouped__primary{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n}\n.slds-avatar-group_medium .slds-avatar-grouped__primary .slds-avatar-grouped__initials,.slds-avatar-group--medium .slds-avatar-grouped__primary .slds-avatar-grouped__initials{\n  transform:scale(0.5);\n}\n.slds-avatar-group_medium .slds-avatar-grouped__secondary,.slds-avatar-group--medium .slds-avatar-grouped__secondary{\n  width:var(--slds-g-sizing-6);\n  height:var(--slds-g-sizing-6);\n}\n.slds-avatar-group_medium .slds-avatar-grouped__secondary .slds-avatar-grouped__initials,.slds-avatar-group--medium .slds-avatar-grouped__secondary .slds-avatar-grouped__initials{\n  transform:scale(0.4);\n}\n.slds-avatar-group_large,.slds-avatar-group--large{\n  width:var(--slds-g-sizing-10);\n  height:var(--slds-g-sizing-10);\n}\n.slds-avatar-group_large .slds-avatar-grouped__primary,.slds-avatar-group--large .slds-avatar-grouped__primary{\n  width:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));\n  height:calc(var(--slds-g-sizing-9) + var(--slds-g-sizing-3));\n}\n.slds-avatar-group_large .slds-avatar-grouped__primary .slds-avatar-grouped__initials,.slds-avatar-group--large .slds-avatar-grouped__primary .slds-avatar-grouped__initials{\n  transform:scale(0.8);\n}\n.slds-avatar-group_large .slds-avatar-grouped__secondary,.slds-avatar-group--large .slds-avatar-grouped__secondary{\n  width:var(--slds-g-sizing-7);\n  height:var(--slds-g-sizing-7);\n}\n.slds-avatar-group_large .slds-avatar-grouped__secondary .slds-avatar-grouped__initials,.slds-avatar-group--large .slds-avatar-grouped__secondary .slds-avatar-grouped__initials{\n  transform:scale(0.5);\n}\n.slds-image,\n.slds-file{\n  display:block;\n  position:relative;\n}\n.slds-image .slds-file__text, .slds-file .slds-file__text{\n  display:block;\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-image .slds-file__figure:hover::before,\n.slds-image .slds-file__figure:hover::after,\n.slds-image .slds-file__figure:focus::before,\n.slds-image .slds-file__figure:focus::after,\n.slds-image .slds-file__crop:hover::before,\n.slds-image .slds-file__crop:hover::after,\n.slds-image .slds-file__crop:focus::before,\n.slds-image .slds-file__crop:focus::after,\n.slds-file .slds-file__figure:hover::before,\n.slds-file .slds-file__figure:hover::after,\n.slds-file .slds-file__figure:focus::before,\n.slds-file .slds-file__figure:focus::after,\n.slds-file .slds-file__crop:hover::before,\n.slds-file .slds-file__crop:hover::after,\n.slds-file .slds-file__crop:focus::before,\n.slds-file .slds-file__crop:focus::after{\n  position:absolute;\n  z-index:5;\n  cursor:pointer;\n  content:'';\n}\n.slds-image.slds-file_loading .slds-file__figure:hover::before,.slds-image.slds-file--loading .slds-file__figure:hover::before,\n.slds-image.slds-file_loading .slds-file__figure:hover::after,\n.slds-image.slds-file--loading .slds-file__figure:hover::after,\n.slds-image.slds-file_loading .slds-file__figure:focus::before,\n.slds-image.slds-file--loading .slds-file__figure:focus::before,\n.slds-image.slds-file_loading .slds-file__figure:focus::after,\n.slds-image.slds-file--loading .slds-file__figure:focus::after,\n.slds-image.slds-file_loading .slds-file__crop:hover::before,\n.slds-image.slds-file--loading .slds-file__crop:hover::before,\n.slds-image.slds-file_loading .slds-file__crop:hover::after,\n.slds-image.slds-file--loading .slds-file__crop:hover::after,\n.slds-image.slds-file_loading .slds-file__crop:focus::before,\n.slds-image.slds-file--loading .slds-file__crop:focus::before,\n.slds-image.slds-file_loading .slds-file__crop:focus::after,\n.slds-image.slds-file--loading .slds-file__crop:focus::after,\n.slds-file.slds-file_loading .slds-file__figure:hover::before,\n.slds-file.slds-file--loading .slds-file__figure:hover::before,\n.slds-file.slds-file_loading .slds-file__figure:hover::after,\n.slds-file.slds-file--loading .slds-file__figure:hover::after,\n.slds-file.slds-file_loading .slds-file__figure:focus::before,\n.slds-file.slds-file--loading .slds-file__figure:focus::before,\n.slds-file.slds-file_loading .slds-file__figure:focus::after,\n.slds-file.slds-file--loading .slds-file__figure:focus::after,\n.slds-file.slds-file_loading .slds-file__crop:hover::before,\n.slds-file.slds-file--loading .slds-file__crop:hover::before,\n.slds-file.slds-file_loading .slds-file__crop:hover::after,\n.slds-file.slds-file--loading .slds-file__crop:hover::after,\n.slds-file.slds-file_loading .slds-file__crop:focus::before,\n.slds-file.slds-file--loading .slds-file__crop:focus::before,\n.slds-file.slds-file_loading .slds-file__crop:focus::after,\n.slds-file.slds-file--loading .slds-file__crop:focus::after{\n  display:none;\n}\n.slds-image .slds-file__figure:hover::before,\n.slds-image .slds-file__figure:focus::before,\n.slds-image .slds-file__crop:hover::before,\n.slds-image .slds-file__crop:focus::before,\n.slds-file .slds-file__figure:hover::before,\n.slds-file .slds-file__figure:focus::before,\n.slds-file .slds-file__crop:hover::before,\n.slds-file .slds-file__crop:focus::before{\n  inset-block-start:0;\n  inset-inline-end:0;\n  inset-block-end:0;\n  inset-inline-start:0;\n  background-color:rgba(24, 24, 24, 0.5);\n}\n.slds-image .slds-file__figure:hover::after,\n.slds-image .slds-file__figure:focus::after,\n.slds-image .slds-file__crop:hover::after,\n.slds-image .slds-file__crop:focus::after,\n.slds-file .slds-file__figure:hover::after,\n.slds-file .slds-file__figure:focus::after,\n.slds-file .slds-file__crop:hover::after,\n.slds-file .slds-file__crop:focus::after{\n  inset-block-start:50%;\n  inset-inline-start:50%;\n  width:var(--slds-g-sizing-9);\n  height:var(--slds-g-sizing-9);\n  background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MiIgaGVpZ2h0PSI1MiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTUxLjggMjVBMjkgMjkgMCAwIDAgMjYgOSAyOSAyOSAwIDAgMCAuMiAyNWEyIDIgMCAwIDAgMCAxLjhDNSAzNi40IDE0LjcgNDMgMjYgNDNhMjkgMjkgMCAwIDAgMjUuOC0xNiAyIDIgMCAwIDAgMC0xLjh6TTI2IDM3YTExIDExIDAgMSAxIDAtMjIgMTEgMTEgMCAxIDEgMCAyMnptMC0xOGMtNCAwLTcgMy03IDdzMyA3IDcgNyA3LTMgNy03LTMtNy03LTd6Ii8+PC9zdmc+);\n  background-size:contain;\n  transform:translate(-50%, -50%);\n}\n.slds-image .slds-file__figure:hover + .slds-file__title,\n.slds-image .slds-file__figure:focus + .slds-file__title,\n.slds-image .slds-file__crop:hover + .slds-file__title,\n.slds-image .slds-file__crop:focus + .slds-file__title,\n.slds-file .slds-file__figure:hover + .slds-file__title,\n.slds-file .slds-file__figure:focus + .slds-file__title,\n.slds-file .slds-file__crop:hover + .slds-file__title,\n.slds-file .slds-file__crop:focus + .slds-file__title{\n  z-index:5;\n}\n.slds-image.slds-has-title .slds-file__figure:hover::after,\n.slds-image.slds-has-title .slds-file__figure:focus::after,\n.slds-image.slds-has-title .slds-file__crop:hover::after,\n.slds-image.slds-has-title .slds-file__crop:focus::after,\n.slds-file.slds-has-title .slds-file__figure:hover::after,\n.slds-file.slds-has-title .slds-file__figure:focus::after,\n.slds-file.slds-has-title .slds-file__crop:hover::after,\n.slds-file.slds-has-title .slds-file__crop:focus::after{\n  transform:translate(-50%, calc(-50% - (var(--slds-g-sizing-9) / 2)));\n}\n.slds-image:focus, .slds-file:focus{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-accent-1);\n  box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.16);\n}\n.slds-image :not(:only-child) .slds-spinner, .slds-file :not(:only-child) .slds-spinner{\n  inset-block-start:45%;\n}\n.slds-image .slds-file__figure_portrait img,.slds-image .slds-file__figure--portrait img, .slds-file .slds-file__figure_portrait img, .slds-file .slds-file__figure--portrait img{\n  display:block;\n  margin:0 auto;\n  max-height:var(--slds-g-sizing-14);\n  height:auto;\n}\n@media (any-hover: none){\n  .slds-image .slds-file__figure:hover::before,\n  .slds-image .slds-file__figure:hover::after,\n  .slds-image .slds-file__figure:focus::before,\n  .slds-image .slds-file__figure:focus::after,\n  .slds-image .slds-file__crop:hover::before,\n  .slds-image .slds-file__crop:hover::after,\n  .slds-image .slds-file__crop:focus::before,\n  .slds-image .slds-file__crop:focus::after,\n  .slds-file .slds-file__figure:hover::before,\n  .slds-file .slds-file__figure:hover::after,\n  .slds-file .slds-file__figure:focus::before,\n  .slds-file .slds-file__figure:focus::after,\n  .slds-file .slds-file__crop:hover::before,\n  .slds-file .slds-file__crop:hover::after,\n  .slds-file .slds-file__crop:focus::before,\n  .slds-file .slds-file__crop:focus::after{\n    display:none;\n  }\n}\n.slds-image__crop,\n.slds-file__crop{\n  display:block;\n  position:relative;\n  overflow:hidden;\n  padding-block-start:56.25%;\n  border-radius:var(--slds-g-radius-border-2);\n}\n.slds-image__crop img, .slds-file__crop img{\n  position:absolute;\n  top:50%;\n  left:50%;\n  transform:translate3d(-50%, -50%, 0);\n  max-width:200%;\n}\n.slds-image__crop::after, .slds-file__crop::after{\n  content:'';\n  display:block;\n}\n.slds-image__crop_1-by-1,.slds-image__crop--1-by-1,\n.slds-file__crop_1-by-1,\n.slds-file__crop--1-by-1{\n  padding-block-start:100%;\n}\n.slds-image__crop_16-by-9,.slds-image__crop--16-by-9,\n.slds-file__crop_16-by-9,\n.slds-file__crop--16-by-9{\n  padding-block-start:56.25%;\n}\n.slds-image__crop_4-by-3,.slds-image__crop--4-by-3,\n.slds-file__crop_4-by-3,\n.slds-file__crop--4-by-3{\n  padding-block-start:75%;\n}\n.slds-image__figure,\n.slds-file__figure{\n  display:block;\n  min-width:calc(var(--slds-g-sizing-13) + var(--slds-g-sizing-9));\n  max-width:var(--slds-g-sizing-14);\n  min-height:calc(var(--slds-g-sizing-10) + var(--slds-g-sizing-9));\n  max-height:var(--slds-g-sizing-14);\n}\n.slds-image__title,\n.slds-file__title{\n  display:flex;\n  z-index:5;\n  align-items:center;\n  padding:var(--slds-g-spacing-2);\n  overflow:hidden;\n}\n.slds-image__title .slds-media, .slds-file__title .slds-media{\n  overflow:hidden;\n}\n.slds-image-has-actions,\n.slds-file-has-actions{\n  padding-inline-end:var(--slds-g-spacing-8);\n}\n.slds-image_overlay,.slds-image--overlay,\n.slds-file_overlay,\n.slds-file--overlay{\n  content:'';\n  background:rgba(24, 24, 24, 0.5);\n  color:var(--slds-g-color-on-surface-inverse-1);\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-start:0;\n  inset-inline-end:0;\n  inset-block-end:0;\n  z-index:1;\n}\n.slds-image_card,.slds-image--card,\n.slds-file_card,\n.slds-file--card{\n  background:var(--slds-g-color-surface-container-1);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n}\n.slds-image__icon,\n.slds-file__icon{\n  position:absolute;\n  top:50%;\n  left:50%;\n  transform:translate3d(-50%, -50%, 0);\n  margin-block-start:calc((var(--slds-g-sizing-9) * 0.5) * -1);\n}\n.slds-image__actions-menu,\n.slds-file__actions-menu{\n  position:absolute;\n  z-index:5;\n  inset-block-end:var(--slds-g-spacing-2);\n  inset-inline-end:var(--slds-g-spacing-1);\n}\n.slds-image__external-icon,\n.slds-file__external-icon{\n  position:absolute;\n  inset-block-start:var(--slds-g-spacing-7);\n  inset-inline-start:var(--slds-g-spacing-5);\n}\n.slds-image__loading-icon,\n.slds-file__loading-icon{\n  fill:var(--slds-g-color-on-disabled-1);\n}\n.slds-image_center-icon .slds-file__icon,.slds-image--center-icon .slds-file__icon, .slds-file_center-icon .slds-file__icon, .slds-file--center-icon .slds-file__icon{\n  margin-block-start:0;\n}\n.slds-image__title_overlay,.slds-image__title--overlay,\n.slds-file__title_overlay,\n.slds-file__title--overlay{\n  color:var(--slds-g-color-on-surface-inverse-1);\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-end:0;\n  inset-block-end:0;\n  inset-inline-start:0;\n}\n.slds-image__title_overlay .slds-media__body,.slds-image__title--overlay .slds-media__body, .slds-file__title_overlay .slds-media__body, .slds-file__title--overlay .slds-media__body{\n  z-index:1;\n}\n.slds-image__title_overlay .slds-media__body .slds-file__text,.slds-image__title--overlay .slds-media__body .slds-file__text, .slds-file__title_overlay .slds-media__body .slds-file__text, .slds-file__title--overlay .slds-media__body .slds-file__text{\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-image__title_card,.slds-image__title--card,\n.slds-file__title_card,\n.slds-file__title--card{\n  background:var(--slds-g-color-surface-container-2);\n  position:absolute;\n  inset-inline-end:0;\n  inset-block-end:0;\n  inset-inline-start:0;\n  border-bottom-left-radius:var(--slds-g-radius-border-2);\n  border-bottom-right-radius:var(--slds-g-radius-border-2);\n}\n.slds-image__title_scrim,.slds-image__title--scrim,\n.slds-file__title_scrim,\n.slds-file__title--scrim{\n  background:linear-gradient(to bottom, transparent, rgba(24, 24, 24, 0.5));\n  position:absolute;\n  inset-inline-end:0;\n  inset-block-end:0;\n  inset-inline-start:0;\n  padding:var(--slds-g-spacing-4);\n}\n.slds-badge{\n  display:inline-flex;\n  align-items:center;\n  padding-block:var(--slds-g-spacing-1);\n  padding-inline:var(--slds-g-spacing-2);\n  color:var(--slds-c-badge-text-color, var(--slds-g-color-on-surface-1));\n  font-size:var(--slds-c-badge-font-size, var(--slds-g-font-scale-neg-1));\n  font-weight:var(--slds-g-font-weight-4);\n  line-height:normal;\n  white-space:nowrap;\n  border-width:var(--slds-c-badge-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(--slds-c-badge-color-border, transparent);\n  border-radius:var(--slds-c-badge-radius-border, var(--slds-g-radius-border-1));\n  background-color:var(--slds-c-badge-color-background, var(--slds-g-color-surface-container-3));\n}\n.slds-badge + .slds-badge{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-badge:empty{\n  padding:0;\n}\n.slds-badge_inverse,.slds-badge--inverse{\n  --slds-c-badge-color-background:var(\n    --slds-c-badge-inverse-color-background,\n    var(--slds-g-color-neutral-base-50)\n  );\n  --slds-c-badge-text-color:var(--slds-c-badge-inverse-text-color, var(--slds-g-color-on-surface-inverse-1));\n}\n.slds-badge_lightest,.slds-badge--lightest{\n  /*! @css-var-fallback background-color */\n  --slds-c-badge-color-background:var(\n    --slds-c-badge-lightest-color-background,\n    var(--slds-g-color-surface-container-1)\n  );\n  --slds-c-badge-color-border:var(--slds-c-badge-lightest-color-border, var(--slds-g-color-border-1));\n}\n.slds-badge__icon{\n  display:inline-flex;\n  align-items:center;\n  color:var(--slds-c-badge-icon-color-foreground, var(--slds-g-color-on-surface-1));\n  line-height:1;\n  vertical-align:middle;\n}\n.slds-badge__icon.slds-badge__icon_inverse,.slds-badge__icon.slds-badge__icon--inverse{\n  --slds-c-badge-icon-color-foreground:var(--slds-c-badge-icon-inverse-color-foreground, currentColor);\n}\n.slds-badge__icon_left,.slds-badge__icon--left{\n  margin-inline-end:var(--slds-g-spacing-1);\n}\n.slds-badge__icon_right,.slds-badge__icon--right{\n  margin-inline-start:var(--slds-g-spacing-1);\n}\n.slds-pill{\n  display:inline-flex;\n  align-items:center;\n  justify-content:space-between;\n  line-height:var(--slds-g-font-lineheight-1);\n  max-width:100%;\n  padding-block-start:var(--slds-c-pill-spacing-blockstart);\n  padding-inline-end:var(--slds-c-pill-spacing-inlineend);\n  padding-block-end:var(--slds-c-pill-spacing-blockend);\n  padding-inline-start:var(--slds-c-pill-spacing-inlinestart, var(--slds-g-spacing-2));\n  border-width:var(--slds-c-pill-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(--slds-c-pill-color-border, var(--slds-g-color-border-2));\n  border-radius:var(--slds-c-pill-radius-border, var(--slds-g-radius-border-pill));\n  background-color:var(--slds-c-pill-color-background, var(--slds-g-color-surface-container-1));\n  box-shadow:var(--slds-c-pill-shadow);\n  position:relative;\n  min-height:1.625rem;\n}\n.slds-pill + .slds-pill{\n  margin-inline-start:var(--slds-g-spacing-1);\n}\n.slds-pill:hover{\n  --slds-c-pill-color-background:var(--slds-s-pill-color-background-hover);\n}\n.slds-pill:has(:focus-visible){\n  outline:0;\n  --slds-c-pill-color-border:var(--slds-g-color-border-2);\n  --slds-c-pill-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-pill a{\n  text-decoration:none;\n}\n.slds-pill .slds-popover_tooltip,.slds-pill .slds-popover--tooltip{\n  width:max-content;\n}\n.slds-pill_bare,.slds-pill--bare{\n  --slds-c-pill-color-background:transparent;\n  --slds-c-pill-sizing-border:0;\n}\n.slds-pill_container,.slds-pill--container{\n  display:flex;\n  min-height:calc(1.625rem + 2px);\n  padding-block-start:var(--slds-c-pill-container-spacing-blockstart, var(--slds-g-spacing-1));\n  padding-inline-end:var(--slds-c-pill-container-spacing-inlineend, var(--slds-g-spacing-1));\n  padding-block-end:var(--slds-c-pill-container-spacing-blockend, var(--slds-g-spacing-1));\n  padding-inline-start:var(--slds-c-pill-container-spacing-inlinestart, var(--slds-g-spacing-1));\n  border-width:var(--slds-c-pill-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(--slds-c-pill-color-border, var(--slds-s-input-color-border));\n  border-radius:var(--slds-c-pill-radius-border, var(--slds-g-radius-border-4));\n  background-color:var(--slds-c-pill-container-color-background, var(--slds-g-color-surface-1));\n}\n.slds-pill_container .slds-listbox_inline,.slds-pill--container .slds-listbox--inline{\n  margin-inline-start:0;\n  margin-inline-end:0;\n}\n.slds-pill__label{\n  white-space:nowrap;\n  overflow:hidden;\n  text-overflow:ellipsis;\n}\n.slds-pill__label:focus{\n  outline:0;\n  border-radius:var(--slds-g-radius-border-1);\n  box-shadow:var(--slds-c-pill-label-shadow-focus, var(--slds-s-button-shadow-focus));\n}\n.slds-pill__icon,\n.slds-pill__icon_container,\n.slds-pill__icon--container{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  margin-inline-end:var(--slds-g-spacing-1);\n}\n.slds-pill__icon .slds-icon,\n.slds-pill__icon .slds-avatar,\n.slds-pill__icon_container .slds-icon,\n.slds-pill__icon--container .slds-icon,\n.slds-pill__icon_container .slds-avatar,\n.slds-pill__icon--container .slds-avatar{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  display:block;\n  font-size:var(--slds-g-font-scale-neg-2);\n}\n.slds-pill__icon ~ .slds-pill__action, .slds-pill__icon_container ~ .slds-pill__action, .slds-pill__icon--container ~ .slds-pill__action{\n  padding-inline-start:calc(var(--slds-g-spacing-2) + var(--slds-g-sizing-5) + var(--slds-g-sizing-2));\n}\n.slds-pill__remove{\n  width:var(--slds-g-sizing-5);\n  height:var(--slds-g-sizing-5);\n  display:inline-flex;\n  align-items:center;\n  justify-content:flex-start;\n  box-sizing:content-box;\n  padding:var(--slds-g-spacing-1);\n}\n.slds-pill__remove svg{\n  width:var(--slds-g-sizing-4);\n  height:var(--slds-g-sizing-4);\n}\n.slds-pill__remove .slds-button_icon,.slds-pill__remove .slds-button--icon{\n  color:var(--slds-g-color-accent-2);\n  line-height:var(--slds-g-font-lineheight-1);\n  font-size:var(--slds-g-sizing-3);\n}\n.slds-pill_link,.slds-pill--link{\n  border:0;\n  padding:0;\n  align-items:stretch;\n}\n.slds-pill_link .slds-pill__icon_container,.slds-pill--link .slds-pill__icon--container{\n  display:inline-block;\n  position:absolute;\n  inset-block-start:50%;\n  inset-inline-start:var(--slds-g-spacing-2);\n  transform:translateY(-50%);\n}\n.slds-pill_link .slds-pill__remove,.slds-pill--link .slds-pill__remove{\n  position:absolute;\n  inset-block-start:50%;\n  inset-inline-end:0;\n  transform:translateY(-50%);\n}\n.slds-pill__action{\n  padding-block-start:var(--slds-c-pill-spacing-blockstart, var(--slds-g-spacing-1));\n  padding-inline-end:var(--slds-c-pill-spacing-inlineend, var(--slds-g-spacing-5));\n  padding-block-end:var(--slds-c-pill-spacing-blockend, var(--slds-g-spacing-1));\n  padding-inline-start:var(--slds-c-pill-spacing-inlinestart, var(--slds-g-spacing-2));\n  border-width:var(--slds-c-pill-sizing-border, var(--slds-g-sizing-border-1));\n  border-style:solid;\n  border-color:var(--slds-c-pill-color-border, var(--slds-s-input-color-border));\n  border-radius:var(--slds-c-pill-radius-border, var(--slds-g-radius-border-pill));\n  white-space:nowrap;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  flex-grow:1;\n  display:flex;\n}\n.slds-pill__action:focus-visible{\n  outline:0;\n  text-decoration:none;\n}\n.slds-pill__action .slds-pill__label{\n  align-self:center;\n}\n.slds-has-error{\n  border-color:var(--slds-c-pill-error-color-border, var(--slds-g-color-border-error-1));\n}\n.slds-has-error:active{\n  border-color:var(--slds-c-pill-error-color-border-active, var(--slds-g-color-border-error-1));\n}\n.slds-has-error .slds-pill__label{\n  font-weight:var(--slds-g-font-weight-4);\n  color:var(--slds-c-pill-text-color-error, var(--slds-g-color-error-1));\n}\n.slds-has-error .slds-button_icon,.slds-has-error .slds-button--icon{\n  color:var(--slds-g-color-error-1);\n}\n.slds-has-error:hover{\n  --slds-c-pill-text-color-error:var(--slds-g-color-error-1);\n  --slds-c-pill-color-background:var(--slds-g-color-surface-container-2);\n}\n.slds-has-error:hover .slds-pill__icon_container .slds-icon-text-error,.slds-has-error:hover .slds-pill__icon--container .slds-icon-text-error{\n  --slds-c-icon-color-foreground:var(--slds-g-color-error-1);\n}\n.slds-notification-container{\n  position:fixed;\n  display:block;\n  width:var(--slds-g-sizing-15);\n  inset-inline-end:var(--slds-g-spacing-1);\n  inset-block-start:var(--slds-g-spacing-1);\n  padding-inline:var(--slds-g-spacing-1);\n  padding-block-start:var(--slds-g-spacing-1);\n  padding-block-end:var(--slds-g-spacing-2);\n  z-index:8500;\n}\n.slds-notification{\n  position:relative;\n  width:var(--slds-g-sizing-15);\n  border:var(--slds-s-container-sizing-border, 1px) solid var(--slds-s-container-color-border);\n  border-radius:var(--slds-g-radius-border-2);\n  box-shadow:0 0 3px 0 rgba(0, 0, 0, 0.09), 0 3px 3px 0 rgba(0, 0, 0, 0.09), 0 -1px 1px 0 rgba(0, 0, 0, 0.04);\n  transition-duration:0.4s;\n  transition-timing-function:ease-in-out;\n  transition-property:margin, max-height, opacity, top;\n}\n.slds-notification .slds-media__body{\n  opacity:1;\n  transition-property:opacity;\n  transition-duration:0.4s;\n  transition-timing-function:ease-in-out;\n  padding-inline-end:var(--slds-g-spacing-5);\n}\n.slds-notification + .slds-notification{\n  margin-block-start:var(--slds-g-spacing-3);\n}\n.slds-notification:nth-of-type(1){\n  z-index:calc(5 - 1);\n}\n.slds-notification:nth-of-type(2){\n  z-index:calc(5 - 2);\n}\n.slds-notification:nth-of-type(3){\n  z-index:calc(5 - 3);\n}\n.slds-notification:nth-of-type(4){\n  z-index:calc(5 - 4);\n}\n.slds-notification:nth-of-type(n + 3){\n  overflow:hidden;\n}\n.slds-notification:nth-of-type(n + 4){\n  margin-block-start:0;\n  transform:scaleX(0.95) translateY(-90%);\n}\n.slds-notification:nth-of-type(n + 4) .slds-media__body,\n.slds-notification:nth-of-type(n + 5){\n  opacity:0;\n}\n.slds-notification:nth-of-type(n + 6){\n  display:none;\n}\n.slds-notification__target{\n  padding:var(--slds-g-spacing-3);\n  border-radius:var(--slds-g-radius-border-2);\n  background-color:var(--slds-g-color-surface-container-2);\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-notification__target:hover,\n.slds-notification__target:focus{\n  background-color:var(--slds-g-color-surface-container-1);\n  text-decoration:none;\n  color:var(--slds-g-color-on-surface-2);\n}\n.slds-notification__target:focus-visible{\n  box-shadow:var(--slds-s-button-shadow-focus);\n  outline:0;\n}\n.slds-notification__footer{\n  padding-inline:var(--slds-g-spacing-3);\n  padding-block-start:var(--slds-g-spacing-3);\n  padding-block-end:var(--slds-g-spacing-4);\n}\n.slds-notification__close{\n  position:absolute;\n  inset-block-start:2px;\n  inset-inline-end:2px;\n}\n.slds-notification__close .slds-button_icon,.slds-notification__close .slds-button--icon{\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-table{\n  background-color:var(--slds-g-color-surface-container-1);\n  font-size:inherit;\n  color:var(--slds-s-table-color);\n}\n.slds-table th,\n.slds-table td{\n  padding:var(--slds-g-spacing-2);\n  white-space:nowrap;\n  position:relative;\n}\n.slds-table th{\n  font-weight:var(--slds-g-font-weight-5);\n}\n.slds-table th:focus{\n  outline:0;\n}\n.slds-table thead th{\n  background-color:var(--slds-s-table-header-color-background);\n  color:var(--slds-s-table-header-color);\n  padding:var(--slds-g-spacing-2);\n  font-weight:var(--slds-s-table-header-font-weight);\n  line-height:normal;\n}\n.slds-table:not(.slds-no-row-hover) tbody tr:hover,\n.slds-table:not(.slds-no-row-hover) tbody tr:focus{\n  outline:0;\n}\n.slds-table:not(.slds-no-row-hover) tbody tr:hover > td,\n.slds-table:not(.slds-no-row-hover) tbody tr:hover > th,\n.slds-table:not(.slds-no-row-hover) tbody tr:focus > td,\n.slds-table:not(.slds-no-row-hover) tbody tr:focus > th{\n  background-color:var(\n    --slds-s-table-row-color-background-selected,\n    var(--slds-g-color-surface-container-2)\n  );\n}\n.slds-table tbody tr.slds-is-selected > td,\n.slds-table tbody tr.slds-is-selected > th{\n  background-color:var(--slds-s-table-row-color-background-selected);\n}\n.slds-table tbody tr.slds-is-selected a{\n  color:var(--slds-g-color-accent-2);\n}\n.slds-table .slds-cell-wrap{\n  white-space:pre-line;\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n}\n.slds-table .slds-cell-shrink{\n  width:1%;\n}\n.slds-table .slds-cell-buffer_left,.slds-table .slds-cell-buffer--left{\n  padding-inline-start:var(--slds-g-spacing-5);\n}\n.slds-table .slds-cell-buffer_right,.slds-table .slds-cell-buffer--right{\n  padding-inline-end:var(--slds-g-spacing-5);\n}\n.slds-table tbody tr{\n  counter-increment:row-number;\n}\n.slds-table .slds-row-number::after{\n  content:counter(row-number);\n}\n.slds-table th:focus,\n.slds-table [role='gridcell']:focus{\n  outline:0;\n}\n.slds-table th:focus,\n.slds-table th.slds-has-focus,\n.slds-table [role='gridcell']:focus,\n.slds-table [role='gridcell'].slds-has-focus{\n  box-shadow:var(--slds-s-table-cell-shadow-selected);\n}\n.slds-table th:focus.slds-cell_action-mode,.slds-table th:focus.slds-cell--action-mode, .slds-table th.slds-has-focus.slds-cell_action-mode, .slds-table th.slds-has-focus.slds-cell--action-mode, .slds-table [role='gridcell']:focus.slds-cell_action-mode, .slds-table [role='gridcell']:focus.slds-cell--action-mode, .slds-table [role='gridcell'].slds-has-focus.slds-cell_action-mode, .slds-table [role='gridcell'].slds-has-focus.slds-cell--action-mode{\n  border-block-end:3px solid var(--slds-g-color-border-accent-1);\n}\n.slds-table th:active,\n.slds-table [role='gridcell']:active{\n  box-shadow:none;\n}\n.slds-table .slds-radio [type='radio'] + .slds-radio__label .slds-radio_faux,.slds-table .slds-radio [type='radio'] + .slds-radio__label .slds-radio--faux{\n  margin-inline-end:0;\n}\n.slds-table_cell-buffer tr > th:first-child,.slds-table--cell-buffer tr > th:first-child,\n.slds-table_cell-buffer tr > td:first-child,\n.slds-table--cell-buffer tr > td:first-child{\n  padding-inline-start:var(--slds-g-spacing-5);\n}\n.slds-table_cell-buffer tr > th:last-child,.slds-table--cell-buffer tr > th:last-child,\n.slds-table_cell-buffer tr > td:last-child,\n.slds-table--cell-buffer tr > td:last-child{\n  padding-inline-end:var(--slds-g-spacing-5);\n}\n.slds-table_bordered,.slds-table--bordered{\n  border-collapse:collapse;\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-table_bordered thead > tr + tr > th,.slds-table--bordered thead > tr + tr > th{\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-table_bordered tbody td,.slds-table--bordered tbody td,\n.slds-table_bordered tbody th,\n.slds-table--bordered tbody th{\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-table_bordered:not(.slds-no-row-hover) tbody tr:hover > td:not(.slds-has-focus),.slds-table--bordered:not(.slds-no-row-hover) tbody tr:hover > td:not(.slds-has-focus),\n.slds-table_bordered:not(.slds-no-row-hover) tbody tr:hover > th:not(.slds-has-focus),\n.slds-table--bordered:not(.slds-no-row-hover) tbody tr:hover > th:not(.slds-has-focus),\n.slds-table_bordered:not(.slds-no-row-hover) tbody tr:focus > td:not(.slds-has-focus),\n.slds-table--bordered:not(.slds-no-row-hover) tbody tr:focus > td:not(.slds-has-focus),\n.slds-table_bordered:not(.slds-no-row-hover) tbody tr:focus > th:not(.slds-has-focus),\n.slds-table--bordered:not(.slds-no-row-hover) tbody tr:focus > th:not(.slds-has-focus){\n  box-shadow:var(--slds-g-color-border-1) 0 calc(var(--slds-g-sizing-border-1) * -1) 0 inset, var(--slds-g-color-border-1) 0 var(--slds-g-sizing-border-1) 0 inset;\n}\n.slds-table_bordered:not(.slds-no-row-hover) tr.slds-is-selected:hover > td:not(.slds-has-focus),.slds-table--bordered:not(.slds-no-row-hover) tr.slds-is-selected:hover > td:not(.slds-has-focus),\n.slds-table_bordered:not(.slds-no-row-hover) tr.slds-is-selected:hover > th:not(.slds-has-focus),\n.slds-table--bordered:not(.slds-no-row-hover) tr.slds-is-selected:hover > th:not(.slds-has-focus){\n  background-color:var(--slds-s-table-row-color-background-selected);\n  box-shadow:var(--slds-s-table-row-color-border-selected-hover) 0 calc(var(--slds-g-sizing-border-1) * -1) 0 inset, var(--slds-s-table-row-color-border-selected-hover) 0 var(--slds-g-sizing-border-1) 0 inset;\n}\n.slds-table_col-bordered td + td,.slds-table--col-bordered td + td,\n.slds-table_col-bordered th + th,\n.slds-table--col-bordered th + th,\n.slds-table_col-bordered th + td,\n.slds-table--col-bordered th + td,\n.slds-table_col-bordered td + th,\n.slds-table--col-bordered td + th{\n  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-table_striped tbody tr:nth-of-type(even) > td,.slds-table--striped tbody tr:nth-of-type(even) > td,\n.slds-table_striped tbody tr:nth-of-type(even) > th,\n.slds-table--striped tbody tr:nth-of-type(even) > th{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-table_fixed-layout,.slds-table--fixed-layout{\n  table-layout:fixed;\n  width:100%;\n  white-space:nowrap;\n}\n.slds-table_fixed-layout thead,.slds-table--fixed-layout thead{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-table_fixed-layout tbody,.slds-table--fixed-layout tbody{\n  transform:translateZ(0);\n}\n.slds-table_fixed-layout .slds-cell-shrink,.slds-table--fixed-layout .slds-cell-shrink{\n  width:var(--slds-g-sizing-3);\n}\n.slds-table_fixed-layout .slds-cell-shrink:nth-child(n),.slds-table--fixed-layout .slds-cell-shrink:nth-child(n){\n  padding-inline-start:0;\n  padding-inline-end:0;\n}\n.slds-table_fixed-layout .slds-cell-shrink:first-child,.slds-table--fixed-layout .slds-cell-shrink:first-child{\n  text-align:right;\n  padding-inline-end:var(--slds-g-spacing-2);\n}\n.slds-table_fixed-layout .slds-cell-shrink:last-child,.slds-table--fixed-layout .slds-cell-shrink:last-child{\n  text-align:left;\n  padding-inline-start:var(--slds-g-spacing-2);\n}\n.slds-is-sortable .slds-th__action:hover,\n.slds-is-sortable .slds-th__action:focus,\n.slds-is-sortable.slds-has-focus .slds-th__action,\n.slds-is-sortable.slds-has-focus .slds-th__action:hover,\n.slds-is-sortable.slds-has-focus .slds-th__action:focus{\n  background-color:var(--slds-s-table-header-color-background-hover);\n  color:currentColor;\n}\n.slds-is-sortable .slds-th__action:hover .slds-is-sortable__icon, .slds-is-sortable .slds-th__action:focus .slds-is-sortable__icon, .slds-is-sortable.slds-has-focus .slds-th__action .slds-is-sortable__icon, .slds-is-sortable.slds-has-focus .slds-th__action:hover .slds-is-sortable__icon, .slds-is-sortable.slds-has-focus .slds-th__action:focus .slds-is-sortable__icon{\n  display:inline-block;\n  fill:var(--slds-g-color-accent-2);\n}\n.slds-th__action{\n  display:flex;\n  padding:var(--slds-g-spacing-2);\n  height:2rem;\n  align-items:center;\n  color:currentColor;\n}\n.slds-th__action:focus,\n.slds-th__action:hover{\n  outline:0;\n  background-color:var(--slds-s-table-header-color-background-hover);\n}\n.slds-th__action_form,.slds-th__action--form{\n  display:inline-flex;\n}\n.slds-th__action-button{\n  position:absolute;\n  transform:translateY(-50%);\n  top:50%;\n  inset-inline-end:var(--slds-g-spacing-1);\n}\n.slds-th__action-button > .slds-button{\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-th__action-button > .slds-button:hover{\n  background:transparent;\n}\n.slds-has-button-menu .slds-th__action{\n  padding-inline-end:var(--slds-g-spacing-6);\n}\n.slds-has-button-menu .slds-th__action-button{\n  inset-inline-end:var(--slds-g-spacing-3);\n}\n.slds-is-sortable__icon{\n  width:0.75rem;\n  height:0.75rem;\n  margin-inline-start:var(--slds-g-spacing-1);\n  display:none;\n}\n.slds-is-sorted .slds-is-sortable__icon{\n  display:inline-block;\n}\n.slds-is-sorted_asc .slds-is-sortable__icon,.slds-is-sorted--asc .slds-is-sortable__icon{\n  transform:rotate(180deg);\n}\n.slds-table_column-1-wrap tbody tr > *:nth-child(1) .slds-truncate,.slds-table--column-1-wrap tbody tr > *:nth-child(1) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-2-wrap tbody tr > *:nth-child(2) .slds-truncate,.slds-table--column-2-wrap tbody tr > *:nth-child(2) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-3-wrap tbody tr > *:nth-child(3) .slds-truncate,.slds-table--column-3-wrap tbody tr > *:nth-child(3) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-4-wrap tbody tr > *:nth-child(4) .slds-truncate,.slds-table--column-4-wrap tbody tr > *:nth-child(4) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-5-wrap tbody tr > *:nth-child(5) .slds-truncate,.slds-table--column-5-wrap tbody tr > *:nth-child(5) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-6-wrap tbody tr > *:nth-child(6) .slds-truncate,.slds-table--column-6-wrap tbody tr > *:nth-child(6) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-7-wrap tbody tr > *:nth-child(7) .slds-truncate,.slds-table--column-7-wrap tbody tr > *:nth-child(7) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-8-wrap tbody tr > *:nth-child(8) .slds-truncate,.slds-table--column-8-wrap tbody tr > *:nth-child(8) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-9-wrap tbody tr > *:nth-child(9) .slds-truncate,.slds-table--column-9-wrap tbody tr > *:nth-child(9) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-10-wrap tbody tr > *:nth-child(10) .slds-truncate,.slds-table--column-10-wrap tbody tr > *:nth-child(10) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-11-wrap tbody tr > *:nth-child(11) .slds-truncate,.slds-table--column-11-wrap tbody tr > *:nth-child(11) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-12-wrap tbody tr > *:nth-child(12) .slds-truncate,.slds-table--column-12-wrap tbody tr > *:nth-child(12) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-13-wrap tbody tr > *:nth-child(13) .slds-truncate,.slds-table--column-13-wrap tbody tr > *:nth-child(13) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-14-wrap tbody tr > *:nth-child(14) .slds-truncate,.slds-table--column-14-wrap tbody tr > *:nth-child(14) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n.slds-table_column-15-wrap tbody tr > *:nth-child(15) .slds-truncate,.slds-table--column-15-wrap tbody tr > *:nth-child(15) .slds-truncate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:none;\n  white-space:normal;\n}\n[class*='slds-table_column-'] tr td .slds-truncate,[class*='slds-table--column-'] tr td .slds-truncate{\n  overflow:hidden;\n  position:relative;\n  max-height:3.25rem;\n}\n[class*='slds-table_column-'] tr td .slds-truncate::after,[class*='slds-table--column-'] tr td .slds-truncate::after{\n  content:'';\n  position:absolute;\n  top:2.25rem;\n  bottom:0;\n  right:0;\n  width:50%;\n  background:linear-gradient(\n    to right,\n    transparent 0%,\n    var(--slds-g-color-neutral-base-100, rgba(255, 255, 255, 1)) 69%\n  );\n}\n[class*='slds-table_column-'] tr:hover td .slds-truncate::after,[class*='slds-table--column-'] tr:hover td .slds-truncate::after{\n  background:linear-gradient(to right, rgba(250, 250, 249, 0) 0%, rgba(250, 250, 249, 1) 69%);\n}\n.slds-table_resizable-cols thead th,.slds-table--resizable-cols thead th{\n  padding:0;\n}\n.slds-table_resizable-cols thead th:last-of-type .slds-resizable__handle,.slds-table--resizable-cols thead th:last-of-type .slds-resizable__handle{\n  width:var(--slds-g-sizing-2);\n  inset-inline-end:0;\n}\n.slds-table_resizable-cols thead th:last-of-type .slds-resizable__handle .slds-resizable__divider::before,.slds-table--resizable-cols thead th:last-of-type .slds-resizable__handle .slds-resizable__divider::before,\n.slds-table_resizable-cols thead th:last-of-type .slds-resizable__handle .slds-resizable__divider::after,\n.slds-table--resizable-cols thead th:last-of-type .slds-resizable__handle .slds-resizable__divider::after{\n  inset-inline-end:0;\n}\n.slds-resizable{\n  max-width:100%;\n}\n.slds-resizable__handle{\n  width:var(--slds-g-sizing-7);\n  height:100%;\n  position:absolute;\n  top:0;\n  inset-inline-end:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-resizable__divider{\n  position:absolute;\n  right:0;\n  top:0;\n  width:100%;\n  height:100%;\n  display:block;\n  cursor:col-resize;\n  z-index:5000;\n}\n.slds-resizable__divider::before,\n.slds-resizable__divider::after{\n  height:100%;\n  content:' ';\n  display:block;\n  position:absolute;\n  top:0;\n  inset-inline-end:var(--slds-g-spacing-3);\n}\n.slds-resizable__divider::before{\n  background-color:var(--slds-s-table-resize-color);\n  height:100%;\n  width:1px;\n}\n.slds-resizable__divider::after{\n  background-color:var(--slds-s-table-resize-color-active);\n  width:1px;\n  height:100vh;\n  opacity:0;\n}\n.slds-resizable__divider:hover::before, .slds-resizable__divider:focus::before, .slds-resizable__divider:active::before{\n  background-color:var(--slds-s-table-resize-color-active);\n  width:var(--slds-g-sizing-2);\n}\n.slds-resizable__divider:hover::after, .slds-resizable__divider:focus::after, .slds-resizable__divider:active::after{\n  opacity:1;\n}\n.slds-resizable__input:focus ~ .slds-resizable__handle .slds-resizable__divider::before{\n  background-color:var(--slds-s-table-resize-color-active);\n  width:var(--slds-g-sizing-2);\n}\n.slds-resizable__input:focus ~ .slds-resizable__handle .slds-resizable__divider::after{\n  opacity:1;\n}\n.slds-table_header-hidden,.slds-table--header-hidden{\n  border-block-start:0;\n}\n.slds-table_header-fixed_container,.slds-table--header-fixed_container{\n  position:relative;\n  padding-block-start:2rem;\n  background-color:var(--slds-s-table-header-color-background);\n  overflow:hidden;\n}\n.slds-table_header-fixed_container::before,.slds-table--header-fixed_container::before{\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n  content:'';\n  display:block;\n  position:relative;\n  width:100%;\n}\n.slds-cell-fixed{\n  background-color:var(--slds-s-table-header-color-background);\n  position:absolute;\n  inset-block-start:0;\n  height:2rem;\n}\n.slds-table_header-fixed,.slds-table--header-fixed{\n  border-block-start:0;\n}\n.slds-table_header-fixed thead th,.slds-table--header-fixed thead th{\n  position:static;\n  padding:0;\n  border-block-start:0;\n}\n.slds-table_header-fixed tbody tr:first-child td,.slds-table--header-fixed tbody tr:first-child td,\n.slds-table_header-fixed tbody tr:first-child th,\n.slds-table--header-fixed tbody tr:first-child th{\n  border-block-start:0;\n}\n.slds-table_edit_container:focus,.slds-table--edit_container:focus{\n  outline:none;\n}\n.slds-table_edit_container:focus::before,.slds-table--edit_container:focus::before{\n  content:' ';\n  position:absolute;\n  top:0;\n  right:0;\n  bottom:0;\n  left:0;\n  z-index:1;\n  background-color:var(--slds-g-color-surface-container-2);\n  box-shadow:0 0 0 4px var(--slds-g-color-accent-2) inset;\n}\n.slds-table_edit_container:focus .slds-table_edit_container-message,.slds-table--edit_container:focus .slds-table--edit--container-message{\n  display:block;\n  position:absolute;\n  top:50%;\n  left:50%;\n  width:var(--slds-g-sizing-15);\n  margin-top:-2.25rem;\n  margin-inline-start:calc((var(--slds-g-sizing-15) * 0.5) * -1);\n  background-color:var(--slds-g-color-surface-container-1);\n  text-align:center;\n  z-index:1;\n}\n.slds-table_edit_container-message,.slds-table--edit_container-message{\n  display:none;\n}\n.slds-table_edit thead th,.slds-table--edit thead th{\n  padding:0;\n}\n.slds-table_edit .slds-cell-error,.slds-table--edit .slds-cell-error{\n  padding-inline-start:0;\n}\n.slds-table_edit:not(.slds-no-cell-focus) tbody tr:hover > .slds-cell-edit.slds-has-focus,.slds-table--edit:not(.slds-no-cell-focus) tbody tr:hover > .slds-cell-edit.slds-has-focus{\n  background-color:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;\n}\n.slds-table_edit.slds-table tbody tr:hover > .slds-cell-edit:hover,.slds-table--edit.slds-table tbody tr:hover > .slds-cell-edit:hover{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-table_edit.slds-table tbody tr:hover > .slds-cell-edit.slds-is-edited,.slds-table--edit.slds-table tbody tr:hover > .slds-cell-edit.slds-is-edited{\n  background-color:var(--slds-g-color-palette-yellow-90);\n}\n.slds-table_edit.slds-table tbody tr:hover > .slds-cell-edit.slds-has-error,.slds-table--edit.slds-table tbody tr:hover > .slds-cell-edit.slds-has-error{\n  background-color:var(--slds-g-color-palette-yellow-90);\n  box-shadow:var(--slds-g-color-error-1) 0 0 0 var(--slds-g-sizing-border-2) inset;\n}\n.slds-table_edit .slds-button__icon_edit:focus,.slds-table--edit .slds-button__icon--edit:focus{\n  fill:var(--slds-g-color-accent-2);\n}\n.slds-has-focus .slds-th__action{\n  background-color:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-s-table-cell-shadow-selected);\n}\n.slds-has-focus.slds-is-resizable .slds-th__action,\n.slds-has-focus.slds-is-resizable .slds-th__action:focus,\n.slds-has-focus.slds-is-resizable .slds-th__action:hover,\n.slds-has-focus.slds-is-resizable .slds-th__action:focus:hover,\n.slds-is-resizable .slds-th__action:focus,\n.slds-is-resizable .slds-th__action:focus:hover{\n  background-color:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-s-table-cell-shadow-selected), var(--slds-g-color-accent-2) -0.25rem 0 0 inset;\n}\n.slds-table .slds-cell-edit{\n  outline:0;\n}\n.slds-table .slds-cell-edit.slds-has-focus{\n  background-color:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;\n}\n.slds-table .slds-cell-edit.slds-has-focus .slds-button__icon_edit,.slds-table .slds-cell-edit.slds-has-focus .slds-button__icon--edit,\n.slds-table .slds-cell-edit.slds-has-focus .slds-button__icon_lock,\n.slds-table .slds-cell-edit.slds-has-focus .slds-button__icon--lock{\n  opacity:1;\n}\n.slds-table .slds-cell-edit.slds-has-focus:hover{\n  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;\n}\n.slds-table .slds-cell-edit.slds-has-focus a:focus{\n  text-decoration:underline;\n  outline:none;\n}\n.slds-table .slds-cell-edit.slds-is-edited,\n.slds-table .slds-cell-edit.slds-is-edited:hover{\n  font-weight:600;\n  background-color:var(--slds-g-color-palette-yellow-90);\n}\n.slds-table .slds-cell-edit.slds-has-error,\n.slds-table .slds-cell-edit.slds-has-error:hover{\n  font-weight:600;\n  background-color:var(--slds-g-color-palette-yellow-90);\n  box-shadow:var(--slds-g-color-error-1) 0 0 0 var(--slds-g-sizing-border-2) inset;\n}\n.slds-table .slds-cell-edit.slds-has-error a{\n  color:currentColor;\n}\n.slds-cell-edit__button{\n  width:1.25rem;\n  height:1.25rem;\n  flex-shrink:0;\n}\n.slds-cell-edit__button:focus .slds-button__icon_edit,.slds-cell-edit__button:focus .slds-button__icon--edit{\n  opacity:1;\n}\n.slds-cell-edit__button[disabled],\n.slds-cell-edit__button:disabled{\n  color:var(--slds-g-color-disabled-1);\n}\n.slds-no-cell-focus .slds-has-focus{\n  background:var(--slds-g-color-surface-container-2);\n  box-shadow:none;\n}\n.slds-no-cell-focus .slds-has-focus .slds-th__action,\n.slds-no-cell-focus .slds-has-focus .slds-th__action:hover,\n.slds-no-cell-focus .slds-has-focus .slds-th__action:focus,\n.slds-no-cell-focus .slds-has-focus .slds-th__action:focus:hover{\n  color:inherit;\n  background-color:var(--slds-g-color-surface-container-1);\n  box-shadow:none;\n}\n.slds-no-cell-focus .slds-has-focus .slds-button__icon_edit,.slds-no-cell-focus .slds-has-focus .slds-button__icon--edit{\n  opacity:1;\n}\n.slds-no-cell-focus .slds-has-focus.slds-is-resizable:hover .slds-th__action{\n  background-color:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-g-color-border-1) -0.25rem 0 0 inset;\n}\n.slds-no-cell-focus .slds-is-sortable.slds-has-focus .slds-is-sortable__icon{\n  display:none;\n}\n.slds-no-cell-focus .slds-is-sorted.slds-has-focus .slds-is-sortable__icon{\n  display:inline-block;\n  fill:var(--slds-g-color-on-surface-1);\n}\n.slds-no-cell-focus .slds-is-edited,\n.slds-no-cell-focus .slds-is-edited:hover{\n  background-color:var(--slds-g-color-palette-yellow-90);\n  color:var(--slds-g-color-on-warning-1);\n}\n.slds-no-cell-focus .slds-has-error,\n.slds-no-cell-focus .slds-has-error:hover{\n  background-color:var(--slds-g-color-palette-yellow-90);\n  box-shadow:var(--slds-g-color-error-1) 0 0 0 var(--slds-g-sizing-border-2) inset;\n}\n.slds-no-cell-focus thead .slds-has-focus:hover{\n  color:var(--slds-s-link-color);\n}\n.slds-no-cell-focus thead .slds-has-focus:hover .slds-is-sortable__icon{\n  display:inline-block;\n  fill:var(--slds-s-link-color);\n}\n.slds-hint-parent .slds-cell-edit .slds-button__icon_edit,.slds-hint-parent .slds-cell-edit .slds-button__icon--edit,\n.slds-hint-parent .slds-cell-edit .slds-button__icon_lock,\n.slds-hint-parent .slds-cell-edit .slds-button__icon--lock{\n  opacity:0;\n}\n.slds-hint-parent .slds-cell-edit:hover .slds-button__icon_edit,.slds-hint-parent .slds-cell-edit:hover .slds-button__icon--edit, .slds-hint-parent .slds-cell-edit:focus .slds-button__icon_edit, .slds-hint-parent .slds-cell-edit:focus .slds-button__icon--edit{\n  opacity:1;\n  fill:var(--slds-g-color-accent-2);\n}\n.slds-hint-parent .slds-cell-edit:hover .slds-button__icon_edit:hover,.slds-hint-parent .slds-cell-edit:hover .slds-button__icon--edit:hover,\n.slds-hint-parent .slds-cell-edit:hover .slds-button__icon_edit:focus,\n.slds-hint-parent .slds-cell-edit:hover .slds-button__icon--edit:focus,\n.slds-hint-parent .slds-cell-edit:focus .slds-button__icon_edit:hover,\n.slds-hint-parent .slds-cell-edit:focus .slds-button__icon--edit:hover,\n.slds-hint-parent .slds-cell-edit:focus .slds-button__icon_edit:focus,\n.slds-hint-parent .slds-cell-edit:focus .slds-button__icon--edit:focus{\n  fill:var(--slds-g-color-accent-2);\n  opacity:1;\n}\n.slds-hint-parent .slds-cell-edit:hover .slds-button__icon_lock,.slds-hint-parent .slds-cell-edit:hover .slds-button__icon--lock, .slds-hint-parent .slds-cell-edit:focus .slds-button__icon_lock, .slds-hint-parent .slds-cell-edit:focus .slds-button__icon--lock{\n  opacity:1;\n}\n.slds-hint-parent .slds-cell-edit:hover .slds-button_icon:hover .slds-button__icon_edit,.slds-hint-parent .slds-cell-edit:hover .slds-button--icon:hover .slds-button__icon--edit, .slds-hint-parent .slds-cell-edit:hover .slds-button_icon:focus .slds-button__icon_edit, .slds-hint-parent .slds-cell-edit:hover .slds-button--icon:focus .slds-button__icon--edit, .slds-hint-parent .slds-cell-edit:focus .slds-button_icon:hover .slds-button__icon_edit, .slds-hint-parent .slds-cell-edit:focus .slds-button--icon:hover .slds-button__icon--edit, .slds-hint-parent .slds-cell-edit:focus .slds-button_icon:focus .slds-button__icon_edit, .slds-hint-parent .slds-cell-edit:focus .slds-button--icon:focus .slds-button__icon--edit{\n  fill:var(--slds-g-color-on-surface-3);\n}\n.slds-hint-parent .slds-cell-edit.slds-has-focus .slds-button__icon_edit,.slds-hint-parent .slds-cell-edit.slds-has-focus .slds-button__icon--edit{\n  fill:var(--slds-g-color-on-surface-3);\n  opacity:1;\n}\n.slds-form-element__label_edit,.slds-form-element__label--edit{\n  margin-block:0;\n  margin-inline:0.125rem;\n}\n.slds-popover_edit,.slds-popover--edit{\n  border-block-start:0;\n  border-start-start-radius:0;\n  border-start-end-radius:0;\n}\n.slds-popover_edit .slds-popover__body,.slds-popover--edit .slds-popover__body{\n  padding:var(--slds-g-spacing-1);\n  padding-inline-start:0;\n}\n.slds-popover_edit .slds-form-element__help,.slds-popover--edit .slds-form-element__help{\n  width:100%;\n  padding-inline-start:var(--slds-g-spacing-2);\n}\n.slds-table_joined table,.slds-table--joined table,\n.slds-table.slds-has-top-magnet table{\n  border-radius:0 0 var(--slds-g-radius-border-2) var(--slds-g-radius-border-2);\n  box-shadow:var(--slds-s-container-shadow, var(--slds-g-shadow-1));\n}\n.slds-table_joined-wrapper,.slds-table--joined-wrapper{\n  padding:var(--slds-g-spacing-4) var(--slds-g-spacing-4) 0 var(--slds-g-spacing-4);\n  border-radius:var(--slds-g-radius-border-2);\n  background-clip:padding-box;\n}\n.slds-table_joined-wrapper .slds-table,.slds-table--joined-wrapper .slds-table{\n  border-radius:0 0 var(--slds-g-radius-border-2) var(--slds-g-radius-border-2);\n  box-shadow:var(--slds-s-container-shadow, var(--slds-g-shadow-1));\n}\n.slds-section{\n  margin-block:var(--slds-g-spacing-2);\n}\n.slds-section.slds-is-open .slds-section__title-action-icon{\n  transform:rotate(0deg);\n  transform-origin:45%;\n}\n.slds-section.slds-is-open .slds-section__content{\n  padding-top:var(--slds-g-spacing-2);\n  overflow:visible;\n  visibility:visible;\n  opacity:1;\n  height:auto;\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-section__title{\n  display:flex;\n  align-items:center;\n  font-size:var(--slds-s-container-heading-font-size, var(--slds-g-font-scale-2));\n  line-height:1.875rem;\n  border:var(--slds-g-sizing-border-1) solid transparent;\n  border-radius:var(--slds-g-radius-border-2);\n}\n.slds-section__title .slds-button{\n  --slds-c-button-radius-border:var(--slds-g-radius-border-2);\n}\n.slds-section__title-action{\n  display:flex;\n  align-items:center;\n  background-color:var(--slds-g-color-surface-container-2);\n  cursor:pointer;\n  width:100%;\n  text-align:left;\n  color:var(--slds-g-color-on-surface-3);\n  font-size:inherit;\n  font-weight:var(--slds-s-container-heading-font-weight);\n  padding:0 var(--slds-g-spacing-2);\n}\n.slds-section__title-action:hover,\n.slds-section__title-action:focus,\n.slds-section__title-action:active{\n  background-color:var(--slds-g-color-surface-container-2);\n  color:inherit;\n}\n.slds-section__content{\n  overflow:hidden;\n  visibility:hidden;\n  opacity:0;\n  height:0;\n}\n.slds-section__title-action-icon{\n  transform:rotate(-90deg);\n}\n.slds-section-title_divider,.slds-section-title--divider{\n  font-size:var(--slds-g-font-scale-neg-1);\n  line-height:var(--slds-g-font-lineheight-2);\n  color:var(--slds-g-color-neutral-base-30);\n  text-transform:uppercase;\n  letter-spacing:0.0625rem;\n  padding:var(--slds-g-spacing-2) var(--slds-g-spacing-4);\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-illustration{\n  text-align:center;\n}\n.slds-illustration.slds-illustration_small .slds-illustration__svg,.slds-illustration.slds-illustration--small .slds-illustration__svg{\n  width:100%;\n  max-width:300px;\n  max-height:200px;\n  margin-block-end:var(--slds-g-spacing-4);\n}\n.slds-illustration.slds-illustration_large .slds-illustration__svg,.slds-illustration.slds-illustration--large .slds-illustration__svg{\n  width:100%;\n  max-width:600px;\n  max-height:400px;\n  margin-block-end:var(--slds-g-spacing-8);\n}\n.slds-illustration.slds-illustration_large .slds-illustration__header,.slds-illustration.slds-illustration--large .slds-illustration__header{\n  margin-block-end:var(--slds-g-spacing-5);\n}\n.slds-illustration.slds-illustration_large p,.slds-illustration.slds-illustration--large p{\n  margin-block-end:var(--slds-g-spacing-8);\n}\n.slds-illustration .slds-illustration__stroke-primary{\n  stroke:var(--slds-g-color-palette-cloud-blue-80);\n}\n.slds-illustration .slds-illustration__stroke-secondary{\n  stroke:var(--slds-g-color-palette-cloud-blue-90);\n}\n.slds-illustration .slds-illustration__fill-primary{\n  fill:var(--slds-g-color-palette-cloud-blue-80);\n}\n.slds-illustration .slds-illustration__fill-secondary{\n  fill:var(--slds-g-color-palette-cloud-blue-90);\n}\n.slds-region{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-region__pinned-top{\n  background-color:var(--slds-g-color-surface-container-1);\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-region__pinned-left{\n  background-color:var(--slds-g-color-surface-container-1);\n  border-inline-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-region__pinned-right{\n  background-color:var(--slds-g-color-surface-container-1);\n  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-map_container,.slds-map--container{\n  flex:3 1 auto;\n}\n.slds-map{\n  position:relative;\n  min-width:23.75rem;\n  width:100%;\n  max-height:100%;\n}\n.slds-map::before{\n  content:'';\n  display:block;\n  height:0;\n  width:100%;\n  padding-block-start:56.25%;\n}\n.slds-map iframe{\n  position:absolute;\n  inset-block-start:0;\n  inset-inline-start:0;\n  inset-inline-end:0;\n  height:100%;\n  width:100%;\n  border:0;\n}\n.slds-has-coordinates{\n  display:flex;\n  flex-wrap:wrap;\n  overflow:auto;\n  max-height:41.25rem;\n  background:var(--slds-g-color-surface-container-1);\n}\n.slds-has-coordinates .slds-map::before{\n  padding-block-start:75%;\n}\n.slds-coordinates{\n  overflow:auto;\n  flex:1 1 auto;\n}\n.slds-coordinates__header{\n  padding:var(--slds-g-spacing-4);\n}\n.slds-coordinates__title{\n  font-size:var(--slds-g-font-scale-2);\n  font-weight:var(--slds-g-font-weight-6);\n}\n.slds-coordinates__item-action{\n  padding-inline:var(--slds-g-spacing-4);\n  padding-block:var(--slds-g-spacing-2);\n  width:100%;\n}\n.slds-coordinates__item-action.slds-media{\n  align-items:center;\n}\n.slds-coordinates__item-action .slds-text-link{\n  display:block;\n}\n.slds-coordinates__item-action:hover,\n.slds-coordinates__item-action:focus{\n  background-color:var(--slds-s-menu-item-color-background-active);\n  outline:0;\n}\n.slds-coordinates__item-action:hover .slds-text-link, .slds-coordinates__item-action:focus .slds-text-link{\n  text-decoration:underline;\n}\n.slds-coordinates__item-action:focus-visible{\n  box-shadow:0 0 0 2px var(--slds-g-color-brand-base-15) inset, 0 0 0 4px var(--slds-g-color-surface-1) inset;\n}\n.slds-coordinates__item-action:active{\n  background-color:var(--slds-s-menu-item-color-background-active);\n}\n.slds-coordinates__item-action[aria-pressed='true']{\n  background-color:var(--slds-s-menu-item-color-background-active);\n}\n.slds-welcome-mat{\n  --_slds-c-welcomemat-image-background:var(\n    --lwc-welcomeMatBackgroundImageInfo\n  );\n  position:relative;\n}\n.slds-welcome-mat__content{\n  min-height:25rem;\n  max-height:37.5rem;\n}\n.slds-welcome-mat__content .slds-progress-bar{\n  display:inline-block;\n  width:12.5rem;\n  background:var(--slds-g-color-surface-1);\n}\n.slds-welcome-mat__content .slds-progress-bar__value{\n  background:var(--slds-g-color-success-1);\n}\n.slds-welcome-mat__info{\n  display:flex;\n  overflow:auto;\n  padding-block:var(--slds-g-spacing-4) 7.75rem;\n  padding-inline:var(--slds-g-spacing-8);\n  color:var(--slds-g-color-brand-base-20);\n  background-image:var(--_slds-c-welcomemat-image-background);\n  background-position:bottom center;\n  background-repeat:no-repeat;\n  background-size:contain;\n  background-color:var(--sds-g-color-palette-cloud-blue-90);\n  align-items:center;\n}\n.slds-welcome-mat__info-content{\n  margin:auto;\n  text-align:center;\n}\n.slds-welcome-mat__info-title{\n  margin-block-end:var(--slds-g-spacing-5);\n  font-size:var(--slds-g-font-scale-7);\n  font-weight:var(--slds-g-font-weight-7);\n  line-height:var(--slds-g-font-lineheight-2);\n}\n.slds-welcome-mat__info-description{\n  margin-block-end:var(--slds-g-spacing-5);\n}\n.slds-welcome-mat__info-progress{\n  margin-block-end:var(--slds-g-spacing-4);\n}\n.slds-welcome-mat__tiles{\n  background:var(--slds-g-color-surface-container-2);\n  overflow:auto;\n  padding:var(--slds-g-spacing-4);\n}\n.slds-welcome-mat__tile{\n  margin-block:var(--slds-g-spacing-4);\n  margin-inline:0;\n  box-shadow:var(--slds-g-shadow-2);\n  border-radius:var(--slds-g-radius-border-2);\n  background:var(--slds-g-color-neutral-base-100);\n}\n.slds-welcome-mat__tile:hover{\n  box-shadow:0 0 0 1px var(--slds-g-color-border-accent-1) inset, var(--slds-g-shadow-2);\n}\n.slds-welcome-mat__tile .slds-media{\n  padding:var(--slds-g-spacing-3);\n}\n.slds-welcome-mat__tile .slds-icon-action-check{\n  display:none;\n}\n.slds-welcome-mat__tile:first-child{\n  margin-block-start:0;\n}\n.slds-welcome-mat__tile:last-child{\n  margin-block-end:0;\n}\n.slds-welcome-mat__tile.slds-welcome-mat__tile_complete,.slds-welcome-mat__tile.slds-welcome-mat__tile--complete,\n.slds-welcome-mat__tile.slds-welcome-mat__tile_info-only,\n.slds-welcome-mat__tile.slds-welcome-mat__tile--info-only{\n  box-shadow:none;\n}\n.slds-welcome-mat__tile-figure{\n  margin-inline-start:var(--slds-g-spacing-1);\n}\n.slds-welcome-mat__tile-title{\n  font-weight:var(--slds-g-font-weight-7);\n}\n.slds-welcome-mat__tile-body{\n  padding:var(--slds-g-spacing-3);\n  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-welcome-mat__tile-description{\n  color:var(--slds-g-color-on-surface-3);\n  font-size:var(--slds-g-font-scale-neg-1);\n  line-height:var(--slds-g-font-lineheight-3);\n}\n.slds-welcome-mat__tile-icon-container{\n  position:relative;\n}\n.slds-welcome-mat__tile_complete,.slds-welcome-mat__tile--complete{\n  background:transparent;\n}\n.slds-welcome-mat__tile_complete .slds-icon,.slds-welcome-mat__tile--complete .slds-icon{\n  fill:var(--slds-g-color-neutral-base-80);\n}\n.slds-welcome-mat__tile_complete .slds-icon-action-check,.slds-welcome-mat__tile--complete .slds-icon-action-check{\n  position:absolute;\n  inset-block-end:calc(var(--slds-g-sizing-6) * 0.5 * -1);\n  inset-inline-end:calc(var(--slds-g-sizing-6) * 0.5 * -1);\n  height:var(--slds-g-sizing-6);\n  width:var(--slds-g-sizing-6);\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  padding:0.25rem;\n  border:var(--slds-g-sizing-borde-2) solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-sizing-6);\n  line-height:0;\n  background:var(--slds-g-color-success-1);\n}\n.slds-welcome-mat__tile_complete .slds-icon-action-check .slds-icon,.slds-welcome-mat__tile--complete .slds-icon-action-check .slds-icon{\n  fill:var(--slds-g-color-neutral-base-100);\n}\n.slds-welcome-mat_info-only .slds-welcome-mat__content,.slds-welcome-mat--info-only .slds-welcome-mat__content{\n  height:37.5rem;\n}\n.slds-welcome-mat_info-only .slds-welcome-mat__info-title,.slds-welcome-mat--info-only .slds-welcome-mat__info-title{\n  font-size:var(--slds-g-font-scale-7);\n}\n.slds-welcome-mat__tiles_info-only,.slds-welcome-mat__tiles--info-only{\n  background-color:var(--slds-g-color-surface-container-1);\n}\n.slds-welcome-mat__tile_info-only .slds-welcome-mat__tile-body,.slds-welcome-mat__tile--info-only .slds-welcome-mat__tile-body{\n  border-inline-start:0;\n}\n.slds-welcome-mat_splash .slds-welcome-mat__content,.slds-welcome-mat--splash .slds-welcome-mat__content{\n  height:37.5rem;\n}\n.slds-welcome-mat_splash .slds-welcome-mat__info-content,.slds-welcome-mat--splash .slds-welcome-mat__info-content{\n  max-width:37.5rem;\n}\n.slds-welcome-mat_splash .slds-welcome-mat__info-title,.slds-welcome-mat--splash .slds-welcome-mat__info-title{\n  font-size:var(--slds-g-font-scale-7);\n}\n.slds-welcome-mat__info-badge-container{\n  display:inline-block;\n  position:relative;\n}\n.slds-welcome-mat__info-badge-container .slds-icon-action-check{\n  border-width:0;\n  top:50%;\n  right:0%;\n  transform:translate3d(50%, -50%, 0);\n  display:none;\n}\n.slds-welcome-mat__info-badge{\n  margin-block-end:var(--slds-g-spacing-3);\n}\n.slds-welcome-mat__info-progress_complete .slds-icon-action-check,.slds-welcome-mat__info-progress--complete .slds-icon-action-check{\n  display:flex;\n}\n.slds-summary-detail{\n  display:flex;\n  align-items:flex-start;\n}\n.slds-summary-detail .slds-summary-detail__action-icon{\n  transform:rotate(-90deg);\n}\n.slds-summary-detail .slds-summary-detail__content{\n  overflow:hidden;\n  visibility:hidden;\n  opacity:0;\n  height:0;\n}\n[dir='rtl'] .slds-summary-detail .slds-summary-detail__action-icon{\n  transform:rotate(90deg);\n}\n.slds-summary-detail.slds-is-open .slds-summary-detail__action-icon{\n  transform:rotate(0deg);\n  transform-origin:45%;\n}\n.slds-summary-detail.slds-is-open .slds-summary-detail__content{\n  padding-block-start:var(--slds-g-spacing-3);\n  overflow:visible;\n  visibility:visible;\n  opacity:1;\n  height:auto;\n}\n.slds-setup-assistant{\n  padding:var(--slds-g-spacing-4);\n}\n.slds-setup-assistant__item{\n  border-block-end:1px var(--slds-g-color-disabled-1) solid;\n  padding-block:var(--slds-g-spacing-6);\n  padding-inline:0;\n}\n.slds-setup-assistant__item:first-child{\n  padding-block-start:0;\n}\n.slds-setup-assistant__item:last-child{\n  padding-block-end:0;\n  border-bottom:0;\n}\n.slds-setup-assistant__step-summary .slds-progress-ring_large,.slds-setup-assistant__step-summary .slds-progress-ring--large{\n  top:1px;\n}\n[dir='rtl'] .slds-setup-assistant__step-summary .slds-media__figure{\n  margin-inline-start:var(--slds-g-spacing-3);\n}\n.slds-setup-assistant__step-summary-content{\n  margin-inline-end:var(--slds-g-spacing-8);\n}\n[dir='rtl'] .slds-setup-assistant__step-summary-content{\n  margin-inline-end:0;\n}\n.slds-setup-assistant__step-summary-title{\n  padding-block-end:var(--slds-g-spacing-2);\n  font-weight:var(--slds-g-font-weight-7);\n}\n.slds-setup-assistant__step-detail{\n  padding-inline-start:2.75rem;\n}\n[dir='rtl'] .slds-setup-assistant__step-detail{\n  padding-inline-end:var(--slds-g-spacing-5);\n  padding-inline-start:var(--slds-g-spacing-4);\n}\n[dir='rtl'] .slds-setup-assistant__step-detail .slds-media_center,[dir='rtl'] .slds-setup-assistant__step-detail .slds-media--center{\n  margin-inline-end:var(--slds-g-spacing-4);\n}\n[dir='rtl'] .slds-setup-assistant__step-detail .slds-media__figure{\n  margin-inline-start:var(--slds-g-spacing-3);\n}\n.slds-grid{\n  display:flex;\n}\n.slds-grid_frame,.slds-grid--frame{\n  min-width:100vw;\n  min-height:100vh;\n  overflow:hidden;\n}\n.slds-grid_vertical,.slds-grid--vertical{\n  flex-direction:column;\n}\n.slds-grid_vertical-reverse,.slds-grid--vertical-reverse{\n  flex-direction:column-reverse;\n}\n.slds-grid_reverse,.slds-grid--reverse{\n  flex-direction:row-reverse;\n}\n.slds-wrap{\n  flex-wrap:wrap;\n  align-items:flex-start;\n}\n.slds-nowrap{\n  flex:1 1 auto;\n  flex-wrap:nowrap;\n  align-items:stretch;\n}\n@media (min-width: 30em){\n  .slds-nowrap_small,.slds-nowrap--small{\n    flex:1 1 auto;\n    flex-wrap:nowrap;\n    align-items:stretch;\n  }\n}\n@media (min-width: 48em){\n  .slds-nowrap_medium,.slds-nowrap--medium{\n    flex:1 1 auto;\n    flex-wrap:nowrap;\n    align-items:stretch;\n  }\n}\n@media (min-width: 64em){\n  .slds-nowrap_large,.slds-nowrap--large{\n    flex:1 1 auto;\n    flex-wrap:nowrap;\n    align-items:stretch;\n  }\n}\n.slds-gutters{\n  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-gutters .slds-col{\n  padding-inline-end:var(--slds-g-spacing-3);\n  padding-inline-start:var(--slds-g-spacing-3);\n}\n.slds-gutters_xxx-small,.slds-gutters--xxx-small{\n  margin-inline-end:calc(0.125rem * -1);\n  margin-inline-start:calc(0.125rem * -1);\n}\n.slds-gutters_xxx-small .slds-col,.slds-gutters--xxx-small .slds-col{\n  padding-inline-end:0.125rem;\n  padding-inline-start:0.125rem;\n}\n.slds-gutters_xx-small,.slds-gutters--xx-small{\n  margin-inline-end:calc(var(--slds-g-spacing-1) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-1) * -1);\n}\n.slds-gutters_xx-small .slds-col,.slds-gutters--xx-small .slds-col{\n  padding-inline-end:var(--slds-g-spacing-1);\n  padding-inline-start:var(--slds-g-spacing-1);\n}\n.slds-gutters_x-small,.slds-gutters--x-small{\n  margin-inline-end:calc(var(--slds-g-spacing-2) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-2) * -1);\n}\n.slds-gutters_x-small .slds-col,.slds-gutters--x-small .slds-col{\n  padding-inline-end:var(--slds-g-spacing-2);\n  padding-inline-start:var(--slds-g-spacing-2);\n}\n.slds-gutters_small,.slds-gutters--small{\n  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-gutters_small .slds-col,.slds-gutters--small .slds-col{\n  padding-inline-end:var(--slds-g-spacing-3);\n  padding-inline-start:var(--slds-g-spacing-3);\n}\n.slds-gutters_medium,.slds-gutters--medium{\n  margin-inline-end:calc(var(--slds-g-spacing-4) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-4) * -1);\n}\n.slds-gutters_medium .slds-col,.slds-gutters--medium .slds-col{\n  padding-inline-end:var(--slds-g-spacing-4);\n  padding-inline-start:var(--slds-g-spacing-4);\n}\n.slds-gutters_large,.slds-gutters--large{\n  margin-inline-end:calc(var(--slds-g-spacing-5) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-5) * -1);\n}\n.slds-gutters_large .slds-col,.slds-gutters--large .slds-col{\n  padding-inline-end:var(--slds-g-spacing-5);\n  padding-inline-start:var(--slds-g-spacing-5);\n}\n.slds-gutters_x-large,.slds-gutters--x-large{\n  margin-inline-end:calc(var(--slds-g-spacing-6) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-6) * -1);\n}\n.slds-gutters_x-large .slds-col,.slds-gutters--x-large .slds-col{\n  padding-inline-end:var(--slds-g-spacing-6);\n  padding-inline-start:var(--slds-g-spacing-6);\n}\n.slds-gutters_xx-large,.slds-gutters--xx-large{\n  margin-inline-end:calc(var(--slds-g-spacing-8) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-8) * -1);\n}\n.slds-gutters_xx-large .slds-col,.slds-gutters--xx-large .slds-col{\n  padding-inline-end:var(--slds-g-spacing-8);\n  padding-inline-start:var(--slds-g-spacing-8);\n}\n.slds-gutters_direct,.slds-gutters--direct{\n  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-gutters_direct > .slds-col,.slds-gutters--direct > .slds-col{\n  padding-inline-end:var(--slds-g-spacing-3);\n  padding-inline-start:var(--slds-g-spacing-3);\n}\n.slds-gutters_direct-xxx-small,.slds-gutters--direct-xxx-small{\n  margin-inline-end:calc(0.125rem * -1);\n  margin-inline-start:calc(0.125rem * -1);\n}\n.slds-gutters_direct-xxx-small > .slds-col,.slds-gutters--direct-xxx-small > .slds-col{\n  padding-inline-end:0.125rem;\n  padding-inline-start:0.125rem;\n}\n.slds-gutters_direct-xx-small,.slds-gutters--direct-xx-small{\n  margin-inline-end:calc(var(--slds-g-spacing-1) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-1) * -1);\n}\n.slds-gutters_direct-xx-small > .slds-col,.slds-gutters--direct-xx-small > .slds-col{\n  padding-inline-end:var(--slds-g-spacing-1);\n  padding-inline-start:var(--slds-g-spacing-1);\n}\n.slds-gutters_direct-x-small,.slds-gutters--direct-x-small{\n  margin-inline-end:calc(var(--slds-g-spacing-2) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-2) * -1);\n}\n.slds-gutters_direct-x-small > .slds-col,.slds-gutters--direct-x-small > .slds-col{\n  padding-inline-end:var(--slds-g-spacing-2);\n  padding-inline-start:var(--slds-g-spacing-2);\n}\n.slds-gutters_direct-small,.slds-gutters--direct-small{\n  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-gutters_direct-small > .slds-col,.slds-gutters--direct-small > .slds-col{\n  padding-inline-end:var(--slds-g-spacing-3);\n  padding-inline-start:var(--slds-g-spacing-3);\n}\n.slds-gutters_direct-medium,.slds-gutters--direct-medium{\n  margin-inline-end:calc(var(--slds-g-spacing-4) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-4) * -1);\n}\n.slds-gutters_direct-medium > .slds-col,.slds-gutters--direct-medium > .slds-col{\n  padding-inline-end:var(--slds-g-spacing-4);\n  padding-inline-start:var(--slds-g-spacing-4);\n}\n.slds-gutters_direct-large,.slds-gutters--direct-large{\n  margin-inline-end:calc(var(--slds-g-spacing-5) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-5) * -1);\n}\n.slds-gutters_direct-large > .slds-col,.slds-gutters--direct-large > .slds-col{\n  padding-inline-end:var(--slds-g-spacing-5);\n  padding-inline-start:var(--slds-g-spacing-5);\n}\n.slds-gutters_direct-x-large,.slds-gutters--direct-x-large{\n  margin-inline-end:calc(var(--slds-g-spacing-6) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-6) * -1);\n}\n.slds-gutters_direct-x-large > .slds-col,.slds-gutters--direct-x-large > .slds-col{\n  padding-inline-end:var(--slds-g-spacing-6);\n  padding-inline-start:var(--slds-g-spacing-6);\n}\n.slds-gutters_direct-xx-large,.slds-gutters--direct-xx-large{\n  margin-inline-end:calc(var(--slds-g-spacing-8) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-8) * -1);\n}\n.slds-gutters_direct-xx-large > .slds-col,.slds-gutters--direct-xx-large > .slds-col{\n  padding-inline-end:var(--slds-g-spacing-8);\n  padding-inline-start:var(--slds-g-spacing-8);\n}\n.slds-grid_pull-padded,.slds-grid--pull-padded{\n  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-grid_pull-padded-xxx-small,.slds-grid--pull-padded-xxx-small{\n  margin-inline-end:calc(0.125rem * -1);\n  margin-inline-start:calc(0.125rem * -1);\n}\n.slds-grid_pull-padded-xx-small,.slds-grid--pull-padded-xx-small{\n  margin-inline-end:calc(var(--slds-g-spacing-1) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-1) * -1);\n}\n.slds-grid_pull-padded-x-small,.slds-grid--pull-padded-x-small{\n  margin-inline-end:calc(var(--slds-g-spacing-2) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-2) * -1);\n}\n.slds-grid_pull-padded-small,.slds-grid--pull-padded-small{\n  margin-inline-end:calc(var(--slds-g-spacing-3) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-3) * -1);\n}\n.slds-grid_pull-padded-medium,.slds-grid--pull-padded-medium{\n  margin-inline-end:calc(var(--slds-g-spacing-4) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-4) * -1);\n}\n.slds-grid_pull-padded-large,.slds-grid--pull-padded-large{\n  margin-inline-end:calc(var(--slds-g-spacing-5) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-5) * -1);\n}\n.slds-grid_pull-padded-x-large,.slds-grid--pull-padded-x-large{\n  margin-inline-end:calc(var(--slds-g-spacing-6) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-6) * -1);\n}\n.slds-grid_pull-padded-xx-large,.slds-grid--pull-padded-xx-large{\n  margin-inline-end:calc(var(--slds-g-spacing-8) * -1);\n  margin-inline-start:calc(var(--slds-g-spacing-8) * -1);\n}\n.slds-col,\n.slds-col_padded-around-medium,\n.slds-col--padded-around-medium,\n.slds-col_padded-medium,\n.slds-col--padded-medium,\n.slds-col_padded-around-large,\n.slds-col--padded-around-large,\n.slds-col_padded-large,\n.slds-col--padded-large,\n.slds-col_padded-around,\n.slds-col--padded-around,\n.slds-col_padded,\n.slds-col--padded{\n  flex:1 1 auto;\n}\n.slds-col{\n  flex:1 1 auto;\n}\n@media (min-width: 64em){\n  .slds-col_rule-top,.slds-col--rule-top{\n    border-inline-start:1px solid var(--slds-g-color-border-1);\n  }\n}\n@media (min-width: 64em){\n  .slds-col_rule-right,.slds-col--rule-right{\n    border-inline-end:1px solid var(--slds-g-color-border-1);\n  }\n}\n@media (min-width: 64em){\n  .slds-col_rule-bottom,.slds-col--rule-bottom{\n    border-block-end:1px solid var(--slds-g-color-border-1);\n  }\n}\n@media (min-width: 64em){\n  .slds-col_rule-left,.slds-col--rule-left{\n    border-inline-start:1px solid var(--slds-g-color-border-1);\n  }\n}\n.slds-has-flexi-truncate{\n  flex:1 1 0%;\n  min-width:0;\n}\n.slds-no-flex{\n  flex:none;\n}\n.slds-no-space{\n  min-width:0;\n}\n.slds-grow{\n  flex-grow:1;\n}\n.slds-grow-none{\n  flex-grow:0;\n}\n.slds-shrink{\n  flex-shrink:1;\n}\n.slds-shrink-none{\n  flex-shrink:0;\n}\n.slds-text-longform ul.slds-grid{\n  margin-inline-start:0;\n  list-style:none;\n}\n.slds-grid_align-center,.slds-grid--align-center{\n  justify-content:center;\n}\n.slds-grid_align-center .slds-col,.slds-grid--align-center .slds-col,\n.slds-grid_align-center .slds-col_padded-around-medium,\n.slds-grid--align-center .slds-col--padded-around-medium,\n.slds-grid_align-center .slds-col_padded-medium,\n.slds-grid--align-center .slds-col--padded-medium,\n.slds-grid_align-center .slds-col_padded-around-large,\n.slds-grid--align-center .slds-col--padded-around-large,\n.slds-grid_align-center .slds-col_padded-large,\n.slds-grid--align-center .slds-col--padded-large,\n.slds-grid_align-center .slds-col_padded-around,\n.slds-grid--align-center .slds-col--padded-around,\n.slds-grid_align-center .slds-col_padded,\n.slds-grid--align-center .slds-col--padded{\n  flex-grow:0;\n}\n.slds-grid_align-space,.slds-grid--align-space{\n  justify-content:space-around;\n}\n.slds-grid_align-space .slds-col,.slds-grid--align-space .slds-col,\n.slds-grid_align-space .slds-col_padded-around-medium,\n.slds-grid--align-space .slds-col--padded-around-medium,\n.slds-grid_align-space .slds-col_padded-medium,\n.slds-grid--align-space .slds-col--padded-medium,\n.slds-grid_align-space .slds-col_padded-around-large,\n.slds-grid--align-space .slds-col--padded-around-large,\n.slds-grid_align-space .slds-col_padded-large,\n.slds-grid--align-space .slds-col--padded-large,\n.slds-grid_align-space .slds-col_padded-around,\n.slds-grid--align-space .slds-col--padded-around,\n.slds-grid_align-space .slds-col_padded,\n.slds-grid--align-space .slds-col--padded{\n  flex-grow:0;\n}\n.slds-grid_align-spread,.slds-grid--align-spread{\n  justify-content:space-between;\n}\n.slds-grid_align-spread .slds-col,.slds-grid--align-spread .slds-col,\n.slds-grid_align-spread .slds-col_padded-around-medium,\n.slds-grid--align-spread .slds-col--padded-around-medium,\n.slds-grid_align-spread .slds-col_padded-medium,\n.slds-grid--align-spread .slds-col--padded-medium,\n.slds-grid_align-spread .slds-col_padded-around-large,\n.slds-grid--align-spread .slds-col--padded-around-large,\n.slds-grid_align-spread .slds-col_padded-large,\n.slds-grid--align-spread .slds-col--padded-large,\n.slds-grid_align-spread .slds-col_padded-around,\n.slds-grid--align-spread .slds-col--padded-around,\n.slds-grid_align-spread .slds-col_padded,\n.slds-grid--align-spread .slds-col--padded{\n  flex-grow:0;\n}\n.slds-grid_align-end,.slds-grid--align-end{\n  justify-content:flex-end;\n}\n.slds-grid_align-end .slds-col,.slds-grid--align-end .slds-col,\n.slds-grid_align-end .slds-col_padded-around-medium,\n.slds-grid--align-end .slds-col--padded-around-medium,\n.slds-grid_align-end .slds-col_padded-medium,\n.slds-grid--align-end .slds-col--padded-medium,\n.slds-grid_align-end .slds-col_padded-around-large,\n.slds-grid--align-end .slds-col--padded-around-large,\n.slds-grid_align-end .slds-col_padded-large,\n.slds-grid--align-end .slds-col--padded-large,\n.slds-grid_align-end .slds-col_padded-around,\n.slds-grid--align-end .slds-col--padded-around,\n.slds-grid_align-end .slds-col_padded,\n.slds-grid--align-end .slds-col--padded{\n  flex-grow:0;\n}\n.slds-grid_vertical-align-start,.slds-grid--vertical-align-start{\n  align-items:flex-start;\n  align-content:flex-start;\n}\n.slds-grid_vertical-align-center,.slds-grid--vertical-align-center{\n  align-items:center;\n  align-content:center;\n}\n.slds-grid_vertical-align-end,.slds-grid--vertical-align-end{\n  align-items:flex-end;\n  align-content:flex-end;\n}\n.slds-align-top{\n  vertical-align:top;\n  align-self:flex-start;\n}\n.slds-align-middle{\n  vertical-align:middle;\n  align-self:center;\n}\n.slds-align-bottom{\n  vertical-align:bottom;\n  align-self:flex-end;\n}\n.slds-col_bump-top,.slds-col--bump-top{\n  margin-block-start:auto;\n}\n.slds-col_bump-right,.slds-col--bump-right{\n  margin-inline-end:auto;\n}\n.slds-col_bump-bottom,.slds-col--bump-bottom{\n  margin-block-end:auto;\n}\n.slds-col_bump-left,.slds-col--bump-left{\n  margin-inline-start:auto;\n}\n.slds-grid_vertical-stretch,.slds-grid--vertical-stretch{\n  align-items:stretch;\n  align-content:stretch;\n}\n.slds-container_small,.slds-container--small{\n  max-width:30rem;\n}\n.slds-container_medium,.slds-container--medium{\n  max-width:48rem;\n}\n.slds-container_large,.slds-container--large{\n  max-width:64rem;\n}\n.slds-container_x-large,.slds-container--x-large{\n  max-width:80rem;\n}\n.slds-container_fluid,.slds-container--fluid{\n  width:100%;\n}\n.slds-container_center,.slds-container--center{\n  margin-inline-start:auto;\n  margin-inline-end:auto;\n}\n.slds-container_left,.slds-container--left{\n  margin-inline-end:auto;\n}\n.slds-container_right,.slds-container--right{\n  margin-inline-start:auto;\n}\n.slds-grid_overflow,.slds-grid--overflow{\n  flex-flow:row nowrap;\n}\n.slds-grid_overflow .slds-col,.slds-grid--overflow .slds-col{\n  min-width:11.25em;\n  max-width:22.5em;\n}\n.slds-col_padded,.slds-col--padded{\n  padding-inline:var(--slds-g-spacing-3);\n}\n.slds-col_padded-medium,.slds-col--padded-medium{\n  padding-inline:var(--slds-g-spacing-4);\n}\n.slds-col_padded-large,.slds-col--padded-large{\n  padding-inline:var(--slds-g-spacing-5);\n}\n.slds-col_padded-around,.slds-col--padded-around{\n  padding:var(--slds-g-spacing-3);\n}\n.slds-col_padded-around-medium,.slds-col--padded-around-medium{\n  padding:var(--slds-g-spacing-4);\n}\n.slds-col_padded-around-large,.slds-col--padded-around-large{\n  padding:var(--slds-g-spacing-5);\n}\n.slds-align_absolute-center,.slds-align--absolute-center{\n  display:flex;\n  justify-content:center;\n  align-content:center;\n  align-items:center;\n  margin:auto;\n}\n.slds-media{\n  display:flex;\n  align-items:flex-start;\n}\n.slds-media__figure{\n  flex-shrink:0;\n  margin-inline-end:var(--slds-g-spacing-3);\n}\n.slds-media__figure_fixed-width,.slds-media__figure--fixed-width{\n  min-width:var(--slds-g-sizing-10);\n}\n.slds-media__body{\n  flex:1;\n  min-width:0;\n}\n.slds-media__body,\n.slds-media__body > :last-child{\n  margin-block-end:0;\n}\n.slds-media-body-iefix{\n  flex-shrink:0;\n  flex-basis:auto;\n}\n.slds-media_small .slds-media__figure,.slds-media--small .slds-media__figure,\n.slds-media--small .slds-media__figure{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-media_small .slds-media__figure_reverse,.slds-media--small .slds-media__figure--reverse,\n.slds-media--small .slds-media__figure--reverse{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-media_large .slds-media__figure,.slds-media--large .slds-media__figure,\n.slds-media--large .slds-media__figure{\n  margin-inline-end:var(--slds-g-spacing-5);\n}\n.slds-media_large .slds-media__figure_reverse,.slds-media--large .slds-media__figure--reverse,\n.slds-media--large .slds-media__figure--reverse{\n  margin-inline-start:var(--slds-g-spacing-5);\n}\n.slds-media_inline .slds-media__body,.slds-media--inline .slds-media__body{\n  flex:0 1 auto;\n}\n.slds-media_center,.slds-media--center,\n.slds-media--center{\n  align-items:center;\n}\n.slds-media__figure_reverse,.slds-media__figure--reverse,\n.slds-media__figure--reverse{\n  margin:0;\n  margin-inline-start:var(--slds-g-spacing-3);\n}\n[class*='slds-var-m-']{\n  --_slds-g-spacing-var-block-1:var(--lwc-varSpacingVerticalXxSmall);\n  --_slds-g-spacing-var-block-2:var(--lwc-varSpacingVerticalXSmall);\n  --_slds-g-spacing-var-block-3:var(--lwc-varSpacingVerticalSmall);\n  --_slds-g-spacing-var-block-4:var(--lwc-varSpacingVerticalMedium);\n  --_slds-g-spacing-var-block-5:var(--lwc-varSpacingVerticalLarge);\n  --_slds-g-spacing-var-block-6:var(--lwc-varSpacingVerticalXLarge);\n  --_slds-g-spacing-var-block-7:var(--lwc-varSpacingVerticalXxLarge);\n  --_slds-g-spacing-var-inline-1:var(--lwc-varSpacingHorizontalXxSmall);\n  --_slds-g-spacing-var-inline-2:var(--lwc-varSpacingHorizontalXSmall);\n  --_slds-g-spacing-var-inline-3:var(--lwc-varSpacingHorizontalSmall);\n  --_slds-g-spacing-var-inline-4:var(--lwc-varSpacingHorizontalMedium);\n  --_slds-g-spacing-var-inline-5:var(--lwc-varSpacingHorizontalLarge);\n  --_slds-g-spacing-var-inline-6:var(--lwc-varSpacingHorizontalXLarge);\n  --_slds-g-spacing-var-inline-7:var(--lwc-varSpacingHorizontalXxLarge);\n  --_slds-g-spacing-var-1:var(--lwc-varSpacingXxSmall);\n  --_slds-g-spacing-var-2:var(--lwc-varSpacingXSmall);\n  --_slds-g-spacing-var-3:var(--lwc-varSpacingSmall);\n  --_slds-g-spacing-var-4:var(--lwc-varSpacingMedium);\n  --_slds-g-spacing-var-5:var(--lwc-varSpacingLarge);\n  --_slds-g-spacing-var-6:var(--lwc-varSpacingXLarge);\n  --_slds-g-spacing-var-7:var(--lwc-varSpacingXxLarge);\n}\n.slds-m-top_none,.slds-m-top--none{\n  margin-block-start:0 !important;\n}\n.slds-m-top_xxx-small,.slds-m-top--xxx-small{\n  margin-block-start:0.125rem;\n}\n.slds-m-top_xx-small,.slds-m-top--xx-small{\n  margin-block-start:var(--slds-g-spacing-1);\n}\n.slds-m-top_x-small,.slds-m-top--x-small{\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-m-top_small,.slds-m-top--small{\n  margin-block-start:var(--slds-g-spacing-3);\n}\n.slds-m-top_medium,.slds-m-top--medium{\n  margin-block-start:var(--slds-g-spacing-4);\n}\n.slds-m-top_large,.slds-m-top--large{\n  margin-block-start:var(--slds-g-spacing-5);\n}\n.slds-m-top_x-large,.slds-m-top--x-large{\n  margin-block-start:var(--slds-g-spacing-6);\n}\n.slds-m-top_xx-large,.slds-m-top--xx-large{\n  margin-block-start:var(--slds-g-spacing-8);\n}\n.slds-var-m-top_xxx-small,.slds-var-m-top--xxx-small{\n  margin-block-start:var(--lwc-varSpacingVerticalXxxSmall);\n}\n.slds-var-m-top_xx-small,.slds-var-m-top--xx-small{\n  margin-block-start:var(--_slds-g-spacing-var-block-1);\n}\n.slds-var-m-top_x-small,.slds-var-m-top--x-small{\n  margin-block-start:var(--_slds-g-spacing-var-block-2);\n}\n.slds-var-m-top_small,.slds-var-m-top--small{\n  margin-block-start:var(--_slds-g-spacing-var-block-3);\n}\n.slds-var-m-top_medium,.slds-var-m-top--medium{\n  margin-block-start:var(--_slds-g-spacing-var-block-4);\n}\n.slds-var-m-top_large,.slds-var-m-top--large{\n  margin-block-start:var(--_slds-g-spacing-var-block-5);\n}\n.slds-var-m-top_x-large,.slds-var-m-top--x-large{\n  margin-block-start:var(--_slds-g-spacing-var-block-6);\n}\n.slds-var-m-top_xx-large,.slds-var-m-top--xx-large{\n  margin-block-start:var(--_slds-g-spacing-var-block-7);\n}\n.slds-m-right_none,.slds-m-right--none{\n  margin-inline-end:0 !important;\n}\n.slds-m-right_xxx-small,.slds-m-right--xxx-small{\n  margin-inline-end:0.125rem;\n}\n.slds-m-right_xx-small,.slds-m-right--xx-small{\n  margin-inline-end:var(--slds-g-spacing-1);\n}\n.slds-m-right_x-small,.slds-m-right--x-small{\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-m-right_small,.slds-m-right--small{\n  margin-inline-end:var(--slds-g-spacing-3);\n}\n.slds-m-right_medium,.slds-m-right--medium{\n  margin-inline-end:var(--slds-g-spacing-4);\n}\n.slds-m-right_large,.slds-m-right--large{\n  margin-inline-end:var(--slds-g-spacing-5);\n}\n.slds-m-right_x-large,.slds-m-right--x-large{\n  margin-inline-end:var(--slds-g-spacing-6);\n}\n.slds-m-right_xx-large,.slds-m-right--xx-large{\n  margin-inline-end:var(--slds-g-spacing-8);\n}\n.slds-var-m-right_xxx-small,.slds-var-m-right--xxx-small{\n  margin-inline-end:var(--lwc-varSpacingHorizontalXxxSmall);\n}\n.slds-var-m-right_xx-small,.slds-var-m-right--xx-small{\n  margin-inline-end:var(--_slds-g-spacing-var-inline-1);\n}\n.slds-var-m-right_x-small,.slds-var-m-right--x-small{\n  margin-inline-end:var(--_slds-g-spacing-var-inline-2);\n}\n.slds-var-m-right_small,.slds-var-m-right--small{\n  margin-inline-end:var(--_slds-g-spacing-var-inline-3);\n}\n.slds-var-m-right_medium,.slds-var-m-right--medium{\n  margin-inline-end:var(--_slds-g-spacing-var-inline-4);\n}\n.slds-var-m-right_large,.slds-var-m-right--large{\n  margin-inline-end:var(--_slds-g-spacing-var-inline-5);\n}\n.slds-var-m-right_x-large,.slds-var-m-right--x-large{\n  margin-inline-end:var(--_slds-g-spacing-var-inline-6);\n}\n.slds-var-m-right_xx-large,.slds-var-m-right--xx-large{\n  margin-inline-end:var(--_slds-g-spacing-var-inline-7);\n}\n.slds-m-bottom_none,.slds-m-bottom--none{\n  margin-block-end:0 !important;\n}\n.slds-m-bottom_xxx-small,.slds-m-bottom--xxx-small{\n  margin-block-end:0.125rem;\n}\n.slds-m-bottom_xx-small,.slds-m-bottom--xx-small{\n  margin-block-end:var(--slds-g-spacing-1);\n}\n.slds-m-bottom_x-small,.slds-m-bottom--x-small{\n  margin-block-end:var(--slds-g-spacing-2);\n}\n.slds-m-bottom_small,.slds-m-bottom--small{\n  margin-block-end:var(--slds-g-spacing-3);\n}\n.slds-m-bottom_medium,.slds-m-bottom--medium{\n  margin-block-end:var(--slds-g-spacing-4);\n}\n.slds-m-bottom_large,.slds-m-bottom--large{\n  margin-block-end:var(--slds-g-spacing-5);\n}\n.slds-m-bottom_x-large,.slds-m-bottom--x-large{\n  margin-block-end:var(--slds-g-spacing-6);\n}\n.slds-m-bottom_xx-large,.slds-m-bottom--xx-large{\n  margin-block-end:var(--slds-g-spacing-8);\n}\n.slds-var-m-bottom_xxx-small,.slds-var-m-bottom--xxx-small{\n  margin-block-end:var(--lwc-varSpacingVerticalXxxSmall);\n}\n.slds-var-m-bottom_xx-small,.slds-var-m-bottom--xx-small{\n  margin-block-end:var(--_slds-g-spacing-var-block-1);\n}\n.slds-var-m-bottom_x-small,.slds-var-m-bottom--x-small{\n  margin-block-end:var(--_slds-g-spacing-var-block-2);\n}\n.slds-var-m-bottom_small,.slds-var-m-bottom--small{\n  margin-block-end:var(--_slds-g-spacing-var-block-3);\n}\n.slds-var-m-bottom_medium,.slds-var-m-bottom--medium{\n  margin-block-end:var(--_slds-g-spacing-var-block-5);\n}\n.slds-var-m-bottom_large,.slds-var-m-bottom--large{\n  margin-block-end:var(--_slds-g-spacing-var-block-6);\n}\n.slds-var-m-bottom_x-large,.slds-var-m-bottom--x-large{\n  margin-block-end:var(--_slds-g-spacing-var-block-6);\n}\n.slds-var-m-bottom_xx-large,.slds-var-m-bottom--xx-large{\n  margin-block-end:var(--_slds-g-spacing-var-block-7);\n}\n.slds-m-left_none,.slds-m-left--none{\n  margin-inline-start:0 !important;\n}\n.slds-m-left_xxx-small,.slds-m-left--xxx-small{\n  margin-inline-start:0.125rem;\n}\n.slds-m-left_xx-small,.slds-m-left--xx-small{\n  margin-inline-start:var(--slds-g-spacing-1);\n}\n.slds-m-left_x-small,.slds-m-left--x-small{\n  margin-inline-start:var(--slds-g-spacing-2);\n}\n.slds-m-left_small,.slds-m-left--small{\n  margin-inline-start:var(--slds-g-spacing-3);\n}\n.slds-m-left_medium,.slds-m-left--medium{\n  margin-inline-start:var(--slds-g-spacing-4);\n}\n.slds-m-left_large,.slds-m-left--large{\n  margin-inline-start:var(--slds-g-spacing-5);\n}\n.slds-m-left_x-large,.slds-m-left--x-large{\n  margin-inline-start:var(--slds-g-spacing-6);\n}\n.slds-m-left_xx-large,.slds-m-left--xx-large{\n  margin-inline-start:var(--slds-g-spacing-8);\n}\n.slds-var-m-left_xxx-small,.slds-var-m-left--xxx-small{\n  margin-inline-start:var(--lwc-varSpacingHorizontalXxxSmall);\n}\n.slds-var-m-left_xx-small,.slds-var-m-left--xx-small{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-1);\n}\n.slds-var-m-left_x-small,.slds-var-m-left--x-small{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-2);\n}\n.slds-var-m-left_small,.slds-var-m-left--small{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-3);\n}\n.slds-var-m-left_medium,.slds-var-m-left--medium{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-4);\n}\n.slds-var-m-left_large,.slds-var-m-left--large{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-5);\n}\n.slds-var-m-left_x-large,.slds-var-m-left--x-large{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-6);\n}\n.slds-var-m-left_xx-large,.slds-var-m-left--xx-large{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-7);\n}\n.slds-m-horizontal_none,.slds-m-horizontal--none{\n  margin-inline-start:0 !important;\n  margin-inline-end:0 !important;\n}\n.slds-m-horizontal_xxx-small,.slds-m-horizontal--xxx-small{\n  margin-inline-start:0.125rem;\n  margin-inline-end:0.125rem;\n}\n.slds-m-horizontal_xx-small,.slds-m-horizontal--xx-small{\n  margin-inline-start:var(--slds-g-spacing-1);\n  margin-inline-end:var(--slds-g-spacing-1);\n}\n.slds-m-horizontal_x-small,.slds-m-horizontal--x-small{\n  margin-inline-start:var(--slds-g-spacing-2);\n  margin-inline-end:var(--slds-g-spacing-2);\n}\n.slds-m-horizontal_small,.slds-m-horizontal--small{\n  margin-inline-start:var(--slds-g-spacing-3);\n  margin-inline-end:var(--slds-g-spacing-3);\n}\n.slds-m-horizontal_medium,.slds-m-horizontal--medium{\n  margin-inline-start:var(--slds-g-spacing-4);\n  margin-inline-end:var(--slds-g-spacing-4);\n}\n.slds-m-horizontal_large,.slds-m-horizontal--large{\n  margin-inline-start:var(--slds-g-spacing-5);\n  margin-inline-end:var(--slds-g-spacing-5);\n}\n.slds-m-horizontal_x-large,.slds-m-horizontal--x-large{\n  margin-inline-start:var(--slds-g-spacing-6);\n  margin-inline-end:var(--slds-g-spacing-6);\n}\n.slds-m-horizontal_xx-large,.slds-m-horizontal--xx-large{\n  margin-inline-start:var(--slds-g-spacing-8);\n  margin-inline-end:var(--slds-g-spacing-8);\n}\n.slds-var-m-horizontal_xxx-small,.slds-var-m-horizontal--xxx-small{\n  margin-inline-start:var(--lwc-varSpacingHorizontalXxxSmall);\n  margin-inline-end:var(--lwc-varSpacingHorizontalXxxSmall);\n}\n.slds-var-m-horizontal_xx-small,.slds-var-m-horizontal--xx-small{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-1);\n  margin-inline-end:var(--_slds-g-spacing-var-inline-1);\n}\n.slds-var-m-horizontal_x-small,.slds-var-m-horizontal--x-small{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-2);\n  margin-inline-end:var(--_slds-g-spacing-var-inline-2);\n}\n.slds-var-m-horizontal_small,.slds-var-m-horizontal--small{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-3);\n  margin-inline-end:var(--_slds-g-spacing-var-inline-3);\n}\n.slds-var-m-horizontal_medium,.slds-var-m-horizontal--medium{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-4);\n  margin-inline-end:var(--_slds-g-spacing-var-inline-4);\n}\n.slds-var-m-horizontal_large,.slds-var-m-horizontal--large{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-5);\n  margin-inline-end:var(--_slds-g-spacing-var-inline-5);\n}\n.slds-var-m-horizontal_x-large,.slds-var-m-horizontal--x-large{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-6);\n  margin-inline-end:var(--_slds-g-spacing-var-inline-6);\n}\n.slds-var-m-horizontal_xx-large,.slds-var-m-horizontal--xx-large{\n  margin-inline-start:var(--_slds-g-spacing-var-inline-7);\n  margin-inline-end:var(--_slds-g-spacing-var-inline-7);\n}\n.slds-m-vertical_none,.slds-m-vertical--none{\n  margin-block-start:0 !important;\n  margin-block-end:0 !important;\n}\n.slds-m-vertical_xxx-small,.slds-m-vertical--xxx-small{\n  margin-block-start:0.125rem;\n  margin-block-end:0.125rem;\n}\n.slds-m-vertical_xx-small,.slds-m-vertical--xx-small{\n  margin-block-start:var(--slds-g-spacing-1);\n  margin-block-end:var(--slds-g-spacing-1);\n}\n.slds-m-vertical_x-small,.slds-m-vertical--x-small{\n  margin-block-start:var(--slds-g-spacing-2);\n  margin-block-end:var(--slds-g-spacing-2);\n}\n.slds-m-vertical_small,.slds-m-vertical--small{\n  margin-block-start:var(--slds-g-spacing-3);\n  margin-block-end:var(--slds-g-spacing-3);\n}\n.slds-m-vertical_medium,.slds-m-vertical--medium{\n  margin-block-start:var(--slds-g-spacing-4);\n  margin-block-end:var(--slds-g-spacing-4);\n}\n.slds-m-vertical_large,.slds-m-vertical--large{\n  margin-block-start:var(--slds-g-spacing-5);\n  margin-block-end:var(--slds-g-spacing-5);\n}\n.slds-m-vertical_x-large,.slds-m-vertical--x-large{\n  margin-block-start:var(--slds-g-spacing-6);\n  margin-block-end:var(--slds-g-spacing-6);\n}\n.slds-m-vertical_xx-large,.slds-m-vertical--xx-large{\n  margin-block-start:var(--slds-g-spacing-8);\n  margin-block-end:var(--slds-g-spacing-8);\n}\n.slds-var-m-vertical_xxx-small,.slds-var-m-vertical--xxx-small{\n  margin-block-start:var(--lwc-varSpacingVerticalXxxSmall);\n  margin-block-end:var(--lwc-varSpacingVerticalXxxSmall);\n}\n.slds-var-m-vertical_xx-small,.slds-var-m-vertical--xx-small{\n  margin-block-start:var(--_slds-g-spacing-var-block-1);\n  margin-block-end:var(--_slds-g-spacing-var-block-1);\n}\n.slds-var-m-vertical_x-small,.slds-var-m-vertical--x-small{\n  margin-block-start:var(--_slds-g-spacing-var-block-2);\n  margin-block-end:var(--_slds-g-spacing-var-block-2);\n}\n.slds-var-m-vertical_small,.slds-var-m-vertical--small{\n  margin-block-start:var(--_slds-g-spacing-var-block-3);\n  margin-block-end:var(--_slds-g-spacing-var-block-3);\n}\n.slds-var-m-vertical_medium,.slds-var-m-vertical--medium{\n  margin-block-start:var(--_slds-g-spacing-var-block-4);\n  margin-block-end:var(--_slds-g-spacing-var-block-4);\n}\n.slds-var-m-vertical_large,.slds-var-m-vertical--large{\n  margin-block-start:var(--_slds-g-spacing-var-block-5);\n  margin-block-end:var(--_slds-g-spacing-var-block-5);\n}\n.slds-var-m-vertical_x-large,.slds-var-m-vertical--x-large{\n  margin-block-start:var(--_slds-g-spacing-var-block-6);\n  margin-block-end:var(--_slds-g-spacing-var-block-6);\n}\n.slds-var-m-vertical_xx-large,.slds-var-m-vertical--xx-large{\n  margin-block-start:var(--_slds-g-spacing-var-block-7);\n  margin-block-end:var(--_slds-g-spacing-var-block-7);\n}\n.slds-m-around_none,.slds-m-around--none{\n  margin:0 !important;\n}\n.slds-m-around_xxx-small,.slds-m-around--xxx-small{\n  margin:0.125rem;\n}\n.slds-m-around_xx-small,.slds-m-around--xx-small{\n  margin:var(--slds-g-spacing-1);\n}\n.slds-m-around_x-small,.slds-m-around--x-small{\n  margin:var(--slds-g-spacing-2);\n}\n.slds-m-around_small,.slds-m-around--small{\n  margin:var(--slds-g-spacing-3);\n}\n.slds-m-around_medium,.slds-m-around--medium{\n  margin:var(--slds-g-spacing-4);\n}\n.slds-m-around_large,.slds-m-around--large{\n  margin:var(--slds-g-spacing-5);\n}\n.slds-m-around_x-large,.slds-m-around--x-large{\n  margin:var(--slds-g-spacing-6);\n}\n.slds-m-around_xx-large,.slds-m-around--xx-large{\n  margin:var(--slds-g-spacing-8);\n}\n.slds-var-m-around_xxx-small,.slds-var-m-around--xxx-small{\n  margin:var(--lwc-varSpacingXxxSmall);\n}\n.slds-var-m-around_xx-small,.slds-var-m-around--xx-small{\n  margin:var(--_slds-g-spacing-var-1);\n}\n.slds-var-m-around_x-small,.slds-var-m-around--x-small{\n  margin:var(--_slds-g-spacing-var-2);\n}\n.slds-var-m-around_small,.slds-var-m-around--small{\n  margin:var(--_slds-g-spacing-var-3);\n}\n.slds-var-m-around_medium,.slds-var-m-around--medium{\n  margin:var(--_slds-g-spacing-var-4);\n}\n.slds-var-m-around_large,.slds-var-m-around--large{\n  margin:var(--_slds-g-spacing-var-5);\n}\n.slds-var-m-around_x-large,.slds-var-m-around--x-large{\n  margin:var(--_slds-g-spacing-var-6);\n}\n.slds-var-m-around_xx-large,.slds-var-m-around--xx-large{\n  margin:var(--_slds-g-spacing-var-7);\n}\n[class*='slds-var-p-']{\n  --_slds-g-spacing-var-block-1:var(--lwc-varSpacingVerticalXxSmall);\n  --_slds-g-spacing-var-block-2:var(--lwc-varSpacingVerticalXSmall);\n  --_slds-g-spacing-var-block-3:var(--lwc-varSpacingVerticalSmall);\n  --_slds-g-spacing-var-block-4:var(--lwc-varSpacingVerticalMedium);\n  --_slds-g-spacing-var-block-5:var(--lwc-varSpacingVerticalLarge);\n  --_slds-g-spacing-var-block-6:var(--lwc-varSpacingVerticalXLarge);\n  --_slds-g-spacing-var-block-7:var(--lwc-varSpacingVerticalXxLarge);\n  --_slds-g-spacing-var-inline-1:var(--lwc-varSpacingHorizontalXxSmall);\n  --_slds-g-spacing-var-inline-2:var(--lwc-varSpacingHorizontalXSmall);\n  --_slds-g-spacing-var-inline-3:var(--lwc-varSpacingHorizontalSmall);\n  --_slds-g-spacing-var-inline-4:var(--lwc-varSpacingHorizontalMedium);\n  --_slds-g-spacing-var-inline-5:var(--lwc-varSpacingHorizontalLarge);\n  --_slds-g-spacing-var-inline-6:var(--lwc-varSpacingHorizontalXLarge);\n  --_slds-g-spacing-var-inline-7:var(--lwc-varSpacingHorizontalXxLarge);\n  --_slds-g-spacing-var-1:var(--lwc-varSpacingXxSmall);\n  --_slds-g-spacing-var-2:var(--lwc-varSpacingXSmall);\n  --_slds-g-spacing-var-3:var(--lwc-varSpacingSmall);\n  --_slds-g-spacing-var-4:var(--lwc-varSpacingMedium);\n  --_slds-g-spacing-var-5:var(--lwc-varSpacingLarge);\n  --_slds-g-spacing-var-6:var(--lwc-varSpacingXLarge);\n  --_slds-g-spacing-var-7:var(--lwc-varSpacingXxLarge);\n}\n.slds-p-top_none,.slds-p-top--none{\n  padding-block-start:0 !important;\n}\n.slds-p-top_xxx-small,.slds-p-top--xxx-small{\n  padding-block-start:0.125rem;\n}\n.slds-p-top_xx-small,.slds-p-top--xx-small{\n  padding-block-start:var(--slds-g-spacing-1);\n}\n.slds-p-top_x-small,.slds-p-top--x-small{\n  padding-block-start:var(--slds-g-spacing-2);\n}\n.slds-p-top_small,.slds-p-top--small{\n  padding-block-start:var(--slds-g-spacing-3);\n}\n.slds-p-top_medium,.slds-p-top--medium{\n  padding-block-start:var(--slds-g-spacing-4);\n}\n.slds-p-top_large,.slds-p-top--large{\n  padding-block-start:var(--slds-g-spacing-5);\n}\n.slds-p-top_x-large,.slds-p-top--x-large{\n  padding-block-start:var(--slds-g-spacing-6);\n}\n.slds-p-top_xx-large,.slds-p-top--xx-large{\n  padding-block-start:var(--slds-g-spacing-8);\n}\n.slds-var-p-top_xxx-small,.slds-var-p-top--xxx-small{\n  padding-block-start:var(--lwc-varSpacingVerticalXxxSmall);\n}\n.slds-var-p-top_xx-small,.slds-var-p-top--xx-small{\n  padding-block-start:var(--_slds-g-spacing-var-block-1);\n}\n.slds-var-p-top_x-small,.slds-var-p-top--x-small{\n  padding-block-start:var(--_slds-g-spacing-var-block-2);\n}\n.slds-var-p-top_small,.slds-var-p-top--small{\n  padding-block-start:var(--_slds-g-spacing-var-block-3);\n}\n.slds-var-p-top_medium,.slds-var-p-top--medium{\n  padding-block-start:var(--_slds-g-spacing-var-block-4);\n}\n.slds-var-p-top_large,.slds-var-p-top--large{\n  padding-block-start:var(--_slds-g-spacing-var-block-5);\n}\n.slds-var-p-top_x-large,.slds-var-p-top--x-large{\n  padding-block-start:var(--_slds-g-spacing-var-block-6);\n}\n.slds-var-p-top_xx-large,.slds-var-p-top--xx-large{\n  padding-block-start:var(--_slds-g-spacing-var-block-7);\n}\n.slds-p-right_none,.slds-p-right--none{\n  padding-inline-end:0 !important;\n}\n.slds-p-right_xxx-small,.slds-p-right--xxx-small{\n  padding-inline-end:0.125rem;\n}\n.slds-p-right_xx-small,.slds-p-right--xx-small{\n  padding-inline-end:var(--slds-g-spacing-1);\n}\n.slds-p-right_x-small,.slds-p-right--x-small{\n  padding-inline-end:var(--slds-g-spacing-2);\n}\n.slds-p-right_small,.slds-p-right--small{\n  padding-inline-end:var(--slds-g-spacing-3);\n}\n.slds-p-right_medium,.slds-p-right--medium{\n  padding-inline-end:var(--slds-g-spacing-4);\n}\n.slds-p-right_large,.slds-p-right--large{\n  padding-inline-end:var(--slds-g-spacing-5);\n}\n.slds-p-right_x-large,.slds-p-right--x-large{\n  padding-inline-end:var(--slds-g-spacing-6);\n}\n.slds-p-right_xx-large,.slds-p-right--xx-large{\n  padding-inline-end:var(--slds-g-spacing-8);\n}\n.slds-var-p-right_xxx-small,.slds-var-p-right--xxx-small{\n  padding-inline-end:var(--lwc-varSpacingHorizontalXxxSmall);\n}\n.slds-var-p-right_xx-small,.slds-var-p-right--xx-small{\n  padding-inline-end:var(--_slds-g-spacing-var-inline-1);\n}\n.slds-var-p-right_x-small,.slds-var-p-right--x-small{\n  padding-inline-end:var(--_slds-g-spacing-var-inline-2);\n}\n.slds-var-p-right_small,.slds-var-p-right--small{\n  padding-inline-end:var(--_slds-g-spacing-var-inline-3);\n}\n.slds-var-p-right_medium,.slds-var-p-right--medium{\n  padding-inline-end:var(--_slds-g-spacing-var-inline-4);\n}\n.slds-var-p-right_large,.slds-var-p-right--large{\n  padding-inline-end:var(--_slds-g-spacing-var-inline-5);\n}\n.slds-var-p-right_x-large,.slds-var-p-right--x-large{\n  padding-inline-end:var(--_slds-g-spacing-var-inline-6);\n}\n.slds-var-p-right_xx-large,.slds-var-p-right--xx-large{\n  padding-inline-end:var(--_slds-g-spacing-var-inline-7);\n}\n.slds-p-bottom_none,.slds-p-bottom--none{\n  padding-block-end:0 !important;\n}\n.slds-p-bottom_xxx-small,.slds-p-bottom--xxx-small{\n  padding-block-end:0.125rem;\n}\n.slds-p-bottom_xx-small,.slds-p-bottom--xx-small{\n  padding-block-end:var(--slds-g-spacing-1);\n}\n.slds-p-bottom_x-small,.slds-p-bottom--x-small{\n  padding-block-end:var(--slds-g-spacing-2);\n}\n.slds-p-bottom_small,.slds-p-bottom--small{\n  padding-block-end:var(--slds-g-spacing-3);\n}\n.slds-p-bottom_medium,.slds-p-bottom--medium{\n  padding-block-end:var(--slds-g-spacing-4);\n}\n.slds-p-bottom_large,.slds-p-bottom--large{\n  padding-block-end:var(--slds-g-spacing-5);\n}\n.slds-p-bottom_x-large,.slds-p-bottom--x-large{\n  padding-block-end:var(--slds-g-spacing-6);\n}\n.slds-p-bottom_xx-large,.slds-p-bottom--xx-large{\n  padding-block-end:var(--slds-g-spacing-8);\n}\n.slds-var-p-bottom_xxx-small,.slds-var-p-bottom--xxx-small{\n  padding-block-end:var(--lwc-varSpacingVerticalXxxSmall);\n}\n.slds-var-p-bottom_xx-small,.slds-var-p-bottom--xx-small{\n  padding-block-end:var(--_slds-g-spacing-var-block-1);\n}\n.slds-var-p-bottom_x-small,.slds-var-p-bottom--x-small{\n  padding-block-end:var(--_slds-g-spacing-var-block-2);\n}\n.slds-var-p-bottom_small,.slds-var-p-bottom--small{\n  padding-block-end:var(--_slds-g-spacing-var-block-3);\n}\n.slds-var-p-bottom_medium,.slds-var-p-bottom--medium{\n  padding-block-end:var(--_slds-g-spacing-var-block-5);\n}\n.slds-var-p-bottom_large,.slds-var-p-bottom--large{\n  padding-block-end:var(--_slds-g-spacing-var-block-6);\n}\n.slds-var-p-bottom_x-large,.slds-var-p-bottom--x-large{\n  padding-block-end:var(--_slds-g-spacing-var-block-6);\n}\n.slds-var-p-bottom_xx-large,.slds-var-p-bottom--xx-large{\n  padding-block-end:var(--_slds-g-spacing-var-block-7);\n}\n.slds-p-left_none,.slds-p-left--none{\n  padding-inline-start:0 !important;\n}\n.slds-p-left_xxx-small,.slds-p-left--xxx-small{\n  padding-inline-start:0.125rem;\n}\n.slds-p-left_xx-small,.slds-p-left--xx-small{\n  padding-inline-start:var(--slds-g-spacing-1);\n}\n.slds-p-left_x-small,.slds-p-left--x-small{\n  padding-inline-start:var(--slds-g-spacing-2);\n}\n.slds-p-left_small,.slds-p-left--small{\n  padding-inline-start:var(--slds-g-spacing-3);\n}\n.slds-p-left_medium,.slds-p-left--medium{\n  padding-inline-start:var(--slds-g-spacing-4);\n}\n.slds-p-left_large,.slds-p-left--large{\n  padding-inline-start:var(--slds-g-spacing-5);\n}\n.slds-p-left_x-large,.slds-p-left--x-large{\n  padding-inline-start:var(--slds-g-spacing-6);\n}\n.slds-p-left_xx-large,.slds-p-left--xx-large{\n  padding-inline-start:var(--slds-g-spacing-8);\n}\n.slds-var-p-left_xxx-small,.slds-var-p-left--xxx-small{\n  padding-inline-start:var(--lwc-varSpacingHorizontalXxxSmall);\n}\n.slds-var-p-left_xx-small,.slds-var-p-left--xx-small{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-1);\n}\n.slds-var-p-left_x-small,.slds-var-p-left--x-small{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-2);\n}\n.slds-var-p-left_small,.slds-var-p-left--small{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-3);\n}\n.slds-var-p-left_medium,.slds-var-p-left--medium{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-4);\n}\n.slds-var-p-left_large,.slds-var-p-left--large{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-5);\n}\n.slds-var-p-left_x-large,.slds-var-p-left--x-large{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-6);\n}\n.slds-var-p-left_xx-large,.slds-var-p-left--xx-large{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-7);\n}\n.slds-p-horizontal_none,.slds-p-horizontal--none{\n  padding-inline-start:0 !important;\n  padding-inline-end:0 !important;\n}\n.slds-p-horizontal_xxx-small,.slds-p-horizontal--xxx-small{\n  padding-inline-start:0.125rem;\n  padding-inline-end:0.125rem;\n}\n.slds-p-horizontal_xx-small,.slds-p-horizontal--xx-small{\n  padding-inline-start:var(--slds-g-spacing-1);\n  padding-inline-end:var(--slds-g-spacing-1);\n}\n.slds-p-horizontal_x-small,.slds-p-horizontal--x-small{\n  padding-inline-start:var(--slds-g-spacing-2);\n  padding-inline-end:var(--slds-g-spacing-2);\n}\n.slds-p-horizontal_small,.slds-p-horizontal--small{\n  padding-inline-start:var(--slds-g-spacing-3);\n  padding-inline-end:var(--slds-g-spacing-3);\n}\n.slds-p-horizontal_medium,.slds-p-horizontal--medium{\n  padding-inline-start:var(--slds-g-spacing-4);\n  padding-inline-end:var(--slds-g-spacing-4);\n}\n.slds-p-horizontal_large,.slds-p-horizontal--large{\n  padding-inline-start:var(--slds-g-spacing-5);\n  padding-inline-end:var(--slds-g-spacing-5);\n}\n.slds-p-horizontal_x-large,.slds-p-horizontal--x-large{\n  padding-inline-start:var(--slds-g-spacing-6);\n  padding-inline-end:var(--slds-g-spacing-6);\n}\n.slds-p-horizontal_xx-large,.slds-p-horizontal--xx-large{\n  padding-inline-start:var(--slds-g-spacing-8);\n  padding-inline-end:var(--slds-g-spacing-8);\n}\n.slds-var-p-horizontal_xxx-small,.slds-var-p-horizontal--xxx-small{\n  padding-inline-start:var(--lwc-varSpacingHorizontalXxxSmall);\n  padding-inline-end:var(--lwc-varSpacingHorizontalXxxSmall);\n}\n.slds-var-p-horizontal_xx-small,.slds-var-p-horizontal--xx-small{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-1);\n  padding-inline-end:var(--_slds-g-spacing-var-inline-1);\n}\n.slds-var-p-horizontal_x-small,.slds-var-p-horizontal--x-small{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-2);\n  padding-inline-end:var(--_slds-g-spacing-var-inline-2);\n}\n.slds-var-p-horizontal_small,.slds-var-p-horizontal--small{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-3);\n  padding-inline-end:var(--_slds-g-spacing-var-inline-3);\n}\n.slds-var-p-horizontal_medium,.slds-var-p-horizontal--medium{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-4);\n  padding-inline-end:var(--_slds-g-spacing-var-inline-4);\n}\n.slds-var-p-horizontal_large,.slds-var-p-horizontal--large{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-5);\n  padding-inline-end:var(--_slds-g-spacing-var-inline-5);\n}\n.slds-var-p-horizontal_x-large,.slds-var-p-horizontal--x-large{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-6);\n  padding-inline-end:var(--_slds-g-spacing-var-inline-6);\n}\n.slds-var-p-horizontal_xx-large,.slds-var-p-horizontal--xx-large{\n  padding-inline-start:var(--_slds-g-spacing-var-inline-7);\n  padding-inline-end:var(--_slds-g-spacing-var-inline-7);\n}\n.slds-p-vertical_none,.slds-p-vertical--none{\n  padding-block-start:0 !important;\n  padding-block-end:0 !important;\n}\n.slds-p-vertical_xxx-small,.slds-p-vertical--xxx-small{\n  padding-block-start:0.125rem;\n  padding-block-end:0.125rem;\n}\n.slds-p-vertical_xx-small,.slds-p-vertical--xx-small{\n  padding-block-start:var(--slds-g-spacing-1);\n  padding-block-end:var(--slds-g-spacing-1);\n}\n.slds-p-vertical_x-small,.slds-p-vertical--x-small{\n  padding-block-start:var(--slds-g-spacing-2);\n  padding-block-end:var(--slds-g-spacing-2);\n}\n.slds-p-vertical_small,.slds-p-vertical--small{\n  padding-block-start:var(--slds-g-spacing-3);\n  padding-block-end:var(--slds-g-spacing-3);\n}\n.slds-p-vertical_medium,.slds-p-vertical--medium{\n  padding-block-start:var(--slds-g-spacing-4);\n  padding-block-end:var(--slds-g-spacing-4);\n}\n.slds-p-vertical_large,.slds-p-vertical--large{\n  padding-block-start:var(--slds-g-spacing-5);\n  padding-block-end:var(--slds-g-spacing-5);\n}\n.slds-p-vertical_x-large,.slds-p-vertical--x-large{\n  padding-block-start:var(--slds-g-spacing-6);\n  padding-block-end:var(--slds-g-spacing-6);\n}\n.slds-p-vertical_xx-large,.slds-p-vertical--xx-large{\n  padding-block-start:var(--slds-g-spacing-8);\n  padding-block-end:var(--slds-g-spacing-8);\n}\n.slds-var-p-vertical_xxx-small,.slds-var-p-vertical--xxx-small{\n  padding-block-start:var(--lwc-varSpacingVerticalXxxSmall);\n  padding-block-end:var(--lwc-varSpacingVerticalXxxSmall);\n}\n.slds-var-p-vertical_xx-small,.slds-var-p-vertical--xx-small{\n  padding-block-start:var(--_slds-g-spacing-var-block-1);\n  padding-block-end:var(--_slds-g-spacing-var-block-1);\n}\n.slds-var-p-vertical_x-small,.slds-var-p-vertical--x-small{\n  padding-block-start:var(--_slds-g-spacing-var-block-2);\n  padding-block-end:var(--_slds-g-spacing-var-block-2);\n}\n.slds-var-p-vertical_small,.slds-var-p-vertical--small{\n  padding-block-start:var(--_slds-g-spacing-var-block-3);\n  padding-block-end:var(--_slds-g-spacing-var-block-3);\n}\n.slds-var-p-vertical_medium,.slds-var-p-vertical--medium{\n  padding-block-start:var(--_slds-g-spacing-var-block-4);\n  padding-block-end:var(--_slds-g-spacing-var-block-4);\n}\n.slds-var-p-vertical_large,.slds-var-p-vertical--large{\n  padding-block-start:var(--_slds-g-spacing-var-block-5);\n  padding-block-end:var(--_slds-g-spacing-var-block-5);\n}\n.slds-var-p-vertical_x-large,.slds-var-p-vertical--x-large{\n  padding-block-start:var(--_slds-g-spacing-var-block-6);\n  padding-block-end:var(--_slds-g-spacing-var-block-6);\n}\n.slds-var-p-vertical_xx-large,.slds-var-p-vertical--xx-large{\n  padding-block-start:var(--_slds-g-spacing-var-block-7);\n  padding-block-end:var(--_slds-g-spacing-var-block-7);\n}\n.slds-p-around_none,.slds-p-around--none{\n  padding:0 !important;\n}\n.slds-p-around_xxx-small,.slds-p-around--xxx-small{\n  padding:0.125rem;\n}\n.slds-p-around_xx-small,.slds-p-around--xx-small{\n  padding:var(--slds-g-spacing-1);\n}\n.slds-p-around_x-small,.slds-p-around--x-small{\n  padding:var(--slds-g-spacing-2);\n}\n.slds-p-around_small,.slds-p-around--small{\n  padding:var(--slds-g-spacing-3);\n}\n.slds-p-around_medium,.slds-p-around--medium{\n  padding:var(--slds-g-spacing-4);\n}\n.slds-p-around_large,.slds-p-around--large{\n  padding:var(--slds-g-spacing-5);\n}\n.slds-p-around_x-large,.slds-p-around--x-large{\n  padding:var(--slds-g-spacing-6);\n}\n.slds-p-around_xx-large,.slds-p-around--xx-large{\n  padding:var(--slds-g-spacing-8);\n}\n.slds-var-p-around_xxx-small,.slds-var-p-around--xxx-small{\n  padding:var(--lwc-varSpacingXxxSmall);\n}\n.slds-var-p-around_xx-small,.slds-var-p-around--xx-small{\n  padding:var(--_slds-g-spacing-var-1);\n}\n.slds-var-p-around_x-small,.slds-var-p-around--x-small{\n  padding:var(--_slds-g-spacing-var-2);\n}\n.slds-var-p-around_small,.slds-var-p-around--small{\n  padding:var(--_slds-g-spacing-var-3);\n}\n.slds-var-p-around_medium,.slds-var-p-around--medium{\n  padding:var(--_slds-g-spacing-var-4);\n}\n.slds-var-p-around_large,.slds-var-p-around--large{\n  padding:var(--_slds-g-spacing-var-5);\n}\n.slds-var-p-around_x-large,.slds-var-p-around--x-large{\n  padding:var(--_slds-g-spacing-var-6);\n}\n.slds-var-p-around_xx-large,.slds-var-p-around--xx-large{\n  padding:var(--_slds-g-spacing-var-7);\n}\n.slds-has-cushion{\n  padding:var(--slds-g-spacing-4);\n}\n.slds-clearfix::after{\n  content:'';\n  display:table;\n  clear:both;\n}\n.slds-clear{\n  clear:both;\n}\n.slds-float_left,.slds-float--left{\n  float:inline-start;\n}\n.slds-float_none,.slds-float--none{\n  float:none;\n}\n.slds-float_right,.slds-float--right{\n  float:inline-end;\n}\n.slds-border_bottom,.slds-border--bottom{\n  border-block-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-border_left,.slds-border--left{\n  border-inline-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-border_right,.slds-border--right{\n  border-inline-end:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-border_top,.slds-border--top{\n  border-block-start:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-text-link_reset,.slds-text-link--reset{\n  cursor:pointer;\n  line-height:inherit;\n  font-size:inherit;\n}\n.slds-text-link_reset:active,.slds-text-link--reset:active{\n  outline:none;\n}\n.slds-text-link_reset,.slds-text-link--reset,\n.slds-text-link_reset:active,\n.slds-text-link--reset:active,\n.slds-text-link_reset:focus,\n.slds-text-link--reset:focus,\n.slds-text-link_reset:hover,\n.slds-text-link--reset:hover{\n  color:inherit;\n  text-decoration:inherit;\n}\n.slds-text-link{\n  color:var(--slds-g-color-accent-2);\n  text-decoration:none;\n  transition:color 0.1s linear;\n}\n.slds-text-link:hover,\n.slds-text-link:focus{\n  text-decoration:underline;\n  color:var(--slds-g-color-accent-3);\n}\n.slds-text-link:active{\n  color:var(--slds-g-color-accent-3);\n}\n.slds-text-link_faux,.slds-text-link--faux,\n.slds-type-focus{\n  border-block-end:var(--slds-g-sizing-border-1) solid transparent;\n  border-radius:0;\n  color:currentColor;\n  cursor:pointer;\n}\n.slds-text-link_faux:hover,.slds-text-link--faux:hover,\n.slds-text-link_faux:focus,\n.slds-text-link--faux:focus,\n.slds-type-focus:hover,\n.slds-type-focus:focus{\n  color:currentColor;\n  border-block-end-color:currentColor;\n}\n.slds-has-blur-focus{\n  color:currentColor;\n}\n.slds-has-blur-focus:hover,\n.slds-has-blur-focus:focus,\n.slds-has-blur-focus:active{\n  color:currentColor;\n  text-decoration:none;\n}\n.slds-has-blur-focus:focus{\n  outline:0;\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-has-input-focus{\n  outline:0;\n  border-color:var(--slds-g-color-border-accent-1);\n  background-color:var(--slds-g-color-surface-container-1);\n  box-shadow:var(--slds-s-button-shadow-focus);\n}\n.slds-list_vertical.slds-has-dividers > .slds-list__item,.slds-list--vertical.slds-has-dividers > .slds-list__item{\n  padding:var(--slds-g-spacing-2);\n  border-block-end:1px solid var(--slds-g-color-border-1);\n}\n.slds-list_vertical.slds-has-dividers > .slds-list__item:hover,.slds-list--vertical.slds-has-dividers > .slds-list__item:hover{\n  background-color:var(--slds-g-color-surface-container-2);\n  border-color:var(--slds-g-color-border-1);\n  cursor:pointer;\n}\n.slds-list_vertical.slds-has-dividers > .slds-list__item:active,.slds-list--vertical.slds-has-dividers > .slds-list__item:active{\n  background-color:var(--slds-g-color-surface-container-2);\n  box-shadow:var(--slds-g-color-border-1) 0 -1px 0 inset;\n}\n.slds-list_vertical.slds-has-dividers > .slds-list__item.slds-is-selected,.slds-list--vertical.slds-has-dividers > .slds-list__item.slds-is-selected{\n  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-list_vertical.slds-has-dividers > .slds-list__item.slds-is-selected:hover,.slds-list--vertical.slds-has-dividers > .slds-list__item.slds-is-selected:hover,\n.slds-list_vertical.slds-has-dividers > .slds-list__item.slds-is-selected:focus,\n.slds-list--vertical.slds-has-dividers > .slds-list__item.slds-is-selected:focus{\n  box-shadow:var(--slds-g-color-accent-1) 0 -2px 0 inset, var(--slds-g-color-accent-1) 0 0 0 1px inset;\n}\n.slds-has-cards > .slds-list__item{\n  border:1px solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n  background-clip:padding-box;\n}\n.slds-has-cards > .slds-list__item + .slds-list__item{\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-has-cards_space > .slds-list__item,.slds-has-cards--space > .slds-list__item{\n  border:1px solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n  background-clip:padding-box;\n  padding:var(--slds-g-spacing-3);\n}\n@media (min-width: 30em){\n  .slds-has-cards_space > .slds-list__item,.slds-has-cards--space > .slds-list__item{\n    padding:var(--slds-g-spacing-2);\n  }\n}\n.slds-has-cards_space > .slds-list__item + .slds-list__item,.slds-has-cards--space > .slds-list__item + .slds-list__item{\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-has-divider{\n  margin-block-start:var(--slds-g-spacing-2);\n  padding-block-start:var(--slds-g-spacing-2);\n  border-block-start:1px solid var(--slds-g-color-border-1);\n}\n.slds-has-block-links a{\n  display:block;\n  text-decoration:none;\n}\n.slds-has-block-links .slds-is-nested{\n  margin-inline-start:var(--slds-g-spacing-4);\n}\n.slds-has-block-links_space .slds-list__item,.slds-has-block-links--space .slds-list__item,\n.slds-has-block-links_space .slds-item,\n.slds-has-block-links--space .slds-item{\n  padding:0;\n}\n.slds-has-block-links_space a,.slds-has-block-links--space a{\n  display:block;\n  text-decoration:none;\n  padding:var(--slds-g-spacing-3);\n}\n@media (min-width: 48em){\n  .slds-has-block-links_space a,.slds-has-block-links--space a{\n    padding:var(--slds-g-spacing-2);\n  }\n}\n.slds-has-inline-block-links a{\n  display:inline-block;\n  text-decoration:none;\n}\n.slds-has-inline-block-links_space a,.slds-has-inline-block-links--space a{\n  display:inline-block;\n  text-decoration:none;\n  padding:var(--slds-g-spacing-3);\n}\n@media (min-width: 48em){\n  .slds-has-inline-block-links_space a,.slds-has-inline-block-links--space a{\n    padding:var(--slds-g-spacing-2);\n  }\n}\n.slds-list_vertical-space .slds-list__item + .slds-list__item,.slds-list--vertical-space .slds-list__item + .slds-list__item,\n.slds-list_vertical-space .slds-item + .slds-item,\n.slds-list--vertical-space .slds-item + .slds-item{\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-list_vertical-space-medium .slds-list__item + .slds-list__item,.slds-list--vertical-space-medium .slds-list__item + .slds-list__item,\n.slds-list_vertical-space-medium .slds-item + .slds-item,\n.slds-list--vertical-space-medium .slds-item + .slds-item{\n  margin-block-start:var(--slds-g-spacing-4);\n}\n.slds-is-nested{\n  margin-inline-start:var(--slds-g-spacing-4);\n}\n.slds-list_dotted,.slds-list--dotted{\n  margin-inline-start:var(--slds-g-spacing-5);\n  list-style:disc;\n}\n.slds-list_ordered,.slds-list--ordered{\n  margin-inline-start:var(--slds-g-spacing-5);\n  list-style:decimal;\n}\n.slds-has-dividers_top > .slds-list__item,.slds-has-dividers--top > .slds-list__item,\n.slds-has-dividers_top > .slds-item,\n.slds-has-dividers--top > .slds-item{\n  border-block-start:1px solid var(--slds-g-color-border-1);\n}\n.slds-has-dividers_top-space > .slds-list__item,.slds-has-dividers--top-space > .slds-list__item,\n.slds-has-dividers_top-space > .slds-item,\n.slds-has-dividers--top-space > .slds-item{\n  border-block-start:1px solid var(--slds-g-color-border-1);\n  padding:var(--slds-g-spacing-3);\n}\n@media (min-width: 30em){\n  .slds-has-dividers_top-space > .slds-list__item,.slds-has-dividers--top-space > .slds-list__item,\n  .slds-has-dividers_top-space > .slds-item,\n  .slds-has-dividers--top-space > .slds-item{\n    padding:var(--slds-g-spacing-2);\n  }\n}\n.slds-has-dividers_bottom > .slds-list__item,.slds-has-dividers--bottom > .slds-list__item,\n.slds-has-dividers_bottom > .slds-item,\n.slds-has-dividers--bottom > .slds-item{\n  border-block-end:1px solid var(--slds-g-color-border-1);\n}\n.slds-has-dividers_bottom-space > .slds-list__item,.slds-has-dividers--bottom-space > .slds-list__item,\n.slds-has-dividers_bottom-space > .slds-item,\n.slds-has-dividers--bottom-space > .slds-item{\n  border-block-end:1px solid var(--slds-g-color-border-1);\n  padding:var(--slds-g-spacing-3);\n}\n@media (min-width: 30em){\n  .slds-has-dividers_bottom-space > .slds-list__item,.slds-has-dividers--bottom-space > .slds-list__item,\n  .slds-has-dividers_bottom-space > .slds-item,\n  .slds-has-dividers--bottom-space > .slds-item{\n    padding:var(--slds-g-spacing-2);\n  }\n}\n.slds-has-dividers_around > .slds-item,.slds-has-dividers--around > .slds-item{\n  border:1px solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n  background-clip:padding-box;\n}\n.slds-has-dividers_around > .slds-item + .slds-item,.slds-has-dividers--around > .slds-item + .slds-item{\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-has-dividers_around-space > .slds-item,.slds-has-dividers--around-space > .slds-item{\n  border:1px solid var(--slds-g-color-border-1);\n  border-radius:var(--slds-g-radius-border-2);\n  background-clip:padding-box;\n  padding:var(--slds-g-spacing-3);\n}\n@media (min-width: 30em){\n  .slds-has-dividers_around-space > .slds-item,.slds-has-dividers--around-space > .slds-item{\n    padding:var(--slds-g-spacing-2);\n  }\n}\n.slds-has-dividers_around-space > .slds-item + .slds-item,.slds-has-dividers--around-space > .slds-item + .slds-item{\n  margin-block-start:var(--slds-g-spacing-2);\n}\n.slds-has-list-interactions > .slds-list__item:hover,\n.slds-has-list-interactions > .slds-item:hover{\n  background-color:var(--slds-g-color-surface-container-2);\n  border-color:var(--slds-g-color-border-1);\n  cursor:pointer;\n}\n.slds-has-list-interactions > .slds-list__item:active,\n.slds-has-list-interactions > .slds-item:active{\n  background-color:var(--slds-g-color-surface-container-2);\n  box-shadow:var(--slds-g-color-border-1) 0 -1px 0 inset;\n}\n.slds-has-list-interactions > .slds-list__item.slds-is-selected,\n.slds-has-list-interactions > .slds-item.slds-is-selected{\n  box-shadow:var(--slds-g-color-accent-2) 0 0 0 1px inset;\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-has-list-interactions > .slds-list__item.slds-is-selected:hover,\n.slds-has-list-interactions > .slds-list__item.slds-is-selected:focus,\n.slds-has-list-interactions > .slds-item.slds-is-selected:hover,\n.slds-has-list-interactions > .slds-item.slds-is-selected:focus{\n  box-shadow:var(--slds-g-color-accent-1) 0 -2px 0 inset, var(--slds-g-color-accent-1) 0 0 0 1px inset;\n}\n.slds-has-divider_top,.slds-has-divider--top{\n  border-block-start:1px solid var(--slds-g-color-border-1);\n}\n.slds-has-divider_top-space,.slds-has-divider--top-space{\n  border-block-start:1px solid var(--slds-g-color-border-1);\n  margin-block-start:var(--slds-g-spacing-2);\n  padding-block-start:var(--slds-g-spacing-2);\n}\n.slds-has-divider_right,.slds-has-divider--right{\n  position:relative;\n  display:flex;\n  align-items:center;\n}\n.slds-has-divider_right::after,.slds-has-divider--right::after{\n  height:2px;\n  content:'';\n  margin-inline-start:var(--slds-g-spacing-2);\n  margin-inline-end:var(--slds-g-spacing-2);\n  border-radius:50%;\n  background-color:currentColor;\n}\n.slds-has-divider_right:last-child,.slds-has-divider--right:last-child{\n  margin-inline-end:0;\n  padding-inline-end:0;\n}\n.slds-has-divider_right:last-child::after,.slds-has-divider--right:last-child::after{\n  content:none;\n}\n.slds-has-divider_bottom,.slds-has-divider--bottom{\n  border-block-end:1px solid var(--slds-g-color-border-1);\n}\n.slds-has-divider_bottom-space,.slds-has-divider--bottom-space{\n  border-block-end:1px solid var(--slds-g-color-border-1);\n  margin-block-end:var(--slds-g-spacing-2);\n  padding-block-end:var(--slds-g-spacing-2);\n}\n.slds-has-divider_left,.slds-has-divider--left{\n  position:relative;\n  display:flex;\n  align-items:center;\n}\n.slds-has-divider_left::before,.slds-has-divider--left::before{\n  width:2px;\n  height:2px;\n  content:'';\n  display:inline-block;\n  vertical-align:middle;\n  margin-inline-start:var(--slds-g-spacing-2);\n  margin-inline-end:var(--slds-g-spacing-2);\n  border-radius:50%;\n  background-color:currentColor;\n}\n.slds-has-divider_left:first-child,.slds-has-divider--left:first-child{\n  margin-inline-end:0;\n  padding-inline-end:0;\n}\n.slds-has-divider_left:first-child::before,.slds-has-divider--left:first-child::before{\n  content:none;\n}\n.slds-list_horizontal.slds-has-dividers > .slds-list__item,.slds-list--horizontal.slds-has-dividers > .slds-list__item{\n  position:relative;\n  display:flex;\n  align-items:center;\n}\n.slds-list_horizontal.slds-has-dividers > .slds-list__item::after,.slds-list--horizontal.slds-has-dividers > .slds-list__item::after{\n  width:2px;\n  height:2px;\n  content:'';\n  margin-inline-start:var(--slds-g-spacing-2);\n  margin-inline-end:var(--slds-g-spacing-2);\n  border-radius:50%;\n  background-color:currentColor;\n}\n.slds-list_horizontal.slds-has-dividers > .slds-list__item:last-child,.slds-list--horizontal.slds-has-dividers > .slds-list__item:last-child{\n  margin-inline-end:0;\n  padding-inline-end:0;\n}\n.slds-list_horizontal.slds-has-dividers > .slds-list__item:last-child::after,.slds-list--horizontal.slds-has-dividers > .slds-list__item:last-child::after{\n  content:none;\n}\n.slds-list_horizontal,.slds-list--horizontal{\n  display:flex;\n}\n.slds-list_horizontal > .slds-list__item,.slds-list--horizontal > .slds-list__item{\n  align-self:center;\n}\n.slds-list_horizontal-large > .slds-list__item > a,.slds-list--horizontal-large > .slds-list__item > a,\n.slds-list_horizontal-large > .slds-item > a,\n.slds-list--horizontal-large > .slds-item > a{\n  padding-block:var(--slds-g-spacing-3);\n  padding-inline:var(--slds-g-spacing-4);\n}\n.slds-has-dividers_left > .slds-list__item,.slds-has-dividers--left > .slds-list__item,\n.slds-has-dividers_left > .slds-item,\n.slds-has-dividers--left > .slds-item{\n  position:relative;\n  display:flex;\n  align-items:center;\n}\n.slds-has-dividers_left > .slds-list__item::before,.slds-has-dividers--left > .slds-list__item::before,\n.slds-has-dividers_left > .slds-item::before,\n.slds-has-dividers--left > .slds-item::before{\n  width:2px;\n  height:2px;\n  content:'';\n  display:inline-block;\n  vertical-align:middle;\n  margin-inline-start:var(--slds-g-spacing-2);\n  margin-inline-end:var(--slds-g-spacing-2);\n  border-radius:50%;\n  background-color:currentColor;\n}\n.slds-has-dividers_left > .slds-list__item:first-child,.slds-has-dividers--left > .slds-list__item:first-child,\n.slds-has-dividers_left > .slds-item:first-child,\n.slds-has-dividers--left > .slds-item:first-child{\n  margin-inline-end:0;\n  padding-inline-end:0;\n}\n.slds-has-dividers_left > .slds-list__item:first-child::before,.slds-has-dividers--left > .slds-list__item:first-child::before,\n.slds-has-dividers_left > .slds-item:first-child::before,\n.slds-has-dividers--left > .slds-item:first-child::before{\n  content:none;\n}\n.slds-has-dividers_right > .slds-list__item,.slds-has-dividers--right > .slds-list__item,\n.slds-has-dividers_right > .slds-item,\n.slds-has-dividers--right > .slds-item{\n  position:relative;\n  display:flex;\n  align-items:center;\n}\n.slds-has-dividers_right > .slds-list__item::after,.slds-has-dividers--right > .slds-list__item::after,\n.slds-has-dividers_right > .slds-item::after,\n.slds-has-dividers--right > .slds-item::after{\n  width:2px;\n  height:2px;\n  content:'';\n  margin-inline-start:var(--slds-g-spacing-2);\n  margin-inline-end:var(--slds-g-spacing-2);\n  border-radius:50%;\n  background-color:currentColor;\n}\n.slds-has-dividers_right > .slds-list__item:last-child,.slds-has-dividers--right > .slds-list__item:last-child,\n.slds-has-dividers_right > .slds-item:last-child,\n.slds-has-dividers--right > .slds-item:last-child{\n  margin-inline-end:0;\n  padding-inline-end:0;\n}\n.slds-has-dividers_right > .slds-list__item:last-child::after,.slds-has-dividers--right > .slds-list__item:last-child::after,\n.slds-has-dividers_right > .slds-item:last-child::after,\n.slds-has-dividers--right > .slds-item:last-child::after{\n  content:none;\n}\n.slds-dl_inline::after,.slds-dl--inline::after{\n  content:'';\n  display:table;\n  clear:both;\n}\n@media (min-width: 30em){\n  .slds-dl_inline__label,.slds-dl--inline__label{\n    float:inline-start;\n    clear:inline-start;\n  }\n  .slds-dl_inline__detail,.slds-dl--inline__detail{\n    float:inline-start;\n    padding-inline-start:var(--slds-g-spacing-1);\n  }\n}\n.slds-region_narrow .slds-dl_inline__label,.slds-region--narrow .slds-dl--inline__label,\n.slds-region_narrow .slds-dl_inline__detail,\n.slds-region--narrow .slds-dl--inline__detail{\n  float:inline-start;\n}\n.slds-region_narrow .slds-dl_inline__label,.slds-region--narrow .slds-dl--inline__label{\n  clear:inline-start;\n}\n.slds-region_narrow .slds-dl_inline__detail,.slds-region--narrow .slds-dl--inline__detail{\n  padding-inline-start:var(--slds-g-spacing-1);\n}\n.slds-region_narrow .slds-dl_horizontal,.slds-region--narrow .slds-dl--horizontal{\n  display:flex;\n  flex-wrap:wrap;\n}\n.slds-region_narrow .slds-dl_horizontal .slds-dl_horizontal__label,.slds-region--narrow .slds-dl--horizontal .slds-dl--horizontal__label{\n  width:30%;\n  padding-inline-end:var(--slds-g-spacing-3);\n}\n.slds-region_narrow .slds-dl_horizontal .slds-dl_horizontal__detail,.slds-region--narrow .slds-dl--horizontal .slds-dl--horizontal__detail{\n  width:70%;\n}\n@media (min-width: 30em){\n  .slds-dl_horizontal,.slds-dl--horizontal{\n    display:flex;\n    flex-wrap:wrap;\n  }\n  .slds-dl_horizontal__label,.slds-dl--horizontal__label{\n    width:30%;\n    padding-inline-end:var(--slds-g-spacing-3);\n  }\n  .slds-dl_horizontal__detail,.slds-dl--horizontal__detail{\n    width:70%;\n  }\n}\n.slds-list_horizontal .slds-item_label,.slds-list--horizontal .slds-item--label{\n  width:30%;\n  padding-inline-end:var(--slds-g-spacing-3);\n}\n.slds-list_horizontal .slds-item_detail,.slds-list--horizontal .slds-item--detail{\n  width:70%;\n}\n.slds-list_vertical .slds-item_label,.slds-list--vertical .slds-item--label,\n.slds-list_vertical .slds-item_detail,\n.slds-list--vertical .slds-item--detail{\n  display:block;\n}\n.slds-list_inline,.slds-list--inline{\n  display:inline-flex;\n  max-width:100%;\n}\n.slds-list_inline .slds-item_label,.slds-list--inline .slds-item--label{\n  max-width:180px;\n  padding-inline-end:var(--slds-g-spacing-3);\n  flex-shrink:0;\n}\n.slds-list_inline .slds-item_label ~ .slds-item_label,.slds-list--inline .slds-item--label ~ .slds-item--label{\n  padding-inline-start:var(--slds-g-spacing-4);\n}\n.slds-list_inline .slds-item_detail,.slds-list--inline .slds-item--detail{\n  min-width:0;\n}\n.slds-truncate{\n  max-width:100%;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n}\n.slds-truncate_container_25,.slds-truncate_container--25{\n  max-width:25%;\n}\n.slds-truncate_container_50,.slds-truncate_container--50{\n  max-width:50%;\n}\n.slds-truncate_container_75,.slds-truncate_container--75{\n  max-width:75%;\n}\n.slds-truncate_container_33,.slds-truncate_container--33{\n  max-width:33%;\n}\n.slds-truncate_container_66,.slds-truncate_container--66{\n  max-width:66%;\n}\n.slds-hyphenate{\n  overflow-wrap:break-word;\n  word-wrap:break-word;\n  hyphens:auto;\n}\n.slds-box{\n  padding:var(--slds-g-spacing-4);\n  border-radius:var(--slds-g-radius-border-2);\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-1);\n}\n.slds-box_xx-small,.slds-box--xx-small{\n  padding:var(--slds-g-spacing-1);\n}\n.slds-box_x-small,.slds-box--x-small{\n  padding:var(--slds-g-spacing-2);\n}\n.slds-box_small,.slds-box--small{\n  padding:var(--slds-g-spacing-3);\n}\n.slds-box_link,.slds-box--link,\n.slds-box_link:active,\n.slds-box--link:active,\n.slds-box_link:focus,\n.slds-box--link:focus,\n.slds-box_link:hover,\n.slds-box--link:hover{\n  color:inherit;\n  text-decoration:inherit;\n}\n.slds-box_link:hover,.slds-box--link:hover,\n.slds-box_link:focus,\n.slds-box--link:focus{\n  cursor:pointer;\n  outline:0;\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-accent-2);\n  box-shadow:0 0 0 1px var(--slds-g-color-accent-1) inset;\n}\n.slds-theme_default,.slds-theme--default{\n  background-color:var(--slds-g-color-surface-container-1);\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-theme_shade,.slds-theme--shade{\n  background-color:var(--slds-g-color-surface-container-2);\n}\n.slds-theme_inverse,.slds-theme--inverse{\n  color:var(--slds-g-color-neutral-base-100);\n  background-color:var(--slds-g-color-brand-base-10);\n  border-color:var(--slds-g-color-brand-base-10);\n}\n.slds-theme_inverse a:not(.slds-button_neutral),.slds-theme--inverse a:not(.slds-button--neutral){\n  color:var(--slds-g-color-neutral-base-100);\n  text-decoration:underline;\n}\n.slds-theme_inverse a:not(.slds-button_neutral):link,.slds-theme--inverse a:not(.slds-button--neutral):link,\n.slds-theme_inverse a:not(.slds-button_neutral):visited,\n.slds-theme--inverse a:not(.slds-button--neutral):visited{\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-theme_inverse a:not(.slds-button_neutral):hover,.slds-theme--inverse a:not(.slds-button--neutral):hover,\n.slds-theme_inverse a:not(.slds-button_neutral):focus,\n.slds-theme--inverse a:not(.slds-button--neutral):focus{\n  text-decoration:none;\n}\n.slds-theme_inverse a:not(.slds-button_neutral):active,.slds-theme--inverse a:not(.slds-button--neutral):active{\n  color:rgba(255, 255, 255, 0.5);\n}\n.slds-theme_inverse a:not(.slds-button_neutral)[disabled],.slds-theme--inverse a:not(.slds-button--neutral)[disabled]{\n  color:rgba(255, 255, 255, 0.15);\n}\n.slds-theme_alt-inverse,.slds-theme--alt-inverse{\n  color:var(--slds-g-color-neutral-base-100);\n  background-color:var(--slds-g-color-brand-base-20);\n  border-color:var(--slds-g-color-brand-base-20);\n}\n.slds-theme_alt-inverse a:not(.slds-button_neutral),.slds-theme--alt-inverse a:not(.slds-button--neutral){\n  color:var(--slds-g-color-neutral-base-100);\n  text-decoration:underline;\n}\n.slds-theme_alt-inverse a:not(.slds-button_neutral):link,.slds-theme--alt-inverse a:not(.slds-button--neutral):link,\n.slds-theme_alt-inverse a:not(.slds-button_neutral):visited,\n.slds-theme--alt-inverse a:not(.slds-button--neutral):visited{\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-theme_alt-inverse a:not(.slds-button_neutral):hover,.slds-theme--alt-inverse a:not(.slds-button--neutral):hover,\n.slds-theme_alt-inverse a:not(.slds-button_neutral):focus,\n.slds-theme--alt-inverse a:not(.slds-button--neutral):focus{\n  text-decoration:none;\n}\n.slds-theme_alt-inverse a:not(.slds-button_neutral):active,.slds-theme--alt-inverse a:not(.slds-button--neutral):active{\n  color:rgba(255, 255, 255, 0.5);\n}\n.slds-theme_alt-inverse a:not(.slds-button_neutral)[disabled],.slds-theme--alt-inverse a:not(.slds-button--neutral)[disabled]{\n  color:rgba(255, 255, 255, 0.15);\n}\n.slds-theme_success,.slds-theme--success{\n  color:var(--slds-g-color-on-success-1);\n  background-color:var(--slds-g-color-success-container-1);\n}\n.slds-theme_success a:not(.slds-button_neutral),.slds-theme--success a:not(.slds-button--neutral){\n  color:var(--slds-g-color-on-success-1);\n  text-decoration:underline;\n}\n.slds-theme_success a:not(.slds-button_neutral):link,.slds-theme--success a:not(.slds-button--neutral):link,\n.slds-theme_success a:not(.slds-button_neutral):visited,\n.slds-theme--success a:not(.slds-button--neutral):visited{\n  color:var(--slds-g-color-on-success-1);\n}\n.slds-theme_success a:not(.slds-button_neutral):hover,.slds-theme--success a:not(.slds-button--neutral):hover,\n.slds-theme_success a:not(.slds-button_neutral):focus,\n.slds-theme--success a:not(.slds-button--neutral):focus{\n  text-decoration:none;\n}\n.slds-theme_success a:not(.slds-button_neutral):active,.slds-theme--success a:not(.slds-button--neutral):active{\n  color:var(--slds-g-color-on-success-1);\n}\n.slds-theme_success a:not(.slds-button_neutral)[disabled],.slds-theme--success a:not(.slds-button--neutral)[disabled]{\n  color:rgba(255, 255, 255, 0.15);\n}\n.slds-theme_success .slds-icon,.slds-theme--success .slds-icon,\n.slds-theme_success .slds-button__icon,\n.slds-theme--success .slds-button__icon{\n  fill:var(--slds-g-color-on-success-1);\n}\n.slds-theme_info,.slds-theme--info{\n  color:var(--slds-g-color-on-info-1);\n  background-color:var(--slds-g-color-info-container-1);\n}\n.slds-theme_info a:not(.slds-button_neutral),.slds-theme--info a:not(.slds-button--neutral){\n  color:var(--slds-g-color-on-info-1);\n  text-decoration:underline;\n}\n.slds-theme_info a:not(.slds-button_neutral):link,.slds-theme--info a:not(.slds-button--neutral):link,\n.slds-theme_info a:not(.slds-button_neutral):visited,\n.slds-theme--info a:not(.slds-button--neutral):visited{\n  color:var(--slds-g-color-on-info-1);\n}\n.slds-theme_info a:not(.slds-button_neutral):hover,.slds-theme--info a:not(.slds-button--neutral):hover,\n.slds-theme_info a:not(.slds-button_neutral):focus,\n.slds-theme--info a:not(.slds-button--neutral):focus{\n  text-decoration:none;\n}\n.slds-theme_info a:not(.slds-button_neutral):active,.slds-theme--info a:not(.slds-button--neutral):active{\n  color:var(--slds-g-color-on-info-1);\n}\n.slds-theme_info a:not(.slds-button_neutral)[disabled],.slds-theme--info a:not(.slds-button--neutral)[disabled]{\n  color:rgba(255, 255, 255, 0.15);\n}\n.slds-theme_info .slds-icon,.slds-theme--info .slds-icon,\n.slds-theme_info .slds-button__icon,\n.slds-theme--info .slds-button__icon{\n  fill:var(--slds-g-color-on-info-1);\n}\n.slds-theme_warning,.slds-theme--warning{\n  background-color:var(--slds-g-color-warning-container-1);\n  color:var(--slds-g-color-on-warning-1);\n}\n.slds-theme_warning a,.slds-theme--warning a{\n  color:var(--slds-g-color-on-warning-1);\n  text-decoration:underline;\n}\n.slds-theme_warning a:link,.slds-theme--warning a:link,\n.slds-theme_warning a:visited,\n.slds-theme--warning a:visited{\n  color:var(--slds-g-color-on-warning-1);\n}\n.slds-theme_warning a:hover,.slds-theme--warning a:hover,\n.slds-theme_warning a:focus,\n.slds-theme--warning a:focus{\n  text-decoration:none;\n}\n.slds-theme_warning a:focus-visible,.slds-theme--warning a:focus-visible{\n  box-shadow:var(--slds-s-link-shadow-focus);\n  outline:0;\n}\n.slds-theme_warning a:active,.slds-theme--warning a:active{\n  color:var(--slds-g-color-on-warning-1);\n}\n.slds-theme_warning a[disabled],.slds-theme--warning a[disabled]{\n  color:var(--slds-g-color-neutral-base-30, #514f4d);\n}\n.slds-theme_warning button,.slds-theme--warning button{\n  color:var(--slds-g-color-neutral-base-30, #514f4d);\n  text-decoration:underline;\n}\n.slds-theme_warning button:hover,.slds-theme--warning button:hover{\n  color:var(--slds-g-color-neutral-base-50, #706e6b);\n}\n.slds-theme_warning button:focus,.slds-theme--warning button:focus{\n  color:var(--slds-g-color-neutral-base-30, #514f4d);\n  box-shadow:0 0 3px var(--slds-g-color-neutral-base-30, #514f4d);\n  border:1px solid var(--slds-g-color-neutral-base-30, #514f4d);\n}\n.slds-theme_warning button:active,.slds-theme--warning button:active{\n  color:var(--slds-g-color-neutral-base-50, #706e6b);\n}\n.slds-theme_warning .slds-icon,.slds-theme--warning .slds-icon,\n.slds-theme_warning .slds-button__icon,\n.slds-theme--warning .slds-button__icon{\n  fill:var(--slds-g-color-on-warning-1);\n}\n.slds-theme_error,.slds-theme--error{\n  color:var(--slds-g-color-on-error-1);\n  background-color:var(--slds-g-color-error-container-1);\n}\n.slds-theme_error a:not(.slds-button_neutral),.slds-theme--error a:not(.slds-button--neutral){\n  color:var(--slds-g-color-on-error-1);\n  text-decoration:underline;\n}\n.slds-theme_error a:not(.slds-button_neutral):link,.slds-theme--error a:not(.slds-button--neutral):link,\n.slds-theme_error a:not(.slds-button_neutral):visited,\n.slds-theme--error a:not(.slds-button--neutral):visited{\n  color:var(--slds-g-color-on-error-1);\n}\n.slds-theme_error a:not(.slds-button_neutral):hover,.slds-theme--error a:not(.slds-button--neutral):hover,\n.slds-theme_error a:not(.slds-button_neutral):focus,\n.slds-theme--error a:not(.slds-button--neutral):focus{\n  text-decoration:none;\n}\n.slds-theme_error a:not(.slds-button_neutral):active,.slds-theme--error a:not(.slds-button--neutral):active{\n  color:var(--slds-g-color-on-error-1);\n}\n.slds-theme_error a:not(.slds-button_neutral)[disabled],.slds-theme--error a:not(.slds-button--neutral)[disabled]{\n  color:rgba(255, 255, 255, 0.15);\n}\n.slds-theme_error .slds-icon,.slds-theme--error .slds-icon,\n.slds-theme_error .slds-button__icon,\n.slds-theme--error .slds-button__icon{\n  fill:var(--slds-g-color-on-error-1);\n}\n.slds-theme_offline,.slds-theme--offline{\n  color:var(--slds-g-color-neutral-base-100);\n  background-color:var(--slds-g-color-neutral-base-30);\n}\n.slds-theme_offline a:not(.slds-button_neutral),.slds-theme--offline a:not(.slds-button--neutral){\n  color:var(--slds-g-color-neutral-base-100);\n  text-decoration:underline;\n}\n.slds-theme_offline a:not(.slds-button_neutral):link,.slds-theme--offline a:not(.slds-button--neutral):link,\n.slds-theme_offline a:not(.slds-button_neutral):visited,\n.slds-theme--offline a:not(.slds-button--neutral):visited{\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-theme_offline a:not(.slds-button_neutral):hover,.slds-theme--offline a:not(.slds-button--neutral):hover,\n.slds-theme_offline a:not(.slds-button_neutral):focus,\n.slds-theme--offline a:not(.slds-button--neutral):focus{\n  text-decoration:none;\n}\n.slds-theme_offline a:not(.slds-button_neutral):active,.slds-theme--offline a:not(.slds-button--neutral):active{\n  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 50%);\n}\n.slds-theme_offline a:not(.slds-button_neutral)[disabled],.slds-theme--offline a:not(.slds-button--neutral)[disabled]{\n  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 10%);\n}\n.slds-theme_inverse-text,.slds-theme--inverse-text{\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-theme_inverse-text a:not(.slds-button_neutral),.slds-theme--inverse-text a:not(.slds-button--neutral){\n  color:var(--slds-g-color-neutral-base-100);\n  text-decoration:underline;\n}\n.slds-theme_inverse-text a:not(.slds-button_neutral):link,.slds-theme--inverse-text a:not(.slds-button--neutral):link,\n.slds-theme_inverse-text a:not(.slds-button_neutral):visited,\n.slds-theme--inverse-text a:not(.slds-button--neutral):visited{\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-theme_inverse-text a:not(.slds-button_neutral):hover,.slds-theme--inverse-text a:not(.slds-button--neutral):hover,\n.slds-theme_inverse-text a:not(.slds-button_neutral):focus,\n.slds-theme--inverse-text a:not(.slds-button--neutral):focus{\n  text-decoration:none;\n}\n.slds-theme_inverse-text a:not(.slds-button_neutral):active,.slds-theme--inverse-text a:not(.slds-button--neutral):active{\n  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 50%);\n}\n.slds-theme_inverse-text a:not(.slds-button_neutral)[disabled],.slds-theme--inverse-text a:not(.slds-button--neutral)[disabled]{\n  color:color-mix(in oklab, var(--slds-g-color-neutral-base-100), transparent 15%);\n}\n.slds-dueling-list{\n  display:flex;\n  clear:left;\n}\n.slds-dueling-list__column{\n  display:inline-flex;\n  flex-direction:column;\n}\n.slds-dueling-list__column .slds-button{\n  margin:var(--slds-g-spacing-1);\n}\n.slds-dueling-list__column .slds-button:first-of-type{\n  margin-top:var(--slds-g-spacing-5);\n}\n.slds-dueling-list__column_responsive,.slds-dueling-list__column--responsive{\n  flex:1 1 var(--slds-g-sizing-14);\n  flex-wrap:wrap;\n  overflow:hidden;\n  min-width:6rem;\n}\n.slds-dueling-list__column_responsive .slds-dueling-list__options,.slds-dueling-list__column--responsive .slds-dueling-list__options{\n  width:auto;\n  max-width:100%;\n}\n.slds-dueling-list__options,\n.slds-picklist__options{\n  border:var(--slds-g-sizing-border-1) solid var(--slds-g-color-border-2);\n  border-radius:var(--slds-g-radius-border-2);\n  padding:var(--slds-g-spacing-1) 0;\n  width:var(--slds-g-sizing-14);\n  height:var(--slds-g-sizing-14);\n  background-color:var(--slds-g-color-surface-container-1);\n  overflow:auto;\n}\n.slds-dueling-list__options .slds-is-grabbed,\n.slds-picklist__options .slds-is-grabbed{\n  transform:rotate(3deg);\n}\n.slds-dueling-list__options [aria-selected='true'],\n.slds-picklist__options [aria-selected='true']{\n  background-color:var(--slds-g-color-accent-container-1);\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-dueling-list__options [aria-selected='true']:hover,\n.slds-picklist__options [aria-selected='true']:hover,\n.slds-dueling-list__options [aria-selected='true']:focus,\n.slds-picklist__options [aria-selected='true']:focus{\n  background:var(--slds-g-color-accent-container-3);\n  color:var(--slds-g-color-on-surface-inverse-1);\n}\n.slds-dueling-list__options.slds-is-disabled,\n.slds-picklist__options.slds-is-disabled{\n  background-color:var(--slds-g-color-disabled-container-1, var(--slds-g-color-neutral-base-95));\n  border-color:var(--slds-g-color-border-disabled-1);\n  color:var(--slds-g-color-disabled-2);\n}\n.slds-dueling-list__options.slds-is-disabled:hover,\n.slds-picklist__options.slds-is-disabled:hover{\n  cursor:not-allowed;\n}\n.slds-dueling-list__options.slds-is-disabled .slds-listbox__option:hover,\n.slds-picklist__options.slds-is-disabled .slds-listbox__option:hover{\n  cursor:not-allowed;\n  background-color:transparent;\n}\n.slds-dueling-list__options.slds-is-disabled .slds-listbox__option:focus,\n.slds-picklist__options.slds-is-disabled .slds-listbox__option:focus{\n  background-color:transparent;\n}\n.slds-text-body_regular,.slds-text-body--regular{\n  font-size:var(--slds-g-font-size-base);\n}\n.slds-text-body_small,.slds-text-body--small{\n  font-size:var(--slds-g-font-scale-neg-1);\n}\n.slds-text-heading_large,.slds-text-heading--large{\n  font-size:var(--slds-g-font-scale-6);\n  line-height:var(--slds-g-font-lineheight-2);\n}\n.slds-text-heading_medium,.slds-text-heading--medium{\n  font-size:var(--slds-g-font-scale-4);\n  line-height:var(--slds-g-font-lineheight-2);\n}\n.slds-text-heading_small,.slds-text-heading--small{\n  font-size:var(--slds-g-font-scale-2);\n  line-height:var(--slds-g-font-lineheight-2);\n}\n.slds-text-title{\n  font-size:var(--slds-g-font-scale-neg-1);\n  line-height:var(--slds-g-font-lineheight-2);\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-text-title_caps,.slds-text-title--caps{\n  font-size:var(--slds-g-font-scale-neg-1);\n  color:var(--slds-g-color-on-surface-1);\n  font-weight:var(--slds-g-font-weight-4);\n  text-transform:uppercase;\n  letter-spacing:0.0625rem;\n}\n.slds-text-title_bold,.slds-text-title--bold{\n  font-size:var(--slds-g-font-scale-neg-1);\n  font-weight:var(--slds-g-font-weight-7);\n}\n.slds-line-height_reset,.slds-line-height--reset{\n  line-height:1;\n}\n.slds-text-color_default,.slds-text-color--default{\n  color:var(--slds-g-color-on-surface-3);\n}\n.slds-text-color_weak,.slds-text-color--weak{\n  color:var(--slds-g-color-on-surface-1);\n}\n.slds-text-color_error,.slds-text-color--error{\n  color:var(--slds-g-color-error-1);\n}\n.slds-text-color_destructive,.slds-text-color--destructive{\n  color:var(--slds-g-color-error-1);\n}\n.slds-text-color_success,.slds-text-color--success{\n  color:var(--slds-g-color-success-1);\n}\n.slds-text-color_inverse,.slds-text-color--inverse{\n  color:var(--slds-g-color-neutral-base-100);\n}\n.slds-text-color_inverse-weak,.slds-text-color--inverse-weak{\n  color:var(--slds-g-color-neutral-base-70);\n}\n.slds-text-align_left,.slds-text-align--left{\n  text-align:start;\n}\n.slds-text-align_center,.slds-text-align--center{\n  text-align:center;\n}\n.slds-text-align_right,.slds-text-align--right{\n  text-align:end;\n}\n.slds-text-longform h1,\n.slds-text-longform h2,\n.slds-text-longform h3,\n.slds-text-longform p,\n.slds-text-longform ul,\n.slds-text-longform ol,\n.slds-text-longform dl,\n.slds-text-longform img{\n  margin-block-end:var(--slds-g-spacing-4);\n}\n.slds-text-longform ul{\n  margin-inline-start:var(--slds-g-spacing-5);\n  list-style:disc;\n}\n.slds-text-longform ul ul{\n  list-style:circle;\n}\n.slds-text-longform ul ul ul{\n  list-style:square;\n}\n.slds-text-longform ol{\n  margin-inline-start:var(--slds-g-spacing-5);\n  list-style:decimal;\n}\n.slds-text-longform ol ol{\n  list-style:lower-alpha;\n}\n.slds-text-longform ol ol ol{\n  list-style:lower-roman;\n}\n.slds-text-longform .slds-video{\n  display:block;\n  max-width:100%;\n}\n.slds-text-longform .slds-video.slds-video_center,.slds-text-longform .slds-video.slds-video--center{\n  margin:0 auto;\n}\n.slds-text-longform .slds-video.slds-video_right,.slds-text-longform .slds-video.slds-video--right{\n  margin:0 0 0 auto;\n}\n.slds-text-font_monospace,.slds-text-font--monospace{\n  font-family:var(--slds-g-font-family-monospace);\n}\n.slds-color__text_gray-1,.slds-color__text--gray-1{\n  color:var(--slds-g-color-neutral-base-100) !important;\n}\n.slds-color__text_gray-2,.slds-color__text--gray-2{\n  color:var(--slds-g-color-neutral-base-95) !important;\n}\n.slds-color__text_gray-3,.slds-color__text--gray-3{\n  color:var(--slds-g-color-neutral-base-95) !important;\n}\n.slds-color__text_gray-4,.slds-color__text--gray-4{\n  color:var(--slds-g-color-neutral-base-90) !important;\n}\n.slds-color__text_gray-5,.slds-color__text--gray-5{\n  color:var(--slds-g-color-neutral-base-90) !important;\n}\n.slds-color__text_gray-6,.slds-color__text--gray-6{\n  color:var(--slds-g-color-neutral-base-80) !important;\n}\n.slds-color__text_gray-7,.slds-color__text--gray-7{\n  color:var(--slds-g-color-neutral-base-70) !important;\n}\n.slds-color__text_gray-8,.slds-color__text--gray-8{\n  color:var(--slds-g-color-neutral-base-60) !important;\n}\n.slds-color__text_gray-9,.slds-color__text--gray-9{\n  color:var(--slds-g-color-neutral-base-50) !important;\n}\n.slds-color__text_gray-10,.slds-color__text--gray-10{\n  color:var(--slds-g-color-neutral-base-30) !important;\n}\n.slds-color__text_gray-11,.slds-color__text--gray-11{\n  color:var(--slds-g-color-neutral-base-30) !important;\n}\n.slds-color__text_gray-12,.slds-color__text--gray-12{\n  color:var(--slds-g-color-neutral-base-20) !important;\n}\n.slds-color__background_gray-1,.slds-color__background--gray-1{\n  background-color:var(--slds-g-color-neutral-base-100) !important;\n}\n.slds-color__background_gray-2,.slds-color__background--gray-2{\n  background-color:var(--slds-g-color-neutral-base-95) !important;\n}\n.slds-color__background_gray-3,.slds-color__background--gray-3{\n  background-color:var(--slds-g-color-neutral-base-95) !important;\n}\n.slds-color__background_gray-4,.slds-color__background--gray-4{\n  background-color:var(--slds-g-color-neutral-base-90) !important;\n}\n.slds-color__background_gray-5,.slds-color__background--gray-5{\n  background-color:var(--slds-g-color-neutral-base-90) !important;\n}\n.slds-color__background_gray-6,.slds-color__background--gray-6{\n  background-color:var(--slds-g-color-neutral-base-80) !important;\n}\n.slds-color__background_gray-7,.slds-color__background--gray-7{\n  background-color:var(--slds-g-color-neutral-base-70) !important;\n}\n.slds-color__background_gray-8,.slds-color__background--gray-8{\n  background-color:var(--slds-g-color-neutral-base-60) !important;\n}\n.slds-color__background_gray-9,.slds-color__background--gray-9{\n  background-color:var(--slds-g-color-neutral-base-50) !important;\n}\n.slds-color__background_gray-10,.slds-color__background--gray-10{\n  background-color:var(--slds-g-color-neutral-base-30) !important;\n}\n.slds-color__background_gray-11,.slds-color__background--gray-11{\n  background-color:var(--slds-g-color-neutral-base-30) !important;\n}\n.slds-color__background_gray-12,.slds-color__background--gray-12{\n  background-color:var(--slds-g-color-neutral-base-20) !important;\n}\n.slds-color__border_gray-1,.slds-color__border--gray-1{\n  border-color:var(--slds-g-color-neutral-base-100) !important;\n}\n.slds-color__border_gray-2,.slds-color__border--gray-2{\n  border-color:var(--slds-g-color-neutral-base-95) !important;\n}\n.slds-color__border_gray-3,.slds-color__border--gray-3{\n  border-color:var(--slds-g-color-neutral-base-95) !important;\n}\n.slds-color__border_gray-4,.slds-color__border--gray-4{\n  border-color:var(--slds-g-color-neutral-base-90) !important;\n}\n.slds-color__border_gray-5,.slds-color__border--gray-5{\n  border-color:var(--slds-g-color-neutral-base-90) !important;\n}\n.slds-color__border_gray-6,.slds-color__border--gray-6{\n  border-color:var(--slds-g-color-neutral-base-80) !important;\n}\n.slds-color__border_gray-7,.slds-color__border--gray-7{\n  border-color:var(--slds-g-color-neutral-base-70) !important;\n}\n.slds-color__border_gray-8,.slds-color__border--gray-8{\n  border-color:var(--slds-g-color-neutral-base-60) !important;\n}\n.slds-color__border_gray-9,.slds-color__border--gray-9{\n  border-color:var(--slds-g-color-neutral-base-50) !important;\n}\n.slds-color__border_gray-10,.slds-color__border--gray-10{\n  border-color:var(--slds-g-color-neutral-base-30) !important;\n}\n.slds-color__border_gray-11,.slds-color__border--gray-11{\n  border-color:var(--slds-g-color-neutral-base-30) !important;\n}\n.slds-color__border_gray-12,.slds-color__border--gray-12{\n  border-color:var(--slds-g-color-neutral-base-20) !important;\n}\n.slds-color__fill_gray-1,.slds-color__fill--gray-1{\n  fill:var(--slds-g-color-neutral-base-100) !important;\n}\n.slds-color__fill_gray-2,.slds-color__fill--gray-2{\n  fill:var(--slds-g-color-neutral-base-95) !important;\n}\n.slds-color__fill_gray-3,.slds-color__fill--gray-3{\n  fill:var(--slds-g-color-neutral-base-95) !important;\n}\n.slds-color__fill_gray-4,.slds-color__fill--gray-4{\n  fill:var(--slds-g-color-neutral-base-90) !important;\n}\n.slds-color__fill_gray-5,.slds-color__fill--gray-5{\n  fill:var(--slds-g-color-neutral-base-90) !important;\n}\n.slds-color__fill_gray-6,.slds-color__fill--gray-6{\n  fill:var(--slds-g-color-neutral-base-80) !important;\n}\n.slds-color__fill_gray-7,.slds-color__fill--gray-7{\n  fill:var(--slds-g-color-neutral-base-70) !important;\n}\n.slds-color__fill_gray-8,.slds-color__fill--gray-8{\n  fill:var(--slds-g-color-neutral-base-60) !important;\n}\n.slds-color__fill_gray-9,.slds-color__fill--gray-9{\n  fill:var(--slds-g-color-neutral-base-50) !important;\n}\n.slds-color__fill_gray-10,.slds-color__fill--gray-10{\n  fill:var(--slds-g-color-neutral-base-30) !important;\n}\n.slds-color__fill_gray-11,.slds-color__fill--gray-11{\n  fill:var(--slds-g-color-neutral-base-30) !important;\n}\n.slds-color__fill_gray-12,.slds-color__fill--gray-12{\n  fill:var(--slds-g-color-neutral-base-20) !important;\n}\n.slds-scrollable{\n  -webkit-overflow-scrolling:touch;\n  overflow:auto;\n}\n.slds-scrollable_none,.slds-scrollable--none{\n  overflow:hidden;\n}\n.slds-scrollable_y,.slds-scrollable--y{\n  -webkit-overflow-scrolling:touch;\n  max-height:100%;\n  overflow:hidden;\n  overflow-y:auto;\n}\n.slds-scrollable_x,.slds-scrollable--x{\n  -webkit-overflow-scrolling:touch;\n  max-width:100%;\n  overflow:hidden;\n  overflow-x:auto;\n}\n.slds-size_xxx-small,.slds-size--xxx-small{\n  width:3rem;\n}\n.slds-size_xx-small,.slds-size--xx-small{\n  width:6rem;\n}\n.slds-size_x-small,.slds-size--x-small{\n  width:12rem;\n}\n.slds-size_small,.slds-size--small{\n  width:15rem;\n}\n.slds-size_medium,.slds-size--medium{\n  width:20rem;\n}\n.slds-size_large,.slds-size--large{\n  width:25rem;\n}\n.slds-size_x-large,.slds-size--x-large{\n  width:40rem;\n}\n.slds-size_xx-large,.slds-size--xx-large{\n  width:60rem;\n}\n.slds-size_full,.slds-size--full{\n  width:100%;\n}\n.slds-size_1-of-1,.slds-size--1-of-1{\n  width:100%;\n}\n.slds-size_1-of-2,.slds-size--1-of-2{\n  width:50%;\n}\n.slds-size_2-of-2,.slds-size--2-of-2{\n  width:100%;\n}\n.slds-size_1-of-3,.slds-size--1-of-3{\n  width:33.333%;\n}\n.slds-size_2-of-3,.slds-size--2-of-3{\n  width:66.6667%;\n}\n.slds-size_3-of-3,.slds-size--3-of-3{\n  width:100%;\n}\n.slds-size_1-of-4,.slds-size--1-of-4{\n  width:25%;\n}\n.slds-size_2-of-4,.slds-size--2-of-4{\n  width:50%;\n}\n.slds-size_3-of-4,.slds-size--3-of-4{\n  width:75%;\n}\n.slds-size_4-of-4,.slds-size--4-of-4{\n  width:100%;\n}\n.slds-size_1-of-5,.slds-size--1-of-5{\n  width:20%;\n}\n.slds-size_2-of-5,.slds-size--2-of-5{\n  width:40%;\n}\n.slds-size_3-of-5,.slds-size--3-of-5{\n  width:60%;\n}\n.slds-size_4-of-5,.slds-size--4-of-5{\n  width:80%;\n}\n.slds-size_5-of-5,.slds-size--5-of-5{\n  width:100%;\n}\n.slds-size_1-of-6,.slds-size--1-of-6{\n  width:16.6667%;\n}\n.slds-size_2-of-6,.slds-size--2-of-6{\n  width:33.333%;\n}\n.slds-size_3-of-6,.slds-size--3-of-6{\n  width:50%;\n}\n.slds-size_4-of-6,.slds-size--4-of-6{\n  width:66.6667%;\n}\n.slds-size_5-of-6,.slds-size--5-of-6{\n  width:83.3333%;\n}\n.slds-size_6-of-6,.slds-size--6-of-6{\n  width:100%;\n}\n.slds-size_1-of-7,.slds-size--1-of-7{\n  width:14.2857%;\n}\n.slds-size_2-of-7,.slds-size--2-of-7{\n  width:28.5714%;\n}\n.slds-size_3-of-7,.slds-size--3-of-7{\n  width:42.8571%;\n}\n.slds-size_4-of-7,.slds-size--4-of-7{\n  width:57.1429%;\n}\n.slds-size_5-of-7,.slds-size--5-of-7{\n  width:71.4286%;\n}\n.slds-size_6-of-7,.slds-size--6-of-7{\n  width:85.7143%;\n}\n.slds-size_7-of-7,.slds-size--7-of-7{\n  width:100%;\n}\n.slds-size_1-of-8,.slds-size--1-of-8{\n  width:12.5%;\n}\n.slds-size_2-of-8,.slds-size--2-of-8{\n  width:25%;\n}\n.slds-size_3-of-8,.slds-size--3-of-8{\n  width:37.5%;\n}\n.slds-size_4-of-8,.slds-size--4-of-8{\n  width:50%;\n}\n.slds-size_5-of-8,.slds-size--5-of-8{\n  width:62.5%;\n}\n.slds-size_6-of-8,.slds-size--6-of-8{\n  width:75%;\n}\n.slds-size_7-of-8,.slds-size--7-of-8{\n  width:87.5%;\n}\n.slds-size_8-of-8,.slds-size--8-of-8{\n  width:100%;\n}\n.slds-size_1-of-12,.slds-size--1-of-12{\n  width:8.3333%;\n}\n.slds-size_2-of-12,.slds-size--2-of-12{\n  width:16.6667%;\n}\n.slds-size_3-of-12,.slds-size--3-of-12{\n  width:25%;\n}\n.slds-size_4-of-12,.slds-size--4-of-12{\n  width:33.333%;\n}\n.slds-size_5-of-12,.slds-size--5-of-12{\n  width:41.6667%;\n}\n.slds-size_6-of-12,.slds-size--6-of-12{\n  width:50%;\n}\n.slds-size_7-of-12,.slds-size--7-of-12{\n  width:58.3333%;\n}\n.slds-size_8-of-12,.slds-size--8-of-12{\n  width:66.6667%;\n}\n.slds-size_9-of-12,.slds-size--9-of-12{\n  width:75%;\n}\n.slds-size_10-of-12,.slds-size--10-of-12{\n  width:83.3333%;\n}\n.slds-size_11-of-12,.slds-size--11-of-12{\n  width:91.6667%;\n}\n.slds-size_12-of-12,.slds-size--12-of-12{\n  width:100%;\n}\n.slds-order_1,.slds-order--1{\n  -webkit-box-ordinal-group:2;\n  -ms-flex-order:1;\n  order:1;\n}\n.slds-order_2,.slds-order--2{\n  -webkit-box-ordinal-group:3;\n  -ms-flex-order:2;\n  order:2;\n}\n.slds-order_3,.slds-order--3{\n  -webkit-box-ordinal-group:4;\n  -ms-flex-order:3;\n  order:3;\n}\n.slds-order_4,.slds-order--4{\n  -webkit-box-ordinal-group:5;\n  -ms-flex-order:4;\n  order:4;\n}\n.slds-order_5,.slds-order--5{\n  -webkit-box-ordinal-group:6;\n  -ms-flex-order:5;\n  order:5;\n}\n.slds-order_6,.slds-order--6{\n  -webkit-box-ordinal-group:7;\n  -ms-flex-order:6;\n  order:6;\n}\n.slds-order_7,.slds-order--7{\n  -webkit-box-ordinal-group:8;\n  -ms-flex-order:7;\n  order:7;\n}\n.slds-order_8,.slds-order--8{\n  -webkit-box-ordinal-group:9;\n  -ms-flex-order:8;\n  order:8;\n}\n.slds-order_9,.slds-order--9{\n  -webkit-box-ordinal-group:10;\n  -ms-flex-order:9;\n  order:9;\n}\n.slds-order_10,.slds-order--10{\n  -webkit-box-ordinal-group:11;\n  -ms-flex-order:10;\n  order:10;\n}\n.slds-order_11,.slds-order--11{\n  -webkit-box-ordinal-group:12;\n  -ms-flex-order:11;\n  order:11;\n}\n.slds-order_12,.slds-order--12{\n  -webkit-box-ordinal-group:13;\n  -ms-flex-order:12;\n  order:12;\n}\n@media (min-width: 20em){\n  .slds-x-small-size_xxx-small,.slds-x-small-size--xxx-small,\n  .slds-x-small-size_xx-small,\n  .slds-x-small-size--xx-small,\n  .slds-x-small-size_x-small,\n  .slds-x-small-size--x-small,\n  .slds-x-small-size_small,\n  .slds-x-small-size--small,\n  .slds-x-small-size_medium,\n  .slds-x-small-size--medium,\n  .slds-x-small-size_large,\n  .slds-x-small-size--large,\n  .slds-x-small-size_x-large,\n  .slds-x-small-size--x-large,\n  .slds-x-small-size_xx-large,\n  .slds-x-small-size--xx-large,\n  .slds-x-small-size_1-of-1,\n  .slds-x-small-size--1-of-1,\n  .slds-x-small-size_1-of-2,\n  .slds-x-small-size--1-of-2,\n  .slds-x-small-size_2-of-2,\n  .slds-x-small-size--2-of-2,\n  .slds-x-small-size_1-of-3,\n  .slds-x-small-size--1-of-3,\n  .slds-x-small-size_2-of-3,\n  .slds-x-small-size--2-of-3,\n  .slds-x-small-size_3-of-3,\n  .slds-x-small-size--3-of-3,\n  .slds-x-small-size_1-of-4,\n  .slds-x-small-size--1-of-4,\n  .slds-x-small-size_2-of-4,\n  .slds-x-small-size--2-of-4,\n  .slds-x-small-size_3-of-4,\n  .slds-x-small-size--3-of-4,\n  .slds-x-small-size_4-of-4,\n  .slds-x-small-size--4-of-4,\n  .slds-x-small-size_1-of-5,\n  .slds-x-small-size--1-of-5,\n  .slds-x-small-size_2-of-5,\n  .slds-x-small-size--2-of-5,\n  .slds-x-small-size_3-of-5,\n  .slds-x-small-size--3-of-5,\n  .slds-x-small-size_4-of-5,\n  .slds-x-small-size--4-of-5,\n  .slds-x-small-size_5-of-5,\n  .slds-x-small-size--5-of-5,\n  .slds-x-small-size_1-of-6,\n  .slds-x-small-size--1-of-6,\n  .slds-x-small-size_2-of-6,\n  .slds-x-small-size--2-of-6,\n  .slds-x-small-size_3-of-6,\n  .slds-x-small-size--3-of-6,\n  .slds-x-small-size_4-of-6,\n  .slds-x-small-size--4-of-6,\n  .slds-x-small-size_5-of-6,\n  .slds-x-small-size--5-of-6,\n  .slds-x-small-size_6-of-6,\n  .slds-x-small-size--6-of-6,\n  .slds-x-small-size_1-of-7,\n  .slds-x-small-size--1-of-7,\n  .slds-x-small-size_2-of-7,\n  .slds-x-small-size--2-of-7,\n  .slds-x-small-size_3-of-7,\n  .slds-x-small-size--3-of-7,\n  .slds-x-small-size_4-of-7,\n  .slds-x-small-size--4-of-7,\n  .slds-x-small-size_5-of-7,\n  .slds-x-small-size--5-of-7,\n  .slds-x-small-size_6-of-7,\n  .slds-x-small-size--6-of-7,\n  .slds-x-small-size_7-of-7,\n  .slds-x-small-size--7-of-7,\n  .slds-x-small-size_1-of-8,\n  .slds-x-small-size--1-of-8,\n  .slds-x-small-size_2-of-8,\n  .slds-x-small-size--2-of-8,\n  .slds-x-small-size_3-of-8,\n  .slds-x-small-size--3-of-8,\n  .slds-x-small-size_4-of-8,\n  .slds-x-small-size--4-of-8,\n  .slds-x-small-size_5-of-8,\n  .slds-x-small-size--5-of-8,\n  .slds-x-small-size_6-of-8,\n  .slds-x-small-size--6-of-8,\n  .slds-x-small-size_7-of-8,\n  .slds-x-small-size--7-of-8,\n  .slds-x-small-size_8-of-8,\n  .slds-x-small-size--8-of-8,\n  .slds-x-small-size_1-of-12,\n  .slds-x-small-size--1-of-12,\n  .slds-x-small-size_2-of-12,\n  .slds-x-small-size--2-of-12,\n  .slds-x-small-size_3-of-12,\n  .slds-x-small-size--3-of-12,\n  .slds-x-small-size_4-of-12,\n  .slds-x-small-size--4-of-12,\n  .slds-x-small-size_5-of-12,\n  .slds-x-small-size--5-of-12,\n  .slds-x-small-size_6-of-12,\n  .slds-x-small-size--6-of-12,\n  .slds-x-small-size_7-of-12,\n  .slds-x-small-size--7-of-12,\n  .slds-x-small-size_8-of-12,\n  .slds-x-small-size--8-of-12,\n  .slds-x-small-size_9-of-12,\n  .slds-x-small-size--9-of-12,\n  .slds-x-small-size_10-of-12,\n  .slds-x-small-size--10-of-12,\n  .slds-x-small-size_11-of-12,\n  .slds-x-small-size--11-of-12,\n  .slds-x-small-size_12-of-12,\n  .slds-x-small-size--12-of-12{\n    flex:none;\n  }\n\n  .slds-x-small-size_xxx-small,.slds-x-small-size--xxx-small{\n    width:3rem;\n  }\n\n  .slds-x-small-size_xx-small,.slds-x-small-size--xx-small{\n    width:6rem;\n  }\n\n  .slds-x-small-size_x-small,.slds-x-small-size--x-small{\n    width:12rem;\n  }\n\n  .slds-x-small-size_small,.slds-x-small-size--small{\n    width:15rem;\n  }\n\n  .slds-x-small-size_medium,.slds-x-small-size--medium{\n    width:20rem;\n  }\n\n  .slds-x-small-size_large,.slds-x-small-size--large{\n    width:25rem;\n  }\n\n  .slds-x-small-size_x-large,.slds-x-small-size--x-large{\n    width:40rem;\n  }\n\n  .slds-x-small-size_xx-large,.slds-x-small-size--xx-large{\n    width:60rem;\n  }\n\n  .slds-x-small-size_1-of-1,.slds-x-small-size--1-of-1{\n    width:100%;\n  }\n\n  .slds-x-small-size_1-of-2,.slds-x-small-size--1-of-2{\n    width:50%;\n  }\n\n  .slds-x-small-size_2-of-2,.slds-x-small-size--2-of-2{\n    width:100%;\n  }\n\n  .slds-x-small-size_1-of-3,.slds-x-small-size--1-of-3{\n    width:33.333%;\n  }\n\n  .slds-x-small-size_2-of-3,.slds-x-small-size--2-of-3{\n    width:66.6667%;\n  }\n\n  .slds-x-small-size_3-of-3,.slds-x-small-size--3-of-3{\n    width:100%;\n  }\n\n  .slds-x-small-size_1-of-4,.slds-x-small-size--1-of-4{\n    width:25%;\n  }\n\n  .slds-x-small-size_2-of-4,.slds-x-small-size--2-of-4{\n    width:50%;\n  }\n\n  .slds-x-small-size_3-of-4,.slds-x-small-size--3-of-4{\n    width:75%;\n  }\n\n  .slds-x-small-size_4-of-4,.slds-x-small-size--4-of-4{\n    width:100%;\n  }\n\n  .slds-x-small-size_1-of-5,.slds-x-small-size--1-of-5{\n    width:20%;\n  }\n\n  .slds-x-small-size_2-of-5,.slds-x-small-size--2-of-5{\n    width:40%;\n  }\n\n  .slds-x-small-size_3-of-5,.slds-x-small-size--3-of-5{\n    width:60%;\n  }\n\n  .slds-x-small-size_4-of-5,.slds-x-small-size--4-of-5{\n    width:80%;\n  }\n\n  .slds-x-small-size_5-of-5,.slds-x-small-size--5-of-5{\n    width:100%;\n  }\n\n  .slds-x-small-size_1-of-6,.slds-x-small-size--1-of-6{\n    width:16.6667%;\n  }\n\n  .slds-x-small-size_2-of-6,.slds-x-small-size--2-of-6{\n    width:33.333%;\n  }\n\n  .slds-x-small-size_3-of-6,.slds-x-small-size--3-of-6{\n    width:50%;\n  }\n\n  .slds-x-small-size_4-of-6,.slds-x-small-size--4-of-6{\n    width:66.6667%;\n  }\n\n  .slds-x-small-size_5-of-6,.slds-x-small-size--5-of-6{\n    width:83.3333%;\n  }\n\n  .slds-x-small-size_6-of-6,.slds-x-small-size--6-of-6{\n    width:100%;\n  }\n\n  .slds-x-small-size_1-of-7,.slds-x-small-size--1-of-7{\n    width:14.2857%;\n  }\n\n  .slds-x-small-size_2-of-7,.slds-x-small-size--2-of-7{\n    width:28.5714%;\n  }\n\n  .slds-x-small-size_3-of-7,.slds-x-small-size--3-of-7{\n    width:42.8571%;\n  }\n\n  .slds-x-small-size_4-of-7,.slds-x-small-size--4-of-7{\n    width:57.1429%;\n  }\n\n  .slds-x-small-size_5-of-7,.slds-x-small-size--5-of-7{\n    width:71.4286%;\n  }\n\n  .slds-x-small-size_6-of-7,.slds-x-small-size--6-of-7{\n    width:85.7143%;\n  }\n\n  .slds-x-small-size_7-of-7,.slds-x-small-size--7-of-7{\n    width:100%;\n  }\n\n  .slds-x-small-size_1-of-8,.slds-x-small-size--1-of-8{\n    width:12.5%;\n  }\n\n  .slds-x-small-size_2-of-8,.slds-x-small-size--2-of-8{\n    width:25%;\n  }\n\n  .slds-x-small-size_3-of-8,.slds-x-small-size--3-of-8{\n    width:37.5%;\n  }\n\n  .slds-x-small-size_4-of-8,.slds-x-small-size--4-of-8{\n    width:50%;\n  }\n\n  .slds-x-small-size_5-of-8,.slds-x-small-size--5-of-8{\n    width:62.5%;\n  }\n\n  .slds-x-small-size_6-of-8,.slds-x-small-size--6-of-8{\n    width:75%;\n  }\n\n  .slds-x-small-size_7-of-8,.slds-x-small-size--7-of-8{\n    width:87.5%;\n  }\n\n  .slds-x-small-size_8-of-8,.slds-x-small-size--8-of-8{\n    width:100%;\n  }\n\n  .slds-x-small-size_1-of-12,.slds-x-small-size--1-of-12{\n    width:8.3333%;\n  }\n\n  .slds-x-small-size_2-of-12,.slds-x-small-size--2-of-12{\n    width:16.6667%;\n  }\n\n  .slds-x-small-size_3-of-12,.slds-x-small-size--3-of-12{\n    width:25%;\n  }\n\n  .slds-x-small-size_4-of-12,.slds-x-small-size--4-of-12{\n    width:33.333%;\n  }\n\n  .slds-x-small-size_5-of-12,.slds-x-small-size--5-of-12{\n    width:41.6667%;\n  }\n\n  .slds-x-small-size_6-of-12,.slds-x-small-size--6-of-12{\n    width:50%;\n  }\n\n  .slds-x-small-size_7-of-12,.slds-x-small-size--7-of-12{\n    width:58.3333%;\n  }\n\n  .slds-x-small-size_8-of-12,.slds-x-small-size--8-of-12{\n    width:66.6667%;\n  }\n\n  .slds-x-small-size_9-of-12,.slds-x-small-size--9-of-12{\n    width:75%;\n  }\n\n  .slds-x-small-size_10-of-12,.slds-x-small-size--10-of-12{\n    width:83.3333%;\n  }\n\n  .slds-x-small-size_11-of-12,.slds-x-small-size--11-of-12{\n    width:91.6667%;\n  }\n\n  .slds-x-small-size_12-of-12,.slds-x-small-size--12-of-12{\n    width:100%;\n  }\n\n  .slds-x-small-order_1,.slds-x-small-order--1{\n    order:1;\n  }\n\n  .slds-x-small-order_2,.slds-x-small-order--2{\n    order:2;\n  }\n\n  .slds-x-small-order_3,.slds-x-small-order--3{\n    order:3;\n  }\n\n  .slds-x-small-order_4,.slds-x-small-order--4{\n    order:4;\n  }\n\n  .slds-x-small-order_5,.slds-x-small-order--5{\n    order:5;\n  }\n\n  .slds-x-small-order_6,.slds-x-small-order--6{\n    order:6;\n  }\n\n  .slds-x-small-order_7,.slds-x-small-order--7{\n    order:7;\n  }\n\n  .slds-x-small-order_8,.slds-x-small-order--8{\n    order:8;\n  }\n\n  .slds-x-small-order_9,.slds-x-small-order--9{\n    order:9;\n  }\n\n  .slds-x-small-order_10,.slds-x-small-order--10{\n    order:10;\n  }\n\n  .slds-x-small-order_11,.slds-x-small-order--11{\n    order:11;\n  }\n\n  .slds-x-small-order_12,.slds-x-small-order--12{\n    order:12;\n  }\n}\n@media (max-width: 20em){\n  .slds-max-x-small-size_xxx-small,.slds-max-x-small-size--xxx-small,\n  .slds-max-x-small-size_xx-small,\n  .slds-max-x-small-size--xx-small,\n  .slds-max-x-small-size_x-small,\n  .slds-max-x-small-size--x-small,\n  .slds-max-x-small-size_small,\n  .slds-max-x-small-size--small,\n  .slds-max-x-small-size_medium,\n  .slds-max-x-small-size--medium,\n  .slds-max-x-small-size_large,\n  .slds-max-x-small-size--large,\n  .slds-max-x-small-size_x-large,\n  .slds-max-x-small-size--x-large,\n  .slds-max-x-small-size_xx-large,\n  .slds-max-x-small-size--xx-large{\n    flex:none;\n  }\n\n  .slds-max-x-small-size_xxx-small,.slds-max-x-small-size--xxx-small{\n    width:3rem;\n  }\n\n  .slds-max-x-small-size_xx-small,.slds-max-x-small-size--xx-small{\n    width:6rem;\n  }\n\n  .slds-max-x-small-size_x-small,.slds-max-x-small-size--x-small{\n    width:12rem;\n  }\n\n  .slds-max-x-small-size_small,.slds-max-x-small-size--small{\n    width:15rem;\n  }\n\n  .slds-max-x-small-size_medium,.slds-max-x-small-size--medium{\n    width:20rem;\n  }\n\n  .slds-max-x-small-size_large,.slds-max-x-small-size--large{\n    width:25rem;\n  }\n\n  .slds-max-x-small-size_x-large,.slds-max-x-small-size--x-large{\n    width:40rem;\n  }\n\n  .slds-max-x-small-size_xx-large,.slds-max-x-small-size--xx-large{\n    width:60rem;\n  }\n\n  .slds-max-x-small-size_1-of-1,.slds-max-x-small-size--1-of-1{\n    width:100%;\n  }\n\n  .slds-max-x-small-size_1-of-2,.slds-max-x-small-size--1-of-2{\n    width:50%;\n  }\n\n  .slds-max-x-small-size_2-of-2,.slds-max-x-small-size--2-of-2{\n    width:100%;\n  }\n\n  .slds-max-x-small-size_1-of-3,.slds-max-x-small-size--1-of-3{\n    width:33.333%;\n  }\n\n  .slds-max-x-small-size_2-of-3,.slds-max-x-small-size--2-of-3{\n    width:66.6667%;\n  }\n\n  .slds-max-x-small-size_3-of-3,.slds-max-x-small-size--3-of-3{\n    width:100%;\n  }\n\n  .slds-max-x-small-size_1-of-4,.slds-max-x-small-size--1-of-4{\n    width:25%;\n  }\n\n  .slds-max-x-small-size_2-of-4,.slds-max-x-small-size--2-of-4{\n    width:50%;\n  }\n\n  .slds-max-x-small-size_3-of-4,.slds-max-x-small-size--3-of-4{\n    width:75%;\n  }\n\n  .slds-max-x-small-size_4-of-4,.slds-max-x-small-size--4-of-4{\n    width:100%;\n  }\n\n  .slds-max-x-small-size_1-of-5,.slds-max-x-small-size--1-of-5{\n    width:20%;\n  }\n\n  .slds-max-x-small-size_2-of-5,.slds-max-x-small-size--2-of-5{\n    width:40%;\n  }\n\n  .slds-max-x-small-size_3-of-5,.slds-max-x-small-size--3-of-5{\n    width:60%;\n  }\n\n  .slds-max-x-small-size_4-of-5,.slds-max-x-small-size--4-of-5{\n    width:80%;\n  }\n\n  .slds-max-x-small-size_5-of-5,.slds-max-x-small-size--5-of-5{\n    width:100%;\n  }\n\n  .slds-max-x-small-size_1-of-6,.slds-max-x-small-size--1-of-6{\n    width:16.6667%;\n  }\n\n  .slds-max-x-small-size_2-of-6,.slds-max-x-small-size--2-of-6{\n    width:33.333%;\n  }\n\n  .slds-max-x-small-size_3-of-6,.slds-max-x-small-size--3-of-6{\n    width:50%;\n  }\n\n  .slds-max-x-small-size_4-of-6,.slds-max-x-small-size--4-of-6{\n    width:66.6667%;\n  }\n\n  .slds-max-x-small-size_5-of-6,.slds-max-x-small-size--5-of-6{\n    width:83.3333%;\n  }\n\n  .slds-max-x-small-size_6-of-6,.slds-max-x-small-size--6-of-6{\n    width:100%;\n  }\n\n  .slds-max-x-small-size_1-of-7,.slds-max-x-small-size--1-of-7{\n    width:14.2857%;\n  }\n\n  .slds-max-x-small-size_2-of-7,.slds-max-x-small-size--2-of-7{\n    width:28.5714%;\n  }\n\n  .slds-max-x-small-size_3-of-7,.slds-max-x-small-size--3-of-7{\n    width:42.8571%;\n  }\n\n  .slds-max-x-small-size_4-of-7,.slds-max-x-small-size--4-of-7{\n    width:57.1429%;\n  }\n\n  .slds-max-x-small-size_5-of-7,.slds-max-x-small-size--5-of-7{\n    width:71.4286%;\n  }\n\n  .slds-max-x-small-size_6-of-7,.slds-max-x-small-size--6-of-7{\n    width:85.7143%;\n  }\n\n  .slds-max-x-small-size_7-of-7,.slds-max-x-small-size--7-of-7{\n    width:100%;\n  }\n\n  .slds-max-x-small-size_1-of-8,.slds-max-x-small-size--1-of-8{\n    width:12.5%;\n  }\n\n  .slds-max-x-small-size_2-of-8,.slds-max-x-small-size--2-of-8{\n    width:25%;\n  }\n\n  .slds-max-x-small-size_3-of-8,.slds-max-x-small-size--3-of-8{\n    width:37.5%;\n  }\n\n  .slds-max-x-small-size_4-of-8,.slds-max-x-small-size--4-of-8{\n    width:50%;\n  }\n\n  .slds-max-x-small-size_5-of-8,.slds-max-x-small-size--5-of-8{\n    width:62.5%;\n  }\n\n  .slds-max-x-small-size_6-of-8,.slds-max-x-small-size--6-of-8{\n    width:75%;\n  }\n\n  .slds-max-x-small-size_7-of-8,.slds-max-x-small-size--7-of-8{\n    width:87.5%;\n  }\n\n  .slds-max-x-small-size_8-of-8,.slds-max-x-small-size--8-of-8{\n    width:100%;\n  }\n\n  .slds-max-x-small-size_1-of-12,.slds-max-x-small-size--1-of-12{\n    width:8.3333%;\n  }\n\n  .slds-max-x-small-size_2-of-12,.slds-max-x-small-size--2-of-12{\n    width:16.6667%;\n  }\n\n  .slds-max-x-small-size_3-of-12,.slds-max-x-small-size--3-of-12{\n    width:25%;\n  }\n\n  .slds-max-x-small-size_4-of-12,.slds-max-x-small-size--4-of-12{\n    width:33.333%;\n  }\n\n  .slds-max-x-small-size_5-of-12,.slds-max-x-small-size--5-of-12{\n    width:41.6667%;\n  }\n\n  .slds-max-x-small-size_6-of-12,.slds-max-x-small-size--6-of-12{\n    width:50%;\n  }\n\n  .slds-max-x-small-size_7-of-12,.slds-max-x-small-size--7-of-12{\n    width:58.3333%;\n  }\n\n  .slds-max-x-small-size_8-of-12,.slds-max-x-small-size--8-of-12{\n    width:66.6667%;\n  }\n\n  .slds-max-x-small-size_9-of-12,.slds-max-x-small-size--9-of-12{\n    width:75%;\n  }\n\n  .slds-max-x-small-size_10-of-12,.slds-max-x-small-size--10-of-12{\n    width:83.3333%;\n  }\n\n  .slds-max-x-small-size_11-of-12,.slds-max-x-small-size--11-of-12{\n    width:91.6667%;\n  }\n\n  .slds-max-x-small-size_12-of-12,.slds-max-x-small-size--12-of-12{\n    width:100%;\n  }\n\n  .slds-max-x-small-order_1,.slds-max-x-small-order--1{\n    order:1;\n  }\n\n  .slds-max-x-small-order_2,.slds-max-x-small-order--2{\n    order:2;\n  }\n\n  .slds-max-x-small-order_3,.slds-max-x-small-order--3{\n    order:3;\n  }\n\n  .slds-max-x-small-order_4,.slds-max-x-small-order--4{\n    order:4;\n  }\n\n  .slds-max-x-small-order_5,.slds-max-x-small-order--5{\n    order:5;\n  }\n\n  .slds-max-x-small-order_6,.slds-max-x-small-order--6{\n    order:6;\n  }\n\n  .slds-max-x-small-order_7,.slds-max-x-small-order--7{\n    order:7;\n  }\n\n  .slds-max-x-small-order_8,.slds-max-x-small-order--8{\n    order:8;\n  }\n\n  .slds-max-x-small-order_9,.slds-max-x-small-order--9{\n    order:9;\n  }\n\n  .slds-max-x-small-order_10,.slds-max-x-small-order--10{\n    order:10;\n  }\n\n  .slds-max-x-small-order_11,.slds-max-x-small-order--11{\n    order:11;\n  }\n\n  .slds-max-x-small-order_12,.slds-max-x-small-order--12{\n    order:12;\n  }\n}\n@media (min-width: 30em){\n  .slds-small-size_xxx-small,.slds-small-size--xxx-small,\n  .slds-small-size_xx-small,\n  .slds-small-size--xx-small,\n  .slds-small-size_x-small,\n  .slds-small-size--x-small,\n  .slds-small-size_small,\n  .slds-small-size--small,\n  .slds-small-size_medium,\n  .slds-small-size--medium,\n  .slds-small-size_large,\n  .slds-small-size--large,\n  .slds-small-size_x-large,\n  .slds-small-size--x-large,\n  .slds-small-size_xx-large,\n  .slds-small-size--xx-large,\n  .slds-small-size_1-of-1,\n  .slds-small-size--1-of-1,\n  .slds-small-size_1-of-2,\n  .slds-small-size--1-of-2,\n  .slds-small-size_2-of-2,\n  .slds-small-size--2-of-2,\n  .slds-small-size_1-of-3,\n  .slds-small-size--1-of-3,\n  .slds-small-size_2-of-3,\n  .slds-small-size--2-of-3,\n  .slds-small-size_3-of-3,\n  .slds-small-size--3-of-3,\n  .slds-small-size_1-of-4,\n  .slds-small-size--1-of-4,\n  .slds-small-size_2-of-4,\n  .slds-small-size--2-of-4,\n  .slds-small-size_3-of-4,\n  .slds-small-size--3-of-4,\n  .slds-small-size_4-of-4,\n  .slds-small-size--4-of-4,\n  .slds-small-size_1-of-5,\n  .slds-small-size--1-of-5,\n  .slds-small-size_2-of-5,\n  .slds-small-size--2-of-5,\n  .slds-small-size_3-of-5,\n  .slds-small-size--3-of-5,\n  .slds-small-size_4-of-5,\n  .slds-small-size--4-of-5,\n  .slds-small-size_5-of-5,\n  .slds-small-size--5-of-5,\n  .slds-small-size_1-of-6,\n  .slds-small-size--1-of-6,\n  .slds-small-size_2-of-6,\n  .slds-small-size--2-of-6,\n  .slds-small-size_3-of-6,\n  .slds-small-size--3-of-6,\n  .slds-small-size_4-of-6,\n  .slds-small-size--4-of-6,\n  .slds-small-size_5-of-6,\n  .slds-small-size--5-of-6,\n  .slds-small-size_6-of-6,\n  .slds-small-size--6-of-6,\n  .slds-small-size_1-of-7,\n  .slds-small-size--1-of-7,\n  .slds-small-size_2-of-7,\n  .slds-small-size--2-of-7,\n  .slds-small-size_3-of-7,\n  .slds-small-size--3-of-7,\n  .slds-small-size_4-of-7,\n  .slds-small-size--4-of-7,\n  .slds-small-size_5-of-7,\n  .slds-small-size--5-of-7,\n  .slds-small-size_6-of-7,\n  .slds-small-size--6-of-7,\n  .slds-small-size_7-of-7,\n  .slds-small-size--7-of-7,\n  .slds-small-size_1-of-8,\n  .slds-small-size--1-of-8,\n  .slds-small-size_2-of-8,\n  .slds-small-size--2-of-8,\n  .slds-small-size_3-of-8,\n  .slds-small-size--3-of-8,\n  .slds-small-size_4-of-8,\n  .slds-small-size--4-of-8,\n  .slds-small-size_5-of-8,\n  .slds-small-size--5-of-8,\n  .slds-small-size_6-of-8,\n  .slds-small-size--6-of-8,\n  .slds-small-size_7-of-8,\n  .slds-small-size--7-of-8,\n  .slds-small-size_8-of-8,\n  .slds-small-size--8-of-8,\n  .slds-small-size_1-of-12,\n  .slds-small-size--1-of-12,\n  .slds-small-size_2-of-12,\n  .slds-small-size--2-of-12,\n  .slds-small-size_3-of-12,\n  .slds-small-size--3-of-12,\n  .slds-small-size_4-of-12,\n  .slds-small-size--4-of-12,\n  .slds-small-size_5-of-12,\n  .slds-small-size--5-of-12,\n  .slds-small-size_6-of-12,\n  .slds-small-size--6-of-12,\n  .slds-small-size_7-of-12,\n  .slds-small-size--7-of-12,\n  .slds-small-size_8-of-12,\n  .slds-small-size--8-of-12,\n  .slds-small-size_9-of-12,\n  .slds-small-size--9-of-12,\n  .slds-small-size_10-of-12,\n  .slds-small-size--10-of-12,\n  .slds-small-size_11-of-12,\n  .slds-small-size--11-of-12,\n  .slds-small-size_12-of-12,\n  .slds-small-size--12-of-12{\n    flex:none;\n  }\n\n  .slds-small-size_xxx-small,.slds-small-size--xxx-small{\n    width:3rem;\n  }\n\n  .slds-small-size_xx-small,.slds-small-size--xx-small{\n    width:6rem;\n  }\n\n  .slds-small-size_x-small,.slds-small-size--x-small{\n    width:12rem;\n  }\n\n  .slds-small-size_small,.slds-small-size--small{\n    width:15rem;\n  }\n\n  .slds-small-size_medium,.slds-small-size--medium{\n    width:20rem;\n  }\n\n  .slds-small-size_large,.slds-small-size--large{\n    width:25rem;\n  }\n\n  .slds-small-size_x-large,.slds-small-size--x-large{\n    width:40rem;\n  }\n\n  .slds-small-size_xx-large,.slds-small-size--xx-large{\n    width:60rem;\n  }\n\n  .slds-small-size_1-of-1,.slds-small-size--1-of-1{\n    width:100%;\n  }\n\n  .slds-small-size_1-of-2,.slds-small-size--1-of-2{\n    width:50%;\n  }\n\n  .slds-small-size_2-of-2,.slds-small-size--2-of-2{\n    width:100%;\n  }\n\n  .slds-small-size_1-of-3,.slds-small-size--1-of-3{\n    width:33.333%;\n  }\n\n  .slds-small-size_2-of-3,.slds-small-size--2-of-3{\n    width:66.6667%;\n  }\n\n  .slds-small-size_3-of-3,.slds-small-size--3-of-3{\n    width:100%;\n  }\n\n  .slds-small-size_1-of-4,.slds-small-size--1-of-4{\n    width:25%;\n  }\n\n  .slds-small-size_2-of-4,.slds-small-size--2-of-4{\n    width:50%;\n  }\n\n  .slds-small-size_3-of-4,.slds-small-size--3-of-4{\n    width:75%;\n  }\n\n  .slds-small-size_4-of-4,.slds-small-size--4-of-4{\n    width:100%;\n  }\n\n  .slds-small-size_1-of-5,.slds-small-size--1-of-5{\n    width:20%;\n  }\n\n  .slds-small-size_2-of-5,.slds-small-size--2-of-5{\n    width:40%;\n  }\n\n  .slds-small-size_3-of-5,.slds-small-size--3-of-5{\n    width:60%;\n  }\n\n  .slds-small-size_4-of-5,.slds-small-size--4-of-5{\n    width:80%;\n  }\n\n  .slds-small-size_5-of-5,.slds-small-size--5-of-5{\n    width:100%;\n  }\n\n  .slds-small-size_1-of-6,.slds-small-size--1-of-6{\n    width:16.6667%;\n  }\n\n  .slds-small-size_2-of-6,.slds-small-size--2-of-6{\n    width:33.333%;\n  }\n\n  .slds-small-size_3-of-6,.slds-small-size--3-of-6{\n    width:50%;\n  }\n\n  .slds-small-size_4-of-6,.slds-small-size--4-of-6{\n    width:66.6667%;\n  }\n\n  .slds-small-size_5-of-6,.slds-small-size--5-of-6{\n    width:83.3333%;\n  }\n\n  .slds-small-size_6-of-6,.slds-small-size--6-of-6{\n    width:100%;\n  }\n\n  .slds-small-size_1-of-7,.slds-small-size--1-of-7{\n    width:14.2857%;\n  }\n\n  .slds-small-size_2-of-7,.slds-small-size--2-of-7{\n    width:28.5714%;\n  }\n\n  .slds-small-size_3-of-7,.slds-small-size--3-of-7{\n    width:42.8571%;\n  }\n\n  .slds-small-size_4-of-7,.slds-small-size--4-of-7{\n    width:57.1429%;\n  }\n\n  .slds-small-size_5-of-7,.slds-small-size--5-of-7{\n    width:71.4286%;\n  }\n\n  .slds-small-size_6-of-7,.slds-small-size--6-of-7{\n    width:85.7143%;\n  }\n\n  .slds-small-size_7-of-7,.slds-small-size--7-of-7{\n    width:100%;\n  }\n\n  .slds-small-size_1-of-8,.slds-small-size--1-of-8{\n    width:12.5%;\n  }\n\n  .slds-small-size_2-of-8,.slds-small-size--2-of-8{\n    width:25%;\n  }\n\n  .slds-small-size_3-of-8,.slds-small-size--3-of-8{\n    width:37.5%;\n  }\n\n  .slds-small-size_4-of-8,.slds-small-size--4-of-8{\n    width:50%;\n  }\n\n  .slds-small-size_5-of-8,.slds-small-size--5-of-8{\n    width:62.5%;\n  }\n\n  .slds-small-size_6-of-8,.slds-small-size--6-of-8{\n    width:75%;\n  }\n\n  .slds-small-size_7-of-8,.slds-small-size--7-of-8{\n    width:87.5%;\n  }\n\n  .slds-small-size_8-of-8,.slds-small-size--8-of-8{\n    width:100%;\n  }\n\n  .slds-small-size_1-of-12,.slds-small-size--1-of-12{\n    width:8.3333%;\n  }\n\n  .slds-small-size_2-of-12,.slds-small-size--2-of-12{\n    width:16.6667%;\n  }\n\n  .slds-small-size_3-of-12,.slds-small-size--3-of-12{\n    width:25%;\n  }\n\n  .slds-small-size_4-of-12,.slds-small-size--4-of-12{\n    width:33.333%;\n  }\n\n  .slds-small-size_5-of-12,.slds-small-size--5-of-12{\n    width:41.6667%;\n  }\n\n  .slds-small-size_6-of-12,.slds-small-size--6-of-12{\n    width:50%;\n  }\n\n  .slds-small-size_7-of-12,.slds-small-size--7-of-12{\n    width:58.3333%;\n  }\n\n  .slds-small-size_8-of-12,.slds-small-size--8-of-12{\n    width:66.6667%;\n  }\n\n  .slds-small-size_9-of-12,.slds-small-size--9-of-12{\n    width:75%;\n  }\n\n  .slds-small-size_10-of-12,.slds-small-size--10-of-12{\n    width:83.3333%;\n  }\n\n  .slds-small-size_11-of-12,.slds-small-size--11-of-12{\n    width:91.6667%;\n  }\n\n  .slds-small-size_12-of-12,.slds-small-size--12-of-12{\n    width:100%;\n  }\n\n  .slds-small-order_1,.slds-small-order--1{\n    order:1;\n  }\n\n  .slds-small-order_2,.slds-small-order--2{\n    order:2;\n  }\n\n  .slds-small-order_3,.slds-small-order--3{\n    order:3;\n  }\n\n  .slds-small-order_4,.slds-small-order--4{\n    order:4;\n  }\n\n  .slds-small-order_5,.slds-small-order--5{\n    order:5;\n  }\n\n  .slds-small-order_6,.slds-small-order--6{\n    order:6;\n  }\n\n  .slds-small-order_7,.slds-small-order--7{\n    order:7;\n  }\n\n  .slds-small-order_8,.slds-small-order--8{\n    order:8;\n  }\n\n  .slds-small-order_9,.slds-small-order--9{\n    order:9;\n  }\n\n  .slds-small-order_10,.slds-small-order--10{\n    order:10;\n  }\n\n  .slds-small-order_11,.slds-small-order--11{\n    order:11;\n  }\n\n  .slds-small-order_12,.slds-small-order--12{\n    order:12;\n  }\n}\n@media (max-width: 30em){\n  .slds-max-small-size_xxx-small,.slds-max-small-size--xxx-small,\n  .slds-max-small-size_xx-small,\n  .slds-max-small-size--xx-small,\n  .slds-max-small-size_x-small,\n  .slds-max-small-size--x-small,\n  .slds-max-small-size_small,\n  .slds-max-small-size--small,\n  .slds-max-small-size_medium,\n  .slds-max-small-size--medium,\n  .slds-max-small-size_large,\n  .slds-max-small-size--large,\n  .slds-max-small-size_x-large,\n  .slds-max-small-size--x-large,\n  .slds-max-small-size_xx-large,\n  .slds-max-small-size--xx-large{\n    flex:none;\n  }\n\n  .slds-max-small-size_xxx-small,.slds-max-small-size--xxx-small{\n    width:3rem;\n  }\n\n  .slds-max-small-size_xx-small,.slds-max-small-size--xx-small{\n    width:6rem;\n  }\n\n  .slds-max-small-size_x-small,.slds-max-small-size--x-small{\n    width:12rem;\n  }\n\n  .slds-max-small-size_small,.slds-max-small-size--small{\n    width:15rem;\n  }\n\n  .slds-max-small-size_medium,.slds-max-small-size--medium{\n    width:20rem;\n  }\n\n  .slds-max-small-size_large,.slds-max-small-size--large{\n    width:25rem;\n  }\n\n  .slds-max-small-size_x-large,.slds-max-small-size--x-large{\n    width:40rem;\n  }\n\n  .slds-max-small-size_xx-large,.slds-max-small-size--xx-large{\n    width:60rem;\n  }\n\n  .slds-max-small-size_1-of-1,.slds-max-small-size--1-of-1{\n    width:100%;\n  }\n\n  .slds-max-small-size_1-of-2,.slds-max-small-size--1-of-2{\n    width:50%;\n  }\n\n  .slds-max-small-size_2-of-2,.slds-max-small-size--2-of-2{\n    width:100%;\n  }\n\n  .slds-max-small-size_1-of-3,.slds-max-small-size--1-of-3{\n    width:33.333%;\n  }\n\n  .slds-max-small-size_2-of-3,.slds-max-small-size--2-of-3{\n    width:66.6667%;\n  }\n\n  .slds-max-small-size_3-of-3,.slds-max-small-size--3-of-3{\n    width:100%;\n  }\n\n  .slds-max-small-size_1-of-4,.slds-max-small-size--1-of-4{\n    width:25%;\n  }\n\n  .slds-max-small-size_2-of-4,.slds-max-small-size--2-of-4{\n    width:50%;\n  }\n\n  .slds-max-small-size_3-of-4,.slds-max-small-size--3-of-4{\n    width:75%;\n  }\n\n  .slds-max-small-size_4-of-4,.slds-max-small-size--4-of-4{\n    width:100%;\n  }\n\n  .slds-max-small-size_1-of-5,.slds-max-small-size--1-of-5{\n    width:20%;\n  }\n\n  .slds-max-small-size_2-of-5,.slds-max-small-size--2-of-5{\n    width:40%;\n  }\n\n  .slds-max-small-size_3-of-5,.slds-max-small-size--3-of-5{\n    width:60%;\n  }\n\n  .slds-max-small-size_4-of-5,.slds-max-small-size--4-of-5{\n    width:80%;\n  }\n\n  .slds-max-small-size_5-of-5,.slds-max-small-size--5-of-5{\n    width:100%;\n  }\n\n  .slds-max-small-size_1-of-6,.slds-max-small-size--1-of-6{\n    width:16.6667%;\n  }\n\n  .slds-max-small-size_2-of-6,.slds-max-small-size--2-of-6{\n    width:33.333%;\n  }\n\n  .slds-max-small-size_3-of-6,.slds-max-small-size--3-of-6{\n    width:50%;\n  }\n\n  .slds-max-small-size_4-of-6,.slds-max-small-size--4-of-6{\n    width:66.6667%;\n  }\n\n  .slds-max-small-size_5-of-6,.slds-max-small-size--5-of-6{\n    width:83.3333%;\n  }\n\n  .slds-max-small-size_6-of-6,.slds-max-small-size--6-of-6{\n    width:100%;\n  }\n\n  .slds-max-small-size_1-of-7,.slds-max-small-size--1-of-7{\n    width:14.2857%;\n  }\n\n  .slds-max-small-size_2-of-7,.slds-max-small-size--2-of-7{\n    width:28.5714%;\n  }\n\n  .slds-max-small-size_3-of-7,.slds-max-small-size--3-of-7{\n    width:42.8571%;\n  }\n\n  .slds-max-small-size_4-of-7,.slds-max-small-size--4-of-7{\n    width:57.1429%;\n  }\n\n  .slds-max-small-size_5-of-7,.slds-max-small-size--5-of-7{\n    width:71.4286%;\n  }\n\n  .slds-max-small-size_6-of-7,.slds-max-small-size--6-of-7{\n    width:85.7143%;\n  }\n\n  .slds-max-small-size_7-of-7,.slds-max-small-size--7-of-7{\n    width:100%;\n  }\n\n  .slds-max-small-size_1-of-8,.slds-max-small-size--1-of-8{\n    width:12.5%;\n  }\n\n  .slds-max-small-size_2-of-8,.slds-max-small-size--2-of-8{\n    width:25%;\n  }\n\n  .slds-max-small-size_3-of-8,.slds-max-small-size--3-of-8{\n    width:37.5%;\n  }\n\n  .slds-max-small-size_4-of-8,.slds-max-small-size--4-of-8{\n    width:50%;\n  }\n\n  .slds-max-small-size_5-of-8,.slds-max-small-size--5-of-8{\n    width:62.5%;\n  }\n\n  .slds-max-small-size_6-of-8,.slds-max-small-size--6-of-8{\n    width:75%;\n  }\n\n  .slds-max-small-size_7-of-8,.slds-max-small-size--7-of-8{\n    width:87.5%;\n  }\n\n  .slds-max-small-size_8-of-8,.slds-max-small-size--8-of-8{\n    width:100%;\n  }\n\n  .slds-max-small-size_1-of-12,.slds-max-small-size--1-of-12{\n    width:8.3333%;\n  }\n\n  .slds-max-small-size_2-of-12,.slds-max-small-size--2-of-12{\n    width:16.6667%;\n  }\n\n  .slds-max-small-size_3-of-12,.slds-max-small-size--3-of-12{\n    width:25%;\n  }\n\n  .slds-max-small-size_4-of-12,.slds-max-small-size--4-of-12{\n    width:33.333%;\n  }\n\n  .slds-max-small-size_5-of-12,.slds-max-small-size--5-of-12{\n    width:41.6667%;\n  }\n\n  .slds-max-small-size_6-of-12,.slds-max-small-size--6-of-12{\n    width:50%;\n  }\n\n  .slds-max-small-size_7-of-12,.slds-max-small-size--7-of-12{\n    width:58.3333%;\n  }\n\n  .slds-max-small-size_8-of-12,.slds-max-small-size--8-of-12{\n    width:66.6667%;\n  }\n\n  .slds-max-small-size_9-of-12,.slds-max-small-size--9-of-12{\n    width:75%;\n  }\n\n  .slds-max-small-size_10-of-12,.slds-max-small-size--10-of-12{\n    width:83.3333%;\n  }\n\n  .slds-max-small-size_11-of-12,.slds-max-small-size--11-of-12{\n    width:91.6667%;\n  }\n\n  .slds-max-small-size_12-of-12,.slds-max-small-size--12-of-12{\n    width:100%;\n  }\n\n  .slds-max-small-order_1,.slds-max-small-order--1{\n    order:1;\n  }\n\n  .slds-max-small-order_2,.slds-max-small-order--2{\n    order:2;\n  }\n\n  .slds-max-small-order_3,.slds-max-small-order--3{\n    order:3;\n  }\n\n  .slds-max-small-order_4,.slds-max-small-order--4{\n    order:4;\n  }\n\n  .slds-max-small-order_5,.slds-max-small-order--5{\n    order:5;\n  }\n\n  .slds-max-small-order_6,.slds-max-small-order--6{\n    order:6;\n  }\n\n  .slds-max-small-order_7,.slds-max-small-order--7{\n    order:7;\n  }\n\n  .slds-max-small-order_8,.slds-max-small-order--8{\n    order:8;\n  }\n\n  .slds-max-small-order_9,.slds-max-small-order--9{\n    order:9;\n  }\n\n  .slds-max-small-order_10,.slds-max-small-order--10{\n    order:10;\n  }\n\n  .slds-max-small-order_11,.slds-max-small-order--11{\n    order:11;\n  }\n\n  .slds-max-small-order_12,.slds-max-small-order--12{\n    order:12;\n  }\n}\n@media (min-width: 48em){\n  .slds-medium-size_xxx-small,.slds-medium-size--xxx-small,\n  .slds-medium-size_xx-small,\n  .slds-medium-size--xx-small,\n  .slds-medium-size_x-small,\n  .slds-medium-size--x-small,\n  .slds-medium-size_small,\n  .slds-medium-size--small,\n  .slds-medium-size_medium,\n  .slds-medium-size--medium,\n  .slds-medium-size_large,\n  .slds-medium-size--large,\n  .slds-medium-size_x-large,\n  .slds-medium-size--x-large,\n  .slds-medium-size_xx-large,\n  .slds-medium-size--xx-large,\n  .slds-medium-size_1-of-1,\n  .slds-medium-size--1-of-1,\n  .slds-medium-size_1-of-2,\n  .slds-medium-size--1-of-2,\n  .slds-medium-size_2-of-2,\n  .slds-medium-size--2-of-2,\n  .slds-medium-size_1-of-3,\n  .slds-medium-size--1-of-3,\n  .slds-medium-size_2-of-3,\n  .slds-medium-size--2-of-3,\n  .slds-medium-size_3-of-3,\n  .slds-medium-size--3-of-3,\n  .slds-medium-size_1-of-4,\n  .slds-medium-size--1-of-4,\n  .slds-medium-size_2-of-4,\n  .slds-medium-size--2-of-4,\n  .slds-medium-size_3-of-4,\n  .slds-medium-size--3-of-4,\n  .slds-medium-size_4-of-4,\n  .slds-medium-size--4-of-4,\n  .slds-medium-size_1-of-5,\n  .slds-medium-size--1-of-5,\n  .slds-medium-size_2-of-5,\n  .slds-medium-size--2-of-5,\n  .slds-medium-size_3-of-5,\n  .slds-medium-size--3-of-5,\n  .slds-medium-size_4-of-5,\n  .slds-medium-size--4-of-5,\n  .slds-medium-size_5-of-5,\n  .slds-medium-size--5-of-5,\n  .slds-medium-size_1-of-6,\n  .slds-medium-size--1-of-6,\n  .slds-medium-size_2-of-6,\n  .slds-medium-size--2-of-6,\n  .slds-medium-size_3-of-6,\n  .slds-medium-size--3-of-6,\n  .slds-medium-size_4-of-6,\n  .slds-medium-size--4-of-6,\n  .slds-medium-size_5-of-6,\n  .slds-medium-size--5-of-6,\n  .slds-medium-size_6-of-6,\n  .slds-medium-size--6-of-6,\n  .slds-medium-size_1-of-7,\n  .slds-medium-size--1-of-7,\n  .slds-medium-size_2-of-7,\n  .slds-medium-size--2-of-7,\n  .slds-medium-size_3-of-7,\n  .slds-medium-size--3-of-7,\n  .slds-medium-size_4-of-7,\n  .slds-medium-size--4-of-7,\n  .slds-medium-size_5-of-7,\n  .slds-medium-size--5-of-7,\n  .slds-medium-size_6-of-7,\n  .slds-medium-size--6-of-7,\n  .slds-medium-size_7-of-7,\n  .slds-medium-size--7-of-7,\n  .slds-medium-size_1-of-8,\n  .slds-medium-size--1-of-8,\n  .slds-medium-size_2-of-8,\n  .slds-medium-size--2-of-8,\n  .slds-medium-size_3-of-8,\n  .slds-medium-size--3-of-8,\n  .slds-medium-size_4-of-8,\n  .slds-medium-size--4-of-8,\n  .slds-medium-size_5-of-8,\n  .slds-medium-size--5-of-8,\n  .slds-medium-size_6-of-8,\n  .slds-medium-size--6-of-8,\n  .slds-medium-size_7-of-8,\n  .slds-medium-size--7-of-8,\n  .slds-medium-size_8-of-8,\n  .slds-medium-size--8-of-8,\n  .slds-medium-size_1-of-12,\n  .slds-medium-size--1-of-12,\n  .slds-medium-size_2-of-12,\n  .slds-medium-size--2-of-12,\n  .slds-medium-size_3-of-12,\n  .slds-medium-size--3-of-12,\n  .slds-medium-size_4-of-12,\n  .slds-medium-size--4-of-12,\n  .slds-medium-size_5-of-12,\n  .slds-medium-size--5-of-12,\n  .slds-medium-size_6-of-12,\n  .slds-medium-size--6-of-12,\n  .slds-medium-size_7-of-12,\n  .slds-medium-size--7-of-12,\n  .slds-medium-size_8-of-12,\n  .slds-medium-size--8-of-12,\n  .slds-medium-size_9-of-12,\n  .slds-medium-size--9-of-12,\n  .slds-medium-size_10-of-12,\n  .slds-medium-size--10-of-12,\n  .slds-medium-size_11-of-12,\n  .slds-medium-size--11-of-12,\n  .slds-medium-size_12-of-12,\n  .slds-medium-size--12-of-12{\n    flex:none;\n  }\n\n  .slds-medium-size_xxx-small,.slds-medium-size--xxx-small{\n    width:3rem;\n  }\n\n  .slds-medium-size_xx-small,.slds-medium-size--xx-small{\n    width:6rem;\n  }\n\n  .slds-medium-size_x-small,.slds-medium-size--x-small{\n    width:12rem;\n  }\n\n  .slds-medium-size_small,.slds-medium-size--small{\n    width:15rem;\n  }\n\n  .slds-medium-size_medium,.slds-medium-size--medium{\n    width:20rem;\n  }\n\n  .slds-medium-size_large,.slds-medium-size--large{\n    width:25rem;\n  }\n\n  .slds-medium-size_x-large,.slds-medium-size--x-large{\n    width:40rem;\n  }\n\n  .slds-medium-size_xx-large,.slds-medium-size--xx-large{\n    width:60rem;\n  }\n\n  .slds-medium-size_1-of-1,.slds-medium-size--1-of-1{\n    width:100%;\n  }\n\n  .slds-medium-size_1-of-2,.slds-medium-size--1-of-2{\n    width:50%;\n  }\n\n  .slds-medium-size_2-of-2,.slds-medium-size--2-of-2{\n    width:100%;\n  }\n\n  .slds-medium-size_1-of-3,.slds-medium-size--1-of-3{\n    width:33.333%;\n  }\n\n  .slds-medium-size_2-of-3,.slds-medium-size--2-of-3{\n    width:66.6667%;\n  }\n\n  .slds-medium-size_3-of-3,.slds-medium-size--3-of-3{\n    width:100%;\n  }\n\n  .slds-medium-size_1-of-4,.slds-medium-size--1-of-4{\n    width:25%;\n  }\n\n  .slds-medium-size_2-of-4,.slds-medium-size--2-of-4{\n    width:50%;\n  }\n\n  .slds-medium-size_3-of-4,.slds-medium-size--3-of-4{\n    width:75%;\n  }\n\n  .slds-medium-size_4-of-4,.slds-medium-size--4-of-4{\n    width:100%;\n  }\n\n  .slds-medium-size_1-of-5,.slds-medium-size--1-of-5{\n    width:20%;\n  }\n\n  .slds-medium-size_2-of-5,.slds-medium-size--2-of-5{\n    width:40%;\n  }\n\n  .slds-medium-size_3-of-5,.slds-medium-size--3-of-5{\n    width:60%;\n  }\n\n  .slds-medium-size_4-of-5,.slds-medium-size--4-of-5{\n    width:80%;\n  }\n\n  .slds-medium-size_5-of-5,.slds-medium-size--5-of-5{\n    width:100%;\n  }\n\n  .slds-medium-size_1-of-6,.slds-medium-size--1-of-6{\n    width:16.6667%;\n  }\n\n  .slds-medium-size_2-of-6,.slds-medium-size--2-of-6{\n    width:33.333%;\n  }\n\n  .slds-medium-size_3-of-6,.slds-medium-size--3-of-6{\n    width:50%;\n  }\n\n  .slds-medium-size_4-of-6,.slds-medium-size--4-of-6{\n    width:66.6667%;\n  }\n\n  .slds-medium-size_5-of-6,.slds-medium-size--5-of-6{\n    width:83.3333%;\n  }\n\n  .slds-medium-size_6-of-6,.slds-medium-size--6-of-6{\n    width:100%;\n  }\n\n  .slds-medium-size_1-of-7,.slds-medium-size--1-of-7{\n    width:14.2857%;\n  }\n\n  .slds-medium-size_2-of-7,.slds-medium-size--2-of-7{\n    width:28.5714%;\n  }\n\n  .slds-medium-size_3-of-7,.slds-medium-size--3-of-7{\n    width:42.8571%;\n  }\n\n  .slds-medium-size_4-of-7,.slds-medium-size--4-of-7{\n    width:57.1429%;\n  }\n\n  .slds-medium-size_5-of-7,.slds-medium-size--5-of-7{\n    width:71.4286%;\n  }\n\n  .slds-medium-size_6-of-7,.slds-medium-size--6-of-7{\n    width:85.7143%;\n  }\n\n  .slds-medium-size_7-of-7,.slds-medium-size--7-of-7{\n    width:100%;\n  }\n\n  .slds-medium-size_1-of-8,.slds-medium-size--1-of-8{\n    width:12.5%;\n  }\n\n  .slds-medium-size_2-of-8,.slds-medium-size--2-of-8{\n    width:25%;\n  }\n\n  .slds-medium-size_3-of-8,.slds-medium-size--3-of-8{\n    width:37.5%;\n  }\n\n  .slds-medium-size_4-of-8,.slds-medium-size--4-of-8{\n    width:50%;\n  }\n\n  .slds-medium-size_5-of-8,.slds-medium-size--5-of-8{\n    width:62.5%;\n  }\n\n  .slds-medium-size_6-of-8,.slds-medium-size--6-of-8{\n    width:75%;\n  }\n\n  .slds-medium-size_7-of-8,.slds-medium-size--7-of-8{\n    width:87.5%;\n  }\n\n  .slds-medium-size_8-of-8,.slds-medium-size--8-of-8{\n    width:100%;\n  }\n\n  .slds-medium-size_1-of-12,.slds-medium-size--1-of-12{\n    width:8.3333%;\n  }\n\n  .slds-medium-size_2-of-12,.slds-medium-size--2-of-12{\n    width:16.6667%;\n  }\n\n  .slds-medium-size_3-of-12,.slds-medium-size--3-of-12{\n    width:25%;\n  }\n\n  .slds-medium-size_4-of-12,.slds-medium-size--4-of-12{\n    width:33.333%;\n  }\n\n  .slds-medium-size_5-of-12,.slds-medium-size--5-of-12{\n    width:41.6667%;\n  }\n\n  .slds-medium-size_6-of-12,.slds-medium-size--6-of-12{\n    width:50%;\n  }\n\n  .slds-medium-size_7-of-12,.slds-medium-size--7-of-12{\n    width:58.3333%;\n  }\n\n  .slds-medium-size_8-of-12,.slds-medium-size--8-of-12{\n    width:66.6667%;\n  }\n\n  .slds-medium-size_9-of-12,.slds-medium-size--9-of-12{\n    width:75%;\n  }\n\n  .slds-medium-size_10-of-12,.slds-medium-size--10-of-12{\n    width:83.3333%;\n  }\n\n  .slds-medium-size_11-of-12,.slds-medium-size--11-of-12{\n    width:91.6667%;\n  }\n\n  .slds-medium-size_12-of-12,.slds-medium-size--12-of-12{\n    width:100%;\n  }\n\n  .slds-medium-order_1,.slds-medium-order--1{\n    order:1;\n  }\n\n  .slds-medium-order_2,.slds-medium-order--2{\n    order:2;\n  }\n\n  .slds-medium-order_3,.slds-medium-order--3{\n    order:3;\n  }\n\n  .slds-medium-order_4,.slds-medium-order--4{\n    order:4;\n  }\n\n  .slds-medium-order_5,.slds-medium-order--5{\n    order:5;\n  }\n\n  .slds-medium-order_6,.slds-medium-order--6{\n    order:6;\n  }\n\n  .slds-medium-order_7,.slds-medium-order--7{\n    order:7;\n  }\n\n  .slds-medium-order_8,.slds-medium-order--8{\n    order:8;\n  }\n\n  .slds-medium-order_9,.slds-medium-order--9{\n    order:9;\n  }\n\n  .slds-medium-order_10,.slds-medium-order--10{\n    order:10;\n  }\n\n  .slds-medium-order_11,.slds-medium-order--11{\n    order:11;\n  }\n\n  .slds-medium-order_12,.slds-medium-order--12{\n    order:12;\n  }\n}\n@media (max-width: 48em){\n  .slds-max-medium-size_xxx-small,.slds-max-medium-size--xxx-small,\n  .slds-max-medium-size_xx-small,\n  .slds-max-medium-size--xx-small,\n  .slds-max-medium-size_x-small,\n  .slds-max-medium-size--x-small,\n  .slds-max-medium-size_small,\n  .slds-max-medium-size--small,\n  .slds-max-medium-size_medium,\n  .slds-max-medium-size--medium,\n  .slds-max-medium-size_large,\n  .slds-max-medium-size--large,\n  .slds-max-medium-size_x-large,\n  .slds-max-medium-size--x-large,\n  .slds-max-medium-size_xx-large,\n  .slds-max-medium-size--xx-large{\n    flex:none;\n  }\n\n  .slds-max-medium-size_xxx-small,.slds-max-medium-size--xxx-small{\n    width:3rem;\n  }\n\n  .slds-max-medium-size_xx-small,.slds-max-medium-size--xx-small{\n    width:6rem;\n  }\n\n  .slds-max-medium-size_x-small,.slds-max-medium-size--x-small{\n    width:12rem;\n  }\n\n  .slds-max-medium-size_small,.slds-max-medium-size--small{\n    width:15rem;\n  }\n\n  .slds-max-medium-size_medium,.slds-max-medium-size--medium{\n    width:20rem;\n  }\n\n  .slds-max-medium-size_large,.slds-max-medium-size--large{\n    width:25rem;\n  }\n\n  .slds-max-medium-size_x-large,.slds-max-medium-size--x-large{\n    width:40rem;\n  }\n\n  .slds-max-medium-size_xx-large,.slds-max-medium-size--xx-large{\n    width:60rem;\n  }\n\n  .slds-max-medium-size_1-of-1,.slds-max-medium-size--1-of-1{\n    width:100%;\n  }\n\n  .slds-max-medium-size_1-of-2,.slds-max-medium-size--1-of-2{\n    width:50%;\n  }\n\n  .slds-max-medium-size_2-of-2,.slds-max-medium-size--2-of-2{\n    width:100%;\n  }\n\n  .slds-max-medium-size_1-of-3,.slds-max-medium-size--1-of-3{\n    width:33.333%;\n  }\n\n  .slds-max-medium-size_2-of-3,.slds-max-medium-size--2-of-3{\n    width:66.6667%;\n  }\n\n  .slds-max-medium-size_3-of-3,.slds-max-medium-size--3-of-3{\n    width:100%;\n  }\n\n  .slds-max-medium-size_1-of-4,.slds-max-medium-size--1-of-4{\n    width:25%;\n  }\n\n  .slds-max-medium-size_2-of-4,.slds-max-medium-size--2-of-4{\n    width:50%;\n  }\n\n  .slds-max-medium-size_3-of-4,.slds-max-medium-size--3-of-4{\n    width:75%;\n  }\n\n  .slds-max-medium-size_4-of-4,.slds-max-medium-size--4-of-4{\n    width:100%;\n  }\n\n  .slds-max-medium-size_1-of-5,.slds-max-medium-size--1-of-5{\n    width:20%;\n  }\n\n  .slds-max-medium-size_2-of-5,.slds-max-medium-size--2-of-5{\n    width:40%;\n  }\n\n  .slds-max-medium-size_3-of-5,.slds-max-medium-size--3-of-5{\n    width:60%;\n  }\n\n  .slds-max-medium-size_4-of-5,.slds-max-medium-size--4-of-5{\n    width:80%;\n  }\n\n  .slds-max-medium-size_5-of-5,.slds-max-medium-size--5-of-5{\n    width:100%;\n  }\n\n  .slds-max-medium-size_1-of-6,.slds-max-medium-size--1-of-6{\n    width:16.6667%;\n  }\n\n  .slds-max-medium-size_2-of-6,.slds-max-medium-size--2-of-6{\n    width:33.333%;\n  }\n\n  .slds-max-medium-size_3-of-6,.slds-max-medium-size--3-of-6{\n    width:50%;\n  }\n\n  .slds-max-medium-size_4-of-6,.slds-max-medium-size--4-of-6{\n    width:66.6667%;\n  }\n\n  .slds-max-medium-size_5-of-6,.slds-max-medium-size--5-of-6{\n    width:83.3333%;\n  }\n\n  .slds-max-medium-size_6-of-6,.slds-max-medium-size--6-of-6{\n    width:100%;\n  }\n\n  .slds-max-medium-size_1-of-7,.slds-max-medium-size--1-of-7{\n    width:14.2857%;\n  }\n\n  .slds-max-medium-size_2-of-7,.slds-max-medium-size--2-of-7{\n    width:28.5714%;\n  }\n\n  .slds-max-medium-size_3-of-7,.slds-max-medium-size--3-of-7{\n    width:42.8571%;\n  }\n\n  .slds-max-medium-size_4-of-7,.slds-max-medium-size--4-of-7{\n    width:57.1429%;\n  }\n\n  .slds-max-medium-size_5-of-7,.slds-max-medium-size--5-of-7{\n    width:71.4286%;\n  }\n\n  .slds-max-medium-size_6-of-7,.slds-max-medium-size--6-of-7{\n    width:85.7143%;\n  }\n\n  .slds-max-medium-size_7-of-7,.slds-max-medium-size--7-of-7{\n    width:100%;\n  }\n\n  .slds-max-medium-size_1-of-8,.slds-max-medium-size--1-of-8{\n    width:12.5%;\n  }\n\n  .slds-max-medium-size_2-of-8,.slds-max-medium-size--2-of-8{\n    width:25%;\n  }\n\n  .slds-max-medium-size_3-of-8,.slds-max-medium-size--3-of-8{\n    width:37.5%;\n  }\n\n  .slds-max-medium-size_4-of-8,.slds-max-medium-size--4-of-8{\n    width:50%;\n  }\n\n  .slds-max-medium-size_5-of-8,.slds-max-medium-size--5-of-8{\n    width:62.5%;\n  }\n\n  .slds-max-medium-size_6-of-8,.slds-max-medium-size--6-of-8{\n    width:75%;\n  }\n\n  .slds-max-medium-size_7-of-8,.slds-max-medium-size--7-of-8{\n    width:87.5%;\n  }\n\n  .slds-max-medium-size_8-of-8,.slds-max-medium-size--8-of-8{\n    width:100%;\n  }\n\n  .slds-max-medium-size_1-of-12,.slds-max-medium-size--1-of-12{\n    width:8.3333%;\n  }\n\n  .slds-max-medium-size_2-of-12,.slds-max-medium-size--2-of-12{\n    width:16.6667%;\n  }\n\n  .slds-max-medium-size_3-of-12,.slds-max-medium-size--3-of-12{\n    width:25%;\n  }\n\n  .slds-max-medium-size_4-of-12,.slds-max-medium-size--4-of-12{\n    width:33.333%;\n  }\n\n  .slds-max-medium-size_5-of-12,.slds-max-medium-size--5-of-12{\n    width:41.6667%;\n  }\n\n  .slds-max-medium-size_6-of-12,.slds-max-medium-size--6-of-12{\n    width:50%;\n  }\n\n  .slds-max-medium-size_7-of-12,.slds-max-medium-size--7-of-12{\n    width:58.3333%;\n  }\n\n  .slds-max-medium-size_8-of-12,.slds-max-medium-size--8-of-12{\n    width:66.6667%;\n  }\n\n  .slds-max-medium-size_9-of-12,.slds-max-medium-size--9-of-12{\n    width:75%;\n  }\n\n  .slds-max-medium-size_10-of-12,.slds-max-medium-size--10-of-12{\n    width:83.3333%;\n  }\n\n  .slds-max-medium-size_11-of-12,.slds-max-medium-size--11-of-12{\n    width:91.6667%;\n  }\n\n  .slds-max-medium-size_12-of-12,.slds-max-medium-size--12-of-12{\n    width:100%;\n  }\n\n  .slds-max-medium-order_1,.slds-max-medium-order--1{\n    order:1;\n  }\n\n  .slds-max-medium-order_2,.slds-max-medium-order--2{\n    order:2;\n  }\n\n  .slds-max-medium-order_3,.slds-max-medium-order--3{\n    order:3;\n  }\n\n  .slds-max-medium-order_4,.slds-max-medium-order--4{\n    order:4;\n  }\n\n  .slds-max-medium-order_5,.slds-max-medium-order--5{\n    order:5;\n  }\n\n  .slds-max-medium-order_6,.slds-max-medium-order--6{\n    order:6;\n  }\n\n  .slds-max-medium-order_7,.slds-max-medium-order--7{\n    order:7;\n  }\n\n  .slds-max-medium-order_8,.slds-max-medium-order--8{\n    order:8;\n  }\n\n  .slds-max-medium-order_9,.slds-max-medium-order--9{\n    order:9;\n  }\n\n  .slds-max-medium-order_10,.slds-max-medium-order--10{\n    order:10;\n  }\n\n  .slds-max-medium-order_11,.slds-max-medium-order--11{\n    order:11;\n  }\n\n  .slds-max-medium-order_12,.slds-max-medium-order--12{\n    order:12;\n  }\n}\n@media (min-width: 64em){\n  .slds-large-size_xxx-small,.slds-large-size--xxx-small,\n  .slds-large-size_xx-small,\n  .slds-large-size--xx-small,\n  .slds-large-size_x-small,\n  .slds-large-size--x-small,\n  .slds-large-size_small,\n  .slds-large-size--small,\n  .slds-large-size_medium,\n  .slds-large-size--medium,\n  .slds-large-size_large,\n  .slds-large-size--large,\n  .slds-large-size_x-large,\n  .slds-large-size--x-large,\n  .slds-large-size_xx-large,\n  .slds-large-size--xx-large,\n  .slds-large-size_1-of-1,\n  .slds-large-size--1-of-1,\n  .slds-large-size_1-of-2,\n  .slds-large-size--1-of-2,\n  .slds-large-size_2-of-2,\n  .slds-large-size--2-of-2,\n  .slds-large-size_1-of-3,\n  .slds-large-size--1-of-3,\n  .slds-large-size_2-of-3,\n  .slds-large-size--2-of-3,\n  .slds-large-size_3-of-3,\n  .slds-large-size--3-of-3,\n  .slds-large-size_1-of-4,\n  .slds-large-size--1-of-4,\n  .slds-large-size_2-of-4,\n  .slds-large-size--2-of-4,\n  .slds-large-size_3-of-4,\n  .slds-large-size--3-of-4,\n  .slds-large-size_4-of-4,\n  .slds-large-size--4-of-4,\n  .slds-large-size_1-of-5,\n  .slds-large-size--1-of-5,\n  .slds-large-size_2-of-5,\n  .slds-large-size--2-of-5,\n  .slds-large-size_3-of-5,\n  .slds-large-size--3-of-5,\n  .slds-large-size_4-of-5,\n  .slds-large-size--4-of-5,\n  .slds-large-size_5-of-5,\n  .slds-large-size--5-of-5,\n  .slds-large-size_1-of-6,\n  .slds-large-size--1-of-6,\n  .slds-large-size_2-of-6,\n  .slds-large-size--2-of-6,\n  .slds-large-size_3-of-6,\n  .slds-large-size--3-of-6,\n  .slds-large-size_4-of-6,\n  .slds-large-size--4-of-6,\n  .slds-large-size_5-of-6,\n  .slds-large-size--5-of-6,\n  .slds-large-size_6-of-6,\n  .slds-large-size--6-of-6,\n  .slds-large-size_1-of-7,\n  .slds-large-size--1-of-7,\n  .slds-large-size_2-of-7,\n  .slds-large-size--2-of-7,\n  .slds-large-size_3-of-7,\n  .slds-large-size--3-of-7,\n  .slds-large-size_4-of-7,\n  .slds-large-size--4-of-7,\n  .slds-large-size_5-of-7,\n  .slds-large-size--5-of-7,\n  .slds-large-size_6-of-7,\n  .slds-large-size--6-of-7,\n  .slds-large-size_7-of-7,\n  .slds-large-size--7-of-7,\n  .slds-large-size_1-of-8,\n  .slds-large-size--1-of-8,\n  .slds-large-size_2-of-8,\n  .slds-large-size--2-of-8,\n  .slds-large-size_3-of-8,\n  .slds-large-size--3-of-8,\n  .slds-large-size_4-of-8,\n  .slds-large-size--4-of-8,\n  .slds-large-size_5-of-8,\n  .slds-large-size--5-of-8,\n  .slds-large-size_6-of-8,\n  .slds-large-size--6-of-8,\n  .slds-large-size_7-of-8,\n  .slds-large-size--7-of-8,\n  .slds-large-size_8-of-8,\n  .slds-large-size--8-of-8,\n  .slds-large-size_1-of-12,\n  .slds-large-size--1-of-12,\n  .slds-large-size_2-of-12,\n  .slds-large-size--2-of-12,\n  .slds-large-size_3-of-12,\n  .slds-large-size--3-of-12,\n  .slds-large-size_4-of-12,\n  .slds-large-size--4-of-12,\n  .slds-large-size_5-of-12,\n  .slds-large-size--5-of-12,\n  .slds-large-size_6-of-12,\n  .slds-large-size--6-of-12,\n  .slds-large-size_7-of-12,\n  .slds-large-size--7-of-12,\n  .slds-large-size_8-of-12,\n  .slds-large-size--8-of-12,\n  .slds-large-size_9-of-12,\n  .slds-large-size--9-of-12,\n  .slds-large-size_10-of-12,\n  .slds-large-size--10-of-12,\n  .slds-large-size_11-of-12,\n  .slds-large-size--11-of-12,\n  .slds-large-size_12-of-12,\n  .slds-large-size--12-of-12{\n    flex:none;\n  }\n\n  .slds-large-size_xxx-small,.slds-large-size--xxx-small{\n    width:3rem;\n  }\n\n  .slds-large-size_xx-small,.slds-large-size--xx-small{\n    width:6rem;\n  }\n\n  .slds-large-size_x-small,.slds-large-size--x-small{\n    width:12rem;\n  }\n\n  .slds-large-size_small,.slds-large-size--small{\n    width:15rem;\n  }\n\n  .slds-large-size_medium,.slds-large-size--medium{\n    width:20rem;\n  }\n\n  .slds-large-size_large,.slds-large-size--large{\n    width:25rem;\n  }\n\n  .slds-large-size_x-large,.slds-large-size--x-large{\n    width:40rem;\n  }\n\n  .slds-large-size_xx-large,.slds-large-size--xx-large{\n    width:60rem;\n  }\n\n  .slds-large-size_1-of-1,.slds-large-size--1-of-1{\n    width:100%;\n  }\n\n  .slds-large-size_1-of-2,.slds-large-size--1-of-2{\n    width:50%;\n  }\n\n  .slds-large-size_2-of-2,.slds-large-size--2-of-2{\n    width:100%;\n  }\n\n  .slds-large-size_1-of-3,.slds-large-size--1-of-3{\n    width:33.333%;\n  }\n\n  .slds-large-size_2-of-3,.slds-large-size--2-of-3{\n    width:66.6667%;\n  }\n\n  .slds-large-size_3-of-3,.slds-large-size--3-of-3{\n    width:100%;\n  }\n\n  .slds-large-size_1-of-4,.slds-large-size--1-of-4{\n    width:25%;\n  }\n\n  .slds-large-size_2-of-4,.slds-large-size--2-of-4{\n    width:50%;\n  }\n\n  .slds-large-size_3-of-4,.slds-large-size--3-of-4{\n    width:75%;\n  }\n\n  .slds-large-size_4-of-4,.slds-large-size--4-of-4{\n    width:100%;\n  }\n\n  .slds-large-size_1-of-5,.slds-large-size--1-of-5{\n    width:20%;\n  }\n\n  .slds-large-size_2-of-5,.slds-large-size--2-of-5{\n    width:40%;\n  }\n\n  .slds-large-size_3-of-5,.slds-large-size--3-of-5{\n    width:60%;\n  }\n\n  .slds-large-size_4-of-5,.slds-large-size--4-of-5{\n    width:80%;\n  }\n\n  .slds-large-size_5-of-5,.slds-large-size--5-of-5{\n    width:100%;\n  }\n\n  .slds-large-size_1-of-6,.slds-large-size--1-of-6{\n    width:16.6667%;\n  }\n\n  .slds-large-size_2-of-6,.slds-large-size--2-of-6{\n    width:33.333%;\n  }\n\n  .slds-large-size_3-of-6,.slds-large-size--3-of-6{\n    width:50%;\n  }\n\n  .slds-large-size_4-of-6,.slds-large-size--4-of-6{\n    width:66.6667%;\n  }\n\n  .slds-large-size_5-of-6,.slds-large-size--5-of-6{\n    width:83.3333%;\n  }\n\n  .slds-large-size_6-of-6,.slds-large-size--6-of-6{\n    width:100%;\n  }\n\n  .slds-large-size_1-of-7,.slds-large-size--1-of-7{\n    width:14.2857%;\n  }\n\n  .slds-large-size_2-of-7,.slds-large-size--2-of-7{\n    width:28.5714%;\n  }\n\n  .slds-large-size_3-of-7,.slds-large-size--3-of-7{\n    width:42.8571%;\n  }\n\n  .slds-large-size_4-of-7,.slds-large-size--4-of-7{\n    width:57.1429%;\n  }\n\n  .slds-large-size_5-of-7,.slds-large-size--5-of-7{\n    width:71.4286%;\n  }\n\n  .slds-large-size_6-of-7,.slds-large-size--6-of-7{\n    width:85.7143%;\n  }\n\n  .slds-large-size_7-of-7,.slds-large-size--7-of-7{\n    width:100%;\n  }\n\n  .slds-large-size_1-of-8,.slds-large-size--1-of-8{\n    width:12.5%;\n  }\n\n  .slds-large-size_2-of-8,.slds-large-size--2-of-8{\n    width:25%;\n  }\n\n  .slds-large-size_3-of-8,.slds-large-size--3-of-8{\n    width:37.5%;\n  }\n\n  .slds-large-size_4-of-8,.slds-large-size--4-of-8{\n    width:50%;\n  }\n\n  .slds-large-size_5-of-8,.slds-large-size--5-of-8{\n    width:62.5%;\n  }\n\n  .slds-large-size_6-of-8,.slds-large-size--6-of-8{\n    width:75%;\n  }\n\n  .slds-large-size_7-of-8,.slds-large-size--7-of-8{\n    width:87.5%;\n  }\n\n  .slds-large-size_8-of-8,.slds-large-size--8-of-8{\n    width:100%;\n  }\n\n  .slds-large-size_1-of-12,.slds-large-size--1-of-12{\n    width:8.3333%;\n  }\n\n  .slds-large-size_2-of-12,.slds-large-size--2-of-12{\n    width:16.6667%;\n  }\n\n  .slds-large-size_3-of-12,.slds-large-size--3-of-12{\n    width:25%;\n  }\n\n  .slds-large-size_4-of-12,.slds-large-size--4-of-12{\n    width:33.333%;\n  }\n\n  .slds-large-size_5-of-12,.slds-large-size--5-of-12{\n    width:41.6667%;\n  }\n\n  .slds-large-size_6-of-12,.slds-large-size--6-of-12{\n    width:50%;\n  }\n\n  .slds-large-size_7-of-12,.slds-large-size--7-of-12{\n    width:58.3333%;\n  }\n\n  .slds-large-size_8-of-12,.slds-large-size--8-of-12{\n    width:66.6667%;\n  }\n\n  .slds-large-size_9-of-12,.slds-large-size--9-of-12{\n    width:75%;\n  }\n\n  .slds-large-size_10-of-12,.slds-large-size--10-of-12{\n    width:83.3333%;\n  }\n\n  .slds-large-size_11-of-12,.slds-large-size--11-of-12{\n    width:91.6667%;\n  }\n\n  .slds-large-size_12-of-12,.slds-large-size--12-of-12{\n    width:100%;\n  }\n\n  .slds-large-order_1,.slds-large-order--1{\n    order:1;\n  }\n\n  .slds-large-order_2,.slds-large-order--2{\n    order:2;\n  }\n\n  .slds-large-order_3,.slds-large-order--3{\n    order:3;\n  }\n\n  .slds-large-order_4,.slds-large-order--4{\n    order:4;\n  }\n\n  .slds-large-order_5,.slds-large-order--5{\n    order:5;\n  }\n\n  .slds-large-order_6,.slds-large-order--6{\n    order:6;\n  }\n\n  .slds-large-order_7,.slds-large-order--7{\n    order:7;\n  }\n\n  .slds-large-order_8,.slds-large-order--8{\n    order:8;\n  }\n\n  .slds-large-order_9,.slds-large-order--9{\n    order:9;\n  }\n\n  .slds-large-order_10,.slds-large-order--10{\n    order:10;\n  }\n\n  .slds-large-order_11,.slds-large-order--11{\n    order:11;\n  }\n\n  .slds-large-order_12,.slds-large-order--12{\n    order:12;\n  }\n}\n@media (max-width: 64em){\n  .slds-max-large-size_xxx-small,.slds-max-large-size--xxx-small,\n  .slds-max-large-size_xx-small,\n  .slds-max-large-size--xx-small,\n  .slds-max-large-size_x-small,\n  .slds-max-large-size--x-small,\n  .slds-max-large-size_small,\n  .slds-max-large-size--small,\n  .slds-max-large-size_medium,\n  .slds-max-large-size--medium,\n  .slds-max-large-size_large,\n  .slds-max-large-size--large,\n  .slds-max-large-size_x-large,\n  .slds-max-large-size--x-large,\n  .slds-max-large-size_xx-large,\n  .slds-max-large-size--xx-large{\n    flex:none;\n  }\n\n  .slds-max-large-size_xxx-small,.slds-max-large-size--xxx-small{\n    width:3rem;\n  }\n\n  .slds-max-large-size_xx-small,.slds-max-large-size--xx-small{\n    width:6rem;\n  }\n\n  .slds-max-large-size_x-small,.slds-max-large-size--x-small{\n    width:12rem;\n  }\n\n  .slds-max-large-size_small,.slds-max-large-size--small{\n    width:15rem;\n  }\n\n  .slds-max-large-size_medium,.slds-max-large-size--medium{\n    width:20rem;\n  }\n\n  .slds-max-large-size_large,.slds-max-large-size--large{\n    width:25rem;\n  }\n\n  .slds-max-large-size_x-large,.slds-max-large-size--x-large{\n    width:40rem;\n  }\n\n  .slds-max-large-size_xx-large,.slds-max-large-size--xx-large{\n    width:60rem;\n  }\n\n  .slds-max-large-size_1-of-1,.slds-max-large-size--1-of-1{\n    width:100%;\n  }\n\n  .slds-max-large-size_1-of-2,.slds-max-large-size--1-of-2{\n    width:50%;\n  }\n\n  .slds-max-large-size_2-of-2,.slds-max-large-size--2-of-2{\n    width:100%;\n  }\n\n  .slds-max-large-size_1-of-3,.slds-max-large-size--1-of-3{\n    width:33.333%;\n  }\n\n  .slds-max-large-size_2-of-3,.slds-max-large-size--2-of-3{\n    width:66.6667%;\n  }\n\n  .slds-max-large-size_3-of-3,.slds-max-large-size--3-of-3{\n    width:100%;\n  }\n\n  .slds-max-large-size_1-of-4,.slds-max-large-size--1-of-4{\n    width:25%;\n  }\n\n  .slds-max-large-size_2-of-4,.slds-max-large-size--2-of-4{\n    width:50%;\n  }\n\n  .slds-max-large-size_3-of-4,.slds-max-large-size--3-of-4{\n    width:75%;\n  }\n\n  .slds-max-large-size_4-of-4,.slds-max-large-size--4-of-4{\n    width:100%;\n  }\n\n  .slds-max-large-size_1-of-5,.slds-max-large-size--1-of-5{\n    width:20%;\n  }\n\n  .slds-max-large-size_2-of-5,.slds-max-large-size--2-of-5{\n    width:40%;\n  }\n\n  .slds-max-large-size_3-of-5,.slds-max-large-size--3-of-5{\n    width:60%;\n  }\n\n  .slds-max-large-size_4-of-5,.slds-max-large-size--4-of-5{\n    width:80%;\n  }\n\n  .slds-max-large-size_5-of-5,.slds-max-large-size--5-of-5{\n    width:100%;\n  }\n\n  .slds-max-large-size_1-of-6,.slds-max-large-size--1-of-6{\n    width:16.6667%;\n  }\n\n  .slds-max-large-size_2-of-6,.slds-max-large-size--2-of-6{\n    width:33.333%;\n  }\n\n  .slds-max-large-size_3-of-6,.slds-max-large-size--3-of-6{\n    width:50%;\n  }\n\n  .slds-max-large-size_4-of-6,.slds-max-large-size--4-of-6{\n    width:66.6667%;\n  }\n\n  .slds-max-large-size_5-of-6,.slds-max-large-size--5-of-6{\n    width:83.3333%;\n  }\n\n  .slds-max-large-size_6-of-6,.slds-max-large-size--6-of-6{\n    width:100%;\n  }\n\n  .slds-max-large-size_1-of-7,.slds-max-large-size--1-of-7{\n    width:14.2857%;\n  }\n\n  .slds-max-large-size_2-of-7,.slds-max-large-size--2-of-7{\n    width:28.5714%;\n  }\n\n  .slds-max-large-size_3-of-7,.slds-max-large-size--3-of-7{\n    width:42.8571%;\n  }\n\n  .slds-max-large-size_4-of-7,.slds-max-large-size--4-of-7{\n    width:57.1429%;\n  }\n\n  .slds-max-large-size_5-of-7,.slds-max-large-size--5-of-7{\n    width:71.4286%;\n  }\n\n  .slds-max-large-size_6-of-7,.slds-max-large-size--6-of-7{\n    width:85.7143%;\n  }\n\n  .slds-max-large-size_7-of-7,.slds-max-large-size--7-of-7{\n    width:100%;\n  }\n\n  .slds-max-large-size_1-of-8,.slds-max-large-size--1-of-8{\n    width:12.5%;\n  }\n\n  .slds-max-large-size_2-of-8,.slds-max-large-size--2-of-8{\n    width:25%;\n  }\n\n  .slds-max-large-size_3-of-8,.slds-max-large-size--3-of-8{\n    width:37.5%;\n  }\n\n  .slds-max-large-size_4-of-8,.slds-max-large-size--4-of-8{\n    width:50%;\n  }\n\n  .slds-max-large-size_5-of-8,.slds-max-large-size--5-of-8{\n    width:62.5%;\n  }\n\n  .slds-max-large-size_6-of-8,.slds-max-large-size--6-of-8{\n    width:75%;\n  }\n\n  .slds-max-large-size_7-of-8,.slds-max-large-size--7-of-8{\n    width:87.5%;\n  }\n\n  .slds-max-large-size_8-of-8,.slds-max-large-size--8-of-8{\n    width:100%;\n  }\n\n  .slds-max-large-size_1-of-12,.slds-max-large-size--1-of-12{\n    width:8.3333%;\n  }\n\n  .slds-max-large-size_2-of-12,.slds-max-large-size--2-of-12{\n    width:16.6667%;\n  }\n\n  .slds-max-large-size_3-of-12,.slds-max-large-size--3-of-12{\n    width:25%;\n  }\n\n  .slds-max-large-size_4-of-12,.slds-max-large-size--4-of-12{\n    width:33.333%;\n  }\n\n  .slds-max-large-size_5-of-12,.slds-max-large-size--5-of-12{\n    width:41.6667%;\n  }\n\n  .slds-max-large-size_6-of-12,.slds-max-large-size--6-of-12{\n    width:50%;\n  }\n\n  .slds-max-large-size_7-of-12,.slds-max-large-size--7-of-12{\n    width:58.3333%;\n  }\n\n  .slds-max-large-size_8-of-12,.slds-max-large-size--8-of-12{\n    width:66.6667%;\n  }\n\n  .slds-max-large-size_9-of-12,.slds-max-large-size--9-of-12{\n    width:75%;\n  }\n\n  .slds-max-large-size_10-of-12,.slds-max-large-size--10-of-12{\n    width:83.3333%;\n  }\n\n  .slds-max-large-size_11-of-12,.slds-max-large-size--11-of-12{\n    width:91.6667%;\n  }\n\n  .slds-max-large-size_12-of-12,.slds-max-large-size--12-of-12{\n    width:100%;\n  }\n\n  .slds-max-large-order_1,.slds-max-large-order--1{\n    order:1;\n  }\n\n  .slds-max-large-order_2,.slds-max-large-order--2{\n    order:2;\n  }\n\n  .slds-max-large-order_3,.slds-max-large-order--3{\n    order:3;\n  }\n\n  .slds-max-large-order_4,.slds-max-large-order--4{\n    order:4;\n  }\n\n  .slds-max-large-order_5,.slds-max-large-order--5{\n    order:5;\n  }\n\n  .slds-max-large-order_6,.slds-max-large-order--6{\n    order:6;\n  }\n\n  .slds-max-large-order_7,.slds-max-large-order--7{\n    order:7;\n  }\n\n  .slds-max-large-order_8,.slds-max-large-order--8{\n    order:8;\n  }\n\n  .slds-max-large-order_9,.slds-max-large-order--9{\n    order:9;\n  }\n\n  .slds-max-large-order_10,.slds-max-large-order--10{\n    order:10;\n  }\n\n  .slds-max-large-order_11,.slds-max-large-order--11{\n    order:11;\n  }\n\n  .slds-max-large-order_12,.slds-max-large-order--12{\n    order:12;\n  }\n}\n.slds-size_xxx-small,.slds-size--xxx-small,\n.slds-size_xx-small,\n.slds-size--xx-small,\n.slds-size_x-small,\n.slds-size--x-small,\n.slds-size_small,\n.slds-size--small,\n.slds-size_medium,\n.slds-size--medium,\n.slds-size_large,\n.slds-size--large,\n.slds-size_x-large,\n.slds-size--x-large,\n.slds-size_xx-large,\n.slds-size--xx-large,\n.slds-size_1-of-1,\n.slds-size--1-of-1,\n.slds-size_1-of-2,\n.slds-size--1-of-2,\n.slds-size_2-of-2,\n.slds-size--2-of-2,\n.slds-size_1-of-3,\n.slds-size--1-of-3,\n.slds-size_2-of-3,\n.slds-size--2-of-3,\n.slds-size_3-of-3,\n.slds-size--3-of-3,\n.slds-size_1-of-4,\n.slds-size--1-of-4,\n.slds-size_2-of-4,\n.slds-size--2-of-4,\n.slds-size_3-of-4,\n.slds-size--3-of-4,\n.slds-size_4-of-4,\n.slds-size--4-of-4,\n.slds-size_1-of-5,\n.slds-size--1-of-5,\n.slds-size_2-of-5,\n.slds-size--2-of-5,\n.slds-size_3-of-5,\n.slds-size--3-of-5,\n.slds-size_4-of-5,\n.slds-size--4-of-5,\n.slds-size_5-of-5,\n.slds-size--5-of-5,\n.slds-size_1-of-6,\n.slds-size--1-of-6,\n.slds-size_2-of-6,\n.slds-size--2-of-6,\n.slds-size_3-of-6,\n.slds-size--3-of-6,\n.slds-size_4-of-6,\n.slds-size--4-of-6,\n.slds-size_5-of-6,\n.slds-size--5-of-6,\n.slds-size_6-of-6,\n.slds-size--6-of-6,\n.slds-size_1-of-7,\n.slds-size--1-of-7,\n.slds-size_2-of-7,\n.slds-size--2-of-7,\n.slds-size_3-of-7,\n.slds-size--3-of-7,\n.slds-size_4-of-7,\n.slds-size--4-of-7,\n.slds-size_5-of-7,\n.slds-size--5-of-7,\n.slds-size_6-of-7,\n.slds-size--6-of-7,\n.slds-size_7-of-7,\n.slds-size--7-of-7,\n.slds-size_1-of-8,\n.slds-size--1-of-8,\n.slds-size_2-of-8,\n.slds-size--2-of-8,\n.slds-size_3-of-8,\n.slds-size--3-of-8,\n.slds-size_4-of-8,\n.slds-size--4-of-8,\n.slds-size_5-of-8,\n.slds-size--5-of-8,\n.slds-size_6-of-8,\n.slds-size--6-of-8,\n.slds-size_7-of-8,\n.slds-size--7-of-8,\n.slds-size_8-of-8,\n.slds-size--8-of-8,\n.slds-size_1-of-12,\n.slds-size--1-of-12,\n.slds-size_2-of-12,\n.slds-size--2-of-12,\n.slds-size_3-of-12,\n.slds-size--3-of-12,\n.slds-size_4-of-12,\n.slds-size--4-of-12,\n.slds-size_5-of-12,\n.slds-size--5-of-12,\n.slds-size_6-of-12,\n.slds-size--6-of-12,\n.slds-size_7-of-12,\n.slds-size--7-of-12,\n.slds-size_8-of-12,\n.slds-size--8-of-12,\n.slds-size_9-of-12,\n.slds-size--9-of-12,\n.slds-size_10-of-12,\n.slds-size--10-of-12,\n.slds-size_11-of-12,\n.slds-size--11-of-12,\n.slds-size_12-of-12,\n.slds-size--12-of-12{\n  flex:none;\n}\n.slds-has-buffer{\n  margin:var(--slds-g-spacing-3);\n}\n.slds-has-full-bleed{\n  margin:0;\n}\n.slds-has-bottom-magnet{\n  margin-block-end:0 !important;\n  border-end-start-radius:0 !important;\n  border-end-end-radius:0 !important;\n}\n.slds-has-top-magnet{\n  margin-block-start:0 !important;\n  border-start-start-radius:0 !important;\n  border-start-end-radius:0 !important;\n}\n.slds-has-top-magnet.slds-has-buffer{\n  margin-block-end:0;\n  border-radius:0;\n  border-block-start:0;\n  box-shadow:none;\n}\n.slds-is-static{\n  position:static;\n}\n.slds-is-relative{\n  position:relative;\n}\n.slds-is-fixed{\n  position:fixed;\n}\n.slds-is-absolute{\n  position:absolute;\n}\n@media print{\n  .slds-no-print{\n    display:none;\n  }\n}\n.slds-assistive-text{\n  position:absolute !important;\n  margin:-1px !important;\n  border:0 !important;\n  padding:0 !important;\n  width:1px !important;\n  height:1px !important;\n  overflow:hidden !important;\n  clip:rect(0 0 0 0) !important;\n  text-transform:none !important;\n  white-space:nowrap !important;\n}\n.slds-assistive-text_focus:focus,.slds-assistive-text--focus:focus{\n  margin:inherit !important;\n  border:inherit !important;\n  padding:inherit !important;\n  width:auto !important;\n  height:auto !important;\n  overflow:visible !important;\n  clip:auto !important;\n}\n.slds-is-collapsed{\n  height:0;\n  overflow:hidden;\n}\n.slds-is-expanded{\n  height:auto;\n  overflow:visible;\n}\n.slds-hidden{\n  visibility:hidden !important;\n}\n.slds-visible{\n  visibility:visible;\n}\n.slds-hide{\n  display:none !important;\n}\n.slds-show{\n  display:block;\n}\n.slds-show_inline-block,.slds-show--inline-block{\n  display:inline-block;\n}\n.slds-show_inline,.slds-show--inline{\n  display:inline;\n}\n.slds-transition-hide{\n  opacity:0;\n}\n.slds-transition-show{\n  opacity:1;\n}\n.slds-x-small-show{\n  display:none;\n}\n@media (min-width: 320px){\n  .slds-x-small-show{\n    display:block;\n  }\n  .slds-x-small-show_inline-block,.slds-x-small-show--inline-block{\n    display:inline-block;\n  }\n  .slds-x-small-show_inline,.slds-x-small-show--inline{\n    display:inline;\n  }\n}\n.slds-x-small-show-only{\n  display:none;\n}\n@media (min-width: 320px) and (max-width: 479px){\n  .slds-x-small-show-only{\n    display:block;\n  }\n  .slds-x-small-show-only_inline-block,.slds-x-small-show-only--inline-block{\n    display:inline-block;\n  }\n  .slds-x-small-show-only_inline,.slds-x-small-show-only--inline{\n    display:inline;\n  }\n}\n@media (max-width: 479px){\n  .slds-max-x-small-hide{\n    display:none;\n  }\n}\n.slds-small-show{\n  display:none;\n}\n@media (min-width: 480px){\n  .slds-small-show{\n    display:block;\n  }\n  .slds-small-show_inline-block,.slds-small-show--inline-block{\n    display:inline-block;\n  }\n  .slds-small-show_inline,.slds-small-show--inline{\n    display:inline;\n  }\n}\n.slds-small-show-only{\n  display:none;\n}\n@media (min-width: 480px) and (max-width: 767px){\n  .slds-small-show-only{\n    display:block;\n  }\n  .slds-small-show-only_inline-block,.slds-small-show-only--inline-block{\n    display:inline-block;\n  }\n  .slds-small-show-only_inline,.slds-small-show-only--inline{\n    display:inline;\n  }\n}\n@media (max-width: 767px){\n  .slds-max-small-hide{\n    display:none;\n  }\n}\n.slds-medium-show{\n  display:none;\n}\n@media (min-width: 768px){\n  .slds-medium-show{\n    display:block;\n  }\n  .slds-medium-show_inline-block,.slds-medium-show--inline-block{\n    display:inline-block;\n  }\n  .slds-medium-show_inline,.slds-medium-show--inline{\n    display:inline;\n  }\n}\n.slds-medium-show-only{\n  display:none;\n}\n@media (min-width: 768px) and (max-width: 1023px){\n  .slds-medium-show-only{\n    display:block;\n  }\n  .slds-medium-show-only_inline-block,.slds-medium-show-only--inline-block{\n    display:inline-block;\n  }\n  .slds-medium-show-only_inline,.slds-medium-show-only--inline{\n    display:inline;\n  }\n}\n@media (max-width: 1023px){\n  .slds-max-medium-hide{\n    display:none;\n  }\n}\n.slds-large-show{\n  display:none;\n}\n@media (min-width: 1024px){\n  .slds-large-show{\n    display:block;\n  }\n  .slds-large-show_inline-block,.slds-large-show--inline-block{\n    display:inline-block;\n  }\n  .slds-large-show_inline,.slds-large-show--inline{\n    display:inline;\n  }\n}\n@media (min-width: 320px){\n  .slds-hide_x-small,.slds-hide--x-small{\n    display:none !important;\n  }\n}\n@media (max-width: 319px){\n  .slds-show_x-small,.slds-show--x-small{\n    display:none !important;\n  }\n}\n@media (min-width: 480px){\n  .slds-hide_small,.slds-hide--small{\n    display:none !important;\n  }\n}\n@media (max-width: 479px){\n  .slds-show_small,.slds-show--small{\n    display:none !important;\n  }\n}\n@media (min-width: 768px){\n  .slds-hide_medium,.slds-hide--medium{\n    display:none !important;\n  }\n}\n@media (max-width: 767px){\n  .slds-show_medium,.slds-show--medium{\n    display:none !important;\n  }\n}\n@media (min-width: 1024px){\n  .slds-hide_large,.slds-hide--large{\n    display:none !important;\n  }\n}\n@media (max-width: 1023px){\n  .slds-show_large,.slds-show--large{\n    display:none !important;\n  }\n}\n@media (min-width: 1280px){\n  .slds-hide_x-large,.slds-hide--x-large{\n    display:none !important;\n  }\n}\n@media (max-width: 1279px){\n  .slds-show_x-large,.slds-show--x-large{\n    display:none !important;\n  }\n}\n.slds-is-visually-empty{\n  visibility:hidden !important;\n  width:0;\n}\n.slds-line-clamp{\n  overflow:hidden;\n  display:-webkit-box;\n  -webkit-box-orient:vertical;\n  -webkit-line-clamp:3;\n  text-overflow:ellipsis;\n  white-space:pre-line;\n}\n.slds-line-clamp_x-small,.slds-line-clamp--x-small{\n  overflow:hidden;\n  display:-webkit-box;\n  -webkit-box-orient:vertical;\n  -webkit-line-clamp:2;\n  text-overflow:ellipsis;\n  white-space:pre-line;\n}\n.slds-line-clamp_small,.slds-line-clamp--small{\n  overflow:hidden;\n  display:-webkit-box;\n  -webkit-box-orient:vertical;\n  -webkit-line-clamp:3;\n  text-overflow:ellipsis;\n  white-space:pre-line;\n}\n.slds-line-clamp_medium,.slds-line-clamp--medium{\n  overflow:hidden;\n  display:-webkit-box;\n  -webkit-box-orient:vertical;\n  -webkit-line-clamp:5;\n  text-overflow:ellipsis;\n  white-space:pre-line;\n}\n.slds-line-clamp_large,.slds-line-clamp--large{\n  overflow:hidden;\n  display:-webkit-box;\n  -webkit-box-orient:vertical;\n  -webkit-line-clamp:7;\n  text-overflow:ellipsis;\n  white-space:pre-line;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
